/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/ecompras/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 320);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(327);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(338);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = createAxiosInstance;
/* unused harmony export createAxiosAirports */
/* harmony export (immutable) */ __webpack_exports__["B"] = guid;
/* harmony export (immutable) */ __webpack_exports__["b"] = addTitleIfOverflow;
/* harmony export (immutable) */ __webpack_exports__["G"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["F"] = isFunction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return uniqueArray; });
/* harmony export (immutable) */ __webpack_exports__["T"] = transformParameterData;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return operators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptedFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return uploadMaxSize; });
/* unused harmony export queryString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return enums; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return extractKeyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return parametro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return parametroConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return usuario; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return grupo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return solicitudservicioitem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return grupoItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return solicitudbiitem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return compraDirectaItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return solicitudservicioitemcenco; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return solicitudcenco; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return detalleparametro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return solicitudserviciofile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return adjunto; });
/* unused harmony export tiquete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cotizacion; });
/* unused harmony export proveedor_servicio */
/* unused harmony export modified */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return plantilla; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return garantia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return documento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return factura; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return adicion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return verificacionSST; });
/* harmony export (immutable) */ __webpack_exports__["U"] = trayecto;
/* harmony export (immutable) */ __webpack_exports__["e"] = alojamiento;
/* harmony export (immutable) */ __webpack_exports__["f"] = asistencia;
/* harmony export (immutable) */ __webpack_exports__["K"] = pasajero;
/* harmony export (immutable) */ __webpack_exports__["C"] = huesped;
/* harmony export (immutable) */ __webpack_exports__["M"] = proveedor;
/* harmony export (immutable) */ __webpack_exports__["r"] = foro;
/* harmony export (immutable) */ __webpack_exports__["n"] = esEntero;
/* harmony export (immutable) */ __webpack_exports__["u"] = getModificaciones;
/* harmony export (immutable) */ __webpack_exports__["D"] = indexBy;
/* harmony export (immutable) */ __webpack_exports__["y"] = groupModificacionesBy;
/* harmony export (immutable) */ __webpack_exports__["E"] = isAllowedToViewComponent;
/* harmony export (immutable) */ __webpack_exports__["N"] = romanize;
/* harmony export (immutable) */ __webpack_exports__["g"] = attachFilesToEntity;
/* harmony export (immutable) */ __webpack_exports__["v"] = getPorcentaje;
/* harmony export (immutable) */ __webpack_exports__["w"] = getPorcentajeFromTotal;
/* harmony export (immutable) */ __webpack_exports__["x"] = getTotalesDocumento;
/* unused harmony export calcularAnticipos */
/* harmony export (immutable) */ __webpack_exports__["q"] = formatcoin;
/* harmony export (immutable) */ __webpack_exports__["t"] = getDivisa;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_exact_math__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_util__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var cookies=new __WEBPACK_IMPORTED_MODULE_1_universal_cookie___default.a();function createAxiosInstance(config){var token=cookies.get('token');if(!token)return null;var minConfig={baseURL:__WEBPACK_IMPORTED_MODULE_8__actions_index__["b" /* API_URL */],headers:{'Authorization':'Bearer '+token}};if(config){minConfig=Object.assign({},minConfig,config);}return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(minConfig);}function createAxiosAirports(){var minConfig={baseURL:__WEBPACK_IMPORTED_MODULE_8__actions_index__["a" /* API_IATACODES */],headers:{'Access-Control-Allow-Origin':'*','Content-Type':'application/json'}};return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(minConfig);}// export function createAxiosAirports() {
//     return axios.create()
// }
function guid(){function s4(){return Math.floor((1+Math.random())*0x10000).toString(16).substring(1);}return s4()+s4()+'-'+s4()+'-'+s4()+'-'+s4()+'-'+s4()+s4()+s4();}function addTitleIfOverflow(element){if(element.offsetWidth<=element.scrollWidth&&!element.hasAttribute('title')){element.setAttribute('title',element.innerHTML);}}function isPrimitive(test){return test!==Object(test);}function isFunction(fn){return fn&&{}.toString.call(fn)==='[object Function]';}var uniqueArray=function uniqueArray(arr){return[].concat(_toConsumableArray(new Set(arr)));};function transformParameterData(parametro){var columnas=[];var table=parametro.parametro_cols.reduce(function(a,b){if(columnas.filter(function(c){return c.nombre===b.nombre;}).length===0){columnas.push({id:b.id,posicion:Number(b.Position),caption:b.nombre.replace('_',' '),value:b.nombre,type:'string',format:'',parametro_id:parametro.id,parametro_col_id:b.id});}b.parametro_rows.forEach(function(x){if(!a[x.registro])a[x.registro]={id:null,valor:null,updated:false,guid:guid(),parametro_id:parametro.id,parametro_col_id:b.parametro_col_id};a[x.registro].registro=x.registro;a[x.registro][b.nombre]={id:x.id,valor:x.valor,updated:false,guid:guid(),parametro_id:parametro.id,parametro_col_id:b.id};});return a;},{});var data=[];for(var key in table){if(table.hasOwnProperty(key)){var obj=columnas.reduce(function(a,b){a[b.value]=null;a.selected=false;a.deleted=false;return a;},{});data.push(Object.assign({},obj,table[key]));}}return{parametro:parametro,columnas:columnas,data:data};}var operators=[{id:1,value:'===',caption:'Igual a',comparisons:['string','number','datetime']},{id:2,value:'!==',caption:'Diferente de',comparisons:['string','number','datetime']},{id:3,value:'>',caption:'Mayor a',comparisons:['number','datetime']},{id:4,value:'>=',caption:'Mayor o igual a',comparisons:['number','datetime']},{id:5,value:'<',caption:'Menor a',comparisons:['number','datetime']},{id:6,value:'<=',caption:'Menor o igual a',comparisons:['number','datetime']},{id:7,value:'like',caption:'Contiene',comparisons:['string','datetime']}];var acceptedFiles=[{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',icon:'xlsx.png'},{type:'text/csv',icon:'xlsx.png'},{type:'application/vnd.ms-excel',icon:'xlsx.png'},{type:'application/vnd.openxmlformats-officedocument.presentationml.presentation',icon:'pptx.png'},{type:'application/vnd.openxmlformats-officedocument.wordprocessingml.document',icon:'doc.png'},{type:'application/pdf',icon:'pdf.png'},{type:'application/x-zip-compressed',icon:'zip.png'},{type:'image/*',icon:'jpg.png'}];// export const acceptedFilesCSV = [
//     { type: 'text/csv', icon: 'xlsx.png' }
// ]
// 8M = 8388608 Bytes
var uploadMaxSize={value:8388608,unidad:'8M'};var queryString=function queryString(search,param){return search.split('?')[1].split(param+'=')[1].split('&')[0];};var enums={solicitudes:{tipos:{1:{caption:'Servicios',url:'servicios',type:'ACTUALIZAR_SOLICITUD_SERVICIO',responsable:null},2:{caption:'Contrato anual',url:'contratos-anuales',type:'ACTUALIZAR_SOLICITUD_CONTRATOANUAL',responsable:null},3:{caption:'Servicio oficina técnica',url:'servicios-oficina-tecnica',type:'ACTUALIZAR_SOLICITUD_SERVICIO_OT',responsable:null},4:{caption:'Tiquetes aéreos',url:'tiquetes-aereos',type:'ACTUALIZAR_SOLICITUD_TIQUETESAEREOS',responsable:null},5:{caption:'OTROSI',url:'otrosi',responsable:null},6:{caption:'Bienes e investigación - Laboratorio',url:'bienes-investigacion',type:'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION',responsable:null},7:{caption:'Bienes e investigación - Materiales',url:'bienes-investigacion',type:'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION',responsable:null},8:{caption:'Hoteles',url:'hoteles',responsable:null}},estados:{0:'Cancelada',1:'Creada',2:'En cotización',3:'En aprobación',4:'Aprobada',5:'En aprobación proveedor',6:'En proceso',7:'Cerrada',8:'Validado',9:'Cerrado NV'}},aprobaciones:{estados:{0:'Rechazada',1:'Pendiente',2:'Aprobada',3:'En revision',4:'Omitido'}},documentos:{tipos:{},estados:{0:'Cancelado',1:'Creado',2:'En aprobacion proveedor',3:'Aprobado proveedor',4:'En ejecución',5:'En revisión entrega',//Ajustes documentos
6:'En ajustes entrega',//Ajustes proveedor
7:'Recibido',8:'En ajustes SOMA',9:'Recibido SOMA',10:'A espera de factura',11:'Cerrada',12:'Vigente',13:'En espera',14:'Vigente sin renovación'}},cotizaciones:{estados:{0:'Cancelado',1:'Creado',2:'En aprobacion proveedor',3:'Aprobado proveedor',4:'Aprobada',5:'Solicitar cotizacion'}},etapas:{"1-1":"Generar Orden/Contrato","1-2":"Actualizar Orden/Contrato","1-3":"Generar Orden/Contrato con ajustes","1-4":"Registrar adicionales para ajustar factura","1-5":"Generar OTROSÍ","1-6":"Actualizar OTROSÍ","2-1":"Solicitar Cotizaciones","2-2":"Analizar Cotizaciones","2-3":"Generar Orden/Contrato","2-4":"Actualizar Orden/Contrato","2-5":"Generar Orden/Contrato con ajustes","2-6":"Generar OTROSÍ","2-7":"Actualizar OTROSÍ","3-1":"Solicitar Cotizaciones","3-2":"Analizar Cotizaciones","3-3":"Registrar Compra","3-4":"Generar Orden/Contrato","3-5":"Actualizar Orden/Contrato","3-6":"Generar Orden/Contrato con ajustes","3-7":"Generar OTROSÍ","3-8":"Actualizar OTROSÍ","4-1":"Registrar Cotizaciones","4-2":"Registrar Compra Tiquetes Aéreos","4-3":"Registrar Compra Asistencia al Viajero","4-4":"Registrar cumplimiento del tiquete","5-1":"Registrar Cotizaciones","5-2":"Registrar Pago del Hotel","5-3":"Registrar cumplimiento de la estadía","6-1":"Generar Contrato Anual","6-2":"Rechazar Contrato Anual","6-3":"Actualizar Contrato Anual","6-4":"Adjuntar Contrato con firmas","6-5":"Registrar Renovación Contrato Anual","6-6":"Rechazar Renovación Contrato Anual"},etapasFilter:{"Actualizar Contrato Anual":"Actualizar Contrato Anual","Actualizar Orden/Contrato":"Actualizar Orden/Contrato","Actualizar OTROSÍ":"Actualizar OTROSÍ","Adjuntar Contrato con firmas":"Adjuntar Contrato con firmas","Analizar Cotizaciones":"Analizar Cotizaciones","Generar Contrato Anual":"Generar Contrato Anual","Generar Orden/Contrato con ajustes":"Generar Orden/Contrato con ajustes","Generar Orden/Contrato":"Generar Orden/Contrato","Generar OTROSÍ":"Generar OTROSÍ","Rechazar Contrato Anual":"Rechazar Contrato Anual","Rechazar Renovación Contrato Anual":"Rechazar Renovación Contrato Anual","Registrar adicionales para ajustar factura":"Registrar adicionales para ajustar factura","Registrar Compra Asistencia al Viajero":"Registrar Compra Asistencia al Viajero","Registrar Compra Tiquetes Aéreos":"Registrar Compra Tiquetes Aéreos","Registrar Compra":"Registrar Compra","Registrar Cotizaciones":"Registrar Cotizaciones","Registrar cumplimiento de la estadía":"Registrar cumplimiento de la estadía","Registrar cumplimiento del tiquete":"Registrar cumplimiento del tiquete","Registrar Pago del Hotel":"Registrar Pago del Hotel","Registrar Renovación Contrato Anual":"Registrar Renovación Contrato Anual","Solicitar Cotizaciones":"Solicitar Cotizaciones"},tipos_identificacion:{1:'Cédula de ciudadania',2:'Cédula de extranjería',3:'Pasaporte',4:'Tarjeta de identidad'}};var extractKeyValue=function extractKeyValue(object){var pathvalue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var pathtext=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;object=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.fromJS(object);var keyvalue=[];if(object instanceof __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map){object.mapKeys(function(value,item){var text=pathvalue?item.getIn(pathvalue.split('.')):item;keyvalue.push({value:value,text:text});});}if(object instanceof __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List){if(pathvalue==null)return;if(pathtext==null)return;object.map(function(x){var value=x.getIn(pathvalue.split('.'));var text=x.getIn(pathtext.split('.'));keyvalue.push({value:value,text:text});});}return keyvalue;};var parametro=function parametro(){return{id:null,guid:guid(),nombre:'',descripcion:'',categoria:'',selected:false,visible:true,parametro_cols:[parametroConfig()]};};var parametroConfig=function parametroConfig(){return{id:null,guid:guid(),posicion:1,nombre:'',descripcion:'',selected:false};};var usuario=function usuario(permisos,grupos){return{username:'',email:'',es_supeusuario:false,ldap:false,esta_activo:true,nombres:'',apellidos:'',extension:'',permisos:permisos,grupos:grupos,reporta_a:{}};};var grupo=function grupo(){return{guid:guid(),nombre:'',descripcion:''};};var solicitudservicioitem=function solicitudservicioitem(){return{id:null,selected:false,guid:guid(),descripcion:'',cantidad:0,cencos:[],cotizado:0,cotizado_iva:0,iva:0};};var grupoItem=function grupoItem(){return{id:null,guid:guid(),items:[],proveedores:[],compra_directa:false};};var solicitudbiitem=function solicitudbiitem(){return{id:null,selected:false,guid:guid(),descripcion:'',cantidad_requerida:0,descripcion_erp:'',cantidad_solicitada:0};};var compraDirectaItem=function compraDirectaItem(){return{id:null,guid:guid(),razon_social:'',nit:'',no_factura:'',fecha_compra:__WEBPACK_IMPORTED_MODULE_5_moment___default()(),medio_pago:'',valor_compra:''};};var solicitudservicioitemcenco=function solicitudservicioitemcenco(){var actual=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return{id:null,guid:guid(),cenco:null,porcentaje:100-actual};};var solicitudcenco=function solicitudcenco(){var actual=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return{id:null,guid:guid(),cenco:null,responsable:null,porcentaje:100-actual};};var detalleparametro=function detalleparametro(columnas,registro){var output={registro:registro,selected:false};columnas.forEach(function(x){output[x.get('value')]={guid:guid(),id:null,updated:true,valor:'',parametro_id:x.get('parametro_id'),parametro_col_id:x.get('parametro_col_id')};});return output;};var solicitudserviciofile=function solicitudserviciofile(){return{id:null,updated:true,guid:guid(),nombre:'',observaciones:'',file:null,icono:null,selected:false,editable:1};};var adjunto=function adjunto(){return{id:null,updated:true,guid:guid(),nombre:'',observaciones:'',file:null,icono:null,selected:false,editable:1,documento_id:null,solicitud_id:null,entities:[]};};var tiquete=function tiquete(){return{id:null,guid:guid(),aerolinea:'',fecha:null,origen:'',destino:'',sale:null,llega:null,valor_aprobado:0,valor_pagado:0,viaje_id:null};};var cotizacion=function cotizacion(){return{id:null,updated:true,guid:guid(),cotizado:0,fecha_entrega:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'),forma_pago:'',servicio:null,proveedor_id:null,proveedore:null,descripcion:'',adjunto_id:null,selected:false,adjunto:adjunto(),estado:1,moneda:'COP'};};var proveedor_servicio=function proveedor_servicio(){return{id:null,guid:guid(),fecha_cotizo:null,servicio:null,proveedore:null,adjunto:adjunto(),selected:false};};var modified=function modified(id,entity,value,action){return{id:id,entity:entity,value:value,action:action};};var plantilla=function plantilla(){return{id:null,guid:guid(),nombre:'',text:'',tipo:0};};var garantia=function garantia(){return{id:null,selected:false,guid:guid(),nombre:'',texto:''};};var documento=function documento(documento_id,solicitud_id,proveedor_id){return{id:null,guid:guid(),documento_id:null,solicitud_id:null,proveedor_id:null,plantilla_id:null,fecha_inicio:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'),fecha_entrega:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'),garantias:[],dias_pagados_saldo:0};};var factura=function factura(documento_id){return{id:null,guid:guid(),documento_id:documento_id,numero_factura:'',fecha_factura:null,fecha_radicacion:null,valor_sin_iva:null,valor_con_iva:null,selected:false,visible:true,file:null,amortizacion:null,porcentaje_amortizacion:null,valor_a_pagar:null};};var adicion=function adicion(documento_id){return{id:null,guid:guid(),documento_id:documento_id,descripcion:'',cantidad:1,valor:0,iva:0,valor_con_iva:0,valor_unidad:0,fecha_entrega:null,cencos:[]};};var verificacionSST=function verificacionSST(documento_id){return{id:null,guid:guid(),documento_id:documento_id,observaciones:'',file:null};};function trayecto(){return{id:null,guid:guid(),selected:false,origen:'',aeropuerto_origen:'',fecha_ida:null,destino:'',aeropuerto_destino:'',fecha_regreso:null};}function alojamiento(){return{id:null,guid:guid(),selected:false,ciudad:'',fecha_ingreso:null,fecha_salida:null,monto_consumo:0,consumo_habitacion:0};}function asistencia(){return{id:null,guid:guid(),pais_destino:'',fecha_salida:null,fecha_regreso:null,avisar_a:'',direccion:'',ciudad:'',celular:'',telefono:'',proveedor:'',numero_voucher:'',valor:0,fecha_compra:null};}function pasajero(){return{id:null,guid:guid(),tipo_pasajero:1,nombres:null,apellidos:null,cedula:null,correo:null,fecha_nacimiento:null,celular:null,nacionalidad:null,pasaporte:null,pais_expedicion:null,fecha_caducidad_pasaporte:"",pasaporte_adjunto:null,asistencia:asistencia(),tipo_documento:1};}function huesped(){return{id:null,guid:guid(),tipo_huesped:1,nombres:null,apellidos:null,tipo_documento:1,numero_documento:'',celular:null};}function proveedor(){return{id:null,guid:guid(),nombre:null,identificacion:null,representante:null,cc_representante:null,contacto:null,correo:null,telefono:null,cargo:null,direccion:null};}function foro(usuario,comentario){return{guid:guid(),id:null,comentario:comentario,solicitud_id:null,usuario_id:usuario.get('id'),usuario:usuario,updated_at:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm:ss')};}function esEntero(x){var y=parseInt(x);if(isNaN(y))return false;return x==y&&x.toString()==y.toString();}function getModificaciones(newObj,OldObj,entity,outputTransformations){var ops=__WEBPACK_IMPORTED_MODULE_3_immutablediff___default()(OldObj,newObj);var modificaciones=[];ops.forEach(function(x){var path=x.get('path').split('/');path.shift();var value=x.get('value');if(value===undefined&&x.get('op')==='remove'){value=path[path.length-1];}if(!isPrimitive(value)){if(__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map.isMap(value)||__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List.isList(value)){value=value.toJS();}}// Modificado por David
var attr=path[0];var id=esEntero(attr)?newObj.getIn([attr,'id']):newObj.get('id');//----
//let modificacion = { id: newObj.get('id'), entity: entity, attribute: path, value: value, action: x.get('op') }
var modificacion={id:id,entity:entity,attribute:path,value:value,action:x.get('op'),relation:path[1]!==undefined&&path[1]!==null?path[1]:"",column:path[3]!==undefined&&path[3]!==null?path[3]:"",idRelation:newObj.getIn([attr,path[1]!==undefined&&path[1]!==null?path[1]:"",path[2]!==undefined&&path[2]!==null?path[2]:"",'id'])// if (isFunction(outputTransformations)) {
//     outputTransformations(x, modificacion)
// }
};if(isFunction(outputTransformations)){outputTransformations(x,modificacion,newObj);}if(modificacion!==null&&modificacion.entity!==null)modificaciones.push(modificacion);});return modificaciones;}//Original
// export function getModificaciones(newObj, OldObj, entity, outputTransformations) {
//     const ops = diff(OldObj, newObj)
//     const modificaciones = []
//     ops.forEach(x => {
//         let path = x.get('path').split('/')
//         path.shift()
//         let value = x.get('value')
//         if (value === undefined && x.get('op') === 'remove') {
//             value = path[path.length - 1]
//         }
//         if (!isPrimitive(value)) {
//             if (Immutable.Map.isMap(value) || Immutable.List.isList(value)) {
//                 value = value.toJS()
//             }
//         }
//         let modificacion = { id: newObj.get('id'), entity: entity, attribute: path, value: value, action: x.get('op') }
//         if (isFunction(outputTransformations)) {
//             outputTransformations(x, modificacion)
//         }
//         if (modificacion !== null && modificacion.entity !== null) modificaciones.push(modificacion)
//     })
//     return modificaciones
// }
function indexBy(iterable,searchKey){return iterable.reduce(function(lookup,item){return lookup.set(item.get(searchKey),item);},__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map());}function groupModificacionesBy(modificaciones,entity,action){var newModificaciones=[];var newValues={};var id=null;modificaciones.forEach(function(a,b){if(a.entity!==entity){newModificaciones=newModificaciones.concat(Object.assign({},a));}else{id=a.id;if(a.action!=='hidden'){newValues[a.attribute]=a.value;}}});newModificaciones=newModificaciones.concat({id:id,entity:entity,action:action,value:newValues});return newModificaciones;}function isAllowedToViewComponent(type,obj,check){var user=__WEBPACK_IMPORTED_MODULE_9__utils_store__["a" /* default */].getState().common.get('user');var parametros=__WEBPACK_IMPORTED_MODULE_9__utils_store__["a" /* default */].getState().common.get('parametros');var solicitud=null;if(type==='documento'){solicitud=obj.get('solicitude');if(obj.get('estado')===0||obj.get('estado')===11||obj.get('estado')===12)return false;if(solicitud.getIn(['solicitud','estado'])===0||solicitud.getIn(['solicitud','estado'])===7)return false;}else if(type==='solicitud'){if(obj.getIn(['solicitud','estado'])===0||obj.getIn(['solicitud','estado'])===7)return false;}else if(type==='aprobacion'){if(obj.get('estado')!==1)return false;if(user.get('es_superusuario')===1)return true;if(obj.get('estado')===1&&obj.get('aprobador_id')!==user.get('id'))return false;}else if(type==='aprobaciones'){if(user.get('es_superusuario')!=1){return user.get('id')==obj.get('id');}else{return true;}}else if(type==='aprobador'){if(user.get('es_superusuario')!=1){return obj.filter(function(aprobador){return aprobador.get('id')==user.get('id');}).count()>0;}else{return true;}}else if(type=='administrador'){if(user.get('es_superusuario')===1)return true;if(obj&&user.get('id')==obj.get('id'))return true;return false;}else if(type=='responsables_recibo'){if(user.get('es_superusuario')===1)return true;solicitud=obj.get('solicitude');return(solicitud.get('responsables_recibo').filter(function(x){return x.get('usuario_id')==user.get('id');}).count()>0||solicitud.getIn(['responsable_compras','id'])===user.get('id'))&&user.get('id')==check;}else if(type=='responsable_almacen'){//Ingresa la factura
if(user.get('es_superusuario')===1)return true;if(obj.getIn(['solicitude','responsable_compras','id'])===user.get('id'))return true;var almacen=parametros.get('ALMACEN').filter(function(x){return x.get('ALMACEN')==obj.get('almacen');}).first();if(almacen){return user.get('username')===almacen.get('USUARIO');}solicitud=obj.get('solicitude');return(solicitud.get('responsables_ingreso').filter(function(x){return x.get('usuario_id')==user.get('id');}).count()>0||solicitud.getIn(['responsable_compras','id'])===user.get('id'))&&user.get('id')==check;}else if(type=='responsable_soma'){if(user.get('es_superusuario')===1)return true;//return ((solicitud.get('responsables_ingreso').filter(x => x.get('usuario_id') == user.get('id')).count() > 0) || solicitud.getIn(['responsable_compras', 'id']) === user.get('id'))
}else if(type=='responsable_compras'){if(user.get('es_superusuario')===1)return true;return obj.get('responsable_compras_id')===user.get('id');}else if(type=='solicitante'){if(user.get('es_superusuario')===1)return true;return obj.get('solicitante_id')===user.get('id')||obj.get('responsable_compras_id')===user.get('id');}else if(type=='aprobador_primer_nivel'){if(user.get('es_superusuario')!=1){return obj.filter(function(aprobador){return aprobador.get('id')==user.get('id')&&aprobador.get('aprobaciones').filter(function(a){return a.get('tipo')==1;}).count()>0;}).count()>0;}else{return true;}}return true;}function romanize(num){if(!+num)return false;var digits=String(+num).split(""),key=["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM","","X","XX","XXX","XL","L","LX","LXX","LXXX","XC","","I","II","III","IV","V","VI","VII","VIII","IX"],roman="",i=3;while(i--){roman=(key[+digits.pop()+i*10]||"")+roman;}return Array(+digits.join("")+1).join("M")+roman;}function attachFilesToEntity(entity,list){return list.filter(function(c){return c.getIn(['adjunto','entities']);}).map(function(a){return a.get('adjunto').update('entities',function(x){return x.push(__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.fromJS({entity:entity,guid:a.get('guid')}));});});}function getPorcentaje(total,porcentaje){if(porcentaje)return porcentaje*total/100;else return 0;}function getPorcentajeFromTotal(total,iva_value){if(iva_value){var formula='('+iva_value+' * 100)/'+total;return __WEBPACK_IMPORTED_MODULE_6_exact_math___default.a.formula(formula);}else return 0;}function getTotalesDocumento(documento){var totales={sin_iva:0,con_iva:0};documento.get('detalles').forEach(function(a){totales.sin_iva+=a.get('valor')*a.get('cantidad');totales.con_iva+=a.get('valor_con_iva')*a.get('cantidad');});documento.get('documentos').forEach(function(b){b.get('detalles').forEach(function(c){totales.sin_iva+=c.get('valor')*c.get('cantidad');totales.con_iva+=c.get('valor_con_iva')*c.get('cantidad');});});var facturas={sin_iva:0,con_iva:0};documento.get('facturas').forEach(function(f){facturas.sin_iva+=f.get('valor_sin_iva');facturas.con_iva+=f.get('valor_con_iva');});totales.sin_iva-=facturas.sin_iva;totales.con_iva-=facturas.con_iva;totales.sin_iva=Number(totales.sin_iva.toFixed(2));totales.con_iva=Number(totales.con_iva.toFixed(2));return totales;}function calcularAnticipos(doc,origen){var total=0;if(doc.get('documentos')){doc.get('documentos').map(function(d){return total+=calcularAnticipos(d,doc);});}if(doc.get('tipo')==6){var totalSevicios=origen.get('detalles').reduce(function(a,b){if(!b.get('adicion_id'))a+=b.get('valor');return a;},0);total+=totalSevicios*origen.get('anticipo')/100;}total=Number(total.toFixed(2));return total;}function formatcoin(value){var coin=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return coin?coin+' '+__WEBPACK_IMPORTED_MODULE_7_numeral___default()(value).format('0,0.00'):''+__WEBPACK_IMPORTED_MODULE_7_numeral___default()(value).format('0,0.00');}function getDivisa(divisas,moneda){var d={moneda:'COP',simbolo:'$'};if(divisas){var divisa=divisas.filter(function(d){return d.get('CODIGO')==moneda;});if(divisa.count()>0){d.moneda=moneda;d.simbolo=divisa.first().get('SIMBOLO');}}return d;}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = displayMessages;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearMessage;
/* harmony export (immutable) */ __webpack_exports__["m"] = getUserConfig;
/* harmony export (immutable) */ __webpack_exports__["w"] = showHideModalMsgBox;
/* harmony export (immutable) */ __webpack_exports__["i"] = expandCollapseModule;
/* harmony export (immutable) */ __webpack_exports__["y"] = showModalSelector;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDataFromUrl;
/* harmony export (immutable) */ __webpack_exports__["z"] = showModalSelectorUrlAirports;
/* harmony export (immutable) */ __webpack_exports__["k"] = getDataFromUrlAirports;
/* harmony export (immutable) */ __webpack_exports__["n"] = hideModalSelectorAirport;
/* harmony export (immutable) */ __webpack_exports__["e"] = clearPagesModalSelectorAirport;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearPagesModalSelector;
/* harmony export (immutable) */ __webpack_exports__["o"] = hideModalSelectorFromList;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateModalSelectorFilterTerm;
/* harmony export (immutable) */ __webpack_exports__["q"] = selectFromSelector;
/* harmony export (immutable) */ __webpack_exports__["l"] = getParameterByName;
/* harmony export (immutable) */ __webpack_exports__["u"] = showHideModalDelete;
/* harmony export (immutable) */ __webpack_exports__["x"] = showModalConfirmarAccion;
/* harmony export (immutable) */ __webpack_exports__["h"] = downloadFile;
/* harmony export (immutable) */ __webpack_exports__["g"] = displayModalAddFile;
/* harmony export (immutable) */ __webpack_exports__["r"] = showHideModalAddFactura;
/* harmony export (immutable) */ __webpack_exports__["s"] = showHideModalAddVerificacionSOMA;
/* harmony export (immutable) */ __webpack_exports__["p"] = selectFile;
/* harmony export (immutable) */ __webpack_exports__["a"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["C"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["E"] = uploadFacturaFile;
/* harmony export (immutable) */ __webpack_exports__["G"] = uploadVerificacionSSTFile;
/* harmony export (immutable) */ __webpack_exports__["A"] = storeFactura;
/* harmony export (immutable) */ __webpack_exports__["B"] = storeVerificacionSST;
/* harmony export (immutable) */ __webpack_exports__["b"] = canmbiarResponsable;
/* harmony export (immutable) */ __webpack_exports__["F"] = uploadFiles;
/* harmony export (immutable) */ __webpack_exports__["v"] = showHideModalLastFactura;
/* harmony export (immutable) */ __webpack_exports__["t"] = showHideModalCreateOtrosi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_file_download__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__documentos__ = __webpack_require__(25);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function displayMessages(dispatch,msg){var obj={type:'warning',message:''};var message='';if(msg.response){switch(msg.response.status){case 500:message=msg&&msg.response&&msg.response.data&&msg.response.data.message?msg.response.data.message:msg.response.data.ExceptionMessage;message=message?message:msg.response.data.Message;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_277" /* MOSTRAR_MODAL_ERROR */],payload:{show:true,message:message}});break;case 401:dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:{type:'danger',message:'No está autorizado para proceder con esta solicitud. Por favor, inicie sesión y vuelva a intentarlo'}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__auth__["e" /* signOut */])());break;case 400:if(msg.response.data.ModelState){for(var property in msg.response.data.ModelState){if(msg.response.data.ModelState.hasOwnProperty(property)){for(var n=0;n<msg.response.data.ModelState[property].length;n++){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:{type:'danger',message:msg.response.data.ModelState[property][n]}});}}}}else if(msg.response.data.error){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:{type:'danger',message:msg.response.data.error_description}});}break;case 422:for(var _property in msg&&msg.response&&msg.response.data&&msg.response.data.errors||{}){if(msg.response.data.errors.hasOwnProperty(_property)){for(var _n=0;_n<msg.response.data.errors[_property].length;_n++){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:{type:'warning',message:msg.response.data.errors[_property][_n]}});}}}break;case 405:if(msg.response.data.message){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_277" /* MOSTRAR_MODAL_ERROR */],payload:{show:true,message:msg.response.data.message}});}break;case 403:dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:{type:'danger',message:'Acceso Denegado'}});break;default:}}else{if(msg.data){obj.message=msg.data.Message;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:obj});}else if(msg.message){obj.type='danger';obj.message=msg.message;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:obj});}else if(msg.info){obj.type='info';obj.message=msg.info;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:obj});}else if(msg.success){obj.type='success';obj.message=msg.success;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:obj});}else if(msg.warning){if(msg.warning instanceof Array){var _loop=function _loop(_n2){var payload={type:'warning',message:msg.warning[_n2]};var fn=function fn(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:payload});};fn(dispatch);};for(var _n2=0;_n2<msg.warning.length;_n2++){_loop(_n2);}}else{obj.type='warning';obj.message=msg.warning;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:obj});}}else{obj.type='danger';obj.message=msg;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_229" /* MOSTRAR_MENSAJE */],payload:obj});}}}function clearMessage(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_180" /* LIMPIAR_MENSAJES */]});};}function getUserConfig(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_5__auth__["b" /* getUserFromToken */])().then(function(data){var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_29" /* ASIGNAR_USUARIO_SESION */],payload:data});};fn2(dispatch);}).catch(function(err){console.log(err,err.response);if(err.response&&err.response.data.status===401){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__auth__["e" /* signOut */])());}});};}function showHideModalMsgBox(){var show=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_277" /* MOSTRAR_MODAL_ERROR */],payload:{show:show,message:message}});};}function expandCollapseModule(moduloId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_170" /* EXPANDIR_CONTRAER_MODULO */],payload:moduloId});};}function showModalSelector(title,fields,url,action){var filter=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_284" /* MOSTRAR_MODAL_SELECTOR */],payload:{title:title,fields:fields,url:url,action:action}});};fn0(dispatch);if(filter){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["D" /* ADICIONAR_FILTRO_MODAL_SELECTOR */],payload:filter});};fn1(dispatch);}dispatch(getDataFromUrl());};}function getDataFromUrl(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var url=getState().common.getIn(['modalSelector','url']);var pages=getState().common.getIn(['modalSelector','pages']);var showRecords=getState().common.getIn(['modalSelector','showRecords']);var filter=getState().common.getIn(['modalSelector','filter']);var fields=getState().common.getIn(['modalSelector','fields']);var filters=getState().common.getIn(['modalSelector','customFilters']).toJS();if(filter){fields.forEach(function(x){var f={column:x.get('value'),operator:'like',value:filter,comparison:'string',or:true};filters.push(f);});}if(pages.filter(function(x){return x===page;}).count()<1){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_225" /* MODIFICAR_PAGINA_MODAL_SELECTOR */],payload:{page:page}});};fn0(dispatch);axios.get(''+__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+url,{params:{page:page,showRecords:showRecords,filters:filters}}).then(function(res){var list=res.data.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["a" /* ACTUALIZAR_LISTADO_SELECTOR */],payload:{list:list}});}).catch(function(err){displayMessages(dispatch,err);});}};}//----------------------------------------------------------------------------------
function showModalSelectorUrlAirports(title,fields,url,action){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_285" /* MOSTRAR_MODAL_SELECTOR_AIRPORT */],payload:{title:title,fields:fields,url:url,action:action}});};fn0(dispatch);dispatch(getDataFromUrlAirports());};}// export function getDataFromUrlAirports(query) {
//     const axios = createAxiosInstance()
//     return (dispatch, getState) => {
//         const url = getState().common.getIn(['modalSelectorAirport', 'url'])
//         axios.get(`${API_IATACODES}${url}`, { params: { query }})
//         .then((res) => {
//             if (res.data.response) {
//                 const list = res.data.response.airports
//                 dispatch({ type: types.ACTUALIZAR_LISTADO_SELECTOR_AIRPORT, payload: { list } })
//             }
//         })
//         .catch((err) => {
//             displayMessages(dispatch, err)
//         })
//     }
// }
function getDataFromUrlAirports(query){var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_360" /* SEARCHING_AIRPORTS */],payload:true});var url=getState().common.getIn(['modalSelectorAirport','url']);axios.get(''+__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+url,{params:{query:query}}).then(function(res){if(res.data.airports){var list=res.data.airports_by_cities;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["b" /* ACTUALIZAR_LISTADO_SELECTOR_AIRPORT */],payload:{list:list}});}}).catch(function(err){displayMessages(dispatch,err);}).finally(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_360" /* SEARCHING_AIRPORTS */],payload:false});});};}function hideModalSelectorAirport(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_321" /* OCULTAR_MODAL_SELECTOR_AIRPORT */]});};}function clearPagesModalSelectorAirport(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_335" /* REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT */]});};}//--------------------------------
function clearPagesModalSelector(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_334" /* REINICIAR_LISTA_MODAL_SELECTOR */]});};}function hideModalSelectorFromList(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_320" /* OCULTAR_MODAL_SELECTOR */]});};}function updateModalSelectorFilterTerm(value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_187" /* MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR */],payload:value});};}function selectFromSelector(type,payload){return function(dispatch){if(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["F" /* isFunction */])(type)){type();}else{dispatch({type:type,payload:payload});}};}function getParameterByName(param){return function(dispatch,getState){var queryParam=getState().common.getIn(['parametros',param]);var gotoSrv=!queryParam;if(!gotoSrv)gotoSrv=queryParam.count()===0;if(gotoSrv){var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();axios.get(__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+'/parametros?nombre='+param).then(function(res){var list=res.data.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["j" /* ACTUALIZAR_STORE_PARAMETROS */],payload:{param:param,data:res.data}});}).catch(function(err){displayMessages(dispatch,err);});}};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_287" /* MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION */],payload:{open:open,message:message,action:action}});};}function showModalConfirmarAccion(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var hasChildren=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_181" /* MODAL_CONFIRMAR_ACCION */],payload:{open:open,message:message,action:action,hasChildren:hasChildren}});};}function downloadFile(id,filename){var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+'/files/'+id,{responseType:'arraybuffer'}).then(function(res){__WEBPACK_IMPORTED_MODULE_0_react_file_download___default()(res.data,filename);}).catch(function(err){var decodedString=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(err.response.data)));var obj={response:{data:decodedString,status:422}};displayMessages(dispatch,obj);});};}function displayModalAddFile(show,title,mode,file){var index=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;return function(dispatch){if(show){var fn0=function fn0(d){return d(getParameterByName('CLASIFICACION_ARCHIVOS'));};fn0(dispatch);dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_241" /* MOSTRAR_MODAL_AGREGAR_ARCHIVO */],payload:{show:show,title:title,mode:mode,file:file,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});}};}function showHideModalAddFactura(show,documento,url,type){var saldo=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_238" /* MOSTRAR_MODAL_ADICIONA_FACTURA */],payload:{show:show,documento:documento,url:url,type:type,saldo:saldo}});};fn0(dispatch);};}function showHideModalAddVerificacionSOMA(show,verificacion,url,type){return function(dispatch,getState){var documentoId=getState().documentos.getIn(['modalSummary','data','id']);if(!verificacion)verificacion=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["Y" /* verificacionSST */])(documentoId));var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_240" /* MOSTRAR_MODAL_ADICION_VERIFICACION_SST */],payload:{show:show,verificacion:verificacion,url:url,type:type}});};fn0(dispatch);};}function selectFile(file){return function(dispatch){var fileType=__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["a" /* acceptedFiles */].filter(function(x){return x.type===file.type;});var icon='_blank.png';if(fileType.length===1){icon=fileType[0].icon;}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:'modalAddFile.data.nombre',value:file.name}});};fn0(dispatch);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:'modalAddFile.data.file',value:file,immutable:false}});};fn1(dispatch);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:'modalAddFile.data.icono',value:icon}});};fn2(dispatch);};}function addFile(action){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:action,payload:data});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}function updateInputs(path,value){if(path==='modalAddFile.data.observaciones'){var regex=/[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;value=value.replace(regex,"").toUpperCase();}return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:path,value:value}});};fn0(dispatch);};}function uploadFacturaFile(file){return function(dispatch){var fileType=__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["a" /* acceptedFiles */].filter(function(x){return x.type===file.type;});var icon='_blank.png';if(fileType.length===1){icon=fileType[0].icon;}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:'modalAddFactura.data.file',value:file,immutable:false}});};fn1(dispatch);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:'modalAddFactura.data.icono',value:icon}});};fn2(dispatch);};}function uploadVerificacionSSTFile(file){return function(dispatch){var fileType=__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["a" /* acceptedFiles */].filter(function(x){return x.type===file.type;});var icon='_blank.png';if(fileType.length===1){icon=fileType[0].icon;}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:'modalAddVerificacionSOMA.data.file',value:file,immutable:false}});};fn1(dispatch);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */],payload:{path:'modalAddVerificacionSOMA.data.icono',value:icon}});};fn2(dispatch);};}function storeFactura(last){var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn00=function fn00(d){return d(showHideModalLastFactura(false));};fn00(dispatch);var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_98" /* DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_98" /* DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA */],payload:false});};fn0(dispatch);var fn3=function fn3(d){return d(showHideModalAddFactura(false));};var url=getState().common.getIn(['modalAddFactura','url']);var type=getState().common.getIn(['modalAddFactura','type']);var tolerancia=Number(getState().common.getIn(['parametros','TOLERANCIA',0,'VALOR']));var data=getState().common.get('modalAddFactura');var objNew=calculoAmortizacion(data.get('data'));var objOld=data.get('unchanged');var errors=validateFactura(objNew,last,tolerancia);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var files=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.fromJS([{file:objNew.get('file'),clasificacion:'Factura',observaciones:'Factura de venta No. '+objNew.get('numero_factura'),editable:false,guid:Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["B" /* guid */])(),tamano:objNew.get('file').size}]);var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["u" /* getModificaciones */])(objNew,objOld,'Factura',switchFacturas);modificaciones=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["y" /* groupModificacionesBy */])(modificaciones,'Factura','add');if(last){modificaciones.push({id:objNew.get('documento_id'),entity:'Documento',attribute:'last',value:true,action:'replace'});}var anticipo_legalizado=objNew.getIn(['documento','anticipo_legalizado'])||0;if(anticipo_legalizado>0){modificaciones.push({id:objNew.get('documento_id'),entity:'Documento',value:{anticipo_legalizado:anticipo_legalizado,estado:last?11:10},action:'edit'});}var otrosis=objNew.getIn(['documento','documentos']).filter(function(d){return d.get('tipo')==4&&d.get('anticipo_legalizado')>0;});otrosis.map(function(o){modificaciones.push({id:o.get('id'),entity:'Documento',attribute:'anticipo_legalizado',value:o.get('anticipo_legalizado'),action:'replace'});});axios.put(__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+'/'+url,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};files=files.setIn(['0','documento_id'],res.data.added.Factura[0].documento_id);files=files.setIn(['0','factura_id'],res.data.added.Factura[0].id);var fn5=function fn5(d){return d(Object(__WEBPACK_IMPORTED_MODULE_8__documentos__["e" /* getDocumento */])(objNew.get('documento_id')));};dispatch(uploadFiles('/files/'+solicitud.id,files,[fn1,fn2,fn3,fn4,fn5]));}).catch(function(err){displayMessages(dispatch,err);fn1(dispatch);});}};}function storeVerificacionSST(){var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_98" /* DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA */],payload:true});};//No aparece en actions creators
var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_98" /* DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA */],payload:false});};fn0(dispatch);var fn3=function fn3(d){return d(showHideModalAddVerificacionSOMA(false));};var data=getState().common.get('modalAddVerificacionSOMA');var url=data.get('url');var type=data.get('type');var objNew=data.get('data');var objOld=data.get('unchanged');var files=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.fromJS([{file:objNew.get('file'),clasificacion:'Documentos',observaciones:'Soporte de verificaci\xF3n de seguridad y salud en el trabajo',editable:true,guid:Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["B" /* guid */])(),tamano:objNew.get('file').size}]);var errors=validateVerificacionSST(objNew);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["u" /* getModificaciones */])(objNew,objOld,'VerificacionesSst',switchVerificacionSST);modificaciones=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["y" /* groupModificacionesBy */])(modificaciones,'VerificacionesSst',objNew.get('id')?'replace':'add');axios.put(__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+'/'+url,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};files=files.setIn(['0','documento_id'],objNew.get('documento_id'));var fn5=function fn5(d){return d(Object(__WEBPACK_IMPORTED_MODULE_8__documentos__["e" /* getDocumento */])(objNew.get('documento_id')));};dispatch(uploadFiles('/files/'+solicitud.id,files,[fn1,fn2,fn3,fn4,fn5]));}).catch(function(err){console.log(err);displayMessages(dispatch,err);fn1(dispatch);});}};}function canmbiarResponsable(solicitud,type){var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var url=getState().common.getIn(['enums','solicitudes','tipos',String(solicitud.get('tipo')),'url']);var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',attribute:'responsable_compras_id',value:solicitud.getIn(['responsable_compras','id']),action:'edit'});modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',attribute:'solicitante_id',value:solicitud.getIn(['solicitante','id']),action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+'/solicitudes/'+url+'/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();}).catch(function(err){console.log(err);displayMessages(dispatch,err);});};}function uploadFiles(url,files,actions){var axios=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var errors=validarUpload(files);if(errors.length){return errors.forEach(function(element){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warning(element,{bodyClassName:'toastify-content toastify-warning'});});}else{var formData=new FormData();var index=0;var j=void 0;files.map(function(f){if(f.get('id')==null){formData.append('files['+index+'][file]',f.get('file'),''+(f.get('nombre')||f.get('file').name));formData.append('files['+index+'][clasificacion]',f.get('clasificacion'));formData.append('files['+index+'][observaciones]',f.get('observaciones')||null);formData.append('files['+index+'][editable]',f.get('editable'));formData.append('files['+index+'][guid]',f.get('guid'));formData.append('files['+index+'][tamano]',f.get('file').size);formData.append('files['+index+'][documento_id]',f.get('documento_id')||null);formData.append('files['+index+'][factura_id]',f.get('factura_id')||null);if(f.get('entities')){j=0;f.get('entities').map(function(r){formData.append('files['+index+'][entities]['+j+'][entity]',r.get('entity'));formData.append('files['+index+'][entities]['+j+'][guid]',r.get('guid'));j++;});}index++;}});axios.post(''+__WEBPACK_IMPORTED_MODULE_7__index__["b" /* API_URL */]+url,formData).then(function(){actions.map(function(x){return x(dispatch);});}).catch(function(){actions.map(function(x){return x(dispatch);});__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].error('Se presentó un error al intentar subir los archivos',{bodyClassName:'toastify-content toastify-danger'});});}};}function validarUpload(files){var errors=[];if(files.length>0){var size=files[0].get('file').size;if(size>__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["W" /* uploadMaxSize */].value)errors.push('La capacidad m\xE1xima para subir archivos es de de '+__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["W" /* uploadMaxSize */].unidad);if(!files[0].get('clasificacion'))errors.push('Debe seleccionar una clasificación');}return errors;}var validateFactura=function validateFactura(data){var last=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var tolerancia=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var errors=[];if(!data.get('numero_factura'))errors.push('El campo factura número es obligatorio');if(!data.get('fecha_factura'))errors.push('El campo fecha de la factura es obligatorio');if(data.get('fecha_factura')&&__WEBPACK_IMPORTED_MODULE_3_moment___default()(data.get('fecha_factura'))>__WEBPACK_IMPORTED_MODULE_3_moment___default()())errors.push('El campo fecha debe ser menor o igual que la de hoy');if(!data.get('valor_sin_iva'))errors.push('El campo valor sin IVA es obligatorio');if(!data.get('valor_con_iva'))errors.push('El campo valor con IVA es obligatorio');if(!data.get('file'))errors.push('Debe adjuntar el documento escaneado');var facturas=data.getIn(['documento','facturas']);if(facturas.filter(function(f){return f.get('numero_factura')==data.get('numero_factura');}).count()>0)errors.push('La factura ya se encuentra registrada');var totales=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["x" /* getTotalesDocumento */])(data.get('documento'));//const anticipo = calcularAnticipos(data.get('documento'))
var saldo_sin_iva=totales.sin_iva-Number(data.get('valor_sin_iva'));var saldo_con_iva=totales.con_iva-Number(data.get('valor_con_iva'));var tolerancia_sin_iva=Math.abs(totales.sin_iva-Number(data.get('valor_sin_iva')));var tolerancia_con_iva=Math.abs(totales.con_iva-Number(data.get('valor_con_iva')));if(data.getIn(['documento','entregas_parciales'])==false){if(tolerancia_sin_iva>tolerancia)errors.push('El valor sin iva de la factura debe ser igual al valor total sin iva del documento.');if(tolerancia_con_iva>tolerancia)errors.push('El valor con iva de la factura debe ser igual al valor total con iva del documento.');}else{if(last&&saldo_sin_iva<0&&tolerancia_sin_iva>tolerancia){errors.push('La suma de los valores sin iva de las factura debe ser igual a la suma de los valores sin iva del documento al cerrar el documento');}if(!last&&saldo_sin_iva<0&&tolerancia_sin_iva>tolerancia){errors.push('La suma de los valores sin iva de las factura debe ser menor o igual a la suma de los valores sin iva del documento.');}if(saldo_con_iva<0&&tolerancia_con_iva>tolerancia){errors.push('La suma de los valores totales de las factura debe ser menor o igual a la suma de los valores totales del documento');}}var verificacion_sst_pendiente=data.getIn(['documento','verificaciones_sst']).filter(function(v){return v.get('verificado')==false;}).count()>0;if(last&&verificacion_sst_pendiente){errors.push('Queda pendiente una verificacion de SOMA');}return errors;};var validateVerificacionSST=function validateVerificacionSST(data){var errors=[];if(data.get('aceptado')==0&&!data.get('observaciones'))errors.push('El campo observaciones es obligatorio');if(!data.get('file'))errors.push('Debe adjuntar el soporte escaneado');return errors;};var switchFacturas=function switchFacturas(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];var hidden=['file','guid','id','icono','documento'];if(hidden.indexOf(modificacion.attribute)!==-1){modificacion.action='hidden';}};var switchVerificacionSST=function switchVerificacionSST(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];var hidden=['file','guid','id','icono'];if(hidden.indexOf(modificacion.attribute)!==-1){modificacion.action='hidden';}};function showHideModalLastFactura(show){var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch){var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_286" /* MOSTRAR_MODAL_ULTIMA_FACTURA */],payload:{show:show,action:action}});};fn2(dispatch);};}// export function showHideModalAddFirmas(show, contratoanual, url, type) {
//     return (dispatch) => {
//         const fn0 = d => d({ type: types.MOSTRAR_MODAL_ADICION_FIRMAS, payload: { show, contratoanual, url, type }})
//         fn0(dispatch)
//     }
// }
function showHideModalCreateOtrosi(show){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_268" /* MOSTRAR_MODAL_CREATE_OTROSI */],payload:{show:show,message:message}});};fn1(dispatch);};}var obtenerDetalles=function obtenerDetalles(documento){var totales={sin_iva:0,con_iva:0,sin_iva_sin_adiciones:0,con_iva_sin_adiciones:0};documento.get('detalles').forEach(function(a){totales.sin_iva+=a.get('valor')*a.get('cantidad');totales.con_iva+=a.get('valor_con_iva')*a.get('cantidad');if(a.get('adicion_id')===null){totales.sin_iva_sin_adiciones+=a.get('valor')*a.get('cantidad');totales.con_iva_sin_adiciones+=a.get('valor_con_iva')*a.get('cantidad');}});return totales;};var calculoAmortizacion=function calculoAmortizacion(factura){var documento=factura.get('documento');var documentos=[];documentos.push(documento);documento.get('documentos').filter(function(d){return d.get('tipo')==4;}).map(function(x){documentos.push(x);});var valor_total_documento_sin_iva=documentos.reduce(function(acc1,current1){acc1+=current1.get('detalles').reduce(function(acc2,current2){acc2+=current2.get('valor')*current2.get('cantidad');return acc2;},0);return acc1;},0);var valor_total_anticipos=documentos.reduce(function(acc1,current1){var anticipo=current1.get('anticipo');var total_detalles=current1.get('detalles').reduce(function(acc2,current2){if(current2.get('adicion_id')===null){acc2+=current2.get('valor')*current2.get('cantidad');}return acc2;},0);acc1+=anticipo/100*total_detalles;return acc1;},0);var anticipo=Math.ceil(valor_total_anticipos/valor_total_documento_sin_iva*100);var valor_sin_iva=factura.get('valor_sin_iva')?factura.get('valor_sin_iva'):0;var valor_con_iva=factura.get('valor_con_iva')?factura.get('valor_con_iva'):0;if(anticipo>0){(function(){var documentos_con_anticipo=[];if(documento.get('anticipo')>0){documentos_con_anticipo.push(documento);}documento.get('documentos').filter(function(d){return d.get('tipo')==4&&d.get('anticipo')>0;}).map(function(x){documentos_con_anticipo.push(x);});var porcentaje_amortizado=void 0;if(documentos_con_anticipo.length>1){porcentaje_amortizado=anticipo;}else{porcentaje_amortizado=documentos_con_anticipo[0].get('anticipo');}porcentaje_amortizado=porcentaje_amortizado?porcentaje_amortizado:0;var valor_descuento=porcentaje_amortizado/100*valor_sin_iva;var valor_descontado=0;var _loop2=function _loop2(i){if(valor_descontado<valor_descuento){var anticipo_legalizado=documentos_con_anticipo[i].get('anticipo_legalizado')||0;var total_sin_iva=obtenerDetalles(documentos_con_anticipo[i]).sin_iva_sin_adiciones;var valor_anticipo=documentos_con_anticipo[i].get('anticipo')/100*total_sin_iva;var pendiente_legalizar=valor_anticipo-anticipo_legalizado;if(pendiente_legalizar>0){var pendiente=valor_descuento-valor_descontado;if(pendiente<=pendiente_legalizar){valor_descontado+=pendiente;anticipo_legalizado+=pendiente;}else{valor_descontado+=pendiente_legalizar;anticipo_legalizado=valor_anticipo;}if(documentos_con_anticipo[i].get('tipo')!=4){// Documento original
factura=factura.setIn(['documento','anticipo_legalizado'],anticipo_legalizado);}else{// Documentos OTROSI
var index=factura.getIn(['documento','documentos']).findIndex(function(d){return d.get('id')==documentos_con_anticipo[i].get('id');});if(index!=-1){factura=factura.setIn(['documento','documentos',index,'anticipo_legalizado'],anticipo_legalizado);}}}}};for(var i=0;i<documentos_con_anticipo.length;i++){_loop2(i);}var valor_a_pagar=valor_con_iva-valor_descontado;factura=factura.set('amortizacion',valor_descontado);factura=factura.set('valor_a_pagar',valor_a_pagar);//Calcular amortizacion
if(valor_descontado<valor_descuento){porcentaje_amortizado=(valor_descontado/valor_sin_iva*100).toFixed(2);}factura=factura.set('porcentaje_amortizacion',porcentaje_amortizado);})();}else{var valor_a_pagar=valor_con_iva;factura=factura.set('amortizacion',0);factura=factura.set('valor_a_pagar',valor_a_pagar);}return factura;};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.26.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.26.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(224)(module)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoxButton=function(_Component){_inherits(BoxButton,_Component);function BoxButton(){_classCallCheck(this,BoxButton);return _possibleConstructorReturn(this,(BoxButton.__proto__||Object.getPrototypeOf(BoxButton)).apply(this,arguments));}_createClass(BoxButton,[{key:'render',value:function render(){var disabled=this.props.disabled===true;var onClick=disabled?null:this.props.onClick;var _props=this.props,size=_props.size,contrast=_props.contrast;var styleButton=Object.assign({},this.props.style||{});var styleI={};if(size){styleButton.lineHeight=size+'px';styleI.fontSize=size+'px';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'box-button '+(disabled?'disabled':'')+' '+(this.props.danger?'danger':'')+' '+(this.props.active?'active':'')+' '+(this.props.dropdown?'dropped':'')+' '+(contrast?'contrast':''),onClick:onClick,title:this.props.title,style:styleButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+this.props.name,style:styleI}));}}]);return BoxButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BoxButton);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return INICIAR_SESION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CERRAR_SESION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return MODIFICAR_INPUTS_SIGNIN_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return ASIGNAR_USUARIO_SESION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_332", function() { return PROCESAMIENTO_SIGNIN_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return LIMPIAR_MENSAJES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return MOSTRAR_MENSAJE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return MOSTRAR_MODAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return EXPANDIR_CONTRAER_MODULO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return MOSTRAR_MODAL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_320", function() { return OCULTAR_MODAL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTUALIZAR_LISTADO_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return MODIFICAR_PAGINA_MODAL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_334", function() { return REINICIAR_LISTA_MODAL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ACTUALIZAR_STORE_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return MODAL_CONFIRMAR_ACCION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ADICIONAR_FILTRO_MODAL_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return MOSTRAR_MODAL_SELECTOR_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_321", function() { return OCULTAR_MODAL_SELECTOR_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTUALIZAR_LISTADO_SELECTOR_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return MODIFICAR_PAGINA_MODAL_SELECTOR_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_335", function() { return REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return OBTENER_ADMIN_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CONMUTAR_SELECCION_ADMIN_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return FILTRAR_ADMIN_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_322", function() { return ORDENAR_ADMIN_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CREAR_ACTUALIZAR_ADMIN_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return ELIMINAR_ADMIN_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_312", function() { return OBTENER_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CONMUTAR_SELECCION_USUARIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CONMUTAR_SELECCION_TODOS_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return FILTRAR_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_331", function() { return ORDENAR_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return MOSTRAR_MODAL_CREAR_USUARIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return DESHABILITAR_BOTON_MODAL_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CREAR_ACTUALIZAR_USUARIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return ELIMINAR_USUARIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ADICIONAR_CRITERIO_FILTRADO_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return ELIMINAR_CRITERIO_FILTRADO_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return MODIFICAR_CRITERIO_FILTRADO_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return APLICAR_CRITERIOS_FILTRADO_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CAMBIAR_MOSTRAR_REGISTROS_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return MODIFICAR_INPUTS_USUARIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_301", function() { return OBTENER_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_300", function() { return OBTENER_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return MODIFICAR_INPUTS_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return ADICIONAR_NUEVO_DETALLE_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CONMUTAR_SELECCION_TODOS_PARAMETROS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_304", function() { return OBTENER_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CONMUTAR_SELECCION_SOLICITUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CONMUTAR_SELECCION_TODOS_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return FILTRAR_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_330", function() { return ORDENAR_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return ELIMINAR_SOLICITUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return APLICAR_CRITERIOS_FILTRADO_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_340", function() { return REINICIAR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return MODIFICAR_INPUTS_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_318", function() { return OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return ELIMINAR_ITEMS_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_314", function() { return OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO; });
/* unused harmony export RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return ENVIAR_COMENTARIO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return EDITAR_COMENTARIO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_309", function() { return OBTENER_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return MODIFICAR_INPUTS_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ACTUALIZAR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CONMUTAR_SELECCION_APROBACION_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_353", function() { return REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_364", function() { return SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_319", function() { return OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return EDITAR_COMENTARIO_SOLICITUD_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_336", function() { return REINICIAR_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION; });
/* unused harmony export OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_305", function() { return OBTENER_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_363", function() { return SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_369", function() { return SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_355", function() { return REMOVER_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION; });
/* unused harmony export ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION1 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CONMUTAR_SELECCION_TODOS_BIENES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_352", function() { return REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_366", function() { return SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_341", function() { return REINICIAR_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_316", function() { return OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_315", function() { return OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_333", function() { return RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_344", function() { return REINICIAR_VALORES_AIU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_345", function() { return REINICIAR_VALORES_IVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return ENVIAR_COMENTARIO_SOLICITUD_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return EDITAR_COMENTARIO_SOLICITUD_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return ELIMINAR_COMENTARIO_SOLICITUD_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_310", function() { return OBTENER_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ACTUALIZAR_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_354", function() { return REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT; });
/* unused harmony export MOSTRAR_MODAL_RESUMEN_SOLICITUD_SERVICIO_OT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_342", function() { return REINICIAR_SOLICITUD_SERVICIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_317", function() { return OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_367", function() { return SELECCIONAR_MONEDA_SOLICITUD_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return EDITAR_COMENTARIO_SOLICITUD_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_302", function() { return OBTENER_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CONMUTAR_SELECCION_PLANTILLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CONMUTAR_SELECCION_TODOS_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return FILTRAR_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_328", function() { return ORDENAR_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return MOSTRAR_MODAL_CREAR_PLANTILLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return MODIFICAR_INPUTS_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return DESHABILITAR_BOTON_MODAL_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CREAR_ACTUALIZAR_PLANTILLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return ELIMINAR_PLANTILLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return APLICAR_CRITERIOS_FILTRADO_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return OBTENER_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CONMUTAR_SELECCION_GARANTIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CONMUTAR_SELECCION_TODOS_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return FILTRAR_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_326", function() { return ORDENAR_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return MOSTRAR_MODAL_CREAR_GARANTIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return MODIFICAR_INPUTS_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return DESHABILITAR_BOTON_MODAL_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CREAR_ACTUALIZAR_GARANTIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return ELIMINAR_GARANTIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ADICIONAR_CRITERIO_FILTRADO_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return ELIMINAR_CRITERIO_FILTRADO_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return MODIFICAR_CRITERIO_FILTRADO_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return APLICAR_CRITERIOS_FILTRADO_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_337", function() { return REINICIAR_SOLICITUD_CONTRATOANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_338", function() { return REINICIAR_SOLICITUD_CONTRATOANUAL1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_306", function() { return OBTENER_SOLICITUD_CONTRATOANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACTUALIZAR_SOLICITUD_CONTRATOANUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return MOSTRAR_MODAL_ADICION_FIRMAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return MOSTRAR_MODAL_AGREGAR_ARCHIVO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_313", function() { return OCULTAR_MODAL_AGREGAR_ARCHIVO; });
/* unused harmony export MODIFICAR_INPUTS_ARCHIVO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return MODIFICAR_INPUTS_COMMON_REDUCER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CONMUTAR_SELECCION_TODOS_ITEMS_FILES; });
/* unused harmony export REMOVER_ARCHIVOS_SOLICITUD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return OBTENER_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return FILTRAR_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_324", function() { return ORDENAR_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return MODIFICAR_INPUTS_EXTERNOS_APROBACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return OBTENER_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return FILTRAR_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_325", function() { return ORDENAR_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return MOSTRAR_MODAL_RESUMEN_DOCUMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return MODIFICAR_INPUTS_DOCUMENTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS; });
/* unused harmony export MOSTRAR_MODAL_ADICIONA_FACTURA_DOCUMENTO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return MOSTRAR_MODAL_ADICIONAR_ADICIONAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return ELIMINAR_ARCHIVOS_DOCUMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return ADICIONAR_NUEVO_CENCO_ADICIONAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return ELIMINAR_CENCOS_ADICIONAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return MOSTRAR_MODAL_ADICIONA_FACTURA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return MOSTRAR_MODAL_ULTIMA_FACTURA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return MOSTRAR_MODAL_ADICION_VERIFICACION_SST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_343", function() { return REINICIAR_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return ADICIONAR_TRAYECTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return ADICIONAR_TRAYECTO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_356", function() { return REMOVER_TRAYECTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_357", function() { return REMOVER_TRAYECTOS1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return ADICIONAR_PASAPORTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_311", function() { return OBTENER_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_351", function() { return REMOVER_COTIZACION_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ADICIONAR_COTIZACION_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ACTUALIZAR_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_362", function() { return SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return MOSTRAR_MODAL_ADICIONAR_TIQUETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return MODIFICAR_TIQUETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return MOSTRAR_MODAL_ADICIONAR_ASISTENCIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return MODIFICAR_ASISTENCIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_348", function() { return REMOVER_CENCOS_TIQUETESAEREOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_349", function() { return REMOVER_CENCOS_TIQUETESAEREOS1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return EDITAR_ARCHIVO_PASAPORTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_339", function() { return REINICIAR_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return MODIFICAR_INPUTS_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ADICIONAR_ALOJAMIENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_346", function() { return REMOVER_ALOJAMIENTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_307", function() { return OBTENER_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_350", function() { return REMOVER_COTIZACION_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return MODIFICAR_INPUTS_SOLICITUD_HOTELES1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return ADICIONAR_MODIFICACION_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ADICIONAR_COTIZACION_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACTUALIZAR_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_361", function() { return SELECCIONAR_APROBACION_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return MOSTRAR_MODAL_ADICIONAR_RESERVACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return MODIFICAR_RESERVACION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_347", function() { return REMOVER_CENCOS_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return ENVIAR_COMENTARIO_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return EDITAR_COMENTARIO_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return ELIMINAR_COMENTARIO_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return EDITAR_COMENTARIO_SOLICITUD_HOTELES1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_308", function() { return OBTENER_SOLICITUD_OTROSI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return MOSTRAR_MODAL_CREATE_OTROSI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_358", function() { return RESETEAR_REDUCER_SOLICITUD_OTROSI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return OBTENER_GRUPOS; });
/* unused harmony export CONMUTAR_SELECCION_GRUPO */
/* unused harmony export CONMUTAR_SELECCION_TODOS_GRUPOS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return FILTRAR_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_327", function() { return ORDENAR_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return MOSTRAR_MODAL_CREAR_GRUPO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return DESHABILITAR_BOTON_MODAL_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CREAR_ACTUALIZAR_GRUPO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return ELIMINAR_GRUPO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ADICIONAR_CRITERIO_FILTRADO_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return ELIMINAR_CRITERIO_FILTRADO_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return MODIFICAR_CRITERIO_FILTRADO_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return APLICAR_CRITERIOS_FILTRADO_GRUPOS; });
/* unused harmony export CAMBIAR_MOSTRAR_REGISTROS_GRUPOS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return MODIFICAR_INPUTS_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_365", function() { return SELECCIONAR_ITEM_GRUPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return BUSQUEDADOCUMENTO_REINICIAR_ESTADO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return BUSQUEDADOCUMENTO_MODIFICAR_INPUTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ADICIONAR_CRITERIO_FILTRADO_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return APLICAR_CRITERIOS_FILTRADO_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return ELIMINAR_CRITERIO_FILTRADO_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return MODIFICAR_CRITERIO_FILTRADO_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return MODIFICAR_INPUTS_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return MODIFICAR_NUMERO_REGISTROS_MOSTRAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return OBTENER_EVALUACION_PROVEEDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_299", function() { return OBTENER_MONTO_CONTRATADO_PROVEEDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_298", function() { return OBTENER_MONTO_CONTRATADO_CENCO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_303", function() { return OBTENER_RADICADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return OBTENER_GESTION_RESPONSABLE_COMPRAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_329", function() { return ORDENAR_REPORTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return MODIFICAR_INPUTS_CAMBIO_CONTRASENA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return OBTENER_MAESTRAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return MOSTRAR_MODAL_ADICIONAR_MAESTRA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CONMUTAR_SELECCION_MAESTRAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CONMUTAR_SELECCION_TODAS_MAESTRAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return MODIFICAR_INPUTS_MAESTRA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return MOSTRAR_MODAL_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return MOSTRAR_MODAL_ADICIONAR_DELEGADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return OBTENER_DELEGADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CONMUTAR_SELECCION_DELEGADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CONMUTAR_SELECCION_TODOS_DELEGADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return MODIFICAR_INPUTS_DELEGADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_359", function() { return RESET_MODAL_ADD_DELEGADO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_323", function() { return ORDENAR_DELEGADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return ADMINDB_POBLAR_RESULTADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return MODIFICAR_INPUTS_ADMINDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return ADMINDB_RESETEAR_TABLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_368", function() { return SELECCIONAR_TIPO_SOLICITUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_360", function() { return SEARCHING_AIRPORTS; });
var INICIAR_SESION='INICIAR_SESION';var CERRAR_SESION='CERRAR_SESION';var MODIFICAR_INPUTS_SIGNIN_PAGE='MODIFICAR_INPUTS_SIGNIN_PAGE';var ASIGNAR_USUARIO_SESION='ASIGNAR_USUARIO_SESION';var PROCESAMIENTO_SIGNIN_PAGE='PROCESAMIENTO_SIGNIN_PAGE';var LIMPIAR_MENSAJES='LIMPIAR_MENSAJES';var MOSTRAR_MENSAJE='MOSTRAR_MENSAJE';var MOSTRAR_MODAL_ERROR='MOSTRAR_MODAL_ERROR';var EXPANDIR_CONTRAER_MODULO='EXPANDIR_CONTRAER_MODULO';var MOSTRAR_MODAL_SELECTOR='MOSTRAR_MODAL_SELECTOR';var OCULTAR_MODAL_SELECTOR='OCULTAR_MODAL_SELECTOR';var MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR='MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR';var ACTUALIZAR_LISTADO_SELECTOR='ACTUALIZAR_LISTADO_SELECTOR';var MODIFICAR_PAGINA_MODAL_SELECTOR='MODIFICAR_PAGINA_MODAL_SELECTOR';var REINICIAR_LISTA_MODAL_SELECTOR='REINICIAR_LISTA_MODAL_SELECTOR';var ACTUALIZAR_STORE_PARAMETROS='ACTUALIZAR_STORE_PARAMETROS';var MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION='MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION';var MODAL_CONFIRMAR_ACCION='MODAL_CONFIRMAR_ACCION';var ADICIONAR_FILTRO_MODAL_SELECTOR='ADICIONAR_FILTRO_MODAL_SELECTOR';//------
var MOSTRAR_MODAL_SELECTOR_AIRPORT='MOSTRAR_MODAL_SELECTOR_AIRPORT';var OCULTAR_MODAL_SELECTOR_AIRPORT='OCULTAR_MODAL_SELECTOR_AIRPORT';var MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR_AIRPORT='MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR_AIRPORT';var ACTUALIZAR_LISTADO_SELECTOR_AIRPORT='ACTUALIZAR_LISTADO_SELECTOR_AIRPORT';var MODIFICAR_PAGINA_MODAL_SELECTOR_AIRPORT='MODIFICAR_PAGINA_MODAL_SELECTOR_AIRPORT';var REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT='REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT';//----
//Admin Parametros
var OBTENER_ADMIN_PARAMETROS='OBTENER_ADMIN_PARAMETROS';var CONMUTAR_SELECCION_ADMIN_PARAMETRO='CONMUTAR_SELECCION_ADMIN_PARAMETRO';var CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS='CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS';var FILTRAR_ADMIN_PARAMETROS='FILTRAR_ADMIN_PARAMETROS';var ORDENAR_ADMIN_PARAMETROS='ORDENAR_ADMIN_PARAMETROS';var MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO='MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO';var MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS='MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS';var DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS='DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS';var CREAR_ACTUALIZAR_ADMIN_PARAMETRO='CREAR_ACTUALIZAR_ADMIN_PARAMETRO';var MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO='MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO';var ELIMINAR_ADMIN_PARAMETRO='ELIMINAR_ADMIN_PARAMETRO';var ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO='ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO';var ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO='ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO';//Usuarios
var OBTENER_USUARIOS='OBTENER_USUARIOS';var CONMUTAR_SELECCION_USUARIO='CONMUTAR_SELECCION_USUARIO';var CONMUTAR_SELECCION_TODOS_USUARIOS='CONMUTAR_SELECCION_TODOS_USUARIOS';var FILTRAR_USUARIOS='FILTRAR_USUARIOS';var ORDENAR_USUARIOS='ORDENAR_USUARIOS';var MOSTRAR_MODAL_CREAR_USUARIO='MOSTRAR_MODAL_CREAR_USUARIO';var MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS='MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS';var DESHABILITAR_BOTON_MODAL_USUARIOS='DESHABILITAR_BOTON_MODAL_USUARIOS';var CREAR_ACTUALIZAR_USUARIO='CREAR_ACTUALIZAR_USUARIO';var MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO='MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO';var ELIMINAR_USUARIO='ELIMINAR_USUARIO';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS='MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS';var ADICIONAR_CRITERIO_FILTRADO_USUARIOS='ADICIONAR_CRITERIO_FILTRADO_USUARIOS';var ELIMINAR_CRITERIO_FILTRADO_USUARIOS='ELIMINAR_CRITERIO_FILTRADO_USUARIOS';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS='CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS';var MODIFICAR_CRITERIO_FILTRADO_USUARIOS='MODIFICAR_CRITERIO_FILTRADO_USUARIOS';var APLICAR_CRITERIOS_FILTRADO_USUARIOS='APLICAR_CRITERIOS_FILTRADO_USUARIOS';var CAMBIAR_MOSTRAR_REGISTROS_USUARIOS='CAMBIAR_MOSTRAR_REGISTROS_USUARIOS';var MODIFICAR_INPUTS_USUARIOS='MODIFICAR_INPUTS_USUARIOS';//Parametros
var OBTENER_PARAMETROS='OBTENER_PARAMETROS';var OBTENER_PARAMETRO='OBTENER_PARAMETRO';var MODIFICAR_INPUTS_PARAMETROS='MODIFICAR_INPUTS_PARAMETROS';var ADICIONAR_NUEVO_DETALLE_PARAMETRO='ADICIONAR_NUEVO_DETALLE_PARAMETRO';var CONMUTAR_SELECCION_TODOS_PARAMETROS='CONMUTAR_SELECCION_TODOS_PARAMETROS';var MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO='MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO';//Solicitudes
var OBTENER_SOLICITUDES='OBTENER_SOLICITUDES';var CONMUTAR_SELECCION_SOLICITUD='CONMUTAR_SELECCION_SOLICITUD';var CONMUTAR_SELECCION_TODOS_SOLICITUDES='CONMUTAR_SELECCION_TODOS_SOLICITUDES';var FILTRAR_SOLICITUDES='FILTRAR_SOLICITUDES';var ORDENAR_SOLICITUDES='ORDENAR_SOLICITUDES';var MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD='MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD';var ELIMINAR_SOLICITUD='ELIMINAR_SOLICITUD';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES='MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES';var ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES='ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES';var ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES='ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES='CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES';var MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES='MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES';var APLICAR_CRITERIOS_FILTRADO_SOLICITUDES='APLICAR_CRITERIOS_FILTRADO_SOLICITUDES';var CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES='CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES';//Creacion solicitudes de servicio
var REINICIAR_SOLICITUD_SERVICIO='REINICIAR_SOLICITUD_SERVICIO';var MODIFICAR_INPUTS_SOLICITUD_SERVICIO='MODIFICAR_INPUTS_SOLICITUD_SERVICIO';var MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO='MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD';var OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO='OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD';var ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO='ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO';var ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM='ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM';var ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO='ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO';var ELIMINAR_ITEMS_SOLICITUD_SERVICIO='ELIMINAR_ITEMS_SOLICITUD_SERVICIO';var CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO='CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO';var OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO='OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO';var ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO='ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO';var MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO='MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO';var RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO='RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO';var DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO='DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO';var ENVIAR_COMENTARIO_SOLICITUD_SERVICIO='ENVIAR_COMENTARIO_SOLICITUD_SERVICIO';var EDITAR_COMENTARIO_SOLICITUD_SERVICIO='EDITAR_COMENTARIO_SOLICITUD_SERVICIO';var ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO='ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO';//Solicitud de servicio
var ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO='ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO';var OBTENER_SOLICITUD_SERVICIO='OBTENER_SOLICITUD_SERVICIO';var MODIFICAR_INPUTS_SOLICITUD_SERVICIO1='MODIFICAR_INPUTS_SOLICITUD_SERVICIO1';var ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO='ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO';var ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO='ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO';var ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO='ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO';var DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO='DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO';var ACTUALIZAR_SOLICITUD_SERVICIO='ACTUALIZAR_SOLICITUD_SERVICIO';var CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO='CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO';var CONMUTAR_SELECCION_APROBACION_SERVICIO='CONMUTAR_SELECCION_APROBACION_SERVICIO';var MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO='MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO';var ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO='ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO';var REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO='REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO';var DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO='DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO';var ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO1='ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO1';var ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO='ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO';var SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO='SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO';var MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO='MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO';var MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1='MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD1';var OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1='OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD1';var ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1='ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1';var ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1='ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1';var ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1='ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1';var DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO='DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO';var ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1='ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1';var EDITAR_COMENTARIO_SOLICITUD_SERVICIO1='EDITAR_COMENTARIO_SOLICITUD_SERVICIO1';var DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1='DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1';// Creacion de solicitud de bienes e investigacion
var REINICIAR_SOLICITUD_BIENES_INVESTIGACION='REINICIAR_SOLICITUD_BIENES_INVESTIGACION';var MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION='MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION';var MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION='MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION';var ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION='ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION';var CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION='CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION';var CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION='CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION';var ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM='ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM';var DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION='DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION';var OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION='OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION';var ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION='ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION';var ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION='ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION';var CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION='CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION';var ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION='ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION';var EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION='EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION';var ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION='ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION';// Solicitud de bienes e investigación
var OBTENER_SOLICITUD_BIENES_INVESTIGACION='OBTENER_SOLICITUD_BIENES_INVESTIGACION';var MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1='MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1';var DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION='DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION';var SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION='SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION';var SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION='SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION';var REMOVER_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION='REMOVER_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION';var CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION='CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION';var CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION='CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION';var MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION='MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION';var ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION='ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION';var DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION='DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION';var MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION='MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION';var ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION1='ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION1';var ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1='ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1';var CONMUTAR_SELECCION_TODOS_BIENES='CONMUTAR_SELECCION_TODOS_BIENES';var REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION='REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION';var DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION='DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION';var SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1='SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1';var ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1='ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1';var EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1='EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1';var DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1='DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1';var ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1='ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1';//Creacion Solicitud de servicio - Oficina tecnica
var ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT='ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT';var REINICIAR_SOLICITUD_SERVICIO_OT='REINICIAR_SOLICITUD_SERVICIO_OT';var MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT='MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT';var MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT='MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD';var OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT='OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD';var ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT='ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT';var ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM='ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM';var ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT='ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT';var ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT='ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT';var CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO_OT='CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO_OT';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT';var OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT='OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT';var ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT='ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT';var MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT='MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT';var RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO_OT='RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO_OT';var DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT='DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT';var ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT='ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT';var ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT='ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT';var REINICIAR_VALORES_AIU='REINICIAR_VALORES_AIU';var REINICIAR_VALORES_IVA='REINICIAR_VALORES_IVA';var ENVIAR_COMENTARIO_SOLICITUD_OT='ENVIAR_COMENTARIO_SOLICITUD_OT';var EDITAR_COMENTARIO_SOLICITUD_OT='EDITAR_COMENTARIO_SOLICITUD_OT';var ELIMINAR_COMENTARIO_SOLICITUD_OT='ELIMINAR_COMENTARIO_SOLICITUD_OT';//Solicitud de servicio - Oficina técnica
var OBTENER_SOLICITUD_SERVICIO_OT='OBTENER_SOLICITUD_SERVICIO_OT';var ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT='ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT';var ACTUALIZAR_SOLICITUD_SERVICIO_OT='ACTUALIZAR_SOLICITUD_SERVICIO_OT';var MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT='MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT';var MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1='MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1';var ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT='ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT';var REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT='REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT';var DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT='DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT';var MOSTRAR_MODAL_RESUMEN_SOLICITUD_SERVICIO_OT='MOSTRAR_MODAL_RESUMEN_SOLICITUD_SERVICIO_OT';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT1='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT1';var ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1='ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1';var REINICIAR_SOLICITUD_SERVICIO_OT1='REINICIAR_SOLICITUD_SERVICIO_OT1';var MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1='MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1';var OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1='OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD1';var ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1='ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1';var DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT='DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT';var SELECCIONAR_MONEDA_SOLICITUD_OT1='SELECCIONAR_MONEDA_SOLICITUD_OT1';var ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1='ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1';var EDITAR_COMENTARIO_SOLICITUD_OT1='EDITAR_COMENTARIO_SOLICITUD_OT1';var DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1='DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1';//Plantillas
var OBTENER_PLANTILLAS='OBTENER_PLANTILLAS';var CONMUTAR_SELECCION_PLANTILLA='CONMUTAR_SELECCION_PLANTILLA';var CONMUTAR_SELECCION_TODOS_PLANTILLAS='CONMUTAR_SELECCION_TODOS_PLANTILLAS';var FILTRAR_PLANTILLAS='FILTRAR_PLANTILLAS';var ORDENAR_PLANTILLAS='ORDENAR_PLANTILLAS';var MOSTRAR_MODAL_CREAR_PLANTILLA='MOSTRAR_MODAL_CREAR_PLANTILLA';var MODIFICAR_INPUTS_PLANTILLAS='MODIFICAR_INPUTS_PLANTILLAS';var DESHABILITAR_BOTON_MODAL_PLANTILLAS='DESHABILITAR_BOTON_MODAL_PLANTILLAS';var CREAR_ACTUALIZAR_PLANTILLA='CREAR_ACTUALIZAR_PLANTILLA';var MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA='MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA';var ELIMINAR_PLANTILLA='ELIMINAR_PLANTILLA';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS='MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS';var ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS='ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS';var ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS='ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS='CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS';var MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS='MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS';var APLICAR_CRITERIOS_FILTRADO_PLANTILLAS='APLICAR_CRITERIOS_FILTRADO_PLANTILLAS';var CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS='CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS';//Garantias
var OBTENER_GARANTIAS='OBTENER_GARANTIAS';var CONMUTAR_SELECCION_GARANTIA='CONMUTAR_SELECCION_GARANTIA';var CONMUTAR_SELECCION_TODOS_GARANTIAS='CONMUTAR_SELECCION_TODOS_GARANTIAS';var FILTRAR_GARANTIAS='FILTRAR_GARANTIAS';var ORDENAR_GARANTIAS='ORDENAR_GARANTIAS';var MOSTRAR_MODAL_CREAR_GARANTIA='MOSTRAR_MODAL_CREAR_GARANTIA';var MODIFICAR_INPUTS_GARANTIAS='MODIFICAR_INPUTS_GARANTIAS';var DESHABILITAR_BOTON_MODAL_GARANTIAS='DESHABILITAR_BOTON_MODAL_GARANTIAS';var CREAR_ACTUALIZAR_GARANTIA='CREAR_ACTUALIZAR_GARANTIA';var MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA='MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA';var ELIMINAR_GARANTIA='ELIMINAR_GARANTIA';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS='MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS';var ADICIONAR_CRITERIO_FILTRADO_GARANTIAS='ADICIONAR_CRITERIO_FILTRADO_GARANTIAS';var ELIMINAR_CRITERIO_FILTRADO_GARANTIAS='ELIMINAR_CRITERIO_FILTRADO_GARANTIAS';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS='CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS';var MODIFICAR_CRITERIO_FILTRADO_GARANTIAS='MODIFICAR_CRITERIO_FILTRADO_GARANTIAS';var APLICAR_CRITERIOS_FILTRADO_GARANTIAS='APLICAR_CRITERIOS_FILTRADO_GARANTIAS';var CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS='CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS';//Creacion solicitudes de contrato anual
var REINICIAR_SOLICITUD_CONTRATOANUAL='REINICIAR_SOLICITUD_CONTRATOANUAL';var MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL='MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL';var DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL='DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL';//Solicitud de Contrato anual
var REINICIAR_SOLICITUD_CONTRATOANUAL1='REINICIAR_SOLICITUD_CONTRATOANUAL1';var OBTENER_SOLICITUD_CONTRATOANUAL='OBTENER_SOLICITUD_CONTRATOANUAL';var MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1='MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1';var ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL='ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL';var MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL='MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL';var ACTUALIZAR_SOLICITUD_CONTRATOANUAL='ACTUALIZAR_SOLICITUD_CONTRATOANUAL';var MOSTRAR_MODAL_ADICION_FIRMAS='MOSTRAR_MODAL_ADICION_FIRMAS';var DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO='DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO';//Adjuntos - common
var MOSTRAR_MODAL_AGREGAR_ARCHIVO='MOSTRAR_MODAL_AGREGAR_ARCHIVO';var OCULTAR_MODAL_AGREGAR_ARCHIVO='OCULTAR_MODAL_AGREGAR_ARCHIVO';var MODIFICAR_INPUTS_ARCHIVO='MODIFICAR_INPUTS_ARCHIVO';var MODIFICAR_INPUTS_COMMON_REDUCER='MODIFICAR_INPUTS_COMMON_REDUCER';var DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA='DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA';var CONMUTAR_SELECCION_TODOS_ITEMS_FILES='CONMUTAR_SELECCION_TODOS_ITEMS_FILES';var REMOVER_ARCHIVOS_SOLICITUD='REMOVER_ARCHIVOS_SOLICITUD';//Aprobaciones proveedores
var OBTENER_EXTERNOS_APROBACIONES='OBTENER_EXTERNOS_APROBACIONES';var CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES='CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES';var FILTRAR_EXTERNOS_APROBACIONES='FILTRAR_EXTERNOS_APROBACIONES';var ORDENAR_EXTERNOS_APROBACIONES='ORDENAR_EXTERNOS_APROBACIONES';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES='CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES';var MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES='MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES';var APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES='APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES='MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES';var ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES='ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES';var ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES='ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES';var MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES='MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES';var MODIFICAR_INPUTS_EXTERNOS_APROBACIONES='MODIFICAR_INPUTS_EXTERNOS_APROBACIONES';//Cotizaciones proveedores
var OBTENER_EXTERNOS_COTIZACIONES='OBTENER_EXTERNOS_COTIZACIONES';var CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES='CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES';var FILTRAR_EXTERNOS_COTIZACIONES='FILTRAR_EXTERNOS_COTIZACIONES';var ORDENAR_EXTERNOS_COTIZACIONES='ORDENAR_EXTERNOS_COTIZACIONES';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES='CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES';var MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES='MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES';var APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES='APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES='MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES';var ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES='ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES';var ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES='ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES';var MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES='MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES';var MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES='MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES';var ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES='ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES';var MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD='MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD';//Documentos
var MOSTRAR_MODAL_RESUMEN_DOCUMENTO='MOSTRAR_MODAL_RESUMEN_DOCUMENTO';var MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO='MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO';var MODIFICAR_INPUTS_DOCUMENTOS='MODIFICAR_INPUTS_DOCUMENTOS';var DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS='DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS';var MOSTRAR_MODAL_ADICIONA_FACTURA_DOCUMENTO='MOSTRAR_MODAL_ADICIONA_FACTURA_DOCUMENTO';var MOSTRAR_MODAL_ADICIONAR_ADICIONAL='MOSTRAR_MODAL_ADICIONAR_ADICIONAL';var ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO='ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO';var ELIMINAR_ARCHIVOS_DOCUMENTO='ELIMINAR_ARCHIVOS_DOCUMENTO';var MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO='MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO';//Adiciones
var ADICIONAR_NUEVO_CENCO_ADICIONAL='ADICIONAR_NUEVO_CENCO_ADICIONAL';var ELIMINAR_CENCOS_ADICIONAL='ELIMINAR_CENCOS_ADICIONAL';var DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION='DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION';//Facturas
var MOSTRAR_MODAL_ADICIONA_FACTURA='MOSTRAR_MODAL_ADICIONA_FACTURA';var MOSTRAR_MODAL_ULTIMA_FACTURA='MOSTRAR_MODAL_ULTIMA_FACTURA';//VerificacionSST
var MOSTRAR_MODAL_ADICION_VERIFICACION_SST='MOSTRAR_MODAL_ADICION_VERIFICACION_SST';//Tiquetes Aereos
var REINICIAR_SOLICITUD_TIQUETESAEREO='REINICIAR_SOLICITUD_TIQUETESAEREO';var MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO='MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO';var ADICIONAR_TRAYECTO='ADICIONAR_TRAYECTO';var ADICIONAR_TRAYECTO1='ADICIONAR_TRAYECTO1';var REMOVER_TRAYECTOS='REMOVER_TRAYECTOS';var REMOVER_TRAYECTOS1='REMOVER_TRAYECTOS1';var DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO='DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO';var ADICIONAR_PASAPORTE='ADICIONAR_PASAPORTE';var OBTENER_SOLICITUD_TIQUETESAEREO='OBTENER_SOLICITUD_TIQUETESAEREO';var MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO='MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO';var REMOVER_COTIZACION_TIQUETESAEREO='REMOVER_COTIZACION_TIQUETESAEREO';var MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1='MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO';var ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO='ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO';var ADICIONAR_COTIZACION_TIQUETESAEREO='ADICIONAR_COTIZACION_TIQUETESAEREO';var DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO='DESHABILITAR_BOTON_CREAR_DOCUMENTO_SOLICITUD_TIQUETESAEREO';var ACTUALIZAR_SOLICITUD_TIQUETESAEREO='ACTUALIZAR_SOLICITUD_TIQUETESAEREO';var ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO='ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO';var ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1='ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1';var SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO='SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO';var MOSTRAR_MODAL_ADICIONAR_TIQUETE='MOSTRAR_MODAL_ADICIONAR_TIQUETE';var MODIFICAR_TIQUETE='MODIFICAR_TIQUETE';var MOSTRAR_MODAL_ADICIONAR_ASISTENCIA='MOSTRAR_MODAL_ADICIONAR_ASISTENCIA';var MODIFICAR_ASISTENCIA='MODIFICAR_ASISTENCIA';var ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO='ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO';var ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1='ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1';var REMOVER_CENCOS_TIQUETESAEREOS='REMOVER_CENCOS_TIQUETESAEREOS';var REMOVER_CENCOS_TIQUETESAEREOS1='REMOVER_CENCOS_TIQUETESAEREOS1';var EDITAR_ARCHIVO_PASAPORTE='EDITAR_ARCHIVO_PASAPORTE';var MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO='MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO';var ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO='ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO';var EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO='EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO';var ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO='ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO';var ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1='ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1';var EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1='EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1';var DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1='DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1';var ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO='ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO';//Hoteles
var REINICIAR_SOLICITUD_HOTELES='REINICIAR_SOLICITUD_HOTELES';var MODIFICAR_INPUTS_SOLICITUD_HOTELES='MODIFICAR_INPUTS_SOLICITUD_HOTELES';var ADICIONAR_ALOJAMIENTO='ADICIONAR_ALOJAMIENTO';var REMOVER_ALOJAMIENTOS='REMOVER_ALOJAMIENTOS';var DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES='DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES';var OBTENER_SOLICITUD_HOTELES='OBTENER_SOLICITUD_HOTELES';var MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES='MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES';var REMOVER_COTIZACION_HOTELES='REMOVER_COTIZACION_HOTELES';var MODIFICAR_INPUTS_SOLICITUD_HOTELES1='MODIFICAR_INPUTS_SOLICITUD_HOTELES1';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES';var ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1='ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1';var ADICIONAR_MODIFICACION_SOLICITUD_HOTELES='ADICIONAR_MODIFICACION_SOLICITUD_HOTELES';var ADICIONAR_COTIZACION_HOTELES='ADICIONAR_COTIZACION_HOTELES';var DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES='DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES';var ACTUALIZAR_SOLICITUD_HOTELES='ACTUALIZAR_SOLICITUD_HOTELES';var ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES='ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES';var SELECCIONAR_APROBACION_SOLICITUD_HOTELES='SELECCIONAR_APROBACION_SOLICITUD_HOTELES';var MOSTRAR_MODAL_ADICIONAR_RESERVACION='MOSTRAR_MODAL_ADICIONAR_RESERVACION';var MODIFICAR_RESERVACION='MODIFICAR_RESERVACION';var ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES='ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES';var REMOVER_CENCOS_HOTELES='REMOVER_CENCOS_HOTELES';var ENVIAR_COMENTARIO_SOLICITUD_HOTELES='ENVIAR_COMENTARIO_SOLICITUD_HOTELES';var EDITAR_COMENTARIO_SOLICITUD_HOTELES='EDITAR_COMENTARIO_SOLICITUD_HOTELES';var ELIMINAR_COMENTARIO_SOLICITUD_HOTELES='ELIMINAR_COMENTARIO_SOLICITUD_HOTELES';var ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1='ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1';var EDITAR_COMENTARIO_SOLICITUD_HOTELES1='EDITAR_COMENTARIO_SOLICITUD_HOTELES1';var DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1='DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1';var ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES='ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES';//OTROSI
var OBTENER_SOLICITUD_OTROSI='OBTENER_SOLICITUD_OTROSI';var MOSTRAR_MODAL_CREATE_OTROSI='MOSTRAR_MODAL_CREATE_OTROSI';var RESETEAR_REDUCER_SOLICITUD_OTROSI='RESETEAR_REDUCER_SOLICITUD_OTROSI';//Grupos
var OBTENER_GRUPOS='OBTENER_GRUPOS';var CONMUTAR_SELECCION_GRUPO='CONMUTAR_SELECCION_GRUPO';var CONMUTAR_SELECCION_TODOS_GRUPOS='CONMUTAR_SELECCION_TODOS_GRUPOS';var FILTRAR_GRUPOS='FILTRAR_GRUPOS';var ORDENAR_GRUPOS='ORDENAR_GRUPOS';var MOSTRAR_MODAL_CREAR_GRUPO='MOSTRAR_MODAL_CREAR_GRUPO';var MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS='MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS';var DESHABILITAR_BOTON_MODAL_GRUPOS='DESHABILITAR_BOTON_MODAL_GRUPOS';var CREAR_ACTUALIZAR_GRUPO='CREAR_ACTUALIZAR_GRUPO';var MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO='MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO';var ELIMINAR_GRUPO='ELIMINAR_GRUPO';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS='MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS';var ADICIONAR_CRITERIO_FILTRADO_GRUPOS='ADICIONAR_CRITERIO_FILTRADO_GRUPOS';var ELIMINAR_CRITERIO_FILTRADO_GRUPOS='ELIMINAR_CRITERIO_FILTRADO_GRUPOS';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS='CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS';var MODIFICAR_CRITERIO_FILTRADO_GRUPOS='MODIFICAR_CRITERIO_FILTRADO_GRUPOS';var APLICAR_CRITERIOS_FILTRADO_GRUPOS='APLICAR_CRITERIOS_FILTRADO_GRUPOS';var CAMBIAR_MOSTRAR_REGISTROS_GRUPOS='CAMBIAR_MOSTRAR_REGISTROS_GRUPOS';var MODIFICAR_INPUTS_GRUPOS='MODIFICAR_INPUTS_GRUPOS';var SELECCIONAR_ITEM_GRUPOS='SELECCIONAR_ITEM_GRUPOS';//Busqueda documento
var BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS='BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS';var BUSQUEDADOCUMENTO_REINICIAR_ESTADO='BUSQUEDADOCUMENTO_REINICIAR_ESTADO';var BUSQUEDADOCUMENTO_MODIFICAR_INPUTS='BUSQUEDADOCUMENTO_MODIFICAR_INPUTS';//Reportes
var ADICIONAR_CRITERIO_FILTRADO_REPORTES='ADICIONAR_CRITERIO_FILTRADO_REPORTES';var APLICAR_CRITERIOS_FILTRADO_REPORTES='APLICAR_CRITERIOS_FILTRADO_REPORTES';var CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES='CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES';var ELIMINAR_CRITERIO_FILTRADO_REPORTES='ELIMINAR_CRITERIO_FILTRADO_REPORTES';var MODIFICAR_CRITERIO_FILTRADO_REPORTES='MODIFICAR_CRITERIO_FILTRADO_REPORTES';var MODIFICAR_INPUTS_REPORTES='MODIFICAR_INPUTS_REPORTES';var MODIFICAR_NUMERO_REGISTROS_MOSTRAR='MODIFICAR_NUMERO_REGISTROS_MOSTRAR';var MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES='MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES';var OBTENER_EVALUACION_PROVEEDOR='OBTENER_EVALUACION_PROVEEDOR';var OBTENER_MONTO_CONTRATADO_PROVEEDOR='OBTENER_MONTO_CONTRATADO_PROVEEDOR';var OBTENER_MONTO_CONTRATADO_CENCO='OBTENER_MONTO_CONTRATADO_CENCO';var OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS='OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS';var OBTENER_RADICADOS='OBTENER_RADICADOS';var OBTENER_GESTION_RESPONSABLE_COMPRAS='OBTENER_GESTION_RESPONSABLE_COMPRAS';var ORDENAR_REPORTES='ORDENAR_REPORTES';//Cambio contrasena
var MODIFICAR_INPUTS_CAMBIO_CONTRASENA='MODIFICAR_INPUTS_CAMBIO_CONTRASENA';//Configuracion de maestras
var OBTENER_MAESTRAS='OBTENER_MAESTRAS';var MOSTRAR_MODAL_ADICIONAR_MAESTRA='MOSTRAR_MODAL_ADICIONAR_MAESTRA';var CONMUTAR_SELECCION_MAESTRAS='CONMUTAR_SELECCION_MAESTRAS';var CONMUTAR_SELECCION_TODAS_MAESTRAS='CONMUTAR_SELECCION_TODAS_MAESTRAS';var MODIFICAR_INPUTS_MAESTRA='MODIFICAR_INPUTS_MAESTRA';var MOSTRAR_MODAL_PROGRESS='MOSTRAR_MODAL_PROGRESS';//Configuracion asignacion delegados
var MOSTRAR_MODAL_ADICIONAR_DELEGADOS='MOSTRAR_MODAL_ADICIONAR_DELEGADOS';var OBTENER_DELEGADOS='OBTENER_DELEGADOS';var CONMUTAR_SELECCION_DELEGADOS='CONMUTAR_SELECCION_DELEGADOS';var CONMUTAR_SELECCION_TODOS_DELEGADOS='CONMUTAR_SELECCION_TODOS_DELEGADOS';var MODIFICAR_INPUTS_DELEGADOS='MODIFICAR_INPUTS_DELEGADOS';var RESET_MODAL_ADD_DELEGADO='RESET_MODAL_ADD_DELEGADO';var ORDENAR_DELEGADOS='ORDENAR_DELEGADOS';var CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS='CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS';var ADMINDB_POBLAR_RESULTADOS='ADMINDB_POBLAR_RESULTADOS';var MODIFICAR_INPUTS_ADMINDB='MODIFICAR_INPUTS_ADMINDB';var ADMINDB_RESETEAR_TABLA='ADMINDB_RESETEAR_TABLA';var SELECCIONAR_TIPO_SOLICITUD='SELECCIONAR_TIPO_SOLICITUD';var SEARCHING_AIRPORTS='SEARCHING_AIRPORTS';

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_draggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_draggable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_Component){_inherits(Modal,_Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!this.props.draggable&&prevProps.draggable){var id='modal-dialog-id-'+this.props.id;document.getElementById(id).style.transform="translate(0px, 0px)";}}},{key:'render',value:function render(){var _props=this.props,id=_props.id,show=_props.show,children=_props.children,style=_props.style,width=_props.width;if(!show){return null;}var st=style;if(!style){st={};if(width){st.width=this.props.width+'px';}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:id,className:'modal animated fadeIn',tabIndex:'-1',role:'dialog',style:{display:'flex',alignItems:'center',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_draggable___default.a,{handle:'.modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'modal-dialog-id-'+id,className:'modal-dialog animated zoomIn',role:'document',style:st},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},children))));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_fontawesome__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var title=props.title,onClose=props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header',style:{cursor:'move'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'modal-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_fontawesome___default.a,{name:'window-maximize',style:{color:'#555'}}),title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'close','aria-label':'Close',onClick:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},'\xD7')));});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-body"},children);});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-footer"},children);});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(332)();
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A React component for the font-awesome icon library.
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false] Inverse the icon's color
 * @param {String} [name] Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another. Arguments specify z-index such as '1x' See documentation for example http://fontawesome.io/examples/#stacked
 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
 * @module FontAwesome
 * @type {ReactClass}
 */
var FontAwesome = function (_React$Component) {
  _inherits(FontAwesome, _React$Component);

  function FontAwesome() {
    _classCallCheck(this, FontAwesome);

    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));

    _this.displayName = 'FontAwesome';
    return _this;
  }

  _createClass(FontAwesome, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          cssModule = _props.cssModule,
          className = _props.className,
          fixedWidth = _props.fixedWidth,
          flip = _props.flip,
          inverse = _props.inverse,
          name = _props.name,
          pulse = _props.pulse,
          rotate = _props.rotate,
          size = _props.size,
          spin = _props.spin,
          stack = _props.stack,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'span' : _props$tag,
          ariaLabel = _props.ariaLabel,
          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);

      var ariaProps = ariaLabel ? { 'aria-label': ariaLabel } : { 'aria-hidden': true };
      var classNames = [];

      if (cssModule) {
        classNames.push(cssModule['fa']);
        classNames.push(cssModule['fa-' + name]);
        size && classNames.push(cssModule['fa-' + size]);
        spin && classNames.push(cssModule['fa-spin']);
        pulse && classNames.push(cssModule['fa-pulse']);
        border && classNames.push(cssModule['fa-border']);
        fixedWidth && classNames.push(cssModule['fa-fw']);
        inverse && classNames.push(cssModule['fa-inverse']);
        flip && classNames.push(cssModule['fa-flip-' + flip]);
        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
        stack && classNames.push(cssModule['fa-stack-' + stack]);
      } else {
        classNames.push('fa');
        classNames.push('fa-' + name);
        size && classNames.push('fa-' + size);
        spin && classNames.push('fa-spin');
        pulse && classNames.push('fa-pulse');
        border && classNames.push('fa-border');
        fixedWidth && classNames.push('fa-fw');
        inverse && classNames.push('fa-inverse');
        flip && classNames.push('fa-flip-' + flip);
        rotate && classNames.push('fa-rotate-' + rotate);
        stack && classNames.push('fa-stack-' + stack);
      }

      // Add any custom class names at the end.
      className && classNames.push(className);
      return _react2.default.createElement(tag, _extends({}, props, ariaProps, {
        className: classNames.join(' ')
      }));
    }
  }]);

  return FontAwesome;
}(_react2.default.Component);

FontAwesome.propTypes = {
  ariaLabel: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  cssModule: _propTypes2.default.object,
  fixedWidth: _propTypes2.default.bool,
  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  inverse: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.oneOf([90, 180, 270]),
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  spin: _propTypes2.default.bool,
  stack: _propTypes2.default.oneOf(['1x', '2x']),
  tag: _propTypes2.default.string
};

exports.default = FontAwesome;
module.exports = exports.default;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Box=function(_Component){_inherits(Box,_Component);function Box(){_classCallCheck(this,Box);return _possibleConstructorReturn(this,(Box.__proto__||Object.getPrototypeOf(Box)).apply(this,arguments));}_createClass(Box,[{key:'render',value:function render(){var _props=this.props,onModal=_props.onModal,stretch=_props.stretch,colors=_props.colors;var styles={box:{position:'relative'},title:{},body:{display:'flex',flexDirection:'column',justifyContent:'space-between'},header:{position:'relative'},bfContent:{flex:1,display:'flex',flexDirection:'column',justifyContent:'space-between',minHeight:0}};if(stretch){styles.box={marginBottom:'0',height:'100%'};styles.bfContent.height='0';}if(onModal){styles.box={marginBottom:'10px'};styles.title={fontSize:'0.95em',fontWeight:'bold',paddingTop:'3px',paddingBottom:'2px'};styles.body={padding:'3px 10px',background:'#efefef'};styles.header=Object.assign({borderBottom:'1px solid #aaa'});styles.bfContent=Object.assign({marginTop:'0'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content box box-default animated fadeIn',style:styles.box},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-body',style:styles.body},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-header with-border',style:styles.header},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'box-title',style:styles.title},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-actions'},this.props.actions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.bfContent},this.props.children)));}}]);return Box;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Box);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoxSection=function(_Component){_inherits(BoxSection,_Component);function BoxSection(){_classCallCheck(this,BoxSection);return _possibleConstructorReturn(this,(BoxSection.__proto__||Object.getPrototypeOf(BoxSection)).apply(this,arguments));}_createClass(BoxSection,[{key:"render",value:function render(){var _props=this.props,title=_props.title,actions=_props.actions,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-area",style:{marginTop:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-area-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"section-area-title"},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,actions)),children);}}]);return BoxSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BoxSection);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-button-strip"},children);});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
// Usa PUBLIC_URL para el basename (configurado en .env.development o .env.production)
var basename="/ecompras"||'/';/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()({basename:basename}));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShowRecords__ = __webpack_require__(436);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ButtonStrip=function(_Component){_inherits(ButtonStrip,_Component);function ButtonStrip(){_classCallCheck(this,ButtonStrip);return _possibleConstructorReturn(this,(ButtonStrip.__proto__||Object.getPrototypeOf(ButtonStrip)).apply(this,arguments));}_createClass(ButtonStrip,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonstrip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.actions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonstrip-records'},!!this.props.showRecords&&!!this.props.totalRecords&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ShowRecords__["a" /* default */],{showRecords:this.props.showRecords,totalRecords:this.props.totalRecords,changeRecordsToShow:this.props.changeRecordsToShow}),this.props.showRecords<this.props.totalRecords&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.pagination))),this.props.formRequest&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),this.props.formRequest));}}]);return ButtonStrip;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ButtonStrip);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.toast = exports.ToastContainer = undefined;

var _ToastContainer = __webpack_require__(362);

var _ToastContainer2 = _interopRequireDefault(_ToastContainer);

var _toaster = __webpack_require__(400);

var _toaster2 = _interopRequireDefault(_toaster);

var _style = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ToastContainer = _ToastContainer2.default;
exports.toast = _toaster2.default;
exports.style = _style.defineStyle;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WAIT_INTERVAL=1500;var ENTER_KEY=13;var ModalSelectorFromList=function(_Component){_inherits(ModalSelectorFromList,_Component);function ModalSelectorFromList(props){_classCallCheck(this,ModalSelectorFromList);var _this=_possibleConstructorReturn(this,(ModalSelectorFromList.__proto__||Object.getPrototypeOf(ModalSelectorFromList)).call(this,props));_this.handleCloseModal=function(e){var modal=document.getElementById('modalSelectorFromList');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSelectorFromList .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){_this.props.hideModalSelectorFromList(false);_this.setState({value:''});},300);};_this.handleSelectFromSelector=function(e,obj){_this.props.modalSelector.get('action')(obj);_this.setState({value:''});_this.props.hideModalSelectorFromList();};_this.handleOnScroll=function(e){var page=_this.props.modalSelector.get('data').count()/100;if(page>=1){var table=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.table);var tableHeight=table.clientHeight-297;var scrollTop=e.target.scrollTop;if(scrollTop>=tableHeight*0.8){var loadPage=Math.floor(page)+1;_this.props.getDataFromUrl(loadPage);}}};_this.handleOnChange=function(value){clearTimeout(_this.timer);_this.setState({value:value});_this.timer=setTimeout(_this.triggerChange,WAIT_INTERVAL);};_this.handleOnKeyDown=function(key){if(key===ENTER_KEY){clearTimeout(_this.timer);_this.triggerChange();}};_this.triggerChange=function(){_this.props.clearPagesModalSelector();_this.props.updateModalSelectorFilterTerm(_this.state.value);_this.props.getDataFromUrl(1);};_this.state={value:props.modalSelector.get('filter')};return _this;}_createClass(ModalSelectorFromList,[{key:'render',value:function render(){var _this2=this;var modalSelector=this.props.modalSelector;if(modalSelector.get('show')===false){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* default */],{id:'modalSelectorFromList',show:true,ZIndex:2001},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModalHeader__["a" /* default */],{title:modalSelector.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSelectorFromList");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:this.state.value,onChange:function onChange(e){return _this2.handleOnChange(e.target.value);},onKeyDown:function onKeyDown(e){return _this2.handleOnKeyDown(e.keyCode);},placeholder:'Busqueda...'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',height:'300px',overflowX:'hidden',marginBottom:'20px',border:'1px solid #ddd'},onScroll:function onScroll(e){return _this2.handleOnScroll(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{ref:function ref(_ref){return _this2.table=_ref;},className:'table table-bordered table-condensed table-striped table-hover nowrap',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,modalSelector.get('fields').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:''+x.get('width'),key:'th4['+n+']'},x.get('caption'));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalSelector.get('data').count()>0?(modalSelector.get('data')||Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["List"])([])).filter(function(x){if(modalSelector.get('filter')){var compare=false;modalSelector.get('fields').forEach(function(y){compare=compare||x.get(''+y.get('value')).toLowerCase().indexOf(modalSelector.get('filter').toLowerCase())>-1;});return compare;}else{return true;}}).map(function(x,n){var tds=modalSelector.get('fields').map(function(y,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td4['+n+']['+n1+']',onMouseEnter:function onMouseEnter(e){return Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["b" /* addTitleIfOverflow */])(e.target);}},x.get(y.get('value')));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+n+']',style:{cursor:'pointer'},onClick:function onClick(e){_this2.handleSelectFromSelector(e,x.toJS());}},tds);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:modalSelector.get('fields').count(),style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',justifyContent:'space-between',height:'270px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{name:'refresh',spin:true,size:'3x'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))))))))))));}}]);return ModalSelectorFromList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSelector:state.common.get('modalSelector')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{hideModalSelectorFromList:function hideModalSelectorFromList(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["o" /* hideModalSelectorFromList */])());},updateModalSelectorFilterTerm:function updateModalSelectorFilterTerm(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["D" /* updateModalSelectorFilterTerm */])(term));},getDataFromUrl:function getDataFromUrl(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["j" /* getDataFromUrl */])(page));},clearPagesModalSelector:function clearPagesModalSelector(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["d" /* clearPagesModalSelector */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSelectorFromList));

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectorInput=function(_Component){_inherits(SelectorInput,_Component);function SelectorInput(){_classCallCheck(this,SelectorInput);return _possibleConstructorReturn(this,(SelectorInput.__proto__||Object.getPrototypeOf(SelectorInput)).apply(this,arguments));}_createClass(SelectorInput,[{key:"render",value:function render(){var _props=this.props,value=_props.value,_onClick=_props.onClick,onReset=_props.onReset,_props$disabled=_props.disabled,disabled=_props$disabled===undefined?false:_props$disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-control input-sm SelectorInput",zindex:2000,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"caption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,value)),value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"reset",onClick:function onClick(e){return onReset(e);}},"\u2715"):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(e){e.preventDefault();_onClick(e);},disabled:disabled},"...")));}}]);return SelectorInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectorInput);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellPosition */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_CellRenderer */
/* unused harmony export bpfrpt_proptype_CellCache */
/* unused harmony export bpfrpt_proptype_StyleCache */
/* unused harmony export bpfrpt_proptype_CellRangeRendererParams */
/* unused harmony export bpfrpt_proptype_CellRangeRenderer */
/* unused harmony export bpfrpt_proptype_CellSizeGetter */
/* unused harmony export bpfrpt_proptype_CellSize */
/* unused harmony export bpfrpt_proptype_NoContentRenderer */
/* unused harmony export bpfrpt_proptype_Scroll */
/* unused harmony export bpfrpt_proptype_ScrollbarPresenceChange */
/* unused harmony export bpfrpt_proptype_RenderedSection */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetterParams */
/* unused harmony export bpfrpt_proptype_OverscanIndices */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony export bpfrpt_proptype_Alignment */
/* unused harmony export bpfrpt_proptype_VisibleCellRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_CellPosition =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellCache =  true ? null : PropTypes.objectOf(PropTypes.node.isRequired);
var bpfrpt_proptype_StyleCache =  true ? null : PropTypes.objectOf(PropTypes.object.isRequired);
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: PropTypes.objectOf(PropTypes.node.isRequired).isRequired,
  cellRenderer: PropTypes.func.isRequired,
  columnSizeAndPositionManager: function columnSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  deferredMeasurementCache: PropTypes.object,
  horizontalOffsetAdjustment: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isScrollingOptOut: PropTypes.bool.isRequired,
  parent: PropTypes.object.isRequired,
  rowSizeAndPositionManager: function rowSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  styleCache: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
  verticalOffsetAdjustment: PropTypes.number.isRequired,
  visibleColumnIndices: PropTypes.object.isRequired,
  visibleRowIndices: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRangeRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSizeGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSize =  true ? null : PropTypes.oneOfType([PropTypes.func, PropTypes.number]);
var bpfrpt_proptype_NoContentRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  clientWidth: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  scrollWidth: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: PropTypes.bool.isRequired,
  vertical: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired
};
var bpfrpt_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: PropTypes.number.isRequired,
  columnOverscanStopIndex: PropTypes.number.isRequired,
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  rowOverscanStartIndex: PropTypes.number.isRequired,
  rowOverscanStopIndex: PropTypes.number.isRequired,
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: PropTypes.oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: PropTypes.number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: PropTypes.number.isRequired,


  // Begin of range of visible cells
  startIndex: PropTypes.number.isRequired,


  // End of range of visible cells
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_Alignment =  true ? null : PropTypes.oneOf(['auto', 'end', 'start', 'center']);
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  start: PropTypes.number,
  stop: PropTypes.number
};




















/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_URL; });
/* unused harmony export CLIENT_ROOT_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_IATACODES; });
/* unused harmony export FOLDER */
var API_URL=window.API_URL;var CLIENT_ROOT_URL=window.CLIENT_ROOT_URL;var API_IATACODES=window.API_IATACODES;var FOLDER=window.FOLDER;// Colocar en package.json cuando se despliega:  "homepage": "ecompras", despues de la version.

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = showHideModalSummary;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDocumento;
/* harmony export (immutable) */ __webpack_exports__["j"] = showHideModalCreateEntrega;
/* unused harmony export showHideModalCreateVerificacion */
/* harmony export (immutable) */ __webpack_exports__["n"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeFactura;
/* harmony export (immutable) */ __webpack_exports__["d"] = createOrUpdateDocumento;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateDocumento;
/* harmony export (immutable) */ __webpack_exports__["c"] = cancelDocumento;
/* harmony export (immutable) */ __webpack_exports__["b"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeFiles;
/* harmony export (immutable) */ __webpack_exports__["i"] = showHideModalAddAdicional;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCencoItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = removeCencosItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = storeAdicion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__otrosi__ = __webpack_require__(69);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function showHideModalSummary(show,id,url,type){return function(dispatch){if(show){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_279" /* MOSTRAR_MODAL_RESUMEN_DOCUMENTO */],payload:{show:show,url:url,type:type}});};var fn0=function fn0(d){return d(getDocumento(id,fn1));};fn0(dispatch);}else{var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_279" /* MOSTRAR_MODAL_RESUMEN_DOCUMENTO */],payload:{show:show}});};fn2(dispatch);}};}function getDocumento(id,next){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/documentos',{params:{id:id}}).then(function(res){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["c" /* ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO */],payload:res.data});};fn1(dispatch);if(Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["F" /* isFunction */])(next))next(dispatch);}).catch(function(err){console.log(err);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_279" /* MOSTRAR_MODAL_RESUMEN_DOCUMENTO */],payload:{show:false}});};fn2(dispatch);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function showHideModalCreateEntrega(show){var id=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){if(show){axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/parametros',{params:{nombre:'CRITERIOS_EVALUACION_PROVEEDORES'}}).then(function(res){var criterios=res.data.reduce(function(a,b){a[b.CRITERIO]=b;return a;},{});var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_262" /* MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO */],payload:{show:show,criterios:criterios,id:id}});};fn0(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});}else{var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_262" /* MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO */],payload:{show:show}});};fn0(dispatch);}};}function showHideModalCreateVerificacion(show,index){return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_267" /* MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO */],payload:{show:show,index:index}});};fn0(dispatch);};}function updateInputs(path,value){var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var immutable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var tipo_solicitud=arguments[4];return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_197" /* MODIFICAR_INPUTS_DOCUMENTOS */],payload:{path:path,value:value,immutable:immutable}});};fn0(dispatch);if((path==='modalAddAdicional.data.iva'||path==='modalAddAdicional.data.valor')&&tipo_solicitud!==3){var iva=getState().documentos.getIn('modalAddAdicional.data.iva'.split('.'));var valor=getState().documentos.getIn('modalAddAdicional.data.valor'.split('.'));//const valor_con_iva = Math.round(valor * (1 + (iva / 100)))              
var valor_con_iva=valor*(1+iva/100);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_197" /* MODIFICAR_INPUTS_DOCUMENTOS */],payload:{path:'modalAddAdicional.data.valor_con_iva',value:valor_con_iva}});};fn1(dispatch);}};}function removeFactura(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var data=getState().documentos.get('modalSummary');var documento=data.get('data');var document_id=data.getIn(['data','id']);var solicitud_id=data.getIn(['data','solicitud_id']);var facturas=data.getIn(['data','facturas']);var url=data.get('url');var type=data.get('type');var modificaciones=[];facturas.map(function(f){if(f.get('selected')){var ev=f.getIn(['entrega','evaluaciones']);ev&&f.getIn(['entrega','evaluaciones']).map(function(ev){modificaciones.push({entity:'Evaluacione',id:ev.get('id'),action:'delete'});});if(f.get('adjunto')){modificaciones.push({entity:'Adjunto',id:f.getIn(['adjunto','id']),action:'delete'});}modificaciones.push({entity:'Factura',id:f.get('id'),action:'delete',value:{documento_id:document_id}});modificaciones.push({entity:'Entrega',id:f.get('entrega_id'),action:'delete'});modificaciones.push({entity:'CodigoRadicacion',id:f.getIn(['radicado','id']),action:'delete'});}});//Revertimos los estados
modificaciones.push({id:solicitud_id,entity:'Solicitude',value:{estado:6},action:'edit'});modificaciones.push({id:document_id,entity:'Documento',value:{estado:10},action:'edit'});var amortizaciones=facturas.filter(function(f){return f.get('selected');}).reduce(function(acc,current){return acc+current.get('amortizacion');},0);modificaciones=revertirAmortizaciones(amortizaciones,documento,modificaciones);axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/'+url,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn2(dispatch);dispatch(getDocumento(document_id));Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Las factura(s) han sido eliminada(s) exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function createOrUpdateDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_103" /* DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS */],payload:true});};//No aparece en actions creators
var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_103" /* DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS */],payload:false});};fn0(dispatch);var data=getState().documentos.get('modalCreateEntrega');var url=data.get('url');var type=data.get('type');var objNew=data.get('data');var objOld=data.get('unchanged');var entregas_parciales=getState().documentos.getIn(['modalSummary','data','entregas_parciales']);var errors=validateEntrega(objNew,entregas_parciales);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{objOld=objOld.set('evaluaciones',Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["D" /* indexBy */])(objOld.get('evaluaciones'),'id'));objNew=objNew.set('evaluaciones',Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["D" /* indexBy */])(objNew.get('evaluaciones'),'id'));var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["u" /* getModificaciones */])(objNew,objOld,'Entrega',switchEntrega);axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/'+url,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn2(dispatch);dispatch(showHideModalCreateEntrega(false));dispatch(getDocumento(objNew.get('documento_id')));Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function updateDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var data=getState().documentos.getIn(['modalSummary','data']);var url=getState().documentos.getIn(['modalSummary','url']);var type=getState().documentos.getIn(['modalSummary','type']);var documento_id=data.get('id');var modificaciones=[];var detalles=data.get('todos_detalles');detalles.valueSeq().forEach(function(detalle){modificaciones.push({id:detalle.get('id'),entity:'DocumentoDetalle',value:{valor:Number(detalle.get('valor')),valor_con_iva:Number(detalle.get('valor_con_iva'))},action:'edit'});});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/'+url,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn2(dispatch);dispatch(showHideModalCreateEntrega(false));dispatch(getDocumento(documento_id));Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});dispatch(updateInputs('modalSummary.editar',false));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function cancelDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var data=getState().documentos.get('modalSummary');var url=data.get('url');var type=data.get('type');var documento=data.get('data');var errors=validateCancelacion(documento);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:documento.get('id'),entity:'Documento',attribute:'estado',value:0,action:'edit'});modificaciones.push({id:documento.get('id'),entity:'Documento',attribute:'fecha_cancelacion',value:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'),action:'edit'});modificaciones.push({id:documento.get('id'),entity:'Documento',attribute:'motivo_cancelacion',value:documento.get('motivo_cancelacion'),action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/'+url,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn2(dispatch);//dispatch(showHideModalSummary(false))
dispatch(getDocumento(documento.get('id')));Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});}};}function addFile(url,documentoId,actions){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var files=[data];files=files.map(function(f){f=f.set('documento_id',documentoId);return f;});dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common__["F" /* uploadFiles */])(url,files,actions));};}function removeFiles(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fns=[];getState().documentos.getIn(['modalSummary','data','adjuntos']).filter(function(a){return a.get('id')&&a.get('selected');}).forEach(function(a){fns.push(function(){return axios.delete(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/files/'+a.get('id'));});});Promise.all(fns.map(function(x){return x();})).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_122" /* ELIMINAR_ARCHIVOS_DOCUMENTO */]});Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function showHideModalAddAdicional(show,documento,url,type){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_230" /* MOSTRAR_MODAL_ADICIONAR_ADICIONAL */],payload:{show:show,documento:documento,url:url,type:type}});};fn0(dispatch);};}function addCencoItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["Y" /* ADICIONAR_NUEVO_CENCO_ADICIONAL */]});};}function removeCencosItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_130" /* ELIMINAR_CENCOS_ADICIONAL */]});};}function storeAdicion(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_97" /* DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_97" /* DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION */],payload:false});};fn0(dispatch);var modalAddAdicional=getState().documentos.get('modalAddAdicional');var adicion=modalAddAdicional.get('data');adicion=adicion.set('documento_id',getState().documentos.getIn(['modalSummary','data','id']));var type=modalAddAdicional.get('type');if(adicion.get('valor')&&Math.abs(Number(adicion.get('valor')))>Math.abs(Number(adicion.get('valor_con_iva')))){fn1(dispatch);return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning("El valor del Servicio debe ser menor al valor total.",{bodyClassName:'toastify-content toastify-warning'});}if(Number(adicion.get('valor_con_iva'))>0&&adicion.get('cencos').count()==0){fn1(dispatch);return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning("Debe agregar al menos un cenco para poder ser aprobado",{bodyClassName:'toastify-content toastify-warning'});}if(Number(adicion.get('valor_con_iva'))>0&&adicion.get('cencos').count()>0){var sindefinir=adicion.get('cencos').filter(function(c){return c.get('cenco')==null;}).count();if(sindefinir>0){fn1(dispatch);return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning("Todos los cencos deben estar definidos",{bodyClassName:'toastify-content toastify-warning'});}}axios.post(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/documentos/adicion',adicion).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;if(!res.data.otrosi){var fn2=function fn2(d){return d({type:type,payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn2(dispatch);dispatch(showHideModalAddAdicional(false));dispatch(getDocumento(adicion.get('documento_id')));Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});fn1(dispatch);}else{//dispatch(showHideModalCreateOtrosi(true, res.data.message, createOtrosi()))
if(adicion.get('cencos').count()==0){fn1(dispatch);return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning("Debe agregar al menos un cenco para poder ser aprobado",{bodyClassName:'toastify-content toastify-warning'});}if(adicion.get('cencos').count()>0){fn1(dispatch);var _sindefinir=adicion.get('cencos').filter(function(c){return c.get('cenco')==null;}).count();if(_sindefinir>0)return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning("Todos los cencos deben estar definidos",{bodyClassName:'toastify-content toastify-warning'});}dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common__["t" /* showHideModalCreateOtrosi */])(true,res.data.message,Object(__WEBPACK_IMPORTED_MODULE_6__otrosi__["a" /* createOtrosi */])()));}}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});};}///******* Shared ********///
var validateEntrega=function validateEntrega(data){var entregas_parciales=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var errors=[];if(!data.get('fecha'))errors.push('El campo fecha entrega es obligatorio');if(data.get('fecha')&&__WEBPACK_IMPORTED_MODULE_5_moment___default()().isBefore(data.get('fecha')))errors.push('La fecha de entrega no debe ser superior a la de hoy');data.get('evaluaciones').forEach(function(a,b){if(a.get('calificacion')===0||a.get('calificacion')===null)errors.push('El criterio '+a.get('criterio')+' no ha sido calificada');});if(entregas_parciales){if(!data.get('valor_a_facturar')||data.get('valor_a_facturar')==0)errors.push('El campo valor a facturar es obligatorio');if(data.get('valor_a_facturar')<0)errors.push('El campo valor a facturar debe ser superior a 0');}return errors;};var validateCancelacion=function validateCancelacion(data){var errors=[];if(!data.get('motivo_cancelacion'))errors.push('El campo motivo de cancelación es obligatorio');return errors;};var switchEntrega=function switchEntrega(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];if(modificacion.attribute==='evaluaciones'){modificacion.entity="Evaluacione";modificacion.id=path[1];modificacion.attribute=path[2];}};var revertirAmortizaciones=function revertirAmortizaciones(amortizaciones,documento,modificaciones){if(amortizaciones>0){var anticipos=[];if(documento.get('anticipo')>0){anticipos.push(documento);}documento.get('documentos').filter(function(d){return d.get('tipo')==4&&d.get('anticipo')>0;}).map(function(x){anticipos.push(x);});for(var i=0;i<anticipos.length;i++){var anticipo_legalizado=anticipos[i].get('anticipo_legalizado');if(amortizaciones<=anticipo_legalizado){modificaciones.push({id:anticipos[i].get('id'),entity:'Documento',value:{anticipo_legalizado:anticipo_legalizado-amortizaciones},action:'edit'});amortizaciones=0;}else{modificaciones.push({id:anticipos[i].get('id'),entity:'Documento',value:{anticipo_legalizado:0},action:'edit'});amortizaciones-=anticipo_legalizado;}if(amortizaciones<=0){break;}}}return modificaciones;};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(264);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var filesTypes=__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["a" /* acceptedFiles */].map(function(x){return x.type;}).join();var ModalAddFile=function(_Component){_inherits(ModalAddFile,_Component);function ModalAddFile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddFile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddFile.__proto__||Object.getPrototypeOf(ModalAddFile)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddFile');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddFile .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddFile(false);},300);},_this.handleOnDrop=function(files){if(files.length>1){__WEBPACK_IMPORTED_MODULE_3_react_toastify__["toast"].warn('Solo es permitido procesar un archivo a la vez',{bodyClassName:'toastify-content toastify-warning'});return;}_this.props.selectFile(files[0]);},_this.handleOnRejected=function(files){files.forEach(function(x){__WEBPACK_IMPORTED_MODULE_3_react_toastify__["toast"].warn('El archivo '+x.name+' no es del tipo esperado. '+x.type,{bodyClassName:'toastify-content toastify-warning'});});},_this.setIcon=function(icon){if(icon){var imageSrc=__webpack_require__(80)("./"+icon);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageSrc});}return null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddFile,[{key:'render',value:function render(){var _this2=this;var modalAddFile=this.props.modalAddFile;if(!modalAddFile.get('show')){return null;}var clasificacionArchivos=this.props.clasificacionArchivos?this.props.clasificacionArchivos.toJS():[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */],{id:'modalAddFile',show:true,zindex:2000,width:600},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ModalHeader__["a" /* default */],{title:modalAddFile.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddFile.get('btnDisabled'),title:'Aceptar',onClick:function onClick(){_this2.props.action();_this2.handleCloseModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{accept:filesTypes,onDropAccepted:this.handleOnDrop,onDropRejected:this.handleOnRejected,className:'dropzone1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Arrastre los archivos a esta secci\xF3n')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'div-input-sm'},modalAddFile.getIn(['data','file'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'1px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.setIcon(modalAddFile.getIn(['data','icono']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'4px',verticalAlign:'bottom'}},modalAddFile.getIn(['data','file']).name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px',verticalAlign:'bottom',color:'#ccc'}},'(',__WEBPACK_IMPORTED_MODULE_4_numeral___default()(modalAddFile.getIn(['data','file']).size).format('0.0 b'),')')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalAddFile.getIn(['data','clasificacion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddFile.data.clasificacion',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:true},'Seleccione un tipo'),clasificacionArchivos.sort(function(a,b){if(a.CLASIFICACION<b.CLASIFICACION)return-1;if(a.CLASIFICACION>b.CLASIFICACION)return 1;return 0;}).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+n+']',value:x.CLASIFICACION},x.CLASIFICACION);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control input-sm',value:modalAddFile.getIn(['data','observaciones']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddFile.data.observaciones',e.target.value);},rows:3})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ModalFooter__["a" /* default */],null));}}]);return ModalAddFile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalAddFile:state.common.get('modalAddFile'),clasificacionArchivos:state.common.getIn(['parametros','CLASIFICACION_ARCHIVOS'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getParameterByName:function getParameterByName(name){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["l" /* getParameterByName */])(name));},selectFile:function selectFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["p" /* selectFile */])(file));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["C" /* updateInputs */])(path,value));},addFile:function addFile(type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["a" /* addFile */])(type));},displayModalAddFile:function displayModalAddFile(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["g" /* displayModalAddFile */])(show));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddFile));

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalConfirmarAccion=function(_Component){_inherits(ModalConfirmarAccion,_Component);function ModalConfirmarAccion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalConfirmarAccion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalConfirmarAccion.__proto__||Object.getPrototypeOf(ModalConfirmarAccion)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalConfirmarAccion');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalConfirmarAccion .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showModalConfirmarAccion(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalConfirmarAccion,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalConfirmarAccion=_props.modalConfirmarAccion,children=_props.children;if(!modalConfirmarAccion.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* default */],{id:'modalConfirmarAccion',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalConfirmarAccion.get('message')||'Esta seguro que desea eliminar este registro?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalConfirmarAccion.get('action')},'Ok')));}}]);return ModalConfirmarAccion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalConfirmarAccion:state.common.get('modalConfirmarAccion')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showModalConfirmarAccion:function showModalConfirmarAccion(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["x" /* showModalConfirmarAccion */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalConfirmarAccion));

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalDelete__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttachedFilesBox=function(_Component){_inherits(AttachedFilesBox,_Component);function AttachedFilesBox(props){_classCallCheck(this,AttachedFilesBox);var _this=_possibleConstructorReturn(this,(AttachedFilesBox.__proto__||Object.getPrototypeOf(AttachedFilesBox)).call(this,props));_this.setIcon=function(icon){if(icon){var imageSrc=__webpack_require__(80)("./"+icon);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:imageSrc});}return null;};_this.toggleSelectAllFiles=function(checked){var files=_this.props.files;var root=_this.props.root?_this.props.root+'.':'';_this.setState({toggleAll:checked});files.forEach(function(x,n){if(x.get('editable')){_this.props.updateInputs(root+'adjuntos.'+n+'.selected',checked);}});};_this.state={toggleAll:false};return _this;}_createClass(AttachedFilesBox,[{key:'render',value:function render(){var _this2=this;var _props=this.props,files=_props.files,obj=_props.obj,check=_props.check,disabledAttach=_props.disabledAttach;var root=this.props.root?this.props.root+'.':'';var noAttach=disabledAttach?disabledAttach:false;var k=0;var accionesArchivosAdjuntos=[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{key:'ba[2][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');},title:'Adicionar archivo',disabled:noAttach}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{key:'ba[2][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los archivos seleccionados?',function(){_this2.props.removeFiles();_this2.props.showHideModalDelete(false);});},title:'Eliminar archivos',disabled:files?files.filter(function(x){return x.get('selected');}).count()===0:true,danger:true})];if(!Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["E" /* isAllowedToViewComponent */])(check,obj,''))accionesArchivosAdjuntos=[];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Archivos adjuntos',actions:accionesArchivosAdjuntos},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.toggleSelectAllFiles(e.target.checked);},checked:this.state.toggleAll})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'25%'}},'Archivo'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'15%'}},'Tipo'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'50%'}},'Observaciones'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'5%'}},'Descargar'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,files&&files.count()>0?files.map(function(x,n){//k++
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],{key:'fr[23]['+n+']['+x.get('guid')+']'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:'tr[23]['+n+']['+x.get('guid')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs(root+'adjuntos.'+n+'.selected',e.target.checked);},disabled:!x.get('editable')})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:x.get('editable')===1?'LinkToEdit':'',style:{textAlign:'right'},onClick:x.get('editable')===1?function(e){return _this2.props.displayModalAddFile(true,'Modificación de archivos','edit',x);}:null},n+1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,_this2.setIcon(x.get('icono')),' ',x.get('nombre')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,x.get('clasificacion')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,x.get('observaciones')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,x.get('id')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'download',onClick:function onClick(e){return _this2.props.downloadFile(x.get('id'),x.get('nombre'));}}))));}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{colSpan:6,style:{textAlign:'center'}},'Para adicionar nuevos archivos haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'plus-circle'})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalDelete__["a" /* default */],null));}}]);return AttachedFilesBox;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return{};}function mapDispatchToProps(dispatch){return{downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["h" /* downloadFile */])(id,filename));},displayModalAddFile:function displayModalAddFile(show,title,mode,file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["g" /* displayModalAddFile */])(show,title,mode,file));},showHideModalDelete:function showHideModalDelete(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["u" /* showHideModalDelete */])(show,message,action));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AttachedFilesBox));

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(226);
var createStoreWithMiddleware=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */]);/* harmony default export */ __webpack_exports__["a"] = (createStoreWithMiddleware(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(714), __esModule: true };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(265);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(737);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(741);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(265);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _paginator = _interopRequireDefault(__webpack_require__(450));

var _Page = _interopRequireDefault(__webpack_require__(451));

var _classnames = _interopRequireDefault(__webpack_require__(228));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: "isFirstPageVisible",
    value: function isFirstPageVisible(has_previous_page) {
      var _this$props = this.props,
          hideDisabled = _this$props.hideDisabled,
          hideNavigation = _this$props.hideNavigation,
          hideFirstLastPages = _this$props.hideFirstLastPages;
      if (hideFirstLastPages || hideDisabled && !has_previous_page) return false;
      return true;
    }
  }, {
    key: "isPrevPageVisible",
    value: function isPrevPageVisible(has_previous_page) {
      var _this$props2 = this.props,
          hideDisabled = _this$props2.hideDisabled,
          hideNavigation = _this$props2.hideNavigation;
      if (hideNavigation || hideDisabled && !has_previous_page) return false;
      return true;
    }
  }, {
    key: "isNextPageVisible",
    value: function isNextPageVisible(has_next_page) {
      var _this$props3 = this.props,
          hideDisabled = _this$props3.hideDisabled,
          hideNavigation = _this$props3.hideNavigation;
      if (hideNavigation || hideDisabled && !has_next_page) return false;
      return true;
    }
  }, {
    key: "isLastPageVisible",
    value: function isLastPageVisible(has_next_page) {
      var _this$props4 = this.props,
          hideDisabled = _this$props4.hideDisabled,
          hideNavigation = _this$props4.hideNavigation,
          hideFirstLastPages = _this$props4.hideFirstLastPages;
      if (hideFirstLastPages || hideDisabled && !has_next_page) return false;
      return true;
    }
  }, {
    key: "buildPages",
    value: function buildPages() {
      var pages = [];
      var _this$props5 = this.props,
          itemsCountPerPage = _this$props5.itemsCountPerPage,
          pageRangeDisplayed = _this$props5.pageRangeDisplayed,
          activePage = _this$props5.activePage,
          prevPageText = _this$props5.prevPageText,
          nextPageText = _this$props5.nextPageText,
          firstPageText = _this$props5.firstPageText,
          lastPageText = _this$props5.lastPageText,
          totalItemsCount = _this$props5.totalItemsCount,
          onChange = _this$props5.onChange,
          activeClass = _this$props5.activeClass,
          itemClass = _this$props5.itemClass,
          itemClassFirst = _this$props5.itemClassFirst,
          itemClassPrev = _this$props5.itemClassPrev,
          itemClassNext = _this$props5.itemClassNext,
          itemClassLast = _this$props5.itemClassLast,
          activeLinkClass = _this$props5.activeLinkClass,
          disabledClass = _this$props5.disabledClass,
          hideDisabled = _this$props5.hideDisabled,
          hideNavigation = _this$props5.hideNavigation,
          linkClass = _this$props5.linkClass,
          linkClassFirst = _this$props5.linkClassFirst,
          linkClassPrev = _this$props5.linkClassPrev,
          linkClassNext = _this$props5.linkClassNext,
          linkClassLast = _this$props5.linkClassLast,
          hideFirstLastPages = _this$props5.hideFirstLastPages,
          getPageUrl = _this$props5.getPageUrl;
      var paginationInfo = new _paginator["default"](itemsCountPerPage, pageRangeDisplayed).build(totalItemsCount, activePage);

      for (var i = paginationInfo.first_page; i <= paginationInfo.last_page; i++) {
        pages.push(_react["default"].createElement(_Page["default"], {
          isActive: i === activePage,
          key: i,
          href: getPageUrl(i),
          pageNumber: i,
          pageText: i + "",
          onClick: onChange,
          itemClass: itemClass,
          linkClass: linkClass,
          activeClass: activeClass,
          activeLinkClass: activeLinkClass,
          ariaLabel: "Go to page number ".concat(i)
        }));
      }

      this.isPrevPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
        key: "prev" + paginationInfo.previous_page,
        href: getPageUrl(paginationInfo.previous_page),
        pageNumber: paginationInfo.previous_page,
        onClick: onChange,
        pageText: prevPageText,
        isDisabled: !paginationInfo.has_previous_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassPrev),
        linkClass: (0, _classnames["default"])(linkClass, linkClassPrev),
        disabledClass: disabledClass,
        ariaLabel: "Go to previous page"
      }));
      this.isFirstPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
        key: "first",
        href: getPageUrl(1),
        pageNumber: 1,
        onClick: onChange,
        pageText: firstPageText,
        isDisabled: !paginationInfo.has_previous_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassFirst),
        linkClass: (0, _classnames["default"])(linkClass, linkClassFirst),
        disabledClass: disabledClass,
        ariaLabel: "Go to first page"
      }));
      this.isNextPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
        key: "next" + paginationInfo.next_page,
        href: getPageUrl(paginationInfo.next_page),
        pageNumber: paginationInfo.next_page,
        onClick: onChange,
        pageText: nextPageText,
        isDisabled: !paginationInfo.has_next_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassNext),
        linkClass: (0, _classnames["default"])(linkClass, linkClassNext),
        disabledClass: disabledClass,
        ariaLabel: "Go to next page"
      }));
      this.isLastPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
        key: "last",
        href: getPageUrl(paginationInfo.total_pages),
        pageNumber: paginationInfo.total_pages,
        onClick: onChange,
        pageText: lastPageText,
        isDisabled: paginationInfo.current_page === paginationInfo.total_pages,
        itemClass: (0, _classnames["default"])(itemClass, itemClassLast),
        linkClass: (0, _classnames["default"])(linkClass, linkClassLast),
        disabledClass: disabledClass,
        ariaLabel: "Go to last page"
      }));
      return pages;
    }
  }, {
    key: "render",
    value: function render() {
      var pages = this.buildPages();
      return _react["default"].createElement("ul", {
        className: this.props.innerClass
      }, pages);
    }
  }]);

  return Pagination;
}(_react["default"].Component);

exports["default"] = Pagination;

_defineProperty(Pagination, "propTypes", {
  totalItemsCount: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  activePage: _propTypes["default"].number,
  itemsCountPerPage: _propTypes["default"].number,
  pageRangeDisplayed: _propTypes["default"].number,
  prevPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  nextPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  lastPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  firstPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  disabledClass: _propTypes["default"].string,
  hideDisabled: _propTypes["default"].bool,
  hideNavigation: _propTypes["default"].bool,
  innerClass: _propTypes["default"].string,
  itemClass: _propTypes["default"].string,
  itemClassFirst: _propTypes["default"].string,
  itemClassPrev: _propTypes["default"].string,
  itemClassNext: _propTypes["default"].string,
  itemClassLast: _propTypes["default"].string,
  linkClass: _propTypes["default"].string,
  activeClass: _propTypes["default"].string,
  activeLinkClass: _propTypes["default"].string,
  linkClassFirst: _propTypes["default"].string,
  linkClassPrev: _propTypes["default"].string,
  linkClassNext: _propTypes["default"].string,
  linkClassLast: _propTypes["default"].string,
  hideFirstLastPages: _propTypes["default"].bool,
  getPageUrl: _propTypes["default"].func
});

_defineProperty(Pagination, "defaultProps", {
  itemsCountPerPage: 10,
  pageRangeDisplayed: 5,
  activePage: 1,
  prevPageText: "⟨",
  firstPageText: "«",
  nextPageText: "⟩",
  lastPageText: "»",
  innerClass: "pagination",
  itemClass: undefined,
  linkClass: undefined,
  activeLinkClass: undefined,
  hideFirstLastPages: false,
  getPageUrl: function getPageUrl(i) {
    return "#";
  }
});

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(160)('wks');
var uid = __webpack_require__(126);
var Symbol = __webpack_require__(37).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(276);
/* unused harmony reexport defaultCellRangeRenderer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(275);
/* unused harmony reexport defaultOverscanIndicesGetter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(23);
/* unused harmony reexport bpfrpt_proptype_NoContentRenderer */
/* unused harmony reexport bpfrpt_proptype_Alignment */
/* unused harmony reexport bpfrpt_proptype_CellPosition */
/* unused harmony reexport bpfrpt_proptype_CellSize */
/* unused harmony reexport bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony reexport bpfrpt_proptype_RenderedSection */
/* unused harmony reexport bpfrpt_proptype_CellRendererParams */
/* unused harmony reexport bpfrpt_proptype_Scroll */

























/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(328);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(219);
var isBuffer = __webpack_require__(408);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["r"] = getSolicitud;
/* harmony export (immutable) */ __webpack_exports__["C"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["d"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["x"] = removeFiles;
/* harmony export (immutable) */ __webpack_exports__["g"] = addProveedorCotizacion;
/* harmony export (immutable) */ __webpack_exports__["c"] = addCotizacionAprobar;
/* harmony export (immutable) */ __webpack_exports__["B"] = seleccionarCotizacionAprobar;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCotizacion;
/* harmony export (immutable) */ __webpack_exports__["y"] = removeProveedorCotizacion;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateSolicitudServicio;
/* harmony export (immutable) */ __webpack_exports__["t"] = recomendarCotizacion;
/* harmony export (immutable) */ __webpack_exports__["A"] = seleccionarAprobacion;
/* harmony export (immutable) */ __webpack_exports__["u"] = registerApprovalResult;
/* harmony export (immutable) */ __webpack_exports__["n"] = displayModalCreateDocumento;
/* harmony export (immutable) */ __webpack_exports__["m"] = displayModalCompraDirecta;
/* harmony export (immutable) */ __webpack_exports__["e"] = addFileCompraDirecta;
/* harmony export (immutable) */ __webpack_exports__["j"] = createOrUpdateCompraDirecta;
/* harmony export (immutable) */ __webpack_exports__["f"] = addGarantia;
/* harmony export (immutable) */ __webpack_exports__["k"] = createOrUpdateDocumento;
/* harmony export (immutable) */ __webpack_exports__["v"] = registerCancelacion;
/* harmony export (immutable) */ __webpack_exports__["s"] = previewDocumento;
/* harmony export (immutable) */ __webpack_exports__["l"] = displayModalAddServicio;
/* harmony export (immutable) */ __webpack_exports__["h"] = addSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCencoSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["w"] = removeCencosSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["z"] = removeSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["q"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["o"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["p"] = eliminarComentario;
/* harmony export (immutable) */ __webpack_exports__["i"] = crearAprobacionAdicional;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_file_download__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__otrosi__ = __webpack_require__(69);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getSolicitud(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+id).then(function(res){var cotizacionesAprobadas=[];var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;for(var index=0;index<solicitud.servicios.length;index++){cotizacionesAprobadas=solicitud.servicios[index].cotizaciones.filter(function(ele){return ele.estado===4;});solicitud.servicios[index].cotizaciones_aprobar=cotizacionesAprobadas;}dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_309" /* OBTENER_SOLICITUD_SERVICIO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}function updateInputs(path,value){var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var immutable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;//Alerta: colocar el id para activar el boton de actualizacion
return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_217" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO1 */],payload:{path:path,value:value,immutable:immutable}});};fn0(dispatch);var pathArray=path.split('.');var entity=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["n" /* esEntero */])(pathArray.slice(-2)[0])?pathArray.slice(-3)[0]:pathArray.slice(-2)[0];var attribute=pathArray.slice(-2)[1];switch(entity){case'solicitud':entity='Solicitude';break;case'servicio':case'servicios':entity='Servicio';break;case'cotizacion':case'cotizacione':case'cotizaciones':case'cotizaciones_aprobar':entity='Cotizacione';break;case'documento':case'documentos':entity='Documento';break;}if(id){var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["L" /* ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO */],payload:{id:id,entity:entity,attribute:attribute,value:value,action:'edit'}});};fn2(dispatch);}};}function addFile(url,actions){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var files=[data];actions.push(function(){return Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'Los archivos han sido guardados exitosamente'});});dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["F" /* uploadFiles */])(url,files,actions));};}function removeFiles(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fns=[];getState().solicitudservicio.getIn(['solicitud','adjuntos']).filter(function(a){return a.get('id')&&a.get('selected');}).map(function(a){fns.push(function(){return axios.delete(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/files/'+a.get('id'));});});var id=getState().solicitudservicio.get('id');Promise.all(fns.map(function(x){return x();})).then(function(){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});dispatch(getSolicitud(id));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}function addProveedorCotizacion(payload){return function(dispatch,getState){var path=payload.path.split('.').slice(0,4);var cotizaciones=getState().solicitudservicio.getIn(path);if(cotizaciones.filter(function(x){return x.getIn(['proveedore','id'])===payload.value.id;}).count()!==0){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn('El proveedor '+payload.value.nombre+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{var proveedor=getState().solicitudservicio.getIn(payload.path.split('.').slice(0,4)).toJS();proveedor=Object.assign({},proveedor,payload.value);payload.value=proveedor;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["z" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO */],payload:payload});var servicio_id=getState().solicitudservicio.getIn(payload.path.split('.').slice(0,3)).get('id');var cotizacion_index=payload.path.split('.').slice(-2)[0];var id=servicio_id+'.'+cotizacion_index;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["L" /* ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO */],payload:{id:id,entity:'Cotizaciones',attribute:'proveedore',value:payload.value.id,action:'edit'}});}};}function addCotizacionAprobar(path){return{type:__WEBPACK_IMPORTED_MODULE_4__types__["m" /* ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO */],payload:{path:path}};}function seleccionarCotizacionAprobar(cotizacion_id,indexServicio,indexCotizacionAprobar){return function(dispatch,getState){var cotizacionesAprobar=getState().solicitudservicio.getIn(['solicitud','servicios',indexServicio,'cotizaciones_aprobar']).filter(function(cot){return cot.get('id')==Number(cotizacion_id);});if(cotizacionesAprobar.count()>0){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn('El proveedor ya ha sido seleccionado',{bodyClassName:'toastify-content toastify-warning'});}else{var cotizaciones=getState().solicitudservicio.getIn(['solicitud','servicios',indexServicio,'cotizaciones']);var cotizacionCompraDirecta=cotizaciones.filter(function(x){return x.get('proveedor_id')==null;});var esCompraDirecta=false;if(cotizacionCompraDirecta.count()>0){esCompraDirecta=true;}dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_364" /* SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO */],payload:{cotizacion_id:cotizacion_id,indexServicio:indexServicio,indexCotizacionAprobar:indexCotizacionAprobar,esCompraDirecta:esCompraDirecta}});}};}function addCotizacion(path,indexServicio){return function(dispatch,getState){var cotizaciones=getState().solicitudservicio.getIn(['solicitud','servicios',indexServicio,'cotizaciones']);var numcotizaciones=cotizaciones?cotizaciones.count():0;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_7" /* ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO */],payload:{path:path,indexServicio:indexServicio}});};}function removeProveedorCotizacion(path){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_141" /* ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO */],payload:{path:path}});};}function updateSolicitudServicio(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_84" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_84" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO */],payload:false});};fn0(dispatch);var files=[];var solicitud=getState().solicitudservicio.get('solicitud');var unchaged=getState().solicitudservicio.get('unchaged');var solicitud_id=getState().solicitudservicio.get('id');var serviciosNew=getState().solicitudservicio.getIn(['solicitud','servicios']);var serviciosdOld=getState().solicitudservicio.getIn(['unchaged','servicios']);var modificar=getState().solicitudservicio.get('addModificacion');var remove=getState().solicitudservicio.get('remove');var errors=validateSolicitud(getState().solicitudservicio.get('solicitud'));if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});//fn1(dispatch)
}else{var serviciosNewCompraDirecta=getState().solicitudservicio.getIn(['solicitud','servicios']);var _files=[];var modificaciones=[];var comprasDirectas=serviciosNewCompraDirecta.filter(function(servicio){return servicio.get('compra_directa')&&servicio.get('factura_compra_directa_servicios');}).map(function(servicio){return servicio.get('factura_compra_directa_servicios');});if(comprasDirectas.count()>0&&solicitud.get('estado')>=4&&solicitud.get('estado')<=6){_files=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* attachFilesToEntity */])("FacturaCompraDirectaServicios",comprasDirectas);}if(modificar){modificaciones=addModificacion(solicitud,unchaged);}else{modificaciones=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["u" /* getModificaciones */])(serviciosNew,serviciosdOld,'Servicio',switchServicios);}modificaciones=[].concat(_toConsumableArray(modificaciones),_toConsumableArray(remove));modificaciones=addProveedoresExternos(modificaciones);axios.put(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+solicitud_id,modificaciones).then(function(res){var cotizacionesAprobadas=[];var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;for(var index=0;index<solicitud.servicios.length;index++){cotizacionesAprobadas=solicitud.servicios[index].cotizaciones.filter(function(ele){return ele.estado===4;});solicitud.servicios[index].cotizaciones_aprobar=cotizacionesAprobadas;}var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["g" /* ACTUALIZAR_SOLICITUD_SERVICIO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_5__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,_files,[fn2,fn3,fn4]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function recomendarCotizacion(indexServicio,indexCotizacion){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_43" /* CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO */],payload:{indexServicio:indexServicio,indexCotizacion:indexCotizacion}});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_84" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO */],payload:false});};}function seleccionarAprobacion(servicioid,aprobadorid,aprobacionid){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_46" /* CONMUTAR_SELECCION_APROBACION_SERVICIO */],payload:{servicioid:servicioid,aprobadorid:aprobadorid,aprobacionid:aprobacionid}});};}function registerApprovalResult(aprobaciones,result){var indexServicio=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var ip=__webpack_require__(79);var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudservicio.get('solicitud');var errors=result>0?validateAprobacion(aprobaciones,result):validateAprobacion(aprobaciones.first().get('observaciones'),result);var disCencos=solicitud.getIn(['servicios',indexServicio,'cencos']);var aprobadas=aprobaciones.filter(function(a){return a.get('estado')==3;});var aprobador_id=aprobadas.count()>0&&aprobadas.first().get('aprobador_id');var cencos=aprobaciones.count()>0&&aprobaciones.first().getIn(['cotizacione','servicios',0,'cencos']);var cenco=cencos.filter(function(c){return c.get('responsable_id')==aprobador_id;});var cenco_id=null;if(cenco.count()>0){cenco_id=cenco.first().get('id');}// if (disCencos && result != 0) {
// 	disCencos.map(c => {
// 		if ((c.get('rubros').count() > 0) && c.get('id') == cenco_id) {
// 			if (! c.getIn(['pivot', 'rubro_id'])) {
// 				errors.push('Deben seleccionar un rubro si tiene rubros existentes')
// 			}
// 		}
// 	})
// }		
if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];aprobaciones.map(function(a){modificaciones.push({id:a.get('id'),entity:'Aprobacione',value:{estado:result>0?a.get('estado')==1?4:result:0,ip:ip.address(),observaciones:aprobaciones.first().get('observaciones')},action:'edit'});});if(disCencos)disCencos.map(function(c){if(c.getIn(['pivot','rubro_id'])){modificaciones.push({id:c.getIn(['pivot','id']),entity:'DisCencoServicio',value:{rubro_id:c.getIn(['pivot','rubro_id'])},action:'edit'});}});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_81" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO */],payload:true});axios.put(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;if(solicitud.estado===0){__WEBPACK_IMPORTED_MODULE_5__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido anulada'});}else{if(solicitud.documento_origen){var fn1=function fn1(d){return d(Object(__WEBPACK_IMPORTED_MODULE_8__otrosi__["b" /* getSolicitud */])(solicitud.id));};fn1(dispatch);}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["g" /* ACTUALIZAR_SOLICITUD_SERVICIO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn0(dispatch);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido guardada exitosamente'});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_81" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO */],payload:false});}}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_81" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO */],payload:false});});}};}function displayModalCreateDocumento(show,title,mode,indexDocumento){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var proveedor=getState().solicitudservicioot.getIn(['solicitud','documentos',indexDocumento,'proveedor_id']);var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/plantillas');};var fn1=function fn1(){return axios.get(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/garantias');};var fn2=function fn2(){return axios.get(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/documentos/contratos-anuales',{params:{proveedor:proveedor}});};Promise.all([fn0(),fn1(),fn2()]).then(function(res){var plantillas=res[0].data.data;var garantias=res[1].data.data;var contratos=res[2].data;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_260" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO */],payload:{show:show,title:title,mode:mode,indexDocumento:indexDocumento,plantillas:plantillas,garantias:garantias,contratos:contratos}});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}function displayModalCompraDirecta(show,title,servicio_id,cotizacion){return{type:__WEBPACK_IMPORTED_MODULE_4__types__["_257" /* MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO */],payload:{title:title,show:show,servicio_id:servicio_id,cotizacion:cotizacion}};}function addFileCompraDirecta(path){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(data.get('clasificacion')&&data.get('clasificacion')!='Facturas')errors.push('Se requiere adjuntar un archivo de tipo Factura');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_217" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO1 */],payload:{path:path,value:data,immutable:true}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}function createOrUpdateCompraDirecta(){return function(dispatch,getState){var documentoNew=getState().solicitudservicio.getIn(['modalCreateCompraDirecta','data']);var cot_id=getState().solicitudservicio.getIn(['modalCreateCompraDirecta','cot_id']);var servicio_id=getState().solicitudservicio.getIn(['modalCreateCompraDirecta','servicio_id']);var cotizacion_idx=getState().solicitudservicio.getIn(['solicitud','cotizaciones']).findIndex(function(cot){return cot.get('id')===cot_id;});var servicios_idx=getState().solicitudservicio.getIn(['solicitud','cotizaciones',cotizacion_idx,'servicios']).findIndex(function(servicio){return servicio.get('id')===servicio_id;});var errors=validateFacturaCompraDirecta(documentoNew);if(errors.length){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{dispatch(displayModalCompraDirecta(false));dispatch(updateInputs('solicitud.cotizaciones.'+cotizacion_idx+'.servicios.'+servicios_idx+'.factura_compra_directa_servicios',documentoNew,servicio_id));servicios_idx=getState().solicitudservicio.getIn(['solicitud','servicios']).findIndex(function(servicio){return servicio.get('id')===servicio_id;});dispatch(updateInputs('solicitud.servicios.'+servicios_idx+'.factura_compra_directa_servicios',documentoNew,servicio_id));if(documentoNew.get('proveedor','nombre'))dispatch(updateInputs('solicitud.cotizaciones.'+cotizacion_idx+'.proveedor_nombre_cp',documentoNew.getIn(['proveedor','nombre']),cot_id));else dispatch(updateInputs('solicitud.cotizaciones.'+cotizacion_idx+'.proveedor_nombre_cp',documentoNew.get(['razon_social']),cot_id));}};}function addGarantia(checked,index,id){return function(dispatch){if(checked){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["F" /* ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO */],payload:index});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_353" /* REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO */],payload:id});}};}function createOrUpdateDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_101" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_101" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO */],payload:false});};fn0(dispatch);var fn3=function fn3(d){return d(displayModalCreateDocumento(false));};var solicitud=getState().solicitudservicio.get('id');var data=getState().solicitudservicio.get('modalCreateDocumento');var documentoNew=data.get('data');var documentoOld=data.get('unchanged');var tipoDocumento=documentoNew.get('tipo');if(tipoDocumento==1||tipoDocumento==3){documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'));}if(tipoDocumento==4){var fecha_inicio=getState().solicitudservicio.getIn(['solicitud','documento_origen','fecha_inicio']);documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_1_moment___default()(fecha_inicio).format('YYYY-MM-DD'));}var errors=validateDocumento(documentoNew,data.get('contratoanual'));if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});fn1(dispatch);}else{documentoOld=documentoOld.set('garantias',Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["D" /* indexBy */])(documentoOld.get('garantias'),'id'));documentoNew=documentoNew.set('garantias',Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["D" /* indexBy */])(documentoNew.get('garantias'),'id'));var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["u" /* getModificaciones */])(documentoNew,documentoOld,'Documento',switchDocumento);axios.put(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+solicitud,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["g" /* ACTUALIZAR_SOLICITUD_SERVICIO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn1(dispatch);fn2(dispatch);fn3(dispatch);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function registerCancelacion(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudservicio.get('solicitud').set('estado',0);var errors=validateSolicitud(solicitud);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{estado:0,motivo_cancelacion:solicitud.get('motivo_cancelacion'),fecha_cancelacion:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')},action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["g" /* ACTUALIZAR_SOLICITUD_SERVICIO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();if(solicitud.documento_origen){var fn2=function fn2(d){return d(Object(__WEBPACK_IMPORTED_MODULE_8__otrosi__["b" /* getSolicitud */])(solicitud.id));};fn2(dispatch);}}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});}};}function previewDocumento(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var documento=getState().solicitudservicio.getIn(['modalCreateDocumento','data']);var tipo=getState().common.getIn(['enums','documentos','tipos',''+documento.get('tipo'),'NOMBRE']);axios.post(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/view/'+id,{documento:documento},{responseType:'arraybuffer'}).then(function(res){__WEBPACK_IMPORTED_MODULE_7_react_file_download___default()(res.data,'PREV-'+tipo+'.pdf');}).catch(function(err){var decodedString=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(err.response.data)));var obj={response:{data:decodedString,status:422}};Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,obj);});};}function displayModalAddServicio(show,title,mode,index){return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_247" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_319" /* OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 */]});}};}function addSolicitudServicioItem(){return function(dispatch,getState){var data=getState().solicitudservicio.getIn(['modalAddServicio','data']);var errors=[];if(!data.get('descripcion'))errors.push('La creación de servicios requiere de una descripción');if(data.get('cantidad')<1)errors.push('La creación de servicios requiere que la cantidad sea superior a 0');if(data.get('cencos').count()===0)errors.push('La creación de servicios requiere al menos de un centro de costo');if(data.get('cencos').filter(function(x){return x.get('id')===null;}).count()>0)errors.push('La creación de servicios requiere que todos los centros de costos estén definidos');if(data.get('cencos').filter(function(x){return x.get(['pivot','porcentaje'])<1;}).count()>0)errors.push('El porcentaje en los cencos debe ser mayor a 0');var sumDist=data.get('cencos').reduce(function(a,b){a+=Number(b.getIn(['pivot','porcentaje']));return a;},0);if(sumDist!==100)errors.push('La creación de servicios requiere la suma de distribución entre cencos sea del 100%');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_84" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO */],payload:false});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_12" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1 */]});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_319" /* OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 */]});};fn0(dispatch);fn1(dispatch);fn2(dispatch);}};}function addCencoSolicitudServicioItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_2" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1 */]});};}function removeCencosSolicitudServicioItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_133" /* ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1 */]});};}function removeSolicitudServicioItem(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var servicios=getState().solicitudservicio.getIn(['solicitud','servicios']).filter(function(x){return x.get('id')&&x.get('selected');});var modificaciones=[];servicios.valueSeq().forEach(function(servicio){var cencos=servicio.get('cencos');cencos.valueSeq().forEach(function(c){modificaciones.push({entity:'DisCencoServicio',id:c.getIn(['pivot','id']),action:'delete'});});modificaciones.push({entity:'Servicio',id:servicio.get('id'),action:'delete'});});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_154" /* ELIMINAR_ITEMS_SOLICITUD_SERVICIO */],payload:{remove:modificaciones}});};}function enviarComentario(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud_id=getState().solicitudservicio.getIn(['solicitud','id']);var usuario_id=getState().common.getIn(['user','id']);var id=getState().solicitudservicio.getIn(['comentario','id']);var comentario=getState().solicitudservicio.getIn(['comentario','texto']);var modificaciones=[];if(id==null){modificaciones.push({entity:'Foro',action:'add',id:null,value:{solicitud_id:solicitud_id,usuario_id:usuario_id,comentario:comentario}});}else{modificaciones.push({id:id,entity:'Foro',value:{comentario:comentario},action:'edit'});}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_88" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1 */],payload:true});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_88" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1 */],payload:false});};fn1(dispatch);axios.put(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+solicitud_id,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_163" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1 */],payload:{foros:foros}});};fn3(dispatch);fn2(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);fn2(dispatch);});};}function editarComentario(id){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_118" /* EDITAR_COMENTARIO_SOLICITUD_SERVICIO1 */],payload:{id:id}});};fn1(dispatch);};}function eliminarComentario(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudservicio.getIn(['solicitud','id']);var modificaciones=[];modificaciones.push({entity:'Foro',id:id,action:'delete'});axios.put(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+solicitud,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_163" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1 */],payload:{foros:foros}});};fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'La eliminacion han sido realizadas exitosamente'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}function crearAprobacionAdicional(_ref){var cotizacion=_ref.cotizacion,aprobador=_ref.aprobador,motivo=_ref.motivo;var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var errors=validarSolicitudAprobacionAdicionalServicio(cotizacion,aprobador,motivo);if(errors.length>0){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{error:errors});return;}var solicitud_id=getState().solicitudservicio.get('id');var modificaciones=[];modificaciones.push({id:null,entity:'Aprobacione',action:'add',value:{cotizacion_id:cotizacion.get('id'),aprobador_id:aprobador.id,estado:1,// Pendiente de aprobación
observaciones:motivo,tipo:3}});axios.put(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/servicios/'+solicitud_id,modificaciones).then(function(res){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'Aprobación adicional solicitada correctamente.'});dispatch(getSolicitud(solicitud_id));}).catch(function(err){if(err.response&&err.response.data&&err.response.data.ExceptionMessage){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{error:err.response.data.ExceptionMessage});}else{Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{error:'Error al solicitar la aprobación adicional.'});}});};}///******* Shared ********///
var addProveedoresExternos=function addProveedoresExternos(modificaciones){modificaciones.forEach(function(m,i){if(m.value&&m.entity=='Servicio'&&m.attribute=='factura_compra_directa_servicios'&&m.action=='create'){if(m.value.proveedor){modificaciones[i].value.razon_social=m.value.proveedor.nombre;delete modificaciones[i].value.proveedor;}else{modificaciones.push({entity:'ProveedorExterno',value:{nombre:m.value.razon_social},action:'add'});}}});return modificaciones;};var validateAprobacion=function validateAprobacion(data,extra){var errors=[];if(extra==2&&data.filter(function(x){return x.get('estado')==3;}).count()==0)errors.push('Debe seleccionar una cotización para aprobar');if(extra==2&&data.filter(function(x){return x.get('estado')==3;}).count()>1)errors.push('Sólo dbe seleccionar una cotización para aprobar');if(extra==0&&!data)errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones');return errors;};function validarSolicitudAprobacionAdicionalServicio(cotizacion,aprobador,motivo){var errors=[];if(!cotizacion||!cotizacion.get('id'))errors.push('Debe seleccionar una cotización válida.');if(!aprobador||!aprobador.id)errors.push('Debe seleccionar un aprobador adicional.');if(!motivo||motivo.trim().length===0)errors.push('El motivo de la solicitud adicional es obligatorio');return errors;}var validateSolicitud=function validateSolicitud(data){var extra=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errors=[];if(data.get('estado')===1){data.get('servicios').map(function(s,n){if(s.get('compra_directa')==true){if(!s.get('fecha_cotizaciones')||s.get('fecha_cotizaciones')=='-0001-11-30 00:00:00')errors.push('El campo fecha cotizaciones es obligatorio');}if(s.get('cotizaciones')&&s.get('cotizaciones').count()>0){if(s.get('fecha_cotizaciones')==='-0001-11-30 00:00:00'||s.get('fecha_cotizaciones')==='')errors.push('El campo fecha cotizaciones es obligatorio en servicio # '+(n+1));if(s.get('fecha_cotizaciones')&&__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract('days',1).isAfter(s.get('fecha_cotizaciones')))errors.push('La fecha de cotizaciones no debe ser inferior a la de hoy');if(s.get('cotizaciones').count()==0)errors.push('Se requiere al menos un proveedor en servicio # '+(n+1));if(s.get('cotizaciones').count()>0&&s.get('cotizaciones').filter(function(c){return c.get('proveedore')==null;}).count()>0)errors.push('Todos los campos de los proveedores son requeridos en servicio # '+(n+1));}});}if(data.get('estado')>=2){data.get('servicios').map(function(s,n){s.get('cotizaciones_aprobar').map(function(c,i){if(c.get('adjunto')){if(!c.get('cotizado'))errors.push('El valor unitario de la cotizaci\xF3n es obligatorio en el servicio '+(n+1));if(!c.get('iva'))errors.push('El valor IVA de la cotizaci\xF3n es obligatorio en el servicio '+(n+1));if(!c.get('forma_pago')||c.get('forma_pago')==0)errors.push('La forma de pago es obligatorio en el servicio '+(n+1));if(!c.get('proveedor_id'))errors.push('Debe seleccionar un proveedor en el servicio '+(n+1));}});if(s.get('cotizaciones_aprobar').filter(function(x){return x.get('recomendado')==true;}).count()==0&&s.get('cotizaciones_aprobar').count()>0)errors.push('Se debe recomendar una cotizaci\xF3n en el servicio '+(n+1));//|| s.get('compra_directa') !== 0
});}else if(data.get('estado')===0){if(!data.get('motivo_cancelacion'))errors.push('El campo motivo cancelación es obligatorio');}return errors;};var switchServicios=function switchServicios(change,modificacion,servicios){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[1];switch(change.get('op')){case'add':if(modificacion.attribute==='cotizaciones'){modificacion.action='create';modificacion.value.adjunto=null;modificacion.value.proveedor_id=modificacion.value.proveedore&&modificacion.value.proveedore.id;modificacion.value.servicio=null;modificacion.value.proveedore=null;}else if(modificacion.attribute==="cotizaciones_aprobar"){modificacion.action='create';modificacion.attribute='cotizaciones';modificacion.value.adjunto=null;modificacion.value.proveedor_id=null;modificacion.value.proveedore=null;modificacion.value.servicio=null;}if(modificacion.attribute==='cencos'){modificacion.action='hidden';}if(modificacion.attribute==='selected'){modificacion.action='hidden';}break;case'replace':if(modificacion.attribute==='cotizaciones'||modificacion.attribute==='cotizaciones_aprobar'){modificacion.attribute=path[3];modificacion.entity='Cotizacione';modificacion.id=servicios.getIn([].concat(_toConsumableArray(path.splice(0,3)),['id']));}if(modificacion.attribute==='cencos'){modificacion.action='hidden';}if(modificacion.attribute==='factura_compra_directa_servicios'){if(servicios.getIn([].concat(_toConsumableArray(path.slice(0,2)),['id']))){modificacion.attribute=path[2];modificacion.entity='FacturaCompraDirectaServicios';modificacion.id=servicios.getIn([].concat(_toConsumableArray(path.slice(0,2)),['id']));}else{modificacion.entity='Servicio',modificacion.action='create';delete modificacion.value.adjunto;delete modificacion.value.id;}}if(modificacion.attribute==='selected'){modificacion.action='hidden';}break;case'remove':if(modificacion.attribute==='cencos'){modificacion.action='hidden';}break;}};var switchFacturaCompraDirecta=function switchFacturaCompraDirecta(change,modification,facturaCP){var path=[].concat(_toConsumableArray(modification.attribute));modification.attribute=path[0];switch(change.get('op')){case'add':if(modification.entity==='FacturaCompraDirectaServicios'){modification.action='create';}}};var validateDocumento=function validateDocumento(data){var escontratoanual=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var errors=[];if(Number(data.get('tipo'))===0)errors.push('El campo tipo de documento es obligatorio');if(data.get('tipo')==2&&!data.get('fecha_inicio'))errors.push('El campo fecha inicio es obligatorio');if(!data.get('fecha_entrega'))errors.push('El campo fecha entrega es obligatorio');if(data.get('tipo')==2&&data.get('fecha_inicio')){if(!__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.get('fecha_inicio')).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')))errors.push('La fecha de inicio no debe ser inferior a hoy');}if(data.get('tipo')==2&&data.get('fecha_inicio')&&data.get('fecha_entrega')){if(__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.get('fecha_inicio')).isAfter(data.get('fecha_entrega')))errors.push('La fecha entrega no debe ser inferior a la fecha de inicio');}if(data.get('tipo')!=4&&Number(data.get('plantilla_id'))===0)errors.push('El campo plantilla es obligatorio');if(Number(data.get('anticipo'))>50)errors.push('El anticipo no debe ser superior al 50%');if(Number(data.get('anticipo'))>0&&!data.get('pago_anticipo'))errors.push('La fecha de pago de anticipo es obligatioria si hay anticipo');if(Number(data.get('anticipo'))>0&&!data.get('forma_pago_anticipo'))errors.push('La forma de pago de anticipo es obligatioria si hay anticipo');if(escontratoanual){if(Number(data.get('documento_id'))===0)errors.push('El campo número de contrato es obligatorio');}var cotizado=data.get('detalles').reduce(function(acum,detalle){acum+=detalle.get('valor_con_iva')*detalle.get('cantidad');return acum;},0);cotizado=parseFloat(cotizado.toFixed(2));var aiu_total=parseFloat(Number(data.get('aiu_total')).toFixed(2));//Lo mando a quitar Oscar el dia 12/07/2019 via Skype
// if (cotizado !== aiu_total && data.get('tipo') != 4) {
// 	errors.push('El valor total de los servicios es diferente al valor total')
// }
if(!data.get('almacen')){errors.push('El campo Almacén es obligatorio');}return errors;};/**
 * Valida que todos los campos esten diligenciados
 * @param {Object} data 
 */var validateFacturaCompraDirecta=function validateFacturaCompraDirecta(data){var errors=[];if(!data.get('razon_social')&&!data.getIn(['proveedor','nombre']))errors.push("Debe ingresar un proveedor");if(!data.get('no_factura'))errors.push("Debe ingresar el número de la factura");if(!data.get('fecha_compra'))errors.push("Ingrese una fecha de compra válida");if(!data.get('medio_pago'))errors.push("Debe ingresar una forma de pago");if(!data.get('valor_compra'))errors.push("Debe ingresar el valor de la compra");if(!data.get('adjunto'))errors.push("Debe adjuntar el archivo de la factura");var today=__WEBPACK_IMPORTED_MODULE_1_moment___default()();if(data.get('fecha_compra')&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.get('fecha_compra')).isAfter(today))errors.push("La fecha de compra no debe ser superior a la de hoy");return errors;};var switchDocumento=function switchDocumento(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];switch(modificacion.attribute){case'aiu_administracion_value':case'aiu_imprevistos_value':case'aiu_utilidad_value':case'aiu_iva_utilidad_value':case'iva_value':case'aiu_total':case'todos_detalles':modificacion.action='hidden';break;}switch(change.get('op')){case'add':if(modificacion.attribute==='garantias'){modificacion.value=modificacion.value.id;modificacion.action='attach';}break;case'remove':if(modificacion.attribute==='garantias'){modificacion.action='detach';}break;}};var addModificacion=function addModificacion(solicitud,unchaged){var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{proyecto_evento:solicitud.get('proyecto_evento'),fecha_requerido:solicitud.get('fecha_requerido')},action:'edit'});solicitud.get('servicios').valueSeq().forEach(function(servicio){if(servicio.get('id')){modificaciones.push({id:servicio.get('id'),entity:'Servicio',value:{descripcion:servicio.get('descripcion'),cantidad:servicio.get('cantidad'),fecha_cotizaciones:servicio.get('fecha_cotizaciones')!='-0001-11-30 00:00:00'?servicio.get('fecha_cotizaciones'):null},action:'edit'});var idx=unchaged.get('servicios').findIndex(function(s){return s.get('id')==servicio.get('id');});if(idx!=-1){var modificacionesCencos=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["u" /* getModificaciones */])(servicio.get('cencos'),unchaged.getIn(['servicios',idx,'cencos']),'DisCencoServicio');// Solo detectamos si hay cambios.
if(modificacionesCencos.length>0){//Modificamos los cencos
var cencos=void 0;// 1 - Borramos todos los que estan en unchanged
cencos=unchaged.getIn(['servicios',idx,'cencos']);cencos.valueSeq().forEach(function(c){modificaciones.push({id:c.getIn(['pivot','id']),entity:'DisCencoServicio',action:'delete'});});// 2 - Y agregamos los que estan en solicitud/servicios
cencos=servicio.get('cencos');cencos.valueSeq().forEach(function(c){modificaciones.push({entity:'DisCencoServicio',value:{servicio_id:servicio.get('id'),cenco_id:c.getIn(['pivot','cenco_id']),porcentaje:c.getIn(['pivot','porcentaje'])},action:'add'});});}}// 3 - Agregamos cotizaciones si las hay en el estado creado
if(solicitud.get('estado')==1&&servicio.get('cotizaciones').count()>0){var cotizaciones=servicio.get('cotizaciones');cotizaciones.forEach(function(c){var value=c.toJS();value.servicio=null;value.adjunto=null;value.proveedore=null;modificaciones.push({entity:'Servicio',id:servicio.get('id'),attribute:'cotizaciones',value:value,action:'create'});});}}else{var _cencos=[];servicio.get('cencos').valueSeq().forEach(function(cenco){_cencos.push({cenco_id:cenco.getIn(['pivot','cenco_id']),porcentaje:cenco.getIn(['pivot','porcentaje']),rubro_id:cenco.getIn(['pivot','rubro_id'])});});// Se modifico el backend para aceptar una relacion
modificaciones.push({entity:'Servicio',value:{solicitud_id:solicitud.get('id'),descripcion:servicio.get('descripcion'),valor:servicio.get('valor'),valor_con_iva:servicio.get('valor_con_iva'),cantidad:servicio.get('cantidad'),estado:1,cencos:_cencos},action:'add'});}});return modificaciones;};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["v"] = getSolicitud;
/* harmony export (immutable) */ __webpack_exports__["m"] = displayModalAddCotizacion;
/* harmony export (immutable) */ __webpack_exports__["n"] = displayModalAddTiquete;
/* harmony export (immutable) */ __webpack_exports__["l"] = displayModalAddAsistencia;
/* harmony export (immutable) */ __webpack_exports__["o"] = displayModalSelectVersion;
/* harmony export (immutable) */ __webpack_exports__["C"] = removeCotizacion;
/* harmony export (immutable) */ __webpack_exports__["G"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["d"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["r"] = editPassportFile;
/* harmony export (immutable) */ __webpack_exports__["g"] = addOrigen;
/* harmony export (immutable) */ __webpack_exports__["c"] = addDestino;
/* harmony export (immutable) */ __webpack_exports__["a"] = activateVersion;
/* harmony export (immutable) */ __webpack_exports__["i"] = addTrayecto;
/* harmony export (immutable) */ __webpack_exports__["E"] = removeTrayectos;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCencoSolicitud;
/* harmony export (immutable) */ __webpack_exports__["B"] = removeCenco;
/* harmony export (immutable) */ __webpack_exports__["h"] = addPasajero;
/* harmony export (immutable) */ __webpack_exports__["f"] = addOrEditCotizacion;
/* harmony export (immutable) */ __webpack_exports__["q"] = editPasajero;
/* harmony export (immutable) */ __webpack_exports__["p"] = editAsistencia;
/* harmony export (immutable) */ __webpack_exports__["I"] = updateTravel;
/* harmony export (immutable) */ __webpack_exports__["H"] = updateTiquetesAereo;
/* harmony export (immutable) */ __webpack_exports__["F"] = seleccionarAprobacion;
/* harmony export (immutable) */ __webpack_exports__["w"] = registerApprovalResult;
/* harmony export (immutable) */ __webpack_exports__["z"] = registerTiquetes;
/* harmony export (immutable) */ __webpack_exports__["x"] = registerAsistencias;
/* harmony export (immutable) */ __webpack_exports__["A"] = registerTiquetesExpirados;
/* harmony export (immutable) */ __webpack_exports__["y"] = registerCancelacion;
/* harmony export (immutable) */ __webpack_exports__["k"] = descargarAsistencia;
/* harmony export (immutable) */ __webpack_exports__["u"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["s"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["t"] = eliminarComentario;
/* harmony export (immutable) */ __webpack_exports__["D"] = removeSolicitudTiqutesAereos;
/* harmony export (immutable) */ __webpack_exports__["e"] = addFileAdjunto;
/* harmony export (immutable) */ __webpack_exports__["j"] = crearAprobacionAdicional;
/* unused harmony export validarSolicitudAprobacionAdicional */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_file_download__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(3);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getSolicitud(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+id);};Promise.all([fn0()]).then(function(res){var solicitud=res[0].data.solicitud;var aprobadores=res[0].data.aprobadores;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_311" /* OBTENER_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});};}function displayModalAddCotizacion(show,title,mode){var index=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_233" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_233" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO */],payload:{show:show}});}};}function displayModalAddTiquete(show,title){var index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_237" /* MOSTRAR_MODAL_ADICIONAR_TIQUETE */],payload:{show:show,title:title,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_237" /* MOSTRAR_MODAL_ADICIONAR_TIQUETE */],payload:{show:show}});}};}function displayModalAddAsistencia(show,title){var index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_231" /* MOSTRAR_MODAL_ADICIONAR_ASISTENCIA */],payload:{show:show,title:title,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_231" /* MOSTRAR_MODAL_ADICIONAR_ASISTENCIA */],payload:{show:show}});}};}function displayModalSelectVersion(show,title,mode){var index=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){if(show){var solicitud_id=getState().tiquetesaereo.getIn(['solicitud','id']);axios.get(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/versiones/'+solicitud_id).then(function(res){return dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_283" /* MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO */],payload:{show:show,title:title,mode:mode,index:index,data:res.data.versiones}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_283" /* MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO */],payload:{show:show}});}};}function removeCotizacion(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_351" /* REMOVER_COTIZACION_TIQUETESAEREO */]});};}function updateInputs(path,value){var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var immutable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch){if(path==='solicitud.proyecto_evento'||path==='solicitud.observaciones'||path.includes('celular')||path.includes('cedula')||path.includes('nombres')||path.includes('apellidos')||path.includes('nacionalidad')||path.includes('pais_expedicion')||path==='comentario.texto'||path==='solicitud.observaciones'||path==='modalAddCotizacion.data.descripcion'||path==='modalAddTiquete.data.tiquete.aerolinea'){var regex=/[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;value=value.replace(regex,"").toUpperCase();}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_221" /* MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1 */],payload:{path:path,value:value,immutable:immutable}});};fn0(dispatch);var entity=void 0;var attribute=path.split('.').slice(-1)[0];switch(attribute){case'descripcion':case'cotizado':entity='Cotizacione';break;default:}if(entity){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["N" /* ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO */],payload:{id:id,entity:entity,attribute:attribute,value:value,action:'edit'}});};fn1(dispatch);}};}function addFile(path){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["W" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO */],payload:{path:path,data:data}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}function editPassportFile(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var index=getState().common.getIn(['modalAddFile','index']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_110" /* EDITAR_ARCHIVO_PASAPORTE */],payload:{index:index,data:data}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};var path="flagAdjunto";var value=false;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_221" /* MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1 */],payload:{path:path,value:value}});};fn1(dispatch);fn2(dispatch);fn3(dispatch);}};}function addOrigen(payload,query){return function(dispatch,getState){var path=payload.path.split('.');var trayecto=getState().tiquetesaereo.getIn(path);//trayectos.0.origen
if(trayecto.get('origen')===payload.value.code){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn('La ubicacion '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{trayecto=trayecto.toJS();trayecto.origen=payload.value.code;trayecto.aeropuerto_origen=payload.value.name+' '+query.toUpperCase();payload.value=trayecto;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["C" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1 */],payload:payload});}};}function addDestino(payload,query){return function(dispatch,getState){var path=payload.path.split('.');var trayecto=getState().tiquetesaereo.getIn(path);if(trayecto.get('destino')===payload.value.code){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn('La ubicacion '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{trayecto=trayecto.toJS();trayecto.destino=payload.value.code;trayecto.aeropuerto_destino=payload.value.name+' '+query.toUpperCase();payload.value=trayecto;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["C" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1 */],payload:payload});}};}function activateVersion(viaje_id){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud_id=getState().tiquetesaereo.getIn(['solicitud','id']);axios.post(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/activate-version/'+solicitud_id,{viaje_id:viaje_id}).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_311" /* OBTENER_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);}).finally(function(){return dispatch(displayModalSelectVersion(false));});};}function addTrayecto(){return{type:__WEBPACK_IMPORTED_MODULE_6__types__["_18" /* ADICIONAR_TRAYECTO1 */]};}function removeTrayectos(){return{type:__WEBPACK_IMPORTED_MODULE_6__types__["_357" /* REMOVER_TRAYECTOS1 */]};}function addCencoSolicitud(){return{type:__WEBPACK_IMPORTED_MODULE_6__types__["_5" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1 */]};}function removeCenco(){return{type:__WEBPACK_IMPORTED_MODULE_6__types__["_349" /* REMOVER_CENCOS_TIQUETESAEREOS1 */]};}function addPasajero(payload){return function(dispatch,getState){var path=payload.path.split('.');var pasajero=getState().tiquetesaereo.getIn(path);if(pasajero.get('id')===payload.value.id){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn('La persona '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{pasajero=pasajero.toJS();pasajero=Object.assign({},pasajero,payload.value);pasajero.correo=pasajero.email;pasajero.cedula=pasajero.username;payload.value=pasajero;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["C" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1 */],payload:payload});}};}function addOrEditCotizacion(){return function(dispatch,getState){var cotizacion=getState().tiquetesaereo.getIn(['modalAddCotizacion','data']);var errors=validateCotizacion(cotizacion);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var data=getState().tiquetesaereo.getIn(['modalAddCotizacion','data']).set('fecha_entrega',__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')).set('estado',4);var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["o" /* ADICIONAR_COTIZACION_TIQUETESAEREO */],payload:{data:data}});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_233" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO */],payload:{show:false}});};fn0(dispatch);fn1(dispatch);}};}function editPasajero(index){return function(dispatch,getState){var data=getState().tiquetesaereo.getIn(['modalAddTiquete','data']);var errors=validateTiquete(data);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_228" /* MODIFICAR_TIQUETE */],payload:{index:index,data:data}});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_237" /* MOSTRAR_MODAL_ADICIONAR_TIQUETE */],payload:{show:false}});};fn0(dispatch);fn1(dispatch);}};}function editAsistencia(index){return function(dispatch,getState){var data=getState().tiquetesaereo.getIn(['modalAddAsistencia','data']);var errors=validateAsistencia(data);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_182" /* MODIFICAR_ASISTENCIA */],payload:{index:index,data:data}});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_231" /* MOSTRAR_MODAL_ADICIONAR_ASISTENCIA */],payload:{show:false}});};fn0(dispatch);fn1(dispatch);}};}function updateTravel(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_109" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_109" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO */],payload:false});};fn0(dispatch);var solicitud_id=getState().tiquetesaereo.get('id');var solicitudNew=getState().tiquetesaereo.get('solicitud');var solicitudOld=getState().tiquetesaereo.get('unchaged');var files=[];var errors=validateSolicitud(solicitudNew);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=addModificaciones(solicitudNew,solicitudOld);var esModPasajero=modificaciones.filter(function(x){return x["entity"]==="Pasajero";}).length;if(esModPasajero){files=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* attachFilesToEntity */])("Pasajero",solicitudNew.getIn(['viaje','pasajeros']));}if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["u" /* getModificaciones */])(solicitudNew,solicitudOld,'Solicitude',switchDocumento)==0){fn1(dispatch);return false;}axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/update-travel/'+solicitud_id,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_7__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__common__["F" /* uploadFiles */])('/solicitudes/tiquetes-aereos/uploadPassport/'+solicitud_id,files,[fn2,fn3,fn4]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function updateTiquetesAereo(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_109" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_109" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO */],payload:false});};fn0(dispatch);var solicitud=getState().tiquetesaereo.get('id');var solicitudNew=getState().tiquetesaereo.get('solicitud');var solicitudOld=getState().tiquetesaereo.get('unchaged');var files=[];files=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* attachFilesToEntity */])('Cotizacione',solicitudNew.get('cotizaciones'));var errors=validateSolicitud(solicitudNew);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["u" /* getModificaciones */])(solicitudNew,solicitudOld,'Solicitude',switchDocumento);axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_7__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn2,fn3,fn4]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function seleccionarAprobacion(indexAprobador,indexAprobacion){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_362" /* SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO */],payload:{indexAprobador:indexAprobador,indexAprobacion:indexAprobacion}});};}function registerApprovalResult(aprobaciones,result){var ip=__webpack_require__(79);var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().tiquetesaereo.get('solicitud');var errors=result>0?validateAprobacion(aprobaciones,result):validateAprobacion(aprobaciones.first().get('observaciones'),result);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];aprobaciones.map(function(a){modificaciones.push({id:a.get('id'),entity:'Aprobacione',value:{estado:result>0?a.get('estado')==1?0:a.get('estado'):0,ip:ip.address(),observaciones:aprobaciones.first().get('observaciones')},action:'edit'});});var disCencos=solicitud.getIn(['viaje','cencos']);disCencos.map(function(c){if(c.getIn(['pivot','rubro_id'])){modificaciones.push({id:c.getIn(['pivot','id']),entity:'DisCencoViaje',value:{rubro_id:c.getIn(['pivot','rubro_id'])},action:'edit'});}});axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn0(dispatch);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido guardada exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});}};}function registerTiquetes(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().tiquetesaereo.get('solicitud');var modificaciones=[];var files=void 0;var tiquetes=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List();var pasajeros=solicitud.getIn(['viaje','pasajeros']);var errors=validateTiquetes(pasajeros);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{pasajeros.map(function(p){tiquetes=tiquetes.push(p.get('tiquete'));p=p.deleteIn(['tiquete','adjunto']);modificaciones.push({id:p.getIn(['tiquete','id']),entity:'Tiquete',value:p.get('tiquete'),action:'edit'});p.getIn(['tiquete','itinerarios']).map(function(i){modificaciones.push({id:i.get('id'),entity:'Itinerario',value:i,action:'edit'});});});files=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* attachFilesToEntity */])('Tiquete',tiquetes);axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_7__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn2,fn3,fn4]));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});}};}function registerAsistencias(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().tiquetesaereo.get('solicitud');var modificaciones=[];var files=void 0;var asistencias=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List();var pasajeros=solicitud.getIn(['viaje','pasajeros']);var errors=validateAsistencias(pasajeros);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{pasajeros.map(function(p){asistencias=asistencias.push(p.get('asistencia'));p=p.deleteIn(['asistencia','adjunto']);modificaciones.push({id:p.getIn(['asistencia','id']),entity:'PasajeroAsistencia',value:p.get('asistencia'),action:'edit'});});files=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["g" /* attachFilesToEntity */])('PasajeroAsistencia',asistencias);axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_7__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn2,fn3,fn4]));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});}};}function registerTiquetesExpirados(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().tiquetesaereo.get('solicitud');var itinerarios=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List();//const hoy = new Date(2019, 5, 15)
var hoy=new Date();solicitud.getIn(['viaje','pasajeros']).map(function(p){p.getIn(['tiquete','itinerarios']).filter(function(i){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(i.get('fecha_salida'))<__WEBPACK_IMPORTED_MODULE_1_moment___default()(hoy);}).map(function(x){itinerarios=itinerarios.push(x.set('numero_tiquete',p.getIn(['tiquete','numero_tiquete'])));});});var errors=validateTiquetesExpirados(itinerarios);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];itinerarios.map(function(i){modificaciones.push({id:i.get('id'),entity:'Itinerario',value:{cumplido:i.get('cumplido'),observaciones:i.get('observaciones')},action:'edit'});});axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});}};}function registerCancelacion(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){//const solicitud = getState().solicitudhoteles.get('solicitud').set('estado', 0)
var solicitud=getState().tiquetesaereo.get('solicitud');var errors=validateSolicitud(solicitud,{cancelar:true});if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{motivo_cancelacion:solicitud.get('motivo_cancelacion'),fecha_cancelacion:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')},action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});}};}function descargarAsistencia(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().tiquetesaereo.get('solicitud');axios.get(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/asistencia/descargar/'+solicitud.get('id'),{responseType:'arraybuffer'}).then(function(res){__WEBPACK_IMPORTED_MODULE_3_react_file_download___default()(res.data,'asistencia_'+solicitud.get('id')+'.pdf');}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});};}function enviarComentario(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud_id=getState().tiquetesaereo.getIn(['solicitud','id']);var usuario_id=getState().common.getIn(['user','id']);var id=getState().tiquetesaereo.getIn(['comentario','id']);var comentario=getState().tiquetesaereo.getIn(['comentario','texto']);var modificaciones=[];if(id==null){modificaciones.push({entity:'Foro',action:'add',id:null,value:{solicitud_id:solicitud_id,usuario_id:usuario_id,comentario:comentario}});}else{modificaciones.push({id:id,entity:'Foro',value:{comentario:comentario},action:'edit'});}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_89" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1 */],payload:true});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_89" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1 */],payload:false});};fn1(dispatch);axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud_id,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_164" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1 */],payload:{foros:foros}});};fn3(dispatch);fn2(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);fn2(dispatch);});};}function editarComentario(id){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_120" /* EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1 */],payload:{id:id}});};fn1(dispatch);};}function eliminarComentario(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().tiquetesaereo.getIn(['solicitud','id']);var modificaciones=[];modificaciones.push({entity:'Foro',id:id,action:'delete',value:null});axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_164" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1 */],payload:{foros:foros}});};fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,{success:'Las eliminaciones han sido realizadas exitosamente'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});};}///******* Shared ********///
var validateSolicitud=function validateSolicitud(data){var extra=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errors=[];if(extra&&extra.cancelar&&!data.get('motivo_cancelacion'))errors.push('El campo motivo cancelación es obligatorio');return errors;};var validateCotizacion=function validateCotizacion(data){var errors=[];if(!data.get('descripcion'))errors.push('El campo aerolínea es obligatorio');if(!data.get('cotizado')||data.get('cotizado')<=0)errors.push('El campo valor cotizado es obligatorio');if(!data.getIn(['adjunto','file']))errors.push('El campo pantallazo cotización es obligatorio');return errors;};// const validateAprobacion = (data) => {
// 	const errors = []
// 	if (data && data.get('estado') == 2 && !data.get('selected')) errors.push('Debe seleccionar una cotización para aprobar')
// 	if (data && data.get('estado') == 0 && !data.get('observaciones')) errors.push('El campo observaciones es obligatorio')
// 	return errors
// }
var validateAprobacion=function validateAprobacion(data,extra){var errors=[];if(extra==2&&data.filter(function(x){return x.get('estado')==2;}).count()==0)errors.push('Debe seleccionar una cotización para aprobar');if(extra==2&&data.filter(function(x){return x.get('estado')==2;}).count()>1)errors.push('Sólo xdbe seleccionar una cotización para aprobar');if(extra==0&&!data)errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones');return errors;};var validateTiquete=function validateTiquete(data){var errors=[];if(!data.getIn(['tiquete','aerolinea']))errors.push('El campo aerolínea es obligatorio');if(!data.getIn(['tiquete','numero_tiquete']))errors.push('El campo número tiquete es obligatorio');if(!data.getIn(['tiquete','fecha_compra']))errors.push('El campo fecha de compra es obligatorio');if(!data.getIn(['tiquete','valor_pagado']))errors.push('El campo valor es obligatorio');if(!data.getIn(['tiquete','adjunto','file']))errors.push('El campo tiquete es obligatorio');var tipo_trayecto=data.getIn(['viaje','tipo_trayecto']);data.getIn(['tiquete','itinerarios']).map(function(i){if(i.get('fecha_salida').split(" ")[0]=="")errors.push('El campo fecha salida es obligatorio');if(i.get('fecha_salida').split(" ")[1]=="")errors.push('El campo hora salida es obligatorio');if(tipo_trayecto==1){if(i.get('fecha_llegada').split(" ")[0]=="")errors.push('El campo fecha llegada es obligatorio');if(i.get('fecha_llegada').split(" ")[1]=="")errors.push('El campo hora llegada es obligatorio');}});if(data.getIn(['tiquete','fecha_compra'])&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.getIn(['tiquete','fecha_compra']))>__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()))errors.push('La fecha de compra debe ser menor o igual a la fecha actual');return errors;};var validateAsistencia=function validateAsistencia(data){var errors=[];if(!data.getIn(['asistencia','numero_voucher']))errors.push('El campo número voucher es obligatorio');if(!data.getIn(['asistencia','fecha_compra']))errors.push('El campo fecha de compra es obligatorio');if(!data.getIn(['asistencia','valor']))errors.push('El campo valor es obligatorio');if(!data.getIn(['asistencia','adjunto','id'])&&!data.getIn(['asistencia','adjunto','file']))errors.push('El campo voucher es obligatorio');if(data.getIn(['asistencia','fecha_compra'])&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.getIn(['asistencia','fecha_compra']))>__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()))errors.push('La fecha de compra debe ser menor o igual a la fecha actual');return errors;};var validateTiquetes=function validateTiquetes(data){var errors=[];data.map(function(p,i){if(validateTiquete(p).length>0){errors.push('Faltan datos en pasajero No. '+(i+1));}});return errors;};var validateAsistencias=function validateAsistencias(data){var errors=[];data.map(function(p,i){var validaciones=validateAsistencia(p);if(validaciones.length>0){errors.push('Faltan datos en pasajero No. '+(i+1));}});return errors;};var validateTiquetesExpirados=function validateTiquetesExpirados(data){var errors=[];data.map(function(t){if(t.get('cumplido')==null)errors.push('El campo cumplido es obligatorio en el tiquete No. '+t.get('numero_tiquete'));if(t.get('cumplido')==0&&!t.get('observaciones'))errors.push('El campo observaciones es obligatorio en el tiquete No. '+t.get('numero_tiquete'));});return errors;};var switchDocumento=function switchDocumento(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];if(modificacion.attribute==='responsable_compras'){modificacion.action='hidden';}switch(change.get('op')){case'add':if(modificacion.attribute==='cotizaciones'){modificacion.action='create';}if(modificacion.attribute==='adjunto'){modificacion.action='hidden';}if(modificacion.attribute==='viaje'){modificacion.action='hidden';}break;case'replace':if(modificacion.attribute==='viaje'){modificacion.action='hidden';}break;case'remove':if(modificacion.attribute==='cotizaciones'){modificacion.action='detach';}break;}};var switchEditSolicitud=function switchEditSolicitud(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];if(modificacion.attribute==='responsable_compras'){modificacion.action='hidden';}switch(change.get('op')){case'add':if(modificacion.attribute==='cotizaciones'){modificacion.action='hidden';}if(modificacion.attribute==='adjunto'){modificacion.action='hidden';}if(modificacion.attribute==='viaje'){modificacion.action='hidden';}break;case'replace':if(modificacion.attribute==='viaje'){modificacion.action='hidden';}break;case'remove':if(modificacion.attribute==='cotizaciones'){modificacion.action='hidden';}break;}};var switchViaje=function switchViaje(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];switch(change.get('op')){case'add':if(modificacion.attribute==='cencos'){modificacion.action='hidden';}if(modificacion.attribute==='trayectos'){modificacion.action='hidden';}if(modificacion.attribute==='pasajeros'){modificacion.action='hidden';}if(modificacion.attribute==='tiquetes'){modificacion.action='hidden';}break;case'replace':if(modificacion.attribute==='cencos'){modificacion.action='hidden';}if(modificacion.attribute==='trayectos'){modificacion.action='hidden';}if(modificacion.attribute==='pasajeros'){modificacion.action='hidden';}if(modificacion.attribute==='tiquetes'){modificacion.action='hidden';}break;case'remove':break;}};var addModificaciones=function addModificaciones(solicitud,unchaged){var modificaciones=[];solicitud.set('created_at',__WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD HH:ii:ss"));modificaciones=[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["u" /* getModificaciones */])(solicitud,unchaged,'Solicitude',switchEditSolicitud)));var modificacionesViajes=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["u" /* getModificaciones */])(solicitud.get('viaje'),unchaged.get('viaje'),'Viaje',switchViaje);modificaciones=[].concat(_toConsumableArray(modificaciones),_toConsumableArray(modificacionesViajes));solicitud.getIn(["viaje","cencos"]).valueSeq().forEach(function(c){modificaciones=[].concat(_toConsumableArray(modificaciones),[{entity:"DisCencoViaje",value:{viaje_id:solicitud.getIn(['viaje','id']),cenco_id:c.get('id'),porcentaje:c.getIn(["pivot","porcentaje"])},action:'add'}]);});solicitud.getIn(["viaje","trayectos"]).valueSeq().forEach(function(t){modificaciones=[].concat(_toConsumableArray(modificaciones),[{entity:"Trayecto",value:{viaje_id:solicitud.getIn(['viaje','id']),origen:t.get('origen'),aeropuerto_origen:t.get('aeropuerto_origen'),fecha_ida:t.get('fecha_ida')&&t.get('fecha_ida')!="0000-00-00 00:00:00"&&t.get('hora_ida')?__WEBPACK_IMPORTED_MODULE_1_moment___default()(t.get('fecha_ida')).format("YYYY-MM-DD")+' '+t.get('hora_ida'):"",destino:t.get('destino'),aeropuerto_destino:t.get('aeropuerto_destino'),fecha_regreso:t.get('fecha_regreso')&&t.get('fecha_regreso')!="0000-00-00 00:00:00"&&t.get('hora_regreso')?__WEBPACK_IMPORTED_MODULE_1_moment___default()(t.get('fecha_regreso')).format("YYYY-MM-DD")+' '+t.get('hora_regreso'):""},id:null,action:"add"}]);});solicitud.getIn(["viaje","pasajeros"]).valueSeq().forEach(function(p){modificaciones=[].concat(_toConsumableArray(modificaciones),[{entity:"Pasajero",value:{tipo_pasajero:p.get('tipo_pasajero'),nombres:p.get('nombres'),apellidos:p.get('apellidos'),cedula:p.get('cedula'),correo:p.get('correo'),fecha_nacimiento:p.get('fecha_nacimiento'),celular:p.get('celular'),pasaporte:p.get('pasaporte'),pasaporte_adjunto:p.get('pasaporte_adjunto'),nacionalidad:p.get('nacionalidad'),pais_expedicion:p.get('pais_expedicion'),fecha_caducidad_pasaporte:p.get('fecha_caducidad_pasaporte'),viaje_id:solicitud.getIn(['viaje','id']),guid:p.get('guid'),asistencia:p.get('asistencia'),tipo_documento:p.get('tipo_documento')},id:"",action:"add"}]);});return modificaciones;};function removeSolicitudTiqutesAereos(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_129" /* ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO */]});};}function addFileAdjunto(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["X" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1 */],payload:data});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}function crearAprobacionAdicional(aprobador,motivo){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var errors=validarSolicitudAprobacionAdicional(aprobador,motivo);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});return;}var solicitud=getState().tiquetesaereo.get('solicitud');var cotizaciones=solicitud.get('cotizaciones');var modificaciones=[];if(cotizaciones&&cotizaciones.size>0){cotizaciones.forEach(function(cotizacion){modificaciones.push({id:null,entity:'Aprobacione',action:'add',value:{cotizacion_id:cotizacion.get('id'),aprobador_id:aprobador.id,estado:1,// Pendiente de aprobación
observaciones:motivo,tipo:3}});});}axios.put(__WEBPACK_IMPORTED_MODULE_5____["b" /* API_URL */]+'/solicitudes/tiquetes-aereos/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_311" /* OBTENER_SOLICITUD_TIQUETESAEREO */],payload:{solicitud:solicitud,aprobadores:aprobadores}});__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Solicitud de aprobación adicional enviada correctamente',{bodyClassName:'toastify-content toastify-success'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_8__common__["f" /* displayMessages */])(dispatch,err);});};}var validarSolicitudAprobacionAdicional=function validarSolicitudAprobacionAdicional(aprobador,motivo){var errors=[];if(!aprobador||!aprobador.id)errors.push('Debe seleccionar un aprobador adicional');if(!motivo||!motivo.trim())errors.push('El motivo de la solicitud adicional es obligatorio');return errors;};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(180)('wks');
var uid = __webpack_require__(135);
var Symbol = __webpack_require__(59).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initReducer */
/* harmony export (immutable) */ __webpack_exports__["k"] = getSolicitud;
/* harmony export (immutable) */ __webpack_exports__["m"] = registerApprovalResult;
/* harmony export (immutable) */ __webpack_exports__["d"] = crearAprobacionAdicional;
/* harmony export (immutable) */ __webpack_exports__["g"] = displayModalCreateDocumento;
/* harmony export (immutable) */ __webpack_exports__["u"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["t"] = seleccionarProveedor;
/* harmony export (immutable) */ __webpack_exports__["f"] = displayModalAddServicio;
/* harmony export (immutable) */ __webpack_exports__["c"] = addSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = addGarantia;
/* harmony export (immutable) */ __webpack_exports__["e"] = createOrUpdateDocumento;
/* harmony export (immutable) */ __webpack_exports__["n"] = registerCancelacion;
/* harmony export (immutable) */ __webpack_exports__["q"] = resetAIU;
/* harmony export (immutable) */ __webpack_exports__["r"] = resetIVA;
/* harmony export (immutable) */ __webpack_exports__["a"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["o"] = removeFiles;
/* harmony export (immutable) */ __webpack_exports__["l"] = previewDocumento;
/* harmony export (immutable) */ __webpack_exports__["v"] = updateSolicitud;
/* harmony export (immutable) */ __webpack_exports__["p"] = removeSolicitudServicioItems;
/* harmony export (immutable) */ __webpack_exports__["s"] = seleccionarMoneda;
/* harmony export (immutable) */ __webpack_exports__["j"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["h"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["i"] = eliminarComentario;
/* unused harmony export validarSolicitudAprobacionAdicional */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_file_download__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__otrosi__ = __webpack_require__(69);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_342" /* REINICIAR_SOLICITUD_SERVICIO_OT1 */]});};}function getSolicitud(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+id).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_310" /* OBTENER_SOLICITUD_SERVICIO_OT */],payload:{solicitud:solicitud,aprobadores:aprobadores}});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function registerApprovalResult(index,result){var ip=__webpack_require__(79);var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudservicioot.get('solicitud');var modificaciones=[];var aprobacion=solicitud.getIn(['cotizaciones','0','aprobaciones',String(index)]);modificaciones.push({id:aprobacion.get('id'),entity:'Aprobacione',value:{estado:result,ip:ip.address(),observaciones:aprobacion.get('observaciones')},action:'edit'});var errors=[];solicitud.get('servicios').valueSeq().forEach(function(servicio){return servicio.get('cencos').valueSeq().forEach(function(cenco){if(modificaciones[0].value.estado!==0&&cenco.get('rubros').count()>0){if(cenco.getIn(['pivot','rubro_id'])){modificaciones.push({id:cenco.getIn(['pivot','id']),entity:'DisCencoServicio',value:{rubro_id:cenco.getIn(['pivot','rubro_id'])},action:'edit'});}}});});if(modificaciones[0].value.estado===0&&!modificaciones[0].value.observaciones){errors.push('Deben existir observaciones si va a rechazar esta aprobación');}if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_82" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT */],payload:true});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;if(solicitud.estado===0){__WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido anulada'});}else{if(solicitud.documento_origen){var fn1=function fn1(d){return d(Object(__WEBPACK_IMPORTED_MODULE_8__otrosi__["b" /* getSolicitud */])(solicitud.id));};fn1(dispatch);}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["h" /* ACTUALIZAR_SOLICITUD_SERVICIO_OT */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn0(dispatch);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido guardada exitosamente'});dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_82" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT */],payload:false});}}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_82" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT */],payload:false});});}};}function crearAprobacionAdicional(aprobador,motivo){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var errors=validarSolicitudAprobacionAdicional(aprobador,motivo);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});return;}var solicitud=getState().solicitudservicioot.get('solicitud');var cotizacion=solicitud.getIn(['cotizaciones','0']);var modificaciones=[];modificaciones.push({id:null,entity:'Aprobacione',action:'add',value:{cotizacion_id:cotizacion.get('id'),aprobador_id:aprobador.id,estado:1,// Pendiente de aprobación
observaciones:motivo,tipo:3}});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+solicitud.get('id'),modificaciones).then(function(res){dispatch(getSolicitud(solicitud.get('id')));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function displayModalCreateDocumento(show,title,mode,indexDocumento){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var proveedor=getState().solicitudservicioot.getIn(['solicitud','documentos',indexDocumento,'proveedor_id']);var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/plantillas');};var fn1=function fn1(){return axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/garantias');};var fn2=function fn2(){return axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/documentos/contratos-anuales',{params:{proveedor:proveedor}});};Promise.all([fn0(),fn1(),fn2()]).then(function(res){var plantillas=res[0].data.data;var garantias=res[1].data.data;var contratos=res[2].data;dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_261" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT */],payload:{show:show,title:title,mode:mode,indexDocumento:indexDocumento,plantillas:plantillas,garantias:garantias,contratos:contratos}});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function updateInputs(path,value){var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var immutable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_219" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1 */],payload:{path:path,value:value,immutable:immutable}});};fn0(dispatch);var pathArray=path.split('.');var entity=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["n" /* esEntero */])(pathArray.slice(-2)[0])?pathArray.slice(-3)[0]:pathArray.slice(-2)[0];var attribute=pathArray.slice(-2)[1];switch(entity){case'solicitud':entity='Solicitude';break;case'servicios':entity='Servicio';break;}if(id){var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["M" /* ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT */],payload:{id:id,entity:entity,attribute:attribute,value:value,action:'edit'}});};fn2(dispatch);}};}function seleccionarProveedor(payload){return function(dispatch){dispatch(updateInputs(payload.path,payload.value,payload.value.id));};}function displayModalAddServicio(show,title,mode,index){return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_245" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_317" /* OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 */]});}};}function addSolicitudServicioItem(){return function(dispatch,getState){var data=getState().solicitudservicioot.getIn(['modalAddServicio','data']);var errors=[];if(!data.get('descripcion'))errors.push('La creación de servicios requiere de una descripción');if(data.get('cotizado')<0)errors.push('La creación de servicios requiere que el valor del servicio sin IVA sea superior a 0');if(data.get('cotizado_iva')<0)errors.push('La creación de servicios requiere que el valor total sea superior a 0');if(Number(data.get('cotizado_iva'))<Number(data.get('cotizado')))errors.push('El valor total debe ser igual o superior al valor sin IVA');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_14" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1 */]});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_317" /* OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 */]});};var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["M" /* ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT */],payload:{id:getState().solicitudservicioot.get('id'),entity:'Solicitud',attribute:'servicios',value:'array',action:'edit'}});};fn1(dispatch);fn2(dispatch);fn3(dispatch);}};}function addGarantia(checked,index,id){return function(dispatch){if(checked){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["G" /* ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT */],payload:index});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_354" /* REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT */],payload:id});}};}function createOrUpdateDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_102" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT */],payload:true});};//No aparece en actions creators
var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_102" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT */],payload:false});};fn0(dispatch);var fn3=function fn3(d){return d(displayModalCreateDocumento(false));};var solicitud=getState().solicitudservicioot.get('id');var data=getState().solicitudservicioot.get('modalCreateDocumento');var documentoNew=data.get('data');var documentoOld=data.get('unchanged');var tipoDocumento=documentoNew.get('tipo');if(tipoDocumento==1||tipoDocumento==3){documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'));}if(tipoDocumento==4){var fecha_inicio=getState().solicitudservicioot.getIn(['solicitud','documento_origen','fecha_inicio']);documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_5_moment___default()(fecha_inicio).format('YYYY-MM-DD'));}var errors=validateDocumento(documentoNew,data.get('contratoanual'));if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});fn1(dispatch);}else{documentoOld=documentoOld.set('garantias',Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["D" /* indexBy */])(documentoOld.get('garantias'),'id'));documentoNew=documentoNew.set('garantias',Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["D" /* indexBy */])(documentoNew.get('garantias'),'id'));var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["u" /* getModificaciones */])(documentoNew,documentoOld,'Documento',switchDocumento);var mode=getState().solicitudservicioot.getIn(['modalCreateDocumento','mode']);if(mode==='create'){}else if(mode==='edit'){modificaciones.push({id:getState().solicitudservicioot.get('id'),entity:'Solicitude',attribute:'fecha_requerido',value:documentoNew.get('fecha_entrega'),action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+solicitud,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["h" /* ACTUALIZAR_SOLICITUD_SERVICIO_OT */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn1(dispatch);fn2(dispatch);fn3(dispatch);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}}};}function registerCancelacion(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudservicioot.get('solicitud').set('estado',0);var errors=validateSolicitud(solicitud);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{estado:0,motivo_cancelacion:solicitud.get('motivo_cancelacion'),fecha_cancelacion:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')},action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["h" /* ACTUALIZAR_SOLICITUD_SERVICIO_OT */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();if(solicitud.documento_origen){var fn2=function fn2(d){return d(Object(__WEBPACK_IMPORTED_MODULE_8__otrosi__["b" /* getSolicitud */])(solicitud.id));};fn2(dispatch);}}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});}};}function resetAIU(){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["_344" /* REINICIAR_VALORES_AIU */]};}function resetIVA(){return{type:__WEBPACK_IMPORTED_MODULE_3__types__["_345" /* REINICIAR_VALORES_IVA */]};}function addFile(url,actions){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var files=[data];dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__common__["F" /* uploadFiles */])(url,files,actions));};}function removeFiles(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fns=[];var selectedFiles=getState().solicitudservicioot.getIn(['solicitud','adjuntos']).filter(function(a){return a.get('id')&&a.get('selected');}).map(function(a){fns.push(function(){return axios.delete(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/files/'+a.get('id'));});});Promise.all(fns.map(function(x){return x();})).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_128" /* ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1 */]});Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function previewDocumento(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var documento=getState().solicitudservicioot.getIn(['modalCreateDocumento','data']);var tipo=getState().common.getIn(['enums','documentos','tipos',''+documento.get('tipo'),'NOMBRE']);axios.post(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/view/'+id,{documento:documento},{responseType:'arraybuffer'}).then(function(res){__WEBPACK_IMPORTED_MODULE_7_react_file_download___default()(res.data,'PREV-'+tipo+'.pdf');}).catch(function(err){var decodedString=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(err.response.data)));var obj={response:{data:decodedString,status:422}};Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,obj);});};}var switchForo=function switchForo(change,modificacion,foros){switch(change.get('op')){case'add':delete modificacion.attribute;delete modificacion.value.usuario;break;case'replace':modificacion.action='edit';modificacion.attribute=modificacion.attribute[1];break;}};function updateSolicitud(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){// const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: true })
// const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO, payload: false })
// fn0(dispatch)
var id=getState().solicitudservicioot.get('id');var solicitud=getState().solicitudservicioot.get('solicitud');var unchaged=getState().solicitudservicioot.get('unchaged');var modificar=getState().solicitudservicioot.get('addModificacion');//const errors = validateSolicitud(solicitud)
var errors=[];if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];if(modificar){modificaciones=addModificacion(solicitud);}axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+id,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["h" /* ACTUALIZAR_SOLICITUD_SERVICIO_OT */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn2(dispatch);fn3();fn4();}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);//fn1(dispatch)
});}};}function removeSolicitudServicioItems(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudservicioot.getIn(['solicitud','id']);var servicios=getState().solicitudservicioot.getIn(['solicitud','servicios']).filter(function(x){return x.get('id')&&x.get('selected');});var modificaciones=[];servicios.valueSeq().forEach(function(servicio){var cencos=servicio.get('cencos');cencos.valueSeq().forEach(function(c){modificaciones.push({entity:'DisCencoServicio',id:c.getIn(['pivot','id']),action:'delete'});});modificaciones.push({entity:'Servicio',id:servicio.get('id'),action:'delete'});});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+solicitud,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["h" /* ACTUALIZAR_SOLICITUD_SERVICIO_OT */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'La eliminacion han sido realizada exitosamente'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function seleccionarMoneda(){var moneda=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'COP';return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_367" /* SELECCIONAR_MONEDA_SOLICITUD_OT1 */],payload:{moneda:moneda}});};fn1(dispatch);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["M" /* ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT */],payload:{id:0,entity:'Cotizacione',attribute:'moneda',value:moneda,action:'edit'}});};fn2(dispatch);};}function enviarComentario(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud_id=getState().solicitudservicioot.getIn(['solicitud','id']);var usuario_id=getState().common.getIn(['user','id']);var id=getState().solicitudservicioot.getIn(['comentario','id']);var comentario=getState().solicitudservicioot.getIn(['comentario','texto']);var modificaciones=[];if(id==null){modificaciones.push({entity:'Foro',action:'add',id:null,value:{solicitud_id:solicitud_id,usuario_id:usuario_id,comentario:comentario}});}else{modificaciones.push({id:id,entity:'Foro',value:{comentario:comentario},action:'edit'});}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_87" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1 */],payload:true});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_87" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1 */],payload:false});};fn1(dispatch);axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+solicitud_id,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_162" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1 */],payload:{foros:foros}});};fn3(dispatch);fn2(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);fn2(dispatch);});};}function editarComentario(id){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_116" /* EDITAR_COMENTARIO_SOLICITUD_OT1 */],payload:{id:id}});};fn1(dispatch);};}function eliminarComentario(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudservicioot.getIn(['solicitud','id']);var modificaciones=[];modificaciones.push({entity:'Foro',id:id,action:'delete'});axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica/'+solicitud,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_162" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1 */],payload:{foros:foros}});};fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,{success:'La eliminacion han sido realizadas exitosamente'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}///******* Shared ********///
var validateSolicitud=function validateSolicitud(data){var errors=[];if(data.get('estado')==0&&!data.get('motivo_cancelacion'))errors.push('El campo motivo cancelación es obligatorio');return errors;};var validateDocumento=function validateDocumento(data){var escontratoanual=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var errors=[];if(Number(data.get('tipo'))===0)errors.push('El campo tipo de documento es obligatorio');if(data.get('tipo')==2&&!data.get('fecha_inicio'))errors.push('El campo fecha inicio es obligatorio');if(!data.get('fecha_entrega'))errors.push('El campo fecha entrega es obligatorio');if(data.get('tipo')==2&&data.get('fecha_inicio')){if(__WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1,'day').isAfter(data.get('fecha_inicio')))errors.push('La fecha de inicio no debe ser inferior a hoy');}if(data.get('tipo')==2&&data.get('fecha_inicio')&&data.get('fecha_entrega')){if(__WEBPACK_IMPORTED_MODULE_5_moment___default()(data.get('fecha_inicio')).isAfter(data.get('fecha_entrega')))errors.push('La fecha entrega no debe ser inferior a la fecha de inicio');}if(data.get('tipo')!=4&&Number(data.get('plantilla_id'))===0)errors.push('El campo plantilla es obligatorio');if(Number(data.get('anticipo'))>50)errors.push('El anticipo no debe ser superior al 50%');if(Number(data.get('anticipo'))>0&&!data.get('pago_anticipo'))errors.push('La fecha de pago de anticipo es obligatioria si hay anticipo');if(Number(data.get('anticipo'))>0&&!data.get('forma_pago_anticipo'))errors.push('La forma de pago de anticipo es obligatioria si hay anticipo');if(escontratoanual){if(Number(data.get('documento_id'))===0)errors.push('El campo número de contrato es obligatorio');}var margen_err=1;var iva_input=parseFloat(Number(data.getIn(['cotizacion','cotizado_iva'])).toFixed(2));var valor=parseFloat(Number(data.get('aiu_total')).toFixed(2));//No borrar.
// if (data.get('iva') == 0 && data.getIn(['cotizacion', 'cotizado_iva']) !== data.get('aiu_total') && data.get('tipo') != 4) {
// 	errors.push('El valor total de los servicios es diferente al valor total del AIU')
// }
//No borrar.
// if (data.get('iva') != 0 && data.getIn(['cotizacion', 'cotizado_iva']) !== data.get('aiu_total') && data.get('tipo') != 4) {
// 	errors.push('El valor total de los servicios es diferente al valor total del IVA')
// }
//Lo mando a quitar Oscar el dia 12/07/2019 via Skype
// if (data.get('iva') != 0 && data.get('tipo') != 4) {
// 	if ( iva_input < valor - 1 || iva_input > valor + 1) errors.push('El valor total de los servicios es diferente al valor total del IVA')		
// }
//Lo mando a quitar Oscar el dia 12/07/2019 via Skype
// if (data.get('iva') == 0 && data.get('tipo') != 4) {
// 	if ( iva_input < valor - 1 || iva_input > valor + 1) errors.push('El valor total de los servicios es diferente al valor total del AIU')
// }
if(!data.get('almacen')){errors.push('El campo Almacén es obligatorio');}return errors;};var validarSolicitudAprobacionAdicional=function validarSolicitudAprobacionAdicional(aprobador,motivo){var errors=[];if(!aprobador||!aprobador.id)errors.push('Debe seleccionar un aprobador adicional');if(!motivo||!motivo.trim())errors.push('El motivo de la solicitud adicional es obligatorio');return errors;};var switchDocumento=function switchDocumento(change,modificacion,documento){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];switch(modificacion.attribute){case'aiu_administracion_value':case'aiu_imprevistos_value':case'aiu_utilidad_value':case'aiu_iva_utilidad_value':case'iva_value':case'aiu_total':case'todos_detalles':modificacion.action='hidden';break;}switch(change.get('op')){case'add':if(modificacion.attribute==='garantias'){modificacion.value=modificacion.value.id;modificacion.action='attach';}break;case'replace':if(modificacion.attribute==='cotizacion'){modificacion.entity='Cotizacione';modificacion.id=documento.getIn(['cotizacion','id']);if(path[1]=='cotizado_iva'){modificacion.attribute='cotizado_iva';modificacion.value=documento.getIn(['cotizacion','cotizado_iva']);}}break;case'remove':if(modificacion.attribute==='garantias'){modificacion.action='detach';}break;}};var addModificacion=function addModificacion(solicitud){var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{proyecto_evento:solicitud.get('proyecto_evento'),fecha_requerido:solicitud.get('fecha_requerido')},action:'edit'});if(solicitud.get('cotizaciones')){for(var idx=0;idx<solicitud.get('cotizaciones').count();idx++){modificaciones.push({id:solicitud.getIn(['cotizaciones',idx,'id']),entity:'Cotizacione',value:{proveedor_id:solicitud.getIn(['cotizaciones',0,'proveedore','id']),moneda:solicitud.getIn(['cotizaciones',0,'moneda'])},action:'edit'});}}solicitud.get('servicios').valueSeq().forEach(function(servicio){if(servicio.get('id')){modificaciones.push({id:servicio.get('id'),entity:'Servicio',value:{descripcion:servicio.get('descripcion'),valor:servicio.get('valor'),valor_con_iva:servicio.get('valor_con_iva')},action:'edit'});}else{modificaciones.push({entity:'Servicio',value:{descripcion:servicio.get('descripcion'),valor:servicio.get('valor'),valor_con_iva:servicio.get('valor_con_iva'),cantidad:1,solicitud_id:solicitud.get('id'),estado:1},action:'add'});}});return modificaciones;};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["r"] = getSolicitud;
/* harmony export (immutable) */ __webpack_exports__["C"] = seleccionarMoneda;
/* harmony export (immutable) */ __webpack_exports__["G"] = updateSolicitudBI;
/* harmony export (immutable) */ __webpack_exports__["c"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["w"] = removeFiles;
/* harmony export (immutable) */ __webpack_exports__["D"] = toggleAllCotizacion;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCotizacion;
/* harmony export (immutable) */ __webpack_exports__["g"] = addProveedorCotizacion;
/* harmony export (immutable) */ __webpack_exports__["y"] = removeProveedorCotizacion;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCotizacionAprobar;
/* harmony export (immutable) */ __webpack_exports__["B"] = seleccionarCotizacionAprobar;
/* harmony export (immutable) */ __webpack_exports__["F"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["f"] = addGroupOrders;
/* harmony export (immutable) */ __webpack_exports__["x"] = removeGroupOrders;
/* harmony export (immutable) */ __webpack_exports__["t"] = recomendarCotizacion;
/* harmony export (immutable) */ __webpack_exports__["A"] = seleccionarAprobacion;
/* harmony export (immutable) */ __webpack_exports__["v"] = registrarResultadoAprobacion;
/* harmony export (immutable) */ __webpack_exports__["n"] = displayModalCreateDocumento;
/* harmony export (immutable) */ __webpack_exports__["m"] = displayModalCompraDirecta;
/* harmony export (immutable) */ __webpack_exports__["d"] = addFileCompraDirecta;
/* harmony export (immutable) */ __webpack_exports__["k"] = createOrUpdateCompraDirecta;
/* harmony export (immutable) */ __webpack_exports__["e"] = addGarantia;
/* harmony export (immutable) */ __webpack_exports__["u"] = registerCancelacion;
/* harmony export (immutable) */ __webpack_exports__["l"] = createOrUpdateDocumento;
/* harmony export (immutable) */ __webpack_exports__["s"] = previewDocumento;
/* harmony export (immutable) */ __webpack_exports__["h"] = addSolicitudBienesItem;
/* harmony export (immutable) */ __webpack_exports__["z"] = removeSolicitudBienesItem;
/* harmony export (immutable) */ __webpack_exports__["E"] = toggleSelectAllProveedores;
/* harmony export (immutable) */ __webpack_exports__["i"] = calculateIva;
/* harmony export (immutable) */ __webpack_exports__["q"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["o"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["p"] = eliminarComentario;
/* harmony export (immutable) */ __webpack_exports__["j"] = crearAprobacionAdicionalBiene;
/* unused harmony export validarSolicitudAprobacionAdicionalBiene */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ip__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_file_download__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__otrosi__ = __webpack_require__(69);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getSolicitud(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+id).then(function(res){var _res$data=res.data,solicitud=_res$data.solicitud,aprobadores=_res$data.aprobadores;var cotizacionesAprobadas=[];var tipo_almacen=solicitud.tipo===6?'Laboratorio':'Materiales';dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common__["l" /* getParameterByName */])("ALMACEN"));for(var index=0;index<solicitud.bienes.length;index++){cotizacionesAprobadas=solicitud.bienes[index].cotizaciones.filter(function(ele){return ele.estado===4;});solicitud.bienes[index].cotizaciones_aprobar=cotizacionesAprobadas;}for(var i=0;i<aprobadores.length;i++){for(var j=0;j<aprobadores[i].aprobaciones.length;j++){aprobadores[i].aprobaciones[j].selected=aprobadores[i].aprobaciones[j].estado===2;}}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_305" /* OBTENER_SOLICITUD_BIENES_INVESTIGACION */],payload:{solicitud:solicitud,aprobadores:aprobadores,tipo_almacen:tipo_almacen}});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function seleccionarMoneda(){var moneda=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'COP';return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_366" /* SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1 */],payload:{moneda:moneda}});};}function updateSolicitudBI(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_83" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:true});var _getState=getState(),solicitudBI=_getState.solicitudBI;var modificar=solicitudBI.get('addModificacion');var remove=solicitudBI.get('remove');var errors=validateSolicitud(solicitudBI.get('solicitud'),modificar);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_83" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:false});}else{var BienesNew=solicitudBI.getIn(['solicitud','bienes']);var BienesOld=solicitudBI.getIn(['unchaged','bienes']);var files=[];var modificaciones=[];var comprasDirectas=BienesNew.filter(function(bien){return bien.get('compra_directa')&&bien.get('factura_compra_directa');}).map(function(bien){return bien.get('factura_compra_directa');});if(comprasDirectas.count()>0&&solicitudBI.get('estado')>=4&&solicitudBI.get('estado')<=6){files=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["g" /* attachFilesToEntity */])("FacturaCompraDirecta",comprasDirectas);}if(modificar){modificaciones=addModificacion(solicitudBI.get('solicitud'));}else{modificaciones=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["u" /* getModificaciones */])(BienesNew,BienesOld,'BienesDetalle',switchBienes);}modificaciones=[].concat(_toConsumableArray(modificaciones),_toConsumableArray(remove));modificaciones=addMoneda(solicitudBI.get('moneda'),modificaciones);modificaciones=addProveedoresExternos(modificaciones);axios.put(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+solicitudBI.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn1=function fn1(){return dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" /* ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn2=function fn2(){return __WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common__["F" /* uploadFiles */])("/files/"+res.data.solicitud.id,files,[fn1,fn2,fn3]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_83" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:false});});}};}function addFile(url,actions){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var files=[data];actions.push(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Los archivos han sido guardados exitosamente'});});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common__["F" /* uploadFiles */])(url,files,actions));};}function removeFiles(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fns=[];getState().solicitudBI.getIn(['solicitud','adjuntos']).filter(function(a){return a.get('id')&&a.get('selected');}).map(function(a){fns.push(function(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/files/"+a.get('id'));});});var id=getState().solicitudBI.get('id');Promise.all(fns.map(function(x){return x();})).then(function(){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});dispatch(getSolicitud(id));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function toggleAllCotizacion(path,value){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_369" /* SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION */],payload:{path:path,value:value}};}function addCotizacion(path,indexServicio){return function(dispatch,getState){var cotizaciones=getState().solicitudBI.getIn(['solicitud','bienes',indexServicio,'cotizaciones']);var numcotizaciones=cotizaciones?cotizaciones.count():0;if(numcotizaciones>=10){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning('Solo es permitido agregar diez(10) proveedores',{bodyClassName:'toastify-content toastify-warning'});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_6" /* ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION */],payload:{path:path,indexServicio:indexServicio}});}};}function addProveedorCotizacion(payload){return function(dispatch,getState){var path=payload.path.split('.');var bienes=getState().solicitudBI.getIn(path).filter(function(b){return b.get('selected');});if(bienes.count()==0){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warn("Debe tener al menos un bien seleccionado para agregar un proveedor",{bodyClassName:'toastify-content toastify-warning'});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["x" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION */],payload:payload});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["I" /* ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION */],payload:{entity:'Solicitude',id:getState().solicitudBI.get('id'),attribute:'bienes'}});}};}function removeProveedorCotizacion(proveedor){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_352" /* REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION */],payload:{bien_id:proveedor.get('bien_id'),proveedor_id:proveedor.get('id')}});};}function addCotizacionAprobar(path){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["l" /* ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION */],payload:{path:path}};}function seleccionarCotizacionAprobar(cotizacion_id,bien_idx,cotizacion_aprobar_idx){return function(dispatch,getState){var cotizacionesAprobar=getState().solicitudBI.getIn(['solicitud','bienes',bien_idx,'cotizaciones_aprobar']).filter(function(cot){return cot.get('id')==Number(cotizacion_id);});if(cotizacionesAprobar.count()>0){return __WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warn("El proveedor ya ha sido seleccionado",{bodyClassName:'toastify-content toastify-warning'});}return dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_363" /* SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION */],payload:{cotizacion_id:cotizacion_id,bien_idx:bien_idx,cotizacion_aprobar_idx:cotizacion_aprobar_idx}});};}// export function removeProveedorCotizacion(path) {
//     return { type: types.ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION, payload: { path } }
// }
function updateInputs(path,value){var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var immutable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_211" /* MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1 */],payload:{path:path,value:value,immutable:immutable}});};fn0(dispatch);var pathArray=path.split('.');var entity=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["n" /* esEntero */])(pathArray.slice(-2)[0])?pathArray.slice(-3)[0]:pathArray.slice(-2)[0];var attribute=pathArray.slice(-2)[1];switch(entity){case'solicitud':entity='Solicitude';break;case'bien':case'bienes':entity='BienesDetalle';break;case'cotizacion':case'cotizacione':case'cotizaciones':case'cotizaciones_aprobar':entity='Cotizacione';break;case'documento':case'documentos':entity='Documento';break;}if(id){var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["I" /* ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION */],payload:{id:id,entity:entity,attribute:attribute,value:value,action:'edit'}});};fn2(dispatch);}};}function addGroupOrders(){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["H" /* ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION */]};}function removeGroupOrders(){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_355" /* REMOVER_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION */]};}// export function recomendarCotizacion(bien_idx, cotizacion_aprobar_idx) {
// 	return (dispatch) => {
// 		dispatch({
// 			type: types.CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION,
// 			payload: {
//                 bien_idx,
//                 cotizacion_aprobar_idx
// 			}
// 		})
// 		dispatch({ type: types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION, payload: false })
// 	}
// }
function recomendarCotizacion(bien_id,proveedor_id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_42" /* CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION */],payload:{bien_id:bien_id,proveedor_id:proveedor_id}});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_83" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:false});};}function seleccionarAprobacion(bien_id,aprobador_id,aprobacion_id){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_45" /* CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION */],payload:{bien_id:bien_id,aprobador_id:aprobador_id,aprobacion_id:aprobacion_id}};}function registrarResultadoAprobacion(aprobaciones,result){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudBI.get('solicitud');var errors=result>0?validateAprobacion(aprobaciones,result):validateAprobacion(aprobaciones.first().get('observaciones'),result);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{// const BienesNew = getState().solicitudBI.getIn(['solicitud', 'bienes'])
// const BienesOld = getState().solicitudBI.getIn(['unchaged', 'bienes'])
// const modificaciones = getModificaciones(BienesNew, BienesOld, 'BienesDetalle', switchBienes)
var modificaciones=[];aprobaciones.filter(function(f){return f.getIn(['cotizacione','recomendado']);}).map(function(a){modificaciones.push({id:a.get('id'),entity:'Aprobacione',value:{estado:result,ip:__WEBPACK_IMPORTED_MODULE_7_ip___default.a.address(),observaciones:aprobaciones.first().get('observaciones')},action:'edit'});var bienId=a.getIn(['cotizacione','bienes',0,'id']);var bienIdx=getState().solicitudBI.getIn(['solicitud','bienes']).findIndex(function(b){return b.get('id')==bienId;});var cantidad=getState().solicitudBI.getIn(['solicitud','bienes',bienIdx,'cantidad_solicitada']);var estado=getState().solicitudBI.getIn(['solicitud','bienes',bienIdx,'estado']);var descripcion=getState().solicitudBI.getIn(['solicitud','bienes',bienIdx,'descripcion']);var observaciones=getState().solicitudBI.getIn(['solicitud','bienes',bienIdx,'observaciones']);modificaciones.push({id:bienId,entity:'BienesDetalle',value:{cantidad_solicitada:cantidad,descripcion:descripcion,observaciones:observaciones,estado:result>0?estado:0},action:'edit'});});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_80" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION */],payload:true});axios.put(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+solicitud.get('id'),modificaciones).then(function(res){var _res$data2=res.data,solicitud=_res$data2.solicitud,aprobadores=_res$data2.aprobadores;if(solicitud.estado===0){__WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido anulada'});}else{if(solicitud.documento_origen){var fn1=function fn1(d){return d(Object(__WEBPACK_IMPORTED_MODULE_9__otrosi__["b" /* getSolicitud */])(solicitud.id));};fn1(dispatch);}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" /* ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:{solicitud:solicitud,aprobadores:aprobadores}});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido guardada exitosamente'});}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_80" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION */],payload:false});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_80" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION */],payload:false});});}};}function displayModalCreateDocumento(show,title,mode,indexDocumento){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var proveedor=getState().solicitudBI.getIn(['solicitud','documentos',indexDocumento,'proveedor_id']);var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/plantillas");};var fn1=function fn1(){return axios.get(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/garantias");};var fn2=function fn2(){return axios.get(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/documentos/contratos-anuales",{params:{proveedor:proveedor}});};Promise.all([fn0(),fn1(),fn2()]).then(function(res){var plantillas=res[0].data.data;var garantias=res[1].data.data;var contratos=res[2].data;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_258" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION */],payload:{show:show,title:title,mode:mode,indexDocumento:indexDocumento,plantillas:plantillas,garantias:garantias,contratos:contratos}});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function displayModalCompraDirecta(show,title,bien_id,cotizacion){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_256" /* MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION */],payload:{title:title,show:show,bien_id:bien_id,cotizacion:cotizacion}};}function addFileCompraDirecta(path){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(data.get('clasificacion')&&data.get('clasificacion')!='Facturas')errors.push('Se requiere adjuntar un archivo de tipo Factura');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_211" /* MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1 */],payload:{path:path,value:data,immutable:true}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}// export function createOrUpdateCompraDirecta() {
//     return (dispatch, getState) => {
//         const documentoNew = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'data'])
//         const cot_id = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'cot_id'])
//         const bien_id = getState().solicitudBI.getIn(['modalCreateCompraDirecta', 'bien_id'])
//         const cotizacion_idx = getState().solicitudBI.getIn(['solicitud', 'cotizaciones']).findIndex(cot => cot.get('id') === cot_id)
//         let bien_idx = getState().solicitudBI.getIn(['solicitud', 'cotizaciones', cotizacion_idx, 'bienes']).findIndex(bien => bien.get('id') === bien_id)
//         const errors = validateFacturaCompraDirecta(documentoNew)
//         if (errors.length) {
//             errors.forEach(x => {
//                 toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
//             })
//         } else {
//             dispatch(displayModalCompraDirecta(false))
//             dispatch(updateInputs(`solicitud.cotizaciones.${cotizacion_idx}.bienes.${bien_idx}.factura_compra_directa`, documentoNew, bien_id))
//             bien_idx = getState().solicitudBI.getIn(['solicitud', 'bienes']).findIndex(bien => bien.get('id') === bien_id)
//             dispatch(updateInputs(`solicitud.bienes.${bien_idx}.factura_compra_directa`, documentoNew, bien_id))
//         }
//     }
// }
function createOrUpdateCompraDirecta(){return function(dispatch,getState){var documentoNew=getState().solicitudBI.getIn(['modalCreateCompraDirecta','data']);var cot_id=getState().solicitudBI.getIn(['modalCreateCompraDirecta','cot_id']);var bien_id=getState().solicitudBI.getIn(['modalCreateCompraDirecta','bien_id']);var cotizacion_idx=getState().solicitudBI.getIn(['solicitud','cotizaciones']).findIndex(function(cot){return cot.get('id')===cot_id;});var bien_idx=getState().solicitudBI.getIn(['solicitud','cotizaciones',cotizacion_idx,'bienes']).findIndex(function(bien){return bien.get('id')===bien_id;});var errors=validateFacturaCompraDirecta(documentoNew);if(errors.length){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{dispatch(displayModalCompraDirecta(false));dispatch(updateInputs("solicitud.cotizaciones."+cotizacion_idx+".bienes."+bien_idx+".factura_compra_directa",documentoNew,bien_id));bien_idx=getState().solicitudBI.getIn(['solicitud','bienes']).findIndex(function(bien){return bien.get('id')===bien_id;});dispatch(updateInputs("solicitud.bienes."+bien_idx+".factura_compra_directa",documentoNew,bien_id));if(documentoNew.get('proveedor','nombre'))dispatch(updateInputs("solicitud.cotizaciones."+cotizacion_idx+".proveedor_nombre_cp",documentoNew.getIn(['proveedor','nombre']),cot_id));else dispatch(updateInputs("solicitud.cotizaciones."+cotizacion_idx+".proveedor_nombre_cp",documentoNew.get(['razon_social']),cot_id));}};}function addGarantia(checked,index,id){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["E" /* ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION */],payload:{index:index,id:id,checked:checked}};}function registerCancelacion(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudBI.get('solicitud').set('estado',0);var errors=validateSolicitud(solicitud);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{estado:0,motivo_cancelacion:solicitud.get('motivo_cancelacion'),fecha_cancelacion:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')},action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" /* ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],//Bug corregido sin probar
payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();if(solicitud.documento_origen){var fn2=function fn2(d){return d(Object(__WEBPACK_IMPORTED_MODULE_9__otrosi__["b" /* getSolicitud */])(solicitud.id));};fn2(dispatch);}}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});}};}function createOrUpdateDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_100" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_100" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION */],payload:false});};var fn4=function fn4(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_83" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:true});};fn0(dispatch);var fn3=function fn3(d){return d(displayModalCreateDocumento(false));};var solicitud=getState().solicitudBI.get('id');var data=getState().solicitudBI.get('modalCreateDocumento');var documentoNew=data.get('data');var documentoOld=data.get('unchanged');var tipoDocumento=documentoNew.get('tipo');if(tipoDocumento==1||tipoDocumento==3){documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'));}if(tipoDocumento==2&&!documentoNew.get('fecha_inicio')){documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'));}else if(tipoDocumento==2){documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_5_moment___default()(documentoNew.get('fecha_inicio')).format('YYYY-MM-DD'));}if(tipoDocumento==4){var fecha_inicio=getState().solicitudBI.getIn(['solicitud','documento_origen','fecha_inicio']);documentoNew=documentoNew.set('fecha_inicio',__WEBPACK_IMPORTED_MODULE_5_moment___default()(fecha_inicio).format('YYYY-MM-DD'));}var errors=validateDocumento(documentoNew,data.get('contratoanual'));if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});fn1(dispatch);}else{documentoOld=documentoOld.set('garantias',Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["D" /* indexBy */])(documentoOld.get('garantias'),'id'));documentoNew=documentoNew.set('garantias',Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["D" /* indexBy */])(documentoNew.get('garantias'),'id'));var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["u" /* getModificaciones */])(documentoNew,documentoOld,'Documento',switchDocumento);axios.put(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+solicitud,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["d" /* ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn1(dispatch);fn2(dispatch);fn3(dispatch);fn4(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function previewDocumento(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var documento=getState().solicitudBI.getIn(['modalCreateDocumento','data']);var tipo=getState().common.getIn(['enums','documentos','tipos',""+documento.get('tipo'),'NOMBRE']);axios.post(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/view/"+id,{documento:documento},{responseType:'arraybuffer'}).then(function(res){__WEBPACK_IMPORTED_MODULE_8_react_file_download___default()(res.data,"PREV-"+tipo+".pdf");}).catch(function(err){var decodedString=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(err.response.data)));var obj={response:{data:decodedString,status:422}};Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,obj);});};}function addSolicitudBienesItem(){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_10" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1 */]};}function removeSolicitudBienesItem(){return function(dispatch,getState){var bienes=getState().solicitudBI.getIn(['solicitud','bienes']).filter(function(x){return x.get('id')&&x.get('selected');});var modificaciones=[];bienes.valueSeq().forEach(function(bien){var id=bien.get('id');var cencos=bien.get('cencos');cencos.valueSeq().forEach(function(c){modificaciones.push({entity:'DisCencoBiene',id:c.getIn(['pivot','id']),action:'delete'});});modificaciones.push({entity:'BienesDetalle',id:bien.get('id'),action:'delete'});});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_153" /* ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1 */],payload:{remove:modificaciones}});};}function toggleSelectAllProveedores(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_62" /* CONMUTAR_SELECCION_TODOS_BIENES */],payload:checked});};}function calculateIva(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_33" /* CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION */]});};}function enviarComentario(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud_id=getState().solicitudBI.getIn(['solicitud','id']);var usuario_id=getState().common.getIn(['user','id']);var id=getState().solicitudBI.getIn(['comentario','id']);var comentario=getState().solicitudBI.getIn(['comentario','texto']);var modificaciones=[];if(id==null){modificaciones.push({entity:'Foro',action:'add',id:null,value:{solicitud_id:solicitud_id,usuario_id:usuario_id,comentario:comentario}});}else{modificaciones.push({id:id,entity:'Foro',value:{comentario:comentario},action:'edit'});}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_85" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1 */],payload:true});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_85" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1 */],payload:false});};fn1(dispatch);axios.put(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+solicitud_id,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_160" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1 */],payload:{foros:foros}});};fn3(dispatch);fn2(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn2(dispatch);});};}function editarComentario(id){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_112" /* EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1 */],payload:{id:id}});};fn1(dispatch);};}function eliminarComentario(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudBI.getIn(['solicitud','id']);var modificaciones=[];modificaciones.push({entity:'Foro',id:id,action:'delete'});axios.put(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+solicitud,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_160" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1 */],payload:{foros:foros}});};fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'La eliminacion han sido realizadas exitosamente'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}/**
 * Verifica que las cotizaciones a aprobar o rechazar tengan los datos necesarios
 * @param {Object} data: datos de la cotizacion
 * @param {Number} respuesta: 2->aprobado, 0->rechazado
 * @returns {Array} errors: Lista de errores
 */// const validateAprobacion = (data, respuesta) => {
// 	const errors = []
// 	if (respuesta == 2 && data.filter(x => x.get('estado') == 3).count() == 0) errors.push('Debe seleccionar una cotización para aprobar')
// 	if (respuesta == 0 && !data) errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones')
// 	return errors
// }
var validateAprobacion=function validateAprobacion(data,respuesta){var errors=[];if(respuesta==0&&!data)errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones');return errors;};/**
 * Valida que todos los campos esten diligenciados
 * @param {Object} data 
 */var validateFacturaCompraDirecta=function validateFacturaCompraDirecta(data){var errors=[];if(!data.get('razon_social')&&!data.getIn(['proveedor','nombre']))errors.push("Debe ingresar un proveedor");//if (!data.get('nit')) errors.push("Debe ingresar el nit de la empresa")
if(!data.get('no_factura'))errors.push("Debe ingresar el número de la factura");if(!data.get('fecha_compra'))errors.push("Ingrese una fecha de compra válida");if(!data.get('medio_pago'))errors.push("Debe ingresar una forma de pago");if(!data.get('valor_compra'))errors.push("Debe ingresar el valor de la compra");if(!data.get('adjunto'))errors.push("Debe adjuntar el archivo de la factura");var today=__WEBPACK_IMPORTED_MODULE_5_moment___default()();if(data.get('fecha_compra')&&__WEBPACK_IMPORTED_MODULE_5_moment___default()(data.get('fecha_compra')).isAfter(today))errors.push("La fecha de compra no debe ser superior a la de hoy");return errors;};/**
 * 
 * @param {*} data 
 * @param {*} escontratoanual 
 */var validateDocumento=function validateDocumento(data){var escontratoanual=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var errors=[];if(Number(data.get('tipo'))===0)errors.push('El campo tipo de documento es obligatorio');if(data.get('tipo')==2&&!data.get('fecha_inicio'))errors.push('El campo fecha inicio es obligatorio');if(!data.get('fecha_entrega'))errors.push('El campo fecha entrega es obligatorio');if(data.get('tipo')==2&&data.get('fecha_inicio')){var today=__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');if(__WEBPACK_IMPORTED_MODULE_5_moment___default()(today).isAfter(data.get('fecha_inicio')))errors.push('La fecha de inicio no debe ser inferior a hoy');}if(data.get('tipo')==2&&data.get('fecha_inicio')&&data.get('fecha_entrega')){if(__WEBPACK_IMPORTED_MODULE_5_moment___default()(data.get('fecha_inicio')).isAfter(data.get('fecha_entrega')))errors.push('La fecha entrega no debe ser inferior a la fecha de inicio');}if(data.get('tipo')!=4&&Number(data.get('plantilla_id'))===0)errors.push('El campo plantilla es obligatorio');if(Number(data.get('anticipo'))>50)errors.push('El anticipo no debe ser superior al 50%');if(Number(data.get('anticipo'))>0&&!data.get('pago_anticipo'))errors.push('La fecha de pago de anticipo es obligatioria si hay anticipo');if(Number(data.get('anticipo'))>0&&!data.get('forma_pago_anticipo'))errors.push('La forma de pago de anticipo es obligatioria si hay anticipo');if(escontratoanual){if(Number(data.get('documento_id'))===0)errors.push('El campo número de contrato es obligatorio');}var input_iva=parseFloat(Number(getTotalConIva(data)).toFixed(2));var aiu_total=parseFloat(Number(data.get('aiu_total')).toFixed(2));//Lo mando a quitar Oscar el dia 12/07/2019 via Skype
// if (input_iva !== aiu_total && data.get('tipo') != 4) {
// 	errors.push('El valor total de los bienes es diferente al valor total del IVA')
// }
if(!data.get('almacen')){errors.push('El campo Almacén es obligatorio');}return errors;};/**
 * Con los datos de la solicitud, valida que pase las restricciones y retorna una lista de inconsistencias.
 * @param {Object} solicitud
 * @returns {Array} errors
 */var validateSolicitud=function validateSolicitud(solicitud){var extra=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errors=[];if(solicitud.get('estado')===1){solicitud.get('bienes').valueSeq().forEach(function(ele,idx){// if (ele.get('cantidad_solicitada') > ele.get("cantidad_requerida"))
//     errors.push(`La cantidad solicitada debe ser menor o igual a la cantidad requerida. ${ele.get('descripcion')}`);
if(!ele.get('descripcion'))errors.push("Debe indicar la descripcion en el bien # "+(idx+1));if(ele.get('cantidad_solicitada')<0)errors.push("La cantidad solicitada no debe ser menor a cero. "+ele.get('descripcion'));// if (!ele.get('item'))
//     errors.push(`Debe seleccionar el item del ERP correspondiente. ${ele.get('descripcion')}`);
if(!ele.get('unidad'))errors.push("Debe indicar la unidad para "+ele.get('descripcion'));if(!ele.get('cantidad_solicitada'))errors.push("Debe indicar la cantidad solicitada para "+ele.get('descripcion'));});}else if(solicitud.get('estado')===8){if(extra==false){if(!solicitud.getIn(['bienes',0,'fecha_cotizaciones'])||solicitud.getIn(['bienes',0,'fecha_cotizaciones'])=='-0001-11-30 00:00:00')errors.push("El campo fecha cotizaciones es obligatorio");if(solicitud.getIn(['bienes',0,'fecha_cotizaciones'])&&__WEBPACK_IMPORTED_MODULE_5_moment___default()().isSameOrAfter(solicitud.getIn(['bienes',0,'fecha_cotizaciones'])))errors.push("La fecha de cotizaciones no debe ser inferior a la de hoy");}solicitud.get('bienes').valueSeq().forEach(function(ele,idx){var descripcion=ele.get('descripcion')?ele.get('descripcion'):"Bien # "+(idx+1);if(!ele.get('descripcion'))errors.push("Debe indicar la descripcion en "+descripcion);if(ele.get('cantidad_solicitada')<0)errors.push("La cantidad solicitada no debe ser menor a cero. "+descripcion);// if (!ele.get('item'))
//     errors.push(`Debe seleccionar el item del ERP correspondiente. ${descripcion}`);
if(!ele.get('unidad'))errors.push("Debe indicar la unidad para "+descripcion);if(!ele.get('cantidad_solicitada'))errors.push("Debe indicar la cantidad solicitada para "+descripcion);if(!ele.get('compra_directa')&&ele.get('cantidad_solicitada')>0&&extra==false){if(ele.get('cotizaciones').count()==0)errors.push("Se requiere al menos un proveedor o una compra directa para "+descripcion);// if (ele.get('cotizaciones').count() > 0 && ele.get('cotizaciones').filter(c => c.get('proveedore') == null).count() > 0)
//     errors.push(`Todos los campos de los bienes son requeridos`)
}});}else if(solicitud.get('estado')>=2){solicitud.get('bienes').filter(function(b){return b.get('cantidad_solicitada')>0&&b.get('estado')==1;}).map(function(bien,idx){var descripcion=bien.get('descripcion')?bien.get('descripcion'):"Bien # "+(idx+1);if(!bien.get('compra_directa')&&bien.get('cantidad_solicitada')>0&&extra==false){if(bien.get('cotizaciones').count()==0)errors.push("Se requiere al menos un proveedor o una compra directa para "+descripcion);// if (bien.get('cotizaciones').count() > 0 && bien.get('cotizaciones').filter(c => c.get('proveedore') == null).count() > 0)
//     errors.push(`Todos los campos de los bienes son requeridos`)
}bien.get('cotizaciones').filter(function(c){return c.get('recomendado');}).map(function(cotizacion){var target=""+bien.getIn(['item','descripcion']);//let tiene_proveedor = false;
var tiene_proveedor=cotizacion.get('proveedor_id')?true:false;if(bien.get('compra_directa')){// Si compra_directa es true, verifica si proveedor_id y proveedor_nombre_cp son válidos
var proveedorId=cotizacion.get('proveedor_id');var proveedorNombreCp=cotizacion.get('proveedor_nombre_cp');// Considera válido el proveedor_id si es un número y no es nulo
var esProveedorIdValido=typeof proveedorId==='number'&&proveedorId!==null;// Considera válido el proveedor_nombre_cp si es un string no vacío y no es nulo
var esProveedorNombreCpValido=typeof proveedorNombreCp==='string'&&proveedorNombreCp!==null&&proveedorNombreCp.trim()!=='';// Se considera que tiene proveedor si al menos uno de los dos es válido
tiene_proveedor=esProveedorIdValido||esProveedorNombreCpValido;}if(!cotizacion.get('cotizado'))errors.push("El valor unitario de la cotizaci\xF3n es obligatorio en el bien: "+target);if(!cotizacion.get('tiempo_entrega'))errors.push("El tiempo de entrega de la cotizaci\xF3n es obligatorio en el bien: "+target);if(tiene_proveedor===false)errors.push("El proveedor de la cotizaci\xF3n es obligatorio en el bien: "+target);});});}else if(solicitud.get('estado')===0){if(!solicitud.get('motivo_cancelacion'))errors.push('El campo motivo cancelación es obligatorio');}return errors;};/**
 * Ejecuta ajustes en los datos de cambios para enviar al servidor
 * @param {Object} change 
 * @param {Object} modificacion 
 * @param {Object} bienes 
 */var switchBienes=function switchBienes(change,modificacion,bienes){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[1];switch(change.get('op')){case'add':if(modificacion.attribute==='cotizaciones'){modificacion.action='create';modificacion.value.adjunto=null;modificacion.value.proveedor_id=modificacion.value.proveedore.id;modificacion.value.proveedore=null;modificacion.value.servicio=null;}else if(modificacion.attribute==="cotizaciones_aprobar"){modificacion.action='create';modificacion.attribute='cotizaciones';modificacion.value.adjunto=null;modificacion.value.proveedor_id=null;modificacion.value.proveedore=null;modificacion.value.servicio=null;}else if(modificacion.attribute==="selected"){modificacion.action='hidden';}break;case'replace':if(modificacion.attribute==='cotizaciones'||modificacion.attribute==="cotizaciones_aprobar"){modificacion.attribute=path[3];modificacion.entity='Cotizacione';modificacion.id=bienes.getIn([].concat(_toConsumableArray(path.splice(0,3)),['id']));}else if(modificacion.attribute==='item'){modificacion.attribute="item_id";modificacion.value=bienes.getIn([].concat(_toConsumableArray(path.splice(0,3)),['id']));}else if(modificacion.attribute==='factura_compra_directa'){if(bienes.getIn([].concat(_toConsumableArray(path.slice(0,2)),['id']))){modificacion.attribute=path[2];modificacion.entity='FacturaCompraDirecta';modificacion.id=bienes.getIn([].concat(_toConsumableArray(path.slice(0,2)),['id']));}else{modificacion.entity='BienesDetalle',modificacion.action='create';delete modificacion.value.adjunto;delete modificacion.value.id;}}else if(modificacion.attribute==="selected"){modificacion.action='hidden';}break;case'remove':break;}};var addMoneda=function addMoneda(moneda,modificaciones){modificaciones.forEach(function(m,i){if(m.value&&m.entity=='BienesDetalle'&&m.attribute=='cotizaciones'&&m.action=='create'){modificaciones[i].value.moneda=moneda?moneda:'COP';}});var modificacion={action:'hidden',entity:'Parametro',value:{moneda:moneda}};modificaciones.push(modificacion);return modificaciones;};var addProveedoresExternos=function addProveedoresExternos(modificaciones){modificaciones.forEach(function(m,i){if(m.value&&m.entity=='BienesDetalle'&&m.attribute=='factura_compra_directa'&&m.action=='create'){if(m.value.proveedor){modificaciones[i].value.razon_social=m.value.proveedor.nombre;delete modificaciones[i].value.proveedor;}else{modificaciones.push({entity:'ProveedorExterno',value:{nombre:m.value.razon_social},action:'add'});}}});return modificaciones;};/**
 * 
 * @param {*} change 
 * @param {*} modificacion 
 */var switchDocumento=function switchDocumento(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];switch(modificacion.attribute){case'aiu_administracion_value':case'aiu_imprevistos_value':case'aiu_utilidad_value':case'aiu_iva_utilidad_value':case'aiu_total':case'todos_detalles':modificacion.action='hidden';break;case'iva_value':if(modificacion.action==='add')modificacion.action='replace';break;}switch(change.get('op')){case'add':if(modificacion.attribute==='garantias'){modificacion.value=modificacion.value.id;modificacion.action='attach';}break;case'remove':if(modificacion.attribute==='garantias'){modificacion.action='detach';}break;}};var switchFacturaCompraDirecta=function switchFacturaCompraDirecta(change,modification,facturaCP){var path=[].concat(_toConsumableArray(modification.attribute));modification.attribute=path[0];switch(change.get('op')){case'add':if(modification.entity==='FacturaCompraDirecta'){modification.action='create';}}};var getTotalSinIva=function getTotalSinIva(data){return data.get('detalles').reduce(function(acum,detalle){acum+=detalle.get('valor')*detalle.get('cantidad');return acum;},0);};var getTotalConIva=function getTotalConIva(data){return data.get('detalles').reduce(function(acum,detalle){acum+=detalle.get('valor_con_iva')*detalle.get('cantidad');return acum;},0);};var addModificacion=function addModificacion(solicitud){var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{proyecto_evento:solicitud.get('proyecto_evento'),fecha_requerido:solicitud.get('fecha_requerido'),tipo:solicitud.get('tipo')},action:'edit'});var cencos=[];solicitud.getIn(['bienes',0,'cencos']).valueSeq().forEach(function(cenco){cencos.push({cenco_id:cenco.getIn(['pivot','cenco_id']),porcentaje:cenco.getIn(['pivot','porcentaje']),rubro_id:cenco.getIn(['pivot','rubro_id'])});});solicitud.get('bienes').valueSeq().forEach(function(bien){if(bien.get('id')){modificaciones.push({id:bien.get('id'),entity:'BienesDetalle',value:{descripcion:bien.get('descripcion'),item_id:bien.getIn(['item','id']),cantidad_requerida:bien.get('cantidad_requerida'),cantidad_solicitada:bien.get('cantidad_solicitada'),unidad:bien.get('unidad')},action:'edit'});}else{// Se modifico el backend para aceptar una relacion
modificaciones.push({entity:'BienesDetalle',value:{solicitud_id:solicitud.get('id'),descripcion:bien.get('descripcion'),item_id:bien.getIn(['item','id']),cantidad_requerida:bien.get('cantidad_requerida'),cantidad_solicitada:bien.get('cantidad_solicitada'),unidad:bien.get('unidad'),estado:1,cencos:cencos},action:'add'});}});return modificaciones;};function crearAprobacionAdicionalBiene(aprobador,motivo){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var errors=validarSolicitudAprobacionAdicionalBiene(aprobador,motivo);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});return;}var solicitud=getState().solicitudBI.get('solicitud');var cotizaciones=solicitud.get('cotizaciones').filter(function(x){return x.get('recomendado')===true;});var modificaciones=[];if(cotizaciones&&cotizaciones.size>0){cotizaciones.forEach(function(cotizacion){modificaciones.push({id:null,entity:'Aprobacione',action:'add',value:{cotizacion_id:cotizacion.get('id'),aprobador_id:aprobador.id,estado:1,// Pendiente de aprobación
observaciones:motivo,tipo:3}});});}axios.put(__WEBPACK_IMPORTED_MODULE_1____["b" /* API_URL */]+"/solicitudes/bienes-investigacion/"+solicitud.get('id'),modificaciones).then(function(res){dispatch(getSolicitud(solicitud.get('id')));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}var validarSolicitudAprobacionAdicionalBiene=function validarSolicitudAprobacionAdicionalBiene(aprobador,motivo){var errors=[];if(!aprobador||!aprobador.id)errors.push('Debe seleccionar un aprobador adicional');if(!motivo||!motivo.trim())errors.push('El motivo de la solicitud adicional es obligatorio');return errors;};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(37);
var core = __webpack_require__(29);
var ctx = __webpack_require__(84);
var hide = __webpack_require__(71);
var has = __webpack_require__(70);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Immutable = __webpack_require__(16);
var utils = __webpack_require__(425);
var lcs = __webpack_require__(426);
var path = __webpack_require__(427);
var concatPath = path.concat,
                  escape = path.escape,
                  op = utils.op,
                  isMap = utils.isMap,
                  isIndexed = utils.isIndexed;

var mapDiff = function(a, b, p){
  var ops = [];
  var path = p || '';

  if(Immutable.is(a, b) || (a == b == null)){ return ops; }

  var areLists = isIndexed(a) && isIndexed(b);
  var lastKey = null;
  var removeKey = null

  if(a.forEach){
    a.forEach(function(aValue, aKey){
      if(b.has(aKey)){
        if(isMap(aValue) && isMap(b.get(aKey))){
          ops = ops.concat(mapDiff(aValue, b.get(aKey), concatPath(path, escape(aKey))));
        }
        else if(isIndexed(b.get(aKey)) && isIndexed(aValue)){
          ops = ops.concat(sequenceDiff(aValue, b.get(aKey), concatPath(path, escape(aKey))));
        }
        else {
          var bValue = b.get ? b.get(aKey) : b;
          var areDifferentValues = (aValue !== bValue);
          if (areDifferentValues) {
            ops.push(op('replace', concatPath(path, escape(aKey)), bValue));
          }
        }
      }
      else {
        if(areLists){
          removeKey = (lastKey != null && (lastKey+1) === aKey) ? removeKey : aKey;
          ops.push( op('remove', concatPath(path, escape(removeKey))) );
          lastKey = aKey;
        }
        else{
          ops.push( op('remove', concatPath(path, escape(aKey))) );
        }

      }
    });
  }

  b.forEach(function(bValue, bKey){
    if(a.has && !a.has(bKey)){
      ops.push( op('add', concatPath(path, escape(bKey)), bValue) );
    }
  });

  return ops;
};

var sequenceDiff = function (a, b, p) {
  var ops = [];
  var path = p || '';
  if(Immutable.is(a, b) || (a == b == null)){ return ops; }
  if((a.count() + 1) * (b.count() + 1) >= 10000 ) { return mapDiff(a, b, p); }

  var lcsDiff = lcs.diff(a, b);

  var pathIndex = 0;

  lcsDiff.forEach(function (diff) {
    if(diff.op === '='){ pathIndex++; }
    else if(diff.op === '!='){
      if(isMap(diff.val) && isMap(diff.newVal)){
        var mapDiffs = mapDiff(diff.val, diff.newVal, concatPath(path, pathIndex));
        ops = ops.concat(mapDiffs);
      }
      else{
        ops.push(op('replace', concatPath(path, pathIndex), diff.newVal));
      }
      pathIndex++;
    }
    else if(diff.op === '+'){
      ops.push(op('add', concatPath(path, pathIndex), diff.val));
      pathIndex++;
    }
    else if(diff.op === '-'){ ops.push(op('remove', concatPath(path, pathIndex))); }
  });

  return ops;
};

var primitiveTypeDiff = function (a, b, p) {
  var path = p || '';
  if(a === b){ return []; }
  else{
    return [ op('replace', concatPath(path, ''), b) ];
  }
};

var diff = function(a, b, p){
  if(Immutable.is(a, b)){ return Immutable.List(); }
  if(a != b && (a == null || b == null)){ return Immutable.fromJS([op('replace', '/', b)]); }
  if(isIndexed(a) && isIndexed(b)){
    return Immutable.fromJS(sequenceDiff(a, b));
  }
  else if(isMap(a) && isMap(b)){
    return Immutable.fromJS(mapDiff(a, b));
  }
  else{
    return Immutable.fromJS(primitiveTypeDiff(a, b, p));
  }
};

module.exports = diff;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Immutable = __webpack_require__(16);
var path = __webpack_require__(428);

var tryParseInt = function(n) {
  var int = parseInt(n);
  return isNaN(int) ? n : int;
};

var primitivePatch = function (op, value) {
  if (op === 'add' || op === 'replace') {
    return value;
  } else if (op === 'remove') {
    return null;
  }
};

var mapPatch = function(map, firstPath, restPath, op, value) {
  if (op === 'add') {
    if (restPath.length > 0 && map.get(firstPath) === undefined) {
      var baseValue = (restPath[0].match(/^\d+$/)) ? Immutable.List() : Immutable.Map();
      return map.set(firstPath, anyPatch(baseValue, restPath, op, value));
    } else {
      return map.set(firstPath, anyPatch(map.get(firstPath), restPath, op, value));
    }
  } else if (op === 'replace') {
    if (restPath.length > 0) {
      return map.set(firstPath, anyPatch(map.get(firstPath), restPath, op, value));
    } else {
      return map.set(firstPath, value);
    }
  } else if (op === 'remove') {
    if (restPath.length > 0) {
      return map.set(firstPath, anyPatch(map.get(firstPath), restPath, op, value));
    } else {
      return map.remove(firstPath);
    }
  } else {
    throw new Error('map patch Error, unknown op: ' + op);
  }
};

var sequencePatch = function(sequence, firstPath, restPath, op, value) {
  firstPath = tryParseInt(firstPath);
  if (op === 'add') {
    if (sequence.get(firstPath) === undefined) {
      if (restPath.length > 0) {
        var baseValue = (restPath[0].match(/^\d+$/)) ? Immutable.List() : Immutable.Map();
        return sequence.set(firstPath, anyPatch(baseValue, restPath, op, value));
      } else {
        // special case, add to the end
        if (firstPath === '-') {
          return sequence.splice(sequence.size, 0, value);
        }
        // special case, return the value
        return sequence.splice(firstPath, 0, value);
      }
    } else {
      if (restPath.length > 0) {
        return sequence.set(firstPath, anyPatch(sequence.get(firstPath), restPath, op, value));
      } else {
        // special case, return the value
        return sequence.splice(firstPath, 0, value);
      }
    }
  } else if (op === 'replace') {
    if (restPath.length > 0) {
      return sequence.set(firstPath, anyPatch(sequence.get(firstPath), restPath, op, value));
    } else {
      return sequence.set(firstPath, value);
    }
  } else if (op === 'remove') {
    if (restPath.length > 0) {
      return sequence.set(firstPath, anyPatch(sequence.get(firstPath), restPath, op, value));
    } else {
      return sequence.remove(firstPath);
    }
  } else {
    throw new Error('sequence patch Error, unknown op: ' + op);
  }
};

var anyPatch = function(any, pathArray, op, value) {
  var firstPath, restPath;

  if (Immutable.Iterable.isKeyed(any)) {
    if (pathArray.length === 0) { return any; }
    firstPath = pathArray[0];
    restPath = pathArray.slice(1);
    return mapPatch(any, firstPath, restPath, op, value);
  } else if (Immutable.Iterable.isIndexed(any)) {
    if (pathArray.length === 0) { return any; }
    firstPath = pathArray[0];
    restPath = pathArray.slice(1);
    return sequencePatch(any, firstPath, restPath, op, value);
  } else {
    if (pathArray.length === 0) { return value; }
    return primitivePatch(op, value);
  }
};

var eachPatchInternal = function(value, patches) {
  while (patches.size) {
    var firstPatch = patches.get(0);
    var patches = patches.slice(1);
    var pathArray = firstPatch.get('path').split('/').slice(1).map(path.unescape);
    value = anyPatch(value, pathArray, firstPatch.get('op'), firstPatch.get('value'));
  }
  return value;
};

var eachPatch = function(value, patches) {
  if (patches.size === 1) {
    var onlyPatch = patches.get(0);
    if (onlyPatch.get('op') === 'replace' && onlyPatch.get('path') === '/') {
      return onlyPatch.get('value');
    }
  }
  return eachPatchInternal(value, patches);
};

eachPatch.default = eachPatch;
module.exports = eachPatch;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getEvaluacionProveedor;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMontoContratadoProveedor;
/* harmony export (immutable) */ __webpack_exports__["h"] = getMontoContratadoCenco;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCumplimientoResponsableCompras;
/* harmony export (immutable) */ __webpack_exports__["j"] = getReporteRadicados;
/* harmony export (immutable) */ __webpack_exports__["g"] = getGestionResponsableCompras;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeNumberRegisterToShow;
/* harmony export (immutable) */ __webpack_exports__["l"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["m"] = showHideModalFilter;
/* harmony export (immutable) */ __webpack_exports__["a"] = addModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["k"] = removeCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["d"] = downloadFile;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateInputs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_file_download__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(24);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**
 * Get the data for report EVALUACION PROVEEDORES
 * @param {Number} page 
 */function getEvaluacionProveedor(page){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var _getState=getState(),reportes=_getState.reportes;axios.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/reportes/evaluacion_proveedores',{params:{proveedor_id:reportes.getIn(['provider_evaluation','provider','id']),fecha_inicio:reportes.getIn(['provider_evaluation','initial_date']),fecha_fin:reportes.getIn(['provider_evaluation','final_date']),page:page,number_registers:reportes.getIn(['provider_evaluation','showRecords']),//showRecords
order_by:reportes.getIn(['provider_evaluation','orderBy']),filters:reportes.getIn(['provider_evaluation','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS()}}).then(function(res){return dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_291" /* OBTENER_EVALUACION_PROVEEDOR */],payload:{data:res.data.result,accumulate:res.data.total_avg,range_eval:res.data.range_eval,totalRecords:res.data.total,page:page}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}/**
 * Get data for report MONTO CONTRATADO POR PROVEEDOR
 * @param {Number} page 
 */function getMontoContratadoProveedor(page){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var _getState2=getState(),reportes=_getState2.reportes;axios.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/reportes/monto_contratado_proveedor',{params:{proveedor_id:reportes.getIn(['contracted_amount_providers','provider','id']),fecha_inicio:reportes.getIn(['contracted_amount_providers','initial_date']),fecha_fin:reportes.getIn(['contracted_amount_providers','final_date']),page:page,number_registers:reportes.getIn(['contracted_amount_providers','showRecords']),//showRecords
filters:reportes.getIn(['contracted_amount_providers','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS()}}).then(function(response){return dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_299" /* OBTENER_MONTO_CONTRATADO_PROVEEDOR */],payload:{data:response.data.result,totalRecords:response.data.total,page:page}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}/**
 * Get data for report MONTO CONTRATADO POR CENCO
 * @param {Number} page 
 */function getMontoContratadoCenco(page){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var _getState3=getState(),reportes=_getState3.reportes;axios.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/reportes/monto_contratado_cenco',{params:{responsable_id:reportes.getIn(['responsable','id']),cenco_id:reportes.getIn(['cenco','id']),fecha_inicio:reportes.getIn(['contracted_amount_cencos','initial_date']),fecha_fin:reportes.getIn(['contracted_amount_cencos','final_date']),page:page,number_registers:reportes.getIn(['contracted_amount_cencos','showRecords']),//showRecords
filters:reportes.getIn(['contracted_amount_cencos','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS()}}).then(function(response){return dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_298" /* OBTENER_MONTO_CONTRATADO_CENCO */],payload:{data:response.data.result,totalRecords:response.data.total,page:page}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}/**
 * Get data for report CUMPLIMIENTO RESPONSABLE DE COMPRAS
 * @param {Number} page 
 */// export function getCumplimientoResponsableCompras(page) {
//     const axios = createAxiosInstance();
//     return (dispatch, getState) => {
//         const { reportes } = getState();
//         let filters = reportes.getIn(['compliance_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();
//         const indexEtapa = filters.findIndex((f)=>f.column === 'evento');
//         if (indexEtapa >= 0) {
//             const evento = filters[indexEtapa];
//             const value = evento.value ? evento.value.split("-") : ["",""];
//             filters = [
//                 ...filters.slice(0, indexEtapa),
//                 {"column": "tipo_evento","operator": evento.operator,"value":value[0], "comparison":"number" },
//                 {"column": "evento","operator":evento.operator,"value":value[1], "comparison":"number" },
//                 ...filters.slice(indexEtapa+1)
//             ];
//         }
//         axios.get(`${API_URL}/reportes/cumplimiento_responsable_compras`, {
//             params: {
//                 responsable_id: reportes.getIn(['purchasing_manager', 'username']),
//                 page,
//                 number_registers: reportes.get('numberRegisters'),
//                 filters
//             }
//         }).then(response => {
//             return dispatch({
//                 type: types.OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS,
//                 data: response.data.result,
//                 total: response.data.total
//             })
//         }).catch(err => displayMessages(dispatch, err));
//     }
// }
function getCumplimientoResponsableCompras(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var _getState4=getState(),reportes=_getState4.reportes;var filters=reportes.getIn(['compliance_purchasing_manager','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS();var indexEtapa=filters.findIndex(function(f){return f.column==='evento';});if(indexEtapa>=0){var evento=filters[indexEtapa];var etapas=getState().common.getIn(['enums','etapas']).filter(function(e){return e==evento.value;});if(etapas.count()){var value=etapas.keySeq().toArray().join('|');var operator=evento.operator==="!=="?"NOT REGEXP":"REGEXP";filters=[].concat(_toConsumableArray(filters.slice(0,indexEtapa)),[{"column":"evento","operator":operator,"value":value,"comparison":"string"}],_toConsumableArray(filters.slice(indexEtapa+1)));}}axios.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/reportes/cumplimiento_responsable_compras',{params:{responsable_id:reportes.getIn(['purchasing_manager','username']),page:page,number_registers:reportes.getIn(['compliance_purchasing_manager','showRecords']),filters:filters,order_by:reportes.getIn(['compliance_purchasing_manager','orderBy'])}}).then(function(response){return dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_289" /* OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS */],payload:{data:response.data.result,page:page,totalRecords:response.data.total}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}// export function getReporteRadicados(page) {
//     const axios = createAxiosInstance();
//     return (dispatch, getState) => {
//         const { reportes } = getState();
//         let filters = reportes.getIn(['radicados', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();
//         axios.get(`${API_URL}/reportes/radicados`, {
//             params: {
//                 usuario_id: reportes.getIn(['storage_manage', 'USUARIO']),
//                 fecha_inicio: reportes.get('initial_date'),
//                 fecha_fin: reportes.get('final_date'),
//                 order_by: reportes.getIn(['radicados', 'orderBy']),
//                 almacen: reportes.get('storage'),
//                 page,
//                 number_registers: reportes.get('numberRegisters'),
//                 filters
//             }
//         }).then(response => {
//             return dispatch({
//                 type: types.OBTENER_RADICADOS,
//                 data: response.data.result,
//                 total: response.data.total
//             })
//         }).catch(err => displayMessages(dispatch, err));
//     }
// }
function getReporteRadicados(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var _getState5=getState(),reportes=_getState5.reportes;var filters=reportes.getIn(['radicados','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS();axios.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/reportes/radicados',{params:{// usuario_id: reportes.getIn(['storage_manage', 'USUARIO']),
fecha_inicio:reportes.getIn(['radicados','initial_date']),fecha_fin:reportes.getIn(['radicados','final_date']),order_by:reportes.getIn(['radicados','orderBy']),almacen:reportes.get('storage'),page:page,number_registers:reportes.getIn(['radicados','showRecords']),filters:filters}}).then(function(response){return dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_303" /* OBTENER_RADICADOS */],payload:{data:response.data.result,page:page,totalRecords:response.data.total}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}// export function getGestionResponsableCompras(page) {
//     const axios = createAxiosInstance();
//     return (dispatch, getState) => {
//         const { reportes } = getState();
//         let filters = reportes.getIn(['manage_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();
//         axios.get(`${API_URL}/reportes/gestion_responsable_compras`, {
//             params: {
//                 fecha_inicio: reportes.get('initial_date'),
//                 fecha_fin: reportes.get('final_date'),
//                 order_by: reportes.getIn(['manage_purchasing_manager','orderBy']),
//                 tipo_solicitud: reportes.get('request_type'),
//                 page,
//                 number_registers: reportes.get('numberRegisters'),
//                 filters
//             }
//         }).then(response => {
//             return dispatch({
//                 type: types.OBTENER_GESTION_RESPONSABLE_COMPRAS,
//                 data: response.data.result,
//                 total: response.data.total
//             })
//         }).catch(err => displayMessages(dispatch, err));
//     }
// }
function getGestionResponsableCompras(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var _getState6=getState(),reportes=_getState6.reportes;var filters=reportes.getIn(['manage_purchasing_manager','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS();axios.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/reportes/gestion_responsable_compras',{params:{fecha_inicio:reportes.getIn(['manage_purchasing_manager','initial_date']),fecha_fin:reportes.getIn(['manage_purchasing_manager','final_date']),order_by:reportes.getIn(['manage_purchasing_manager','orderBy']),tipo_solicitud:reportes.get('request_type'),page:page,number_registers:reportes.getIn(['manage_purchasing_manager','showRecords']),//showRecords
filters:filters}}).then(function(response){return dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_295" /* OBTENER_GESTION_RESPONSABLE_COMPRAS */],payload:{data:response.data.result,accumulate:response.data.acumulados,page:page,totalRecords:response.data.total}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}/**
 * Change the amount of registers to show
 * @param {Number} number 
 */function changeNumberRegisterToShow(number,reportToGet){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_224" /* MODIFICAR_NUMERO_REGISTROS_MOSTRAR */],number:number,reportToGet:reportToGet});switch(reportToGet){case'provider_evaluation':return dispatch(getEvaluacionProveedor());case'contracted_amount_providers':return dispatch(getMontoContratadoProveedor());case'contracted_amount_cencos':return dispatch(getMontoContratadoCenco());case'compliance_purchasing_manager':return dispatch(getCumplimientoResponsableCompras());case'radicados':return dispatch(getReporteRadicados());case'manage_purchasing_manager':return dispatch(getGestionResponsableCompras());default:console.error('no refresh');}};}/**
 * Set true or false, if the order is ascending or not by field.
 * @param {Object} field 
 * @param {String} reportToGet
 */function setOrderBy(field,reportToGet){return function(dispatch,getState){var currentOrder=getState().reportes.getIn([reportToGet,'orderBy']);var newOrder=currentOrder.set('field',field.value);if(field===null){newOrder=newOrder.set('asc',false);}else{newOrder=newOrder.set('asc',!currentOrder.get('asc'));}dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_329" /* ORDENAR_REPORTES */],payload:{orderBy:newOrder,reportToGet:reportToGet}});dispatch(applyFilterCriterias());};}/**
 * Show or hide the modal filter.
 * @param {boolean} state 
 * @param {Object} tableCols 
 * @param {string} reportToGet 
 */function showHideModalFilter(state,tableCols,reportToGet){return function(dispatch,getState){if(!reportToGet){reportToGet=getState().reportes.get('reportToGet');}return dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_274" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES */],payload:{state:state,tableCols:tableCols,reportToGet:reportToGet}});};}/**
 * Add row filter to state
 */function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["u" /* ADICIONAR_CRITERIO_FILTRADO_REPORTES */]});};}/**
 * Delete row filter from state
 */function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_147" /* ELIMINAR_CRITERIO_FILTRADO_REPORTES */]});};}/**
 * Select a row filter in modal
 * @param {Number} index 
 * @param {Boolean} checked 
 */function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_52" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES */],payload:{index:index,checked:checked}});};}/**
 * Modify an attribute of a row filter.
 * @param {Number} index 
 * @param {String} attr 
 * @param {*} value 
 */function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_190" /* MODIFICAR_CRITERIO_FILTRADO_REPORTES */],payload:{index:index,attr:attr,value:value}});};}/**
 * Get data of a report with the information of state
 */function applyFilterCriterias(){return function(dispatch,getState){var _getState7=getState(),reportes=_getState7.reportes;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_26" /* APLICAR_CRITERIOS_FILTRADO_REPORTES */]});switch(reportes.get('reportToGet')){case'provider_evaluation':return dispatch(getEvaluacionProveedor());case'contracted_amount_providers':return dispatch(getMontoContratadoProveedor());case'contracted_amount_cencos':return dispatch(getMontoContratadoCenco());case'compliance_purchasing_manager':return dispatch(getCumplimientoResponsableCompras());case'radicados':return dispatch(getReporteRadicados());case'manage_purchasing_manager':return dispatch(getGestionResponsableCompras());default:console.error('no refresh');}};}/**
 * Download a file from server
 * @param {String} ruta 
 * @param {Object} params 
 * @param {String} filename 
 */function downloadFile(ruta,params,filename){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){axios.get(''+__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+ruta,{params:params,responseType:'arraybuffer'}).then(function(res){__WEBPACK_IMPORTED_MODULE_1_react_file_download___default()(res.data,filename);}).catch(function(err){var _err$response=err.response,data=_err$response.data,status=_err$response.status;var decodedString=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(data)));var obj={response:{data:decodedString,status:status}};Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,obj);});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_208" /* MODIFICAR_INPUTS_REPORTES */],payload:{path:path,value:value}});};}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(65);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(274);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(59);
var core = __webpack_require__(54);
var hide = __webpack_require__(89);
var redefine = __webpack_require__(91);
var ctx = __webpack_require__(75);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { tableCols } from '../../containers/Solicitudes'
var ModalFilter=function(_Component){_inherits(ModalFilter,_Component);function ModalFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalFilter.__proto__||Object.getPrototypeOf(ModalFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalFilter');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalFilter .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalFilter(false);},300);},_this.handleApplyFilters=function(e){_this.handleCloseModal();_this.props.applyFilterCriterias();},_this.showTypeInput=function(index,item){var _this$props=_this.props,modalFilter=_this$props.modalFilter,updateModalFilterCriteria=_this$props.updateModalFilterCriteria;var tableCols=modalFilter.get('columns');var value=modalFilter.getIn(['filters',index,'column']);var col=tableCols.filter(function(c){return c.get('value')==value;}).first();if(col.get('enums')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);},value:modalFilter.getIn(['filters',index,'value'])||0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'optDefault',value:0,disabled:true},'Seleccione un tipo de solicitud'),col.get('enums').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+index+']['+n+']',value:x.get('value')},x.get('text'));}));}else if(col.get('type')==='datetime'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalFilter,[{key:'render',value:function render(){var _this2=this;var modalFilter=this.props.modalFilter;if(!modalFilter.get('show')){return null;}var tableCols=modalFilter.get('columns');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalFilter',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Filtro',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalFilter");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus',onClick:function onClick(e){return _this2.props.addModalFilterCriteria();},title:'Aceptar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'trash',onClick:function onClick(e){return _this2.props.removeCheckedModalFilterCriterias();},disabled:modalFilter.get('filters').filter(function(item){return item.get('checked');}).count()===0,title:'Eliminar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',onClick:function onClick(e){return _this2.handleApplyFilters();},title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12',style:{height:'200px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Columna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Operador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Filtro'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalFilter.get('filters').count()>0?modalFilter.get('filters').map(function(item,index){var key='tr2['+index+']';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key,className:''+(item.get('checked')?'info':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.props.toggleCheckedModalFilterCriterias(index,e.target.checked);},checked:item.get('checked')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('column'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'column',e.target.value);}},tableCols.map(function(x1,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+x1.get('id')+']['+n1+']',value:x1.get('value')},x1.get('caption'));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('operator'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'operator',e.target.value);}},__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["H" /* operators */].filter(function(x){return x.comparisons.includes(item.get('comparison'));}).map(function(item1,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+item1.id+']['+n+']',value:item1.value},item1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.showTypeInput(index,item)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',style:{textAlign:'center'}},'No hay filtros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;var reportToGet=reportes.get('reportToGet');return{modalFilter:reportes.getIn([reportToGet,'modalFilter'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_reportes__["m" /* showHideModalFilter */])(state));},addModalFilterCriteria:function addModalFilterCriteria(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_reportes__["a" /* addModalFilterCriteria */])());},removeCheckedModalFilterCriterias:function removeCheckedModalFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_reportes__["k" /* removeCheckedModalFilterCriterias */])());},toggleCheckedModalFilterCriterias:function toggleCheckedModalFilterCriterias(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_reportes__["n" /* toggleCheckedModalFilterCriterias */])(index,checked));},updateModalFilterCriteria:function updateModalFilterCriteria(index,attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_reportes__["p" /* updateModalFilterCriteria */])(index,attr,value));},applyFilterCriterias:function applyFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_reportes__["b" /* applyFilterCriterias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalFilter));

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = getSolicitud;
/* harmony export (immutable) */ __webpack_exports__["e"] = displayModalAddCotizacion;
/* harmony export (immutable) */ __webpack_exports__["f"] = displayModalAddReservacion;
/* unused harmony export displayModalAddAsistencia */
/* harmony export (immutable) */ __webpack_exports__["p"] = removeCotizacion;
/* harmony export (immutable) */ __webpack_exports__["s"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["b"] = addHuesped;
/* harmony export (immutable) */ __webpack_exports__["a"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["c"] = addOrEditCotizacion;
/* harmony export (immutable) */ __webpack_exports__["g"] = editHuesped;
/* harmony export (immutable) */ __webpack_exports__["t"] = updateSolicitudHoteles;
/* harmony export (immutable) */ __webpack_exports__["q"] = seleccionarAprobacion;
/* harmony export (immutable) */ __webpack_exports__["l"] = registerApprovalResult;
/* harmony export (immutable) */ __webpack_exports__["n"] = registerReservaciones;
/* harmony export (immutable) */ __webpack_exports__["o"] = registerReservacionesExpirados;
/* harmony export (immutable) */ __webpack_exports__["m"] = registerCancelacion;
/* harmony export (immutable) */ __webpack_exports__["r"] = solicitarCancelación;
/* harmony export (immutable) */ __webpack_exports__["j"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["h"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["i"] = eliminarComentario;
/* harmony export (immutable) */ __webpack_exports__["d"] = crearAprobacionAdicional;
/* unused harmony export validarSolicitudAprobacionAdicional */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common__ = __webpack_require__(3);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getSolicitud(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+id);};Promise.all([fn0()]).then(function(res){var solicitud=res[0].data.solicitud;var aprobadores=res[0].data.aprobadores;dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_307" /* OBTENER_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});};}function displayModalAddCotizacion(show,title,mode){var index=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_232" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_232" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES */],payload:{show:show}});}};}function displayModalAddReservacion(show,title){var index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_236" /* MOSTRAR_MODAL_ADICIONAR_RESERVACION */],payload:{show:show,title:title,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_236" /* MOSTRAR_MODAL_ADICIONAR_RESERVACION */],payload:{show:show}});}};}function displayModalAddAsistencia(show,title){var index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_231" /* MOSTRAR_MODAL_ADICIONAR_ASISTENCIA */],payload:{show:show,title:title,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_231" /* MOSTRAR_MODAL_ADICIONAR_ASISTENCIA */],payload:{show:show}});}};}function removeCotizacion(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_350" /* REMOVER_COTIZACION_HOTELES */]});};}function updateInputs(path,value){var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var immutable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch){if(path==='comentario.texto'||path.includes('huespedes')||path.includes('ciudad')||path==='modalAddCotizacion.data.descripcion'){var regex=/[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;value=value.replace(regex,"").toUpperCase();}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_215" /* MODIFICAR_INPUTS_SOLICITUD_HOTELES1 */],payload:{path:path,value:value,immutable:immutable}});};fn0(dispatch);var entity=void 0;var attribute=path.split('.').slice(-1)[0];switch(attribute){case'descripcion':case'cotizado':entity='Cotizacione';break;default:}if(entity){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["K" /* ADICIONAR_MODIFICACION_SOLICITUD_HOTELES */],payload:{id:id,entity:entity,attribute:attribute,value:value,action:'edit'}});};fn1(dispatch);}};}function addHuesped(payload){return function(dispatch,getState){var path=payload.path.split('.')[0];var solicitud=getState().solicitudhoteles.get(path).toJS();var huespedes=solicitud.hotel.huespedes;if(huespedes.filter(function(x){return x.id===payload.value.id;}).length!==0){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn('La persona '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{var _solicitud=getState().solicitudhoteles.get(path).toJS();var _huespedes=_solicitud.hotel.huespedes;var huesped=getState().solicitudhoteles.getIn(payload.path.split('.')).toJS();huesped=Object.assign({},huesped,payload.value);huesped.correo=huesped.email;huesped.cedula=huesped.username;payload.value=huesped;dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_215" /* MODIFICAR_INPUTS_SOLICITUD_HOTELES1 */],payload:payload});}};}function addFile(path){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["R" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES */],payload:{path:path,data:data}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}function addOrEditCotizacion(){return function(dispatch,getState){var cotizacion=getState().solicitudhoteles.getIn(['modalAddCotizacion','data']);var errors=validateCotizacion(cotizacion);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var data=getState().solicitudhoteles.getIn(['modalAddCotizacion','data']).set('fecha_entrega',__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')).set('estado',4);var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["n" /* ADICIONAR_COTIZACION_HOTELES */],payload:{data:data}});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_232" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES */],payload:{show:false}});};fn0(dispatch);fn1(dispatch);}};}function editHuesped(index){return function(dispatch,getState){var data=getState().solicitudhoteles.getIn(['modalAddReservacion','data']);var errors=validateReservacion(data);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_227" /* MODIFICAR_RESERVACION */],payload:{index:index,data:data}});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_236" /* MOSTRAR_MODAL_ADICIONAR_RESERVACION */],payload:{show:false}});};fn0(dispatch);fn1(dispatch);}};}function updateSolicitudHoteles(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_108" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_108" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES */],payload:false});};fn0(dispatch);var solicitud=getState().solicitudhoteles.get('id');var solicitudNew=getState().solicitudhoteles.get('solicitud');var solicitudOld=getState().solicitudhoteles.get('unchaged');var files=[];files=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["g" /* attachFilesToEntity */])('Cotizacione',solicitudNew.get('cotizaciones'));var errors=validateSolicitud(solicitudNew);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["u" /* getModificaciones */])(solicitudNew,solicitudOld,'Solicitude',switchDocumento);axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud,modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["f" /* ACTUALIZAR_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn2,fn3,fn4]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function seleccionarAprobacion(indexAprobador,indexAprobacion){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_361" /* SELECCIONAR_APROBACION_SOLICITUD_HOTELES */],payload:{indexAprobador:indexAprobador,indexAprobacion:indexAprobacion}});};}function registerApprovalResult(aprobaciones,result){var ip=__webpack_require__(79);var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudhoteles.get('solicitud');var errors=result>0?validateAprobacion(aprobaciones,result):validateAprobacion(aprobaciones.first().get('observaciones'),result);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];aprobaciones.map(function(a){modificaciones.push({id:a.get('id'),entity:'Aprobacione',value:{estado:result>0?a.get('estado')==1?0:a.get('estado'):0,ip:ip.address(),observaciones:aprobaciones.first().get('observaciones')},action:'edit'});});var disCencos=solicitud.getIn(['hotel','cencos']);disCencos.map(function(c){if(c.getIn(['pivot','rubro_id'])){modificaciones.push({id:c.getIn(['pivot','id']),entity:'DisCencoHotel',value:{rubro_id:c.getIn(['pivot','rubro_id'])},action:'edit'});}});axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["f" /* ACTUALIZAR_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};fn0(dispatch);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido guardada exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}function registerReservaciones(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudhoteles.get('solicitud');var modificaciones=[];var files=void 0;var reservaciones=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List();var huespedes=solicitud.getIn(['hotel','huespedes']);var errors=validateReservaciones(huespedes);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{huespedes.map(function(p){reservaciones=reservaciones.push(p.get('reservacion'));p=p.deleteIn(['reservacion','adjunto']);modificaciones.push({id:p.getIn(['reservacion','id']),entity:'Reservacion',value:p.get('reservacion'),action:'edit'});p.getIn(['reservacion','rutas']).map(function(i){modificaciones.push({id:i.get('id'),entity:'RutasReservacion',value:i,action:'edit'});});});files=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["g" /* attachFilesToEntity */])('Reservacion',reservaciones);axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["f" /* ACTUALIZAR_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn2,fn3,fn4]));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}function registerReservacionesExpirados(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudhoteles.get('solicitud');var rutas=__WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List();//const hoy = new Date(2020, 11, 15)
var hoy=new Date();solicitud.getIn(['hotel','huespedes']).map(function(p){p.getIn(['reservacion','rutas']).filter(function(i){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(i.get('fecha_salida'))<__WEBPACK_IMPORTED_MODULE_1_moment___default()(hoy);}).map(function(x){rutas=rutas.push(x.set('numero_reservacion',p.getIn(['reservacion','numero_reservacion'])));});});var errors=validateReservacionesExpirados(rutas);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];rutas.map(function(i){modificaciones.push({id:i.get('id'),entity:'RutasReservacion',value:{cumplido:i.get('cumplido'),observaciones:i.get('observaciones')},action:'edit'});});axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["f" /* ACTUALIZAR_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}function registerCancelacion(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){//const solicitud = getState().solicitudhoteles.get('solicitud').set('estado', 0)
var solicitud=getState().solicitudhoteles.get('solicitud');var errors=validateSolicitud(solicitud,{cancelar:true});if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{motivo_cancelacion:solicitud.get('motivo_cancelacion'),fecha_cancelacion:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')},action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["f" /* ACTUALIZAR_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}function solicitarCancelación(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudhoteles.get('solicitud');var errors=validateSolicitud(solicitud);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',value:{motivo_cancelacion:solicitud.get('motivo_cancelacion')},action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["f" /* ACTUALIZAR_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});};var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn0(dispatch);fn1();}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}function enviarComentario(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud_id=getState().solicitudhoteles.getIn(['solicitud','id']);var usuario_id=getState().common.getIn(['user','id']);var id=getState().solicitudhoteles.getIn(['comentario','id']);var comentario=getState().solicitudhoteles.getIn(['comentario','texto']);var modificaciones=[];if(id==null){modificaciones.push({entity:'Foro',action:'add',id:null,value:{solicitud_id:solicitud_id,usuario_id:usuario_id,comentario:comentario}});}else{modificaciones.push({id:id,entity:'Foro',value:{comentario:comentario},action:'edit'});}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_86" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1 */],payload:true});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_86" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1 */],payload:false});};fn1(dispatch);axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud_id,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_161" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1 */],payload:{foros:foros}});};fn3(dispatch);fn2(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);fn2(dispatch);});};}function editarComentario(id){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_114" /* EDITAR_COMENTARIO_SOLICITUD_HOTELES1 */],payload:{id:id}});};fn1(dispatch);};}function eliminarComentario(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var solicitud=getState().solicitudhoteles.getIn(['solicitud','id']);var modificaciones=[];modificaciones.push({entity:'Foro',id:id,action:'delete',value:null});axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud,modificaciones).then(function(res){var foros=res.data.solicitud.foros;var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_161" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1 */],payload:{foros:foros}});};fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,{success:'La eliminacion han sido realizada exitosamente'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});};}///******* Shared ********///
var validateSolicitud=function validateSolicitud(data){var extra=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errors=[];if(extra&&extra.cancelar&&!data.get('motivo_cancelacion'))errors.push('El campo motivo cancelación es obligatorio');//const cantpagado = data.getIn(['hotel', 'huespedes']).filter(x => x.getIn(['reservacion', 'valor_pagado']) > 0).count()
// if (cantpagado > 0) errors.push('No es posible cancelar la solicitud con reservaciones pagadas')
return errors;};var validateCotizacion=function validateCotizacion(data){var errors=[];if(!data.get('descripcion'))errors.push('El campo proveedor alojamiento es obligatorio');if(!data.get('cotizado')||data.get('cotizado')<=0)errors.push('El campo valor cotizado es obligatorio');if(!data.getIn(['adjunto','file']))errors.push('El campo pantallazo cotización es obligatorio');return errors;};var validateAprobacion=function validateAprobacion(data,extra){var errors=[];if(extra==2&&data.filter(function(x){return x.get('estado')==2;}).count()==0)errors.push('Debe seleccionar una cotización para aprobar');if(extra==2&&data.filter(function(x){return x.get('estado')==2;}).count()>1)errors.push('Sólo xdbe seleccionar una cotización para aprobar');if(extra==0&&!data)errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones');return errors;};var validateReservacion=function validateReservacion(data){var errors=[];if(!data.getIn(['reservacion','proveedor_alojamiento']))errors.push('El campo proveedor alojamiento es obligatorio');if(!data.getIn(['reservacion','numero_reservacion']))errors.push('El campo número reservacion es obligatorio');if(!data.getIn(['reservacion','fecha_compra']))errors.push('El campo fecha de compra es obligatorio');if(!data.getIn(['reservacion','valor_pagado']))errors.push('El campo valor es obligatorio');if(!data.getIn(['reservacion','adjunto','file']))errors.push('El campo reservacion es obligatorio');var tipo_trayecto=data.getIn(['hotel','tipo_trayecto']);data.getIn(['reservacion','rutas']).map(function(i){if(i.get('fecha_salida').split(" ")[0]=="")errors.push('El campo fecha salida es obligatorio');if(i.get('fecha_salida').split(" ")[1]=="")errors.push('El campo hora salida es obligatorio');if(tipo_trayecto==1){if(i.get('fecha_llegada').split(" ")[0]=="")errors.push('El campo fecha llegada es obligatorio');if(i.get('fecha_llegada').split(" ")[1]=="")errors.push('El campo hora llegada es obligatorio');}});if(data.getIn(['reservacion','fecha_compra'])&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.getIn(['reservacion','fecha_compra']))>__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()))errors.push('La fecha de compra debe ser menor o igual a la fecha actual');return errors;};var validateAsistencia=function validateAsistencia(data){var errors=[];if(!data.getIn(['asistencia','numero_voucher']))errors.push('El campo número voucher es obligatorio');if(!data.getIn(['asistencia','fecha_compra']))errors.push('El campo fecha de compra es obligatorio');if(!data.getIn(['asistencia','valor']))errors.push('El campo valor es obligatorio');if(!data.getIn(['asistencia','adjunto','id'])&&!data.getIn(['asistencia','adjunto','file']))errors.push('El campo voucher es obligatorio');if(data.getIn(['asistencia','fecha_compra'])&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.getIn(['asistencia','fecha_compra']))>__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()))errors.push('La fecha de compra debe ser menor o igual a la fecha actual');return errors;};var validateReservaciones=function validateReservaciones(data){var errors=[];data.map(function(p,i){if(validateReservacion(p).length>0){errors.push('Faltan datos en huesped No. '+(i+1));}});return errors;};var validateReservacionesExpirados=function validateReservacionesExpirados(data){var errors=[];data.map(function(t){if(t.get('cumplido')==null)errors.push('El campo cumplido es obligatorio en el reservacion No. '+t.get('numero_reservacion'));if(t.get('cumplido')==0&&!t.get('observaciones'))errors.push('El campo observaciones es obligatorio en el reservacion No. '+t.get('numero_reservacion'));});return errors;};var switchDocumento=function switchDocumento(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];if(modificacion.attribute==='responsable_compras'){modificacion.action='hidden';}switch(change.get('op')){case'add':if(modificacion.attribute==='cotizaciones'){modificacion.action='create';}if(modificacion.attribute==='adjunto'){modificacion.action='hidden';}if(modificacion.attribute==='foros'){modificacion.action='create';}break;case'remove':if(modificacion.attribute==='cotizaciones'){modificacion.action='detach';}break;}};function crearAprobacionAdicional(aprobador,motivo){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var errors=validarSolicitudAprobacionAdicional(aprobador,motivo);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});return;}var solicitud=getState().solicitudhoteles.get('solicitud');var cotizaciones=solicitud.get('cotizaciones');var modificaciones=[];if(cotizaciones&&cotizaciones.size>0){cotizaciones.forEach(function(cotizacion){modificaciones.push({id:null,entity:'Aprobacione',action:'add',value:{cotizacion_id:cotizacion.get('id'),aprobador_id:aprobador.id,estado:1,// Pendiente de aprobación
observaciones:motivo,tipo:3}});});}axios.put(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles/'+solicitud.get('id'),modificaciones).then(function(res){var solicitud=res.data.solicitud;var aprobadores=res.data.aprobadores;dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_307" /* OBTENER_SOLICITUD_HOTELES */],payload:{solicitud:solicitud,aprobadores:aprobadores}});__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Solicitud de aprobación adicional enviada correctamente',{bodyClassName:'toastify-content toastify-success'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});};}var validarSolicitudAprobacionAdicional=function validarSolicitudAprobacionAdicional(aprobador,motivo){var errors=[];if(!aprobador||!aprobador.id)errors.push('Debe seleccionar un aprobador adicional');if(!motivo||!motivo.trim())errors.push('El motivo de la solicitud adicional es obligatorio');return errors;};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(51);
var IE8_DOM_DEFINE = __webpack_require__(263);
var toPrimitive = __webpack_require__(163);
var dP = Object.defineProperty;

exports.f = __webpack_require__(58) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(85)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getSolicitud;
/* harmony export (immutable) */ __webpack_exports__["d"] = displayModalCreateDocumento;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["c"] = createOrUpdateDocumento;
/* harmony export (immutable) */ __webpack_exports__["h"] = showHideModalAddFirmas;
/* harmony export (immutable) */ __webpack_exports__["j"] = uploadFirmasFile;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeDocumento;
/* harmony export (immutable) */ __webpack_exports__["f"] = previewDocumento;
/* harmony export (immutable) */ __webpack_exports__["a"] = cancelSolicitud;
/* harmony export (immutable) */ __webpack_exports__["g"] = renewContrato;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_file_download__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__documentos__ = __webpack_require__(25);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getSolicitud(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* API_URL */]+'/solicitudes/contratos-anuales/'+id).then(function(res){var solicitud=res.data.solicitud;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_306" /* OBTENER_SOLICITUD_CONTRATOANUAL */],payload:{solicitud:solicitud}});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});};}function displayModalCreateDocumento(show,title,indexDocumento){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* API_URL */]+'/plantillas');};Promise.all([fn0()]).then(function(res){var plantillas=res[0].data.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_259" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL */],payload:{show:show,title:title,indexDocumento:indexDocumento,plantillas:plantillas}});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});};}function updateInputs(path,value){var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var immutable=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_213" /* MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1 */],payload:{path:path,value:value,immutable:immutable}});};fn0(dispatch);var entity=void 0;var attribute=path.split('.').slice(-1)[0];switch(attribute){case'fecha_inicio':case'fecha_entrega':entity='Documento';break;default:}if(entity){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["J" /* ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL */],payload:{id:id,entity:entity,attribute:attribute,value:value,action:'edit'}});};fn1(dispatch);}};}function createOrUpdateDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn3=function fn3(d){return d(displayModalCreateDocumento(false));};var solicitud=getState().contratoanual.get('id');var data=getState().contratoanual.get('modalCreateDocumento');var documentoNew=data.get('data');var documentoOld=data.get('unchanged');documentoNew=documentoNew.set('estado',2);var errors=validateDocumento(documentoNew);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["u" /* getModificaciones */])(documentoNew,documentoOld,'Documento',switchDocumento);dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_90" /* DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO */],payload:true});axios.put(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* API_URL */]+'/solicitudes/contratos-anuales/'+solicitud,modificaciones).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_6__types__["_90" /* DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO */],payload:false});var solicitud=res.data.solicitud;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["e" /* ACTUALIZAR_SOLICITUD_CONTRATOANUAL */],payload:{solicitud:solicitud}});};fn2(dispatch);fn3(dispatch);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}function showHideModalAddFirmas(show,solicitud){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_239" /* MOSTRAR_MODAL_ADICION_FIRMAS */],payload:{show:show,solicitud:solicitud}});};fn0(dispatch);};}function uploadFirmasFile(file){return function(dispatch){var fileType=__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["a" /* acceptedFiles */].filter(function(x){return x.type===file.type;});var icon='_blank.png';if(fileType.length===1){icon=fileType[0].icon;}var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_213" /* MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1 */],payload:{path:'modalAddFirmas.data.file',value:file,immutable:false}});};fn1(dispatch);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_213" /* MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1 */],payload:{path:'modalAddFirmas.data.icono',value:icon}});};fn2(dispatch);};}function closeDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn1=function fn1(d){return d(displayModalCreateDocumento(false));};var data=getState().documentos.get('modalSummary');var documentoOld=data.get('unchanged');var documentoNew=data.get('data');var solicitud=documentoNew.getIn(['solicitude','id']);var estado=void 0;if(__WEBPACK_IMPORTED_MODULE_1_moment___default()(documentoNew.get('fecha_inicio')).isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()())){estado=13;}else{estado=12;}documentoNew=documentoNew.set('estado',estado);var file=getState().contratoanual.getIn(['modalAddFirmas','data']);var modificaciones=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["u" /* getModificaciones */])(documentoNew,documentoOld,'Documento',switchDocumento);axios.put(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* API_URL */]+'/solicitudes/contratos-anuales/'+solicitud,modificaciones).then(function(res){var solicitud=res.data.solicitud;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["e" /* ACTUALIZAR_SOLICITUD_CONTRATOANUAL */],payload:{solicitud:solicitud}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};var fn4=function fn4(d){return d(Object(__WEBPACK_IMPORTED_MODULE_8__documentos__["e" /* getDocumento */])(documentoOld.get('id')));};dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common__["F" /* uploadFiles */])('/files/'+solicitud.id,[file],[fn1,fn2,fn3,fn4]));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});};}function previewDocumento(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var documento=getState().contratoanual.getIn(['modalCreateDocumento','data']);var tipo=getState().common.getIn(['enums','documentos','tipos',''+documento.get('tipo'),'NOMBRE']);axios.post(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* API_URL */]+'/solicitudes/contratos-anuales/view/'+id,{documento:documento},{responseType:'arraybuffer'}).then(function(res){__WEBPACK_IMPORTED_MODULE_2_react_file_download___default()(res.data,'PREV-'+tipo+'.pdf');}).catch(function(err){var decodedString=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(err.response.data)));var obj={response:{data:decodedString,status:422}};Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,obj);});};}function cancelSolicitud(){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var id=getState().contratoanual.get('id');var solicitud=getState().contratoanual.get('solicitud').set('estado',0);var errors=validateSolicitud(solicitud);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',attribute:'estado',value:0,action:'edit'});modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',attribute:'fecha_cancelacion',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),action:'edit'});modificaciones.push({id:solicitud.get('id'),entity:'Solicitude',attribute:'motivo_cancelacion',value:solicitud.get('motivo_cancelacion'),action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* API_URL */]+'/solicitudes/contratos-anuales/'+id,modificaciones).then(function(res){var solicitud=res.data.solicitud;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["e" /* ACTUALIZAR_SOLICITUD_CONTRATOANUAL */],payload:{solicitud:solicitud}});};fn2(dispatch);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}function renewContrato(result){var axios=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var data=getState().documentos.get('modalSummary');var documento=result==1?data.get('data'):data.get('data').set('estado',14);var solicitud=documento.getIn(['solicitude','id']);var observaciones=documento.get('motivo_no_renovacion');var errors=validateDocumento(documento);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var id=getState().contratoanual.get('id');axios.put(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* API_URL */]+'/solicitudes/contratos-anuales/renew/'+solicitud,{result:result,observaciones:observaciones}).then(function(res){var solicitud=res.data.solicitud;var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_306" /* OBTENER_SOLICITUD_CONTRATOANUAL */],payload:{solicitud:solicitud}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_6__types__["_279" /* MOSTRAR_MODAL_RESUMEN_DOCUMENTO */],payload:{show:false}});};var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('La solicitud de renovación ha sido realizada exitosamente',{bodyClassName:'toastify-content toastify-success'});};var fn4=function fn4(d){return __WEBPACK_IMPORTED_MODULE_3__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};fn1(dispatch);fn2(dispatch);fn3();fn4(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);});}};}///******* Shared ********///
var validateDocumento=function validateDocumento(data){var errors=[];if(data.get('estado')==2&&!data.get('fecha_inicio'))errors.push('El campo fecha inicio es obligatorio');if(data.get('estado')==2&&!data.get('plantilla_id'))errors.push('Debe seleccionar una plantilla');var firstDay=__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(new Date().getFullYear(),0,1));if(data.get('estado')==2&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(data.get('fecha_inicio')).isBefore(firstDay))errors.push('La fecha de inicio del contrato no debe ser inferior a la fecha de inicio del año');if(data.get('estado')==14&&!data.get('motivo_no_renovacion'))errors.push('El campo motivo no renovación es obligatorio');return errors;};var validateSolicitud=function validateSolicitud(data){var errors=[];if(data.get('estado')==0&&!data.get('motivo_cancelacion'))errors.push('El campo motivo es obligatorio');return errors;};var switchDocumento=function switchDocumento(change,modificacion){var path=[].concat(_toConsumableArray(modificacion.attribute));modificacion.attribute=path[0];switch(change.get('op')){case'add':if(modificacion.attribute==='adjuntos'){modificacion.action='hidden';}break;case'remove':break;}};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function(data, filename, mime) {
    var blob = new Blob([data], {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were 
        // revoked by closing the blob for which they were created. 
        // These URLs will no longer resolve as the data backing 
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename); 
        
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking 
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }
        
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
    }
}


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initReducer */
/* harmony export (immutable) */ __webpack_exports__["b"] = getSolicitud;
/* harmony export (immutable) */ __webpack_exports__["a"] = createOtrosi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__solicitudservicioot__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__documentos__ = __webpack_require__(25);
function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_358" /* RESETEAR_REDUCER_SOLICITUD_OTROSI */]});};}function getSolicitud(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_3____["b" /* API_URL */]+'/solicitudes/otrosi/'+id).then(function(res){var solicitud=res.data.solicitud;dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_308" /* OBTENER_SOLICITUD_OTROSI */],payload:{solicitud:solicitud}});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}function createOtrosi(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var modalAddAdicional=getState().documentos.get('modalAddAdicional');var otrosi=modalAddAdicional.get('data');otrosi=otrosi.set('documento_id',getState().documentos.getIn(['modalSummary','data','id']));axios.post(__WEBPACK_IMPORTED_MODULE_3____["b" /* API_URL */]+'/solicitudes/otrosi',otrosi).then(function(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__documentos__["i" /* showHideModalAddAdicional */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["t" /* showHideModalCreateOtrosi */])(false));dispatch(initReducer());dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__solicitudservicioot__["g" /* displayModalCreateDocumento */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__documentos__["k" /* showHideModalSummary */])(false));__WEBPACK_IMPORTED_MODULE_5__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{success:'Los cambios han sido guardados exitosamente'});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(57);
var createDesc = __webpack_require__(100);
module.exports = __webpack_require__(58) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(269);
var defined = __webpack_require__(158);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(90);
var IE8_DOM_DEFINE = __webpack_require__(299);
var toPrimitive = __webpack_require__(301);
var dP = Object.defineProperty;

exports.f = __webpack_require__(74) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(133)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(303);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(206);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
exports.speedy = speedy;
exports.simulations = simulations;
exports.simulate = simulate;
exports.cssLabels = cssLabels;
exports.isLikeRule = isLikeRule;
exports.idFor = idFor;
exports.css = css;
exports.rehydrate = rehydrate;
exports.flush = flush;
exports.select = select;
exports.parent = parent;
exports.media = media;
exports.pseudo = pseudo;
exports.active = active;
exports.any = any;
exports.checked = checked;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports._default = _default;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.fullscreen = fullscreen;
exports.focus = focus;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.left = left;
exports.link = link;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.right = right;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.dir = dir;
exports.lang = lang;
exports.not = not;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.selection = selection;
exports.backdrop = backdrop;
exports.placeholder = placeholder;
exports.cssFor = cssFor;
exports.attribsFor = attribsFor;

var _objectAssign = __webpack_require__(66);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _sheet = __webpack_require__(363);

var _CSSPropertyOperations = __webpack_require__(213);

var _clean = __webpack_require__(372);

var _clean2 = _interopRequireDefault(_clean);

var _plugins = __webpack_require__(373);

var _hash = __webpack_require__(390);

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* stylesheet */


var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
// an isomorphic StyleSheet shim. hides all the nitty gritty.

// /**************** LIFTOFF IN 3... 2... 1... ****************/
styleSheet.inject(); //eslint-disable-line indent
// /****************      TO THE MOOOOOOON     ****************/

// convenience function to toggle speedy
function speedy(bool) {
  return styleSheet.speedy(bool);
}

// plugins
// we include these by default
var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
plugins.fontFace = new _plugins.PluginSet();
plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);

// define some constants

var isDev = "production" === 'development' || !"production";
var isTest = "production" === 'test';
var isBrowser = typeof window !== 'undefined';

/**** simulations  ****/

// a flag to enable simulation meta tags on dom nodes
// defaults to true in dev mode. recommend *not* to
// toggle often.
var canSimulate = isDev;

// we use these flags for issuing warnings when simulate is called
// in prod / in incorrect order
var warned1 = false,
    warned2 = false;

// toggles simulation activity. shouldn't be needed in most cases
function simulations() {
  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  canSimulate = !!bool;
}

// use this on dom nodes to 'simulate' pseudoclasses
// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
// you can even send in some weird ones, as long as it's in simple format
// and matches an existing rule on the element
// eg simulate('nthChild2', ':hover:active') etc
function simulate() {
  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
    pseudos[_key] = arguments[_key];
  }

  pseudos = (0, _clean2.default)(pseudos);
  if (!pseudos) return {};
  if (!canSimulate) {
    if (!warned1) {
      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
      warned1 = true;
    }
    if (!isDev && !isTest && !warned2) {
      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
      warned2 = true;
    }
    return {};
  }
  return pseudos.reduce(function (o, p) {
    return o['data-simulate-' + simple(p)] = '', o;
  }, {});
}

/**** labels ****/
// toggle for debug labels.
// *shouldn't* have to mess with this manually
var hasLabels = isDev;

function cssLabels(bool) {
  hasLabels = !!bool;
}

// takes a string, converts to lowercase, strips out nonalphanumeric.
function simple(str) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
}

// hashes a string to something 'unique'
// we use this to generate ids for styles


function hashify(obj) {
  var str = JSON.stringify(obj);
  var toRet = (0, _hash2.default)(str).toString(36);
  if (obj.label && obj.label.length > 0 && isDev) {
    return simple(obj.label.join('.'), '-') + '-' + toRet;
  }
  return toRet;
}

// of shape { 'data-css-<id>': '' }
function isLikeRule(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) {
    return false;
  }
  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
}

// extracts id from a { 'data-css-<id>': ''} like object
function idFor(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) throw new Error('not a rule');
  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
  var match = regex.exec(keys[0]);
  if (!match) throw new Error('not a rule');
  return match[1];
}

// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61

// "Tokenizes" the selectors into parts relevant for the next function.
// Strings and comments are matched, but ignored afterwards.
// This is not a full tokenizers. It only recognizes comas, parentheses,
// strings and comments.
// regexp generated by scripts/regexps.js then trimmed by hand
var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;

/**
 * This will split a coma-separated selector list into individual selectors,
 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
 *
 * @param {string} selector
 * @return {string[]}
 */

function splitSelector(selector) {
  if (selector.indexOf(',') === -1) {
    return [selector];
  }

  var indices = [],
      res = [],
      inParen = 0,
      o;
  /*eslint-disable no-cond-assign*/
  while (o = selectorTokenizer.exec(selector)) {
    /*eslint-enable no-cond-assign*/
    switch (o[0]) {
      case '(':
        inParen++;break;
      case ')':
        inParen--;break;
      case ',':
        if (inParen) break;indices.push(o.index);
    }
  }
  for (o = indices.length; o--;) {
    res.unshift(selector.slice(indices[o] + 1));
    selector = selector.slice(0, indices[o]);
  }
  res.unshift(selector);
  return res;
}

function selector(id, path) {
  if (!id) {
    return path.replace(/\&/g, '');
  }
  if (!path) return '.css-' + id + ',[data-css-' + id + ']';

  var x = splitSelector(path).map(function (x) {
    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
  }).join(',');

  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
  }
  return x;
}

// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61


function toCSS(_ref) {
  var selector = _ref.selector,
      style = _ref.style;

  var result = plugins.transform({ selector: selector, style: style });
  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
}

function deconstruct(style) {
  // we can be sure it's not infinitely nested here
  var plain = void 0,
      selects = void 0,
      medias = void 0,
      supports = void 0;
  Object.keys(style).forEach(function (key) {
    if (key.indexOf('&') >= 0) {
      selects = selects || {};
      selects[key] = style[key];
    } else if (key.indexOf('@media') === 0) {
      medias = medias || {};
      medias[key] = deconstruct(style[key]);
    } else if (key.indexOf('@supports') === 0) {
      supports = supports || {};
      supports[key] = deconstruct(style[key]);
    } else if (key === 'label') {
      if (style.label.length > 0) {
        plain = plain || {};
        plain.label = hasLabels ? style.label.join('.') : '';
      }
    } else {
      plain = plain || {};
      plain[key] = style[key];
    }
  });
  return { plain: plain, selects: selects, medias: medias, supports: supports };
}

function deconstructedStyleToCSS(id, style) {
  var css = [];

  // plugins here
  var plain = style.plain,
      selects = style.selects,
      medias = style.medias,
      supports = style.supports;

  if (plain) {
    css.push(toCSS({ style: plain, selector: selector(id) }));
  }
  if (selects) {
    Object.keys(selects).forEach(function (key) {
      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
    });
  }
  if (medias) {
    Object.keys(medias).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
    });
  }
  if (supports) {
    Object.keys(supports).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
    });
  }
  return css;
}

// this cache to track which rules have
// been inserted into the stylesheet
var inserted = styleSheet.inserted = {};

// and helpers to insert rules into said styleSheet
function insert(spec) {
  if (!inserted[spec.id]) {
    inserted[spec.id] = true;
    var deconstructed = deconstruct(spec.style);
    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
    inserted[spec.id] = isBrowser ? true : rules;
    rules.forEach(function (cssRule) {
      return styleSheet.insert(cssRule);
    });
  }
}

// a simple cache to store generated rules
var registered = styleSheet.registered = {};
function register(spec) {
  if (!registered[spec.id]) {
    registered[spec.id] = spec;
  }
}

function _getRegistered(rule) {
  if (isLikeRule(rule)) {
    var ret = registered[idFor(rule)];
    if (ret == null) {
      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
    }
    return ret;
  }
  return rule;
}

// todo - perf
var ruleCache = {};
function toRule(spec) {
  register(spec);
  insert(spec);

  if (ruleCache[spec.id]) {
    return ruleCache[spec.id];
  }

  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
  Object.defineProperty(ret, 'toString', {
    enumerable: false, value: function value() {
      return 'css-' + spec.id;
    }
  });
  ruleCache[spec.id] = ret;
  return ret;
}

function log() {
  //eslint-disable-line no-unused-vars
  console.log(this); //eslint-disable-line no-console
  return this;
}

function isSelector(key) {
  var possibles = [':', '.', '[', '>', ' '],
      found = false,
      ch = key.charAt(0);
  for (var i = 0; i < possibles.length; i++) {
    if (ch === possibles[i]) {
      found = true;
      break;
    }
  }
  return found || key.indexOf('&') >= 0;
}

function joinSelectors(a, b) {
  var as = splitSelector(a).map(function (a) {
    return !(a.indexOf('&') >= 0) ? '&' + a : a;
  });
  var bs = splitSelector(b).map(function (b) {
    return !(b.indexOf('&') >= 0) ? '&' + b : b;
  });

  return bs.reduce(function (arr, b) {
    return arr.concat(as.map(function (a) {
      return b.replace(/\&/g, a);
    }));
  }, []).join(',');
}

function joinMediaQueries(a, b) {
  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
}

function isMediaQuery(key) {
  return key.indexOf('@media') === 0;
}

function isSupports(key) {
  return key.indexOf('@supports') === 0;
}

function joinSupports(a, b) {
  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
}

// flatten a nested array
function flatten(inArr) {
  var arr = [];
  for (var i = 0; i < inArr.length; i++) {
    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
  }
  return arr;
}

var prefixedPseudoSelectors = {
  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']

  // mutable! modifies dest.
};function build(dest, _ref2) {
  var _ref2$selector = _ref2.selector,
      selector = _ref2$selector === undefined ? '' : _ref2$selector,
      _ref2$mq = _ref2.mq,
      mq = _ref2$mq === undefined ? '' : _ref2$mq,
      _ref2$supp = _ref2.supp,
      supp = _ref2$supp === undefined ? '' : _ref2$supp,
      _ref2$src = _ref2.src,
      src = _ref2$src === undefined ? {} : _ref2$src;


  if (!Array.isArray(src)) {
    src = [src];
  }
  src = flatten(src);

  src.forEach(function (_src) {
    if (isLikeRule(_src)) {
      var reg = _getRegistered(_src);
      if (reg.type !== 'css') {
        throw new Error('cannot merge this rule');
      }
      _src = reg.style;
    }
    _src = (0, _clean2.default)(_src);
    if (_src && _src.composes) {
      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
    }
    Object.keys(_src || {}).forEach(function (key) {
      if (isSelector(key)) {

        if (prefixedPseudoSelectors[key]) {
          prefixedPseudoSelectors[key].forEach(function (p) {
            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
          });
        }

        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
      } else if (isMediaQuery(key)) {
        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
      } else if (isSupports(key)) {
        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
      } else if (key === 'composes') {
        // ignore, we already dealth with it
      } else {
        var _dest = dest;
        if (supp) {
          _dest[supp] = _dest[supp] || {};
          _dest = _dest[supp];
        }
        if (mq) {
          _dest[mq] = _dest[mq] || {};
          _dest = _dest[mq];
        }
        if (selector) {
          _dest[selector] = _dest[selector] || {};
          _dest = _dest[selector];
        }

        if (key === 'label') {
          if (hasLabels) {
            dest.label = dest.label.concat(_src.label);
          }
        } else {
          _dest[key] = _src[key];
        }
      }
    });
  });
}

function _css(rules) {
  var style = { label: [] };
  build(style, { src: rules }); // mutative! but worth it.

  var spec = {
    id: hashify(style),
    style: style, label: hasLabels ? style.label.join('.') : '',
    type: 'css'
  };
  return toRule(spec);
}

var nullrule = {
  // 'data-css-nil': ''
};
Object.defineProperty(nullrule, 'toString', {
  enumerable: false, value: function value() {
    return 'css-nil';
  }
});

var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];

var warnedWeakMapError = false;
function multiIndexCache(fn) {
  return function (args) {
    if (inputCaches[args.length]) {
      var coi = inputCaches[args.length];
      var ctr = 0;
      while (ctr < args.length - 1) {
        if (!coi.has(args[ctr])) {
          coi.set(args[ctr], new WeakMap());
        }
        coi = coi.get(args[ctr]);
        ctr++;
      }
      if (coi.has(args[args.length - 1])) {
        var ret = coi.get(args[ctr]);

        if (registered[ret.toString().substring(4)]) {
          // make sure it hasn't been flushed
          return ret;
        }
      }
    }
    var value = fn(args);
    if (inputCaches[args.length]) {
      var _ctr = 0,
          _coi = inputCaches[args.length];
      while (_ctr < args.length - 1) {
        _coi = _coi.get(args[_ctr]);
        _ctr++;
      }
      try {
        _coi.set(args[_ctr], value);
      } catch (err) {
        if (isDev && !warnedWeakMapError) {
          var _console;

          warnedWeakMapError = true;
          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
        }
      }
    }
    return value;
  };
}

var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;

function css() {
  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rules[_key2] = arguments[_key2];
  }

  if (rules[0] && rules[0].length && rules[0].raw) {
    throw new Error('you forgot to include glamor/babel in your babel plugins.');
  }

  rules = (0, _clean2.default)(rules);
  if (!rules) {
    return nullrule;
  }

  return cachedCss(rules);
}

css.insert = function (css) {
  var spec = {
    id: hashify(css),
    css: css,
    type: 'raw'
  };
  register(spec);
  if (!inserted[spec.id]) {
    styleSheet.insert(spec.css);
    inserted[spec.id] = isBrowser ? true : [spec.css];
  }
};

var insertRule = exports.insertRule = css.insert;

css.global = function (selector, style) {
  style = (0, _clean2.default)(style);
  if (style) {
    return css.insert(toCSS({ selector: selector, style: style }));
  }
};

var insertGlobal = exports.insertGlobal = css.global;

function insertKeyframe(spec) {
  if (!inserted[spec.id]) {
    var inner = Object.keys(spec.keyframes).map(function (kf) {
      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
    }).join('');

    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
    });
    rules.forEach(function (rule) {
      return styleSheet.insert(rule);
    });

    inserted[spec.id] = isBrowser ? true : rules;
  }
}
css.keyframes = function (name, kfs) {
  if (!kfs) {
    kfs = name, name = 'animation';
  }

  // do not ignore empty keyframe definitions for now.
  kfs = (0, _clean2.default)(kfs) || {};
  var spec = {
    id: hashify({ name: name, kfs: kfs }),
    type: 'keyframes',
    name: name,
    keyframes: kfs
  };
  register(spec);
  insertKeyframe(spec);
  return name + '_' + spec.id;
};

// we don't go all out for fonts as much, giving a simple font loading strategy
// use a fancier lib if you need moar power
css.fontFace = function (font) {
  font = (0, _clean2.default)(font);
  var spec = {
    id: hashify(font),
    type: 'font-face',
    font: font
  };
  register(spec);
  insertFontFace(spec);

  return font.fontFamily;
};

var fontFace = exports.fontFace = css.fontFace;
var keyframes = exports.keyframes = css.keyframes;

function insertFontFace(spec) {
  if (!inserted[spec.id]) {
    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
    styleSheet.insert(rule);
    inserted[spec.id] = isBrowser ? true : [rule];
  }
}

// rehydrate the insertion cache with ids sent from
// renderStatic / renderStaticOptimized
function rehydrate(ids) {
  // load up ids
  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
    return o[i] = true, o;
  }, {}));
  // assume css loaded separately
}

// clears out the cache and empties the stylesheet
// best for tests, though there might be some value for SSR.

function flush() {
  inserted = styleSheet.inserted = {};
  registered = styleSheet.registered = {};
  ruleCache = {};
  styleSheet.flush();
  styleSheet.inject();
}

var presets = exports.presets = {
  mobile: '(min-width: 400px)',
  Mobile: '@media (min-width: 400px)',
  phablet: '(min-width: 550px)',
  Phablet: '@media (min-width: 550px)',
  tablet: '(min-width: 750px)',
  Tablet: '@media (min-width: 750px)',
  desktop: '(min-width: 1000px)',
  Desktop: '@media (min-width: 1000px)',
  hd: '(min-width: 1200px)',
  Hd: '@media (min-width: 1200px)'
};

var style = exports.style = css;

function select(selector) {
  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    styles[_key3 - 1] = arguments[_key3];
  }

  if (!selector) {
    return style(styles);
  }
  return css(_defineProperty({}, selector, styles));
}
var $ = exports.$ = select;

function parent(selector) {
  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    styles[_key4 - 1] = arguments[_key4];
  }

  return css(_defineProperty({}, selector + ' &', styles));
}

var merge = exports.merge = css;
var compose = exports.compose = css;

function media(query) {
  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    rules[_key5 - 1] = arguments[_key5];
  }

  return css(_defineProperty({}, '@media ' + query, rules));
}

function pseudo(selector) {
  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    styles[_key6 - 1] = arguments[_key6];
  }

  return css(_defineProperty({}, selector, styles));
}

// allllll the pseudoclasses

function active(x) {
  return pseudo(':active', x);
}

function any(x) {
  return pseudo(':any', x);
}

function checked(x) {
  return pseudo(':checked', x);
}

function disabled(x) {
  return pseudo(':disabled', x);
}

function empty(x) {
  return pseudo(':empty', x);
}

function enabled(x) {
  return pseudo(':enabled', x);
}

function _default(x) {
  return pseudo(':default', x); // note '_default' name
}

function first(x) {
  return pseudo(':first', x);
}

function firstChild(x) {
  return pseudo(':first-child', x);
}

function firstOfType(x) {
  return pseudo(':first-of-type', x);
}

function fullscreen(x) {
  return pseudo(':fullscreen', x);
}

function focus(x) {
  return pseudo(':focus', x);
}

function hover(x) {
  return pseudo(':hover', x);
}

function indeterminate(x) {
  return pseudo(':indeterminate', x);
}

function inRange(x) {
  return pseudo(':in-range', x);
}

function invalid(x) {
  return pseudo(':invalid', x);
}

function lastChild(x) {
  return pseudo(':last-child', x);
}

function lastOfType(x) {
  return pseudo(':last-of-type', x);
}

function left(x) {
  return pseudo(':left', x);
}

function link(x) {
  return pseudo(':link', x);
}

function onlyChild(x) {
  return pseudo(':only-child', x);
}

function onlyOfType(x) {
  return pseudo(':only-of-type', x);
}

function optional(x) {
  return pseudo(':optional', x);
}

function outOfRange(x) {
  return pseudo(':out-of-range', x);
}

function readOnly(x) {
  return pseudo(':read-only', x);
}

function readWrite(x) {
  return pseudo(':read-write', x);
}

function required(x) {
  return pseudo(':required', x);
}

function right(x) {
  return pseudo(':right', x);
}

function root(x) {
  return pseudo(':root', x);
}

function scope(x) {
  return pseudo(':scope', x);
}

function target(x) {
  return pseudo(':target', x);
}

function valid(x) {
  return pseudo(':valid', x);
}

function visited(x) {
  return pseudo(':visited', x);
}

// parameterized pseudoclasses
function dir(p, x) {
  return pseudo(':dir(' + p + ')', x);
}
function lang(p, x) {
  return pseudo(':lang(' + p + ')', x);
}
function not(p, x) {
  // should this be a plugin?
  var selector = p.split(',').map(function (x) {
    return x.trim();
  }).map(function (x) {
    return ':not(' + x + ')';
  });
  if (selector.length === 1) {
    return pseudo(':not(' + p + ')', x);
  }
  return select(selector.join(''), x);
}
function nthChild(p, x) {
  return pseudo(':nth-child(' + p + ')', x);
}
function nthLastChild(p, x) {
  return pseudo(':nth-last-child(' + p + ')', x);
}
function nthLastOfType(p, x) {
  return pseudo(':nth-last-of-type(' + p + ')', x);
}
function nthOfType(p, x) {
  return pseudo(':nth-of-type(' + p + ')', x);
}

// pseudoelements
function after(x) {
  return pseudo('::after', x);
}
function before(x) {
  return pseudo('::before', x);
}
function firstLetter(x) {
  return pseudo('::first-letter', x);
}
function firstLine(x) {
  return pseudo('::first-line', x);
}
function selection(x) {
  return pseudo('::selection', x);
}
function backdrop(x) {
  return pseudo('::backdrop', x);
}
function placeholder(x) {
  // https://github.com/threepointone/glamor/issues/14
  return css({ '::placeholder': x });
}

/*** helpers for web components ***/
// https://github.com/threepointone/glamor/issues/16

function cssFor() {
  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    rules[_key7] = arguments[_key7];
  }

  rules = (0, _clean2.default)(rules);
  return rules ? rules.map(function (r) {
    var style = { label: [] };
    build(style, { src: r }); // mutative! but worth it.
    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
  }).join('') : '';
}

function attribsFor() {
  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    rules[_key8] = arguments[_key8];
  }

  rules = (0, _clean2.default)(rules);
  var htmlAttributes = rules ? rules.map(function (rule) {
    idFor(rule); // throwaway check for rule
    var key = Object.keys(rule)[0],
        value = rule[key];
    return key + '="' + (value || '') + '"';
  }).join(' ') : '';

  return htmlAttributes;
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = signIn;
/* harmony export (immutable) */ __webpack_exports__["e"] = signOut;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeInputs;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUserFromToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = signInWithToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_universal_cookie__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common__ = __webpack_require__(3);
var cookies=new __WEBPACK_IMPORTED_MODULE_2_universal_cookie___default.a();function signIn(_ref){var username=_ref.username,password=_ref.password;return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_332" /* PROCESAMIENTO_SIGNIN_PAGE */],payload:true});};fn0(dispatch);var data=__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify({username:username,password:password});__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/account/signin',data).then(function(res){cookies.set('token',res.data.access_token,{path:'/'});var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_179" /* INICIAR_SESION */]});};fn1(dispatch);__WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/');}).catch(function(err){var fn5=function fn5(d){return d({type:__WEBPACK_IMPORTED_MODULE_5__types__["_332" /* PROCESAMIENTO_SIGNIN_PAGE */],payload:false});};fn5(dispatch);if(err.response&&err.response.status===401){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_229" /* MOSTRAR_MENSAJE */],payload:{type:'danger',message:'Nombre de usuario o contraseña incorrectas'}});}else{Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);}});};}function signOut(){var axiosWithToken=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){if(axiosWithToken){axiosWithToken.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/account/signout').then(function(res){cookies.remove('token',{path:'/'});dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_41" /* CERRAR_SESION */]});__WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/signin');}).catch(function(err){cookies.remove('token',{path:'/'});dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_41" /* CERRAR_SESION */]});__WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/signin');});}else{cookies.remove('token',{path:'/'});dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_41" /* CERRAR_SESION */]});__WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/signin');}};}function changeInputs(attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_209" /* MODIFICAR_INPUTS_SIGNIN_PAGE */],payload:{attr:attr,value:value}});};}function getUserFromToken(){var axiosWithToken=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return axiosWithToken.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/account/user').then(function(res){var data=res.data;return data;}).catch(function(err){throw err;});}function signInWithToken(token,expirate_date,url){return function(dispatch){var data=__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify({token:token,expirate_date:expirate_date});__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/account/external-login',data).then(function(res){cookies.set('token',token,{path:'/'});dispatch({type:__WEBPACK_IMPORTED_MODULE_5__types__["_179" /* INICIAR_SESION */]});dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__common__["m" /* getUserConfig */])());}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_7__common__["f" /* displayMessages */])(dispatch,err);__WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+'/signin');});};}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ip = exports;
var Buffer = __webpack_require__(443).Buffer;
var os = __webpack_require__(447);

ip.toBuffer = function(ip, buff, offset) {
  offset = ~~offset;

  var result;

  if (this.isV4Format(ip)) {
    result = buff || new Buffer(offset + 4);
    ip.split(/\./g).map(function(byte) {
      result[offset++] = parseInt(byte, 10) & 0xff;
    });
  } else if (this.isV6Format(ip)) {
    var sections = ip.split(':', 8);

    var i;
    for (i = 0; i < sections.length; i++) {
      var isv4 = this.isV4Format(sections[i]);
      var v4Buffer;

      if (isv4) {
        v4Buffer = this.toBuffer(sections[i]);
        sections[i] = v4Buffer.slice(0, 2).toString('hex');
      }

      if (v4Buffer && ++i < 8) {
        sections.splice(i, 0, v4Buffer.slice(2, 4).toString('hex'));
      }
    }

    if (sections[0] === '') {
      while (sections.length < 8) sections.unshift('0');
    } else if (sections[sections.length - 1] === '') {
      while (sections.length < 8) sections.push('0');
    } else if (sections.length < 8) {
      for (i = 0; i < sections.length && sections[i] !== ''; i++);
      var argv = [ i, 1 ];
      for (i = 9 - sections.length; i > 0; i--) {
        argv.push('0');
      }
      sections.splice.apply(sections, argv);
    }

    result = buff || new Buffer(offset + 16);
    for (i = 0; i < sections.length; i++) {
      var word = parseInt(sections[i], 16);
      result[offset++] = (word >> 8) & 0xff;
      result[offset++] = word & 0xff;
    }
  }

  if (!result) {
    throw Error('Invalid ip address: ' + ip);
  }

  return result;
};

ip.toString = function(buff, offset, length) {
  offset = ~~offset;
  length = length || (buff.length - offset);

  var result = [];
  if (length === 4) {
    // IPv4
    for (var i = 0; i < length; i++) {
      result.push(buff[offset + i]);
    }
    result = result.join('.');
  } else if (length === 16) {
    // IPv6
    for (var i = 0; i < length; i += 2) {
      result.push(buff.readUInt16BE(offset + i).toString(16));
    }
    result = result.join(':');
    result = result.replace(/(^|:)0(:0)*:0(:|$)/, '$1::$3');
    result = result.replace(/:{3,4}/, '::');
  }

  return result;
};

var ipv4Regex = /^(\d{1,3}\.){3,3}\d{1,3}$/;
var ipv6Regex =
    /^(::)?(((\d{1,3}\.){3}(\d{1,3}){1})?([0-9a-f]){0,4}:{0,2}){1,8}(::)?$/i;

ip.isV4Format = function(ip) {
  return ipv4Regex.test(ip);
};

ip.isV6Format = function(ip) {
  return ipv6Regex.test(ip);
};
function _normalizeFamily(family) {
  return family ? family.toLowerCase() : 'ipv4';
}

ip.fromPrefixLen = function(prefixlen, family) {
  if (prefixlen > 32) {
    family = 'ipv6';
  } else {
    family = _normalizeFamily(family);
  }

  var len = 4;
  if (family === 'ipv6') {
    len = 16;
  }
  var buff = new Buffer(len);

  for (var i = 0, n = buff.length; i < n; ++i) {
    var bits = 8;
    if (prefixlen < 8) {
      bits = prefixlen;
    }
    prefixlen -= bits;

    buff[i] = ~(0xff >> bits) & 0xff;
  }

  return ip.toString(buff);
};

ip.mask = function(addr, mask) {
  addr = ip.toBuffer(addr);
  mask = ip.toBuffer(mask);

  var result = new Buffer(Math.max(addr.length, mask.length));

  var i = 0;
  // Same protocol - do bitwise and
  if (addr.length === mask.length) {
    for (i = 0; i < addr.length; i++) {
      result[i] = addr[i] & mask[i];
    }
  } else if (mask.length === 4) {
    // IPv6 address and IPv4 mask
    // (Mask low bits)
    for (i = 0; i < mask.length; i++) {
      result[i] = addr[addr.length - 4  + i] & mask[i];
    }
  } else {
    // IPv6 mask and IPv4 addr
    for (var i = 0; i < result.length - 6; i++) {
      result[i] = 0;
    }

    // ::ffff:ipv4
    result[10] = 0xff;
    result[11] = 0xff;
    for (i = 0; i < addr.length; i++) {
      result[i + 12] = addr[i] & mask[i + 12];
    }
    i = i + 12;
  }
  for (; i < result.length; i++)
    result[i] = 0;

  return ip.toString(result);
};

ip.cidr = function(cidrString) {
  var cidrParts = cidrString.split('/');

  var addr = cidrParts[0];
  if (cidrParts.length !== 2)
    throw new Error('invalid CIDR subnet: ' + addr);

  var mask = ip.fromPrefixLen(parseInt(cidrParts[1], 10));

  return ip.mask(addr, mask);
};

ip.subnet = function(addr, mask) {
  var networkAddress = ip.toLong(ip.mask(addr, mask));

  // Calculate the mask's length.
  var maskBuffer = ip.toBuffer(mask);
  var maskLength = 0;

  for (var i = 0; i < maskBuffer.length; i++) {
    if (maskBuffer[i] === 0xff) {
      maskLength += 8;
    } else {
      var octet = maskBuffer[i] & 0xff;
      while (octet) {
        octet = (octet << 1) & 0xff;
        maskLength++;
      }
    }
  }

  var numberOfAddresses = Math.pow(2, 32 - maskLength);

  return {
    networkAddress: ip.fromLong(networkAddress),
    firstAddress: numberOfAddresses <= 2 ?
                    ip.fromLong(networkAddress) :
                    ip.fromLong(networkAddress + 1),
    lastAddress: numberOfAddresses <= 2 ?
                    ip.fromLong(networkAddress + numberOfAddresses - 1) :
                    ip.fromLong(networkAddress + numberOfAddresses - 2),
    broadcastAddress: ip.fromLong(networkAddress + numberOfAddresses - 1),
    subnetMask: mask,
    subnetMaskLength: maskLength,
    numHosts: numberOfAddresses <= 2 ?
                numberOfAddresses : numberOfAddresses - 2,
    length: numberOfAddresses,
    contains: function(other) {
      return networkAddress === ip.toLong(ip.mask(other, mask));
    }
  };
};

ip.cidrSubnet = function(cidrString) {
  var cidrParts = cidrString.split('/');

  var addr = cidrParts[0];
  if (cidrParts.length !== 2)
    throw new Error('invalid CIDR subnet: ' + addr);

  var mask = ip.fromPrefixLen(parseInt(cidrParts[1], 10));

  return ip.subnet(addr, mask);
};

ip.not = function(addr) {
  var buff = ip.toBuffer(addr);
  for (var i = 0; i < buff.length; i++) {
    buff[i] = 0xff ^ buff[i];
  }
  return ip.toString(buff);
};

ip.or = function(a, b) {
  a = ip.toBuffer(a);
  b = ip.toBuffer(b);

  // same protocol
  if (a.length === b.length) {
    for (var i = 0; i < a.length; ++i) {
      a[i] |= b[i];
    }
    return ip.toString(a);

  // mixed protocols
  } else {
    var buff = a;
    var other = b;
    if (b.length > a.length) {
      buff = b;
      other = a;
    }

    var offset = buff.length - other.length;
    for (var i = offset; i < buff.length; ++i) {
      buff[i] |= other[i - offset];
    }

    return ip.toString(buff);
  }
};

ip.isEqual = function(a, b) {
  a = ip.toBuffer(a);
  b = ip.toBuffer(b);

  // Same protocol
  if (a.length === b.length) {
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  // Swap
  if (b.length === 4) {
    var t = b;
    b = a;
    a = t;
  }

  // a - IPv4, b - IPv6
  for (var i = 0; i < 10; i++) {
    if (b[i] !== 0) return false;
  }

  var word = b.readUInt16BE(10);
  if (word !== 0 && word !== 0xffff) return false;

  for (var i = 0; i < 4; i++) {
    if (a[i] !== b[i + 12]) return false;
  }

  return true;
};

ip.isPrivate = function(addr) {
  return /^(::f{4}:)?10\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i
      .test(addr) ||
    /^(::f{4}:)?192\.168\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(addr) ||
    /^(::f{4}:)?172\.(1[6-9]|2\d|30|31)\.([0-9]{1,3})\.([0-9]{1,3})$/i
      .test(addr) ||
    /^(::f{4}:)?127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(addr) ||
    /^(::f{4}:)?169\.254\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(addr) ||
    /^f[cd][0-9a-f]{2}:/i.test(addr) ||
    /^fe80:/i.test(addr) ||
    /^::1$/.test(addr) ||
    /^::$/.test(addr);
};

ip.isPublic = function(addr) {
  return !ip.isPrivate(addr);
};

ip.isLoopback = function(addr) {
  return /^(::f{4}:)?127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})/
      .test(addr) ||
    /^fe80::1$/.test(addr) ||
    /^::1$/.test(addr) ||
    /^::$/.test(addr);
};

ip.loopback = function(family) {
  //
  // Default to `ipv4`
  //
  family = _normalizeFamily(family);

  if (family !== 'ipv4' && family !== 'ipv6') {
    throw new Error('family must be ipv4 or ipv6');
  }

  return family === 'ipv4' ? '127.0.0.1' : 'fe80::1';
};

//
// ### function address (name, family)
// #### @name {string|'public'|'private'} **Optional** Name or security
//      of the network interface.
// #### @family {ipv4|ipv6} **Optional** IP family of the address (defaults
//      to ipv4).
//
// Returns the address for the network interface on the current system with
// the specified `name`:
//   * String: First `family` address of the interface.
//             If not found see `undefined`.
//   * 'public': the first public ip address of family.
//   * 'private': the first private ip address of family.
//   * undefined: First address with `ipv4` or loopback address `127.0.0.1`.
//
ip.address = function(name, family) {
  var interfaces = os.networkInterfaces();
  var all;

  //
  // Default to `ipv4`
  //
  family = _normalizeFamily(family);

  //
  // If a specific network interface has been named,
  // return the address.
  //
  if (name && name !== 'private' && name !== 'public') {
    var res = interfaces[name].filter(function(details) {
      var itemFamily = details.family.toLowerCase();
      return itemFamily === family;
    });
    if (res.length === 0)
      return undefined;
    return res[0].address;
  }

  var all = Object.keys(interfaces).map(function (nic) {
    //
    // Note: name will only be `public` or `private`
    // when this is called.
    //
    var addresses = interfaces[nic].filter(function (details) {
      details.family = details.family.toLowerCase();
      if (details.family !== family || ip.isLoopback(details.address)) {
        return false;
      } else if (!name) {
        return true;
      }

      return name === 'public' ? ip.isPrivate(details.address) :
          ip.isPublic(details.address);
    });

    return addresses.length ? addresses[0].address : undefined;
  }).filter(Boolean);

  return !all.length ? ip.loopback(family) : all[0];
};

ip.toLong = function(ip) {
  var ipl = 0;
  ip.split('.').forEach(function(octet) {
    ipl <<= 8;
    ipl += parseInt(octet);
  });
  return(ipl >>> 0);
};

ip.fromLong = function(ipl) {
  return ((ipl >>> 24) + '.' +
      (ipl >> 16 & 255) + '.' +
      (ipl >> 8 & 255) + '.' +
      (ipl & 255) );
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./_blank.png": 454,
	"./_page.png": 455,
	"./aac.png": 456,
	"./ai.png": 457,
	"./aiff.png": 458,
	"./avi.png": 459,
	"./bmp.png": 460,
	"./c.png": 461,
	"./cpp.png": 462,
	"./css.png": 463,
	"./csv.png": 464,
	"./dat.png": 465,
	"./dmg.png": 466,
	"./doc.png": 467,
	"./dotx.png": 468,
	"./dwg.png": 469,
	"./dxf.png": 470,
	"./eps.png": 471,
	"./exe.png": 472,
	"./flv.png": 473,
	"./gif.png": 474,
	"./h.png": 475,
	"./hpp.png": 476,
	"./html.png": 477,
	"./ics.png": 478,
	"./iso.png": 479,
	"./java.png": 480,
	"./jpg.png": 481,
	"./js.png": 482,
	"./key.png": 483,
	"./less.png": 484,
	"./mid.png": 485,
	"./mp3.png": 486,
	"./mp4.png": 487,
	"./mpg.png": 488,
	"./odf.png": 489,
	"./ods.png": 490,
	"./odt.png": 491,
	"./otp.png": 492,
	"./ots.png": 493,
	"./ott.png": 494,
	"./pdf.png": 495,
	"./php.png": 496,
	"./png.png": 497,
	"./ppt.png": 498,
	"./psd.png": 499,
	"./py.png": 500,
	"./qt.png": 501,
	"./rar.png": 502,
	"./rb.png": 503,
	"./rtf.png": 504,
	"./sass.png": 505,
	"./scss.png": 506,
	"./sql.png": 507,
	"./tga.png": 508,
	"./tgz.png": 509,
	"./tiff.png": 510,
	"./txt.png": 511,
	"./wav.png": 512,
	"./xls.png": 513,
	"./xlsx.png": 514,
	"./xml.png": 515,
	"./yml.png": 516,
	"./zip.png": 517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(592);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_documentos__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancelacion=function(_Component){_inherits(Cancelacion,_Component);function Cancelacion(){_classCallCheck(this,Cancelacion);return _possibleConstructorReturn(this,(Cancelacion.__proto__||Object.getPrototypeOf(Cancelacion)).apply(this,arguments));}_createClass(Cancelacion,[{key:'render',value:function render(){var _this2=this;var documento=this.props.documento;// let enableBtn = true 
// enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-02-03`) 
// enableBtn = enableBtn && documento.get('estado') >= 12
var enableBtn=true;enableBtn=enableBtn&&__WEBPACK_IMPORTED_MODULE_2_moment___default()().isAfter(new Date().getFullYear()+'-11-30');enableBtn=enableBtn&&documento.get('estado')>=12;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,documento.get('tipo')==5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de cierre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_cancelacion')).format('YYYY-MM-DD')||'',disabled:true})))),documento.get('tipo')==5&&!documento.get('motivo_no_renovacion')||documento.get('tipo')!=5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de cancelaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de cancelaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:documento.get('estado')==0?__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_cancelacion')).format('DD/MM/YYYY'):__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('DD/MM/YYYY'),disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:documento.get('motivo_cancelacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.motivo_cancelacion',e.target.value);},disabled:documento.get('estado')==0}))))):null,documento.get('tipo')==5&&enableBtn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de no renovaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:documento.get('motivo_no_renovacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.motivo_no_renovacion',e.target.value);},disabled:documento.get('estado')==14}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Cancelacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{documento:state.documentos.getIn(['modalSummary','data'])};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_documentos__["n" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cancelacion));

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(158);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(127);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_Index */
/* unused harmony export bpfrpt_proptype_PositionInfo */
/* unused harmony export bpfrpt_proptype_ScrollPosition */
/* unused harmony export bpfrpt_proptype_SizeAndPositionInfo */
/* unused harmony export bpfrpt_proptype_SizeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_Index =  true ? null : {
  index: PropTypes.number.isRequired
};
var bpfrpt_proptype_PositionInfo =  true ? null : {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollPosition =  true ? null : {
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};







/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(73);
var createDesc = __webpack_require__(134);
module.exports = __webpack_require__(74) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(60);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(59);
var hide = __webpack_require__(89);
var has = __webpack_require__(92);
var SRC = __webpack_require__(135)('src');
var $toString = __webpack_require__(823);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(54).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 92 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var POSITION = exports.POSITION = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
};

var TYPE = exports.TYPE = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
};
var ACTION = exports.ACTION = {
  SHOW: "SHOW_TOAST",
  CLEAR: "CLEAR_TOAST",
  MOUNTED: "CONTAINER_MOUNTED"
};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalDelete:state.common.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["u" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = getUsuarios;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeRecordsToShow;
/* harmony export (immutable) */ __webpack_exports__["o"] = toggleSelectItem;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["g"] = filterUsuarios;
/* harmony export (immutable) */ __webpack_exports__["j"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["f"] = displayModalCreate;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateInputsInModalCreate;
/* harmony export (immutable) */ __webpack_exports__["d"] = createOrUpdateUsuarios;
/* harmony export (immutable) */ __webpack_exports__["k"] = showHideModalDelete;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteUsuarios;
/* harmony export (immutable) */ __webpack_exports__["l"] = showHideModalFilter;
/* harmony export (immutable) */ __webpack_exports__["a"] = addModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["r"] = updateModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateInputs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
function getUsuarios(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().usuarios.get('showRecords');var orderBy=getState().usuarios.get('orderBy');var filters=getState().usuarios.getIn(['modalFilter','filters']).filter(function(x){return x.get('apply');}).toJS();axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/usuarios',{params:{page:page,showRecords:showRecords,orderBy:orderBy,filters:filters}}).then(function(res){var data=res.data.data.map(function(x){x.visible=true;x.selected=false;return x;});var totalRecords=Number(res.data.totalRecords);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_312" /* OBTENER_USUARIOS */],payload:{data:data,page:page,totalRecords:totalRecords}});};fn1(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function changeRecordsToShow(showRecords){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_40" /* CAMBIAR_MOSTRAR_REGISTROS_USUARIOS */],payload:showRecords});};var fn1=function fn1(d){return d(getUsuarios(1));};fn0(dispatch);fn1(dispatch);};}function toggleSelectItem(id,checked){return function(dispatch,getState){var index=getState().usuarios.get('usuarios').findIndex(function(x){return x.get('id')===id;});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_74" /* CONMUTAR_SELECCION_USUARIO */],payload:{index:index,checked:checked}});};}function toggleSelectAllItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_73" /* CONMUTAR_SELECCION_TODOS_USUARIOS */],payload:checked});};}function filterUsuarios(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_178" /* FILTRAR_USUARIOS */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().usuarios.get('orderBy');current=current.set('field',field.value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_331" /* ORDENAR_USUARIOS */],payload:{orderBy:current}});};var fn1=function fn1(d){return d(getUsuarios(1));};fn0(dispatch);fn1(dispatch);};}function displayModalCreate(show,title,mode,id){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/usuarios/'+id);};var fn1=function fn1(){return axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/permisos');};var fn2=function fn2(){return axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/grupos');};var fn3=function fn3(){return axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/usuarios/areas');};if(id){Promise.all([fn0(),fn1(),fn2(),fn3()]).then(function(res){var usuario=res[0].data.usuario;usuario.permisos=res[1].data.map(function(x){x.selected=usuario.permisos.filter(function(p){return p.id===x.id;}).length===1;return x;});usuario.grupos=res[2].data.data.map(function(x){x.selected=usuario.grupos.filter(function(g){return g.id===x.id;}).length===1;return x;});var areas=res[3].data.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_266" /* MOSTRAR_MODAL_CREAR_USUARIO */],payload:{show:show,title:title,mode:mode,usuario:usuario,areas:areas}});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});}else{Promise.all([fn1(),fn2(),fn3()]).then(function(res){var permisos=res[0].data.map(function(x){x.selected=false;return x;});var grupos=res[1].data.data.map(function(x){x.selected=false;return x;});var areas=res[2].data.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_266" /* MOSTRAR_MODAL_CREAR_USUARIO */],payload:{show:show,title:title,mode:mode,permisos:permisos,grupos:grupos,areas:areas}});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_266" /* MOSTRAR_MODAL_CREAR_USUARIO */],payload:{show:show,title:title,mode:mode}});}};}function updateInputsInModalCreate(attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_205" /* MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS */],payload:{attr:attr,value:value}});};}function createOrUpdateUsuarios(data,mode){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){if(getState().usuarios.getIn(['modalCreate','data','reporta_a','id'])===getState().common.getIn(['user','id'])){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{warning:'El usuario al que reporta no puede ser el mismo usuario'});}else{var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_107" /* DESHABILITAR_BOTON_MODAL_USUARIOS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_107" /* DESHABILITAR_BOTON_MODAL_USUARIOS */],payload:false});};fn0(dispatch);data=data.set('grupos',data.get('grupos').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');}));data=data.set('permisos',data.get('permisos').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');}));if(mode==='create'){axios.post(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/usuarios',data.toJS()).then(function(res){var usuario=res.data;usuario.visible=true;usuario.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_79" /* CREAR_ACTUALIZAR_USUARIO */],payload:usuario});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El usuario ha sido guardado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}else if(mode==='edit'){axios.put(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/usuarios/'+data.get('id'),data.toJS()).then(function(res){var usuario=res.data;usuario.visible=true;usuario.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_79" /* CREAR_ACTUALIZAR_USUARIO */],payload:usuario});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El usuario ha sido actualizado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}}};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_254" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO */],payload:{open:open,message:message,action:action}});};}function deleteUsuarios(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selected=getState().usuarios.get('usuarios').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');});var fns=[];selected.forEach(function(x){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/usuarios/'+x);};fns.push(fn);});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var succeded=[];var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}else{succeded.push(x.result.data.Nombre);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_159" /* ELIMINAR_USUARIO */],payload:x.result.data.id});}});if(succeded.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Se han eliminado los siguentes usuarios: '+succeded.join(', ')});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});});};}function showHideModalFilter(state){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_276" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS */],payload:state});};}function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["w" /* ADICIONAR_CRITERIO_FILTRADO_USUARIOS */]});};}function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_149" /* ELIMINAR_CRITERIO_FILTRADO_USUARIOS */]});};}function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_54" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS */],payload:{index:index,checked:checked}});};}function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_192" /* MODIFICAR_CRITERIO_FILTRADO_USUARIOS */],payload:{index:index,attr:attr,value:value}});};}function applyFilterCriterias(){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_28" /* APLICAR_CRITERIOS_FILTRADO_USUARIOS */]});};var fn1=function fn1(d){return d(getUsuarios(1));};fn0(dispatch);fn1(dispatch);};}function updateInputs(path,value){var immutable=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_222" /* MODIFICAR_INPUTS_USUARIOS */],payload:{path:path,value:value,immutable:immutable}});};fn1(dispatch);};}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"/ecompras"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(567);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(568);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147)))

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_timeago__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_timeago___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_timeago__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_timeago_lib_language_strings_es__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_timeago_lib_language_strings_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_timeago_lib_language_strings_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_timeago_lib_formatters_buildFormatter__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_timeago_lib_formatters_buildFormatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_timeago_lib_formatters_buildFormatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var formatter=__WEBPACK_IMPORTED_MODULE_5_react_timeago_lib_formatters_buildFormatter___default()(__WEBPACK_IMPORTED_MODULE_4_react_timeago_lib_language_strings_es___default.a);var Comentarios=function(_Component){_inherits(Comentarios,_Component);function Comentarios(){_classCallCheck(this,Comentarios);return _possibleConstructorReturn(this,(Comentarios.__proto__||Object.getPrototypeOf(Comentarios)).apply(this,arguments));}_createClass(Comentarios,[{key:'render',value:function render(){var _this2=this;var _props=this.props,foros=_props.foros,comentario=_props.comentario,disabled_comment=_props.disabled_comment;if(!foros)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Comentarios'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},foros.sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.get('updated_at')).unix()-__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('updated_at')).unix();}).map(function(c,i){// const indicador = c.get('id') ? c.get('id') : c.get('guid')
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_Box__["a" /* default */],{key:'c['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nota-nombre'},c.getIn(['usuario','nombres']),' ',c.getIn(['usuario','apellidos'])),'\xA0@\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nota-tiempo'},''+__WEBPACK_IMPORTED_MODULE_2_moment___default()(c.get('updated_at')).format('YYYY-MM-DD HH:mm:ss')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},c.get('comentario'))));})),foros.count()==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 text-center'},'Agregue comentarios adicionales en esta secci\xF3n')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:6,value:comentario.get('texto')||'',onChange:function onChange(e){return _this2.props.updateInputs('comentario.texto',e.target.value);},disabled:disabled_comment}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'send',title:'Enviar comentario',onClick:function onClick(){return _this2.props.enviarComentario();},disabled:!disabled_comment&&comentario.get('texto')&&!comentario.get('btnSendDisabled')?false:true})))));}}]);return Comentarios;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Comentarios);

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(720)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(266)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(268);
var enumBugKeys = __webpack_require__(167);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestAnimationTimeout; });
/* unused harmony export bpfrpt_proptype_AnimationTimeoutId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animationFrame__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  id: PropTypes.number.isRequired
};


var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["a" /* caf */])(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = void 0;
  // wait for end of processing current event handler, because event handler may be long
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout)
  };

  return frame;
};



/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellDataGetterParams */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRowRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRendererParams */
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellDataGetterParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  cellData: PropTypes.any,
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_HeaderRendererParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  disableSort: PropTypes.bool,
  label: PropTypes.any,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string
};
var bpfrpt_proptype_RowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onRowMouseOver: PropTypes.func,
  onRowMouseOut: PropTypes.func,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};







/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineStyle = defineStyle;
var style = {
  width: "320px",
  colorDefault: "#fff",
  colorInfo: "#3498db",
  colorSuccess: "#07bc0c",
  colorWarning: "#f1c40f",
  colorError: "#e74c3c",
  colorProgressDefault: "linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55)",
  mobile: "only screen and (max-width : 480px)"
};

function defineStyle(props) {
  Object.keys(props).forEach(function (k) {
    var val = props[k];
    if (style.hasOwnProperty(k) && typeof val === 'string') {
      style[k] = val;
    }
  });
}

exports.default = style;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(401);

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cookies2.default;
module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = getPlantillas;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeRecordsToShow;
/* harmony export (immutable) */ __webpack_exports__["o"] = toggleSelectItem;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["g"] = filterPlantillas;
/* harmony export (immutable) */ __webpack_exports__["j"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["f"] = displayModalCreate;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["d"] = createOrUpdatePlantillas;
/* harmony export (immutable) */ __webpack_exports__["k"] = showHideModalDelete;
/* harmony export (immutable) */ __webpack_exports__["e"] = deletePlantillas;
/* harmony export (immutable) */ __webpack_exports__["l"] = showHideModalFilter;
/* harmony export (immutable) */ __webpack_exports__["a"] = addModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyFilterCriterias;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
function getPlantillas(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().plantillas.get('showRecords');var orderBy=getState().plantillas.get('orderBy');var filters=getState().plantillas.getIn(['modalFilter','filters']).filter(function(x){return x.get('apply');}).toJS();axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/plantillas',{params:{page:page,showRecords:showRecords,orderBy:orderBy,filters:filters}}).then(function(res){var data=res.data.data.map(function(x){x.visible=true;x.selected=false;return x;});var totalRecords=Number(res.data.totalRecords);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_302" /* OBTENER_PLANTILLAS */],payload:{data:data,page:page,totalRecords:totalRecords}});};fn1(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function changeRecordsToShow(showRecords){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_38" /* CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS */],payload:showRecords});};var fn1=function fn1(d){return d(getPlantillas(1));};fn0(dispatch);fn1(dispatch);};}function toggleSelectItem(index,checked){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_58" /* CONMUTAR_SELECCION_PLANTILLA */],payload:{index:index,checked:checked}});};}function toggleSelectAllItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_71" /* CONMUTAR_SELECCION_TODOS_PLANTILLAS */],payload:checked});};}function filterPlantillas(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_176" /* FILTRAR_PLANTILLAS */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().plantillas.get('orderBy');current=current.set('field',field.Value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_328" /* ORDENAR_PLANTILLAS */],payload:{orderBy:current}});};var fn1=function fn1(d){return d(getPlantillas(1));};fn0(dispatch);fn1(dispatch);};}function displayModalCreate(show,title,mode,id){return function(dispatch,getState){var user=getState().common.get('user');dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_265" /* MOSTRAR_MODAL_CREAR_PLANTILLA */],payload:{show:show,title:title,mode:mode,id:id,user:user}});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_207" /* MODIFICAR_INPUTS_PLANTILLAS */],payload:{path:path,value:value}});};}function createOrUpdatePlantillas(data,mode){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_106" /* DESHABILITAR_BOTON_MODAL_PLANTILLAS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_106" /* DESHABILITAR_BOTON_MODAL_PLANTILLAS */],payload:false});};fn0(dispatch);if(mode==='create'){axios.post(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/plantillas',data.toJS()).then(function(res){var plantilla=res.data;plantilla.visible=true;plantilla.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_78" /* CREAR_ACTUALIZAR_PLANTILLA */],payload:plantilla});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El plantilla ha sido guardado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}else if(mode==='edit'){axios.put(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/plantillas/'+data.get('id'),data.toJS()).then(function(res){var plantilla=res.data;plantilla.visible=true;plantilla.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_78" /* CREAR_ACTUALIZAR_PLANTILLA */],payload:plantilla});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El plantilla ha sido actualizado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_252" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA */],payload:{open:open,message:message,action:action}});};}function deletePlantillas(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selected=getState().plantillas.get('plantillas').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');});var fns=[];selected.forEach(function(x){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/plantillas/'+x);};fns.push(fn);});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var succeded=[];var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}else{succeded.push(x.result.data.nombre);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_156" /* ELIMINAR_PLANTILLA */],payload:x.result.data.id});}});if(succeded.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Se han eliminado los siguentes plantillas: '+succeded.join(', ')});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});});};}function showHideModalFilter(state){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_273" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS */],payload:state});};}function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["t" /* ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS */]});};}function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_146" /* ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS */]});};}function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_51" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS */],payload:{index:index,checked:checked}});};}function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_189" /* MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS */],payload:{index:index,attr:attr,value:value}});};}function applyFilterCriterias(){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_25" /* APLICAR_CRITERIOS_FILTRADO_PLANTILLAS */]});};var fn1=function fn1(d){return d(getPlantillas(1));};fn0(dispatch);fn1(dispatch);};}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = getGarantias;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeRecordsToShow;
/* harmony export (immutable) */ __webpack_exports__["o"] = toggleSelectItem;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["g"] = filterGarantias;
/* harmony export (immutable) */ __webpack_exports__["j"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["f"] = displayModalCreate;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["d"] = createOrUpdateGarantias;
/* harmony export (immutable) */ __webpack_exports__["k"] = showHideModalDelete;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteGarantias;
/* harmony export (immutable) */ __webpack_exports__["l"] = showHideModalFilter;
/* harmony export (immutable) */ __webpack_exports__["a"] = addModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyFilterCriterias;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
function getGarantias(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().garantias.get('showRecords');var orderBy=getState().garantias.get('orderBy');var filters=getState().garantias.getIn(['modalFilter','filters']).filter(function(x){return x.get('apply');}).toJS();axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/garantias',{params:{page:page,showRecords:showRecords,orderBy:orderBy,filters:filters}}).then(function(res){var data=res.data.data.map(function(x){x.visible=true;x.selected=false;return x;});var totalRecords=Number(res.data.totalRecords);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_294" /* OBTENER_GARANTIAS */],payload:{data:data,page:page,totalRecords:totalRecords}});};fn1(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function changeRecordsToShow(showRecords){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_37" /* CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS */],payload:showRecords});};var fn1=function fn1(d){return d(getGarantias(1));};fn0(dispatch);fn1(dispatch);};}function toggleSelectItem(id,checked){return function(dispatch,getState){var index=getState().garantias.get('garantias').findIndex(function(x){return x.get('id')===id;});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_56" /* CONMUTAR_SELECCION_GARANTIA */],payload:{index:index,checked:checked}});};}function toggleSelectAllItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_65" /* CONMUTAR_SELECCION_TODOS_GARANTIAS */],payload:checked});};}function filterGarantias(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_174" /* FILTRAR_GARANTIAS */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().garantias.get('orderBy');current=current.set('field',field.Value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_326" /* ORDENAR_GARANTIAS */],payload:{orderBy:current}});};var fn1=function fn1(d){return d(getGarantias(1));};fn0(dispatch);fn1(dispatch);};}function displayModalCreate(show,title,mode,id){return function(dispatch,getState){var user=getState().common.get('user');dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_263" /* MOSTRAR_MODAL_CREAR_GARANTIA */],payload:{show:show,title:title,mode:mode,id:id,user:user}});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_200" /* MODIFICAR_INPUTS_GARANTIAS */],payload:{path:path,value:value}});};}function createOrUpdateGarantias(data,mode){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_104" /* DESHABILITAR_BOTON_MODAL_GARANTIAS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_104" /* DESHABILITAR_BOTON_MODAL_GARANTIAS */],payload:false});};fn0(dispatch);if(mode==='create'){axios.post(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/garantias',data.toJS()).then(function(res){var garantia=res.data;garantia.visible=true;garantia.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_76" /* CREAR_ACTUALIZAR_GARANTIA */],payload:garantia});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El garantia ha sido guardado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}else if(mode==='edit'){axios.put(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/garantias/'+data.get('id'),data.toJS()).then(function(res){var garantia=res.data;garantia.visible=true;garantia.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_76" /* CREAR_ACTUALIZAR_GARANTIA */],payload:garantia});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El garantia ha sido actualizado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_249" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA */],payload:{open:open,message:message,action:action}});};}function deleteGarantias(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selected=getState().garantias.get('garantias').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');});var fns=[];selected.forEach(function(x){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/garantias/'+x);};fns.push(fn);});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var succeded=[];var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}else{succeded.push(x.result.data.Nombre);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_150" /* ELIMINAR_GARANTIA */],payload:x.result.data.id});}});if(succeded.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Se han eliminado los siguentes garantias: '+succeded.join(', ')});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});});};}function showHideModalFilter(state){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_271" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS */],payload:state});};}function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["r" /* ADICIONAR_CRITERIO_FILTRADO_GARANTIAS */]});};}function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_144" /* ELIMINAR_CRITERIO_FILTRADO_GARANTIAS */]});};}function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_49" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS */],payload:{index:index,checked:checked}});};}function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_185" /* MODIFICAR_CRITERIO_FILTRADO_GARANTIAS */],payload:{index:index,attr:attr,value:value}});};}function applyFilterCriterias(){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_23" /* APLICAR_CRITERIOS_FILTRADO_GARANTIAS */]});};var fn1=function fn1(d){return d(getGarantias(1));};fn0(dispatch);fn1(dispatch);};}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getGrupos;
/* harmony export (immutable) */ __webpack_exports__["d"] = filterGrupos;
/* harmony export (immutable) */ __webpack_exports__["g"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["c"] = displayModalCreate;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateInputsInModalCreate;
/* harmony export (immutable) */ __webpack_exports__["f"] = selectItem;
/* harmony export (immutable) */ __webpack_exports__["a"] = createOrUpdateGrupos;
/* harmony export (immutable) */ __webpack_exports__["h"] = showHideModalDelete;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteGrupos;
/* harmony export (immutable) */ __webpack_exports__["i"] = showHideModalFilter;
/* unused harmony export addModalFilterCriteria */
/* unused harmony export removeCheckedModalFilterCriterias */
/* unused harmony export toggleCheckedModalFilterCriterias */
/* unused harmony export updateModalFilterCriteria */
/* unused harmony export applyFilterCriterias */
/* harmony export (immutable) */ __webpack_exports__["l"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["k"] = toggleSelectAll;
/* harmony export (immutable) */ __webpack_exports__["j"] = storePermisosGrupo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
function getGrupos(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().grupos.get('showRecords');var orderBy=getState().grupos.get('orderBy');var filters=getState().grupos.getIn(['modalFilter','filters']).filter(function(x){return x.get('apply');}).toJS();var fn0=function fn0(){return axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/grupos',{params:{page:page,showRecords:showRecords,orderBy:orderBy,filters:filters,full:true}});};var fn1=function fn1(){return axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/permisos');};Promise.all([fn0(),fn1()]).then(function(res){var data=res[0].data.data.map(function(x){x.visible=true;x.selected=false;return x;});var totalRecords=Number(res[0].data.totalRecords);var permisos=res[1].data;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_296" /* OBTENER_GRUPOS */],payload:{data:data,page:page,totalRecords:totalRecords,permisos:permisos}});};fn3(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function filterGrupos(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_175" /* FILTRAR_GRUPOS */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().grupos.get('orderBy');current=current.set('field',field.value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_327" /* ORDENAR_GRUPOS */],payload:{orderBy:current}});};var fn1=function fn1(d){return d(getGrupos(1));};fn0(dispatch);fn1(dispatch);};}function displayModalCreate(show,title,mode){var index=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_264" /* MOSTRAR_MODAL_CREAR_GRUPO */],payload:{show:show,title:title,mode:mode,index:index}});};}function updateInputsInModalCreate(attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_204" /* MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS */],payload:{attr:attr,value:value}});};}function selectItem(index){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_365" /* SELECCIONAR_ITEM_GRUPOS */],payload:index});};}function createOrUpdateGrupos(data,mode){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){if(getState().grupos.getIn(['modalCreate','data','reporta_a','id'])===getState().common.getIn(['user','id'])){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{warning:'El grupo al que reporta no puede ser el mismo grupo'});}else{var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_105" /* DESHABILITAR_BOTON_MODAL_GRUPOS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_105" /* DESHABILITAR_BOTON_MODAL_GRUPOS */],payload:false});};fn0(dispatch);if(mode==='create'){axios.post(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/grupos',data.toJS()).then(function(res){var grupo=res.data;grupo.visible=true;grupo.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_77" /* CREAR_ACTUALIZAR_GRUPO */],payload:grupo});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El grupo ha sido guardado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}else if(mode==='edit'){axios.put(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/grupos/'+data.get('id'),data.toJS()).then(function(res){var grupo=res.data;grupo.visible=true;grupo.selected=false;dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_77" /* CREAR_ACTUALIZAR_GRUPO */],payload:grupo});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El grupo ha sido actualizado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}}};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_250" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO */],payload:{open:open,message:message,action:action}});};}function deleteGrupos(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selected=getState().grupos.get('grupos').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');});var fns=[];selected.forEach(function(x){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/grupos/'+x);};fns.push(fn);});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var succeded=[];var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}else{succeded.push(x.result.data.Nombre);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_151" /* ELIMINAR_GRUPO */],payload:x.result.data.id});}});if(succeded.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Se han eliminado los siguentes grupos: '+succeded.join(', ')});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});});};}function showHideModalFilter(state){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_272" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS */],payload:state});};}function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["s" /* ADICIONAR_CRITERIO_FILTRADO_GRUPOS */]});};}function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_145" /* ELIMINAR_CRITERIO_FILTRADO_GRUPOS */]});};}function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_50" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS */],payload:{index:index,checked:checked}});};}function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_186" /* MODIFICAR_CRITERIO_FILTRADO_GRUPOS */],payload:{index:index,attr:attr,value:value}});};}function applyFilterCriterias(){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_24" /* APLICAR_CRITERIOS_FILTRADO_GRUPOS */]});};var fn1=function fn1(d){return d(getGrupos(1));};fn0(dispatch);fn1(dispatch);};}function updateInputs(path,value){var immutable=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_201" /* MODIFICAR_INPUTS_GRUPOS */],payload:{path:path,value:value,immutable:immutable}});};fn1(dispatch);};}function toggleSelectAll(checked){return function(dispatch,getState){var permisosGrupo=getState().grupos.get('permisosGrupo');permisosGrupo.forEach(function(x,n){var path='permisosGrupo.'+n+'.selected';dispatch(updateInputs(path,checked,false));});};}function storePermisosGrupo(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var grupo=getState().grupos.getIn(['grupos',String(getState().grupos.get('selected'))]);var selected=getState().grupos.get('permisosGrupo').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');});var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_105" /* DESHABILITAR_BOTON_MODAL_GRUPOS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_105" /* DESHABILITAR_BOTON_MODAL_GRUPOS */],payload:false});};fn0(dispatch);axios.put(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/grupos/'+grupo.get('id')+'/permisos',{permisos:selected.toJS()}).then(function(res){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El grupo ha sido actualizado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});};}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_solicitudservicioot__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getClassDetalle(detalle){if(detalle.get('adicion_id')){return'adicional';}else if(detalle.get('tipo')===4){return'otrosi';}else{return'';}}var General=function(_Component){_inherits(General,_Component);function General(){var _ref;var _temp,_this,_ret;_classCallCheck(this,General);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=General.__proto__||Object.getPrototypeOf(General)).call.apply(_ref,[this].concat(args))),_this),_this.estaCotizado=function(){return _this.props.documento.getIn(['cotizacion','cotizado'])!=0;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(General,[{key:'render',value:function render(){var _this2=this;var _props=this.props,documento=_props.documento,enums=_props.enums,documento_origen=_props.documento_origen,summary=_props.summary,divisas=_props.divisas;if(!documento)return null;if(!documento.get('detalles'))return null;var moneda=documento.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var totalSevicios=documento.get('detalles').reduce(function(a,b){if(!b.get('adicion_id'))a+=b.get('valor')*b.get('cantidad');return a;},0);var editar=summary.get('editar');var solicitud=documento.get('solicitude');var soloResponsableCompras=Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);var id=documento.get('id');var accionesDetalles=[];if(soloResponsableCompras){// accionesDetalles = [
//     <BoxButton key="ba[0][0]" size={14} contrast name="pencil" onClick={ () => this.props.updateInputs('modalSummary.editar', !editar) } title="Editar costos" active={ editar }  />,
// ]
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:enums.documentos.tipos[documento.get('tipo')].NOMBRE,className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'N\xFAmero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.get('consecutivo'),className:'form-control input-sm',disabled:true}))),documento.get('tipo')==4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-md-offset-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Orden/Contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:''+enums.documentos.tipos[documento_origen.get('tipo')].PREFIJO+documento_origen.get('consecutivo')||'',className:'form-control input-sm',disabled:true}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-md-offset-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['solicitude','id']),className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','nombre']),className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de inicio (creaci\xF3n)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_inicio')).format('YYYY-MM-DD'),className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_entrega')).format('YYYY-MM-DD'),className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:totalSevicios>0?__WEBPACK_IMPORTED_MODULE_3_numeral___default()(documento.get('anticipo')/100).format('0.0%'):'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:totalSevicios>0?Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["q" /* formatcoin */])(totalSevicios*documento.get('anticipo')/100,divisa.simbolo):'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha pago anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:totalSevicios>0?documento.get('pago_anticipo')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('pago_anticipo')).format('YYYY-MM-DD'):'':'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},documento.get('garantias').count()>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Garantias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},documento.get('garantias').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'div1['+a.get('id')+']',className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:true,disabled:true}),a.get('nombre'))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opciones adicionales'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:documento.get('entregas_parciales'),disabled:true}),'Entregas parciales'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:documento.get('validacion_soma'),disabled:true}),'Validaci\xF3n por SOMA'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Detalle',actions:accionesDetalles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'40%'}},'Item'),editar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Valor unt. sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Valor unt. con IVA')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Valor sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Valor total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'35%'}},'Distribuci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,documento.get('todos_detalles').count()>0&&documento.get('todos_detalles').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:x.get('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'},className:getClassDetalle(x)},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion'),' ',x.get('tipo')==4?'<Solicitud No. '+x.get('solicitud_id')+'>':null),editar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',value:x.get('valor')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.todos_detalles.'+n+'.valor',e.target.value,id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',value:x.get('valor_con_iva')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.todos_detalles.'+n+'.valor_con_iva',e.target.value,id);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["q" /* formatcoin */])(x.get('valor')*x.get('cantidad'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["q" /* formatcoin */])(x.get('valor_con_iva')*x.get('cantidad'),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'36%'}},'Ordenador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'22%'}},'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'22%'}},'Valor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,x.get('cencos').map(function(e,f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr2['+x.get('id')+']['+e.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+e.get('descripcion')},e.get('codigo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,e.get('nombres')+' '+e.get('apellidos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(e.get('porcentaje')/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["q" /* formatcoin */])(e.get('porcentaje')/100*x.get('valor_con_iva')*x.get('cantidad'),divisa.simbolo)));})))));}),documento.get('detalles').count()==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5,style:{textAlign:'center'}},'Ha ocurrido un error'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_AttachedFilesBox__["a" /* default */],{files:documento.get('adjuntos'),root:'modalSummary.data',removeFiles:this.props.removeFiles,updateInputs:this.props.updateInputs,obj:documento,check:'documento',disabledAttach:this.props.disabledAttach}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('/files/'+documento.get('solicitud_id'),documento.get('id'),[function(){return _this2.props.getDocumento(documento.get('id'));},function(){return _this2.props.getSolicitud(documento.get('solicitud_id'));}]);}}));}}]);return General;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{documento:state.documentos.getIn(['modalSummary','data']),documento_origen:ownProps.reducer?state[ownProps.reducer].getIn(['solicitud','documento_origen']):null,enums:state.common.get('enums').toJS(),summary:state.documentos.get('modalSummary'),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{addFile:function addFile(url,documentoId,actions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["b" /* addFile */])(url,documentoId,actions));},removeFiles:function removeFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["h" /* removeFiles */])());},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["n" /* updateInputs */])(path,value));},getDocumento:function getDocumento(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["e" /* getDocumento */])(id));},getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_solicitudservicioot__["k" /* getSolicitud */])(id));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(General));

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Aprobacion=function(_Component){_inherits(Aprobacion,_Component);function Aprobacion(){_classCallCheck(this,Aprobacion);return _possibleConstructorReturn(this,(Aprobacion.__proto__||Object.getPrototypeOf(Aprobacion)).apply(this,arguments));}_createClass(Aprobacion,[{key:'render',value:function render(){var _props=this.props,documento=_props.documento,enums=_props.enums;if(!documento)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{key:'bs1['+documento.get('id')+']',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,documento.getIn(['aprobacion','estado'])===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{name:'check',style:{color:'green'}}):documento.getIn(['aprobacion','estado'])===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{name:'times',style:{color:'red'}}):'',' Solicitud de aprobaci\xF3n del documento al proveedor')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Aprobaci\xF3n ',documento.getIn(['proveedore','nombre']),' ',enums.aprobaciones.estados[documento.getIn(['aprobacion','estado'])],documento.getIn(['aprobacion','estado'])===1?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' \u2022 ',__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.getIn(['aprobacion','fecha'])).format('YYYY-MM-DD HH:mm')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Solicitada por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,documento.getIn(['solicitude','responsable_compras','fullname']))),' \u2022 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+documento.getIn(['solicitud','responsable_compras','email'])},documento.getIn(['solicitude','responsable_compras','email'])))))));}}]);return Aprobacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{documento:state.documentos.getIn(['modalSummary','data']),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Aprobacion));

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RowDocumentosAsociados__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocumentosAsociados=function(_Component){_inherits(DocumentosAsociados,_Component);function DocumentosAsociados(){_classCallCheck(this,DocumentosAsociados);return _possibleConstructorReturn(this,(DocumentosAsociados.__proto__||Object.getPrototypeOf(DocumentosAsociados)).apply(this,arguments));}_createClass(DocumentosAsociados,[{key:'render',value:function render(){var _props=this.props,documento=_props.documento,enums=_props.enums,downloadFile=_props.downloadFile,divisas=_props.divisas;if(!documento)return null;if(documento.get('documentos').count()===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',color:'#bbb'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'exclamation-circle'}),' Este documento no tiene otros documentos asociados'));}var moneda=documento.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["t" /* getDivisa */])(divisas,moneda);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'9%'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'11%'}},'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'9%'}},'Fecha inicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'9%'}},'Fecha entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Servicios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'center'}},'Descargas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,documento.get('documentos').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RowDocumentosAsociados__["a" /* RowDocumentosAsociados */],{origen:documento,documento:a,indice:b,divisa:divisa,key:'tr4['+a.get('id')+']',downloadFile:downloadFile,enums:enums});}))))));}}]);return DocumentosAsociados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{documento:state.documentos.getIn(['modalSummary','data']),enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["h" /* downloadFile */])(id,filename));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DocumentosAsociados));

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Documentos_ModalAddVerificacionSOMA__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_window_size__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_window_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_window_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Entregas=function(_Component){_inherits(Entregas,_Component);function Entregas(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Entregas);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Entregas.__proto__||Object.getPrototypeOf(Entregas)).call.apply(_ref,[this].concat(args))),_this),_this.promediar=function(criterio){var entregas=_this.props.documento.get('entregas').filter(function(e){return e.get('recibido')==1;});var total=entregas.reduce(function(a,b){var criterios=b.get('evaluaciones').filter(function(x){return x.get('criterio')==criterio;});a+=criterios.count()>0?criterios.first().get('calificacion')?criterios.first().get('calificacion'):0:0;return a;},0);return entregas.count()>0?(total/entregas.count()).toFixed():0;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Entregas,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('CRITERIOS_EVALUACION_PROVEEDORES');}},{key:'renderEvaluaciones',value:function renderEvaluaciones(entrega,divisa){if(!entrega.get('recibido'))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Criterio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Calificaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,entrega.get('evaluaciones').map(function(c,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr8['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,c.get('criterio')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,c.get('calificacion')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:2},'Observaciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'80px',overflowX:'hidden'}},entrega.get('observaciones')||''))),this.props.documento.get('entregas_parciales')==true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'60%'}},'Valor a facturar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["q" /* formatcoin */])(entrega.get('valor_a_facturar'),divisa.simbolo))))))));}},{key:'render',value:function render(){var _this2=this;var _props=this.props,documento=_props.documento,url=_props.url,type=_props.type,parametros=_props.parametros,divisas=_props.divisas;if(!documento)return null;var moneda=documento.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var criterios=parametros.get('CRITERIOS_EVALUACION_PROVEEDORES')?parametros.get('CRITERIOS_EVALUACION_PROVEEDORES'):[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Promedios')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Criterio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Calificaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,criterios.map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr9['+b+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('CRITERIO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.promediar(a.get('CRITERIO'))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Cumplimiento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.promediar('Cumplimiento')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),documento.get('entregas').filter(function(a){return a.get('recibido')==false;}).sort(function(a,b){return a.get('id')<b.get('id')?1:-1;}).map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'fr1['+a.get('id')+']'},b>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{key:'bs1['+a.get('id')+']',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'clock-o'}),' Verificaci\xF3n de recibido')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Responsable: ',a.getIn(['responsable_recibo','fullname']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Fecha registro: \xA0 ',a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('updated_at')).format('DD/MM/YYYY hh:mm A')):'Sin recibir'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Fecha recibido: \xA0 ',a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha')).format('DD/MM/YYYY')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Estado: \xA0 ',a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Recibido'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin recibir')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null))),_this2.renderEvaluaciones(a,divisa),!a.get('recibido')&&Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["E" /* isAllowedToViewComponent */])('responsables_recibo',documento,a.getIn(['responsable_recibo','id']))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right',padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm btn-squared',onClick:function onClick(e){return _this2.props.showHideModalCreateEntrega(true,a.get('id'));}},'Recibir')))))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),documento.get('verificaciones_sst').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{key:'bs2['+a.get('id')+']',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,a.get('verificado')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'clock-o'}),' Verificaci\xF3n de SOMA')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Responsable: ',a.getIn(['responsable_soma','fullname']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Estado: ',a.get('verificado')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Verificaci\xF3n \u2022 ',__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('updated_at')).format('DD/MM/YYYY hh:mm A')):'Sin verificar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null))),!a.get('verificado')&&Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_soma',documento,a.getIn(['responsable_soma','id']))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right',padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm btn-squared',onClick:function onClick(e){return _this2.props.showHideModalAddVerificacionSOMA(true,a,url,type);}},'Verificar'))))),a.get('verificado')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Criterio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Calificaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Calificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,''+(a.get('aceptado')==1?'Aceptado':'No aceptado'))))),a.get('observaciones')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:2},'Observaciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'80px',overflowX:'hidden'}},a.get('observaciones'))))))))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),documento.get('entregas').filter(function(a){return a.get('recibido')==true;}).sort(function(a,b){return a.get('id')<b.get('id')?1:-1;}).map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'fr1['+a.get('id')+']'},b>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{key:'bs1['+a.get('id')+']',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'clock-o'}),' Verificaci\xF3n de recibido')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Responsable: ',a.getIn(['responsable_recibo','fullname']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Fecha registro: \xA0 ',a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('updated_at')).format('DD/MM/YYYY hh:mm A')):'Sin recibir'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Fecha recibido: \xA0 ',a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha')).format('DD/MM/YYYY')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Estado: \xA0 ',a.get('recibido')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Recibido'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin recibir')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null))),_this2.renderEvaluaciones(a,divisa)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Documentos_ModalAddVerificacionSOMA__["a" /* default */],null));}}]);return Entregas;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{documento:state.documentos.getIn(['modalSummary','data']),url:state.documentos.getIn(['modalSummary','url']),type:state.documentos.getIn(['modalSummary','type']),parametros:state.common.get('parametros'),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{showHideModalCreateEntrega:function showHideModalCreateEntrega(show,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["j" /* showHideModalCreateEntrega */])(show,id));},showHideModalAddVerificacionSOMA:function showHideModalAddVerificacionSOMA(show,verificacion,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["s" /* showHideModalAddVerificacionSOMA */])(show,verificacion,url,type));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["l" /* getParameterByName */])(nombre));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Entregas));

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Documentos_AttachedAditionalsBox__ = __webpack_require__(618);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Adiciones=function(_Component){_inherits(Adiciones,_Component);function Adiciones(){_classCallCheck(this,Adiciones);return _possibleConstructorReturn(this,(Adiciones.__proto__||Object.getPrototypeOf(Adiciones)).apply(this,arguments));}_createClass(Adiciones,[{key:'render',value:function render(){var _props=this.props,documento=_props.documento,divisas=_props.divisas;if(!documento)return null;var moneda=documento.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["t" /* getDivisa */])(divisas,moneda);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Documentos_AttachedAditionalsBox__["a" /* default */],{adiciones:documento.get('adiciones'),divisa:divisa}));}}]);return Adiciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{documento:state.documentos.getIn(['modalSummary','data']),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Adiciones));

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_AttachedInvoicesBox__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RowControlFacturacion__ = __webpack_require__(620);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Facturas=function(_Component){_inherits(Facturas,_Component);function Facturas(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Facturas);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Facturas.__proto__||Object.getPrototypeOf(Facturas)).call.apply(_ref,[this].concat(args))),_this),_this.calcularTotales=function(doc,origen){var total=0;if(doc.get('estado')==0){return total;}if(doc.get('documentos')){doc.get('documentos').map(function(d){return total+=_this.calcularTotales(d,doc);});}if(doc.get('tipo')==6){var totalSevicios=origen.get('detalles').reduce(function(a,b){if(!b.get('adicion_id'))a+=b.get('valor')*b.get('cantidad');return a;},0);//total -= Math.round((totalSevicios * (origen.get('anticipo'))) / 100)
total-=totalSevicios*origen.get('anticipo')/100;}else{total+=doc.get('detalles').reduce(function(a1,b1){a1+=b1.get('valor_con_iva')*b1.get('cantidad');return a1;},0);}return total;},_this.calcularTotalesSinAnticipo=function(doc){var total=0;if(doc.get('estado')==0){return total;}if(doc.get('documentos')){doc.get('documentos').map(function(d){return total+=_this.calcularTotalesSinAnticipo(d);});}total+=doc.get('detalles').reduce(function(a1,b1){a1+=b1.get('valor_con_iva')*b1.get('cantidad');return a1;},0);return total;},_this.obtenerDetalles=function(documento){var totales={sin_iva:0,con_iva:0,sin_iva_sin_adiciones:0,con_iva_sin_adiciones:0};documento.get('detalles').forEach(function(a){totales.sin_iva+=a.get('valor')*a.get('cantidad');totales.con_iva+=a.get('valor_con_iva')*a.get('cantidad');if(a.get('adicion_id')===null){totales.sin_iva_sin_adiciones+=a.get('valor')*a.get('cantidad');totales.con_iva_sin_adiciones+=a.get('valor_con_iva')*a.get('cantidad');}});return totales;},_this.obtenerTotalAnticipo=function(documento){var totales={valor_total_anticipos:0,anticipo_legalizado:0,pendiente_legalizar:0};var documentos=[];documentos.push(documento);documento.get('documentos').filter(function(d){return d.get('tipo')==4;}).map(function(x){documentos.push(x);});var valor_total_anticipos=documentos.reduce(function(acc1,current1){var anticipo=current1.get('anticipo');var total_detalles=current1.get('detalles').reduce(function(acc2,current2){if(current2.get('adicion_id')===null){acc2+=current2.get('valor')*current2.get('cantidad');}return acc2;},0);acc1+=anticipo/100*total_detalles;return acc1;},0);totales.valor_total_anticipos=valor_total_anticipos;var anticipo_legalizado=documentos.reduce(function(acc1,current1){return acc1+=current1.get('anticipo_legalizado')||0;},0);totales.anticipo_legalizado=anticipo_legalizado;totales.pendiente_legalizar=valor_total_anticipos-totales.anticipo_legalizado;return totales;},_this.obtenerTotalFacturacion=function(documento){var totales={sin_iva:0,con_iva:0};var documentos=[];documentos.push(documento);documento.get('documentos').filter(function(d){return d.get('tipo')==4;}).map(function(x){documentos.push(x);});var sin_iva=documentos.reduce(function(acc1,current1){acc1+=current1.get('detalles').reduce(function(acc2,current2){return acc2+=current2.get('valor')*current2.get('cantidad');},0);return acc1;},0);var con_iva=documentos.reduce(function(acc1,current1){acc1+=current1.get('detalles').reduce(function(acc2,current2){return acc2+=current2.get('valor_con_iva')*current2.get('cantidad');},0);return acc1;},0);totales.sin_iva=sin_iva;totales.con_iva=con_iva;return totales;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Facturas,[{key:'render',value:function render(){var _this2=this;var _props=this.props,documento=_props.documento,enums=_props.enums,divisas=_props.divisas;if(!documento)return null;var moneda=documento.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var cencos={};var totales=this.obtenerDetalles(documento);var totalAnticipo=this.obtenerTotalAnticipo(documento);var totalFacturacion=this.obtenerTotalFacturacion(documento);var por_recibir=documento.get('entregas').filter(function(e){return e.get('recibido')==false;}).count()>0;documento.get('todos_detalles').forEach(function(a,b){a.get('cencos').forEach(function(c,d){if(!cencos[c.get('codigo')])cencos[c.get('codigo')]={codigo:null,descripcion:null,total:0};cencos[c.get('codigo')].codigo=c.get('codigo');cencos[c.get('codigo')].descripcion=c.get('descripcion');cencos[c.get('codigo')].total+=Number(c.get('porcentaje'))/100*(a.get('valor_con_iva')*a.get('cantidad'));});});totales.facturado=documento.get('facturas').reduce(function(acc,current){return acc+current.get('valor_con_iva');},0);var saldo=Math.round(this.calcularTotalesSinAnticipo(documento),2)-Math.round(totales.facturado,2);var saldoTotal=this.calcularTotalesSinAnticipo(documento)-totales.facturado;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Control de facturaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'120px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{rowSpan:2},'Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:2,style:{textAlign:'center'}},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:2,style:{textAlign:'center'}},'Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{rowSpan:2},'Saldo Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{rowSpan:2},'Anticipo por Legalizar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Antes de IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.tipos[documento.get('tipo')].PREFIJO+documento.get('consecutivo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(totales.sin_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(totales.con_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},'0%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(0,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'},rowSpan:documento.get('documentos').count()*2},Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(saldo,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'},rowSpan:documento.get('documentos').count()*2},Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(totalAnticipo.pendiente_legalizar,divisa.simbolo))),documento.get('documentos').map(function(d,i){return d.get('estado')>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RowControlFacturacion__["a" /* RowControlFacturacion */],{origen:documento,documento:d,enums:enums,totalDetalles:_this2.obtenerDetalles,divisa:divisa,key:'tr12['+i+']'}):null;})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n del gasto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'120px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:'2',style:{textAlign:'center'}},'Centro de costo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{rowSpan:'2'},'Valor')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Descripci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,Object.keys(cencos).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr10['+x+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,cencos[x].codigo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,cencos[x].descripcion),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(cencos[x].total,divisa.simbolo)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2,style:{textAlign:'right',fontWeight:'bold'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(totalFacturacion.con_iva,divisa.simbolo))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),por_recibir&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-warning',style:{fontWeight:'bold',border:'1px solid #8a6d3b'}},'Para cargar facturas adicionales, el usuario debe recibir y calificar la entrega parcial.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_AttachedInvoicesBox__["a" /* default */],{saldo:saldoTotal,por_recibir:por_recibir,divisa:divisa}))));}}]);return Facturas;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{documento:state.documentos.getIn(['modalSummary','data']),enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Facturas));

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreateEntrega=function(_Component){_inherits(ModalCreateEntrega,_Component);function ModalCreateEntrega(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreateEntrega);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreateEntrega.__proto__||Object.getPrototypeOf(ModalCreateEntrega)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('modalCreateEntrega');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateEntrega .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalCreateEntrega(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreateEntrega,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreateEntrega=_props.modalCreateEntrega,documento=_props.documento;if(!modalCreateEntrega.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalCreateEntrega',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:'Verificación de recibido',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalCreateEntrega");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Guardar',onClick:function onClick(e){return _this2.props.createOrUpdateDocumento();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de recibido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalCreateEntrega.getIn(['data','fecha'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateEntrega.data.fecha',e.target.value);}})))),documento.get('entregas_parciales')==true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor a facturar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateEntrega.getIn(['data','valor_a_facturar'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateEntrega.data.valor_a_facturar',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-info'},'Diligencie el valor a facturar sin puntos, comas ni caracteres especiales.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control input-sm',rows:3,value:modalCreateEntrega.getIn(['data','observaciones'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateEntrega.data.observaciones',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Evaluaci\xF3n del servicio recibido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'5 = alta')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3 = media')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'1 = baja')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'70%'}},'Criterio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Calificaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalCreateEntrega.getIn(['data','evaluaciones']).map(function(a,b){var path=['criterios',a.get('criterio'),'VALORES_PERMITIDOS'];var options=modalCreateEntrega.getIn(path)?modalCreateEntrega.getIn(path).split(','):[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr9['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('criterio')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:a.get('calificacion')||0,onChange:function onChange(e){return _this2.props.updateInputs('modalCreateEntrega.data.evaluaciones.'+b+'.calificacion',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opci\xF3n'),options.map(function(c,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt9['+d+']',value:c},c);}))));}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalCreateEntrega;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalCreateEntrega:state.documentos.get('modalCreateEntrega'),documento:state.documentos.getIn(['modalSummary','data'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalCreateEntrega:function showHideModalCreateEntrega(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["j" /* showHideModalCreateEntrega */])(state));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["n" /* updateInputs */])(path,value,immutable));},createOrUpdateDocumento:function createOrUpdateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_documentos__["d" /* createOrUpdateDocumento */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreateEntrega));

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var filesTypes=__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* acceptedFiles */].map(function(x){return x.type;}).join();var ModalAddFactura=function(_Component){_inherits(ModalAddFactura,_Component);function ModalAddFactura(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddFactura);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddFactura.__proto__||Object.getPrototypeOf(ModalAddFactura)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('modalAddFactura');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddFactura .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalAddFactura(false);},300);},_this.handleOnDrop=function(files){if(files.length>1){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('Solo es permitido procesar un archivo a la vez',{bodyClassName:'toastify-content toastify-warning'});return;}_this.props.uploadFacturaFile(files[0]);},_this.handleOnRejected=function(files){files.forEach(function(x){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('El archivo '+x.name+' no es del tipo esperado. '+x.type,{bodyClassName:'toastify-content toastify-warning'});});},_this.setIcon=function(icon){if(icon){var imageSrc=__webpack_require__(80)("./"+icon);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageSrc});}return null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddFactura,[{key:'render',value:function render(){var _this2=this;var modalAddFactura=this.props.modalAddFactura;if(!modalAddFactura.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Modal__["a" /* default */],{id:'modalAddFactura',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__["a" /* default */],{title:'Adici\xF3n de facturas al documento',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalAddFactura");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Guardar',onClick:function onClick(e){return _this2.props.showHideModalLastFactura(true,_this2.props.storeFactura);},disabled:modalAddFactura.get('btnDisabled')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_dropzone__["a" /* default */],{accept:filesTypes,onDropAccepted:this.handleOnDrop,onDropRejected:this.handleOnRejected,className:'dropzone1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Arrastre la factura escaneada a esta secci\xF3n')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre del archivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'div-input-sm'},modalAddFactura.getIn(['data','file'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'1px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.setIcon(modalAddFactura.getIn(['data','icono']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'4px',verticalAlign:'bottom'}},modalAddFactura.getIn(['data','file']).name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px',verticalAlign:'bottom',color:'#ccc'}},'(',__WEBPACK_IMPORTED_MODULE_3_numeral___default()(modalAddFactura.getIn(['data','file']).size).format('0.0 b'),')')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Factura n\xFAmero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalAddFactura.getIn(['data','numero_factura']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddFactura.data.numero_factura',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de la factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalAddFactura.getIn(['data','fecha_factura'])).format('YYYY-MM-DD'),onChange:function onChange(e){return _this2.props.updateInputs('modalAddFactura.data.fecha_factura',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddFactura.getIn(['data','valor_sin_iva'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddFactura.data.valor_sin_iva',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddFactura.getIn(['data','valor_con_iva'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddFactura.data.valor_con_iva',e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddFactura;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddFactura:state.common.get('modalAddFactura')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalAddFactura:function showHideModalAddFactura(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["r" /* showHideModalAddFactura */])(show));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["C" /* updateInputs */])(path,value,immutable));},uploadFacturaFile:function uploadFacturaFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["E" /* uploadFacturaFile */])(file));},storeFactura:function storeFactura(last){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["A" /* storeFactura */])(last));},showHideModalLastFactura:function showHideModalLastFactura(show,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["v" /* showHideModalLastFactura */])(show,action));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddFactura));

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalLastFactura=function(_Component){_inherits(ModalLastFactura,_Component);function ModalLastFactura(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalLastFactura);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalLastFactura.__proto__||Object.getPrototypeOf(ModalLastFactura)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalLastFactura');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalLastFactura .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalLastFactura(false);},300);},_this.handleCloseParentModal=function(e){var modalParent=document.getElementById('modalAddFactura');modalParent.classList.remove('fadeIn');modalParent.classList.add('fadeOut');var modal=document.getElementById('modalLastFactura');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');setTimeout(function(){_this.props.showHideModalAddFactura(false);_this.props.showHideModalLastFactura(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalLastFactura,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalLastFactura=_props.modalLastFactura,saldo=_props.saldo,tolerancia=_props.tolerancia;if(!modalLastFactura.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalLastFactura',show:true,ZIndex:2000},saldo<=0||Math.abs(saldo)<=Number(tolerancia)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},'Está a punto de cerrar la solicitud. ¿Desea hacerlo?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseParentModal(e);}},'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return modalLastFactura.get('action')(true);}},'Si'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},'Esta solicitud aún tiene saldo pendiente y no puede ser cerrado')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return modalLastFactura.get('action')(false);}},'Aceptar'))));}}]);return ModalLastFactura;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalLastFactura:state.common.get('modalLastFactura'),modalAddFactura:state.common.get('modalAddFactura'),saldo:Number(state.common.getIn(['modalAddFactura','saldo']))-Number(state.common.getIn(['modalAddFactura','data','valor_con_iva'])),tolerancia:state.common.getIn(['parametros','TOLERANCIA',0,'VALOR'])||0};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalLastFactura:function showHideModalLastFactura(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["v" /* showHideModalLastFactura */])(open));},showHideModalAddFactura:function showHideModalAddFactura(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["r" /* showHideModalAddFactura */])(show));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalLastFactura));

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Otrosi_ModalCreate__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_otrosi__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddAdicional=function(_Component){_inherits(ModalAddAdicional,_Component);function ModalAddAdicional(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddAdicional);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddAdicional.__proto__||Object.getPrototypeOf(ModalAddAdicional)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddAdicional');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddAdicional .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalAddAdicional(false);},300);},_this.handleOpenSelector=function(list){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var responsables=[];var payload={};var fn=function fn(a){var index=_this.props.modalAddAdicional.getIn(['data','cencos']).findIndex(function(c){return c.getIn(['cenco','id'])==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_DOCUMENTOS',payload);}};_this.props.modalAddAdicional.get('detalles').valueSeq().forEach(function(detalle){detalle.get('cencos').valueSeq().forEach(function(cenco){return responsables.push(cenco.get('responsable_id'));});});var customFilter={column:'T0.responsable_id',operator:'IN',value:'('+responsables.join(',')+')',comparison:'number'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddAdicional,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalAddAdicional=_props.modalAddAdicional,tipo_solicitud=_props.tipo_solicitud;if(!modalAddAdicional.get('show')){return null;}var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',size:14,name:'plus-circle',onClick:function onClick(e){return _this2.props.addCencoItem();},title:'Nueva'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',size:14,name:'trash',onClick:function onClick(e){return _this2.props.removeCencosItem();},title:'Eliminar',disabled:modalAddAdicional.getIn(['data','cencos']).filter(function(x){return x.get('selected');}).count()===0,danger:true})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_Modal__["a" /* default */],{id:'modalAddAdicional',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__["a" /* default */],{title:'Creaci\xF3n de adicionales',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Guardar',onClick:function onClick(e){return _this2.props.storeAdicion();},disabled:modalAddAdicional.get('guardando')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'60vw',height:'40vh',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control input-sm',rows:4,value:modalAddAdicional.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.descripcion',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tipo_solicitud!==3?"col-md-2":"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddAdicional.getIn(['data','cantidad'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.cantidad',e.target.value);},disabled:tipo_solicitud==3}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tipo_solicitud!==3?"col-md-2":"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor total sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddAdicional.getIn(['data','valor']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.valor',e.target.value,tipo_solicitud);}}))),tipo_solicitud!==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'IVA, %'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddAdicional.getIn(['data','iva']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.iva',e.target.value,tipo_solicitud);}}))),tipo_solicitud!==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_13_numeral___default()(modalAddAdicional.getIn(['data','cantidad'])*modalAddAdicional.getIn(['data','valor_con_iva'])).format('$0,0.00'),onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.valor_con_iva',e.target.value,tipo_solicitud);},disabled:true}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-md-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddAdicional.getIn(['data','valor_con_iva']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.valor_con_iva',e.target.value,tipo_solicitud);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalAddAdicional.getIn(['data','fecha_entrega'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.fecha_entrega',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Layout_Box__["a" /* default */],{title:'Centros de costo',actions:boxActions,onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalAddAdicional.getIn(['data','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('guid')+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.getIn('selected'),onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'75%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_SelectorInput__["a" /* default */],{value:x.getIn(['cenco','descripcion'])?x.getIn(['cenco','descripcion']):'',onClick:function onClick(){return _this2.handleOpenSelector('modalAddAdicional.data.cencos.'+n+'.cenco');},onReset:function onReset(){return _this2.props.updateInputs('modalAddAdicional.data.cencos.'+n+'.cenco',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.get('porcentaje'),onChange:function onChange(e){return _this2.props.updateInputs('modalAddAdicional.data.cencos.'+n+'.porcentaje',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Otrosi_ModalCreate__["a" /* default */],null));}}]);return ModalAddAdicional;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalAddAdicional:state.documentos.get('modalAddAdicional')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalAddAdicional:function showHideModalAddAdicional(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["i" /* showHideModalAddAdicional */])(open));},updateInputs:function updateInputs(path,value,tipo_solicitud){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["n" /* updateInputs */])(path,value,null,true,tipo_solicitud));},addCencoItem:function addCencoItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["a" /* addCencoItem */])());},removeCencosItem:function removeCencosItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["f" /* removeCencosItem */])());},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_common__["q" /* selectFromSelector */])(type,payload));},storeAdicion:function storeAdicion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["l" /* storeAdicion */])());},createOtrosi:function createOtrosi(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_otrosi__["a" /* createOtrosi */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddAdicional));

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getCotizaciones;
/* harmony export (immutable) */ __webpack_exports__["d"] = changeRecordsToShow;
/* harmony export (immutable) */ __webpack_exports__["e"] = filterCotizaciones;
/* harmony export (immutable) */ __webpack_exports__["j"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["k"] = showHideModalFilter;
/* harmony export (immutable) */ __webpack_exports__["b"] = addModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["c"] = applyFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["l"] = showHideModalSummary;
/* harmony export (immutable) */ __webpack_exports__["m"] = showHideModalSummaryCotizaciones;
/* harmony export (immutable) */ __webpack_exports__["g"] = registerCotizacion;
/* harmony export (immutable) */ __webpack_exports__["h"] = registerSolicitudCotizaciones;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["a"] = addFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(3);
function getCotizaciones(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().externoscotizaciones.get('showRecords');var orderBy=getState().externoscotizaciones.get('orderBy');var filters=getState().externoscotizaciones.getIn(['modalFilter','filters']).filter(function(x){return x.get('apply');}).toJS();var having=[];axios.get(__WEBPACK_IMPORTED_MODULE_3____["b" /* API_URL */]+'/externos/cotizaciones',{params:{estado:1,page:page,showRecords:showRecords,orderBy:orderBy,filters:filters,having:having}}).then(function(res){var data=res.data.data.map(function(x){x.visible=true;x.selected=false;return x;});var totalRecords=Number(res.data.totalRecords);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_293" /* OBTENER_EXTERNOS_COTIZACIONES */],payload:{data:data,page:page,totalRecords:totalRecords}});};fn1(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}function changeRecordsToShow(showRecords){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_36" /* CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES */],payload:showRecords});};var fn1=function fn1(d){return d(getCotizaciones(1));};fn0(dispatch);fn1(dispatch);};}function filterCotizaciones(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_173" /* FILTRAR_EXTERNOS_COTIZACIONES */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().externoscotizaciones.get('orderBy');current=current.set('field',field.value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_325" /* ORDENAR_EXTERNOS_COTIZACIONES */],payload:{orderBy:current}});};var fn1=function fn1(d){return d(getCotizaciones(1));};fn0(dispatch);fn1(dispatch);};}function showHideModalFilter(state,tableCols){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_270" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES */],payload:{state:state,tableCols:tableCols}});};}function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["q" /* ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */]});};}function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_143" /* ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */]});};}function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_48" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */],payload:{index:index,checked:checked}});};}function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_184" /* MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */],payload:{index:index,attr:attr,value:value}});};}function applyFilterCriterias(){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_22" /* APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES */]});};var fn1=function fn1(d){return d(getCotizaciones(1));};fn0(dispatch);fn1(dispatch);};}function showHideModalSummary(show,id){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_3____["b" /* API_URL */]+'/externos/cotizaciones',{params:{id:id}}).then(function(res){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_281" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES */],payload:{show:show,data:res.data}});};fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});};}function showHideModalSummaryCotizaciones(show,solicitud_id){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){if(show){axios.get(__WEBPACK_IMPORTED_MODULE_3____["b" /* API_URL */]+'/externos/cotizaciones/solicitud',{params:{id:solicitud_id}}).then(function(res){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_282" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD */],payload:{show:show,data:res.data}});};fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});}else{var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_282" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD */],payload:{show:show}});};fn2(dispatch);}};}function registerCotizacion(id,result){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_281" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES */],payload:{show:false}});};var data=getState().externoscotizaciones.getIn(['modalSummary','data']).set('result',result);var modificaciones=[];var files=[];files=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* attachFilesToEntity */])('Cotizacione',[data]);var errors=validateCotizacion(data);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{modificaciones.push({id:data.get('id'),entity:'Cotizacione',value:{estado:result,fecha_entrega:data.get('fecha_entrega'),observaciones:data.get('observaciones')},action:'edit'});axios.put(__WEBPACK_IMPORTED_MODULE_3____["b" /* API_URL */]+'/externos/cotizaciones/'+id,modificaciones).then(function(res){var fn1=function fn1(d){return d(getCotizaciones(1));};var fn2=function fn2(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Los cambios han sido guardados exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn0,fn1,fn2]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});}};}// export function registerSolicitudCotizaciones(solicitud_id) {
// 	const axios = createAxiosInstance()
// 	return (dispatch, getState) => {
// 		const fn0 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD, payload: { show: false }})
// 		const cotizaciones = getState().externoscotizaciones.getIn(['modalSummaryCotizaciones', 'data', 'cotizaciones'])
// 		const modificaciones = []
// 		cotizaciones.valueSeq().forEach(cotizacion => {
// 			modificaciones.push({
// 				id: cotizacion.get('id'),
// 				entity: 'Cotizacione',
// 				value: {					
// 					marca: cotizacion.get('marca'),
// 					cotizado: cotizacion.get('cotizado'),
// 					iva: cotizacion.get('iva'),
// 					cotizado_iva: cotizacion.get('cotizado_iva'),
// 					tiempo_entrega: cotizacion.get('tiempo_entrega'),
// 					estado: 3
// 				},
// 				action: 'edit'
// 			})
// 		})
// 		axios.put(`${API_URL}/externos/cotizaciones/solicitud/${solicitud_id}`, modificaciones)
// 		.then((res) => {
// 			const fn1 = () => toast.success('Las cotizaciones han sido enviadas exitosamente', { bodyClassName: 'toastify-content toastify-success' })
// 			const fn2 = (d) => d(getCotizaciones(1))
// 			dispatch(fn0)
// 			dispatch(fn1)
// 			dispatch(fn2)
// 		})
// 		.catch(err => {
// 			displayMessages(dispatch, err)
// 		})
// 	}
// }
function registerSolicitudCotizaciones(solicitud_id){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var dataFiles=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List();var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_282" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD */],payload:{show:false}});};var cotizaciones=getState().externoscotizaciones.getIn(['modalSummaryCotizaciones','data','solicitud','cotizaciones']);var archivo=getState().externoscotizaciones.getIn(['modalSummaryCotizaciones','data','solicitud','cotizaciones',0,'adjunto']);var errors=validateSolicitudCotizaciones(cotizaciones,archivo);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[];cotizaciones.valueSeq().forEach(function(cotizacion){dataFiles=dataFiles.push(cotizacion);if(!cotizacion.get('no_cotizar')){modificaciones.push({id:cotizacion.get('id'),entity:'Cotizacione',value:{marca:cotizacion.get('marca'),cotizado:cotizacion.get('cotizado'),iva:cotizacion.get('iva'),cotizado_iva:cotizacion.get('cotizado_iva'),tiempo_entrega:cotizacion.get('tiempo_entrega'),estado:3},action:'edit'});}else{modificaciones.push({id:cotizacion.get('id'),entity:'Cotizacione',value:{marca:cotizacion.get('marca'),cotizado:0,iva:0,cotizado_iva:0,tiempo_entrega:0,estado:0},action:'edit'});}});var files=[];files=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["g" /* attachFilesToEntity */])('Cotizacione',dataFiles);axios.put(__WEBPACK_IMPORTED_MODULE_3____["b" /* API_URL */]+'/externos/cotizaciones/solicitud/'+solicitud_id,modificaciones).then(function(){var fn1=function fn1(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('Las cotizaciones han sido enviadas exitosamente',{bodyClassName:'toastify-content toastify-success'});};var fn2=function fn2(d){return d(getCotizaciones(1));};dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["F" /* uploadFiles */])('/files/'+solicitud_id,files,[fn0,fn1,fn2]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);});}};}function updateInputs(path,value){return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_199" /* MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES */],payload:{path:path,value:value}});};fn0(dispatch);var tipomodal=path.split('.')[0];if(tipomodal=='modalSummary'){if(path==='modalSummary.data.iva'||path==='modalSummary.data.cotizado'){var iva=getState().externoscotizaciones.getIn('modalSummary.data.iva'.split('.'));var cotizado=getState().externoscotizaciones.getIn('modalSummary.data.cotizado'.split('.'));//const cotizado_iva = Math.round(cotizado * (1 + (iva / 100)))
var cotizado_iva=cotizado*(1+iva/100);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_199" /* MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES */],payload:{path:'modalSummary.data.cotizado_iva',value:cotizado_iva}});};fn1(dispatch);}}if(tipomodal=='modalSummaryCotizaciones'){var attribute=path.split('.').slice(-1)[0];var index=path.split('.').slice(-2)[0];var cotizaciones=getState().externoscotizaciones.getIn(['modalSummaryCotizaciones','data','solicitud','cotizaciones']);var marca=cotizaciones.getIn([index,'marca']);var _cotizado=cotizaciones.getIn([index,'cotizado']);var _iva=cotizaciones.getIn([index,'iva']);var tiempo_entrega=cotizaciones.getIn([index,'tiempo_entrega']);var adjunto=cotizaciones.getIn([index,'adjunto','file']);if(attribute==='cotizado'||attribute==='iva'){var _cotizado_iva=_cotizado*(1+_iva/100);var _fn=function _fn(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_199" /* MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES */],payload:{path:'modalSummaryCotizaciones.data.solicitud.cotizaciones.'+index+'.cotizado_iva',value:_cotizado_iva}});};_fn(dispatch);}var check=marca||_cotizado||_iva||tiempo_entrega||adjunto?false:true;var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_199" /* MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES */],payload:{path:'modalSummaryCotizaciones.data.solicitud.cotizaciones.'+index+'.no_cotizar',value:check}});};fn2(dispatch);}};}// export function addFile(path) {
// 	return (dispatch, getState) => {
// 		const data = getState().common.getIn(['modalAddFile', 'data'])
// 		const errors = []
// 		if (!data.get('file')) errors.push('No adicionó ningun archivo')
// 		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
// 		if (data.get('clasificacion') && data.get('clasificacion') != 'Cotizaciones') errors.push('Se requiere adjuntar un archivo de tipo cotización')
// 		if (errors.length > 0) {
// 			errors.forEach(x => {
// 				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
// 			})
// 		} else {
// 			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES, payload: {path, data} })
// 			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
// 			fn1(dispatch)
// 			fn2(dispatch)
// 		}
// 	}
// }
function addFile(path){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(data.get('clasificacion')&&data.get('clasificacion')!='Cotizaciones')errors.push('Se requiere adjuntar un archivo de tipo cotización');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["P" /* ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES */],payload:{path:path,data:data}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}///******* Shared ********///
var validateCotizacion=function validateCotizacion(data){var errors=[];//if (!data.get('cotizado')) errors.push('El valor de la cotización es requerida')
//if (data.get('cotizado') && data.get('cotizado') == 0) errors.push('El valor de la cotización es requerida')
if(!data.get('fecha_entrega'))errors.push('El valor de la fecha de entrega es requerida');if(!data.get('adjunto'))errors.push('Se requiere adjuntar un archivo con la cotización');if(data.get('adjunto')&&data.getIn(['adjunto','clasificacion'])!='Cotizaciones')errors.push('Se requiere adjuntar un archivo de tipo cotización');return errors;};var validateSolicitudCotizaciones=function validateSolicitudCotizaciones(data,archivo){var errors=[];var no_cotizados=0;if(archivo==null)errors.push('El Archivo es requerido');data.map(function(cotizacion){var target=cotizacion.getIn(['bienes',0,'descripcion']);no_cotizados+=cotizacion.get('no_cotizar')?1:0;if(!cotizacion.get('no_cotizar')){if(!cotizacion.get('marca'))errors.push('La marca es requerida en '+target);if(!cotizacion.get('cotizado'))errors.push('El valor unitario es requerido en '+target);if(!cotizacion.get('iva'))errors.push('El valor del iva es requerido en '+target);if(!cotizacion.get('tiempo_entrega'))errors.push('El tiempo de entrega es requerido en '+target);}});if(no_cotizados==data.count())errors.push('No diligenció ninguna cotización para ningún ítem');return errors;};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(57).f;
var has = __webpack_require__(70);
var TAG = __webpack_require__(38)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(725);
var global = __webpack_require__(37);
var hide = __webpack_require__(71);
var Iterators = __webpack_require__(86);
var TO_STRING_TAG = __webpack_require__(38)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 130 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* unused harmony export bpfrpt_proptype_RowRenderer */
/* unused harmony export bpfrpt_proptype_RenderedRows */
/* unused harmony export bpfrpt_proptype_Scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


var bpfrpt_proptype_RowRendererParams =  true ? null : {
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_RowRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};






/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(184);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(44)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(89)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(305);
var defined = __webpack_require__(183);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(75);
var call = __webpack_require__(311);
var isArrayIter = __webpack_require__(312);
var anObject = __webpack_require__(90);
var toLength = __webpack_require__(136);
var getIterFn = __webpack_require__(313);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(407);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(41);
var normalizeHeaderName = __webpack_require__(410);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(220);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(220);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147)))

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports=function(modules){var installedModules={};function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{enumerable:!0,get:getter})},__webpack_require__.r=function(exports){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(exports,"__esModule",{value:!0})},__webpack_require__.t=function(value,mode){if(1&mode&&(value=__webpack_require__(value)),8&mode)return value;if(4&mode&&"object"==typeof value&&value&&value.__esModule)return value;var ns=Object.create(null);if(__webpack_require__.r(ns),Object.defineProperty(ns,"default",{enumerable:!0,value:value}),2&mode&&"string"!=typeof value)for(var key in value)__webpack_require__.d(ns,key,function(key){return value[key]}.bind(null,key));return ns},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=0)}([function(module,__webpack_exports__,__webpack_require__){"use strict";function _typeof(obj){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj})(obj)}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}__webpack_require__.r(__webpack_exports__);var _g=function(){return global||window}.bind(void 0),OfType=function(){function OfType(){!function(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}(this,OfType);var _this=this;return function(value,type){return _this._setInitials(arguments,value,type),_this._validate()}}var Constructor,protoProps,staticProps;return Constructor=OfType,(protoProps=[{key:"_setInitials",value:function(_arguments,value,type){this._arguments=_arguments,this._value=value,this._type=type}},{key:"_validate",value:function(){return!!this.isTypeDefined&&(this.isTypeNull?this.isValueNull:this.isTypeUndefined?void 0===this._value:this.isTypeFunction?this._typeConstructor():this.isTypeArray?this._typeArray():this.isTypeString?this._typeString():!!this.isTypeRegExp&&this._typeRegexp())}},{key:"_typeConstructor",value:function(){return!this.isValueUndefined&&!this.isValueNull&&Object.getPrototypeOf(this._value).constructor===this._type}},{key:"_typeArray",value:function(){if(!this._type.length)return!0;var _iteratorNormalCompletion=!0,_didIteratorError=!1,_iteratorError=void 0;try{for(var _step,_iterator=this._type[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=!0){var t=_step.value;if(null===t&&this.isValueNull)return!0;if(void 0===t&&this.isValueUndefined)return!0;if(!this.isValueNull&&!this.isValueUndefined&&(null!==t&&void 0!==t&&Object.getPrototypeOf(this._value).constructor===t))return!0}}catch(err){_didIteratorError=!0,_iteratorError=err}finally{try{_iteratorNormalCompletion||null==_iterator.return||_iterator.return()}finally{if(_didIteratorError)throw _iteratorError}}return!1}},{key:"_typeString",value:function(){var _this2=this,typeList=this._type.toLowerCase().split("|");if(1===typeList.length&&""===typeList[0]||typeList.some(function(i){return"any"===i}))return!0;if(typeList.some(function(i){return"truthy"===i})&&this._value)return!0;if(typeList.some(function(i){return"falsy"===i})&&!this._value)return!0;if(this.isValueUndefined&&typeList.some(function(i){return"undefined"===i}))return!0;if(this.isValueNull&&typeList.some(function(i){return"null"===i}))return!0;if(this.isValueNull||void 0===this._value)return!1;var valueConstructor=Object.getPrototypeOf(this._value).constructor;return!!(this.argumentsRegExp.test(this._value.toString())&&valueConstructor&&valueConstructor===Object&&typeList.some(function(i){return"arguments"===i}))||(!!(typeList.some(function(i){return"instance"===i})&&this.isValueObject&&valueConstructor&&valueConstructor!==_g()[valueConstructor.name])||(!(!typeList.some(function(i){return"objectable"===i})||!this.isObjectInstance)||typeList.some(function(i){return i===Object.getPrototypeOf(_this2._value).constructor.name.toLowerCase()})))}},{key:"_typeRegexp",value:function(){if(this._exec("any")||this._type.test(""))return!0;if(this._exec("truthy")&&this._value)return!0;if(this._exec("falsy")&&!this._value)return!0;if(this._type.test("undefined")&&this.isValueUndefined)return!0;if(this._type.test("null")&&this.isValueNull)return!0;if(this.isValueNull||void 0===this._value)return!1;var valueConstructor=Object.getPrototypeOf(this._value).constructor;return!!(this._exec("arguments")&&valueConstructor&&valueConstructor===Object&&this.argumentsRegExp.test(this._value.toString()))||(!!(this._exec("instance")&&this.isValueObject&&valueConstructor&&valueConstructor!==_g()[valueConstructor.name])||(!(!this._exec("objectable")||!this.isObjectInstance)||this._type.test(Object.getPrototypeOf(this._value).constructor.name)))}},{key:"_exec",value:function(name){var _exec=this._type.exec(name);return null!==_exec&&_exec[0]===name}},{key:"isTypeDefined",get:function(){return this._arguments.length>=2}},{key:"isTypeString",get:function(){return"string"==typeof this._type}},{key:"isTypeFunction",get:function(){return"function"==typeof this._type}},{key:"isTypeUndefined",get:function(){return void 0===this._type}},{key:"isValueUndefined",get:function(){return void 0===this._value}},{key:"isTypeNull",get:function(){return null===this._type}},{key:"isValueNull",get:function(){return null===this._value}},{key:"isValueObject",get:function(){return"object"===_typeof(this._value)}},{key:"isObjectInstance",get:function(){return this._value instanceof Object}},{key:"isTypeArray",get:function(){return!this.isTypeNull&&"object"===_typeof(this._type)&&this._type.constructor===Array}},{key:"isTypeRegExp",get:function(){return this._type&&this._type.constructor===RegExp}},{key:"argumentsRegExp",get:function(){return/^\[object Arguments\]$/i}}])&&_defineProperties(Constructor.prototype,protoProps),staticProps&&_defineProperties(Constructor,staticProps),OfType}();__webpack_exports__.default=new OfType}]).default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getParametros;
/* harmony export (immutable) */ __webpack_exports__["k"] = toggleSelectItem;
/* harmony export (immutable) */ __webpack_exports__["j"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["e"] = filterParametros;
/* harmony export (immutable) */ __webpack_exports__["h"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["d"] = displayModalCreate;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOrUpdateParametros;
/* harmony export (immutable) */ __webpack_exports__["i"] = showHideModalDelete;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteParametros;
/* harmony export (immutable) */ __webpack_exports__["a"] = addParametroConfig;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeParametrosConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
function getParametros(){return function(dispatch){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/admin/parametros').then(function(res){var data=res.data.map(function(x){x.visible=true;x.selected=false;x.parametro_cols.map(function(y){y.guid=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["B" /* guid */])();return y;});return x;});var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_288" /* OBTENER_ADMIN_PARAMETROS */],payload:data});};fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function toggleSelectItem(id,checked){return function(dispatch,getState){var index=getState().parametros.get('parametros').findIndex(function(x){return x.get('id')===id;});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_44" /* CONMUTAR_SELECCION_ADMIN_PARAMETRO */],payload:{index:index,checked:checked}});};}function toggleSelectAllItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_61" /* CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS */],payload:checked});};}function filterParametros(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_171" /* FILTRAR_ADMIN_PARAMETROS */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().parametros.get('orderBy');current=current.set('field',field.Value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_322" /* ORDENAR_ADMIN_PARAMETROS */],payload:{orderBy:current}});};}function displayModalCreate(show,title,mode,id){return function(dispatch,getState){var user=getState().common.get('user');dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_255" /* MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO */],payload:{show:show,title:title,mode:mode,id:id,user:user}});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_203" /* MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS */],payload:{path:path,value:value}});};}function createOrUpdateParametros(data,mode){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_99" /* DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_99" /* DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS */],payload:false});};fn0(dispatch);if(mode==='create'){axios.post(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/admin/parametros',data.toJS()).then(function(res){var parametro=res.data;parametro.visible=true;parametro.selected=false;parametro.parametro_cols.map(function(y){y.guid=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["B" /* guid */])();return y;});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_75" /* CREAR_ACTUALIZAR_ADMIN_PARAMETRO */],payload:parametro});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El parametro ha sido guardado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}else if(mode==='edit'){axios.put(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/admin/parametros/'+data.get('id'),data.toJS()).then(function(res){var parametro=res.data;parametro.visible=true;parametro.selected=false;parametro.parametro_cols.map(function(y){y.guid=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["B" /* guid */])();return y;});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_75" /* CREAR_ACTUALIZAR_ADMIN_PARAMETRO */],payload:parametro});Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'El parametro ha sido actualizado exitosamente'});fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_248" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO */],payload:{open:open,message:message,action:action}});};}function deleteParametros(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selected=getState().parametros.get('parametros').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');});var fns=[];selected.forEach(function(x){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/admin/parametros/'+x);};fns.push(fn);});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var succeded=[];var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}else{succeded.push(x.result.data.Nombre);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_121" /* ELIMINAR_ADMIN_PARAMETRO */],payload:x.result.data.id});}});if(succeded.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Se han eliminado los siguentes parametros: '+succeded.join(', ')});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});});};}function addParametroConfig(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["O" /* ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO */]});};}function removeParametrosConfig(id){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selected=getState().parametros.getIn(['modalCreate','data','parametro_cols']).filter(function(x){return x.get('id')!==null&&x.get('selected');}).map(function(x){return x.get('id');});var fns=[];selected.forEach(function(x){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/admin/parametros/'+id+'/configuracion/'+x);};fns.push(fn);});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_140" /* ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO */]});};}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tableCols; });
/* unused harmony export findvalues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Usuarios_ModalCreate__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Usuarios_ModalDelete__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Usuarios_ModalFilter__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_usuarios__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tableCols=[{id:1,caption:'Nombre de usuario',value:'username',type:'string',format:'',width:'20%',LinkToEdit:true},{id:2,caption:'Nombre Completo',value:'fullname',type:'string',format:'',width:'30%'},{id:3,caption:'Email',value:'email',type:'string',format:'',width:'30%'},{id:4,caption:'Super usuario',value:'es_superusuario',type:'bool',format:'',width:'10%'},{id:5,caption:'LDAP',value:'ldap',type:'bool',format:'',width:'10%'},{id:6,caption:'Estado',value:'esta_activo',type:'bool',format:'',width:'10%'}];function findvalues(c,x){var value=x.getIn(c.value.split('.'));return value;}var Usuarios=function(_Component){_inherits(Usuarios,_Component);function Usuarios(){_classCallCheck(this,Usuarios);return _possibleConstructorReturn(this,(Usuarios.__proto__||Object.getPrototypeOf(Usuarios)).apply(this,arguments));}_createClass(Usuarios,[{key:'componentWillMount',value:function componentWillMount(){this.props.getUsuarios(1);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,usuarios=_props.usuarios,orderBy=_props.orderBy,page=_props.page,totalRecords=_props.totalRecords,showRecords=_props.showRecords;var boxActions=[// <BoxButton key="ba[0]" name="plus-circle" onClick={ e => this.props.displayModalCreate(true, 'Creación de usuarios', 'create') } title="Nuevo usuario"/>,
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[1]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los Usuarios seleccionados?',function(){return _this2.props.deleteUsuarios();});},disabled:usuarios.filter(function(x){return x.get('selected');}).count()===0,danger:true,title:'Eliminar par\xE1metro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[2]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true);},title:'Filtro'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.getUsuarios(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-right'})});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Usuarios del sistema',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeRecordsToShow(records);},pagination:pagination}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-usuarios'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(e.target.checked);},checked:usuarios.filter(function(x){return x.get('selected');}).count()>0&&usuarios.filter(function(x){return x.get('selected')&&x.get('visible');}).count()>=usuarios.filter(function(x){return x.get('visible');}).count()})),tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,usuarios.filter(function(x){return x.get('visible');}).count()>0?usuarios.filter(function(x){return x.get('visible');}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectItem(x.get('id'),e.target.checked);},checked:x.get('selected')})),tableCols.map(function(c){var alignment='left';var value=findvalues(c,x);if(c.type){switch(c.type){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format);alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Modificación de usuarios','edit',x.get('id'));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Usuarios_ModalCreate__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Usuarios_ModalDelete__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Usuarios_ModalFilter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Usuarios;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{usuarios:state.usuarios.get('usuarios'),orderBy:state.usuarios.get('orderBy'),totalRecords:state.usuarios.get('totalRecords'),showRecords:state.usuarios.get('showRecords'),page:state.usuarios.get('page')};}function mapDispatchToProps(dispatch){return{getUsuarios:function getUsuarios(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["h" /* getUsuarios */])(page));},toggleSelectItem:function toggleSelectItem(id,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["o" /* toggleSelectItem */])(id,checked));},toggleSelectAllItems:function toggleSelectAllItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["n" /* toggleSelectAllItems */])(checked));},filterUsuarios:function filterUsuarios(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["g" /* filterUsuarios */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["j" /* setOrderBy */])(field));},displayModalCreate:function displayModalCreate(show,title,mode,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["f" /* displayModalCreate */])(show,title,mode,id));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["k" /* showHideModalDelete */])(open,message,action));},deleteUsuarios:function deleteUsuarios(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["e" /* deleteUsuarios */])());},changeRecordsToShow:function changeRecordsToShow(records){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["c" /* changeRecordsToShow */])(records));},showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_usuarios__["l" /* showHideModalFilter */])(state));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Usuarios));

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tableCols; });
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Plantillas_ModalCreate__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Plantillas_ModalDelete__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Plantillas_ModalFilter__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_plantillas__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tableCols=[{Id:1,Caption:'Tipo documento',Value:'tipo',Type:'string',Format:'',Width:'12%'},{Id:2,Caption:'Nombre',Value:'nombre',Type:'string',Format:'',Width:'20%',LinkToEdit:true},{Id:3,Caption:'Plantilla',Value:'texto',Type:'html',Format:'',Width:'68%'}];function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_12__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.Value.split('.'));if(c.Id===1){if(value){value=enums.documentos.tipos[value].NOMBRE;}else if(value===0){value="Notificación";}}return value;}var Plantillas=function(_Component){_inherits(Plantillas,_Component);function Plantillas(){_classCallCheck(this,Plantillas);return _possibleConstructorReturn(this,(Plantillas.__proto__||Object.getPrototypeOf(Plantillas)).apply(this,arguments));}_createClass(Plantillas,[{key:'componentWillMount',value:function componentWillMount(){this.props.getPlantillas(1);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,plantillas=_props.plantillas,orderBy=_props.orderBy,page=_props.page,totalRecords=_props.totalRecords,showRecords=_props.showRecords,enums=_props.enums;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[0]',name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Creación de plantillas','create');},title:'Nuevo plantilla'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[1]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los Plantillas seleccionados?',function(){return _this2.props.deletePlantillas();});},disabled:plantillas.filter(function(x){return x.get('selected');}).count()===0,danger:true,title:'Eliminar par\xE1metro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[2]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true);},title:'Filtro'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.getPlantillas(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-right'})});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Plantillas disponibles',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeRecordsToShow(records);},pagination:pagination}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-plantillas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(e.target.checked);},checked:plantillas.filter(function(x){return x.get('selected');}).count()>0&&plantillas.filter(function(x){return x.get('selected')&&x.get('visible');}).count()>=plantillas.filter(function(x){return x.get('visible');}).count()})),tableCols.map(function(x){var style={width:''+x.Width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.Id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.Value?orderBy.get('asc')?'asc':'desc':''},x.Caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,plantillas.filter(function(x){return x.get('visible');}).count()>0?plantillas.filter(function(x){return x.get('visible');}).map(function(x,c){if(!x.get('visible'))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectItem(c,e.target.checked);},checked:x.get('selected')})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.Type){switch(c.Type){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.Format);alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.Format);alignment='right';break;case'html':value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'10vh',overflowX:'hidden'},dangerouslySetInnerHTML:{__html:value}});break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Modificación de plantillas','edit',x.get('id'));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Plantillas_ModalCreate__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Plantillas_ModalDelete__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Plantillas_ModalFilter__["a" /* default */],null));}}]);return Plantillas;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{plantillas:state.plantillas.get('plantillas'),orderBy:state.plantillas.get('orderBy'),totalRecords:state.plantillas.get('totalRecords'),showRecords:state.plantillas.get('showRecords'),page:state.plantillas.get('page'),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{getPlantillas:function getPlantillas(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["h" /* getPlantillas */])(page));},toggleSelectItem:function toggleSelectItem(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["o" /* toggleSelectItem */])(index,checked));},toggleSelectAllItems:function toggleSelectAllItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["n" /* toggleSelectAllItems */])(checked));},filterPlantillas:function filterPlantillas(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["g" /* filterPlantillas */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["j" /* setOrderBy */])(field));},displayModalCreate:function displayModalCreate(show,title,mode,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["f" /* displayModalCreate */])(show,title,mode,id));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["k" /* showHideModalDelete */])(open,message,action));},deletePlantillas:function deletePlantillas(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["e" /* deletePlantillas */])());},changeRecordsToShow:function changeRecordsToShow(records){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["c" /* changeRecordsToShow */])(records));},showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["l" /* showHideModalFilter */])(state));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Plantillas));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */

/**
 * Define a module along with a payload
 * @param module a name for the payload
 * @param payload a function to call with (acequire, exports, module) params
 */

(function() {

var ACE_NAMESPACE = "ace";

var global = (function() { return this; })();
if (!global && typeof window != "undefined") global = window; // strict mode


if (!ACE_NAMESPACE && typeof acequirejs !== "undefined")
    return;


var define = function(module, deps, payload) {
    if (typeof module !== "string") {
        if (define.original)
            define.original.apply(this, arguments);
        else {
            console.error("dropping module because define wasn\'t a string.");
            console.trace();
        }
        return;
    }
    if (arguments.length == 2)
        payload = deps;
    if (!define.modules[module]) {
        define.payloads[module] = payload;
        define.modules[module] = null;
    }
};

define.modules = {};
define.payloads = {};

/**
 * Get at functionality define()ed using the function above
 */
var _acequire = function(parentId, module, callback) {
    if (typeof module === "string") {
        var payload = lookup(parentId, module);
        if (payload != undefined) {
            callback && callback();
            return payload;
        }
    } else if (Object.prototype.toString.call(module) === "[object Array]") {
        var params = [];
        for (var i = 0, l = module.length; i < l; ++i) {
            var dep = lookup(parentId, module[i]);
            if (dep == undefined && acequire.original)
                return;
            params.push(dep);
        }
        return callback && callback.apply(null, params) || true;
    }
};

var acequire = function(module, callback) {
    var packagedModule = _acequire("", module, callback);
    if (packagedModule == undefined && acequire.original)
        return acequire.original.apply(this, arguments);
    return packagedModule;
};

var normalizeModule = function(parentId, moduleName) {
    // normalize plugin acequires
    if (moduleName.indexOf("!") !== -1) {
        var chunks = moduleName.split("!");
        return normalizeModule(parentId, chunks[0]) + "!" + normalizeModule(parentId, chunks[1]);
    }
    // normalize relative acequires
    if (moduleName.charAt(0) == ".") {
        var base = parentId.split("/").slice(0, -1).join("/");
        moduleName = base + "/" + moduleName;

        while(moduleName.indexOf(".") !== -1 && previous != moduleName) {
            var previous = moduleName;
            moduleName = moduleName.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
        }
    }
    return moduleName;
};

/**
 * Internal function to lookup moduleNames and resolve them by calling the
 * definition function if needed.
 */
var lookup = function(parentId, moduleName) {
    moduleName = normalizeModule(parentId, moduleName);

    var module = define.modules[moduleName];
    if (!module) {
        module = define.payloads[moduleName];
        if (typeof module === 'function') {
            var exports = {};
            var mod = {
                id: moduleName,
                uri: '',
                exports: exports,
                packaged: true
            };

            var req = function(module, callback) {
                return _acequire(moduleName, module, callback);
            };

            var returnValue = module(req, exports, mod);
            exports = returnValue || mod.exports;
            define.modules[moduleName] = exports;
            delete define.payloads[moduleName];
        }
        module = define.modules[moduleName] = exports || module;
    }
    return module;
};

function exportAce(ns) {
    var root = global;
    if (ns) {
        if (!global[ns])
            global[ns] = {};
        root = global[ns];
    }

    if (!root.define || !root.define.packaged) {
        define.original = root.define;
        root.define = define;
        root.define.packaged = true;
    }

    if (!root.acequire || !root.acequire.packaged) {
        acequire.original = root.acequire;
        root.acequire = acequire;
        root.acequire.packaged = true;
    }
}

exportAce(ACE_NAMESPACE);

})();

ace.define("ace/lib/regexp",["require","exports","module"], function(acequire, exports, module) {
"use strict";

    var real = {
            exec: RegExp.prototype.exec,
            test: RegExp.prototype.test,
            match: String.prototype.match,
            replace: String.prototype.replace,
            split: String.prototype.split
        },
        compliantExecNpcg = real.exec.call(/()??/, "")[1] === undefined, // check `exec` handling of nonparticipating capturing groups
        compliantLastIndexIncrement = function () {
            var x = /^/g;
            real.test.call(x, "");
            return !x.lastIndex;
        }();

    if (compliantLastIndexIncrement && compliantExecNpcg)
        return;
    RegExp.prototype.exec = function (str) {
        var match = real.exec.apply(this, arguments),
            name, r2;
        if ( typeof(str) == 'string' && match) {
            if (!compliantExecNpcg && match.length > 1 && indexOf(match, "") > -1) {
                r2 = RegExp(this.source, real.replace.call(getNativeFlags(this), "g", ""));
                real.replace.call(str.slice(match.index), r2, function () {
                    for (var i = 1; i < arguments.length - 2; i++) {
                        if (arguments[i] === undefined)
                            match[i] = undefined;
                    }
                });
            }
            if (this._xregexp && this._xregexp.captureNames) {
                for (var i = 1; i < match.length; i++) {
                    name = this._xregexp.captureNames[i - 1];
                    if (name)
                       match[name] = match[i];
                }
            }
            if (!compliantLastIndexIncrement && this.global && !match[0].length && (this.lastIndex > match.index))
                this.lastIndex--;
        }
        return match;
    };
    if (!compliantLastIndexIncrement) {
        RegExp.prototype.test = function (str) {
            var match = real.exec.call(this, str);
            if (match && this.global && !match[0].length && (this.lastIndex > match.index))
                this.lastIndex--;
            return !!match;
        };
    }

    function getNativeFlags (regex) {
        return (regex.global     ? "g" : "") +
               (regex.ignoreCase ? "i" : "") +
               (regex.multiline  ? "m" : "") +
               (regex.extended   ? "x" : "") + // Proposed for ES4; included in AS3
               (regex.sticky     ? "y" : "");
    }

    function indexOf (array, item, from) {
        if (Array.prototype.indexOf) // Use the native array method if available
            return array.indexOf(item, from);
        for (var i = from || 0; i < array.length; i++) {
            if (array[i] === item)
                return i;
        }
        return -1;
    }

});

ace.define("ace/lib/es5-shim",["require","exports","module"], function(acequire, exports, module) {

function Empty() {}

if (!Function.prototype.bind) {
    Function.prototype.bind = function bind(that) { // .length is 1
        var target = this;
        if (typeof target != "function") {
            throw new TypeError("Function.prototype.bind called on incompatible " + target);
        }
        var args = slice.call(arguments, 1); // for normal call
        var bound = function () {

            if (this instanceof bound) {

                var result = target.apply(
                    this,
                    args.concat(slice.call(arguments))
                );
                if (Object(result) === result) {
                    return result;
                }
                return this;

            } else {
                return target.apply(
                    that,
                    args.concat(slice.call(arguments))
                );

            }

        };
        if(target.prototype) {
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
        }
        return bound;
    };
}
var call = Function.prototype.call;
var prototypeOfArray = Array.prototype;
var prototypeOfObject = Object.prototype;
var slice = prototypeOfArray.slice;
var _toString = call.bind(prototypeOfObject.toString);
var owns = call.bind(prototypeOfObject.hasOwnProperty);
var defineGetter;
var defineSetter;
var lookupGetter;
var lookupSetter;
var supportsAccessors;
if ((supportsAccessors = owns(prototypeOfObject, "__defineGetter__"))) {
    defineGetter = call.bind(prototypeOfObject.__defineGetter__);
    defineSetter = call.bind(prototypeOfObject.__defineSetter__);
    lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
    lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
}
if ([1,2].splice(0).length != 2) {
    if(function() { // test IE < 9 to splice bug - see issue #138
        function makeArray(l) {
            var a = new Array(l+2);
            a[0] = a[1] = 0;
            return a;
        }
        var array = [], lengthBefore;
        
        array.splice.apply(array, makeArray(20));
        array.splice.apply(array, makeArray(26));

        lengthBefore = array.length; //46
        array.splice(5, 0, "XXX"); // add one element

        lengthBefore + 1 == array.length

        if (lengthBefore + 1 == array.length) {
            return true;// has right splice implementation without bugs
        }
    }()) {//IE 6/7
        var array_splice = Array.prototype.splice;
        Array.prototype.splice = function(start, deleteCount) {
            if (!arguments.length) {
                return [];
            } else {
                return array_splice.apply(this, [
                    start === void 0 ? 0 : start,
                    deleteCount === void 0 ? (this.length - start) : deleteCount
                ].concat(slice.call(arguments, 2)))
            }
        };
    } else {//IE8
        Array.prototype.splice = function(pos, removeCount){
            var length = this.length;
            if (pos > 0) {
                if (pos > length)
                    pos = length;
            } else if (pos == void 0) {
                pos = 0;
            } else if (pos < 0) {
                pos = Math.max(length + pos, 0);
            }

            if (!(pos+removeCount < length))
                removeCount = length - pos;

            var removed = this.slice(pos, pos+removeCount);
            var insert = slice.call(arguments, 2);
            var add = insert.length;            
            if (pos === length) {
                if (add) {
                    this.push.apply(this, insert);
                }
            } else {
                var remove = Math.min(removeCount, length - pos);
                var tailOldPos = pos + remove;
                var tailNewPos = tailOldPos + add - remove;
                var tailCount = length - tailOldPos;
                var lengthAfterRemove = length - remove;

                if (tailNewPos < tailOldPos) { // case A
                    for (var i = 0; i < tailCount; ++i) {
                        this[tailNewPos+i] = this[tailOldPos+i];
                    }
                } else if (tailNewPos > tailOldPos) { // case B
                    for (i = tailCount; i--; ) {
                        this[tailNewPos+i] = this[tailOldPos+i];
                    }
                } // else, add == remove (nothing to do)

                if (add && pos === lengthAfterRemove) {
                    this.length = lengthAfterRemove; // truncate array
                    this.push.apply(this, insert);
                } else {
                    this.length = lengthAfterRemove + add; // reserves space
                    for (i = 0; i < add; ++i) {
                        this[pos+i] = insert[i];
                    }
                }
            }
            return removed;
        };
    }
}
if (!Array.isArray) {
    Array.isArray = function isArray(obj) {
        return _toString(obj) == "[object Array]";
    };
}
var boxedString = Object("a"),
    splitString = boxedString[0] != "a" || !(0 in boxedString);

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function forEach(fun /*, thisp*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            thisp = arguments[1],
            i = -1,
            length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(); // TODO message
        }

        while (++i < length) {
            if (i in self) {
                fun.call(thisp, self[i], i, object);
            }
        }
    };
}
if (!Array.prototype.map) {
    Array.prototype.map = function map(fun /*, thisp*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0,
            result = Array(length),
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self)
                result[i] = fun.call(thisp, self[i], i, object);
        }
        return result;
    };
}
if (!Array.prototype.filter) {
    Array.prototype.filter = function filter(fun /*, thisp */) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                    object,
            length = self.length >>> 0,
            result = [],
            value,
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self) {
                value = self[i];
                if (fun.call(thisp, value, i, object)) {
                    result.push(value);
                }
            }
        }
        return result;
    };
}
if (!Array.prototype.every) {
    Array.prototype.every = function every(fun /*, thisp */) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0,
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self && !fun.call(thisp, self[i], i, object)) {
                return false;
            }
        }
        return true;
    };
}
if (!Array.prototype.some) {
    Array.prototype.some = function some(fun /*, thisp */) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0,
            thisp = arguments[1];
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }

        for (var i = 0; i < length; i++) {
            if (i in self && fun.call(thisp, self[i], i, object)) {
                return true;
            }
        }
        return false;
    };
}
if (!Array.prototype.reduce) {
    Array.prototype.reduce = function reduce(fun /*, initial*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }
        if (!length && arguments.length == 1) {
            throw new TypeError("reduce of empty array with no initial value");
        }

        var i = 0;
        var result;
        if (arguments.length >= 2) {
            result = arguments[1];
        } else {
            do {
                if (i in self) {
                    result = self[i++];
                    break;
                }
                if (++i >= length) {
                    throw new TypeError("reduce of empty array with no initial value");
                }
            } while (true);
        }

        for (; i < length; i++) {
            if (i in self) {
                result = fun.call(void 0, result, self[i], i, object);
            }
        }

        return result;
    };
}
if (!Array.prototype.reduceRight) {
    Array.prototype.reduceRight = function reduceRight(fun /*, initial*/) {
        var object = toObject(this),
            self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                object,
            length = self.length >>> 0;
        if (_toString(fun) != "[object Function]") {
            throw new TypeError(fun + " is not a function");
        }
        if (!length && arguments.length == 1) {
            throw new TypeError("reduceRight of empty array with no initial value");
        }

        var result, i = length - 1;
        if (arguments.length >= 2) {
            result = arguments[1];
        } else {
            do {
                if (i in self) {
                    result = self[i--];
                    break;
                }
                if (--i < 0) {
                    throw new TypeError("reduceRight of empty array with no initial value");
                }
            } while (true);
        }

        do {
            if (i in this) {
                result = fun.call(void 0, result, self[i], i, object);
            }
        } while (i--);

        return result;
    };
}
if (!Array.prototype.indexOf || ([0, 1].indexOf(1, 2) != -1)) {
    Array.prototype.indexOf = function indexOf(sought /*, fromIndex */ ) {
        var self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                toObject(this),
            length = self.length >>> 0;

        if (!length) {
            return -1;
        }

        var i = 0;
        if (arguments.length > 1) {
            i = toInteger(arguments[1]);
        }
        i = i >= 0 ? i : Math.max(0, length + i);
        for (; i < length; i++) {
            if (i in self && self[i] === sought) {
                return i;
            }
        }
        return -1;
    };
}
if (!Array.prototype.lastIndexOf || ([0, 1].lastIndexOf(0, -3) != -1)) {
    Array.prototype.lastIndexOf = function lastIndexOf(sought /*, fromIndex */) {
        var self = splitString && _toString(this) == "[object String]" ?
                this.split("") :
                toObject(this),
            length = self.length >>> 0;

        if (!length) {
            return -1;
        }
        var i = length - 1;
        if (arguments.length > 1) {
            i = Math.min(i, toInteger(arguments[1]));
        }
        i = i >= 0 ? i : length - Math.abs(i);
        for (; i >= 0; i--) {
            if (i in self && sought === self[i]) {
                return i;
            }
        }
        return -1;
    };
}
if (!Object.getPrototypeOf) {
    Object.getPrototypeOf = function getPrototypeOf(object) {
        return object.__proto__ || (
            object.constructor ?
            object.constructor.prototype :
            prototypeOfObject
        );
    };
}
if (!Object.getOwnPropertyDescriptor) {
    var ERR_NON_OBJECT = "Object.getOwnPropertyDescriptor called on a " +
                         "non-object: ";
    Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
        if ((typeof object != "object" && typeof object != "function") || object === null)
            throw new TypeError(ERR_NON_OBJECT + object);
        if (!owns(object, property))
            return;

        var descriptor, getter, setter;
        descriptor =  { enumerable: true, configurable: true };
        if (supportsAccessors) {
            var prototype = object.__proto__;
            object.__proto__ = prototypeOfObject;

            var getter = lookupGetter(object, property);
            var setter = lookupSetter(object, property);
            object.__proto__ = prototype;

            if (getter || setter) {
                if (getter) descriptor.get = getter;
                if (setter) descriptor.set = setter;
                return descriptor;
            }
        }
        descriptor.value = object[property];
        return descriptor;
    };
}
if (!Object.getOwnPropertyNames) {
    Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
        return Object.keys(object);
    };
}
if (!Object.create) {
    var createEmpty;
    if (Object.prototype.__proto__ === null) {
        createEmpty = function () {
            return { "__proto__": null };
        };
    } else {
        createEmpty = function () {
            var empty = {};
            for (var i in empty)
                empty[i] = null;
            empty.constructor =
            empty.hasOwnProperty =
            empty.propertyIsEnumerable =
            empty.isPrototypeOf =
            empty.toLocaleString =
            empty.toString =
            empty.valueOf =
            empty.__proto__ = null;
            return empty;
        }
    }

    Object.create = function create(prototype, properties) {
        var object;
        if (prototype === null) {
            object = createEmpty();
        } else {
            if (typeof prototype != "object")
                throw new TypeError("typeof prototype["+(typeof prototype)+"] != 'object'");
            var Type = function () {};
            Type.prototype = prototype;
            object = new Type();
            object.__proto__ = prototype;
        }
        if (properties !== void 0)
            Object.defineProperties(object, properties);
        return object;
    };
}

function doesDefinePropertyWork(object) {
    try {
        Object.defineProperty(object, "sentinel", {});
        return "sentinel" in object;
    } catch (exception) {
    }
}
if (Object.defineProperty) {
    var definePropertyWorksOnObject = doesDefinePropertyWork({});
    var definePropertyWorksOnDom = typeof document == "undefined" ||
        doesDefinePropertyWork(document.createElement("div"));
    if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) {
        var definePropertyFallback = Object.defineProperty;
    }
}

if (!Object.defineProperty || definePropertyFallback) {
    var ERR_NON_OBJECT_DESCRIPTOR = "Property description must be an object: ";
    var ERR_NON_OBJECT_TARGET = "Object.defineProperty called on non-object: "
    var ERR_ACCESSORS_NOT_SUPPORTED = "getters & setters can not be defined " +
                                      "on this javascript engine";

    Object.defineProperty = function defineProperty(object, property, descriptor) {
        if ((typeof object != "object" && typeof object != "function") || object === null)
            throw new TypeError(ERR_NON_OBJECT_TARGET + object);
        if ((typeof descriptor != "object" && typeof descriptor != "function") || descriptor === null)
            throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
        if (definePropertyFallback) {
            try {
                return definePropertyFallback.call(Object, object, property, descriptor);
            } catch (exception) {
            }
        }
        if (owns(descriptor, "value")) {

            if (supportsAccessors && (lookupGetter(object, property) ||
                                      lookupSetter(object, property)))
            {
                var prototype = object.__proto__;
                object.__proto__ = prototypeOfObject;
                delete object[property];
                object[property] = descriptor.value;
                object.__proto__ = prototype;
            } else {
                object[property] = descriptor.value;
            }
        } else {
            if (!supportsAccessors)
                throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
            if (owns(descriptor, "get"))
                defineGetter(object, property, descriptor.get);
            if (owns(descriptor, "set"))
                defineSetter(object, property, descriptor.set);
        }

        return object;
    };
}
if (!Object.defineProperties) {
    Object.defineProperties = function defineProperties(object, properties) {
        for (var property in properties) {
            if (owns(properties, property))
                Object.defineProperty(object, property, properties[property]);
        }
        return object;
    };
}
if (!Object.seal) {
    Object.seal = function seal(object) {
        return object;
    };
}
if (!Object.freeze) {
    Object.freeze = function freeze(object) {
        return object;
    };
}
try {
    Object.freeze(function () {});
} catch (exception) {
    Object.freeze = (function freeze(freezeObject) {
        return function freeze(object) {
            if (typeof object == "function") {
                return object;
            } else {
                return freezeObject(object);
            }
        };
    })(Object.freeze);
}
if (!Object.preventExtensions) {
    Object.preventExtensions = function preventExtensions(object) {
        return object;
    };
}
if (!Object.isSealed) {
    Object.isSealed = function isSealed(object) {
        return false;
    };
}
if (!Object.isFrozen) {
    Object.isFrozen = function isFrozen(object) {
        return false;
    };
}
if (!Object.isExtensible) {
    Object.isExtensible = function isExtensible(object) {
        if (Object(object) === object) {
            throw new TypeError(); // TODO message
        }
        var name = '';
        while (owns(object, name)) {
            name += '?';
        }
        object[name] = true;
        var returnValue = owns(object, name);
        delete object[name];
        return returnValue;
    };
}
if (!Object.keys) {
    var hasDontEnumBug = true,
        dontEnums = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ],
        dontEnumsLength = dontEnums.length;

    for (var key in {"toString": null}) {
        hasDontEnumBug = false;
    }

    Object.keys = function keys(object) {

        if (
            (typeof object != "object" && typeof object != "function") ||
            object === null
        ) {
            throw new TypeError("Object.keys called on a non-object");
        }

        var keys = [];
        for (var name in object) {
            if (owns(object, name)) {
                keys.push(name);
            }
        }

        if (hasDontEnumBug) {
            for (var i = 0, ii = dontEnumsLength; i < ii; i++) {
                var dontEnum = dontEnums[i];
                if (owns(object, dontEnum)) {
                    keys.push(dontEnum);
                }
            }
        }
        return keys;
    };

}
if (!Date.now) {
    Date.now = function now() {
        return new Date().getTime();
    };
}
var ws = "\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003" +
    "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028" +
    "\u2029\uFEFF";
if (!String.prototype.trim || ws.trim()) {
    ws = "[" + ws + "]";
    var trimBeginRegexp = new RegExp("^" + ws + ws + "*"),
        trimEndRegexp = new RegExp(ws + ws + "*$");
    String.prototype.trim = function trim() {
        return String(this).replace(trimBeginRegexp, "").replace(trimEndRegexp, "");
    };
}

function toInteger(n) {
    n = +n;
    if (n !== n) { // isNaN
        n = 0;
    } else if (n !== 0 && n !== (1/0) && n !== -(1/0)) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
    }
    return n;
}

function isPrimitive(input) {
    var type = typeof input;
    return (
        input === null ||
        type === "undefined" ||
        type === "boolean" ||
        type === "number" ||
        type === "string"
    );
}

function toPrimitive(input) {
    var val, valueOf, toString;
    if (isPrimitive(input)) {
        return input;
    }
    valueOf = input.valueOf;
    if (typeof valueOf === "function") {
        val = valueOf.call(input);
        if (isPrimitive(val)) {
            return val;
        }
    }
    toString = input.toString;
    if (typeof toString === "function") {
        val = toString.call(input);
        if (isPrimitive(val)) {
            return val;
        }
    }
    throw new TypeError();
}
var toObject = function (o) {
    if (o == null) { // this matches both null and undefined
        throw new TypeError("can't convert "+o+" to object");
    }
    return Object(o);
};

});

ace.define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/regexp","ace/lib/es5-shim"], function(acequire, exports, module) {
"use strict";

acequire("./regexp");
acequire("./es5-shim");

});

ace.define("ace/lib/dom",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var XHTML_NS = "http://www.w3.org/1999/xhtml";

exports.getDocumentHead = function(doc) {
    if (!doc)
        doc = document;
    return doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
};

exports.createElement = function(tag, ns) {
    return document.createElementNS ?
           document.createElementNS(ns || XHTML_NS, tag) :
           document.createElement(tag);
};

exports.hasCssClass = function(el, name) {
    var classes = (el.className + "").split(/\s+/g);
    return classes.indexOf(name) !== -1;
};
exports.addCssClass = function(el, name) {
    if (!exports.hasCssClass(el, name)) {
        el.className += " " + name;
    }
};
exports.removeCssClass = function(el, name) {
    var classes = el.className.split(/\s+/g);
    while (true) {
        var index = classes.indexOf(name);
        if (index == -1) {
            break;
        }
        classes.splice(index, 1);
    }
    el.className = classes.join(" ");
};

exports.toggleCssClass = function(el, name) {
    var classes = el.className.split(/\s+/g), add = true;
    while (true) {
        var index = classes.indexOf(name);
        if (index == -1) {
            break;
        }
        add = false;
        classes.splice(index, 1);
    }
    if (add)
        classes.push(name);

    el.className = classes.join(" ");
    return add;
};
exports.setCssClass = function(node, className, include) {
    if (include) {
        exports.addCssClass(node, className);
    } else {
        exports.removeCssClass(node, className);
    }
};

exports.hasCssString = function(id, doc) {
    var index = 0, sheets;
    doc = doc || document;

    if (doc.createStyleSheet && (sheets = doc.styleSheets)) {
        while (index < sheets.length)
            if (sheets[index++].owningElement.id === id) return true;
    } else if ((sheets = doc.getElementsByTagName("style"))) {
        while (index < sheets.length)
            if (sheets[index++].id === id) return true;
    }

    return false;
};

exports.importCssString = function importCssString(cssText, id, doc) {
    doc = doc || document;
    if (id && exports.hasCssString(id, doc))
        return null;
    
    var style;
    
    if (id)
        cssText += "\n/*# sourceURL=ace/css/" + id + " */";
    
    if (doc.createStyleSheet) {
        style = doc.createStyleSheet();
        style.cssText = cssText;
        if (id)
            style.owningElement.id = id;
    } else {
        style = exports.createElement("style");
        style.appendChild(doc.createTextNode(cssText));
        if (id)
            style.id = id;

        exports.getDocumentHead(doc).appendChild(style);
    }
};

exports.importCssStylsheet = function(uri, doc) {
    if (doc.createStyleSheet) {
        doc.createStyleSheet(uri);
    } else {
        var link = exports.createElement('link');
        link.rel = 'stylesheet';
        link.href = uri;

        exports.getDocumentHead(doc).appendChild(link);
    }
};

exports.getInnerWidth = function(element) {
    return (
        parseInt(exports.computedStyle(element, "paddingLeft"), 10) +
        parseInt(exports.computedStyle(element, "paddingRight"), 10) + 
        element.clientWidth
    );
};

exports.getInnerHeight = function(element) {
    return (
        parseInt(exports.computedStyle(element, "paddingTop"), 10) +
        parseInt(exports.computedStyle(element, "paddingBottom"), 10) +
        element.clientHeight
    );
};

exports.scrollbarWidth = function(document) {
    var inner = exports.createElement("ace_inner");
    inner.style.width = "100%";
    inner.style.minWidth = "0px";
    inner.style.height = "200px";
    inner.style.display = "block";

    var outer = exports.createElement("ace_outer");
    var style = outer.style;

    style.position = "absolute";
    style.left = "-10000px";
    style.overflow = "hidden";
    style.width = "200px";
    style.minWidth = "0px";
    style.height = "150px";
    style.display = "block";

    outer.appendChild(inner);

    var body = document.documentElement;
    body.appendChild(outer);

    var noScrollbar = inner.offsetWidth;

    style.overflow = "scroll";
    var withScrollbar = inner.offsetWidth;

    if (noScrollbar == withScrollbar) {
        withScrollbar = outer.clientWidth;
    }

    body.removeChild(outer);

    return noScrollbar-withScrollbar;
};

if (typeof document == "undefined") {
    exports.importCssString = function() {};
    return;
}

if (window.pageYOffset !== undefined) {
    exports.getPageScrollTop = function() {
        return window.pageYOffset;
    };

    exports.getPageScrollLeft = function() {
        return window.pageXOffset;
    };
}
else {
    exports.getPageScrollTop = function() {
        return document.body.scrollTop;
    };

    exports.getPageScrollLeft = function() {
        return document.body.scrollLeft;
    };
}

if (window.getComputedStyle)
    exports.computedStyle = function(element, style) {
        if (style)
            return (window.getComputedStyle(element, "") || {})[style] || "";
        return window.getComputedStyle(element, "") || {};
    };
else
    exports.computedStyle = function(element, style) {
        if (style)
            return element.currentStyle[style];
        return element.currentStyle;
    };
exports.setInnerHtml = function(el, innerHtml) {
    var element = el.cloneNode(false);//document.createElement("div");
    element.innerHTML = innerHtml;
    el.parentNode.replaceChild(element, el);
    return element;
};

if ("textContent" in document.documentElement) {
    exports.setInnerText = function(el, innerText) {
        el.textContent = innerText;
    };

    exports.getInnerText = function(el) {
        return el.textContent;
    };
}
else {
    exports.setInnerText = function(el, innerText) {
        el.innerText = innerText;
    };

    exports.getInnerText = function(el) {
        return el.innerText;
    };
}

exports.getParentWindow = function(document) {
    return document.defaultView || document.parentWindow;
};

});

ace.define("ace/lib/oop",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.inherits = function(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};

exports.mixin = function(obj, mixin) {
    for (var key in mixin) {
        obj[key] = mixin[key];
    }
    return obj;
};

exports.implement = function(proto, mixin) {
    exports.mixin(proto, mixin);
};

});

ace.define("ace/lib/keys",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop"], function(acequire, exports, module) {
"use strict";

acequire("./fixoldbrowsers");

var oop = acequire("./oop");
var Keys = (function() {
    var ret = {
        MODIFIER_KEYS: {
            16: 'Shift', 17: 'Ctrl', 18: 'Alt', 224: 'Meta'
        },

        KEY_MODS: {
            "ctrl": 1, "alt": 2, "option" : 2, "shift": 4,
            "super": 8, "meta": 8, "command": 8, "cmd": 8
        },

        FUNCTION_KEYS : {
            8  : "Backspace",
            9  : "Tab",
            13 : "Return",
            19 : "Pause",
            27 : "Esc",
            32 : "Space",
            33 : "PageUp",
            34 : "PageDown",
            35 : "End",
            36 : "Home",
            37 : "Left",
            38 : "Up",
            39 : "Right",
            40 : "Down",
            44 : "Print",
            45 : "Insert",
            46 : "Delete",
            96 : "Numpad0",
            97 : "Numpad1",
            98 : "Numpad2",
            99 : "Numpad3",
            100: "Numpad4",
            101: "Numpad5",
            102: "Numpad6",
            103: "Numpad7",
            104: "Numpad8",
            105: "Numpad9",
            '-13': "NumpadEnter",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "Numlock",
            145: "Scrolllock"
        },

        PRINTABLE_KEYS: {
           32: ' ',  48: '0',  49: '1',  50: '2',  51: '3',  52: '4', 53:  '5',
           54: '6',  55: '7',  56: '8',  57: '9',  59: ';',  61: '=', 65:  'a',
           66: 'b',  67: 'c',  68: 'd',  69: 'e',  70: 'f',  71: 'g', 72:  'h',
           73: 'i',  74: 'j',  75: 'k',  76: 'l',  77: 'm',  78: 'n', 79:  'o',
           80: 'p',  81: 'q',  82: 'r',  83: 's',  84: 't',  85: 'u', 86:  'v',
           87: 'w',  88: 'x',  89: 'y',  90: 'z', 107: '+', 109: '-', 110: '.',
          186: ';', 187: '=', 188: ',', 189: '-', 190: '.', 191: '/', 192: '`',
          219: '[', 220: '\\',221: ']', 222: "'", 111: '/', 106: '*'
        }
    };
    var name, i;
    for (i in ret.FUNCTION_KEYS) {
        name = ret.FUNCTION_KEYS[i].toLowerCase();
        ret[name] = parseInt(i, 10);
    }
    for (i in ret.PRINTABLE_KEYS) {
        name = ret.PRINTABLE_KEYS[i].toLowerCase();
        ret[name] = parseInt(i, 10);
    }
    oop.mixin(ret, ret.MODIFIER_KEYS);
    oop.mixin(ret, ret.PRINTABLE_KEYS);
    oop.mixin(ret, ret.FUNCTION_KEYS);
    ret.enter = ret["return"];
    ret.escape = ret.esc;
    ret.del = ret["delete"];
    ret[173] = '-';
    
    (function() {
        var mods = ["cmd", "ctrl", "alt", "shift"];
        for (var i = Math.pow(2, mods.length); i--;) {            
            ret.KEY_MODS[i] = mods.filter(function(x) {
                return i & ret.KEY_MODS[x];
            }).join("-") + "-";
        }
    })();

    ret.KEY_MODS[0] = "";
    ret.KEY_MODS[-1] = "input-";

    return ret;
})();
oop.mixin(exports, Keys);

exports.keyCodeToString = function(keyCode) {
    var keyString = Keys[keyCode];
    if (typeof keyString != "string")
        keyString = String.fromCharCode(keyCode);
    return keyString.toLowerCase();
};

});

ace.define("ace/lib/useragent",["require","exports","module"], function(acequire, exports, module) {
"use strict";
exports.OS = {
    LINUX: "LINUX",
    MAC: "MAC",
    WINDOWS: "WINDOWS"
};
exports.getOS = function() {
    if (exports.isMac) {
        return exports.OS.MAC;
    } else if (exports.isLinux) {
        return exports.OS.LINUX;
    } else {
        return exports.OS.WINDOWS;
    }
};
if (typeof navigator != "object")
    return;

var os = (navigator.platform.match(/mac|win|linux/i) || ["other"])[0].toLowerCase();
var ua = navigator.userAgent;
exports.isWin = (os == "win");
exports.isMac = (os == "mac");
exports.isLinux = (os == "linux");
exports.isIE = 
    (navigator.appName == "Microsoft Internet Explorer" || navigator.appName.indexOf("MSAppHost") >= 0)
    ? parseFloat((ua.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1])
    : parseFloat((ua.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]); // for ie
    
exports.isOldIE = exports.isIE && exports.isIE < 9;
exports.isGecko = exports.isMozilla = (window.Controllers || window.controllers) && window.navigator.product === "Gecko";
exports.isOldGecko = exports.isGecko && parseInt((ua.match(/rv:(\d+)/)||[])[1], 10) < 4;
exports.isOpera = window.opera && Object.prototype.toString.call(window.opera) == "[object Opera]";
exports.isWebKit = parseFloat(ua.split("WebKit/")[1]) || undefined;

exports.isChrome = parseFloat(ua.split(" Chrome/")[1]) || undefined;

exports.isAIR = ua.indexOf("AdobeAIR") >= 0;

exports.isIPad = ua.indexOf("iPad") >= 0;

exports.isChromeOS = ua.indexOf(" CrOS ") >= 0;

exports.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

if (exports.isIOS) exports.isMac = true;

});

ace.define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var keys = acequire("./keys");
var useragent = acequire("./useragent");

var pressedKeys = null;
var ts = 0;

exports.addListener = function(elem, type, callback) {
    if (elem.addEventListener) {
        return elem.addEventListener(type, callback, false);
    }
    if (elem.attachEvent) {
        var wrapper = function() {
            callback.call(elem, window.event);
        };
        callback._wrapper = wrapper;
        elem.attachEvent("on" + type, wrapper);
    }
};

exports.removeListener = function(elem, type, callback) {
    if (elem.removeEventListener) {
        return elem.removeEventListener(type, callback, false);
    }
    if (elem.detachEvent) {
        elem.detachEvent("on" + type, callback._wrapper || callback);
    }
};
exports.stopEvent = function(e) {
    exports.stopPropagation(e);
    exports.preventDefault(e);
    return false;
};

exports.stopPropagation = function(e) {
    if (e.stopPropagation)
        e.stopPropagation();
    else
        e.cancelBubble = true;
};

exports.preventDefault = function(e) {
    if (e.preventDefault)
        e.preventDefault();
    else
        e.returnValue = false;
};
exports.getButton = function(e) {
    if (e.type == "dblclick")
        return 0;
    if (e.type == "contextmenu" || (useragent.isMac && (e.ctrlKey && !e.altKey && !e.shiftKey)))
        return 2;
    if (e.preventDefault) {
        return e.button;
    }
    else {
        return {1:0, 2:2, 4:1}[e.button];
    }
};

exports.capture = function(el, eventHandler, releaseCaptureHandler) {
    function onMouseUp(e) {
        eventHandler && eventHandler(e);
        releaseCaptureHandler && releaseCaptureHandler(e);

        exports.removeListener(document, "mousemove", eventHandler, true);
        exports.removeListener(document, "mouseup", onMouseUp, true);
        exports.removeListener(document, "dragstart", onMouseUp, true);
    }

    exports.addListener(document, "mousemove", eventHandler, true);
    exports.addListener(document, "mouseup", onMouseUp, true);
    exports.addListener(document, "dragstart", onMouseUp, true);
    
    return onMouseUp;
};

exports.addTouchMoveListener = function (el, callback) {
    var startx, starty;
    exports.addListener(el, "touchstart", function (e) {
        var touches = e.touches;
        var touchObj = touches[0];
        startx = touchObj.clientX;
        starty = touchObj.clientY;
    });
    exports.addListener(el, "touchmove", function (e) {
        var touches = e.touches;
        if (touches.length > 1) return;

        var touchObj = touches[0];

        e.wheelX = startx - touchObj.clientX;
        e.wheelY = starty - touchObj.clientY;

        startx = touchObj.clientX;
        starty = touchObj.clientY;

        callback(e);
    });
};

exports.addMouseWheelListener = function(el, callback) {
    if ("onmousewheel" in el) {
        exports.addListener(el, "mousewheel", function(e) {
            var factor = 8;
            if (e.wheelDeltaX !== undefined) {
                e.wheelX = -e.wheelDeltaX / factor;
                e.wheelY = -e.wheelDeltaY / factor;
            } else {
                e.wheelX = 0;
                e.wheelY = -e.wheelDelta / factor;
            }
            callback(e);
        });
    } else if ("onwheel" in el) {
        exports.addListener(el, "wheel",  function(e) {
            var factor = 0.35;
            switch (e.deltaMode) {
                case e.DOM_DELTA_PIXEL:
                    e.wheelX = e.deltaX * factor || 0;
                    e.wheelY = e.deltaY * factor || 0;
                    break;
                case e.DOM_DELTA_LINE:
                case e.DOM_DELTA_PAGE:
                    e.wheelX = (e.deltaX || 0) * 5;
                    e.wheelY = (e.deltaY || 0) * 5;
                    break;
            }
            
            callback(e);
        });
    } else {
        exports.addListener(el, "DOMMouseScroll", function(e) {
            if (e.axis && e.axis == e.HORIZONTAL_AXIS) {
                e.wheelX = (e.detail || 0) * 5;
                e.wheelY = 0;
            } else {
                e.wheelX = 0;
                e.wheelY = (e.detail || 0) * 5;
            }
            callback(e);
        });
    }
};

exports.addMultiMouseDownListener = function(elements, timeouts, eventHandler, callbackName) {
    var clicks = 0;
    var startX, startY, timer; 
    var eventNames = {
        2: "dblclick",
        3: "tripleclick",
        4: "quadclick"
    };

    function onMousedown(e) {
        if (exports.getButton(e) !== 0) {
            clicks = 0;
        } else if (e.detail > 1) {
            clicks++;
            if (clicks > 4)
                clicks = 1;
        } else {
            clicks = 1;
        }
        if (useragent.isIE) {
            var isNewClick = Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5;
            if (!timer || isNewClick)
                clicks = 1;
            if (timer)
                clearTimeout(timer);
            timer = setTimeout(function() {timer = null;}, timeouts[clicks - 1] || 600);

            if (clicks == 1) {
                startX = e.clientX;
                startY = e.clientY;
            }
        }
        
        e._clicks = clicks;

        eventHandler[callbackName]("mousedown", e);

        if (clicks > 4)
            clicks = 0;
        else if (clicks > 1)
            return eventHandler[callbackName](eventNames[clicks], e);
    }
    function onDblclick(e) {
        clicks = 2;
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(function() {timer = null;}, timeouts[clicks - 1] || 600);
        eventHandler[callbackName]("mousedown", e);
        eventHandler[callbackName](eventNames[clicks], e);
    }
    if (!Array.isArray(elements))
        elements = [elements];
    elements.forEach(function(el) {
        exports.addListener(el, "mousedown", onMousedown);
        if (useragent.isOldIE)
            exports.addListener(el, "dblclick", onDblclick);
    });
};

var getModifierHash = useragent.isMac && useragent.isOpera && !("KeyboardEvent" in window)
    ? function(e) {
        return 0 | (e.metaKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.ctrlKey ? 8 : 0);
    }
    : function(e) {
        return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
    };

exports.getModifierString = function(e) {
    return keys.KEY_MODS[getModifierHash(e)];
};

function normalizeCommandKeys(callback, e, keyCode) {
    var hashId = getModifierHash(e);

    if (!useragent.isMac && pressedKeys) {
        if (e.getModifierState && (e.getModifierState("OS") || e.getModifierState("Win")))
            hashId |= 8;
        if (pressedKeys.altGr) {
            if ((3 & hashId) != 3)
                pressedKeys.altGr = 0;
            else
                return;
        }
        if (keyCode === 18 || keyCode === 17) {
            var location = "location" in e ? e.location : e.keyLocation;
            if (keyCode === 17 && location === 1) {
                if (pressedKeys[keyCode] == 1)
                    ts = e.timeStamp;
            } else if (keyCode === 18 && hashId === 3 && location === 2) {
                var dt = e.timeStamp - ts;
                if (dt < 50)
                    pressedKeys.altGr = true;
            }
        }
    }
    
    if (keyCode in keys.MODIFIER_KEYS) {
        keyCode = -1;
    }
    if (hashId & 8 && (keyCode >= 91 && keyCode <= 93)) {
        keyCode = -1;
    }
    
    if (!hashId && keyCode === 13) {
        var location = "location" in e ? e.location : e.keyLocation;
        if (location === 3) {
            callback(e, hashId, -keyCode);
            if (e.defaultPrevented)
                return;
        }
    }
    
    if (useragent.isChromeOS && hashId & 8) {
        callback(e, hashId, keyCode);
        if (e.defaultPrevented)
            return;
        else
            hashId &= ~8;
    }
    if (!hashId && !(keyCode in keys.FUNCTION_KEYS) && !(keyCode in keys.PRINTABLE_KEYS)) {
        return false;
    }
    
    return callback(e, hashId, keyCode);
}


exports.addCommandKeyListener = function(el, callback) {
    var addListener = exports.addListener;
    if (useragent.isOldGecko || (useragent.isOpera && !("KeyboardEvent" in window))) {
        var lastKeyDownKeyCode = null;
        addListener(el, "keydown", function(e) {
            lastKeyDownKeyCode = e.keyCode;
        });
        addListener(el, "keypress", function(e) {
            return normalizeCommandKeys(callback, e, lastKeyDownKeyCode);
        });
    } else {
        var lastDefaultPrevented = null;

        addListener(el, "keydown", function(e) {
            pressedKeys[e.keyCode] = (pressedKeys[e.keyCode] || 0) + 1;
            var result = normalizeCommandKeys(callback, e, e.keyCode);
            lastDefaultPrevented = e.defaultPrevented;
            return result;
        });

        addListener(el, "keypress", function(e) {
            if (lastDefaultPrevented && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey)) {
                exports.stopEvent(e);
                lastDefaultPrevented = null;
            }
        });

        addListener(el, "keyup", function(e) {
            pressedKeys[e.keyCode] = null;
        });

        if (!pressedKeys) {
            resetPressedKeys();
            addListener(window, "focus", resetPressedKeys);
        }
    }
};
function resetPressedKeys() {
    pressedKeys = Object.create(null);
}

if (typeof window == "object" && window.postMessage && !useragent.isOldIE) {
    var postMessageId = 1;
    exports.nextTick = function(callback, win) {
        win = win || window;
        var messageName = "zero-timeout-message-" + postMessageId;
        exports.addListener(win, "message", function listener(e) {
            if (e.data == messageName) {
                exports.stopPropagation(e);
                exports.removeListener(win, "message", listener);
                callback();
            }
        });
        win.postMessage(messageName, "*");
    };
}


exports.nextFrame = typeof window == "object" && (window.requestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.msRequestAnimationFrame
    || window.oRequestAnimationFrame);

if (exports.nextFrame)
    exports.nextFrame = exports.nextFrame.bind(window);
else
    exports.nextFrame = function(callback) {
        setTimeout(callback, 17);
    };
});

ace.define("ace/lib/lang",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.last = function(a) {
    return a[a.length - 1];
};

exports.stringReverse = function(string) {
    return string.split("").reverse().join("");
};

exports.stringRepeat = function (string, count) {
    var result = '';
    while (count > 0) {
        if (count & 1)
            result += string;

        if (count >>= 1)
            string += string;
    }
    return result;
};

var trimBeginRegexp = /^\s\s*/;
var trimEndRegexp = /\s\s*$/;

exports.stringTrimLeft = function (string) {
    return string.replace(trimBeginRegexp, '');
};

exports.stringTrimRight = function (string) {
    return string.replace(trimEndRegexp, '');
};

exports.copyObject = function(obj) {
    var copy = {};
    for (var key in obj) {
        copy[key] = obj[key];
    }
    return copy;
};

exports.copyArray = function(array){
    var copy = [];
    for (var i=0, l=array.length; i<l; i++) {
        if (array[i] && typeof array[i] == "object")
            copy[i] = this.copyObject(array[i]);
        else 
            copy[i] = array[i];
    }
    return copy;
};

exports.deepCopy = function deepCopy(obj) {
    if (typeof obj !== "object" || !obj)
        return obj;
    var copy;
    if (Array.isArray(obj)) {
        copy = [];
        for (var key = 0; key < obj.length; key++) {
            copy[key] = deepCopy(obj[key]);
        }
        return copy;
    }
    if (Object.prototype.toString.call(obj) !== "[object Object]")
        return obj;
    
    copy = {};
    for (var key in obj)
        copy[key] = deepCopy(obj[key]);
    return copy;
};

exports.arrayToMap = function(arr) {
    var map = {};
    for (var i=0; i<arr.length; i++) {
        map[arr[i]] = 1;
    }
    return map;

};

exports.createMap = function(props) {
    var map = Object.create(null);
    for (var i in props) {
        map[i] = props[i];
    }
    return map;
};
exports.arrayRemove = function(array, value) {
  for (var i = 0; i <= array.length; i++) {
    if (value === array[i]) {
      array.splice(i, 1);
    }
  }
};

exports.escapeRegExp = function(str) {
    return str.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
};

exports.escapeHTML = function(str) {
    return str.replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
};

exports.getMatchOffsets = function(string, regExp) {
    var matches = [];

    string.replace(regExp, function(str) {
        matches.push({
            offset: arguments[arguments.length-2],
            length: str.length
        });
    });

    return matches;
};
exports.deferredCall = function(fcn) {
    var timer = null;
    var callback = function() {
        timer = null;
        fcn();
    };

    var deferred = function(timeout) {
        deferred.cancel();
        timer = setTimeout(callback, timeout || 0);
        return deferred;
    };

    deferred.schedule = deferred;

    deferred.call = function() {
        this.cancel();
        fcn();
        return deferred;
    };

    deferred.cancel = function() {
        clearTimeout(timer);
        timer = null;
        return deferred;
    };
    
    deferred.isPending = function() {
        return timer;
    };

    return deferred;
};


exports.delayedCall = function(fcn, defaultTimeout) {
    var timer = null;
    var callback = function() {
        timer = null;
        fcn();
    };

    var _self = function(timeout) {
        if (timer == null)
            timer = setTimeout(callback, timeout || defaultTimeout);
    };

    _self.delay = function(timeout) {
        timer && clearTimeout(timer);
        timer = setTimeout(callback, timeout || defaultTimeout);
    };
    _self.schedule = _self;

    _self.call = function() {
        this.cancel();
        fcn();
    };

    _self.cancel = function() {
        timer && clearTimeout(timer);
        timer = null;
    };

    _self.isPending = function() {
        return timer;
    };

    return _self;
};
});

ace.define("ace/keyboard/textinput_ios",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang","ace/lib/keys"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var KEYS = acequire("../lib/keys");
var MODS = KEYS.KEY_MODS;
var BROKEN_SETDATA = useragent.isChrome < 18;
var USE_IE_MIME_TYPE =  useragent.isIE;

var TextInput = function(parentNode, host) {
    var self = this;
    var text = dom.createElement("textarea");
    text.className = useragent.isIOS ? "ace_text-input ace_text-input-ios" : "ace_text-input";

    if (useragent.isTouchPad)
        text.setAttribute("x-palm-disable-auto-cap", true);

    text.setAttribute("wrap", "off");
    text.setAttribute("autocorrect", "off");
    text.setAttribute("autocapitalize", "off");
    text.setAttribute("spellcheck", false);

    text.style.opacity = "0";
    parentNode.insertBefore(text, parentNode.firstChild);

    var PLACEHOLDER = "\n aaaa a\n";

    var copied = false;
    var cut = false;
    var pasted = false;
    var inComposition = false;
    var tempStyle = '';
    var isSelectionEmpty = true;
    try { var isFocused = document.activeElement === text; } catch(e) {}

    event.addListener(text, "blur", function(e) {
        host.onBlur(e);
        isFocused = false;
    });
    event.addListener(text, "focus", function(e) {
        isFocused = true;
        host.onFocus(e);
        resetSelection();
    });
    this.focus = function() {
        if (tempStyle) return text.focus();
        text.style.position = "fixed";
        text.focus();
    };
    this.blur = function() {
        text.blur();
    };
    this.isFocused = function() {
        return isFocused;
    };
    var syncSelection = lang.delayedCall(function() {
        isFocused && resetSelection(isSelectionEmpty);
    });
    var syncValue = lang.delayedCall(function() {
         if (!inComposition) {
            text.value = PLACEHOLDER;
            isFocused && resetSelection();
         }
    });

    function resetSelection(isEmpty) {
        if (inComposition)
            return;
        inComposition = true;

        if (inputHandler) {
            selectionStart = 0;
            selectionEnd = isEmpty ? 0 : text.value.length - 1;
        } else {
            var selectionStart = 4;
            var selectionEnd = 5;
        }
        try {
            text.setSelectionRange(selectionStart, selectionEnd);
        } catch(e) {}

        inComposition = false;
    }

    function resetValue() {
        if (inComposition)
            return;
        text.value = PLACEHOLDER;
        if (useragent.isWebKit)
            syncValue.schedule();
    }

    useragent.isWebKit || host.addEventListener('changeSelection', function() {
        if (host.selection.isEmpty() != isSelectionEmpty) {
            isSelectionEmpty = !isSelectionEmpty;
            syncSelection.schedule();
        }
    });

    resetValue();
    if (isFocused)
        host.onFocus();


    var isAllSelected = function(text) {
        return text.selectionStart === 0 && text.selectionEnd === text.value.length;
    };

    var onSelect = function(e) {
        if (isAllSelected(text)) {
            host.selectAll();
            resetSelection();
        } else if (inputHandler) {
            resetSelection(host.selection.isEmpty());
        }
    };

    var inputHandler = null;
    this.setInputHandler = function(cb) {inputHandler = cb;};
    this.getInputHandler = function() {return inputHandler;};
    var afterContextMenu = false;

    var sendText = function(data) {
        if (text.selectionStart === 4 && text.selectionEnd === 5) {
          return;
        }
        if (inputHandler) {
            data = inputHandler(data);
            inputHandler = null;
        }
        if (pasted) {
            resetSelection();
            if (data)
                host.onPaste(data);
            pasted = false;
        } else if (data == PLACEHOLDER.substr(0) && text.selectionStart === 4) {
            if (afterContextMenu)
                host.execCommand("del", {source: "ace"});
            else // some versions of android do not fire keydown when pressing backspace
                host.execCommand("backspace", {source: "ace"});
        } else if (!copied) {
            if (data.substring(0, 9) == PLACEHOLDER && data.length > PLACEHOLDER.length)
                data = data.substr(9);
            else if (data.substr(0, 4) == PLACEHOLDER.substr(0, 4))
                data = data.substr(4, data.length - PLACEHOLDER.length + 1);
            else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);
            if (data == PLACEHOLDER.charAt(0)) {
            } else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);

            if (data)
                host.onTextInput(data);
        }
        if (copied) {
          copied = false;
        }
        if (afterContextMenu)
            afterContextMenu = false;
    };
    var onInput = function(e) {
        if (inComposition)
            return;
        var data = text.value;
        sendText(data);
        resetValue();
    };

    var handleClipboardData = function(e, data, forceIEMime) {
        var clipboardData = e.clipboardData || window.clipboardData;
        if (!clipboardData || BROKEN_SETDATA)
            return;
        var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
        try {
            if (data) {
                return clipboardData.setData(mime, data) !== false;
            } else {
                return clipboardData.getData(mime);
            }
        } catch(e) {
            if (!forceIEMime)
                return handleClipboardData(e, data, true);
        }
    };

    var doCopy = function(e, isCut) {
        var data = host.getCopyText();
        if (!data)
            return event.preventDefault(e);

        if (handleClipboardData(e, data)) {
            if (useragent.isIOS) {
                cut = isCut;
                text.value = "\n aa" + data + "a a\n";
                text.setSelectionRange(4, 4 + data.length);
                copied = {
                    value: data
                };
            }
            isCut ? host.onCut() : host.onCopy();
            if (!useragent.isIOS) event.preventDefault(e);
        } else {
            copied = true;
            text.value = data;
            text.select();
            setTimeout(function(){
                copied = false;
                resetValue();
                resetSelection();
                isCut ? host.onCut() : host.onCopy();
            });
        }
    };

    var onCut = function(e) {
        doCopy(e, true);
    };

    var onCopy = function(e) {
        doCopy(e, false);
    };

    var onPaste = function(e) {
        var data = handleClipboardData(e);
        if (typeof data == "string") {
            if (data)
                host.onPaste(data, e);
            if (useragent.isIE)
                setTimeout(resetSelection);
            event.preventDefault(e);
        }
        else {
            text.value = "";
            pasted = true;
        }
    };

    event.addCommandKeyListener(text, host.onCommandKey.bind(host));

    event.addListener(text, "select", onSelect);

    event.addListener(text, "input", onInput);

    event.addListener(text, "cut", onCut);
    event.addListener(text, "copy", onCopy);
    event.addListener(text, "paste", onPaste);
    var onCompositionStart = function(e) {
        if (inComposition || !host.onCompositionStart || host.$readOnly)
            return;
        inComposition = {};
        inComposition.canUndo = host.session.$undoManager;
        host.onCompositionStart();
        setTimeout(onCompositionUpdate, 0);
        host.on("mousedown", onCompositionEnd);
        if (inComposition.canUndo && !host.selection.isEmpty()) {
            host.insert("");
            host.session.markUndoGroup();
            host.selection.clearSelection();
        }
        host.session.markUndoGroup();
    };

    var onCompositionUpdate = function() {
        if (!inComposition || !host.onCompositionUpdate || host.$readOnly)
            return;
        var val = text.value.replace(/\x01/g, "");
        if (inComposition.lastValue === val) return;

        host.onCompositionUpdate(val);
        if (inComposition.lastValue)
            host.undo();
        if (inComposition.canUndo)
            inComposition.lastValue = val;
        if (inComposition.lastValue) {
            var r = host.selection.getRange();
            host.insert(inComposition.lastValue);
            host.session.markUndoGroup();
            inComposition.range = host.selection.getRange();
            host.selection.setRange(r);
            host.selection.clearSelection();
        }
    };

    var onCompositionEnd = function(e) {
        if (!host.onCompositionEnd || host.$readOnly) return;
        var c = inComposition;
        inComposition = false;
        var timer = setTimeout(function() {
            timer = null;
            var str = text.value.replace(/\x01/g, "");
            if (inComposition)
                return;
            else if (str == c.lastValue)
                resetValue();
            else if (!c.lastValue && str) {
                resetValue();
                sendText(str);
            }
        });
        inputHandler = function compositionInputHandler(str) {
            if (timer)
                clearTimeout(timer);
            str = str.replace(/\x01/g, "");
            if (str == c.lastValue)
                return "";
            if (c.lastValue && timer)
                host.undo();
            return str;
        };
        host.onCompositionEnd();
        host.removeListener("mousedown", onCompositionEnd);
        if (e.type == "compositionend" && c.range) {
            host.selection.setRange(c.range);
        }
        var needsOnInput =
            (!!useragent.isChrome && useragent.isChrome >= 53) ||
            (!!useragent.isWebKit && useragent.isWebKit >= 603);

        if (needsOnInput) {
          onInput();
        }
    };



    var syncComposition = lang.delayedCall(onCompositionUpdate, 50);

    event.addListener(text, "compositionstart", onCompositionStart);
    if (useragent.isGecko) {
        event.addListener(text, "text", function(){syncComposition.schedule();});
    } else {
        event.addListener(text, "keyup", function(){syncComposition.schedule();});
        event.addListener(text, "keydown", function(){syncComposition.schedule();});
    }
    event.addListener(text, "compositionend", onCompositionEnd);

    this.getElement = function() {
        return text;
    };

    this.setReadOnly = function(readOnly) {
       text.readOnly = readOnly;
    };

    this.onContextMenu = function(e) {
        afterContextMenu = true;
        resetSelection(host.selection.isEmpty());
        host._emit("nativecontextmenu", {target: host, domEvent: e});
        this.moveToMouse(e, true);
    };

    this.moveToMouse = function(e, bringToFront) {
        if (!tempStyle)
            tempStyle = text.style.cssText;
        text.style.cssText = (bringToFront ? "z-index:100000;" : "")
            + "height:" + text.style.height + ";"
            + (useragent.isIE ? "opacity:0.1;" : "");

        var rect = host.container.getBoundingClientRect();
        var style = dom.computedStyle(host.container);
        var top = rect.top + (parseInt(style.borderTopWidth) || 0);
        var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
        var maxTop = rect.bottom - top - text.clientHeight -2;
        var move = function(e) {
            text.style.left = e.clientX - left - 2 + "px";
            text.style.top = Math.min(e.clientY - top - 2, maxTop) + "px";
        };
        move(e);

        if (e.type != "mousedown")
            return;

        if (host.renderer.$keepTextAreaAtCursor)
            host.renderer.$keepTextAreaAtCursor = null;

        clearTimeout(closeTimeout);
        if (useragent.isWin)
            event.capture(host.container, move, onContextMenuClose);
    };

    this.onContextMenuClose = onContextMenuClose;
    var closeTimeout;
    function onContextMenuClose() {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(function () {
            if (tempStyle) {
                text.style.cssText = tempStyle;
                tempStyle = '';
            }
            if (host.renderer.$keepTextAreaAtCursor == null) {
                host.renderer.$keepTextAreaAtCursor = true;
                host.renderer.$moveTextAreaToCursor();
            }
        }, 0);
    }

    var onContextMenu = function(e) {
        host.textInput.onContextMenu(e);
        onContextMenuClose();
    };
    event.addListener(text, "mouseup", onContextMenu);
    event.addListener(text, "mousedown", function(e) {
        e.preventDefault();
        onContextMenuClose();
    });
    event.addListener(host.renderer.scroller, "contextmenu", onContextMenu);
    event.addListener(text, "contextmenu", onContextMenu);

    if (useragent.isIOS) {
        var typingResetTimeout = null;
        var typing = false;

        parentNode.addEventListener("keydown", function (e) {
            if (typingResetTimeout) clearTimeout(typingResetTimeout);
            typing = true;
        });

        parentNode.addEventListener("keyup", function (e) {
            typingResetTimeout = setTimeout(function () {
                typing = false;
            }, 100);
        });
        var detectArrowKeys = function(e) {
            if (document.activeElement !== text) return;
            if (typing) return;

            if (cut) {
                return setTimeout(function () {
                    cut = false;
                }, 100);
            }
            var selectionStart = text.selectionStart;
            var selectionEnd = text.selectionEnd;
            text.setSelectionRange(4, 5);
            if (selectionStart == selectionEnd) {
                switch (selectionStart) {
                    case 0: host.onCommandKey(null, 0, KEYS.up); break;
                    case 1: host.onCommandKey(null, 0, KEYS.home); break;
                    case 2: host.onCommandKey(null, MODS.option, KEYS.left); break;
                    case 4: host.onCommandKey(null, 0, KEYS.left); break;
                    case 5: host.onCommandKey(null, 0, KEYS.right); break;
                    case 7: host.onCommandKey(null, MODS.option, KEYS.right); break;
                    case 8: host.onCommandKey(null, 0, KEYS.end); break;
                    case 9: host.onCommandKey(null, 0, KEYS.down); break;
                }
            } else {
                switch (selectionEnd) {
                    case 6: host.onCommandKey(null, MODS.shift, KEYS.right); break;
                    case 7: host.onCommandKey(null, MODS.shift | MODS.option, KEYS.right); break;
                    case 8: host.onCommandKey(null, MODS.shift, KEYS.end); break;
                    case 9: host.onCommandKey(null, MODS.shift, KEYS.down); break;
                }
                switch (selectionStart) {
                    case 0: host.onCommandKey(null, MODS.shift, KEYS.up); break;
                    case 1: host.onCommandKey(null, MODS.shift, KEYS.home); break;
                    case 2: host.onCommandKey(null, MODS.shift | MODS.option, KEYS.left); break;
                    case 3: host.onCommandKey(null, MODS.shift, KEYS.left); break;
                }
            }
        };
        document.addEventListener("selectionchange", detectArrowKeys);
        host.on("destroy", function() {
            document.removeEventListener("selectionchange", detectArrowKeys);
        });
    }
};

exports.TextInput = TextInput;
});

ace.define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang","ace/keyboard/textinput_ios"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var BROKEN_SETDATA = useragent.isChrome < 18;
var USE_IE_MIME_TYPE =  useragent.isIE;

var TextInputIOS = acequire("./textinput_ios").TextInput;
var TextInput = function(parentNode, host) {
    if (useragent.isIOS)
        return TextInputIOS.call(this, parentNode, host);

    var text = dom.createElement("textarea");
    text.className = "ace_text-input";

    text.setAttribute("wrap", "off");
    text.setAttribute("autocorrect", "off");
    text.setAttribute("autocapitalize", "off");
    text.setAttribute("spellcheck", false);

    text.style.opacity = "0";
    parentNode.insertBefore(text, parentNode.firstChild);

    var PLACEHOLDER = "\u2028\u2028";

    var copied = false;
    var pasted = false;
    var inComposition = false;
    var tempStyle = '';
    var isSelectionEmpty = true;
    try { var isFocused = document.activeElement === text; } catch(e) {}
    
    event.addListener(text, "blur", function(e) {
        host.onBlur(e);
        isFocused = false;
    });
    event.addListener(text, "focus", function(e) {
        isFocused = true;
        host.onFocus(e);
        resetSelection();
    });
    this.focus = function() {
        if (tempStyle) return text.focus();
        var top = text.style.top;
        text.style.position = "fixed";
        text.style.top = "0px";
        text.focus();
        setTimeout(function() {
            text.style.position = "";
            if (text.style.top == "0px")
                text.style.top = top;
        }, 0);
    };
    this.blur = function() {
        text.blur();
    };
    this.isFocused = function() {
        return isFocused;
    };
    var syncSelection = lang.delayedCall(function() {
        isFocused && resetSelection(isSelectionEmpty);
    });
    var syncValue = lang.delayedCall(function() {
         if (!inComposition) {
            text.value = PLACEHOLDER;
            isFocused && resetSelection();
         }
    });

    function resetSelection(isEmpty) {
        if (inComposition)
            return;
        inComposition = true;
        
        if (inputHandler) {
            var selectionStart = 0;
            var selectionEnd = isEmpty ? 0 : text.value.length - 1;
        } else {
            var selectionStart = isEmpty ? 2 : 1;
            var selectionEnd = 2;
        }
        try {
            text.setSelectionRange(selectionStart, selectionEnd);
        } catch(e){}
        
        inComposition = false;
    }

    function resetValue() {
        if (inComposition)
            return;
        text.value = PLACEHOLDER;
        if (useragent.isWebKit)
            syncValue.schedule();
    }

    useragent.isWebKit || host.addEventListener('changeSelection', function() {
        if (host.selection.isEmpty() != isSelectionEmpty) {
            isSelectionEmpty = !isSelectionEmpty;
            syncSelection.schedule();
        }
    });

    resetValue();
    if (isFocused)
        host.onFocus();


    var isAllSelected = function(text) {
        return text.selectionStart === 0 && text.selectionEnd === text.value.length;
    };

    var onSelect = function(e) {
        if (copied) {
            copied = false;
        } else if (isAllSelected(text)) {
            host.selectAll();
            resetSelection();
        } else if (inputHandler) {
            resetSelection(host.selection.isEmpty());
        }
    };

    var inputHandler = null;
    this.setInputHandler = function(cb) {inputHandler = cb;};
    this.getInputHandler = function() {return inputHandler;};
    var afterContextMenu = false;
    
    var sendText = function(data) {
        if (inputHandler) {
            data = inputHandler(data);
            inputHandler = null;
        }
        if (pasted) {
            resetSelection();
            if (data)
                host.onPaste(data);
            pasted = false;
        } else if (data == PLACEHOLDER.charAt(0)) {
            if (afterContextMenu)
                host.execCommand("del", {source: "ace"});
            else // some versions of android do not fire keydown when pressing backspace
                host.execCommand("backspace", {source: "ace"});
        } else {
            if (data.substring(0, 2) == PLACEHOLDER)
                data = data.substr(2);
            else if (data.charAt(0) == PLACEHOLDER.charAt(0))
                data = data.substr(1);
            else if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);
            if (data.charAt(data.length - 1) == PLACEHOLDER.charAt(0))
                data = data.slice(0, -1);
            
            if (data)
                host.onTextInput(data);
        }
        if (afterContextMenu)
            afterContextMenu = false;
    };
    var onInput = function(e) {
        if (inComposition)
            return;
        var data = text.value;
        sendText(data);
        resetValue();
    };
    
    var handleClipboardData = function(e, data, forceIEMime) {
        var clipboardData = e.clipboardData || window.clipboardData;
        if (!clipboardData || BROKEN_SETDATA)
            return;
        var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
        try {
            if (data) {
                return clipboardData.setData(mime, data) !== false;
            } else {
                return clipboardData.getData(mime);
            }
        } catch(e) {
            if (!forceIEMime)
                return handleClipboardData(e, data, true);
        }
    };

    var doCopy = function(e, isCut) {
        var data = host.getCopyText();
        if (!data)
            return event.preventDefault(e);

        if (handleClipboardData(e, data)) {
            isCut ? host.onCut() : host.onCopy();
            event.preventDefault(e);
        } else {
            copied = true;
            text.value = data;
            text.select();
            setTimeout(function(){
                copied = false;
                resetValue();
                resetSelection();
                isCut ? host.onCut() : host.onCopy();
            });
        }
    };
    
    var onCut = function(e) {
        doCopy(e, true);
    };
    
    var onCopy = function(e) {
        doCopy(e, false);
    };
    
    var onPaste = function(e) {
        var data = handleClipboardData(e);
        if (typeof data == "string") {
            if (data)
                host.onPaste(data, e);
            if (useragent.isIE)
                setTimeout(resetSelection);
            event.preventDefault(e);
        }
        else {
            text.value = "";
            pasted = true;
        }
    };

    event.addCommandKeyListener(text, host.onCommandKey.bind(host));

    event.addListener(text, "select", onSelect);

    event.addListener(text, "input", onInput);

    event.addListener(text, "cut", onCut);
    event.addListener(text, "copy", onCopy);
    event.addListener(text, "paste", onPaste);
    if (!('oncut' in text) || !('oncopy' in text) || !('onpaste' in text)) {
        event.addListener(parentNode, "keydown", function(e) {
            if ((useragent.isMac && !e.metaKey) || !e.ctrlKey)
                return;

            switch (e.keyCode) {
                case 67:
                    onCopy(e);
                    break;
                case 86:
                    onPaste(e);
                    break;
                case 88:
                    onCut(e);
                    break;
            }
        });
    }
    var onCompositionStart = function(e) {
        if (inComposition || !host.onCompositionStart || host.$readOnly) 
            return;
        inComposition = {};
        inComposition.canUndo = host.session.$undoManager;
        host.onCompositionStart();
        setTimeout(onCompositionUpdate, 0);
        host.on("mousedown", onCompositionEnd);
        if (inComposition.canUndo && !host.selection.isEmpty()) {
            host.insert("");
            host.session.markUndoGroup();
            host.selection.clearSelection();
        }
        host.session.markUndoGroup();
    };

    var onCompositionUpdate = function() {
        if (!inComposition || !host.onCompositionUpdate || host.$readOnly)
            return;
        var val = text.value.replace(/\u2028/g, "");
        if (inComposition.lastValue === val) return;
        
        host.onCompositionUpdate(val);
        if (inComposition.lastValue)
            host.undo();
        if (inComposition.canUndo)
            inComposition.lastValue = val;
        if (inComposition.lastValue) {
            var r = host.selection.getRange();
            host.insert(inComposition.lastValue);
            host.session.markUndoGroup();
            inComposition.range = host.selection.getRange();
            host.selection.setRange(r);
            host.selection.clearSelection();
        }
    };

    var onCompositionEnd = function(e) {
        if (!host.onCompositionEnd || host.$readOnly) return;
        var c = inComposition;
        inComposition = false;
        var timer = setTimeout(function() {
            timer = null;
            var str = text.value.replace(/\u2028/g, "");
            if (inComposition)
                return;
            else if (str == c.lastValue)
                resetValue();
            else if (!c.lastValue && str) {
                resetValue();
                sendText(str);
            }
        });
        inputHandler = function compositionInputHandler(str) {
            if (timer)
                clearTimeout(timer);
            str = str.replace(/\u2028/g, "");
            if (str == c.lastValue)
                return "";
            if (c.lastValue && timer)
                host.undo();
            return str;
        };
        host.onCompositionEnd();
        host.removeListener("mousedown", onCompositionEnd);
        if (e.type == "compositionend" && c.range) {
            host.selection.setRange(c.range);
        }
        var needsOnInput =
            (!!useragent.isChrome && useragent.isChrome >= 53) ||
            (!!useragent.isWebKit && useragent.isWebKit >= 603);

        if (needsOnInput) {
          onInput();
        }
    };
    
    

    var syncComposition = lang.delayedCall(onCompositionUpdate, 50);

    event.addListener(text, "compositionstart", onCompositionStart);
    if (useragent.isGecko) {
        event.addListener(text, "text", function(){syncComposition.schedule();});
    } else {
        event.addListener(text, "keyup", function(){syncComposition.schedule();});
        event.addListener(text, "keydown", function(){syncComposition.schedule();});
    }
    event.addListener(text, "compositionend", onCompositionEnd);

    this.getElement = function() {
        return text;
    };

    this.setReadOnly = function(readOnly) {
       text.readOnly = readOnly;
    };

    this.onContextMenu = function(e) {
        afterContextMenu = true;
        resetSelection(host.selection.isEmpty());
        host._emit("nativecontextmenu", {target: host, domEvent: e});
        this.moveToMouse(e, true);
    };
    
    this.moveToMouse = function(e, bringToFront) {
        if (!tempStyle)
            tempStyle = text.style.cssText;
        text.style.cssText = (bringToFront ? "z-index:100000;" : "")
            + "height:" + text.style.height + ";"
            + (useragent.isIE ? "opacity:0.1;" : "");

        var rect = host.container.getBoundingClientRect();
        var style = dom.computedStyle(host.container);
        var top = rect.top + (parseInt(style.borderTopWidth) || 0);
        var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
        var maxTop = rect.bottom - top - text.clientHeight -2;
        var move = function(e) {
            text.style.left = e.clientX - left - 2 + "px";
            text.style.top = Math.min(e.clientY - top - 2, maxTop) + "px";
        }; 
        move(e);

        if (e.type != "mousedown")
            return;

        if (host.renderer.$keepTextAreaAtCursor)
            host.renderer.$keepTextAreaAtCursor = null;

        clearTimeout(closeTimeout);
        if (useragent.isWin)
            event.capture(host.container, move, onContextMenuClose);
    };

    this.onContextMenuClose = onContextMenuClose;
    var closeTimeout;
    function onContextMenuClose() {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(function () {
            if (tempStyle) {
                text.style.cssText = tempStyle;
                tempStyle = '';
            }
            if (host.renderer.$keepTextAreaAtCursor == null) {
                host.renderer.$keepTextAreaAtCursor = true;
                host.renderer.$moveTextAreaToCursor();
            }
        }, 0);
    }

    var onContextMenu = function(e) {
        host.textInput.onContextMenu(e);
        onContextMenuClose();
    };
    event.addListener(text, "mouseup", onContextMenu);
    event.addListener(text, "mousedown", function(e) {
        e.preventDefault();
        onContextMenuClose();
    });
    event.addListener(host.renderer.scroller, "contextmenu", onContextMenu);
    event.addListener(text, "contextmenu", onContextMenu);
};

exports.TextInput = TextInput;
});

ace.define("ace/mouse/default_handlers",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");

var DRAG_OFFSET = 0; // pixels
var SCROLL_COOLDOWN_T = 250; // milliseconds

function DefaultHandlers(mouseHandler) {
    mouseHandler.$clickSelection = null;

    var editor = mouseHandler.editor;
    editor.setDefaultHandler("mousedown", this.onMouseDown.bind(mouseHandler));
    editor.setDefaultHandler("dblclick", this.onDoubleClick.bind(mouseHandler));
    editor.setDefaultHandler("tripleclick", this.onTripleClick.bind(mouseHandler));
    editor.setDefaultHandler("quadclick", this.onQuadClick.bind(mouseHandler));
    editor.setDefaultHandler("mousewheel", this.onMouseWheel.bind(mouseHandler));
    editor.setDefaultHandler("touchmove", this.onTouchMove.bind(mouseHandler));

    var exports = ["select", "startSelect", "selectEnd", "selectAllEnd", "selectByWordsEnd",
        "selectByLinesEnd", "dragWait", "dragWaitEnd", "focusWait"];

    exports.forEach(function(x) {
        mouseHandler[x] = this[x];
    }, this);

    mouseHandler.selectByLines = this.extendSelectionBy.bind(mouseHandler, "getLineRange");
    mouseHandler.selectByWords = this.extendSelectionBy.bind(mouseHandler, "getWordRange");
}

(function() {

    this.onMouseDown = function(ev) {
        var inSelection = ev.inSelection();
        var pos = ev.getDocumentPosition();
        this.mousedownEvent = ev;
        var editor = this.editor;

        var button = ev.getButton();
        if (button !== 0) {
            var selectionRange = editor.getSelectionRange();
            var selectionEmpty = selectionRange.isEmpty();
            editor.$blockScrolling++;
            if (selectionEmpty || button == 1)
                editor.selection.moveToPosition(pos);
            editor.$blockScrolling--;
            if (button == 2) {
                editor.textInput.onContextMenu(ev.domEvent);
                if (!useragent.isMozilla)
                    ev.preventDefault();
            }
            return;
        }

        this.mousedownEvent.time = Date.now();
        if (inSelection && !editor.isFocused()) {
            editor.focus();
            if (this.$focusTimout && !this.$clickSelection && !editor.inMultiSelectMode) {
                this.setState("focusWait");
                this.captureMouse(ev);
                return;
            }
        }

        this.captureMouse(ev);
        this.startSelect(pos, ev.domEvent._clicks > 1);
        return ev.preventDefault();
    };

    this.startSelect = function(pos, waitForClickSelection) {
        pos = pos || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
        var editor = this.editor;
        editor.$blockScrolling++;
        if (this.mousedownEvent.getShiftKey())
            editor.selection.selectToPosition(pos);
        else if (!waitForClickSelection)
            editor.selection.moveToPosition(pos);
        if (!waitForClickSelection)
            this.select();
        if (editor.renderer.scroller.setCapture) {
            editor.renderer.scroller.setCapture();
        }
        editor.setStyle("ace_selecting");
        this.setState("select");
        editor.$blockScrolling--;
    };

    this.select = function() {
        var anchor, editor = this.editor;
        var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
        editor.$blockScrolling++;
        if (this.$clickSelection) {
            var cmp = this.$clickSelection.comparePoint(cursor);

            if (cmp == -1) {
                anchor = this.$clickSelection.end;
            } else if (cmp == 1) {
                anchor = this.$clickSelection.start;
            } else {
                var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                cursor = orientedRange.cursor;
                anchor = orientedRange.anchor;
            }
            editor.selection.setSelectionAnchor(anchor.row, anchor.column);
        }
        editor.selection.selectToPosition(cursor);
        editor.$blockScrolling--;
        editor.renderer.scrollCursorIntoView();
    };

    this.extendSelectionBy = function(unitName) {
        var anchor, editor = this.editor;
        var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
        var range = editor.selection[unitName](cursor.row, cursor.column);
        editor.$blockScrolling++;
        if (this.$clickSelection) {
            var cmpStart = this.$clickSelection.comparePoint(range.start);
            var cmpEnd = this.$clickSelection.comparePoint(range.end);

            if (cmpStart == -1 && cmpEnd <= 0) {
                anchor = this.$clickSelection.end;
                if (range.end.row != cursor.row || range.end.column != cursor.column)
                    cursor = range.start;
            } else if (cmpEnd == 1 && cmpStart >= 0) {
                anchor = this.$clickSelection.start;
                if (range.start.row != cursor.row || range.start.column != cursor.column)
                    cursor = range.end;
            } else if (cmpStart == -1 && cmpEnd == 1) {
                cursor = range.end;
                anchor = range.start;
            } else {
                var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                cursor = orientedRange.cursor;
                anchor = orientedRange.anchor;
            }
            editor.selection.setSelectionAnchor(anchor.row, anchor.column);
        }
        editor.selection.selectToPosition(cursor);
        editor.$blockScrolling--;
        editor.renderer.scrollCursorIntoView();
    };

    this.selectEnd =
    this.selectAllEnd =
    this.selectByWordsEnd =
    this.selectByLinesEnd = function() {
        this.$clickSelection = null;
        this.editor.unsetStyle("ace_selecting");
        if (this.editor.renderer.scroller.releaseCapture) {
            this.editor.renderer.scroller.releaseCapture();
        }
    };

    this.focusWait = function() {
        var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
        var time = Date.now();

        if (distance > DRAG_OFFSET || time - this.mousedownEvent.time > this.$focusTimout)
            this.startSelect(this.mousedownEvent.getDocumentPosition());
    };

    this.onDoubleClick = function(ev) {
        var pos = ev.getDocumentPosition();
        var editor = this.editor;
        var session = editor.session;

        var range = session.getBracketRange(pos);
        if (range) {
            if (range.isEmpty()) {
                range.start.column--;
                range.end.column++;
            }
            this.setState("select");
        } else {
            range = editor.selection.getWordRange(pos.row, pos.column);
            this.setState("selectByWords");
        }
        this.$clickSelection = range;
        this.select();
    };

    this.onTripleClick = function(ev) {
        var pos = ev.getDocumentPosition();
        var editor = this.editor;

        this.setState("selectByLines");
        var range = editor.getSelectionRange();
        if (range.isMultiLine() && range.contains(pos.row, pos.column)) {
            this.$clickSelection = editor.selection.getLineRange(range.start.row);
            this.$clickSelection.end = editor.selection.getLineRange(range.end.row).end;
        } else {
            this.$clickSelection = editor.selection.getLineRange(pos.row);
        }
        this.select();
    };

    this.onQuadClick = function(ev) {
        var editor = this.editor;

        editor.selectAll();
        this.$clickSelection = editor.getSelectionRange();
        this.setState("selectAll");
    };

    this.onMouseWheel = function(ev) {
        if (ev.getAccelKey())
            return;
        if (ev.getShiftKey() && ev.wheelY && !ev.wheelX) {
            ev.wheelX = ev.wheelY;
            ev.wheelY = 0;
        }
        
        var editor = this.editor;

        if (!this.$lastScroll)
            this.$lastScroll = { t: 0, vx: 0, vy: 0, allowed: 0 };

        var prevScroll = this.$lastScroll;
        var t = ev.domEvent.timeStamp;
        var dt = t - prevScroll.t;
        var vx = ev.wheelX / dt;
        var vy = ev.wheelY / dt;
        if (dt < SCROLL_COOLDOWN_T) {
            vx = (vx + prevScroll.vx) / 2;
            vy = (vy + prevScroll.vy) / 2;
        }

        var direction = Math.abs(vx / vy);

        var canScroll = false;
        if (direction >= 1 && editor.renderer.isScrollableBy(ev.wheelX * ev.speed, 0))
            canScroll = true;
        if (direction <= 1 && editor.renderer.isScrollableBy(0, ev.wheelY * ev.speed))
            canScroll = true;

        if (canScroll) {
            prevScroll.allowed = t;
        } else if (t - prevScroll.allowed < SCROLL_COOLDOWN_T) {
            var isSlower = Math.abs(vx) <= 1.1 * Math.abs(prevScroll.vx)
                && Math.abs(vy) <= 1.1 * Math.abs(prevScroll.vy);
            if (isSlower) {
                canScroll = true;
                prevScroll.allowed = t;
            }
            else {
                prevScroll.allowed = 0;
            }
        }

        prevScroll.t = t;
        prevScroll.vx = vx;
        prevScroll.vy = vy;

        if (canScroll) {
            editor.renderer.scrollBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
            return ev.stop();
        }
    };

    this.onTouchMove = function(ev) {
        this.editor._emit("mousewheel", ev);
    };

}).call(DefaultHandlers.prototype);

exports.DefaultHandlers = DefaultHandlers;

function calcDistance(ax, ay, bx, by) {
    return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
}

function calcRangeOrientation(range, cursor) {
    if (range.start.row == range.end.row)
        var cmp = 2 * cursor.column - range.start.column - range.end.column;
    else if (range.start.row == range.end.row - 1 && !range.start.column && !range.end.column)
        var cmp = cursor.column - 4;
    else
        var cmp = 2 * cursor.row - range.start.row - range.end.row;

    if (cmp < 0)
        return {cursor: range.start, anchor: range.end};
    else
        return {cursor: range.end, anchor: range.start};
}

});

ace.define("ace/tooltip",["require","exports","module","ace/lib/oop","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
function Tooltip (parentNode) {
    this.isOpen = false;
    this.$element = null;
    this.$parentNode = parentNode;
}

(function() {
    this.$init = function() {
        this.$element = dom.createElement("div");
        this.$element.className = "ace_tooltip";
        this.$element.style.display = "none";
        this.$parentNode.appendChild(this.$element);
        return this.$element;
    };
    this.getElement = function() {
        return this.$element || this.$init();
    };
    this.setText = function(text) {
        dom.setInnerText(this.getElement(), text);
    };
    this.setHtml = function(html) {
        this.getElement().innerHTML = html;
    };
    this.setPosition = function(x, y) {
        this.getElement().style.left = x + "px";
        this.getElement().style.top = y + "px";
    };
    this.setClassName = function(className) {
        dom.addCssClass(this.getElement(), className);
    };
    this.show = function(text, x, y) {
        if (text != null)
            this.setText(text);
        if (x != null && y != null)
            this.setPosition(x, y);
        if (!this.isOpen) {
            this.getElement().style.display = "block";
            this.isOpen = true;
        }
    };

    this.hide = function() {
        if (this.isOpen) {
            this.getElement().style.display = "none";
            this.isOpen = false;
        }
    };
    this.getHeight = function() {
        return this.getElement().offsetHeight;
    };
    this.getWidth = function() {
        return this.getElement().offsetWidth;
    };

    this.destroy = function() {
        this.isOpen = false;
        if (this.$element && this.$element.parentNode) {
            this.$element.parentNode.removeChild(this.$element);
        }
    };

}).call(Tooltip.prototype);

exports.Tooltip = Tooltip;
});

ace.define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event","ace/tooltip"], function(acequire, exports, module) {
"use strict";
var dom = acequire("../lib/dom");
var oop = acequire("../lib/oop");
var event = acequire("../lib/event");
var Tooltip = acequire("../tooltip").Tooltip;

function GutterHandler(mouseHandler) {
    var editor = mouseHandler.editor;
    var gutter = editor.renderer.$gutterLayer;
    var tooltip = new GutterTooltip(editor.container);

    mouseHandler.editor.setDefaultHandler("guttermousedown", function(e) {
        if (!editor.isFocused() || e.getButton() != 0)
            return;
        var gutterRegion = gutter.getRegion(e);

        if (gutterRegion == "foldWidgets")
            return;

        var row = e.getDocumentPosition().row;
        var selection = editor.session.selection;

        if (e.getShiftKey())
            selection.selectTo(row, 0);
        else {
            if (e.domEvent.detail == 2) {
                editor.selectAll();
                return e.preventDefault();
            }
            mouseHandler.$clickSelection = editor.selection.getLineRange(row);
        }
        mouseHandler.setState("selectByLines");
        mouseHandler.captureMouse(e);
        return e.preventDefault();
    });


    var tooltipTimeout, mouseEvent, tooltipAnnotation;

    function showTooltip() {
        var row = mouseEvent.getDocumentPosition().row;
        var annotation = gutter.$annotations[row];
        if (!annotation)
            return hideTooltip();

        var maxRow = editor.session.getLength();
        if (row == maxRow) {
            var screenRow = editor.renderer.pixelToScreenCoordinates(0, mouseEvent.y).row;
            var pos = mouseEvent.$pos;
            if (screenRow > editor.session.documentToScreenRow(pos.row, pos.column))
                return hideTooltip();
        }

        if (tooltipAnnotation == annotation)
            return;
        tooltipAnnotation = annotation.text.join("<br/>");

        tooltip.setHtml(tooltipAnnotation);
        tooltip.show();
        editor._signal("showGutterTooltip", tooltip);
        editor.on("mousewheel", hideTooltip);

        if (mouseHandler.$tooltipFollowsMouse) {
            moveTooltip(mouseEvent);
        } else {
            var gutterElement = mouseEvent.domEvent.target;
            var rect = gutterElement.getBoundingClientRect();
            var style = tooltip.getElement().style;
            style.left = rect.right + "px";
            style.top = rect.bottom + "px";
        }
    }

    function hideTooltip() {
        if (tooltipTimeout)
            tooltipTimeout = clearTimeout(tooltipTimeout);
        if (tooltipAnnotation) {
            tooltip.hide();
            tooltipAnnotation = null;
            editor._signal("hideGutterTooltip", tooltip);
            editor.removeEventListener("mousewheel", hideTooltip);
        }
    }

    function moveTooltip(e) {
        tooltip.setPosition(e.x, e.y);
    }

    mouseHandler.editor.setDefaultHandler("guttermousemove", function(e) {
        var target = e.domEvent.target || e.domEvent.srcElement;
        if (dom.hasCssClass(target, "ace_fold-widget"))
            return hideTooltip();

        if (tooltipAnnotation && mouseHandler.$tooltipFollowsMouse)
            moveTooltip(e);

        mouseEvent = e;
        if (tooltipTimeout)
            return;
        tooltipTimeout = setTimeout(function() {
            tooltipTimeout = null;
            if (mouseEvent && !mouseHandler.isMousePressed)
                showTooltip();
            else
                hideTooltip();
        }, 50);
    });

    event.addListener(editor.renderer.$gutter, "mouseout", function(e) {
        mouseEvent = null;
        if (!tooltipAnnotation || tooltipTimeout)
            return;

        tooltipTimeout = setTimeout(function() {
            tooltipTimeout = null;
            hideTooltip();
        }, 50);
    });
    
    editor.on("changeSession", hideTooltip);
}

function GutterTooltip(parentNode) {
    Tooltip.call(this, parentNode);
}

oop.inherits(GutterTooltip, Tooltip);

(function(){
    this.setPosition = function(x, y) {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        var width = this.getWidth();
        var height = this.getHeight();
        x += 15;
        y += 15;
        if (x + width > windowWidth) {
            x -= (x + width) - windowWidth;
        }
        if (y + height > windowHeight) {
            y -= 20 + height;
        }
        Tooltip.prototype.setPosition.call(this, x, y);
    };

}).call(GutterTooltip.prototype);



exports.GutterHandler = GutterHandler;

});

ace.define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var MouseEvent = exports.MouseEvent = function(domEvent, editor) {
    this.domEvent = domEvent;
    this.editor = editor;
    
    this.x = this.clientX = domEvent.clientX;
    this.y = this.clientY = domEvent.clientY;

    this.$pos = null;
    this.$inSelection = null;
    
    this.propagationStopped = false;
    this.defaultPrevented = false;
};

(function() {  
    
    this.stopPropagation = function() {
        event.stopPropagation(this.domEvent);
        this.propagationStopped = true;
    };
    
    this.preventDefault = function() {
        event.preventDefault(this.domEvent);
        this.defaultPrevented = true;
    };
    
    this.stop = function() {
        this.stopPropagation();
        this.preventDefault();
    };
    this.getDocumentPosition = function() {
        if (this.$pos)
            return this.$pos;
        
        this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY);
        return this.$pos;
    };
    this.inSelection = function() {
        if (this.$inSelection !== null)
            return this.$inSelection;
            
        var editor = this.editor;
        

        var selectionRange = editor.getSelectionRange();
        if (selectionRange.isEmpty())
            this.$inSelection = false;
        else {
            var pos = this.getDocumentPosition();
            this.$inSelection = selectionRange.contains(pos.row, pos.column);
        }

        return this.$inSelection;
    };
    this.getButton = function() {
        return event.getButton(this.domEvent);
    };
    this.getShiftKey = function() {
        return this.domEvent.shiftKey;
    };
    
    this.getAccelKey = useragent.isMac
        ? function() { return this.domEvent.metaKey; }
        : function() { return this.domEvent.ctrlKey; };
    
}).call(MouseEvent.prototype);

});

ace.define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");

var AUTOSCROLL_DELAY = 200;
var SCROLL_CURSOR_DELAY = 200;
var SCROLL_CURSOR_HYSTERESIS = 5;

function DragdropHandler(mouseHandler) {

    var editor = mouseHandler.editor;

    var blankImage = dom.createElement("img");
    blankImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    if (useragent.isOpera)
        blankImage.style.cssText = "width:1px;height:1px;position:fixed;top:0;left:0;z-index:2147483647;opacity:0;";

    var exports = ["dragWait", "dragWaitEnd", "startDrag", "dragReadyEnd", "onMouseDrag"];

     exports.forEach(function(x) {
         mouseHandler[x] = this[x];
    }, this);
    editor.addEventListener("mousedown", this.onMouseDown.bind(mouseHandler));


    var mouseTarget = editor.container;
    var dragSelectionMarker, x, y;
    var timerId, range;
    var dragCursor, counter = 0;
    var dragOperation;
    var isInternal;
    var autoScrollStartTime;
    var cursorMovedTime;
    var cursorPointOnCaretMoved;

    this.onDragStart = function(e) {
        if (this.cancelDrag || !mouseTarget.draggable) {
            var self = this;
            setTimeout(function(){
                self.startSelect();
                self.captureMouse(e);
            }, 0);
            return e.preventDefault();
        }
        range = editor.getSelectionRange();

        var dataTransfer = e.dataTransfer;
        dataTransfer.effectAllowed = editor.getReadOnly() ? "copy" : "copyMove";
        if (useragent.isOpera) {
            editor.container.appendChild(blankImage);
            blankImage.scrollTop = 0;
        }
        dataTransfer.setDragImage && dataTransfer.setDragImage(blankImage, 0, 0);
        if (useragent.isOpera) {
            editor.container.removeChild(blankImage);
        }
        dataTransfer.clearData();
        dataTransfer.setData("Text", editor.session.getTextRange());

        isInternal = true;
        this.setState("drag");
    };

    this.onDragEnd = function(e) {
        mouseTarget.draggable = false;
        isInternal = false;
        this.setState(null);
        if (!editor.getReadOnly()) {
            var dropEffect = e.dataTransfer.dropEffect;
            if (!dragOperation && dropEffect == "move")
                editor.session.remove(editor.getSelectionRange());
            editor.renderer.$cursorLayer.setBlinking(true);
        }
        this.editor.unsetStyle("ace_dragging");
        this.editor.renderer.setCursorStyle("");
    };

    this.onDragEnter = function(e) {
        if (editor.getReadOnly() || !canAccept(e.dataTransfer))
            return;
        x = e.clientX;
        y = e.clientY;
        if (!dragSelectionMarker)
            addDragMarker();
        counter++;
        e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
        return event.preventDefault(e);
    };

    this.onDragOver = function(e) {
        if (editor.getReadOnly() || !canAccept(e.dataTransfer))
            return;
        x = e.clientX;
        y = e.clientY;
        if (!dragSelectionMarker) {
            addDragMarker();
            counter++;
        }
        if (onMouseMoveTimer !== null)
            onMouseMoveTimer = null;

        e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
        return event.preventDefault(e);
    };

    this.onDragLeave = function(e) {
        counter--;
        if (counter <= 0 && dragSelectionMarker) {
            clearDragMarker();
            dragOperation = null;
            return event.preventDefault(e);
        }
    };

    this.onDrop = function(e) {
        if (!dragCursor)
            return;
        var dataTransfer = e.dataTransfer;
        if (isInternal) {
            switch (dragOperation) {
                case "move":
                    if (range.contains(dragCursor.row, dragCursor.column)) {
                        range = {
                            start: dragCursor,
                            end: dragCursor
                        };
                    } else {
                        range = editor.moveText(range, dragCursor);
                    }
                    break;
                case "copy":
                    range = editor.moveText(range, dragCursor, true);
                    break;
            }
        } else {
            var dropData = dataTransfer.getData('Text');
            range = {
                start: dragCursor,
                end: editor.session.insert(dragCursor, dropData)
            };
            editor.focus();
            dragOperation = null;
        }
        clearDragMarker();
        return event.preventDefault(e);
    };

    event.addListener(mouseTarget, "dragstart", this.onDragStart.bind(mouseHandler));
    event.addListener(mouseTarget, "dragend", this.onDragEnd.bind(mouseHandler));
    event.addListener(mouseTarget, "dragenter", this.onDragEnter.bind(mouseHandler));
    event.addListener(mouseTarget, "dragover", this.onDragOver.bind(mouseHandler));
    event.addListener(mouseTarget, "dragleave", this.onDragLeave.bind(mouseHandler));
    event.addListener(mouseTarget, "drop", this.onDrop.bind(mouseHandler));

    function scrollCursorIntoView(cursor, prevCursor) {
        var now = Date.now();
        var vMovement = !prevCursor || cursor.row != prevCursor.row;
        var hMovement = !prevCursor || cursor.column != prevCursor.column;
        if (!cursorMovedTime || vMovement || hMovement) {
            editor.$blockScrolling += 1;
            editor.moveCursorToPosition(cursor);
            editor.$blockScrolling -= 1;
            cursorMovedTime = now;
            cursorPointOnCaretMoved = {x: x, y: y};
        } else {
            var distance = calcDistance(cursorPointOnCaretMoved.x, cursorPointOnCaretMoved.y, x, y);
            if (distance > SCROLL_CURSOR_HYSTERESIS) {
                cursorMovedTime = null;
            } else if (now - cursorMovedTime >= SCROLL_CURSOR_DELAY) {
                editor.renderer.scrollCursorIntoView();
                cursorMovedTime = null;
            }
        }
    }

    function autoScroll(cursor, prevCursor) {
        var now = Date.now();
        var lineHeight = editor.renderer.layerConfig.lineHeight;
        var characterWidth = editor.renderer.layerConfig.characterWidth;
        var editorRect = editor.renderer.scroller.getBoundingClientRect();
        var offsets = {
           x: {
               left: x - editorRect.left,
               right: editorRect.right - x
           },
           y: {
               top: y - editorRect.top,
               bottom: editorRect.bottom - y
           }
        };
        var nearestXOffset = Math.min(offsets.x.left, offsets.x.right);
        var nearestYOffset = Math.min(offsets.y.top, offsets.y.bottom);
        var scrollCursor = {row: cursor.row, column: cursor.column};
        if (nearestXOffset / characterWidth <= 2) {
            scrollCursor.column += (offsets.x.left < offsets.x.right ? -3 : +2);
        }
        if (nearestYOffset / lineHeight <= 1) {
            scrollCursor.row += (offsets.y.top < offsets.y.bottom ? -1 : +1);
        }
        var vScroll = cursor.row != scrollCursor.row;
        var hScroll = cursor.column != scrollCursor.column;
        var vMovement = !prevCursor || cursor.row != prevCursor.row;
        if (vScroll || (hScroll && !vMovement)) {
            if (!autoScrollStartTime)
                autoScrollStartTime = now;
            else if (now - autoScrollStartTime >= AUTOSCROLL_DELAY)
                editor.renderer.scrollCursorIntoView(scrollCursor);
        } else {
            autoScrollStartTime = null;
        }
    }

    function onDragInterval() {
        var prevCursor = dragCursor;
        dragCursor = editor.renderer.screenToTextCoordinates(x, y);
        scrollCursorIntoView(dragCursor, prevCursor);
        autoScroll(dragCursor, prevCursor);
    }

    function addDragMarker() {
        range = editor.selection.toOrientedRange();
        dragSelectionMarker = editor.session.addMarker(range, "ace_selection", editor.getSelectionStyle());
        editor.clearSelection();
        if (editor.isFocused())
            editor.renderer.$cursorLayer.setBlinking(false);
        clearInterval(timerId);
        onDragInterval();
        timerId = setInterval(onDragInterval, 20);
        counter = 0;
        event.addListener(document, "mousemove", onMouseMove);
    }

    function clearDragMarker() {
        clearInterval(timerId);
        editor.session.removeMarker(dragSelectionMarker);
        dragSelectionMarker = null;
        editor.$blockScrolling += 1;
        editor.selection.fromOrientedRange(range);
        editor.$blockScrolling -= 1;
        if (editor.isFocused() && !isInternal)
            editor.renderer.$cursorLayer.setBlinking(!editor.getReadOnly());
        range = null;
        dragCursor = null;
        counter = 0;
        autoScrollStartTime = null;
        cursorMovedTime = null;
        event.removeListener(document, "mousemove", onMouseMove);
    }
    var onMouseMoveTimer = null;
    function onMouseMove() {
        if (onMouseMoveTimer == null) {
            onMouseMoveTimer = setTimeout(function() {
                if (onMouseMoveTimer != null && dragSelectionMarker)
                    clearDragMarker();
            }, 20);
        }
    }

    function canAccept(dataTransfer) {
        var types = dataTransfer.types;
        return !types || Array.prototype.some.call(types, function(type) {
            return type == 'text/plain' || type == 'Text';
        });
    }

    function getDropEffect(e) {
        var copyAllowed = ['copy', 'copymove', 'all', 'uninitialized'];
        var moveAllowed = ['move', 'copymove', 'linkmove', 'all', 'uninitialized'];

        var copyModifierState = useragent.isMac ? e.altKey : e.ctrlKey;
        var effectAllowed = "uninitialized";
        try {
            effectAllowed = e.dataTransfer.effectAllowed.toLowerCase();
        } catch (e) {}
        var dropEffect = "none";

        if (copyModifierState && copyAllowed.indexOf(effectAllowed) >= 0)
            dropEffect = "copy";
        else if (moveAllowed.indexOf(effectAllowed) >= 0)
            dropEffect = "move";
        else if (copyAllowed.indexOf(effectAllowed) >= 0)
            dropEffect = "copy";

        return dropEffect;
    }
}

(function() {

    this.dragWait = function() {
        var interval = Date.now() - this.mousedownEvent.time;
        if (interval > this.editor.getDragDelay())
            this.startDrag();
    };

    this.dragWaitEnd = function() {
        var target = this.editor.container;
        target.draggable = false;
        this.startSelect(this.mousedownEvent.getDocumentPosition());
        this.selectEnd();
    };

    this.dragReadyEnd = function(e) {
        this.editor.renderer.$cursorLayer.setBlinking(!this.editor.getReadOnly());
        this.editor.unsetStyle("ace_dragging");
        this.editor.renderer.setCursorStyle("");
        this.dragWaitEnd();
    };

    this.startDrag = function(){
        this.cancelDrag = false;
        var editor = this.editor;
        var target = editor.container;
        target.draggable = true;
        editor.renderer.$cursorLayer.setBlinking(false);
        editor.setStyle("ace_dragging");
        var cursorStyle = useragent.isWin ? "default" : "move";
        editor.renderer.setCursorStyle(cursorStyle);
        this.setState("dragReady");
    };

    this.onMouseDrag = function(e) {
        var target = this.editor.container;
        if (useragent.isIE && this.state == "dragReady") {
            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
            if (distance > 3)
                target.dragDrop();
        }
        if (this.state === "dragWait") {
            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
            if (distance > 0) {
                target.draggable = false;
                this.startSelect(this.mousedownEvent.getDocumentPosition());
            }
        }
    };

    this.onMouseDown = function(e) {
        if (!this.$dragEnabled)
            return;
        this.mousedownEvent = e;
        var editor = this.editor;

        var inSelection = e.inSelection();
        var button = e.getButton();
        var clickCount = e.domEvent.detail || 1;
        if (clickCount === 1 && button === 0 && inSelection) {
            if (e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey()))
                return;
            this.mousedownEvent.time = Date.now();
            var eventTarget = e.domEvent.target || e.domEvent.srcElement;
            if ("unselectable" in eventTarget)
                eventTarget.unselectable = "on";
            if (editor.getDragDelay()) {
                if (useragent.isWebKit) {
                    this.cancelDrag = true;
                    var mouseTarget = editor.container;
                    mouseTarget.draggable = true;
                }
                this.setState("dragWait");
            } else {
                this.startDrag();
            }
            this.captureMouse(e, this.onMouseDrag.bind(this));
            e.defaultPrevented = true;
        }
    };

}).call(DragdropHandler.prototype);


function calcDistance(ax, ay, bx, by) {
    return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
}

exports.DragdropHandler = DragdropHandler;

});

ace.define("ace/lib/net",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";
var dom = acequire("./dom");

exports.get = function (url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            callback(xhr.responseText);
        }
    };
    xhr.send(null);
};

exports.loadScript = function(path, callback) {
    var head = dom.getDocumentHead();
    var s = document.createElement('script');

    s.src = path;
    head.appendChild(s);

    s.onload = s.onreadystatechange = function(_, isAbort) {
        if (isAbort || !s.readyState || s.readyState == "loaded" || s.readyState == "complete") {
            s = s.onload = s.onreadystatechange = null;
            if (!isAbort)
                callback();
        }
    };
};
exports.qualifyURL = function(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.href;
};

});

ace.define("ace/lib/event_emitter",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var EventEmitter = {};
var stopPropagation = function() { this.propagationStopped = true; };
var preventDefault = function() { this.defaultPrevented = true; };

EventEmitter._emit =
EventEmitter._dispatchEvent = function(eventName, e) {
    this._eventRegistry || (this._eventRegistry = {});
    this._defaultHandlers || (this._defaultHandlers = {});

    var listeners = this._eventRegistry[eventName] || [];
    var defaultHandler = this._defaultHandlers[eventName];
    if (!listeners.length && !defaultHandler)
        return;

    if (typeof e != "object" || !e)
        e = {};

    if (!e.type)
        e.type = eventName;
    if (!e.stopPropagation)
        e.stopPropagation = stopPropagation;
    if (!e.preventDefault)
        e.preventDefault = preventDefault;

    listeners = listeners.slice();
    for (var i=0; i<listeners.length; i++) {
        listeners[i](e, this);
        if (e.propagationStopped)
            break;
    }
    
    if (defaultHandler && !e.defaultPrevented)
        return defaultHandler(e, this);
};


EventEmitter._signal = function(eventName, e) {
    var listeners = (this._eventRegistry || {})[eventName];
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i=0; i<listeners.length; i++)
        listeners[i](e, this);
};

EventEmitter.once = function(eventName, callback) {
    var _self = this;
    callback && this.addEventListener(eventName, function newCallback() {
        _self.removeEventListener(eventName, newCallback);
        callback.apply(null, arguments);
    });
};


EventEmitter.setDefaultHandler = function(eventName, callback) {
    var handlers = this._defaultHandlers;
    if (!handlers)
        handlers = this._defaultHandlers = {_disabled_: {}};
    
    if (handlers[eventName]) {
        var old = handlers[eventName];
        var disabled = handlers._disabled_[eventName];
        if (!disabled)
            handlers._disabled_[eventName] = disabled = [];
        disabled.push(old);
        var i = disabled.indexOf(callback);
        if (i != -1) 
            disabled.splice(i, 1);
    }
    handlers[eventName] = callback;
};
EventEmitter.removeDefaultHandler = function(eventName, callback) {
    var handlers = this._defaultHandlers;
    if (!handlers)
        return;
    var disabled = handlers._disabled_[eventName];
    
    if (handlers[eventName] == callback) {
        var old = handlers[eventName];
        if (disabled)
            this.setDefaultHandler(eventName, disabled.pop());
    } else if (disabled) {
        var i = disabled.indexOf(callback);
        if (i != -1)
            disabled.splice(i, 1);
    }
};

EventEmitter.on =
EventEmitter.addEventListener = function(eventName, callback, capturing) {
    this._eventRegistry = this._eventRegistry || {};

    var listeners = this._eventRegistry[eventName];
    if (!listeners)
        listeners = this._eventRegistry[eventName] = [];

    if (listeners.indexOf(callback) == -1)
        listeners[capturing ? "unshift" : "push"](callback);
    return callback;
};

EventEmitter.off =
EventEmitter.removeListener =
EventEmitter.removeEventListener = function(eventName, callback) {
    this._eventRegistry = this._eventRegistry || {};

    var listeners = this._eventRegistry[eventName];
    if (!listeners)
        return;

    var index = listeners.indexOf(callback);
    if (index !== -1)
        listeners.splice(index, 1);
};

EventEmitter.removeAllListeners = function(eventName) {
    if (this._eventRegistry) this._eventRegistry[eventName] = [];
};

exports.EventEmitter = EventEmitter;

});

ace.define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
"no use strict";

var oop = acequire("./oop");
var EventEmitter = acequire("./event_emitter").EventEmitter;

var optionsProvider = {
    setOptions: function(optList) {
        Object.keys(optList).forEach(function(key) {
            this.setOption(key, optList[key]);
        }, this);
    },
    getOptions: function(optionNames) {
        var result = {};
        if (!optionNames) {
            optionNames = Object.keys(this.$options);
        } else if (!Array.isArray(optionNames)) {
            result = optionNames;
            optionNames = Object.keys(result);
        }
        optionNames.forEach(function(key) {
            result[key] = this.getOption(key);
        }, this);
        return result;
    },
    setOption: function(name, value) {
        if (this["$" + name] === value)
            return;
        var opt = this.$options[name];
        if (!opt) {
            return warn('misspelled option "' + name + '"');
        }
        if (opt.forwardTo)
            return this[opt.forwardTo] && this[opt.forwardTo].setOption(name, value);

        if (!opt.handlesSet)
            this["$" + name] = value;
        if (opt && opt.set)
            opt.set.call(this, value);
    },
    getOption: function(name) {
        var opt = this.$options[name];
        if (!opt) {
            return warn('misspelled option "' + name + '"');
        }
        if (opt.forwardTo)
            return this[opt.forwardTo] && this[opt.forwardTo].getOption(name);
        return opt && opt.get ? opt.get.call(this) : this["$" + name];
    }
};

function warn(message) {
    if (typeof console != "undefined" && console.warn)
        console.warn.apply(console, arguments);
}

function reportError(msg, data) {
    var e = new Error(msg);
    e.data = data;
    if (typeof console == "object" && console.error)
        console.error(e);
    setTimeout(function() { throw e; });
}

var AppConfig = function() {
    this.$defaultOptions = {};
};

(function() {
    oop.implement(this, EventEmitter);
    this.defineOptions = function(obj, path, options) {
        if (!obj.$options)
            this.$defaultOptions[path] = obj.$options = {};

        Object.keys(options).forEach(function(key) {
            var opt = options[key];
            if (typeof opt == "string")
                opt = {forwardTo: opt};

            opt.name || (opt.name = key);
            obj.$options[opt.name] = opt;
            if ("initialValue" in opt)
                obj["$" + opt.name] = opt.initialValue;
        });
        oop.implement(obj, optionsProvider);

        return this;
    };

    this.resetOptions = function(obj) {
        Object.keys(obj.$options).forEach(function(key) {
            var opt = obj.$options[key];
            if ("value" in opt)
                obj.setOption(key, opt.value);
        });
    };

    this.setDefaultValue = function(path, name, value) {
        var opts = this.$defaultOptions[path] || (this.$defaultOptions[path] = {});
        if (opts[name]) {
            if (opts.forwardTo)
                this.setDefaultValue(opts.forwardTo, name, value);
            else
                opts[name].value = value;
        }
    };

    this.setDefaultValues = function(path, optionHash) {
        Object.keys(optionHash).forEach(function(key) {
            this.setDefaultValue(path, key, optionHash[key]);
        }, this);
    };
    
    this.warn = warn;
    this.reportError = reportError;
    
}).call(AppConfig.prototype);

exports.AppConfig = AppConfig;

});

ace.define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/lib/net","ace/lib/app_config"], function(acequire, exports, module) {
"no use strict";

var lang = acequire("./lib/lang");
var oop = acequire("./lib/oop");
var net = acequire("./lib/net");
var AppConfig = acequire("./lib/app_config").AppConfig;

module.exports = exports = new AppConfig();

var global = (function() {
    return this || typeof window != "undefined" && window;
})();

var options = {
    packaged: false,
    workerPath: null,
    modePath: null,
    themePath: null,
    basePath: "",
    suffix: ".js",
    $moduleUrls: {}
};

exports.get = function(key) {
    if (!options.hasOwnProperty(key))
        throw new Error("Unknown config key: " + key);

    return options[key];
};

exports.set = function(key, value) {
    if (!options.hasOwnProperty(key))
        throw new Error("Unknown config key: " + key);

    options[key] = value;
};

exports.all = function() {
    return lang.copyObject(options);
};
exports.moduleUrl = function(name, component) {
    if (options.$moduleUrls[name])
        return options.$moduleUrls[name];

    var parts = name.split("/");
    component = component || parts[parts.length - 2] || "";
    var sep = component == "snippets" ? "/" : "-";
    var base = parts[parts.length - 1];
    if (component == "worker" && sep == "-") {
        var re = new RegExp("^" + component + "[\\-_]|[\\-_]" + component + "$", "g");
        base = base.replace(re, "");
    }

    if ((!base || base == component) && parts.length > 1)
        base = parts[parts.length - 2];
    var path = options[component + "Path"];
    if (path == null) {
        path = options.basePath;
    } else if (sep == "/") {
        component = sep = "";
    }
    if (path && path.slice(-1) != "/")
        path += "/";
    return path + component + sep + base + this.get("suffix");
};

exports.setModuleUrl = function(name, subst) {
    return options.$moduleUrls[name] = subst;
};

exports.$loading = {};
exports.loadModule = function(moduleName, onLoad) {
    var module, moduleType;
    if (Array.isArray(moduleName)) {
        moduleType = moduleName[0];
        moduleName = moduleName[1];
    }

    try {
        module = acequire(moduleName);
    } catch (e) {}
    if (module && !exports.$loading[moduleName])
        return onLoad && onLoad(module);

    if (!exports.$loading[moduleName])
        exports.$loading[moduleName] = [];

    exports.$loading[moduleName].push(onLoad);

    if (exports.$loading[moduleName].length > 1)
        return;

    var afterLoad = function() {
        acequire([moduleName], function(module) {
            exports._emit("load.module", {name: moduleName, module: module});
            var listeners = exports.$loading[moduleName];
            exports.$loading[moduleName] = null;
            listeners.forEach(function(onLoad) {
                onLoad && onLoad(module);
            });
        });
    };

    if (!exports.get("packaged"))
        return afterLoad();
    net.loadScript(exports.moduleUrl(moduleName, moduleType), afterLoad);
};
init(true);function init(packaged) {

    if (!global || !global.document)
        return;
    
    options.packaged = packaged || acequire.packaged || module.packaged || (global.define && __webpack_require__(233).packaged);

    var scriptOptions = {};
    var scriptUrl = "";
    var currentScript = (document.currentScript || document._currentScript ); // native or polyfill
    var currentDocument = currentScript && currentScript.ownerDocument || document;
    
    var scripts = currentDocument.getElementsByTagName("script");
    for (var i=0; i<scripts.length; i++) {
        var script = scripts[i];

        var src = script.src || script.getAttribute("src");
        if (!src)
            continue;

        var attributes = script.attributes;
        for (var j=0, l=attributes.length; j < l; j++) {
            var attr = attributes[j];
            if (attr.name.indexOf("data-ace-") === 0) {
                scriptOptions[deHyphenate(attr.name.replace(/^data-ace-/, ""))] = attr.value;
            }
        }

        var m = src.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);
        if (m)
            scriptUrl = m[1];
    }

    if (scriptUrl) {
        scriptOptions.base = scriptOptions.base || scriptUrl;
        scriptOptions.packaged = true;
    }

    scriptOptions.basePath = scriptOptions.base;
    scriptOptions.workerPath = scriptOptions.workerPath || scriptOptions.base;
    scriptOptions.modePath = scriptOptions.modePath || scriptOptions.base;
    scriptOptions.themePath = scriptOptions.themePath || scriptOptions.base;
    delete scriptOptions.base;

    for (var key in scriptOptions)
        if (typeof scriptOptions[key] !== "undefined")
            exports.set(key, scriptOptions[key]);
}

exports.init = init;

function deHyphenate(str) {
    return str.replace(/-(.)/g, function(m, m1) { return m1.toUpperCase(); });
}

});

ace.define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/config"], function(acequire, exports, module) {
"use strict";

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
var DefaultHandlers = acequire("./default_handlers").DefaultHandlers;
var DefaultGutterHandler = acequire("./default_gutter_handler").GutterHandler;
var MouseEvent = acequire("./mouse_event").MouseEvent;
var DragdropHandler = acequire("./dragdrop_handler").DragdropHandler;
var config = acequire("../config");

var MouseHandler = function(editor) {
    var _self = this;
    this.editor = editor;

    new DefaultHandlers(this);
    new DefaultGutterHandler(this);
    new DragdropHandler(this);

    var focusEditor = function(e) {
        var windowBlurred = !document.hasFocus || !document.hasFocus()
            || !editor.isFocused() && document.activeElement == (editor.textInput && editor.textInput.getElement());
        if (windowBlurred)
            window.focus();
        editor.focus();
    };

    var mouseTarget = editor.renderer.getMouseEventTarget();
    event.addListener(mouseTarget, "click", this.onMouseEvent.bind(this, "click"));
    event.addListener(mouseTarget, "mousemove", this.onMouseMove.bind(this, "mousemove"));
    event.addMultiMouseDownListener([
        mouseTarget,
        editor.renderer.scrollBarV && editor.renderer.scrollBarV.inner,
        editor.renderer.scrollBarH && editor.renderer.scrollBarH.inner,
        editor.textInput && editor.textInput.getElement()
    ].filter(Boolean), [400, 300, 250], this, "onMouseEvent");
    event.addMouseWheelListener(editor.container, this.onMouseWheel.bind(this, "mousewheel"));
    event.addTouchMoveListener(editor.container, this.onTouchMove.bind(this, "touchmove"));

    var gutterEl = editor.renderer.$gutter;
    event.addListener(gutterEl, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"));
    event.addListener(gutterEl, "click", this.onMouseEvent.bind(this, "gutterclick"));
    event.addListener(gutterEl, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"));
    event.addListener(gutterEl, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"));

    event.addListener(mouseTarget, "mousedown", focusEditor);
    event.addListener(gutterEl, "mousedown", focusEditor);
    if (useragent.isIE && editor.renderer.scrollBarV) {
        event.addListener(editor.renderer.scrollBarV.element, "mousedown", focusEditor);
        event.addListener(editor.renderer.scrollBarH.element, "mousedown", focusEditor);
    }

    editor.on("mousemove", function(e){
        if (_self.state || _self.$dragDelay || !_self.$dragEnabled)
            return;

        var character = editor.renderer.screenToTextCoordinates(e.x, e.y);
        var range = editor.session.selection.getRange();
        var renderer = editor.renderer;

        if (!range.isEmpty() && range.insideStart(character.row, character.column)) {
            renderer.setCursorStyle("default");
        } else {
            renderer.setCursorStyle("");
        }
    });
};

(function() {
    this.onMouseEvent = function(name, e) {
        this.editor._emit(name, new MouseEvent(e, this.editor));
    };

    this.onMouseMove = function(name, e) {
        var listeners = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
        if (!listeners || !listeners.length)
            return;

        this.editor._emit(name, new MouseEvent(e, this.editor));
    };

    this.onMouseWheel = function(name, e) {
        var mouseEvent = new MouseEvent(e, this.editor);
        mouseEvent.speed = this.$scrollSpeed * 2;
        mouseEvent.wheelX = e.wheelX;
        mouseEvent.wheelY = e.wheelY;

        this.editor._emit(name, mouseEvent);
    };
    
    this.onTouchMove = function (name, e) {
        var mouseEvent = new MouseEvent(e, this.editor);
        mouseEvent.speed = 1;//this.$scrollSpeed * 2;
        mouseEvent.wheelX = e.wheelX;
        mouseEvent.wheelY = e.wheelY;
        this.editor._emit(name, mouseEvent);
    };

    this.setState = function(state) {
        this.state = state;
    };

    this.captureMouse = function(ev, mouseMoveHandler) {
        this.x = ev.x;
        this.y = ev.y;

        this.isMousePressed = true;
        var renderer = this.editor.renderer;
        if (renderer.$keepTextAreaAtCursor)
            renderer.$keepTextAreaAtCursor = null;

        var self = this;
        var onMouseMove = function(e) {
            if (!e) return;
            if (useragent.isWebKit && !e.which && self.releaseMouse)
                return self.releaseMouse();

            self.x = e.clientX;
            self.y = e.clientY;
            mouseMoveHandler && mouseMoveHandler(e);
            self.mouseEvent = new MouseEvent(e, self.editor);
            self.$mouseMoved = true;
        };

        var onCaptureEnd = function(e) {
            clearInterval(timerId);
            onCaptureInterval();
            self[self.state + "End"] && self[self.state + "End"](e);
            self.state = "";
            if (renderer.$keepTextAreaAtCursor == null) {
                renderer.$keepTextAreaAtCursor = true;
                renderer.$moveTextAreaToCursor();
            }
            self.isMousePressed = false;
            self.$onCaptureMouseMove = self.releaseMouse = null;
            e && self.onMouseEvent("mouseup", e);
        };

        var onCaptureInterval = function() {
            self[self.state] && self[self.state]();
            self.$mouseMoved = false;
        };

        if (useragent.isOldIE && ev.domEvent.type == "dblclick") {
            return setTimeout(function() {onCaptureEnd(ev);});
        }

        self.$onCaptureMouseMove = onMouseMove;
        self.releaseMouse = event.capture(this.editor.container, onMouseMove, onCaptureEnd);
        var timerId = setInterval(onCaptureInterval, 20);
    };
    this.releaseMouse = null;
    this.cancelContextMenu = function() {
        var stop = function(e) {
            if (e && e.domEvent && e.domEvent.type != "contextmenu")
                return;
            this.editor.off("nativecontextmenu", stop);
            if (e && e.domEvent)
                event.stopEvent(e.domEvent);
        }.bind(this);
        setTimeout(stop, 10);
        this.editor.on("nativecontextmenu", stop);
    };
}).call(MouseHandler.prototype);

config.defineOptions(MouseHandler.prototype, "mouseHandler", {
    scrollSpeed: {initialValue: 2},
    dragDelay: {initialValue: (useragent.isMac ? 150 : 0)},
    dragEnabled: {initialValue: true},
    focusTimout: {initialValue: 0},
    tooltipFollowsMouse: {initialValue: true}
});


exports.MouseHandler = MouseHandler;
});

ace.define("ace/mouse/fold_handler",["require","exports","module"], function(acequire, exports, module) {
"use strict";

function FoldHandler(editor) {

    editor.on("click", function(e) {
        var position = e.getDocumentPosition();
        var session = editor.session;
        var fold = session.getFoldAt(position.row, position.column, 1);
        if (fold) {
            if (e.getAccelKey())
                session.removeFold(fold);
            else
                session.expandFold(fold);

            e.stop();
        }
    });

    editor.on("gutterclick", function(e) {
        var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);

        if (gutterRegion == "foldWidgets") {
            var row = e.getDocumentPosition().row;
            var session = editor.session;
            if (session.foldWidgets && session.foldWidgets[row])
                editor.session.onFoldWidgetClick(row, e);
            if (!editor.isFocused())
                editor.focus();
            e.stop();
        }
    });

    editor.on("gutterdblclick", function(e) {
        var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);

        if (gutterRegion == "foldWidgets") {
            var row = e.getDocumentPosition().row;
            var session = editor.session;
            var data = session.getParentFoldRangeData(row, true);
            var range = data.range || data.firstRange;

            if (range) {
                row = range.start.row;
                var fold = session.getFoldAt(row, session.getLine(row).length, 1);

                if (fold) {
                    session.removeFold(fold);
                } else {
                    session.addFold("...", range);
                    editor.renderer.scrollCursorIntoView({row: range.start.row, column: 0});
                }
            }
            e.stop();
        }
    });
}

exports.FoldHandler = FoldHandler;

});

ace.define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"], function(acequire, exports, module) {
"use strict";

var keyUtil  = acequire("../lib/keys");
var event = acequire("../lib/event");

var KeyBinding = function(editor) {
    this.$editor = editor;
    this.$data = {editor: editor};
    this.$handlers = [];
    this.setDefaultHandler(editor.commands);
};

(function() {
    this.setDefaultHandler = function(kb) {
        this.removeKeyboardHandler(this.$defaultHandler);
        this.$defaultHandler = kb;
        this.addKeyboardHandler(kb, 0);
    };

    this.setKeyboardHandler = function(kb) {
        var h = this.$handlers;
        if (h[h.length - 1] == kb)
            return;

        while (h[h.length - 1] && h[h.length - 1] != this.$defaultHandler)
            this.removeKeyboardHandler(h[h.length - 1]);

        this.addKeyboardHandler(kb, 1);
    };

    this.addKeyboardHandler = function(kb, pos) {
        if (!kb)
            return;
        if (typeof kb == "function" && !kb.handleKeyboard)
            kb.handleKeyboard = kb;
        var i = this.$handlers.indexOf(kb);
        if (i != -1)
            this.$handlers.splice(i, 1);

        if (pos == undefined)
            this.$handlers.push(kb);
        else
            this.$handlers.splice(pos, 0, kb);

        if (i == -1 && kb.attach)
            kb.attach(this.$editor);
    };

    this.removeKeyboardHandler = function(kb) {
        var i = this.$handlers.indexOf(kb);
        if (i == -1)
            return false;
        this.$handlers.splice(i, 1);
        kb.detach && kb.detach(this.$editor);
        return true;
    };

    this.getKeyboardHandler = function() {
        return this.$handlers[this.$handlers.length - 1];
    };
    
    this.getStatusText = function() {
        var data = this.$data;
        var editor = data.editor;
        return this.$handlers.map(function(h) {
            return h.getStatusText && h.getStatusText(editor, data) || "";
        }).filter(Boolean).join(" ");
    };

    this.$callKeyboardHandlers = function(hashId, keyString, keyCode, e) {
        var toExecute;
        var success = false;
        var commands = this.$editor.commands;

        for (var i = this.$handlers.length; i--;) {
            toExecute = this.$handlers[i].handleKeyboard(
                this.$data, hashId, keyString, keyCode, e
            );
            if (!toExecute || !toExecute.command)
                continue;
            if (toExecute.command == "null") {
                success = true;
            } else {
                success = commands.exec(toExecute.command, this.$editor, toExecute.args, e);
            }
            if (success && e && hashId != -1 && 
                toExecute.passEvent != true && toExecute.command.passEvent != true
            ) {
                event.stopEvent(e);
            }
            if (success)
                break;
        }
        
        if (!success && hashId == -1) {
            toExecute = {command: "insertstring"};
            success = commands.exec("insertstring", this.$editor, keyString);
        }
        
        if (success && this.$editor._signal)
            this.$editor._signal("keyboardActivity", toExecute);
        
        return success;
    };

    this.onCommandKey = function(e, hashId, keyCode) {
        var keyString = keyUtil.keyCodeToString(keyCode);
        this.$callKeyboardHandlers(hashId, keyString, keyCode, e);
    };

    this.onTextInput = function(text) {
        this.$callKeyboardHandlers(-1, text);
    };

}).call(KeyBinding.prototype);

exports.KeyBinding = KeyBinding;
});

ace.define("ace/lib/bidiutil",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var ArabicAlefBetIntervalsBegine = ['\u0621', '\u0641'];
var ArabicAlefBetIntervalsEnd = ['\u063A', '\u064a'];
var dir = 0, hiLevel = 0;
var lastArabic = false, hasUBAT_AL = false,  hasUBAT_B = false,  hasUBAT_S = false, hasBlockSep = false, hasSegSep = false;

var impTab_LTR = [	[	0,		3,		0,		1,		0,		0,		0	],	[	0,		3,		0,		1,		2,		2,		0	],	[	0,		3,		0,		0x11,		2,		0,		1	],	[	0,		3,		5,		5,		4,		1,		0	],	[	0,		3,		0x15,		0x15,		4,		0,		1	],	[	0,		3,		5,		5,		4,		2,		0	]
];

var impTab_RTL = [	[	2,		0,		1,		1,		0,		1,		0	],	[	2,		0,		1,		1,		0,		2,		0	],	[	2,		0,		2,		1,		3,		2,		0	],	[	2,		0,		2,		0x21,		3,		1,		1	]
];

var LTR = 0, RTL = 1;

var L = 0;
var R = 1;
var EN = 2;
var AN = 3;
var ON = 4;
var B = 5;
var S = 6;
var AL = 7;
var WS = 8;
var CS = 9;
var ES = 10;
var ET = 11;
var NSM = 12;
var LRE = 13;
var RLE = 14;
var PDF = 15;
var LRO = 16;
var RLO = 17;
var BN = 18;

var UnicodeTBL00 = [
BN,BN,BN,BN,BN,BN,BN,BN,BN,S,B,S,WS,B,BN,BN,
BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,B,B,B,S,
WS,ON,ON,ET,ET,ET,ON,ON,ON,ON,ON,ES,CS,ES,CS,CS,
EN,EN,EN,EN,EN,EN,EN,EN,EN,EN,CS,ON,ON,ON,ON,ON,
ON,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,
L,L,L,L,L,L,L,L,L,L,L,ON,ON,ON,ON,ON,
ON,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,
L,L,L,L,L,L,L,L,L,L,L,ON,ON,ON,ON,BN,
BN,BN,BN,BN,BN,B,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,
BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,BN,
CS,ON,ET,ET,ET,ET,ON,ON,ON,ON,L,ON,ON,BN,ON,ON,
ET,ET,EN,EN,ON,L,ON,ON,ON,EN,L,ON,ON,ON,ON,ON
];

var UnicodeTBL20 = [
WS,WS,WS,WS,WS,WS,WS,WS,WS,WS,WS,BN,BN,BN,L,R	,
ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,
ON,ON,ON,ON,ON,ON,ON,ON,WS,B,LRE,RLE,PDF,LRO,RLO,CS,
ET,ET,ET,ET,ET,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,
ON,ON,ON,ON,CS,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,
ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,ON,WS
];

function _computeLevels(chars, levels, len, charTypes) {
	var impTab = dir ? impTab_RTL : impTab_LTR
		, prevState = null, newClass = null, newLevel = null, newState = 0
		, action = null, cond = null, condPos = -1, i = null, ix = null, classes = [];

	if (!charTypes) {
		for (i = 0, charTypes = []; i < len; i++) {
			charTypes[i] = _getCharacterType(chars[i]);
		}
	}
	hiLevel = dir;
	lastArabic = false;
	hasUBAT_AL = false;
	hasUBAT_B = false;
	hasUBAT_S = false;
	for (ix = 0; ix < len; ix++){
		prevState = newState;
		classes[ix] = newClass = _getCharClass(chars, charTypes, classes, ix);
		newState = impTab[prevState][newClass];
		action = newState & 0xF0;
		newState &= 0x0F;
		levels[ix] = newLevel = impTab[newState][5];
		if (action > 0){
			if (action == 0x10){
				for(i = condPos; i < ix; i++){
					levels[i] = 1;
				}
				condPos = -1;
			} else {
				condPos = -1;
			}
		}
		cond = impTab[newState][6];
		if (cond){
			if(condPos == -1){
				condPos = ix;
			}
		}else{
			if (condPos > -1){
				for(i = condPos; i < ix; i++){
					levels[i] = newLevel;
				}
				condPos = -1;
			}
		}
		if (charTypes[ix] == B){
			levels[ix] = 0;
		}
		hiLevel |= newLevel;
	}
	if (hasUBAT_S){
		for(i = 0; i < len; i++){
			if(charTypes[i] == S){
				levels[i] = dir;
				for(var j = i - 1; j >= 0; j--){
					if(charTypes[j] == WS){
						levels[j] = dir;
					}else{
						break;
					}
				}
			}
		}
	}
}

function _invertLevel(lev, levels, _array) {
	if (hiLevel < lev){
		return;
	}
	if (lev == 1 && dir == RTL && !hasUBAT_B){
		_array.reverse();
		return;
	}
	var len = _array.length, start = 0, end, lo, hi, tmp;
	while(start < len){
		if (levels[start] >= lev){
			end = start + 1;
		while(end < len && levels[end] >= lev){
			end++;
		}
		for(lo = start, hi = end - 1 ; lo < hi; lo++, hi--){
			tmp = _array[lo];
			_array[lo] = _array[hi];
			_array[hi] = tmp;
		}
		start = end;
	}
	start++;
	}
}

function _getCharClass(chars, types, classes, ix) {
	var cType = types[ix], wType, nType, len, i;
	switch(cType){
		case L:
		case R:
			lastArabic = false;
		case ON:
		case AN:
			return cType;
		case EN:
			return lastArabic ? AN : EN;
		case AL:
			lastArabic = true;
			hasUBAT_AL = true;
			return R;
		case WS:
			return ON;
		case CS:
			if (ix < 1 || (ix + 1) >= types.length ||
				((wType = classes[ix - 1]) != EN && wType != AN) ||
				((nType = types[ix + 1]) != EN && nType != AN)){
				return ON;
			}
			if (lastArabic){nType = AN;}
			return nType == wType ? nType : ON;
		case ES:
			wType = ix > 0 ? classes[ix - 1] : B;
			if (wType == EN && (ix + 1) < types.length && types[ix + 1] == EN){
				return EN;
			}
			return ON;
		case ET:
			if (ix > 0 && classes[ix - 1] == EN){
				return EN;
			}
			if (lastArabic){
				return ON;
			}
			i = ix + 1;
			len = types.length;
			while (i < len && types[i] == ET){
				i++;
			}
			if (i < len && types[i] == EN){
				return EN;
			}
			return ON;
		case NSM:
			len = types.length;
			i = ix + 1;
			while (i < len && types[i] == NSM){
				i++;
			}
			if (i < len){
				var c = chars[ix], rtlCandidate = (c >= 0x0591 && c <= 0x08FF) || c == 0xFB1E;

				wType = types[i];
				if (rtlCandidate && (wType == R || wType == AL)){
					return R;
				}
			}

			if (ix < 1 || (wType = types[ix - 1]) == B){
				return ON;
			}
			return classes[ix - 1];
		case B:
			lastArabic = false;
			hasUBAT_B = true;
			return dir;
		case S:
			hasUBAT_S = true;
			return ON;
		case LRE:
		case RLE:
		case LRO:
		case RLO:
		case PDF:
			lastArabic = false;
		case BN:
			return ON;
	}
}

function _getCharacterType( ch ) {
	var uc = ch.charCodeAt(0), hi = uc >> 8;

	if (hi == 0) {
		return ((uc > 0x00BF) ? L : UnicodeTBL00[uc]);
	} else if (hi == 5) {
		return (/[\u0591-\u05f4]/.test(ch) ? R : L);
	} else if (hi == 6) {
		if (/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(ch))
			return NSM;
		else if (/[\u0660-\u0669\u066b-\u066c]/.test(ch))
			return AN;
		else if (uc == 0x066A)
			return ET;
		else if (/[\u06f0-\u06f9]/.test(ch))
			return EN;
		else
			return AL;
	} else if (hi == 0x20 && uc <= 0x205F) {
		return UnicodeTBL20[uc & 0xFF];
	} else if (hi == 0xFE) {
		return (uc >= 0xFE70 ? AL : ON);
	}
	return ON;
}

function _isArabicDiacritics( ch ) {
	return (ch >= '\u064b' && ch <= '\u0655');
}
exports.L = L;
exports.R = R;
exports.EN = EN;
exports.ON_R = 3;
exports.AN = 4;
exports.R_H = 5;
exports.B = 6;

exports.DOT = "\xB7";
exports.doBidiReorder = function(text, textCharTypes, isRtl) {
	if (text.length < 2)
		return {};

	var chars = text.split(""), logicalFromVisual = new Array(chars.length),
		bidiLevels = new Array(chars.length), levels = [];

	dir = isRtl ? RTL : LTR;

	_computeLevels(chars, levels, chars.length, textCharTypes);

	for (var i = 0; i < logicalFromVisual.length; logicalFromVisual[i] = i, i++);

	_invertLevel(2, levels, logicalFromVisual);
	_invertLevel(1, levels, logicalFromVisual);

	for (var i = 0; i < logicalFromVisual.length - 1; i++) { //fix levels to reflect character width
		if (textCharTypes[i] === AN) {
			levels[i] = exports.AN;
		} else if (levels[i] === R && ((textCharTypes[i] > AL && textCharTypes[i] < LRE)
			|| textCharTypes[i] === ON || textCharTypes[i] === BN)) {
			levels[i] = exports.ON_R;
		} else if ((i > 0 && chars[i - 1] === '\u0644') && /\u0622|\u0623|\u0625|\u0627/.test(chars[i])) {
			levels[i - 1] = levels[i] = exports.R_H;
			i++;
		}
	}
	if (chars[chars.length - 1] === exports.DOT)
		levels[chars.length - 1] = exports.B;

	for (var i = 0; i < logicalFromVisual.length; i++) {
		bidiLevels[i] = levels[logicalFromVisual[i]];
	}

	return {'logicalFromVisual': logicalFromVisual, 'bidiLevels': bidiLevels};
};
exports.hasBidiCharacters = function(text, textCharTypes){
	var ret = false;
	for (var i = 0; i < text.length; i++){
		textCharTypes[i] = _getCharacterType(text.charAt(i));
		if (!ret && (textCharTypes[i] == R || textCharTypes[i] == AL))
			ret = true;
	}
	return ret;
};
exports.getVisualFromLogicalIdx = function(logIdx, rowMap) {
	for (var i = 0; i < rowMap.logicalFromVisual.length; i++) {
		if (rowMap.logicalFromVisual[i] == logIdx)
			return i;
	}
	return 0;
};

});

ace.define("ace/bidihandler",["require","exports","module","ace/lib/bidiutil","ace/lib/lang","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var bidiUtil = acequire("./lib/bidiutil");
var lang = acequire("./lib/lang");
var useragent = acequire("./lib/useragent");
var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
var BidiHandler = function(session) {
    this.session = session;
    this.bidiMap = {};
    this.currentRow = null;
    this.bidiUtil = bidiUtil;
    this.charWidths = [];
    this.EOL = "\xAC";
    this.showInvisibles = true;
    this.isRtlDir = false;
    this.line = "";
    this.wrapIndent = 0;
    this.isLastRow = false;
    this.EOF = "\xB6";
    this.seenBidi = false;
};

(function() {
    this.isBidiRow = function(screenRow, docRow, splitIndex) {
        if (!this.seenBidi)
            return false;
        if (screenRow !== this.currentRow) {
            this.currentRow = screenRow;
            this.updateRowLine(docRow, splitIndex);
            this.updateBidiMap();
        }
        return this.bidiMap.bidiLevels;
    };

    this.onChange = function(delta) {
        if (!this.seenBidi) {
            if (delta.action == "insert" && bidiRE.test(delta.lines.join("\n"))) {
                this.seenBidi = true;
                this.currentRow = null;
            }
        }
        else {
            this.currentRow = null;
        }
    };

    this.getDocumentRow = function() {
        var docRow = 0;
        var rowCache = this.session.$screenRowCache;
        if (rowCache.length) {
            var index = this.session.$getRowCacheIndex(rowCache, this.currentRow);
            if (index >= 0)
                docRow = this.session.$docRowCache[index];
        }

        return docRow;
    };

    this.getSplitIndex = function() {
        var splitIndex = 0;
        var rowCache = this.session.$screenRowCache;
        if (rowCache.length) {
            var currentIndex, prevIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow);
            while (this.currentRow - splitIndex > 0) {
                currentIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow - splitIndex - 1);
                if (currentIndex !== prevIndex)
                    break;

                prevIndex = currentIndex;
                splitIndex++;
            }
        }

        return splitIndex;
    };

    this.updateRowLine = function(docRow, splitIndex) {
        if (docRow === undefined)
            docRow = this.getDocumentRow();

        this.wrapIndent = 0;
        this.isLastRow = (docRow === this.session.getLength() - 1);
        this.line = this.session.getLine(docRow);
        if (this.session.$useWrapMode) {
            var splits = this.session.$wrapData[docRow];
            if (splits) {
                if (splitIndex === undefined)
                    splitIndex = this.getSplitIndex();

                if(splitIndex > 0 && splits.length) {
                    this.wrapIndent = splits.indent;
                    this.line = (splitIndex < splits.length) ?
                        this.line.substring(splits[splitIndex - 1], splits[splits.length - 1]) :
                            this.line.substring(splits[splits.length - 1]);
                } else {
                    this.line = this.line.substring(0, splits[splitIndex]);
                }
            }
        }
        var session = this.session, shift = 0, size;
        this.line = this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function(ch, i){
            if (ch === '\t' || session.isFullWidth(ch.charCodeAt(0))) {
                size = (ch === '\t') ? session.getScreenTabSize(i + shift) : 2;
                shift += size - 1;
                return lang.stringRepeat(bidiUtil.DOT, size);
            }
            return ch;
        });
    };

    this.updateBidiMap = function() {
        var textCharTypes = [], endOfLine = this.isLastRow ? this.EOF : this.EOL;
        var line = this.line + (this.showInvisibles ? endOfLine : bidiUtil.DOT);
        if (bidiUtil.hasBidiCharacters(line, textCharTypes)) {
            this.bidiMap = bidiUtil.doBidiReorder(line, textCharTypes, this.isRtlDir);
        } else {
            this.bidiMap = {};
        }
    };
    this.markAsDirty = function() {
        this.currentRow = null;
    };
    this.updateCharacterWidths = function(fontMetrics) {
        if (!this.seenBidi)
            return;
        if (this.characterWidth === fontMetrics.$characterSize.width)
            return;

        var characterWidth = this.characterWidth = fontMetrics.$characterSize.width;
        var bidiCharWidth = fontMetrics.$measureCharWidth("\u05d4");

        this.charWidths[bidiUtil.L] = this.charWidths[bidiUtil.EN] = this.charWidths[bidiUtil.ON_R] = characterWidth;
        this.charWidths[bidiUtil.R] = this.charWidths[bidiUtil.AN] = bidiCharWidth;
        this.charWidths[bidiUtil.R_H] = useragent.isChrome ? bidiCharWidth : bidiCharWidth * 0.45;
        this.charWidths[bidiUtil.B] = 0;

        this.currentRow = null;
    };

    this.getShowInvisibles = function() {
        return this.showInvisibles;
    };

    this.setShowInvisibles = function(showInvisibles) {
        this.showInvisibles = showInvisibles;
        this.currentRow = null;
    };

    this.setEolChar = function(eolChar) {
        this.EOL = eolChar;
    };

    this.setTextDir = function(isRtlDir) {
        this.isRtlDir = isRtlDir;
    };
    this.getPosLeft = function(col) {
        col -= this.wrapIndent;
        var visualIdx = bidiUtil.getVisualFromLogicalIdx(col > 0 ? col - 1 : 0, this.bidiMap),
            levels = this.bidiMap.bidiLevels, left = 0;

        if (col === 0 && levels[visualIdx] % 2 !== 0)
            visualIdx++;

        for (var i = 0; i < visualIdx; i++) {
            left += this.charWidths[levels[i]];
        }

        if (col !== 0 && levels[visualIdx] % 2 === 0)
            left += this.charWidths[levels[visualIdx]];

        if (this.wrapIndent)
            left += this.wrapIndent * this.charWidths[bidiUtil.L];

        return left;
    };
    this.getSelections = function(startCol, endCol) {
        var map = this.bidiMap, levels = map.bidiLevels, level, offset = this.wrapIndent * this.charWidths[bidiUtil.L], selections = [],
            selColMin = Math.min(startCol, endCol) - this.wrapIndent, selColMax = Math.max(startCol, endCol) - this.wrapIndent,
                isSelected = false, isSelectedPrev = false, selectionStart = 0;

        for (var logIdx, visIdx = 0; visIdx < levels.length; visIdx++) {
            logIdx = map.logicalFromVisual[visIdx];
            level = levels[visIdx];
            isSelected = (logIdx >= selColMin) && (logIdx < selColMax);
            if (isSelected && !isSelectedPrev) {
                selectionStart = offset;
            } else if (!isSelected && isSelectedPrev) {
                selections.push({left: selectionStart, width: offset - selectionStart});
            }
            offset += this.charWidths[level];
            isSelectedPrev = isSelected;
        }

        if (isSelected && (visIdx === levels.length)) {
            selections.push({left: selectionStart, width: offset - selectionStart});
        }

        return selections;
    };
    this.offsetToCol = function(posX) {
        var logicalIdx = 0, posX = Math.max(posX, 0),
            offset = 0, visualIdx = 0, levels = this.bidiMap.bidiLevels,
                charWidth = this.charWidths[levels[visualIdx]];

        if (this.wrapIndent) {
            posX -= this.wrapIndent * this.charWidths[bidiUtil.L];
        }

        while(posX > offset + charWidth/2) {
            offset += charWidth;
            if(visualIdx === levels.length - 1) {
                charWidth = 0;
                break;
            }
            charWidth = this.charWidths[levels[++visualIdx]];
        }

        if (visualIdx > 0 && (levels[visualIdx - 1] % 2 !== 0) && (levels[visualIdx] % 2 === 0)){
            if(posX < offset)
                visualIdx--;
            logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];

        } else if (visualIdx > 0 && (levels[visualIdx - 1] % 2 === 0) && (levels[visualIdx] % 2 !== 0)){
            logicalIdx = 1 + ((posX > offset) ? this.bidiMap.logicalFromVisual[visualIdx]
                    : this.bidiMap.logicalFromVisual[visualIdx - 1]);

        } else if ((this.isRtlDir && visualIdx === levels.length - 1 && charWidth === 0 && (levels[visualIdx - 1] % 2 === 0))
                || (!this.isRtlDir && visualIdx === 0 && (levels[visualIdx] % 2 !== 0))){
            logicalIdx = 1 + this.bidiMap.logicalFromVisual[visualIdx];
        } else {
            if (visualIdx > 0 && (levels[visualIdx - 1] % 2 !== 0) && charWidth !== 0)
                visualIdx--;
            logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
        }

        return (logicalIdx + this.wrapIndent);
    };

}).call(BidiHandler.prototype);

exports.BidiHandler = BidiHandler;
});

ace.define("ace/range",["require","exports","module"], function(acequire, exports, module) {
"use strict";
var comparePoints = function(p1, p2) {
    return p1.row - p2.row || p1.column - p2.column;
};
var Range = function(startRow, startColumn, endRow, endColumn) {
    this.start = {
        row: startRow,
        column: startColumn
    };

    this.end = {
        row: endRow,
        column: endColumn
    };
};

(function() {
    this.isEqual = function(range) {
        return this.start.row === range.start.row &&
            this.end.row === range.end.row &&
            this.start.column === range.start.column &&
            this.end.column === range.end.column;
    };
    this.toString = function() {
        return ("Range: [" + this.start.row + "/" + this.start.column +
            "] -> [" + this.end.row + "/" + this.end.column + "]");
    };

    this.contains = function(row, column) {
        return this.compare(row, column) == 0;
    };
    this.compareRange = function(range) {
        var cmp,
            end = range.end,
            start = range.start;

        cmp = this.compare(end.row, end.column);
        if (cmp == 1) {
            cmp = this.compare(start.row, start.column);
            if (cmp == 1) {
                return 2;
            } else if (cmp == 0) {
                return 1;
            } else {
                return 0;
            }
        } else if (cmp == -1) {
            return -2;
        } else {
            cmp = this.compare(start.row, start.column);
            if (cmp == -1) {
                return -1;
            } else if (cmp == 1) {
                return 42;
            } else {
                return 0;
            }
        }
    };
    this.comparePoint = function(p) {
        return this.compare(p.row, p.column);
    };
    this.containsRange = function(range) {
        return this.comparePoint(range.start) == 0 && this.comparePoint(range.end) == 0;
    };
    this.intersects = function(range) {
        var cmp = this.compareRange(range);
        return (cmp == -1 || cmp == 0 || cmp == 1);
    };
    this.isEnd = function(row, column) {
        return this.end.row == row && this.end.column == column;
    };
    this.isStart = function(row, column) {
        return this.start.row == row && this.start.column == column;
    };
    this.setStart = function(row, column) {
        if (typeof row == "object") {
            this.start.column = row.column;
            this.start.row = row.row;
        } else {
            this.start.row = row;
            this.start.column = column;
        }
    };
    this.setEnd = function(row, column) {
        if (typeof row == "object") {
            this.end.column = row.column;
            this.end.row = row.row;
        } else {
            this.end.row = row;
            this.end.column = column;
        }
    };
    this.inside = function(row, column) {
        if (this.compare(row, column) == 0) {
            if (this.isEnd(row, column) || this.isStart(row, column)) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    };
    this.insideStart = function(row, column) {
        if (this.compare(row, column) == 0) {
            if (this.isEnd(row, column)) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    };
    this.insideEnd = function(row, column) {
        if (this.compare(row, column) == 0) {
            if (this.isStart(row, column)) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    };
    this.compare = function(row, column) {
        if (!this.isMultiLine()) {
            if (row === this.start.row) {
                return column < this.start.column ? -1 : (column > this.end.column ? 1 : 0);
            }
        }

        if (row < this.start.row)
            return -1;

        if (row > this.end.row)
            return 1;

        if (this.start.row === row)
            return column >= this.start.column ? 0 : -1;

        if (this.end.row === row)
            return column <= this.end.column ? 0 : 1;

        return 0;
    };
    this.compareStart = function(row, column) {
        if (this.start.row == row && this.start.column == column) {
            return -1;
        } else {
            return this.compare(row, column);
        }
    };
    this.compareEnd = function(row, column) {
        if (this.end.row == row && this.end.column == column) {
            return 1;
        } else {
            return this.compare(row, column);
        }
    };
    this.compareInside = function(row, column) {
        if (this.end.row == row && this.end.column == column) {
            return 1;
        } else if (this.start.row == row && this.start.column == column) {
            return -1;
        } else {
            return this.compare(row, column);
        }
    };
    this.clipRows = function(firstRow, lastRow) {
        if (this.end.row > lastRow)
            var end = {row: lastRow + 1, column: 0};
        else if (this.end.row < firstRow)
            var end = {row: firstRow, column: 0};

        if (this.start.row > lastRow)
            var start = {row: lastRow + 1, column: 0};
        else if (this.start.row < firstRow)
            var start = {row: firstRow, column: 0};

        return Range.fromPoints(start || this.start, end || this.end);
    };
    this.extend = function(row, column) {
        var cmp = this.compare(row, column);

        if (cmp == 0)
            return this;
        else if (cmp == -1)
            var start = {row: row, column: column};
        else
            var end = {row: row, column: column};

        return Range.fromPoints(start || this.start, end || this.end);
    };

    this.isEmpty = function() {
        return (this.start.row === this.end.row && this.start.column === this.end.column);
    };
    this.isMultiLine = function() {
        return (this.start.row !== this.end.row);
    };
    this.clone = function() {
        return Range.fromPoints(this.start, this.end);
    };
    this.collapseRows = function() {
        if (this.end.column == 0)
            return new Range(this.start.row, 0, Math.max(this.start.row, this.end.row-1), 0);
        else
            return new Range(this.start.row, 0, this.end.row, 0);
    };
    this.toScreenRange = function(session) {
        var screenPosStart = session.documentToScreenPosition(this.start);
        var screenPosEnd = session.documentToScreenPosition(this.end);

        return new Range(
            screenPosStart.row, screenPosStart.column,
            screenPosEnd.row, screenPosEnd.column
        );
    };
    this.moveBy = function(row, column) {
        this.start.row += row;
        this.start.column += column;
        this.end.row += row;
        this.end.column += column;
    };

}).call(Range.prototype);
Range.fromPoints = function(start, end) {
    return new Range(start.row, start.column, end.row, end.column);
};
Range.comparePoints = comparePoints;

Range.comparePoints = function(p1, p2) {
    return p1.row - p2.row || p1.column - p2.column;
};


exports.Range = Range;
});

ace.define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var lang = acequire("./lib/lang");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var Range = acequire("./range").Range;
var Selection = function(session) {
    this.session = session;
    this.doc = session.getDocument();

    this.clearSelection();
    this.lead = this.selectionLead = this.doc.createAnchor(0, 0);
    this.anchor = this.selectionAnchor = this.doc.createAnchor(0, 0);

    var self = this;
    this.lead.on("change", function(e) {
        self._emit("changeCursor");
        if (!self.$isEmpty)
            self._emit("changeSelection");
        if (!self.$keepDesiredColumnOnChange && e.old.column != e.value.column)
            self.$desiredColumn = null;
    });

    this.selectionAnchor.on("change", function() {
        if (!self.$isEmpty)
            self._emit("changeSelection");
    });
};

(function() {

    oop.implement(this, EventEmitter);
    this.isEmpty = function() {
        return (this.$isEmpty || (
            this.anchor.row == this.lead.row &&
            this.anchor.column == this.lead.column
        ));
    };
    this.isMultiLine = function() {
        if (this.isEmpty()) {
            return false;
        }

        return this.getRange().isMultiLine();
    };
    this.getCursor = function() {
        return this.lead.getPosition();
    };
    this.setSelectionAnchor = function(row, column) {
        this.anchor.setPosition(row, column);

        if (this.$isEmpty) {
            this.$isEmpty = false;
            this._emit("changeSelection");
        }
    };
    this.getSelectionAnchor = function() {
        if (this.$isEmpty)
            return this.getSelectionLead();
        else
            return this.anchor.getPosition();
    };
    this.getSelectionLead = function() {
        return this.lead.getPosition();
    };
    this.shiftSelection = function(columns) {
        if (this.$isEmpty) {
            this.moveCursorTo(this.lead.row, this.lead.column + columns);
            return;
        }

        var anchor = this.getSelectionAnchor();
        var lead = this.getSelectionLead();

        var isBackwards = this.isBackwards();

        if (!isBackwards || anchor.column !== 0)
            this.setSelectionAnchor(anchor.row, anchor.column + columns);

        if (isBackwards || lead.column !== 0) {
            this.$moveSelection(function() {
                this.moveCursorTo(lead.row, lead.column + columns);
            });
        }
    };
    this.isBackwards = function() {
        var anchor = this.anchor;
        var lead = this.lead;
        return (anchor.row > lead.row || (anchor.row == lead.row && anchor.column > lead.column));
    };
    this.getRange = function() {
        var anchor = this.anchor;
        var lead = this.lead;

        if (this.isEmpty())
            return Range.fromPoints(lead, lead);

        if (this.isBackwards()) {
            return Range.fromPoints(lead, anchor);
        }
        else {
            return Range.fromPoints(anchor, lead);
        }
    };
    this.clearSelection = function() {
        if (!this.$isEmpty) {
            this.$isEmpty = true;
            this._emit("changeSelection");
        }
    };
    this.selectAll = function() {
        var lastRow = this.doc.getLength() - 1;
        this.setSelectionAnchor(0, 0);
        this.moveCursorTo(lastRow, this.doc.getLine(lastRow).length);
    };
    this.setRange =
    this.setSelectionRange = function(range, reverse) {
        if (reverse) {
            this.setSelectionAnchor(range.end.row, range.end.column);
            this.selectTo(range.start.row, range.start.column);
        } else {
            this.setSelectionAnchor(range.start.row, range.start.column);
            this.selectTo(range.end.row, range.end.column);
        }
        if (this.getRange().isEmpty())
            this.$isEmpty = true;
        this.$desiredColumn = null;
    };

    this.$moveSelection = function(mover) {
        var lead = this.lead;
        if (this.$isEmpty)
            this.setSelectionAnchor(lead.row, lead.column);

        mover.call(this);
    };
    this.selectTo = function(row, column) {
        this.$moveSelection(function() {
            this.moveCursorTo(row, column);
        });
    };
    this.selectToPosition = function(pos) {
        this.$moveSelection(function() {
            this.moveCursorToPosition(pos);
        });
    };
    this.moveTo = function(row, column) {
        this.clearSelection();
        this.moveCursorTo(row, column);
    };
    this.moveToPosition = function(pos) {
        this.clearSelection();
        this.moveCursorToPosition(pos);
    };
    this.selectUp = function() {
        this.$moveSelection(this.moveCursorUp);
    };
    this.selectDown = function() {
        this.$moveSelection(this.moveCursorDown);
    };
    this.selectRight = function() {
        this.$moveSelection(this.moveCursorRight);
    };
    this.selectLeft = function() {
        this.$moveSelection(this.moveCursorLeft);
    };
    this.selectLineStart = function() {
        this.$moveSelection(this.moveCursorLineStart);
    };
    this.selectLineEnd = function() {
        this.$moveSelection(this.moveCursorLineEnd);
    };
    this.selectFileEnd = function() {
        this.$moveSelection(this.moveCursorFileEnd);
    };
    this.selectFileStart = function() {
        this.$moveSelection(this.moveCursorFileStart);
    };
    this.selectWordRight = function() {
        this.$moveSelection(this.moveCursorWordRight);
    };
    this.selectWordLeft = function() {
        this.$moveSelection(this.moveCursorWordLeft);
    };
    this.getWordRange = function(row, column) {
        if (typeof column == "undefined") {
            var cursor = row || this.lead;
            row = cursor.row;
            column = cursor.column;
        }
        return this.session.getWordRange(row, column);
    };
    this.selectWord = function() {
        this.setSelectionRange(this.getWordRange());
    };
    this.selectAWord = function() {
        var cursor = this.getCursor();
        var range = this.session.getAWordRange(cursor.row, cursor.column);
        this.setSelectionRange(range);
    };

    this.getLineRange = function(row, excludeLastChar) {
        var rowStart = typeof row == "number" ? row : this.lead.row;
        var rowEnd;

        var foldLine = this.session.getFoldLine(rowStart);
        if (foldLine) {
            rowStart = foldLine.start.row;
            rowEnd = foldLine.end.row;
        } else {
            rowEnd = rowStart;
        }
        if (excludeLastChar === true)
            return new Range(rowStart, 0, rowEnd, this.session.getLine(rowEnd).length);
        else
            return new Range(rowStart, 0, rowEnd + 1, 0);
    };
    this.selectLine = function() {
        this.setSelectionRange(this.getLineRange());
    };
    this.moveCursorUp = function() {
        this.moveCursorBy(-1, 0);
    };
    this.moveCursorDown = function() {
        this.moveCursorBy(1, 0);
    };
    this.wouldMoveIntoSoftTab = function(cursor, tabSize, direction) {
        var start = cursor.column;
        var end = cursor.column + tabSize;

        if (direction < 0) {
            start = cursor.column - tabSize;
            end = cursor.column;
        }
        return this.session.isTabStop(cursor) && this.doc.getLine(cursor.row).slice(start, end).split(" ").length-1 == tabSize;
    };
    this.moveCursorLeft = function() {
        var cursor = this.lead.getPosition(),
            fold;

        if (fold = this.session.getFoldAt(cursor.row, cursor.column, -1)) {
            this.moveCursorTo(fold.start.row, fold.start.column);
        } else if (cursor.column === 0) {
            if (cursor.row > 0) {
                this.moveCursorTo(cursor.row - 1, this.doc.getLine(cursor.row - 1).length);
            }
        }
        else {
            var tabSize = this.session.getTabSize();
            if (this.wouldMoveIntoSoftTab(cursor, tabSize, -1) && !this.session.getNavigateWithinSoftTabs()) {
                this.moveCursorBy(0, -tabSize);
            } else {
                this.moveCursorBy(0, -1);
            }
        }
    };
    this.moveCursorRight = function() {
        var cursor = this.lead.getPosition(),
            fold;
        if (fold = this.session.getFoldAt(cursor.row, cursor.column, 1)) {
            this.moveCursorTo(fold.end.row, fold.end.column);
        }
        else if (this.lead.column == this.doc.getLine(this.lead.row).length) {
            if (this.lead.row < this.doc.getLength() - 1) {
                this.moveCursorTo(this.lead.row + 1, 0);
            }
        }
        else {
            var tabSize = this.session.getTabSize();
            var cursor = this.lead;
            if (this.wouldMoveIntoSoftTab(cursor, tabSize, 1) && !this.session.getNavigateWithinSoftTabs()) {
                this.moveCursorBy(0, tabSize);
            } else {
                this.moveCursorBy(0, 1);
            }
        }
    };
    this.moveCursorLineStart = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var screenRow = this.session.documentToScreenRow(row, column);
        var firstColumnPosition = this.session.screenToDocumentPosition(screenRow, 0);
        var beforeCursor = this.session.getDisplayLine(
            row, null, firstColumnPosition.row,
            firstColumnPosition.column
        );

        var leadingSpace = beforeCursor.match(/^\s*/);
        if (leadingSpace[0].length != column && !this.session.$useEmacsStyleLineStart)
            firstColumnPosition.column += leadingSpace[0].length;
        this.moveCursorToPosition(firstColumnPosition);
    };
    this.moveCursorLineEnd = function() {
        var lead = this.lead;
        var lineEnd = this.session.getDocumentLastRowColumnPosition(lead.row, lead.column);
        if (this.lead.column == lineEnd.column) {
            var line = this.session.getLine(lineEnd.row);
            if (lineEnd.column == line.length) {
                var textEnd = line.search(/\s+$/);
                if (textEnd > 0)
                    lineEnd.column = textEnd;
            }
        }

        this.moveCursorTo(lineEnd.row, lineEnd.column);
    };
    this.moveCursorFileEnd = function() {
        var row = this.doc.getLength() - 1;
        var column = this.doc.getLine(row).length;
        this.moveCursorTo(row, column);
    };
    this.moveCursorFileStart = function() {
        this.moveCursorTo(0, 0);
    };
    this.moveCursorLongWordRight = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var line = this.doc.getLine(row);
        var rightOfCursor = line.substring(column);

        var match;
        this.session.nonTokenRe.lastIndex = 0;
        this.session.tokenRe.lastIndex = 0;
        var fold = this.session.getFoldAt(row, column, 1);
        if (fold) {
            this.moveCursorTo(fold.end.row, fold.end.column);
            return;
        }
        if (match = this.session.nonTokenRe.exec(rightOfCursor)) {
            column += this.session.nonTokenRe.lastIndex;
            this.session.nonTokenRe.lastIndex = 0;
            rightOfCursor = line.substring(column);
        }
        if (column >= line.length) {
            this.moveCursorTo(row, line.length);
            this.moveCursorRight();
            if (row < this.doc.getLength() - 1)
                this.moveCursorWordRight();
            return;
        }
        if (match = this.session.tokenRe.exec(rightOfCursor)) {
            column += this.session.tokenRe.lastIndex;
            this.session.tokenRe.lastIndex = 0;
        }

        this.moveCursorTo(row, column);
    };
    this.moveCursorLongWordLeft = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var fold;
        if (fold = this.session.getFoldAt(row, column, -1)) {
            this.moveCursorTo(fold.start.row, fold.start.column);
            return;
        }

        var str = this.session.getFoldStringAt(row, column, -1);
        if (str == null) {
            str = this.doc.getLine(row).substring(0, column);
        }

        var leftOfCursor = lang.stringReverse(str);
        var match;
        this.session.nonTokenRe.lastIndex = 0;
        this.session.tokenRe.lastIndex = 0;
        if (match = this.session.nonTokenRe.exec(leftOfCursor)) {
            column -= this.session.nonTokenRe.lastIndex;
            leftOfCursor = leftOfCursor.slice(this.session.nonTokenRe.lastIndex);
            this.session.nonTokenRe.lastIndex = 0;
        }
        if (column <= 0) {
            this.moveCursorTo(row, 0);
            this.moveCursorLeft();
            if (row > 0)
                this.moveCursorWordLeft();
            return;
        }
        if (match = this.session.tokenRe.exec(leftOfCursor)) {
            column -= this.session.tokenRe.lastIndex;
            this.session.tokenRe.lastIndex = 0;
        }

        this.moveCursorTo(row, column);
    };

    this.$shortWordEndIndex = function(rightOfCursor) {
        var match, index = 0, ch;
        var whitespaceRe = /\s/;
        var tokenRe = this.session.tokenRe;

        tokenRe.lastIndex = 0;
        if (match = this.session.tokenRe.exec(rightOfCursor)) {
            index = this.session.tokenRe.lastIndex;
        } else {
            while ((ch = rightOfCursor[index]) && whitespaceRe.test(ch))
                index ++;

            if (index < 1) {
                tokenRe.lastIndex = 0;
                 while ((ch = rightOfCursor[index]) && !tokenRe.test(ch)) {
                    tokenRe.lastIndex = 0;
                    index ++;
                    if (whitespaceRe.test(ch)) {
                        if (index > 2) {
                            index--;
                            break;
                        } else {
                            while ((ch = rightOfCursor[index]) && whitespaceRe.test(ch))
                                index ++;
                            if (index > 2)
                                break;
                        }
                    }
                }
            }
        }
        tokenRe.lastIndex = 0;

        return index;
    };

    this.moveCursorShortWordRight = function() {
        var row = this.lead.row;
        var column = this.lead.column;
        var line = this.doc.getLine(row);
        var rightOfCursor = line.substring(column);

        var fold = this.session.getFoldAt(row, column, 1);
        if (fold)
            return this.moveCursorTo(fold.end.row, fold.end.column);

        if (column == line.length) {
            var l = this.doc.getLength();
            do {
                row++;
                rightOfCursor = this.doc.getLine(row);
            } while (row < l && /^\s*$/.test(rightOfCursor));

            if (!/^\s+/.test(rightOfCursor))
                rightOfCursor = "";
            column = 0;
        }

        var index = this.$shortWordEndIndex(rightOfCursor);

        this.moveCursorTo(row, column + index);
    };

    this.moveCursorShortWordLeft = function() {
        var row = this.lead.row;
        var column = this.lead.column;

        var fold;
        if (fold = this.session.getFoldAt(row, column, -1))
            return this.moveCursorTo(fold.start.row, fold.start.column);

        var line = this.session.getLine(row).substring(0, column);
        if (column === 0) {
            do {
                row--;
                line = this.doc.getLine(row);
            } while (row > 0 && /^\s*$/.test(line));

            column = line.length;
            if (!/\s+$/.test(line))
                line = "";
        }

        var leftOfCursor = lang.stringReverse(line);
        var index = this.$shortWordEndIndex(leftOfCursor);

        return this.moveCursorTo(row, column - index);
    };

    this.moveCursorWordRight = function() {
        if (this.session.$selectLongWords)
            this.moveCursorLongWordRight();
        else
            this.moveCursorShortWordRight();
    };

    this.moveCursorWordLeft = function() {
        if (this.session.$selectLongWords)
            this.moveCursorLongWordLeft();
        else
            this.moveCursorShortWordLeft();
    };
    this.moveCursorBy = function(rows, chars) {
        var screenPos = this.session.documentToScreenPosition(
            this.lead.row,
            this.lead.column
        );

        var offsetX;

        if (chars === 0) {
            if (rows !== 0) {
                if (this.session.$bidiHandler.isBidiRow(screenPos.row, this.lead.row)) {
                    offsetX = this.session.$bidiHandler.getPosLeft(screenPos.column);
                    screenPos.column = Math.round(offsetX / this.session.$bidiHandler.charWidths[0]);
                } else {
                    offsetX = screenPos.column * this.session.$bidiHandler.charWidths[0];
                }
            }

            if (this.$desiredColumn)
                screenPos.column = this.$desiredColumn;
            else
                this.$desiredColumn = screenPos.column;
        }

        var docPos = this.session.screenToDocumentPosition(screenPos.row + rows, screenPos.column, offsetX);
        
        if (rows !== 0 && chars === 0 && docPos.row === this.lead.row && docPos.column === this.lead.column) {
            if (this.session.lineWidgets && this.session.lineWidgets[docPos.row]) {
                if (docPos.row > 0 || rows > 0)
                    docPos.row++;
            }
        }
        this.moveCursorTo(docPos.row, docPos.column + chars, chars === 0);
    };
    this.moveCursorToPosition = function(position) {
        this.moveCursorTo(position.row, position.column);
    };
    this.moveCursorTo = function(row, column, keepDesiredColumn) {
        var fold = this.session.getFoldAt(row, column, 1);
        if (fold) {
            row = fold.start.row;
            column = fold.start.column;
        }

        this.$keepDesiredColumnOnChange = true;
        var line = this.session.getLine(row);
        if (/[\uDC00-\uDFFF]/.test(line.charAt(column)) && line.charAt(column - 1)) {
            if (this.lead.row == row && this.lead.column == column + 1)
                column = column - 1;
            else
                column = column + 1;
        }
        this.lead.setPosition(row, column);
        this.$keepDesiredColumnOnChange = false;

        if (!keepDesiredColumn)
            this.$desiredColumn = null;
    };
    this.moveCursorToScreen = function(row, column, keepDesiredColumn) {
        var pos = this.session.screenToDocumentPosition(row, column);
        this.moveCursorTo(pos.row, pos.column, keepDesiredColumn);
    };
    this.detach = function() {
        this.lead.detach();
        this.anchor.detach();
        this.session = this.doc = null;
    };

    this.fromOrientedRange = function(range) {
        this.setSelectionRange(range, range.cursor == range.start);
        this.$desiredColumn = range.desiredColumn || this.$desiredColumn;
    };

    this.toOrientedRange = function(range) {
        var r = this.getRange();
        if (range) {
            range.start.column = r.start.column;
            range.start.row = r.start.row;
            range.end.column = r.end.column;
            range.end.row = r.end.row;
        } else {
            range = r;
        }

        range.cursor = this.isBackwards() ? range.start : range.end;
        range.desiredColumn = this.$desiredColumn;
        return range;
    };
    this.getRangeOfMovements = function(func) {
        var start = this.getCursor();
        try {
            func(this);
            var end = this.getCursor();
            return Range.fromPoints(start,end);
        } catch(e) {
            return Range.fromPoints(start,start);
        } finally {
            this.moveCursorToPosition(start);
        }
    };

    this.toJSON = function() {
        if (this.rangeCount) {
            var data = this.ranges.map(function(r) {
                var r1 = r.clone();
                r1.isBackwards = r.cursor == r.start;
                return r1;
            });
        } else {
            var data = this.getRange();
            data.isBackwards = this.isBackwards();
        }
        return data;
    };

    this.fromJSON = function(data) {
        if (data.start == undefined) {
            if (this.rangeList) {
                this.toSingleRange(data[0]);
                for (var i = data.length; i--; ) {
                    var r = Range.fromPoints(data[i].start, data[i].end);
                    if (data[i].isBackwards)
                        r.cursor = r.start;
                    this.addRange(r, true);
                }
                return;
            } else
                data = data[0];
        }
        if (this.rangeList)
            this.toSingleRange(data);
        this.setSelectionRange(data, data.isBackwards);
    };

    this.isEqual = function(data) {
        if ((data.length || this.rangeCount) && data.length != this.rangeCount)
            return false;
        if (!data.length || !this.ranges)
            return this.getRange().isEqual(data);

        for (var i = this.ranges.length; i--; ) {
            if (!this.ranges[i].isEqual(data[i]))
                return false;
        }
        return true;
    };

}).call(Selection.prototype);

exports.Selection = Selection;
});

ace.define("ace/tokenizer",["require","exports","module","ace/config"], function(acequire, exports, module) {
"use strict";

var config = acequire("./config");
var MAX_TOKEN_COUNT = 2000;
var Tokenizer = function(rules) {
    this.states = rules;

    this.regExps = {};
    this.matchMappings = {};
    for (var key in this.states) {
        var state = this.states[key];
        var ruleRegExps = [];
        var matchTotal = 0;
        var mapping = this.matchMappings[key] = {defaultToken: "text"};
        var flag = "g";

        var splitterRurles = [];
        for (var i = 0; i < state.length; i++) {
            var rule = state[i];
            if (rule.defaultToken)
                mapping.defaultToken = rule.defaultToken;
            if (rule.caseInsensitive)
                flag = "gi";
            if (rule.regex == null)
                continue;

            if (rule.regex instanceof RegExp)
                rule.regex = rule.regex.toString().slice(1, -1);
            var adjustedregex = rule.regex;
            var matchcount = new RegExp("(?:(" + adjustedregex + ")|(.))").exec("a").length - 2;
            if (Array.isArray(rule.token)) {
                if (rule.token.length == 1 || matchcount == 1) {
                    rule.token = rule.token[0];
                } else if (matchcount - 1 != rule.token.length) {
                    this.reportError("number of classes and regexp groups doesn't match", { 
                        rule: rule,
                        groupCount: matchcount - 1
                    });
                    rule.token = rule.token[0];
                } else {
                    rule.tokenArray = rule.token;
                    rule.token = null;
                    rule.onMatch = this.$arrayTokens;
                }
            } else if (typeof rule.token == "function" && !rule.onMatch) {
                if (matchcount > 1)
                    rule.onMatch = this.$applyToken;
                else
                    rule.onMatch = rule.token;
            }

            if (matchcount > 1) {
                if (/\\\d/.test(rule.regex)) {
                    adjustedregex = rule.regex.replace(/\\([0-9]+)/g, function(match, digit) {
                        return "\\" + (parseInt(digit, 10) + matchTotal + 1);
                    });
                } else {
                    matchcount = 1;
                    adjustedregex = this.removeCapturingGroups(rule.regex);
                }
                if (!rule.splitRegex && typeof rule.token != "string")
                    splitterRurles.push(rule); // flag will be known only at the very end
            }

            mapping[matchTotal] = i;
            matchTotal += matchcount;

            ruleRegExps.push(adjustedregex);
            if (!rule.onMatch)
                rule.onMatch = null;
        }
        
        if (!ruleRegExps.length) {
            mapping[0] = 0;
            ruleRegExps.push("$");
        }
        
        splitterRurles.forEach(function(rule) {
            rule.splitRegex = this.createSplitterRegexp(rule.regex, flag);
        }, this);

        this.regExps[key] = new RegExp("(" + ruleRegExps.join(")|(") + ")|($)", flag);
    }
};

(function() {
    this.$setMaxTokenCount = function(m) {
        MAX_TOKEN_COUNT = m | 0;
    };
    
    this.$applyToken = function(str) {
        var values = this.splitRegex.exec(str).slice(1);
        var types = this.token.apply(this, values);
        if (typeof types === "string")
            return [{type: types, value: str}];

        var tokens = [];
        for (var i = 0, l = types.length; i < l; i++) {
            if (values[i])
                tokens[tokens.length] = {
                    type: types[i],
                    value: values[i]
                };
        }
        return tokens;
    };

    this.$arrayTokens = function(str) {
        if (!str)
            return [];
        var values = this.splitRegex.exec(str);
        if (!values)
            return "text";
        var tokens = [];
        var types = this.tokenArray;
        for (var i = 0, l = types.length; i < l; i++) {
            if (values[i + 1])
                tokens[tokens.length] = {
                    type: types[i],
                    value: values[i + 1]
                };
        }
        return tokens;
    };

    this.removeCapturingGroups = function(src) {
        var r = src.replace(
            /\[(?:\\.|[^\]])*?\]|\\.|\(\?[:=!]|(\()/g,
            function(x, y) {return y ? "(?:" : x;}
        );
        return r;
    };

    this.createSplitterRegexp = function(src, flag) {
        if (src.indexOf("(?=") != -1) {
            var stack = 0;
            var inChClass = false;
            var lastCapture = {};
            src.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(
                m, esc, parenOpen, parenClose, square, index
            ) {
                if (inChClass) {
                    inChClass = square != "]";
                } else if (square) {
                    inChClass = true;
                } else if (parenClose) {
                    if (stack == lastCapture.stack) {
                        lastCapture.end = index+1;
                        lastCapture.stack = -1;
                    }
                    stack--;
                } else if (parenOpen) {
                    stack++;
                    if (parenOpen.length != 1) {
                        lastCapture.stack = stack;
                        lastCapture.start = index;
                    }
                }
                return m;
            });

            if (lastCapture.end != null && /^\)*$/.test(src.substr(lastCapture.end)))
                src = src.substring(0, lastCapture.start) + src.substr(lastCapture.end);
        }
        if (src.charAt(0) != "^") src = "^" + src;
        if (src.charAt(src.length - 1) != "$") src += "$";
        
        return new RegExp(src, (flag||"").replace("g", ""));
    };
    this.getLineTokens = function(line, startState) {
        if (startState && typeof startState != "string") {
            var stack = startState.slice(0);
            startState = stack[0];
            if (startState === "#tmp") {
                stack.shift();
                startState = stack.shift();
            }
        } else
            var stack = [];

        var currentState = startState || "start";
        var state = this.states[currentState];
        if (!state) {
            currentState = "start";
            state = this.states[currentState];
        }
        var mapping = this.matchMappings[currentState];
        var re = this.regExps[currentState];
        re.lastIndex = 0;

        var match, tokens = [];
        var lastIndex = 0;
        var matchAttempts = 0;

        var token = {type: null, value: ""};

        while (match = re.exec(line)) {
            var type = mapping.defaultToken;
            var rule = null;
            var value = match[0];
            var index = re.lastIndex;

            if (index - value.length > lastIndex) {
                var skipped = line.substring(lastIndex, index - value.length);
                if (token.type == type) {
                    token.value += skipped;
                } else {
                    if (token.type)
                        tokens.push(token);
                    token = {type: type, value: skipped};
                }
            }

            for (var i = 0; i < match.length-2; i++) {
                if (match[i + 1] === undefined)
                    continue;

                rule = state[mapping[i]];

                if (rule.onMatch)
                    type = rule.onMatch(value, currentState, stack, line);
                else
                    type = rule.token;

                if (rule.next) {
                    if (typeof rule.next == "string") {
                        currentState = rule.next;
                    } else {
                        currentState = rule.next(currentState, stack);
                    }
                    
                    state = this.states[currentState];
                    if (!state) {
                        this.reportError("state doesn't exist", currentState);
                        currentState = "start";
                        state = this.states[currentState];
                    }
                    mapping = this.matchMappings[currentState];
                    lastIndex = index;
                    re = this.regExps[currentState];
                    re.lastIndex = index;
                }
                if (rule.consumeLineEnd)
                    lastIndex = index;
                break;
            }

            if (value) {
                if (typeof type === "string") {
                    if ((!rule || rule.merge !== false) && token.type === type) {
                        token.value += value;
                    } else {
                        if (token.type)
                            tokens.push(token);
                        token = {type: type, value: value};
                    }
                } else if (type) {
                    if (token.type)
                        tokens.push(token);
                    token = {type: null, value: ""};
                    for (var i = 0; i < type.length; i++)
                        tokens.push(type[i]);
                }
            }

            if (lastIndex == line.length)
                break;

            lastIndex = index;

            if (matchAttempts++ > MAX_TOKEN_COUNT) {
                if (matchAttempts > 2 * line.length) {
                    this.reportError("infinite loop with in ace tokenizer", {
                        startState: startState,
                        line: line
                    });
                }
                while (lastIndex < line.length) {
                    if (token.type)
                        tokens.push(token);
                    token = {
                        value: line.substring(lastIndex, lastIndex += 2000),
                        type: "overflow"
                    };
                }
                currentState = "start";
                stack = [];
                break;
            }
        }

        if (token.type)
            tokens.push(token);
        
        if (stack.length > 1) {
            if (stack[0] !== currentState)
                stack.unshift("#tmp", currentState);
        }
        return {
            tokens : tokens,
            state : stack.length ? stack : currentState
        };
    };
    
    this.reportError = config.reportError;
    
}).call(Tokenizer.prototype);

exports.Tokenizer = Tokenizer;
});

ace.define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/lang"], function(acequire, exports, module) {
"use strict";

var lang = acequire("../lib/lang");

var TextHighlightRules = function() {

    this.$rules = {
        "start" : [{
            token : "empty_line",
            regex : '^$'
        }, {
            defaultToken : "text"
        }]
    };
};

(function() {

    this.addRules = function(rules, prefix) {
        if (!prefix) {
            for (var key in rules)
                this.$rules[key] = rules[key];
            return;
        }
        for (var key in rules) {
            var state = rules[key];
            for (var i = 0; i < state.length; i++) {
                var rule = state[i];
                if (rule.next || rule.onMatch) {
                    if (typeof rule.next == "string") {
                        if (rule.next.indexOf(prefix) !== 0)
                            rule.next = prefix + rule.next;
                    }
                    if (rule.nextState && rule.nextState.indexOf(prefix) !== 0)
                        rule.nextState = prefix + rule.nextState;
                }
            }
            this.$rules[prefix + key] = state;
        }
    };

    this.getRules = function() {
        return this.$rules;
    };

    this.embedRules = function (HighlightRules, prefix, escapeRules, states, append) {
        var embedRules = typeof HighlightRules == "function"
            ? new HighlightRules().getRules()
            : HighlightRules;
        if (states) {
            for (var i = 0; i < states.length; i++)
                states[i] = prefix + states[i];
        } else {
            states = [];
            for (var key in embedRules)
                states.push(prefix + key);
        }

        this.addRules(embedRules, prefix);

        if (escapeRules) {
            var addRules = Array.prototype[append ? "push" : "unshift"];
            for (var i = 0; i < states.length; i++)
                addRules.apply(this.$rules[states[i]], lang.deepCopy(escapeRules));
        }

        if (!this.$embeds)
            this.$embeds = [];
        this.$embeds.push(prefix);
    };

    this.getEmbeds = function() {
        return this.$embeds;
    };

    var pushState = function(currentState, stack) {
        if (currentState != "start" || stack.length)
            stack.unshift(this.nextState, currentState);
        return this.nextState;
    };
    var popState = function(currentState, stack) {
        stack.shift();
        return stack.shift() || "start";
    };

    this.normalizeRules = function() {
        var id = 0;
        var rules = this.$rules;
        function processState(key) {
            var state = rules[key];
            state.processed = true;
            for (var i = 0; i < state.length; i++) {
                var rule = state[i];
                var toInsert = null;
                if (Array.isArray(rule)) {
                    toInsert = rule;
                    rule = {};
                }
                if (!rule.regex && rule.start) {
                    rule.regex = rule.start;
                    if (!rule.next)
                        rule.next = [];
                    rule.next.push({
                        defaultToken: rule.token
                    }, {
                        token: rule.token + ".end",
                        regex: rule.end || rule.start,
                        next: "pop"
                    });
                    rule.token = rule.token + ".start";
                    rule.push = true;
                }
                var next = rule.next || rule.push;
                if (next && Array.isArray(next)) {
                    var stateName = rule.stateName;
                    if (!stateName)  {
                        stateName = rule.token;
                        if (typeof stateName != "string")
                            stateName = stateName[0] || "";
                        if (rules[stateName])
                            stateName += id++;
                    }
                    rules[stateName] = next;
                    rule.next = stateName;
                    processState(stateName);
                } else if (next == "pop") {
                    rule.next = popState;
                }

                if (rule.push) {
                    rule.nextState = rule.next || rule.push;
                    rule.next = pushState;
                    delete rule.push;
                }

                if (rule.rules) {
                    for (var r in rule.rules) {
                        if (rules[r]) {
                            if (rules[r].push)
                                rules[r].push.apply(rules[r], rule.rules[r]);
                        } else {
                            rules[r] = rule.rules[r];
                        }
                    }
                }
                var includeName = typeof rule == "string" ? rule : rule.include;
                if (includeName) {
                    if (Array.isArray(includeName))
                        toInsert = includeName.map(function(x) { return rules[x]; });
                    else
                        toInsert = rules[includeName];
                }

                if (toInsert) {
                    var args = [i, 1].concat(toInsert);
                    if (rule.noEscape)
                        args = args.filter(function(x) {return !x.next;});
                    state.splice.apply(state, args);
                    i--;
                }
                
                if (rule.keywordMap) {
                    rule.token = this.createKeywordMapper(
                        rule.keywordMap, rule.defaultToken || "text", rule.caseInsensitive
                    );
                    delete rule.defaultToken;
                }
            }
        }
        Object.keys(rules).forEach(processState, this);
    };

    this.createKeywordMapper = function(map, defaultToken, ignoreCase, splitChar) {
        var keywords = Object.create(null);
        Object.keys(map).forEach(function(className) {
            var a = map[className];
            if (ignoreCase)
                a = a.toLowerCase();
            var list = a.split(splitChar || "|");
            for (var i = list.length; i--; )
                keywords[list[i]] = className;
        });
        if (Object.getPrototypeOf(keywords)) {
            keywords.__proto__ = null;
        }
        this.$keywordList = Object.keys(keywords);
        map = null;
        return ignoreCase
            ? function(value) {return keywords[value.toLowerCase()] || defaultToken; }
            : function(value) {return keywords[value] || defaultToken; };
    };

    this.getKeywords = function() {
        return this.$keywords;
    };

}).call(TextHighlightRules.prototype);

exports.TextHighlightRules = TextHighlightRules;
});

ace.define("ace/mode/behaviour",["require","exports","module"], function(acequire, exports, module) {
"use strict";

var Behaviour = function() {
   this.$behaviours = {};
};

(function () {

    this.add = function (name, action, callback) {
        switch (undefined) {
          case this.$behaviours:
              this.$behaviours = {};
          case this.$behaviours[name]:
              this.$behaviours[name] = {};
        }
        this.$behaviours[name][action] = callback;
    };
    
    this.addBehaviours = function (behaviours) {
        for (var key in behaviours) {
            for (var action in behaviours[key]) {
                this.add(key, action, behaviours[key][action]);
            }
        }
    };
    
    this.remove = function (name) {
        if (this.$behaviours && this.$behaviours[name]) {
            delete this.$behaviours[name];
        }
    };
    
    this.inherit = function (mode, filter) {
        if (typeof mode === "function") {
            var behaviours = new mode().getBehaviours(filter);
        } else {
            var behaviours = mode.getBehaviours(filter);
        }
        this.addBehaviours(behaviours);
    };
    
    this.getBehaviours = function (filter) {
        if (!filter) {
            return this.$behaviours;
        } else {
            var ret = {};
            for (var i = 0; i < filter.length; i++) {
                if (this.$behaviours[filter[i]]) {
                    ret[filter[i]] = this.$behaviours[filter[i]];
                }
            }
            return ret;
        }
    };

}).call(Behaviour.prototype);

exports.Behaviour = Behaviour;
});

ace.define("ace/token_iterator",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("./range").Range;
var TokenIterator = function(session, initialRow, initialColumn) {
    this.$session = session;
    this.$row = initialRow;
    this.$rowTokens = session.getTokens(initialRow);

    var token = session.getTokenAt(initialRow, initialColumn);
    this.$tokenIndex = token ? token.index : -1;
};

(function() { 
    this.stepBackward = function() {
        this.$tokenIndex -= 1;
        
        while (this.$tokenIndex < 0) {
            this.$row -= 1;
            if (this.$row < 0) {
                this.$row = 0;
                return null;
            }
                
            this.$rowTokens = this.$session.getTokens(this.$row);
            this.$tokenIndex = this.$rowTokens.length - 1;
        }
            
        return this.$rowTokens[this.$tokenIndex];
    };   
    this.stepForward = function() {
        this.$tokenIndex += 1;
        var rowCount;
        while (this.$tokenIndex >= this.$rowTokens.length) {
            this.$row += 1;
            if (!rowCount)
                rowCount = this.$session.getLength();
            if (this.$row >= rowCount) {
                this.$row = rowCount - 1;
                return null;
            }

            this.$rowTokens = this.$session.getTokens(this.$row);
            this.$tokenIndex = 0;
        }
            
        return this.$rowTokens[this.$tokenIndex];
    };      
    this.getCurrentToken = function () {
        return this.$rowTokens[this.$tokenIndex];
    };      
    this.getCurrentTokenRow = function () {
        return this.$row;
    };     
    this.getCurrentTokenColumn = function() {
        var rowTokens = this.$rowTokens;
        var tokenIndex = this.$tokenIndex;
        var column = rowTokens[tokenIndex].start;
        if (column !== undefined)
            return column;
            
        column = 0;
        while (tokenIndex > 0) {
            tokenIndex -= 1;
            column += rowTokens[tokenIndex].value.length;
        }
        
        return column;  
    };
    this.getCurrentTokenPosition = function() {
        return {row: this.$row, column: this.getCurrentTokenColumn()};
    };
    this.getCurrentTokenRange = function() {
        var token = this.$rowTokens[this.$tokenIndex];
        var column = this.getCurrentTokenColumn();
        return new Range(this.$row, column, this.$row, column + token.value.length);
    };

}).call(TokenIterator.prototype);

exports.TokenIterator = TokenIterator;
});

ace.define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Behaviour = acequire("../behaviour").Behaviour;
var TokenIterator = acequire("../../token_iterator").TokenIterator;
var lang = acequire("../../lib/lang");

var SAFE_INSERT_IN_TOKENS =
    ["text", "paren.rparen", "punctuation.operator"];
var SAFE_INSERT_BEFORE_TOKENS =
    ["text", "paren.rparen", "punctuation.operator", "comment"];

var context;
var contextCache = {};
var defaultQuotes = {'"' : '"', "'" : "'"};

var initContext = function(editor) {
    var id = -1;
    if (editor.multiSelect) {
        id = editor.selection.index;
        if (contextCache.rangeCount != editor.multiSelect.rangeCount)
            contextCache = {rangeCount: editor.multiSelect.rangeCount};
    }
    if (contextCache[id])
        return context = contextCache[id];
    context = contextCache[id] = {
        autoInsertedBrackets: 0,
        autoInsertedRow: -1,
        autoInsertedLineEnd: "",
        maybeInsertedBrackets: 0,
        maybeInsertedRow: -1,
        maybeInsertedLineStart: "",
        maybeInsertedLineEnd: ""
    };
};

var getWrapped = function(selection, selected, opening, closing) {
    var rowDiff = selection.end.row - selection.start.row;
    return {
        text: opening + selected + closing,
        selection: [
                0,
                selection.start.column + 1,
                rowDiff,
                selection.end.column + (rowDiff ? 0 : 1)
            ]
    };
};

var CstyleBehaviour = function(options) {
    this.add("braces", "insertion", function(state, action, editor, session, text) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (text == '{') {
            initContext(editor);
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && selected !== "{" && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, '{', '}');
            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                if (/[\]\}\)]/.test(line[cursor.column]) || editor.inMultiSelectMode || options && options.braces) {
                    CstyleBehaviour.recordAutoInsert(editor, session, "}");
                    return {
                        text: '{}',
                        selection: [1, 1]
                    };
                } else {
                    CstyleBehaviour.recordMaybeInsert(editor, session, "{");
                    return {
                        text: '{',
                        selection: [1, 1]
                    };
                }
            }
        } else if (text == '}') {
            initContext(editor);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar == '}') {
                var matching = session.$findOpeningBracket('}', {column: cursor.column + 1, row: cursor.row});
                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                    CstyleBehaviour.popAutoInsertedClosing();
                    return {
                        text: '',
                        selection: [1, 1]
                    };
                }
            }
        } else if (text == "\n" || text == "\r\n") {
            initContext(editor);
            var closing = "";
            if (CstyleBehaviour.isMaybeInsertedClosing(cursor, line)) {
                closing = lang.stringRepeat("}", context.maybeInsertedBrackets);
                CstyleBehaviour.clearMaybeInsertedClosing();
            }
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar === '}') {
                var openBracePos = session.findMatchingBracket({row: cursor.row, column: cursor.column+1}, '}');
                if (!openBracePos)
                     return null;
                var next_indent = this.$getIndent(session.getLine(openBracePos.row));
            } else if (closing) {
                var next_indent = this.$getIndent(line);
            } else {
                CstyleBehaviour.clearMaybeInsertedClosing();
                return;
            }
            var indent = next_indent + session.getTabString();

            return {
                text: '\n' + indent + '\n' + next_indent + closing,
                selection: [1, indent.length, 1, indent.length]
            };
        } else {
            CstyleBehaviour.clearMaybeInsertedClosing();
        }
    });

    this.add("braces", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && selected == '{') {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.end.column, range.end.column + 1);
            if (rightChar == '}') {
                range.end.column++;
                return range;
            } else {
                context.maybeInsertedBrackets--;
            }
        }
    });

    this.add("parens", "insertion", function(state, action, editor, session, text) {
        if (text == '(') {
            initContext(editor);
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, '(', ')');
            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                CstyleBehaviour.recordAutoInsert(editor, session, ")");
                return {
                    text: '()',
                    selection: [1, 1]
                };
            }
        } else if (text == ')') {
            initContext(editor);
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar == ')') {
                var matching = session.$findOpeningBracket(')', {column: cursor.column + 1, row: cursor.row});
                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                    CstyleBehaviour.popAutoInsertedClosing();
                    return {
                        text: '',
                        selection: [1, 1]
                    };
                }
            }
        }
    });

    this.add("parens", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && selected == '(') {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
            if (rightChar == ')') {
                range.end.column++;
                return range;
            }
        }
    });

    this.add("brackets", "insertion", function(state, action, editor, session, text) {
        if (text == '[') {
            initContext(editor);
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, '[', ']');
            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                CstyleBehaviour.recordAutoInsert(editor, session, "]");
                return {
                    text: '[]',
                    selection: [1, 1]
                };
            }
        } else if (text == ']') {
            initContext(editor);
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            var rightChar = line.substring(cursor.column, cursor.column + 1);
            if (rightChar == ']') {
                var matching = session.$findOpeningBracket(']', {column: cursor.column + 1, row: cursor.row});
                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                    CstyleBehaviour.popAutoInsertedClosing();
                    return {
                        text: '',
                        selection: [1, 1]
                    };
                }
            }
        }
    });

    this.add("brackets", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && selected == '[') {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
            if (rightChar == ']') {
                range.end.column++;
                return range;
            }
        }
    });

    this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
        var quotes = session.$mode.$quotes || defaultQuotes;
        if (text.length == 1 && quotes[text]) {
            if (this.lineCommentStart && this.lineCommentStart.indexOf(text) != -1)
                return;
            initContext(editor);
            var quote = text;
            var selection = editor.getSelectionRange();
            var selected = session.doc.getTextRange(selection);
            if (selected !== "" && (selected.length != 1 || !quotes[selected]) && editor.getWrapBehavioursEnabled()) {
                return getWrapped(selection, selected, quote, quote);
            } else if (!selected) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var leftChar = line.substring(cursor.column-1, cursor.column);
                var rightChar = line.substring(cursor.column, cursor.column + 1);

                var token = session.getTokenAt(cursor.row, cursor.column);
                var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
                if (leftChar == "\\" && token && /escape/.test(token.type))
                    return null;

                var stringBefore = token && /string|escape/.test(token.type);
                var stringAfter = !rightToken || /string|escape/.test(rightToken.type);

                var pair;
                if (rightChar == quote) {
                    pair = stringBefore !== stringAfter;
                    if (pair && /string\.end/.test(rightToken.type))
                        pair = false;
                } else {
                    if (stringBefore && !stringAfter)
                        return null; // wrap string with different quote
                    if (stringBefore && stringAfter)
                        return null; // do not pair quotes inside strings
                    var wordRe = session.$mode.tokenRe;
                    wordRe.lastIndex = 0;
                    var isWordBefore = wordRe.test(leftChar);
                    wordRe.lastIndex = 0;
                    var isWordAfter = wordRe.test(leftChar);
                    if (isWordBefore || isWordAfter)
                        return null; // before or after alphanumeric
                    if (rightChar && !/[\s;,.})\]\\]/.test(rightChar))
                        return null; // there is rightChar and it isn't closing
                    pair = true;
                }
                return {
                    text: pair ? quote + quote : "",
                    selection: [1,1]
                };
            }
        }
    });

    this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);
        if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
            initContext(editor);
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
            if (rightChar == selected) {
                range.end.column++;
                return range;
            }
        }
    });

};


CstyleBehaviour.isSaneInsertion = function(editor, session) {
    var cursor = editor.getCursorPosition();
    var iterator = new TokenIterator(session, cursor.row, cursor.column);
    if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
        var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
        if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS))
            return false;
    }
    iterator.stepForward();
    return iterator.getCurrentTokenRow() !== cursor.row ||
        this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
};

CstyleBehaviour.$matchTokenType = function(token, types) {
    return types.indexOf(token.type || token) > -1;
};

CstyleBehaviour.recordAutoInsert = function(editor, session, bracket) {
    var cursor = editor.getCursorPosition();
    var line = session.doc.getLine(cursor.row);
    if (!this.isAutoInsertedClosing(cursor, line, context.autoInsertedLineEnd[0]))
        context.autoInsertedBrackets = 0;
    context.autoInsertedRow = cursor.row;
    context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
    context.autoInsertedBrackets++;
};

CstyleBehaviour.recordMaybeInsert = function(editor, session, bracket) {
    var cursor = editor.getCursorPosition();
    var line = session.doc.getLine(cursor.row);
    if (!this.isMaybeInsertedClosing(cursor, line))
        context.maybeInsertedBrackets = 0;
    context.maybeInsertedRow = cursor.row;
    context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
    context.maybeInsertedLineEnd = line.substr(cursor.column);
    context.maybeInsertedBrackets++;
};

CstyleBehaviour.isAutoInsertedClosing = function(cursor, line, bracket) {
    return context.autoInsertedBrackets > 0 &&
        cursor.row === context.autoInsertedRow &&
        bracket === context.autoInsertedLineEnd[0] &&
        line.substr(cursor.column) === context.autoInsertedLineEnd;
};

CstyleBehaviour.isMaybeInsertedClosing = function(cursor, line) {
    return context.maybeInsertedBrackets > 0 &&
        cursor.row === context.maybeInsertedRow &&
        line.substr(cursor.column) === context.maybeInsertedLineEnd &&
        line.substr(0, cursor.column) == context.maybeInsertedLineStart;
};

CstyleBehaviour.popAutoInsertedClosing = function() {
    context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
    context.autoInsertedBrackets--;
};

CstyleBehaviour.clearMaybeInsertedClosing = function() {
    if (context) {
        context.maybeInsertedBrackets = 0;
        context.maybeInsertedRow = -1;
    }
};



oop.inherits(CstyleBehaviour, Behaviour);

exports.CstyleBehaviour = CstyleBehaviour;
});

ace.define("ace/unicode",["require","exports","module"], function(acequire, exports, module) {
"use strict";
exports.packages = {};

addUnicodePackage({
    L:  "0041-005A0061-007A00AA00B500BA00C0-00D600D8-00F600F8-02C102C6-02D102E0-02E402EC02EE0370-037403760377037A-037D03860388-038A038C038E-03A103A3-03F503F7-0481048A-05250531-055605590561-058705D0-05EA05F0-05F20621-064A066E066F0671-06D306D506E506E606EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA07F407F507FA0800-0815081A082408280904-0939093D09500958-0961097109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E460E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EC60EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10A0-10C510D0-10FA10FC1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317D717DC1820-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541AA71B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C7D1CE9-1CEC1CEE-1CF11D00-1DBF1E00-1F151F18-1F1D1F20-1F451F48-1F4D1F50-1F571F591F5B1F5D1F5F-1F7D1F80-1FB41FB6-1FBC1FBE1FC2-1FC41FC6-1FCC1FD0-1FD31FD6-1FDB1FE0-1FEC1FF2-1FF41FF6-1FFC2071207F2090-209421022107210A-211321152119-211D212421262128212A-212D212F-2139213C-213F2145-2149214E218321842C00-2C2E2C30-2C5E2C60-2CE42CEB-2CEE2D00-2D252D30-2D652D6F2D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE2E2F300530063031-3035303B303C3041-3096309D-309F30A1-30FA30FC-30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A48CA4D0-A4FDA500-A60CA610-A61FA62AA62BA640-A65FA662-A66EA67F-A697A6A0-A6E5A717-A71FA722-A788A78BA78CA7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2A9CFAA00-AA28AA40-AA42AA44-AA4BAA60-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADB-AADDABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB00-FB06FB13-FB17FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF21-FF3AFF41-FF5AFF66-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
    Ll: "0061-007A00AA00B500BA00DF-00F600F8-00FF01010103010501070109010B010D010F01110113011501170119011B011D011F01210123012501270129012B012D012F01310133013501370138013A013C013E014001420144014601480149014B014D014F01510153015501570159015B015D015F01610163016501670169016B016D016F0171017301750177017A017C017E-0180018301850188018C018D019201950199-019B019E01A101A301A501A801AA01AB01AD01B001B401B601B901BA01BD-01BF01C601C901CC01CE01D001D201D401D601D801DA01DC01DD01DF01E101E301E501E701E901EB01ED01EF01F001F301F501F901FB01FD01FF02010203020502070209020B020D020F02110213021502170219021B021D021F02210223022502270229022B022D022F02310233-0239023C023F0240024202470249024B024D024F-02930295-02AF037103730377037B-037D039003AC-03CE03D003D103D5-03D703D903DB03DD03DF03E103E303E503E703E903EB03ED03EF-03F303F503F803FB03FC0430-045F04610463046504670469046B046D046F04710473047504770479047B047D047F0481048B048D048F04910493049504970499049B049D049F04A104A304A504A704A904AB04AD04AF04B104B304B504B704B904BB04BD04BF04C204C404C604C804CA04CC04CE04CF04D104D304D504D704D904DB04DD04DF04E104E304E504E704E904EB04ED04EF04F104F304F504F704F904FB04FD04FF05010503050505070509050B050D050F05110513051505170519051B051D051F0521052305250561-05871D00-1D2B1D62-1D771D79-1D9A1E011E031E051E071E091E0B1E0D1E0F1E111E131E151E171E191E1B1E1D1E1F1E211E231E251E271E291E2B1E2D1E2F1E311E331E351E371E391E3B1E3D1E3F1E411E431E451E471E491E4B1E4D1E4F1E511E531E551E571E591E5B1E5D1E5F1E611E631E651E671E691E6B1E6D1E6F1E711E731E751E771E791E7B1E7D1E7F1E811E831E851E871E891E8B1E8D1E8F1E911E931E95-1E9D1E9F1EA11EA31EA51EA71EA91EAB1EAD1EAF1EB11EB31EB51EB71EB91EBB1EBD1EBF1EC11EC31EC51EC71EC91ECB1ECD1ECF1ED11ED31ED51ED71ED91EDB1EDD1EDF1EE11EE31EE51EE71EE91EEB1EED1EEF1EF11EF31EF51EF71EF91EFB1EFD1EFF-1F071F10-1F151F20-1F271F30-1F371F40-1F451F50-1F571F60-1F671F70-1F7D1F80-1F871F90-1F971FA0-1FA71FB0-1FB41FB61FB71FBE1FC2-1FC41FC61FC71FD0-1FD31FD61FD71FE0-1FE71FF2-1FF41FF61FF7210A210E210F2113212F21342139213C213D2146-2149214E21842C30-2C5E2C612C652C662C682C6A2C6C2C712C732C742C76-2C7C2C812C832C852C872C892C8B2C8D2C8F2C912C932C952C972C992C9B2C9D2C9F2CA12CA32CA52CA72CA92CAB2CAD2CAF2CB12CB32CB52CB72CB92CBB2CBD2CBF2CC12CC32CC52CC72CC92CCB2CCD2CCF2CD12CD32CD52CD72CD92CDB2CDD2CDF2CE12CE32CE42CEC2CEE2D00-2D25A641A643A645A647A649A64BA64DA64FA651A653A655A657A659A65BA65DA65FA663A665A667A669A66BA66DA681A683A685A687A689A68BA68DA68FA691A693A695A697A723A725A727A729A72BA72DA72F-A731A733A735A737A739A73BA73DA73FA741A743A745A747A749A74BA74DA74FA751A753A755A757A759A75BA75DA75FA761A763A765A767A769A76BA76DA76FA771-A778A77AA77CA77FA781A783A785A787A78CFB00-FB06FB13-FB17FF41-FF5A",
    Lu: "0041-005A00C0-00D600D8-00DE01000102010401060108010A010C010E01100112011401160118011A011C011E01200122012401260128012A012C012E01300132013401360139013B013D013F0141014301450147014A014C014E01500152015401560158015A015C015E01600162016401660168016A016C016E017001720174017601780179017B017D018101820184018601870189-018B018E-0191019301940196-0198019C019D019F01A001A201A401A601A701A901AC01AE01AF01B1-01B301B501B701B801BC01C401C701CA01CD01CF01D101D301D501D701D901DB01DE01E001E201E401E601E801EA01EC01EE01F101F401F6-01F801FA01FC01FE02000202020402060208020A020C020E02100212021402160218021A021C021E02200222022402260228022A022C022E02300232023A023B023D023E02410243-02460248024A024C024E03700372037603860388-038A038C038E038F0391-03A103A3-03AB03CF03D2-03D403D803DA03DC03DE03E003E203E403E603E803EA03EC03EE03F403F703F903FA03FD-042F04600462046404660468046A046C046E04700472047404760478047A047C047E0480048A048C048E04900492049404960498049A049C049E04A004A204A404A604A804AA04AC04AE04B004B204B404B604B804BA04BC04BE04C004C104C304C504C704C904CB04CD04D004D204D404D604D804DA04DC04DE04E004E204E404E604E804EA04EC04EE04F004F204F404F604F804FA04FC04FE05000502050405060508050A050C050E05100512051405160518051A051C051E0520052205240531-055610A0-10C51E001E021E041E061E081E0A1E0C1E0E1E101E121E141E161E181E1A1E1C1E1E1E201E221E241E261E281E2A1E2C1E2E1E301E321E341E361E381E3A1E3C1E3E1E401E421E441E461E481E4A1E4C1E4E1E501E521E541E561E581E5A1E5C1E5E1E601E621E641E661E681E6A1E6C1E6E1E701E721E741E761E781E7A1E7C1E7E1E801E821E841E861E881E8A1E8C1E8E1E901E921E941E9E1EA01EA21EA41EA61EA81EAA1EAC1EAE1EB01EB21EB41EB61EB81EBA1EBC1EBE1EC01EC21EC41EC61EC81ECA1ECC1ECE1ED01ED21ED41ED61ED81EDA1EDC1EDE1EE01EE21EE41EE61EE81EEA1EEC1EEE1EF01EF21EF41EF61EF81EFA1EFC1EFE1F08-1F0F1F18-1F1D1F28-1F2F1F38-1F3F1F48-1F4D1F591F5B1F5D1F5F1F68-1F6F1FB8-1FBB1FC8-1FCB1FD8-1FDB1FE8-1FEC1FF8-1FFB21022107210B-210D2110-211221152119-211D212421262128212A-212D2130-2133213E213F214521832C00-2C2E2C602C62-2C642C672C692C6B2C6D-2C702C722C752C7E-2C802C822C842C862C882C8A2C8C2C8E2C902C922C942C962C982C9A2C9C2C9E2CA02CA22CA42CA62CA82CAA2CAC2CAE2CB02CB22CB42CB62CB82CBA2CBC2CBE2CC02CC22CC42CC62CC82CCA2CCC2CCE2CD02CD22CD42CD62CD82CDA2CDC2CDE2CE02CE22CEB2CEDA640A642A644A646A648A64AA64CA64EA650A652A654A656A658A65AA65CA65EA662A664A666A668A66AA66CA680A682A684A686A688A68AA68CA68EA690A692A694A696A722A724A726A728A72AA72CA72EA732A734A736A738A73AA73CA73EA740A742A744A746A748A74AA74CA74EA750A752A754A756A758A75AA75CA75EA760A762A764A766A768A76AA76CA76EA779A77BA77DA77EA780A782A784A786A78BFF21-FF3A",
    Lt: "01C501C801CB01F21F88-1F8F1F98-1F9F1FA8-1FAF1FBC1FCC1FFC",
    Lm: "02B0-02C102C6-02D102E0-02E402EC02EE0374037A0559064006E506E607F407F507FA081A0824082809710E460EC610FC17D718431AA71C78-1C7D1D2C-1D611D781D9B-1DBF2071207F2090-20942C7D2D6F2E2F30053031-3035303B309D309E30FC-30FEA015A4F8-A4FDA60CA67FA717-A71FA770A788A9CFAA70AADDFF70FF9EFF9F",
    Lo: "01BB01C0-01C3029405D0-05EA05F0-05F20621-063F0641-064A066E066F0671-06D306D506EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA0800-08150904-0939093D09500958-096109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E450E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10D0-10FA1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317DC1820-18421844-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C771CE9-1CEC1CEE-1CF12135-21382D30-2D652D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE3006303C3041-3096309F30A1-30FA30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A014A016-A48CA4D0-A4F7A500-A60BA610-A61FA62AA62BA66EA6A0-A6E5A7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2AA00-AA28AA40-AA42AA44-AA4BAA60-AA6FAA71-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADBAADCABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF66-FF6FFF71-FF9DFFA0-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",
    M:  "0300-036F0483-04890591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DE-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0903093C093E-094E0951-0955096209630981-098309BC09BE-09C409C709C809CB-09CD09D709E209E30A01-0A030A3C0A3E-0A420A470A480A4B-0A4D0A510A700A710A750A81-0A830ABC0ABE-0AC50AC7-0AC90ACB-0ACD0AE20AE30B01-0B030B3C0B3E-0B440B470B480B4B-0B4D0B560B570B620B630B820BBE-0BC20BC6-0BC80BCA-0BCD0BD70C01-0C030C3E-0C440C46-0C480C4A-0C4D0C550C560C620C630C820C830CBC0CBE-0CC40CC6-0CC80CCA-0CCD0CD50CD60CE20CE30D020D030D3E-0D440D46-0D480D4A-0D4D0D570D620D630D820D830DCA0DCF-0DD40DD60DD8-0DDF0DF20DF30E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F3E0F3F0F71-0F840F860F870F90-0F970F99-0FBC0FC6102B-103E1056-1059105E-10601062-10641067-106D1071-10741082-108D108F109A-109D135F1712-17141732-1734175217531772177317B6-17D317DD180B-180D18A91920-192B1930-193B19B0-19C019C819C91A17-1A1B1A55-1A5E1A60-1A7C1A7F1B00-1B041B34-1B441B6B-1B731B80-1B821BA1-1BAA1C24-1C371CD0-1CD21CD4-1CE81CED1CF21DC0-1DE61DFD-1DFF20D0-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66F-A672A67CA67DA6F0A6F1A802A806A80BA823-A827A880A881A8B4-A8C4A8E0-A8F1A926-A92DA947-A953A980-A983A9B3-A9C0AA29-AA36AA43AA4CAA4DAA7BAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE3-ABEAABECABEDFB1EFE00-FE0FFE20-FE26",
    Mn: "0300-036F0483-04870591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DF-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0902093C0941-0948094D0951-095509620963098109BC09C1-09C409CD09E209E30A010A020A3C0A410A420A470A480A4B-0A4D0A510A700A710A750A810A820ABC0AC1-0AC50AC70AC80ACD0AE20AE30B010B3C0B3F0B41-0B440B4D0B560B620B630B820BC00BCD0C3E-0C400C46-0C480C4A-0C4D0C550C560C620C630CBC0CBF0CC60CCC0CCD0CE20CE30D41-0D440D4D0D620D630DCA0DD2-0DD40DD60E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F71-0F7E0F80-0F840F860F870F90-0F970F99-0FBC0FC6102D-10301032-10371039103A103D103E10581059105E-10601071-1074108210851086108D109D135F1712-17141732-1734175217531772177317B7-17BD17C617C9-17D317DD180B-180D18A91920-19221927192819321939-193B1A171A181A561A58-1A5E1A601A621A65-1A6C1A73-1A7C1A7F1B00-1B031B341B36-1B3A1B3C1B421B6B-1B731B801B811BA2-1BA51BA81BA91C2C-1C331C361C371CD0-1CD21CD4-1CE01CE2-1CE81CED1DC0-1DE61DFD-1DFF20D0-20DC20E120E5-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66FA67CA67DA6F0A6F1A802A806A80BA825A826A8C4A8E0-A8F1A926-A92DA947-A951A980-A982A9B3A9B6-A9B9A9BCAA29-AA2EAA31AA32AA35AA36AA43AA4CAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE5ABE8ABEDFB1EFE00-FE0FFE20-FE26",
    Mc: "0903093E-09400949-094C094E0982098309BE-09C009C709C809CB09CC09D70A030A3E-0A400A830ABE-0AC00AC90ACB0ACC0B020B030B3E0B400B470B480B4B0B4C0B570BBE0BBF0BC10BC20BC6-0BC80BCA-0BCC0BD70C01-0C030C41-0C440C820C830CBE0CC0-0CC40CC70CC80CCA0CCB0CD50CD60D020D030D3E-0D400D46-0D480D4A-0D4C0D570D820D830DCF-0DD10DD8-0DDF0DF20DF30F3E0F3F0F7F102B102C10311038103B103C105610571062-10641067-106D108310841087-108C108F109A-109C17B617BE-17C517C717C81923-19261929-192B193019311933-193819B0-19C019C819C91A19-1A1B1A551A571A611A631A641A6D-1A721B041B351B3B1B3D-1B411B431B441B821BA11BA61BA71BAA1C24-1C2B1C341C351CE11CF2A823A824A827A880A881A8B4-A8C3A952A953A983A9B4A9B5A9BAA9BBA9BD-A9C0AA2FAA30AA33AA34AA4DAA7BABE3ABE4ABE6ABE7ABE9ABEAABEC",
    Me: "0488048906DE20DD-20E020E2-20E4A670-A672",
    N:  "0030-003900B200B300B900BC-00BE0660-066906F0-06F907C0-07C90966-096F09E6-09EF09F4-09F90A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BF20C66-0C6F0C78-0C7E0CE6-0CEF0D66-0D750E50-0E590ED0-0ED90F20-0F331040-10491090-10991369-137C16EE-16F017E0-17E917F0-17F91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C5920702074-20792080-20892150-21822185-21892460-249B24EA-24FF2776-27932CFD30073021-30293038-303A3192-31953220-32293251-325F3280-328932B1-32BFA620-A629A6E6-A6EFA830-A835A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
    Nd: "0030-00390660-066906F0-06F907C0-07C90966-096F09E6-09EF0A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BEF0C66-0C6F0CE6-0CEF0D66-0D6F0E50-0E590ED0-0ED90F20-0F291040-10491090-109917E0-17E91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C59A620-A629A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",
    Nl: "16EE-16F02160-21822185-218830073021-30293038-303AA6E6-A6EF",
    No: "00B200B300B900BC-00BE09F4-09F90BF0-0BF20C78-0C7E0D70-0D750F2A-0F331369-137C17F0-17F920702074-20792080-20892150-215F21892460-249B24EA-24FF2776-27932CFD3192-31953220-32293251-325F3280-328932B1-32BFA830-A835",
    P:  "0021-00230025-002A002C-002F003A003B003F0040005B-005D005F007B007D00A100AB00B700BB00BF037E0387055A-055F0589058A05BE05C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F3A-0F3D0F850FD0-0FD4104A-104F10FB1361-13681400166D166E169B169C16EB-16ED1735173617D4-17D617D8-17DA1800-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD32010-20272030-20432045-20512053-205E207D207E208D208E2329232A2768-277527C527C627E6-27EF2983-299829D8-29DB29FC29FD2CF9-2CFC2CFE2CFF2E00-2E2E2E302E313001-30033008-30113014-301F3030303D30A030FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFD3EFD3FFE10-FE19FE30-FE52FE54-FE61FE63FE68FE6AFE6BFF01-FF03FF05-FF0AFF0C-FF0FFF1AFF1BFF1FFF20FF3B-FF3DFF3FFF5BFF5DFF5F-FF65",
    Pd: "002D058A05BE140018062010-20152E172E1A301C303030A0FE31FE32FE58FE63FF0D",
    Ps: "0028005B007B0F3A0F3C169B201A201E2045207D208D23292768276A276C276E27702772277427C527E627E827EA27EC27EE2983298529872989298B298D298F299129932995299729D829DA29FC2E222E242E262E283008300A300C300E3010301430163018301A301DFD3EFE17FE35FE37FE39FE3BFE3DFE3FFE41FE43FE47FE59FE5BFE5DFF08FF3BFF5BFF5FFF62",
    Pe: "0029005D007D0F3B0F3D169C2046207E208E232A2769276B276D276F27712773277527C627E727E927EB27ED27EF298429862988298A298C298E2990299229942996299829D929DB29FD2E232E252E272E293009300B300D300F3011301530173019301B301E301FFD3FFE18FE36FE38FE3AFE3CFE3EFE40FE42FE44FE48FE5AFE5CFE5EFF09FF3DFF5DFF60FF63",
    Pi: "00AB2018201B201C201F20392E022E042E092E0C2E1C2E20",
    Pf: "00BB2019201D203A2E032E052E0A2E0D2E1D2E21",
    Pc: "005F203F20402054FE33FE34FE4D-FE4FFF3F",
    Po: "0021-00230025-0027002A002C002E002F003A003B003F0040005C00A100B700BF037E0387055A-055F058905C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F850FD0-0FD4104A-104F10FB1361-1368166D166E16EB-16ED1735173617D4-17D617D8-17DA1800-18051807-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD3201620172020-20272030-2038203B-203E2041-20432047-205120532055-205E2CF9-2CFC2CFE2CFF2E002E012E06-2E082E0B2E0E-2E162E182E192E1B2E1E2E1F2E2A-2E2E2E302E313001-3003303D30FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFE10-FE16FE19FE30FE45FE46FE49-FE4CFE50-FE52FE54-FE57FE5F-FE61FE68FE6AFE6BFF01-FF03FF05-FF07FF0AFF0CFF0EFF0FFF1AFF1BFF1FFF20FF3CFF61FF64FF65",
    S:  "0024002B003C-003E005E0060007C007E00A2-00A900AC00AE-00B100B400B600B800D700F702C2-02C502D2-02DF02E5-02EB02ED02EF-02FF03750384038503F604820606-0608060B060E060F06E906FD06FE07F609F209F309FA09FB0AF10B700BF3-0BFA0C7F0CF10CF20D790E3F0F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-139917DB194019E0-19FF1B61-1B6A1B74-1B7C1FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE20442052207A-207C208A-208C20A0-20B8210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B2140-2144214A-214D214F2190-2328232B-23E82400-24262440-244A249C-24E92500-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE27C0-27C427C7-27CA27CC27D0-27E527F0-29822999-29D729DC-29FB29FE-2B4C2B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F309B309C319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A700-A716A720A721A789A78AA828-A82BA836-A839AA77-AA79FB29FDFCFDFDFE62FE64-FE66FE69FF04FF0BFF1C-FF1EFF3EFF40FF5CFF5EFFE0-FFE6FFE8-FFEEFFFCFFFD",
    Sm: "002B003C-003E007C007E00AC00B100D700F703F60606-060820442052207A-207C208A-208C2140-2144214B2190-2194219A219B21A021A321A621AE21CE21CF21D221D421F4-22FF2308-230B23202321237C239B-23B323DC-23E125B725C125F8-25FF266F27C0-27C427C7-27CA27CC27D0-27E527F0-27FF2900-29822999-29D729DC-29FB29FE-2AFF2B30-2B442B47-2B4CFB29FE62FE64-FE66FF0BFF1C-FF1EFF5CFF5EFFE2FFE9-FFEC",
    Sc: "002400A2-00A5060B09F209F309FB0AF10BF90E3F17DB20A0-20B8A838FDFCFE69FF04FFE0FFE1FFE5FFE6",
    Sk: "005E006000A800AF00B400B802C2-02C502D2-02DF02E5-02EB02ED02EF-02FF0375038403851FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE309B309CA700-A716A720A721A789A78AFF3EFF40FFE3",
    So: "00A600A700A900AE00B000B60482060E060F06E906FD06FE07F609FA0B700BF3-0BF80BFA0C7F0CF10CF20D790F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-1399194019E0-19FF1B61-1B6A1B74-1B7C210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B214A214C214D214F2195-2199219C-219F21A121A221A421A521A7-21AD21AF-21CD21D021D121D321D5-21F32300-2307230C-231F2322-2328232B-237B237D-239A23B4-23DB23E2-23E82400-24262440-244A249C-24E92500-25B625B8-25C025C2-25F72600-266E2670-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE2800-28FF2B00-2B2F2B452B462B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A828-A82BA836A837A839AA77-AA79FDFDFFE4FFE8FFEDFFEEFFFCFFFD",
    Z:  "002000A01680180E2000-200A20282029202F205F3000",
    Zs: "002000A01680180E2000-200A202F205F3000",
    Zl: "2028",
    Zp: "2029",
    C:  "0000-001F007F-009F00AD03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-0605061C061D0620065F06DD070E070F074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17B417B517DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF200B-200F202A-202E2060-206F20722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-F8FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFD-FF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFFBFFFEFFFF",
    Cc: "0000-001F007F-009F",
    Cf: "00AD0600-060306DD070F17B417B5200B-200F202A-202E2060-2064206A-206FFEFFFFF9-FFFB",
    Co: "E000-F8FF",
    Cs: "D800-DFFF",
    Cn: "03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-05FF06040605061C061D0620065F070E074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF2065-206920722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-D7FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFDFEFEFF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFF8FFFEFFFF"
});

function addUnicodePackage (pack) {
    var codePoint = /\w{4}/g;
    for (var name in pack)
        exports.packages[name] = pack[name].replace(codePoint, "\\u$&");
}

});

ace.define("ace/mode/text",["require","exports","module","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour/cstyle","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"], function(acequire, exports, module) {
"use strict";

var Tokenizer = acequire("../tokenizer").Tokenizer;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
var unicode = acequire("../unicode");
var lang = acequire("../lib/lang");
var TokenIterator = acequire("../token_iterator").TokenIterator;
var Range = acequire("../range").Range;

var Mode = function() {
    this.HighlightRules = TextHighlightRules;
};

(function() {
    this.$defaultBehaviour = new CstyleBehaviour();

    this.tokenRe = new RegExp("^["
        + unicode.packages.L
        + unicode.packages.Mn + unicode.packages.Mc
        + unicode.packages.Nd
        + unicode.packages.Pc + "\\$_]+", "g"
    );

    this.nonTokenRe = new RegExp("^(?:[^"
        + unicode.packages.L
        + unicode.packages.Mn + unicode.packages.Mc
        + unicode.packages.Nd
        + unicode.packages.Pc + "\\$_]|\\s])+", "g"
    );

    this.getTokenizer = function() {
        if (!this.$tokenizer) {
            this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig);
            this.$tokenizer = new Tokenizer(this.$highlightRules.getRules());
        }
        return this.$tokenizer;
    };

    this.lineCommentStart = "";
    this.blockComment = "";

    this.toggleCommentLines = function(state, session, startRow, endRow) {
        var doc = session.doc;

        var ignoreBlankLines = true;
        var shouldRemove = true;
        var minIndent = Infinity;
        var tabSize = session.getTabSize();
        var insertAtTabStop = false;

        if (!this.lineCommentStart) {
            if (!this.blockComment)
                return false;
            var lineCommentStart = this.blockComment.start;
            var lineCommentEnd = this.blockComment.end;
            var regexpStart = new RegExp("^(\\s*)(?:" + lang.escapeRegExp(lineCommentStart) + ")");
            var regexpEnd = new RegExp("(?:" + lang.escapeRegExp(lineCommentEnd) + ")\\s*$");

            var comment = function(line, i) {
                if (testRemove(line, i))
                    return;
                if (!ignoreBlankLines || /\S/.test(line)) {
                    doc.insertInLine({row: i, column: line.length}, lineCommentEnd);
                    doc.insertInLine({row: i, column: minIndent}, lineCommentStart);
                }
            };

            var uncomment = function(line, i) {
                var m;
                if (m = line.match(regexpEnd))
                    doc.removeInLine(i, line.length - m[0].length, line.length);
                if (m = line.match(regexpStart))
                    doc.removeInLine(i, m[1].length, m[0].length);
            };

            var testRemove = function(line, row) {
                if (regexpStart.test(line))
                    return true;
                var tokens = session.getTokens(row);
                for (var i = 0; i < tokens.length; i++) {
                    if (tokens[i].type === "comment")
                        return true;
                }
            };
        } else {
            if (Array.isArray(this.lineCommentStart)) {
                var regexpStart = this.lineCommentStart.map(lang.escapeRegExp).join("|");
                var lineCommentStart = this.lineCommentStart[0];
            } else {
                var regexpStart = lang.escapeRegExp(this.lineCommentStart);
                var lineCommentStart = this.lineCommentStart;
            }
            regexpStart = new RegExp("^(\\s*)(?:" + regexpStart + ") ?");
            
            insertAtTabStop = session.getUseSoftTabs();

            var uncomment = function(line, i) {
                var m = line.match(regexpStart);
                if (!m) return;
                var start = m[1].length, end = m[0].length;
                if (!shouldInsertSpace(line, start, end) && m[0][end - 1] == " ")
                    end--;
                doc.removeInLine(i, start, end);
            };
            var commentWithSpace = lineCommentStart + " ";
            var comment = function(line, i) {
                if (!ignoreBlankLines || /\S/.test(line)) {
                    if (shouldInsertSpace(line, minIndent, minIndent))
                        doc.insertInLine({row: i, column: minIndent}, commentWithSpace);
                    else
                        doc.insertInLine({row: i, column: minIndent}, lineCommentStart);
                }
            };
            var testRemove = function(line, i) {
                return regexpStart.test(line);
            };
            
            var shouldInsertSpace = function(line, before, after) {
                var spaces = 0;
                while (before-- && line.charAt(before) == " ")
                    spaces++;
                if (spaces % tabSize != 0)
                    return false;
                var spaces = 0;
                while (line.charAt(after++) == " ")
                    spaces++;
                if (tabSize > 2)
                    return spaces % tabSize != tabSize - 1;
                else
                    return spaces % tabSize == 0;
                return true;
            };
        }

        function iter(fun) {
            for (var i = startRow; i <= endRow; i++)
                fun(doc.getLine(i), i);
        }


        var minEmptyLength = Infinity;
        iter(function(line, i) {
            var indent = line.search(/\S/);
            if (indent !== -1) {
                if (indent < minIndent)
                    minIndent = indent;
                if (shouldRemove && !testRemove(line, i))
                    shouldRemove = false;
            } else if (minEmptyLength > line.length) {
                minEmptyLength = line.length;
            }
        });

        if (minIndent == Infinity) {
            minIndent = minEmptyLength;
            ignoreBlankLines = false;
            shouldRemove = false;
        }

        if (insertAtTabStop && minIndent % tabSize != 0)
            minIndent = Math.floor(minIndent / tabSize) * tabSize;

        iter(shouldRemove ? uncomment : comment);
    };

    this.toggleBlockComment = function(state, session, range, cursor) {
        var comment = this.blockComment;
        if (!comment)
            return;
        if (!comment.start && comment[0])
            comment = comment[0];

        var iterator = new TokenIterator(session, cursor.row, cursor.column);
        var token = iterator.getCurrentToken();

        var sel = session.selection;
        var initialRange = session.selection.toOrientedRange();
        var startRow, colDiff;

        if (token && /comment/.test(token.type)) {
            var startRange, endRange;
            while (token && /comment/.test(token.type)) {
                var i = token.value.indexOf(comment.start);
                if (i != -1) {
                    var row = iterator.getCurrentTokenRow();
                    var column = iterator.getCurrentTokenColumn() + i;
                    startRange = new Range(row, column, row, column + comment.start.length);
                    break;
                }
                token = iterator.stepBackward();
            }

            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();
            while (token && /comment/.test(token.type)) {
                var i = token.value.indexOf(comment.end);
                if (i != -1) {
                    var row = iterator.getCurrentTokenRow();
                    var column = iterator.getCurrentTokenColumn() + i;
                    endRange = new Range(row, column, row, column + comment.end.length);
                    break;
                }
                token = iterator.stepForward();
            }
            if (endRange)
                session.remove(endRange);
            if (startRange) {
                session.remove(startRange);
                startRow = startRange.start.row;
                colDiff = -comment.start.length;
            }
        } else {
            colDiff = comment.start.length;
            startRow = range.start.row;
            session.insert(range.end, comment.end);
            session.insert(range.start, comment.start);
        }
        if (initialRange.start.row == startRow)
            initialRange.start.column += colDiff;
        if (initialRange.end.row == startRow)
            initialRange.end.column += colDiff;
        session.selection.fromOrientedRange(initialRange);
    };

    this.getNextLineIndent = function(state, line, tab) {
        return this.$getIndent(line);
    };

    this.checkOutdent = function(state, line, input) {
        return false;
    };

    this.autoOutdent = function(state, doc, row) {
    };

    this.$getIndent = function(line) {
        return line.match(/^\s*/)[0];
    };

    this.createWorker = function(session) {
        return null;
    };

    this.createModeDelegates = function (mapping) {
        this.$embeds = [];
        this.$modes = {};
        for (var i in mapping) {
            if (mapping[i]) {
                this.$embeds.push(i);
                this.$modes[i] = new mapping[i]();
            }
        }

        var delegations = ["toggleBlockComment", "toggleCommentLines", "getNextLineIndent", 
            "checkOutdent", "autoOutdent", "transformAction", "getCompletions"];

        for (var i = 0; i < delegations.length; i++) {
            (function(scope) {
              var functionName = delegations[i];
              var defaultHandler = scope[functionName];
              scope[delegations[i]] = function() {
                  return this.$delegator(functionName, arguments, defaultHandler);
              };
            }(this));
        }
    };

    this.$delegator = function(method, args, defaultHandler) {
        var state = args[0];
        if (typeof state != "string")
            state = state[0];
        for (var i = 0; i < this.$embeds.length; i++) {
            if (!this.$modes[this.$embeds[i]]) continue;

            var split = state.split(this.$embeds[i]);
            if (!split[0] && split[1]) {
                args[0] = split[1];
                var mode = this.$modes[this.$embeds[i]];
                return mode[method].apply(mode, args);
            }
        }
        var ret = defaultHandler.apply(this, args);
        return defaultHandler ? ret : undefined;
    };

    this.transformAction = function(state, action, editor, session, param) {
        if (this.$behaviour) {
            var behaviours = this.$behaviour.getBehaviours();
            for (var key in behaviours) {
                if (behaviours[key][action]) {
                    var ret = behaviours[key][action].apply(this, arguments);
                    if (ret) {
                        return ret;
                    }
                }
            }
        }
    };
    
    this.getKeywords = function(append) {
        if (!this.completionKeywords) {
            var rules = this.$tokenizer.rules;
            var completionKeywords = [];
            for (var rule in rules) {
                var ruleItr = rules[rule];
                for (var r = 0, l = ruleItr.length; r < l; r++) {
                    if (typeof ruleItr[r].token === "string") {
                        if (/keyword|support|storage/.test(ruleItr[r].token))
                            completionKeywords.push(ruleItr[r].regex);
                    }
                    else if (typeof ruleItr[r].token === "object") {
                        for (var a = 0, aLength = ruleItr[r].token.length; a < aLength; a++) {    
                            if (/keyword|support|storage/.test(ruleItr[r].token[a])) {
                                var rule = ruleItr[r].regex.match(/\(.+?\)/g)[a];
                                completionKeywords.push(rule.substr(1, rule.length - 2));
                            }
                        }
                    }
                }
            }
            this.completionKeywords = completionKeywords;
        }
        if (!append)
            return this.$keywordList;
        return completionKeywords.concat(this.$keywordList || []);
    };
    
    this.$createKeywordList = function() {
        if (!this.$highlightRules)
            this.getTokenizer();
        return this.$keywordList = this.$highlightRules.$keywordList || [];
    };

    this.getCompletions = function(state, session, pos, prefix) {
        var keywords = this.$keywordList || this.$createKeywordList();
        return keywords.map(function(word) {
            return {
                name: word,
                value: word,
                score: 0,
                meta: "keyword"
            };
        });
    };

    this.$id = "ace/mode/text";
}).call(Mode.prototype);

exports.Mode = Mode;
});

ace.define("ace/apply_delta",["require","exports","module"], function(acequire, exports, module) {
"use strict";

function throwDeltaError(delta, errorText){
    console.log("Invalid Delta:", delta);
    throw "Invalid Delta: " + errorText;
}

function positionInDocument(docLines, position) {
    return position.row    >= 0 && position.row    <  docLines.length &&
           position.column >= 0 && position.column <= docLines[position.row].length;
}

function validateDelta(docLines, delta) {
    if (delta.action != "insert" && delta.action != "remove")
        throwDeltaError(delta, "delta.action must be 'insert' or 'remove'");
    if (!(delta.lines instanceof Array))
        throwDeltaError(delta, "delta.lines must be an Array");
    if (!delta.start || !delta.end)
       throwDeltaError(delta, "delta.start/end must be an present");
    var start = delta.start;
    if (!positionInDocument(docLines, delta.start))
        throwDeltaError(delta, "delta.start must be contained in document");
    var end = delta.end;
    if (delta.action == "remove" && !positionInDocument(docLines, end))
        throwDeltaError(delta, "delta.end must contained in document for 'remove' actions");
    var numRangeRows = end.row - start.row;
    var numRangeLastLineChars = (end.column - (numRangeRows == 0 ? start.column : 0));
    if (numRangeRows != delta.lines.length - 1 || delta.lines[numRangeRows].length != numRangeLastLineChars)
        throwDeltaError(delta, "delta.range must match delta lines");
}

exports.applyDelta = function(docLines, delta, doNotValidate) {
    
    var row = delta.start.row;
    var startColumn = delta.start.column;
    var line = docLines[row] || "";
    switch (delta.action) {
        case "insert":
            var lines = delta.lines;
            if (lines.length === 1) {
                docLines[row] = line.substring(0, startColumn) + delta.lines[0] + line.substring(startColumn);
            } else {
                var args = [row, 1].concat(delta.lines);
                docLines.splice.apply(docLines, args);
                docLines[row] = line.substring(0, startColumn) + docLines[row];
                docLines[row + delta.lines.length - 1] += line.substring(startColumn);
            }
            break;
        case "remove":
            var endColumn = delta.end.column;
            var endRow = delta.end.row;
            if (row === endRow) {
                docLines[row] = line.substring(0, startColumn) + line.substring(endColumn);
            } else {
                docLines.splice(
                    row, endRow - row + 1,
                    line.substring(0, startColumn) + docLines[endRow].substring(endColumn)
                );
            }
            break;
    }
};
});

ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;

var Anchor = exports.Anchor = function(doc, row, column) {
    this.$onChange = this.onChange.bind(this);
    this.attach(doc);
    
    if (typeof column == "undefined")
        this.setPosition(row.row, row.column);
    else
        this.setPosition(row, column);
};

(function() {

    oop.implement(this, EventEmitter);
    this.getPosition = function() {
        return this.$clipPositionToDocument(this.row, this.column);
    };
    this.getDocument = function() {
        return this.document;
    };
    this.$insertRight = false;
    this.onChange = function(delta) {
        if (delta.start.row == delta.end.row && delta.start.row != this.row)
            return;

        if (delta.start.row > this.row)
            return;
            
        var point = $getTransformedPoint(delta, {row: this.row, column: this.column}, this.$insertRight);
        this.setPosition(point.row, point.column, true);
    };
    
    function $pointsInOrder(point1, point2, equalPointsInOrder) {
        var bColIsAfter = equalPointsInOrder ? point1.column <= point2.column : point1.column < point2.column;
        return (point1.row < point2.row) || (point1.row == point2.row && bColIsAfter);
    }
            
    function $getTransformedPoint(delta, point, moveIfEqual) {
        var deltaIsInsert = delta.action == "insert";
        var deltaRowShift = (deltaIsInsert ? 1 : -1) * (delta.end.row    - delta.start.row);
        var deltaColShift = (deltaIsInsert ? 1 : -1) * (delta.end.column - delta.start.column);
        var deltaStart = delta.start;
        var deltaEnd = deltaIsInsert ? deltaStart : delta.end; // Collapse insert range.
        if ($pointsInOrder(point, deltaStart, moveIfEqual)) {
            return {
                row: point.row,
                column: point.column
            };
        }
        if ($pointsInOrder(deltaEnd, point, !moveIfEqual)) {
            return {
                row: point.row + deltaRowShift,
                column: point.column + (point.row == deltaEnd.row ? deltaColShift : 0)
            };
        }
        
        return {
            row: deltaStart.row,
            column: deltaStart.column
        };
    }
    this.setPosition = function(row, column, noClip) {
        var pos;
        if (noClip) {
            pos = {
                row: row,
                column: column
            };
        } else {
            pos = this.$clipPositionToDocument(row, column);
        }

        if (this.row == pos.row && this.column == pos.column)
            return;

        var old = {
            row: this.row,
            column: this.column
        };

        this.row = pos.row;
        this.column = pos.column;
        this._signal("change", {
            old: old,
            value: pos
        });
    };
    this.detach = function() {
        this.document.removeEventListener("change", this.$onChange);
    };
    this.attach = function(doc) {
        this.document = doc || this.document;
        this.document.on("change", this.$onChange);
    };
    this.$clipPositionToDocument = function(row, column) {
        var pos = {};

        if (row >= this.document.getLength()) {
            pos.row = Math.max(0, this.document.getLength() - 1);
            pos.column = this.document.getLine(pos.row).length;
        }
        else if (row < 0) {
            pos.row = 0;
            pos.column = 0;
        }
        else {
            pos.row = row;
            pos.column = Math.min(this.document.getLine(pos.row).length, Math.max(0, column));
        }

        if (column < 0)
            pos.column = 0;

        return pos;
    };

}).call(Anchor.prototype);

});

ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var applyDelta = acequire("./apply_delta").applyDelta;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var Range = acequire("./range").Range;
var Anchor = acequire("./anchor").Anchor;

var Document = function(textOrLines) {
    this.$lines = [""];
    if (textOrLines.length === 0) {
        this.$lines = [""];
    } else if (Array.isArray(textOrLines)) {
        this.insertMergedLines({row: 0, column: 0}, textOrLines);
    } else {
        this.insert({row: 0, column:0}, textOrLines);
    }
};

(function() {

    oop.implement(this, EventEmitter);
    this.setValue = function(text) {
        var len = this.getLength() - 1;
        this.remove(new Range(0, 0, len, this.getLine(len).length));
        this.insert({row: 0, column: 0}, text);
    };
    this.getValue = function() {
        return this.getAllLines().join(this.getNewLineCharacter());
    };
    this.createAnchor = function(row, column) {
        return new Anchor(this, row, column);
    };
    if ("aaa".split(/a/).length === 0) {
        this.$split = function(text) {
            return text.replace(/\r\n|\r/g, "\n").split("\n");
        };
    } else {
        this.$split = function(text) {
            return text.split(/\r\n|\r|\n/);
        };
    }


    this.$detectNewLine = function(text) {
        var match = text.match(/^.*?(\r\n|\r|\n)/m);
        this.$autoNewLine = match ? match[1] : "\n";
        this._signal("changeNewLineMode");
    };
    this.getNewLineCharacter = function() {
        switch (this.$newLineMode) {
          case "windows":
            return "\r\n";
          case "unix":
            return "\n";
          default:
            return this.$autoNewLine || "\n";
        }
    };

    this.$autoNewLine = "";
    this.$newLineMode = "auto";
    this.setNewLineMode = function(newLineMode) {
        if (this.$newLineMode === newLineMode)
            return;

        this.$newLineMode = newLineMode;
        this._signal("changeNewLineMode");
    };
    this.getNewLineMode = function() {
        return this.$newLineMode;
    };
    this.isNewLine = function(text) {
        return (text == "\r\n" || text == "\r" || text == "\n");
    };
    this.getLine = function(row) {
        return this.$lines[row] || "";
    };
    this.getLines = function(firstRow, lastRow) {
        return this.$lines.slice(firstRow, lastRow + 1);
    };
    this.getAllLines = function() {
        return this.getLines(0, this.getLength());
    };
    this.getLength = function() {
        return this.$lines.length;
    };
    this.getTextRange = function(range) {
        return this.getLinesForRange(range).join(this.getNewLineCharacter());
    };
    this.getLinesForRange = function(range) {
        var lines;
        if (range.start.row === range.end.row) {
            lines = [this.getLine(range.start.row).substring(range.start.column, range.end.column)];
        } else {
            lines = this.getLines(range.start.row, range.end.row);
            lines[0] = (lines[0] || "").substring(range.start.column);
            var l = lines.length - 1;
            if (range.end.row - range.start.row == l)
                lines[l] = lines[l].substring(0, range.end.column);
        }
        return lines;
    };
    this.insertLines = function(row, lines) {
        console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead.");
        return this.insertFullLines(row, lines);
    };
    this.removeLines = function(firstRow, lastRow) {
        console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead.");
        return this.removeFullLines(firstRow, lastRow);
    };
    this.insertNewLine = function(position) {
        console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.");
        return this.insertMergedLines(position, ["", ""]);
    };
    this.insert = function(position, text) {
        if (this.getLength() <= 1)
            this.$detectNewLine(text);
        
        return this.insertMergedLines(position, this.$split(text));
    };
    this.insertInLine = function(position, text) {
        var start = this.clippedPos(position.row, position.column);
        var end = this.pos(position.row, position.column + text.length);
        
        this.applyDelta({
            start: start,
            end: end,
            action: "insert",
            lines: [text]
        }, true);
        
        return this.clonePos(end);
    };
    
    this.clippedPos = function(row, column) {
        var length = this.getLength();
        if (row === undefined) {
            row = length;
        } else if (row < 0) {
            row = 0;
        } else if (row >= length) {
            row = length - 1;
            column = undefined;
        }
        var line = this.getLine(row);
        if (column == undefined)
            column = line.length;
        column = Math.min(Math.max(column, 0), line.length);
        return {row: row, column: column};
    };
    
    this.clonePos = function(pos) {
        return {row: pos.row, column: pos.column};
    };
    
    this.pos = function(row, column) {
        return {row: row, column: column};
    };
    
    this.$clipPosition = function(position) {
        var length = this.getLength();
        if (position.row >= length) {
            position.row = Math.max(0, length - 1);
            position.column = this.getLine(length - 1).length;
        } else {
            position.row = Math.max(0, position.row);
            position.column = Math.min(Math.max(position.column, 0), this.getLine(position.row).length);
        }
        return position;
    };
    this.insertFullLines = function(row, lines) {
        row = Math.min(Math.max(row, 0), this.getLength());
        var column = 0;
        if (row < this.getLength()) {
            lines = lines.concat([""]);
            column = 0;
        } else {
            lines = [""].concat(lines);
            row--;
            column = this.$lines[row].length;
        }
        this.insertMergedLines({row: row, column: column}, lines);
    };    
    this.insertMergedLines = function(position, lines) {
        var start = this.clippedPos(position.row, position.column);
        var end = {
            row: start.row + lines.length - 1,
            column: (lines.length == 1 ? start.column : 0) + lines[lines.length - 1].length
        };
        
        this.applyDelta({
            start: start,
            end: end,
            action: "insert",
            lines: lines
        });
        
        return this.clonePos(end);
    };
    this.remove = function(range) {
        var start = this.clippedPos(range.start.row, range.start.column);
        var end = this.clippedPos(range.end.row, range.end.column);
        this.applyDelta({
            start: start,
            end: end,
            action: "remove",
            lines: this.getLinesForRange({start: start, end: end})
        });
        return this.clonePos(start);
    };
    this.removeInLine = function(row, startColumn, endColumn) {
        var start = this.clippedPos(row, startColumn);
        var end = this.clippedPos(row, endColumn);
        
        this.applyDelta({
            start: start,
            end: end,
            action: "remove",
            lines: this.getLinesForRange({start: start, end: end})
        }, true);
        
        return this.clonePos(start);
    };
    this.removeFullLines = function(firstRow, lastRow) {
        firstRow = Math.min(Math.max(0, firstRow), this.getLength() - 1);
        lastRow  = Math.min(Math.max(0, lastRow ), this.getLength() - 1);
        var deleteFirstNewLine = lastRow == this.getLength() - 1 && firstRow > 0;
        var deleteLastNewLine  = lastRow  < this.getLength() - 1;
        var startRow = ( deleteFirstNewLine ? firstRow - 1                  : firstRow                    );
        var startCol = ( deleteFirstNewLine ? this.getLine(startRow).length : 0                           );
        var endRow   = ( deleteLastNewLine  ? lastRow + 1                   : lastRow                     );
        var endCol   = ( deleteLastNewLine  ? 0                             : this.getLine(endRow).length ); 
        var range = new Range(startRow, startCol, endRow, endCol);
        var deletedLines = this.$lines.slice(firstRow, lastRow + 1);
        
        this.applyDelta({
            start: range.start,
            end: range.end,
            action: "remove",
            lines: this.getLinesForRange(range)
        });
        return deletedLines;
    };
    this.removeNewLine = function(row) {
        if (row < this.getLength() - 1 && row >= 0) {
            this.applyDelta({
                start: this.pos(row, this.getLine(row).length),
                end: this.pos(row + 1, 0),
                action: "remove",
                lines: ["", ""]
            });
        }
    };
    this.replace = function(range, text) {
        if (!(range instanceof Range))
            range = Range.fromPoints(range.start, range.end);
        if (text.length === 0 && range.isEmpty())
            return range.start;
        if (text == this.getTextRange(range))
            return range.end;

        this.remove(range);
        var end;
        if (text) {
            end = this.insert(range.start, text);
        }
        else {
            end = range.start;
        }
        
        return end;
    };
    this.applyDeltas = function(deltas) {
        for (var i=0; i<deltas.length; i++) {
            this.applyDelta(deltas[i]);
        }
    };
    this.revertDeltas = function(deltas) {
        for (var i=deltas.length-1; i>=0; i--) {
            this.revertDelta(deltas[i]);
        }
    };
    this.applyDelta = function(delta, doNotValidate) {
        var isInsert = delta.action == "insert";
        if (isInsert ? delta.lines.length <= 1 && !delta.lines[0]
            : !Range.comparePoints(delta.start, delta.end)) {
            return;
        }
        
        if (isInsert && delta.lines.length > 20000)
            this.$splitAndapplyLargeDelta(delta, 20000);
        applyDelta(this.$lines, delta, doNotValidate);
        this._signal("change", delta);
    };
    
    this.$splitAndapplyLargeDelta = function(delta, MAX) {
        var lines = delta.lines;
        var l = lines.length;
        var row = delta.start.row; 
        var column = delta.start.column;
        var from = 0, to = 0;
        do {
            from = to;
            to += MAX - 1;
            var chunk = lines.slice(from, to);
            if (to > l) {
                delta.lines = chunk;
                delta.start.row = row + from;
                delta.start.column = column;
                break;
            }
            chunk.push("");
            this.applyDelta({
                start: this.pos(row + from, column),
                end: this.pos(row + to, column = 0),
                action: delta.action,
                lines: chunk
            }, true);
        } while(true);
    };
    this.revertDelta = function(delta) {
        this.applyDelta({
            start: this.clonePos(delta.start),
            end: this.clonePos(delta.end),
            action: (delta.action == "insert" ? "remove" : "insert"),
            lines: delta.lines.slice()
        });
    };
    this.indexToPosition = function(index, startRow) {
        var lines = this.$lines || this.getAllLines();
        var newlineLength = this.getNewLineCharacter().length;
        for (var i = startRow || 0, l = lines.length; i < l; i++) {
            index -= lines[i].length + newlineLength;
            if (index < 0)
                return {row: i, column: index + lines[i].length + newlineLength};
        }
        return {row: l-1, column: lines[l-1].length};
    };
    this.positionToIndex = function(pos, startRow) {
        var lines = this.$lines || this.getAllLines();
        var newlineLength = this.getNewLineCharacter().length;
        var index = 0;
        var row = Math.min(pos.row, lines.length);
        for (var i = startRow || 0; i < row; ++i)
            index += lines[i].length + newlineLength;

        return index + pos.column;
    };

}).call(Document.prototype);

exports.Document = Document;
});

ace.define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;

var BackgroundTokenizer = function(tokenizer, editor) {
    this.running = false;
    this.lines = [];
    this.states = [];
    this.currentLine = 0;
    this.tokenizer = tokenizer;

    var self = this;

    this.$worker = function() {
        if (!self.running) { return; }

        var workerStart = new Date();
        var currentLine = self.currentLine;
        var endLine = -1;
        var doc = self.doc;

        var startLine = currentLine;
        while (self.lines[currentLine])
            currentLine++;
        
        var len = doc.getLength();
        var processedLines = 0;
        self.running = false;
        while (currentLine < len) {
            self.$tokenizeRow(currentLine);
            endLine = currentLine;
            do {
                currentLine++;
            } while (self.lines[currentLine]);
            processedLines ++;
            if ((processedLines % 5 === 0) && (new Date() - workerStart) > 20) {                
                self.running = setTimeout(self.$worker, 20);
                break;
            }
        }
        self.currentLine = currentLine;
        
        if (endLine == -1)
            endLine = currentLine;

        if (startLine <= endLine)
            self.fireUpdateEvent(startLine, endLine);
    };
};

(function(){

    oop.implement(this, EventEmitter);
    this.setTokenizer = function(tokenizer) {
        this.tokenizer = tokenizer;
        this.lines = [];
        this.states = [];

        this.start(0);
    };
    this.setDocument = function(doc) {
        this.doc = doc;
        this.lines = [];
        this.states = [];

        this.stop();
    };
    this.fireUpdateEvent = function(firstRow, lastRow) {
        var data = {
            first: firstRow,
            last: lastRow
        };
        this._signal("update", {data: data});
    };
    this.start = function(startRow) {
        this.currentLine = Math.min(startRow || 0, this.currentLine, this.doc.getLength());
        this.lines.splice(this.currentLine, this.lines.length);
        this.states.splice(this.currentLine, this.states.length);

        this.stop();
        this.running = setTimeout(this.$worker, 700);
    };
    
    this.scheduleStart = function() {
        if (!this.running)
            this.running = setTimeout(this.$worker, 700);
    };

    this.$updateOnChange = function(delta) {
        var startRow = delta.start.row;
        var len = delta.end.row - startRow;

        if (len === 0) {
            this.lines[startRow] = null;
        } else if (delta.action == "remove") {
            this.lines.splice(startRow, len + 1, null);
            this.states.splice(startRow, len + 1, null);
        } else {
            var args = Array(len + 1);
            args.unshift(startRow, 1);
            this.lines.splice.apply(this.lines, args);
            this.states.splice.apply(this.states, args);
        }

        this.currentLine = Math.min(startRow, this.currentLine, this.doc.getLength());

        this.stop();
    };
    this.stop = function() {
        if (this.running)
            clearTimeout(this.running);
        this.running = false;
    };
    this.getTokens = function(row) {
        return this.lines[row] || this.$tokenizeRow(row);
    };
    this.getState = function(row) {
        if (this.currentLine == row)
            this.$tokenizeRow(row);
        return this.states[row] || "start";
    };

    this.$tokenizeRow = function(row) {
        var line = this.doc.getLine(row);
        var state = this.states[row - 1];

        var data = this.tokenizer.getLineTokens(line, state, row);

        if (this.states[row] + "" !== data.state + "") {
            this.states[row] = data.state;
            this.lines[row + 1] = null;
            if (this.currentLine > row + 1)
                this.currentLine = row + 1;
        } else if (this.currentLine == row) {
            this.currentLine = row + 1;
        }

        return this.lines[row] = data.tokens;
    };

}).call(BackgroundTokenizer.prototype);

exports.BackgroundTokenizer = BackgroundTokenizer;
});

ace.define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"], function(acequire, exports, module) {
"use strict";

var lang = acequire("./lib/lang");
var oop = acequire("./lib/oop");
var Range = acequire("./range").Range;

var SearchHighlight = function(regExp, clazz, type) {
    this.setRegexp(regExp);
    this.clazz = clazz;
    this.type = type || "text";
};

(function() {
    this.MAX_RANGES = 500;
    
    this.setRegexp = function(regExp) {
        if (this.regExp+"" == regExp+"")
            return;
        this.regExp = regExp;
        this.cache = [];
    };

    this.update = function(html, markerLayer, session, config) {
        if (!this.regExp)
            return;
        var start = config.firstRow, end = config.lastRow;

        for (var i = start; i <= end; i++) {
            var ranges = this.cache[i];
            if (ranges == null) {
                ranges = lang.getMatchOffsets(session.getLine(i), this.regExp);
                if (ranges.length > this.MAX_RANGES)
                    ranges = ranges.slice(0, this.MAX_RANGES);
                ranges = ranges.map(function(match) {
                    return new Range(i, match.offset, i, match.offset + match.length);
                });
                this.cache[i] = ranges.length ? ranges : "";
            }

            for (var j = ranges.length; j --; ) {
                markerLayer.drawSingleLineMarker(
                    html, ranges[j].toScreenRange(session), this.clazz, config);
            }
        }
    };

}).call(SearchHighlight.prototype);

exports.SearchHighlight = SearchHighlight;
});

ace.define("ace/edit_session/fold_line",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
function FoldLine(foldData, folds) {
    this.foldData = foldData;
    if (Array.isArray(folds)) {
        this.folds = folds;
    } else {
        folds = this.folds = [ folds ];
    }

    var last = folds[folds.length - 1];
    this.range = new Range(folds[0].start.row, folds[0].start.column,
                           last.end.row, last.end.column);
    this.start = this.range.start;
    this.end   = this.range.end;

    this.folds.forEach(function(fold) {
        fold.setFoldLine(this);
    }, this);
}

(function() {
    this.shiftRow = function(shift) {
        this.start.row += shift;
        this.end.row += shift;
        this.folds.forEach(function(fold) {
            fold.start.row += shift;
            fold.end.row += shift;
        });
    };

    this.addFold = function(fold) {
        if (fold.sameRow) {
            if (fold.start.row < this.startRow || fold.endRow > this.endRow) {
                throw new Error("Can't add a fold to this FoldLine as it has no connection");
            }
            this.folds.push(fold);
            this.folds.sort(function(a, b) {
                return -a.range.compareEnd(b.start.row, b.start.column);
            });
            if (this.range.compareEnd(fold.start.row, fold.start.column) > 0) {
                this.end.row = fold.end.row;
                this.end.column =  fold.end.column;
            } else if (this.range.compareStart(fold.end.row, fold.end.column) < 0) {
                this.start.row = fold.start.row;
                this.start.column = fold.start.column;
            }
        } else if (fold.start.row == this.end.row) {
            this.folds.push(fold);
            this.end.row = fold.end.row;
            this.end.column = fold.end.column;
        } else if (fold.end.row == this.start.row) {
            this.folds.unshift(fold);
            this.start.row = fold.start.row;
            this.start.column = fold.start.column;
        } else {
            throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
        }
        fold.foldLine = this;
    };

    this.containsRow = function(row) {
        return row >= this.start.row && row <= this.end.row;
    };

    this.walk = function(callback, endRow, endColumn) {
        var lastEnd = 0,
            folds = this.folds,
            fold,
            cmp, stop, isNewRow = true;

        if (endRow == null) {
            endRow = this.end.row;
            endColumn = this.end.column;
        }

        for (var i = 0; i < folds.length; i++) {
            fold = folds[i];

            cmp = fold.range.compareStart(endRow, endColumn);
            if (cmp == -1) {
                callback(null, endRow, endColumn, lastEnd, isNewRow);
                return;
            }

            stop = callback(null, fold.start.row, fold.start.column, lastEnd, isNewRow);
            stop = !stop && callback(fold.placeholder, fold.start.row, fold.start.column, lastEnd);
            if (stop || cmp === 0) {
                return;
            }
            isNewRow = !fold.sameRow;
            lastEnd = fold.end.column;
        }
        callback(null, endRow, endColumn, lastEnd, isNewRow);
    };

    this.getNextFoldTo = function(row, column) {
        var fold, cmp;
        for (var i = 0; i < this.folds.length; i++) {
            fold = this.folds[i];
            cmp = fold.range.compareEnd(row, column);
            if (cmp == -1) {
                return {
                    fold: fold,
                    kind: "after"
                };
            } else if (cmp === 0) {
                return {
                    fold: fold,
                    kind: "inside"
                };
            }
        }
        return null;
    };

    this.addRemoveChars = function(row, column, len) {
        var ret = this.getNextFoldTo(row, column),
            fold, folds;
        if (ret) {
            fold = ret.fold;
            if (ret.kind == "inside"
                && fold.start.column != column
                && fold.start.row != row)
            {
                window.console && window.console.log(row, column, fold);
            } else if (fold.start.row == row) {
                folds = this.folds;
                var i = folds.indexOf(fold);
                if (i === 0) {
                    this.start.column += len;
                }
                for (i; i < folds.length; i++) {
                    fold = folds[i];
                    fold.start.column += len;
                    if (!fold.sameRow) {
                        return;
                    }
                    fold.end.column += len;
                }
                this.end.column += len;
            }
        }
    };

    this.split = function(row, column) {
        var pos = this.getNextFoldTo(row, column);
        
        if (!pos || pos.kind == "inside")
            return null;
            
        var fold = pos.fold;
        var folds = this.folds;
        var foldData = this.foldData;
        
        var i = folds.indexOf(fold);
        var foldBefore = folds[i - 1];
        this.end.row = foldBefore.end.row;
        this.end.column = foldBefore.end.column;
        folds = folds.splice(i, folds.length - i);

        var newFoldLine = new FoldLine(foldData, folds);
        foldData.splice(foldData.indexOf(this) + 1, 0, newFoldLine);
        return newFoldLine;
    };

    this.merge = function(foldLineNext) {
        var folds = foldLineNext.folds;
        for (var i = 0; i < folds.length; i++) {
            this.addFold(folds[i]);
        }
        var foldData = this.foldData;
        foldData.splice(foldData.indexOf(foldLineNext), 1);
    };

    this.toString = function() {
        var ret = [this.range.toString() + ": [" ];

        this.folds.forEach(function(fold) {
            ret.push("  " + fold.toString());
        });
        ret.push("]");
        return ret.join("\n");
    };

    this.idxToPosition = function(idx) {
        var lastFoldEndColumn = 0;

        for (var i = 0; i < this.folds.length; i++) {
            var fold = this.folds[i];

            idx -= fold.start.column - lastFoldEndColumn;
            if (idx < 0) {
                return {
                    row: fold.start.row,
                    column: fold.start.column + idx
                };
            }

            idx -= fold.placeholder.length;
            if (idx < 0) {
                return fold.start;
            }

            lastFoldEndColumn = fold.end.column;
        }

        return {
            row: this.end.row,
            column: this.end.column + idx
        };
    };
}).call(FoldLine.prototype);

exports.FoldLine = FoldLine;
});

ace.define("ace/range_list",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";
var Range = acequire("./range").Range;
var comparePoints = Range.comparePoints;

var RangeList = function() {
    this.ranges = [];
};

(function() {
    this.comparePoints = comparePoints;

    this.pointIndex = function(pos, excludeEdges, startIndex) {
        var list = this.ranges;

        for (var i = startIndex || 0; i < list.length; i++) {
            var range = list[i];
            var cmpEnd = comparePoints(pos, range.end);
            if (cmpEnd > 0)
                continue;
            var cmpStart = comparePoints(pos, range.start);
            if (cmpEnd === 0)
                return excludeEdges && cmpStart !== 0 ? -i-2 : i;
            if (cmpStart > 0 || (cmpStart === 0 && !excludeEdges))
                return i;

            return -i-1;
        }
        return -i - 1;
    };

    this.add = function(range) {
        var excludeEdges = !range.isEmpty();
        var startIndex = this.pointIndex(range.start, excludeEdges);
        if (startIndex < 0)
            startIndex = -startIndex - 1;

        var endIndex = this.pointIndex(range.end, excludeEdges, startIndex);

        if (endIndex < 0)
            endIndex = -endIndex - 1;
        else
            endIndex++;
        return this.ranges.splice(startIndex, endIndex - startIndex, range);
    };

    this.addList = function(list) {
        var removed = [];
        for (var i = list.length; i--; ) {
            removed.push.apply(removed, this.add(list[i]));
        }
        return removed;
    };

    this.substractPoint = function(pos) {
        var i = this.pointIndex(pos);

        if (i >= 0)
            return this.ranges.splice(i, 1);
    };
    this.merge = function() {
        var removed = [];
        var list = this.ranges;
        
        list = list.sort(function(a, b) {
            return comparePoints(a.start, b.start);
        });
        
        var next = list[0], range;
        for (var i = 1; i < list.length; i++) {
            range = next;
            next = list[i];
            var cmp = comparePoints(range.end, next.start);
            if (cmp < 0)
                continue;

            if (cmp == 0 && !range.isEmpty() && !next.isEmpty())
                continue;

            if (comparePoints(range.end, next.end) < 0) {
                range.end.row = next.end.row;
                range.end.column = next.end.column;
            }

            list.splice(i, 1);
            removed.push(next);
            next = range;
            i--;
        }
        
        this.ranges = list;

        return removed;
    };

    this.contains = function(row, column) {
        return this.pointIndex({row: row, column: column}) >= 0;
    };

    this.containsPoint = function(pos) {
        return this.pointIndex(pos) >= 0;
    };

    this.rangeAtPoint = function(pos) {
        var i = this.pointIndex(pos);
        if (i >= 0)
            return this.ranges[i];
    };


    this.clipRows = function(startRow, endRow) {
        var list = this.ranges;
        if (list[0].start.row > endRow || list[list.length - 1].start.row < startRow)
            return [];

        var startIndex = this.pointIndex({row: startRow, column: 0});
        if (startIndex < 0)
            startIndex = -startIndex - 1;
        var endIndex = this.pointIndex({row: endRow, column: 0}, startIndex);
        if (endIndex < 0)
            endIndex = -endIndex - 1;

        var clipped = [];
        for (var i = startIndex; i < endIndex; i++) {
            clipped.push(list[i]);
        }
        return clipped;
    };

    this.removeAll = function() {
        return this.ranges.splice(0, this.ranges.length);
    };

    this.attach = function(session) {
        if (this.session)
            this.detach();

        this.session = session;
        this.onChange = this.$onChange.bind(this);

        this.session.on('change', this.onChange);
    };

    this.detach = function() {
        if (!this.session)
            return;
        this.session.removeListener('change', this.onChange);
        this.session = null;
    };

    this.$onChange = function(delta) {
        if (delta.action == "insert"){
            var start = delta.start;
            var end = delta.end;
        } else {
            var end = delta.start;
            var start = delta.end;
        }
        var startRow = start.row;
        var endRow = end.row;
        var lineDif = endRow - startRow;

        var colDiff = -start.column + end.column;
        var ranges = this.ranges;

        for (var i = 0, n = ranges.length; i < n; i++) {
            var r = ranges[i];
            if (r.end.row < startRow)
                continue;
            if (r.start.row > startRow)
                break;

            if (r.start.row == startRow && r.start.column >= start.column ) {
                if (r.start.column == start.column && this.$insertRight) {
                } else {
                    r.start.column += colDiff;
                    r.start.row += lineDif;
                }
            }
            if (r.end.row == startRow && r.end.column >= start.column) {
                if (r.end.column == start.column && this.$insertRight) {
                    continue;
                }
                if (r.end.column == start.column && colDiff > 0 && i < n - 1) {                
                    if (r.end.column > r.start.column && r.end.column == ranges[i+1].start.column)
                        r.end.column -= colDiff;
                }
                r.end.column += colDiff;
                r.end.row += lineDif;
            }
        }

        if (lineDif != 0 && i < n) {
            for (; i < n; i++) {
                var r = ranges[i];
                r.start.row += lineDif;
                r.end.row += lineDif;
            }
        }
    };

}).call(RangeList.prototype);

exports.RangeList = RangeList;
});

ace.define("ace/edit_session/fold",["require","exports","module","ace/range","ace/range_list","ace/lib/oop"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
var RangeList = acequire("../range_list").RangeList;
var oop = acequire("../lib/oop");
var Fold = exports.Fold = function(range, placeholder) {
    this.foldLine = null;
    this.placeholder = placeholder;
    this.range = range;
    this.start = range.start;
    this.end = range.end;

    this.sameRow = range.start.row == range.end.row;
    this.subFolds = this.ranges = [];
};

oop.inherits(Fold, RangeList);

(function() {

    this.toString = function() {
        return '"' + this.placeholder + '" ' + this.range.toString();
    };

    this.setFoldLine = function(foldLine) {
        this.foldLine = foldLine;
        this.subFolds.forEach(function(fold) {
            fold.setFoldLine(foldLine);
        });
    };

    this.clone = function() {
        var range = this.range.clone();
        var fold = new Fold(range, this.placeholder);
        this.subFolds.forEach(function(subFold) {
            fold.subFolds.push(subFold.clone());
        });
        fold.collapseChildren = this.collapseChildren;
        return fold;
    };

    this.addSubFold = function(fold) {
        if (this.range.isEqual(fold))
            return;

        if (!this.range.containsRange(fold))
            throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);
        consumeRange(fold, this.start);

        var row = fold.start.row, column = fold.start.column;
        for (var i = 0, cmp = -1; i < this.subFolds.length; i++) {
            cmp = this.subFolds[i].range.compare(row, column);
            if (cmp != 1)
                break;
        }
        var afterStart = this.subFolds[i];

        if (cmp == 0)
            return afterStart.addSubFold(fold);
        var row = fold.range.end.row, column = fold.range.end.column;
        for (var j = i, cmp = -1; j < this.subFolds.length; j++) {
            cmp = this.subFolds[j].range.compare(row, column);
            if (cmp != 1)
                break;
        }
        var afterEnd = this.subFolds[j];

        if (cmp == 0)
            throw new Error("A fold can't intersect already existing fold" + fold.range + this.range);

        var consumedFolds = this.subFolds.splice(i, j - i, fold);
        fold.setFoldLine(this.foldLine);

        return fold;
    };
    
    this.restoreRange = function(range) {
        return restoreRange(range, this.start);
    };

}).call(Fold.prototype);

function consumePoint(point, anchor) {
    point.row -= anchor.row;
    if (point.row == 0)
        point.column -= anchor.column;
}
function consumeRange(range, anchor) {
    consumePoint(range.start, anchor);
    consumePoint(range.end, anchor);
}
function restorePoint(point, anchor) {
    if (point.row == 0)
        point.column += anchor.column;
    point.row += anchor.row;
}
function restoreRange(range, anchor) {
    restorePoint(range.start, anchor);
    restorePoint(range.end, anchor);
}

});

ace.define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
var FoldLine = acequire("./fold_line").FoldLine;
var Fold = acequire("./fold").Fold;
var TokenIterator = acequire("../token_iterator").TokenIterator;

function Folding() {
    this.getFoldAt = function(row, column, side) {
        var foldLine = this.getFoldLine(row);
        if (!foldLine)
            return null;

        var folds = foldLine.folds;
        for (var i = 0; i < folds.length; i++) {
            var fold = folds[i];
            if (fold.range.contains(row, column)) {
                if (side == 1 && fold.range.isEnd(row, column)) {
                    continue;
                } else if (side == -1 && fold.range.isStart(row, column)) {
                    continue;
                }
                return fold;
            }
        }
    };
    this.getFoldsInRange = function(range) {
        var start = range.start;
        var end = range.end;
        var foldLines = this.$foldData;
        var foundFolds = [];

        start.column += 1;
        end.column -= 1;

        for (var i = 0; i < foldLines.length; i++) {
            var cmp = foldLines[i].range.compareRange(range);
            if (cmp == 2) {
                continue;
            }
            else if (cmp == -2) {
                break;
            }

            var folds = foldLines[i].folds;
            for (var j = 0; j < folds.length; j++) {
                var fold = folds[j];
                cmp = fold.range.compareRange(range);
                if (cmp == -2) {
                    break;
                } else if (cmp == 2) {
                    continue;
                } else
                if (cmp == 42) {
                    break;
                }
                foundFolds.push(fold);
            }
        }
        start.column -= 1;
        end.column += 1;

        return foundFolds;
    };

    this.getFoldsInRangeList = function(ranges) {
        if (Array.isArray(ranges)) {
            var folds = [];
            ranges.forEach(function(range) {
                folds = folds.concat(this.getFoldsInRange(range));
            }, this);
        } else {
            var folds = this.getFoldsInRange(ranges);
        }
        return folds;
    };
    this.getAllFolds = function() {
        var folds = [];
        var foldLines = this.$foldData;
        
        for (var i = 0; i < foldLines.length; i++)
            for (var j = 0; j < foldLines[i].folds.length; j++)
                folds.push(foldLines[i].folds[j]);

        return folds;
    };
    this.getFoldStringAt = function(row, column, trim, foldLine) {
        foldLine = foldLine || this.getFoldLine(row);
        if (!foldLine)
            return null;

        var lastFold = {
            end: { column: 0 }
        };
        var str, fold;
        for (var i = 0; i < foldLine.folds.length; i++) {
            fold = foldLine.folds[i];
            var cmp = fold.range.compareEnd(row, column);
            if (cmp == -1) {
                str = this
                    .getLine(fold.start.row)
                    .substring(lastFold.end.column, fold.start.column);
                break;
            }
            else if (cmp === 0) {
                return null;
            }
            lastFold = fold;
        }
        if (!str)
            str = this.getLine(fold.start.row).substring(lastFold.end.column);

        if (trim == -1)
            return str.substring(0, column - lastFold.end.column);
        else if (trim == 1)
            return str.substring(column - lastFold.end.column);
        else
            return str;
    };

    this.getFoldLine = function(docRow, startFoldLine) {
        var foldData = this.$foldData;
        var i = 0;
        if (startFoldLine)
            i = foldData.indexOf(startFoldLine);
        if (i == -1)
            i = 0;
        for (i; i < foldData.length; i++) {
            var foldLine = foldData[i];
            if (foldLine.start.row <= docRow && foldLine.end.row >= docRow) {
                return foldLine;
            } else if (foldLine.end.row > docRow) {
                return null;
            }
        }
        return null;
    };
    this.getNextFoldLine = function(docRow, startFoldLine) {
        var foldData = this.$foldData;
        var i = 0;
        if (startFoldLine)
            i = foldData.indexOf(startFoldLine);
        if (i == -1)
            i = 0;
        for (i; i < foldData.length; i++) {
            var foldLine = foldData[i];
            if (foldLine.end.row >= docRow) {
                return foldLine;
            }
        }
        return null;
    };

    this.getFoldedRowCount = function(first, last) {
        var foldData = this.$foldData, rowCount = last-first+1;
        for (var i = 0; i < foldData.length; i++) {
            var foldLine = foldData[i],
                end = foldLine.end.row,
                start = foldLine.start.row;
            if (end >= last) {
                if (start < last) {
                    if (start >= first)
                        rowCount -= last-start;
                    else
                        rowCount = 0; // in one fold
                }
                break;
            } else if (end >= first){
                if (start >= first) // fold inside range
                    rowCount -=  end-start;
                else
                    rowCount -=  end-first+1;
            }
        }
        return rowCount;
    };

    this.$addFoldLine = function(foldLine) {
        this.$foldData.push(foldLine);
        this.$foldData.sort(function(a, b) {
            return a.start.row - b.start.row;
        });
        return foldLine;
    };
    this.addFold = function(placeholder, range) {
        var foldData = this.$foldData;
        var added = false;
        var fold;
        
        if (placeholder instanceof Fold)
            fold = placeholder;
        else {
            fold = new Fold(range, placeholder);
            fold.collapseChildren = range.collapseChildren;
        }
        this.$clipRangeToDocument(fold.range);

        var startRow = fold.start.row;
        var startColumn = fold.start.column;
        var endRow = fold.end.row;
        var endColumn = fold.end.column;
        if (!(startRow < endRow || 
            startRow == endRow && startColumn <= endColumn - 2))
            throw new Error("The range has to be at least 2 characters width");

        var startFold = this.getFoldAt(startRow, startColumn, 1);
        var endFold = this.getFoldAt(endRow, endColumn, -1);
        if (startFold && endFold == startFold)
            return startFold.addSubFold(fold);

        if (startFold && !startFold.range.isStart(startRow, startColumn))
            this.removeFold(startFold);
        
        if (endFold && !endFold.range.isEnd(endRow, endColumn))
            this.removeFold(endFold);
        var folds = this.getFoldsInRange(fold.range);
        if (folds.length > 0) {
            this.removeFolds(folds);
            folds.forEach(function(subFold) {
                fold.addSubFold(subFold);
            });
        }

        for (var i = 0; i < foldData.length; i++) {
            var foldLine = foldData[i];
            if (endRow == foldLine.start.row) {
                foldLine.addFold(fold);
                added = true;
                break;
            } else if (startRow == foldLine.end.row) {
                foldLine.addFold(fold);
                added = true;
                if (!fold.sameRow) {
                    var foldLineNext = foldData[i + 1];
                    if (foldLineNext && foldLineNext.start.row == endRow) {
                        foldLine.merge(foldLineNext);
                        break;
                    }
                }
                break;
            } else if (endRow <= foldLine.start.row) {
                break;
            }
        }

        if (!added)
            foldLine = this.$addFoldLine(new FoldLine(this.$foldData, fold));

        if (this.$useWrapMode)
            this.$updateWrapData(foldLine.start.row, foldLine.start.row);
        else
            this.$updateRowLengthCache(foldLine.start.row, foldLine.start.row);
        this.$modified = true;
        this._signal("changeFold", { data: fold, action: "add" });

        return fold;
    };

    this.addFolds = function(folds) {
        folds.forEach(function(fold) {
            this.addFold(fold);
        }, this);
    };

    this.removeFold = function(fold) {
        var foldLine = fold.foldLine;
        var startRow = foldLine.start.row;
        var endRow = foldLine.end.row;

        var foldLines = this.$foldData;
        var folds = foldLine.folds;
        if (folds.length == 1) {
            foldLines.splice(foldLines.indexOf(foldLine), 1);
        } else
        if (foldLine.range.isEnd(fold.end.row, fold.end.column)) {
            folds.pop();
            foldLine.end.row = folds[folds.length - 1].end.row;
            foldLine.end.column = folds[folds.length - 1].end.column;
        } else
        if (foldLine.range.isStart(fold.start.row, fold.start.column)) {
            folds.shift();
            foldLine.start.row = folds[0].start.row;
            foldLine.start.column = folds[0].start.column;
        } else
        if (fold.sameRow) {
            folds.splice(folds.indexOf(fold), 1);
        } else
        {
            var newFoldLine = foldLine.split(fold.start.row, fold.start.column);
            folds = newFoldLine.folds;
            folds.shift();
            newFoldLine.start.row = folds[0].start.row;
            newFoldLine.start.column = folds[0].start.column;
        }

        if (!this.$updating) {
            if (this.$useWrapMode)
                this.$updateWrapData(startRow, endRow);
            else
                this.$updateRowLengthCache(startRow, endRow);
        }
        this.$modified = true;
        this._signal("changeFold", { data: fold, action: "remove" });
    };

    this.removeFolds = function(folds) {
        var cloneFolds = [];
        for (var i = 0; i < folds.length; i++) {
            cloneFolds.push(folds[i]);
        }

        cloneFolds.forEach(function(fold) {
            this.removeFold(fold);
        }, this);
        this.$modified = true;
    };

    this.expandFold = function(fold) {
        this.removeFold(fold);
        fold.subFolds.forEach(function(subFold) {
            fold.restoreRange(subFold);
            this.addFold(subFold);
        }, this);
        if (fold.collapseChildren > 0) {
            this.foldAll(fold.start.row+1, fold.end.row, fold.collapseChildren-1);
        }
        fold.subFolds = [];
    };

    this.expandFolds = function(folds) {
        folds.forEach(function(fold) {
            this.expandFold(fold);
        }, this);
    };

    this.unfold = function(location, expandInner) {
        var range, folds;
        if (location == null) {
            range = new Range(0, 0, this.getLength(), 0);
            expandInner = true;
        } else if (typeof location == "number")
            range = new Range(location, 0, location, this.getLine(location).length);
        else if ("row" in location)
            range = Range.fromPoints(location, location);
        else
            range = location;
        
        folds = this.getFoldsInRangeList(range);
        if (expandInner) {
            this.removeFolds(folds);
        } else {
            var subFolds = folds;
            while (subFolds.length) {
                this.expandFolds(subFolds);
                subFolds = this.getFoldsInRangeList(range);
            }
        }
        if (folds.length)
            return folds;
    };
    this.isRowFolded = function(docRow, startFoldRow) {
        return !!this.getFoldLine(docRow, startFoldRow);
    };

    this.getRowFoldEnd = function(docRow, startFoldRow) {
        var foldLine = this.getFoldLine(docRow, startFoldRow);
        return foldLine ? foldLine.end.row : docRow;
    };

    this.getRowFoldStart = function(docRow, startFoldRow) {
        var foldLine = this.getFoldLine(docRow, startFoldRow);
        return foldLine ? foldLine.start.row : docRow;
    };

    this.getFoldDisplayLine = function(foldLine, endRow, endColumn, startRow, startColumn) {
        if (startRow == null)
            startRow = foldLine.start.row;
        if (startColumn == null)
            startColumn = 0;
        if (endRow == null)
            endRow = foldLine.end.row;
        if (endColumn == null)
            endColumn = this.getLine(endRow).length;
        var doc = this.doc;
        var textLine = "";

        foldLine.walk(function(placeholder, row, column, lastColumn) {
            if (row < startRow)
                return;
            if (row == startRow) {
                if (column < startColumn)
                    return;
                lastColumn = Math.max(startColumn, lastColumn);
            }

            if (placeholder != null) {
                textLine += placeholder;
            } else {
                textLine += doc.getLine(row).substring(lastColumn, column);
            }
        }, endRow, endColumn);
        return textLine;
    };

    this.getDisplayLine = function(row, endColumn, startRow, startColumn) {
        var foldLine = this.getFoldLine(row);

        if (!foldLine) {
            var line;
            line = this.doc.getLine(row);
            return line.substring(startColumn || 0, endColumn || line.length);
        } else {
            return this.getFoldDisplayLine(
                foldLine, row, endColumn, startRow, startColumn);
        }
    };

    this.$cloneFoldData = function() {
        var fd = [];
        fd = this.$foldData.map(function(foldLine) {
            var folds = foldLine.folds.map(function(fold) {
                return fold.clone();
            });
            return new FoldLine(fd, folds);
        });

        return fd;
    };

    this.toggleFold = function(tryToUnfold) {
        var selection = this.selection;
        var range = selection.getRange();
        var fold;
        var bracketPos;

        if (range.isEmpty()) {
            var cursor = range.start;
            fold = this.getFoldAt(cursor.row, cursor.column);

            if (fold) {
                this.expandFold(fold);
                return;
            } else if (bracketPos = this.findMatchingBracket(cursor)) {
                if (range.comparePoint(bracketPos) == 1) {
                    range.end = bracketPos;
                } else {
                    range.start = bracketPos;
                    range.start.column++;
                    range.end.column--;
                }
            } else if (bracketPos = this.findMatchingBracket({row: cursor.row, column: cursor.column + 1})) {
                if (range.comparePoint(bracketPos) == 1)
                    range.end = bracketPos;
                else
                    range.start = bracketPos;

                range.start.column++;
            } else {
                range = this.getCommentFoldRange(cursor.row, cursor.column) || range;
            }
        } else {
            var folds = this.getFoldsInRange(range);
            if (tryToUnfold && folds.length) {
                this.expandFolds(folds);
                return;
            } else if (folds.length == 1 ) {
                fold = folds[0];
            }
        }

        if (!fold)
            fold = this.getFoldAt(range.start.row, range.start.column);

        if (fold && fold.range.toString() == range.toString()) {
            this.expandFold(fold);
            return;
        }

        var placeholder = "...";
        if (!range.isMultiLine()) {
            placeholder = this.getTextRange(range);
            if (placeholder.length < 4)
                return;
            placeholder = placeholder.trim().substring(0, 2) + "..";
        }

        this.addFold(placeholder, range);
    };

    this.getCommentFoldRange = function(row, column, dir) {
        var iterator = new TokenIterator(this, row, column);
        var token = iterator.getCurrentToken();
        var type = token.type;
        if (token && /^comment|string/.test(type)) {
            type = type.match(/comment|string/)[0];
            if (type == "comment")
                type += "|doc-start";
            var re = new RegExp(type);
            var range = new Range();
            if (dir != 1) {
                do {
                    token = iterator.stepBackward();
                } while (token && re.test(token.type));
                iterator.stepForward();
            }
            
            range.start.row = iterator.getCurrentTokenRow();
            range.start.column = iterator.getCurrentTokenColumn() + 2;

            iterator = new TokenIterator(this, row, column);
            
            if (dir != -1) {
                var lastRow = -1;
                do {
                    token = iterator.stepForward();
                    if (lastRow == -1) {
                        var state = this.getState(iterator.$row);
                        if (!re.test(state))
                            lastRow = iterator.$row;
                    } else if (iterator.$row > lastRow) {
                        break;
                    }
                } while (token && re.test(token.type));
                token = iterator.stepBackward();
            } else
                token = iterator.getCurrentToken();

            range.end.row = iterator.getCurrentTokenRow();
            range.end.column = iterator.getCurrentTokenColumn() + token.value.length - 2;
            return range;
        }
    };

    this.foldAll = function(startRow, endRow, depth) {
        if (depth == undefined)
            depth = 100000; // JSON.stringify doesn't hanle Infinity
        var foldWidgets = this.foldWidgets;
        if (!foldWidgets)
            return; // mode doesn't support folding
        endRow = endRow || this.getLength();
        startRow = startRow || 0;
        for (var row = startRow; row < endRow; row++) {
            if (foldWidgets[row] == null)
                foldWidgets[row] = this.getFoldWidget(row);
            if (foldWidgets[row] != "start")
                continue;

            var range = this.getFoldWidgetRange(row);
            if (range && range.isMultiLine()
                && range.end.row <= endRow
                && range.start.row >= startRow
            ) {
                row = range.end.row;
                try {
                    var fold = this.addFold("...", range);
                    if (fold)
                        fold.collapseChildren = depth;
                } catch(e) {}
            }
        }
    };
    this.$foldStyles = {
        "manual": 1,
        "markbegin": 1,
        "markbeginend": 1
    };
    this.$foldStyle = "markbegin";
    this.setFoldStyle = function(style) {
        if (!this.$foldStyles[style])
            throw new Error("invalid fold style: " + style + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
        
        if (this.$foldStyle == style)
            return;

        this.$foldStyle = style;
        
        if (style == "manual")
            this.unfold();
        var mode = this.$foldMode;
        this.$setFolding(null);
        this.$setFolding(mode);
    };

    this.$setFolding = function(foldMode) {
        if (this.$foldMode == foldMode)
            return;
            
        this.$foldMode = foldMode;
        
        this.off('change', this.$updateFoldWidgets);
        this.off('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
        this._signal("changeAnnotation");
        
        if (!foldMode || this.$foldStyle == "manual") {
            this.foldWidgets = null;
            return;
        }
        
        this.foldWidgets = [];
        this.getFoldWidget = foldMode.getFoldWidget.bind(foldMode, this, this.$foldStyle);
        this.getFoldWidgetRange = foldMode.getFoldWidgetRange.bind(foldMode, this, this.$foldStyle);
        
        this.$updateFoldWidgets = this.updateFoldWidgets.bind(this);
        this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this);
        this.on('change', this.$updateFoldWidgets);
        this.on('tokenizerUpdate', this.$tokenizerUpdateFoldWidgets);
    };

    this.getParentFoldRangeData = function (row, ignoreCurrent) {
        var fw = this.foldWidgets;
        if (!fw || (ignoreCurrent && fw[row]))
            return {};

        var i = row - 1, firstRange;
        while (i >= 0) {
            var c = fw[i];
            if (c == null)
                c = fw[i] = this.getFoldWidget(i);

            if (c == "start") {
                var range = this.getFoldWidgetRange(i);
                if (!firstRange)
                    firstRange = range;
                if (range && range.end.row >= row)
                    break;
            }
            i--;
        }

        return {
            range: i !== -1 && range,
            firstRange: firstRange
        };
    };

    this.onFoldWidgetClick = function(row, e) {
        e = e.domEvent;
        var options = {
            children: e.shiftKey,
            all: e.ctrlKey || e.metaKey,
            siblings: e.altKey
        };
        
        var range = this.$toggleFoldWidget(row, options);
        if (!range) {
            var el = (e.target || e.srcElement);
            if (el && /ace_fold-widget/.test(el.className))
                el.className += " ace_invalid";
        }
    };
    
    this.$toggleFoldWidget = function(row, options) {
        if (!this.getFoldWidget)
            return;
        var type = this.getFoldWidget(row);
        var line = this.getLine(row);

        var dir = type === "end" ? -1 : 1;
        var fold = this.getFoldAt(row, dir === -1 ? 0 : line.length, dir);

        if (fold) {
            if (options.children || options.all)
                this.removeFold(fold);
            else
                this.expandFold(fold);
            return fold;
        }

        var range = this.getFoldWidgetRange(row, true);
        if (range && !range.isMultiLine()) {
            fold = this.getFoldAt(range.start.row, range.start.column, 1);
            if (fold && range.isEqual(fold.range)) {
                this.removeFold(fold);
                return fold;
            }
        }
        
        if (options.siblings) {
            var data = this.getParentFoldRangeData(row);
            if (data.range) {
                var startRow = data.range.start.row + 1;
                var endRow = data.range.end.row;
            }
            this.foldAll(startRow, endRow, options.all ? 10000 : 0);
        } else if (options.children) {
            endRow = range ? range.end.row : this.getLength();
            this.foldAll(row + 1, endRow, options.all ? 10000 : 0);
        } else if (range) {
            if (options.all) 
                range.collapseChildren = 10000;
            this.addFold("...", range);
        }
        
        return range;
    };
    
    
    
    this.toggleFoldWidget = function(toggleParent) {
        var row = this.selection.getCursor().row;
        row = this.getRowFoldStart(row);
        var range = this.$toggleFoldWidget(row, {});
        
        if (range)
            return;
        var data = this.getParentFoldRangeData(row, true);
        range = data.range || data.firstRange;
        
        if (range) {
            row = range.start.row;
            var fold = this.getFoldAt(row, this.getLine(row).length, 1);

            if (fold) {
                this.removeFold(fold);
            } else {
                this.addFold("...", range);
            }
        }
    };

    this.updateFoldWidgets = function(delta) {
        var firstRow = delta.start.row;
        var len = delta.end.row - firstRow;

        if (len === 0) {
            this.foldWidgets[firstRow] = null;
        } else if (delta.action == 'remove') {
            this.foldWidgets.splice(firstRow, len + 1, null);
        } else {
            var args = Array(len + 1);
            args.unshift(firstRow, 1);
            this.foldWidgets.splice.apply(this.foldWidgets, args);
        }
    };
    this.tokenizerUpdateFoldWidgets = function(e) {
        var rows = e.data;
        if (rows.first != rows.last) {
            if (this.foldWidgets.length > rows.first)
                this.foldWidgets.splice(rows.first, this.foldWidgets.length);
        }
    };
}

exports.Folding = Folding;

});

ace.define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"], function(acequire, exports, module) {
"use strict";

var TokenIterator = acequire("../token_iterator").TokenIterator;
var Range = acequire("../range").Range;


function BracketMatch() {

    this.findMatchingBracket = function(position, chr) {
        if (position.column == 0) return null;

        var charBeforeCursor = chr || this.getLine(position.row).charAt(position.column-1);
        if (charBeforeCursor == "") return null;

        var match = charBeforeCursor.match(/([\(\[\{])|([\)\]\}])/);
        if (!match)
            return null;

        if (match[1])
            return this.$findClosingBracket(match[1], position);
        else
            return this.$findOpeningBracket(match[2], position);
    };
    
    this.getBracketRange = function(pos) {
        var line = this.getLine(pos.row);
        var before = true, range;

        var chr = line.charAt(pos.column-1);
        var match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
        if (!match) {
            chr = line.charAt(pos.column);
            pos = {row: pos.row, column: pos.column + 1};
            match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
            before = false;
        }
        if (!match)
            return null;

        if (match[1]) {
            var bracketPos = this.$findClosingBracket(match[1], pos);
            if (!bracketPos)
                return null;
            range = Range.fromPoints(pos, bracketPos);
            if (!before) {
                range.end.column++;
                range.start.column--;
            }
            range.cursor = range.end;
        } else {
            var bracketPos = this.$findOpeningBracket(match[2], pos);
            if (!bracketPos)
                return null;
            range = Range.fromPoints(bracketPos, pos);
            if (!before) {
                range.start.column++;
                range.end.column--;
            }
            range.cursor = range.start;
        }
        
        return range;
    };

    this.$brackets = {
        ")": "(",
        "(": ")",
        "]": "[",
        "[": "]",
        "{": "}",
        "}": "{"
    };

    this.$findOpeningBracket = function(bracket, position, typeRe) {
        var openBracket = this.$brackets[bracket];
        var depth = 1;

        var iterator = new TokenIterator(this, position.row, position.column);
        var token = iterator.getCurrentToken();
        if (!token)
            token = iterator.stepForward();
        if (!token)
            return;
        
         if (!typeRe){
            typeRe = new RegExp(
                "(\\.?" +
                token.type.replace(".", "\\.").replace("rparen", ".paren")
                    .replace(/\b(?:end)\b/, "(?:start|begin|end)")
                + ")+"
            );
        }
        var valueIndex = position.column - iterator.getCurrentTokenColumn() - 2;
        var value = token.value;
        
        while (true) {
        
            while (valueIndex >= 0) {
                var chr = value.charAt(valueIndex);
                if (chr == openBracket) {
                    depth -= 1;
                    if (depth == 0) {
                        return {row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()};
                    }
                }
                else if (chr == bracket) {
                    depth += 1;
                }
                valueIndex -= 1;
            }
            do {
                token = iterator.stepBackward();
            } while (token && !typeRe.test(token.type));

            if (token == null)
                break;
                
            value = token.value;
            valueIndex = value.length - 1;
        }
        
        return null;
    };

    this.$findClosingBracket = function(bracket, position, typeRe) {
        var closingBracket = this.$brackets[bracket];
        var depth = 1;

        var iterator = new TokenIterator(this, position.row, position.column);
        var token = iterator.getCurrentToken();
        if (!token)
            token = iterator.stepForward();
        if (!token)
            return;

        if (!typeRe){
            typeRe = new RegExp(
                "(\\.?" +
                token.type.replace(".", "\\.").replace("lparen", ".paren")
                    .replace(/\b(?:start|begin)\b/, "(?:start|begin|end)")
                + ")+"
            );
        }
        var valueIndex = position.column - iterator.getCurrentTokenColumn();

        while (true) {

            var value = token.value;
            var valueLength = value.length;
            while (valueIndex < valueLength) {
                var chr = value.charAt(valueIndex);
                if (chr == closingBracket) {
                    depth -= 1;
                    if (depth == 0) {
                        return {row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()};
                    }
                }
                else if (chr == bracket) {
                    depth += 1;
                }
                valueIndex += 1;
            }
            do {
                token = iterator.stepForward();
            } while (token && !typeRe.test(token.type));

            if (token == null)
                break;

            valueIndex = 0;
        }
        
        return null;
    };
}
exports.BracketMatch = BracketMatch;

});

ace.define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/bidihandler","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/document","ace/background_tokenizer","ace/search_highlight","ace/edit_session/folding","ace/edit_session/bracket_match"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var lang = acequire("./lib/lang");
var BidiHandler = acequire("./bidihandler").BidiHandler;
var config = acequire("./config");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var Selection = acequire("./selection").Selection;
var TextMode = acequire("./mode/text").Mode;
var Range = acequire("./range").Range;
var Document = acequire("./document").Document;
var BackgroundTokenizer = acequire("./background_tokenizer").BackgroundTokenizer;
var SearchHighlight = acequire("./search_highlight").SearchHighlight;

var EditSession = function(text, mode) {
    this.$breakpoints = [];
    this.$decorations = [];
    this.$frontMarkers = {};
    this.$backMarkers = {};
    this.$markerId = 1;
    this.$undoSelect = true;

    this.$foldData = [];
    this.id = "session" + (++EditSession.$uid);
    this.$foldData.toString = function() {
        return this.join("\n");
    };
    this.on("changeFold", this.onChangeFold.bind(this));
    this.$onChange = this.onChange.bind(this);

    if (typeof text != "object" || !text.getLine)
        text = new Document(text);

    this.$bidiHandler = new BidiHandler(this);
    this.setDocument(text);
    this.selection = new Selection(this);

    config.resetOptions(this);
    this.setMode(mode);
    config._signal("session", this);
};


EditSession.$uid = 0;

(function() {

    oop.implement(this, EventEmitter);
    this.setDocument = function(doc) {
        if (this.doc)
            this.doc.removeListener("change", this.$onChange);

        this.doc = doc;
        doc.on("change", this.$onChange);

        if (this.bgTokenizer)
            this.bgTokenizer.setDocument(this.getDocument());

        this.resetCaches();
    };
    this.getDocument = function() {
        return this.doc;
    };
    this.$resetRowCache = function(docRow) {
        if (!docRow) {
            this.$docRowCache = [];
            this.$screenRowCache = [];
            return;
        }
        var l = this.$docRowCache.length;
        var i = this.$getRowCacheIndex(this.$docRowCache, docRow) + 1;
        if (l > i) {
            this.$docRowCache.splice(i, l);
            this.$screenRowCache.splice(i, l);
        }
    };

    this.$getRowCacheIndex = function(cacheArray, val) {
        var low = 0;
        var hi = cacheArray.length - 1;

        while (low <= hi) {
            var mid = (low + hi) >> 1;
            var c = cacheArray[mid];

            if (val > c)
                low = mid + 1;
            else if (val < c)
                hi = mid - 1;
            else
                return mid;
        }

        return low -1;
    };

    this.resetCaches = function() {
        this.$modified = true;
        this.$wrapData = [];
        this.$rowLengthCache = [];
        this.$resetRowCache(0);
        if (this.bgTokenizer)
            this.bgTokenizer.start(0);
    };

    this.onChangeFold = function(e) {
        var fold = e.data;
        this.$resetRowCache(fold.start.row);
    };

    this.onChange = function(delta) {
        this.$modified = true;
        this.$bidiHandler.onChange(delta);
        this.$resetRowCache(delta.start.row);

        var removedFolds = this.$updateInternalDataOnChange(delta);
        if (!this.$fromUndo && this.$undoManager && !delta.ignore) {
            this.$deltasDoc.push(delta);
            if (removedFolds && removedFolds.length != 0) {
                this.$deltasFold.push({
                    action: "removeFolds",
                    folds:  removedFolds
                });
            }

            this.$informUndoManager.schedule();
        }

        this.bgTokenizer && this.bgTokenizer.$updateOnChange(delta);
        this._signal("change", delta);
    };
    this.setValue = function(text) {
        this.doc.setValue(text);
        this.selection.moveTo(0, 0);

        this.$resetRowCache(0);
        this.$deltas = [];
        this.$deltasDoc = [];
        this.$deltasFold = [];
        this.setUndoManager(this.$undoManager);
        this.getUndoManager().reset();
    };
    this.getValue =
    this.toString = function() {
        return this.doc.getValue();
    };
    this.getSelection = function() {
        return this.selection;
    };
    this.getState = function(row) {
        return this.bgTokenizer.getState(row);
    };
    this.getTokens = function(row) {
        return this.bgTokenizer.getTokens(row);
    };
    this.getTokenAt = function(row, column) {
        var tokens = this.bgTokenizer.getTokens(row);
        var token, c = 0;
        if (column == null) {
            var i = tokens.length - 1;
            c = this.getLine(row).length;
        } else {
            for (var i = 0; i < tokens.length; i++) {
                c += tokens[i].value.length;
                if (c >= column)
                    break;
            }
        }
        token = tokens[i];
        if (!token)
            return null;
        token.index = i;
        token.start = c - token.value.length;
        return token;
    };
    this.setUndoManager = function(undoManager) {
        this.$undoManager = undoManager;
        this.$deltas = [];
        this.$deltasDoc = [];
        this.$deltasFold = [];

        if (this.$informUndoManager)
            this.$informUndoManager.cancel();

        if (undoManager) {
            var self = this;

            this.$syncInformUndoManager = function() {
                self.$informUndoManager.cancel();

                if (self.$deltasFold.length) {
                    self.$deltas.push({
                        group: "fold",
                        deltas: self.$deltasFold
                    });
                    self.$deltasFold = [];
                }

                if (self.$deltasDoc.length) {
                    self.$deltas.push({
                        group: "doc",
                        deltas: self.$deltasDoc
                    });
                    self.$deltasDoc = [];
                }

                if (self.$deltas.length > 0) {
                    undoManager.execute({
                        action: "aceupdate",
                        args: [self.$deltas, self],
                        merge: self.mergeUndoDeltas
                    });
                }
                self.mergeUndoDeltas = false;
                self.$deltas = [];
            };
            this.$informUndoManager = lang.delayedCall(this.$syncInformUndoManager);
        }
    };
    this.markUndoGroup = function() {
        if (this.$syncInformUndoManager)
            this.$syncInformUndoManager();
    };
    
    this.$defaultUndoManager = {
        undo: function() {},
        redo: function() {},
        reset: function() {}
    };
    this.getUndoManager = function() {
        return this.$undoManager || this.$defaultUndoManager;
    };
    this.getTabString = function() {
        if (this.getUseSoftTabs()) {
            return lang.stringRepeat(" ", this.getTabSize());
        } else {
            return "\t";
        }
    };
    this.setUseSoftTabs = function(val) {
        this.setOption("useSoftTabs", val);
    };
    this.getUseSoftTabs = function() {
        return this.$useSoftTabs && !this.$mode.$indentWithTabs;
    };
    this.setTabSize = function(tabSize) {
        this.setOption("tabSize", tabSize);
    };
    this.getTabSize = function() {
        return this.$tabSize;
    };
    this.isTabStop = function(position) {
        return this.$useSoftTabs && (position.column % this.$tabSize === 0);
    };
    this.setNavigateWithinSoftTabs = function (navigateWithinSoftTabs) {
        this.setOption("navigateWithinSoftTabs", navigateWithinSoftTabs);
    };
    this.getNavigateWithinSoftTabs = function() {
        return this.$navigateWithinSoftTabs;
    };

    this.$overwrite = false;
    this.setOverwrite = function(overwrite) {
        this.setOption("overwrite", overwrite);
    };
    this.getOverwrite = function() {
        return this.$overwrite;
    };
    this.toggleOverwrite = function() {
        this.setOverwrite(!this.$overwrite);
    };
    this.addGutterDecoration = function(row, className) {
        if (!this.$decorations[row])
            this.$decorations[row] = "";
        this.$decorations[row] += " " + className;
        this._signal("changeBreakpoint", {});
    };
    this.removeGutterDecoration = function(row, className) {
        this.$decorations[row] = (this.$decorations[row] || "").replace(" " + className, "");
        this._signal("changeBreakpoint", {});
    };
    this.getBreakpoints = function() {
        return this.$breakpoints;
    };
    this.setBreakpoints = function(rows) {
        this.$breakpoints = [];
        for (var i=0; i<rows.length; i++) {
            this.$breakpoints[rows[i]] = "ace_breakpoint";
        }
        this._signal("changeBreakpoint", {});
    };
    this.clearBreakpoints = function() {
        this.$breakpoints = [];
        this._signal("changeBreakpoint", {});
    };
    this.setBreakpoint = function(row, className) {
        if (className === undefined)
            className = "ace_breakpoint";
        if (className)
            this.$breakpoints[row] = className;
        else
            delete this.$breakpoints[row];
        this._signal("changeBreakpoint", {});
    };
    this.clearBreakpoint = function(row) {
        delete this.$breakpoints[row];
        this._signal("changeBreakpoint", {});
    };
    this.addMarker = function(range, clazz, type, inFront) {
        var id = this.$markerId++;

        var marker = {
            range : range,
            type : type || "line",
            renderer: typeof type == "function" ? type : null,
            clazz : clazz,
            inFront: !!inFront,
            id: id
        };

        if (inFront) {
            this.$frontMarkers[id] = marker;
            this._signal("changeFrontMarker");
        } else {
            this.$backMarkers[id] = marker;
            this._signal("changeBackMarker");
        }

        return id;
    };
    this.addDynamicMarker = function(marker, inFront) {
        if (!marker.update)
            return;
        var id = this.$markerId++;
        marker.id = id;
        marker.inFront = !!inFront;

        if (inFront) {
            this.$frontMarkers[id] = marker;
            this._signal("changeFrontMarker");
        } else {
            this.$backMarkers[id] = marker;
            this._signal("changeBackMarker");
        }

        return marker;
    };
    this.removeMarker = function(markerId) {
        var marker = this.$frontMarkers[markerId] || this.$backMarkers[markerId];
        if (!marker)
            return;

        var markers = marker.inFront ? this.$frontMarkers : this.$backMarkers;
        if (marker) {
            delete (markers[markerId]);
            this._signal(marker.inFront ? "changeFrontMarker" : "changeBackMarker");
        }
    };
    this.getMarkers = function(inFront) {
        return inFront ? this.$frontMarkers : this.$backMarkers;
    };

    this.highlight = function(re) {
        if (!this.$searchHighlight) {
            var highlight = new SearchHighlight(null, "ace_selected-word", "text");
            this.$searchHighlight = this.addDynamicMarker(highlight);
        }
        this.$searchHighlight.setRegexp(re);
    };
    this.highlightLines = function(startRow, endRow, clazz, inFront) {
        if (typeof endRow != "number") {
            clazz = endRow;
            endRow = startRow;
        }
        if (!clazz)
            clazz = "ace_step";

        var range = new Range(startRow, 0, endRow, Infinity);
        range.id = this.addMarker(range, clazz, "fullLine", inFront);
        return range;
    };
    this.setAnnotations = function(annotations) {
        this.$annotations = annotations;
        this._signal("changeAnnotation", {});
    };
    this.getAnnotations = function() {
        return this.$annotations || [];
    };
    this.clearAnnotations = function() {
        this.setAnnotations([]);
    };
    this.$detectNewLine = function(text) {
        var match = text.match(/^.*?(\r?\n)/m);
        if (match) {
            this.$autoNewLine = match[1];
        } else {
            this.$autoNewLine = "\n";
        }
    };
    this.getWordRange = function(row, column) {
        var line = this.getLine(row);

        var inToken = false;
        if (column > 0)
            inToken = !!line.charAt(column - 1).match(this.tokenRe);

        if (!inToken)
            inToken = !!line.charAt(column).match(this.tokenRe);

        if (inToken)
            var re = this.tokenRe;
        else if (/^\s+$/.test(line.slice(column-1, column+1)))
            var re = /\s/;
        else
            var re = this.nonTokenRe;

        var start = column;
        if (start > 0) {
            do {
                start--;
            }
            while (start >= 0 && line.charAt(start).match(re));
            start++;
        }

        var end = column;
        while (end < line.length && line.charAt(end).match(re)) {
            end++;
        }

        return new Range(row, start, row, end);
    };
    this.getAWordRange = function(row, column) {
        var wordRange = this.getWordRange(row, column);
        var line = this.getLine(wordRange.end.row);

        while (line.charAt(wordRange.end.column).match(/[ \t]/)) {
            wordRange.end.column += 1;
        }
        return wordRange;
    };
    this.setNewLineMode = function(newLineMode) {
        this.doc.setNewLineMode(newLineMode);
    };
    this.getNewLineMode = function() {
        return this.doc.getNewLineMode();
    };
    this.setUseWorker = function(useWorker) { this.setOption("useWorker", useWorker); };
    this.getUseWorker = function() { return this.$useWorker; };
    this.onReloadTokenizer = function(e) {
        var rows = e.data;
        this.bgTokenizer.start(rows.first);
        this._signal("tokenizerUpdate", e);
    };

    this.$modes = {};
    this.$mode = null;
    this.$modeId = null;
    this.setMode = function(mode, cb) {
        if (mode && typeof mode === "object") {
            if (mode.getTokenizer)
                return this.$onChangeMode(mode);
            var options = mode;
            var path = options.path;
        } else {
            path = mode || "ace/mode/text";
        }
        if (!this.$modes["ace/mode/text"])
            this.$modes["ace/mode/text"] = new TextMode();

        if (this.$modes[path] && !options) {
            this.$onChangeMode(this.$modes[path]);
            cb && cb();
            return;
        }
        this.$modeId = path;
        config.loadModule(["mode", path], function(m) {
            if (this.$modeId !== path)
                return cb && cb();
            if (this.$modes[path] && !options) {
                this.$onChangeMode(this.$modes[path]);
            } else if (m && m.Mode) {
                m = new m.Mode(options);
                if (!options) {
                    this.$modes[path] = m;
                    m.$id = path;
                }
                this.$onChangeMode(m);
            }
            cb && cb();
        }.bind(this));
        if (!this.$mode)
            this.$onChangeMode(this.$modes["ace/mode/text"], true);
    };

    this.$onChangeMode = function(mode, $isPlaceholder) {
        if (!$isPlaceholder)
            this.$modeId = mode.$id;
        if (this.$mode === mode) 
            return;

        this.$mode = mode;

        this.$stopWorker();

        if (this.$useWorker)
            this.$startWorker();

        var tokenizer = mode.getTokenizer();

        if(tokenizer.addEventListener !== undefined) {
            var onReloadTokenizer = this.onReloadTokenizer.bind(this);
            tokenizer.addEventListener("update", onReloadTokenizer);
        }

        if (!this.bgTokenizer) {
            this.bgTokenizer = new BackgroundTokenizer(tokenizer);
            var _self = this;
            this.bgTokenizer.addEventListener("update", function(e) {
                _self._signal("tokenizerUpdate", e);
            });
        } else {
            this.bgTokenizer.setTokenizer(tokenizer);
        }

        this.bgTokenizer.setDocument(this.getDocument());

        this.tokenRe = mode.tokenRe;
        this.nonTokenRe = mode.nonTokenRe;

        
        if (!$isPlaceholder) {
            if (mode.attachToSession)
                mode.attachToSession(this);
            this.$options.wrapMethod.set.call(this, this.$wrapMethod);
            this.$setFolding(mode.foldingRules);
            this.bgTokenizer.start(0);
            this._emit("changeMode");
        }
    };

    this.$stopWorker = function() {
        if (this.$worker) {
            this.$worker.terminate();
            this.$worker = null;
        }
    };

    this.$startWorker = function() {
        try {
            this.$worker = this.$mode.createWorker(this);
        } catch (e) {
            config.warn("Could not load worker", e);
            this.$worker = null;
        }
    };
    this.getMode = function() {
        return this.$mode;
    };

    this.$scrollTop = 0;
    this.setScrollTop = function(scrollTop) {
        if (this.$scrollTop === scrollTop || isNaN(scrollTop))
            return;

        this.$scrollTop = scrollTop;
        this._signal("changeScrollTop", scrollTop);
    };
    this.getScrollTop = function() {
        return this.$scrollTop;
    };

    this.$scrollLeft = 0;
    this.setScrollLeft = function(scrollLeft) {
        if (this.$scrollLeft === scrollLeft || isNaN(scrollLeft))
            return;

        this.$scrollLeft = scrollLeft;
        this._signal("changeScrollLeft", scrollLeft);
    };
    this.getScrollLeft = function() {
        return this.$scrollLeft;
    };
    this.getScreenWidth = function() {
        this.$computeWidth();
        if (this.lineWidgets) 
            return Math.max(this.getLineWidgetMaxWidth(), this.screenWidth);
        return this.screenWidth;
    };
    
    this.getLineWidgetMaxWidth = function() {
        if (this.lineWidgetsWidth != null) return this.lineWidgetsWidth;
        var width = 0;
        this.lineWidgets.forEach(function(w) {
            if (w && w.screenWidth > width)
                width = w.screenWidth;
        });
        return this.lineWidgetWidth = width;
    };

    this.$computeWidth = function(force) {
        if (this.$modified || force) {
            this.$modified = false;

            if (this.$useWrapMode)
                return this.screenWidth = this.$wrapLimit;

            var lines = this.doc.getAllLines();
            var cache = this.$rowLengthCache;
            var longestScreenLine = 0;
            var foldIndex = 0;
            var foldLine = this.$foldData[foldIndex];
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            var len = lines.length;

            for (var i = 0; i < len; i++) {
                if (i > foldStart) {
                    i = foldLine.end.row + 1;
                    if (i >= len)
                        break;
                    foldLine = this.$foldData[foldIndex++];
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }

                if (cache[i] == null)
                    cache[i] = this.$getStringScreenWidth(lines[i])[0];

                if (cache[i] > longestScreenLine)
                    longestScreenLine = cache[i];
            }
            this.screenWidth = longestScreenLine;
        }
    };
    this.getLine = function(row) {
        return this.doc.getLine(row);
    };
    this.getLines = function(firstRow, lastRow) {
        return this.doc.getLines(firstRow, lastRow);
    };
    this.getLength = function() {
        return this.doc.getLength();
    };
    this.getTextRange = function(range) {
        return this.doc.getTextRange(range || this.selection.getRange());
    };
    this.insert = function(position, text) {
        return this.doc.insert(position, text);
    };
    this.remove = function(range) {
        return this.doc.remove(range);
    };
    this.removeFullLines = function(firstRow, lastRow){
        return this.doc.removeFullLines(firstRow, lastRow);
    };
    this.undoChanges = function(deltas, dontSelect) {
        if (!deltas.length)
            return;

        this.$fromUndo = true;
        var lastUndoRange = null;
        for (var i = deltas.length - 1; i != -1; i--) {
            var delta = deltas[i];
            if (delta.group == "doc") {
                this.doc.revertDeltas(delta.deltas);
                lastUndoRange =
                    this.$getUndoSelection(delta.deltas, true, lastUndoRange);
            } else {
                delta.deltas.forEach(function(foldDelta) {
                    this.addFolds(foldDelta.folds);
                }, this);
            }
        }
        this.$fromUndo = false;
        lastUndoRange &&
            this.$undoSelect &&
            !dontSelect &&
            this.selection.setSelectionRange(lastUndoRange);
        return lastUndoRange;
    };
    this.redoChanges = function(deltas, dontSelect) {
        if (!deltas.length)
            return;

        this.$fromUndo = true;
        var lastUndoRange = null;
        for (var i = 0; i < deltas.length; i++) {
            var delta = deltas[i];
            if (delta.group == "doc") {
                this.doc.applyDeltas(delta.deltas);
                lastUndoRange =
                    this.$getUndoSelection(delta.deltas, false, lastUndoRange);
            }
        }
        this.$fromUndo = false;
        lastUndoRange &&
            this.$undoSelect &&
            !dontSelect &&
            this.selection.setSelectionRange(lastUndoRange);
        return lastUndoRange;
    };
    this.setUndoSelect = function(enable) {
        this.$undoSelect = enable;
    };

    this.$getUndoSelection = function(deltas, isUndo, lastUndoRange) {
        function isInsert(delta) {
            return isUndo ? delta.action !== "insert" : delta.action === "insert";
        }

        var delta = deltas[0];
        var range, point;
        var lastDeltaIsInsert = false;
        if (isInsert(delta)) {
            range = Range.fromPoints(delta.start, delta.end);
            lastDeltaIsInsert = true;
        } else {
            range = Range.fromPoints(delta.start, delta.start);
            lastDeltaIsInsert = false;
        }

        for (var i = 1; i < deltas.length; i++) {
            delta = deltas[i];
            if (isInsert(delta)) {
                point = delta.start;
                if (range.compare(point.row, point.column) == -1) {
                    range.setStart(point);
                }
                point = delta.end;
                if (range.compare(point.row, point.column) == 1) {
                    range.setEnd(point);
                }
                lastDeltaIsInsert = true;
            } else {
                point = delta.start;
                if (range.compare(point.row, point.column) == -1) {
                    range = Range.fromPoints(delta.start, delta.start);
                }
                lastDeltaIsInsert = false;
            }
        }
        if (lastUndoRange != null) {
            if (Range.comparePoints(lastUndoRange.start, range.start) === 0) {
                lastUndoRange.start.column += range.end.column - range.start.column;
                lastUndoRange.end.column += range.end.column - range.start.column;
            }

            var cmp = lastUndoRange.compareRange(range);
            if (cmp == 1) {
                range.setStart(lastUndoRange.start);
            } else if (cmp == -1) {
                range.setEnd(lastUndoRange.end);
            }
        }

        return range;
    };
    this.replace = function(range, text) {
        return this.doc.replace(range, text);
    };
    this.moveText = function(fromRange, toPosition, copy) {
        var text = this.getTextRange(fromRange);
        var folds = this.getFoldsInRange(fromRange);

        var toRange = Range.fromPoints(toPosition, toPosition);
        if (!copy) {
            this.remove(fromRange);
            var rowDiff = fromRange.start.row - fromRange.end.row;
            var collDiff = rowDiff ? -fromRange.end.column : fromRange.start.column - fromRange.end.column;
            if (collDiff) {
                if (toRange.start.row == fromRange.end.row && toRange.start.column > fromRange.end.column)
                    toRange.start.column += collDiff;
                if (toRange.end.row == fromRange.end.row && toRange.end.column > fromRange.end.column)
                    toRange.end.column += collDiff;
            }
            if (rowDiff && toRange.start.row >= fromRange.end.row) {
                toRange.start.row += rowDiff;
                toRange.end.row += rowDiff;
            }
        }

        toRange.end = this.insert(toRange.start, text);
        if (folds.length) {
            var oldStart = fromRange.start;
            var newStart = toRange.start;
            var rowDiff = newStart.row - oldStart.row;
            var collDiff = newStart.column - oldStart.column;
            this.addFolds(folds.map(function(x) {
                x = x.clone();
                if (x.start.row == oldStart.row)
                    x.start.column += collDiff;
                if (x.end.row == oldStart.row)
                    x.end.column += collDiff;
                x.start.row += rowDiff;
                x.end.row += rowDiff;
                return x;
            }));
        }

        return toRange;
    };
    this.indentRows = function(startRow, endRow, indentString) {
        indentString = indentString.replace(/\t/g, this.getTabString());
        for (var row=startRow; row<=endRow; row++)
            this.doc.insertInLine({row: row, column: 0}, indentString);
    };
    this.outdentRows = function (range) {
        var rowRange = range.collapseRows();
        var deleteRange = new Range(0, 0, 0, 0);
        var size = this.getTabSize();

        for (var i = rowRange.start.row; i <= rowRange.end.row; ++i) {
            var line = this.getLine(i);

            deleteRange.start.row = i;
            deleteRange.end.row = i;
            for (var j = 0; j < size; ++j)
                if (line.charAt(j) != ' ')
                    break;
            if (j < size && line.charAt(j) == '\t') {
                deleteRange.start.column = j;
                deleteRange.end.column = j + 1;
            } else {
                deleteRange.start.column = 0;
                deleteRange.end.column = j;
            }
            this.remove(deleteRange);
        }
    };

    this.$moveLines = function(firstRow, lastRow, dir) {
        firstRow = this.getRowFoldStart(firstRow);
        lastRow = this.getRowFoldEnd(lastRow);
        if (dir < 0) {
            var row = this.getRowFoldStart(firstRow + dir);
            if (row < 0) return 0;
            var diff = row-firstRow;
        } else if (dir > 0) {
            var row = this.getRowFoldEnd(lastRow + dir);
            if (row > this.doc.getLength()-1) return 0;
            var diff = row-lastRow;
        } else {
            firstRow = this.$clipRowToDocument(firstRow);
            lastRow = this.$clipRowToDocument(lastRow);
            var diff = lastRow - firstRow + 1;
        }

        var range = new Range(firstRow, 0, lastRow, Number.MAX_VALUE);
        var folds = this.getFoldsInRange(range).map(function(x){
            x = x.clone();
            x.start.row += diff;
            x.end.row += diff;
            return x;
        });
        
        var lines = dir == 0
            ? this.doc.getLines(firstRow, lastRow)
            : this.doc.removeFullLines(firstRow, lastRow);
        this.doc.insertFullLines(firstRow+diff, lines);
        folds.length && this.addFolds(folds);
        return diff;
    };
    this.moveLinesUp = function(firstRow, lastRow) {
        return this.$moveLines(firstRow, lastRow, -1);
    };
    this.moveLinesDown = function(firstRow, lastRow) {
        return this.$moveLines(firstRow, lastRow, 1);
    };
    this.duplicateLines = function(firstRow, lastRow) {
        return this.$moveLines(firstRow, lastRow, 0);
    };


    this.$clipRowToDocument = function(row) {
        return Math.max(0, Math.min(row, this.doc.getLength()-1));
    };

    this.$clipColumnToRow = function(row, column) {
        if (column < 0)
            return 0;
        return Math.min(this.doc.getLine(row).length, column);
    };


    this.$clipPositionToDocument = function(row, column) {
        column = Math.max(0, column);

        if (row < 0) {
            row = 0;
            column = 0;
        } else {
            var len = this.doc.getLength();
            if (row >= len) {
                row = len - 1;
                column = this.doc.getLine(len-1).length;
            } else {
                column = Math.min(this.doc.getLine(row).length, column);
            }
        }

        return {
            row: row,
            column: column
        };
    };

    this.$clipRangeToDocument = function(range) {
        if (range.start.row < 0) {
            range.start.row = 0;
            range.start.column = 0;
        } else {
            range.start.column = this.$clipColumnToRow(
                range.start.row,
                range.start.column
            );
        }

        var len = this.doc.getLength() - 1;
        if (range.end.row > len) {
            range.end.row = len;
            range.end.column = this.doc.getLine(len).length;
        } else {
            range.end.column = this.$clipColumnToRow(
                range.end.row,
                range.end.column
            );
        }
        return range;
    };
    this.$wrapLimit = 80;
    this.$useWrapMode = false;
    this.$wrapLimitRange = {
        min : null,
        max : null
    };
    this.setUseWrapMode = function(useWrapMode) {
        if (useWrapMode != this.$useWrapMode) {
            this.$useWrapMode = useWrapMode;
            this.$modified = true;
            this.$resetRowCache(0);
            if (useWrapMode) {
                var len = this.getLength();
                this.$wrapData = Array(len);
                this.$updateWrapData(0, len - 1);
            }

            this._signal("changeWrapMode");
        }
    };
    this.getUseWrapMode = function() {
        return this.$useWrapMode;
    };
    this.setWrapLimitRange = function(min, max) {
        if (this.$wrapLimitRange.min !== min || this.$wrapLimitRange.max !== max) {
            this.$wrapLimitRange = { min: min, max: max };
            this.$modified = true;
            this.$bidiHandler.markAsDirty();
            if (this.$useWrapMode)
                this._signal("changeWrapMode");
        }
    };
    this.adjustWrapLimit = function(desiredLimit, $printMargin) {
        var limits = this.$wrapLimitRange;
        if (limits.max < 0)
            limits = {min: $printMargin, max: $printMargin};
        var wrapLimit = this.$constrainWrapLimit(desiredLimit, limits.min, limits.max);
        if (wrapLimit != this.$wrapLimit && wrapLimit > 1) {
            this.$wrapLimit = wrapLimit;
            this.$modified = true;
            if (this.$useWrapMode) {
                this.$updateWrapData(0, this.getLength() - 1);
                this.$resetRowCache(0);
                this._signal("changeWrapLimit");
            }
            return true;
        }
        return false;
    };

    this.$constrainWrapLimit = function(wrapLimit, min, max) {
        if (min)
            wrapLimit = Math.max(min, wrapLimit);

        if (max)
            wrapLimit = Math.min(max, wrapLimit);

        return wrapLimit;
    };
    this.getWrapLimit = function() {
        return this.$wrapLimit;
    };
    this.setWrapLimit = function (limit) {
        this.setWrapLimitRange(limit, limit);
    };
    this.getWrapLimitRange = function() {
        return {
            min : this.$wrapLimitRange.min,
            max : this.$wrapLimitRange.max
        };
    };

    this.$updateInternalDataOnChange = function(delta) {
        var useWrapMode = this.$useWrapMode;
        var action = delta.action;
        var start = delta.start;
        var end = delta.end;
        var firstRow = start.row;
        var lastRow = end.row;
        var len = lastRow - firstRow;
        var removedFolds = null;
        
        this.$updating = true;
        if (len != 0) {
            if (action === "remove") {
                this[useWrapMode ? "$wrapData" : "$rowLengthCache"].splice(firstRow, len);

                var foldLines = this.$foldData;
                removedFolds = this.getFoldsInRange(delta);
                this.removeFolds(removedFolds);

                var foldLine = this.getFoldLine(end.row);
                var idx = 0;
                if (foldLine) {
                    foldLine.addRemoveChars(end.row, end.column, start.column - end.column);
                    foldLine.shiftRow(-len);

                    var foldLineBefore = this.getFoldLine(firstRow);
                    if (foldLineBefore && foldLineBefore !== foldLine) {
                        foldLineBefore.merge(foldLine);
                        foldLine = foldLineBefore;
                    }
                    idx = foldLines.indexOf(foldLine) + 1;
                }

                for (idx; idx < foldLines.length; idx++) {
                    var foldLine = foldLines[idx];
                    if (foldLine.start.row >= end.row) {
                        foldLine.shiftRow(-len);
                    }
                }

                lastRow = firstRow;
            } else {
                var args = Array(len);
                args.unshift(firstRow, 0);
                var arr = useWrapMode ? this.$wrapData : this.$rowLengthCache;
                arr.splice.apply(arr, args);
                var foldLines = this.$foldData;
                var foldLine = this.getFoldLine(firstRow);
                var idx = 0;
                if (foldLine) {
                    var cmp = foldLine.range.compareInside(start.row, start.column);
                    if (cmp == 0) {
                        foldLine = foldLine.split(start.row, start.column);
                        if (foldLine) {
                            foldLine.shiftRow(len);
                            foldLine.addRemoveChars(lastRow, 0, end.column - start.column);
                        }
                    } else
                    if (cmp == -1) {
                        foldLine.addRemoveChars(firstRow, 0, end.column - start.column);
                        foldLine.shiftRow(len);
                    }
                    idx = foldLines.indexOf(foldLine) + 1;
                }

                for (idx; idx < foldLines.length; idx++) {
                    var foldLine = foldLines[idx];
                    if (foldLine.start.row >= firstRow) {
                        foldLine.shiftRow(len);
                    }
                }
            }
        } else {
            len = Math.abs(delta.start.column - delta.end.column);
            if (action === "remove") {
                removedFolds = this.getFoldsInRange(delta);
                this.removeFolds(removedFolds);

                len = -len;
            }
            var foldLine = this.getFoldLine(firstRow);
            if (foldLine) {
                foldLine.addRemoveChars(firstRow, start.column, len);
            }
        }

        if (useWrapMode && this.$wrapData.length != this.doc.getLength()) {
            console.error("doc.getLength() and $wrapData.length have to be the same!");
        }
        this.$updating = false;

        if (useWrapMode)
            this.$updateWrapData(firstRow, lastRow);
        else
            this.$updateRowLengthCache(firstRow, lastRow);

        return removedFolds;
    };

    this.$updateRowLengthCache = function(firstRow, lastRow, b) {
        this.$rowLengthCache[firstRow] = null;
        this.$rowLengthCache[lastRow] = null;
    };

    this.$updateWrapData = function(firstRow, lastRow) {
        var lines = this.doc.getAllLines();
        var tabSize = this.getTabSize();
        var wrapData = this.$wrapData;
        var wrapLimit = this.$wrapLimit;
        var tokens;
        var foldLine;

        var row = firstRow;
        lastRow = Math.min(lastRow, lines.length - 1);
        while (row <= lastRow) {
            foldLine = this.getFoldLine(row, foldLine);
            if (!foldLine) {
                tokens = this.$getDisplayTokens(lines[row]);
                wrapData[row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                row ++;
            } else {
                tokens = [];
                foldLine.walk(function(placeholder, row, column, lastColumn) {
                        var walkTokens;
                        if (placeholder != null) {
                            walkTokens = this.$getDisplayTokens(
                                            placeholder, tokens.length);
                            walkTokens[0] = PLACEHOLDER_START;
                            for (var i = 1; i < walkTokens.length; i++) {
                                walkTokens[i] = PLACEHOLDER_BODY;
                            }
                        } else {
                            walkTokens = this.$getDisplayTokens(
                                lines[row].substring(lastColumn, column),
                                tokens.length);
                        }
                        tokens = tokens.concat(walkTokens);
                    }.bind(this),
                    foldLine.end.row,
                    lines[foldLine.end.row].length + 1
                );

                wrapData[foldLine.start.row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                row = foldLine.end.row + 1;
            }
        }
    };
    var CHAR = 1,
        CHAR_EXT = 2,
        PLACEHOLDER_START = 3,
        PLACEHOLDER_BODY =  4,
        PUNCTUATION = 9,
        SPACE = 10,
        TAB = 11,
        TAB_SPACE = 12;


    this.$computeWrapSplits = function(tokens, wrapLimit, tabSize) {
        if (tokens.length == 0) {
            return [];
        }

        var splits = [];
        var displayLength = tokens.length;
        var lastSplit = 0, lastDocSplit = 0;

        var isCode = this.$wrapAsCode;

        var indentedSoftWrap = this.$indentedSoftWrap;
        var maxIndent = wrapLimit <= Math.max(2 * tabSize, 8)
            || indentedSoftWrap === false ? 0 : Math.floor(wrapLimit / 2);

        function getWrapIndent() {
            var indentation = 0;
            if (maxIndent === 0)
                return indentation;
            if (indentedSoftWrap) {
                for (var i = 0; i < tokens.length; i++) {
                    var token = tokens[i];
                    if (token == SPACE)
                        indentation += 1;
                    else if (token == TAB)
                        indentation += tabSize;
                    else if (token == TAB_SPACE)
                        continue;
                    else
                        break;
                }
            }
            if (isCode && indentedSoftWrap !== false)
                indentation += tabSize;
            return Math.min(indentation, maxIndent);
        }
        function addSplit(screenPos) {
            var displayed = tokens.slice(lastSplit, screenPos);
            var len = displayed.length;
            displayed.join("")
                .replace(/12/g, function() {
                    len -= 1;
                })
                .replace(/2/g, function() {
                    len -= 1;
                });

            if (!splits.length) {
                indent = getWrapIndent();
                splits.indent = indent;
            }
            lastDocSplit += len;
            splits.push(lastDocSplit);
            lastSplit = screenPos;
        }
        var indent = 0;
        while (displayLength - lastSplit > wrapLimit - indent) {
            var split = lastSplit + wrapLimit - indent;
            if (tokens[split - 1] >= SPACE && tokens[split] >= SPACE) {
                addSplit(split);
                continue;
            }
            if (tokens[split] == PLACEHOLDER_START || tokens[split] == PLACEHOLDER_BODY) {
                for (split; split != lastSplit - 1; split--) {
                    if (tokens[split] == PLACEHOLDER_START) {
                        break;
                    }
                }
                if (split > lastSplit) {
                    addSplit(split);
                    continue;
                }
                split = lastSplit + wrapLimit;
                for (split; split < tokens.length; split++) {
                    if (tokens[split] != PLACEHOLDER_BODY) {
                        break;
                    }
                }
                if (split == tokens.length) {
                    break;  // Breaks the while-loop.
                }
                addSplit(split);
                continue;
            }
            var minSplit = Math.max(split - (wrapLimit -(wrapLimit>>2)), lastSplit - 1);
            while (split > minSplit && tokens[split] < PLACEHOLDER_START) {
                split --;
            }
            if (isCode) {
                while (split > minSplit && tokens[split] < PLACEHOLDER_START) {
                    split --;
                }
                while (split > minSplit && tokens[split] == PUNCTUATION) {
                    split --;
                }
            } else {
                while (split > minSplit && tokens[split] < SPACE) {
                    split --;
                }
            }
            if (split > minSplit) {
                addSplit(++split);
                continue;
            }
            split = lastSplit + wrapLimit;
            if (tokens[split] == CHAR_EXT)
                split--;
            addSplit(split - indent);
        }
        return splits;
    };
    this.$getDisplayTokens = function(str, offset) {
        var arr = [];
        var tabSize;
        offset = offset || 0;

        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            if (c == 9) {
                tabSize = this.getScreenTabSize(arr.length + offset);
                arr.push(TAB);
                for (var n = 1; n < tabSize; n++) {
                    arr.push(TAB_SPACE);
                }
            }
            else if (c == 32) {
                arr.push(SPACE);
            } else if((c > 39 && c < 48) || (c > 57 && c < 64)) {
                arr.push(PUNCTUATION);
            }
            else if (c >= 0x1100 && isFullWidth(c)) {
                arr.push(CHAR, CHAR_EXT);
            } else {
                arr.push(CHAR);
            }
        }
        return arr;
    };
    this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
        if (maxScreenColumn == 0)
            return [0, 0];
        if (maxScreenColumn == null)
            maxScreenColumn = Infinity;
        screenColumn = screenColumn || 0;

        var c, column;
        for (column = 0; column < str.length; column++) {
            c = str.charCodeAt(column);
            if (c == 9) {
                screenColumn += this.getScreenTabSize(screenColumn);
            }
            else if (c >= 0x1100 && isFullWidth(c)) {
                screenColumn += 2;
            } else {
                screenColumn += 1;
            }
            if (screenColumn > maxScreenColumn) {
                break;
            }
        }

        return [screenColumn, column];
    };

    this.lineWidgets = null;
    this.getRowLength = function(row) {
        if (this.lineWidgets)
            var h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
        else 
            h = 0;
        if (!this.$useWrapMode || !this.$wrapData[row]) {
            return 1 + h;
        } else {
            return this.$wrapData[row].length + 1 + h;
        }
    };
    this.getRowLineCount = function(row) {
        if (!this.$useWrapMode || !this.$wrapData[row]) {
            return 1;
        } else {
            return this.$wrapData[row].length + 1;
        }
    };

    this.getRowWrapIndent = function(screenRow) {
        if (this.$useWrapMode) {
            var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
            var splits = this.$wrapData[pos.row];
            return splits.length && splits[0] < pos.column ? splits.indent : 0;
        } else {
            return 0;
        }
    };
    this.getScreenLastRowColumn = function(screenRow) {
        var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
        return this.documentToScreenColumn(pos.row, pos.column);
    };
    this.getDocumentLastRowColumn = function(docRow, docColumn) {
        var screenRow = this.documentToScreenRow(docRow, docColumn);
        return this.getScreenLastRowColumn(screenRow);
    };
    this.getDocumentLastRowColumnPosition = function(docRow, docColumn) {
        var screenRow = this.documentToScreenRow(docRow, docColumn);
        return this.screenToDocumentPosition(screenRow, Number.MAX_VALUE / 10);
    };
    this.getRowSplitData = function(row) {
        if (!this.$useWrapMode) {
            return undefined;
        } else {
            return this.$wrapData[row];
        }
    };
    this.getScreenTabSize = function(screenColumn) {
        return this.$tabSize - screenColumn % this.$tabSize;
    };


    this.screenToDocumentRow = function(screenRow, screenColumn) {
        return this.screenToDocumentPosition(screenRow, screenColumn).row;
    };


    this.screenToDocumentColumn = function(screenRow, screenColumn) {
        return this.screenToDocumentPosition(screenRow, screenColumn).column;
    };
    this.screenToDocumentPosition = function(screenRow, screenColumn, offsetX) {
        if (screenRow < 0)
            return {row: 0, column: 0};

        var line;
        var docRow = 0;
        var docColumn = 0;
        var column;
        var row = 0;
        var rowLength = 0;

        var rowCache = this.$screenRowCache;
        var i = this.$getRowCacheIndex(rowCache, screenRow);
        var l = rowCache.length;
        if (l && i >= 0) {
            var row = rowCache[i];
            var docRow = this.$docRowCache[i];
            var doCache = screenRow > rowCache[l - 1];
        } else {
            var doCache = !l;
        }

        var maxRow = this.getLength() - 1;
        var foldLine = this.getNextFoldLine(docRow);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (row <= screenRow) {
            rowLength = this.getRowLength(docRow);
            if (row + rowLength > screenRow || docRow >= maxRow) {
                break;
            } else {
                row += rowLength;
                docRow++;
                if (docRow > foldStart) {
                    docRow = foldLine.end.row+1;
                    foldLine = this.getNextFoldLine(docRow, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
            }

            if (doCache) {
                this.$docRowCache.push(docRow);
                this.$screenRowCache.push(row);
            }
        }

        if (foldLine && foldLine.start.row <= docRow) {
            line = this.getFoldDisplayLine(foldLine);
            docRow = foldLine.start.row;
        } else if (row + rowLength <= screenRow || docRow > maxRow) {
            return {
                row: maxRow,
                column: this.getLine(maxRow).length
            };
        } else {
            line = this.getLine(docRow);
            foldLine = null;
        }
        var wrapIndent = 0, splitIndex = Math.floor(screenRow - row);
        if (this.$useWrapMode) {
            var splits = this.$wrapData[docRow];
            if (splits) {
                column = splits[splitIndex];
                if(splitIndex > 0 && splits.length) {
                    wrapIndent = splits.indent;
                    docColumn = splits[splitIndex - 1] || splits[splits.length - 1];
                    line = line.substring(docColumn);
                }
            }
        }

        if (offsetX !== undefined && this.$bidiHandler.isBidiRow(row + splitIndex, docRow, splitIndex))
            screenColumn = this.$bidiHandler.offsetToCol(offsetX);

        docColumn += this.$getStringScreenWidth(line, screenColumn - wrapIndent)[1];
        if (this.$useWrapMode && docColumn >= column)
            docColumn = column - 1;

        if (foldLine)
            return foldLine.idxToPosition(docColumn);

        return {row: docRow, column: docColumn};
    };
    this.documentToScreenPosition = function(docRow, docColumn) {
        if (typeof docColumn === "undefined")
            var pos = this.$clipPositionToDocument(docRow.row, docRow.column);
        else
            pos = this.$clipPositionToDocument(docRow, docColumn);

        docRow = pos.row;
        docColumn = pos.column;

        var screenRow = 0;
        var foldStartRow = null;
        var fold = null;
        fold = this.getFoldAt(docRow, docColumn, 1);
        if (fold) {
            docRow = fold.start.row;
            docColumn = fold.start.column;
        }

        var rowEnd, row = 0;


        var rowCache = this.$docRowCache;
        var i = this.$getRowCacheIndex(rowCache, docRow);
        var l = rowCache.length;
        if (l && i >= 0) {
            var row = rowCache[i];
            var screenRow = this.$screenRowCache[i];
            var doCache = docRow > rowCache[l - 1];
        } else {
            var doCache = !l;
        }

        var foldLine = this.getNextFoldLine(row);
        var foldStart = foldLine ?foldLine.start.row :Infinity;

        while (row < docRow) {
            if (row >= foldStart) {
                rowEnd = foldLine.end.row + 1;
                if (rowEnd > docRow)
                    break;
                foldLine = this.getNextFoldLine(rowEnd, foldLine);
                foldStart = foldLine ?foldLine.start.row :Infinity;
            }
            else {
                rowEnd = row + 1;
            }

            screenRow += this.getRowLength(row);
            row = rowEnd;

            if (doCache) {
                this.$docRowCache.push(row);
                this.$screenRowCache.push(screenRow);
            }
        }
        var textLine = "";
        if (foldLine && row >= foldStart) {
            textLine = this.getFoldDisplayLine(foldLine, docRow, docColumn);
            foldStartRow = foldLine.start.row;
        } else {
            textLine = this.getLine(docRow).substring(0, docColumn);
            foldStartRow = docRow;
        }
        var wrapIndent = 0;
        if (this.$useWrapMode) {
            var wrapRow = this.$wrapData[foldStartRow];
            if (wrapRow) {
                var screenRowOffset = 0;
                while (textLine.length >= wrapRow[screenRowOffset]) {
                    screenRow ++;
                    screenRowOffset++;
                }
                textLine = textLine.substring(
                    wrapRow[screenRowOffset - 1] || 0, textLine.length
                );
                wrapIndent = screenRowOffset > 0 ? wrapRow.indent : 0;
            }
        }

        return {
            row: screenRow,
            column: wrapIndent + this.$getStringScreenWidth(textLine)[0]
        };
    };
    this.documentToScreenColumn = function(row, docColumn) {
        return this.documentToScreenPosition(row, docColumn).column;
    };
    this.documentToScreenRow = function(docRow, docColumn) {
        return this.documentToScreenPosition(docRow, docColumn).row;
    };
    this.getScreenLength = function() {
        var screenRows = 0;
        var fold = null;
        if (!this.$useWrapMode) {
            screenRows = this.getLength();
            var foldData = this.$foldData;
            for (var i = 0; i < foldData.length; i++) {
                fold = foldData[i];
                screenRows -= fold.end.row - fold.start.row;
            }
        } else {
            var lastRow = this.$wrapData.length;
            var row = 0, i = 0;
            var fold = this.$foldData[i++];
            var foldStart = fold ? fold.start.row :Infinity;

            while (row < lastRow) {
                var splits = this.$wrapData[row];
                screenRows += splits ? splits.length + 1 : 1;
                row ++;
                if (row > foldStart) {
                    row = fold.end.row+1;
                    fold = this.$foldData[i++];
                    foldStart = fold ?fold.start.row :Infinity;
                }
            }
        }
        if (this.lineWidgets)
            screenRows += this.$getWidgetScreenLength();

        return screenRows;
    };
    this.$setFontMetrics = function(fm) {
        if (!this.$enableVarChar) return;
        this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
            if (maxScreenColumn === 0)
                return [0, 0];
            if (!maxScreenColumn)
                maxScreenColumn = Infinity;
            screenColumn = screenColumn || 0;
            
            var c, column;
            for (column = 0; column < str.length; column++) {
                c = str.charAt(column);
                if (c === "\t") {
                    screenColumn += this.getScreenTabSize(screenColumn);
                } else {
                    screenColumn += fm.getCharacterWidth(c);
                }
                if (screenColumn > maxScreenColumn) {
                    break;
                }
            }
            
            return [screenColumn, column];
        };
    };
    
    this.destroy = function() {
        if (this.bgTokenizer) {
            this.bgTokenizer.setDocument(null);
            this.bgTokenizer = null;
        }
        this.$stopWorker();
    };

    this.isFullWidth = isFullWidth;
    function isFullWidth(c) {
        if (c < 0x1100)
            return false;
        return c >= 0x1100 && c <= 0x115F ||
               c >= 0x11A3 && c <= 0x11A7 ||
               c >= 0x11FA && c <= 0x11FF ||
               c >= 0x2329 && c <= 0x232A ||
               c >= 0x2E80 && c <= 0x2E99 ||
               c >= 0x2E9B && c <= 0x2EF3 ||
               c >= 0x2F00 && c <= 0x2FD5 ||
               c >= 0x2FF0 && c <= 0x2FFB ||
               c >= 0x3000 && c <= 0x303E ||
               c >= 0x3041 && c <= 0x3096 ||
               c >= 0x3099 && c <= 0x30FF ||
               c >= 0x3105 && c <= 0x312D ||
               c >= 0x3131 && c <= 0x318E ||
               c >= 0x3190 && c <= 0x31BA ||
               c >= 0x31C0 && c <= 0x31E3 ||
               c >= 0x31F0 && c <= 0x321E ||
               c >= 0x3220 && c <= 0x3247 ||
               c >= 0x3250 && c <= 0x32FE ||
               c >= 0x3300 && c <= 0x4DBF ||
               c >= 0x4E00 && c <= 0xA48C ||
               c >= 0xA490 && c <= 0xA4C6 ||
               c >= 0xA960 && c <= 0xA97C ||
               c >= 0xAC00 && c <= 0xD7A3 ||
               c >= 0xD7B0 && c <= 0xD7C6 ||
               c >= 0xD7CB && c <= 0xD7FB ||
               c >= 0xF900 && c <= 0xFAFF ||
               c >= 0xFE10 && c <= 0xFE19 ||
               c >= 0xFE30 && c <= 0xFE52 ||
               c >= 0xFE54 && c <= 0xFE66 ||
               c >= 0xFE68 && c <= 0xFE6B ||
               c >= 0xFF01 && c <= 0xFF60 ||
               c >= 0xFFE0 && c <= 0xFFE6;
    }

}).call(EditSession.prototype);

acequire("./edit_session/folding").Folding.call(EditSession.prototype);
acequire("./edit_session/bracket_match").BracketMatch.call(EditSession.prototype);


config.defineOptions(EditSession.prototype, "session", {
    wrap: {
        set: function(value) {
            if (!value || value == "off")
                value = false;
            else if (value == "free")
                value = true;
            else if (value == "printMargin")
                value = -1;
            else if (typeof value == "string")
                value = parseInt(value, 10) || false;

            if (this.$wrap == value)
                return;
            this.$wrap = value;
            if (!value) {
                this.setUseWrapMode(false);
            } else {
                var col = typeof value == "number" ? value : null;
                this.setWrapLimitRange(col, col);
                this.setUseWrapMode(true);
            }
        },
        get: function() {
            if (this.getUseWrapMode()) {
                if (this.$wrap == -1)
                    return "printMargin";
                if (!this.getWrapLimitRange().min)
                    return "free";
                return this.$wrap;
            }
            return "off";
        },
        handlesSet: true
    },    
    wrapMethod: {
        set: function(val) {
            val = val == "auto"
                ? this.$mode.type != "text"
                : val != "text";
            if (val != this.$wrapAsCode) {
                this.$wrapAsCode = val;
                if (this.$useWrapMode) {
                    this.$modified = true;
                    this.$resetRowCache(0);
                    this.$updateWrapData(0, this.getLength() - 1);
                }
            }
        },
        initialValue: "auto"
    },
    indentedSoftWrap: { initialValue: true },
    firstLineNumber: {
        set: function() {this._signal("changeBreakpoint");},
        initialValue: 1
    },
    useWorker: {
        set: function(useWorker) {
            this.$useWorker = useWorker;

            this.$stopWorker();
            if (useWorker)
                this.$startWorker();
        },
        initialValue: true
    },
    useSoftTabs: {initialValue: true},
    tabSize: {
        set: function(tabSize) {
            if (isNaN(tabSize) || this.$tabSize === tabSize) return;

            this.$modified = true;
            this.$rowLengthCache = [];
            this.$tabSize = tabSize;
            this._signal("changeTabSize");
        },
        initialValue: 4,
        handlesSet: true
    },
    navigateWithinSoftTabs: {initialValue: false},
    overwrite: {
        set: function(val) {this._signal("changeOverwrite");},
        initialValue: false
    },
    newLineMode: {
        set: function(val) {this.doc.setNewLineMode(val);},
        get: function() {return this.doc.getNewLineMode();},
        handlesSet: true
    },
    mode: {
        set: function(val) { this.setMode(val); },
        get: function() { return this.$modeId; }
    }
});

exports.EditSession = EditSession;
});

ace.define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"], function(acequire, exports, module) {
"use strict";

var lang = acequire("./lib/lang");
var oop = acequire("./lib/oop");
var Range = acequire("./range").Range;

var Search = function() {
    this.$options = {};
};

(function() {
    this.set = function(options) {
        oop.mixin(this.$options, options);
        return this;
    };
    this.getOptions = function() {
        return lang.copyObject(this.$options);
    };
    this.setOptions = function(options) {
        this.$options = options;
    };
    this.find = function(session) {
        var options = this.$options;
        var iterator = this.$matchIterator(session, options);
        if (!iterator)
            return false;

        var firstRange = null;
        iterator.forEach(function(sr, sc, er, ec) {
            firstRange = new Range(sr, sc, er, ec);
            if (sc == ec && options.start && options.start.start
                && options.skipCurrent != false && firstRange.isEqual(options.start)
            ) {
                firstRange = null;
                return false;
            }

            return true;
        });

        return firstRange;
    };
    this.findAll = function(session) {
        var options = this.$options;
        if (!options.needle)
            return [];
        this.$assembleRegExp(options);

        var range = options.range;
        var lines = range
            ? session.getLines(range.start.row, range.end.row)
            : session.doc.getAllLines();

        var ranges = [];
        var re = options.re;
        if (options.$isMultiLine) {
            var len = re.length;
            var maxRow = lines.length - len;
            var prevRange;
            outer: for (var row = re.offset || 0; row <= maxRow; row++) {
                for (var j = 0; j < len; j++)
                    if (lines[row + j].search(re[j]) == -1)
                        continue outer;
                
                var startLine = lines[row];
                var line = lines[row + len - 1];
                var startIndex = startLine.length - startLine.match(re[0])[0].length;
                var endIndex = line.match(re[len - 1])[0].length;
                
                if (prevRange && prevRange.end.row === row &&
                    prevRange.end.column > startIndex
                ) {
                    continue;
                }
                ranges.push(prevRange = new Range(
                    row, startIndex, row + len - 1, endIndex
                ));
                if (len > 2)
                    row = row + len - 2;
            }
        } else {
            for (var i = 0; i < lines.length; i++) {
                var matches = lang.getMatchOffsets(lines[i], re);
                for (var j = 0; j < matches.length; j++) {
                    var match = matches[j];
                    ranges.push(new Range(i, match.offset, i, match.offset + match.length));
                }
            }
        }

        if (range) {
            var startColumn = range.start.column;
            var endColumn = range.start.column;
            var i = 0, j = ranges.length - 1;
            while (i < j && ranges[i].start.column < startColumn && ranges[i].start.row == range.start.row)
                i++;

            while (i < j && ranges[j].end.column > endColumn && ranges[j].end.row == range.end.row)
                j--;
            
            ranges = ranges.slice(i, j + 1);
            for (i = 0, j = ranges.length; i < j; i++) {
                ranges[i].start.row += range.start.row;
                ranges[i].end.row += range.start.row;
            }
        }

        return ranges;
    };
    this.replace = function(input, replacement) {
        var options = this.$options;

        var re = this.$assembleRegExp(options);
        if (options.$isMultiLine)
            return replacement;

        if (!re)
            return;

        var match = re.exec(input);
        if (!match || match[0].length != input.length)
            return null;
        
        replacement = input.replace(re, replacement);
        if (options.preserveCase) {
            replacement = replacement.split("");
            for (var i = Math.min(input.length, input.length); i--; ) {
                var ch = input[i];
                if (ch && ch.toLowerCase() != ch)
                    replacement[i] = replacement[i].toUpperCase();
                else
                    replacement[i] = replacement[i].toLowerCase();
            }
            replacement = replacement.join("");
        }
        
        return replacement;
    };

    this.$assembleRegExp = function(options, $disableFakeMultiline) {
        if (options.needle instanceof RegExp)
            return options.re = options.needle;

        var needle = options.needle;

        if (!options.needle)
            return options.re = false;

        if (!options.regExp)
            needle = lang.escapeRegExp(needle);

        if (options.wholeWord)
            needle = addWordBoundary(needle, options);

        var modifier = options.caseSensitive ? "gm" : "gmi";

        options.$isMultiLine = !$disableFakeMultiline && /[\n\r]/.test(needle);
        if (options.$isMultiLine)
            return options.re = this.$assembleMultilineRegExp(needle, modifier);

        try {
            var re = new RegExp(needle, modifier);
        } catch(e) {
            re = false;
        }
        return options.re = re;
    };

    this.$assembleMultilineRegExp = function(needle, modifier) {
        var parts = needle.replace(/\r\n|\r|\n/g, "$\n^").split("\n");
        var re = [];
        for (var i = 0; i < parts.length; i++) try {
            re.push(new RegExp(parts[i], modifier));
        } catch(e) {
            return false;
        }
        return re;
    };

    this.$matchIterator = function(session, options) {
        var re = this.$assembleRegExp(options);
        if (!re)
            return false;
        var backwards = options.backwards == true;
        var skipCurrent = options.skipCurrent != false;

        var range = options.range;
        var start = options.start;
        if (!start)
            start = range ? range[backwards ? "end" : "start"] : session.selection.getRange();
         
        if (start.start)
            start = start[skipCurrent != backwards ? "end" : "start"];

        var firstRow = range ? range.start.row : 0;
        var lastRow = range ? range.end.row : session.getLength() - 1;

        if (backwards) {
            var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback))
                    return;
                for (row--; row >= firstRow; row--)
                    if (forEachInLine(row, Number.MAX_VALUE, callback))
                        return;
                if (options.wrap == false)
                    return;
                for (row = lastRow, firstRow = start.row; row >= firstRow; row--)
                    if (forEachInLine(row, Number.MAX_VALUE, callback))
                        return;
            };
        }
        else {
            var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback))
                    return;
                for (row = row + 1; row <= lastRow; row++)
                    if (forEachInLine(row, 0, callback))
                        return;
                if (options.wrap == false)
                    return;
                for (row = firstRow, lastRow = start.row; row <= lastRow; row++)
                    if (forEachInLine(row, 0, callback))
                        return;
            };
        }
        
        if (options.$isMultiLine) {
            var len = re.length;
            var forEachInLine = function(row, offset, callback) {
                var startRow = backwards ? row - len + 1 : row;
                if (startRow < 0) return;
                var line = session.getLine(startRow);
                var startIndex = line.search(re[0]);
                if (!backwards && startIndex < offset || startIndex === -1) return;
                for (var i = 1; i < len; i++) {
                    line = session.getLine(startRow + i);
                    if (line.search(re[i]) == -1)
                        return;
                }
                var endIndex = line.match(re[len - 1])[0].length;
                if (backwards && endIndex > offset) return;
                if (callback(startRow, startIndex, startRow + len - 1, endIndex))
                    return true;
            };
        }
        else if (backwards) {
            var forEachInLine = function(row, endIndex, callback) {
                var line = session.getLine(row);
                var matches = [];
                var m, last = 0;
                re.lastIndex = 0;
                while((m = re.exec(line))) {
                    var length = m[0].length;
                    last = m.index;
                    if (!length) {
                        if (last >= line.length) break;
                        re.lastIndex = last += 1;
                    }
                    if (m.index + length > endIndex)
                        break;
                    matches.push(m.index, length);
                }
                for (var i = matches.length - 1; i >= 0; i -= 2) {
                    var column = matches[i - 1];
                    var length = matches[i];
                    if (callback(row, column, row, column + length))
                        return true;
                }
            };
        }
        else {
            var forEachInLine = function(row, startIndex, callback) {
                var line = session.getLine(row);
                var m;
                var last = startIndex;
                re.lastIndex = startIndex;
                while((m = re.exec(line))) {
                    var length = m[0].length;
                    last = m.index;
                    if (callback(row, last, row,last + length))
                        return true;
                    if (!length) {
                        re.lastIndex = last += 1;
                        if (last >= line.length) return false;
                    }
                }
            };
        }
        return {forEach: forEach};
    };

}).call(Search.prototype);

function addWordBoundary(needle, options) {
    function wordBoundary(c) {
        if (/\w/.test(c) || options.regExp) return "\\b";
        return "";
    }
    return wordBoundary(needle[0]) + needle
        + wordBoundary(needle[needle.length - 1]);
}

exports.Search = Search;
});

ace.define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"], function(acequire, exports, module) {
"use strict";

var keyUtil = acequire("../lib/keys");
var useragent = acequire("../lib/useragent");
var KEY_MODS = keyUtil.KEY_MODS;

function HashHandler(config, platform) {
    this.platform = platform || (useragent.isMac ? "mac" : "win");
    this.commands = {};
    this.commandKeyBinding = {};
    this.addCommands(config);
    this.$singleCommand = true;
}

function MultiHashHandler(config, platform) {
    HashHandler.call(this, config, platform);
    this.$singleCommand = false;
}

MultiHashHandler.prototype = HashHandler.prototype;

(function() {
    

    this.addCommand = function(command) {
        if (this.commands[command.name])
            this.removeCommand(command);

        this.commands[command.name] = command;

        if (command.bindKey)
            this._buildKeyHash(command);
    };

    this.removeCommand = function(command, keepCommand) {
        var name = command && (typeof command === 'string' ? command : command.name);
        command = this.commands[name];
        if (!keepCommand)
            delete this.commands[name];
        var ckb = this.commandKeyBinding;
        for (var keyId in ckb) {
            var cmdGroup = ckb[keyId];
            if (cmdGroup == command) {
                delete ckb[keyId];
            } else if (Array.isArray(cmdGroup)) {
                var i = cmdGroup.indexOf(command);
                if (i != -1) {
                    cmdGroup.splice(i, 1);
                    if (cmdGroup.length == 1)
                        ckb[keyId] = cmdGroup[0];
                }
            }
        }
    };

    this.bindKey = function(key, command, position) {
        if (typeof key == "object" && key) {
            if (position == undefined)
                position = key.position;
            key = key[this.platform];
        }
        if (!key)
            return;
        if (typeof command == "function")
            return this.addCommand({exec: command, bindKey: key, name: command.name || key});
        
        key.split("|").forEach(function(keyPart) {
            var chain = "";
            if (keyPart.indexOf(" ") != -1) {
                var parts = keyPart.split(/\s+/);
                keyPart = parts.pop();
                parts.forEach(function(keyPart) {
                    var binding = this.parseKeys(keyPart);
                    var id = KEY_MODS[binding.hashId] + binding.key;
                    chain += (chain ? " " : "") + id;
                    this._addCommandToBinding(chain, "chainKeys");
                }, this);
                chain += " ";
            }
            var binding = this.parseKeys(keyPart);
            var id = KEY_MODS[binding.hashId] + binding.key;
            this._addCommandToBinding(chain + id, command, position);
        }, this);
    };
    
    function getPosition(command) {
        return typeof command == "object" && command.bindKey
            && command.bindKey.position
            || (command.isDefault ? -100 : 0);
    }
    this._addCommandToBinding = function(keyId, command, position) {
        var ckb = this.commandKeyBinding, i;
        if (!command) {
            delete ckb[keyId];
        } else if (!ckb[keyId] || this.$singleCommand) {
            ckb[keyId] = command;
        } else {
            if (!Array.isArray(ckb[keyId])) {
                ckb[keyId] = [ckb[keyId]];
            } else if ((i = ckb[keyId].indexOf(command)) != -1) {
                ckb[keyId].splice(i, 1);
            }

            if (typeof position != "number") {
                position = getPosition(command);
            }

            var commands = ckb[keyId];
            for (i = 0; i < commands.length; i++) {
                var other = commands[i];
                var otherPos = getPosition(other);
                if (otherPos > position)
                    break;
            }
            commands.splice(i, 0, command);
        }
    };

    this.addCommands = function(commands) {
        commands && Object.keys(commands).forEach(function(name) {
            var command = commands[name];
            if (!command)
                return;
            
            if (typeof command === "string")
                return this.bindKey(command, name);

            if (typeof command === "function")
                command = { exec: command };

            if (typeof command !== "object")
                return;

            if (!command.name)
                command.name = name;

            this.addCommand(command);
        }, this);
    };

    this.removeCommands = function(commands) {
        Object.keys(commands).forEach(function(name) {
            this.removeCommand(commands[name]);
        }, this);
    };

    this.bindKeys = function(keyList) {
        Object.keys(keyList).forEach(function(key) {
            this.bindKey(key, keyList[key]);
        }, this);
    };

    this._buildKeyHash = function(command) {
        this.bindKey(command.bindKey, command);
    };
    this.parseKeys = function(keys) {
        var parts = keys.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(x){return x;});
        var key = parts.pop();

        var keyCode = keyUtil[key];
        if (keyUtil.FUNCTION_KEYS[keyCode])
            key = keyUtil.FUNCTION_KEYS[keyCode].toLowerCase();
        else if (!parts.length)
            return {key: key, hashId: -1};
        else if (parts.length == 1 && parts[0] == "shift")
            return {key: key.toUpperCase(), hashId: -1};

        var hashId = 0;
        for (var i = parts.length; i--;) {
            var modifier = keyUtil.KEY_MODS[parts[i]];
            if (modifier == null) {
                if (typeof console != "undefined")
                    console.error("invalid modifier " + parts[i] + " in " + keys);
                return false;
            }
            hashId |= modifier;
        }
        return {key: key, hashId: hashId};
    };

    this.findKeyCommand = function findKeyCommand(hashId, keyString) {
        var key = KEY_MODS[hashId] + keyString;
        return this.commandKeyBinding[key];
    };

    this.handleKeyboard = function(data, hashId, keyString, keyCode) {
        if (keyCode < 0) return;
        var key = KEY_MODS[hashId] + keyString;
        var command = this.commandKeyBinding[key];
        if (data.$keyChain) {
            data.$keyChain += " " + key;
            command = this.commandKeyBinding[data.$keyChain] || command;
        }
        
        if (command) {
            if (command == "chainKeys" || command[command.length - 1] == "chainKeys") {
                data.$keyChain = data.$keyChain || key;
                return {command: "null"};
            }
        }
        
        if (data.$keyChain) {
            if ((!hashId || hashId == 4) && keyString.length == 1)
                data.$keyChain = data.$keyChain.slice(0, -key.length - 1); // wait for input
            else if (hashId == -1 || keyCode > 0)
                data.$keyChain = ""; // reset keyChain
        }
        return {command: command};
    };
    
    this.getStatusText = function(editor, data) {
        return data.$keyChain || "";
    };

}).call(HashHandler.prototype);

exports.HashHandler = HashHandler;
exports.MultiHashHandler = MultiHashHandler;
});

ace.define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var MultiHashHandler = acequire("../keyboard/hash_handler").MultiHashHandler;
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var CommandManager = function(platform, commands) {
    MultiHashHandler.call(this, commands, platform);
    this.byName = this.commands;
    this.setDefaultHandler("exec", function(e) {
        return e.command.exec(e.editor, e.args || {});
    });
};

oop.inherits(CommandManager, MultiHashHandler);

(function() {

    oop.implement(this, EventEmitter);

    this.exec = function(command, editor, args) {
        if (Array.isArray(command)) {
            for (var i = command.length; i--; ) {
                if (this.exec(command[i], editor, args)) return true;
            }
            return false;
        }

        if (typeof command === "string")
            command = this.commands[command];

        if (!command)
            return false;

        if (editor && editor.$readOnly && !command.readOnly)
            return false;

        if (command.isAvailable && !command.isAvailable(editor))
            return false;

        var e = {editor: editor, command: command, args: args};
        e.returnValue = this._emit("exec", e);
        this._signal("afterExec", e);

        return e.returnValue === false ? false : true;
    };

    this.toggleRecording = function(editor) {
        if (this.$inReplay)
            return;

        editor && editor._emit("changeStatus");
        if (this.recording) {
            this.macro.pop();
            this.removeEventListener("exec", this.$addCommandToMacro);

            if (!this.macro.length)
                this.macro = this.oldMacro;

            return this.recording = false;
        }
        if (!this.$addCommandToMacro) {
            this.$addCommandToMacro = function(e) {
                this.macro.push([e.command, e.args]);
            }.bind(this);
        }

        this.oldMacro = this.macro;
        this.macro = [];
        this.on("exec", this.$addCommandToMacro);
        return this.recording = true;
    };

    this.replay = function(editor) {
        if (this.$inReplay || !this.macro)
            return;

        if (this.recording)
            return this.toggleRecording(editor);

        try {
            this.$inReplay = true;
            this.macro.forEach(function(x) {
                if (typeof x == "string")
                    this.exec(x, editor);
                else
                    this.exec(x[0], editor, x[1]);
            }, this);
        } finally {
            this.$inReplay = false;
        }
    };

    this.trimMacro = function(m) {
        return m.map(function(x){
            if (typeof x[0] != "string")
                x[0] = x[0].name;
            if (!x[1])
                x = x[0];
            return x;
        });
    };

}).call(CommandManager.prototype);

exports.CommandManager = CommandManager;

});

ace.define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"], function(acequire, exports, module) {
"use strict";

var lang = acequire("../lib/lang");
var config = acequire("../config");
var Range = acequire("../range").Range;

function bindKey(win, mac) {
    return {win: win, mac: mac};
}
exports.commands = [{
    name: "showSettingsMenu",
    bindKey: bindKey("Ctrl-,", "Command-,"),
    exec: function(editor) {
        config.loadModule("ace/ext/settings_menu", function(module) {
            module.init(editor);
            editor.showSettingsMenu();
        });
    },
    readOnly: true
}, {
    name: "goToNextError",
    bindKey: bindKey("Alt-E", "F4"),
    exec: function(editor) {
        config.loadModule("ace/ext/error_marker", function(module) {
            module.showErrorMarker(editor, 1);
        });
    },
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "goToPreviousError",
    bindKey: bindKey("Alt-Shift-E", "Shift-F4"),
    exec: function(editor) {
        config.loadModule("ace/ext/error_marker", function(module) {
            module.showErrorMarker(editor, -1);
        });
    },
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "selectall",
    bindKey: bindKey("Ctrl-A", "Command-A"),
    exec: function(editor) { editor.selectAll(); },
    readOnly: true
}, {
    name: "centerselection",
    bindKey: bindKey(null, "Ctrl-L"),
    exec: function(editor) { editor.centerSelection(); },
    readOnly: true
}, {
    name: "gotoline",
    bindKey: bindKey("Ctrl-L", "Command-L"),
    exec: function(editor) {
        var line = parseInt(prompt("Enter line number:"), 10);
        if (!isNaN(line)) {
            editor.gotoLine(line);
        }
    },
    readOnly: true
}, {
    name: "fold",
    bindKey: bindKey("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
    exec: function(editor) { editor.session.toggleFold(false); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "unfold",
    bindKey: bindKey("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
    exec: function(editor) { editor.session.toggleFold(true); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "toggleFoldWidget",
    bindKey: bindKey("F2", "F2"),
    exec: function(editor) { editor.session.toggleFoldWidget(); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "toggleParentFoldWidget",
    bindKey: bindKey("Alt-F2", "Alt-F2"),
    exec: function(editor) { editor.session.toggleFoldWidget(true); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "foldall",
    bindKey: bindKey(null, "Ctrl-Command-Option-0"),
    exec: function(editor) { editor.session.foldAll(); },
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "foldOther",
    bindKey: bindKey("Alt-0", "Command-Option-0"),
    exec: function(editor) { 
        editor.session.foldAll();
        editor.session.unfold(editor.selection.getAllRanges());
    },
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "unfoldall",
    bindKey: bindKey("Alt-Shift-0", "Command-Option-Shift-0"),
    exec: function(editor) { editor.session.unfold(); },
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "findnext",
    bindKey: bindKey("Ctrl-K", "Command-G"),
    exec: function(editor) { editor.findNext(); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "findprevious",
    bindKey: bindKey("Ctrl-Shift-K", "Command-Shift-G"),
    exec: function(editor) { editor.findPrevious(); },
    multiSelectAction: "forEach",
    scrollIntoView: "center",
    readOnly: true
}, {
    name: "selectOrFindNext",
    bindKey: bindKey("Alt-K", "Ctrl-G"),
    exec: function(editor) {
        if (editor.selection.isEmpty())
            editor.selection.selectWord();
        else
            editor.findNext(); 
    },
    readOnly: true
}, {
    name: "selectOrFindPrevious",
    bindKey: bindKey("Alt-Shift-K", "Ctrl-Shift-G"),
    exec: function(editor) { 
        if (editor.selection.isEmpty())
            editor.selection.selectWord();
        else
            editor.findPrevious();
    },
    readOnly: true
}, {
    name: "find",
    bindKey: bindKey("Ctrl-F", "Command-F"),
    exec: function(editor) {
        config.loadModule("ace/ext/searchbox", function(e) {e.Search(editor);});
    },
    readOnly: true
}, {
    name: "overwrite",
    bindKey: "Insert",
    exec: function(editor) { editor.toggleOverwrite(); },
    readOnly: true
}, {
    name: "selecttostart",
    bindKey: bindKey("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
    exec: function(editor) { editor.getSelection().selectFileStart(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "gotostart",
    bindKey: bindKey("Ctrl-Home", "Command-Home|Command-Up"),
    exec: function(editor) { editor.navigateFileStart(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "selectup",
    bindKey: bindKey("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
    exec: function(editor) { editor.getSelection().selectUp(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "golineup",
    bindKey: bindKey("Up", "Up|Ctrl-P"),
    exec: function(editor, args) { editor.navigateUp(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selecttoend",
    bindKey: bindKey("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
    exec: function(editor) { editor.getSelection().selectFileEnd(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "gotoend",
    bindKey: bindKey("Ctrl-End", "Command-End|Command-Down"),
    exec: function(editor) { editor.navigateFileEnd(); },
    multiSelectAction: "forEach",
    readOnly: true,
    scrollIntoView: "animate",
    aceCommandGroup: "fileJump"
}, {
    name: "selectdown",
    bindKey: bindKey("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
    exec: function(editor) { editor.getSelection().selectDown(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "golinedown",
    bindKey: bindKey("Down", "Down|Ctrl-N"),
    exec: function(editor, args) { editor.navigateDown(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectwordleft",
    bindKey: bindKey("Ctrl-Shift-Left", "Option-Shift-Left"),
    exec: function(editor) { editor.getSelection().selectWordLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotowordleft",
    bindKey: bindKey("Ctrl-Left", "Option-Left"),
    exec: function(editor) { editor.navigateWordLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selecttolinestart",
    bindKey: bindKey("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
    exec: function(editor) { editor.getSelection().selectLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotolinestart",
    bindKey: bindKey("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
    exec: function(editor) { editor.navigateLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectleft",
    bindKey: bindKey("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
    exec: function(editor) { editor.getSelection().selectLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotoleft",
    bindKey: bindKey("Left", "Left|Ctrl-B"),
    exec: function(editor, args) { editor.navigateLeft(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectwordright",
    bindKey: bindKey("Ctrl-Shift-Right", "Option-Shift-Right"),
    exec: function(editor) { editor.getSelection().selectWordRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotowordright",
    bindKey: bindKey("Ctrl-Right", "Option-Right"),
    exec: function(editor) { editor.navigateWordRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selecttolineend",
    bindKey: bindKey("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
    exec: function(editor) { editor.getSelection().selectLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotolineend",
    bindKey: bindKey("Alt-Right|End", "Command-Right|End|Ctrl-E"),
    exec: function(editor) { editor.navigateLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectright",
    bindKey: bindKey("Shift-Right", "Shift-Right"),
    exec: function(editor) { editor.getSelection().selectRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "gotoright",
    bindKey: bindKey("Right", "Right|Ctrl-F"),
    exec: function(editor, args) { editor.navigateRight(args.times); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectpagedown",
    bindKey: "Shift-PageDown",
    exec: function(editor) { editor.selectPageDown(); },
    readOnly: true
}, {
    name: "pagedown",
    bindKey: bindKey(null, "Option-PageDown"),
    exec: function(editor) { editor.scrollPageDown(); },
    readOnly: true
}, {
    name: "gotopagedown",
    bindKey: bindKey("PageDown", "PageDown|Ctrl-V"),
    exec: function(editor) { editor.gotoPageDown(); },
    readOnly: true
}, {
    name: "selectpageup",
    bindKey: "Shift-PageUp",
    exec: function(editor) { editor.selectPageUp(); },
    readOnly: true
}, {
    name: "pageup",
    bindKey: bindKey(null, "Option-PageUp"),
    exec: function(editor) { editor.scrollPageUp(); },
    readOnly: true
}, {
    name: "gotopageup",
    bindKey: "PageUp",
    exec: function(editor) { editor.gotoPageUp(); },
    readOnly: true
}, {
    name: "scrollup",
    bindKey: bindKey("Ctrl-Up", null),
    exec: function(e) { e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight); },
    readOnly: true
}, {
    name: "scrolldown",
    bindKey: bindKey("Ctrl-Down", null),
    exec: function(e) { e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight); },
    readOnly: true
}, {
    name: "selectlinestart",
    bindKey: "Shift-Home",
    exec: function(editor) { editor.getSelection().selectLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectlineend",
    bindKey: "Shift-End",
    exec: function(editor) { editor.getSelection().selectLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "togglerecording",
    bindKey: bindKey("Ctrl-Alt-E", "Command-Option-E"),
    exec: function(editor) { editor.commands.toggleRecording(editor); },
    readOnly: true
}, {
    name: "replaymacro",
    bindKey: bindKey("Ctrl-Shift-E", "Command-Shift-E"),
    exec: function(editor) { editor.commands.replay(editor); },
    readOnly: true
}, {
    name: "jumptomatching",
    bindKey: bindKey("Ctrl-P", "Ctrl-P"),
    exec: function(editor) { editor.jumpToMatching(); },
    multiSelectAction: "forEach",
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "selecttomatching",
    bindKey: bindKey("Ctrl-Shift-P", "Ctrl-Shift-P"),
    exec: function(editor) { editor.jumpToMatching(true); },
    multiSelectAction: "forEach",
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "expandToMatching",
    bindKey: bindKey("Ctrl-Shift-M", "Ctrl-Shift-M"),
    exec: function(editor) { editor.jumpToMatching(true, true); },
    multiSelectAction: "forEach",
    scrollIntoView: "animate",
    readOnly: true
}, {
    name: "passKeysToBrowser",
    bindKey: bindKey(null, null),
    exec: function() {},
    passEvent: true,
    readOnly: true
}, {
    name: "copy",
    exec: function(editor) {
    },
    readOnly: true
},
{
    name: "cut",
    exec: function(editor) {
        var range = editor.getSelectionRange();
        editor._emit("cut", range);

        if (!editor.selection.isEmpty()) {
            editor.session.remove(range);
            editor.clearSelection();
        }
    },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "paste",
    exec: function(editor, args) {
        editor.$handlePaste(args);
    },
    scrollIntoView: "cursor"
}, {
    name: "removeline",
    bindKey: bindKey("Ctrl-D", "Command-D"),
    exec: function(editor) { editor.removeLines(); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEachLine"
}, {
    name: "duplicateSelection",
    bindKey: bindKey("Ctrl-Shift-D", "Command-Shift-D"),
    exec: function(editor) { editor.duplicateSelection(); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "sortlines",
    bindKey: bindKey("Ctrl-Alt-S", "Command-Alt-S"),
    exec: function(editor) { editor.sortLines(); },
    scrollIntoView: "selection",
    multiSelectAction: "forEachLine"
}, {
    name: "togglecomment",
    bindKey: bindKey("Ctrl-/", "Command-/"),
    exec: function(editor) { editor.toggleCommentLines(); },
    multiSelectAction: "forEachLine",
    scrollIntoView: "selectionPart"
}, {
    name: "toggleBlockComment",
    bindKey: bindKey("Ctrl-Shift-/", "Command-Shift-/"),
    exec: function(editor) { editor.toggleBlockComment(); },
    multiSelectAction: "forEach",
    scrollIntoView: "selectionPart"
}, {
    name: "modifyNumberUp",
    bindKey: bindKey("Ctrl-Shift-Up", "Alt-Shift-Up"),
    exec: function(editor) { editor.modifyNumber(1); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "modifyNumberDown",
    bindKey: bindKey("Ctrl-Shift-Down", "Alt-Shift-Down"),
    exec: function(editor) { editor.modifyNumber(-1); },
    scrollIntoView: "cursor",
    multiSelectAction: "forEach"
}, {
    name: "replace",
    bindKey: bindKey("Ctrl-H", "Command-Option-F"),
    exec: function(editor) {
        config.loadModule("ace/ext/searchbox", function(e) {e.Search(editor, true);});
    }
}, {
    name: "undo",
    bindKey: bindKey("Ctrl-Z", "Command-Z"),
    exec: function(editor) { editor.undo(); }
}, {
    name: "redo",
    bindKey: bindKey("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
    exec: function(editor) { editor.redo(); }
}, {
    name: "copylinesup",
    bindKey: bindKey("Alt-Shift-Up", "Command-Option-Up"),
    exec: function(editor) { editor.copyLinesUp(); },
    scrollIntoView: "cursor"
}, {
    name: "movelinesup",
    bindKey: bindKey("Alt-Up", "Option-Up"),
    exec: function(editor) { editor.moveLinesUp(); },
    scrollIntoView: "cursor"
}, {
    name: "copylinesdown",
    bindKey: bindKey("Alt-Shift-Down", "Command-Option-Down"),
    exec: function(editor) { editor.copyLinesDown(); },
    scrollIntoView: "cursor"
}, {
    name: "movelinesdown",
    bindKey: bindKey("Alt-Down", "Option-Down"),
    exec: function(editor) { editor.moveLinesDown(); },
    scrollIntoView: "cursor"
}, {
    name: "del",
    bindKey: bindKey("Delete", "Delete|Ctrl-D|Shift-Delete"),
    exec: function(editor) { editor.remove("right"); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "backspace",
    bindKey: bindKey(
        "Shift-Backspace|Backspace",
        "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"
    ),
    exec: function(editor) { editor.remove("left"); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "cut_or_delete",
    bindKey: bindKey("Shift-Delete", null),
    exec: function(editor) { 
        if (editor.selection.isEmpty()) {
            editor.remove("left");
        } else {
            return false;
        }
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolinestart",
    bindKey: bindKey("Alt-Backspace", "Command-Backspace"),
    exec: function(editor) { editor.removeToLineStart(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolineend",
    bindKey: bindKey("Alt-Delete", "Ctrl-K|Command-Delete"),
    exec: function(editor) { editor.removeToLineEnd(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolinestarthard",
    bindKey: bindKey("Ctrl-Shift-Backspace", null),
    exec: function(editor) {
        var range = editor.selection.getRange();
        range.start.column = 0;
        editor.session.remove(range);
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removetolineendhard",
    bindKey: bindKey("Ctrl-Shift-Delete", null),
    exec: function(editor) {
        var range = editor.selection.getRange();
        range.end.column = Number.MAX_VALUE;
        editor.session.remove(range);
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removewordleft",
    bindKey: bindKey("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
    exec: function(editor) { editor.removeWordLeft(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "removewordright",
    bindKey: bindKey("Ctrl-Delete", "Alt-Delete"),
    exec: function(editor) { editor.removeWordRight(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "outdent",
    bindKey: bindKey("Shift-Tab", "Shift-Tab"),
    exec: function(editor) { editor.blockOutdent(); },
    multiSelectAction: "forEach",
    scrollIntoView: "selectionPart"
}, {
    name: "indent",
    bindKey: bindKey("Tab", "Tab"),
    exec: function(editor) { editor.indent(); },
    multiSelectAction: "forEach",
    scrollIntoView: "selectionPart"
}, {
    name: "blockoutdent",
    bindKey: bindKey("Ctrl-[", "Ctrl-["),
    exec: function(editor) { editor.blockOutdent(); },
    multiSelectAction: "forEachLine",
    scrollIntoView: "selectionPart"
}, {
    name: "blockindent",
    bindKey: bindKey("Ctrl-]", "Ctrl-]"),
    exec: function(editor) { editor.blockIndent(); },
    multiSelectAction: "forEachLine",
    scrollIntoView: "selectionPart"
}, {
    name: "insertstring",
    exec: function(editor, str) { editor.insert(str); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "inserttext",
    exec: function(editor, args) {
        editor.insert(lang.stringRepeat(args.text  || "", args.times || 1));
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "splitline",
    bindKey: bindKey(null, "Ctrl-O"),
    exec: function(editor) { editor.splitLine(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "transposeletters",
    bindKey: bindKey("Alt-Shift-X", "Ctrl-T"),
    exec: function(editor) { editor.transposeLetters(); },
    multiSelectAction: function(editor) {editor.transposeSelections(1); },
    scrollIntoView: "cursor"
}, {
    name: "touppercase",
    bindKey: bindKey("Ctrl-U", "Ctrl-U"),
    exec: function(editor) { editor.toUpperCase(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "tolowercase",
    bindKey: bindKey("Ctrl-Shift-U", "Ctrl-Shift-U"),
    exec: function(editor) { editor.toLowerCase(); },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor"
}, {
    name: "expandtoline",
    bindKey: bindKey("Ctrl-Shift-L", "Command-Shift-L"),
    exec: function(editor) {
        var range = editor.selection.getRange();

        range.start.column = range.end.column = 0;
        range.end.row++;
        editor.selection.setRange(range, false);
    },
    multiSelectAction: "forEach",
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "joinlines",
    bindKey: bindKey(null, null),
    exec: function(editor) {
        var isBackwards = editor.selection.isBackwards();
        var selectionStart = isBackwards ? editor.selection.getSelectionLead() : editor.selection.getSelectionAnchor();
        var selectionEnd = isBackwards ? editor.selection.getSelectionAnchor() : editor.selection.getSelectionLead();
        var firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length;
        var selectedText = editor.session.doc.getTextRange(editor.selection.getRange());
        var selectedCount = selectedText.replace(/\n\s*/, " ").length;
        var insertLine = editor.session.doc.getLine(selectionStart.row);

        for (var i = selectionStart.row + 1; i <= selectionEnd.row + 1; i++) {
            var curLine = lang.stringTrimLeft(lang.stringTrimRight(editor.session.doc.getLine(i)));
            if (curLine.length !== 0) {
                curLine = " " + curLine;
            }
            insertLine += curLine;
        }

        if (selectionEnd.row + 1 < (editor.session.doc.getLength() - 1)) {
            insertLine += editor.session.doc.getNewLineCharacter();
        }

        editor.clearSelection();
        editor.session.doc.replace(new Range(selectionStart.row, 0, selectionEnd.row + 2, 0), insertLine);

        if (selectedCount > 0) {
            editor.selection.moveCursorTo(selectionStart.row, selectionStart.column);
            editor.selection.selectTo(selectionStart.row, selectionStart.column + selectedCount);
        } else {
            firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length > firstLineEndCol ? (firstLineEndCol + 1) : firstLineEndCol;
            editor.selection.moveCursorTo(selectionStart.row, firstLineEndCol);
        }
    },
    multiSelectAction: "forEach",
    readOnly: true
}, {
    name: "invertSelection",
    bindKey: bindKey(null, null),
    exec: function(editor) {
        var endRow = editor.session.doc.getLength() - 1;
        var endCol = editor.session.doc.getLine(endRow).length;
        var ranges = editor.selection.rangeList.ranges;
        var newRanges = [];
        if (ranges.length < 1) {
            ranges = [editor.selection.getRange()];
        }

        for (var i = 0; i < ranges.length; i++) {
            if (i == (ranges.length - 1)) {
                if (!(ranges[i].end.row === endRow && ranges[i].end.column === endCol)) {
                    newRanges.push(new Range(ranges[i].end.row, ranges[i].end.column, endRow, endCol));
                }
            }

            if (i === 0) {
                if (!(ranges[i].start.row === 0 && ranges[i].start.column === 0)) {
                    newRanges.push(new Range(0, 0, ranges[i].start.row, ranges[i].start.column));
                }
            } else {
                newRanges.push(new Range(ranges[i-1].end.row, ranges[i-1].end.column, ranges[i].start.row, ranges[i].start.column));
            }
        }

        editor.exitMultiSelectMode();
        editor.clearSelection();

        for(var i = 0; i < newRanges.length; i++) {
            editor.selection.addRange(newRanges[i], false);
        }
    },
    readOnly: true,
    scrollIntoView: "none"
}];

});

ace.define("ace/editor",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator"], function(acequire, exports, module) {
"use strict";

acequire("./lib/fixoldbrowsers");

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var lang = acequire("./lib/lang");
var useragent = acequire("./lib/useragent");
var TextInput = acequire("./keyboard/textinput").TextInput;
var MouseHandler = acequire("./mouse/mouse_handler").MouseHandler;
var FoldHandler = acequire("./mouse/fold_handler").FoldHandler;
var KeyBinding = acequire("./keyboard/keybinding").KeyBinding;
var EditSession = acequire("./edit_session").EditSession;
var Search = acequire("./search").Search;
var Range = acequire("./range").Range;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var CommandManager = acequire("./commands/command_manager").CommandManager;
var defaultCommands = acequire("./commands/default_commands").commands;
var config = acequire("./config");
var TokenIterator = acequire("./token_iterator").TokenIterator;
var Editor = function(renderer, session) {
    var container = renderer.getContainerElement();
    this.container = container;
    this.renderer = renderer;
    this.id = "editor" + (++Editor.$uid);

    this.commands = new CommandManager(useragent.isMac ? "mac" : "win", defaultCommands);
    if (typeof document == "object") {
        this.textInput  = new TextInput(renderer.getTextAreaContainer(), this);
        this.renderer.textarea = this.textInput.getElement();
        this.$mouseHandler = new MouseHandler(this);
        new FoldHandler(this);
    }

    this.keyBinding = new KeyBinding(this);

    this.$blockScrolling = 0;
    this.$search = new Search().set({
        wrap: true
    });

    this.$historyTracker = this.$historyTracker.bind(this);
    this.commands.on("exec", this.$historyTracker);

    this.$initOperationListeners();
    
    this._$emitInputEvent = lang.delayedCall(function() {
        this._signal("input", {});
        if (this.session && this.session.bgTokenizer)
            this.session.bgTokenizer.scheduleStart();
    }.bind(this));
    
    this.on("change", function(_, _self) {
        _self._$emitInputEvent.schedule(31);
    });

    this.setSession(session || new EditSession(""));
    config.resetOptions(this);
    config._signal("editor", this);
};

Editor.$uid = 0;

(function(){

    oop.implement(this, EventEmitter);

    this.$initOperationListeners = function() {
        function last(a) {return a[a.length - 1];}

        this.selections = [];
        this.commands.on("exec", this.startOperation.bind(this), true);
        this.commands.on("afterExec", this.endOperation.bind(this), true);

        this.$opResetTimer = lang.delayedCall(this.endOperation.bind(this));

        this.on("change", function() {
            this.curOp || this.startOperation();
            this.curOp.docChanged = true;
        }.bind(this), true);

        this.on("changeSelection", function() {
            this.curOp || this.startOperation();
            this.curOp.selectionChanged = true;
        }.bind(this), true);
    };

    this.curOp = null;
    this.prevOp = {};
    this.startOperation = function(commadEvent) {
        if (this.curOp) {
            if (!commadEvent || this.curOp.command)
                return;
            this.prevOp = this.curOp;
        }
        if (!commadEvent) {
            this.previousCommand = null;
            commadEvent = {};
        }

        this.$opResetTimer.schedule();
        this.curOp = {
            command: commadEvent.command || {},
            args: commadEvent.args,
            scrollTop: this.renderer.scrollTop
        };
        if (this.curOp.command.name && this.curOp.command.scrollIntoView !== undefined)
            this.$blockScrolling++;
    };

    this.endOperation = function(e) {
        if (this.curOp) {
            if (e && e.returnValue === false)
                return this.curOp = null;
            this._signal("beforeEndOperation");
            var command = this.curOp.command;
            if (command.name && this.$blockScrolling > 0)
                this.$blockScrolling--;
            var scrollIntoView = command && command.scrollIntoView;
            if (scrollIntoView) {
                switch (scrollIntoView) {
                    case "center-animate":
                        scrollIntoView = "animate";
                    case "center":
                        this.renderer.scrollCursorIntoView(null, 0.5);
                        break;
                    case "animate":
                    case "cursor":
                        this.renderer.scrollCursorIntoView();
                        break;
                    case "selectionPart":
                        var range = this.selection.getRange();
                        var config = this.renderer.layerConfig;
                        if (range.start.row >= config.lastRow || range.end.row <= config.firstRow) {
                            this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
                        }
                        break;
                    default:
                        break;
                }
                if (scrollIntoView == "animate")
                    this.renderer.animateScrolling(this.curOp.scrollTop);
            }
            
            this.prevOp = this.curOp;
            this.curOp = null;
        }
    };
    this.$mergeableCommands = ["backspace", "del", "insertstring"];
    this.$historyTracker = function(e) {
        if (!this.$mergeUndoDeltas)
            return;

        var prev = this.prevOp;
        var mergeableCommands = this.$mergeableCommands;
        var shouldMerge = prev.command && (e.command.name == prev.command.name);
        if (e.command.name == "insertstring") {
            var text = e.args;
            if (this.mergeNextCommand === undefined)
                this.mergeNextCommand = true;

            shouldMerge = shouldMerge
                && this.mergeNextCommand // previous command allows to coalesce with
                && (!/\s/.test(text) || /\s/.test(prev.args)); // previous insertion was of same type

            this.mergeNextCommand = true;
        } else {
            shouldMerge = shouldMerge
                && mergeableCommands.indexOf(e.command.name) !== -1; // the command is mergeable
        }

        if (
            this.$mergeUndoDeltas != "always"
            && Date.now() - this.sequenceStartTime > 2000
        ) {
            shouldMerge = false; // the sequence is too long
        }

        if (shouldMerge)
            this.session.mergeUndoDeltas = true;
        else if (mergeableCommands.indexOf(e.command.name) !== -1)
            this.sequenceStartTime = Date.now();
    };
    this.setKeyboardHandler = function(keyboardHandler, cb) {
        if (keyboardHandler && typeof keyboardHandler === "string") {
            this.$keybindingId = keyboardHandler;
            var _self = this;
            config.loadModule(["keybinding", keyboardHandler], function(module) {
                if (_self.$keybindingId == keyboardHandler)
                    _self.keyBinding.setKeyboardHandler(module && module.handler);
                cb && cb();
            });
        } else {
            this.$keybindingId = null;
            this.keyBinding.setKeyboardHandler(keyboardHandler);
            cb && cb();
        }
    };
    this.getKeyboardHandler = function() {
        return this.keyBinding.getKeyboardHandler();
    };
    this.setSession = function(session) {
        if (this.session == session)
            return;
        if (this.curOp) this.endOperation();
        this.curOp = {};

        var oldSession = this.session;
        if (oldSession) {
            this.session.off("change", this.$onDocumentChange);
            this.session.off("changeMode", this.$onChangeMode);
            this.session.off("tokenizerUpdate", this.$onTokenizerUpdate);
            this.session.off("changeTabSize", this.$onChangeTabSize);
            this.session.off("changeWrapLimit", this.$onChangeWrapLimit);
            this.session.off("changeWrapMode", this.$onChangeWrapMode);
            this.session.off("changeFold", this.$onChangeFold);
            this.session.off("changeFrontMarker", this.$onChangeFrontMarker);
            this.session.off("changeBackMarker", this.$onChangeBackMarker);
            this.session.off("changeBreakpoint", this.$onChangeBreakpoint);
            this.session.off("changeAnnotation", this.$onChangeAnnotation);
            this.session.off("changeOverwrite", this.$onCursorChange);
            this.session.off("changeScrollTop", this.$onScrollTopChange);
            this.session.off("changeScrollLeft", this.$onScrollLeftChange);

            var selection = this.session.getSelection();
            selection.off("changeCursor", this.$onCursorChange);
            selection.off("changeSelection", this.$onSelectionChange);
        }

        this.session = session;
        if (session) {
            this.$onDocumentChange = this.onDocumentChange.bind(this);
            session.on("change", this.$onDocumentChange);
            this.renderer.setSession(session);
    
            this.$onChangeMode = this.onChangeMode.bind(this);
            session.on("changeMode", this.$onChangeMode);
    
            this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this);
            session.on("tokenizerUpdate", this.$onTokenizerUpdate);
    
            this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer);
            session.on("changeTabSize", this.$onChangeTabSize);
    
            this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this);
            session.on("changeWrapLimit", this.$onChangeWrapLimit);
    
            this.$onChangeWrapMode = this.onChangeWrapMode.bind(this);
            session.on("changeWrapMode", this.$onChangeWrapMode);
    
            this.$onChangeFold = this.onChangeFold.bind(this);
            session.on("changeFold", this.$onChangeFold);
    
            this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this);
            this.session.on("changeFrontMarker", this.$onChangeFrontMarker);
    
            this.$onChangeBackMarker = this.onChangeBackMarker.bind(this);
            this.session.on("changeBackMarker", this.$onChangeBackMarker);
    
            this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this);
            this.session.on("changeBreakpoint", this.$onChangeBreakpoint);
    
            this.$onChangeAnnotation = this.onChangeAnnotation.bind(this);
            this.session.on("changeAnnotation", this.$onChangeAnnotation);
    
            this.$onCursorChange = this.onCursorChange.bind(this);
            this.session.on("changeOverwrite", this.$onCursorChange);
    
            this.$onScrollTopChange = this.onScrollTopChange.bind(this);
            this.session.on("changeScrollTop", this.$onScrollTopChange);
    
            this.$onScrollLeftChange = this.onScrollLeftChange.bind(this);
            this.session.on("changeScrollLeft", this.$onScrollLeftChange);
    
            this.selection = session.getSelection();
            this.selection.on("changeCursor", this.$onCursorChange);
    
            this.$onSelectionChange = this.onSelectionChange.bind(this);
            this.selection.on("changeSelection", this.$onSelectionChange);
    
            this.onChangeMode();
    
            this.$blockScrolling += 1;
            this.onCursorChange();
            this.$blockScrolling -= 1;
    
            this.onScrollTopChange();
            this.onScrollLeftChange();
            this.onSelectionChange();
            this.onChangeFrontMarker();
            this.onChangeBackMarker();
            this.onChangeBreakpoint();
            this.onChangeAnnotation();
            this.session.getUseWrapMode() && this.renderer.adjustWrapLimit();
            this.renderer.updateFull();
        } else {
            this.selection = null;
            this.renderer.setSession(session);
        }

        this._signal("changeSession", {
            session: session,
            oldSession: oldSession
        });
        
        this.curOp = null;
        
        oldSession && oldSession._signal("changeEditor", {oldEditor: this});
        session && session._signal("changeEditor", {editor: this});

        if (session && session.bgTokenizer)
            session.bgTokenizer.scheduleStart();
    };
    this.getSession = function() {
        return this.session;
    };
    this.setValue = function(val, cursorPos) {
        this.session.doc.setValue(val);

        if (!cursorPos)
            this.selectAll();
        else if (cursorPos == 1)
            this.navigateFileEnd();
        else if (cursorPos == -1)
            this.navigateFileStart();

        return val;
    };
    this.getValue = function() {
        return this.session.getValue();
    };
    this.getSelection = function() {
        return this.selection;
    };
    this.resize = function(force) {
        this.renderer.onResize(force);
    };
    this.setTheme = function(theme, cb) {
        this.renderer.setTheme(theme, cb);
    };
    this.getTheme = function() {
        return this.renderer.getTheme();
    };
    this.setStyle = function(style) {
        this.renderer.setStyle(style);
    };
    this.unsetStyle = function(style) {
        this.renderer.unsetStyle(style);
    };
    this.getFontSize = function () {
        return this.getOption("fontSize") ||
           dom.computedStyle(this.container, "fontSize");
    };
    this.setFontSize = function(size) {
        this.setOption("fontSize", size);
    };

    this.$highlightBrackets = function() {
        if (this.session.$bracketHighlight) {
            this.session.removeMarker(this.session.$bracketHighlight);
            this.session.$bracketHighlight = null;
        }

        if (this.$highlightPending) {
            return;
        }
        var self = this;
        this.$highlightPending = true;
        setTimeout(function() {
            self.$highlightPending = false;
            var session = self.session;
            if (!session || !session.bgTokenizer) return;
            var pos = session.findMatchingBracket(self.getCursorPosition());
            if (pos) {
                var range = new Range(pos.row, pos.column, pos.row, pos.column + 1);
            } else if (session.$mode.getMatching) {
                var range = session.$mode.getMatching(self.session);
            }
            if (range)
                session.$bracketHighlight = session.addMarker(range, "ace_bracket", "text");
        }, 50);
    };
    this.$highlightTags = function() {
        if (this.$highlightTagPending)
            return;
        var self = this;
        this.$highlightTagPending = true;
        setTimeout(function() {
            self.$highlightTagPending = false;
            
            var session = self.session;
            if (!session || !session.bgTokenizer) return;
            
            var pos = self.getCursorPosition();
            var iterator = new TokenIterator(self.session, pos.row, pos.column);
            var token = iterator.getCurrentToken();
            
            if (!token || !/\b(?:tag-open|tag-name)/.test(token.type)) {
                session.removeMarker(session.$tagHighlight);
                session.$tagHighlight = null;
                return;
            }
            
            if (token.type.indexOf("tag-open") != -1) {
                token = iterator.stepForward();
                if (!token)
                    return;
            }
            
            var tag = token.value;
            var depth = 0;
            var prevToken = iterator.stepBackward();
            
            if (prevToken.value == '<'){
                do {
                    prevToken = token;
                    token = iterator.stepForward();
                    
                    if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
                        if (prevToken.value === '<'){
                            depth++;
                        } else if (prevToken.value === '</'){
                            depth--;
                        }
                    }
                    
                } while (token && depth >= 0);
            } else {
                do {
                    token = prevToken;
                    prevToken = iterator.stepBackward();
                    
                    if (token && token.value === tag && token.type.indexOf('tag-name') !== -1) {
                        if (prevToken.value === '<') {
                            depth++;
                        } else if (prevToken.value === '</') {
                            depth--;
                        }
                    }
                } while (prevToken && depth <= 0);
                iterator.stepForward();
            }
            
            if (!token) {
                session.removeMarker(session.$tagHighlight);
                session.$tagHighlight = null;
                return;
            }
            
            var row = iterator.getCurrentTokenRow();
            var column = iterator.getCurrentTokenColumn();
            var range = new Range(row, column, row, column+token.value.length);
            var sbm = session.$backMarkers[session.$tagHighlight];
            if (session.$tagHighlight && sbm != undefined && range.compareRange(sbm.range) !== 0) {
                session.removeMarker(session.$tagHighlight);
                session.$tagHighlight = null;
            }
            
            if (range && !session.$tagHighlight)
                session.$tagHighlight = session.addMarker(range, "ace_bracket", "text");
        }, 50);
    };
    this.focus = function() {
        var _self = this;
        setTimeout(function() {
            _self.textInput.focus();
        });
        this.textInput.focus();
    };
    this.isFocused = function() {
        return this.textInput.isFocused();
    };
    this.blur = function() {
        this.textInput.blur();
    };
    this.onFocus = function(e) {
        if (this.$isFocused)
            return;
        this.$isFocused = true;
        this.renderer.showCursor();
        this.renderer.visualizeFocus();
        this._emit("focus", e);
    };
    this.onBlur = function(e) {
        if (!this.$isFocused)
            return;
        this.$isFocused = false;
        this.renderer.hideCursor();
        this.renderer.visualizeBlur();
        this._emit("blur", e);
    };

    this.$cursorChange = function() {
        this.renderer.updateCursor();
    };
    this.onDocumentChange = function(delta) {
        var wrap = this.session.$useWrapMode;
        var lastRow = (delta.start.row == delta.end.row ? delta.end.row : Infinity);
        this.renderer.updateLines(delta.start.row, lastRow, wrap);

        this._signal("change", delta);
        this.$cursorChange();
        this.$updateHighlightActiveLine();
    };

    this.onTokenizerUpdate = function(e) {
        var rows = e.data;
        this.renderer.updateLines(rows.first, rows.last);
    };


    this.onScrollTopChange = function() {
        this.renderer.scrollToY(this.session.getScrollTop());
    };

    this.onScrollLeftChange = function() {
        this.renderer.scrollToX(this.session.getScrollLeft());
    };
    this.onCursorChange = function() {
        this.$cursorChange();

        if (!this.$blockScrolling) {
            config.warn("Automatically scrolling cursor into view after selection change",
                "this will be disabled in the next version",
                "set editor.$blockScrolling = Infinity to disable this message"
            );
            this.renderer.scrollCursorIntoView();
        }

        this.$highlightBrackets();
        this.$highlightTags();
        this.$updateHighlightActiveLine();
        this._signal("changeSelection");
    };

    this.$updateHighlightActiveLine = function() {
        var session = this.getSession();

        var highlight;
        if (this.$highlightActiveLine) {
            if ((this.$selectionStyle != "line" || !this.selection.isMultiLine()))
                highlight = this.getCursorPosition();
            if (this.renderer.$maxLines && this.session.getLength() === 1 && !(this.renderer.$minLines > 1))
                highlight = false;
        }

        if (session.$highlightLineMarker && !highlight) {
            session.removeMarker(session.$highlightLineMarker.id);
            session.$highlightLineMarker = null;
        } else if (!session.$highlightLineMarker && highlight) {
            var range = new Range(highlight.row, highlight.column, highlight.row, Infinity);
            range.id = session.addMarker(range, "ace_active-line", "screenLine");
            session.$highlightLineMarker = range;
        } else if (highlight) {
            session.$highlightLineMarker.start.row = highlight.row;
            session.$highlightLineMarker.end.row = highlight.row;
            session.$highlightLineMarker.start.column = highlight.column;
            session._signal("changeBackMarker");
        }
    };

    this.onSelectionChange = function(e) {
        var session = this.session;

        if (session.$selectionMarker) {
            session.removeMarker(session.$selectionMarker);
        }
        session.$selectionMarker = null;

        if (!this.selection.isEmpty()) {
            var range = this.selection.getRange();
            var style = this.getSelectionStyle();
            session.$selectionMarker = session.addMarker(range, "ace_selection", style);
        } else {
            this.$updateHighlightActiveLine();
        }

        var re = this.$highlightSelectedWord && this.$getSelectionHighLightRegexp();
        this.session.highlight(re);

        this._signal("changeSelection");
    };

    this.$getSelectionHighLightRegexp = function() {
        var session = this.session;

        var selection = this.getSelectionRange();
        if (selection.isEmpty() || selection.isMultiLine())
            return;

        var startOuter = selection.start.column - 1;
        var endOuter = selection.end.column + 1;
        var line = session.getLine(selection.start.row);
        var lineCols = line.length;
        var needle = line.substring(Math.max(startOuter, 0),
                                    Math.min(endOuter, lineCols));
        if ((startOuter >= 0 && /^[\w\d]/.test(needle)) ||
            (endOuter <= lineCols && /[\w\d]$/.test(needle)))
            return;

        needle = line.substring(selection.start.column, selection.end.column);
        if (!/^[\w\d]+$/.test(needle))
            return;

        var re = this.$search.$assembleRegExp({
            wholeWord: true,
            caseSensitive: true,
            needle: needle
        });

        return re;
    };


    this.onChangeFrontMarker = function() {
        this.renderer.updateFrontMarkers();
    };

    this.onChangeBackMarker = function() {
        this.renderer.updateBackMarkers();
    };


    this.onChangeBreakpoint = function() {
        this.renderer.updateBreakpoints();
    };

    this.onChangeAnnotation = function() {
        this.renderer.setAnnotations(this.session.getAnnotations());
    };


    this.onChangeMode = function(e) {
        this.renderer.updateText();
        this._emit("changeMode", e);
    };


    this.onChangeWrapLimit = function() {
        this.renderer.updateFull();
    };

    this.onChangeWrapMode = function() {
        this.renderer.onResize(true);
    };


    this.onChangeFold = function() {
        this.$updateHighlightActiveLine();
        this.renderer.updateFull();
    };
    this.getSelectedText = function() {
        return this.session.getTextRange(this.getSelectionRange());
    };
    this.getCopyText = function() {
        var text = this.getSelectedText();
        this._signal("copy", text);
        return text;
    };
    this.onCopy = function() {
        this.commands.exec("copy", this);
    };
    this.onCut = function() {
        this.commands.exec("cut", this);
    };
    this.onPaste = function(text, event) {
        var e = {text: text, event: event};
        this.commands.exec("paste", this, e);
    };
    
    this.$handlePaste = function(e) {
        if (typeof e == "string") 
            e = {text: e};
        this._signal("paste", e);
        var text = e.text;
        if (!this.inMultiSelectMode || this.inVirtualSelectionMode) {
            this.insert(text);
        } else {
            var lines = text.split(/\r\n|\r|\n/);
            var ranges = this.selection.rangeList.ranges;
    
            if (lines.length > ranges.length || lines.length < 2 || !lines[1])
                return this.commands.exec("insertstring", this, text);
    
            for (var i = ranges.length; i--;) {
                var range = ranges[i];
                if (!range.isEmpty())
                    this.session.remove(range);
    
                this.session.insert(range.start, lines[i]);
            }
        }
    };

    this.execCommand = function(command, args) {
        return this.commands.exec(command, this, args);
    };
    this.insert = function(text, pasted) {
        var session = this.session;
        var mode = session.getMode();
        var cursor = this.getCursorPosition();

        if (this.getBehavioursEnabled() && !pasted) {
            var transform = mode.transformAction(session.getState(cursor.row), 'insertion', this, session, text);
            if (transform) {
                if (text !== transform.text) {
                    this.session.mergeUndoDeltas = false;
                    this.$mergeNextCommand = false;
                }
                text = transform.text;

            }
        }
        
        if (text == "\t")
            text = this.session.getTabString();
        if (!this.selection.isEmpty()) {
            var range = this.getSelectionRange();
            cursor = this.session.remove(range);
            this.clearSelection();
        }
        else if (this.session.getOverwrite() && text.indexOf("\n") == -1) {
            var range = new Range.fromPoints(cursor, cursor);
            range.end.column += text.length;
            this.session.remove(range);
        }

        if (text == "\n" || text == "\r\n") {
            var line = session.getLine(cursor.row);
            if (cursor.column > line.search(/\S|$/)) {
                var d = line.substr(cursor.column).search(/\S|$/);
                session.doc.removeInLine(cursor.row, cursor.column, cursor.column + d);
            }
        }
        this.clearSelection();

        var start = cursor.column;
        var lineState = session.getState(cursor.row);
        var line = session.getLine(cursor.row);
        var shouldOutdent = mode.checkOutdent(lineState, line, text);
        var end = session.insert(cursor, text);

        if (transform && transform.selection) {
            if (transform.selection.length == 2) { // Transform relative to the current column
                this.selection.setSelectionRange(
                    new Range(cursor.row, start + transform.selection[0],
                              cursor.row, start + transform.selection[1]));
            } else { // Transform relative to the current row.
                this.selection.setSelectionRange(
                    new Range(cursor.row + transform.selection[0],
                              transform.selection[1],
                              cursor.row + transform.selection[2],
                              transform.selection[3]));
            }
        }

        if (session.getDocument().isNewLine(text)) {
            var lineIndent = mode.getNextLineIndent(lineState, line.slice(0, cursor.column), session.getTabString());

            session.insert({row: cursor.row+1, column: 0}, lineIndent);
        }
        if (shouldOutdent)
            mode.autoOutdent(lineState, session, cursor.row);
    };

    this.onTextInput = function(text) {
        this.keyBinding.onTextInput(text);
    };

    this.onCommandKey = function(e, hashId, keyCode) {
        this.keyBinding.onCommandKey(e, hashId, keyCode);
    };
    this.setOverwrite = function(overwrite) {
        this.session.setOverwrite(overwrite);
    };
    this.getOverwrite = function() {
        return this.session.getOverwrite();
    };
    this.toggleOverwrite = function() {
        this.session.toggleOverwrite();
    };
    this.setScrollSpeed = function(speed) {
        this.setOption("scrollSpeed", speed);
    };
    this.getScrollSpeed = function() {
        return this.getOption("scrollSpeed");
    };
    this.setDragDelay = function(dragDelay) {
        this.setOption("dragDelay", dragDelay);
    };
    this.getDragDelay = function() {
        return this.getOption("dragDelay");
    };
    this.setSelectionStyle = function(val) {
        this.setOption("selectionStyle", val);
    };
    this.getSelectionStyle = function() {
        return this.getOption("selectionStyle");
    };
    this.setHighlightActiveLine = function(shouldHighlight) {
        this.setOption("highlightActiveLine", shouldHighlight);
    };
    this.getHighlightActiveLine = function() {
        return this.getOption("highlightActiveLine");
    };
    this.setHighlightGutterLine = function(shouldHighlight) {
        this.setOption("highlightGutterLine", shouldHighlight);
    };

    this.getHighlightGutterLine = function() {
        return this.getOption("highlightGutterLine");
    };
    this.setHighlightSelectedWord = function(shouldHighlight) {
        this.setOption("highlightSelectedWord", shouldHighlight);
    };
    this.getHighlightSelectedWord = function() {
        return this.$highlightSelectedWord;
    };

    this.setAnimatedScroll = function(shouldAnimate){
        this.renderer.setAnimatedScroll(shouldAnimate);
    };

    this.getAnimatedScroll = function(){
        return this.renderer.getAnimatedScroll();
    };
    this.setShowInvisibles = function(showInvisibles) {
        this.renderer.setShowInvisibles(showInvisibles);
    };
    this.getShowInvisibles = function() {
        return this.renderer.getShowInvisibles();
    };

    this.setDisplayIndentGuides = function(display) {
        this.renderer.setDisplayIndentGuides(display);
    };

    this.getDisplayIndentGuides = function() {
        return this.renderer.getDisplayIndentGuides();
    };
    this.setShowPrintMargin = function(showPrintMargin) {
        this.renderer.setShowPrintMargin(showPrintMargin);
    };
    this.getShowPrintMargin = function() {
        return this.renderer.getShowPrintMargin();
    };
    this.setPrintMarginColumn = function(showPrintMargin) {
        this.renderer.setPrintMarginColumn(showPrintMargin);
    };
    this.getPrintMarginColumn = function() {
        return this.renderer.getPrintMarginColumn();
    };
    this.setReadOnly = function(readOnly) {
        this.setOption("readOnly", readOnly);
    };
    this.getReadOnly = function() {
        return this.getOption("readOnly");
    };
    this.setBehavioursEnabled = function (enabled) {
        this.setOption("behavioursEnabled", enabled);
    };
    this.getBehavioursEnabled = function () {
        return this.getOption("behavioursEnabled");
    };
    this.setWrapBehavioursEnabled = function (enabled) {
        this.setOption("wrapBehavioursEnabled", enabled);
    };
    this.getWrapBehavioursEnabled = function () {
        return this.getOption("wrapBehavioursEnabled");
    };
    this.setShowFoldWidgets = function(show) {
        this.setOption("showFoldWidgets", show);

    };
    this.getShowFoldWidgets = function() {
        return this.getOption("showFoldWidgets");
    };

    this.setFadeFoldWidgets = function(fade) {
        this.setOption("fadeFoldWidgets", fade);
    };

    this.getFadeFoldWidgets = function() {
        return this.getOption("fadeFoldWidgets");
    };
    this.remove = function(dir) {
        if (this.selection.isEmpty()){
            if (dir == "left")
                this.selection.selectLeft();
            else
                this.selection.selectRight();
        }

        var range = this.getSelectionRange();
        if (this.getBehavioursEnabled()) {
            var session = this.session;
            var state = session.getState(range.start.row);
            var new_range = session.getMode().transformAction(state, 'deletion', this, session, range);

            if (range.end.column === 0) {
                var text = session.getTextRange(range);
                if (text[text.length - 1] == "\n") {
                    var line = session.getLine(range.end.row);
                    if (/^\s+$/.test(line)) {
                        range.end.column = line.length;
                    }
                }
            }
            if (new_range)
                range = new_range;
        }

        this.session.remove(range);
        this.clearSelection();
    };
    this.removeWordRight = function() {
        if (this.selection.isEmpty())
            this.selection.selectWordRight();

        this.session.remove(this.getSelectionRange());
        this.clearSelection();
    };
    this.removeWordLeft = function() {
        if (this.selection.isEmpty())
            this.selection.selectWordLeft();

        this.session.remove(this.getSelectionRange());
        this.clearSelection();
    };
    this.removeToLineStart = function() {
        if (this.selection.isEmpty())
            this.selection.selectLineStart();

        this.session.remove(this.getSelectionRange());
        this.clearSelection();
    };
    this.removeToLineEnd = function() {
        if (this.selection.isEmpty())
            this.selection.selectLineEnd();

        var range = this.getSelectionRange();
        if (range.start.column == range.end.column && range.start.row == range.end.row) {
            range.end.column = 0;
            range.end.row++;
        }

        this.session.remove(range);
        this.clearSelection();
    };
    this.splitLine = function() {
        if (!this.selection.isEmpty()) {
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        }

        var cursor = this.getCursorPosition();
        this.insert("\n");
        this.moveCursorToPosition(cursor);
    };
    this.transposeLetters = function() {
        if (!this.selection.isEmpty()) {
            return;
        }

        var cursor = this.getCursorPosition();
        var column = cursor.column;
        if (column === 0)
            return;

        var line = this.session.getLine(cursor.row);
        var swap, range;
        if (column < line.length) {
            swap = line.charAt(column) + line.charAt(column-1);
            range = new Range(cursor.row, column-1, cursor.row, column+1);
        }
        else {
            swap = line.charAt(column-1) + line.charAt(column-2);
            range = new Range(cursor.row, column-2, cursor.row, column);
        }
        this.session.replace(range, swap);
        this.session.selection.moveToPosition(range.end);
    };
    this.toLowerCase = function() {
        var originalRange = this.getSelectionRange();
        if (this.selection.isEmpty()) {
            this.selection.selectWord();
        }

        var range = this.getSelectionRange();
        var text = this.session.getTextRange(range);
        this.session.replace(range, text.toLowerCase());
        this.selection.setSelectionRange(originalRange);
    };
    this.toUpperCase = function() {
        var originalRange = this.getSelectionRange();
        if (this.selection.isEmpty()) {
            this.selection.selectWord();
        }

        var range = this.getSelectionRange();
        var text = this.session.getTextRange(range);
        this.session.replace(range, text.toUpperCase());
        this.selection.setSelectionRange(originalRange);
    };
    this.indent = function() {
        var session = this.session;
        var range = this.getSelectionRange();

        if (range.start.row < range.end.row) {
            var rows = this.$getSelectedRows();
            session.indentRows(rows.first, rows.last, "\t");
            return;
        } else if (range.start.column < range.end.column) {
            var text = session.getTextRange(range);
            if (!/^\s+$/.test(text)) {
                var rows = this.$getSelectedRows();
                session.indentRows(rows.first, rows.last, "\t");
                return;
            }
        }
        
        var line = session.getLine(range.start.row);
        var position = range.start;
        var size = session.getTabSize();
        var column = session.documentToScreenColumn(position.row, position.column);

        if (this.session.getUseSoftTabs()) {
            var count = (size - column % size);
            var indentString = lang.stringRepeat(" ", count);
        } else {
            var count = column % size;
            while (line[range.start.column - 1] == " " && count) {
                range.start.column--;
                count--;
            }
            this.selection.setSelectionRange(range);
            indentString = "\t";
        }
        return this.insert(indentString);
    };
    this.blockIndent = function() {
        var rows = this.$getSelectedRows();
        this.session.indentRows(rows.first, rows.last, "\t");
    };
    this.blockOutdent = function() {
        var selection = this.session.getSelection();
        this.session.outdentRows(selection.getRange());
    };
    this.sortLines = function() {
        var rows = this.$getSelectedRows();
        var session = this.session;

        var lines = [];
        for (var i = rows.first; i <= rows.last; i++)
            lines.push(session.getLine(i));

        lines.sort(function(a, b) {
            if (a.toLowerCase() < b.toLowerCase()) return -1;
            if (a.toLowerCase() > b.toLowerCase()) return 1;
            return 0;
        });

        var deleteRange = new Range(0, 0, 0, 0);
        for (var i = rows.first; i <= rows.last; i++) {
            var line = session.getLine(i);
            deleteRange.start.row = i;
            deleteRange.end.row = i;
            deleteRange.end.column = line.length;
            session.replace(deleteRange, lines[i-rows.first]);
        }
    };
    this.toggleCommentLines = function() {
        var state = this.session.getState(this.getCursorPosition().row);
        var rows = this.$getSelectedRows();
        this.session.getMode().toggleCommentLines(state, this.session, rows.first, rows.last);
    };

    this.toggleBlockComment = function() {
        var cursor = this.getCursorPosition();
        var state = this.session.getState(cursor.row);
        var range = this.getSelectionRange();
        this.session.getMode().toggleBlockComment(state, this.session, range, cursor);
    };
    this.getNumberAt = function(row, column) {
        var _numberRx = /[\-]?[0-9]+(?:\.[0-9]+)?/g;
        _numberRx.lastIndex = 0;

        var s = this.session.getLine(row);
        while (_numberRx.lastIndex < column) {
            var m = _numberRx.exec(s);
            if(m.index <= column && m.index+m[0].length >= column){
                var number = {
                    value: m[0],
                    start: m.index,
                    end: m.index+m[0].length
                };
                return number;
            }
        }
        return null;
    };
    this.modifyNumber = function(amount) {
        var row = this.selection.getCursor().row;
        var column = this.selection.getCursor().column;
        var charRange = new Range(row, column-1, row, column);

        var c = this.session.getTextRange(charRange);
        if (!isNaN(parseFloat(c)) && isFinite(c)) {
            var nr = this.getNumberAt(row, column);
            if (nr) {
                var fp = nr.value.indexOf(".") >= 0 ? nr.start + nr.value.indexOf(".") + 1 : nr.end;
                var decimals = nr.start + nr.value.length - fp;

                var t = parseFloat(nr.value);
                t *= Math.pow(10, decimals);


                if(fp !== nr.end && column < fp){
                    amount *= Math.pow(10, nr.end - column - 1);
                } else {
                    amount *= Math.pow(10, nr.end - column);
                }

                t += amount;
                t /= Math.pow(10, decimals);
                var nnr = t.toFixed(decimals);
                var replaceRange = new Range(row, nr.start, row, nr.end);
                this.session.replace(replaceRange, nnr);
                this.moveCursorTo(row, Math.max(nr.start +1, column + nnr.length - nr.value.length));

            }
        }
    };
    this.removeLines = function() {
        var rows = this.$getSelectedRows();
        this.session.removeFullLines(rows.first, rows.last);
        this.clearSelection();
    };

    this.duplicateSelection = function() {
        var sel = this.selection;
        var doc = this.session;
        var range = sel.getRange();
        var reverse = sel.isBackwards();
        if (range.isEmpty()) {
            var row = range.start.row;
            doc.duplicateLines(row, row);
        } else {
            var point = reverse ? range.start : range.end;
            var endPoint = doc.insert(point, doc.getTextRange(range), false);
            range.start = point;
            range.end = endPoint;

            sel.setSelectionRange(range, reverse);
        }
    };
    this.moveLinesDown = function() {
        this.$moveLines(1, false);
    };
    this.moveLinesUp = function() {
        this.$moveLines(-1, false);
    };
    this.moveText = function(range, toPosition, copy) {
        return this.session.moveText(range, toPosition, copy);
    };
    this.copyLinesUp = function() {
        this.$moveLines(-1, true);
    };
    this.copyLinesDown = function() {
        this.$moveLines(1, true);
    };
    this.$moveLines = function(dir, copy) {
        var rows, moved;
        var selection = this.selection;
        if (!selection.inMultiSelectMode || this.inVirtualSelectionMode) {
            var range = selection.toOrientedRange();
            rows = this.$getSelectedRows(range);
            moved = this.session.$moveLines(rows.first, rows.last, copy ? 0 : dir);
            if (copy && dir == -1) moved = 0;
            range.moveBy(moved, 0);
            selection.fromOrientedRange(range);
        } else {
            var ranges = selection.rangeList.ranges;
            selection.rangeList.detach(this.session);
            this.inVirtualSelectionMode = true;
            
            var diff = 0;
            var totalDiff = 0;
            var l = ranges.length;
            for (var i = 0; i < l; i++) {
                var rangeIndex = i;
                ranges[i].moveBy(diff, 0);
                rows = this.$getSelectedRows(ranges[i]);
                var first = rows.first;
                var last = rows.last;
                while (++i < l) {
                    if (totalDiff) ranges[i].moveBy(totalDiff, 0);
                    var subRows = this.$getSelectedRows(ranges[i]);
                    if (copy && subRows.first != last)
                        break;
                    else if (!copy && subRows.first > last + 1)
                        break;
                    last = subRows.last;
                }
                i--;
                diff = this.session.$moveLines(first, last, copy ? 0 : dir);
                if (copy && dir == -1) rangeIndex = i + 1;
                while (rangeIndex <= i) {
                    ranges[rangeIndex].moveBy(diff, 0);
                    rangeIndex++;
                }
                if (!copy) diff = 0;
                totalDiff += diff;
            }
            
            selection.fromOrientedRange(selection.ranges[0]);
            selection.rangeList.attach(this.session);
            this.inVirtualSelectionMode = false;
        }
    };
    this.$getSelectedRows = function(range) {
        range = (range || this.getSelectionRange()).collapseRows();

        return {
            first: this.session.getRowFoldStart(range.start.row),
            last: this.session.getRowFoldEnd(range.end.row)
        };
    };

    this.onCompositionStart = function(text) {
        this.renderer.showComposition(this.getCursorPosition());
    };

    this.onCompositionUpdate = function(text) {
        this.renderer.setCompositionText(text);
    };

    this.onCompositionEnd = function() {
        this.renderer.hideComposition();
    };
    this.getFirstVisibleRow = function() {
        return this.renderer.getFirstVisibleRow();
    };
    this.getLastVisibleRow = function() {
        return this.renderer.getLastVisibleRow();
    };
    this.isRowVisible = function(row) {
        return (row >= this.getFirstVisibleRow() && row <= this.getLastVisibleRow());
    };
    this.isRowFullyVisible = function(row) {
        return (row >= this.renderer.getFirstFullyVisibleRow() && row <= this.renderer.getLastFullyVisibleRow());
    };
    this.$getVisibleRowCount = function() {
        return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
    };

    this.$moveByPage = function(dir, select) {
        var renderer = this.renderer;
        var config = this.renderer.layerConfig;
        var rows = dir * Math.floor(config.height / config.lineHeight);

        this.$blockScrolling++;
        if (select === true) {
            this.selection.$moveSelection(function(){
                this.moveCursorBy(rows, 0);
            });
        } else if (select === false) {
            this.selection.moveCursorBy(rows, 0);
            this.selection.clearSelection();
        }
        this.$blockScrolling--;

        var scrollTop = renderer.scrollTop;

        renderer.scrollBy(0, rows * config.lineHeight);
        if (select != null)
            renderer.scrollCursorIntoView(null, 0.5);

        renderer.animateScrolling(scrollTop);
    };
    this.selectPageDown = function() {
        this.$moveByPage(1, true);
    };
    this.selectPageUp = function() {
        this.$moveByPage(-1, true);
    };
    this.gotoPageDown = function() {
       this.$moveByPage(1, false);
    };
    this.gotoPageUp = function() {
        this.$moveByPage(-1, false);
    };
    this.scrollPageDown = function() {
        this.$moveByPage(1);
    };
    this.scrollPageUp = function() {
        this.$moveByPage(-1);
    };
    this.scrollToRow = function(row) {
        this.renderer.scrollToRow(row);
    };
    this.scrollToLine = function(line, center, animate, callback) {
        this.renderer.scrollToLine(line, center, animate, callback);
    };
    this.centerSelection = function() {
        var range = this.getSelectionRange();
        var pos = {
            row: Math.floor(range.start.row + (range.end.row - range.start.row) / 2),
            column: Math.floor(range.start.column + (range.end.column - range.start.column) / 2)
        };
        this.renderer.alignCursor(pos, 0.5);
    };
    this.getCursorPosition = function() {
        return this.selection.getCursor();
    };
    this.getCursorPositionScreen = function() {
        return this.session.documentToScreenPosition(this.getCursorPosition());
    };
    this.getSelectionRange = function() {
        return this.selection.getRange();
    };
    this.selectAll = function() {
        this.$blockScrolling += 1;
        this.selection.selectAll();
        this.$blockScrolling -= 1;
    };
    this.clearSelection = function() {
        this.selection.clearSelection();
    };
    this.moveCursorTo = function(row, column) {
        this.selection.moveCursorTo(row, column);
    };
    this.moveCursorToPosition = function(pos) {
        this.selection.moveCursorToPosition(pos);
    };
    this.jumpToMatching = function(select, expand) {
        var cursor = this.getCursorPosition();
        var iterator = new TokenIterator(this.session, cursor.row, cursor.column);
        var prevToken = iterator.getCurrentToken();
        var token = prevToken || iterator.stepForward();

        if (!token) return;
        var matchType;
        var found = false;
        var depth = {};
        var i = cursor.column - token.start;
        var bracketType;
        var brackets = {
            ")": "(",
            "(": "(",
            "]": "[",
            "[": "[",
            "{": "{",
            "}": "{"
        };
        
        do {
            if (token.value.match(/[{}()\[\]]/g)) {
                for (; i < token.value.length && !found; i++) {
                    if (!brackets[token.value[i]]) {
                        continue;
                    }

                    bracketType = brackets[token.value[i]] + '.' + token.type.replace("rparen", "lparen");

                    if (isNaN(depth[bracketType])) {
                        depth[bracketType] = 0;
                    }

                    switch (token.value[i]) {
                        case '(':
                        case '[':
                        case '{':
                            depth[bracketType]++;
                            break;
                        case ')':
                        case ']':
                        case '}':
                            depth[bracketType]--;

                            if (depth[bracketType] === -1) {
                                matchType = 'bracket';
                                found = true;
                            }
                        break;
                    }
                }
            }
            else if (token && token.type.indexOf('tag-name') !== -1) {
                if (isNaN(depth[token.value])) {
                    depth[token.value] = 0;
                }
                
                if (prevToken.value === '<') {
                    depth[token.value]++;
                }
                else if (prevToken.value === '</') {
                    depth[token.value]--;
                }
                
                if (depth[token.value] === -1) {
                    matchType = 'tag';
                    found = true;
                }
            }

            if (!found) {
                prevToken = token;
                token = iterator.stepForward();
                i = 0;
            }
        } while (token && !found);
        if (!matchType)
            return;

        var range, pos;
        if (matchType === 'bracket') {
            range = this.session.getBracketRange(cursor);
            if (!range) {
                range = new Range(
                    iterator.getCurrentTokenRow(),
                    iterator.getCurrentTokenColumn() + i - 1,
                    iterator.getCurrentTokenRow(),
                    iterator.getCurrentTokenColumn() + i - 1
                );
                pos = range.start;
                if (expand || pos.row === cursor.row && Math.abs(pos.column - cursor.column) < 2)
                    range = this.session.getBracketRange(pos);
            }
        }
        else if (matchType === 'tag') {
            if (token && token.type.indexOf('tag-name') !== -1) 
                var tag = token.value;
            else
                return;

            range = new Range(
                iterator.getCurrentTokenRow(),
                iterator.getCurrentTokenColumn() - 2,
                iterator.getCurrentTokenRow(),
                iterator.getCurrentTokenColumn() - 2
            );
            if (range.compare(cursor.row, cursor.column) === 0) {
                found = false;
                do {
                    token = prevToken;
                    prevToken = iterator.stepBackward();
                    
                    if (prevToken) {
                        if (prevToken.type.indexOf('tag-close') !== -1) {
                            range.setEnd(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1);
                        }

                        if (token.value === tag && token.type.indexOf('tag-name') !== -1) {
                            if (prevToken.value === '<') {
                                depth[tag]++;
                            }
                            else if (prevToken.value === '</') {
                                depth[tag]--;
                            }
                            
                            if (depth[tag] === 0)
                                found = true;
                        }
                    }
                } while (prevToken && !found);
            }
            if (token && token.type.indexOf('tag-name')) {
                pos = range.start;
                if (pos.row == cursor.row && Math.abs(pos.column - cursor.column) < 2)
                    pos = range.end;
            }
        }

        pos = range && range.cursor || pos;
        if (pos) {
            if (select) {
                if (range && expand) {
                    this.selection.setRange(range);
                } else if (range && range.isEqual(this.getSelectionRange())) {
                    this.clearSelection();
                } else {
                    this.selection.selectTo(pos.row, pos.column);
                }
            } else {
                this.selection.moveTo(pos.row, pos.column);
            }
        }
    };
    this.gotoLine = function(lineNumber, column, animate) {
        this.selection.clearSelection();
        this.session.unfold({row: lineNumber - 1, column: column || 0});

        this.$blockScrolling += 1;
        this.exitMultiSelectMode && this.exitMultiSelectMode();
        this.moveCursorTo(lineNumber - 1, column || 0);
        this.$blockScrolling -= 1;

        if (!this.isRowFullyVisible(lineNumber - 1))
            this.scrollToLine(lineNumber - 1, true, animate);
    };
    this.navigateTo = function(row, column) {
        this.selection.moveTo(row, column);
    };
    this.navigateUp = function(times) {
        if (this.selection.isMultiLine() && !this.selection.isBackwards()) {
            var selectionStart = this.selection.anchor.getPosition();
            return this.moveCursorToPosition(selectionStart);
        }
        this.selection.clearSelection();
        this.selection.moveCursorBy(-times || -1, 0);
    };
    this.navigateDown = function(times) {
        if (this.selection.isMultiLine() && this.selection.isBackwards()) {
            var selectionEnd = this.selection.anchor.getPosition();
            return this.moveCursorToPosition(selectionEnd);
        }
        this.selection.clearSelection();
        this.selection.moveCursorBy(times || 1, 0);
    };
    this.navigateLeft = function(times) {
        if (!this.selection.isEmpty()) {
            var selectionStart = this.getSelectionRange().start;
            this.moveCursorToPosition(selectionStart);
        }
        else {
            times = times || 1;
            while (times--) {
                this.selection.moveCursorLeft();
            }
        }
        this.clearSelection();
    };
    this.navigateRight = function(times) {
        if (!this.selection.isEmpty()) {
            var selectionEnd = this.getSelectionRange().end;
            this.moveCursorToPosition(selectionEnd);
        }
        else {
            times = times || 1;
            while (times--) {
                this.selection.moveCursorRight();
            }
        }
        this.clearSelection();
    };
    this.navigateLineStart = function() {
        this.selection.moveCursorLineStart();
        this.clearSelection();
    };
    this.navigateLineEnd = function() {
        this.selection.moveCursorLineEnd();
        this.clearSelection();
    };
    this.navigateFileEnd = function() {
        this.selection.moveCursorFileEnd();
        this.clearSelection();
    };
    this.navigateFileStart = function() {
        this.selection.moveCursorFileStart();
        this.clearSelection();
    };
    this.navigateWordRight = function() {
        this.selection.moveCursorWordRight();
        this.clearSelection();
    };
    this.navigateWordLeft = function() {
        this.selection.moveCursorWordLeft();
        this.clearSelection();
    };
    this.replace = function(replacement, options) {
        if (options)
            this.$search.set(options);

        var range = this.$search.find(this.session);
        var replaced = 0;
        if (!range)
            return replaced;

        if (this.$tryReplace(range, replacement)) {
            replaced = 1;
        }
        if (range !== null) {
            this.selection.setSelectionRange(range);
            this.renderer.scrollSelectionIntoView(range.start, range.end);
        }

        return replaced;
    };
    this.replaceAll = function(replacement, options) {
        if (options) {
            this.$search.set(options);
        }

        var ranges = this.$search.findAll(this.session);
        var replaced = 0;
        if (!ranges.length)
            return replaced;

        this.$blockScrolling += 1;

        var selection = this.getSelectionRange();
        this.selection.moveTo(0, 0);

        for (var i = ranges.length - 1; i >= 0; --i) {
            if(this.$tryReplace(ranges[i], replacement)) {
                replaced++;
            }
        }

        this.selection.setSelectionRange(selection);
        this.$blockScrolling -= 1;

        return replaced;
    };

    this.$tryReplace = function(range, replacement) {
        var input = this.session.getTextRange(range);
        replacement = this.$search.replace(input, replacement);
        if (replacement !== null) {
            range.end = this.session.replace(range, replacement);
            return range;
        } else {
            return null;
        }
    };
    this.getLastSearchOptions = function() {
        return this.$search.getOptions();
    };
    this.find = function(needle, options, animate) {
        if (!options)
            options = {};

        if (typeof needle == "string" || needle instanceof RegExp)
            options.needle = needle;
        else if (typeof needle == "object")
            oop.mixin(options, needle);

        var range = this.selection.getRange();
        if (options.needle == null) {
            needle = this.session.getTextRange(range)
                || this.$search.$options.needle;
            if (!needle) {
                range = this.session.getWordRange(range.start.row, range.start.column);
                needle = this.session.getTextRange(range);
            }
            this.$search.set({needle: needle});
        }

        this.$search.set(options);
        if (!options.start)
            this.$search.set({start: range});

        var newRange = this.$search.find(this.session);
        if (options.preventScroll)
            return newRange;
        if (newRange) {
            this.revealRange(newRange, animate);
            return newRange;
        }
        if (options.backwards)
            range.start = range.end;
        else
            range.end = range.start;
        this.selection.setRange(range);
    };
    this.findNext = function(options, animate) {
        this.find({skipCurrent: true, backwards: false}, options, animate);
    };
    this.findPrevious = function(options, animate) {
        this.find(options, {skipCurrent: true, backwards: true}, animate);
    };

    this.revealRange = function(range, animate) {
        this.$blockScrolling += 1;
        this.session.unfold(range);
        this.selection.setSelectionRange(range);
        this.$blockScrolling -= 1;

        var scrollTop = this.renderer.scrollTop;
        this.renderer.scrollSelectionIntoView(range.start, range.end, 0.5);
        if (animate !== false)
            this.renderer.animateScrolling(scrollTop);
    };
    this.undo = function() {
        this.$blockScrolling++;
        this.session.getUndoManager().undo();
        this.$blockScrolling--;
        this.renderer.scrollCursorIntoView(null, 0.5);
    };
    this.redo = function() {
        this.$blockScrolling++;
        this.session.getUndoManager().redo();
        this.$blockScrolling--;
        this.renderer.scrollCursorIntoView(null, 0.5);
    };
    this.destroy = function() {
        this.renderer.destroy();
        this._signal("destroy", this);
        if (this.session) {
            this.session.destroy();
        }
    };
    this.setAutoScrollEditorIntoView = function(enable) {
        if (!enable)
            return;
        var rect;
        var self = this;
        var shouldScroll = false;
        if (!this.$scrollAnchor)
            this.$scrollAnchor = document.createElement("div");
        var scrollAnchor = this.$scrollAnchor;
        scrollAnchor.style.cssText = "position:absolute";
        this.container.insertBefore(scrollAnchor, this.container.firstChild);
        var onChangeSelection = this.on("changeSelection", function() {
            shouldScroll = true;
        });
        var onBeforeRender = this.renderer.on("beforeRender", function() {
            if (shouldScroll)
                rect = self.renderer.container.getBoundingClientRect();
        });
        var onAfterRender = this.renderer.on("afterRender", function() {
            if (shouldScroll && rect && (self.isFocused()
                || self.searchBox && self.searchBox.isFocused())
            ) {
                var renderer = self.renderer;
                var pos = renderer.$cursorLayer.$pixelPos;
                var config = renderer.layerConfig;
                var top = pos.top - config.offset;
                if (pos.top >= 0 && top + rect.top < 0) {
                    shouldScroll = true;
                } else if (pos.top < config.height &&
                    pos.top + rect.top + config.lineHeight > window.innerHeight) {
                    shouldScroll = false;
                } else {
                    shouldScroll = null;
                }
                if (shouldScroll != null) {
                    scrollAnchor.style.top = top + "px";
                    scrollAnchor.style.left = pos.left + "px";
                    scrollAnchor.style.height = config.lineHeight + "px";
                    scrollAnchor.scrollIntoView(shouldScroll);
                }
                shouldScroll = rect = null;
            }
        });
        this.setAutoScrollEditorIntoView = function(enable) {
            if (enable)
                return;
            delete this.setAutoScrollEditorIntoView;
            this.off("changeSelection", onChangeSelection);
            this.renderer.off("afterRender", onAfterRender);
            this.renderer.off("beforeRender", onBeforeRender);
        };
    };


    this.$resetCursorStyle = function() {
        var style = this.$cursorStyle || "ace";
        var cursorLayer = this.renderer.$cursorLayer;
        if (!cursorLayer)
            return;
        cursorLayer.setSmoothBlinking(/smooth/.test(style));
        cursorLayer.isBlinking = !this.$readOnly && style != "wide";
        dom.setCssClass(cursorLayer.element, "ace_slim-cursors", /slim/.test(style));
    };

}).call(Editor.prototype);



config.defineOptions(Editor.prototype, "editor", {
    selectionStyle: {
        set: function(style) {
            this.onSelectionChange();
            this._signal("changeSelectionStyle", {data: style});
        },
        initialValue: "line"
    },
    highlightActiveLine: {
        set: function() {this.$updateHighlightActiveLine();},
        initialValue: true
    },
    highlightSelectedWord: {
        set: function(shouldHighlight) {this.$onSelectionChange();},
        initialValue: true
    },
    readOnly: {
        set: function(readOnly) {
            this.$resetCursorStyle(); 
        },
        initialValue: false
    },
    cursorStyle: {
        set: function(val) { this.$resetCursorStyle(); },
        values: ["ace", "slim", "smooth", "wide"],
        initialValue: "ace"
    },
    mergeUndoDeltas: {
        values: [false, true, "always"],
        initialValue: true
    },
    behavioursEnabled: {initialValue: true},
    wrapBehavioursEnabled: {initialValue: true},
    autoScrollEditorIntoView: {
        set: function(val) {this.setAutoScrollEditorIntoView(val);}
    },
    keyboardHandler: {
        set: function(val) { this.setKeyboardHandler(val); },
        get: function() { return this.keybindingId; },
        handlesSet: true
    },

    hScrollBarAlwaysVisible: "renderer",
    vScrollBarAlwaysVisible: "renderer",
    highlightGutterLine: "renderer",
    animatedScroll: "renderer",
    showInvisibles: "renderer",
    showPrintMargin: "renderer",
    printMarginColumn: "renderer",
    printMargin: "renderer",
    fadeFoldWidgets: "renderer",
    showFoldWidgets: "renderer",
    showLineNumbers: "renderer",
    showGutter: "renderer",
    displayIndentGuides: "renderer",
    fontSize: "renderer",
    fontFamily: "renderer",
    maxLines: "renderer",
    minLines: "renderer",
    scrollPastEnd: "renderer",
    fixedWidthGutter: "renderer",
    theme: "renderer",

    scrollSpeed: "$mouseHandler",
    dragDelay: "$mouseHandler",
    dragEnabled: "$mouseHandler",
    focusTimout: "$mouseHandler",
    tooltipFollowsMouse: "$mouseHandler",

    firstLineNumber: "session",
    overwrite: "session",
    newLineMode: "session",
    useWorker: "session",
    useSoftTabs: "session",
    tabSize: "session",
    wrap: "session",
    indentedSoftWrap: "session",
    foldStyle: "session",
    mode: "session"
});

exports.Editor = Editor;
});

ace.define("ace/undomanager",["require","exports","module"], function(acequire, exports, module) {
"use strict";
var UndoManager = function() {
    this.reset();
};

(function() {
    this.execute = function(options) {
        var deltaSets = options.args[0];
        this.$doc  = options.args[1];
        if (options.merge && this.hasUndo()){
            this.dirtyCounter--;
            deltaSets = this.$undoStack.pop().concat(deltaSets);
        }
        this.$undoStack.push(deltaSets);
        this.$redoStack = [];
        if (this.dirtyCounter < 0) {
            this.dirtyCounter = NaN;
        }
        this.dirtyCounter++;
    };
    this.undo = function(dontSelect) {
        var deltaSets = this.$undoStack.pop();
        var undoSelectionRange = null;
        if (deltaSets) {
            undoSelectionRange = this.$doc.undoChanges(deltaSets, dontSelect);
            this.$redoStack.push(deltaSets);
            this.dirtyCounter--;
        }

        return undoSelectionRange;
    };
    this.redo = function(dontSelect) {
        var deltaSets = this.$redoStack.pop();
        var redoSelectionRange = null;
        if (deltaSets) {
            redoSelectionRange =
                this.$doc.redoChanges(this.$deserializeDeltas(deltaSets), dontSelect);
            this.$undoStack.push(deltaSets);
            this.dirtyCounter++;
        }
        return redoSelectionRange;
    };
    this.reset = function() {
        this.$undoStack = [];
        this.$redoStack = [];
        this.dirtyCounter = 0;
    };
    this.hasUndo = function() {
        return this.$undoStack.length > 0;
    };
    this.hasRedo = function() {
        return this.$redoStack.length > 0;
    };
    this.markClean = function() {
        this.dirtyCounter = 0;
    };
    this.isClean = function() {
        return this.dirtyCounter === 0;
    };
    this.$serializeDeltas = function(deltaSets) {
        return cloneDeltaSetsObj(deltaSets, $serializeDelta);
    };
    this.$deserializeDeltas = function(deltaSets) {
        return cloneDeltaSetsObj(deltaSets, $deserializeDelta);
    };
    
    function $serializeDelta(delta){
        return {
            action: delta.action,
            start: delta.start,
            end: delta.end,
            lines: delta.lines.length == 1 ? null : delta.lines,
            text: delta.lines.length == 1 ? delta.lines[0] : null
        };
    }
        
    function $deserializeDelta(delta) {
        return {
            action: delta.action,
            start: delta.start,
            end: delta.end,
            lines: delta.lines || [delta.text]
        };
    }
    
    function cloneDeltaSetsObj(deltaSets_old, fnGetModifiedDelta) {
        var deltaSets_new = new Array(deltaSets_old.length);
        for (var i = 0; i < deltaSets_old.length; i++) {
            var deltaSet_old = deltaSets_old[i];
            var deltaSet_new = { group: deltaSet_old.group, deltas: new Array(deltaSet_old.length)};
            
            for (var j = 0; j < deltaSet_old.deltas.length; j++) {
                var delta_old = deltaSet_old.deltas[j];
                deltaSet_new.deltas[j] = fnGetModifiedDelta(delta_old);
            }
            
            deltaSets_new[i] = deltaSet_new;
        }
        return deltaSets_new;
    }
    
}).call(UndoManager.prototype);

exports.UndoManager = UndoManager;
});

ace.define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var Gutter = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_gutter-layer";
    parentEl.appendChild(this.element);
    this.setShowFoldWidgets(this.$showFoldWidgets);
    
    this.gutterWidth = 0;

    this.$annotations = [];
    this.$updateAnnotations = this.$updateAnnotations.bind(this);

    this.$cells = [];
};

(function() {

    oop.implement(this, EventEmitter);

    this.setSession = function(session) {
        if (this.session)
            this.session.removeEventListener("change", this.$updateAnnotations);
        this.session = session;
        if (session)
            session.on("change", this.$updateAnnotations);
    };

    this.addGutterDecoration = function(row, className){
        if (window.console)
            console.warn && console.warn("deprecated use session.addGutterDecoration");
        this.session.addGutterDecoration(row, className);
    };

    this.removeGutterDecoration = function(row, className){
        if (window.console)
            console.warn && console.warn("deprecated use session.removeGutterDecoration");
        this.session.removeGutterDecoration(row, className);
    };

    this.setAnnotations = function(annotations) {
        this.$annotations = [];
        for (var i = 0; i < annotations.length; i++) {
            var annotation = annotations[i];
            var row = annotation.row;
            var rowInfo = this.$annotations[row];
            if (!rowInfo)
                rowInfo = this.$annotations[row] = {text: []};
           
            var annoText = annotation.text;
            annoText = annoText ? lang.escapeHTML(annoText) : annotation.html || "";

            if (rowInfo.text.indexOf(annoText) === -1)
                rowInfo.text.push(annoText);

            var type = annotation.type;
            if (type == "error")
                rowInfo.className = " ace_error";
            else if (type == "warning" && rowInfo.className != " ace_error")
                rowInfo.className = " ace_warning";
            else if (type == "info" && (!rowInfo.className))
                rowInfo.className = " ace_info";
        }
    };

    this.$updateAnnotations = function (delta) {
        if (!this.$annotations.length)
            return;
        var firstRow = delta.start.row;
        var len = delta.end.row - firstRow;
        if (len === 0) {
        } else if (delta.action == 'remove') {
            this.$annotations.splice(firstRow, len + 1, null);
        } else {
            var args = new Array(len + 1);
            args.unshift(firstRow, 1);
            this.$annotations.splice.apply(this.$annotations, args);
        }
    };

    this.update = function(config) {
        var session = this.session;
        var firstRow = config.firstRow;
        var lastRow = Math.min(config.lastRow + config.gutterOffset,  // needed to compensate for hor scollbar
            session.getLength() - 1);
        var fold = session.getNextFoldLine(firstRow);
        var foldStart = fold ? fold.start.row : Infinity;
        var foldWidgets = this.$showFoldWidgets && session.foldWidgets;
        var breakpoints = session.$breakpoints;
        var decorations = session.$decorations;
        var firstLineNumber = session.$firstLineNumber;
        var lastLineNumber = 0;
        
        var gutterRenderer = session.gutterRenderer || this.$renderer;

        var cell = null;
        var index = -1;
        var row = firstRow;
        while (true) {
            if (row > foldStart) {
                row = fold.end.row + 1;
                fold = session.getNextFoldLine(row, fold);
                foldStart = fold ? fold.start.row : Infinity;
            }
            if (row > lastRow) {
                while (this.$cells.length > index + 1) {
                    cell = this.$cells.pop();
                    this.element.removeChild(cell.element);
                }
                break;
            }

            cell = this.$cells[++index];
            if (!cell) {
                cell = {element: null, textNode: null, foldWidget: null};
                cell.element = dom.createElement("div");
                cell.textNode = document.createTextNode('');
                cell.element.appendChild(cell.textNode);
                this.element.appendChild(cell.element);
                this.$cells[index] = cell;
            }

            var className = "ace_gutter-cell ";
            if (breakpoints[row])
                className += breakpoints[row];
            if (decorations[row])
                className += decorations[row];
            if (this.$annotations[row])
                className += this.$annotations[row].className;
            if (cell.element.className != className)
                cell.element.className = className;

            var height = session.getRowLength(row) * config.lineHeight + "px";
            if (height != cell.element.style.height)
                cell.element.style.height = height;

            if (foldWidgets) {
                var c = foldWidgets[row];
                if (c == null)
                    c = foldWidgets[row] = session.getFoldWidget(row);
            }

            if (c) {
                if (!cell.foldWidget) {
                    cell.foldWidget = dom.createElement("span");
                    cell.element.appendChild(cell.foldWidget);
                }
                var className = "ace_fold-widget ace_" + c;
                if (c == "start" && row == foldStart && row < fold.end.row)
                    className += " ace_closed";
                else
                    className += " ace_open";
                if (cell.foldWidget.className != className)
                    cell.foldWidget.className = className;

                var height = config.lineHeight + "px";
                if (cell.foldWidget.style.height != height)
                    cell.foldWidget.style.height = height;
            } else {
                if (cell.foldWidget) {
                    cell.element.removeChild(cell.foldWidget);
                    cell.foldWidget = null;
                }
            }
            
            var text = lastLineNumber = gutterRenderer
                ? gutterRenderer.getText(session, row)
                : row + firstLineNumber;
            if (text !== cell.textNode.data)
                cell.textNode.data = text;

            row++;
        }

        this.element.style.height = config.minHeight + "px";

        if (this.$fixedWidth || session.$useWrapMode)
            lastLineNumber = session.getLength() + firstLineNumber;

        var gutterWidth = gutterRenderer 
            ? gutterRenderer.getWidth(session, lastLineNumber, config)
            : lastLineNumber.toString().length * config.characterWidth;
        
        var padding = this.$padding || this.$computePadding();
        gutterWidth += padding.left + padding.right;
        if (gutterWidth !== this.gutterWidth && !isNaN(gutterWidth)) {
            this.gutterWidth = gutterWidth;
            this.element.style.width = Math.ceil(this.gutterWidth) + "px";
            this._emit("changeGutterWidth", gutterWidth);
        }
    };

    this.$fixedWidth = false;
    
    this.$showLineNumbers = true;
    this.$renderer = "";
    this.setShowLineNumbers = function(show) {
        this.$renderer = !show && {
            getWidth: function() {return "";},
            getText: function() {return "";}
        };
    };
    
    this.getShowLineNumbers = function() {
        return this.$showLineNumbers;
    };
    
    this.$showFoldWidgets = true;
    this.setShowFoldWidgets = function(show) {
        if (show)
            dom.addCssClass(this.element, "ace_folding-enabled");
        else
            dom.removeCssClass(this.element, "ace_folding-enabled");

        this.$showFoldWidgets = show;
        this.$padding = null;
    };
    
    this.getShowFoldWidgets = function() {
        return this.$showFoldWidgets;
    };

    this.$computePadding = function() {
        if (!this.element.firstChild)
            return {left: 0, right: 0};
        var style = dom.computedStyle(this.element.firstChild);
        this.$padding = {};
        this.$padding.left = parseInt(style.paddingLeft) + 1 || 0;
        this.$padding.right = parseInt(style.paddingRight) || 0;
        return this.$padding;
    };

    this.getRegion = function(point) {
        var padding = this.$padding || this.$computePadding();
        var rect = this.element.getBoundingClientRect();
        if (point.x < padding.left + rect.left)
            return "markers";
        if (this.$showFoldWidgets && point.x > rect.right - padding.right)
            return "foldWidgets";
    };

}).call(Gutter.prototype);

exports.Gutter = Gutter;

});

ace.define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;
var dom = acequire("../lib/dom");

var Marker = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_marker-layer";
    parentEl.appendChild(this.element);
};

(function() {

    this.$padding = 0;

    this.setPadding = function(padding) {
        this.$padding = padding;
    };
    this.setSession = function(session) {
        this.session = session;
    };
    
    this.setMarkers = function(markers) {
        this.markers = markers;
    };

    this.update = function(config) {
        if (!config) return;

        this.config = config;


        var html = [];
        for (var key in this.markers) {
            var marker = this.markers[key];

            if (!marker.range) {
                marker.update(html, this, this.session, config);
                continue;
            }

            var range = marker.range.clipRows(config.firstRow, config.lastRow);
            if (range.isEmpty()) continue;

            range = range.toScreenRange(this.session);
            if (marker.renderer) {
                var top = this.$getTop(range.start.row, config);
                var left = this.$padding + (this.session.$bidiHandler.isBidiRow(range.start.row)
                    ? this.session.$bidiHandler.getPosLeft(range.start.column)
                    : range.start.column * config.characterWidth);
                marker.renderer(html, range, left, top, config);
            } else if (marker.type == "fullLine") {
                this.drawFullLineMarker(html, range, marker.clazz, config);
            } else if (marker.type == "screenLine") {
                this.drawScreenLineMarker(html, range, marker.clazz, config);
            } else if (range.isMultiLine()) {
                if (marker.type == "text")
                    this.drawTextMarker(html, range, marker.clazz, config);
                else
                    this.drawMultiLineMarker(html, range, marker.clazz, config);
            } else {
                if (this.session.$bidiHandler.isBidiRow(range.start.row)) {
                    this.drawBidiSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
                } else {
                    this.drawSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
                }
            }
        }
        this.element.innerHTML = html.join("");
    };

    this.$getTop = function(row, layerConfig) {
        return (row - layerConfig.firstRowScreen) * layerConfig.lineHeight;
    };

    function getBorderClass(tl, tr, br, bl) {
        return (tl ? 1 : 0) | (tr ? 2 : 0) | (br ? 4 : 0) | (bl ? 8 : 0);
    }
    this.drawTextMarker = function(stringBuilder, range, clazz, layerConfig, extraStyle) {
        var session = this.session;
        var start = range.start.row;
        var end = range.end.row;
        var row = start;
        var prev = 0; 
        var curr = 0;
        var next = session.getScreenLastRowColumn(row);
        var clazzModified = null;
        var lineRange = new Range(row, range.start.column, row, curr);
        for (; row <= end; row++) {
            lineRange.start.row = lineRange.end.row = row;
            lineRange.start.column = row == start ? range.start.column : session.getRowWrapIndent(row);
            lineRange.end.column = next;
            prev = curr;
            curr = next;
            next = row + 1 < end ? session.getScreenLastRowColumn(row + 1) : row == end ? 0 : range.end.column;
            clazzModified = clazz + (row == start  ? " ace_start" : "") + " ace_br"
                + getBorderClass(row == start || row == start + 1 && range.start.column, prev < curr, curr > next, row == end);

            if (this.session.$bidiHandler.isBidiRow(row)) {
                this.drawBidiSingleLineMarker(stringBuilder, lineRange, clazzModified,
                    layerConfig, row == end ? 0 : 1, extraStyle);
            } else {
                this.drawSingleLineMarker(stringBuilder, lineRange, clazzModified,
                    layerConfig, row == end ? 0 : 1, extraStyle);
            }
        }
    };
    this.drawMultiLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
        var padding = this.$padding;
        var height, top, left;
        extraStyle = extraStyle || "";
       if (this.session.$bidiHandler.isBidiRow(range.start.row)) {
           var range1 = range.clone();
           range1.end.row = range1.start.row;
           range1.end.column = this.session.getLine(range1.start.row).length;
           this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br1 ace_start", config, null, extraStyle);
        } else {
           height = config.lineHeight;
           top = this.$getTop(range.start.row, config);
           left = padding + range.start.column * config.characterWidth;
           stringBuilder.push(
               "<div class='", clazz, " ace_br1 ace_start' style='",
               "height:", height, "px;",
               "right:0;",
               "top:", top, "px;",
               "left:", left, "px;", extraStyle, "'></div>"
           );
        }
        if (this.session.$bidiHandler.isBidiRow(range.end.row)) {
           var range1 = range.clone();
           range1.start.row = range1.end.row;
           range1.start.column = 0;
           this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br12", config, null, extraStyle);
        } else {
           var width = range.end.column * config.characterWidth;
           height = config.lineHeight;
           top = this.$getTop(range.end.row, config);
           stringBuilder.push(
               "<div class='", clazz, " ace_br12' style='",
               "height:", height, "px;",
               "width:", width, "px;",
               "top:", top, "px;",
               "left:", padding, "px;", extraStyle, "'></div>"
           );
        }
        height = (range.end.row - range.start.row - 1) * config.lineHeight;
        if (height <= 0)
            return;
        top = this.$getTop(range.start.row + 1, config);
        
        var radiusClass = (range.start.column ? 1 : 0) | (range.end.column ? 0 : 8);

        stringBuilder.push(
            "<div class='", clazz, (radiusClass ? " ace_br" + radiusClass : ""), "' style='",
            "height:", height, "px;",
            "right:0;",
            "top:", top, "px;",
            "left:", padding, "px;", extraStyle, "'></div>"
        );
    };
    this.drawSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
        var height = config.lineHeight;
        var width = (range.end.column + (extraLength || 0) - range.start.column) * config.characterWidth;

        var top = this.$getTop(range.start.row, config);
        var left = this.$padding + range.start.column * config.characterWidth;

        stringBuilder.push(
            "<div class='", clazz, "' style='",
            "height:", height, "px;",
            "width:", width, "px;",
            "top:", top, "px;",
            "left:", left, "px;", extraStyle || "", "'></div>"
        );
    };
    this.drawBidiSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
        var height = config.lineHeight, top = this.$getTop(range.start.row, config), padding = this.$padding;
        var selections = this.session.$bidiHandler.getSelections(range.start.column, range.end.column);

        selections.forEach(function(selection) {
            stringBuilder.push(
                "<div class='", clazz, "' style='",
                "height:", height, "px;",
                "width:", selection.width + (extraLength || 0), "px;",
                "top:", top, "px;",
                "left:", padding + selection.left, "px;", extraStyle || "", "'></div>"
            );
        });
    };

    this.drawFullLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
        var top = this.$getTop(range.start.row, config);
        var height = config.lineHeight;
        if (range.start.row != range.end.row)
            height += this.$getTop(range.end.row, config) - top;

        stringBuilder.push(
            "<div class='", clazz, "' style='",
            "height:", height, "px;",
            "top:", top, "px;",
            "left:0;right:0;", extraStyle || "", "'></div>"
        );
    };
    
    this.drawScreenLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
        var top = this.$getTop(range.start.row, config);
        var height = config.lineHeight;

        stringBuilder.push(
            "<div class='", clazz, "' style='",
            "height:", height, "px;",
            "top:", top, "px;",
            "left:0;right:0;", extraStyle || "", "'></div>"
        );
    };

}).call(Marker.prototype);

exports.Marker = Marker;

});

ace.define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var useragent = acequire("../lib/useragent");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var Text = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_text-layer";
    parentEl.appendChild(this.element);
    this.$updateEolChar = this.$updateEolChar.bind(this);
};

(function() {

    oop.implement(this, EventEmitter);

    this.EOF_CHAR = "\xB6";
    this.EOL_CHAR_LF = "\xAC";
    this.EOL_CHAR_CRLF = "\xa4";
    this.EOL_CHAR = this.EOL_CHAR_LF;
    this.TAB_CHAR = "\u2014"; //"\u21E5";
    this.SPACE_CHAR = "\xB7";
    this.$padding = 0;

    this.$updateEolChar = function() {
        var EOL_CHAR = this.session.doc.getNewLineCharacter() == "\n"
           ? this.EOL_CHAR_LF
           : this.EOL_CHAR_CRLF;
        if (this.EOL_CHAR != EOL_CHAR) {
            this.EOL_CHAR = EOL_CHAR;
            return true;
        }
    };

    this.setPadding = function(padding) {
        this.$padding = padding;
        this.element.style.padding = "0 " + padding + "px";
    };

    this.getLineHeight = function() {
        return this.$fontMetrics.$characterSize.height || 0;
    };

    this.getCharacterWidth = function() {
        return this.$fontMetrics.$characterSize.width || 0;
    };
    
    this.$setFontMetrics = function(measure) {
        this.$fontMetrics = measure;
        this.$fontMetrics.on("changeCharacterSize", function(e) {
            this._signal("changeCharacterSize", e);
        }.bind(this));
        this.$pollSizeChanges();
    };

    this.checkForSizeChanges = function() {
        this.$fontMetrics.checkForSizeChanges();
    };
    this.$pollSizeChanges = function() {
        return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
    };
    this.setSession = function(session) {
        this.session = session;
        if (session)
            this.$computeTabString();
    };

    this.showInvisibles = false;
    this.setShowInvisibles = function(showInvisibles) {
        if (this.showInvisibles == showInvisibles)
            return false;

        this.showInvisibles = showInvisibles;
        this.$computeTabString();
        return true;
    };

    this.displayIndentGuides = true;
    this.setDisplayIndentGuides = function(display) {
        if (this.displayIndentGuides == display)
            return false;

        this.displayIndentGuides = display;
        this.$computeTabString();
        return true;
    };

    this.$tabStrings = [];
    this.onChangeTabSize =
    this.$computeTabString = function() {
        var tabSize = this.session.getTabSize();
        this.tabSize = tabSize;
        var tabStr = this.$tabStrings = [0];
        for (var i = 1; i < tabSize + 1; i++) {
            if (this.showInvisibles) {
                tabStr.push("<span class='ace_invisible ace_invisible_tab'>"
                    + lang.stringRepeat(this.TAB_CHAR, i)
                    + "</span>");
            } else {
                tabStr.push(lang.stringRepeat(" ", i));
            }
        }
        if (this.displayIndentGuides) {
            this.$indentGuideRe =  /\s\S| \t|\t |\s$/;
            var className = "ace_indent-guide";
            var spaceClass = "";
            var tabClass = "";
            if (this.showInvisibles) {
                className += " ace_invisible";
                spaceClass = " ace_invisible_space";
                tabClass = " ace_invisible_tab";
                var spaceContent = lang.stringRepeat(this.SPACE_CHAR, this.tabSize);
                var tabContent = lang.stringRepeat(this.TAB_CHAR, this.tabSize);
            } else{
                var spaceContent = lang.stringRepeat(" ", this.tabSize);
                var tabContent = spaceContent;
            }

            this.$tabStrings[" "] = "<span class='" + className + spaceClass + "'>" + spaceContent + "</span>";
            this.$tabStrings["\t"] = "<span class='" + className + tabClass + "'>" + tabContent + "</span>";
        }
    };

    this.updateLines = function(config, firstRow, lastRow) {
        if (this.config.lastRow != config.lastRow ||
            this.config.firstRow != config.firstRow) {
            this.scrollLines(config);
        }
        this.config = config;

        var first = Math.max(firstRow, config.firstRow);
        var last = Math.min(lastRow, config.lastRow);

        var lineElements = this.element.childNodes;
        var lineElementsIdx = 0;

        for (var row = config.firstRow; row < first; row++) {
            var foldLine = this.session.getFoldLine(row);
            if (foldLine) {
                if (foldLine.containsRow(first)) {
                    first = foldLine.start.row;
                    break;
                } else {
                    row = foldLine.end.row;
                }
            }
            lineElementsIdx ++;
        }

        var row = first;
        var foldLine = this.session.getNextFoldLine(row);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (true) {
            if (row > foldStart) {
                row = foldLine.end.row+1;
                foldLine = this.session.getNextFoldLine(row, foldLine);
                foldStart = foldLine ? foldLine.start.row :Infinity;
            }
            if (row > last)
                break;

            var lineElement = lineElements[lineElementsIdx++];
            if (lineElement) {
                var html = [];
                this.$renderLine(
                    html, row, !this.$useLineGroups(), row == foldStart ? foldLine : false
                );
                lineElement.style.height = config.lineHeight * this.session.getRowLength(row) + "px";
                lineElement.innerHTML = html.join("");
            }
            row++;
        }
    };

    this.scrollLines = function(config) {
        var oldConfig = this.config;
        this.config = config;

        if (!oldConfig || oldConfig.lastRow < config.firstRow)
            return this.update(config);

        if (config.lastRow < oldConfig.firstRow)
            return this.update(config);

        var el = this.element;
        if (oldConfig.firstRow < config.firstRow)
            for (var row=this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row>0; row--)
                el.removeChild(el.firstChild);

        if (oldConfig.lastRow > config.lastRow)
            for (var row=this.session.getFoldedRowCount(config.lastRow + 1, oldConfig.lastRow); row>0; row--)
                el.removeChild(el.lastChild);

        if (config.firstRow < oldConfig.firstRow) {
            var fragment = this.$renderLinesFragment(config, config.firstRow, oldConfig.firstRow - 1);
            if (el.firstChild)
                el.insertBefore(fragment, el.firstChild);
            else
                el.appendChild(fragment);
        }

        if (config.lastRow > oldConfig.lastRow) {
            var fragment = this.$renderLinesFragment(config, oldConfig.lastRow + 1, config.lastRow);
            el.appendChild(fragment);
        }
    };

    this.$renderLinesFragment = function(config, firstRow, lastRow) {
        var fragment = this.element.ownerDocument.createDocumentFragment();
        var row = firstRow;
        var foldLine = this.session.getNextFoldLine(row);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (true) {
            if (row > foldStart) {
                row = foldLine.end.row+1;
                foldLine = this.session.getNextFoldLine(row, foldLine);
                foldStart = foldLine ? foldLine.start.row : Infinity;
            }
            if (row > lastRow)
                break;

            var container = dom.createElement("div");

            var html = [];
            this.$renderLine(html, row, false, row == foldStart ? foldLine : false);
            container.innerHTML = html.join("");
            if (this.$useLineGroups()) {
                container.className = 'ace_line_group';
                fragment.appendChild(container);
                container.style.height = config.lineHeight * this.session.getRowLength(row) + "px";

            } else {
                while(container.firstChild)
                    fragment.appendChild(container.firstChild);
            }

            row++;
        }
        return fragment;
    };

    this.update = function(config) {
        this.config = config;

        var html = [];
        var firstRow = config.firstRow, lastRow = config.lastRow;

        var row = firstRow;
        var foldLine = this.session.getNextFoldLine(row);
        var foldStart = foldLine ? foldLine.start.row : Infinity;

        while (true) {
            if (row > foldStart) {
                row = foldLine.end.row+1;
                foldLine = this.session.getNextFoldLine(row, foldLine);
                foldStart = foldLine ? foldLine.start.row :Infinity;
            }
            if (row > lastRow)
                break;

            if (this.$useLineGroups())
                html.push("<div class='ace_line_group' style='height:", config.lineHeight*this.session.getRowLength(row), "px'>");

            this.$renderLine(html, row, false, row == foldStart ? foldLine : false);

            if (this.$useLineGroups())
                html.push("</div>"); // end the line group

            row++;
        }
        this.element.innerHTML = html.join("");
    };

    this.$textToken = {
        "text": true,
        "rparen": true,
        "lparen": true
    };

    this.$renderToken = function(stringBuilder, screenColumn, token, value) {
        var self = this;
        var replaceReg = /\t|&|<|>|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\u3000\uFEFF\uFFF9-\uFFFC])|[\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        var replaceFunc = function(c, a, b, tabIdx, idx4) {
            if (a) {
                return self.showInvisibles
                    ? "<span class='ace_invisible ace_invisible_space'>" + lang.stringRepeat(self.SPACE_CHAR, c.length) + "</span>"
                    : c;
            } else if (c == "&") {
                return "&#38;";
            } else if (c == "<") {
                return "&#60;";
            } else if (c == ">") {
                return "&#62;";
            } else if (c == "\t") {
                var tabSize = self.session.getScreenTabSize(screenColumn + tabIdx);
                screenColumn += tabSize - 1;
                return self.$tabStrings[tabSize];
            } else if (c == "\u3000") {
                var classToUse = self.showInvisibles ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk";
                var space = self.showInvisibles ? self.SPACE_CHAR : "";
                screenColumn += 1;
                return "<span class='" + classToUse + "' style='width:" +
                    (self.config.characterWidth * 2) +
                    "px'>" + space + "</span>";
            } else if (b) {
                return "<span class='ace_invisible ace_invisible_space ace_invalid'>" + self.SPACE_CHAR + "</span>";
            } else {
                screenColumn += 1;
                return "<span class='ace_cjk' style='width:" +
                    (self.config.characterWidth * 2) +
                    "px'>" + c + "</span>";
            }
        };

        var output = value.replace(replaceReg, replaceFunc);

        if (!this.$textToken[token.type]) {
            var classes = "ace_" + token.type.replace(/\./g, " ace_");
            var style = "";
            if (token.type == "fold")
                style = " style='width:" + (token.value.length * this.config.characterWidth) + "px;' ";
            stringBuilder.push("<span class='", classes, "'", style, ">", output, "</span>");
        }
        else {
            stringBuilder.push(output);
        }
        return screenColumn + value.length;
    };

    this.renderIndentGuide = function(stringBuilder, value, max) {
        var cols = value.search(this.$indentGuideRe);
        if (cols <= 0 || cols >= max)
            return value;
        if (value[0] == " ") {
            cols -= cols % this.tabSize;
            stringBuilder.push(lang.stringRepeat(this.$tabStrings[" "], cols/this.tabSize));
            return value.substr(cols);
        } else if (value[0] == "\t") {
            stringBuilder.push(lang.stringRepeat(this.$tabStrings["\t"], cols));
            return value.substr(cols);
        }
        return value;
    };

    this.$renderWrappedLine = function(stringBuilder, tokens, splits, onlyContents) {
        var chars = 0;
        var split = 0;
        var splitChars = splits[0];
        var screenColumn = 0;

        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            var value = token.value;
            if (i == 0 && this.displayIndentGuides) {
                chars = value.length;
                value = this.renderIndentGuide(stringBuilder, value, splitChars);
                if (!value)
                    continue;
                chars -= value.length;
            }

            if (chars + value.length < splitChars) {
                screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
                chars += value.length;
            } else {
                while (chars + value.length >= splitChars) {
                    screenColumn = this.$renderToken(
                        stringBuilder, screenColumn,
                        token, value.substring(0, splitChars - chars)
                    );
                    value = value.substring(splitChars - chars);
                    chars = splitChars;

                    if (!onlyContents) {
                        stringBuilder.push("</div>",
                            "<div class='ace_line' style='height:",
                            this.config.lineHeight, "px'>"
                        );
                    }

                    stringBuilder.push(lang.stringRepeat("\xa0", splits.indent));

                    split ++;
                    screenColumn = 0;
                    splitChars = splits[split] || Number.MAX_VALUE;
                }
                if (value.length != 0) {
                    chars += value.length;
                    screenColumn = this.$renderToken(
                        stringBuilder, screenColumn, token, value
                    );
                }
            }
        }
    };

    this.$renderSimpleLine = function(stringBuilder, tokens) {
        var screenColumn = 0;
        var token = tokens[0];
        var value = token.value;
        if (this.displayIndentGuides)
            value = this.renderIndentGuide(stringBuilder, value);
        if (value)
            screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
        for (var i = 1; i < tokens.length; i++) {
            token = tokens[i];
            value = token.value;
            screenColumn = this.$renderToken(stringBuilder, screenColumn, token, value);
        }
    };
    this.$renderLine = function(stringBuilder, row, onlyContents, foldLine) {
        if (!foldLine && foldLine != false)
            foldLine = this.session.getFoldLine(row);

        if (foldLine)
            var tokens = this.$getFoldLineTokens(row, foldLine);
        else
            var tokens = this.session.getTokens(row);


        if (!onlyContents) {
            stringBuilder.push(
                "<div class='ace_line' style='height:", 
                    this.config.lineHeight * (
                        this.$useLineGroups() ? 1 :this.session.getRowLength(row)
                    ), "px'>"
            );
        }

        if (tokens.length) {
            var splits = this.session.getRowSplitData(row);
            if (splits && splits.length)
                this.$renderWrappedLine(stringBuilder, tokens, splits, onlyContents);
            else
                this.$renderSimpleLine(stringBuilder, tokens);
        }

        if (this.showInvisibles) {
            if (foldLine)
                row = foldLine.end.row;

            stringBuilder.push(
                "<span class='ace_invisible ace_invisible_eol'>",
                row == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR,
                "</span>"
            );
        }
        if (!onlyContents)
            stringBuilder.push("</div>");
    };

    this.$getFoldLineTokens = function(row, foldLine) {
        var session = this.session;
        var renderTokens = [];

        function addTokens(tokens, from, to) {
            var idx = 0, col = 0;
            while ((col + tokens[idx].value.length) < from) {
                col += tokens[idx].value.length;
                idx++;

                if (idx == tokens.length)
                    return;
            }
            if (col != from) {
                var value = tokens[idx].value.substring(from - col);
                if (value.length > (to - from))
                    value = value.substring(0, to - from);

                renderTokens.push({
                    type: tokens[idx].type,
                    value: value
                });

                col = from + value.length;
                idx += 1;
            }

            while (col < to && idx < tokens.length) {
                var value = tokens[idx].value;
                if (value.length + col > to) {
                    renderTokens.push({
                        type: tokens[idx].type,
                        value: value.substring(0, to - col)
                    });
                } else
                    renderTokens.push(tokens[idx]);
                col += value.length;
                idx += 1;
            }
        }

        var tokens = session.getTokens(row);
        foldLine.walk(function(placeholder, row, column, lastColumn, isNewRow) {
            if (placeholder != null) {
                renderTokens.push({
                    type: "fold",
                    value: placeholder
                });
            } else {
                if (isNewRow)
                    tokens = session.getTokens(row);

                if (tokens.length)
                    addTokens(tokens, lastColumn, column);
            }
        }, foldLine.end.row, this.session.getLine(foldLine.end.row).length);

        return renderTokens;
    };

    this.$useLineGroups = function() {
        return this.session.getUseWrapMode();
    };

    this.destroy = function() {
        clearInterval(this.$pollSizeChangesTimer);
        if (this.$measureNode)
            this.$measureNode.parentNode.removeChild(this.$measureNode);
        delete this.$measureNode;
    };

}).call(Text.prototype);

exports.Text = Text;

});

ace.define("ace/layer/cursor",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var dom = acequire("../lib/dom");
var isIE8;

var Cursor = function(parentEl) {
    this.element = dom.createElement("div");
    this.element.className = "ace_layer ace_cursor-layer";
    parentEl.appendChild(this.element);
    
    if (isIE8 === undefined)
        isIE8 = !("opacity" in this.element.style);

    this.isVisible = false;
    this.isBlinking = true;
    this.blinkInterval = 1000;
    this.smoothBlinking = false;

    this.cursors = [];
    this.cursor = this.addCursor();
    dom.addCssClass(this.element, "ace_hidden-cursors");
    this.$updateCursors = (isIE8
        ? this.$updateVisibility
        : this.$updateOpacity).bind(this);
};

(function() {
    
    this.$updateVisibility = function(val) {
        var cursors = this.cursors;
        for (var i = cursors.length; i--; )
            cursors[i].style.visibility = val ? "" : "hidden";
    };
    this.$updateOpacity = function(val) {
        var cursors = this.cursors;
        for (var i = cursors.length; i--; )
            cursors[i].style.opacity = val ? "" : "0";
    };
    

    this.$padding = 0;
    this.setPadding = function(padding) {
        this.$padding = padding;
    };

    this.setSession = function(session) {
        this.session = session;
    };

    this.setBlinking = function(blinking) {
        if (blinking != this.isBlinking){
            this.isBlinking = blinking;
            this.restartTimer();
        }
    };

    this.setBlinkInterval = function(blinkInterval) {
        if (blinkInterval != this.blinkInterval){
            this.blinkInterval = blinkInterval;
            this.restartTimer();
        }
    };

    this.setSmoothBlinking = function(smoothBlinking) {
        if (smoothBlinking != this.smoothBlinking && !isIE8) {
            this.smoothBlinking = smoothBlinking;
            dom.setCssClass(this.element, "ace_smooth-blinking", smoothBlinking);
            this.$updateCursors(true);
            this.$updateCursors = (this.$updateOpacity).bind(this);
            this.restartTimer();
        }
    };

    this.addCursor = function() {
        var el = dom.createElement("div");
        el.className = "ace_cursor";
        this.element.appendChild(el);
        this.cursors.push(el);
        return el;
    };

    this.removeCursor = function() {
        if (this.cursors.length > 1) {
            var el = this.cursors.pop();
            el.parentNode.removeChild(el);
            return el;
        }
    };

    this.hideCursor = function() {
        this.isVisible = false;
        dom.addCssClass(this.element, "ace_hidden-cursors");
        this.restartTimer();
    };

    this.showCursor = function() {
        this.isVisible = true;
        dom.removeCssClass(this.element, "ace_hidden-cursors");
        this.restartTimer();
    };

    this.restartTimer = function() {
        var update = this.$updateCursors;
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
        if (this.smoothBlinking) {
            dom.removeCssClass(this.element, "ace_smooth-blinking");
        }
        
        update(true);

        if (!this.isBlinking || !this.blinkInterval || !this.isVisible)
            return;

        if (this.smoothBlinking) {
            setTimeout(function(){
                dom.addCssClass(this.element, "ace_smooth-blinking");
            }.bind(this));
        }
        
        var blink = function(){
            this.timeoutId = setTimeout(function() {
                update(false);
            }, 0.6 * this.blinkInterval);
        }.bind(this);

        this.intervalId = setInterval(function() {
            update(true);
            blink();
        }, this.blinkInterval);

        blink();
    };

    this.getPixelPosition = function(position, onScreen) {
        if (!this.config || !this.session)
            return {left : 0, top : 0};

        if (!position)
            position = this.session.selection.getCursor();
        var pos = this.session.documentToScreenPosition(position);
        var cursorLeft = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, position.row)
            ? this.session.$bidiHandler.getPosLeft(pos.column)
            : pos.column * this.config.characterWidth);

        var cursorTop = (pos.row - (onScreen ? this.config.firstRowScreen : 0)) *
            this.config.lineHeight;

        return {left : cursorLeft, top : cursorTop};
    };

    this.update = function(config) {
        this.config = config;

        var selections = this.session.$selectionMarkers;
        var i = 0, cursorIndex = 0;

        if (selections === undefined || selections.length === 0){
            selections = [{cursor: null}];
        }

        for (var i = 0, n = selections.length; i < n; i++) {
            var pixelPos = this.getPixelPosition(selections[i].cursor, true);
            if ((pixelPos.top > config.height + config.offset ||
                 pixelPos.top < 0) && i > 1) {
                continue;
            }

            var style = (this.cursors[cursorIndex++] || this.addCursor()).style;
            
            if (!this.drawCursor) {
                style.left = pixelPos.left + "px";
                style.top = pixelPos.top + "px";
                style.width = config.characterWidth + "px";
                style.height = config.lineHeight + "px";
            } else {
                this.drawCursor(style, pixelPos, config, selections[i], this.session);
            }
        }
        while (this.cursors.length > cursorIndex)
            this.removeCursor();

        var overwrite = this.session.getOverwrite();
        this.$setOverwrite(overwrite);
        this.$pixelPos = pixelPos;
        this.restartTimer();
    };
    
    this.drawCursor = null;

    this.$setOverwrite = function(overwrite) {
        if (overwrite != this.overwrite) {
            this.overwrite = overwrite;
            if (overwrite)
                dom.addCssClass(this.element, "ace_overwrite-cursors");
            else
                dom.removeCssClass(this.element, "ace_overwrite-cursors");
        }
    };

    this.destroy = function() {
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
    };

}).call(Cursor.prototype);

exports.Cursor = Cursor;

});

ace.define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var event = acequire("./lib/event");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var MAX_SCROLL_H = 0x8000;
var ScrollBar = function(parent) {
    this.element = dom.createElement("div");
    this.element.className = "ace_scrollbar ace_scrollbar" + this.classSuffix;

    this.inner = dom.createElement("div");
    this.inner.className = "ace_scrollbar-inner";
    this.element.appendChild(this.inner);

    parent.appendChild(this.element);

    this.setVisible(false);
    this.skipEvent = false;

    event.addListener(this.element, "scroll", this.onScroll.bind(this));
    event.addListener(this.element, "mousedown", event.preventDefault);
};

(function() {
    oop.implement(this, EventEmitter);

    this.setVisible = function(isVisible) {
        this.element.style.display = isVisible ? "" : "none";
        this.isVisible = isVisible;
        this.coeff = 1;
    };
}).call(ScrollBar.prototype);
var VScrollBar = function(parent, renderer) {
    ScrollBar.call(this, parent);
    this.scrollTop = 0;
    this.scrollHeight = 0;
    renderer.$scrollbarWidth = 
    this.width = dom.scrollbarWidth(parent.ownerDocument);
    this.inner.style.width =
    this.element.style.width = (this.width || 15) + 5 + "px";
    this.$minWidth = 0;
};

oop.inherits(VScrollBar, ScrollBar);

(function() {

    this.classSuffix = '-v';
    this.onScroll = function() {
        if (!this.skipEvent) {
            this.scrollTop = this.element.scrollTop;
            if (this.coeff != 1) {
                var h = this.element.clientHeight / this.scrollHeight;
                this.scrollTop = this.scrollTop * (1 - h) / (this.coeff - h);
            }
            this._emit("scroll", {data: this.scrollTop});
        }
        this.skipEvent = false;
    };
    this.getWidth = function() {
        return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
    };
    this.setHeight = function(height) {
        this.element.style.height = height + "px";
    };
    this.setInnerHeight =
    this.setScrollHeight = function(height) {
        this.scrollHeight = height;
        if (height > MAX_SCROLL_H) {
            this.coeff = MAX_SCROLL_H / height;
            height = MAX_SCROLL_H;
        } else if (this.coeff != 1) {
            this.coeff = 1;
        }
        this.inner.style.height = height + "px";
    };
    this.setScrollTop = function(scrollTop) {
        if (this.scrollTop != scrollTop) {
            this.skipEvent = true;
            this.scrollTop = scrollTop;
            this.element.scrollTop = scrollTop * this.coeff;
        }
    };

}).call(VScrollBar.prototype);
var HScrollBar = function(parent, renderer) {
    ScrollBar.call(this, parent);
    this.scrollLeft = 0;
    this.height = renderer.$scrollbarWidth;
    this.inner.style.height =
    this.element.style.height = (this.height || 15) + 5 + "px";
};

oop.inherits(HScrollBar, ScrollBar);

(function() {

    this.classSuffix = '-h';
    this.onScroll = function() {
        if (!this.skipEvent) {
            this.scrollLeft = this.element.scrollLeft;
            this._emit("scroll", {data: this.scrollLeft});
        }
        this.skipEvent = false;
    };
    this.getHeight = function() {
        return this.isVisible ? this.height : 0;
    };
    this.setWidth = function(width) {
        this.element.style.width = width + "px";
    };
    this.setInnerWidth = function(width) {
        this.inner.style.width = width + "px";
    };
    this.setScrollWidth = function(width) {
        this.inner.style.width = width + "px";
    };
    this.setScrollLeft = function(scrollLeft) {
        if (this.scrollLeft != scrollLeft) {
            this.skipEvent = true;
            this.scrollLeft = this.element.scrollLeft = scrollLeft;
        }
    };

}).call(HScrollBar.prototype);


exports.ScrollBar = VScrollBar; // backward compatibility
exports.ScrollBarV = VScrollBar; // backward compatibility
exports.ScrollBarH = HScrollBar; // backward compatibility

exports.VScrollBar = VScrollBar;
exports.HScrollBar = HScrollBar;
});

ace.define("ace/renderloop",["require","exports","module","ace/lib/event"], function(acequire, exports, module) {
"use strict";

var event = acequire("./lib/event");


var RenderLoop = function(onRender, win) {
    this.onRender = onRender;
    this.pending = false;
    this.changes = 0;
    this.window = win || window;
};

(function() {


    this.schedule = function(change) {
        this.changes = this.changes | change;
        if (!this.pending && this.changes) {
            this.pending = true;
            var _self = this;
            event.nextFrame(function() {
                _self.pending = false;
                var changes;
                while (changes = _self.changes) {
                    _self.changes = 0;
                    _self.onRender(changes);
                }
            }, this.window);
        }
    };

}).call(RenderLoop.prototype);

exports.RenderLoop = RenderLoop;
});

ace.define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"], function(acequire, exports, module) {

var oop = acequire("../lib/oop");
var dom = acequire("../lib/dom");
var lang = acequire("../lib/lang");
var useragent = acequire("../lib/useragent");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;

var CHAR_COUNT = 0;

var FontMetrics = exports.FontMetrics = function(parentEl) {
    this.el = dom.createElement("div");
    this.$setMeasureNodeStyles(this.el.style, true);
    
    this.$main = dom.createElement("div");
    this.$setMeasureNodeStyles(this.$main.style);
    
    this.$measureNode = dom.createElement("div");
    this.$setMeasureNodeStyles(this.$measureNode.style);
    
    
    this.el.appendChild(this.$main);
    this.el.appendChild(this.$measureNode);
    parentEl.appendChild(this.el);
    
    if (!CHAR_COUNT)
        this.$testFractionalRect();
    this.$measureNode.innerHTML = lang.stringRepeat("X", CHAR_COUNT);
    
    this.$characterSize = {width: 0, height: 0};
    this.checkForSizeChanges();
};

(function() {

    oop.implement(this, EventEmitter);
        
    this.$characterSize = {width: 0, height: 0};
    
    this.$testFractionalRect = function() {
        var el = dom.createElement("div");
        this.$setMeasureNodeStyles(el.style);
        el.style.width = "0.2px";
        document.documentElement.appendChild(el);
        var w = el.getBoundingClientRect().width;
        if (w > 0 && w < 1)
            CHAR_COUNT = 50;
        else
            CHAR_COUNT = 100;
        el.parentNode.removeChild(el);
    };
    
    this.$setMeasureNodeStyles = function(style, isRoot) {
        style.width = style.height = "auto";
        style.left = style.top = "0px";
        style.visibility = "hidden";
        style.position = "absolute";
        style.whiteSpace = "pre";

        if (useragent.isIE < 8) {
            style["font-family"] = "inherit";
        } else {
            style.font = "inherit";
        }
        style.overflow = isRoot ? "hidden" : "visible";
    };

    this.checkForSizeChanges = function() {
        var size = this.$measureSizes();
        if (size && (this.$characterSize.width !== size.width || this.$characterSize.height !== size.height)) {
            this.$measureNode.style.fontWeight = "bold";
            var boldSize = this.$measureSizes();
            this.$measureNode.style.fontWeight = "";
            this.$characterSize = size;
            this.charSizes = Object.create(null);
            this.allowBoldFonts = boldSize && boldSize.width === size.width && boldSize.height === size.height;
            this._emit("changeCharacterSize", {data: size});
        }
    };

    this.$pollSizeChanges = function() {
        if (this.$pollSizeChangesTimer)
            return this.$pollSizeChangesTimer;
        var self = this;
        return this.$pollSizeChangesTimer = setInterval(function() {
            self.checkForSizeChanges();
        }, 500);
    };
    
    this.setPolling = function(val) {
        if (val) {
            this.$pollSizeChanges();
        } else if (this.$pollSizeChangesTimer) {
            clearInterval(this.$pollSizeChangesTimer);
            this.$pollSizeChangesTimer = 0;
        }
    };

    this.$measureSizes = function() {
        if (CHAR_COUNT === 50) {
            var rect = null;
            try { 
               rect = this.$measureNode.getBoundingClientRect();
            } catch(e) {
               rect = {width: 0, height:0 };
            }
            var size = {
                height: rect.height,
                width: rect.width / CHAR_COUNT
            };
        } else {
            var size = {
                height: this.$measureNode.clientHeight,
                width: this.$measureNode.clientWidth / CHAR_COUNT
            };
        }
        if (size.width === 0 || size.height === 0)
            return null;
        return size;
    };

    this.$measureCharWidth = function(ch) {
        this.$main.innerHTML = lang.stringRepeat(ch, CHAR_COUNT);
        var rect = this.$main.getBoundingClientRect();
        return rect.width / CHAR_COUNT;
    };
    
    this.getCharacterWidth = function(ch) {
        var w = this.charSizes[ch];
        if (w === undefined) {
            w = this.charSizes[ch] = this.$measureCharWidth(ch) / this.$characterSize.width;
        }
        return w;
    };

    this.destroy = function() {
        clearInterval(this.$pollSizeChangesTimer);
        if (this.el && this.el.parentNode)
            this.el.parentNode.removeChild(this.el);
    };

}).call(FontMetrics.prototype);

});

ace.define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/config","ace/lib/useragent","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var config = acequire("./config");
var useragent = acequire("./lib/useragent");
var GutterLayer = acequire("./layer/gutter").Gutter;
var MarkerLayer = acequire("./layer/marker").Marker;
var TextLayer = acequire("./layer/text").Text;
var CursorLayer = acequire("./layer/cursor").Cursor;
var HScrollBar = acequire("./scrollbar").HScrollBar;
var VScrollBar = acequire("./scrollbar").VScrollBar;
var RenderLoop = acequire("./renderloop").RenderLoop;
var FontMetrics = acequire("./layer/font_metrics").FontMetrics;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var editorCss = ".ace_editor {\
position: relative;\
overflow: hidden;\
font: 12px/normal 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;\
direction: ltr;\
text-align: left;\
-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\
}\
.ace_scroller {\
position: absolute;\
overflow: hidden;\
top: 0;\
bottom: 0;\
background-color: inherit;\
-ms-user-select: none;\
-moz-user-select: none;\
-webkit-user-select: none;\
user-select: none;\
cursor: text;\
}\
.ace_content {\
position: absolute;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
min-width: 100%;\
}\
.ace_dragging .ace_scroller:before{\
position: absolute;\
top: 0;\
left: 0;\
right: 0;\
bottom: 0;\
content: '';\
background: rgba(250, 250, 250, 0.01);\
z-index: 1000;\
}\
.ace_dragging.ace_dark .ace_scroller:before{\
background: rgba(0, 0, 0, 0.01);\
}\
.ace_selecting, .ace_selecting * {\
cursor: text !important;\
}\
.ace_gutter {\
position: absolute;\
overflow : hidden;\
width: auto;\
top: 0;\
bottom: 0;\
left: 0;\
cursor: default;\
z-index: 4;\
-ms-user-select: none;\
-moz-user-select: none;\
-webkit-user-select: none;\
user-select: none;\
}\
.ace_gutter-active-line {\
position: absolute;\
left: 0;\
right: 0;\
}\
.ace_scroller.ace_scroll-left {\
box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\
}\
.ace_gutter-cell {\
padding-left: 19px;\
padding-right: 6px;\
background-repeat: no-repeat;\
}\
.ace_gutter-cell.ace_error {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==\");\
background-repeat: no-repeat;\
background-position: 2px center;\
}\
.ace_gutter-cell.ace_warning {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==\");\
background-position: 2px center;\
}\
.ace_gutter-cell.ace_info {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=\");\
background-position: 2px center;\
}\
.ace_dark .ace_gutter-cell.ace_info {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC\");\
}\
.ace_scrollbar {\
position: absolute;\
right: 0;\
bottom: 0;\
z-index: 6;\
}\
.ace_scrollbar-inner {\
position: absolute;\
cursor: text;\
left: 0;\
top: 0;\
}\
.ace_scrollbar-v{\
overflow-x: hidden;\
overflow-y: scroll;\
top: 0;\
}\
.ace_scrollbar-h {\
overflow-x: scroll;\
overflow-y: hidden;\
left: 0;\
}\
.ace_print-margin {\
position: absolute;\
height: 100%;\
}\
.ace_text-input {\
position: absolute;\
z-index: 0;\
width: 0.5em;\
height: 1em;\
opacity: 0;\
background: transparent;\
-moz-appearance: none;\
appearance: none;\
border: none;\
resize: none;\
outline: none;\
overflow: hidden;\
font: inherit;\
padding: 0 1px;\
margin: 0 -1px;\
text-indent: -1em;\
-ms-user-select: text;\
-moz-user-select: text;\
-webkit-user-select: text;\
user-select: text;\
white-space: pre!important;\
}\
.ace_text-input.ace_composition {\
background: inherit;\
color: inherit;\
z-index: 1000;\
opacity: 1;\
text-indent: 0;\
}\
.ace_layer {\
z-index: 1;\
position: absolute;\
overflow: hidden;\
word-wrap: normal;\
white-space: pre;\
height: 100%;\
width: 100%;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
pointer-events: none;\
}\
.ace_gutter-layer {\
position: relative;\
width: auto;\
text-align: right;\
pointer-events: auto;\
}\
.ace_text-layer {\
font: inherit !important;\
}\
.ace_cjk {\
display: inline-block;\
text-align: center;\
}\
.ace_cursor-layer {\
z-index: 4;\
}\
.ace_cursor {\
z-index: 4;\
position: absolute;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
border-left: 2px solid;\
transform: translatez(0);\
}\
.ace_multiselect .ace_cursor {\
border-left-width: 1px;\
}\
.ace_slim-cursors .ace_cursor {\
border-left-width: 1px;\
}\
.ace_overwrite-cursors .ace_cursor {\
border-left-width: 0;\
border-bottom: 1px solid;\
}\
.ace_hidden-cursors .ace_cursor {\
opacity: 0.2;\
}\
.ace_smooth-blinking .ace_cursor {\
-webkit-transition: opacity 0.18s;\
transition: opacity 0.18s;\
}\
.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\
position: absolute;\
z-index: 3;\
}\
.ace_marker-layer .ace_selection {\
position: absolute;\
z-index: 5;\
}\
.ace_marker-layer .ace_bracket {\
position: absolute;\
z-index: 6;\
}\
.ace_marker-layer .ace_active-line {\
position: absolute;\
z-index: 2;\
}\
.ace_marker-layer .ace_selected-word {\
position: absolute;\
z-index: 4;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
}\
.ace_line .ace_fold {\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
display: inline-block;\
height: 11px;\
margin-top: -2px;\
vertical-align: middle;\
background-image:\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=\");\
background-repeat: no-repeat, repeat-x;\
background-position: center center, top left;\
color: transparent;\
border: 1px solid black;\
border-radius: 2px;\
cursor: pointer;\
pointer-events: auto;\
}\
.ace_dark .ace_fold {\
}\
.ace_fold:hover{\
background-image:\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),\
url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC\");\
}\
.ace_tooltip {\
background-color: #FFF;\
background-image: -webkit-linear-gradient(top, transparent, rgba(0, 0, 0, 0.1));\
background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));\
border: 1px solid gray;\
border-radius: 1px;\
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\
color: black;\
max-width: 100%;\
padding: 3px 4px;\
position: fixed;\
z-index: 999999;\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
cursor: default;\
white-space: pre;\
word-wrap: break-word;\
line-height: normal;\
font-style: normal;\
font-weight: normal;\
letter-spacing: normal;\
pointer-events: none;\
}\
.ace_folding-enabled > .ace_gutter-cell {\
padding-right: 13px;\
}\
.ace_fold-widget {\
-moz-box-sizing: border-box;\
-webkit-box-sizing: border-box;\
box-sizing: border-box;\
margin: 0 -12px 0 1px;\
display: none;\
width: 11px;\
vertical-align: top;\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==\");\
background-repeat: no-repeat;\
background-position: center;\
border-radius: 3px;\
border: 1px solid transparent;\
cursor: pointer;\
}\
.ace_folding-enabled .ace_fold-widget {\
display: inline-block;   \
}\
.ace_fold-widget.ace_end {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==\");\
}\
.ace_fold-widget.ace_closed {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==\");\
}\
.ace_fold-widget:hover {\
border: 1px solid rgba(0, 0, 0, 0.3);\
background-color: rgba(255, 255, 255, 0.2);\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\
}\
.ace_fold-widget:active {\
border: 1px solid rgba(0, 0, 0, 0.4);\
background-color: rgba(0, 0, 0, 0.05);\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\
}\
.ace_dark .ace_fold-widget {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC\");\
}\
.ace_dark .ace_fold-widget.ace_end {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==\");\
}\
.ace_dark .ace_fold-widget.ace_closed {\
background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==\");\
}\
.ace_dark .ace_fold-widget:hover {\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
background-color: rgba(255, 255, 255, 0.1);\
}\
.ace_dark .ace_fold-widget:active {\
box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\
}\
.ace_fold-widget.ace_invalid {\
background-color: #FFB4B4;\
border-color: #DE5555;\
}\
.ace_fade-fold-widgets .ace_fold-widget {\
-webkit-transition: opacity 0.4s ease 0.05s;\
transition: opacity 0.4s ease 0.05s;\
opacity: 0;\
}\
.ace_fade-fold-widgets:hover .ace_fold-widget {\
-webkit-transition: opacity 0.05s ease 0.05s;\
transition: opacity 0.05s ease 0.05s;\
opacity:1;\
}\
.ace_underline {\
text-decoration: underline;\
}\
.ace_bold {\
font-weight: bold;\
}\
.ace_nobold .ace_bold {\
font-weight: normal;\
}\
.ace_italic {\
font-style: italic;\
}\
.ace_error-marker {\
background-color: rgba(255, 0, 0,0.2);\
position: absolute;\
z-index: 9;\
}\
.ace_highlight-marker {\
background-color: rgba(255, 255, 0,0.2);\
position: absolute;\
z-index: 8;\
}\
.ace_br1 {border-top-left-radius    : 3px;}\
.ace_br2 {border-top-right-radius   : 3px;}\
.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\
.ace_br4 {border-bottom-right-radius: 3px;}\
.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\
.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\
.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\
.ace_br8 {border-bottom-left-radius : 3px;}\
.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\
.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\
.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\
.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\
.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\
.ace_text-input-ios {\
position: absolute !important;\
top: -100000px !important;\
left: -100000px !important;\
}\
";

dom.importCssString(editorCss, "ace_editor.css");

var VirtualRenderer = function(container, theme) {
    var _self = this;

    this.container = container || dom.createElement("div");
    this.$keepTextAreaAtCursor = !useragent.isOldIE;

    dom.addCssClass(this.container, "ace_editor");

    this.setTheme(theme);

    this.$gutter = dom.createElement("div");
    this.$gutter.className = "ace_gutter";
    this.container.appendChild(this.$gutter);
    this.$gutter.setAttribute("aria-hidden", true);

    this.scroller = dom.createElement("div");
    this.scroller.className = "ace_scroller";
    this.container.appendChild(this.scroller);

    this.content = dom.createElement("div");
    this.content.className = "ace_content";
    this.scroller.appendChild(this.content);

    this.$gutterLayer = new GutterLayer(this.$gutter);
    this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this));

    this.$markerBack = new MarkerLayer(this.content);

    var textLayer = this.$textLayer = new TextLayer(this.content);
    this.canvas = textLayer.element;

    this.$markerFront = new MarkerLayer(this.content);

    this.$cursorLayer = new CursorLayer(this.content);
    this.$horizScroll = false;
    this.$vScroll = false;

    this.scrollBar = 
    this.scrollBarV = new VScrollBar(this.container, this);
    this.scrollBarH = new HScrollBar(this.container, this);
    this.scrollBarV.addEventListener("scroll", function(e) {
        if (!_self.$scrollAnimation)
            _self.session.setScrollTop(e.data - _self.scrollMargin.top);
    });
    this.scrollBarH.addEventListener("scroll", function(e) {
        if (!_self.$scrollAnimation)
            _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
    });

    this.scrollTop = 0;
    this.scrollLeft = 0;

    this.cursorPos = {
        row : 0,
        column : 0
    };

    this.$fontMetrics = new FontMetrics(this.container);
    this.$textLayer.$setFontMetrics(this.$fontMetrics);
    this.$textLayer.addEventListener("changeCharacterSize", function(e) {
        _self.updateCharacterSize();
        _self.onResize(true, _self.gutterWidth, _self.$size.width, _self.$size.height);
        _self._signal("changeCharacterSize", e);
    });

    this.$size = {
        width: 0,
        height: 0,
        scrollerHeight: 0,
        scrollerWidth: 0,
        $dirty: true
    };

    this.layerConfig = {
        width : 1,
        padding : 0,
        firstRow : 0,
        firstRowScreen: 0,
        lastRow : 0,
        lineHeight : 0,
        characterWidth : 0,
        minHeight : 1,
        maxHeight : 1,
        offset : 0,
        height : 1,
        gutterOffset: 1
    };
    
    this.scrollMargin = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        v: 0,
        h: 0
    };

    this.$loop = new RenderLoop(
        this.$renderChanges.bind(this),
        this.container.ownerDocument.defaultView
    );
    this.$loop.schedule(this.CHANGE_FULL);

    this.updateCharacterSize();
    this.setPadding(4);
    config.resetOptions(this);
    config._emit("renderer", this);
};

(function() {

    this.CHANGE_CURSOR = 1;
    this.CHANGE_MARKER = 2;
    this.CHANGE_GUTTER = 4;
    this.CHANGE_SCROLL = 8;
    this.CHANGE_LINES = 16;
    this.CHANGE_TEXT = 32;
    this.CHANGE_SIZE = 64;
    this.CHANGE_MARKER_BACK = 128;
    this.CHANGE_MARKER_FRONT = 256;
    this.CHANGE_FULL = 512;
    this.CHANGE_H_SCROLL = 1024;

    oop.implement(this, EventEmitter);

    this.updateCharacterSize = function() {
        if (this.$textLayer.allowBoldFonts != this.$allowBoldFonts) {
            this.$allowBoldFonts = this.$textLayer.allowBoldFonts;
            this.setStyle("ace_nobold", !this.$allowBoldFonts);
        }

        this.layerConfig.characterWidth =
        this.characterWidth = this.$textLayer.getCharacterWidth();
        this.layerConfig.lineHeight =
        this.lineHeight = this.$textLayer.getLineHeight();
        this.$updatePrintMargin();
    };
    this.setSession = function(session) {
        if (this.session)
            this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode);
            
        this.session = session;
        if (session && this.scrollMargin.top && session.getScrollTop() <= 0)
            session.setScrollTop(-this.scrollMargin.top);

        this.$cursorLayer.setSession(session);
        this.$markerBack.setSession(session);
        this.$markerFront.setSession(session);
        this.$gutterLayer.setSession(session);
        this.$textLayer.setSession(session);
        if (!session)
            return;
        
        this.$loop.schedule(this.CHANGE_FULL);
        this.session.$setFontMetrics(this.$fontMetrics);
        this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null;
        
        this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this);
        this.onChangeNewLineMode();
        this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode);
    };
    this.updateLines = function(firstRow, lastRow, force) {
        if (lastRow === undefined)
            lastRow = Infinity;

        if (!this.$changedLines) {
            this.$changedLines = {
                firstRow: firstRow,
                lastRow: lastRow
            };
        }
        else {
            if (this.$changedLines.firstRow > firstRow)
                this.$changedLines.firstRow = firstRow;

            if (this.$changedLines.lastRow < lastRow)
                this.$changedLines.lastRow = lastRow;
        }
        if (this.$changedLines.lastRow < this.layerConfig.firstRow) {
            if (force)
                this.$changedLines.lastRow = this.layerConfig.lastRow;
            else
                return;
        }
        if (this.$changedLines.firstRow > this.layerConfig.lastRow)
            return;
        this.$loop.schedule(this.CHANGE_LINES);
    };

    this.onChangeNewLineMode = function() {
        this.$loop.schedule(this.CHANGE_TEXT);
        this.$textLayer.$updateEolChar();
        this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);
    };
    
    this.onChangeTabSize = function() {
        this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER);
        this.$textLayer.onChangeTabSize();
    };
    this.updateText = function() {
        this.$loop.schedule(this.CHANGE_TEXT);
    };
    this.updateFull = function(force) {
        if (force)
            this.$renderChanges(this.CHANGE_FULL, true);
        else
            this.$loop.schedule(this.CHANGE_FULL);
    };
    this.updateFontSize = function() {
        this.$textLayer.checkForSizeChanges();
    };

    this.$changes = 0;
    this.$updateSizeAsync = function() {
        if (this.$loop.pending)
            this.$size.$dirty = true;
        else
            this.onResize();
    };
    this.onResize = function(force, gutterWidth, width, height) {
        if (this.resizing > 2)
            return;
        else if (this.resizing > 0)
            this.resizing++;
        else
            this.resizing = force ? 1 : 0;
        var el = this.container;
        if (!height)
            height = el.clientHeight || el.scrollHeight;
        if (!width)
            width = el.clientWidth || el.scrollWidth;
        var changes = this.$updateCachedSize(force, gutterWidth, width, height);

        
        if (!this.$size.scrollerHeight || (!width && !height))
            return this.resizing = 0;

        if (force)
            this.$gutterLayer.$padding = null;

        if (force)
            this.$renderChanges(changes | this.$changes, true);
        else
            this.$loop.schedule(changes | this.$changes);

        if (this.resizing)
            this.resizing = 0;
        this.scrollBarV.scrollLeft = this.scrollBarV.scrollTop = null;
    };
    
    this.$updateCachedSize = function(force, gutterWidth, width, height) {
        height -= (this.$extraHeight || 0);
        var changes = 0;
        var size = this.$size;
        var oldSize = {
            width: size.width,
            height: size.height,
            scrollerHeight: size.scrollerHeight,
            scrollerWidth: size.scrollerWidth
        };
        if (height && (force || size.height != height)) {
            size.height = height;
            changes |= this.CHANGE_SIZE;

            size.scrollerHeight = size.height;
            if (this.$horizScroll)
                size.scrollerHeight -= this.scrollBarH.getHeight();
            this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px";

            changes = changes | this.CHANGE_SCROLL;
        }

        if (width && (force || size.width != width)) {
            changes |= this.CHANGE_SIZE;
            size.width = width;
            
            if (gutterWidth == null)
                gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
            
            this.gutterWidth = gutterWidth;
            
            this.scrollBarH.element.style.left = 
            this.scroller.style.left = gutterWidth + "px";
            size.scrollerWidth = Math.max(0, width - gutterWidth - this.scrollBarV.getWidth());           
            
            this.scrollBarH.element.style.right = 
            this.scroller.style.right = this.scrollBarV.getWidth() + "px";
            this.scroller.style.bottom = this.scrollBarH.getHeight() + "px";

            if (this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || force)
                changes |= this.CHANGE_FULL;
        }
        
        size.$dirty = !width || !height;

        if (changes)
            this._signal("resize", oldSize);

        return changes;
    };

    this.onGutterResize = function() {
        var gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
        if (gutterWidth != this.gutterWidth)
            this.$changes |= this.$updateCachedSize(true, gutterWidth, this.$size.width, this.$size.height);

        if (this.session.getUseWrapMode() && this.adjustWrapLimit()) {
            this.$loop.schedule(this.CHANGE_FULL);
        } else if (this.$size.$dirty) {
            this.$loop.schedule(this.CHANGE_FULL);
        } else {
            this.$computeLayerConfig();
            this.$loop.schedule(this.CHANGE_MARKER);
        }
    };
    this.adjustWrapLimit = function() {
        var availableWidth = this.$size.scrollerWidth - this.$padding * 2;
        var limit = Math.floor(availableWidth / this.characterWidth);
        return this.session.adjustWrapLimit(limit, this.$showPrintMargin && this.$printMarginColumn);
    };
    this.setAnimatedScroll = function(shouldAnimate){
        this.setOption("animatedScroll", shouldAnimate);
    };
    this.getAnimatedScroll = function() {
        return this.$animatedScroll;
    };
    this.setShowInvisibles = function(showInvisibles) {
        this.setOption("showInvisibles", showInvisibles);
        this.session.$bidiHandler.setShowInvisibles(showInvisibles);
    };
    this.getShowInvisibles = function() {
        return this.getOption("showInvisibles");
    };
    this.getDisplayIndentGuides = function() {
        return this.getOption("displayIndentGuides");
    };

    this.setDisplayIndentGuides = function(display) {
        this.setOption("displayIndentGuides", display);
    };
    this.setShowPrintMargin = function(showPrintMargin) {
        this.setOption("showPrintMargin", showPrintMargin);
    };
    this.getShowPrintMargin = function() {
        return this.getOption("showPrintMargin");
    };
    this.setPrintMarginColumn = function(showPrintMargin) {
        this.setOption("printMarginColumn", showPrintMargin);
    };
    this.getPrintMarginColumn = function() {
        return this.getOption("printMarginColumn");
    };
    this.getShowGutter = function(){
        return this.getOption("showGutter");
    };
    this.setShowGutter = function(show){
        return this.setOption("showGutter", show);
    };

    this.getFadeFoldWidgets = function(){
        return this.getOption("fadeFoldWidgets");
    };

    this.setFadeFoldWidgets = function(show) {
        this.setOption("fadeFoldWidgets", show);
    };

    this.setHighlightGutterLine = function(shouldHighlight) {
        this.setOption("highlightGutterLine", shouldHighlight);
    };

    this.getHighlightGutterLine = function() {
        return this.getOption("highlightGutterLine");
    };

    this.$updateGutterLineHighlight = function() {
        var pos = this.$cursorLayer.$pixelPos;
        var height = this.layerConfig.lineHeight;
        if (this.session.getUseWrapMode()) {
            var cursor = this.session.selection.getCursor();
            cursor.column = 0;
            pos = this.$cursorLayer.getPixelPosition(cursor, true);
            height *= this.session.getRowLength(cursor.row);
        }
        this.$gutterLineHighlight.style.top = pos.top - this.layerConfig.offset + "px";
        this.$gutterLineHighlight.style.height = height + "px";
    };

    this.$updatePrintMargin = function() {
        if (!this.$showPrintMargin && !this.$printMarginEl)
            return;

        if (!this.$printMarginEl) {
            var containerEl = dom.createElement("div");
            containerEl.className = "ace_layer ace_print-margin-layer";
            this.$printMarginEl = dom.createElement("div");
            this.$printMarginEl.className = "ace_print-margin";
            containerEl.appendChild(this.$printMarginEl);
            this.content.insertBefore(containerEl, this.content.firstChild);
        }

        var style = this.$printMarginEl.style;
        style.left = ((this.characterWidth * this.$printMarginColumn) + this.$padding) + "px";
        style.visibility = this.$showPrintMargin ? "visible" : "hidden";
        
        if (this.session && this.session.$wrap == -1)
            this.adjustWrapLimit();
    };
    this.getContainerElement = function() {
        return this.container;
    };
    this.getMouseEventTarget = function() {
        return this.scroller;
    };
    this.getTextAreaContainer = function() {
        return this.container;
    };
    this.$moveTextAreaToCursor = function() {
        if (!this.$keepTextAreaAtCursor)
            return;
        var config = this.layerConfig;
        var posTop = this.$cursorLayer.$pixelPos.top;
        var posLeft = this.$cursorLayer.$pixelPos.left;
        posTop -= config.offset;

        var style = this.textarea.style;
        var h = this.lineHeight;
        if (posTop < 0 || posTop > config.height - h) {
            style.top = style.left = "0";
            return;
        }

        var w = this.characterWidth;
        if (this.$composition) {
            var val = this.textarea.value.replace(/^\x01+/, "");
            w *= (this.session.$getStringScreenWidth(val)[0]+2);
            h += 2;
        }
        posLeft -= this.scrollLeft;
        if (posLeft > this.$size.scrollerWidth - w)
            posLeft = this.$size.scrollerWidth - w;

        posLeft += this.gutterWidth;
        style.height = h + "px";
        style.width = w + "px";
        style.left = Math.min(posLeft, this.$size.scrollerWidth - w) + "px";
        style.top = Math.min(posTop, this.$size.height - h) + "px";
    };
    this.getFirstVisibleRow = function() {
        return this.layerConfig.firstRow;
    };
    this.getFirstFullyVisibleRow = function() {
        return this.layerConfig.firstRow + (this.layerConfig.offset === 0 ? 0 : 1);
    };
    this.getLastFullyVisibleRow = function() {
        var config = this.layerConfig;
        var lastRow = config.lastRow;
        var top = this.session.documentToScreenRow(lastRow, 0) * config.lineHeight;
        if (top - this.session.getScrollTop() > config.height - config.lineHeight)
            return lastRow - 1;
        return lastRow;
    };
    this.getLastVisibleRow = function() {
        return this.layerConfig.lastRow;
    };

    this.$padding = null;
    this.setPadding = function(padding) {
        this.$padding = padding;
        this.$textLayer.setPadding(padding);
        this.$cursorLayer.setPadding(padding);
        this.$markerFront.setPadding(padding);
        this.$markerBack.setPadding(padding);
        this.$loop.schedule(this.CHANGE_FULL);
        this.$updatePrintMargin();
    };
    
    this.setScrollMargin = function(top, bottom, left, right) {
        var sm = this.scrollMargin;
        sm.top = top|0;
        sm.bottom = bottom|0;
        sm.right = right|0;
        sm.left = left|0;
        sm.v = sm.top + sm.bottom;
        sm.h = sm.left + sm.right;
        if (sm.top && this.scrollTop <= 0 && this.session)
            this.session.setScrollTop(-sm.top);
        this.updateFull();
    };
    this.getHScrollBarAlwaysVisible = function() {
        return this.$hScrollBarAlwaysVisible;
    };
    this.setHScrollBarAlwaysVisible = function(alwaysVisible) {
        this.setOption("hScrollBarAlwaysVisible", alwaysVisible);
    };
    this.getVScrollBarAlwaysVisible = function() {
        return this.$vScrollBarAlwaysVisible;
    };
    this.setVScrollBarAlwaysVisible = function(alwaysVisible) {
        this.setOption("vScrollBarAlwaysVisible", alwaysVisible);
    };

    this.$updateScrollBarV = function() {
        var scrollHeight = this.layerConfig.maxHeight;
        var scrollerHeight = this.$size.scrollerHeight;
        if (!this.$maxLines && this.$scrollPastEnd) {
            scrollHeight -= (scrollerHeight - this.lineHeight) * this.$scrollPastEnd;
            if (this.scrollTop > scrollHeight - scrollerHeight) {
                scrollHeight = this.scrollTop + scrollerHeight;
                this.scrollBarV.scrollTop = null;
            }
        }
        this.scrollBarV.setScrollHeight(scrollHeight + this.scrollMargin.v);
        this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
    };
    this.$updateScrollBarH = function() {
        this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h);
        this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
    };
    
    this.$frozen = false;
    this.freeze = function() {
        this.$frozen = true;
    };
    
    this.unfreeze = function() {
        this.$frozen = false;
    };

    this.$renderChanges = function(changes, force) {
        if (this.$changes) {
            changes |= this.$changes;
            this.$changes = 0;
        }
        if ((!this.session || !this.container.offsetWidth || this.$frozen) || (!changes && !force)) {
            this.$changes |= changes;
            return; 
        } 
        if (this.$size.$dirty) {
            this.$changes |= changes;
            return this.onResize(true);
        }
        if (!this.lineHeight) {
            this.$textLayer.checkForSizeChanges();
        }
        
        this._signal("beforeRender");

        if (this.session && this.session.$bidiHandler)
            this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);

        var config = this.layerConfig;
        if (changes & this.CHANGE_FULL ||
            changes & this.CHANGE_SIZE ||
            changes & this.CHANGE_TEXT ||
            changes & this.CHANGE_LINES ||
            changes & this.CHANGE_SCROLL ||
            changes & this.CHANGE_H_SCROLL
        ) {
            changes |= this.$computeLayerConfig();
            if (config.firstRow != this.layerConfig.firstRow && config.firstRowScreen == this.layerConfig.firstRowScreen) {
                var st = this.scrollTop + (config.firstRow - this.layerConfig.firstRow) * this.lineHeight;
                if (st > 0) {
                    this.scrollTop = st;
                    changes = changes | this.CHANGE_SCROLL;
                    changes |= this.$computeLayerConfig();
                }
            }
            config = this.layerConfig;
            this.$updateScrollBarV();
            if (changes & this.CHANGE_H_SCROLL)
                this.$updateScrollBarH();
            this.$gutterLayer.element.style.marginTop = (-config.offset) + "px";
            this.content.style.marginTop = (-config.offset) + "px";
            this.content.style.width = config.width + 2 * this.$padding + "px";
            this.content.style.height = config.minHeight + "px";
        }
        if (changes & this.CHANGE_H_SCROLL) {
            this.content.style.marginLeft = -this.scrollLeft + "px";
            this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller" : "ace_scroller ace_scroll-left";
        }
        if (changes & this.CHANGE_FULL) {
            this.$textLayer.update(config);
            if (this.$showGutter)
                this.$gutterLayer.update(config);
            this.$markerBack.update(config);
            this.$markerFront.update(config);
            this.$cursorLayer.update(config);
            this.$moveTextAreaToCursor();
            this.$highlightGutterLine && this.$updateGutterLineHighlight();
            this._signal("afterRender");
            return;
        }
        if (changes & this.CHANGE_SCROLL) {
            if (changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES)
                this.$textLayer.update(config);
            else
                this.$textLayer.scrollLines(config);

            if (this.$showGutter)
                this.$gutterLayer.update(config);
            this.$markerBack.update(config);
            this.$markerFront.update(config);
            this.$cursorLayer.update(config);
            this.$highlightGutterLine && this.$updateGutterLineHighlight();
            this.$moveTextAreaToCursor();
            this._signal("afterRender");
            return;
        }

        if (changes & this.CHANGE_TEXT) {
            this.$textLayer.update(config);
            if (this.$showGutter)
                this.$gutterLayer.update(config);
        }
        else if (changes & this.CHANGE_LINES) {
            if (this.$updateLines() || (changes & this.CHANGE_GUTTER) && this.$showGutter)
                this.$gutterLayer.update(config);
        }
        else if (changes & this.CHANGE_TEXT || changes & this.CHANGE_GUTTER) {
            if (this.$showGutter)
                this.$gutterLayer.update(config);
        }

        if (changes & this.CHANGE_CURSOR) {
            this.$cursorLayer.update(config);
            this.$moveTextAreaToCursor();
            this.$highlightGutterLine && this.$updateGutterLineHighlight();
        }

        if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT)) {
            this.$markerFront.update(config);
        }

        if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK)) {
            this.$markerBack.update(config);
        }

        this._signal("afterRender");
    };

    
    this.$autosize = function() {
        var height = this.session.getScreenLength() * this.lineHeight;
        var maxHeight = this.$maxLines * this.lineHeight;
        var desiredHeight = Math.min(maxHeight,
            Math.max((this.$minLines || 1) * this.lineHeight, height)
        ) + this.scrollMargin.v + (this.$extraHeight || 0);
        if (this.$horizScroll)
            desiredHeight += this.scrollBarH.getHeight();
        if (this.$maxPixelHeight && desiredHeight > this.$maxPixelHeight)
            desiredHeight = this.$maxPixelHeight;
        var vScroll = height > maxHeight;
        
        if (desiredHeight != this.desiredHeight ||
            this.$size.height != this.desiredHeight || vScroll != this.$vScroll) {
            if (vScroll != this.$vScroll) {
                this.$vScroll = vScroll;
                this.scrollBarV.setVisible(vScroll);
            }
            
            var w = this.container.clientWidth;
            this.container.style.height = desiredHeight + "px";
            this.$updateCachedSize(true, this.$gutterWidth, w, desiredHeight);
            this.desiredHeight = desiredHeight;
            
            this._signal("autosize");
        }
    };
    
    this.$computeLayerConfig = function() {
        var session = this.session;
        var size = this.$size;
        
        var hideScrollbars = size.height <= 2 * this.lineHeight;
        var screenLines = this.session.getScreenLength();
        var maxHeight = screenLines * this.lineHeight;

        var longestLine = this.$getLongestLine();
        
        var horizScroll = !hideScrollbars && (this.$hScrollBarAlwaysVisible ||
            size.scrollerWidth - longestLine - 2 * this.$padding < 0);

        var hScrollChanged = this.$horizScroll !== horizScroll;
        if (hScrollChanged) {
            this.$horizScroll = horizScroll;
            this.scrollBarH.setVisible(horizScroll);
        }
        var vScrollBefore = this.$vScroll; // autosize can change vscroll value in which case we need to update longestLine
        if (this.$maxLines && this.lineHeight > 1)
            this.$autosize();

        var offset = this.scrollTop % this.lineHeight;
        var minHeight = size.scrollerHeight + this.lineHeight;
        
        var scrollPastEnd = !this.$maxLines && this.$scrollPastEnd
            ? (size.scrollerHeight - this.lineHeight) * this.$scrollPastEnd
            : 0;
        maxHeight += scrollPastEnd;
        
        var sm = this.scrollMargin;
        this.session.setScrollTop(Math.max(-sm.top,
            Math.min(this.scrollTop, maxHeight - size.scrollerHeight + sm.bottom)));

        this.session.setScrollLeft(Math.max(-sm.left, Math.min(this.scrollLeft, 
            longestLine + 2 * this.$padding - size.scrollerWidth + sm.right)));
        
        var vScroll = !hideScrollbars && (this.$vScrollBarAlwaysVisible ||
            size.scrollerHeight - maxHeight + scrollPastEnd < 0 || this.scrollTop > sm.top);
        var vScrollChanged = vScrollBefore !== vScroll;
        if (vScrollChanged) {
            this.$vScroll = vScroll;
            this.scrollBarV.setVisible(vScroll);
        }

        var lineCount = Math.ceil(minHeight / this.lineHeight) - 1;
        var firstRow = Math.max(0, Math.round((this.scrollTop - offset) / this.lineHeight));
        var lastRow = firstRow + lineCount;
        var firstRowScreen, firstRowHeight;
        var lineHeight = this.lineHeight;
        firstRow = session.screenToDocumentRow(firstRow, 0);
        var foldLine = session.getFoldLine(firstRow);
        if (foldLine) {
            firstRow = foldLine.start.row;
        }

        firstRowScreen = session.documentToScreenRow(firstRow, 0);
        firstRowHeight = session.getRowLength(firstRow) * lineHeight;

        lastRow = Math.min(session.screenToDocumentRow(lastRow, 0), session.getLength() - 1);
        minHeight = size.scrollerHeight + session.getRowLength(lastRow) * lineHeight +
                                                firstRowHeight;

        offset = this.scrollTop - firstRowScreen * lineHeight;

        var changes = 0;
        if (this.layerConfig.width != longestLine) 
            changes = this.CHANGE_H_SCROLL;
        if (hScrollChanged || vScrollChanged) {
            changes = this.$updateCachedSize(true, this.gutterWidth, size.width, size.height);
            this._signal("scrollbarVisibilityChanged");
            if (vScrollChanged)
                longestLine = this.$getLongestLine();
        }
        
        this.layerConfig = {
            width : longestLine,
            padding : this.$padding,
            firstRow : firstRow,
            firstRowScreen: firstRowScreen,
            lastRow : lastRow,
            lineHeight : lineHeight,
            characterWidth : this.characterWidth,
            minHeight : minHeight,
            maxHeight : maxHeight,
            offset : offset,
            gutterOffset : lineHeight ? Math.max(0, Math.ceil((offset + size.height - size.scrollerHeight) / lineHeight)) : 0,
            height : this.$size.scrollerHeight
        };

        return changes;
    };

    this.$updateLines = function() {
        if (!this.$changedLines) return;
        var firstRow = this.$changedLines.firstRow;
        var lastRow = this.$changedLines.lastRow;
        this.$changedLines = null;

        var layerConfig = this.layerConfig;

        if (firstRow > layerConfig.lastRow + 1) { return; }
        if (lastRow < layerConfig.firstRow) { return; }
        if (lastRow === Infinity) {
            if (this.$showGutter)
                this.$gutterLayer.update(layerConfig);
            this.$textLayer.update(layerConfig);
            return;
        }
        this.$textLayer.updateLines(layerConfig, firstRow, lastRow);
        return true;
    };

    this.$getLongestLine = function() {
        var charCount = this.session.getScreenWidth();
        if (this.showInvisibles && !this.session.$useWrapMode)
            charCount += 1;

        return Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(charCount * this.characterWidth));
    };
    this.updateFrontMarkers = function() {
        this.$markerFront.setMarkers(this.session.getMarkers(true));
        this.$loop.schedule(this.CHANGE_MARKER_FRONT);
    };
    this.updateBackMarkers = function() {
        this.$markerBack.setMarkers(this.session.getMarkers());
        this.$loop.schedule(this.CHANGE_MARKER_BACK);
    };
    this.addGutterDecoration = function(row, className){
        this.$gutterLayer.addGutterDecoration(row, className);
    };
    this.removeGutterDecoration = function(row, className){
        this.$gutterLayer.removeGutterDecoration(row, className);
    };
    this.updateBreakpoints = function(rows) {
        this.$loop.schedule(this.CHANGE_GUTTER);
    };
    this.setAnnotations = function(annotations) {
        this.$gutterLayer.setAnnotations(annotations);
        this.$loop.schedule(this.CHANGE_GUTTER);
    };
    this.updateCursor = function() {
        this.$loop.schedule(this.CHANGE_CURSOR);
    };
    this.hideCursor = function() {
        this.$cursorLayer.hideCursor();
    };
    this.showCursor = function() {
        this.$cursorLayer.showCursor();
    };

    this.scrollSelectionIntoView = function(anchor, lead, offset) {
        this.scrollCursorIntoView(anchor, offset);
        this.scrollCursorIntoView(lead, offset);
    };
    this.scrollCursorIntoView = function(cursor, offset, $viewMargin) {
        if (this.$size.scrollerHeight === 0)
            return;

        var pos = this.$cursorLayer.getPixelPosition(cursor);

        var left = pos.left;
        var top = pos.top;
        
        var topMargin = $viewMargin && $viewMargin.top || 0;
        var bottomMargin = $viewMargin && $viewMargin.bottom || 0;
        
        var scrollTop = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop;
        
        if (scrollTop + topMargin > top) {
            if (offset && scrollTop + topMargin > top + this.lineHeight)
                top -= offset * this.$size.scrollerHeight;
            if (top === 0)
                top = -this.scrollMargin.top;
            this.session.setScrollTop(top);
        } else if (scrollTop + this.$size.scrollerHeight - bottomMargin < top + this.lineHeight) {
            if (offset && scrollTop + this.$size.scrollerHeight - bottomMargin < top -  this.lineHeight)
                top += offset * this.$size.scrollerHeight;
            this.session.setScrollTop(top + this.lineHeight - this.$size.scrollerHeight);
        }

        var scrollLeft = this.scrollLeft;

        if (scrollLeft > left) {
            if (left < this.$padding + 2 * this.layerConfig.characterWidth)
                left = -this.scrollMargin.left;
            this.session.setScrollLeft(left);
        } else if (scrollLeft + this.$size.scrollerWidth < left + this.characterWidth) {
            this.session.setScrollLeft(Math.round(left + this.characterWidth - this.$size.scrollerWidth));
        } else if (scrollLeft <= this.$padding && left - scrollLeft < this.characterWidth) {
            this.session.setScrollLeft(0);
        }
    };
    this.getScrollTop = function() {
        return this.session.getScrollTop();
    };
    this.getScrollLeft = function() {
        return this.session.getScrollLeft();
    };
    this.getScrollTopRow = function() {
        return this.scrollTop / this.lineHeight;
    };
    this.getScrollBottomRow = function() {
        return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
    };
    this.scrollToRow = function(row) {
        this.session.setScrollTop(row * this.lineHeight);
    };

    this.alignCursor = function(cursor, alignment) {
        if (typeof cursor == "number")
            cursor = {row: cursor, column: 0};

        var pos = this.$cursorLayer.getPixelPosition(cursor);
        var h = this.$size.scrollerHeight - this.lineHeight;
        var offset = pos.top - h * (alignment || 0);

        this.session.setScrollTop(offset);
        return offset;
    };

    this.STEPS = 8;
    this.$calcSteps = function(fromValue, toValue){
        var i = 0;
        var l = this.STEPS;
        var steps = [];

        var func  = function(t, x_min, dx) {
            return dx * (Math.pow(t - 1, 3) + 1) + x_min;
        };

        for (i = 0; i < l; ++i)
            steps.push(func(i / this.STEPS, fromValue, toValue - fromValue));

        return steps;
    };
    this.scrollToLine = function(line, center, animate, callback) {
        var pos = this.$cursorLayer.getPixelPosition({row: line, column: 0});
        var offset = pos.top;
        if (center)
            offset -= this.$size.scrollerHeight / 2;

        var initialScroll = this.scrollTop;
        this.session.setScrollTop(offset);
        if (animate !== false)
            this.animateScrolling(initialScroll, callback);
    };

    this.animateScrolling = function(fromValue, callback) {
        var toValue = this.scrollTop;
        if (!this.$animatedScroll)
            return;
        var _self = this;
        
        if (fromValue == toValue)
            return;
        
        if (this.$scrollAnimation) {
            var oldSteps = this.$scrollAnimation.steps;
            if (oldSteps.length) {
                fromValue = oldSteps[0];
                if (fromValue == toValue)
                    return;
            }
        }
        
        var steps = _self.$calcSteps(fromValue, toValue);
        this.$scrollAnimation = {from: fromValue, to: toValue, steps: steps};

        clearInterval(this.$timer);

        _self.session.setScrollTop(steps.shift());
        _self.session.$scrollTop = toValue;
        this.$timer = setInterval(function() {
            if (steps.length) {
                _self.session.setScrollTop(steps.shift());
                _self.session.$scrollTop = toValue;
            } else if (toValue != null) {
                _self.session.$scrollTop = -1;
                _self.session.setScrollTop(toValue);
                toValue = null;
            } else {
                _self.$timer = clearInterval(_self.$timer);
                _self.$scrollAnimation = null;
                callback && callback();
            }
        }, 10);
    };
    this.scrollToY = function(scrollTop) {
        if (this.scrollTop !== scrollTop) {
            this.$loop.schedule(this.CHANGE_SCROLL);
            this.scrollTop = scrollTop;
        }
    };
    this.scrollToX = function(scrollLeft) {
        if (this.scrollLeft !== scrollLeft)
            this.scrollLeft = scrollLeft;
        this.$loop.schedule(this.CHANGE_H_SCROLL);
    };
    this.scrollTo = function(x, y) {
        this.session.setScrollTop(y);
        this.session.setScrollLeft(y);
    };
    this.scrollBy = function(deltaX, deltaY) {
        deltaY && this.session.setScrollTop(this.session.getScrollTop() + deltaY);
        deltaX && this.session.setScrollLeft(this.session.getScrollLeft() + deltaX);
    };
    this.isScrollableBy = function(deltaX, deltaY) {
        if (deltaY < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top)
           return true;
        if (deltaY > 0 && this.session.getScrollTop() + this.$size.scrollerHeight
            - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom)
           return true;
        if (deltaX < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left)
            return true;
        if (deltaX > 0 && this.session.getScrollLeft() + this.$size.scrollerWidth
            - this.layerConfig.width < -1 + this.scrollMargin.right)
           return true;
    };

    this.pixelToScreenCoordinates = function(x, y) {
        var canvasPos = this.scroller.getBoundingClientRect();

        var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
        var offset = offsetX / this.characterWidth;
        var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
        var col = Math.round(offset);

        return {row: row, column: col, side: offset - col > 0 ? 1 : -1, offsetX:  offsetX};
    };

    this.screenToTextCoordinates = function(x, y) {
        var canvasPos = this.scroller.getBoundingClientRect();
        var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;

        var col = Math.round(offsetX / this.characterWidth);

        var row = (y + this.scrollTop - canvasPos.top) / this.lineHeight;

        return this.session.screenToDocumentPosition(row, Math.max(col, 0), offsetX);
    };
    this.textToScreenCoordinates = function(row, column) {
        var canvasPos = this.scroller.getBoundingClientRect();
        var pos = this.session.documentToScreenPosition(row, column);

        var x = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, row)
             ? this.session.$bidiHandler.getPosLeft(pos.column)
             : Math.round(pos.column * this.characterWidth));

        var y = pos.row * this.lineHeight;

        return {
            pageX: canvasPos.left + x - this.scrollLeft,
            pageY: canvasPos.top + y - this.scrollTop
        };
    };
    this.visualizeFocus = function() {
        dom.addCssClass(this.container, "ace_focus");
    };
    this.visualizeBlur = function() {
        dom.removeCssClass(this.container, "ace_focus");
    };
    this.showComposition = function(position) {
        if (!this.$composition)
            this.$composition = {
                keepTextAreaAtCursor: this.$keepTextAreaAtCursor,
                cssText: this.textarea.style.cssText
            };

        this.$keepTextAreaAtCursor = true;
        dom.addCssClass(this.textarea, "ace_composition");
        this.textarea.style.cssText = "";
        this.$moveTextAreaToCursor();
    };
    this.setCompositionText = function(text) {
        this.$moveTextAreaToCursor();
    };
    this.hideComposition = function() {
        if (!this.$composition)
            return;

        dom.removeCssClass(this.textarea, "ace_composition");
        this.$keepTextAreaAtCursor = this.$composition.keepTextAreaAtCursor;
        this.textarea.style.cssText = this.$composition.cssText;
        this.$composition = null;
    };
    this.setTheme = function(theme, cb) {
        var _self = this;
        this.$themeId = theme;
        _self._dispatchEvent('themeChange',{theme:theme});

        if (!theme || typeof theme == "string") {
            var moduleName = theme || this.$options.theme.initialValue;
            config.loadModule(["theme", moduleName], afterLoad);
        } else {
            afterLoad(theme);
        }

        function afterLoad(module) {
            if (_self.$themeId != theme)
                return cb && cb();
            if (!module || !module.cssClass)
                throw new Error("couldn't load module " + theme + " or it didn't call define");
            dom.importCssString(
                module.cssText,
                module.cssClass,
                _self.container.ownerDocument
            );

            if (_self.theme)
                dom.removeCssClass(_self.container, _self.theme.cssClass);

            var padding = "padding" in module ? module.padding 
                : "padding" in (_self.theme || {}) ? 4 : _self.$padding;
            if (_self.$padding && padding != _self.$padding)
                _self.setPadding(padding);
            _self.$theme = module.cssClass;

            _self.theme = module;
            dom.addCssClass(_self.container, module.cssClass);
            dom.setCssClass(_self.container, "ace_dark", module.isDark);
            if (_self.$size) {
                _self.$size.width = 0;
                _self.$updateSizeAsync();
            }

            _self._dispatchEvent('themeLoaded', {theme:module});
            cb && cb();
        }
    };
    this.getTheme = function() {
        return this.$themeId;
    };
    this.setStyle = function(style, include) {
        dom.setCssClass(this.container, style, include !== false);
    };
    this.unsetStyle = function(style) {
        dom.removeCssClass(this.container, style);
    };
    
    this.setCursorStyle = function(style) {
        if (this.scroller.style.cursor != style)
            this.scroller.style.cursor = style;
    };
    this.setMouseCursor = function(cursorStyle) {
        this.scroller.style.cursor = cursorStyle;
    };
    this.destroy = function() {
        this.$textLayer.destroy();
        this.$cursorLayer.destroy();
    };

}).call(VirtualRenderer.prototype);


config.defineOptions(VirtualRenderer.prototype, "renderer", {
    animatedScroll: {initialValue: false},
    showInvisibles: {
        set: function(value) {
            if (this.$textLayer.setShowInvisibles(value))
                this.$loop.schedule(this.CHANGE_TEXT);
        },
        initialValue: false
    },
    showPrintMargin: {
        set: function() { this.$updatePrintMargin(); },
        initialValue: true
    },
    printMarginColumn: {
        set: function() { this.$updatePrintMargin(); },
        initialValue: 80
    },
    printMargin: {
        set: function(val) {
            if (typeof val == "number")
                this.$printMarginColumn = val;
            this.$showPrintMargin = !!val;
            this.$updatePrintMargin();
        },
        get: function() {
            return this.$showPrintMargin && this.$printMarginColumn; 
        }
    },
    showGutter: {
        set: function(show){
            this.$gutter.style.display = show ? "block" : "none";
            this.$loop.schedule(this.CHANGE_FULL);
            this.onGutterResize();
        },
        initialValue: true
    },
    fadeFoldWidgets: {
        set: function(show) {
            dom.setCssClass(this.$gutter, "ace_fade-fold-widgets", show);
        },
        initialValue: false
    },
    showFoldWidgets: {
        set: function(show) {this.$gutterLayer.setShowFoldWidgets(show);},
        initialValue: true
    },
    showLineNumbers: {
        set: function(show) {
            this.$gutterLayer.setShowLineNumbers(show);
            this.$loop.schedule(this.CHANGE_GUTTER);
        },
        initialValue: true
    },
    displayIndentGuides: {
        set: function(show) {
            if (this.$textLayer.setDisplayIndentGuides(show))
                this.$loop.schedule(this.CHANGE_TEXT);
        },
        initialValue: true
    },
    highlightGutterLine: {
        set: function(shouldHighlight) {
            if (!this.$gutterLineHighlight) {
                this.$gutterLineHighlight = dom.createElement("div");
                this.$gutterLineHighlight.className = "ace_gutter-active-line";
                this.$gutter.appendChild(this.$gutterLineHighlight);
                return;
            }

            this.$gutterLineHighlight.style.display = shouldHighlight ? "" : "none";
            if (this.$cursorLayer.$pixelPos)
                this.$updateGutterLineHighlight();
        },
        initialValue: false,
        value: true
    },
    hScrollBarAlwaysVisible: {
        set: function(val) {
            if (!this.$hScrollBarAlwaysVisible || !this.$horizScroll)
                this.$loop.schedule(this.CHANGE_SCROLL);
        },
        initialValue: false
    },
    vScrollBarAlwaysVisible: {
        set: function(val) {
            if (!this.$vScrollBarAlwaysVisible || !this.$vScroll)
                this.$loop.schedule(this.CHANGE_SCROLL);
        },
        initialValue: false
    },
    fontSize:  {
        set: function(size) {
            if (typeof size == "number")
                size = size + "px";
            this.container.style.fontSize = size;
            this.updateFontSize();
        },
        initialValue: 12
    },
    fontFamily: {
        set: function(name) {
            this.container.style.fontFamily = name;
            this.updateFontSize();
        }
    },
    maxLines: {
        set: function(val) {
            this.updateFull();
        }
    },
    minLines: {
        set: function(val) {
            this.updateFull();
        }
    },
    maxPixelHeight: {
        set: function(val) {
            this.updateFull();
        },
        initialValue: 0
    },
    scrollPastEnd: {
        set: function(val) {
            val = +val || 0;
            if (this.$scrollPastEnd == val)
                return;
            this.$scrollPastEnd = val;
            this.$loop.schedule(this.CHANGE_SCROLL);
        },
        initialValue: 0,
        handlesSet: true
    },
    fixedWidthGutter: {
        set: function(val) {
            this.$gutterLayer.$fixedWidth = !!val;
            this.$loop.schedule(this.CHANGE_GUTTER);
        }
    },
    theme: {
        set: function(val) { this.setTheme(val); },
        get: function() { return this.$themeId || this.theme; },
        initialValue: "./theme/textmate",
        handlesSet: true
    }
});

exports.VirtualRenderer = VirtualRenderer;
});

ace.define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var net = acequire("../lib/net");
var EventEmitter = acequire("../lib/event_emitter").EventEmitter;
var config = acequire("../config");

function $workerBlob(workerUrl, mod) {
    var script = mod.src;"importScripts('" + net.qualifyURL(workerUrl) + "');";
    try {
        return new Blob([script], {"type": "application/javascript"});
    } catch (e) { // Backwards-compatibility
        var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
        var blobBuilder = new BlobBuilder();
        blobBuilder.append(script);
        return blobBuilder.getBlob("application/javascript");
    }
}

function createWorker(workerUrl, mod) {
    var blob = $workerBlob(workerUrl, mod);
    var URL = window.URL || window.webkitURL;
    var blobURL = URL.createObjectURL(blob);
    return new Worker(blobURL);
}

var WorkerClient = function(topLevelNamespaces, mod, classname, workerUrl, importScripts) {
    this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.onMessage = this.onMessage.bind(this);
    if (acequire.nameToUrl && !acequire.toUrl)
        acequire.toUrl = acequire.nameToUrl;
    
    if (config.get("packaged") || !acequire.toUrl) {
        workerUrl = workerUrl || config.moduleUrl(mod.id, "worker");
    } else {
        var normalizePath = this.$normalizePath;
        workerUrl = workerUrl || normalizePath(acequire.toUrl("ace/worker/worker.js", null, "_"));

        var tlns = {};
        topLevelNamespaces.forEach(function(ns) {
            tlns[ns] = normalizePath(acequire.toUrl(ns, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
        });
    }

    this.$worker = createWorker(workerUrl, mod);
    if (importScripts) {
        this.send("importScripts", importScripts);
    }
    this.$worker.postMessage({
        init : true,
        tlns : tlns,
        module : mod.id,
        classname : classname
    });

    this.callbackId = 1;
    this.callbacks = {};

    this.$worker.onmessage = this.onMessage;
};

(function(){

    oop.implement(this, EventEmitter);

    this.onMessage = function(e) {
        var msg = e.data;
        switch (msg.type) {
            case "event":
                this._signal(msg.name, {data: msg.data});
                break;
            case "call":
                var callback = this.callbacks[msg.id];
                if (callback) {
                    callback(msg.data);
                    delete this.callbacks[msg.id];
                }
                break;
            case "error":
                this.reportError(msg.data);
                break;
            case "log":
                window.console && console.log && console.log.apply(console, msg.data);
                break;
        }
    };
    
    this.reportError = function(err) {
        window.console && console.error && console.error(err);
    };

    this.$normalizePath = function(path) {
        return net.qualifyURL(path);
    };

    this.terminate = function() {
        this._signal("terminate", {});
        this.deltaQueue = null;
        this.$worker.terminate();
        this.$worker = null;
        if (this.$doc)
            this.$doc.off("change", this.changeListener);
        this.$doc = null;
    };

    this.send = function(cmd, args) {
        this.$worker.postMessage({command: cmd, args: args});
    };

    this.call = function(cmd, args, callback) {
        if (callback) {
            var id = this.callbackId++;
            this.callbacks[id] = callback;
            args.push(id);
        }
        this.send(cmd, args);
    };

    this.emit = function(event, data) {
        try {
            this.$worker.postMessage({event: event, data: {data: data.data}});
        }
        catch(ex) {
            console.error(ex.stack);
        }
    };

    this.attachToDocument = function(doc) {
        if (this.$doc)
            this.terminate();

        this.$doc = doc;
        this.call("setValue", [doc.getValue()]);
        doc.on("change", this.changeListener);
    };

    this.changeListener = function(delta) {
        if (!this.deltaQueue) {
            this.deltaQueue = [];
            setTimeout(this.$sendDeltaQueue, 0);
        }
        if (delta.action == "insert")
            this.deltaQueue.push(delta.start, delta.lines);
        else
            this.deltaQueue.push(delta.start, delta.end);
    };

    this.$sendDeltaQueue = function() {
        var q = this.deltaQueue;
        if (!q) return;
        this.deltaQueue = null;
        if (q.length > 50 && q.length > this.$doc.getLength() >> 1) {
            this.call("setValue", [this.$doc.getValue()]);
        } else
            this.emit("change", {data: q});
    };

}).call(WorkerClient.prototype);


var UIWorkerClient = function(topLevelNamespaces, mod, classname) {
    this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.callbackId = 1;
    this.callbacks = {};
    this.messageBuffer = [];

    var main = null;
    var emitSync = false;
    var sender = Object.create(EventEmitter);
    var _self = this;

    this.$worker = {};
    this.$worker.terminate = function() {};
    this.$worker.postMessage = function(e) {
        _self.messageBuffer.push(e);
        if (main) {
            if (emitSync)
                setTimeout(processNext);
            else
                processNext();
        }
    };
    this.setEmitSync = function(val) { emitSync = val; };

    var processNext = function() {
        var msg = _self.messageBuffer.shift();
        if (msg.command)
            main[msg.command].apply(main, msg.args);
        else if (msg.event)
            sender._signal(msg.event, msg.data);
    };

    sender.postMessage = function(msg) {
        _self.onMessage({data: msg});
    };
    sender.callback = function(data, callbackId) {
        this.postMessage({type: "call", id: callbackId, data: data});
    };
    sender.emit = function(name, data) {
        this.postMessage({type: "event", name: name, data: data});
    };

    config.loadModule(["worker", mod], function(Main) {
        main = new Main[classname](sender);
        while (_self.messageBuffer.length)
            processNext();
    });
};

UIWorkerClient.prototype = WorkerClient.prototype;

exports.UIWorkerClient = UIWorkerClient;
exports.WorkerClient = WorkerClient;
exports.createWorker = createWorker;


});

ace.define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"], function(acequire, exports, module) {
"use strict";

var Range = acequire("./range").Range;
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var oop = acequire("./lib/oop");

var PlaceHolder = function(session, length, pos, others, mainClass, othersClass) {
    var _self = this;
    this.length = length;
    this.session = session;
    this.doc = session.getDocument();
    this.mainClass = mainClass;
    this.othersClass = othersClass;
    this.$onUpdate = this.onUpdate.bind(this);
    this.doc.on("change", this.$onUpdate);
    this.$others = others;
    
    this.$onCursorChange = function() {
        setTimeout(function() {
            _self.onCursorChange();
        });
    };
    
    this.$pos = pos;
    var undoStack = session.getUndoManager().$undoStack || session.getUndoManager().$undostack || {length: -1};
    this.$undoStackDepth = undoStack.length;
    this.setup();

    session.selection.on("changeCursor", this.$onCursorChange);
};

(function() {

    oop.implement(this, EventEmitter);
    this.setup = function() {
        var _self = this;
        var doc = this.doc;
        var session = this.session;
        
        this.selectionBefore = session.selection.toJSON();
        if (session.selection.inMultiSelectMode)
            session.selection.toSingleRange();

        this.pos = doc.createAnchor(this.$pos.row, this.$pos.column);
        var pos = this.pos;
        pos.$insertRight = true;
        pos.detach();
        pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + this.length), this.mainClass, null, false);
        this.others = [];
        this.$others.forEach(function(other) {
            var anchor = doc.createAnchor(other.row, other.column);
            anchor.$insertRight = true;
            anchor.detach();
            _self.others.push(anchor);
        });
        session.setUndoSelect(false);
    };
    this.showOtherMarkers = function() {
        if (this.othersActive) return;
        var session = this.session;
        var _self = this;
        this.othersActive = true;
        this.others.forEach(function(anchor) {
            anchor.markerId = session.addMarker(new Range(anchor.row, anchor.column, anchor.row, anchor.column+_self.length), _self.othersClass, null, false);
        });
    };
    this.hideOtherMarkers = function() {
        if (!this.othersActive) return;
        this.othersActive = false;
        for (var i = 0; i < this.others.length; i++) {
            this.session.removeMarker(this.others[i].markerId);
        }
    };
    this.onUpdate = function(delta) {
        if (this.$updating)
            return this.updateAnchors(delta);
            
        var range = delta;
        if (range.start.row !== range.end.row) return;
        if (range.start.row !== this.pos.row) return;
        this.$updating = true;
        var lengthDiff = delta.action === "insert" ? range.end.column - range.start.column : range.start.column - range.end.column;
        var inMainRange = range.start.column >= this.pos.column && range.start.column <= this.pos.column + this.length + 1;
        var distanceFromStart = range.start.column - this.pos.column;
        
        this.updateAnchors(delta);
        
        if (inMainRange)
            this.length += lengthDiff;

        if (inMainRange && !this.session.$fromUndo) {
            if (delta.action === 'insert') {
                for (var i = this.others.length - 1; i >= 0; i--) {
                    var otherPos = this.others[i];
                    var newPos = {row: otherPos.row, column: otherPos.column + distanceFromStart};
                    this.doc.insertMergedLines(newPos, delta.lines);
                }
            } else if (delta.action === 'remove') {
                for (var i = this.others.length - 1; i >= 0; i--) {
                    var otherPos = this.others[i];
                    var newPos = {row: otherPos.row, column: otherPos.column + distanceFromStart};
                    this.doc.remove(new Range(newPos.row, newPos.column, newPos.row, newPos.column - lengthDiff));
                }
            }
        }
        
        this.$updating = false;
        this.updateMarkers();
    };
    
    this.updateAnchors = function(delta) {
        this.pos.onChange(delta);
        for (var i = this.others.length; i--;)
            this.others[i].onChange(delta);
        this.updateMarkers();
    };
    
    this.updateMarkers = function() {
        if (this.$updating)
            return;
        var _self = this;
        var session = this.session;
        var updateMarker = function(pos, className) {
            session.removeMarker(pos.markerId);
            pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column+_self.length), className, null, false);
        };
        updateMarker(this.pos, this.mainClass);
        for (var i = this.others.length; i--;)
            updateMarker(this.others[i], this.othersClass);
    };

    this.onCursorChange = function(event) {
        if (this.$updating || !this.session) return;
        var pos = this.session.selection.getCursor();
        if (pos.row === this.pos.row && pos.column >= this.pos.column && pos.column <= this.pos.column + this.length) {
            this.showOtherMarkers();
            this._emit("cursorEnter", event);
        } else {
            this.hideOtherMarkers();
            this._emit("cursorLeave", event);
        }
    };    
    this.detach = function() {
        this.session.removeMarker(this.pos && this.pos.markerId);
        this.hideOtherMarkers();
        this.doc.removeEventListener("change", this.$onUpdate);
        this.session.selection.removeEventListener("changeCursor", this.$onCursorChange);
        this.session.setUndoSelect(true);
        this.session = null;
    };
    this.cancel = function() {
        if (this.$undoStackDepth === -1)
            return;
        var undoManager = this.session.getUndoManager();
        var undosRequired = (undoManager.$undoStack || undoManager.$undostack).length - this.$undoStackDepth;
        for (var i = 0; i < undosRequired; i++) {
            undoManager.undo(true);
        }
        if (this.selectionBefore)
            this.session.selection.fromJSON(this.selectionBefore);
    };
}).call(PlaceHolder.prototype);


exports.PlaceHolder = PlaceHolder;
});

ace.define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"], function(acequire, exports, module) {

var event = acequire("../lib/event");
var useragent = acequire("../lib/useragent");
function isSamePoint(p1, p2) {
    return p1.row == p2.row && p1.column == p2.column;
}

function onMouseDown(e) {
    var ev = e.domEvent;
    var alt = ev.altKey;
    var shift = ev.shiftKey;
    var ctrl = ev.ctrlKey;
    var accel = e.getAccelKey();
    var button = e.getButton();
    
    if (ctrl && useragent.isMac)
        button = ev.button;

    if (e.editor.inMultiSelectMode && button == 2) {
        e.editor.textInput.onContextMenu(e.domEvent);
        return;
    }
    
    if (!ctrl && !alt && !accel) {
        if (button === 0 && e.editor.inMultiSelectMode)
            e.editor.exitMultiSelectMode();
        return;
    }
    
    if (button !== 0)
        return;

    var editor = e.editor;
    var selection = editor.selection;
    var isMultiSelect = editor.inMultiSelectMode;
    var pos = e.getDocumentPosition();
    var cursor = selection.getCursor();
    var inSelection = e.inSelection() || (selection.isEmpty() && isSamePoint(pos, cursor));

    var mouseX = e.x, mouseY = e.y;
    var onMouseSelection = function(e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
    };
    
    var session = editor.session;
    var screenAnchor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
    var screenCursor = screenAnchor;
    
    var selectionMode;
    if (editor.$mouseHandler.$enableJumpToDef) {
        if (ctrl && alt || accel && alt)
            selectionMode = shift ? "block" : "add";
        else if (alt && editor.$blockSelectEnabled)
            selectionMode = "block";
    } else {
        if (accel && !alt) {
            selectionMode = "add";
            if (!isMultiSelect && shift)
                return;
        } else if (alt && editor.$blockSelectEnabled) {
            selectionMode = "block";
        }
    }
    
    if (selectionMode && useragent.isMac && ev.ctrlKey) {
        editor.$mouseHandler.cancelContextMenu();
    }

    if (selectionMode == "add") {
        if (!isMultiSelect && inSelection)
            return; // dragging

        if (!isMultiSelect) {
            var range = selection.toOrientedRange();
            editor.addSelectionMarker(range);
        }

        var oldRange = selection.rangeList.rangeAtPoint(pos);
        
        
        editor.$blockScrolling++;
        editor.inVirtualSelectionMode = true;
        
        if (shift) {
            oldRange = null;
            range = selection.ranges[0] || range;
            editor.removeSelectionMarker(range);
        }
        editor.once("mouseup", function() {
            var tmpSel = selection.toOrientedRange();

            if (oldRange && tmpSel.isEmpty() && isSamePoint(oldRange.cursor, tmpSel.cursor))
                selection.substractPoint(tmpSel.cursor);
            else {
                if (shift) {
                    selection.substractPoint(range.cursor);
                } else if (range) {
                    editor.removeSelectionMarker(range);
                    selection.addRange(range);
                }
                selection.addRange(tmpSel);
            }
            editor.$blockScrolling--;
            editor.inVirtualSelectionMode = false;
        });

    } else if (selectionMode == "block") {
        e.stop();
        editor.inVirtualSelectionMode = true;        
        var initialRange;
        var rectSel = [];
        var blockSelect = function() {
            var newCursor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
            var cursor = session.screenToDocumentPosition(newCursor.row, newCursor.column, newCursor.offsetX);

            if (isSamePoint(screenCursor, newCursor) && isSamePoint(cursor, selection.lead))
                return;
            screenCursor = newCursor;
            
            editor.$blockScrolling++;
            editor.selection.moveToPosition(cursor);
            editor.renderer.scrollCursorIntoView();

            editor.removeSelectionMarkers(rectSel);
            rectSel = selection.rectangularRangeBlock(screenCursor, screenAnchor);
            if (editor.$mouseHandler.$clickSelection && rectSel.length == 1 && rectSel[0].isEmpty())
                rectSel[0] = editor.$mouseHandler.$clickSelection.clone();
            rectSel.forEach(editor.addSelectionMarker, editor);
            editor.updateSelectionMarkers();
            editor.$blockScrolling--;
        };
        editor.$blockScrolling++;
        if (isMultiSelect && !accel) {
            selection.toSingleRange();
        } else if (!isMultiSelect && accel) {
            initialRange = selection.toOrientedRange();
            editor.addSelectionMarker(initialRange);
        }
        
        if (shift)
            screenAnchor = session.documentToScreenPosition(selection.lead);            
        else
            selection.moveToPosition(pos);
        editor.$blockScrolling--;
        
        screenCursor = {row: -1, column: -1};

        var onMouseSelectionEnd = function(e) {
            clearInterval(timerId);
            editor.removeSelectionMarkers(rectSel);
            if (!rectSel.length)
                rectSel = [selection.toOrientedRange()];
            editor.$blockScrolling++;
            if (initialRange) {
                editor.removeSelectionMarker(initialRange);
                selection.toSingleRange(initialRange);
            }
            for (var i = 0; i < rectSel.length; i++)
                selection.addRange(rectSel[i]);
            editor.inVirtualSelectionMode = false;
            editor.$mouseHandler.$clickSelection = null;
            editor.$blockScrolling--;
        };

        var onSelectionInterval = blockSelect;

        event.capture(editor.container, onMouseSelection, onMouseSelectionEnd);
        var timerId = setInterval(function() {onSelectionInterval();}, 20);

        return e.preventDefault();
    }
}


exports.onMouseDown = onMouseDown;

});

ace.define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"], function(acequire, exports, module) {
exports.defaultCommands = [{
    name: "addCursorAbove",
    exec: function(editor) { editor.selectMoreLines(-1); },
    bindKey: {win: "Ctrl-Alt-Up", mac: "Ctrl-Alt-Up"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "addCursorBelow",
    exec: function(editor) { editor.selectMoreLines(1); },
    bindKey: {win: "Ctrl-Alt-Down", mac: "Ctrl-Alt-Down"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "addCursorAboveSkipCurrent",
    exec: function(editor) { editor.selectMoreLines(-1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Up", mac: "Ctrl-Alt-Shift-Up"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "addCursorBelowSkipCurrent",
    exec: function(editor) { editor.selectMoreLines(1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Down", mac: "Ctrl-Alt-Shift-Down"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectMoreBefore",
    exec: function(editor) { editor.selectMore(-1); },
    bindKey: {win: "Ctrl-Alt-Left", mac: "Ctrl-Alt-Left"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectMoreAfter",
    exec: function(editor) { editor.selectMore(1); },
    bindKey: {win: "Ctrl-Alt-Right", mac: "Ctrl-Alt-Right"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectNextBefore",
    exec: function(editor) { editor.selectMore(-1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Left", mac: "Ctrl-Alt-Shift-Left"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "selectNextAfter",
    exec: function(editor) { editor.selectMore(1, true); },
    bindKey: {win: "Ctrl-Alt-Shift-Right", mac: "Ctrl-Alt-Shift-Right"},
    scrollIntoView: "cursor",
    readOnly: true
}, {
    name: "splitIntoLines",
    exec: function(editor) { editor.multiSelect.splitIntoLines(); },
    bindKey: {win: "Ctrl-Alt-L", mac: "Ctrl-Alt-L"},
    readOnly: true
}, {
    name: "alignCursors",
    exec: function(editor) { editor.alignCursors(); },
    bindKey: {win: "Ctrl-Alt-A", mac: "Ctrl-Alt-A"},
    scrollIntoView: "cursor"
}, {
    name: "findAll",
    exec: function(editor) { editor.findAll(); },
    bindKey: {win: "Ctrl-Alt-K", mac: "Ctrl-Alt-G"},
    scrollIntoView: "cursor",
    readOnly: true
}];
exports.multiSelectCommands = [{
    name: "singleSelection",
    bindKey: "esc",
    exec: function(editor) { editor.exitMultiSelectMode(); },
    scrollIntoView: "cursor",
    readOnly: true,
    isAvailable: function(editor) {return editor && editor.inMultiSelectMode;}
}];

var HashHandler = acequire("../keyboard/hash_handler").HashHandler;
exports.keyboardHandler = new HashHandler(exports.multiSelectCommands);

});

ace.define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"], function(acequire, exports, module) {

var RangeList = acequire("./range_list").RangeList;
var Range = acequire("./range").Range;
var Selection = acequire("./selection").Selection;
var onMouseDown = acequire("./mouse/multi_select_handler").onMouseDown;
var event = acequire("./lib/event");
var lang = acequire("./lib/lang");
var commands = acequire("./commands/multi_select_commands");
exports.commands = commands.defaultCommands.concat(commands.multiSelectCommands);
var Search = acequire("./search").Search;
var search = new Search();

function find(session, needle, dir) {
    search.$options.wrap = true;
    search.$options.needle = needle;
    search.$options.backwards = dir == -1;
    return search.find(session);
}
var EditSession = acequire("./edit_session").EditSession;
(function() {
    this.getSelectionMarkers = function() {
        return this.$selectionMarkers;
    };
}).call(EditSession.prototype);
(function() {
    this.ranges = null;
    this.rangeList = null;
    this.addRange = function(range, $blockChangeEvents) {
        if (!range)
            return;

        if (!this.inMultiSelectMode && this.rangeCount === 0) {
            var oldRange = this.toOrientedRange();
            this.rangeList.add(oldRange);
            this.rangeList.add(range);
            if (this.rangeList.ranges.length != 2) {
                this.rangeList.removeAll();
                return $blockChangeEvents || this.fromOrientedRange(range);
            }
            this.rangeList.removeAll();
            this.rangeList.add(oldRange);
            this.$onAddRange(oldRange);
        }

        if (!range.cursor)
            range.cursor = range.end;

        var removed = this.rangeList.add(range);

        this.$onAddRange(range);

        if (removed.length)
            this.$onRemoveRange(removed);

        if (this.rangeCount > 1 && !this.inMultiSelectMode) {
            this._signal("multiSelect");
            this.inMultiSelectMode = true;
            this.session.$undoSelect = false;
            this.rangeList.attach(this.session);
        }

        return $blockChangeEvents || this.fromOrientedRange(range);
    };

    this.toSingleRange = function(range) {
        range = range || this.ranges[0];
        var removed = this.rangeList.removeAll();
        if (removed.length)
            this.$onRemoveRange(removed);

        range && this.fromOrientedRange(range);
    };
    this.substractPoint = function(pos) {
        var removed = this.rangeList.substractPoint(pos);
        if (removed) {
            this.$onRemoveRange(removed);
            return removed[0];
        }
    };
    this.mergeOverlappingRanges = function() {
        var removed = this.rangeList.merge();
        if (removed.length)
            this.$onRemoveRange(removed);
        else if(this.ranges[0])
            this.fromOrientedRange(this.ranges[0]);
    };

    this.$onAddRange = function(range) {
        this.rangeCount = this.rangeList.ranges.length;
        this.ranges.unshift(range);
        this._signal("addRange", {range: range});
    };

    this.$onRemoveRange = function(removed) {
        this.rangeCount = this.rangeList.ranges.length;
        if (this.rangeCount == 1 && this.inMultiSelectMode) {
            var lastRange = this.rangeList.ranges.pop();
            removed.push(lastRange);
            this.rangeCount = 0;
        }

        for (var i = removed.length; i--; ) {
            var index = this.ranges.indexOf(removed[i]);
            this.ranges.splice(index, 1);
        }

        this._signal("removeRange", {ranges: removed});

        if (this.rangeCount === 0 && this.inMultiSelectMode) {
            this.inMultiSelectMode = false;
            this._signal("singleSelect");
            this.session.$undoSelect = true;
            this.rangeList.detach(this.session);
        }

        lastRange = lastRange || this.ranges[0];
        if (lastRange && !lastRange.isEqual(this.getRange()))
            this.fromOrientedRange(lastRange);
    };
    this.$initRangeList = function() {
        if (this.rangeList)
            return;

        this.rangeList = new RangeList();
        this.ranges = [];
        this.rangeCount = 0;
    };
    this.getAllRanges = function() {
        return this.rangeCount ? this.rangeList.ranges.concat() : [this.getRange()];
    };

    this.splitIntoLines = function () {
        if (this.rangeCount > 1) {
            var ranges = this.rangeList.ranges;
            var lastRange = ranges[ranges.length - 1];
            var range = Range.fromPoints(ranges[0].start, lastRange.end);

            this.toSingleRange();
            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
        } else {
            var range = this.getRange();
            var isBackwards = this.isBackwards();
            var startRow = range.start.row;
            var endRow = range.end.row;
            if (startRow == endRow) {
                if (isBackwards)
                    var start = range.end, end = range.start;
                else
                    var start = range.start, end = range.end;
                
                this.addRange(Range.fromPoints(end, end));
                this.addRange(Range.fromPoints(start, start));
                return;
            }

            var rectSel = [];
            var r = this.getLineRange(startRow, true);
            r.start.column = range.start.column;
            rectSel.push(r);

            for (var i = startRow + 1; i < endRow; i++)
                rectSel.push(this.getLineRange(i, true));

            r = this.getLineRange(endRow, true);
            r.end.column = range.end.column;
            rectSel.push(r);

            rectSel.forEach(this.addRange, this);
        }
    };
    this.toggleBlockSelection = function () {
        if (this.rangeCount > 1) {
            var ranges = this.rangeList.ranges;
            var lastRange = ranges[ranges.length - 1];
            var range = Range.fromPoints(ranges[0].start, lastRange.end);

            this.toSingleRange();
            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
        } else {
            var cursor = this.session.documentToScreenPosition(this.selectionLead);
            var anchor = this.session.documentToScreenPosition(this.selectionAnchor);

            var rectSel = this.rectangularRangeBlock(cursor, anchor);
            rectSel.forEach(this.addRange, this);
        }
    };
    this.rectangularRangeBlock = function(screenCursor, screenAnchor, includeEmptyLines) {
        var rectSel = [];

        var xBackwards = screenCursor.column < screenAnchor.column;
        if (xBackwards) {
            var startColumn = screenCursor.column;
            var endColumn = screenAnchor.column;
            var startOffsetX = screenCursor.offsetX;
            var endOffsetX = screenAnchor.offsetX;
        } else {
            var startColumn = screenAnchor.column;
            var endColumn = screenCursor.column;
            var startOffsetX = screenAnchor.offsetX;
            var endOffsetX = screenCursor.offsetX;
        }

        var yBackwards = screenCursor.row < screenAnchor.row;
        if (yBackwards) {
            var startRow = screenCursor.row;
            var endRow = screenAnchor.row;
        } else {
            var startRow = screenAnchor.row;
            var endRow = screenCursor.row;
        }

        if (startColumn < 0)
            startColumn = 0;
        if (startRow < 0)
            startRow = 0;

        if (startRow == endRow)
            includeEmptyLines = true;

        for (var row = startRow; row <= endRow; row++) {
            var range = Range.fromPoints(
                this.session.screenToDocumentPosition(row, startColumn, startOffsetX),
                this.session.screenToDocumentPosition(row, endColumn, endOffsetX)
            );
            if (range.isEmpty()) {
                if (docEnd && isSamePoint(range.end, docEnd))
                    break;
                var docEnd = range.end;
            }
            range.cursor = xBackwards ? range.start : range.end;
            rectSel.push(range);
        }

        if (yBackwards)
            rectSel.reverse();

        if (!includeEmptyLines) {
            var end = rectSel.length - 1;
            while (rectSel[end].isEmpty() && end > 0)
                end--;
            if (end > 0) {
                var start = 0;
                while (rectSel[start].isEmpty())
                    start++;
            }
            for (var i = end; i >= start; i--) {
                if (rectSel[i].isEmpty())
                    rectSel.splice(i, 1);
            }
        }

        return rectSel;
    };
}).call(Selection.prototype);
var Editor = acequire("./editor").Editor;
(function() {
    this.updateSelectionMarkers = function() {
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };
    this.addSelectionMarker = function(orientedRange) {
        if (!orientedRange.cursor)
            orientedRange.cursor = orientedRange.end;

        var style = this.getSelectionStyle();
        orientedRange.marker = this.session.addMarker(orientedRange, "ace_selection", style);

        this.session.$selectionMarkers.push(orientedRange);
        this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
        return orientedRange;
    };
    this.removeSelectionMarker = function(range) {
        if (!range.marker)
            return;
        this.session.removeMarker(range.marker);
        var index = this.session.$selectionMarkers.indexOf(range);
        if (index != -1)
            this.session.$selectionMarkers.splice(index, 1);
        this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
    };

    this.removeSelectionMarkers = function(ranges) {
        var markerList = this.session.$selectionMarkers;
        for (var i = ranges.length; i--; ) {
            var range = ranges[i];
            if (!range.marker)
                continue;
            this.session.removeMarker(range.marker);
            var index = markerList.indexOf(range);
            if (index != -1)
                markerList.splice(index, 1);
        }
        this.session.selectionMarkerCount = markerList.length;
    };

    this.$onAddRange = function(e) {
        this.addSelectionMarker(e.range);
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };

    this.$onRemoveRange = function(e) {
        this.removeSelectionMarkers(e.ranges);
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };

    this.$onMultiSelect = function(e) {
        if (this.inMultiSelectMode)
            return;
        this.inMultiSelectMode = true;

        this.setStyle("ace_multiselect");
        this.keyBinding.addKeyboardHandler(commands.keyboardHandler);
        this.commands.setDefaultHandler("exec", this.$onMultiSelectExec);

        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
    };

    this.$onSingleSelect = function(e) {
        if (this.session.multiSelect.inVirtualMode)
            return;
        this.inMultiSelectMode = false;

        this.unsetStyle("ace_multiselect");
        this.keyBinding.removeKeyboardHandler(commands.keyboardHandler);

        this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec);
        this.renderer.updateCursor();
        this.renderer.updateBackMarkers();
        this._emit("changeSelection");
    };

    this.$onMultiSelectExec = function(e) {
        var command = e.command;
        var editor = e.editor;
        if (!editor.multiSelect)
            return;
        if (!command.multiSelectAction) {
            var result = command.exec(editor, e.args || {});
            editor.multiSelect.addRange(editor.multiSelect.toOrientedRange());
            editor.multiSelect.mergeOverlappingRanges();
        } else if (command.multiSelectAction == "forEach") {
            result = editor.forEachSelection(command, e.args);
        } else if (command.multiSelectAction == "forEachLine") {
            result = editor.forEachSelection(command, e.args, true);
        } else if (command.multiSelectAction == "single") {
            editor.exitMultiSelectMode();
            result = command.exec(editor, e.args || {});
        } else {
            result = command.multiSelectAction(editor, e.args || {});
        }
        return result;
    }; 
    this.forEachSelection = function(cmd, args, options) {
        if (this.inVirtualSelectionMode)
            return;
        var keepOrder = options && options.keepOrder;
        var $byLines = options == true || options && options.$byLines;
        var session = this.session;
        var selection = this.selection;
        var rangeList = selection.rangeList;
        var ranges = (keepOrder ? selection : rangeList).ranges;
        var result;
        
        if (!ranges.length)
            return cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
        
        var reg = selection._eventRegistry;
        selection._eventRegistry = {};

        var tmpSel = new Selection(session);
        this.inVirtualSelectionMode = true;
        for (var i = ranges.length; i--;) {
            if ($byLines) {
                while (i > 0 && ranges[i].start.row == ranges[i - 1].end.row)
                    i--;
            }
            tmpSel.fromOrientedRange(ranges[i]);
            tmpSel.index = i;
            this.selection = session.selection = tmpSel;
            var cmdResult = cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
            if (!result && cmdResult !== undefined)
                result = cmdResult;
            tmpSel.toOrientedRange(ranges[i]);
        }
        tmpSel.detach();

        this.selection = session.selection = selection;
        this.inVirtualSelectionMode = false;
        selection._eventRegistry = reg;
        selection.mergeOverlappingRanges();
        
        var anim = this.renderer.$scrollAnimation;
        this.onCursorChange();
        this.onSelectionChange();
        if (anim && anim.from == anim.to)
            this.renderer.animateScrolling(anim.from);
        
        return result;
    };
    this.exitMultiSelectMode = function() {
        if (!this.inMultiSelectMode || this.inVirtualSelectionMode)
            return;
        this.multiSelect.toSingleRange();
    };

    this.getSelectedText = function() {
        var text = "";
        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
            var ranges = this.multiSelect.rangeList.ranges;
            var buf = [];
            for (var i = 0; i < ranges.length; i++) {
                buf.push(this.session.getTextRange(ranges[i]));
            }
            var nl = this.session.getDocument().getNewLineCharacter();
            text = buf.join(nl);
            if (text.length == (buf.length - 1) * nl.length)
                text = "";
        } else if (!this.selection.isEmpty()) {
            text = this.session.getTextRange(this.getSelectionRange());
        }
        return text;
    };
    
    this.$checkMultiselectChange = function(e, anchor) {
        if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
            var range = this.multiSelect.ranges[0];
            if (this.multiSelect.isEmpty() && anchor == this.multiSelect.anchor)
                return;
            var pos = anchor == this.multiSelect.anchor
                ? range.cursor == range.start ? range.end : range.start
                : range.cursor;
            if (pos.row != anchor.row 
                || this.session.$clipPositionToDocument(pos.row, pos.column).column != anchor.column)
                this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange());
        }
    };
    this.findAll = function(needle, options, additive) {
        options = options || {};
        options.needle = needle || options.needle;
        if (options.needle == undefined) {
            var range = this.selection.isEmpty()
                ? this.selection.getWordRange()
                : this.selection.getRange();
            options.needle = this.session.getTextRange(range);
        }    
        this.$search.set(options);
        
        var ranges = this.$search.findAll(this.session);
        if (!ranges.length)
            return 0;

        this.$blockScrolling += 1;
        var selection = this.multiSelect;

        if (!additive)
            selection.toSingleRange(ranges[0]);

        for (var i = ranges.length; i--; )
            selection.addRange(ranges[i], true);
        if (range && selection.rangeList.rangeAtPoint(range.start))
            selection.addRange(range, true);
        
        this.$blockScrolling -= 1;

        return ranges.length;
    };
    this.selectMoreLines = function(dir, skip) {
        var range = this.selection.toOrientedRange();
        var isBackwards = range.cursor == range.end;

        var screenLead = this.session.documentToScreenPosition(range.cursor);
        if (this.selection.$desiredColumn)
            screenLead.column = this.selection.$desiredColumn;

        var lead = this.session.screenToDocumentPosition(screenLead.row + dir, screenLead.column);

        if (!range.isEmpty()) {
            var screenAnchor = this.session.documentToScreenPosition(isBackwards ? range.end : range.start);
            var anchor = this.session.screenToDocumentPosition(screenAnchor.row + dir, screenAnchor.column);
        } else {
            var anchor = lead;
        }

        if (isBackwards) {
            var newRange = Range.fromPoints(lead, anchor);
            newRange.cursor = newRange.start;
        } else {
            var newRange = Range.fromPoints(anchor, lead);
            newRange.cursor = newRange.end;
        }

        newRange.desiredColumn = screenLead.column;
        if (!this.selection.inMultiSelectMode) {
            this.selection.addRange(range);
        } else {
            if (skip)
                var toRemove = range.cursor;
        }

        this.selection.addRange(newRange);
        if (toRemove)
            this.selection.substractPoint(toRemove);
    };
    this.transposeSelections = function(dir) {
        var session = this.session;
        var sel = session.multiSelect;
        var all = sel.ranges;

        for (var i = all.length; i--; ) {
            var range = all[i];
            if (range.isEmpty()) {
                var tmp = session.getWordRange(range.start.row, range.start.column);
                range.start.row = tmp.start.row;
                range.start.column = tmp.start.column;
                range.end.row = tmp.end.row;
                range.end.column = tmp.end.column;
            }
        }
        sel.mergeOverlappingRanges();

        var words = [];
        for (var i = all.length; i--; ) {
            var range = all[i];
            words.unshift(session.getTextRange(range));
        }

        if (dir < 0)
            words.unshift(words.pop());
        else
            words.push(words.shift());

        for (var i = all.length; i--; ) {
            var range = all[i];
            var tmp = range.clone();
            session.replace(range, words[i]);
            range.start.row = tmp.start.row;
            range.start.column = tmp.start.column;
        }
    };
    this.selectMore = function(dir, skip, stopAtFirst) {
        var session = this.session;
        var sel = session.multiSelect;

        var range = sel.toOrientedRange();
        if (range.isEmpty()) {
            range = session.getWordRange(range.start.row, range.start.column);
            range.cursor = dir == -1 ? range.start : range.end;
            this.multiSelect.addRange(range);
            if (stopAtFirst)
                return;
        }
        var needle = session.getTextRange(range);

        var newRange = find(session, needle, dir);
        if (newRange) {
            newRange.cursor = dir == -1 ? newRange.start : newRange.end;
            this.$blockScrolling += 1;
            this.session.unfold(newRange);
            this.multiSelect.addRange(newRange);
            this.$blockScrolling -= 1;
            this.renderer.scrollCursorIntoView(null, 0.5);
        }
        if (skip)
            this.multiSelect.substractPoint(range.cursor);
    };
    this.alignCursors = function() {
        var session = this.session;
        var sel = session.multiSelect;
        var ranges = sel.ranges;
        var row = -1;
        var sameRowRanges = ranges.filter(function(r) {
            if (r.cursor.row == row)
                return true;
            row = r.cursor.row;
        });
        
        if (!ranges.length || sameRowRanges.length == ranges.length - 1) {
            var range = this.selection.getRange();
            var fr = range.start.row, lr = range.end.row;
            var guessRange = fr == lr;
            if (guessRange) {
                var max = this.session.getLength();
                var line;
                do {
                    line = this.session.getLine(lr);
                } while (/[=:]/.test(line) && ++lr < max);
                do {
                    line = this.session.getLine(fr);
                } while (/[=:]/.test(line) && --fr > 0);
                
                if (fr < 0) fr = 0;
                if (lr >= max) lr = max - 1;
            }
            var lines = this.session.removeFullLines(fr, lr);
            lines = this.$reAlignText(lines, guessRange);
            this.session.insert({row: fr, column: 0}, lines.join("\n") + "\n");
            if (!guessRange) {
                range.start.column = 0;
                range.end.column = lines[lines.length - 1].length;
            }
            this.selection.setRange(range);
        } else {
            sameRowRanges.forEach(function(r) {
                sel.substractPoint(r.cursor);
            });

            var maxCol = 0;
            var minSpace = Infinity;
            var spaceOffsets = ranges.map(function(r) {
                var p = r.cursor;
                var line = session.getLine(p.row);
                var spaceOffset = line.substr(p.column).search(/\S/g);
                if (spaceOffset == -1)
                    spaceOffset = 0;

                if (p.column > maxCol)
                    maxCol = p.column;
                if (spaceOffset < minSpace)
                    minSpace = spaceOffset;
                return spaceOffset;
            });
            ranges.forEach(function(r, i) {
                var p = r.cursor;
                var l = maxCol - p.column;
                var d = spaceOffsets[i] - minSpace;
                if (l > d)
                    session.insert(p, lang.stringRepeat(" ", l - d));
                else
                    session.remove(new Range(p.row, p.column, p.row, p.column - l + d));

                r.start.column = r.end.column = maxCol;
                r.start.row = r.end.row = p.row;
                r.cursor = r.end;
            });
            sel.fromOrientedRange(ranges[0]);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        }
    };

    this.$reAlignText = function(lines, forceLeft) {
        var isLeftAligned = true, isRightAligned = true;
        var startW, textW, endW;

        return lines.map(function(line) {
            var m = line.match(/(\s*)(.*?)(\s*)([=:].*)/);
            if (!m)
                return [line];

            if (startW == null) {
                startW = m[1].length;
                textW = m[2].length;
                endW = m[3].length;
                return m;
            }

            if (startW + textW + endW != m[1].length + m[2].length + m[3].length)
                isRightAligned = false;
            if (startW != m[1].length)
                isLeftAligned = false;

            if (startW > m[1].length)
                startW = m[1].length;
            if (textW < m[2].length)
                textW = m[2].length;
            if (endW > m[3].length)
                endW = m[3].length;

            return m;
        }).map(forceLeft ? alignLeft :
            isLeftAligned ? isRightAligned ? alignRight : alignLeft : unAlign);

        function spaces(n) {
            return lang.stringRepeat(" ", n);
        }

        function alignLeft(m) {
            return !m[2] ? m[0] : spaces(startW) + m[2]
                + spaces(textW - m[2].length + endW)
                + m[4].replace(/^([=:])\s+/, "$1 ");
        }
        function alignRight(m) {
            return !m[2] ? m[0] : spaces(startW + textW - m[2].length) + m[2]
                + spaces(endW, " ")
                + m[4].replace(/^([=:])\s+/, "$1 ");
        }
        function unAlign(m) {
            return !m[2] ? m[0] : spaces(startW) + m[2]
                + spaces(endW)
                + m[4].replace(/^([=:])\s+/, "$1 ");
        }
    };
}).call(Editor.prototype);


function isSamePoint(p1, p2) {
    return p1.row == p2.row && p1.column == p2.column;
}
exports.onSessionChange = function(e) {
    var session = e.session;
    if (session && !session.multiSelect) {
        session.$selectionMarkers = [];
        session.selection.$initRangeList();
        session.multiSelect = session.selection;
    }
    this.multiSelect = session && session.multiSelect;

    var oldSession = e.oldSession;
    if (oldSession) {
        oldSession.multiSelect.off("addRange", this.$onAddRange);
        oldSession.multiSelect.off("removeRange", this.$onRemoveRange);
        oldSession.multiSelect.off("multiSelect", this.$onMultiSelect);
        oldSession.multiSelect.off("singleSelect", this.$onSingleSelect);
        oldSession.multiSelect.lead.off("change", this.$checkMultiselectChange);
        oldSession.multiSelect.anchor.off("change", this.$checkMultiselectChange);
    }

    if (session) {
        session.multiSelect.on("addRange", this.$onAddRange);
        session.multiSelect.on("removeRange", this.$onRemoveRange);
        session.multiSelect.on("multiSelect", this.$onMultiSelect);
        session.multiSelect.on("singleSelect", this.$onSingleSelect);
        session.multiSelect.lead.on("change", this.$checkMultiselectChange);
        session.multiSelect.anchor.on("change", this.$checkMultiselectChange);
    }

    if (session && this.inMultiSelectMode != session.selection.inMultiSelectMode) {
        if (session.selection.inMultiSelectMode)
            this.$onMultiSelect();
        else
            this.$onSingleSelect();
    }
};
function MultiSelect(editor) {
    if (editor.$multiselectOnSessionChange)
        return;
    editor.$onAddRange = editor.$onAddRange.bind(editor);
    editor.$onRemoveRange = editor.$onRemoveRange.bind(editor);
    editor.$onMultiSelect = editor.$onMultiSelect.bind(editor);
    editor.$onSingleSelect = editor.$onSingleSelect.bind(editor);
    editor.$multiselectOnSessionChange = exports.onSessionChange.bind(editor);
    editor.$checkMultiselectChange = editor.$checkMultiselectChange.bind(editor);

    editor.$multiselectOnSessionChange(editor);
    editor.on("changeSession", editor.$multiselectOnSessionChange);

    editor.on("mousedown", onMouseDown);
    editor.commands.addCommands(commands.defaultCommands);

    addAltCursorListeners(editor);
}

function addAltCursorListeners(editor){
    var el = editor.textInput.getElement();
    var altCursor = false;
    event.addListener(el, "keydown", function(e) {
        var altDown = e.keyCode == 18 && !(e.ctrlKey || e.shiftKey || e.metaKey);
        if (editor.$blockSelectEnabled && altDown) {
            if (!altCursor) {
                editor.renderer.setMouseCursor("crosshair");
                altCursor = true;
            }
        } else if (altCursor) {
            reset();
        }
    });

    event.addListener(el, "keyup", reset);
    event.addListener(el, "blur", reset);
    function reset(e) {
        if (altCursor) {
            editor.renderer.setMouseCursor("");
            altCursor = false;
        }
    }
}

exports.MultiSelect = MultiSelect;


acequire("./config").defineOptions(Editor.prototype, "editor", {
    enableMultiselect: {
        set: function(val) {
            MultiSelect(this);
            if (val) {
                this.on("changeSession", this.$multiselectOnSessionChange);
                this.on("mousedown", onMouseDown);
            } else {
                this.off("changeSession", this.$multiselectOnSessionChange);
                this.off("mousedown", onMouseDown);
            }
        },
        value: true
    },
    enableBlockSelect: {
        set: function(val) {
            this.$blockSelectEnabled = val;
        },
        value: true
    }
});



});

ace.define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../../range").Range;

var FoldMode = exports.FoldMode = function() {};

(function() {

    this.foldingStartMarker = null;
    this.foldingStopMarker = null;
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
        if (this.foldingStartMarker.test(line))
            return "start";
        if (foldStyle == "markbeginend"
                && this.foldingStopMarker
                && this.foldingStopMarker.test(line))
            return "end";
        return "";
    };

    this.getFoldWidgetRange = function(session, foldStyle, row) {
        return null;
    };

    this.indentationBlock = function(session, row, column) {
        var re = /\S/;
        var line = session.getLine(row);
        var startLevel = line.search(re);
        if (startLevel == -1)
            return;

        var startColumn = column || line.length;
        var maxRow = session.getLength();
        var startRow = row;
        var endRow = row;

        while (++row < maxRow) {
            var level = session.getLine(row).search(re);

            if (level == -1)
                continue;

            if (level <= startLevel)
                break;

            endRow = row;
        }

        if (endRow > startRow) {
            var endColumn = session.getLine(endRow).length;
            return new Range(startRow, startColumn, endRow, endColumn);
        }
    };

    this.openingBracketBlock = function(session, bracket, row, column, typeRe) {
        var start = {row: row, column: column + 1};
        var end = session.$findClosingBracket(bracket, start, typeRe);
        if (!end)
            return;

        var fw = session.foldWidgets[end.row];
        if (fw == null)
            fw = session.getFoldWidget(end.row);

        if (fw == "start" && end.row > start.row) {
            end.row --;
            end.column = session.getLine(end.row).length;
        }
        return Range.fromPoints(start, end);
    };

    this.closingBracketBlock = function(session, bracket, row, column, typeRe) {
        var end = {row: row, column: column};
        var start = session.$findOpeningBracket(bracket, end);

        if (!start)
            return;

        start.column++;
        end.column--;

        return  Range.fromPoints(start, end);
    };
}).call(FoldMode.prototype);

});

ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

exports.isDark = false;
exports.cssClass = "ace-tm";
exports.cssText = ".ace-tm .ace_gutter {\
background: #f0f0f0;\
color: #333;\
}\
.ace-tm .ace_print-margin {\
width: 1px;\
background: #e8e8e8;\
}\
.ace-tm .ace_fold {\
background-color: #6B72E6;\
}\
.ace-tm {\
background-color: #FFFFFF;\
color: black;\
}\
.ace-tm .ace_cursor {\
color: black;\
}\
.ace-tm .ace_invisible {\
color: rgb(191, 191, 191);\
}\
.ace-tm .ace_storage,\
.ace-tm .ace_keyword {\
color: blue;\
}\
.ace-tm .ace_constant {\
color: rgb(197, 6, 11);\
}\
.ace-tm .ace_constant.ace_buildin {\
color: rgb(88, 72, 246);\
}\
.ace-tm .ace_constant.ace_language {\
color: rgb(88, 92, 246);\
}\
.ace-tm .ace_constant.ace_library {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_invalid {\
background-color: rgba(255, 0, 0, 0.1);\
color: red;\
}\
.ace-tm .ace_support.ace_function {\
color: rgb(60, 76, 114);\
}\
.ace-tm .ace_support.ace_constant {\
color: rgb(6, 150, 14);\
}\
.ace-tm .ace_support.ace_type,\
.ace-tm .ace_support.ace_class {\
color: rgb(109, 121, 222);\
}\
.ace-tm .ace_keyword.ace_operator {\
color: rgb(104, 118, 135);\
}\
.ace-tm .ace_string {\
color: rgb(3, 106, 7);\
}\
.ace-tm .ace_comment {\
color: rgb(76, 136, 107);\
}\
.ace-tm .ace_comment.ace_doc {\
color: rgb(0, 102, 255);\
}\
.ace-tm .ace_comment.ace_doc.ace_tag {\
color: rgb(128, 159, 191);\
}\
.ace-tm .ace_constant.ace_numeric {\
color: rgb(0, 0, 205);\
}\
.ace-tm .ace_variable {\
color: rgb(49, 132, 149);\
}\
.ace-tm .ace_xml-pe {\
color: rgb(104, 104, 91);\
}\
.ace-tm .ace_entity.ace_name.ace_function {\
color: #0000A2;\
}\
.ace-tm .ace_heading {\
color: rgb(12, 7, 255);\
}\
.ace-tm .ace_list {\
color:rgb(185, 6, 144);\
}\
.ace-tm .ace_meta.ace_tag {\
color:rgb(0, 22, 142);\
}\
.ace-tm .ace_string.ace_regex {\
color: rgb(255, 0, 0)\
}\
.ace-tm .ace_marker-layer .ace_selection {\
background: rgb(181, 213, 255);\
}\
.ace-tm.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px white;\
}\
.ace-tm .ace_marker-layer .ace_step {\
background: rgb(252, 255, 0);\
}\
.ace-tm .ace_marker-layer .ace_stack {\
background: rgb(164, 229, 101);\
}\
.ace-tm .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgb(192, 192, 192);\
}\
.ace-tm .ace_marker-layer .ace_active-line {\
background: rgba(0, 0, 0, 0.07);\
}\
.ace-tm .ace_gutter-active-line {\
background-color : #dcdcdc;\
}\
.ace-tm .ace_marker-layer .ace_selected-word {\
background: rgb(250, 250, 255);\
border: 1px solid rgb(200, 200, 250);\
}\
.ace-tm .ace_indent-guide {\
background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
}\
";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});

ace.define("ace/line_widgets",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/range"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var dom = acequire("./lib/dom");
var Range = acequire("./range").Range;


function LineWidgets(session) {
    this.session = session;
    this.session.widgetManager = this;
    this.session.getRowLength = this.getRowLength;
    this.session.$getWidgetScreenLength = this.$getWidgetScreenLength;
    this.updateOnChange = this.updateOnChange.bind(this);
    this.renderWidgets = this.renderWidgets.bind(this);
    this.measureWidgets = this.measureWidgets.bind(this);
    this.session._changedWidgets = [];
    this.$onChangeEditor = this.$onChangeEditor.bind(this);
    
    this.session.on("change", this.updateOnChange);
    this.session.on("changeFold", this.updateOnFold);
    this.session.on("changeEditor", this.$onChangeEditor);
}

(function() {
    this.getRowLength = function(row) {
        var h;
        if (this.lineWidgets)
            h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
        else 
            h = 0;
        if (!this.$useWrapMode || !this.$wrapData[row]) {
            return 1 + h;
        } else {
            return this.$wrapData[row].length + 1 + h;
        }
    };

    this.$getWidgetScreenLength = function() {
        var screenRows = 0;
        this.lineWidgets.forEach(function(w){
            if (w && w.rowCount && !w.hidden)
                screenRows += w.rowCount;
        });
        return screenRows;
    };    
    
    this.$onChangeEditor = function(e) {
        this.attach(e.editor);
    };
    
    this.attach = function(editor) {
        if (editor  && editor.widgetManager && editor.widgetManager != this)
            editor.widgetManager.detach();

        if (this.editor == editor)
            return;

        this.detach();
        this.editor = editor;
        
        if (editor) {
            editor.widgetManager = this;
            editor.renderer.on("beforeRender", this.measureWidgets);
            editor.renderer.on("afterRender", this.renderWidgets);
        }
    };
    this.detach = function(e) {
        var editor = this.editor;
        if (!editor)
            return;
        
        this.editor = null;
        editor.widgetManager = null;
        
        editor.renderer.off("beforeRender", this.measureWidgets);
        editor.renderer.off("afterRender", this.renderWidgets);
        var lineWidgets = this.session.lineWidgets;
        lineWidgets && lineWidgets.forEach(function(w) {
            if (w && w.el && w.el.parentNode) {
                w._inDocument = false;
                w.el.parentNode.removeChild(w.el);
            }
        });
    };

    this.updateOnFold = function(e, session) {
        var lineWidgets = session.lineWidgets;
        if (!lineWidgets || !e.action)
            return;
        var fold = e.data;
        var start = fold.start.row;
        var end = fold.end.row;
        var hide = e.action == "add";
        for (var i = start + 1; i < end; i++) {
            if (lineWidgets[i])
                lineWidgets[i].hidden = hide;
        }
        if (lineWidgets[end]) {
            if (hide) {
                if (!lineWidgets[start])
                    lineWidgets[start] = lineWidgets[end];
                else
                    lineWidgets[end].hidden = hide;
            } else {
                if (lineWidgets[start] == lineWidgets[end])
                    lineWidgets[start] = undefined;
                lineWidgets[end].hidden = hide;
            }
        }
    };
    
    this.updateOnChange = function(delta) {
        var lineWidgets = this.session.lineWidgets;
        if (!lineWidgets) return;
        
        var startRow = delta.start.row;
        var len = delta.end.row - startRow;

        if (len === 0) {
        } else if (delta.action == 'remove') {
            var removed = lineWidgets.splice(startRow + 1, len);
            removed.forEach(function(w) {
                w && this.removeLineWidget(w);
            }, this);
            this.$updateRows();
        } else {
            var args = new Array(len);
            args.unshift(startRow, 0);
            lineWidgets.splice.apply(lineWidgets, args);
            this.$updateRows();
        }
    };
    
    this.$updateRows = function() {
        var lineWidgets = this.session.lineWidgets;
        if (!lineWidgets) return;
        var noWidgets = true;
        lineWidgets.forEach(function(w, i) {
            if (w) {
                noWidgets = false;
                w.row = i;
                while (w.$oldWidget) {
                    w.$oldWidget.row = i;
                    w = w.$oldWidget;
                }
            }
        });
        if (noWidgets)
            this.session.lineWidgets = null;
    };

    this.addLineWidget = function(w) {
        if (!this.session.lineWidgets)
            this.session.lineWidgets = new Array(this.session.getLength());
        
        var old = this.session.lineWidgets[w.row];
        if (old) {
            w.$oldWidget = old;
            if (old.el && old.el.parentNode) {
                old.el.parentNode.removeChild(old.el);
                old._inDocument = false;
            }
        }
            
        this.session.lineWidgets[w.row] = w;
        
        w.session = this.session;
        
        var renderer = this.editor.renderer;
        if (w.html && !w.el) {
            w.el = dom.createElement("div");
            w.el.innerHTML = w.html;
        }
        if (w.el) {
            dom.addCssClass(w.el, "ace_lineWidgetContainer");
            w.el.style.position = "absolute";
            w.el.style.zIndex = 5;
            renderer.container.appendChild(w.el);
            w._inDocument = true;
        }
        
        if (!w.coverGutter) {
            w.el.style.zIndex = 3;
        }
        if (w.pixelHeight == null) {
            w.pixelHeight = w.el.offsetHeight;
        }
        if (w.rowCount == null) {
            w.rowCount = w.pixelHeight / renderer.layerConfig.lineHeight;
        }
        
        var fold = this.session.getFoldAt(w.row, 0);
        w.$fold = fold;
        if (fold) {
            var lineWidgets = this.session.lineWidgets;
            if (w.row == fold.end.row && !lineWidgets[fold.start.row])
                lineWidgets[fold.start.row] = w;
            else
                w.hidden = true;
        }
            
        this.session._emit("changeFold", {data:{start:{row: w.row}}});
        
        this.$updateRows();
        this.renderWidgets(null, renderer);
        this.onWidgetChanged(w);
        return w;
    };
    
    this.removeLineWidget = function(w) {
        w._inDocument = false;
        w.session = null;
        if (w.el && w.el.parentNode)
            w.el.parentNode.removeChild(w.el);
        if (w.editor && w.editor.destroy) try {
            w.editor.destroy();
        } catch(e){}
        if (this.session.lineWidgets) {
            var w1 = this.session.lineWidgets[w.row];
            if (w1 == w) {
                this.session.lineWidgets[w.row] = w.$oldWidget;
                if (w.$oldWidget)
                    this.onWidgetChanged(w.$oldWidget);
            } else {
                while (w1) {
                    if (w1.$oldWidget == w) {
                        w1.$oldWidget = w.$oldWidget;
                        break;
                    }
                    w1 = w1.$oldWidget;
                }
            }
        }
        this.session._emit("changeFold", {data:{start:{row: w.row}}});
        this.$updateRows();
    };
    
    this.getWidgetsAtRow = function(row) {
        var lineWidgets = this.session.lineWidgets;
        var w = lineWidgets && lineWidgets[row];
        var list = [];
        while (w) {
            list.push(w);
            w = w.$oldWidget;
        }
        return list;
    };
    
    this.onWidgetChanged = function(w) {
        this.session._changedWidgets.push(w);
        this.editor && this.editor.renderer.updateFull();
    };
    
    this.measureWidgets = function(e, renderer) {
        var changedWidgets = this.session._changedWidgets;
        var config = renderer.layerConfig;
        
        if (!changedWidgets || !changedWidgets.length) return;
        var min = Infinity;
        for (var i = 0; i < changedWidgets.length; i++) {
            var w = changedWidgets[i];
            if (!w || !w.el) continue;
            if (w.session != this.session) continue;
            if (!w._inDocument) {
                if (this.session.lineWidgets[w.row] != w)
                    continue;
                w._inDocument = true;
                renderer.container.appendChild(w.el);
            }
            
            w.h = w.el.offsetHeight;
            
            if (!w.fixedWidth) {
                w.w = w.el.offsetWidth;
                w.screenWidth = Math.ceil(w.w / config.characterWidth);
            }
            
            var rowCount = w.h / config.lineHeight;
            if (w.coverLine) {
                rowCount -= this.session.getRowLineCount(w.row);
                if (rowCount < 0)
                    rowCount = 0;
            }
            if (w.rowCount != rowCount) {
                w.rowCount = rowCount;
                if (w.row < min)
                    min = w.row;
            }
        }
        if (min != Infinity) {
            this.session._emit("changeFold", {data:{start:{row: min}}});
            this.session.lineWidgetWidth = null;
        }
        this.session._changedWidgets = [];
    };
    
    this.renderWidgets = function(e, renderer) {
        var config = renderer.layerConfig;
        var lineWidgets = this.session.lineWidgets;
        if (!lineWidgets)
            return;
        var first = Math.min(this.firstRow, config.firstRow);
        var last = Math.max(this.lastRow, config.lastRow, lineWidgets.length);
        
        while (first > 0 && !lineWidgets[first])
            first--;
        
        this.firstRow = config.firstRow;
        this.lastRow = config.lastRow;

        renderer.$cursorLayer.config = config;
        for (var i = first; i <= last; i++) {
            var w = lineWidgets[i];
            if (!w || !w.el) continue;
            if (w.hidden) {
                w.el.style.top = -100 - (w.pixelHeight || 0) + "px";
                continue;
            }
            if (!w._inDocument) {
                w._inDocument = true;
                renderer.container.appendChild(w.el);
            }
            var top = renderer.$cursorLayer.getPixelPosition({row: i, column:0}, true).top;
            if (!w.coverLine)
                top += config.lineHeight * this.session.getRowLineCount(w.row);
            w.el.style.top = top - config.offset + "px";
            
            var left = w.coverGutter ? 0 : renderer.gutterWidth;
            if (!w.fixedWidth)
                left -= renderer.scrollLeft;
            w.el.style.left = left + "px";
            
            if (w.fullWidth && w.screenWidth) {
                w.el.style.minWidth = config.width + 2 * config.padding + "px";
            }
            
            if (w.fixedWidth) {
                w.el.style.right = renderer.scrollBar.getWidth() + "px";
            } else {
                w.el.style.right = "";
            }
        }
    };
    
}).call(LineWidgets.prototype);


exports.LineWidgets = LineWidgets;

});

ace.define("ace/ext/error_marker",["require","exports","module","ace/line_widgets","ace/lib/dom","ace/range"], function(acequire, exports, module) {
"use strict";
var LineWidgets = acequire("../line_widgets").LineWidgets;
var dom = acequire("../lib/dom");
var Range = acequire("../range").Range;

function binarySearch(array, needle, comparator) {
    var first = 0;
    var last = array.length - 1;

    while (first <= last) {
        var mid = (first + last) >> 1;
        var c = comparator(needle, array[mid]);
        if (c > 0)
            first = mid + 1;
        else if (c < 0)
            last = mid - 1;
        else
            return mid;
    }
    return -(first + 1);
}

function findAnnotations(session, row, dir) {
    var annotations = session.getAnnotations().sort(Range.comparePoints);
    if (!annotations.length)
        return;
    
    var i = binarySearch(annotations, {row: row, column: -1}, Range.comparePoints);
    if (i < 0)
        i = -i - 1;
    
    if (i >= annotations.length)
        i = dir > 0 ? 0 : annotations.length - 1;
    else if (i === 0 && dir < 0)
        i = annotations.length - 1;
    
    var annotation = annotations[i];
    if (!annotation || !dir)
        return;

    if (annotation.row === row) {
        do {
            annotation = annotations[i += dir];
        } while (annotation && annotation.row === row);
        if (!annotation)
            return annotations.slice();
    }
    
    
    var matched = [];
    row = annotation.row;
    do {
        matched[dir < 0 ? "unshift" : "push"](annotation);
        annotation = annotations[i += dir];
    } while (annotation && annotation.row == row);
    return matched.length && matched;
}

exports.showErrorMarker = function(editor, dir) {
    var session = editor.session;
    if (!session.widgetManager) {
        session.widgetManager = new LineWidgets(session);
        session.widgetManager.attach(editor);
    }
    
    var pos = editor.getCursorPosition();
    var row = pos.row;
    var oldWidget = session.widgetManager.getWidgetsAtRow(row).filter(function(w) {
        return w.type == "errorMarker";
    })[0];
    if (oldWidget) {
        oldWidget.destroy();
    } else {
        row -= dir;
    }
    var annotations = findAnnotations(session, row, dir);
    var gutterAnno;
    if (annotations) {
        var annotation = annotations[0];
        pos.column = (annotation.pos && typeof annotation.column != "number"
            ? annotation.pos.sc
            : annotation.column) || 0;
        pos.row = annotation.row;
        gutterAnno = editor.renderer.$gutterLayer.$annotations[pos.row];
    } else if (oldWidget) {
        return;
    } else {
        gutterAnno = {
            text: ["Looks good!"],
            className: "ace_ok"
        };
    }
    editor.session.unfold(pos.row);
    editor.selection.moveToPosition(pos);
    
    var w = {
        row: pos.row, 
        fixedWidth: true,
        coverGutter: true,
        el: dom.createElement("div"),
        type: "errorMarker"
    };
    var el = w.el.appendChild(dom.createElement("div"));
    var arrow = w.el.appendChild(dom.createElement("div"));
    arrow.className = "error_widget_arrow " + gutterAnno.className;
    
    var left = editor.renderer.$cursorLayer
        .getPixelPosition(pos).left;
    arrow.style.left = left + editor.renderer.gutterWidth - 5 + "px";
    
    w.el.className = "error_widget_wrapper";
    el.className = "error_widget " + gutterAnno.className;
    el.innerHTML = gutterAnno.text.join("<br>");
    
    el.appendChild(dom.createElement("div"));
    
    var kb = function(_, hashId, keyString) {
        if (hashId === 0 && (keyString === "esc" || keyString === "return")) {
            w.destroy();
            return {command: "null"};
        }
    };
    
    w.destroy = function() {
        if (editor.$mouseHandler.isMousePressed)
            return;
        editor.keyBinding.removeKeyboardHandler(kb);
        session.widgetManager.removeLineWidget(w);
        editor.off("changeSelection", w.destroy);
        editor.off("changeSession", w.destroy);
        editor.off("mouseup", w.destroy);
        editor.off("change", w.destroy);
    };
    
    editor.keyBinding.addKeyboardHandler(kb);
    editor.on("changeSelection", w.destroy);
    editor.on("changeSession", w.destroy);
    editor.on("mouseup", w.destroy);
    editor.on("change", w.destroy);
    
    editor.session.widgetManager.addLineWidget(w);
    
    w.el.onmousedown = editor.focus.bind(editor);
    
    editor.renderer.scrollCursorIntoView(null, 0.5, {bottom: w.el.offsetHeight});
};


dom.importCssString("\
    .error_widget_wrapper {\
        background: inherit;\
        color: inherit;\
        border:none\
    }\
    .error_widget {\
        border-top: solid 2px;\
        border-bottom: solid 2px;\
        margin: 5px 0;\
        padding: 10px 40px;\
        white-space: pre-wrap;\
    }\
    .error_widget.ace_error, .error_widget_arrow.ace_error{\
        border-color: #ff5a5a\
    }\
    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\
        border-color: #F1D817\
    }\
    .error_widget.ace_info, .error_widget_arrow.ace_info{\
        border-color: #5a5a5a\
    }\
    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\
        border-color: #5aaa5a\
    }\
    .error_widget_arrow {\
        position: absolute;\
        border: solid 5px;\
        border-top-color: transparent!important;\
        border-right-color: transparent!important;\
        border-left-color: transparent!important;\
        top: -5px;\
    }\
", "");

});

ace.define("ace/ace",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/dom","ace/lib/event","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config"], function(acequire, exports, module) {
"use strict";

acequire("./lib/fixoldbrowsers");

var dom = acequire("./lib/dom");
var event = acequire("./lib/event");

var Editor = acequire("./editor").Editor;
var EditSession = acequire("./edit_session").EditSession;
var UndoManager = acequire("./undomanager").UndoManager;
var Renderer = acequire("./virtual_renderer").VirtualRenderer;
acequire("./worker/worker_client");
acequire("./keyboard/hash_handler");
acequire("./placeholder");
acequire("./multi_select");
acequire("./mode/folding/fold_mode");
acequire("./theme/textmate");
acequire("./ext/error_marker");

exports.config = acequire("./config");
exports.acequire = acequire;

if (true)
    exports.define = __webpack_require__(233);
exports.edit = function(el) {
    if (typeof el == "string") {
        var _id = el;
        el = document.getElementById(_id);
        if (!el)
            throw new Error("ace.edit can't find div #" + _id);
    }

    if (el && el.env && el.env.editor instanceof Editor)
        return el.env.editor;

    var value = "";
    if (el && /input|textarea/i.test(el.tagName)) {
        var oldNode = el;
        value = oldNode.value;
        el = dom.createElement("pre");
        oldNode.parentNode.replaceChild(el, oldNode);
    } else if (el) {
        value = dom.getInnerText(el);
        el.innerHTML = "";
    }

    var doc = exports.createEditSession(value);

    var editor = new Editor(new Renderer(el));
    editor.setSession(doc);

    var env = {
        document: doc,
        editor: editor,
        onResize: editor.resize.bind(editor, null)
    };
    if (oldNode) env.textarea = oldNode;
    event.addListener(window, "resize", env.onResize);
    editor.on("destroy", function() {
        event.removeListener(window, "resize", env.onResize);
        env.editor.container.env = null; // prevent memory leak on old ie
    });
    editor.container.env = editor.env = env;
    return editor;
};
exports.createEditSession = function(text, mode) {
    var doc = new EditSession(text, mode);
    doc.setUndoManager(new UndoManager());
    return doc;
};
exports.EditSession = EditSession;
exports.UndoManager = UndoManager;
exports.version = "1.2.9";
});
            (function() {
                ace.acequire(["ace/ace"], function(a) {
                    if (a) {
                        a.config.init(true);
                        a.define = ace.define;
                    }
                    if (!window.ace)
                        window.ace = a;
                    for (var key in a) if (a.hasOwnProperty(key))
                        window.ace[key] = a[key];
                });
            })();
        
module.exports = window.ace.acequire("ace/ace");

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tableCols; });
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Garantias_ModalCreate__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Garantias_ModalDelete__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Garantias_ModalFilter__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_garantias__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tableCols=[{Id:1,Caption:'Nombre',Value:'nombre',Type:'string',Format:'',Width:'15%',LinkToEdit:true},{Id:2,Caption:'Garantia',Value:'texto',Type:'html',Format:'',Width:'85%'}];function findValues(c,x){var value=x.getIn(c.Value.split('.'));return value;}var Garantias=function(_Component){_inherits(Garantias,_Component);function Garantias(){_classCallCheck(this,Garantias);return _possibleConstructorReturn(this,(Garantias.__proto__||Object.getPrototypeOf(Garantias)).apply(this,arguments));}_createClass(Garantias,[{key:'componentWillMount',value:function componentWillMount(){this.props.getGarantias(1);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,garantias=_props.garantias,orderBy=_props.orderBy,page=_props.page,totalRecords=_props.totalRecords,showRecords=_props.showRecords;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[0]',name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Creación de garantias','create');},title:'Nueva garantia'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[1]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los Garantias seleccionadas?',function(){return _this2.props.deleteGarantias();});},disabled:garantias.filter(function(x){return x.get('selected');}).count()===0,danger:true,title:'Eliminar par\xE1metro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[2]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true);},title:'Filtro'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.getGarantias(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-right'})});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Garantias disponibles',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeRecordsToShow(records);},pagination:pagination}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-garantias'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(e.target.checked);},checked:garantias.filter(function(x){return x.get('selected');}).count()>0&&garantias.filter(function(x){return x.get('selected')&&x.get('visible');}).count()>=garantias.filter(function(x){return x.get('visible');}).count()})),tableCols.map(function(x){var style={width:''+x.Width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.Id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.Value?orderBy.get('asc')?'asc':'desc':''},x.Caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,garantias.filter(function(x){return x.get('visible');}).count()>0?garantias.filter(function(x){return x.get('visible');}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectItem(x.get('id'),e.target.checked);},checked:x.get('selected')})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.Type){switch(c.Type){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.Format);alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.Format);alignment='right';break;case'html':value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'10vh',overflowX:'hidden'},dangerouslySetInnerHTML:{__html:value}});break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Modificación de garantias','edit',x.get('id'));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Garantias_ModalCreate__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Garantias_ModalDelete__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Garantias_ModalFilter__["a" /* default */],null));}}]);return Garantias;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{garantias:state.garantias.get('garantias'),orderBy:state.garantias.get('orderBy'),totalRecords:state.garantias.get('totalRecords'),showRecords:state.garantias.get('showRecords'),page:state.garantias.get('page')};}function mapDispatchToProps(dispatch){return{getGarantias:function getGarantias(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["h" /* getGarantias */])(page));},toggleSelectItem:function toggleSelectItem(id,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["o" /* toggleSelectItem */])(id,checked));},toggleSelectAllItems:function toggleSelectAllItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["n" /* toggleSelectAllItems */])(checked));},filterGarantias:function filterGarantias(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["g" /* filterGarantias */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["j" /* setOrderBy */])(field));},displayModalCreate:function displayModalCreate(show,title,mode,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["f" /* displayModalCreate */])(show,title,mode,id));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["k" /* showHideModalDelete */])(open,message,action));},deleteGarantias:function deleteGarantias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["e" /* deleteGarantias */])());},changeRecordsToShow:function changeRecordsToShow(records){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["c" /* changeRecordsToShow */])(records));},showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_garantias__["l" /* showHideModalFilter */])(state));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Garantias));

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = initReducer;
/* harmony export (immutable) */ __webpack_exports__["s"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["h"] = displayModalAddServicio;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCencoSolicitudServicio;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeCencosSolicitudServicio;
/* harmony export (immutable) */ __webpack_exports__["d"] = addSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["o"] = removeSolicitudServicioItems;
/* harmony export (immutable) */ __webpack_exports__["r"] = toggleSelectAllSolicitudServicioItems;
/* harmony export (immutable) */ __webpack_exports__["q"] = toggleSelectAllSolicitudServicioFiles;
/* harmony export (immutable) */ __webpack_exports__["t"] = uploadFile;
/* harmony export (immutable) */ __webpack_exports__["c"] = addSolicitudServicioFile;
/* harmony export (immutable) */ __webpack_exports__["n"] = removeSolicitudServicioFiles;
/* harmony export (immutable) */ __webpack_exports__["g"] = displayModalAddFile;
/* harmony export (immutable) */ __webpack_exports__["f"] = createSolicitudServicio;
/* harmony export (immutable) */ __webpack_exports__["p"] = removeSolicitudServicioResponsable;
/* harmony export (immutable) */ __webpack_exports__["b"] = addResponsable;
/* harmony export (immutable) */ __webpack_exports__["e"] = addUsuarioResponsable;
/* harmony export (immutable) */ __webpack_exports__["k"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["i"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["j"] = eliminarComentario;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(3);
function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_341" /* REINICIAR_SOLICITUD_SERVICIO_OT */]});};}function updateInputs(path,value){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_218" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT */],payload:{path:path,value:value}});};fn0(dispatch);};}function displayModalAddServicio(show,title,mode,index){return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_244" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_316" /* OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT */]});}};}function addCencoSolicitudServicio(){return function(dispatch,getState){var ordenador_gasto=getState().creacionsolicitudservicioot.get('ordenador_gasto');if(ordenador_gasto===null){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning('Seleccione primero al ordenador del gasto',{bodyClassName:'toastify-content toastify-warning'});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_3" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT */]});}};}function removeCencosSolicitudServicio(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_134" /* ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM */]});};}function addSolicitudServicioItem(){return function(dispatch,getState){var data=getState().creacionsolicitudservicioot.getIn(['modalAddServicio','data']);var errors=[];if(!data.get('descripcion'))errors.push('La creación de servicios requiere de una descripción');if(data.get('cotizado')<0)errors.push('La creación de servicios requiere que el valor del servicio sin IVA sea superior a 0');if(data.get('cotizado_iva')<0)errors.push('La creación de servicios requiere que el valor total sea superior a 0');if(Number(data.get('cotizado_iva'))<Number(data.get('cotizado')))errors.push('El valor total debe ser igual o superior al valor sin IVA');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_13" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT */]});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_316" /* OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT */]});};fn1(dispatch);fn2(dispatch);}};}function removeSolicitudServicioItems(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_155" /* ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT */]});};}function toggleSelectAllSolicitudServicioItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_69" /* CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO_OT */],payload:checked});};}function toggleSelectAllSolicitudServicioFiles(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_66" /* CONMUTAR_SELECCION_TODOS_ITEMS_FILES */],payload:checked});};}function uploadFile(file){return function(dispatch){var fileType=__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["a" /* acceptedFiles */].filter(function(x){return x.type===file.type;});var icon='_blank.png';if(fileType.length===1){icon=fileType[0].icon;}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_218" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT */],payload:{path:'modalAddFile.data.nombre',value:file.name}});};fn0(dispatch);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_218" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT */],payload:{path:'modalAddFile.data.file',value:file,immutable:false}});};fn1(dispatch);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_218" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT */],payload:{path:'modalAddFile.data.icono',value:icon}});};fn2(dispatch);};}function addSolicitudServicioFile(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["U" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT */],payload:data});};fn1(dispatch);};}function removeSolicitudServicioFiles(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_127" /* ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT */]});};}function displayModalAddFile(show,title,mode,index){return function(dispatch){if(show){var fn0=function fn0(d){return d(Object(__WEBPACK_IMPORTED_MODULE_5__common__["l" /* getParameterByName */])('CLASIFICACION_ARCHIVOS'));};fn0(dispatch);dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_243" /* MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_315" /* OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT */]});}};}function createSolicitudServicio(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_95" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_95" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT */],payload:false});};var fn2=function fn2(d){return d(initReducer());};fn0(dispatch);var data=getState().creacionsolicitudservicioot;var errors=validarSolicitud(data);if(errors.length){fn1(dispatch);return errors.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(element,{bodyClassName:'toastify-content toastify-warning'});});}else{var files=data.get('adjuntos');var cotizaciones=files.filter(function(l){return l.get('clasificacion')=='Cotizaciones';});var cotizacionid=cotizaciones.count()>0?cotizaciones.first().get('guid'):null;var index=files.findIndex(function(x){return x.get('guid')==cotizacionid;});if(index>=0){files=files.setIn([index,'editable'],false);}axios.post(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios-oficina-tecnica',data).then(function(res){var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_4__utils_history__["a" /* default */].push(window.FOLDER+'/');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('La solicitud ha sido guardada exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn1,fn2,fn3,fn4]));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function removeSolicitudServicioResponsable(path){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_157" /* ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT */],payload:{path:path}});};}function addResponsable(payload){return function(dispatch,getState){var path=payload.path.split('.')[0];var responsables=getState().creacionsolicitudservicioot.get(path);if(responsables.filter(function(x){return x.get('id')===payload.value.id;}).count()!==0){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn('La persona '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{var responsable=getState().creacionsolicitudservicioot.getIn(payload.path.split('.')).toJS();responsable=Object.assign({},responsable,payload.value);payload.value=responsable;dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["A" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT */],payload:payload});}};}function addUsuarioResponsable(path){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_15" /* ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT */],payload:path});};}function enviarComentario(){return function(dispatch,getState){var guid=getState().creacionsolicitudservicioot.getIn(['comentario','guid']);var comentario=getState().creacionsolicitudservicioot.getIn(['comentario','texto']);var usuario=getState().common.get('user');var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_167" /* ENVIAR_COMENTARIO_SOLICITUD_OT */],payload:{comentario:comentario,guid:guid,usuario:usuario}});};fn1(dispatch);};}function editarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_115" /* EDITAR_COMENTARIO_SOLICITUD_OT */],payload:{guid:guid}});};fn1(dispatch);};}function eliminarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_137" /* ELIMINAR_COMENTARIO_SOLICITUD_OT */],payload:{guid:guid}});};fn1(dispatch);};}// Shared
function validarSolicitud(data){var errors=[];if(data.get('adjuntos').count()>0){var size=data.get('adjuntos').reduce(function(a,b){a+=b.get('file').size;return a;},0);if(size>__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["W" /* uploadMaxSize */].value)errors.push('La capacidad m\xE1xima para subir archivos es de de '+__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["W" /* uploadMaxSize */].unidad);if(data.get('adjuntos').filter(function(x){return!x.get('clasificacion');}).count()>0)errors.push('Todos los archivos deben tener una clasificación');if(data.get('adjuntos').filter(function(x){return x.get('clasificacion')=='Cotizaciones';}).count()==0)errors.push('Debe haber al menos una cotización');}return errors;}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getSolicitudes;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeRecordsToShow;
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleSelectItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["e"] = filterSolicitudes;
/* harmony export (immutable) */ __webpack_exports__["h"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["i"] = showHideModalDelete;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteSolicitudes;
/* harmony export (immutable) */ __webpack_exports__["j"] = showHideModalFilter;
/* harmony export (immutable) */ __webpack_exports__["a"] = addModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["k"] = toggleCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["n"] = updateModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyFilterCriterias;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
function getSolicitudes(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().solicitudes.get('showRecords');var orderBy=getState().solicitudes.get('orderBy');var filters=getState().solicitudes.getIn(['modalFilter','filters']).filter(function(x){return x.get('apply');}).toJS();var having=[];axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/solicitudes',{params:{estado:1,page:page,showRecords:showRecords,orderBy:orderBy,filters:filters,having:having}}).then(function(res){var data=res.data.data.map(function(x){x.visible=true;x.selected=false;return x;});var totalRecords=Number(res.data.totalRecords);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_304" /* OBTENER_SOLICITUDES */],payload:{data:data,page:page,totalRecords:totalRecords}});};fn1(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function changeRecordsToShow(showRecords){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_39" /* CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES */],payload:showRecords});};var fn1=function fn1(d){return d(getSolicitudes(1));};fn0(dispatch);fn1(dispatch);};}function toggleSelectItem(id,checked){return function(dispatch,getState){var index=getState().solicitudes.get('solicitudes').findIndex(function(x){return x.get('id')===id;});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_59" /* CONMUTAR_SELECCION_SOLICITUD */],payload:{index:index,checked:checked}});};}function toggleSelectAllItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_72" /* CONMUTAR_SELECCION_TODOS_SOLICITUDES */],payload:checked});};}function filterSolicitudes(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_177" /* FILTRAR_SOLICITUDES */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().solicitudes.get('orderBy');current=current.set('field',field.value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_330" /* ORDENAR_SOLICITUDES */],payload:{orderBy:current}});};var fn1=function fn1(d){return d(getSolicitudes(1));};fn0(dispatch);fn1(dispatch);};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_253" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD */],payload:{open:open,message:message,action:action}});};}function deleteSolicitudes(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selected=getState().solicitudes.get('solicitudes').filter(function(x){return x.get('selected');}).map(function(x){return x.get('id');});var fns=[];selected.forEach(function(x){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/solicitudes/'+x);};fns.push(fn);});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var succeded=[];var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}else{succeded.push(x.result.data.proyecto_evento);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_158" /* ELIMINAR_SOLICITUD */],payload:x.result.data.id});}});if(succeded.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Se han eliminado los siguentes solicitudes: '+succeded.join(', ')});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});});};}function showHideModalFilter(state,tableCols){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_275" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES */],payload:{state:state,tableCols:tableCols}});};}function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["v" /* ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES */]});};}function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_148" /* ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES */]});};}function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_53" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES */],payload:{index:index,checked:checked}});};}function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_191" /* MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES */],payload:{index:index,attr:attr,value:value}});};}function applyFilterCriterias(){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_27" /* APLICAR_CRITERIOS_FILTRADO_SOLICITUDES */]});};var fn1=function fn1(d){return d(getSolicitudes(1));};fn0(dispatch);fn1(dispatch);};}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getAprobaciones;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeRecordsToShow;
/* harmony export (immutable) */ __webpack_exports__["d"] = filterAprobaciones;
/* harmony export (immutable) */ __webpack_exports__["h"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["i"] = showHideModalFilter;
/* harmony export (immutable) */ __webpack_exports__["a"] = addModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["k"] = toggleCheckedModalFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateModalFilterCriteria;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyFilterCriterias;
/* harmony export (immutable) */ __webpack_exports__["j"] = showHideModalSummary;
/* harmony export (immutable) */ __webpack_exports__["f"] = registerApprovalResult;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateInputs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(3);
function getAprobaciones(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().externosaprobaciones.get('showRecords');var orderBy=getState().externosaprobaciones.get('orderBy');var filters=getState().externosaprobaciones.getIn(['modalFilter','filters']).filter(function(x){return x.get('apply');}).toJS();var having=[];axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/externos/documentos',{params:{estado:1,page:page,showRecords:showRecords,orderBy:orderBy,filters:filters,having:having}}).then(function(res){var data=res.data.data.map(function(x){x.visible=true;x.selected=false;return x;});var totalRecords=Number(res.data.totalRecords);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_292" /* OBTENER_EXTERNOS_APROBACIONES */],payload:{data:data,page:page,totalRecords:totalRecords}});};fn1(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,err);});};}function changeRecordsToShow(showRecords){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_35" /* CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES */],payload:showRecords});};var fn1=function fn1(d){return d(getAprobaciones(1));};fn0(dispatch);fn1(dispatch);};}function filterAprobaciones(term){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_172" /* FILTRAR_EXTERNOS_APROBACIONES */],payload:term});};}function setOrderBy(field){return function(dispatch,getState){var current=getState().externosaprobaciones.get('orderBy');current=current.set('field',field.value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_324" /* ORDENAR_EXTERNOS_APROBACIONES */],payload:{orderBy:current}});};var fn1=function fn1(d){return d(getAprobaciones(1));};fn0(dispatch);fn1(dispatch);};}function showHideModalFilter(state,tableCols){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_269" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES */],payload:{state:state,tableCols:tableCols}});};}function addModalFilterCriteria(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["p" /* ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */]});};}function removeCheckedModalFilterCriterias(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_142" /* ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */]});};}function toggleCheckedModalFilterCriterias(index,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_47" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */],payload:{index:index,checked:checked}});};}function updateModalFilterCriteria(index,attr,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_183" /* MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */],payload:{index:index,attr:attr,value:value}});};}function applyFilterCriterias(){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_21" /* APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES */]});};var fn1=function fn1(d){return d(getAprobaciones(1));};fn0(dispatch);fn1(dispatch);};}function showHideModalSummary(show,id){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){axios.get(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/externos/documentos',{params:{id:id}}).then(function(res){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_280" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES */],payload:{show:show,data:res.data}});};fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,err);});};}function registerApprovalResult(id,result){var ip=__webpack_require__(79);var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var data=getState().externosaprobaciones.getIn(['modalSummary','data']).set('result',result);var errors=validateDocumento(data);if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var modificaciones=[{id:id,entity:'ProveedorAprobacione',value:{estado:result,ip:ip.address(),observaciones:data.get('observaciones')},action:'replace'}];axios.put(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/externos/documentos/'+id,modificaciones).then(function(res){var fn0=function fn0(d){return d(getAprobaciones(1));};fn0(dispatch);Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,{success:'La solicitud ha sido guardada exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,err);});}};}function updateInputs(path,value){return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_198" /* MODIFICAR_INPUTS_EXTERNOS_APROBACIONES */],payload:{path:path,value:value}});};fn0(dispatch);};}///******* Shared ********///
var validateDocumento=function validateDocumento(data){var errors=[];if(!data.get('observaciones')&&data.get('result')==1)errors.push('Debe agregar una observación si va a regresar el documento');return errors;};

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(108);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(160)('keys');
var uid = __webpack_require__(126);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(29);
var global = __webpack_require__(37);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(99) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(47);
var core = __webpack_require__(29);
var fails = __webpack_require__(85);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(65);
var document = __webpack_require__(37).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(65);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(51);
var dPs = __webpack_require__(722);
var enumBugKeys = __webpack_require__(167);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(162)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(270).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(164);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(38);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(37);
var core = __webpack_require__(29);
var LIBRARY = __webpack_require__(99);
var wksExt = __webpack_require__(168);
var defineProperty = __webpack_require__(57).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(130);
var createDesc = __webpack_require__(100);
var toIObject = __webpack_require__(72);
var toPrimitive = __webpack_require__(163);
var has = __webpack_require__(70);
var IE8_DOM_DEFINE = __webpack_require__(263);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(58) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(23);









/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);




/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(750), __esModule: true };

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(103);
var TAG = __webpack_require__(38)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(176);
var ITERATOR = __webpack_require__(38)('iterator');
var Iterators = __webpack_require__(86);
module.exports = __webpack_require__(29).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(127);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* unused harmony export bpfrpt_proptype_CellMeasurerCache */
/* unused harmony export bpfrpt_proptype_Positioner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PositionCache__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













var emptyObject = {};

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Masonry, _React$PureComponent);

  function Masonry() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Masonry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Masonry.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Masonry)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isScrolling: false,
      scrollTop: 0
    }, _this._invalidateOnUpdateStartIndex = null, _this._invalidateOnUpdateStopIndex = null, _this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */](), _this._startIndex = null, _this._startIndexMemoized = null, _this._stopIndex = null, _this._stopIndexMemoized = null, _this._debounceResetIsScrollingCallback = function () {
      _this.setState({
        isScrolling: false
      });
    }, _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    }, _this._onScroll = function (event) {
      var height = _this.props.height;


      var eventScrollTop = event.currentTarget.scrollTop;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);

      // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
      if (eventScrollTop !== scrollTop) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._debounceResetIsScrolling();

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Masonry, [{
    key: 'clearCellPositions',
    value: function clearCellPositions() {
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this.forceUpdate();
    }

    // HACK This method signature was intended for Grid

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var index = _ref2.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: 'recomputeCellPositions',
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;

      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoHeight = _props.autoHeight,
          cellCount = _props.cellCount,
          cellMeasurerCache = _props.cellMeasurerCache,
          cellRenderer = _props.cellRenderer,
          className = _props.className,
          height = _props.height,
          id = _props.id,
          keyMapper = _props.keyMapper,
          overscanByPixels = _props.overscanByPixels,
          role = _props.role,
          style = _props.style,
          tabIndex = _props.tabIndex,
          width = _props.width,
          rowDirection = _props.rowDirection;
      var _state = this.state,
          isScrolling = _state.isScrolling,
          scrollTop = _state.scrollTop;


      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;

      var startIndex = 0;
      var stopIndex = void 0;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, rowDirection === 'ltr' ? 'left' : 'right', left), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'position', 'absolute'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'top', top), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'width', cellMeasurerCache.getWidth(index)), _style)
        }));
      });

      // We need to measure additional cells for this layout
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;

          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])('ReactVirtualized__Masonry', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            boxSizing: 'border-box',
            direction: 'ltr',
            height: autoHeight ? 'auto' : height,
            overflowX: 'hidden',
            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
            position: 'relative',
            width: width,
            WebkitOverflowScrolling: 'touch',
            willChange: 'transform'
          }, style),
          tabIndex: tabIndex },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Masonry__innerScrollContainer',
            style: {
              width: '100%',
              height: estimateTotalHeight,
              maxWidth: '100%',
              maxHeight: estimateTotalHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            } },
          children
        )
      );
    }
  }, {
    key: '_checkInvalidateOnUpdate',
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var _startIndex = this._invalidateOnUpdateStartIndex;
        var _stopIndex = this._invalidateOnUpdateStopIndex;

        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;

        // Query external layout logic for position of newly-measured cells
        this._populatePositionCache(_startIndex, _stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: '_debounceResetIsScrolling',
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_getEstimatedTotalHeight',
    value: function _getEstimatedTotalHeight() {
      var _props2 = this.props,
          cellCount = _props2.cellCount,
          cellMeasurerCache = _props2.cellMeasurerCache,
          width = _props2.width;


      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));

      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: '_invokeOnScrollCallback',
    value: function _invokeOnScrollCallback() {
      var _props3 = this.props,
          height = _props3.height,
          onScroll = _props3.onScroll;
      var scrollTop = this.state.scrollTop;


      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });

        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: '_invokeOnCellsRenderedCallback',
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var _onCellsRendered = this.props.onCellsRendered;


        _onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });

        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: '_populatePositionCache',
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _props4 = this.props,
          cellMeasurerCache = _props4.cellMeasurerCache,
          cellPositioner = _props4.cellPositioner;


      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            _left = _cellPositioner.left,
            _top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Masonry.defaultProps = {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
};
Masonry.propTypes =  true ? null : {
  autoHeight: PropTypes.bool.isRequired,
  cellCount: PropTypes.number.isRequired,
  cellMeasurerCache: function cellMeasurerCache() {
    return (typeof CellMeasurerCache === 'function' ? PropTypes.instanceOf(CellMeasurerCache).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellPositioner: function cellPositioner() {
    return (typeof Positioner === 'function' ? PropTypes.instanceOf(Positioner).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellRenderer: function cellRenderer() {
    return (typeof CellRenderer === 'function' ? PropTypes.instanceOf(CellRenderer).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  id: PropTypes.string,
  keyMapper: function keyMapper() {
    return (typeof KeyMapper === 'function' ? PropTypes.instanceOf(KeyMapper).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  onCellsRendered: function onCellsRendered() {
    return (typeof OnCellsRenderedCallback === 'function' ? PropTypes.instanceOf(OnCellsRenderedCallback) : PropTypes.any).apply(this, arguments);
  },
  onScroll: function onScroll() {
    return (typeof OnScrollCallback === 'function' ? PropTypes.instanceOf(OnScrollCallback) : PropTypes.any).apply(this, arguments);
  },
  overscanByPixels: PropTypes.number.isRequired,
  role: PropTypes.string.isRequired,
  scrollingResetTimeInterval: PropTypes.number.isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  tabIndex: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  rowDirection: PropTypes.string.isRequired
};


function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : {
  defaultHeight: PropTypes.number.isRequired,
  defaultWidth: PropTypes.number.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(Masonry);

/* harmony default export */ __webpack_exports__["a"] = (Masonry);

var bpfrpt_proptype_Positioner =  true ? null : PropTypes.func;





/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(54);
var global = __webpack_require__(59);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(302) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 181 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(183);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(302);
var $export = __webpack_require__(53);
var redefine = __webpack_require__(91);
var hide = __webpack_require__(89);
var Iterators = __webpack_require__(106);
var $iterCreate = __webpack_require__(836);
var setToStringTag = __webpack_require__(187);
var getPrototypeOf = __webpack_require__(840);
var ITERATOR = __webpack_require__(44)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(180)('keys');
var uid = __webpack_require__(135);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(73).f;
var has = __webpack_require__(92);
var TAG = __webpack_require__(44)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(181);
var TAG = __webpack_require__(44)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(323);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(191);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(336);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(349);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(348);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(342);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(200);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(140);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(202);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(207);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(208);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(210);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(143);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(109);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(212);
/* unused harmony reexport withRouter */





















/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(108);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(143);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(360)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(109);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(144);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processStyleName = undefined;
exports.createMarkupForStyles = createMarkupForStyles;

var _camelizeStyleName = __webpack_require__(364);

var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);

var _dangerousStyleValue = __webpack_require__(366);

var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);

var _hyphenateStyleName = __webpack_require__(369);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _memoizeStringOnly = __webpack_require__(371);

var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);

var _warning = __webpack_require__(214);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
                                                                                                                   * Copyright 2013-present, Facebook, Inc.
                                                                                                                   * All rights reserved.
                                                                                                                   *
                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                   *
                                                                                                                   * @providesModule CSSPropertyOperations
                                                                                                                   */

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function checkRenderMessage(owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function warnValidStyle(name, value, component) {
    //eslint-disable-line no-var
    var owner = void 0;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */

function createMarkupForStyles(styles, component) {
  var serialized = '';
  for (var styleName in styles) {
    var isCustomProp = styleName.indexOf('--') === 0;
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }
    if (styleName === 'label') {
      continue;
    }
    var styleValue = styles[styleName];
    if (false) {
      warnValidStyle(styleName, styleValue, component);
    }
    if (styleValue != null) {
      if (isCustomProp) {
        serialized += styleName + ':' + styleValue + ';';
      } else {
        serialized += processStyleName(styleName) + ':';
        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
      }
    }
  }
  return serialized || null;
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(368);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (obj) {
  var values = [];
  Object.keys(obj).forEach(function (key) {
    return values.push(obj[key]);
  });
  return values;
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.falseOrElement = exports.falseOrNumber = undefined;
exports.typeOf = typeOf;
exports.isValidDelay = isValidDelay;

var _react = __webpack_require__(0);

function typeOf(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1);
}

function isValidDelay(val) {
  return typeOf(val) === 'Number' && !isNaN(val) && val > 0;
}

function withRequired(fn) {
  fn.isRequired = function (props, propName, componentName) {
    var prop = props[propName];

    if (typeof prop === 'undefined') {
      return new Error('The prop ' + propName + ' is marked as required in \n      ' + componentName + ', but its value is undefined.');
    }

    fn(props, propName, componentName);
  };
  return fn;
}

/**
 * TODO: Maybe rethink about the name
 */
var falseOrNumber = exports.falseOrNumber = withRequired(function (props, propName, componentName) {
  var prop = props[propName];

  if (prop !== false && !isValidDelay(prop)) {
    return new Error(componentName + ' expect ' + propName + ' \n      to be a valid Number > 0 or equal to false. ' + prop + ' given.');
  }

  return null;
});

var falseOrElement = exports.falseOrElement = withRequired(function (props, propName, componentName) {
  var prop = props[propName];

  if (prop !== false && !(0, _react.isValidElement)(prop)) {
    return new Error(componentName + ' expect ' + propName + ' \n      to be a valid react element or equal to false. ' + prop + ' given.');
  }

  return null;
});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var eventManager = {
  eventList: new Map(),

  on: function on(event, callback) {
    this.eventList.has(event) || this.eventList.set(event, []);

    this.eventList.get(event).push(callback);

    return this;
  },
  off: function off() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return this.eventList.delete(event);
  },
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!this.eventList.has(event)) {
      /* eslint no-console: 0 */
      console.warn("<" + event + "> Event is not registered. Did you forgot to bind the event ?");
      return false;
    }

    this.eventList.get(event).forEach(function (callback) {
      return setTimeout(function () {
        return callback.call.apply(callback, [_this].concat(_toConsumableArray(args)));
      }, 0);
    });

    return true;
  }
};

exports.default = eventManager;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var settle = __webpack_require__(411);
var buildURL = __webpack_require__(413);
var parseHeaders = __webpack_require__(414);
var isURLSameOrigin = __webpack_require__(415);
var createError = __webpack_require__(221);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(416);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(417);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(412);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=2)}([function(e,t){e.exports=__webpack_require__(148)},function(e,t){e.exports=__webpack_require__(429)},function(e,t,r){"use strict";r.r(t);var n=r(0),i=r.n(n);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(t){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this._turnNegatives(t.digits),new g(t)}var t,r,n;return t=e,n=[{key:"_subDigits",value:function(e,t,r){var n=e.after.length>t.after.length?e.after.length:t.after.length,i=e.before.length>t.before.length?e.before.length:t.before.length,a=!1,o=u(n,"after"),s=u(i,"before");return new A({before:s,after:o,e:0,negative:r});function u(r,n){for(var i=[],o=r-1;o>=0;o--){var s="after"===n?o:o-(r-e[n].length),u="after"===n?o:o-(r-t[n].length),l=Number(e[n][s])||0,f=Number(t[n][u])||0;a&&(0==l?l=9:(l--,a=!1)),l<f?(i[o]=10+l-f,a=!0):i[o]=l-f}return i}}}],(r=[{key:"_turnNegatives",value:function(e){for(var t=1;t<e.length;t++)e[t].negative=!e[t].negative}}])&&a(t.prototype,r),n&&a(t,n),e}(),s=function(e){return e%1==0},u=function(e,t){for(var r=[],n=0;n<t;n++)r[n]=e;return r},l=function(e,t){if(e[t]<=9)return 0;var r=e[t]%10,n=(e[t]-r)/10;return e[t]=r,n},f=function(e,t){if(e.before.length>t.before.length)return!0;if(e.before.length<t.before.length)return!1;for(var r=0;r<e.before.length;r++){var n=Number(e.before[r]),i=Number(t.before[r]);if(n>i)return!0;if(n<i)return!1}for(var a=0;;){var o=Number(e.after[a]),s=Number(t.after[a]);if(Number.isNaN(o)&&Number.isNaN(s))return!1;if(o>s||Number.isNaN(s))return!0;if(o<s||Number.isNaN(o))return!1;a++}},c=function(e,t){var r=0===t,n=t===e.length-1;return{first:r,last:n,item:e[t],index:t,previous:r?null:e[t-1],next:n?null:e[t+1]}};function h(e){if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(e=function(e,t){if(!e)return;if("string"==typeof e)return d(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(r);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return d(e,t)}(e))){var t=0,r=function(){};return{s:r,n:function(){return t>=e.length?{done:!0}:{done:!1,value:e[t++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var n,i,a=!0,o=!1;return{s:function(){n=e[Symbol.iterator]()},n:function(){var e=n.next();return a=e.done,e},e:function(e){o=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(o)throw i}}}}function d(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function v(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var g=function(){function e(t){var r=t.digits,n=t.addToFirst,i=void 0!==n&&n;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.beforeTens=0,this.addToFirst=i;var a,s={neg:[],pos:[]},u=h(r);try{for(u.s();!(a=u.n()).done;){var l=a.value;s[l.negative?"neg":"pos"].push(l),l.removeE()}}catch(e){u.e(e)}finally{u.f()}var c=!!s.pos.length,d=!!s.neg.length;if(!d||!c)return this._addDigits(s[c?"pos":"neg"],d);var v=1===s.neg.length?s.neg[0]:this._addDigits(s.neg,!0),g=1===s.pos.length?s.pos[0]:this._addDigits(s.pos,!1),p=f(v,g),b=p?v:g,m=p?g:v;return o._subDigits(b,m,p)}var t,r,n;return t=e,(r=[{key:"_addDigits",value:function(e,t){switch(e.reduce(this._reduceAfter.bind(this)),e.reduce(this._reduceBefore.bind(this)),this.addToFirst){case!0:return e[0].before=this.sumBefore,e[0].after=this.sumAfter,e[0].e=0,e[0].negative=t,e[0];default:return new A({before:this.sumBefore,after:this.sumAfter,e:0,negative:t})}}},{key:"_reduceAfter",value:function(e,t,r,n){for(var i=e.after.length>t.after.length?e:t,a=i.after,o=i===e?t.after:e.after,s=0,u=o.length-1;u>=0;u--)a[u]=Number(a[u])+Number(o[u])+s,s=l(a,u);return this.beforeTens+=s,s=0,r===n.length-1&&(this.sumAfter=a),i}},{key:"_reduceBefore",value:function(e,t,r,n){for(var i=e.before.length>t.before.length?e:t,a=i.before,o=i===e?t.before:e.before,s=0;s<a.length;s++){var u=o.length-1-s,f=a.length-1-s;if(a[f]=Number(a[f])+(u>=0?Number(o[u]):0)+this.beforeTens,this.beforeTens=l(a,f),0===u&&0===this.beforeTens)break}return this.beforeTens>0&&a.unshift(this.beforeTens),this.beforeTens=0,r===n.length-1&&(this.sumBefore=a),i}}])&&v(t.prototype,r),n&&v(t,n),e}();function p(e){return(p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function b(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&m(e,t)}function m(e,t){return(m=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function y(e){return function(){var t,r=E(e);if(w()){var n=E(this).constructor;t=Reflect.construct(r,arguments,n)}else t=r.apply(this,arguments);return _(this,t)}}function _(e,t){return!t||"object"!==p(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function w(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}function E(e){return(E=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function k(e){return function(e){if(Array.isArray(e))return S(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return S(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(r);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return S(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function S(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function x(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function D(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var C=function(){function e(t,r){var n=t.digit,i=t.places,a=t.trim;if(x(this,e),this.action=r,this.digit=n,this.digit.removeE(),this.places=i,this.trim=a,0===this.places)return this.digit;this.mode=this.places>0?"before":"after";var o="before"===this.mode?this.places-1:0;"after"===this.mode&&(this.places*=-1),"before"===this.mode&&(this.places=this.digit.before.length-this.places+1);var s=this._reduceRight();return null===s?new A({before:[0],after:[],e:0,negative:!1}):(this._round(s),this._addZeros(o),this.digit.trimZeros(),this._fillZeros(i),this.digit)}var t,r,n;return t=e,(r=[{key:"_fillZeros",value:function(e){var t=Math.abs(e);if(!(!0===this.trim||e>=0||this.digit.after.length>=t))for(;this.digit.after.length<t;)this.digit.after.push(0)}},{key:"_reduceRight",value:function(){return"ceil"!==this.action&&this.places<0&&"before"===this.mode?null:(this.places<0&&(this.places=0),this.digit[this.mode].splice(this.places,this.digit[this.mode].length-this.places).concat("before"===this.mode?this.digit.after.splice(0,this.digit.after.length):[]))}},{key:"_round",value:function(e){function t(){for(var e=this.digit.after.length-1;e>=0;e--){if(Number(this.digit.after[e])<10)return;var t=e-1<0;e===this.digit.after.length-1?this.digit.after.pop():this.digit.after[e]=0,this.digit[t?"before":"after"][t?this.digit.before.length-1:e-1]++}for(var r=this.digit.before.length-1;r>=0;r--){if(Number(this.digit.before[r])<10)return;var n=r-1<0;this.digit.before[r]=0,n?this.digit.before.unshift(1):this.digit.before[r-1]++}}"floor"!==this.action&&e.length&&("round"===this.action?function(){return Number(e[0])>=5}.call(this):function(){for(var t in e)if(Number(e[t])>0)return!0;return!1}.call(this))&&(this.digit.after.length?(this.digit.after[this.digit.after.length-1]++,t.call(this)):this.digit.before.length?(this.digit.before[this.digit.before.length-1]++,t.call(this)):this.digit.before[0]=1)}},{key:"_addZeros",value:function(e){var t;this.digit.before.length?(t=this.digit.before).push.apply(t,k(u(0,e))):this.digit.before[0]=0}}])&&D(t.prototype,r),n&&D(t,n),e}(),T=function(e){b(r,e);var t=y(r);function r(e){return x(this,r),t.call(this,e,"round")}return r}(C),N=function(e){b(r,e);var t=y(r);function r(e){return x(this,r),t.call(this,e,"ceil")}return r}(C),O=function(e){b(r,e);var t=y(r);function r(e){return x(this,r),t.call(this,e,"floor")}return r}(C);function j(e){return function(e){if(Array.isArray(e))return I(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return I(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(r);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return I(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function I(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function P(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var A=function(){function e(t){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),i()(t,Object))this.negative=t.negative,this.before=t.before,this.after=t.after,this.e=t.e;else{this.print=i()(t,String)?t:String(t);var r=/^\s*([+-]?)(\d*)(?:(?:([.,])(\d+)))?(?:e([+-]\d+))?\s*$/.exec(this.print);this.negative="-"===r[1],this.before=(r[2]||"0").split(""),this.after=(r[4]||"").split(""),this.e=r[5]?Number(r[5]):0}this.trimZeros()}var t,r,n;return t=e,(r=[{key:"trimZeros",value:function(){for(;this.before.length>1&&0==this.before[0];)this.before.shift();for(;this.after.length&&0==this.after[this.after.length-1];)this.after.pop();this.before.length||(this.before[0]=0)}},{key:"setExponential",value:function(e,t){if(!this.after.length&&this.before.length>=t)for(;this.before.length>1&&0==this.before[this.before.length-1];)this.before.pop(),this.e++;else if(this.beforeEqualsZero&&this.after.length>=e){for(;0==this.after[0];)this.after.shift(),this.e--;this.after.length?(this.before[0]=this.after.shift(),this.e--):this.before[0]=0}}},{key:"reduceE",value:function(){if(this.e>0){var e,t=this.after.splice(0,this.e);(e=this.before).push.apply(e,j(t)),this.e=this.e-t.length}if(this.e<0){var r,n=this.before.length+this.e,i=n<0?0:n,a=this.before.splice(i,this.before.length-i);(r=this.after).unshift.apply(r,j(a)),this.e=this.e+a.length,this.before.length||(this.before[0]=0)}this.trimZeros()}},{key:"removeE",value:function(e){var t,r;i()(e,Number)&&(this.e+=e),this.reduceE(),this.e>0&&(t=this.before).push.apply(t,j(u(0,this.e))),this.e<0&&(r=this.after).unshift.apply(r,j(u(0,-1*this.e))),this.e=0}},{key:"toString",value:function(){return(!this.negative||this.beforeEqualsZero&&!this.after.length?"":"-")+(this.before.length?this.before.join(""):"0")+(this.after.length?"."+this.after.join(""):"")+(this.e>0?"e+"+String(this.e):this.e<0?"e"+String(this.e):"")}},{key:"toIntegers",value:function(){var e;this.after.length&&(this.e-=this.after.length,(e=this.before).push.apply(e,j(this.after.splice(0,this.after.length)))),this.e>0&&this.removeE(),this.trimZeros()}},{key:"negate",value:function(){this.negative=!this.negative}},{key:"floor",value:function(e){new O({digit:this,places:e})}},{key:"round",value:function(e){new T({digit:this,places:e})}},{key:"add",value:function(e){new g({digits:[this,e],addToFirst:!0})}},{key:"equalsZero",get:function(){return 0==this.toString()}},{key:"equalsTenths",get:function(){return this.trimZeros(),!(1!=this.before[0]||this.after.length||!this.before.every((function(e,t){return 0===t||0==e})))||!(1!=this.after[this.after.length-1]||!this.beforeEqualsZero||!this.after.every((function(e,t,r){return t===r.length-1||0==e})))}},{key:"beforeEqualsZero",get:function(){return 1===this.before.length&&0==this.before[0]}}])&&P(t.prototype,r),n&&P(t,n),e}();function R(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var Z=function(){function e(t){var r,n=this,i=t.digits,a=t.zeroValue,o=void 0===a?-1:a,s=t.power,u=void 0===s?null:s;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),o>=0)return new A({before:[0],after:[],e:0,negative:!1});if(i[0].toIntegers(),null===u)r=i.reduce((function(e,t){return t.toIntegers(),n.constructor._mulDigits(e,t)}));else{r=i[0];for(var l=0;l<u-1;l++)r=this.constructor._mulDigits(r,i[0])}return r.removeE(),r}var t,r,n;return t=e,n=[{key:"_mulDigits",value:function(e,t){var r=[],n=e.before.length+t.before.length-1,i=e.equalsTenths,a=t.equalsTenths;if(i||a)return i&&e.setExponential(1,1),a&&t.setExponential(1,1),new A({before:i?t.before.slice():e.before.slice(),after:i?t.after.slice():e.after.slice(),e:e.e+t.e,negative:!(e.negative&&t.negative||!e.negative&&!t.negative)});for(var o=n-1,s=e.before.length-1;s>=0;s--,o--)for(var u=0,f=t.before.length-1;f>=0;f--,u++)r[o-u]=r[o-u]||0,r[o-u]+=e.before[s]*t.before[f];for(var c=r.length-1;c>=0;c--){var h=l(r,c);c-1>=0&&(r[c-1]+=h)}for(;h>0;)r.unshift(h),h=l(r,0);return new A({before:r,after:[],e:e.e+t.e,negative:!(e.negative&&t.negative||!e.negative&&!t.negative)})}}],(r=null)&&R(t.prototype,r),n&&R(t,n),e}();function q(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var V=function(){function e(t){var r=this,n=t.maxDecimal,i=t.digits,a=t.divideByZeroError,o=t.divisionError;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.maxDecimal=n,this._mapZeroDigits(i),this.zeroDigits.first&&null===this.zeroDigits.next?new A(0):this.zeroDigits.next?o(a,this.zeroDigits.next):(this.result=function(e,t,r){for(var n=arguments.length>=3,i=n?r:e[0],a=n?0:1;a<e.length;a++){var o=e[a],s=t(i,o);i=s}return i}(i,(function(e,t){return r._divDigits(e,t,!1)})),this.result.round(0===this.maxDecimal?1:-this.maxDecimal),this.result.removeE(),this.result)}var t,r,n;return t=e,(r=[{key:"_mapZeroDigits",value:function(e){var t=this;this.zeroDigits={first:!1,next:null},e.some((function(e,r){if(e.equalsZero){if(0!==r)return t.zeroDigits.next=r,!0;t.zeroDigits.first=!0}}))}},{key:"_divDigits",value:function(e,t){var r=function(){return-(t.e-e.e)},n=function(){return!(e.negative&&t.negative||!e.negative&&!t.negative)};if(t.equalsTenths)return t.setExponential(1,1),e.e=r(),e.negative=n(),e;e.toIntegers(),t.toIntegers();var i=r(),a=n();t.negative=!1,t.e=0;for(var s,u,l=new A(0),c=b(t,14),h=0;;){e.negative=!1,e.e=0;var d=b(e,15),v=Math.floor(d.value/c.value);if(v<1){var g=c.extracted.length-d.extracted.length||1;e.removeE(g),h-=g}else{var p=new A(v);if(p.e=d.left-c.left,s=new Z({digits:[p,t]}),u=new o({digits:[e,s]}),p.e+=h,l.add(p),e=u,!f(t,u))continue}if(u&&0==u.toString()||l.after.length-i>=this.maxDecimal+1)break}return l.e=i,l.negative=a,l.floor(-(this.maxDecimal+1)),l;function b(e,t){var r=e.before.slice(0,t),n=e.before.length-r.length,i=Number(r.join(""));return{extracted:r,left:n,value:i}}}}])&&q(t.prototype,r),n&&q(t,n),e}();function B(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var M=function(){function e(t){var r=t.digit,n=t.power;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.digit=r,this.power=n,this.digitPower=new A(this.power),this.digitPower.equalsZero?new A({before:[1],after:[],e:0,negative:!1}):this.digit.equalsZero?new A({before:[0],after:[],e:0,negative:!1}):this.digit.equalsTenths?(this.digit.setExponential(1,1),this.digit.e*=this.power,this.digit.removeE(),this._setTenthsNegative(),this.digit):new Z({digits:[this.digit],power:this.power})}var t,r,n;return t=e,(r=[{key:"_setTenthsNegative",value:function(){var e=this.power/2,t=e===Math.round(e);this.digit.negative&&t&&(this.digit.negative=!1)}}])&&B(t.prototype,r),n&&B(t,n),e}(),z=r(1),$=r.n(z);function F(e){return(F="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function U(e){return function(e){if(Array.isArray(e))return H(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||G(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function L(e){if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(e=G(e))){var t=0,r=function(){};return{s:r,n:function(){return t>=e.length?{done:!0}:{done:!1,value:e[t++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var n,i,a=!0,o=!1;return{s:function(){n=e[Symbol.iterator]()},n:function(){var e=n.next();return a=e.done,e},e:function(e){o=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(o)throw i}}}}function G(e,t){if(e){if("string"==typeof e)return H(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(r):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?H(e,t):void 0}}function H(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function J(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function K(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function Q(e,t,r){return t&&K(e.prototype,t),r&&K(e,r),e}var W=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t.length-1;J(this,e),this.elements=t.splice(r,n-r+1),this.print=this.printScope(this.elements),"("===this.elements[0]&&this.elements.shift(),")"===this.elements[this.elements.length-1]&&this.elements.pop()}return Q(e,[{key:"printScope",value:function(t){var r,n="",a=L(t);try{for(a.s();!(r=a.n()).done;){var o=r.value;i()(o,String)&&(n+=o),i()(o,e)&&(n+=o.print)}}catch(e){a.e(e)}finally{a.f()}return n}}]),e}(),X=function(){function e(t,r){J(this,e),this.type=r,this.print=t,this.adjacent=!/\s$/.test(t)}return Q(e,[{key:"digitChar",get:function(){return(this.add||this.sub)&&/[+-]$/.test(this.print)}},{key:"add",get:function(){return"add"===this.type}},{key:"sub",get:function(){return"sub"===this.type}},{key:"mul",get:function(){return"mul"===this.type}},{key:"div",get:function(){return"div"===this.type}}]),e}(),Y=function(){function e(t){var r=this,n=t.formula,i=t.chars,a=t.maxDecimal,o=t.invalidError,s=t.divisionError,u=t.unsafeError;J(this,e),this.maxDecimal=a,this.invalidError=o,this.divisionError=s,this.unsafeError=u,this.result=null;var l=[this,"_seekIllegalChars","_cutParentheses","_validateParentheses","_createParenthesesScopes","_resolveParenthesesScopes"],f="\\d*[".concat(i.decimalChar,"]?\\d+(?:e[+-]\\d+)?"),c={formula:n,chars:i,reg:{split:new RegExp("\\s*((".concat(f,")|([-+").concat(i.divChar).concat(i.mulChar,"])|(.))\\s*"),"g"),digitRegExp:new RegExp("^\\s*".concat(f,"\\s*$")),charsRegExp:new RegExp("^\\s*(?:([+])|([-])|([".concat(i.mulChar,"])|([").concat(i.divChar,"]))\\s*$"))}};if($()([l],{context:c,timeout:null},(function(e,t,n){return r.result=n}),(function(e,t){var r=t.type,n=t.error,i=t.args,a=void 0===i?[]:i;return r(n.apply(void 0,U(a)))})),null!==this.result)return this.result}return Q(e,[{key:"_seekIllegalChars",value:function(e,t,r){if(/^\s*$/.test(r.formula))return this.invalidError(this.errorDefaults.emptyFormula());var n=new RegExp("[^0-9e()\\s-+".concat(r.chars.decimalChar).concat(r.chars.divChar).concat(r.chars.mulChar,"]")),i=r.formula.match(n);if(i&&i.length)return this.invalidError(this.errorDefaults.illegalCharacter(i[0]));e()}},{key:"_cutParentheses",value:function(e,t,r){var n=/(\(|\))/g;r.allCollection=r.formula.split(n),r.parenthesesCollection=r.formula.match(n),e()}},{key:"_validateParentheses",value:function(e,t,r){var n=0,i=0,a=0,o=!1;if(!r.parenthesesCollection)return e();var s,u=L(r.parenthesesCollection);try{for(u.s();!(s=u.n()).done;){var l=s.value;"("===l&&(n++,a++),")"===l&&(i++,a--),a<0&&(o=!0)}}catch(e){u.e(e)}finally{u.f()}if(n!==i){var f={side:n>i?"closing":"opening",num:Math.abs(n-i)};return this.invalidError(this.errorDefaults.missingParenthesis(f.side,f.num))}if(o)return this.invalidError(this.errorDefaults.invalidParenthesesOrder());e()}},{key:"_createParenthesesScopes",value:function(e,t,r){r.scopeOrder=[],function e(t){for(var n=null,i=0;i<t.length;i++){var a=t[i];if("("===a)n=i;else if(")"===a){var o=new W(t,n,i);t.splice(n,0,o),r.scopeOrder.push(o),e(t)}else if(/^\s*$/.test(a)){t.splice(i,1),i--;continue}}}(r.allCollection),r.scopeOrder.push(new W(r.allCollection)),e()}},{key:"_resolveParenthesesScopes",value:function(e,t,r){var n,i=[],a=[this,"_splitEquation","_parseDigitsChars","_validateScopeElements","_computeScope"],o=L(r.scopeOrder);try{var s=function(){var e=n.value;i.push((function(t,n){var i={root:r,scopeEquation:e};$()([a],{context:i,timeout:null},t,(function(e,t){return n(t)}))}))};for(o.s();!(n=o.n()).done;)s()}catch(e){o.e(e)}finally{o.f()}$.a.all(i,{context:r,timeout:null},(function(t,r){var n=r.scopeOrder[r.scopeOrder.length-1].result;return n.removeE(),e(n)}),(function(e,r){return t(r)}))}},{key:"_splitEquation",value:function(e,t,r){var n,a=[],o=L(r.scopeEquation.elements);try{for(o.s();!(n=o.n()).done;){var s=n.value;i()(s,String)?a.push.apply(a,U(s.match(r.root.reg.split))):a.push(s)}}catch(e){o.e(e)}finally{o.f()}r.equationItems=a,e()}},{key:"_parseDigitsChars",value:function(e,t,r){for(var n=this,a=[],o=function(e){var o=c(r.equationItems,e).item;if(i()(o,W))return a.push(o),"continue";var s=o.match(r.root.reg.digitRegExp);if(s)return a.push(new A(s[0])),"continue";var u=o.match(r.root.reg.charsRegExp);return u?(u.some((function(e,t){var r=t>0&&e;return r&&a.push(new X(u[0],["add","sub","mul","div"][t-1])),r})),"continue"):{v:t({type:n.invalidError,error:n.errorDefaults.illegalCombination,args:[r.scopeEquation.print,o]})}},s=0;s<r.equationItems.length;s++){var u=o(s);switch(u){case"continue":continue;default:if("object"===F(u))return u.v}}r.collection=a,e()}},{key:"_validateScopeElements",value:function(e,t,r){for(var n=0;n<r.collection.length;n++){var a=c(r.collection,n),o=a.item,s=a.previous,u=a.next,l=a.first,f=a.last;if(i()(o,A)){if(i()(u,A))return t({type:this.invalidError,error:this.errorDefaults.illegalCombination,args:[r.scopeEquation.print,o.print+u.print]});i()(u,W)&&r.collection.splice(++n,0,new X("*","mul"))}else if(i()(o,X))switch(!0){case l&&(o.div||o.mul||i()(u,X))||i()(s,X)&&i()(u,X):case f:case l&&!o.adjacent&&i()(u,A):case i()(u,X)&&(u.mul||u.div||!u.digitChar):return t({type:this.invalidError,error:this.errorDefaults.illegalCombination,args:[r.scopeEquation.print,(l?"":s.print)+o.print+(f?"":u.print)]});case l||i()(s,X):o.sub&&i()(u,A)&&u.negate(),o.sub&&i()(u,W)&&u.result.negate(),r.collection.splice(n,1),n--}else i()(o,W)&&i()(u,[W,A])&&r.collection.splice(++n,0,new X("*","mul"))}e()}},{key:"_computeScope",value:function(e,t,r){for(var n=this,a=0;a<r.collection.length;a++){var s=c(r.collection,a),u=s.item,l=s.previous,f=s.next;if(i()(u,X)&&(u.mul||u.div)){var h=i()(l,A)?l:l.result,d=i()(f,A)?f:f.result;if(u.mul&&r.collection.splice(a-1,3,new Z({digits:[h,d],zeroValue:h.equalsZero?0:d.equalsZero?1:-1})),u.div){var v=!1;if(r.collection.splice(a-1,3,new V({digits:[h,d],maxDecimal:this.maxDecimal,divideByZeroError:this.errorDefaults.divideByZero(r.scopeEquation.print),divisionError:function(e){return v=!0,t({type:n.divisionError,error:function(){return e}})}})),v)return}a--}}for(var p=0;p<r.collection.length;p++){var b=c(r.collection,p),m=b.item,y=b.previous,_=b.next;if(i()(m,X)&&(m.add||m.sub)){var w=i()(y,A)?y:y.result,E=i()(_,A)?_:_.result;m.add&&r.collection.splice(p-1,3,new g({digits:[w,E]})),m.sub&&r.collection.splice(p-1,3,new o({digits:[w,E]})),p--}}if(!r.collection.length)return t({type:this.invalidError,error:this.errorDefaults.emptyParentheses});r.scopeEquation.result=i()(r.collection[0],A)?r.collection[0]:r.collection[0].result,e()}},{key:"signDescriptor",get:function(){return{div:"division",mul:"multiplication",add:"addition",sub:"subtraction"}}},{key:"errorDefaults",get:function(){return{emptyFormula:function(){return new Error("The [String] formula cannot be empty.")},missingParenthesis:function(e,t){return new Error("The ".concat(t," ").concat(e," parenthes").concat(t>1?"es are":"is is"," missing in the [String] formula."))},invalidParenthesesOrder:function(){return new Error("The closing parenthesis has been placed before the opening parenthesis in the [String] formula.")},illegalCharacter:function(e){return new Error("The [String] formula contains illegal character ".concat(e))},illegalCombination:function(e,t){return new Error("Invalid '".concat(e,"' expression. It contains illegal combination: '").concat(t,"'."))},emptyParentheses:function(){return new Error("The [String] formula cannot contain empty parentheses scope.")},divideByZero:function(e){return new Error("Invalid '".concat(e,"' expression. The division by zero is not allowed."))}}}}]),e}();function ee(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function te(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function re(e,t,r){return t&&te(e.prototype,t),r&&te(e,r),e}t.default=new(function(){function e(){ee(this,e)}return re(e,[{key:"add",value:function(){return new ne(arguments,"add")._algebra()}},{key:"sub",value:function(){return new ne(arguments,"sub")._algebra()}},{key:"mul",value:function(){return new ne(arguments,"mul")._algebra()}},{key:"div",value:function(){return new ne(arguments,"div")._algebra()}},{key:"formula",value:function(){return new ne(arguments,"formula")._formula()}},{key:"round",value:function(){return new ne(arguments,"round")._rounding()}},{key:"ceil",value:function(){return new ne(arguments,"ceil")._rounding()}},{key:"floor",value:function(){return new ne(arguments,"floor")._rounding()}},{key:"pow",value:function(){return new ne(arguments,"pow")._power()}}]),e}());var ne=function(){function e(t,r){function n(e,t){if(i()(e,String)){var r=e;if(!t.has(r))return t;t.forEach((function(e,n){return t.set(n,r===n)}))}if(i()(e,Array)){var n=e;if(!n.some((function(e){return t.has(e)})))return t;t.forEach((function(e,r){return t.set(r,n.some((function(e){return e===r})))}))}return t}ee(this,e),this._data={mode:r,invalidReturn:NaN,values:Array.prototype.slice.call(t),zeroValue:-1,digits:[]},function(){this._data.callback=i()(this._data.values[this._data.values.length-1],Function)?this._data.values.pop():null}.call(this),function(){var e=this._data.values[this._data.values.length-1];this._data.userConfig=i()(e,Object)?this._data.values.pop():i()(e,Boolean)?{returnString:this._data.values.pop()}:{}}.call(this),function(){this._data.config=this.configDefaults;var e=this.configValidatorList,t=this._data.userConfig;for(var r in t){var n=t[r];this._data.config.hasOwnProperty(r)&&e[r](n)&&(this._data.config[r]=n)}}.call(this),function(){var e=this.charsDefaults,t=this._data.userConfig;for(var r in t){var i=t[r];e.hasOwnProperty(r)&&(e[r]=n(i,e[r]))}delete this._data.userConfig,this._data.chars=e}.call(this),function(){for(var e in this._data.chars){var t=this._data.chars[e],r="";t.forEach((function(e,t){e&&(r+=t)})),this._data.chars[e]="".concat(r)}}.call(this)}return re(e,[{key:"_validateValues",value:function(e){for(var t=this.validStringNumber,r=0;r<e.length;r++){var n=e[r];if(i()(n,String)){if("Infinity"===n||"-Infinity"===n){var a=this.errorDefaults.infinityValueError(r);return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:a,argumentSet:{error:a,index:r,list:this._data.values,callback:this._data.callback||void 0}})}if("NaN"===n){var o=this.errorDefaults.nanValueError(r);return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:o,argumentSet:{error:o,index:r,list:this._data.values,callback:this._data.callback||void 0}})}if(!t.test(n)){var s=this.errorDefaults.invalidStringValueError(r);return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:s,argumentSet:{error:s,index:r,list:this._data.values,callback:this._data.callback||void 0}})}}else{if(!i()(n,Number)){var u=this.errorDefaults.invalidValueTypeError(r);return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:u,argumentSet:{error:u,index:r,list:this._data.values,callback:this._data.callback||void 0}})}if(n===1/0||n===-1/0){var l=this.errorDefaults.infinityValueError(r);return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:l,argumentSet:{error:l,index:r,list:this._data.values,callback:this._data.callback||void 0}})}if(Number.isNaN(n)){var f=this.errorDefaults.nanValueError(r);return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:f,argumentSet:{error:f,index:r,list:this._data.values,callback:this._data.callback||void 0}})}}h.call(this,n,r);var c=new A(n);this._data.digits.push(c)}function h(e,t){this._data.zeroValue>=0||0==Number(e)&&(this._data.zeroValue=t)}return!0}},{key:"_algebra",value:function(){var e=this;if(this._data.values.length<2){var t=this.errorDefaults.algebraTwoValuesError();return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:t,argumentSet:{error:t,index:void 0,list:this._data.values,callback:this._data.callback||void 0}}),this._data.invalidReturn}if(!this._validateValues(this._data.values))return this._data.invalidReturn;switch(this._data.mode){case"add":this._data.result=new g({digits:this._data.digits});break;case"sub":this._data.result=new o({digits:this._data.digits});break;case"mul":this._data.result=new Z({digits:this._data.digits,zeroValue:this._data.zeroValue});break;case"div":var r=!1;if(this._data.result=new V({digits:this._data.digits,maxDecimal:this._data.config.maxDecimal,divideByZeroError:this.errorDefaults.divideByZeroError,divisionError:function(t,n){r=!0;var i=t(n);e._handleErrors({errorConfig:e._data.config.divideByZeroError,errorDefault:i,argumentSet:{error:i,index:n,list:e._data.values,callback:e._data.callback||void 0}})}}),r)return this._data.invalidReturn}return this._handleResult()}},{key:"_formula",value:function(){var e=this;if(1!==this._data.values.length||!i()(this._data.values[0],String)){var t=this.errorDefaults.formulaOneParameterError();return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:t,argumentSet:{error:t,index:void 0,list:this._data.values,callback:this._data.callback||void 0}}),this._data.invalidReturn}var r=!1,n=!1;return this._data.result=new Y({formula:this._data.values[0],chars:this._data.chars,maxDecimal:this._data.config.maxDecimal,zeroArgumentError:this.errorDefaults.divideByZero,divisionError:function(t){n=!0,e._handleErrors({errorConfig:e._data.config.divideByZeroError,errorDefault:t,argumentSet:{error:t,index:void 0,list:e._data.values,callback:e._data.callback||void 0}})},invalidError:function(t){r=!0,e._handleErrors({errorConfig:e._data.config.invalidError,errorDefault:t,argumentSet:{error:t,index:0,list:e._data.values,callback:e._data.callback||void 0}})}}),n||r?this._data.invalidReturn:this._handleResult()}},{key:"_rounding",value:function(){var e=this._data.values.length;if(0===e||e>2){var t=this.errorDefaults.roundingTwoArgumentsError();return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:t,argumentSet:{error:t,index:void 0,list:this._data.values,callback:this._data.callback||void 0}}),this._data.invalidReturn}if(!this._validateValues([this._data.values[0]]))return this._data.invalidReturn;if(1===e)this._data.values.push(1);else if(!i()(this._data.values[1],Number)||!s(this._data.values[1])){var r=this.errorDefaults.roundingInvalidIntegerError();return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:r,argumentSet:{error:r,index:1,list:this._data.values,callback:this._data.callback||void 0}}),this._data.invalidReturn}var n={digit:this._data.digits[0],places:this._data.values[1],trim:this._data.config.trim};switch(this._data.mode){case"round":this._data.result=new T(n);break;case"ceil":this._data.result=new N(n);break;case"floor":this._data.result=new O(n)}return this._handleResult()}},{key:"_power",value:function(){var e=this._data.values.length;if(0===e||e>2){var t=this.errorDefaults.powerTwoArgumentsError();return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:t,argumentSet:{error:t,index:void 0,list:this._data.values,callback:this._data.callback||void 0}}),this._data.invalidReturn}if(!this._validateValues([this._data.values[0]]))return this._data.invalidReturn;if(1===e)this._data.values.push(2);else if(!(i()(this._data.values[1],Number)&&s(this._data.values[1])&&this._data.values[1]>=0)){var r=this.errorDefaults.powerInvalidPositiveIntegerError();return this._handleErrors({errorConfig:this._data.config.invalidError,errorDefault:r,argumentSet:{error:r,index:1,list:this._data.values,callback:this._data.callback||void 0}}),this._data.invalidReturn}var n={digit:this._data.digits[0],power:this._data.values[1]};switch(this._data.mode){case"pow":this._data.result=new M(n)}return this._handleResult()}},{key:"_handleErrors",value:function(e){var t=e.errorConfig,r=e.errorDefault,n=e.argumentSet,a=void 0===n?{}:n,o=t,s=this._data.callback;switch(!0){case i()(o,Boolean):if(!0===o&&!s)throw r;return s&&s(this.invalidCallbackObject(o?r:null)),!1;case i()(o,/.*Error/):if(!s)throw o;return s(this.invalidCallbackObject(o)),!1;case i()(o,Function):return this._data.invalidReturn=o(a),!1}}},{key:"_handleResult",value:function(){var e=this._data.config;(e.returnString||this._data.callback)&&this._data.result.setExponential(e.eMinus,e.ePlus);var t=this._data.result.toString(),r={error:null,string:t,number:Number(t)};return this._data.callback&&this._data.callback(r),r[e.returnString?"string":"number"]}},{key:"configValidatorList",get:function(){var e=this;return{returnString:function(e){return i()(e,Boolean)},eMinus:function(t){return(e._data.callback||e._data.config.returnString)&&i()(t,Number)&&t>=0&&(s(t)||t===1/0)},ePlus:function(t){return(e._data.callback||e._data.config.returnString)&&i()(t,Number)&&t>=0&&(s(t)||t===1/0)},maxDecimal:function(t){return("div"===e._data.mode||"formula"===e._data.mode)&&i()(t,Number)&&t>=0&&s(t)},divideByZeroError:function(t){return("div"===e._data.mode||"formula"===e._data.mode)&&i()(t,/(Boolean|.*Error|Function)/)},invalidError:function(e){return i()(e,/(Boolean|.*Error|Function)/)},trim:function(e){return i()(e,Boolean)}}}},{key:"configDefaults",get:function(){return{returnString:!1,eMinus:7,ePlus:21,maxDecimal:17,divideByZeroError:!1,invalidError:!0,trim:!0}}},{key:"charsDefaults",get:function(){return{decimalChar:new Map([[".",!0],[",",!0]]),divChar:new Map([["/",!0],[":",!0],["÷",!0]]),mulChar:new Map([["*",!0],["x",!0],["⋅",!0],["×",!0]])}}},{key:"errorDefaults",get:function(){return{algebraTwoValuesError:function(){return new Error("Set at least two [Number|String] values.")},invalidValueTypeError:function(e){return new TypeError("Incorrect argument [".concat(e,"]. The [Number|String] value is expected."))},nanValueError:function(e){return new TypeError("Incorrect argument [".concat(e,"]. The argument cannot be a NaN value."))},infinityValueError:function(e){return new TypeError("Incorrect argument [".concat(e,"]. The argument cannot be an Infinity or -Infinity value."))},invalidStringValueError:function(e){return new Error("Incorrect argument [".concat(e,"]. The [String] argument is not a valid numerical value."))},formulaOneParameterError:function(){return new Error("The one [String] formula argument is expected.")},roundingTwoArgumentsError:function(){return new Error("Two arguments are expected: [0]: [String|Number] value; [1]: [Number] decimal places integer.")},powerTwoArgumentsError:function(){return new Error("Two arguments are expected: [0]: [String|Number] value; [1]: [Number] power exponent positive integer.")},roundingInvalidIntegerError:function(){return new Error("Incorrect argument [1]. The [Number] decimal places integer is expected.")},powerInvalidPositiveIntegerError:function(){return new Error("Incorrect argument [1]. The [Number] power exponent positive integer is expected.")},divideByZeroError:function(e){return new Error("Incorrect argument [".concat(e,"]. The division by zero is not allowed."))}}}},{key:"invalidCallbackObject",get:function(){var e=this;return function(t){return{number:e._data.invalidReturn,string:e._data.invalidReturn,error:t}}}},{key:"validStringNumber",get:function(){return new RegExp("^([+-]?\\d*[".concat(this._data.chars.decimalChar,"]?\\d+(?:e[+-]\\d+)?)$"))}}]),e}()}]).default;

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parametros__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__usuarios__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parametros1__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__solicitudes__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__creacionsolicitudservicio__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__creacionsolicitudbi__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__solicitudservicio__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plantillas__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__garantias__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__creacionsolicitudservicioot__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__creacioncontratoanual__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__solicitudservicioot__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contratoanual__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__externosaprobaciones__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__documentos__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__creaciontiqueteaereo__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__tiquetesaereo__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__otrosi__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__solicitudbi__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__grupos__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__busquedadocumento__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__reportes__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__externoscotizaciones__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__creacionsolicitudhoteles__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__maestra__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__solicitudhoteles__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__cambiarcontrasena__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__delegados__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__admindb__ = __webpack_require__(565);
var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({auth:__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */],common:__WEBPACK_IMPORTED_MODULE_2__common__["a" /* default */],parametros:__WEBPACK_IMPORTED_MODULE_3__parametros__["a" /* default */],usuarios:__WEBPACK_IMPORTED_MODULE_4__usuarios__["a" /* default */],parametros1:__WEBPACK_IMPORTED_MODULE_5__parametros1__["a" /* default */],creacionsolicitudservicio:__WEBPACK_IMPORTED_MODULE_7__creacionsolicitudservicio__["a" /* default */],creacionsolicitudBI:__WEBPACK_IMPORTED_MODULE_8__creacionsolicitudbi__["a" /* default */],solicitudes:__WEBPACK_IMPORTED_MODULE_6__solicitudes__["a" /* default */],solicitudservicio:__WEBPACK_IMPORTED_MODULE_9__solicitudservicio__["a" /* default */],creacionsolicitudservicioot:__WEBPACK_IMPORTED_MODULE_12__creacionsolicitudservicioot__["a" /* default */],solicitudservicioot:__WEBPACK_IMPORTED_MODULE_14__solicitudservicioot__["a" /* default */],plantillas:__WEBPACK_IMPORTED_MODULE_10__plantillas__["a" /* default */],garantias:__WEBPACK_IMPORTED_MODULE_11__garantias__["a" /* default */],creacioncontratoanual:__WEBPACK_IMPORTED_MODULE_13__creacioncontratoanual__["a" /* default */],contratoanual:__WEBPACK_IMPORTED_MODULE_15__contratoanual__["a" /* default */],externosaprobaciones:__WEBPACK_IMPORTED_MODULE_16__externosaprobaciones__["a" /* default */],documentos:__WEBPACK_IMPORTED_MODULE_17__documentos__["a" /* default */],creaciontiqueteaereo:__WEBPACK_IMPORTED_MODULE_18__creaciontiqueteaereo__["a" /* default */],tiquetesaereo:__WEBPACK_IMPORTED_MODULE_19__tiquetesaereo__["a" /* default */],otrosi:__WEBPACK_IMPORTED_MODULE_20__otrosi__["a" /* default */],solicitudBI:__WEBPACK_IMPORTED_MODULE_21__solicitudbi__["a" /* default */],grupos:__WEBPACK_IMPORTED_MODULE_22__grupos__["a" /* default */],busquedadocumento:__WEBPACK_IMPORTED_MODULE_23__busquedadocumento__["a" /* default */],reportes:__WEBPACK_IMPORTED_MODULE_24__reportes__["a" /* default */],externoscotizaciones:__WEBPACK_IMPORTED_MODULE_25__externoscotizaciones__["a" /* default */],maestras:__WEBPACK_IMPORTED_MODULE_27__maestra__["a" /* default */],delegados:__WEBPACK_IMPORTED_MODULE_30__delegados__["a" /* default */],creacionsolicitudhoteles:__WEBPACK_IMPORTED_MODULE_26__creacionsolicitudhoteles__["a" /* default */],solicitudhoteles:__WEBPACK_IMPORTED_MODULE_28__solicitudhoteles__["a" /* default */],cambiarcontrasena:__WEBPACK_IMPORTED_MODULE_29__cambiarcontrasena__["a" /* default */],admindb:__WEBPACK_IMPORTED_MODULE_31__admindb__["a" /* default */]});var rootReducer=function rootReducer(state,action){if(action.type==='CERRAR_SESION'||action.type==='INICIAR_SESION'){state=undefined;}return appReducer(state,action);};/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tableCols; });
/* harmony export (immutable) */ __webpack_exports__["b"] = findValues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxSearch__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Parametros_ModalCreate__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Parametros_ModalDelete__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_parametros__ = __webpack_require__(149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tableCols=[{id:1,caption:'Nombre',value:'nombre',type:'string',format:'',width:'15%',linkToEdit:true},{id:2,caption:'Descripción',value:'descripcion',type:'string',format:'',width:'70%'},{id:3,caption:'Categoría',value:'categoria',type:'string',format:'',width:'15%'}];function findValues(c,x){var value=x.getIn(c.value.split('.'));return value;}var Parametros=function(_Component){_inherits(Parametros,_Component);function Parametros(){_classCallCheck(this,Parametros);return _possibleConstructorReturn(this,(Parametros.__proto__||Object.getPrototypeOf(Parametros)).apply(this,arguments));}_createClass(Parametros,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParametros();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,parametros=_props.parametros,orderBy=_props.orderBy;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[0]',name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Creación de parámetros','create');},title:'Nuevo par\xE1metro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[1]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los Parametros seleccionados?',function(){return _this2.props.deleteParametros();});},disabled:parametros.filter(function(x){return x.get('selected');}).count()===0,danger:true,title:'Eliminar par\xE1metro'})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Layout_Box__["a" /* default */],{title:'Parametros',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxSearch__["a" /* default */],{onChange:this.props.filterParametros}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-parametros'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(e.target.checked);},checked:parametros.filter(function(x){return x.get('selected');}).count()>0&&parametros.filter(function(x){return x.get('selected')&&x.get('visible');}).count()>=parametros.filter(function(x){return x.get('visible');}).count()})),tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,parametros.filter(function(x){return x.get('visible');}).count()>0?parametros.map(function(x){if(!x.get('visible'))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectItem(x.get('id'),e.target.checked);},checked:x.get('selected')})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format);alignment='right';break;case'bool':value=value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.linkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Modificación de parametros','edit',x.get('id'));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Parametros_ModalCreate__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Parametros_ModalDelete__["a" /* default */],null));}}]);return Parametros;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{parametros:state.parametros.get('parametros'),orderBy:state.parametros.get('orderBy')};}function mapDispatchToProps(dispatch){return{getParametros:function getParametros(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["f" /* getParametros */])());},toggleSelectItem:function toggleSelectItem(id,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["k" /* toggleSelectItem */])(id,checked));},toggleSelectAllItems:function toggleSelectAllItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["j" /* toggleSelectAllItems */])(checked));},filterParametros:function filterParametros(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["e" /* filterParametros */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["h" /* setOrderBy */])(field));},displayModalCreate:function displayModalCreate(show,title,mode,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["d" /* displayModalCreate */])(show,title,mode,id));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["i" /* showHideModalDelete */])(open,message,action));},deleteParametros:function deleteParametros(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_parametros__["c" /* deleteParametros */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Parametros));

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(527);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ace_1 = __webpack_require__(529);
var diff_1 = __webpack_require__(530);
exports.diff = diff_1.default;
var split_1 = __webpack_require__(234);
exports.split = split_1.default;
exports.default = ace_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), __webpack_require__(224)(module)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var editorOptions = [
    "minLines",
    "maxLines",
    "readOnly",
    "highlightActiveLine",
    "tabSize",
    "enableBasicAutocompletion",
    "enableLiveAutocompletion",
    "enableSnippets"
];
exports.editorOptions = editorOptions;
var editorEvents = [
    "onChange",
    "onFocus",
    "onInput",
    "onBlur",
    "onCopy",
    "onPaste",
    "onSelectionChange",
    "onCursorChange",
    "onScroll",
    "handleOptions",
    "updateRef"
];
exports.editorEvents = editorEvents;
var getAceInstance = function () {
    var ace;
    // Fallback for ace.require when vanilla ACE is hosted over a CDN
    if (window.ace) {
        ace = window.ace;
        ace.acequire = window.ace.require || window.ace.acequire;
    }
    else {
        ace = __webpack_require__(152);
    }
    return ace;
};
exports.getAceInstance = getAceInstance;
var debounce = function (fn, delay) {
    var timer = null;
    return function () {
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
};
exports.debounce = debounce;
//# sourceMappingURL=editorOptions.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var editorOptions_1 = __webpack_require__(232);
var ace = editorOptions_1.getAceInstance();
__webpack_require__(152);
var Range = ace.acequire("ace/range").Range;
__webpack_require__(531);
var Split = ace.acequire("ace/split").Split;
var PropTypes = __webpack_require__(12);
var React = __webpack_require__(0);
var isEqual = __webpack_require__(231);
var get = __webpack_require__(532);
var SplitComponent = /** @class */ (function (_super) {
    __extends(SplitComponent, _super);
    function SplitComponent(props) {
        var _this = _super.call(this, props) || this;
        editorOptions_1.editorEvents.forEach(function (method) {
            _this[method] = _this[method].bind(_this);
        });
        _this.debounce = editorOptions_1.debounce;
        return _this;
    }
    SplitComponent.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, className = _a.className, onBeforeLoad = _a.onBeforeLoad, mode = _a.mode, focus = _a.focus, theme = _a.theme, fontSize = _a.fontSize, value = _a.value, defaultValue = _a.defaultValue, cursorStart = _a.cursorStart, showGutter = _a.showGutter, wrapEnabled = _a.wrapEnabled, showPrintMargin = _a.showPrintMargin, _b = _a.scrollMargin, scrollMargin = _b === void 0 ? [0, 0, 0, 0] : _b, keyboardHandler = _a.keyboardHandler, onLoad = _a.onLoad, commands = _a.commands, annotations = _a.annotations, markers = _a.markers, splits = _a.splits;
        this.editor = ace.edit(this.refEditor);
        if (onBeforeLoad) {
            onBeforeLoad(ace);
        }
        var editorProps = Object.keys(this.props.editorProps);
        var split = new Split(this.editor.container, "ace/theme/" + theme, splits);
        this.editor.env.split = split;
        this.splitEditor = split.getEditor(0);
        this.split = split;
        // in a split scenario we don't want a print margin for the entire application
        this.editor.setShowPrintMargin(false);
        this.editor.renderer.setShowGutter(false);
        // get a list of possible options to avoid 'misspelled option errors'
        var availableOptions = this.splitEditor.$options;
        if (this.props.debounceChangePeriod) {
            this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
        }
        split.forEach(function (editor, index) {
            for (var i = 0; i < editorProps.length; i++) {
                editor[editorProps[i]] = _this.props.editorProps[editorProps[i]];
            }
            var defaultValueForEditor = get(defaultValue, index);
            var valueForEditor = get(value, index, "");
            editor.session.setUndoManager(new ace.UndoManager());
            editor.setTheme("ace/theme/" + theme);
            editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
            editor.getSession().setMode("ace/mode/" + mode);
            editor.setFontSize(fontSize);
            editor.renderer.setShowGutter(showGutter);
            editor.getSession().setUseWrapMode(wrapEnabled);
            editor.setShowPrintMargin(showPrintMargin);
            editor.on("focus", _this.onFocus);
            editor.on("blur", _this.onBlur);
            editor.on("input", _this.onInput);
            editor.on("copy", _this.onCopy);
            editor.on("paste", _this.onPaste);
            editor.on("change", _this.onChange);
            editor
                .getSession()
                .selection.on("changeSelection", _this.onSelectionChange);
            editor.getSession().selection.on("changeCursor", _this.onCursorChange);
            editor.session.on("changeScrollTop", _this.onScroll);
            editor.setValue(defaultValueForEditor === undefined
                ? valueForEditor
                : defaultValueForEditor, cursorStart);
            var newAnnotations = get(annotations, index, []);
            var newMarkers = get(markers, index, []);
            editor.getSession().setAnnotations(newAnnotations);
            if (newMarkers && newMarkers.length > 0) {
                _this.handleMarkers(newMarkers, editor);
            }
            for (var i = 0; i < editorOptions_1.editorOptions.length; i++) {
                var option = editorOptions_1.editorOptions[i];
                if (availableOptions.hasOwnProperty(option)) {
                    editor.setOption(option, _this.props[option]);
                }
                else if (_this.props[option]) {
                    console.warn("ReaceAce: editor option " + option + " was activated but not found. Did you need to import a related tool or did you possibly mispell the option?");
                }
            }
            _this.handleOptions(_this.props, editor);
            if (Array.isArray(commands)) {
                commands.forEach(function (command) {
                    if (typeof command.exec === "string") {
                        editor.commands.bindKey(command.bindKey, command.exec);
                    }
                    else {
                        editor.commands.addCommand(command);
                    }
                });
            }
            if (keyboardHandler) {
                editor.setKeyboardHandler("ace/keyboard/" + keyboardHandler);
            }
        });
        if (className) {
            this.refEditor.className += " " + className;
        }
        if (focus) {
            this.splitEditor.focus();
        }
        var sp = this.editor.env.split;
        sp.setOrientation(this.props.orientation === "below" ? sp.BELOW : sp.BESIDE);
        sp.resize(true);
        if (onLoad) {
            onLoad(sp);
        }
    };
    SplitComponent.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var oldProps = prevProps;
        var nextProps = this.props;
        var split = this.editor.env.split;
        if (nextProps.splits !== oldProps.splits) {
            split.setSplits(nextProps.splits);
        }
        if (nextProps.orientation !== oldProps.orientation) {
            split.setOrientation(nextProps.orientation === "below" ? split.BELOW : split.BESIDE);
        }
        split.forEach(function (editor, index) {
            if (nextProps.mode !== oldProps.mode) {
                editor.getSession().setMode("ace/mode/" + nextProps.mode);
            }
            if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
                if (nextProps.keyboardHandler) {
                    editor.setKeyboardHandler("ace/keyboard/" + nextProps.keyboardHandler);
                }
                else {
                    editor.setKeyboardHandler(null);
                }
            }
            if (nextProps.fontSize !== oldProps.fontSize) {
                editor.setFontSize(nextProps.fontSize);
            }
            if (nextProps.wrapEnabled !== oldProps.wrapEnabled) {
                editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
            }
            if (nextProps.showPrintMargin !== oldProps.showPrintMargin) {
                editor.setShowPrintMargin(nextProps.showPrintMargin);
            }
            if (nextProps.showGutter !== oldProps.showGutter) {
                editor.renderer.setShowGutter(nextProps.showGutter);
            }
            for (var i = 0; i < editorOptions_1.editorOptions.length; i++) {
                var option = editorOptions_1.editorOptions[i];
                if (nextProps[option] !== oldProps[option]) {
                    editor.setOption(option, nextProps[option]);
                }
            }
            if (!isEqual(nextProps.setOptions, oldProps.setOptions)) {
                _this.handleOptions(nextProps, editor);
            }
            var nextValue = get(nextProps.value, index, "");
            if (editor.getValue() !== nextValue) {
                // editor.setValue is a synchronous function call, change event is emitted before setValue return.
                _this.silent = true;
                var pos = editor.session.selection.toJSON();
                editor.setValue(nextValue, nextProps.cursorStart);
                editor.session.selection.fromJSON(pos);
                _this.silent = false;
            }
            var newAnnotations = get(nextProps.annotations, index, []);
            var oldAnnotations = get(oldProps.annotations, index, []);
            if (!isEqual(newAnnotations, oldAnnotations)) {
                editor.getSession().setAnnotations(newAnnotations);
            }
            var newMarkers = get(nextProps.markers, index, []);
            var oldMarkers = get(oldProps.markers, index, []);
            if (!isEqual(newMarkers, oldMarkers) && Array.isArray(newMarkers)) {
                _this.handleMarkers(newMarkers, editor);
            }
        });
        if (nextProps.className !== oldProps.className) {
            var appliedClasses = this.refEditor.className;
            var appliedClassesArray_1 = appliedClasses.trim().split(" ");
            var oldClassesArray = oldProps.className.trim().split(" ");
            oldClassesArray.forEach(function (oldClass) {
                var index = appliedClassesArray_1.indexOf(oldClass);
                appliedClassesArray_1.splice(index, 1);
            });
            this.refEditor.className =
                " " + nextProps.className + " " + appliedClassesArray_1.join(" ");
        }
        if (nextProps.theme !== oldProps.theme) {
            split.setTheme("ace/theme/" + nextProps.theme);
        }
        if (nextProps.focus && !oldProps.focus) {
            this.splitEditor.focus();
        }
        if (nextProps.height !== this.props.height ||
            nextProps.width !== this.props.width) {
            this.editor.resize();
        }
    };
    SplitComponent.prototype.componentWillUnmount = function () {
        this.editor.destroy();
        this.editor = null;
    };
    SplitComponent.prototype.onChange = function (event) {
        if (this.props.onChange && !this.silent) {
            var value_1 = [];
            this.editor.env.split.forEach(function (editor) {
                value_1.push(editor.getValue());
            });
            this.props.onChange(value_1, event);
        }
    };
    SplitComponent.prototype.onSelectionChange = function (event) {
        if (this.props.onSelectionChange) {
            var value_2 = [];
            this.editor.env.split.forEach(function (editor) {
                value_2.push(editor.getSelection());
            });
            this.props.onSelectionChange(value_2, event);
        }
    };
    SplitComponent.prototype.onCursorChange = function (event) {
        if (this.props.onCursorChange) {
            var value_3 = [];
            this.editor.env.split.forEach(function (editor) {
                value_3.push(editor.getSelection());
            });
            this.props.onCursorChange(value_3, event);
        }
    };
    SplitComponent.prototype.onFocus = function (event) {
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    };
    SplitComponent.prototype.onInput = function (event) {
        if (this.props.onInput) {
            this.props.onInput(event);
        }
    };
    SplitComponent.prototype.onBlur = function (event) {
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    };
    SplitComponent.prototype.onCopy = function (text) {
        if (this.props.onCopy) {
            this.props.onCopy(text);
        }
    };
    SplitComponent.prototype.onPaste = function (text) {
        if (this.props.onPaste) {
            this.props.onPaste(text);
        }
    };
    SplitComponent.prototype.onScroll = function () {
        if (this.props.onScroll) {
            this.props.onScroll(this.editor);
        }
    };
    SplitComponent.prototype.handleOptions = function (props, editor) {
        var setOptions = Object.keys(props.setOptions);
        for (var y = 0; y < setOptions.length; y++) {
            editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
        }
    };
    SplitComponent.prototype.handleMarkers = function (markers, editor) {
        // remove foreground markers
        var currentMarkers = editor.getSession().getMarkers(true);
        for (var i in currentMarkers) {
            if (currentMarkers.hasOwnProperty(i)) {
                editor.getSession().removeMarker(currentMarkers[i].id);
            }
        }
        // remove background markers
        currentMarkers = editor.getSession().getMarkers(false);
        for (var i in currentMarkers) {
            if (currentMarkers.hasOwnProperty(i)) {
                editor.getSession().removeMarker(currentMarkers[i].id);
            }
        }
        // add new markers
        markers.forEach(function (_a) {
            var startRow = _a.startRow, startCol = _a.startCol, endRow = _a.endRow, endCol = _a.endCol, className = _a.className, type = _a.type, _b = _a.inFront, inFront = _b === void 0 ? false : _b;
            var range = new Range(startRow, startCol, endRow, endCol);
            editor.getSession().addMarker(range, className, type, inFront);
        });
    };
    SplitComponent.prototype.updateRef = function (item) {
        this.refEditor = item;
    };
    SplitComponent.prototype.render = function () {
        var _a = this.props, name = _a.name, width = _a.width, height = _a.height, style = _a.style;
        var divStyle = __assign({ width: width, height: height }, style);
        return React.createElement("div", { ref: this.updateRef, id: name, style: divStyle });
    };
    SplitComponent.propTypes = {
        className: PropTypes.string,
        debounceChangePeriod: PropTypes.number,
        defaultValue: PropTypes.arrayOf(PropTypes.string),
        focus: PropTypes.bool,
        fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        height: PropTypes.string,
        mode: PropTypes.string,
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onCopy: PropTypes.func,
        onFocus: PropTypes.func,
        onInput: PropTypes.func,
        onLoad: PropTypes.func,
        onPaste: PropTypes.func,
        onScroll: PropTypes.func,
        orientation: PropTypes.string,
        showGutter: PropTypes.bool,
        splits: PropTypes.number,
        theme: PropTypes.string,
        value: PropTypes.arrayOf(PropTypes.string),
        width: PropTypes.string,
        onSelectionChange: PropTypes.func,
        onCursorChange: PropTypes.func,
        onBeforeLoad: PropTypes.func,
        minLines: PropTypes.number,
        maxLines: PropTypes.number,
        readOnly: PropTypes.bool,
        highlightActiveLine: PropTypes.bool,
        tabSize: PropTypes.number,
        showPrintMargin: PropTypes.bool,
        cursorStart: PropTypes.number,
        editorProps: PropTypes.object,
        setOptions: PropTypes.object,
        style: PropTypes.object,
        scrollMargin: PropTypes.array,
        annotations: PropTypes.array,
        markers: PropTypes.array,
        keyboardHandler: PropTypes.string,
        wrapEnabled: PropTypes.bool,
        enableBasicAutocompletion: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.array
        ]),
        enableLiveAutocompletion: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.array
        ]),
        commands: PropTypes.array
    };
    SplitComponent.defaultProps = {
        name: "brace-editor",
        focus: false,
        orientation: "beside",
        splits: 2,
        mode: "",
        theme: "",
        height: "500px",
        width: "500px",
        value: [],
        fontSize: 12,
        showGutter: true,
        onChange: null,
        onPaste: null,
        onLoad: null,
        onScroll: null,
        minLines: null,
        maxLines: null,
        readOnly: false,
        highlightActiveLine: true,
        showPrintMargin: true,
        tabSize: 4,
        cursorStart: 1,
        editorProps: {},
        style: {},
        scrollMargin: [0, 0, 0, 0],
        setOptions: {},
        wrapEnabled: false,
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false
    };
    return SplitComponent;
}(React.Component));
exports.default = SplitComponent;
//# sourceMappingURL=split.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports) {

ace.define("ace/theme/github",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {

exports.isDark = false;
exports.cssClass = "ace-github";
exports.cssText = "\
.ace-github .ace_gutter {\
background: #e8e8e8;\
color: #AAA;\
}\
.ace-github  {\
background: #fff;\
color: #000;\
}\
.ace-github .ace_keyword {\
font-weight: bold;\
}\
.ace-github .ace_string {\
color: #D14;\
}\
.ace-github .ace_variable.ace_class {\
color: teal;\
}\
.ace-github .ace_constant.ace_numeric {\
color: #099;\
}\
.ace-github .ace_constant.ace_buildin {\
color: #0086B3;\
}\
.ace-github .ace_support.ace_function {\
color: #0086B3;\
}\
.ace-github .ace_comment {\
color: #998;\
font-style: italic;\
}\
.ace-github .ace_variable.ace_language  {\
color: #0086B3;\
}\
.ace-github .ace_paren {\
font-weight: bold;\
}\
.ace-github .ace_boolean {\
font-weight: bold;\
}\
.ace-github .ace_string.ace_regexp {\
color: #009926;\
font-weight: normal;\
}\
.ace-github .ace_variable.ace_instance {\
color: teal;\
}\
.ace-github .ace_constant.ace_language {\
font-weight: bold;\
}\
.ace-github .ace_cursor {\
color: black;\
}\
.ace-github.ace_focus .ace_marker-layer .ace_active-line {\
background: rgb(255, 255, 204);\
}\
.ace-github .ace_marker-layer .ace_active-line {\
background: rgb(245, 245, 245);\
}\
.ace-github .ace_marker-layer .ace_selection {\
background: rgb(181, 213, 255);\
}\
.ace-github.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px white;\
}\
.ace-github.ace_nobold .ace_line > span {\
font-weight: normal !important;\
}\
.ace-github .ace_marker-layer .ace_step {\
background: rgb(252, 255, 0);\
}\
.ace-github .ace_marker-layer .ace_stack {\
background: rgb(164, 229, 101);\
}\
.ace-github .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgb(192, 192, 192);\
}\
.ace-github .ace_gutter-active-line {\
background-color : rgba(0, 0, 0, 0.07);\
}\
.ace-github .ace_marker-layer .ace_selected-word {\
background: rgb(250, 250, 255);\
border: 1px solid rgb(200, 200, 250);\
}\
.ace-github .ace_invisible {\
color: #BFBFBF\
}\
.ace-github .ace_print-margin {\
width: 1px;\
background: #e8e8e8;\
}\
.ace-github .ace_indent-guide {\
background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
}";

    var dom = acequire("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass);
});


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tableCols; });
/* unused harmony export findvalues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Grupos_PermisosGrupo__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Grupos_ModalCreate__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Grupos_ModalDelete__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_grupos__ = __webpack_require__(114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tableCols=[{id:1,caption:'Nombre',value:'nombre',type:'string',format:'',width:'30%'},{id:2,caption:'Descripción',value:'descripcion',type:'string',format:'',width:'70%'}];function findvalues(c,x){var value=x.getIn(c.value.split('.'));return value;}var Grupos=function(_Component){_inherits(Grupos,_Component);function Grupos(){_classCallCheck(this,Grupos);return _possibleConstructorReturn(this,(Grupos.__proto__||Object.getPrototypeOf(Grupos)).apply(this,arguments));}_createClass(Grupos,[{key:'componentWillMount',value:function componentWillMount(){this.props.getGrupos(1);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,grupos=_props.grupos,orderBy=_props.orderBy,selected=_props.selected;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[0]',name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Creación de grupos','create');},title:'Nuevo grupo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[1]',name:'edit',onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Creación de grupos','edit',selected);},title:'Modificar grupo',disabled:selected===null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[2]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los Grupos seleccionados?',function(){return _this2.props.deleteGrupos();});},disabled:grupos.filter(function(x){return x.get('selected');}).count()===0,danger:true,title:'Eliminar par\xE1metro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[3]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true);},title:'Filtro'})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Layout_Box__["a" /* default */],{title:'Grupos del sistema',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-grupos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,grupos.filter(function(x){return x.get('visible');}).count()>0?grupos.map(function(x,n){if(!x.get('visible'))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:selected===n?'info':'',onClick:function onClick(){return _this2.props.selectItem(n);}},tableCols.map(function(c){var alignment='left';var value=findvalues(c,x);if(c.type){switch(c.type){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format);alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return _this2.props.displayModalCreate(true,'Modificación de grupos','edit',n);}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Grupos_PermisosGrupo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Grupos_ModalCreate__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Grupos_ModalDelete__["a" /* default */],null));}}]);return Grupos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{grupos:state.grupos.get('grupos'),orderBy:state.grupos.get('orderBy'),selected:state.grupos.get('selected')};}function mapDispatchToProps(dispatch){return{getGrupos:function getGrupos(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["e" /* getGrupos */])(page));},filterGrupos:function filterGrupos(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["d" /* filterGrupos */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["g" /* setOrderBy */])(field));},displayModalCreate:function displayModalCreate(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["c" /* displayModalCreate */])(show,title,mode,index));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["h" /* showHideModalDelete */])(open,message,action));},deleteGrupos:function deleteGrupos(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["b" /* deleteGrupos */])());},showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["i" /* showHideModalFilter */])(state));},selectItem:function selectItem(index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_grupos__["f" /* selectItem */])(index));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Grupos));

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalMsgBox=function(_Component){_inherits(ModalMsgBox,_Component);function ModalMsgBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalMsgBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalMsgBox.__proto__||Object.getPrototypeOf(ModalMsgBox)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalMsgBox');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalMsgBox .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalMsgBox(false);},300);},_this.renderMessage=function(width,message){if(width===500){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-2',style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{style:{color:'#C00000',fontSize:'3em'},name:'exclamation-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-10',style:{whiteSpace:'pre-line',maxHeight:'200px',overflow:'scroll',fontSize:'14px',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,message)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12',style:{whiteSpace:'pre-line',maxHeight:'600px',overflow:'scroll'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:message}})));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalMsgBox,[{key:'render',value:function render(){var _this2=this;var modalMsgBox=this.props.modalMsgBox;if(!modalMsgBox.get('show')){return null;}var message=modalMsgBox.get('message');var width=500;if(message.startsWith('<!DOCTYPE html>'))width=1300;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalMsgBox',show:true,width:width},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:'Ha ocurrido un error',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderMessage(width,modalMsgBox.get('message')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Aceptar')));}}]);return ModalMsgBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalMsgBox:state.common.get('msgBox')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalMsgBox:function showHideModalMsgBox(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_common__["w" /* showHideModalMsgBox */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalMsgBox));

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getParametros;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["a"] = addNewParameterDetail;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOrUpdateParametros;
/* harmony export (immutable) */ __webpack_exports__["f"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteParametros;
/* harmony export (immutable) */ __webpack_exports__["e"] = showHideModalDelete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
function getParametros(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return function(dispatch){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();var queryString='';if(id)queryString='?id='+id;axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/parametros'+queryString).then(function(res){var data=res.data.map(function(x){var param=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["T" /* transformParameterData */])(x);delete param.parametro.parametro_cols;delete param.parametro.parametro_rows;return param;});var fn1=void 0;if(id){fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_300" /* OBTENER_PARAMETRO */],payload:{id:id,data:data}});};}else{fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_301" /* OBTENER_PARAMETROS */],payload:data});};}fn1(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_206" /* MODIFICAR_INPUTS_PARAMETROS */],payload:{path:path,value:value}});};}function addNewParameterDetail(parametroId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_8" /* ADICIONAR_NUEVO_DETALLE_PARAMETRO */],payload:{parametroId:parametroId}});};}function createOrUpdateParametros(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var parametros=getState().parametros1.get('parametros');var toSave=[];parametros.forEach(function(x){x.get('data').forEach(function(d){x.get('columnas').forEach(function(c){if(d.getIn([c.get('value'),'updated'])){var detParam=d.get(c.get('value')).toJS();detParam.registro=d.get('registro');toSave.push(detParam);}});});});if(toSave.length>0){axios.post(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/parametros',toSave).then(function(res){var fn0=function fn0(d){return d(getParametros());};fn0(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Los parametros ha sido actualizados exitosamente'});}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});}else{Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{info:'No se encontraron cambios para guardar'});}};}function toggleSelectAllItems(parametroIndex,checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_70" /* CONMUTAR_SELECCION_TODOS_PARAMETROS */],payload:{parametroIndex:parametroIndex,checked:checked}});};}function deleteParametros(parametroIndex){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var parametro=getState().parametros1.getIn(['parametros',parametroIndex]);var toDelete=[];var selected=parametro.get('data').filter(function(x){return x.get('selected');});var fns=[];selected.forEach(function(x){parametro.get('columnas').forEach(function(c){var id=x.getIn([c.get('value'),'id']);if(id){var fn=function fn(){return axios.delete(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/parametros/'+id);};fns.push(fn);}});});var toResultObject=function toResultObject(promise){return promise.then(function(result){return{success:true,result:result};}).catch(function(error){return{success:false,error:error};});};Promise.all(fns.map(function(x){return x();}).map(toResultObject)).then(function(res){var succeded=[];var failed=[];res.forEach(function(x){if(!x.success){failed.push(x.error.response.data.ExceptionMessage);}else{succeded.push(x.result.data.Nombre);}});if(succeded.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:'Se han eliminado los siguentes parametros: '+succeded.join(', ')});if(failed.length>0)Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{response:{status:500,data:failed.join('\n')}});dispatch(getParametros(parametro.get('Id')));dispatch(showHideModalDelete(false));});};}function showHideModalDelete(open){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var action=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_251" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO */],payload:{open:open,message:message,action:action}});};}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_creacionsolicitudservicio__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddServicio=function(_Component){_inherits(ModalAddServicio,_Component);function ModalAddServicio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddServicio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddServicio.__proto__||Object.getPrototypeOf(ModalAddServicio)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddServicio');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddServicio .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddServicio(false,'','');},300);},_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/cencos',fn);},_this.handleOpenSelectorAddCenco=function(list,index){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){var index=_this.props.modalAddServicio.getIn(['data','cencos']).findIndex(function(c){return c.getIn(['cenco','id'])==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO',payload);}};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.modalAddServicio.getIn(['data','cencos',index,'responsable','id']),comparison:'string'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddServicio,[{key:'render',value:function render(){var _this2=this;var modalAddServicio=this.props.modalAddServicio;if(!modalAddServicio.get('show')){return null;}var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',size:14,name:'plus-circle',onClick:function onClick(e){return _this2.props.addCencoSolicitudServicioItem();},title:'Nueva'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',size:14,name:'trash',onClick:function onClick(e){return _this2.props.removeCencosSolicitudServicioItem();},title:'Eliminar',disabled:modalAddServicio.getIn(['data','cencos']).filter(function(x){return x.get('selected');}).count()===0,danger:true})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_Modal__["a" /* default */],{id:'modalAddServicio',show:true,zindex:2000,width:800},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__["a" /* default */],{title:modalAddServicio.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddServicio.get('btnDisabled'),title:'Aceptar',onClick:function onClick(){return _this2.props.addSolicitudServicioItem();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'Descripcion',className:'form-control input-sm',value:modalAddServicio.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.descripcion',e.target.value);},rows:3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddServicio.getIn(['data','cantidad']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cantidad',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_Box__["a" /* default */],{title:'Centros de costo',actions:boxActions,onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalAddServicio.getIn(['data','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('guid')+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.getIn('selected'),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:x.getIn(['responsable','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('modalAddServicio.data.cencos.'+n+'.responsable');},onReset:function onReset(){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n+'.responsable',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'30%'}},x.get('responsable')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:x.get('cenco')?x.getIn(['cenco','descripcion']):'',onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('modalAddServicio.data.cencos.'+n+'.cenco',n);},onReset:function onReset(){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n+'.cenco',null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',placeholder:'Seleccione un responsable del cenco',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.get('porcentaje'),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n+'.porcentaje',e.target.value);},disabled:x.get('responsable')==null})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddServicio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalAddServicio:state.creacionsolicitudservicio.get('modalAddServicio')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddServicio:function displayModalAddServicio(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_creacionsolicitudservicio__["f" /* displayModalAddServicio */])(show,title));},addCencoSolicitudServicioItem:function addCencoSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_creacionsolicitudservicio__["a" /* addCencoSolicitudServicioItem */])());},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["q" /* selectFromSelector */])(type,payload));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_creacionsolicitudservicio__["o" /* updateInputs */])(path,value));},removeCencosSolicitudServicioItem:function removeCencosSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_creacionsolicitudservicio__["j" /* removeCencosSolicitudServicioItem */])());},addSolicitudServicioItem:function addSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_creacionsolicitudservicio__["c" /* addSolicitudServicioItem */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddServicio));

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initReducer */
/* harmony export (immutable) */ __webpack_exports__["o"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["f"] = displayModalAddServicio;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCencoSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["j"] = removeCencosSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["c"] = addSolicitudServicioItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = removeSolicitudServicioItems;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleSelectAllSolicitudServicioItems;
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleSelectAllSolicitudServicioFiles;
/* harmony export (immutable) */ __webpack_exports__["p"] = uploadFile;
/* harmony export (immutable) */ __webpack_exports__["b"] = addSolicitudServicioFile;
/* harmony export (immutable) */ __webpack_exports__["k"] = removeSolicitudServicioFiles;
/* harmony export (immutable) */ __webpack_exports__["e"] = displayModalAddFile;
/* harmony export (immutable) */ __webpack_exports__["d"] = createSolicitudServicio;
/* harmony export (immutable) */ __webpack_exports__["i"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["g"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["h"] = eliminarComentario;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_340" /* REINICIAR_SOLICITUD_SERVICIO */]});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_216" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO */],payload:{path:path,value:value}});};}function displayModalAddServicio(show,title,mode,index){return function(dispatch){if(show){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_246" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_318" /* OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO */]});}};}function addCencoSolicitudServicioItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_1" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO */]});};}function removeCencosSolicitudServicioItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_132" /* ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM */]});};}function addSolicitudServicioItem(){return function(dispatch,getState){var data=getState().creacionsolicitudservicio.getIn(['modalAddServicio','data']);var errors=[];if(!data.get('descripcion'))errors.push('La creación de servicios requiere de una descripción');if(data.get('cantidad')<1)errors.push('La creación de servicios requiere que la cantidad sea superior a 0');if(data.get('cencos').count()===0)errors.push('La creación de servicios requiere al menos de un centro de costo');if(data.get('cencos').filter(function(x){return x.get('cenco')===null;}).count()>0)errors.push('La creación de servicios requiere que todos los centros de costos estén definidos');if(data.get('cencos').filter(function(x){return x.get('porcentaje')<1;}).count()>0)errors.push('El porcentaje en los cencos debe ser mayor a 0');var sumDist=data.get('cencos').reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);if(sumDist!==100)errors.push('La creación de servicios requiere la suma de distribución entre cencos sea del 100%');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_11" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO */]});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_318" /* OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO */]});};fn1(dispatch);fn2(dispatch);}};}function removeSolicitudServicioItems(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_154" /* ELIMINAR_ITEMS_SOLICITUD_SERVICIO */]});};}function toggleSelectAllSolicitudServicioItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_68" /* CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO */],payload:checked});};}function toggleSelectAllSolicitudServicioFiles(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_66" /* CONMUTAR_SELECCION_TODOS_ITEMS_FILES */],payload:checked});};}function uploadFile(file){return function(dispatch){var fileType=__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["a" /* acceptedFiles */].filter(function(x){return x.type===file.type;});var icon='_blank.png';if(fileType.length===1){icon=fileType[0].icon;}var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_216" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO */],payload:{path:'modalAddFile.data.nombre',value:file.name}});};fn0(dispatch);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_216" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO */],payload:{path:'modalAddFile.data.file',value:file,immutable:false}});};fn1(dispatch);var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_216" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO */],payload:{path:'modalAddFile.data.icono',value:icon}});};fn2(dispatch);};}function addSolicitudServicioFile(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["T" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO */],payload:data});};fn1(dispatch);};}function removeSolicitudServicioFiles(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_125" /* ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO */]});};}function displayModalAddFile(show,title,mode,index){return function(dispatch){if(show){var fn0=function fn0(d){return d(Object(__WEBPACK_IMPORTED_MODULE_5__common__["l" /* getParameterByName */])('CLASIFICACION_ARCHIVOS'));};fn0(dispatch);dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_242" /* MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO */],payload:{show:show,title:title,mode:mode,index:index}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_314" /* OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO */]});}};}function createSolicitudServicio(){var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_94" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_94" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO */],payload:false});};var fn2=function fn2(d){return d(initReducer());};fn0(dispatch);var data=getState().creacionsolicitudservicio;var errors=validarSolicitud(data);if(errors.length){fn1(dispatch);return errors.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(element,{bodyClassName:'toastify-content toastify-warning'});});}else{var files=data.get('adjuntos');axios.post(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/solicitudes/servicios',data).then(function(res){var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_4__utils_history__["a" /* default */].push(window.FOLDER+'/');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('La solicitud ha sido guardada exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn1,fn2,fn3,fn4]));}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function enviarComentario(){return function(dispatch,getState){var guid=getState().creacionsolicitudservicio.getIn(['comentario','guid']);var comentario=getState().creacionsolicitudservicio.getIn(['comentario','texto']);var usuario=getState().common.get('user');var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_168" /* ENVIAR_COMENTARIO_SOLICITUD_SERVICIO */],payload:{comentario:comentario,guid:guid,usuario:usuario}});};fn1(dispatch);};}function editarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_117" /* EDITAR_COMENTARIO_SOLICITUD_SERVICIO */],payload:{guid:guid}});};fn1(dispatch);};}function eliminarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_3__types__["_138" /* ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO */],payload:{guid:guid}});};fn1(dispatch);};}// Shared
function validarSolicitud(data){var errors=[];if(data.get('fecha_requerido')&&__WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract('days',1).isAfter(data.get('fecha_requerido')))errors.push('La fecha de entrega no debe ser inferior a la de hoy');if(data.get('adjuntos').count()>0){var size=data.get('adjuntos').reduce(function(a,b){a+=b.get('file').size;return a;},0);if(size>__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["W" /* uploadMaxSize */].value)errors.push('La capacidad m\xE1xima para subir archivos es de de '+__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["W" /* uploadMaxSize */].unidad);if(data.get('adjuntos').filter(function(x){return!x.get('clasificacion');}).count()>0)errors.push('Todos los archivos deben tener una clasificación');}return errors;}

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_Comentarios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalAddServicio__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var General=function(_Component){_inherits(General,_Component);function General(){var _ref;var _temp,_this,_ret;_classCallCheck(this,General);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=General.__proto__||Object.getPrototypeOf(General)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/auxiliares',fn);},_this.modificarSolicitud=function(path,value,id){_this.props.updateInputs(path,value,id);_this.props.updateInputs('addModificacion',true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(General,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicio=_props.solicitudservicio,enums=_props.enums,user=_props.user,comentario=_props.comentario;var esResponsableCompras=solicitudservicio.getIn(['responsable_compras','id'])==user.get('id');var esSuperusuario=user.get('es_superusuario');var estado=solicitudservicio.get('estado');var readOnly=!esResponsableCompras&&!esSuperusuario||estado>1;//const readOnly = true
if(!id)return null;var actionsSectionDetallesServicios=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalAddServicio(true,'Agregar Item','create');},title:'Adicionar servicio',disabled:readOnly||solicitudservicio.get('estado')!=1&&solicitudservicio.get('estado')!=2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeSolicitudServicioItem();},title:'Eliminar servicio',danger:true,disabled:solicitudservicio.get('servicios')&&!solicitudservicio.get('servicios').filter(function(x){return x.get('selected');}).count()})];var disabled_comment=estado===0||estado===7;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudservicio.get('solicitante'))&&solicitudservicio.get('tipo')!=5&&solicitudservicio.get('estado')!=0&&solicitudservicio.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_SelectorInput__["a" /* default */],{value:solicitudservicio.getIn(['solicitante','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.solicitante');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.solicitante',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['solicitante','fullname'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['solicitante','email'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['solicitante','extension'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['solicitante','area','nombre'])||'',className:'form-control input-sm',disabled:true}))),solicitudservicio.get('documento_origen_id')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Orden/Contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:enums.documentos.tipos[solicitudservicio.getIn(['documento_origen','tipo'])].PREFIJO+solicitudservicio.getIn(['documento_origen','consecutivo'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudservicio.get('responsable_compras'))&&solicitudservicio.get('tipo')!=5&&solicitudservicio.get('estado')!=0&&solicitudservicio.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_SelectorInput__["a" /* default */],{value:solicitudservicio.getIn(['responsable_compras','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.responsable_compras');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.responsable_compras',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudservicio.getIn(['responsable_compras','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudservicio.getIn(['responsable_compras','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudservicio.getIn(['responsable_compras','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicio.get('created_at')).format('DD/MM/YYYY')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudservicio.get('id')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del servicio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.get('proyecto_evento')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.modificarSolicitud('solicitud.proyecto_evento',e.target.value,id);},disabled:readOnly}))),readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicio.get('fecha_requerido')).format('DD/MM/YYYY')||'',className:'form-control input-sm',disabled:true}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicio.get('fecha_requerido')).format('YYYY-MM-DD')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.modificarSolicitud('solicitud.fecha_requerido',e.target.value,id);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable gesti\xF3n recibo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['responsables_recibo',0,'usuario','fullname'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['responsables_recibo',0,'usuario','area','nombre'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['responsables_recibo',0,'usuario','extension'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable gesti\xF3n ingreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['responsables_ingreso',0,'usuario','fullname'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['responsables_ingreso',0,'usuario','area','nombre'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicio.getIn(['responsables_ingreso',0,'usuario','extension'])||'',className:'form-control input-sm',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Detalles servicios',actions:actionsSectionDetallesServicios},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Descripci\xF3n del servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'35%'}},'Centro de costo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicio.get('servicios').count()>0?solicitudservicio.get('servicios').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:x.get('id')?x.get('id'):x.get('guid'),className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected')?x.get('selected'):false,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.selected',e.target.checked,x.get('id'));},disabled:readOnly||n==0||x.get('cotizaciones')&&x.get('cotizaciones').count()>0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''+(readOnly?'':'LinkToEdit'),style:{textAlign:'right'},onClick:function onClick(){return readOnly?null:_this2.props.displayModalAddServicio(true,'Modificación de items','edit',n);}},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('cantidad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('cencos').map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:c.get('id')?c.get('id'):c.get('guid'),className:'label-cenco-dist',title:c.get('descripcion')},c.get('codigo'),' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_3_numeral___default()(c.getIn(['pivot','porcentaje'])/100).format('0%')));})));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5,style:{textAlign:'center'}},'Para crear los servicios haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'plus-circle'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitudservicio.get('observaciones'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_Comentarios__["a" /* default */],{foros:solicitudservicio.get('foros'),comentario:this.props.comentario,updateInputs:this.props.updateInputs,disabled_comment:disabled_comment,enviarComentario:this.props.enviarComentario,editarComentario:this.props.editarComentario,eliminarComentario:this.props.eliminarComentario}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_AttachedFilesBox__["a" /* default */],{files:solicitudservicio.get('adjuntos'),displayModalAddFile:this.props.displayModalAddFile,removeFiles:this.props.removeFiles,updateInputs:this.props.updateInputs,toggleSelectAllSolicitudServicioFiles:this.props.toggleSelectAllSolicitudServicioFiles,obj:solicitudservicio,check:'solicitud',root:'solicitud'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('/files/'+id,[function(){return _this2.props.getSolicitud(id);}]);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ModalAddServicio__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return General;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudservicio.get('id'),solicitudservicio:state.solicitudservicio.get('solicitud'),enums:state.common.get('enums').toJS(),user:state.common.get('user'),comentario:state.solicitudservicio.get('comentario')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["r" /* getSolicitud */])(id));},updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["C" /* updateInputs */])(path,value,id));},addFile:function addFile(url,actions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["d" /* addFile */])(url,actions));},removeFiles:function removeFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["x" /* removeFiles */])());},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["q" /* selectFromSelector */])(type,payload));},displayModalAddServicio:function displayModalAddServicio(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["l" /* displayModalAddServicio */])(show,title,mode,index));},removeSolicitudServicioItem:function removeSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["z" /* removeSolicitudServicioItem */])());},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["q" /* enviarComentario */])());},editarComentario:function editarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["o" /* editarComentario */])(id));},eliminarComentario:function eliminarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_solicitudservicio__["p" /* eliminarComentario */])(id));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(General));

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_solicitudservicio__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Aprobaciones=function(_Component){_inherits(Aprobaciones,_Component);_createClass(Aprobaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('SMMLV');this.props.getParameterByName('MATRIZ_APROBACION');this.props.getParameterByName('APROBADORES_ADICIONALES');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.setState({aprobadores:this.props.aprobadores});}}]);function Aprobaciones(props){_classCallCheck(this,Aprobaciones);var _this=_possibleConstructorReturn(this,(Aprobaciones.__proto__||Object.getPrototypeOf(Aprobaciones)).call(this,props));_this.rubros=false;_this.aprobador_id=null;_this.indexServicio=null;_this.approve=function(aprobador_id,cencos,indexServicio,idServicio,divisa){var indexCotizacion=_this.props.solicitudservicio.get('cotizaciones').findIndex(function(c){return c.getIn(['servicios',0,'id'])==idServicio;});var indexAprobacion=_this.props.solicitudservicio.getIn(['cotizaciones',indexCotizacion,'aprobaciones']).findIndex(function(a){return a.get('aprobador_id')==aprobador_id;});var tipo=_this.props.solicitudservicio.getIn(['cotizaciones',indexCotizacion,'aprobaciones',indexAprobacion,'tipo']);_this.rubros=false;if(tipo==1){//this.rubros = true
}_this.aprobador_id=aprobador_id;_this.indexServicio=indexServicio;var aprobaciones=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones').filter(function(x){return x.getIn(['cotizacione','servicios',0,'id'])==idServicio;});var observaciones=_this.getObservacion(aprobador_id,idServicio);var setaprobaciones=aprobaciones.setIn([0,'observaciones'],observaciones);_this.props.showModalConfirmarAccion(true,'Al hacer click en Ok, estar\xE1 aprobando el cargue de '+Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["q" /* formatcoin */])(_this.getTotal(_this.aprobador_id),divisa.simbolo)+' \n            '+(cencos.length>1?'entre los ':'al')+' centro'+(cencos.length>1?'s':'')+' de costo '+Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["V" /* uniqueArray */])(cencos).join(', ')+'\n            '+(_this.props.solicitudservicio.get('tipo')==5?'y con la fecha de entrega '+__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.props.solicitudservicio.get('fecha_requerido')).format('DD/MM/YYYY')+' ':''),function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(setaprobaciones,2,indexServicio);},true);};_this.reject=function(aprobadorid,servicioid){_this.rubros=false;_this.indexServicio=null;var indexCotizacion=_this.props.solicitudservicio.get('cotizaciones').findIndex(function(c){return c.getIn(['servicios',0,'id'])==servicioid;});var indexAprobacion=_this.props.solicitudservicio.getIn(['cotizaciones',indexCotizacion,'aprobaciones']).findIndex(function(a){return a.get('aprobador_id')==aprobadorid;});var observaciones=_this.props.solicitudservicio.getIn(['cotizaciones',indexCotizacion,'aprobaciones',indexAprobacion,'observaciones']);var aprobaciones=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobadorid;}).first().get('aprobaciones').filter(function(x){return x.getIn(['cotizacione','servicios',0,'id'])==servicioid;});aprobaciones=aprobaciones.setIn([0,'observaciones'],observaciones);_this.props.showModalConfirmarAccion(true,'\xBFEsta seguro que desea rechazar esta solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(aprobaciones,0);});};_this.getTotal=function(aprobador_id){var total=0;var aprobacion=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones').filter(function(a){return a.get('estado')==3;});if(aprobacion.count()>0){var cotizado=aprobacion.first().getIn(['cotizacione','cotizado_iva'])*aprobacion.first().getIn(['cotizacione','servicios',0,'cantidad']);if(aprobacion.first().get('tipo')<2){// aprobador_id = aprobacion.first().get('aprobador_original_id') || aprobador_id 
total=aprobacion.first().getIn(['cotizacione','servicios',0,'cencos']).filter(function(cenco){return cenco.get('responsable_id')==aprobador_id;}).reduce(function(acc,ele){acc+=cotizado*ele.getIn(['pivot','porcentaje'])/100;return acc;},0);}else{total=aprobacion.first().getIn(['cotizacione','servicios',0,'cencos']).reduce(function(acc,ele){acc+=cotizado*ele.getIn(['pivot','porcentaje'])/100;return acc;},0);}}return total;};_this.getSolicitudRechazada=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')==0;}).count()==aprobaciones.count();};_this.getSolicitudAprobadas=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')==2;}).count()>0;};_this.getSolicitudAprobadasEnRevision=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')==3;}).count()>0;};_this.getEstadoAprobacion=function(index,servicioid){if(index<_this.props.aprobadores.count()){var aprobaciones=_this.props.aprobadores.getIn([index,'aprobaciones']).filter(function(a){return a.getIn(['cotizacione','servicios',0,'id'])==servicioid;});if(aprobaciones.count()>0){if(_this.getSolicitudRechazada(aprobaciones))return 0;if(_this.getSolicitudAprobadas(aprobaciones))return 2;if(_this.getSolicitudAprobadasEnRevision(aprobaciones))return 3;return 1;}}return 1;};_this.getObservacion=function(aprobadorid,servicioid){var cotizacion=_this.props.solicitudservicio.get('cotizaciones').filter(function(c){return c.getIn(['servicios',0,'id'])==servicioid;});var aprobacion=cotizacion&&cotizacion.count()>0?cotizacion.first().get('aprobaciones').filter(function(a){return a.get('aprobador_id')==aprobadorid;}):null;var observacion=aprobacion&&aprobacion.count()>0?aprobacion.first().get('observaciones'):'';return observacion;};_this.getPathObservacion=function(aprobadorid,servicioid){var indexCotizacion=_this.props.solicitudservicio.get('cotizaciones').findIndex(function(c){return c.getIn(['servicios',0,'id'])==servicioid;});var indexAprobacion=_this.props.solicitudservicio.getIn(['cotizaciones',indexCotizacion,'aprobaciones']).findIndex(function(a){return a.get('aprobador_id')==aprobadorid;});return'solicitud.cotizaciones.'+indexCotizacion+'.aprobaciones.'+indexAprobacion+'.observaciones';};_this.handleOpenSelectorAprobador=function(cotizacionId){var fields=[{id:1,caption:'Nombre',value:'fullname',width:'40%'},{id:2,caption:'Cargo',value:'cargo',width:'40%'},{id:3,caption:'Miembro',value:'esmiembrocomite',width:'20%'}];_this.props.showModalSelector('Seleccione aprobador adicional',fields,'/usuarios/aprobadores-adicionales',function(aprobador){return _this.setState(_defineProperty({},'aprobadorAdicional_'+cotizacionId,aprobador));});};_this.tipo_corte=function(cotizadoIva){var _this$props=_this.props,smmlv=_this$props.smmlv,matriz_aprobacion=_this$props.matriz_aprobacion;var tipoAprobacion=1;var totalSMMLV=smmlv&&cotizadoIva/parseFloat(smmlv.first().get('SMMLV'))||0;var match=matriz_aprobacion&&matriz_aprobacion.find(function(item){return parseFloat(item.get('DESDE_SMMLV'))<=totalSMMLV&&totalSMMLV<parseFloat(item.get('HASTA_SMMLV'));});if(match){tipoAprobacion=match&&parseInt(match.get('TIPO_APROBACION'))||1;}return tipoAprobacion;};_this.info_aprobador_adicional=function(aprobador){var aprobadores_adicionales=_this.props.aprobadores_adicionales;if(!aprobador)return null;if(!aprobadores_adicionales)return null;var aprobadorInfo=aprobadores_adicionales.find(function(a){return a.get('USUARIO')===aprobador.get('username');});if(!aprobadorInfo)return null;return{cargo:aprobadorInfo.get('CARGO')||'Sin cargo',esmiembrocomite:aprobadorInfo.get('MIEMBRO_COMITE')==='SI'};};_this.state={aprobador_id:null,aprobadores:_this.props.aprobadores};return _this;}_createClass(Aprobaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicio=_props.solicitudservicio,aprobadores=_props.aprobadores,btnAproveDisabled=_props.btnAproveDisabled,divisas=_props.divisas,enums=_props.enums;//console.log("# entrada de datos 1", aprobadores.toJS())
if(!id)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,solicitudservicio.get('servicios').map(function(servicio,iservicio){return[iservicio>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep1['+iservicio+']',className:'separator'}):null,iservicio>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep2'+iservicio+']',className:'separator'}):null,iservicio>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep3'+iservicio+']',className:'separator'}):null,iservicio>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep4['+iservicio+']',className:'separator'}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{key:'bs['+iservicio+']',title:'Servicio No '+(iservicio+1)+' - '+(servicio.get('descripcion')||'')},solicitudservicio.get('tipo')==5&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Fecha de entrega: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(solicitudservicio.get('fecha_requerido')).format('DD/MM/YYYY')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'separator'}),function(){// Buscar la cotización asociada a este servicio
var cotizacion=solicitudservicio.get('cotizaciones').find(function(c){return c.getIn(['servicios',0,'id'])===servicio.get('id');});if(!cotizacion)return null;var cotizacionId=cotizacion.get('id');var aprobaciones=cotizacion.get('aprobaciones');var cotizadoIva=cotizacion?Number(cotizacion.get('cotizado_iva')):0;var tipo_corte=_this2.tipo_corte(cotizadoIva);// Estados locales para selector y motivo
var solicitar=_this2.state&&_this2.state['solicitarAprobacionAdicional_'+cotizacionId];var aprobador=_this2.state&&_this2.state['aprobadorAdicional_'+cotizacionId];var motivo=_this2.state&&_this2.state['motivoAprobacionAdicional_'+cotizacionId]||'';// Función para manejar el envío de la aprobación adicional
var handleEnviarAprobacionAdicional=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(cotizacionId,servicioId){var _setState;var cotizacion,aprobador,motivo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:cotizacion=this.props.solicitudservicio.get('cotizaciones').find(function(c){return c.get('id')===cotizacionId;});aprobador=this.state['aprobadorAdicional_'+cotizacionId];motivo=this.state['motivoAprobacionAdicional_'+cotizacionId]||'';if(!(!cotizacion||!aprobador||!motivo.trim())){_context.next=5;break;}return _context.abrupt('return');case 5:_context.next=7;return this.props.crearAprobacionAdicional({cotizacion:cotizacion,aprobador:aprobador,motivo:motivo});case 7:this.setState((_setState={},_defineProperty(_setState,'solicitarAprobacionAdicional_'+cotizacionId,false),_defineProperty(_setState,'aprobadorAdicional_'+cotizacionId,null),_defineProperty(_setState,'motivoAprobacionAdicional_'+cotizacionId,''),_setState));case 8:case'end':return _context.stop();}}},_callee,this);}));return function handleEnviarAprobacionAdicional(_x,_x2){return _ref.apply(this,arguments);};}();return tipo_corte===1&&solicitudservicio.get('estado')===3&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Aprobaci\xF3n adicional'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',checked:!!solicitar,onChange:function onChange(e){return _this2.setState(_defineProperty({},'solicitarAprobacionAdicional_'+cotizacionId,e.target.checked));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{marginLeft:'7px'}},'Solicitar aprobaci\xF3n adicional')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3'},solicitar&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'control-label'},'Seleccione aprobador adicional'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_SelectorInput__["a" /* default */],{value:aprobador?aprobador.fullname:'',onClick:function onClick(){return _this2.handleOpenSelectorAprobador(cotizacionId);},onReset:function onReset(){return _this2.setState(_defineProperty({},'aprobadorAdicional_'+cotizacionId,null));}})))),solicitar&&aprobador&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'control-label'},'Cargo del aprobador:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-control input-sm',style:{background:'#f9f9f9',paddingTop:'5px'}},aprobador.cargo||'Sin cargo'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-3',style:{display:'flex',alignItems:'center',marginTop:25}},aprobador.esmiembrocomite==='SI'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label label-success',style:{fontSize:13}},'Integrantes del Comit\xE9 de Rector\xEDa')))),solicitar&&aprobador&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'control-label'},'Motivo de la solicitud adicional'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{rows:3,className:'form-control input-sm',value:motivo,onChange:function onChange(e){return _this2.setState(_defineProperty({},'motivoAprobacionAdicional_'+cotizacionId,e.target.value));}})))),solicitar&&aprobador&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12',style:{textAlign:'right',paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',disabled:!motivo.trim(),onClick:function onClick(){return handleEnviarAprobacionAdicional.call(_this2,cotizacionId,servicio.get('id'));}},'Enviar solicitud adicional'))));}(),aprobadores.map(function(aprobador,iaprobador){var aprobaciones=aprobador.get('aprobaciones').filter(function(x){return x.getIn(['cotizacione','servicios',0,'id'])==servicio.get('id');});var estado=_this2.getEstadoAprobacion(iaprobador,servicio.get('id'));var cencos=[];if(aprobaciones.count()==0)return null;var moneda=aprobaciones.first().getIn(['cotizacione','moneda'])?aprobaciones.first().getIn(['cotizacione','moneda']):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var info_aprobador_adicional=_this2.info_aprobador_adicional(aprobador);console.log("# aprobador: ",info_aprobador_adicional);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],{key:'fr['+iservicio+']['+iaprobador+']'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,aprobaciones.first().get('tipo')===3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'#fff',fontWeight:600}},'Solicitud de aprobaci\xF3n adicional a ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,aprobador.get('fullname'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,'Solicitud de aprobaci\xF3n nivel ',Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["N" /* romanize */])(aprobaciones.first().get('tipo')),' a ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,aprobador.get('fullname'))))},info_aprobador_adicional&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontWeight:500}},'Cargo: ',info_aprobador_adicional.cargo||'Sin cargo'),info_aprobador_adicional.esmiembrocomite?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'label label-success',style:{marginLeft:10}},'Integrantes del Comit\xE9 de Rector\xEDa'):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Solicitud de aprobaci\xF3n: ',enums.aprobaciones.estados[estado],estado===1?'':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' \u2022 ',aprobaciones.first().get('fecha')?__WEBPACK_IMPORTED_MODULE_3_moment___default()(aprobaciones.first().get('fecha')).format('YYYY-MM-DD HH:mm'):null)))),estado==2&&aprobaciones.filter(function(a){return a.get('estado')==2;}).first().get('aprobador_su')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep2['+iservicio+']['+iaprobador+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Esta solicitud fue aprobada por ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,aprobaciones.first().getIn(['aprobador_su','fullname'])))))),estado==0&&aprobaciones.filter(function(a){return a.get('estado')==0;}).first().get('aprobador_su')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep2['+iservicio+']['+iaprobador+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Esta solicitud fue rechazada por ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,aprobaciones.first().getIn(['aprobador_su','fullname'])))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Solicitada por ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,solicitudservicio.getIn(['solicitante','fullname']))),' \u2022 ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'mailto:'+solicitudservicio.getIn(['solicitante','email'])},solicitudservicio.getIn(['solicitante','email']))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep2['+iservicio+']['+iaprobador+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,'Detalle:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sep3['+iservicio+']['+iaprobador+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'row['+iservicio+']['+iaprobador+']',className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped',id:'aprobaciones'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'Seleccionar'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'Valor cotizado'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'Valor a aprobar'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{textAlign:'center'}},'Distribuci\xF3n de cenco'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'50px',textAlign:'center'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,aprobaciones.map(function(aprobacion,iaprobacion){var totalAprobar_porcentaje=100;var aprobador_id=aprobador.get('id');if(aprobacion.get('tipo')<2){totalAprobar_porcentaje=aprobacion.getIn(['cotizacione','servicios','0','cencos']).filter(function(x){return x.get('responsable_id')==aprobador_id;}).reduce(function(a,b){a+=Number(b.getIn(['pivot','porcentaje']));return a;},0);}var totalAprobar=totalAprobar_porcentaje/100*aprobacion.getIn(['cotizacione','cotizado_iva'])*servicio.get('cantidad');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:'tr['+iservicio+']['+iaprobador+'['+iaprobacion+']]'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle',padding:'15px'}},estado==0||estado==2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,aprobacion.get('estado')==2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default.a,{name:'check',style:{color:'green',fontSize:'30px'}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,aprobacion.get('estado')==2||aprobacion.get('estado')==3?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default.a,{name:'check',style:{color:'green',fontSize:'30px'}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{style:{width:'45px',height:'35px'},onClick:function onClick(){return _this2.props.seleccionarAprobacion(servicio.get('id'),aprobador.get('id'),aprobacion.get('id'));}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},aprobacion.getIn(['cotizacione','proveedore','nombre'])==null?' COMPRA DIRECTA':aprobacion.getIn(['cotizacione','proveedore','nombre'])),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle'}},Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["q" /* formatcoin */])(aprobacion.getIn(['cotizacione','cotizado_iva'])*servicio.get('cantidad'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle'}},Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["q" /* formatcoin */])(totalAprobar,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped',id:'dist-cenco'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{textAlign:'center'}},'Cenco'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{textAlign:'center'}},'Rubro'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{textAlign:'center'}},'%'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{textAlign:'center'}},'Valor'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,aprobacion.getIn(['cotizacione','servicios','0','cencos']).map(function(cenco,icenco){var indexCenco=cencos.findIndex(function(x){return x==cenco.get('codigo');});if(indexCenco==-1)cencos.push(cenco.get('codigo'));if(aprobacion.get('tipo')<2&&cenco.get('responsable_id')!=aprobador_id&&cenco.getIn(['pivot','aprobador_id'])!=aprobador_id)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:'tr2['+iservicio+']['+iaprobador+']['+iaprobacion+']['+icenco+']'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{title:''+cenco.get('descripcion')},cenco.get('codigo'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{title:''+cenco.getIn(['pivot','rubro','descripcion'])},cenco.getIn(['pivot','rubro','nombre']))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(cenco.getIn(['pivot','porcentaje'])/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["q" /* formatcoin */])(cenco.getIn(['pivot','porcentaje'])/100*aprobacion.getIn(['cotizacione','cotizado_iva'])*servicio.get('cantidad'),divisa.simbolo)));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle'}},aprobacion.getIn(['cotizacione','recomendado'])&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default.a,{name:'star',style:{color:'goldenrod',fontSize:'30px'},title:"Recomendado"})));}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{rows:6,className:'form-control input-sm',value:_this2.getObservacion(aprobador.get('id'),servicio.get('id'))||'',onChange:function onChange(e){return _this2.props.updateInputs(_this2.getPathObservacion(aprobador.get('id'),servicio.get('id')),e.target.value);},disabled:estado!=1&&estado!=3||solicitudservicio.get('estado')==0||!Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobaciones',aprobador)||aprobaciones.first().get('tipo')===3})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'separator'}),(estado==1||estado==3)&&Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobaciones',aprobador)&&solicitudservicio.get('estado')>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'right',padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary btn-sm btn-squared',onClick:function onClick(){return _this2.approve(aprobador.get('id'),cencos,iservicio,servicio.get('id'),divisa);},disabled:btnAproveDisabled},'Aprobar')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-default btn-sm btn-squared',onClick:function onClick(e){return _this2.reject(aprobador.get('id'),servicio.get('id'));},disabled:btnAproveDisabled},'Rechazar')))))));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalConfirmarAccion__["a" /* default */],null,_this2.rubros&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Selecci\xF3n de rubros',onModal:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,_this2.props.solicitudservicio.getIn(['servicios',_this2.indexServicio,'cencos']).filter(function(c){return c.get('responsable_id')==_this2.aprobador_id;}).map(function(x,n){if(x.get('rubros').count()>0){var index=_this2.props.solicitudservicio.getIn(['servicios',_this2.indexServicio,'cencos']).findIndex(function(f){return f.get('id')===x.get('id');});if(index<0)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:'tr['+x.get('id')+']'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:x.get('descripcion')?x.get('descripcion'):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{className:'form-control input-sm',value:Number(x.getIn(['pivot','rubro_id']))||0,onChange:function onChange(e){_this2.props.updateInputs('solicitud.servicios.'+_this2.indexServicio+'.cencos.'+index+'.pivot.rubro_id',Number(e.target.value));}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opci\xF3n'),x.get('rubros').map(function(r,j){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'optr['+j+']',value:r.get('id')},r.get('nombre'));}))));}})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalSelectorFromList__["a" /* default */],null))];}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalConfirmarAccion__["a" /* default */],null,this.rubros&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Selecci\xF3n de rubros',onModal:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,this.props.solicitudservicio.getIn(['servicios',this.indexServicio,'cencos']).filter(function(c){return c.get('responsable_id')==_this2.aprobador_id;}).map(function(x,n){if(x.get('rubros').count()>0){var index=_this2.props.solicitudservicio.getIn(['servicios',_this2.indexServicio,'cencos']).findIndex(function(f){return f.get('id')===x.get('id');});if(index<0)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:'tr['+x.get('id')+']'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:x.get('descripcion')?x.get('descripcion'):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{className:'form-control input-sm',value:Number(x.getIn(['pivot','rubro_id']))||0,onChange:function onChange(e){_this2.props.updateInputs('solicitud.servicios.'+_this2.indexServicio+'.cencos.'+index+'.pivot.rubro_id',Number(e.target.value));}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opci\xF3n'),x.get('rubros').map(function(r,j){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'optr['+j+']',value:r.get('id')},r.get('nombre'));}))));}})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Aprobaciones;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudservicio.get('id'),solicitudservicio:state.solicitudservicio.get('solicitud'),aprobadores:state.solicitudservicio.get('aprobadores'),user:state.common.get('user'),modalConfirmarAccion:state.common.get('modalConfirmarAccion'),btnAproveDisabled:state.solicitudservicio.get('btnAproveDisabled'),divisas:state.common.getIn(['parametros','DIVISAS']),enums:state.common.get('enums').toJS(),smmlv:state.common.getIn(['parametros','SMMLV']),matriz_aprobacion:state.common.getIn(['parametros','MATRIZ_APROBACION']),aprobadores_adicionales:state.common.getIn(['parametros','APROBADORES_ADICIONALES'])};}function mapDispatchToProps(dispatch){return{showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},seleccionarAprobacion:function seleccionarAprobacion(servicioid,aprobadorid,aprobacionid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudservicio__["A" /* seleccionarAprobacion */])(servicioid,aprobadorid,aprobacionid));},registerApprovalResult:function registerApprovalResult(aprobaciones,result,indexServicio){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudservicio__["u" /* registerApprovalResult */])(aprobaciones,result,indexServicio));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudservicio__["C" /* updateInputs */])(path,value));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["q" /* selectFromSelector */])(type,payload));},crearAprobacionAdicional:function crearAprobacionAdicional(payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudservicio__["i" /* crearAprobacionAdicional */])(payload));},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["l" /* getParameterByName */])(param));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Aprobaciones));

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicio_ModalCreateDocumento__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SolicitudServicio_ModalSummaryDocumento__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Documentos_ModalCreateEntrega__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Documentos_ModalAddFactura__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Documentos_ModalLastFactura__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Documentos_ModalAddAdicional__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_documentos__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Documentos=function(_Component){_inherits(Documentos,_Component);function Documentos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Documentos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Documentos.__proto__||Object.getPrototypeOf(Documentos)).call.apply(_ref,[this].concat(args))),_this),_this.buttonOption=function(documento,index){if(documento.getIn(['aprobacion','estado'])===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'binoculars',onClick:function onClick(){return _this.props.showHideModalSummary(true,documento.get('id'),'solicitudes/servicios/'+_this.props.id,'ACTUALIZAR_SOLICITUD_SERVICIO');}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',onClick:function onClick(){return _this.props.displayModalCreateDocumento(true,'Documento','edit',index);},disabled:!Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',_this.props.solicitudservicio)||documento.get('estado')===0});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Documentos,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicio=_props.solicitudservicio,enums=_props.enums,divisas=_props.divisas;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'9%'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'11%'}},'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'12%'}},'Fecha inicio (registro)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'7%'}},'Fecha entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Servicios'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicio.get('documentos').map(function(a,b){var moneda=a.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var valor_con_iva=a.get('detalles').reduce(function(a1,b1){a1+=b1.get('valor_con_iva')*b1.get('cantidad');return a1;},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},_this2.buttonOption(a,b)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('consecutivo')?enums.documentos.tipos[a.get('tipo')].PREFIJO+a.get('consecutivo'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['proveedore','nombre'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["q" /* formatcoin */])(valor_con_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.tipos[a.get('tipo')]?enums.documentos.tipos[a.get('tipo')].NOMBRE:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.estados[a.get('estado')]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_inicio')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_inicio')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_entrega')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_entrega')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,a.get('detalles').map(function(c,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr5['+a.get('id')+']['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:c.get('adicion_id')!==null?'adicional':''},c.get('descripcion')));})))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicio_ModalCreateDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SolicitudServicio_ModalSummaryDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Documentos_ModalCreateEntrega__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Documentos_ModalAddFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Documentos_ModalLastFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Documentos_ModalAddAdicional__["a" /* default */],{tipo_solicitud:solicitudservicio.get('tipo')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Documentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{id:state.solicitudservicio.get('id'),solicitudservicio:state.solicitudservicio.get('solicitud'),enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode,indexDocumento){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicio__["n" /* displayModalCreateDocumento */])(show,title,mode,indexDocumento));},showHideModalSummary:function showHideModalSummary(show,id,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["k" /* showHideModalSummary */])(show,id,url,type));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Documentos));

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_solicitudservicio__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancelacion=function(_Component){_inherits(Cancelacion,_Component);function Cancelacion(){_classCallCheck(this,Cancelacion);return _possibleConstructorReturn(this,(Cancelacion.__proto__||Object.getPrototypeOf(Cancelacion)).apply(this,arguments));}_createClass(Cancelacion,[{key:'render',value:function render(){var _this2=this;var solicitud=this.props.solicitud;var id=solicitud.get('id');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de cancelaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitud.get('fecha_cancelacion')).format('YYYY-MM-DD')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de cancelaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitud.get('motivo_cancelacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.motivo_cancelacion',e.target.value,id);},disabled:solicitud.get('estado')==0}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Cancelacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitud:state.solicitudservicio.get('solicitud')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_solicitudservicio__["C" /* updateInputs */])(path,value,id));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cancelacion));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ModalAddServicio__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_Comentarios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var General=function(_Component){_inherits(General,_Component);function General(){var _ref;var _temp,_this,_ret;_classCallCheck(this,General);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=General.__proto__||Object.getPrototypeOf(General)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1',payload);var estado=_this.props.solicitudservicioot.get('estado');if(estado==1){_this.props.updateInputs('addModificacion',true);}};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/auxiliares',fn);},_this.handleOpenSelectorProveedor=function(path){var columns=[{id:1,caption:'Identificacion',value:'identificacion',width:'30%'},{id:2,caption:'Nombre',value:'nombre',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.seleccionarProveedor(payload);});};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores',fn);},_this.modificarSolicitud=function(path,value,id){_this.props.updateInputs(path,value,id);_this.props.updateInputs('addModificacion',true);},_this.handleOpenSelectorMoneda=function(moneda){_this.props.seleccionarMoneda(moneda);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(General,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicioot=_props.solicitudservicioot,enums=_props.enums,user=_props.user,divisas=_props.divisas;if(!id)return null;var moneda=solicitudservicioot.getIn(['cotizaciones',0,'moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var esResponsableCompras=solicitudservicioot.getIn(['responsable_compras','id'])==user.get('id');var esSuperusuario=user.get('es_superusuario');var estado=solicitudservicioot.get('estado');var readOnly=!esResponsableCompras&&!esSuperusuario||estado===0||estado>=3;//const readOnly = true
var totalSevicios_sin_iva=solicitudservicioot.get('servicios').reduce(function(a,b){a+=b.get('valor');return a;},0);var totalSevicios=solicitudservicioot.get('servicios').reduce(function(a,b){a+=Number(b.get('valor_con_iva'));return a;},0);var nombre='';var documento=solicitudservicioot.get('documentos').first();if(documento){var consecutivo=documento.get('consecutivo')?documento.get('consecutivo'):null;if(consecutivo){nombre=''+enums.documentos.tipos[documento.get('tipo')].PREFIJO+consecutivo;}}var actionsSectionDetallesServicios=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalAddServicio(true,'Agregar Item','create');},title:'Adicionar servicio',disabled:readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeSolicitudServicioItems();},title:'Eliminar servicio',danger:true,disabled:solicitudservicioot.get('servicios').filter(function(x){return x.get('selected');}).count()===0})];var disabled_comment=estado===0||estado===7;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudservicioot.get('solicitante'))&&solicitudservicioot.get('tipo')!=5&&solicitudservicioot.get('estado')!=0&&solicitudservicioot.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_SelectorInput__["a" /* default */],{value:solicitudservicioot.getIn(['solicitante','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.solicitante');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.solicitante',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicioot.getIn(['solicitante','fullname'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicioot.getIn(['solicitante','email'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicioot.getIn(['solicitante','extension'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicioot.getIn(['solicitante','area','nombre'])||'',className:'form-control input-sm',disabled:true}))),solicitudservicioot.get('documento_origen_id')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Orden/Contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:enums.documentos.tipos[solicitudservicioot.getIn(['documento_origen','tipo'])].PREFIJO+solicitudservicioot.getIn(['documento_origen','consecutivo'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudservicioot.get('responsable_compras'))&&solicitudservicioot.get('tipo')!=5&&solicitudservicioot.get('estado')!=0&&solicitudservicioot.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_SelectorInput__["a" /* default */],{value:solicitudservicioot.getIn(['responsable_compras','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.responsable_compras');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.responsable_compras',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudservicioot.getIn(['responsable_compras','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudservicioot.getIn(['responsable_compras','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudservicioot.getIn(['responsable_compras','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicioot.get('created_at')).format('DD/MM/YYYY')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudservicioot.get('id')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del servicio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudservicioot.get('proyecto_evento')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.modificarSolicitud('solicitud.proyecto_evento',e.target.value,id);},disabled:readOnly}))),readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:solicitudservicioot.getIn(['cotizaciones','0','proveedore','nombre'])||'',disabled:true}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_SelectorInput__["a" /* default */],{value:solicitudservicioot.getIn(['cotizaciones','0','proveedore','nombre'])||'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('solicitud.cotizaciones.0.proveedore');},onReset:function onReset(){return null;}}))),readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicioot.get('fecha_requerido')).format('DD/MM/YYYY'),disabled:true}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicioot.get('fecha_requerido')).format('YYYY-MM-DD'),onChange:function onChange(e){return _this2.modificarSolicitud('solicitud.fecha_requerido',e.target.value,id);},disabled:readOnly})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Responsables del ingreso del proveedor',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{maxHeight:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicioot.get('responsables_ingreso').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr3['+a.get('id')+']',className:a.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.getIn(['usuario','fullname'])?a.getIn(['usuario','fullname']):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.getIn(['usuario','area','nombre'])||'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'14%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.getIn(['usuario','extension'])||'',disabled:true})));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Responsables del recibo del servicio',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{maxHeight:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicioot.get('responsables_recibo').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr3['+a.get('id')+']',className:a.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.getIn(['usuario','fullname'])?a.getIn(['usuario','fullname']):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.getIn(['usuario','area','nombre'])||'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'14%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.getIn(['usuario','extension'])||'',disabled:true})));})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Detalles servicios',actions:actionsSectionDetallesServicios},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-divisas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{maxWidth:'86%',padding:'0 10px'}},'Tipo de moneda:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{alignItems:'flex-end'},className:'btn-group',role:'group'},divisas&&divisas.map(function(d,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:'d['+i+']',style:{borderRadius:'5px'},onClick:!readOnly?function(){return _this2.handleOpenSelectorMoneda(d.get('CODIGO'));}:null,type:'button',className:divisa.moneda==d.get('CODIGO')?'btn btn-primary':'btn btn-outline-primary'},d.get('CODIGO'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'40%'}},'Descripci\xF3n del servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'18%'}},'Valor del servicio sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'18%'}},'Valor total del servicio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicioot.get('servicios').count()>0?solicitudservicioot.get('servicios').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:x.get('id'),className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.selected',e.target.checked);},disabled:n==0||solicitudservicioot.get('estado')!=3})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''+(readOnly?'':'LinkToEdit'),style:{textAlign:'right'},onClick:function onClick(){return readOnly?null:_this2.props.displayModalAddServicio(true,'Modificación de items','edit',n);}},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["q" /* formatcoin */])(x.get('valor'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["q" /* formatcoin */])(x.get('valor_con_iva'),divisa.simbolo)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4,style:{textAlign:'center'}},'Para crear los servicios haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{name:'plus-circle'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Recursos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Ordenador del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:solicitudservicioot.getIn(['servicios','0','cencos','0','usuario','fullname'])||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Anticipo aprobado, %'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:solicitudservicioot.getIn(['cotizaciones','0','anticipo']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor del anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["q" /* formatcoin */])(Number(solicitudservicioot.getIn(['cotizaciones','0','anticipo']))/100*totalSevicios_sin_iva,divisa.simbolo),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Distribuci\xF3n en centros de costo',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicioot.getIn(['servicios','0','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:x.get('descripcion')?x.get('descripcion'):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.getIn(['pivot','porcentaje']),disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["q" /* formatcoin */])(Number(x.getIn(['pivot','porcentaje']))/100*totalSevicios,divisa.simbolo),disabled:true})));})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitudservicioot.get('observaciones')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_Comentarios__["a" /* default */],{foros:solicitudservicioot.get('foros'),comentario:this.props.comentario,updateInputs:this.props.updateInputs,disabled_comment:disabled_comment,enviarComentario:this.props.enviarComentario,editarComentario:this.props.editarComentario,eliminarComentario:this.props.eliminarComentario}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_AttachedFilesBox__["a" /* default */],{files:solicitudservicioot.get('adjuntos').filter(function(adjunto){return!adjunto.get('documento_id');}),root:'solicitud',removeFiles:this.props.removeFiles,updateInputs:this.props.updateInputs,obj:solicitudservicioot,check:'solicitud'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('/files/'+id,[function(){return _this2.props.getSolicitud(id);}]);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ModalAddServicio__["a" /* default */],null));}}]);return General;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudservicioot.get('id'),solicitudservicioot:state.solicitudservicioot.get('solicitud'),enums:state.common.get('enums').toJS(),user:state.common.get('user'),divisas:state.common.getIn(['parametros','DIVISAS']),comentario:state.solicitudservicioot.get('comentario')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["k" /* getSolicitud */])(id));},updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["u" /* updateInputs */])(path,value,id));},addFile:function addFile(url,actions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["a" /* addFile */])(url,actions));},removeFiles:function removeFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["o" /* removeFiles */])());},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},seleccionarProveedor:function seleccionarProveedor(payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["t" /* seleccionarProveedor */])(payload));},displayModalAddServicio:function displayModalAddServicio(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["f" /* displayModalAddServicio */])(show,title,mode,index));},removeSolicitudServicioItems:function removeSolicitudServicioItems(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["p" /* removeSolicitudServicioItems */])());},seleccionarMoneda:function seleccionarMoneda(moneda){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["s" /* seleccionarMoneda */])(moneda));},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["j" /* enviarComentario */])());},editarComentario:function editarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["h" /* editarComentario */])(id));},eliminarComentario:function eliminarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_solicitudservicioot__["i" /* eliminarComentario */])(id));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(General));

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Aprobaciones=function(_Component){_inherits(Aprobaciones,_Component);_createClass(Aprobaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('SMMLV');this.props.getParameterByName('MATRIZ_APROBACION');this.props.getParameterByName('APROBADORES_ADICIONALES');}}]);function Aprobaciones(props){_classCallCheck(this,Aprobaciones);var _this=_possibleConstructorReturn(this,(Aprobaciones.__proto__||Object.getPrototypeOf(Aprobaciones)).call(this,props));_this.handleOpenSelectorAprobador=function(){var fields=[{id:1,caption:'Nombre',value:'fullname',width:'40%'},{id:2,caption:'Cargo',value:'cargo',width:'40%'},{id:3,caption:'Miembro',value:'esmiembrocomite',width:'20%'}];_this.props.showModalSelector('Seleccione aprobador adicional',fields,'/usuarios/aprobadores-adicionales',function(aprobador){_this.setState({aprobadorAdicional:aprobador});});};_this.rubros=false;_this.registerRubros=function(index,value){_this.props.solicitudservicioot.get('servicios').keySeq().forEach(function(k){return _this.props.updateInputs('solicitud.servicios.'+k+'.cencos.'+index+'.pivot.rubro_id',value);});};_this.approve=function(tipo,indice,totalSevicios,cencos,m){_this.rubros=false;if(tipo==1){//this.rubros = true
}_this.props.showModalConfirmarAccion(true,'Al hacer click en Ok, estar\xE1 aprobando el cargue de '+Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(totalSevicios,m)+' '+(cencos.length>1?'entre los ':'al')+' \n            centro'+(cencos.length>1?'s':'')+' de costo '+Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["V" /* uniqueArray */])(cencos).join(', ')+'\n            '+(_this.props.solicitudservicioot.get('tipo')==5?'y con la fecha de entrega '+__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.props.solicitudservicioot.get('fecha_requerido')).format('DD/MM/YYYY')+' ':''),function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(indice,2);});};_this.reject=function(indice){_this.rubros=false;_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea rechazar esta solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(indice,0);});};_this.showApproval=function(aprobador_id){var showApproval=true;var aprobaciones=_this.props.solicitudservicioot.getIn(['cotizaciones','0','aprobaciones']);var aprobacion=aprobaciones.filter(function(a){return a.get('aprobador_id')===aprobador_id;}).first();if(aprobacion.get('estado')===1&&!_this.props.user.get('es_superusuario')){var aprobaciones_requeridas=aprobaciones.filter(function(a){return a.getIn(['aprobador','reporta_a_id'])===aprobador_id&&a.get('aprobador_id')!==a.getIn(['aprobador','reporta_a_id']);});showApproval=aprobaciones_requeridas.filter(function(a){return a.get('estado')===1;}).count()===0;}return showApproval;};_this.handleEnviarSolicitudAdicional=function(){var _this$state=_this.state,aprobadorAdicional=_this$state.aprobadorAdicional,motivoAprobacionAdicional=_this$state.motivoAprobacionAdicional;if(!aprobadorAdicional||!motivoAprobacionAdicional.trim()){return;}_this.props.crearAprobacionAdicional(aprobadorAdicional,motivoAprobacionAdicional);_this.setState({solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''});};_this.tipo_corte=function(){var _this$props=_this.props,smmlv=_this$props.smmlv,matriz_aprobacion=_this$props.matriz_aprobacion,solicitudservicioot=_this$props.solicitudservicioot;var tipoAprobacion=1;var cotizacion=solicitudservicioot.getIn(['cotizaciones',0]);var trm=cotizacion?Number(cotizacion.get('trm')):1;var cotizadoIva=cotizacion?Number(cotizacion.get('cotizado_iva')):0;var totalSMMLV=smmlv&&cotizadoIva*trm/parseFloat(smmlv.first().get('SMMLV'))||0;var match=matriz_aprobacion&&matriz_aprobacion.find(function(item){return parseFloat(item.get('DESDE_SMMLV'))<=totalSMMLV&&totalSMMLV<parseFloat(item.get('HASTA_SMMLV'));});if(match){tipoAprobacion=match&&parseInt(match.get('TIPO_APROBACION'))||1;}return tipoAprobacion;};_this.info_aprobador_adicional=function(aprobador){var aprobadores_adicionales=_this.props.aprobadores_adicionales;if(!aprobador)return null;if(!aprobadores_adicionales)return null;var aprobadorInfo=aprobadores_adicionales.find(function(a){return a.get('USUARIO')===aprobador.get('username');});if(!aprobadorInfo)return null;return{cargo:aprobadorInfo.get('CARGO')||'Sin cargo',esmiembrocomite:aprobadorInfo.get('MIEMBRO_COMITE')==='SI'};};_this.state={solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''};return _this;}_createClass(Aprobaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicioot=_props.solicitudservicioot,enums=_props.enums,btnAproveDisabled=_props.btnAproveDisabled,divisas=_props.divisas;if(!id)return null;var moneda=solicitudservicioot.getIn(['cotizaciones',0,'moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var totalSevicios=solicitudservicioot.get('servicios').reduce(function(a,b){a+=b.get('valor_con_iva');return a;},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.tipo_corte()===1&&solicitudservicioot.get('estado')==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Aprobaci\xF3n adicional'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:this.state.solicitarAprobacionAdicional,onChange:function onChange(e){return _this2.setState({solicitarAprobacionAdicional:e.target.checked});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'7px'}},'Solicitar aprobaci\xF3n adicional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},this.state.solicitarAprobacionAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione aprobador adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__["a" /* default */],{value:this.state.aprobadorAdicional?this.state.aprobadorAdicional.fullname:'',onClick:this.handleOpenSelectorAprobador,onReset:function onReset(){return _this2.setState({aprobadorAdicional:null});}})))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cargo del aprobador:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control input-sm',style:{background:'#f9f9f9',paddingTop:'5px'}},this.state.aprobadorAdicional.cargo||'Sin cargo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{display:'flex',alignItems:'center',marginTop:25}},this.state.aprobadorAdicional.esmiembrocomite==='SI'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{fontSize:13}},'Integrantes del Comit\xE9 de Rector\xEDa')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo de la solicitud adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:3,className:'form-control input-sm',value:this.state.motivoAprobacionAdicional,onChange:function onChange(e){return _this2.setState({motivoAprobacionAdicional:e.target.value});}}))))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{textAlign:'right',paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',disabled:!this.state.motivoAprobacionAdicional.trim()||!this.state.aprobadorAdicional,onClick:this.handleEnviarSolicitudAdicional},'Enviar solicitud adicional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'20px'}}),solicitudservicioot.getIn(['cotizaciones','0','aprobaciones']).count()>0&&solicitudservicioot.getIn(['cotizaciones','0','aprobaciones']).map(function(a,b){var cencos=[];if(!_this2.showApproval(a.get('aprobador_id')))return;var info_aprobador_adicional=_this2.info_aprobador_adicional(a.getIn(['aprobador']));return[b>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep1['+b+']',className:'separator'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{key:'bs1['+a.get('id')+']',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,a.get('estado')===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green'}}):a.get('estado')===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'times',style:{color:'red'}}):'',a.get('tipo')===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#fff',fontWeight:600}},'Solicitud de aprobaci\xF3n adicional a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,a.getIn(['aprobador','fullname']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,'Solicitud de aprobaci\xF3n nivel ',Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["N" /* romanize */])(a.get('tipo')),' a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,a.getIn(['aprobador','fullname']))))},info_aprobador_adicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:500}},'Cargo: ',info_aprobador_adicional.cargo||'Sin cargo'),info_aprobador_adicional.esmiembrocomite?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{marginLeft:10}},'Integrantes del Comit\xE9 de Rector\xEDa'):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Solicitud de aprobaci\xF3n: ',enums.aprobaciones.estados[a.get('estado')],a.get('estado')===1?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' \u2022 ',__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha')).format('YYYY-MM-DD HH:mm'))))),a.get('aprobador_su')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Esta solicitud fue aprobada por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,a.getIn(['aprobador_su','fullname']))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Solicitada por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,solicitudservicioot.getIn(['solicitante','fullname']))),' \u2022 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+solicitudservicioot.getIn(['solicitante','email'])},solicitudservicioot.getIn(['solicitante','email']))))),solicitudservicioot.get('tipo')==5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fecha de entrega: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicioot.get('fecha_requerido')).format('DD/MM/YYYY')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep3['+b+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Detalle:'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'40%'}},'Distribuci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicioot.getIn(['cotizaciones','0','servicios']).map(function(c,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+a.get('id')+']['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,c.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(c.get('valor_con_iva'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Rubro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,c.get('cencos').filter(function(e){return a.get("tipo")==1?e.get('responsable_id')===a.getIn(['aprobador','id'])||e.getIn(['pivot','aprobador_id'])===a.getIn(['aprobador','id']):true;}).map(function(e,f){cencos.push(e.get('codigo'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr2['+a.get('id')+']['+c.get('id')+']['+e.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+e.get('descripcion')},e.get('codigo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+e.getIn(['pivot','rubro','descripcion'])},e.getIn(['pivot','rubro','nombre']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(e.getIn(['pivot','porcentaje'])/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(e.getIn(['pivot','porcentaje'])/100*c.get('valor_con_iva'),divisa.simbolo)));})))));}))))),a.get('estado')!==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control input-sm',style:{height:'60px',overflowX:'hidden'}},a.get('observaciones')||'')))),Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobacion',a)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:6,className:'form-control input-sm',value:a.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.cotizaciones.0.aprobaciones.'+b+'.observaciones',e.target.value);},disabled:a.get('tipo')===3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right',padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm btn-squared',onClick:function onClick(e){return _this2.approve(a.get('tipo'),b,totalSevicios,cencos,divisa.simbolo);},disabled:btnAproveDisabled},'Aprobar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default btn-sm btn-squared',onClick:function onClick(e){return _this2.reject(b);},disabled:btnAproveDisabled},'Rechazar')))))))];}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Shared_ModalConfirmarAccion__["a" /* default */],null,this.rubros&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_Box__["a" /* default */],{title:'Selecci\xF3n de rubros',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.solicitudservicioot.getIn(['servicios','0','cencos']).map(function(x,n){if(x.get('rubros').count()>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:x.get('descripcion')?x.get('descripcion'):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:Number(x.getIn(['pivot','rubro_id']))||0,onChange:function onChange(e){_this2.registerRubros(n,Number(e.target.value));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opci\xF3n'),x.get('rubros').map(function(r,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'optr['+j+']',value:r.get('id')},r.get('nombre'));}))));}})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Aprobaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudservicioot.get('id'),solicitudservicioot:state.solicitudservicioot.get('solicitud'),enums:state.common.get('enums').toJS(),user:state.common.get('user'),btnAproveDisabled:state.solicitudservicioot.get('btnAproveDisabled'),divisas:state.common.getIn(['parametros','DIVISAS']),smmlv:state.common.getIn(['parametros','SMMLV']),matriz_aprobacion:state.common.getIn(['parametros','MATRIZ_APROBACION']),aprobadores_adicionales:state.common.getIn(['parametros','APROBADORES_ADICIONALES'])};}function mapDispatchToProps(dispatch){return{showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},registerApprovalResult:function registerApprovalResult(index,result){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["m" /* registerApprovalResult */])(index,result));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["u" /* updateInputs */])(path,value));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["q" /* selectFromSelector */])(type,payload));},crearAprobacionAdicional:function crearAprobacionAdicional(aprobadorAdicional,motivoAprobacionAdicional){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["d" /* crearAprobacionAdicional */])(aprobadorAdicional,motivoAprobacionAdicional));},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["l" /* getParameterByName */])(param));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Aprobaciones));

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SolicitudServicioOT_ModalCreateDocumento__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicioOT_ModalSummaryDocumento__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Documentos_ModalCreateEntrega__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Documentos_ModalAddFactura__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Documentos_ModalLastFactura__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Documentos_ModalAddAdicional__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_solicitudservicioot__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_documentos__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Documentos=function(_Component){_inherits(Documentos,_Component);function Documentos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Documentos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Documentos.__proto__||Object.getPrototypeOf(Documentos)).call.apply(_ref,[this].concat(args))),_this),_this.buttonOption=function(documento,index){if(documento.getIn(['aprobacion','estado'])===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxButton__["a" /* default */],{size:12,name:'binoculars',onClick:function onClick(){return _this.props.showHideModalSummary(true,documento.get('id'),'solicitudes/servicios-oficina-tecnica/'+_this.props.id,'ACTUALIZAR_SOLICITUD_SERVICIO_OT');}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',onClick:function onClick(){return _this.props.displayModalCreateDocumento(true,'Documento','edit',index);},disabled:!Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',_this.props.solicitudservicioot)||documento.get('estado')===0});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Documentos,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicioot=_props.solicitudservicioot,enums=_props.enums,divisas=_props.divisas;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'9%'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'11%'}},'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'12%'}},'Fecha inicio (registro)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'7%'}},'Fecha entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Servicios'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicioot.get('documentos').valueSeq().map(function(a,b){var moneda=a.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var valor_con_iva=a.get('detalles').reduce(function(a1,b1){a1+=b1.get('valor_con_iva');return a1;},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},_this2.buttonOption(a,b)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('consecutivo')?enums.documentos.tipos[a.get('tipo')].PREFIJO+a.get('consecutivo'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['proveedore','nombre'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["q" /* formatcoin */])(valor_con_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.tipos[a.get('tipo')]?enums.documentos.tipos[a.get('tipo')].NOMBRE:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.estados[a.get('estado')]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_inicio')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_inicio')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_entrega')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_entrega')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,a.get('detalles').map(function(c,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr5['+a.get('id')+']['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:c.get('adicion_id')!==null?'adicional':''},c.get('descripcion')));})))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SolicitudServicioOT_ModalCreateDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicioOT_ModalSummaryDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Documentos_ModalCreateEntrega__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Documentos_ModalAddFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Documentos_ModalLastFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Documentos_ModalAddAdicional__["a" /* default */],{tipo_solicitud:solicitudservicioot.get('tipo')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Documentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{id:state.solicitudservicioot.get('id'),solicitudservicioot:state.solicitudservicioot.get('solicitud'),enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode,indexDocumento){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudservicioot__["g" /* displayModalCreateDocumento */])(show,title,mode,indexDocumento));},showHideModalSummary:function showHideModalSummary(show,id,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_documentos__["k" /* showHideModalSummary */])(show,id,url,type));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Documentos));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_solicitudservicioot__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancelacion=function(_Component){_inherits(Cancelacion,_Component);function Cancelacion(){_classCallCheck(this,Cancelacion);return _possibleConstructorReturn(this,(Cancelacion.__proto__||Object.getPrototypeOf(Cancelacion)).apply(this,arguments));}_createClass(Cancelacion,[{key:'render',value:function render(){var _this2=this;var solicitud=this.props.solicitud;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de cancelaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitud.get('fecha_cancelacion')).format('YYYY-MM-DD')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de cancelaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitud.get('motivo_cancelacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.motivo_cancelacion',e.target.value);},disabled:solicitud.get('estado')==0}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Cancelacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitud:state.solicitudservicioot.get('solicitud')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_solicitudservicioot__["u" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cancelacion));

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_Comentarios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SolicitudBI=function(_Component){_inherits(SolicitudBI,_Component);function SolicitudBI(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SolicitudBI);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SolicitudBI.__proto__||Object.getPrototypeOf(SolicitudBI)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(list){var columns=[{id:1,caption:'Identificacion',value:'codigo',width:'30%'},{id:2,caption:'Nombre',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1',payload);var estado=_this.props.solicitudBI.get('estado');if(estado==8){_this.props.updateInputs('addModificacion',true);}};_this.props.showModalSelector('Listado de bienes',columns,'/solicitudes/bienes-investigacion/erp_items',fn);},_this.handleOpenSelectorResponsable=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/auxiliares',fn);},_this.modificarSolicitud=function(path,value,id){_this.props.updateInputs(path,value,id);_this.props.updateInputs('addModificacion',true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SolicitudBI,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('UNIDADES');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,solicitudBI=_props.solicitudBI,p_almacen=_props.p_almacen,user_id=_props.user_id,superusuario=_props.superusuario,enums=_props.enums,id=_props.id,user=_props.user,unidades=_props.unidades;var responsable_almacen="";if(p_almacen&&p_almacen.count()>0){responsable_almacen=p_almacen.filter(function(a){return a.get('ALMACEN')===_this2.props.tipo_almacen;}).getIn(['0','USUARIO']);}var esResponsableAlmacen=responsable_almacen==user_id;var esResponsableCompras=solicitudBI.getIn(['responsable_compras','id'])==user.get('id');var esSuperusuario=user.get('es_superusuario');var estado=solicitudBI.get('estado');// const readOnly = (!esResponsableCompras && !esSuperusuario && !esResponsableAlmacen) || ((estado == 0) || ((estado != 1) && (estado != 8)) || ((estado > 2) && (estado != 8)))
var readOnly=!esResponsableCompras&&!esSuperusuario&&!esResponsableAlmacen||estado==0||estado>1;// const readOnly = true
var actionsSectionDetallesBienes=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.addSolicitudBienesItem();},title:'Adicionar bienes',disabled:readOnly}),// <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={this.borrarTabla()} title="Eliminar servicio" danger disabled={ solicitudBI.get('bienes') && !solicitudBI.get('bienes').filter(x => x.get('selected')).count() } />
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeSolicitudBienesItem();},title:'Eliminar servicio',danger:true,disabled:solicitudBI.get('bienes')&&!solicitudBI.get('bienes').filter(function(x){return x.get('selected');}).count()})];var disabled_comment=estado===0||estado===7;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudBI.get('solicitante'))&&solicitudBI.get('estado')!=0&&solicitudBI.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__["a" /* default */],{value:solicitudBI.getIn(['solicitante','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelectorResponsable('solicitud.solicitante');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.solicitante',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudBI.getIn(['solicitante','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudBI.getIn(['solicitante','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudBI.getIn(['solicitante','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudBI.getIn(['solicitante','area','nombre'])||'',disabled:true}))),solicitudBI.get('documento_origen_id')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Orden/Contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:enums.documentos.tipos[solicitudBI.getIn(['documento_origen','tipo'])].PREFIJO+solicitudBI.getIn(['documento_origen','consecutivo'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudBI.get('responsable_compras'))&&solicitudBI.get('estado')!=0&&solicitudBI.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__["a" /* default */],{value:solicitudBI.getIn(['responsable_compras','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelectorResponsable('solicitud.responsable_compras');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.responsable_compras',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudBI.getIn(['responsable_compras','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudBI.getIn(['responsable_compras','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudBI.getIn(['responsable_compras','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudBI.getIn(['created_at'])).format('DD/MM/YYYY')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudBI.get('id')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del bien solicitado'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad bienes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:solicitudBI.get('proyecto_evento')||'',onChange:function onChange(e){return _this2.modificarSolicitud('solicitud.proyecto_evento',e.target.value,id);},className:'form-control input-sm',disabled:readOnly}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{disabled:readOnly,className:'form-control input-sm',value:this.props.tipo_almacen,onChange:function onChange(e){return _this2.modificarSolicitud('tipo_almacen',e.target.value,id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Seleccione el almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Laboratorio'},'Laboratorio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Materiales'},'Materiales')))),readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',disabled:true,value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudBI.get('fecha_requerido')).format('YYYY/MM/DD')||'',className:'form-control input-sm'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudBI.get('fecha_requerido')).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.modificarSolicitud('solicitud.fecha_requerido',e.target.value,id);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Detalle Bienes',actions:actionsSectionDetallesBienes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:'3'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:'2'},'Responsable almac\xE9n')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'center',width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Descripci\xF3n bienes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Cantidad a solicitar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Unidad / Presentaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudBI.get('bienes')&&solicitudBI.get('bienes').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:x.get('id')?x.get('id'):x.get('guid'),className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+n+'.selected',e.target.checked);},disabled:readOnly||n==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{defaultValue:x.get('descripcion')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.modificarSolicitud('solicitud.bienes.'+n+'.descripcion',e.target.value,id);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',value:x.get('cantidad_solicitada')||'',className:'form-control input-sm',disabled:readOnly,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+n+'.cantidad_solicitada',e.target.value,id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:x.get('unidad')||"",className:'form-control input-sm',disabled:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:x.get('unidad')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+n+'.unidad',e.target.value,id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Seleccione unidad'),unidades&&unidades.map(function(unidad,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:idx,value:unidad.get('UNIDAD')},unidad.get('UNIDAD'));}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n de centros de costo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Responsable Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Porcentaje'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudBI.getIn(['bienes','0','cencos'])&&solicitudBI.getIn(['bienes','0','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('id')+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:true,defaultValue:x.getIn(['usuario','fullname']),className:'form-control input-sm'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:true,defaultValue:x.get('codigo'),className:'form-control input-sm'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:true,defaultValue:__WEBPACK_IMPORTED_MODULE_3_numeral___default()(x.getIn(['pivot','porcentaje'])/100).format('0%'),className:'form-control input-sm text-right'})));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{disabled:true,className:'form-control input-sm',rows:4,value:solicitudBI.get('observaciones')}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_Comentarios__["a" /* default */],{foros:solicitudBI.get('foros'),comentario:this.props.comentario,updateInputs:this.props.updateInputs,disabled_comment:disabled_comment,enviarComentario:this.props.enviarComentario,editarComentario:this.props.editarComentario,eliminarComentario:this.props.eliminarComentario}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_AttachedFilesBox__["a" /* default */],{files:solicitudBI.get('adjuntos'),removeFiles:this.props.removeFiles,updateInputs:this.props.updateInputs,obj:solicitudBI,check:'solicitud',root:'solicitud'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Recomendaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-sorted',style:{backgroundColor:'#eee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'SI EL EQUIPO REQUIERE ACCESORIOS (KIT DE HERRAMIENTAS O PARTES) ADICIONALES PARA SU FUNCIONAMIENTO, DEBE RELACIONARLO EN EL SIGUIENTE CUADRO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'EN LA DESCRIPCI\xD3N DE LOS BIENES, FAVOR INDICAR MARCA, MODELO, CARACTER\xCDSTICAS Y ESPECIFICACIONES.'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('/files/'+id,[function(){return _this2.props.getSolicitud(id);}]);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return SolicitudBI;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudBI.get('id'),solicitudBI:state.solicitudBI.get('solicitud'),tipo_almacen:state.solicitudBI.get('tipo_almacen'),enums:state.common.get('enums').toJS(),p_almacen:state.common.getIn(['parametros','ALMACEN']),user_id:state.common.getIn(['user','username']),superusuario:state.common.getIn(['user','es_superusuario']),user:state.common.get('user'),comentario:state.solicitudBI.get('comentario'),unidades:state.common.getIn(['parametros','UNIDADES'])};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["F" /* updateInputs */])(path,value,id));},showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["q" /* selectFromSelector */])(type,payload));},getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["r" /* getSolicitud */])(id));},addFile:function addFile(url,actions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["c" /* addFile */])(url,actions));},removeFiles:function removeFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["w" /* removeFiles */])());},addSolicitudBienesItem:function addSolicitudBienesItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["h" /* addSolicitudBienesItem */])());},removeSolicitudBienesItem:function removeSolicitudBienesItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["z" /* removeSolicitudBienesItem */])());},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["q" /* enviarComentario */])());},editarComentario:function editarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["o" /* editarComentario */])(id));},eliminarComentario:function eliminarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["p" /* eliminarComentario */])(id));},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["l" /* getParameterByName */])(param));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SolicitudBI));

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Aprobaciones=function(_Component){_inherits(Aprobaciones,_Component);function Aprobaciones(props){_classCallCheck(this,Aprobaciones);var _this=_possibleConstructorReturn(this,(Aprobaciones.__proto__||Object.getPrototypeOf(Aprobaciones)).call(this,props));_this.handleOpenSelectorAprobador=function(){var fields=[{id:1,caption:'Nombre',value:'fullname',width:'40%'},{id:2,caption:'Cargo',value:'cargo',width:'40%'},{id:3,caption:'Miembro',value:'esmiembrocomite',width:'20%'}];_this.props.showModalSelector('Seleccione aprobador adicional',fields,'/usuarios/aprobadores-adicionales',function(aprobador){_this.setState({aprobadorAdicional:aprobador});});};_this.getTotal=function(valor,iva,cantidad){if(!valor)return 0;if(!cantidad)return 0;var total=valor*cantidad;return iva?total+iva*total/100:total;};_this.getProveedores=function(){var cotizaciones=_this.props.solicitudBI.get('cotizaciones');var proveedores=[];cotizaciones&&cotizaciones.map(function(c){var index=-1;proveedores.forEach(function(p,i){if(c.get('proveedor_id')==p.get('id'))index=i;});if(c.get('proveedor_id')&&index==-1){proveedores.push(c.get('proveedore'));}});return proveedores.sort(function(a,b){return a.get('id')-b.get('id');});};_this.getTotalCotizacion=function(){var total=_this.props.solicitudBI.get('bienes').reduce(function(acum,bien){acum+=bien.get('cotizaciones').filter(function(c){return c.get('recomendado');}).reduce(function(acum2,cotizacion){acum2+=Number(cotizacion.get('cotizado_iva'))*Number(bien.get('cantidad_solicitada'));return acum2;},0);return acum;},0);return total;};_this.getTotalCotizacionTrm=function(){var total=_this.props.solicitudBI.get('bienes').reduce(function(acum,bien){acum+=bien.get('cotizaciones').filter(function(c){return c.get('recomendado');}).reduce(function(acum2,cotizacion){var trm=cotizacion.get('trm')?cotizacion.get('trm'):1;var cotizado_iva=cotizacion.get('cotizado_iva')?cotizacion.get('cotizado_iva'):0;var cantidad_solicitada=bien.get('cantidad_solicitada')?bien.get('cantidad_solicitada'):0;acum2+=cotizado_iva*trm*cantidad_solicitada;return acum2;},0);return acum;},0);return total;};_this.getTotalCotizacionProveedor=function(proveedor_id){var total=_this.props.solicitudBI.get('bienes').reduce(function(acum,bien){acum+=bien.get('cotizaciones').reduce(function(acum2,cotizacion){if(cotizacion.get('proveedor_id')==proveedor_id&&cotizacion.get('recomendado')){acum2+=Number(cotizacion.get('cotizado_iva'))*Number(bien.get('cantidad_solicitada'));}return acum2;},0);return acum;},0);return total;};_this.getTotalAprobador=function(aprobador_id){var total=_this.props.solicitudBI.get('cotizaciones').reduce(function(acum1,item1){if(item1.get('recomendado')){var idx=item1.get('aprobaciones').findIndex(function(x){return x.get('aprobador_id')==aprobador_id;});if(idx!=-1){var bienId=item1.getIn(['bienes',0,'id']);var bienIdx=_this.props.solicitudBI.get('bienes').findIndex(function(b){return b.get('id')==bienId;});if(bienIdx!=-1){var cantidad=_this.props.solicitudBI.getIn(['bienes',bienIdx,'cantidad_solicitada']);acum1+=Number(item1.get('cotizado_iva'))*Number(cantidad);}}}return acum1;},0);return total;};_this.approve=function(aprobaciones,cencos,totalAprobador,divisa){_this.props.showModalConfirmarAccion(true,'Al hacer click en Ok, estar\xE1 aprobando el cargue de '+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(totalAprobador,divisa.simbolo)+' \n            '+(cencos.length>1?'entre los ':'al')+' centro'+(cencos.length>1?'s':'')+' de costo '+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["V" /* uniqueArray */])(cencos).join(', ')+'\n            '+(_this.props.solicitudBI.get('tipo')==5?'y con la fecha de entrega '+__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.props.solicitudBI.get('fecha_requerido')).format('DD/MM/YYYY')+' ':''),function(){_this.props.showModalConfirmarAccion(false);_this.props.registrarResultadoAprobacion(aprobaciones,2);});};_this.reject=function(aprobaciones,cencos,totalAprobador,divisa){_this.props.showModalConfirmarAccion(true,'Al hacer click en Ok, estar\xE1 rechazando el cargue de '+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(totalAprobador,divisa.simbolo)+' \n            '+(cencos.length>1?'entre los ':'al')+' centro'+(cencos.length>1?'s':'')+' de costo '+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["V" /* uniqueArray */])(cencos).join(', ')+'\n            '+(_this.props.solicitudBI.get('tipo')==5?'y con la fecha de entrega '+__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.props.solicitudBI.get('fecha_requerido')).format('DD/MM/YYYY')+' ':''),function(){_this.props.showModalConfirmarAccion(false);_this.props.registrarResultadoAprobacion(aprobaciones,0);});};_this.getTipoCompra=function(bien){var tiene_proveedor=bien.get('cotizaciones').filter(function(c){return c.get('proveedor_id')!=null;}).count()>0;if(bien.get('compra_directa')&&!tiene_proveedor)return 1;if(!bien.get('compra_directa')&&tiene_proveedor)return 2;if(bien.get('compra_directa')&&tiene_proveedor)return 3;return 1;};_this.changeValueCotizacion=function(cotizacion_id,attr,value){var bienes=_this.props.solicitudBI.get('bienes');var cotizaciones=_this.props.solicitudBI.get('cotizaciones');var cotizacion=cotizaciones.filter(function(c){return c.get('id')==cotizacion_id;}).first();var bien_id=cotizacion.getIn(['bienes',0,'id']);var bien_idx=bienes.findIndex(function(x){return x.get('id')==bien_id;});if(bien_idx>=0){if(attr=='recomendado'){bienes.getIn([bien_idx,'cotizaciones']).valueSeq().forEach(function(cot){var idx=bienes.getIn([bien_idx,'cotizaciones']).findIndex(function(x){return x.get('id')==cot.get('id');});_this.props.updateInputs('solicitud.bienes.'+bien_idx+'.cotizaciones.'+idx+'.recomendado',false);});cotizaciones.valueSeq().forEach(function(cot,idx){if(cot.getIn(['bienes',0,'id'])==bien_id){_this.props.updateInputs('solicitud.cotizaciones.'+idx+'.recomendado',false);}});}var cotizacion_idx=bienes.getIn([bien_idx,'cotizaciones']).findIndex(function(x){return x.get('id')==cotizacion_id;});if(cotizacion_idx>=0){_this.props.updateInputs('solicitud.bienes.'+bien_idx+'.cotizaciones.'+cotizacion_idx+'.'+attr,value,cotizacion_id);}}};_this.actualizarrecomendado=function(indice,valor){_this.props.updateInputs('solicitud.bienes.'+indice+'.cantidad_solicitada',valor);var idbien=_this.props.solicitudBI.getIn(['bienes',indice,'id']);_this.props.updateInputs('solicitud.bienes.'+indice+'.cantidad_solicitada',valor,idbien);var cotizaciones=_this.props.solicitudBI.get('cotizaciones');var dato=cotizaciones.filter(function(c){return c.getIn(['bienes',indice,'pivot','bienes_detalle_id'])==idbien;});cotizaciones.filter(function(c){return c.getIn(['bienes',0,'pivot','bienes_detalle_id'])==idbien;}).map(function(c){var idc=c.get('id');if(valor==0){_this.changeValueCotizacion(idc,'recomendado',false);}});};_this.handleEnviarSolicitudAdicional=function(){var _this$state=_this.state,aprobadorAdicional=_this$state.aprobadorAdicional,motivoAprobacionAdicional=_this$state.motivoAprobacionAdicional;if(!aprobadorAdicional||!motivoAprobacionAdicional.trim()){return;}_this.props.crearAprobacionAdicionalBiene(aprobadorAdicional,motivoAprobacionAdicional);_this.setState({solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''});};_this.tipo_corte=function(){var _this$props=_this.props,smmlv=_this$props.smmlv,matriz_aprobacion=_this$props.matriz_aprobacion;var tipoAprobacion=1;var totalSMMLV=smmlv&&_this.getTotalCotizacionTrm()/parseFloat(smmlv.first().get('SMMLV'))||0;var match=matriz_aprobacion&&matriz_aprobacion.find(function(item){return parseFloat(item.get('DESDE_SMMLV'))<=totalSMMLV&&totalSMMLV<parseFloat(item.get('HASTA_SMMLV'));});if(match){tipoAprobacion=match&&parseInt(match.get('TIPO_APROBACION'))||1;}return tipoAprobacion;};_this.info_aprobador_adicional=function(aprobador){var aprobadores_adicionales=_this.props.aprobadores_adicionales;if(!aprobador)return null;if(!aprobadores_adicionales)return null;var aprobadorInfo=aprobadores_adicionales.find(function(a){return a.get('USUARIO')===aprobador.get('username');});if(!aprobadorInfo)return null;return{cargo:aprobadorInfo.get('CARGO')||'Sin cargo',esmiembrocomite:aprobadorInfo.get('MIEMBRO_COMITE')==='SI'};};_this.state={solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''};return _this;}_createClass(Aprobaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('SMMLV');this.props.getParameterByName('MATRIZ_APROBACION');this.props.getParameterByName('APROBADORES_ADICIONALES');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudBI=_props.solicitudBI,enums=_props.enums,aprobadores=_props.aprobadores,btnAproveDisabled=_props.btnAproveDisabled,divisas=_props.divisas;var botonAprove=true;if(this.props.btnSaveDisabled){botonAprove=false;}var moneda=solicitudBI.get('cotizaciones')?solicitudBI.get('cotizaciones').first().get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var proveedores=this.getProveedores();var es_aprobador=Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobador',aprobadores);var readOnly=solicitudBI.get('estado')==0||solicitudBI.get('estado')>3||!es_aprobador;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{overflow:'auto',whiteSpace:'nowrap',paddingBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped',id:'comparativo-cotizaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4,style:{borderTop:'1px solid #FFF',borderLeft:'1px solid #FFF'}}),proveedores.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'phead['+i+']'},p.get('nombre'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'COMPRA DIRECTA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Descripci\xF3n inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'U.M.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cantidad'),proveedores.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'pcol['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudBI.get('bienes').map(function(bien,bienIndex){var cantidad=bien.get('cantidad_solicitada');var tipo_compra=_this2.getTipoCompra(bien);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'itm['+bienIndex+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',style:{width:'200px'},value:bien.get('descripcion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+bienIndex+'.descripcion',e.target.value,bien.get('id'));},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{width:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control input-sm',rows:3,value:bien.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+bienIndex+'.observaciones',e.target.value,bien.get('id'));},disabled:readOnly}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,bien.get('unidad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'100px'},type:'number',className:'form-control input-sm',value:bien.get('cantidad_solicitada'),onChange:function onChange(e){return _this2.actualizarrecomendado(bienIndex,e.target.value);},disabled:readOnly})),proveedores.map(function(p){var cotizaciones_proveedor=bien.get('cotizaciones').filter(function(cotizaciones){return cotizaciones.getIn(['pivot','bienes_detalle_id'])==bien.get('id')&&cotizaciones.get('proveedor_id')==p.get('id');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'tdprov['+p.get('id')+']['+bien.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Marca'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. Unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. con IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'T. Entrega'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,cotizaciones_proveedor.map(function(cp,cpi){var valor=cp.get('cotizado')?cp.get('cotizado'):0;var iva=cp.get('iva')?cp.get('iva'):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'cp['+bien.get('id')+']['+cp.get('id')+']['+cp.get('proveedor_id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:cp.get('recomendado'),onChange:function onChange(e){return _this2.changeValueCotizacion(cp.get('id'),'recomendado',e.target.checked);},disabled:bien.get('cantidad_solicitada')==0||readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px'}},cp.get('marca'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},valor)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100px',textAlign:'right'}},iva+'%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(_this2.getTotal(valor,iva,cantidad),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100px',textAlign:'right'}},cp.get('tiempo_entrega'))));}))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,tipo_compra==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Marca'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. Unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. con IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'T. Entrega'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,bien.get('cotizaciones').map(function(cotizacion,cotizacionIndex){var valor=cotizacion.get('cotizado')?cotizacion.get('cotizado'):0;var iva=cotizacion.get('iva')?cotizacion.get('iva'):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+bienIndex+']['+cotizacionIndex+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:cotizacion.get('recomendado'),onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'recomendado',e.target.checked);},disabled:cantidad==0||readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'200px'}},cotizacion.get('proveedor_nombre_cp'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px'}},cotizacion.get('marca'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(valor,divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100px',textAlign:'right'}},iva+'%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(_this2.getTotal(valor,iva,cantidad),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100px',textAlign:'right'}},cotizacion.get('tiempo_entrega'))));}))),tipo_compra==3&&bien.get('cotizaciones').filter(function(c){return!c.get('proveedor_id');}).count()>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Marca'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. Unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. con IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'T. Entrega'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,bien.get('cotizaciones').filter(function(c){return!c.get('proveedor_id');}).map(function(cotizacion,cotizacionIndex){var valor=cotizacion.get('cotizado')?cotizacion.get('cotizado'):0;var iva=cotizacion.get('iva')?cotizacion.get('iva'):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+bienIndex+']['+cotizacionIndex+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:cotizacion.get('recomendado'),onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'recomendado',e.target.checked);},disabled:valor==0||readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'200px'}},cotizacion.get('proveedor_nombre_cp'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px'}},cotizacion.get('marca'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(valor,divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100px',textAlign:'right'}},iva+'%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(_this2.getTotal(valor,iva,cantidad),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100px',textAlign:'right'}},cotizacion.get('tiempo_entrega'))));})))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{backgroundColor:'#eee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:4,style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total Seleccionado por Proveedor')),proveedores.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'fcol['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(_this2.getTotalCotizacionProveedor(p.get('id')),divisa.simbolo))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),this.tipo_corte()===1&&solicitudBI.get('estado')===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Aprobaci\xF3n adicional'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:this.state.solicitarAprobacionAdicional,onChange:function onChange(e){return _this2.setState({solicitarAprobacionAdicional:e.target.checked});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'7px'}},'Solicitar aprobaci\xF3n adicional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},this.state.solicitarAprobacionAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione aprobador adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__["a" /* default */],{value:this.state.aprobadorAdicional?this.state.aprobadorAdicional.fullname:'',onClick:this.handleOpenSelectorAprobador,onReset:function onReset(){return _this2.setState({aprobadorAdicional:null});}})))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cargo del aprobador:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control input-sm',style:{background:'#f9f9f9',paddingTop:'5px'}},this.state.aprobadorAdicional.cargo||'Sin cargo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{display:'flex',alignItems:'center',marginTop:25}},this.state.aprobadorAdicional.esmiembrocomite==='SI'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{fontSize:13}},'Integrantes del Comit\xE9 de Rector\xEDa')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo de la solicitud adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:3,className:'form-control input-sm',value:this.state.motivoAprobacionAdicional,onChange:function onChange(e){return _this2.setState({motivoAprobacionAdicional:e.target.value});}}))))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{textAlign:'right',paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',disabled:!this.state.motivoAprobacionAdicional.trim()||!this.state.aprobadorAdicional,onClick:this.handleEnviarSolicitudAdicional},'Enviar solicitud adicional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),aprobadores.map(function(aprobador,aprobadoridx){var nombre_aprobador=aprobador.get('fullname');var aprobacion=aprobador.get('aprobaciones').filter(function(x){return x.get('estado')==2;}).count()>0?aprobador.get('aprobaciones').filter(function(x){return x.get('estado')==2;}).first():aprobador.get('aprobaciones').first();var estado=aprobacion.get('estado');var tipo=aprobacion.get('tipo');var fecha=aprobacion.get('fecha');var observaciones=aprobacion.get('observaciones');var aprobador_id=aprobador.get('id');var cencos=[];var nombre_aprobador_original=aprobacion.getIn(['aprobador_su','fullname']);var totalAprobador=0;var info_aprobador_adicional=_this2.info_aprobador_adicional(aprobador);return[aprobadoridx>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep1['+aprobadoridx+']',className:'separator'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{key:'bs1['+aprobador.get('id')+']',title:tipo===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,estado===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green'}}):estado===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'times',style:{color:'red'}}):'','Solicitud de aprobaci\xF3n adicional a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,nombre_aprobador)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,estado===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green'}}):estado===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'times',style:{color:'red'}}):'','Solicitud de aprobaci\xF3n nivel ',Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["N" /* romanize */])(tipo),' a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,nombre_aprobador))},info_aprobador_adicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:500}},'Cargo: ',info_aprobador_adicional.cargo||'Sin cargo'),info_aprobador_adicional.esmiembrocomite?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{marginLeft:10}},'Integrantes del Comit\xE9 de Rector\xEDa'):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Solicitud de aprobaci\xF3n: ',enums.aprobaciones.estados[estado],estado===1?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' \u2022 ',__WEBPACK_IMPORTED_MODULE_2_moment___default()(fecha).format('YYYY-MM-DD HH:mm'))))),nombre_aprobador_original&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Esta solicitud fue aprobada por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,nombre_aprobador_original)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Solicitada por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,solicitudBI.getIn(['solicitante','fullname']))),' \u2022 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+solicitudBI.getIn(['solicitante','email'])},solicitudBI.getIn(['solicitante','email']))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fecha de entrega: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudBI.get('fecha_requerido')).format('DD/MM/YYYY')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep2['+aprobadoridx+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Detalle:'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep3['+aprobadoridx+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{key:'tbl['+aprobadoridx+']',className:'table table-bordered table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Distribuci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{fontSize:'18px',fontWeight:'bold',textAlign:'center',verticalAlign:'middle'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(_this2.getTotalCotizacion(),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,aprobacion.getIn(['cotizacione','bienes']).map(function(b,bidx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{key:'tbl['+aprobadoridx+']['+bidx+']',className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,b.get('cencos').map(function(c){if(tipo<2&&c.get('responsable_id')!=aprobador_id&&c.getIn(['pivot','aprobador_id'])!=aprobador_id)return null;cencos.push(c.get('codigo'));totalAprobador+=c.getIn(['pivot','porcentaje'])/100*_this2.getTotalCotizacion();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr2['+aprobador.get('id')+']['+b.get('id')+']['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+c.get('descripcion')},c.get('codigo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(c.getIn(['pivot','porcentaje'])/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(c.getIn(['pivot','porcentaje'])/100*_this2.getTotalCotizacion(),divisa.simbolo)));})));}))))))),estado!==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control input-sm',style:{height:'60px',overflowX:'hidden'}},observaciones||'')))),Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobacion',aprobador.get('aprobaciones').first())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:6,className:'form-control input-sm',value:observaciones||'',onChange:function onChange(e){return _this2.props.updateInputs('aprobadores.'+aprobadoridx+'.aprobaciones.0.observaciones',e.target.value);},disabled:tipo===3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right',padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm btn-squared',onClick:function onClick(e){return _this2.approve(aprobador.get('aprobaciones'),cencos,totalAprobador,divisa);},disabled:botonAprove},'Aprobar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default btn-sm btn-squared',onClick:function onClick(e){return _this2.reject(aprobador.get('aprobaciones'),cencos,totalAprobador,divisa);},disabled:btnAproveDisabled},'Rechazar')))))))];}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalConfirmarAccion__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Aprobaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudBI.get('id'),solicitudBI:state.solicitudBI.get('solicitud'),aprobadores:state.solicitudBI.get('aprobadores'),enums:state.common.get('enums').toJS(),user:state.common.get('user'),btnAproveDisabled:state.solicitudBI.get('btnAproveDisabled'),divisas:state.common.getIn(['parametros','DIVISAS']),btnSaveDisabled:state.solicitudBI.get('btnSaveDisabled'),smmlv:state.common.getIn(['parametros','SMMLV']),matriz_aprobacion:state.common.getIn(['parametros','MATRIZ_APROBACION']),aprobadores_adicionales:state.common.getIn(['parametros','APROBADORES_ADICIONALES'])};}function mapDispatchToProps(dispatch){return{showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},seleccionarAprobacion:function seleccionarAprobacion(bienid,aprobadorid,aprobacionid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["A" /* seleccionarAprobacion */])(bienid,aprobadorid,aprobacionid));},registrarResultadoAprobacion:function registrarResultadoAprobacion(aprobaciones,result,bienes){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["v" /* registrarResultadoAprobacion */])(aprobaciones,result,bienes));},updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["F" /* updateInputs */])(path,value,id));},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["l" /* getParameterByName */])(param));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["q" /* selectFromSelector */])(type,payload));},crearAprobacionAdicionalBiene:function crearAprobacionAdicionalBiene(aprobadorAdicional,motivoAprobacionAdicional){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["j" /* crearAprobacionAdicionalBiene */])(aprobadorAdicional,motivoAprobacionAdicional));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Aprobaciones));

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SolicitudBI_ModalCreateDocumento__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SolicitudBI_ModalSummaryDocumento__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Documentos_ModalCreateEntrega__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Documentos_ModalAddFactura__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Documentos_ModalLastFactura__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Documentos_ModalAddAdicional__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Documentos=function(_React$Component){_inherits(Documentos,_React$Component);function Documentos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Documentos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Documentos.__proto__||Object.getPrototypeOf(Documentos)).call.apply(_ref,[this].concat(args))),_this),_this.buttonOption=function(documento,index){if(documento.getIn(['aprobacion','estado'])===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'binoculars',onClick:function onClick(){return _this.props.showHideModalSummary(true,documento.get('id'),'solicitudes/bienes-investigacion/'+_this.props.id,'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION');}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',onClick:function onClick(){return _this.props.displayModalCreateDocumento(true,'Documento','edit',index);},disabled:!Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',_this.props.solicitudBI)||documento.get('estado')===0});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Documentos,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudBI=_props.solicitudBI,enums=_props.enums,divisas=_props.divisas;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'9%'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'11%'}},'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'12%'}},'Fecha inicio (registro)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'7%'}},'Fecha entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bienes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudBI.get('documentos').map(function(a,b){var moneda=a.getIn(['cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var valor_con_iva=a.get('detalles').reduce(function(a1,b1){a1+=b1.get('valor_con_iva')*b1.get('cantidad');return a1;},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},_this2.buttonOption(a,b)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('consecutivo')?enums.documentos.tipos[a.get('tipo')].PREFIJO+a.get('consecutivo'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['proveedore','nombre'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["q" /* formatcoin */])(valor_con_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.tipos[a.get('tipo')]?enums.documentos.tipos[a.get('tipo')].NOMBRE:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.estados[a.get('estado')]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_inicio')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_inicio')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_entrega')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_entrega')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,a.get('detalles').map(function(c,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr5['+a.get('id')+']['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:c.get('adicion_id')!==null?'adicional':''},c.get('descripcion')));})))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SolicitudBI_ModalCreateDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SolicitudBI_ModalSummaryDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Documentos_ModalCreateEntrega__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Documentos_ModalAddFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Documentos_ModalLastFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Documentos_ModalAddAdicional__["a" /* default */],{tipo_solicitud:solicitudBI.get('tipo')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Documentos;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state,ownProps){return{id:state.solicitudBI.get('id'),solicitudBI:state.solicitudBI.get('solicitud'),enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode,indexDocumento){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_solicitudbi__["n" /* displayModalCreateDocumento */])(show,title,mode,indexDocumento));},showHideModalSummary:function showHideModalSummary(show,id,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_documentos__["k" /* showHideModalSummary */])(show,id,url,type));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Documentos));

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_solicitudbi__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancelacion=function(_Component){_inherits(Cancelacion,_Component);function Cancelacion(){_classCallCheck(this,Cancelacion);return _possibleConstructorReturn(this,(Cancelacion.__proto__||Object.getPrototypeOf(Cancelacion)).apply(this,arguments));}_createClass(Cancelacion,[{key:'render',value:function render(){var _this2=this;var solicitud=this.props.solicitud;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de cancelaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitud.get('fecha_cancelacion')).format('YYYY-MM-DD')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de cancelaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitud.get('motivo_cancelacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.motivo_cancelacion',e.target.value);},disabled:solicitud.get('estado')==0}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Cancelacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitud:state.solicitudBI.get('solicitud')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_solicitudbi__["F" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cancelacion));

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicioot__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var General=function(_Component){_inherits(General,_Component);function General(){_classCallCheck(this,General);return _possibleConstructorReturn(this,(General.__proto__||Object.getPrototypeOf(General)).apply(this,arguments));}_createClass(General,[{key:'render',value:function render(){var _this2=this;var _props=this.props,documento=_props.documento,enums=_props.enums;if(!documento)return null;if(!documento.get('detalles'))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,documento.get('estado')<11&&Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',documento.get('solicitude'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-info'},'Adjunte el documento firmado para cerrar esta solicitud haciendo click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'cloud-upload'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:enums.documentos.tipos[documento.get('tipo')].NOMBRE,className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'N\xFAmero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.get('consecutivo'),className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-md-offset-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['solicitude','id']),className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de servicio a desarrollar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['solicitude','proyecto_evento']),className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','nombre']),className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Inicio del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_inicio')).format('YYYY-MM-DD'),className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Culminaci\xF3n del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_entrega')).format('YYYY-MM-DD'),className:'form-control input-sm',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_AttachedFilesBox__["a" /* default */],{files:documento.get('adjuntos'),root:'modalSummary.data',removeFiles:this.props.removeFiles,updateInputs:this.props.updateInputs,obj:documento,check:'documento',disabledAttach:this.props.disabledAttach||!Object(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',documento.get('solicitude'))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('/files/'+documento.get('solicitud_id'),documento.get('id'),[function(){return _this2.props.getDocumento(documento.get('id'));},function(){return _this2.props.getSolicitud(documento.get('solicitud_id'));}]);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return General;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{documento:state.documentos.getIn(['modalSummary','data']),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{addFile:function addFile(url,documentoId,actions){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_documentos__["b" /* addFile */])(url,documentoId,actions));},removeFiles:function removeFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_documentos__["h" /* removeFiles */])());},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_documentos__["n" /* updateInputs */])(path,value));},getDocumento:function getDocumento(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_documentos__["e" /* getDocumento */])(id));},getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicioot__["k" /* getSolicitud */])(id));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(General));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var filesTypes=__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* acceptedFiles */].map(function(x){return x.type;}).join();var ModalAddFirmas=function(_Component){_inherits(ModalAddFirmas,_Component);function ModalAddFirmas(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddFirmas);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddFirmas.__proto__||Object.getPrototypeOf(ModalAddFirmas)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('modalAddFirmas');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddFirmas .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalAddFirmas(false);},300);},_this.handleOnDrop=function(files){if(files.length>1){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('Solo es permitido procesar un archivo a la vez',{bodyClassName:'toastify-content toastify-warning'});return;}_this.props.uploadFirmasFile(files[0]);},_this.handleOnRejected=function(files){files.forEach(function(x){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('El archivo '+x.name+' no es del tipo esperado. '+x.type,{bodyClassName:'toastify-content toastify-warning'});});},_this.setIcon=function(icon){if(icon){var imageSrc=__webpack_require__(80)("./"+icon);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageSrc});}return null;},_this.handleSave=function(e){_this.props.closeDocumento();_this.handleCloseModal(e,"modalAddFirmas");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddFirmas,[{key:'render',value:function render(){var _this2=this;var modalAddFirmas=this.props.modalAddFirmas;if(!modalAddFirmas.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Modal__["a" /* default */],{id:'modalAddFirmas',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__["a" /* default */],{title:'Subir contrato firmado',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalAddFirmas");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Guardar',onClick:function onClick(e){return _this2.handleSave(e);},disabled:modalAddFirmas.getIn(['data','file'])&&modalAddFirmas.getIn(['data','file']).size!=0?false:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_dropzone__["a" /* default */],{accept:filesTypes,onDropAccepted:this.handleOnDrop,onDropRejected:this.handleOnRejected,className:'dropzone1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Arrastre el documento escaneado con las firmas a esta secci\xF3n')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre del archivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'div-input-sm'},modalAddFirmas.getIn(['data','file'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'1px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.setIcon(modalAddFirmas.getIn(['data','icono']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'4px',verticalAlign:'bottom'}},modalAddFirmas.getIn(['data','file']).name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px',verticalAlign:'bottom',color:'#ccc'}},'(',__WEBPACK_IMPORTED_MODULE_3_numeral___default()(modalAddFirmas.getIn(['data','file']).size).format('0.0 b'),')')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control input-sm',rows:4,value:modalAddFirmas.getIn(['data','observaciones'])||'',disabled:true})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddFirmas;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddFirmas:state.contratoanual.get('modalAddFirmas'),createDocumento:state.contratoanual.get('createDocumento')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalAddFirmas:function showHideModalAddFirmas(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__["h" /* showHideModalAddFirmas */])(show));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__["i" /* updateInputs */])(path,value,immutable));},uploadFirmasFile:function uploadFirmasFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__["j" /* uploadFirmasFile */])(file));},closeDocumento:function closeDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__["b" /* closeDocumento */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddFirmas));

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WAIT_INTERVAL=1000;var ENTER_KEY=13;var ModalSelectorAirport=function(_Component){_inherits(ModalSelectorAirport,_Component);function ModalSelectorAirport(props){_classCallCheck(this,ModalSelectorAirport);var _this=_possibleConstructorReturn(this,(ModalSelectorAirport.__proto__||Object.getPrototypeOf(ModalSelectorAirport)).call(this,props));_this.handleCloseModal=function(e){var modal=document.getElementById('modalSelectorAirport');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSelectorAirport .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){_this.props.hideModalSelectorAirport(false);_this.setState({value:''});},300);};_this.handleSelectFromSelector=function(e,obj){_this.props.modalSelectorAirport.get('action')(obj,_this.state.value);_this.setState({value:''});_this.props.hideModalSelectorAirport();};_this.handleOnChange=function(value){clearTimeout(_this.timer);_this.setState({value:value});_this.timer=setTimeout(_this.triggerChange,WAIT_INTERVAL);};_this.handleOnKeyDown=function(key){if(key===ENTER_KEY){clearTimeout(_this.timer);_this.triggerChange();}};_this.triggerChange=function(){_this.props.clearPagesModalSelectorAirport();_this.props.getDataFromUrlAirports(_this.state.value);};_this.state={value:props.modalSelectorAirport.get('filter')};return _this;}_createClass(ModalSelectorAirport,[{key:'render',value:function render(){var _this2=this;var modalSelectorAirport=this.props.modalSelectorAirport;var seachingAirports=modalSelectorAirport.get('isLoading');if(modalSelectorAirport.get('show')===false)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* default */],{id:'modalSelectorAirport',show:true,ZIndex:2001},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModalHeader__["a" /* default */],{title:modalSelectorAirport.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSelectorAirport");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:this.state.value,onChange:function onChange(e){return _this2.handleOnChange(e.target.value);},onKeyDown:function onKeyDown(e){return _this2.handleOnKeyDown(e.keyCode);},placeholder:'Busqueda...'})))),modalSelectorAirport.get('data').count()===0&&this.state.value.length>2&&!seachingAirports&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-warning',role:'alert'},'No se encontraron resultados'))),modalSelectorAirport.get('data').count()===0&&this.state.value.length>2&&seachingAirports&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-info',role:'alert'},'Buscando...'))),modalSelectorAirport.get('data').count()===0&&this.state.value.length<3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-info',role:'alert'},'Ingrese al menos 3 caracteres del nombre del aeropuerto o ciudad'))),modalSelectorAirport.get('data').count()!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',height:'300px',overflowX:'hidden',marginBottom:'20px',border:'1px solid #ddd'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{ref:function ref(_ref){return _this2.table=_ref;},className:'table table-bordered table-condensed table-striped table-hover nowrap',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,modalSelectorAirport.get('fields').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:''+x.get('width'),key:'th4['+n+']'},x.get('caption'));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalSelectorAirport.get('data').count()>0?(modalSelectorAirport.get('data')||Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["List"])([])).filter(function(x){if(modalSelectorAirport.get('filter')){var compare=false;modalSelectorAirport.get('fields').forEach(function(y){compare=compare||x.get(''+y.get('value')).toLowerCase().indexOf(modalSelectorAirport.get('filter').toLowerCase())>-1;});return compare;}else{return true;}}).map(function(x,n){var tds=modalSelectorAirport.get('fields').map(function(y,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td4['+n+']['+n1+']',onMouseEnter:function onMouseEnter(e){return Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["b" /* addTitleIfOverflow */])(e.target);}},x.get(y.get('value')));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+n+']',style:{cursor:'pointer'},onClick:function onClick(e){_this2.handleSelectFromSelector(e,x.toJS());}},tds);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:modalSelectorAirport.get('fields').count(),style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',justifyContent:'space-between',height:'270px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{name:'refresh',spin:true,size:'3x'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))))))))))));}}]);return ModalSelectorAirport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSelectorAirport:state.common.get('modalSelectorAirport')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{hideModalSelectorAirport:function hideModalSelectorAirport(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["n" /* hideModalSelectorAirport */])());},getDataFromUrlAirports:function getDataFromUrlAirports(query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["k" /* getDataFromUrlAirports */])(query));},clearPagesModalSelectorAirport:function clearPagesModalSelectorAirport(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["e" /* clearPagesModalSelectorAirport */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSelectorAirport));

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initReducer */
/* harmony export (immutable) */ __webpack_exports__["o"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["g"] = addTrayecto;
/* harmony export (immutable) */ __webpack_exports__["n"] = removeTrayectos;
/* harmony export (immutable) */ __webpack_exports__["p"] = validateCaducidadPasaporte;
/* harmony export (immutable) */ __webpack_exports__["h"] = createTiqueteAereo;
/* harmony export (immutable) */ __webpack_exports__["c"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["f"] = addPasajero;
/* harmony export (immutable) */ __webpack_exports__["e"] = addOrigen;
/* harmony export (immutable) */ __webpack_exports__["b"] = addDestino;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCencoSolicitud;
/* harmony export (immutable) */ __webpack_exports__["l"] = removeCenco;
/* harmony export (immutable) */ __webpack_exports__["k"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["i"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["j"] = eliminarComentario;
/* harmony export (immutable) */ __webpack_exports__["d"] = addFileAdjunto;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeSolicitudTiqutesAereos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(3);
function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_343" /* REINICIAR_SOLICITUD_TIQUETESAEREO */]});};}function updateInputs(path,value){return function(dispatch){if(path==='motivo_viaje'||path==='observaciones'||path.includes('celular')||path.includes('cedula')||path.includes('nombres')||path.includes('apellidos')||path.includes('nacionalidad')||path.includes('pais_expedicion')){var regex=/[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;value=value.replace(regex,"").toUpperCase();}dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_220" /* MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO */],payload:{path:path,value:value}});};}function addTrayecto(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_17" /* ADICIONAR_TRAYECTO */]});};}function removeTrayectos(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_356" /* REMOVER_TRAYECTOS */]});};}function validateCaducidadPasaporte(value){return function(dispatch){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(value)<__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date())){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,{warning:'La fecha de caducidad del pasaporte es inferior o igual a la fecha actual'});}};}function createTiqueteAereo(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var formData=new FormData();var index=void 0;var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_96" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_96" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO */],payload:false});};var fn2=function fn2(d){return d(initReducer());};fn0(dispatch);var data=getState().creaciontiqueteaereo;var files=data.get('adjuntos');index=1;data.get('foros').map(function(f){f.get('solicitud_id')&&formData.append('foros['+index+'][solicitud_id]',f.get('solicitud_id'));f.get('usuario_id')&&formData.append('foros['+index+'][usuario_id]',f.get('usuario_id'));f.get('comentario')&&formData.append('foros['+index+'][comentario]',f.get('comentario'));index++;});data.get('motivo_viaje')&&formData.append('motivo_viaje',data.get('motivo_viaje'));data.get('fecha_solicitud')&&formData.append('fecha_solicitud',data.get('fecha_solicitud'));data.get('tipo_viaje')&&formData.append('tipo_viaje',data.get('tipo_viaje'));formData.append('asistencia_viajero',Number(data.get('asistencia_viajero')));data.get('tipo_trayecto')&&formData.append('tipo_trayecto',data.get('tipo_trayecto'));data.get('cant_pasajeros')&&formData.append('cant_pasajeros',data.get('cant_pasajeros'));data.get('tiquete_comprado')&&formData.append('tiquete_comprado',data.get('tiquete_comprado'));data.get('observaciones')&&formData.append('observaciones',data.get('observaciones'));index=1;data.get('trayectos').map(function(t){t.get('origen')&&formData.append('trayectos['+index+'][origen]',t.get('origen'));t.get('aeropuerto_origen')&&formData.append('trayectos['+index+'][aeropuerto_origen]',t.get('aeropuerto_origen'));t.get('fecha_ida')&&formData.append('trayectos['+index+'][fecha_ida]',t.get('fecha_ida')+' '+t.get('hora_ida'));t.get('destino')&&formData.append('trayectos['+index+'][destino]',t.get('destino'));t.get('aeropuerto_destino')&&formData.append('trayectos['+index+'][aeropuerto_destino]',t.get('aeropuerto_destino'));t.get('fecha_regreso')&&formData.append('trayectos['+index+'][fecha_regreso]',t.get('fecha_regreso')+' '+t.get('hora_regreso'));index++;});index=1;data.get('cencos').map(function(c){c.get('porcentaje')&&formData.append('cencos['+index+'][porcentaje]',c.get('porcentaje'));c.getIn(['cenco','id'])&&formData.append('cencos['+index+'][id]',c.getIn(['cenco','id']));index++;});index=1;data.get('pasajeros').map(function(p){formData.append('pasajeros['+index+'][tipo_pasajero]',p.get('tipo_pasajero'));formData.append('pasajeros['+index+'][nombres]',p.get('nombres'));formData.append('pasajeros['+index+'][apellidos]',p.get('apellidos'));formData.append('pasajeros['+index+'][cedula]',p.get('cedula'));formData.append('pasajeros['+index+'][correo]',p.get('correo'));formData.append('pasajeros['+index+'][fecha_nacimiento]',p.get('fecha_nacimiento'));formData.append('pasajeros['+index+'][celular]',p.get('celular'));formData.append('pasajeros['+index+'][tipo_documento]',p.get('tipo_documento'));if(data.get('tipo_viaje')==2){formData.append('pasajeros['+index+'][pasaporte]',p.get('pasaporte'));formData.append('pasajeros['+index+'][nacionalidad]',p.get('nacionalidad'));formData.append('pasajeros['+index+'][pais_expedicion]',p.get('pais_expedicion'));formData.append('pasajeros['+index+'][fecha_caducidad_pasaporte]',p.get('fecha_caducidad_pasaporte'));p.getIn(['pasaporte_adjunto','clasificacion'])&&formData.append('pasajeros['+index+'][pasaporte_adjunto][clasificacion]',p.getIn(['pasaporte_adjunto','clasificacion']));p.getIn(['pasaporte_adjunto','file'])&&formData.append('pasajeros['+index+'][pasaporte_adjunto][file]',p.getIn(['pasaporte_adjunto','file']),p.getIn(['pasaporte_adjunto','file']).name);p.getIn(['pasaporte_adjunto','guid'])&&formData.append('pasajeros['+index+'][pasaporte_adjunto][guid]',p.getIn(['pasaporte_adjunto','guid']));p.getIn(['pasaporte_adjunto','icono'])&&formData.append('pasajeros['+index+'][pasaporte_adjunto][icono]',p.getIn(['pasaporte_adjunto','icono']));p.getIn(['pasaporte_adjunto','nombre'])&&formData.append('pasajeros['+index+'][pasaporte_adjunto][nombre]',p.getIn(['pasaporte_adjunto','nombre']));p.getIn(['pasaporte_adjunto','observaciones'])&&formData.append('pasajeros['+index+'][pasaporte_adjunto][observaciones]',p.getIn(['pasaporte_adjunto','observaciones']));if(data.get('asistencia_viajero')){// const fecha_salida = data.get('trayectos').first().get('fecha_ida')
// let fecha_regreso
// if (data.get('tipo_trayecto') == 1) {
// 	fecha_regreso = data.get('trayectos').last().get('fecha_regreso')
// } else {
// 	fecha_regreso = p.getIn(['asistencia', 'fecha_regreso'])
// }
formData.append('pasajeros['+index+'][asistencia][guid]',p.getIn(['asistencia','guid']));formData.append('pasajeros['+index+'][asistencia][pais_destino]',p.getIn(['asistencia','pais_destino']));formData.append('pasajeros['+index+'][asistencia][fecha_salida]',p.getIn(['asistencia','fecha_salida']));formData.append('pasajeros['+index+'][asistencia][fecha_regreso]',p.getIn(['asistencia','fecha_regreso']));formData.append('pasajeros['+index+'][asistencia][avisar_a]',p.getIn(['asistencia','avisar_a']));formData.append('pasajeros['+index+'][asistencia][direccion]',p.getIn(['asistencia','direccion']));formData.append('pasajeros['+index+'][asistencia][ciudad]',p.getIn(['asistencia','ciudad']));formData.append('pasajeros['+index+'][asistencia][celular]',p.getIn(['asistencia','celular']));formData.append('pasajeros['+index+'][asistencia][telefono]',p.getIn(['asistencia','telefono']));}}index++;});axios.post(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+'/solicitudes/tiquetes-aereos',formData).then(function(res){var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_5__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].success('La solicitud ha sido guardada exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn1,fn2,fn3,fn4]));fn1(dispatch);fn2(dispatch);fn3();fn4();}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});};}function addFile(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var index=getState().common.getIn(['modalAddFile','index']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_16" /* ADICIONAR_PASAPORTE */],payload:{index:index,data:data}});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};var path="flagAdjunto";var value=false;var fn3=function fn3(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_220" /* MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO */],payload:{path:path,value:value}});};fn1(dispatch);fn2(dispatch);fn3(dispatch);}};}function addPasajero(payload){return function(dispatch,getState){var path=payload.path.split('.')[0];var pasajeros=getState().creaciontiqueteaereo.get(path);if(pasajeros.filter(function(x){return x.get('id')===payload.value.id;}).count()!==0){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warn('La persona '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{var pasajero=getState().creaciontiqueteaereo.getIn(payload.path.split('.')).toJS();pasajero=Object.assign({},pasajero,payload.value);pasajero.correo=pasajero.email;pasajero.cedula=pasajero.username;payload.value=pasajero;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["B" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO */],payload:payload});}};}function addOrigen(payload,query){return function(dispatch,getState){var path=payload.path.split('.')[0];var trayectos=getState().creaciontiqueteaereo.get(path);//trayectos.0.origen
if(trayectos.filter(function(x){return x.get('origen')===payload.value.code;}).count()!==0){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warn('La ubicacion '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{var trayecto=getState().creaciontiqueteaereo.getIn(payload.path.split('.')).toJS();trayecto.origen=payload.value.code;trayecto.aeropuerto_origen=payload.value.name+' '+query.toUpperCase();payload.value=trayecto;payload.value=trayecto;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["B" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO */],payload:payload});}};}function addDestino(payload,query){return function(dispatch,getState){var path=payload.path.split('.')[0];var trayectos=getState().creaciontiqueteaereo.get(path);if(trayectos.filter(function(x){return x.get('destino')===payload.value.code;}).count()!==0){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warn('La ubicacion '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{var trayecto=getState().creaciontiqueteaereo.getIn(payload.path.split('.')).toJS();trayecto.destino=payload.value.code;trayecto.aeropuerto_destino=payload.value.name+' '+query.toUpperCase();payload.value=trayecto;payload.value=trayecto;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["B" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO */],payload:payload});}};}function addCencoSolicitud(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_4" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO */]});};}function removeCenco(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_348" /* REMOVER_CENCOS_TIQUETESAEREOS */]});};}function enviarComentario(){return function(dispatch,getState){var guid=getState().creaciontiqueteaereo.getIn(['comentario','guid']);var comentario=getState().creaciontiqueteaereo.getIn(['comentario','texto']);var usuario=getState().common.get('user');var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_169" /* ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO */],payload:{comentario:comentario,guid:guid,usuario:usuario}});};fn1(dispatch);};}function editarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_119" /* EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO */],payload:{guid:guid}});};fn1(dispatch);};}function eliminarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_139" /* ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO */],payload:{guid:guid}});};fn1(dispatch);};}function addFileAdjunto(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["X" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1 */],payload:data});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}function removeSolicitudTiqutesAereos(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_129" /* ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO */]});};}

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(144);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getMaestras;
/* harmony export (immutable) */ __webpack_exports__["k"] = toggleSelectItem;
/* harmony export (immutable) */ __webpack_exports__["j"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["h"] = showHideModalAddMaestra;
/* unused harmony export showBarProgress */
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteMaestras;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["g"] = selectFile;
/* harmony export (immutable) */ __webpack_exports__["a"] = AddMaestra;
/* harmony export (immutable) */ __webpack_exports__["f"] = getProveedores;
/* harmony export (immutable) */ __webpack_exports__["i"] = synchroUsers;
/* harmony export (immutable) */ __webpack_exports__["d"] = getItems;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCencos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
function getMaestras(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/maestras').then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_297" /* OBTENER_MAESTRAS */],payload:res.data});}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function toggleSelectItem(item,checked){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_57" /* CONMUTAR_SELECCION_MAESTRAS */],payload:{index:item,checked:checked}};}function toggleSelectAllItems(checked){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_60" /* CONMUTAR_SELECCION_TODAS_MAESTRAS */],payload:{checked:checked}};}function showHideModalAddMaestra(show){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_235" /* MOSTRAR_MODAL_ADICIONAR_MAESTRA */],payload:show};}function showBarProgress(show){return{type:__WEBPACK_IMPORTED_MODULE_2__types__["_278" /* MOSTRAR_MODAL_PROGRESS */],payload:show};}function deleteMaestras(){return function(dispatch,getState){var maestas_ids=getState().maestras.get('maestras').filter(function(m){return m.get('checked');}).map(function(m){return m.get('id');});var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();axios({method:'DELETE',url:__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/maestras',data:{maestras:maestas_ids.toJS()}}).then(function(res){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].success("Se han eliminado las maestras correctamente",{bodyClassName:"toastify-content toastify-success"});dispatch(getMaestras());}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);}).finally(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common__["u" /* showHideModalDelete */])(false));});};}function updateInputs(path,value){return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_202" /* MODIFICAR_INPUTS_MAESTRA */],payload:{path:path,value:value}});};fn0(dispatch);};}function selectFile(file){return function(dispatch){var icon='_blank.png';dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_202" /* MODIFICAR_INPUTS_MAESTRA */],payload:{path:'modalAddMaestra.data.nombre',value:file.name}});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_202" /* MODIFICAR_INPUTS_MAESTRA */],payload:{path:'modalAddMaestra.data.file',value:file,immutable:false}});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_202" /* MODIFICAR_INPUTS_MAESTRA */],payload:{path:'modalAddMaestra.data.icono',value:icon}});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_202" /* MODIFICAR_INPUTS_MAESTRA */],payload:{path:'modalAddMaestra.data.guid',value:Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["B" /* guid */])()}});};}function AddMaestra(){return function(dispatch,getState){var data=getState().maestras.getIn(['modalAddMaestra','data']);dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__common__["F" /* uploadFiles */])('/maestras',[data],[function(){return dispatch(getMaestras());},function(){return __WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].success("Se ha actualizado la maestra correctamente",{bodyClassName:"toastify-content toastify-success"});}]));};}function getProveedores(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_278" /* MOSTRAR_MODAL_PROGRESS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_278" /* MOSTRAR_MODAL_PROGRESS */],payload:false});};fn0(dispatch);axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/integracion/proveedores').then(function(res){fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:res.data.success});}).catch(function(err){fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function synchroUsers(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{info:"La sincronización de los usuarios se hará el día de hoy a las 8:00P.M. con el último archivo cargado."});};}function getItems(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_278" /* MOSTRAR_MODAL_PROGRESS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_278" /* MOSTRAR_MODAL_PROGRESS */],payload:false});};fn0(dispatch);axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/integracion/items').then(function(res){fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:res.data.success});}).catch(function(err){fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}function getCencos(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_278" /* MOSTRAR_MODAL_PROGRESS */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_278" /* MOSTRAR_MODAL_PROGRESS */],payload:false});};fn0(dispatch);axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/integracion/cencos').then(function(res){fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,{success:res.data.success});}).catch(function(err){fn1(dispatch);Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);});};}

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getDelegados;
/* harmony export (immutable) */ __webpack_exports__["c"] = changeRecordsToShow;
/* harmony export (immutable) */ __webpack_exports__["f"] = setOrderBy;
/* harmony export (immutable) */ __webpack_exports__["a"] = AddDelegado;
/* harmony export (immutable) */ __webpack_exports__["i"] = toggleSelectItem;
/* harmony export (immutable) */ __webpack_exports__["h"] = toggleSelectAllItems;
/* harmony export (immutable) */ __webpack_exports__["g"] = showHideModalAddDelegados;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteDelegados;
/* harmony export (immutable) */ __webpack_exports__["j"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["b"] = SelectTipoSolicitud;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(24);
function getDelegados(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var axiosWithToken=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var showRecords=getState().delegados.get('showRecords');var orderBy=getState().delegados.get('orderBy');axiosWithToken.get(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+"/delegados",{params:{page:page,showRecords:showRecords,orderBy:orderBy}}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["_290" /* OBTENER_DELEGADOS */],payload:{data:res.data.data,page:res.data.current_page,totalRecords:res.data.total}});}).catch(function(err){return Object(__WEBPACK_IMPORTED_MODULE_3__actions_common__["f" /* displayMessages */])(dispatch,err);});};}function changeRecordsToShow(showRecords){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["_34" /* CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS */],payload:showRecords});dispatch(getDelegados(1));};}function setOrderBy(field){console.log(field);return function(dispatch,getState){var current=getState().delegados.get('orderBy');current=current.set('field',field.Value);if(field===null){current=current.set('asc',false);}else{current=current.set('asc',!current.get('asc'));}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["_323" /* ORDENAR_DELEGADOS */],payload:{orderBy:current}});dispatch(getDelegados(1));};}function AddDelegado(){var axiosWithToken=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var data=getState().delegados.getIn(['modalAddDelegado','data']);if(!data.get('delegado')||!data.get('cenco')||!data.get('delegado')||data.get('tipo_solicitud').count()===0){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning("Todos los campos son obligatorios",{bodyClassName:'toastify-content toastify-warning'});}if(data.getIn(["delegado","id"])===data.getIn(["responsable_cenco","id"])){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning("No puede delegarse a sí mismo",{bodyClassName:'toastify-content toastify-warning'});}var action=getState().delegados.getIn(['modalAddDelegado','action']);if(action==='create'){axiosWithToken.post(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+"/delegados",data).then(function(res){dispatch(getDelegados());}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__actions_common__["f" /* displayMessages */])(dispatch,err);});}else{axiosWithToken.put(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+"/delegados/"+data.get('id'),data).then(function(res){dispatch(getDelegados());}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__actions_common__["f" /* displayMessages */])(dispatch,err);});}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["_359" /* RESET_MODAL_ADD_DELEGADO */]});};}function toggleSelectItem(item,checked){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_55" /* CONMUTAR_SELECCION_DELEGADOS */],payload:{index:item,checked:checked}};}function toggleSelectAllItems(checked){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_64" /* CONMUTAR_SELECCION_TODOS_DELEGADOS */],payload:{checked:checked}};}function showHideModalAddDelegados(show,title,action,id){return function(dispatch){if(show===false||action==="create"){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["_359" /* RESET_MODAL_ADD_DELEGADO */]});}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["_234" /* MOSTRAR_MODAL_ADICIONAR_DELEGADOS */],payload:{show:show,title:title,action:action,id:id}});};}function deleteDelegados(){var axiosWithToken=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var selecteds=getState().delegados.get('delegados').filter(function(x){return x.get('checked');}).toJS();console.log(selecteds);axiosWithToken.delete(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* API_URL */]+"/delegados",{data:selecteds}).then(function(res){dispatch(getDelegados());}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__actions_common__["f" /* displayMessages */])(dispatch,err);}).finally(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_common__["u" /* showHideModalDelete */])());});};}function updateInputs(path,value,immutable){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_196" /* MODIFICAR_INPUTS_DELEGADOS */],payload:{path:path,value:value,immutable:immutable}};}function SelectTipoSolicitud(tipo_solicitud,check){return{type:__WEBPACK_IMPORTED_MODULE_1__types__["_368" /* SELECCIONAR_TIPO_SOLICITUD */],payload:{tipo_solicitud:tipo_solicitud,check:check}};}

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollToColumn: 0,
      scrollToRow: 0
    }, _this._columnStartIndex = 0, _this._columnStopIndex = 0, _this._rowStartIndex = 0, _this._rowStopIndex = 0, _this._onKeyDown = function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;


      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }, _this._onSectionRendered = function (_ref2) {
      var columnStartIndex = _ref2.columnStartIndex,
          columnStopIndex = _ref2.columnStopIndex,
          rowStartIndex = _ref2.rowStartIndex,
          rowStopIndex = _ref2.rowStopIndex;

      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'setScrollIndexes',
    value: function setScrollIndexes(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;

      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;

      var _getScrollState2 = this._getScrollState(),
          scrollToColumn = _getScrollState2.scrollToColumn,
          scrollToRow = _getScrollState2.scrollToRow;

      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](
        'div',
        { className: className, onKeyDown: this._onKeyDown },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: '_getScrollState',
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: '_updateScrollState',
    value: function _updateScrollState(_ref4) {
      var scrollToColumn = _ref4.scrollToColumn,
          scrollToRow = _ref4.scrollToRow;
      var _props2 = this.props,
          isControlled = _props2.isControlled,
          onScrollToChange = _props2.onScrollToChange;


      if (typeof onScrollToChange === 'function') {
        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }

      if (!isControlled) {
        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return null;
      }

      if (nextProps.scrollToColumn !== prevState.scrollToColumn || nextProps.scrollToRow !== prevState.scrollToRow) {
        return {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow
        };
      }

      return null;
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
ArrowKeyStepper.propTypes =  true ? null : {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  isControlled: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['cells', 'edges']).isRequired,
  onScrollToChange: PropTypes.func,
  rowCount: PropTypes.number.isRequired,
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(ArrowKeyStepper);

/* unused harmony default export */ var _unused_webpack_default_export = (ArrowKeyStepper);




/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(70);
var toObject = __webpack_require__(83);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(58) && !__webpack_require__(85)(function () {
  return Object.defineProperty(__webpack_require__(162)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(716), __esModule: true };

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(718);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(728);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(99);
var $export = __webpack_require__(47);
var redefine = __webpack_require__(267);
var hide = __webpack_require__(71);
var Iterators = __webpack_require__(86);
var $iterCreate = __webpack_require__(721);
var setToStringTag = __webpack_require__(128);
var getPrototypeOf = __webpack_require__(262);
var ITERATOR = __webpack_require__(38)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(71);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(70);
var toIObject = __webpack_require__(72);
var arrayIndexOf = __webpack_require__(723)(false);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(103);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(37).document;
module.exports = document && document.documentElement;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(268);
var hiddenKeys = __webpack_require__(167).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 272 */
/***/ (function(module, exports) {



/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_scrollbarSize__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);



















/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props));

    _this._onGridRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;
    _this._styleCache = {};
    _this._cellCache = {};

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      // isScrolling is used to determine if we reset styleCache
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    var columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });

    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,

        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,

        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,

      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: 'getTotalRowsHeight',
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }

    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: 'getTotalColumnsWidth',
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;
      var instanceProps = this.state.instanceProps;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;
      var instanceProps = this.state.instanceProps;

      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;
      var instanceProps = this.state.instanceProps;


      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._styleCache = {};
      this._cellCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;
      var instanceProps = this.state.instanceProps;

      // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prevState, { needToResetStyleCache: false });
          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }

      // refs don't work in `react-test-renderer`
      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop,
          instanceProps = _state.instanceProps;
      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          autoContainerWidth = _props6.autoContainerWidth,
          autoHeight = _props6.autoHeight,
          autoWidth = _props6.autoWidth,
          className = _props6.className,
          containerProps = _props6.containerProps,
          containerRole = _props6.containerRole,
          containerStyle = _props6.containerStyle,
          height = _props6.height,
          id = _props6.id,
          noContentRenderer = _props6.noContentRenderer,
          role = _props6.role,
          style = _props6.style,
          tabIndex = _props6.tabIndex,
          width = _props6.width;
      var _state2 = this.state,
          instanceProps = _state2.instanceProps,
          needToResetStyleCache = _state2.needToResetStyleCache;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      }

      // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }

      // calculate children to render here
      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
        'div',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;


      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });

        // update the indices
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_handleInvalidatedGridSize',


    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props7 = _this3.props,
              height = _props7.height,
              onScroll = _props7.onScroll,
              width = _props7.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;

        // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps;

      // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });

      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, {
          isScrolling: false
        });
      }

      var maybeStateA = void 0;
      var maybeStateB = void 0;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });

      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;

      // getting scrollBarSize (moved from componentWillMount)
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, newState, maybeStateA, maybeStateB);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_getScrollToPositionStateUpdate',


    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }
      return null;
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;

        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollLeftForScrollToColumnStateUpdate',
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return null;
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollTopForScrollToRowStateUpdate',
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return null;
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_15_dom_helpers_scrollbarSize__["a" /* default */],
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
};
Grid.propTypes =  true ? null : {
  "aria-label": PropTypes.string.isRequired,
  "aria-readonly": PropTypes.bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: PropTypes.bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: PropTypes.bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: function cellRenderer() {
    return (typeof bpfrpt_proptype_CellRenderer === 'function' ? bpfrpt_proptype_CellRenderer.isRequired ? bpfrpt_proptype_CellRenderer.isRequired : bpfrpt_proptype_CellRenderer : PropTypes.shape(bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: function cellRangeRenderer() {
    return (typeof bpfrpt_proptype_CellRangeRenderer === 'function' ? bpfrpt_proptype_CellRangeRenderer.isRequired ? bpfrpt_proptype_CellRangeRenderer.isRequired : bpfrpt_proptype_CellRangeRenderer : PropTypes.shape(bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: PropTypes.string,


  /** Number of columns in grid.  */
  columnCount: PropTypes.number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: function columnWidth() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Unfiltered props for the Grid container. */
  containerProps: PropTypes.object,


  /** ARIA role for the cell-container.  */
  containerRole: PropTypes.string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: PropTypes.object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: PropTypes.object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: PropTypes.number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: PropTypes.func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: PropTypes.number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: PropTypes.string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: PropTypes.bool,


  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  isScrollingOptOut: PropTypes.bool.isRequired,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: function noContentRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: PropTypes.func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: PropTypes.func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: PropTypes.number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** ARIA role for the grid element.  */
  role: PropTypes.string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Number of rows in grid.  */
  rowCount: PropTypes.number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Horizontal offset. */
  scrollLeft: PropTypes.number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: PropTypes.number.isRequired,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__["polyfill"])(Grid);
/* harmony default export */ __webpack_exports__["a"] = (Grid);
















/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(744), __esModule: true };

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(23);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}



/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(23);


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseDOM__ = __webpack_require__(753);

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (__WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */]) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(51);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(86);
var ITERATOR = __webpack_require__(38)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(51);
var aFunction = __webpack_require__(127);
var SPECIES = __webpack_require__(38)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(84);
var invoke = __webpack_require__(759);
var html = __webpack_require__(270);
var cel = __webpack_require__(162);
var global = __webpack_require__(37);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(103)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(51);
var isObject = __webpack_require__(65);
var newPromiseCapability = __webpack_require__(178);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(38)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_ScrollIndices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_ScrollIndices =  true ? null : {
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};



/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var AutoSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var win = _this._window || window;
        var _style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // uses any instead of Window because Flow doesn't have window type


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])(nonce, this._window);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        {
          className: className,
          ref: this._setRef,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: PropTypes.func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: PropTypes.string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: PropTypes.number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: PropTypes.number,


  /** Disable dynamic :height property */
  disableHeight: PropTypes.bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: PropTypes.bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: PropTypes.string,


  /** Callback to be invoked on-resize */
  onResize: PropTypes.func.isRequired,


  /** Optional inline style */
  style: PropTypes.object
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/

function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(61)))

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__ = __webpack_require__(770);
/* unused harmony reexport CellMeasurer */
/* unused harmony reexport CellMeasurerCache */



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a" /* default */]);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellMeasureCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellMeasureCache =  true ? null : {
  hasFixedWidth: PropTypes.func.isRequired,
  hasFixedHeight: PropTypes.func.isRequired,
  has: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};



/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_clsx__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);











/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = Object(__WEBPACK_IMPORTED_MODULE_9_clsx__["a" /* default */])('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_7__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": PropTypes.string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /** Optional CSS class name */
  className: PropTypes.string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: PropTypes.number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: function noRowsRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: PropTypes.func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: function rowRenderer() {
    return (typeof bpfrpt_proptype_RowRenderer === 'function' ? bpfrpt_proptype_RowRenderer.isRequired ? bpfrpt_proptype_RowRenderer.isRequired : bpfrpt_proptype_RowRenderer : PropTypes.shape(bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },


  /** Number of rows in list. */
  rowCount: PropTypes.number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of list */
  width: PropTypes.number.isRequired
};
/* unused harmony default export */ var _unused_webpack_default_export = (List);













/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(105);


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(105);


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'div',
    { className: className, role: 'row', style: style },
    columns
  );
}
defaultHeaderRowRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRowRendererParams;



/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: typeof label === 'string' ? label : null },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], { key: 'SortIndicator', sortDirection: sortDirection }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRendererParams;



/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clsx__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortDirection__ = __webpack_require__(132);





/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = Object(__WEBPACK_IMPORTED_MODULE_0_clsx__["a" /* default */])('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](
    'svg',
    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
    sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

SortIndicator.propTypes =  false ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;

  var a11yProps = { 'aria-rowindex': index + 1 };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({ event: event, index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      role: 'row',
      style: style }),
    columns
  );
}
defaultRowRenderer.propTypes =  true ? null : bpfrpt_proptype_RowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_RowRendererParams;



/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SortDirection__ = __webpack_require__(132);











/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _React$Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__["a" /* default */],
  defaultSortDirection: __WEBPACK_IMPORTED_MODULE_9__SortDirection__["a" /* default */].ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* unused harmony default export */ var _unused_webpack_default_export = (Column);
Column.propTypes =  false ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,

  /** Optional id to set on the column header */
  id: PropTypes.string,

  /** Header label for this column */
  label: PropTypes.node,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);












/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }), _this._registerChild = function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }
      _this._child = element;
      _this.updatePosition();
    }, _this._onChildScroll = function (_ref2) {
      var scrollTop = _ref2.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    }, _this._registerResizeListener = function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    }, _this._unregisterResizeListener = function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    }, _this._onResize = function () {
      _this.updatePosition();
    }, _this.__handleWindowScrollEvent = function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;


      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        var scrollOffset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollOffset */])(scrollElement);
        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });

        onScroll({
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });
      }
    }, _this.__resetIsScrolling = function () {
      _this.setState({
        isScrolling: false
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _state = this.state,
          height = _state.height,
          width = _state.width;


      var thisNode = this._child || __WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"](this);
      if (thisNode instanceof Element && scrollElement) {
        var offset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionOffset */])(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(scrollElement, this.props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;

      this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__["a" /* default */])();

      this.updatePosition(scrollElement);

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);
        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;


      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);

        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, prevScrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);
        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;
      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollTop = _state2.scrollTop,
          scrollLeft = _state2.scrollLeft,
          height = _state2.height,
          width = _state2.width;


      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }

    // Referenced by utils/onScroll


    // Referenced by utils/onScroll

  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
};
WindowScroller.propTypes =  true ? null : {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,


  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: PropTypes.func.isRequired,


  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
  onScroll: PropTypes.func.isRequired,


  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: PropTypes.oneOfType([PropTypes.any, function () {
    return (typeof Element === 'function' ? PropTypes.instanceOf(Element) : PropTypes.any).apply(this, arguments);
  }]),

  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Height used for server-side rendering */
  serverHeight: PropTypes.number.isRequired,


  /** Width used for server-side rendering */
  serverWidth: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(74) && !__webpack_require__(133)(function () {
  return Object.defineProperty(__webpack_require__(300)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(60);
var document = __webpack_require__(59).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(60);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(75);
var IObject = __webpack_require__(305);
var toObject = __webpack_require__(182);
var toLength = __webpack_require__(136);
var asc = __webpack_require__(824);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(181);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(138);
var toLength = __webpack_require__(136);
var toAbsoluteIndex = __webpack_require__(829);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(835)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(185)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(90);
var dPs = __webpack_require__(837);
var enumBugKeys = __webpack_require__(310);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(300)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(839).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(838);
var enumBugKeys = __webpack_require__(310);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(90);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(106);
var ITERATOR = __webpack_require__(44)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(188);
var ITERATOR = __webpack_require__(44)('iterator');
var Iterators = __webpack_require__(106);
module.exports = __webpack_require__(54).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(44)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(91);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(135)('meta');
var isObject = __webpack_require__(60);
var has = __webpack_require__(92);
var setDesc = __webpack_require__(73).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(133)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(60);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(321);
module.exports = __webpack_require__(326);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(322).enable();
  window.Promise = __webpack_require__(324);
}

// fetch() polyfill for making API calls.
__webpack_require__(325);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(66);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(189);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(189);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 325 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_universal_cookie__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral_locales_es__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral_locales_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral_locales_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reducers__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_auth__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_polyfills_js__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__css_bootstrap_css__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__css_fonts_css__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__css_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__css_fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_font_awesome_min_css__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__css_animate_css__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__css_layout_css__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__css_layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__css_layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__css_custom_toastify_css__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__css_custom_toastify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__css_custom_toastify_css__);
//import 'react-toastify/dist/ReactToastify.min.css'
__WEBPACK_IMPORTED_MODULE_6_numeral___default.a.locale('es');var cookies=new __WEBPACK_IMPORTED_MODULE_5_universal_cookie___default.a();var token=cookies.get('token');if(token){var d=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].dispatch;d({type:__WEBPACK_IMPORTED_MODULE_10__actions_types__["_179" /* INICIAR_SESION */]});Object(__WEBPACK_IMPORTED_MODULE_11__actions_auth__["b" /* getUserFromToken */])().then(function(data){d({type:__WEBPACK_IMPORTED_MODULE_10__actions_types__["_29" /* ASIGNAR_USUARIO_SESION */],payload:data});}).catch(function(err){console.log(err);__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].dispatch({type:__WEBPACK_IMPORTED_MODULE_10__actions_types__["_41" /* CERRAR_SESION */]});__WEBPACK_IMPORTED_MODULE_12__utils_history__["a" /* default */].push(window.FOLDER+'/signin');});}window.root=window.document.getElementById('root');__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_12__utils_history__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_8__routes__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toastify__["ToastContainer"],{toastClassName:'toastify'}))),window.root);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(66),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(66),r=__webpack_require__(329);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(330);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(140);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(333);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(193);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(358);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(199);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(345);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(343);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(61)))

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(196);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(347);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(351);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(61), __webpack_require__(350)(module)))

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(197);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(199);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(200);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(359);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(140);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = __webpack_require__(77);

var _TransitionGroup = __webpack_require__(391);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Toast = __webpack_require__(393);

var _Toast2 = _interopRequireDefault(_Toast);

var _DefaultCloseButton = __webpack_require__(395);

var _DefaultCloseButton2 = _interopRequireDefault(_DefaultCloseButton);

var _DefaultTransition = __webpack_require__(396);

var _DefaultTransition2 = _interopRequireDefault(_DefaultTransition);

var _constant = __webpack_require__(94);

var _style = __webpack_require__(110);

var _style2 = _interopRequireDefault(_style);

var _EventManager = __webpack_require__(218);

var _EventManager2 = _interopRequireDefault(_EventManager);

var _objectValues = __webpack_require__(216);

var _objectValues2 = _interopRequireDefault(_objectValues);

var _propValidator = __webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var container = function container() {
  return (0, _glamor.css)(_defineProperty({
    zIndex: 999,
    position: "fixed",
    padding: "4px",
    width: _style2.default.width,
    boxSizing: "border-box",
    color: "#fff"
  }, "@media " + _style2.default.mobile, {
    width: "100vw",
    padding: 0
  }));
};

var toastPosition = function toastPosition(pos) {
  var rule = void 0;
  var marginLeft = "-" + parseInt(_style2.default.width, 10) / 2 + "px";
  switch (pos) {
    case _constant.POSITION.TOP_LEFT:
      rule = {
        top: "1em",
        left: "1em"
      };
      break;
    case _constant.POSITION.TOP_CENTER:
      rule = {
        top: "1em",
        left: "50%",
        marginLeft: marginLeft
      };
      break;
    case _constant.POSITION.TOP_RIGHT:
    default:
      rule = {
        top: "1em",
        right: "1em"
      };
      break;
    case _constant.POSITION.BOTTOM_LEFT:
      rule = {
        bottom: "1em",
        left: "1em"
      };
      break;
    case _constant.POSITION.BOTTOM_CENTER:
      rule = {
        bottom: "1em",
        left: "50%",
        marginLeft: marginLeft
      };
      break;
    case _constant.POSITION.BOTTOM_RIGHT:
      rule = {
        bottom: "1em",
        right: "1em"
      };
  }
  return (0, _glamor.css)(rule, (0, _glamor.css)(_defineProperty({}, "@media " + _style2.default.mobile, _extends({
    left: 0,
    margin: 0,
    position: "fixed"
  }, pos.substring(0, 3) === "top" ? { top: 0 } : { bottom: 0 }))));
};

var ToastContainer = function (_Component) {
  _inherits(ToastContainer, _Component);

  function ToastContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToastContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToastContainer.__proto__ || Object.getPrototypeOf(ToastContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      toast: []
    }, _this.collection = {}, _this.isToastActive = function (id) {
      return _this.state.toast.indexOf(parseInt(id, 10)) !== -1;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToastContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var SHOW = _constant.ACTION.SHOW,
          CLEAR = _constant.ACTION.CLEAR,
          MOUNTED = _constant.ACTION.MOUNTED;

      _EventManager2.default.on(SHOW, function (content, options) {
        return _this2.show(content, options);
      }).on(CLEAR, function (id) {
        return id !== null ? _this2.removeToast(id) : _this2.clear();
      }).emit(MOUNTED, this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _EventManager2.default.off(_constant.ACTION.SHOW);
      _EventManager2.default.off(_constant.ACTION.CLEAR);
    }
  }, {
    key: "removeToast",
    value: function removeToast(id) {
      this.setState({
        toast: this.state.toast.filter(function (v) {
          return v !== parseInt(id, 10);
        })
      });
    }
  }, {
    key: "with",
    value: function _with(component, props) {
      return (0, _react.cloneElement)(component, _extends({}, props, component.props));
    }
  }, {
    key: "makeCloseButton",
    value: function makeCloseButton(toastClose, toastId, type) {
      var _this3 = this;

      var closeButton = this.props.closeButton;

      if ((0, _react.isValidElement)(toastClose) || toastClose === false) {
        closeButton = toastClose;
      }

      return closeButton === false ? false : this.with(closeButton, {
        closeToast: function closeToast() {
          return _this3.removeToast(toastId);
        },
        type: type
      });
    }
  }, {
    key: "getAutoCloseDelay",
    value: function getAutoCloseDelay(toastAutoClose) {
      return toastAutoClose === false || (0, _propValidator.isValidDelay)(toastAutoClose) ? toastAutoClose : this.props.autoClose;
    }
  }, {
    key: "isFunction",
    value: function isFunction(object) {
      return !!(object && object.constructor && object.call && object.apply);
    }
  }, {
    key: "canBeRendered",
    value: function canBeRendered(content) {
      return (0, _react.isValidElement)(content) || (0, _propValidator.typeOf)(content) === "String" || (0, _propValidator.typeOf)(content) === "Number";
    }
  }, {
    key: "show",
    value: function show(content, options) {
      var _this4 = this;

      if (!this.canBeRendered(content)) {
        throw new Error("The element you provided cannot be rendered. You provided an element of type " + (typeof content === "undefined" ? "undefined" : _typeof(content)));
      }
      var toastId = options.toastId;
      var closeToast = function closeToast() {
        return _this4.removeToast(toastId);
      };
      var toastOptions = {
        id: toastId,
        type: options.type,
        closeButton: this.makeCloseButton(options.closeButton, toastId, options.type),
        position: options.position || this.props.position,
        transition: options.transition || this.props.transition,
        pauseOnHover: options.pauseOnHover !== null ? options.pauseOnHover : this.props.pauseOnHover,
        closeOnClick: options.closeOnClick !== null ? options.closeOnClick : this.props.closeOnClick,
        className: options.className || this.props.toastClassName,
        bodyClassName: options.bodyClassName || this.props.bodyClassName,
        progressClassName: options.progressClassName || this.props.progressClassName
      };

      this.isFunction(options.onOpen) && (toastOptions.onOpen = options.onOpen);

      this.isFunction(options.onClose) && (toastOptions.onClose = options.onClose);

      toastOptions.autoClose = this.getAutoCloseDelay(options.autoClose !== false ? parseInt(options.autoClose, 10) : options.autoClose);

      toastOptions.hideProgressBar = typeof options.hideProgressBar === "boolean" ? options.hideProgressBar : this.props.hideProgressBar;

      toastOptions.closeToast = closeToast;

      if ((0, _react.isValidElement)(content) && (0, _propValidator.typeOf)(content.type) !== "String") {
        content = this.with(content, {
          closeToast: closeToast
        });
      }

      this.collection = _extends({}, this.collection, _defineProperty({}, toastId, {
        content: this.makeToast(content, toastOptions),
        position: toastOptions.position
      }));

      this.setState({
        toast: [].concat(_toConsumableArray(this.state.toast), [toastId])
      });
    }
  }, {
    key: "makeToast",
    value: function makeToast(content, options) {
      return _react2.default.createElement(
        _Toast2.default,
        _extends({}, options, { key: "toast-" + options.id }),
        content
      );
    }
  }, {
    key: "clear",
    value: function clear() {
      this.setState({ toast: [] });
    }
  }, {
    key: "getContainerProps",
    value: function getContainerProps(disablePointer) {
      var props = {
        style: disablePointer ? { pointerEvents: "none" } : {}
      };

      if (this.props.className !== null) {
        props.className = this.props.className;
      }

      if (this.props.style !== null) {
        props.style = _extends({}, this.props.style, props.style);
      }

      return props;
    }
  }, {
    key: "renderToast",
    value: function renderToast() {
      var _this5 = this;

      var toastToRender = {};
      var collection = this.props.newestOnTop ? Object.keys(this.collection).reverse() : Object.keys(this.collection);

      collection.forEach(function (toastId) {
        var item = _this5.collection[toastId];
        toastToRender[item.position] || (toastToRender[item.position] = []);

        if (_this5.state.toast.indexOf(parseInt(toastId, 10)) !== -1) {
          toastToRender[item.position].push(item.content);
        } else {
          toastToRender[item.position].push(null);
          delete _this5.collection[toastId];
        }
      });

      return Object.keys(toastToRender).map(function (position) {
        var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;

        return _react2.default.createElement(
          _TransitionGroup2.default,
          _extends({}, container(), toastPosition(position), _this5.getContainerProps(disablePointer), {
            key: "container-" + position
          }),
          toastToRender[position]
        );
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        this.renderToast()
      );
    }
  }]);

  return ToastContainer;
}(_react.Component);

ToastContainer.propTypes = {
  /**
   * Set toast position
   */
  position: _propTypes2.default.oneOf((0, _objectValues2.default)(_constant.POSITION)),

  /**
   * Disable or set autoClose delay
   */
  autoClose: _propValidator.falseOrNumber,

  /**
   * Disable or set a custom react element for the close button
   */
  closeButton: _propValidator.falseOrElement,

  /**
   * Hide or not progress bar when autoClose is enabled
   */
  hideProgressBar: _propTypes2.default.bool,

  /**
   * Pause toast duration on hover
   */
  pauseOnHover: _propTypes2.default.bool,

  /**
   * Dismiss toast on click
   */
  closeOnClick: _propTypes2.default.bool,

  /**
   * Newest on top
   */
  newestOnTop: _propTypes2.default.bool,

  /**
   * An optional className
   */
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  /**
   * An optional style
   */
  style: _propTypes2.default.object,

  /**
   * An optional className for the toast
   */
  toastClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  /**
   * An optional className for the toast body
   */
  bodyClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  /**
   * An optional className for the toast progress bar
   */
  progressClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  /**
   * Define enter and exit transition using react-transition-group
   */
  transition: _propTypes2.default.func
};
ToastContainer.defaultProps = {
  position: _constant.POSITION.TOP_RIGHT,
  transition: _DefaultTransition2.default,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: _react2.default.createElement(_DefaultCloseButton2.default, null),
  pauseOnHover: true,
  closeOnClick: true,
  newestOnTop: false,
  className: null,
  style: null,
  toastClassName: '',
  bodyClassName: '',
  progressClassName: ''
};
exports.default = ToastContainer;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSheet = StyleSheet;

var _objectAssign = __webpack_require__(66);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* 

high performance StyleSheet for css-in-js systems 

- uses multiple style tags behind the scenes for millions of rules 
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side 


// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject() 
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }') 
- appends a css rule into the stylesheet 

styleSheet.flush() 
- empties the stylesheet of all its contents


*/

function last(arr) {
  return arr[arr.length - 1];
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  // this weirdness brought to you by firefox 
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}

var isBrowser = typeof window !== 'undefined';
var isDev = "production" === 'development' || !"production"; //(x => (x === 'development') || !x)(process.env.NODE_ENV)
var isTest = "production" === 'test';

var oldIE = function () {
  if (isBrowser) {
    var div = document.createElement('div');
    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
    return div.getElementsByTagName('i').length === 1;
  }
}();

function makeStyleTag() {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-glamor', '');
  tag.appendChild(document.createTextNode(''));
  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
  return tag;
}

function StyleSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$speedy = _ref.speedy,
      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;

  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
  this.sheet = undefined;
  this.tags = [];
  this.maxLength = maxLength;
  this.ctr = 0;
}

(0, _objectAssign2.default)(StyleSheet.prototype, {
  getSheet: function getSheet() {
    return sheetForTag(last(this.tags));
  },
  inject: function inject() {
    var _this = this;

    if (this.injected) {
      throw new Error('already injected stylesheet!');
    }
    if (isBrowser) {
      this.tags[0] = makeStyleTag();
    } else {
      // server side 'polyfill'. just enough behavior to be useful.
      this.sheet = {
        cssRules: [],
        insertRule: function insertRule(rule) {
          // enough 'spec compliance' to be able to extract the rules later  
          // in other words, just the cssText field 
          _this.sheet.cssRules.push({ cssText: rule });
        }
      };
    }
    this.injected = true;
  },
  speedy: function speedy(bool) {
    if (this.ctr !== 0) {
      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
    }
    this.isSpeedy = !!bool;
  },
  _insert: function _insert(rule) {
    // this weirdness for perf, and chrome's weird bug 
    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
    try {
      var sheet = this.getSheet();
      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
    } catch (e) {
      if (isDev) {
        // might need beter dx for this 
        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
      }
    }
  },
  insert: function insert(rule) {

    if (isBrowser) {
      // this is the ultrafast version, works across browsers 
      if (this.isSpeedy && this.getSheet().insertRule) {
        this._insert(rule);
      }
      // more browser weirdness. I don't even know    
      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
      //   this.tags::last().styleSheet.cssText+= rule
      // }
      else {
          if (rule.indexOf('@import') !== -1) {
            var tag = last(this.tags);
            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
          } else {
            last(this.tags).appendChild(document.createTextNode(rule));
          }
        }
    } else {
      // server side is pretty simple         
      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
    }

    this.ctr++;
    if (isBrowser && this.ctr % this.maxLength === 0) {
      this.tags.push(makeStyleTag());
    }
    return this.ctr - 1;
  },

  // commenting this out till we decide on v3's decision 
  // _replace(index, rule) {
  //   // this weirdness for perf, and chrome's weird bug 
  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
  //   try {  
  //     let sheet = this.getSheet()        
  //     sheet.deleteRule(index) // todo - correct index here     
  //     sheet.insertRule(rule, index)
  //   }
  //   catch(e) {
  //     if(isDev) {
  //       // might need beter dx for this 
  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
  //     }          
  //   }          

  // }
  // replace(index, rule) {
  //   if(isBrowser) {
  //     if(this.isSpeedy && this.getSheet().insertRule) {
  //       this._replace(index, rule)
  //     }
  //     else {
  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
  //       let _index = (index % this.maxLength) + 1
  //       let tag = this.tags[_slot]
  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
  //     }
  //   }
  //   else {
  //     let rules = this.sheet.cssRules
  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
  //   }
  // }
  delete: function _delete(index) {
    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
    return this.replace(index, '');
  },
  flush: function flush() {
    if (isBrowser) {
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.sheet = null;
      this.ctr = 0;
      // todo - look for remnants in document.styleSheets
    } else {
      // simpler on server 
      this.sheet.cssRules = [];
    }
    this.injected = false;
  },
  rules: function rules() {
    if (!isBrowser) {
      return this.sheet.cssRules;
    }
    var arr = [];
    this.tags.forEach(function (tag) {
      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
    });
    return arr;
  }
});

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(365);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CSSProperty = __webpack_require__(367);

var _CSSProperty2 = _interopRequireDefault(_CSSProperty);

var _warning = __webpack_require__(214);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */

var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

exports.default = dangerousStyleValue;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true

  /**
   * @param {string} prefix vendor-specific prefix, eg: Webkit
   * @param {string} key style name, eg: transitionDuration
   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
   * WebkitTransitionDuration
   */
};function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

exports.default = CSSProperty;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(370);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = clean;
// Returns true for null, false, undefined and {}
function isFalsy(value) {
  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
}

function cleanObject(object) {
  if (isFalsy(object)) return null;
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;

  var acc = {},
      keys = Object.keys(object),
      hasFalsy = false;
  for (var i = 0; i < keys.length; i++) {
    var value = object[keys[i]];
    var filteredValue = clean(value);
    if (filteredValue === null || filteredValue !== value) {
      hasFalsy = true;
    }
    if (filteredValue !== null) {
      acc[keys[i]] = filteredValue;
    }
  }
  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
}

function cleanArray(rules) {
  var hasFalsy = false;
  var filtered = [];
  rules.forEach(function (rule) {
    var filteredRule = clean(rule);
    if (filteredRule === null || filteredRule !== rule) {
      hasFalsy = true;
    }
    if (filteredRule !== null) {
      filtered.push(filteredRule);
    }
  });
  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
}

// Takes style array or object provided by user and clears all the falsy data 
// If there is no styles left after filtration returns null
function clean(input) {
  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.PluginSet = PluginSet;
exports.fallbacks = fallbacks;
exports.contentWrap = contentWrap;
exports.prefixes = prefixes;

var _objectAssign = __webpack_require__(66);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _CSSPropertyOperations = __webpack_require__(213);

var _prefixer = __webpack_require__(374);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = function (x) {
  return x === 'development' || !x;
}("production");

function PluginSet(initial) {
  this.fns = initial || [];
}

(0, _objectAssign2.default)(PluginSet.prototype, {
  add: function add() {
    var _this = this;

    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    fns.forEach(function (fn) {
      if (_this.fns.indexOf(fn) >= 0) {
        if (isDev) {
          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
        }
      } else {
        _this.fns = [fn].concat(_this.fns);
      }
    });
  },
  remove: function remove(fn) {
    this.fns = this.fns.filter(function (x) {
      return x !== fn;
    });
  },
  clear: function clear() {
    this.fns = [];
  },
  transform: function transform(o) {
    return this.fns.reduce(function (o, fn) {
      return fn(o);
    }, o);
  }
});

function fallbacks(node) {
  var hasArray = Object.keys(node.style).map(function (x) {
    return Array.isArray(node.style[x]);
  }).indexOf(true) >= 0;
  if (hasArray) {
    var style = node.style;

    var flattened = Object.keys(style).reduce(function (o, key) {
      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
      return o;
    }, {});
    // todo - 
    // flatten arrays which haven't been flattened yet 
    return (0, _objectAssign2.default)({}, node, { style: flattened });
  }
  return node;
}

var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];

function contentWrap(node) {
  if (node.style.content) {
    var cont = node.style.content;
    if (contentValues.indexOf(cont) >= 0) {
      return node;
    }
    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
      return node;
    }
    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
      return node;
    }
    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
  }
  return node;
}

function prefixes(node) {
  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixer;

var _staticData = __webpack_require__(375);

var _staticData2 = _interopRequireDefault(_staticData);

var _prefixProperty = __webpack_require__(376);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(377);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _cursor = __webpack_require__(378);

var _cursor2 = _interopRequireDefault(_cursor);

var _crossFade = __webpack_require__(379);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _filter = __webpack_require__(380);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(381);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxOld = __webpack_require__(382);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(383);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(384);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(385);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(386);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(387);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer

var prefixMap = _staticData2.default.prefixMap;

function prefixer(style) {
  for (var property in style) {
    var value = style[property];

    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

    // only modify the value if it was touched
    // by any plugin to prevent unnecessary mutations
    if (processedValue) {
      style[property] = processedValue;
    }

    (0, _prefixProperty2.default)(prefixMap, property, style);
  }
  return style;
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

exports.default = {
  plugins: [],
  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
};
module.exports = exports["default"];

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(215);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(93);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(93);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(93);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(93);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(388);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(93);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(215);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(389);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doHash;
// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(67);

var _ChildMapping = __webpack_require__(392);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = __webpack_require__(77);

var _ProgressBar = __webpack_require__(394);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _constant = __webpack_require__(94);

var _style = __webpack_require__(110);

var _style2 = _interopRequireDefault(_style);

var _objectValues = __webpack_require__(216);

var _objectValues2 = _interopRequireDefault(_objectValues);

var _propValidator = __webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toast = function toast(type) {
  return (0, _glamor.css)(_extends({
    position: "relative",
    minHeight: "48px",
    marginBottom: "1rem",
    padding: "8px",
    borderRadius: "1px",
    boxShadow: "0 1px 10px 0 rgba(0, 0, 0, .1), 0 2px 15px 0 rgba(0, 0, 0, .05)",
    display: "flex",
    justifyContent: "space-between",
    maxHeight: "800px",
    overflow: "hidden",
    fontFamily: "sans-serif",
    cursor: "pointer",
    background: _style2.default["color" + type.charAt(0).toUpperCase() + type.slice(1)]
  }, type === "default" ? { color: "#aaa" } : {}, _defineProperty({}, "@media " + _style2.default.mobile, {
    marginBottom: 0
  })));
};

var body = (0, _glamor.css)({
  margin: "auto 0",
  flex: 1
});

var Toast = function (_Component) {
  _inherits(Toast, _Component);

  function Toast() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Toast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toast.__proto__ || Object.getPrototypeOf(Toast)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isRunning: true
    }, _this.handleVisibility = function () {
      return _this.setState({ isRunning: !document.hidden });
    }, _this.pauseToast = function () {
      _this.setState({ isRunning: false });
    }, _this.playToast = function () {
      _this.setState({ isRunning: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onOpen !== null && this.props.onOpen(this.getChildrenProps());
      document.addEventListener("visibilitychange", this.handleVisibility);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onClose !== null && this.props.onClose(this.getChildrenProps());
      document.removeEventListener("visibilitychange", this.handleVisibility);
    }
  }, {
    key: "getChildrenProps",
    value: function getChildrenProps() {
      return this.props.children.props;
    }
  }, {
    key: "getToastProps",
    value: function getToastProps() {
      var toastProps = {};

      if (this.props.autoClose !== false && this.props.pauseOnHover === true) {
        toastProps.onMouseEnter = this.pauseToast;
        toastProps.onMouseLeave = this.playToast;
      }

      this.props.closeOnClick && (toastProps.onClick = this.props.closeToast);

      return toastProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          closeButton = _props.closeButton,
          children = _props.children,
          autoClose = _props.autoClose,
          type = _props.type,
          hideProgressBar = _props.hideProgressBar,
          closeToast = _props.closeToast,
          Transition = _props.transition,
          position = _props.position,
          onExited = _props.onExited,
          className = _props.className,
          bodyClassName = _props.bodyClassName,
          progressClassName = _props.progressClassName;


      return _react2.default.createElement(
        Transition,
        { "in": this.props.in, appear: true, unmountOnExit: true, onExited: onExited, position: position },
        _react2.default.createElement(
          "div",
          _extends({}, toast(type), this.getToastProps(), { className: className }),
          _react2.default.createElement(
            "div",
            _extends({}, body, { className: bodyClassName }),
            children
          ),
          closeButton !== false && closeButton,
          autoClose !== false && _react2.default.createElement(_ProgressBar2.default, {
            delay: autoClose,
            isRunning: this.state.isRunning,
            closeToast: closeToast,
            hide: hideProgressBar,
            type: type,
            className: progressClassName
          })
        )
      );
    }
  }]);

  return Toast;
}(_react.Component);

Toast.propTypes = {
  closeButton: _propValidator.falseOrElement.isRequired,
  autoClose: _propValidator.falseOrNumber.isRequired,
  children: _propTypes2.default.node.isRequired,
  closeToast: _propTypes2.default.func.isRequired,
  position: _propTypes2.default.oneOf((0, _objectValues2.default)(_constant.POSITION)).isRequired,
  pauseOnHover: _propTypes2.default.bool.isRequired,
  closeOnClick: _propTypes2.default.bool.isRequired,
  transition: _propTypes2.default.func.isRequired,
  in: _propTypes2.default.bool,
  onExited: _propTypes2.default.func,
  hideProgressBar: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  type: _propTypes2.default.oneOf((0, _objectValues2.default)(_constant.TYPE)),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  progressClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};
Toast.defaultProps = {
  type: _constant.TYPE.DEFAULT,
  in: true,
  hideProgressBar: false,
  onOpen: null,
  onClose: null,
  className: "",
  bodyClassName: "",
  progressClassName: ""
};
exports.default = Toast;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = __webpack_require__(77);

var _constant = __webpack_require__(94);

var _style = __webpack_require__(110);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackProgress = _glamor.css.keyframes('track-progress', {
  "0%": { width: "100%" },
  "100%": { width: 0 }
});

var progress = function progress(type) {
  return (0, _glamor.css)(_extends({
    position: "absolute",
    bottom: 0,
    left: 0,
    width: 0,
    height: "5px",
    zIndex: 999,
    opacity: 0.7,
    animation: trackProgress + ' linear 1',
    backgroundColor: "rgba(255,255,255,.7)"
  }, type === "default" ? { background: _style2.default.colorProgressDefault } : {}));
};

function ProgressBar(_ref) {
  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className;

  var style = {
    animationDuration: delay + 'ms',
    animationPlayState: isRunning ? 'running' : 'paused'
  };
  style.WebkitAnimationPlayState = style.animationPlayState;

  if (hide) {
    style.opacity = 0;
  }

  return _react2.default.createElement('div', _extends({}, progress(type), {
    className: className,
    style: style,
    onAnimationEnd: closeToast
  }));
}

ProgressBar.propTypes = {
  /**
   * The animation delay which determine when to close the toast
   */
  delay: _propTypes2.default.number.isRequired,

  /**
   * Whether or not the animation is running or paused
   */
  isRunning: _propTypes2.default.bool.isRequired,

  /**
   * Func to close the current toast
   */
  closeToast: _propTypes2.default.func.isRequired,

  /**
   * Optional type : info, success ...
   */
  type: _propTypes2.default.string,

  /**
   * Hide or not the progress bar
   */
  hide: _propTypes2.default.bool,

  /**
   * Optionnal className
   */
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

ProgressBar.defaultProps = {
  type: _constant.TYPE.DEFAULT,
  hide: false,
  className: ''
};

exports.default = ProgressBar;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/require-default-props: 0 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rule = function rule(isDefault) {
  return (0, _glamor.css)({
    padding: 0,
    color: isDefault ? "#000" : "#fff",
    fontWeight: "bold",
    fontSize: "14px",
    background: "transparent",
    outline: "none",
    border: "none",
    cursor: "pointer",
    opacity: isDefault ? "0.3" : "0.7",
    transition: ".3s ease",
    alignSelf: "flex-start",
    ":hover, :focus": {
      opacity: 1
    }
  });
};

function DefaultCloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type;

  return _react2.default.createElement(
    'button',
    _extends({}, rule(type === "default"), {
      type: 'button',
      onClick: closeToast
    }),
    '\u2716'
  );
}

DefaultCloseButton.propTypes = {
  closeToast: _propTypes2.default.func
};

exports.default = DefaultCloseButton;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(397);

var _Transition2 = _interopRequireDefault(_Transition);

var _glamor = __webpack_require__(77);

var _animation2 = __webpack_require__(399);

var _animation3 = _interopRequireDefault(_animation2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var animate = {
  animationDuration: "0.75s",
  animationFillMode: "both"
};

var animation = function animation(pos) {
  var _getAnimation = (0, _animation3.default)(pos),
      enter = _getAnimation.enter,
      exit = _getAnimation.exit;

  var enterAnimation = _glamor.css.keyframes('enter', _extends({
    "from, 60%, 75%, 90%, to": {
      animationTimingFunction: "cubic-bezier(0.215, 0.610, 0.355, 1.000)"
    }
  }, enter));
  var exitAnimation = _glamor.css.keyframes('exit', exit);

  return {
    enter: (0, _glamor.css)(_extends({}, animate, { animationName: enterAnimation })),
    exit: (0, _glamor.css)(_extends({}, animate, { animationName: exitAnimation }))
  };
};

function DefaultTransition(_ref) {
  var children = _ref.children,
      position = _ref.position,
      props = _objectWithoutProperties(_ref, ["children", "position"]);

  var _animation = animation(position),
      enter = _animation.enter,
      exit = _animation.exit;

  return _react2.default.createElement(
    _Transition2.default,
    _extends({}, props, {
      timeout: 750,
      onEnter: function onEnter(node) {
        node.classList.add(enter);
      },
      onExit: function onExit(node) {
        node.classList.remove(enter);
        node.classList.add(exit);
      }
    }),
    children
  );
}

exports.default = DefaultTransition;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(40));

var _reactLifecyclesCompat = __webpack_require__(67);

var _PropTypes = __webpack_require__(398);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(12));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAnimation;

var _constant = __webpack_require__(94);

function getAnimation(pos) {
  switch (pos) {
    case _constant.POSITION.TOP_RIGHT:
    case _constant.POSITION.BOTTOM_RIGHT:
    default:
      return {
        enter: {
          from: {
            opacity: 0,
            transform: "translate3d(3000px, 0, 0)"
          },
          "60%": {
            opacity: 1,
            transform: "translate3d(-25px, 0, 0)"
          },
          "75%": {
            transform: "translate3d(10px, 0, 0)"
          },
          "90%": {
            transform: "translate3d(-5px, 0, 0)"
          },
          to: {
            transform: "none"
          }
        },
        exit: {
          "20%": {
            opacity: 1,
            transform: "translate3d(-20px, 0, 0)"
          },
          to: {
            opacity: 0,
            transform: "translate3d(2000px, 0, 0)"
          }
        }
      };
    case _constant.POSITION.TOP_LEFT:
    case _constant.POSITION.BOTTOM_LEFT:
      return {
        enter: {
          "0%": {
            opacity: 0,
            transform: "translate3d(-3000px, 0, 0)"
          },
          "60%": {
            opacity: 1,
            transform: "translate3d(25px, 0, 0)"
          },
          "75%": {
            transform: "translate3d(-10px, 0, 0)"
          },
          "90%": {
            transform: "translate3d(5px, 0, 0)"
          },
          to: {
            transform: "none"
          }
        },
        exit: {
          "20%": {
            opacity: 1,
            transform: "translate3d(20px, 0, 0)"
          },
          to: {
            opacity: 0,
            transform: "translate3d(-2000px, 0, 0)"
          }
        }
      };
    case _constant.POSITION.BOTTOM_CENTER:
      return {
        enter: {
          from: {
            opacity: 0,
            transform: "translate3d(0, 3000px, 0)"
          },
          "60%": {
            opacity: 1,
            transform: "translate3d(0, -20px, 0)"
          },
          "75%": {
            transform: "translate3d(0, 10px, 0)"
          },
          "90%": {
            transform: "translate3d(0, -5px, 0)"
          },
          to: {
            transform: "translate3d(0, 0, 0)"
          }
        },
        exit: {
          "20%": {
            transform: "translate3d(0, 10px, 0)"
          },
          "40%, 45%": {
            opacity: 1,
            transform: "translate3d(0, -20px, 0)"
          },
          to: {
            opacity: 0,
            transform: "translate3d(0, 2000px, 0)"
          }
        }
      };
    case _constant.POSITION.TOP_CENTER:
      return {
        enter: {
          "0%": {
            opacity: 0,
            transform: "translate3d(0, -3000px, 0)"
          },
          "60%": {
            opacity: 1,
            transform: "translate3d(0, 25px, 0)"
          },
          "75%": {
            transform: "translate3d(0, -10px, 0)"
          },
          "90%": {
            transform: "translate3d(0, 5px, 0)"
          },
          to: {
            transform: "none"
          }
        },
        exit: {
          "20%": {
            transform: "translate3d(0, -10px, 0)"
          },
          "40%, 45%": {
            opacity: 1,
            transform: "translate3d(0, 20px, 0)"
          },
          to: {
            opacity: 0,
            transform: "translate3d(0, -2000px, 0)"
          }
        }
      };
  }
}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                  * TODO: Add validation here :
                                                                                                                                                                                                                                                                  *   - Validate type
                                                                                                                                                                                                                                                                  *   - Maybe autoClose
                                                                                                                                                                                                                                                                  *   - Maybe closeButton as well
                                                                                                                                                                                                                                                                  * */


var _EventManager = __webpack_require__(218);

var _EventManager2 = _interopRequireDefault(_EventManager);

var _constant = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  type: _constant.TYPE.DEFAULT,
  autoClose: null,
  closeButton: null,
  hideProgressBar: null,
  position: null,
  pauseOnHover: null,
  closeOnClick: null,
  className: null,
  bodyClassName: null,
  progressClassName: null,
  transition: null
};

var container = null;
var queue = [];
var toastId = 0;

/**
 * Merge provided options with the defaults settings and generate the toastId
 * @param {*} options
 */
function mergeOptions(options) {
  return _extends({}, defaultOptions, options, { toastId: ++toastId });
}

/**
 * Dispatch toast. If the container is not mounted, the toast is enqueued
 * @param {*} content
 * @param {*} options
 */
function emitEvent(content, options) {
  if (container !== null) {
    _EventManager2.default.emit(_constant.ACTION.SHOW, content, options);
  } else {
    queue.push({ action: _constant.ACTION.SHOW, content: content, options: options });
  }

  return options.toastId;
}

var toaster = _extends(function (content, options) {
  return emitEvent(content, mergeOptions(options));
}, {
  success: function success(content, options) {
    return emitEvent(content, _extends(mergeOptions(options), { type: _constant.TYPE.SUCCESS }));
  },
  info: function info(content, options) {
    return emitEvent(content, _extends(mergeOptions(options), { type: _constant.TYPE.INFO }));
  },
  warn: function warn(content, options) {
    return emitEvent(content, _extends(mergeOptions(options), { type: _constant.TYPE.WARNING }));
  },
  warning: function warning(content, options) {
    return emitEvent(content, _extends(mergeOptions(options), { type: _constant.TYPE.WARNING }));
  },
  error: function error(content, options) {
    return emitEvent(content, _extends(mergeOptions(options), { type: _constant.TYPE.ERROR }));
  },
  dismiss: function dismiss() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return container && _EventManager2.default.emit(_constant.ACTION.CLEAR, id);
  },
  isActive: function isActive() {
    return false;
  }
}, {
  POSITION: _constant.POSITION,
  TYPE: _constant.TYPE
});

/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */
_EventManager2.default.on(_constant.ACTION.MOUNTED, function (containerInstance) {
  container = containerInstance;

  toaster.isActive = function (id) {
    return container.isToastActive(id);
  };

  queue.forEach(function (item) {
    _EventManager2.default.emit(item.action, item.content, item.options);
  });
  queue = [];
});

exports.default = toaster;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(402);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(66);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utils = __webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = function () {
  function Cookies(cookies, hooks) {
    _classCallCheck(this, Cookies);

    this.changeListeners = [];

    this.cookies = parseCookies(cookies);
    this.hooks = hooks;
    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
  }

  _createClass(Cookies, [{
    key: '_updateBrowserValues',
    value: function _updateBrowserValues() {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }

      this.cookies = _cookie2.default.parse(document.cookie);
    }
  }, {
    key: 'get',
    value: function get(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._updateBrowserValues();
      return readCookie(this.cookies[name], options);
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._updateBrowserValues();
      var result = {};

      for (var name in this.cookies) {
        result[name] = readCookie(this.cookies[name], options);
      }

      return result;
    }
  }, {
    key: 'set',
    value: function set(name, value, options) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = JSON.stringify(value);
      }

      if (this.hooks && this.hooks.onSet) {
        this.hooks.onSet(name, value, options);
      }

      this.cookies[name] = value;

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, value, options);
      }

      this._emitChange({ name: name, value: value, options: options });
    }
  }, {
    key: 'remove',
    value: function remove(name, options) {
      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: 0
      });

      if (this.hooks && this.hooks.onRemove) {
        this.hooks.onRemove(name, finalOptions);
      }

      delete this.cookies[name];

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
      }

      this._emitChange({ name: name, value: undefined, options: options });
    }
  }, {
    key: '_emitChange',
    value: function _emitChange(params) {
      for (var i = 0; i < this.changeListeners.length; ++i) {
        this.changeListeners[i](params);
      }
    }
  }, {
    key: 'addChangeListener',
    value: function addChangeListener(callback) {
      this.changeListeners.push(callback);
    }
  }, {
    key: 'removeChangeListener',
    value: function removeChangeListener(callback) {
      var idx = this.changeListeners.indexOf(callback);
      if (idx >= 0) {
        this.changeListeners.splice(idx, 1);
      }
    }
  }]);

  return Cookies;
}();

exports.default = Cookies;


function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return _cookie2.default.parse(cookies);
  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isParsingCookie(value, options.doNotParse)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // At least we tried
    }
  }

  return value;
}
module.exports = exports['default'];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.hasDocumentCookie = hasDocumentCookie;
exports.cleanCookies = cleanCookies;
// Can we get/set cookies on document.cookie?

function hasDocumentCookie() {
  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}

//backwards compatibility
var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();

function cleanCookies() {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : spanish
// author : Hernan Garcia : https://github.com/hgarcia

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'es', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                (b === 7 || b === 0) ? 'mo' :
		(b === 8) ? 'vo' :
		(b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$'
        }
    });
}));


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Layout__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_SignIn__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Authorization__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_App__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Parametros__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Usuarios__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Parametros1__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_Error404__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Error401__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_CreacionSolicitudServicio__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_CreacionSolicitudServicioOT__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_CreacionSolicitudBI__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_Solicitudes__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_SolicitudServicio__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_Plantillas__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_Garantias__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_SolicitudServicioOT__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_SolicitudBI__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__containers_CreacionContratoAnual__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_ContratoAnual__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_ExternosAprobaciones__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__containers_CreacionTiquetesAereo__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__containers_TiquetesAereos__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__containers_Grupos__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__containers_Otrosi__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__containers_BusquedaDocumentos__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_BusquedaDocumento_Documento__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__containers_Reportes__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__containers_ExternosCotizaciones__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__containers_CreacionSolicitudHoteles__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__containers_SolicitudHoteles__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__containers_CambiarContrasena__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__containers_Maestra__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__containers_Delegados__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__containers_AdminDB__ = __webpack_require__(711);
var prefix=window.FOLDER;/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/signin',component:__WEBPACK_IMPORTED_MODULE_3__containers_SignIn__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_Layout__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__containers_App__["a" /* default */],false)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/servicios',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__containers_CreacionSolicitudServicio__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/servicios-oficina-tecnica',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__containers_CreacionSolicitudServicioOT__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/contratos-anuales',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_20__containers_CreacionContratoAnual__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/bienes-investigacion',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__containers_CreacionSolicitudBI__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/contratos-anuales/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_21__containers_ContratoAnual__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/solicitudes/servicios/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__containers_SolicitudServicio__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/solicitudes/servicios-oficina-tecnica/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18__containers_SolicitudServicioOT__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/solicitudes/bienes-investigacion/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_19__containers_SolicitudBI__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/solicitudes/abiertas',component:__WEBPACK_IMPORTED_MODULE_14__containers_Solicitudes__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/admin/parametros',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__containers_Parametros__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/usuarios',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__containers_Usuarios__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/parametros',component:__WEBPACK_IMPORTED_MODULE_8__containers_Parametros1__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/grupos',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_25__containers_Grupos__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/plantillas',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__containers_Plantillas__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/garantias',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_17__containers_Garantias__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/externos/aprobaciones',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_22__containers_ExternosAprobaciones__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/tiquetes-aereos',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_23__containers_CreacionTiquetesAereo__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/tiquetes-aereos/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_24__containers_TiquetesAereos__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/otrosi/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_26__containers_Otrosi__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/documentos/busqueda',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_27__containers_BusquedaDocumentos__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/documentos/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_28__components_BusquedaDocumento_Documento__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/reportes/',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_29__containers_Reportes__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/externos/cotizaciones',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_30__containers_ExternosCotizaciones__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/hoteles',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_31__containers_CreacionSolicitudHoteles__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/solicitudes/hoteles/:id',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_32__containers_SolicitudHoteles__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/cambiar-contrasena',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_33__containers_CambiarContrasena__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/maestras',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_34__containers_Maestra__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/delegados',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_35__containers_Delegados__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{exact:true,path:prefix+'/database-client',component:Object(__WEBPACK_IMPORTED_MODULE_4__containers_Authorization__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_36__containers_AdminDB__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:prefix+'/unauthorized',component:__WEBPACK_IMPORTED_MODULE_10__containers_Error401__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_9__containers_Error404__["a" /* default */]})))));

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_auth__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_MsgBox__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ModuleButton__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_logo_icesi_png__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_logo_icesi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_logo_icesi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_User_Profile_jpg__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_User_Profile_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_User_Profile_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_simple_sidebar_css__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_simple_sidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__css_simple_sidebar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_immutable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var version=__webpack_require__(577).version;var Layout=function(_Component){_inherits(Layout,_Component);function Layout(props){_classCallCheck(this,Layout);var _this=_possibleConstructorReturn(this,(Layout.__proto__||Object.getPrototypeOf(Layout)).call(this,props));_this.handleDocumentClick=function(e){var dd1=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.dd1);if(!dd1.contains(e.target)){_this.setState({showSignOut:false});}};_this.state={showSignOut:false,showSideBar:true};return _this;}_createClass(Layout,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.isAuthenticated){var params=new URLSearchParams(this.props.location.search);if(params.has("token")){var token=params.get('token').slice(0,-8);var expire_date=params.get('token').slice(-8);this.props.signInWithToken(token,expire_date,this.props.location);}else{this.props.signOut();}}else{if(!this.props.user){this.props.getUserConfig();}}}},{key:'componentDidMount',value:function componentDidMount(){window.root.addEventListener('click',this.handleDocumentClick);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.root.removeEventListener('click',this.handleDocumentClick);}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!nextProps.isAuthenticated){this.props.signOut();}}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.clearMessage();}},{key:'render',value:function render(){var _this2=this;var user=this.props.user;if(!user)return null;if(this.props.message){var message=this.props.message;switch(message.get('type')){case'danger':__WEBPACK_IMPORTED_MODULE_3_react_toastify__["toast"].error(message.get('message'),{bodyClassName:'toastify-content toastify-danger'});break;case'warning':__WEBPACK_IMPORTED_MODULE_3_react_toastify__["toast"].warn(message.get('message'),{bodyClassName:'toastify-content toastify-warning'});break;case'success':__WEBPACK_IMPORTED_MODULE_3_react_toastify__["toast"].success(message.get('message'),{bodyClassName:'toastify-content toastify-success'});break;default:__WEBPACK_IMPORTED_MODULE_3_react_toastify__["toast"].info(message.get('message'),{bodyClassName:'toastify-content toastify-info'});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar navbar-default navbar-fixed-top',style:{backgroundColor:'#F7F9FA',borderBottom:'1px solid #d2d6de'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{background:'#F7F9FA'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'navbar-brand',style:{width:'181px',background:'#f7f9fa',padding:'5px 25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__img_logo_icesi_png___default.a,height:'40',alt:'logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-link hide-menu',onClick:function onClick(){return _this2.setState({showSideBar:!_this2.state.showSideBar});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-bars'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wrapper',className:''+(this.state.showSideBar?'':'toggled')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'sidebar-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center',style:{background:'#fff',paddingTop:'25px',paddingBottom:'40px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'profile-user-img img-responsive img-circle',src:__WEBPACK_IMPORTED_MODULE_9__img_User_Profile_jpg___default.a,alt:'profile'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{style:{textTransform:'uppercase',fontWeight:'bold'}},user.get('username'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'usertype'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown'},user.get('es_superusuario')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'text-center dropdown-toggle',onClick:function onClick(e){e.preventDefault();_this2.setState({showSignOut:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'S\xFAper administrador ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-caret-down'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'text-center dropdown-toggle',onClick:function onClick(e){e.preventDefault();_this2.setState({showSignOut:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,' Usuario ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-caret-down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'dropdown-menu animated flipInX',ref:function ref(dd1){return _this2.dd1=dd1;},style:{width:'172px',margin:'0 5px',display:this.state.showSignOut?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){e.preventDefault();_this2.props.signOut();}},'Cerrar sesi\xF3n')),!user.get('ldap')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_10__utils_history__["a" /* default */].push(window.FOLDER+'/cambiar-contrasena');}},'Cambiar contrase\xF1a'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'sidebar-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ModuleButton__["a" /* default */],{id:'home',caption:'Inicio',expandible:false,options:Object(__WEBPACK_IMPORTED_MODULE_12_immutable__["List"])(),url:'/'}),user.get('modulos').filter(function(x){return x.get('en_menu');}).sortBy(function(x){return x.get('orden');}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ModuleButton__["a" /* default */],{key:x.get('id'),id:x.get('id'),caption:x.get('nombre'),expandible:x.get('padre_id')===null&&(x.get('url')===null||x.get('url')===''),options:x.get('modulos').filter(function(a){return a.get('en_menu');}).sortBy(function(a){return a.get('orden');}),url:x.get('url')});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'page-content-wrapper'},this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center',style:{width:'100%',position:'absolute',bottom:'0px',fontSize:'0.9em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#c8c8c8'}},'Desarrollado por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.mawesi.net',target:'_blank',rel:'noopener noreferrer',style:{color:'#b5b5b5'}},'MAWESI S.A.S.'),' | \xA9 2018 Mawesi \xA0 | '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'5px',color:'#c8c8c8',fontWeight:'bold'}},'v'+version)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_MsgBox__["a" /* default */],null));}}]);return Layout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{message:state.common.get('message'),isAuthenticated:state.auth.get('isAuthenticated'),user:state.common.get('user')};}function mapDispatchToProps(dispatch){return{signOut:function signOut(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_auth__["e" /* signOut */])());},clearMessage:function clearMessage(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["c" /* clearMessage */])());},getUserConfig:function getUserConfig(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["m" /* getUserConfig */])());},signInWithToken:function signInWithToken(t,ed,url){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_auth__["d" /* signInWithToken */])(t,ed,url));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Layout));

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var bind = __webpack_require__(219);
var Axios = __webpack_require__(409);
var defaults = __webpack_require__(146);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(223);
axios.CancelToken = __webpack_require__(423);
axios.isCancel = __webpack_require__(222);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(424);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(146);
var utils = __webpack_require__(41);
var InterceptorManager = __webpack_require__(418);
var dispatchRequest = __webpack_require__(419);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(221);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var transformData = __webpack_require__(420);
var isCancel = __webpack_require__(222);
var defaults = __webpack_require__(146);
var isAbsoluteURL = __webpack_require__(421);
var combineURLs = __webpack_require__(422);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(223);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Immutable = __webpack_require__(16);

var isMap = function(obj){ return Immutable.Iterable.isKeyed(obj); };
var isIndexed = function(obj) { return Immutable.Iterable.isIndexed(obj); };

var op = function(operation, path, value){
  if(operation === 'remove') { return { op: operation, path: path }; }

  return { op: operation, path: path, value: value };
};

module.exports = {
  isMap: isMap,
  isIndexed: isIndexed,
  op: op
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Immutable = __webpack_require__(16);

/**
 * Returns a two-dimensional array (an array of arrays) with dimensions n by m.
 * All the elements of this new matrix are initially equal to x
 * @param n number of rows
 * @param m number of columns
 * @param x initial element for every item in matrix
 */
var makeMatrix = function(n, m, x){
  var matrix = [];
  for(var i = 0; i < n; i++) {
    matrix[i] = new Array(m);

    if(x != null){
      for(var j = 0; j < m; j++){
        matrix[i][j] = x;
      }
    }
  }

  return matrix;
};

/**
 * Computes Longest Common Subsequence between two Immutable.JS Indexed Iterables
 * Based on Dynamic Programming http://rosettacode.org/wiki/Longest_common_subsequence#Java
 * @param xs ImmutableJS Indexed Sequence 1
 * @param ys ImmutableJS Indexed Sequence 2
 */
var lcs = function(xs, ys){
  var matrix = computeLcsMatrix(xs, ys);

  return backtrackLcs(xs, ys, matrix);
};

var DiffResult = Immutable.Record({op: '=', val: null});
var ReplaceResult = Immutable.Record({op: '!=', val: null, newVal: null});

/**
 * Returns the resulting diff operations of LCS between two sequences
 * @param xs Indexed Sequence 1
 * @param ys Indexed Sequence 2
 * @returns Array of DiffResult {op:'=' | '+' | '-', val:any}
 */
var diff = function(xs, ys){
  var matrix = computeLcsMatrix(xs, ys);

  return printDiff(matrix, xs, ys, xs.size||0, ys.size||0);
};

var printDiff = function(matrix, xs, ys, xSize, ySize) {
  var diffArray = [];
  var i = xSize - 1;
  var j = ySize - 1;
  while (i >= 0 || j >= 0) {
    if (i >= 0 && j >= 0 && Immutable.is(xs.get(i), ys.get(j))) {
      diffArray.push(new DiffResult({
        op: '=',
        val: xs.get(i)
      }));
      i -= 1;
      j -= 1;
    }
    else if (i >= 0 && j >= 0 && i === j && !Immutable.is(xs.get(i), ys.get(j))) {
      diffArray.push(new ReplaceResult({
      val: xs.get(i),
      newVal: ys.get(i)
      }));
      i -= 1;
      j -= 1;
    }
    else {
      if (j >= 0 && (i === -1 || matrix[i+1][j] >= matrix[i][j+1])) {
        diffArray.push(new DiffResult({
          op: '+',
          val: ys.get(j)
        }));
        j -= 1;
      }
      else if (i >= 0 && (j === -1 || matrix[i+1][j] < matrix[i][j+1])){
        diffArray.push(new DiffResult({
          op: '-',
          val: xs.get(i)
        }));
        i -= 1;
      }
    }
  }
  return diffArray.reverse();
};

/**
 * Computes the Longest Common Subsequence table
 * @param xs Indexed Sequence 1
 * @param ys Indexed Sequence 2
 */
function computeLcsMatrix(xs, ys) {
  var n = xs.size||0;
  var m = ys.size||0;
  var a = makeMatrix(n + 1, m + 1, 0);

  for (var i = 0; i < n; i++) {
    for (var j = 0; j < m; j++) {
      if (Immutable.is(xs.get(i), ys.get(j))) {
        a[i + 1][j + 1] = a[i][j] + 1;
      }
      else {
        a[i + 1][j + 1] = Math.max(a[i + 1][j], a[i][j + 1]);
      }
    }
  }

  return a;
}

/**
 * Extracts a LCS from matrix M
 * @param xs Indexed Sequence 1
 * @param ys Indexed Sequence 2
 * @param matrix LCS Matrix
 * @returns {Array.<T>} Longest Common Subsequence
 */
var backtrackLcs = function(xs, ys, matrix){
  var lcs = [];
  for(var i = xs.size, j = ys.size; i !== 0 && j !== 0;){
    if (matrix[i][j] === matrix[i-1][j]){ i--; }
    else if (matrix[i][j] === matrix[i][j-1]){ j--; }
    else{
      if(Immutable.is(xs.get(i-1), ys.get(j-1))){
        lcs.push(xs.get(i-1));
        i--;
        j--;
      }
    }
  }
  return lcs.reverse();
};

module.exports = {
  lcs: lcs,
  computeLcsMatrix: computeLcsMatrix,
  diff: diff
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slashRe = new RegExp('/', 'g');
var escapedSlashRe = new RegExp('~1', 'g');
var tildeRe = /~/g;
var escapedTildeRe = /~0/g;

var Path = {
  escape: function (str) {
    if(typeof(str) === 'number'){
      return str.toString();
    }
    if(typeof(str) !== 'string'){
      throw 'param str (' + str + ') is not a string';
    }

    return str.replace(tildeRe, '~0').replace(slashRe, '~1');
  },

  unescape: function (str) {
    if(typeof(str) == 'string') {
      return str.replace(escapedSlashRe, '/').replace(escapedTildeRe, '~');
    }
    else {
      return str;
    }
  },
  concat: function(path, key){
    return path + '/' + key;
  }
};

module.exports = Path;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slashRe = new RegExp('/', 'g');
var escapedSlashRe = new RegExp('~1', 'g');
var tildeRe = /~/g;
var escapedTildeRe = /~0/g;

var Path = {
  escape: function (str) {
    if(typeof(str) !== 'string'){
      throw 'param str (' + str + ') is not a string';
    }

    return str.replace(tildeRe, '~0').replace(slashRe, '~1');
  },

  unescape: function (str) {
    if(typeof(str) == 'string') {
      return str.replace(escapedSlashRe, '/').replace(escapedTildeRe, '~');
    }
    else {
      return str;
    }
  }
};

module.exports = Path;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(modules){var installedModules={};function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{enumerable:!0,get:getter})},__webpack_require__.r=function(exports){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(exports,"__esModule",{value:!0})},__webpack_require__.t=function(value,mode){if(1&mode&&(value=__webpack_require__(value)),8&mode)return value;if(4&mode&&"object"==typeof value&&value&&value.__esModule)return value;var ns=Object.create(null);if(__webpack_require__.r(ns),Object.defineProperty(ns,"default",{enumerable:!0,value:value}),2&mode&&"string"!=typeof value)for(var key in value)__webpack_require__.d(ns,key,function(key){return value[key]}.bind(null,key));return ns},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=2)}([function(module,exports){module.exports=__webpack_require__(148)},function(module,exports){module.exports=__webpack_require__(430)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);var typeof_arguments__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(1),typeof_arguments__WEBPACK_IMPORTED_MODULE_0___default=__webpack_require__.n(typeof_arguments__WEBPACK_IMPORTED_MODULE_0__),of_type__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(0),of_type__WEBPACK_IMPORTED_MODULE_1___default=__webpack_require__.n(of_type__WEBPACK_IMPORTED_MODULE_1__);function _toConsumableArray(arr){return function(arr){if(Array.isArray(arr)){for(var i=0,arr2=new Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}}(arr)||function(iter){if(Symbol.iterator in Object(iter)||"[object Arguments]"===Object.prototype.toString.call(iter))return Array.from(iter)}(arr)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function _typeof(obj){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj})(obj)}function _possibleConstructorReturn(self,call){return!call||"object"!==_typeof(call)&&"function"!=typeof call?function(self){if(void 0===self)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return self}(self):call}function _getPrototypeOf(o){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(o){return o.__proto__||Object.getPrototypeOf(o)})(o)}function _inherits(subClass,superClass){if("function"!=typeof superClass&&null!==superClass)throw new TypeError("Super expression must either be null or a function");subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:!0,configurable:!0}}),superClass&&_setPrototypeOf(subClass,superClass)}function _setPrototypeOf(o,p){return(_setPrototypeOf=Object.setPrototypeOf||function(o,p){return o.__proto__=p,o})(o,p)}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}function _createClass(Constructor,protoProps,staticProps){return protoProps&&_defineProperties(Constructor.prototype,protoProps),staticProps&&_defineProperties(Constructor,staticProps),Constructor}var Utils=function(){function Utils(l){_classCallCheck(this,Utils),Object.defineProperty(this,"_listLength",{value:l})}return _createClass(Utils,[{key:"_add",value:function(i,arr){var args=of_type__WEBPACK_IMPORTED_MODULE_1___default()(arr,"arguments")?Array.prototype.slice.call(arr,0):arr;this[i]=args}},{key:"forEach",value:function(callback){typeof_arguments__WEBPACK_IMPORTED_MODULE_0___default()(arguments,[Function],function(o){throw new TypeError("".concat("move-on",": forEach: ").concat(o.message))});for(var _arr=Object.keys(this),_i=0;_i<_arr.length;_i++){var argsIndex=_arr[_i];callback(this[argsIndex],Number(argsIndex),this)}}},{key:"forAll",value:function(callback){typeof_arguments__WEBPACK_IMPORTED_MODULE_0___default()(arguments,[Function],function(o){throw new TypeError("".concat("move-on",": forAll: ").concat(o.message))});for(var _arr2=Object.keys(this),_i2=0;_i2<_arr2.length;_i2++){var argsIndex=_arr2[_i2];for(var itemIndex in this[argsIndex])callback(this[argsIndex][itemIndex],Number(argsIndex),Number(itemIndex),this)}}},{key:"missing",get:function(){for(var list=[],i=0;i<this._listLength;i++)of_type__WEBPACK_IMPORTED_MODULE_1___default()(this[i],Array)||list.push(i);return list}}]),Utils}(),Resolved=function(_Utils){function Resolved(l){return _classCallCheck(this,Resolved),_possibleConstructorReturn(this,_getPrototypeOf(Resolved).call(this,l))}return _inherits(Resolved,Utils),Resolved}(),Rejected=function(_Utils2){function Rejected(l){return _classCallCheck(this,Rejected),_possibleConstructorReturn(this,_getPrototypeOf(Rejected).call(this,l))}return _inherits(Rejected,Utils),Rejected}(),Timeout=function(){function Timeout(_ref){var time=_ref.time,callback=_ref.callback;_classCallCheck(this,Timeout),this._time=time,this._callback=callback,this._pending=!1,this._timedOut=!1,this._quietMode=!1,this._mount()}return _createClass(Timeout,[{key:"_mount",value:function(){var _this=this;this._pending=!0,this._timer=setTimeout(function(){_this._pending=!1,_this._timedOut=!0,_this._quietMode||_this._callback(_this._timeoutError)},this._time)}},{key:"unmount",value:function(){this._pending&&(clearTimeout(this._timer),this._pending=!1)}},{key:"quiet",value:function(){this._pending&&(this._quietMode=!0)}},{key:"timedOut",get:function(){return this._timedOut}},{key:"_timeoutError",get:function(){var err=new Error;return err.message="Timeout. The chained function did not respond in the expected time of ".concat(this._time," ms."),err.info="timeout",err.code="ETIMEDOUT",err}}]),Timeout}(),MoveOn=function(){function MoveOn(mode,args){_classCallCheck(this,MoveOn),this._mode=mode,this._init.apply(this,_toConsumableArray(args))}return _createClass(MoveOn,[{key:"_validateArguments",value:function(argumentsObject){var validationTypes=[Array,[Object,null],Function,Function];typeof_arguments__WEBPACK_IMPORTED_MODULE_0___default()(argumentsObject,validationTypes,function(o){throw new TypeError("".concat("move-on",": ").concat(o.message))})}},{key:"_validateFunctionList",value:function(list){var _this2=this;this.list=list;var _loop=function(i){var fun=_this2.list[i];if(!of_type__WEBPACK_IMPORTED_MODULE_1___default()(fun,[Function,Array]))throw _this2.error.incorrectListItem(i);if(of_type__WEBPACK_IMPORTED_MODULE_1___default()(fun,Array)){if(0===fun.length)return"continue";fun.forEach(function(item,index){if(0!==index&&!of_type__WEBPACK_IMPORTED_MODULE_1___default()(item,[String,Function]))throw _this2.error.incorrectMethodItem(i,index);if(0!==index&&of_type__WEBPACK_IMPORTED_MODULE_1___default()(item,String)&&!of_type__WEBPACK_IMPORTED_MODULE_1___default()(fun[0][item],Function))throw _this2.error.incorrectMethodName(item,i,index)})}};for(var i in this.list)_loop(i)}},{key:"_validateConfig",value:function(config){this.config=this.defaults,of_type__WEBPACK_IMPORTED_MODULE_1___default()(config,null)||((config.hasOwnProperty("timeout")&&of_type__WEBPACK_IMPORTED_MODULE_1___default()(config.timeout,null)||of_type__WEBPACK_IMPORTED_MODULE_1___default()(config.timeout,Number)&config.timeout>=0&Math.round(config.timeout)===config.timeout&&!isNaN(config.timeout))&&(this.config.timeout=config.timeout),config.hasOwnProperty("bind")&&of_type__WEBPACK_IMPORTED_MODULE_1___default()(config.bind,Boolean)&&(this.config.bind=config.bind),config.hasOwnProperty("context")&&(this.config.context=config.context),config.hasOwnProperty("passContext")&&of_type__WEBPACK_IMPORTED_MODULE_1___default()(config.passContext,Boolean)&&(this.config.passContext=config.passContext))}},{key:"_init",value:function(list,config,onDone,onCatch){this._validateArguments(arguments),this._validateFunctionList(list),this._validateConfig(config),this.finalCatch=this._bind({caller:onCatch}),this.finalDone=this._bind({caller:onDone,reject:this.finalCatch}),this[this._mode]()}},{key:"_moveOn",value:function(){var _this3=this;this.list.reduceRight(function(chain,next){if(of_type__WEBPACK_IMPORTED_MODULE_1___default()(next,Function)){var config={caller:next,resolve:chain,reject:_this3.finalCatch,timeout:!0};return _this3._bind(config)}var innerContext=next[0];return next.reduceRight(function(innerChain,innerNext,index){return 0===index?innerChain:_this3._bind({caller:[innerContext,innerNext],resolve:innerChain,reject:_this3.finalCatch,timeout:!0})},chain)},this.finalDone)()}},{key:"_moveAll",value:function(){var _this4=this,alreadyResolvedMap=new Map,timeout=this.timeoutDefined?new Timeout(this.timeoutConfig):null,resolveData=new Resolved(this.listLength),alreadyRejected=!1,iterator=0,callback=function(iter,resolve){return function(){!0===alreadyResolvedMap.get(iter)||alreadyRejected||(resolve?(alreadyResolvedMap.set(iter,!0),resolveData._add(iter,arguments),++iterator===this.listLength&&(timeout&&timeout.unmount(),timeout&&timeout.timedOut||this.finalDone(resolveData))):(timeout&&timeout.unmount(),timeout&&timeout.timedOut||this.finalCatch.apply(this,arguments),alreadyRejected=!0))}.bind(_this4)};this._loopChain(function(item,iter,stop){if(_this4._bind({caller:item,resolve:callback(iter,!0),reject:callback(iter,!1)})(),alreadyRejected)return stop()},this.finalDone)}},{key:"_moveEach",value:function(){var _this5=this,alreadyResolvedMap=new Map,timeout=this.timeoutDefined?new Timeout(this.timeoutConfig):null,resolveData=new Resolved(this.listLength),iterator=0,callback=function(iter,resolve){return function(){!0!==alreadyResolvedMap.get(iter)&&(alreadyResolvedMap.set(iter,!0),resolve&&resolveData._add(iter,arguments),resolve||timeout&&timeout.timedOut||this.finalCatch.apply(this,arguments),++iterator===this.listLength&&(timeout&&timeout.unmount(),timeout&&timeout.timedOut||this.finalDone(resolveData)))}.bind(_this5)};this._loopChain(function(item,iter){_this5._bind({caller:item,resolve:callback(iter,!0),reject:callback(iter,!1)})()},this.finalDone)}},{key:"_moveFirst",value:function(){var _this6=this,alreadyRejectedMap=new Map,timeout=this.timeoutDefined?new Timeout(this.timeoutConfig):null,rejectData=new Rejected(this.listLength),alreadyResolved=!1,iterator=0,callback=function(iter,resolve){return function(){!0===alreadyRejectedMap.get(iter)||alreadyResolved||(resolve?(timeout&&timeout.unmount(),timeout&&timeout.timedOut||this.finalDone.apply(this,arguments),alreadyResolved=!0):(alreadyRejectedMap.set(iter,!0),rejectData._add(iter,arguments),++iterator===this.listLength&&(timeout&&timeout.unmount(),timeout&&timeout.timedOut||this.finalCatch(rejectData))))}.bind(_this6)};this._loopChain(function(item,iter,stop){if(_this6._bind({caller:item,resolve:callback(iter,!0),reject:callback(iter,!1)})(),alreadyResolved)return stop()},this.finalDone)}},{key:"_loopChain",value:function(callback,empty){var iter=0,stop=function(){return shouldStop=!0},shouldStop=!1,_iteratorNormalCompletion=!0,_didIteratorError=!1,_iteratorError=void 0;try{for(var _step,_iterator=this.list[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=!0){var item=_step.value;if(of_type__WEBPACK_IMPORTED_MODULE_1___default()(item,Function))callback(item,iter++,stop);else for(var i=1;i<item.length&&(callback([item[0],item[i]],iter++,stop),!shouldStop);i++);if(shouldStop)break}}catch(err){_didIteratorError=!0,_iteratorError=err}finally{try{_iteratorNormalCompletion||null==_iterator.return||_iterator.return()}finally{if(_didIteratorError)throw _iteratorError}}0===iter&&empty()}},{key:"_bind",value:function(){var _ref2=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},caller=_ref2.caller,resolve=_ref2.resolve,reject=_ref2.reject,timeout=_ref2.timeout,context=this.config.passContext?[this.config.context]:[];return function(){var _caller$,_caller$2,timer=this.timeoutDefined&&timeout?new Timeout(this.timeoutConfig):null,defaults=[];this._middleChain(defaults,resolve,"resolve",timer),this._middleChain(defaults,reject,"reject",timer);var args=[].concat(defaults,context);return of_type__WEBPACK_IMPORTED_MODULE_1___default()(caller,Array)?of_type__WEBPACK_IMPORTED_MODULE_1___default()(caller[1],Function)?(_caller$=caller[1]).call.apply(_caller$,[caller[0]].concat(_toConsumableArray(args),Array.prototype.slice.call(arguments))):(_caller$2=caller[0])[caller[1]].apply(_caller$2,_toConsumableArray(args).concat(Array.prototype.slice.call(arguments))):this.config.bind?caller.call.apply(caller,[this.config.context].concat(_toConsumableArray(args),Array.prototype.slice.call(arguments))):caller.apply(void 0,_toConsumableArray(args).concat(Array.prototype.slice.call(arguments)))}.bind(this)}},{key:"_middleChain",value:function(arr,next,name,timer){of_type__WEBPACK_IMPORTED_MODULE_1___default()(next,Function)&&arr.push(Object.defineProperty(function(){timer&&timer.quiet(),timer&&timer.timedOut||next.apply(void 0,arguments)}.bind(this),"name",{value:name}))}},{key:"error",get:function(){return{incorrectListItem:function(i){return new TypeError("".concat("move-on",": Invalid argument [0]. Incorrect [").concat(i,"] item type. The item of [Function|Array] type is expected."))},incorrectObjectItem:function(i){return new TypeError("".concat("move-on",": Invalid argument [0]. Incorrect [").concat(i,"][0] item. The item of [Object] type is expected."))},incorrectMethodItem:function(i,index){return new TypeError("".concat("move-on",": Invalid argument [0]. Incorrect [").concat(i,"][").concat(index,"] item. The [Function|String] item is expected."))},incorrectMethodName:function(name,i,index){return new TypeError("".concat("move-on",": Invalid argument [0]. Incorrect [").concat(i,"][").concat(index,"] item. The given [").concat(i,'][0] object does not define ["').concat(name,'"] method.'))}}}},{key:"defaults",get:function(){return{timeout:1e4,bind:!0,context:{},passContext:!0}}},{key:"listLength",get:function(){for(var iter=0,i=0;i<this.list.length;i++)of_type__WEBPACK_IMPORTED_MODULE_1___default()(this.list[i],Function)?iter++:of_type__WEBPACK_IMPORTED_MODULE_1___default()(this.list[i],Array)&&(iter+=this.list[i].length-1);return iter}},{key:"timeoutConfig",get:function(){return{time:this.config.timeout,callback:this.finalCatch}}},{key:"timeoutDefined",get:function(){return!(null===this.config.timeout||this.config.timeout===1/0)}}]),MoveOn}();var statics={all:{value:function(){new MoveOn("_moveAll",arguments)}},each:{value:function(){new MoveOn("_moveEach",arguments)}},first:{value:function(){new MoveOn("_moveFirst",arguments)}}};__webpack_exports__.default=Object.defineProperties(function(){new MoveOn("_moveOn",arguments)},statics)}]).default;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(modules){var installedModules={};function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{enumerable:!0,get:getter})},__webpack_require__.r=function(exports){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(exports,"__esModule",{value:!0})},__webpack_require__.t=function(value,mode){if(1&mode&&(value=__webpack_require__(value)),8&mode)return value;if(4&mode&&"object"==typeof value&&value&&value.__esModule)return value;var ns=Object.create(null);if(__webpack_require__.r(ns),Object.defineProperty(ns,"default",{enumerable:!0,value:value}),2&mode&&"string"!=typeof value)for(var key in value)__webpack_require__.d(ns,key,function(key){return value[key]}.bind(null,key));return ns},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=1)}([function(module,exports){module.exports=__webpack_require__(148)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__),__webpack_require__.d(__webpack_exports__,"default",function(){return typeofArguments});var of_type__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(0),of_type__WEBPACK_IMPORTED_MODULE_0___default=__webpack_require__.n(of_type__WEBPACK_IMPORTED_MODULE_0__);function _construct(Parent,args,Class){return(_construct=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0}catch(e){return!1}}()?Reflect.construct:function(Parent,args,Class){var a=[null];a.push.apply(a,args);var instance=new(Function.bind.apply(Parent,a));return Class&&_setPrototypeOf(instance,Class.prototype),instance}).apply(null,arguments)}function _setPrototypeOf(o,p){return(_setPrototypeOf=Object.setPrototypeOf||function(o,p){return o.__proto__=p,o})(o,p)}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}var TypeofArguments=function(){function TypeofArguments(getArgumentsObject,getExpectedArray,callbackFunction){if(function(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}(this,TypeofArguments),!of_type__WEBPACK_IMPORTED_MODULE_0___default()(getArgumentsObject,"arguments"))throw new TypeError("typeof-arguments: The [0] argument must be the [arguments] Object.");if(!of_type__WEBPACK_IMPORTED_MODULE_0___default()(getExpectedArray,Array))throw new TypeError("typeof-arguments: The [1] argument must be of type [Array].");for(var index=0;index<getExpectedArray.length;index++)if(!of_type__WEBPACK_IMPORTED_MODULE_0___default()(getArgumentsObject[index],getExpectedArray[index])){var actual=this.getActualType(getArgumentsObject[index]),types=this.getExpectedTypes(getExpectedArray[index]),textActual="[".concat(actual,"] ").concat(types.addons,"argument"),textExpected=types.message,message="Invalid argument [".concat(index,"]. The ").concat(textActual," has been passed, while the ").concat(textExpected," is expected.");if(of_type__WEBPACK_IMPORTED_MODULE_0___default()(callbackFunction,"function"))return callbackFunction({index:index,actual:actual,expected:types.expected,message:message,textActual:textActual,textExpected:textExpected}),function(){return!1};throw new TypeError(message)}return function(){return!0}}var Constructor,protoProps,staticProps;return Constructor=TypeofArguments,(protoProps=[{key:"getActualType",value:function(actualValue){return of_type__WEBPACK_IMPORTED_MODULE_0___default()(actualValue,null)?"null":of_type__WEBPACK_IMPORTED_MODULE_0___default()(actualValue,void 0)?"undefined":of_type__WEBPACK_IMPORTED_MODULE_0___default()(actualValue,"arguments")?"arguments":actualValue.constructor.name}},{key:"getExpectedTypes",value:function(expectedType){for(var types=["whenString","whenRegExp","whenObject","whenArray"],_i=0;_i<types.length;_i++){var check=this[types[_i]](expectedType);if(check)return check}throw new TypeError("typeof-arguments: The expected type is not callable.")}},{key:"whenString",value:function(stringType){if(!of_type__WEBPACK_IMPORTED_MODULE_0___default()(stringType,String))return null;var msg='argument of type matching string expression "'.concat(stringType,'"'),truthness="",objectable="";return stringType.split("|").forEach(function(i){"truthy"===i.toLowerCase()&&(truthness="<<falsy>> "),"falsy"===i.toLowerCase()&&(truthness="<<truthy>> "),"objectable"===i.toLowerCase()&&(objectable="<<non-objectable>> ")}),{message:msg,addons:truthness+objectable,expected:stringType}}},{key:"whenRegExp",value:function(regType){return of_type__WEBPACK_IMPORTED_MODULE_0___default()(regType,RegExp)?{message:"argument of type matching regular expression ".concat(regType),addons:function(regType){var isCaseInsensitive=regType.flags.match(/i/),str=regType.toString();str=isCaseInsensitive?str.toLowerCase():str;var truthness="",objectable="";str.match(/truthy/)&&(truthness="<<falsy>> ");str.match(/falsy/)&&(truthness="<<truthy>> ");str.match(/objectable/)&&(objectable="<<non-objectable>> ");return truthness+objectable}(regType),expected:regType.toString()}:null}},{key:"whenObject",value:function(objectType){return of_type__WEBPACK_IMPORTED_MODULE_0___default()(objectType,null)?{message:"argument of type [null]",addons:"",expected:"null"}:of_type__WEBPACK_IMPORTED_MODULE_0___default()(objectType,void 0)?{message:"argument of type [undefined]",addons:"",expected:"undefined"}:of_type__WEBPACK_IMPORTED_MODULE_0___default()(objectType,Function)?{message:"argument of type [".concat(objectType.name,"]"),addons:"",expected:objectType.name}:null}},{key:"whenArray",value:function(arrayTypes){if(!of_type__WEBPACK_IMPORTED_MODULE_0___default()(arrayTypes,Array))return null;var types={},_iteratorNormalCompletion=!0,_didIteratorError=!1,_iteratorError=void 0;try{for(var _step,_iterator=arrayTypes[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=!0){var _type=_step.value,exp=this.whenObject(_type);if(of_type__WEBPACK_IMPORTED_MODULE_0___default()(exp,null))return null;types[exp.expected]=exp.expected}}catch(err){_didIteratorError=!0,_iteratorError=err}finally{try{_iteratorNormalCompletion||null==_iterator.return||_iterator.return()}finally{if(_didIteratorError)throw _iteratorError}}var expected=Object.getOwnPropertyNames(types).join("|");return{message:"argument of type [".concat(expected,"]"),addons:"",expected:expected}}}])&&_defineProperties(Constructor.prototype,protoProps),staticProps&&_defineProperties(Constructor,staticProps),TypeofArguments}();function typeofArguments(){return _construct(TypeofArguments,Array.prototype.slice.call(arguments))()}}]).default;

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({username:'',password:'',processing:false,isAuthenticated:false});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_179" /* INICIAR_SESION */]:state=state.set('isAuthenticated',true);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_41" /* CERRAR_SESION */]:state=state.set('isAuthenticated',false);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_209" /* MODIFICAR_INPUTS_SIGNIN_PAGE */]:state=state.set(action.payload.attr,action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_332" /* PROCESAMIENTO_SIGNIN_PAGE */]:state=state.set('processing',action.payload);if(!action.payload){state=state.set('password','');}return state;default:return state;}});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({user:null,message:null,msgBox:{show:false,message:null},expanded:null,modalSelector:{show:false,title:'',url:'',fields:[],data:[],action:null,filter:'',pages:[],showRecords:100,customFilters:[]},modalSelectorAirport:{show:false,title:'',url:'',fields:[],data:[],action:null,filter:'',pages:[],showRecords:100,customFilters:[],isLoading:false},parametros:{},modalDelete:{show:false,action:null,message:null},modalConfirmarAccion:{show:false,action:null,message:null,hasChildren:false},modalAddFile:{show:false,title:'',data:null,btnDisabled:false,index:null},modalAddChat:{show:false,title:'',data:null,btnDisabled:false,index:null},modalAddFactura:{show:false,data:null,unchanged:null,url:null,type:null,saldo:0,btnDisabled:false},modalLastFactura:{show:false,action:null},modalAddVerificacionSOMA:{show:false,data:null,unchanged:null,url:null,type:null},modalCreateOtrosi:{show:false,message:''},enums:{},searchingAirports:false});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var data=void 0,index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_29" /* ASIGNAR_USUARIO_SESION */]:state=state.set('user',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.usuario));data=__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["m" /* enums */];data.documentos.tipos=action.payload.documentos.reduce(function(a,b){a[b.CODIGO]=b;return a;},{});Object.keys(data.solicitudes.tipos).forEach(function(tipo){var solicitud=action.payload.solicitudes.filter(function(solicitud){return solicitud.TIPO_SOLICITUD==tipo;})[0];if(solicitud){data.solicitudes.tipos[tipo].responsable=solicitud['USUARIO'];}});state=state.set('enums',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(data));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_229" /* MOSTRAR_MENSAJE */]:state=state.set('message',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_180" /* LIMPIAR_MENSAJES */]:state=state.set('message',null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_277" /* MOSTRAR_MODAL_ERROR */]:state=state.setIn(['msgBox','show'],action.payload.show);state=state.setIn(['msgBox','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_170" /* EXPANDIR_CONTRAER_MODULO */]:state=state.set('expanded',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_284" /* MOSTRAR_MODAL_SELECTOR */]:state=state.setIn(['modalSelector','show'],true);state=state.setIn(['modalSelector','title'],action.payload.title);state=state.setIn(['modalSelector','url'],action.payload.url);state=state.setIn(['modalSelector','fields'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.fields));state=state.setIn(['modalSelector','action'],action.payload.action);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_320" /* OCULTAR_MODAL_SELECTOR */]:state=state.set('modalSelector',INITIAL_STATE.get('modalSelector'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_187" /* MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR */]:state=state.setIn(['modalSelector','filter'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_225" /* MODIFICAR_PAGINA_MODAL_SELECTOR */]:state=state.setIn(['modalSelector','pages'],state.getIn(['modalSelector','pages']).concat(action.payload.page));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_334" /* REINICIAR_LISTA_MODAL_SELECTOR */]:state=state.setIn(['modalSelector','pages'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS([]));state=state.setIn(['modalSelector','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS([]));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["a" /* ACTUALIZAR_LISTADO_SELECTOR */]:state=state.setIn(['modalSelector','data'],state.getIn(['modalSelector','data']).concat(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.list)));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_285" /* MOSTRAR_MODAL_SELECTOR_AIRPORT */]:state=state.setIn(['modalSelectorAirport','show'],true);state=state.setIn(['modalSelectorAirport','title'],action.payload.title);state=state.setIn(['modalSelectorAirport','url'],action.payload.url);state=state.setIn(['modalSelectorAirport','fields'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.fields));state=state.setIn(['modalSelectorAirport','action'],action.payload.action);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_321" /* OCULTAR_MODAL_SELECTOR_AIRPORT */]:state=state.set('modalSelectorAirport',INITIAL_STATE.get('modalSelectorAirport'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_188" /* MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR_AIRPORT */]:state=state.setIn(['modalSelectorAirport','filter'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_226" /* MODIFICAR_PAGINA_MODAL_SELECTOR_AIRPORT */]:state=state.setIn(['modalSelectorAirport','pages'],state.getIn(['modalSelectorAirport','pages']).concat(action.payload.page));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_335" /* REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT */]:state=state.setIn(['modalSelectorAirport','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS([]));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["b" /* ACTUALIZAR_LISTADO_SELECTOR_AIRPORT */]:state=state.setIn(['modalSelectorAirport','data'],state.getIn(['modalSelectorAirport','data']).concat(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.list)));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* ACTUALIZAR_STORE_PARAMETROS */]:state=state.setIn(['parametros',action.payload.param],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_287" /* MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_181" /* MODAL_CONFIRMAR_ACCION */]:state=state.setIn(['modalConfirmarAccion','show'],action.payload.open);state=state.setIn(['modalConfirmarAccion','action'],action.payload.action);state=state.setIn(['modalConfirmarAccion','message'],action.payload.message);state=state.setIn(['modalConfirmarAccion','hasChildren'],action.payload.hasChildren);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["D" /* ADICIONAR_FILTRO_MODAL_SELECTOR */]:state=state.updateIn(['modalSelector','customFilters'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_241" /* MOSTRAR_MODAL_AGREGAR_ARCHIVO */]:state=state.setIn(['modalAddFile','title'],action.payload.title);state=state.setIn(['modalAddFile','show'],action.payload.show);state=state.setIn(['modalAddFile','index'],action.payload.index);data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["d" /* adjunto */])());if(action.payload.mode==='edit')data=action.payload.file;state=state.setIn(['modalAddFile','data'],data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]:state=state.set('modalAddFile',INITIAL_STATE.get('modalAddFile'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_195" /* MODIFICAR_INPUTS_COMMON_REDUCER */]:if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_238" /* MOSTRAR_MODAL_ADICIONA_FACTURA */]:if(action.payload.show){state=state.setIn(['modalAddFactura','show'],true);state=state.setIn(['modalAddFactura','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["p" /* factura */])(action.payload.documento.get('id'))));state=state.setIn(['modalAddFactura','data','documento'],action.payload.documento);state=state.setIn(['modalAddFactura','unchanged'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["p" /* factura */])(null)));state=state.setIn(['modalAddFactura','url'],action.payload.url);state=state.setIn(['modalAddFactura','type'],action.payload.type);state=state.setIn(['modalAddFactura','saldo'],action.payload.saldo);state=state.setIn(['modalAddFactura','btnDisabled'],false);}else{state=state.set('modalAddFactura',INITIAL_STATE.get('modalAddFactura'));state=state.setIn(['modalAddFactura','btnDisabled'],false);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_286" /* MOSTRAR_MODAL_ULTIMA_FACTURA */]:state=state.setIn(['modalLastFactura','show'],action.payload.show);state=state.setIn(['modalLastFactura','action'],action.payload.action);state=state.setIn(['modalAddFactura','btnDisabled'],true);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_240" /* MOSTRAR_MODAL_ADICION_VERIFICACION_SST */]:if(action.payload.show){state=state.setIn(['modalAddVerificacionSOMA','show'],true);state=state.setIn(['modalAddVerificacionSOMA','data'],action.payload.verificacion);state=state.setIn(['modalAddVerificacionSOMA','unchanged'],action.payload.verificacion);state=state.setIn(['modalAddVerificacionSOMA','url'],action.payload.url);state=state.setIn(['modalAddVerificacionSOMA','type'],action.payload.type);}else{state=state.set('modalAddVerificacionSOMA',INITIAL_STATE.get('modalAddVerificacionSOMA'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_268" /* MOSTRAR_MODAL_CREATE_OTROSI */]:state=state.setIn(['modalCreateOtrosi','show'],action.payload.show);state=state.setIn(['modalCreateOtrosi','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_360" /* SEARCHING_AIRPORTS */]:console.log('SEARCHING_AIRPORTS',action.payload);state=state.setIn(['modalSelectorAirport','isLoading'],action.payload);return state;default:return state;}});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Parametros__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({parametros:[],orderBy:{field:null,asc:false},modalCreate:{title:'',mode:'',show:false,data:null,btnDisabled:false},modalDelete:{show:false,action:null,message:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var id=void 0;var data=void 0;var index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_288" /* OBTENER_ADMIN_PARAMETROS */]:state=state.set('parametros',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_44" /* CONMUTAR_SELECCION_ADMIN_PARAMETRO */]:state=state.setIn(['parametros',action.payload.index,'selected'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_61" /* CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS */]:state.get('parametros').forEach(function(x,n){if(action.payload){if(x.get('visible')){state=state.setIn(['parametros',n,'selected'],action.payload);}}else{state=state.setIn(['parametros',n,'selected'],action.payload);}});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_171" /* FILTRAR_ADMIN_PARAMETROS */]:var term=action.payload.toLowerCase();var pattern=new RegExp(term.replace(/\*/g,'.*'));var searchCols=__WEBPACK_IMPORTED_MODULE_2__containers_Parametros__["c" /* tableCols */];if(term){data=state.get('parametros').map(function(x){var compare=false;searchCols.forEach(function(c){var value=Object(__WEBPACK_IMPORTED_MODULE_2__containers_Parametros__["b" /* findValues */])(c,x).toString();compare=compare||pattern.test(value.toLowerCase());});x=x.set('visible',compare);return x;});state=state.set('parametros',data);data=null;}else{state=state.set('parametros',state.get('parametros').map(function(x){x=x.set('visible',true);return x;}));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_322" /* ORDENAR_ADMIN_PARAMETROS */]:state=state.set('orderBy',action.payload.orderBy);var c=state.getIn(['orderBy','field']);if(c){data=state.get('parametros').sort(function(a,b){var va=Object(__WEBPACK_IMPORTED_MODULE_2__containers_Parametros__["b" /* findValues */])({Value:c},a).toString();var vb=Object(__WEBPACK_IMPORTED_MODULE_2__containers_Parametros__["b" /* findValues */])({Value:c},b).toString();va=va||'';vb=vb||'';return va>vb?1:va===vb?0:-1;});if(!state.getIn(['orderBy','asc']))data=data.reverse();state=state.set('parametros',data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_255" /* MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO */]:state=state.setIn(['modalCreate','show'],action.payload.show);state=state.setIn(['modalCreate','title'],action.payload.title);state=state.setIn(['modalCreate','mode'],action.payload.mode);if(action.payload.mode==='create'){state=state.setIn(['modalCreate','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["I" /* parametro */])()));}else if(action.payload.mode==='edit'){index=state.get('parametros').findIndex(function(x){return x.get('id')===action.payload.id;});state=state.setIn(['modalCreate','data'],state.getIn(['parametros',index]));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_203" /* MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_75" /* CREAR_ACTUALIZAR_ADMIN_PARAMETRO */]:id=action.payload.id;index=state.get('parametros').findIndex(function(x){return x.get('id')===id;});if(index!==-1){state=state.setIn(['parametros',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));}else{state=state.set('parametros',state.get('parametros').push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload)));}state=state.setIn(['modalCreate','show'],false);state=state.setIn(['modalCreate','title'],'');state=state.setIn(['modalCreate','mode'],'');state=state.setIn(['modalCreate','data'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_99" /* DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS */]:state=state.setIn(['modalCreate','btnDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_248" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_121" /* ELIMINAR_ADMIN_PARAMETRO */]:index=state.get('parametros').findIndex(function(x){return x.get('id')===action.payload;});state=state.deleteIn(['parametros',index]);state=state.setIn(['modalDelete','show'],false);state=state.setIn(['modalDelete','action'],null);state=state.setIn(['modalDelete','message'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["O" /* ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO */]:var newItem=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["J" /* parametroConfig */])());newItem=newItem.set('posicion',state.getIn(['modalCreate','data','parametro_cols']).count()+1);state=state.updateIn(['modalCreate','data','parametro_cols'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(newItem));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_140" /* ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO */]:state=state.setIn(['modalCreate','data','parametro_cols'],state.getIn(['modalCreate','data','parametro_cols']).filter(function(x){return!x.get('selected');}).sortBy(function(x){return x.get('posicion');}).map(function(x,n){return x.set('posicion',n+1);}));return state;default:return state;}});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BoxSearch=function(_Component){_inherits(BoxSearch,_Component);function BoxSearch(){_classCallCheck(this,BoxSearch);return _possibleConstructorReturn(this,(BoxSearch.__proto__||Object.getPrototypeOf(BoxSearch)).apply(this,arguments));}_createClass(BoxSearch,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"searchbar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"form-control input-sm",type:"search",placeholder:"\uF002 Busqueda por nombre",onChange:function onChange(e){return _this2.props.onChange(e.target.value);}})));}}]);return BoxSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BoxSearch);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowRecords=function(_Component){_inherits(ShowRecords,_Component);function ShowRecords(){_classCallCheck(this,ShowRecords);return _possibleConstructorReturn(this,(ShowRecords.__proto__||Object.getPrototypeOf(ShowRecords)).apply(this,arguments));}_createClass(ShowRecords,[{key:'render',value:function render(){var _props=this.props,showRecords=_props.showRecords,totalRecords=_props.totalRecords,changeRecordsToShow=_props.changeRecordsToShow;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Mostrar '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'input-control input-sm',style:{display:'inline-block'},value:showRecords,onChange:function onChange(e){return changeRecordsToShow(e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:50},'50'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:100},'100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:200},'200')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' de ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,totalRecords),' registros'));}}]);return ShowRecords;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ShowRecords);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_parametros__ = __webpack_require__(149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreate=function(_Component){_inherits(ModalCreate,_Component);function ModalCreate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreate.__proto__||Object.getPrototypeOf(ModalCreate)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreate');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreate .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreate(false,'','');},300);},_this.handleAddNewConf=function(e){e.preventDefault();_this.props.addParametroConfig();},_this.handleRemoveConf=function(e){e.preventDefault();var id=_this.props.modalCreate.getIn(['data','id']);_this.props.removeParametrosConfig(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreate,[{key:'render',value:function render(){var _this2=this;var modalCreate=this.props.modalCreate;if(!modalCreate.get('show')){return null;}var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'plus-circle',onClick:function onClick(e){return _this2.handleAddNewConf(e);},title:'Nueva'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'trash',onClick:function onClick(e){return _this2.handleRemoveConf(e);},title:'Eliminar',disabled:modalCreate.getIn(['data','parametro_cols']).filter(function(x){return x.get('selected');}).count()===0,danger:true})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalCreate',show:true,ZIndex:2000,width:700},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateParametros(modalCreate.get('data'),modalCreate.get('mode'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:modalCreate.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreate.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','nombre']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.nombre',e.target.value);},style:{textTransform:'uppercase'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.descripcion',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Categor\xEDa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','categoria']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.categoria',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_Box__["a" /* default */],{title:'Configuraci\xF3n',actions:boxActions,onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{maxHeight:'135px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalCreate.getIn(['data','parametro_cols']).sortBy(function(x){return x.get('posicion');}).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('guid')+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},value:x.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.parametro_cols.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,x.get('posicion'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',placeholder:'Nombre',value:x.get('nombre'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.parametro_cols.'+n+'.nombre',e.target.value);},style:{textTransform:'uppercase'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',placeholder:'Descripcion',value:x.get('descripcion'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.parametro_cols.'+n+'.descripcion',e.target.value);}})));}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalCreate:state.parametros.get('modalCreate')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreate:function displayModalCreate(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_parametros__["d" /* displayModalCreate */])(show,title,mode));},updateInputs:function updateInputs(attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_parametros__["l" /* updateInputs */])(attr,value));},createOrUpdateParametros:function createOrUpdateParametros(data,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_parametros__["b" /* createOrUpdateParametros */])(data,mode));},addParametroConfig:function addParametroConfig(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_parametros__["a" /* addParametroConfig */])());},removeParametrosConfig:function removeParametrosConfig(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_parametros__["g" /* removeParametrosConfig */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreate));

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(40), __webpack_require__(0)) :
	typeof define === 'function' && define.amd ? define(['react-dom', 'react'], factory) :
	(global.ReactDraggable = factory(global.ReactDOM,global.React));
}(this, (function (ReactDOM,React) { 'use strict';

	ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
	React = React && React.hasOwnProperty('default') ? React['default'] : React;

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */

	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};

	var emptyFunction_1 = emptyFunction;

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var validateFormat = function validateFormat(format) {};

	{
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}

	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}

	var invariant_1 = invariant;

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var warning = emptyFunction_1;

	{
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };

	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }

	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }

	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }

	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}

	var warning_1 = warning;

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	var ReactPropTypesSecret_1 = ReactPropTypesSecret;

	{
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}

	var checkPropTypes_1 = checkPropTypes;

	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if ("development" !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
	      return emptyFunction_1.thatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
	      return emptyFunction_1.thatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }

	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};

	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	{
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;

	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	}
	});

	var classnames = createCommonjsModule(function (module) {
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if ('object' !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (false) {
			// register as 'classnames', consistent with npm package name
			undefined('classnames', [], function () {
				return classNames;
			});
		} else {
			window.classNames = classNames;
		}
	}());
	});

	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}

	function isFunction(func /*: any*/) /*: boolean*/ {
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}

	function isNum(num /*: any*/) /*: boolean*/ {
	  return typeof num === 'number' && !isNaN(num);
	}

	function int(a /*: string*/) /*: number*/ {
	  return parseInt(a, 10);
	}

	function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
	  if (props[propName]) {
	    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
	  }
	}

	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	function getPrefix() /*: string*/ {
	  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

	  // Checking specifically for 'window.document' is for pseudo-browser server-side
	  // environments that define 'window' as the global context.
	  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
	  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

	  var style = window.document.documentElement.style;

	  if (prop in style) return '';

	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }

	  return '';
	}

	function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
	  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
	}

	function kebabToTitleCase(str /*: string*/) /*: string*/ {
	  var out = '';
	  var shouldCapitalize = true;
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	  return out;
	}

	// Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	var browserPrefix = getPrefix();

	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	};

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};

	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};

	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;

	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);

	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }

	    return _arr;
	  }

	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

	/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/


	var matchesSelectorFunc = '';
	function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = findInArray(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return isFunction(el[method]);
	    });
	  }

	  // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	  if (!isFunction(el[matchesSelectorFunc])) return false;

	  // $FlowIgnore: Doesn't think elements are indexable
	  return el[matchesSelectorFunc](selector);
	}

	// Works up the tree to the draggable itself attempting to match selector.
	function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
	  var node = el;
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);

	  return false;
	}

	function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else if (el.addEventListener) {
	    el.addEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}

	function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else if (el.removeEventListener) {
	    el.removeEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}

	function outerHeight(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += int(computedStyle.borderTopWidth);
	  height += int(computedStyle.borderBottomWidth);
	  return height;
	}

	function outerWidth(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += int(computedStyle.borderLeftWidth);
	  width += int(computedStyle.borderRightWidth);
	  return width;
	}
	function innerHeight(node /*: HTMLElement*/) /*: number*/ {
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= int(computedStyle.paddingTop);
	  height -= int(computedStyle.paddingBottom);
	  return height;
	}

	function innerWidth(node /*: HTMLElement*/) /*: number*/ {
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= int(computedStyle.paddingLeft);
	  width -= int(computedStyle.paddingRight);
	  return width;
	}

	// Get from offsetParent
	function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();

	  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
	  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

	  return { x: x, y: y };
	}

	function createCSSTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: Object*/ {
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return defineProperty({}, browserPrefixToKey('transform', browserPrefix), translation);
	}

	function createSVGTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: string*/ {
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	function getTranslation(_ref2, positionOffset /*: PositionOffsetControlPosition*/, unitSuffix /*: string*/) /*: string*/ {
	  var x = _ref2.x,
	      y = _ref2.y;

	  var translation = 'translate(' + x + unitSuffix + ',' + y + unitSuffix + ')';
	  if (positionOffset) {
	    var defaultX = '' + (typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = '' + (typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = 'translate(' + defaultX + ', ' + defaultY + ')' + translation;
	  }
	  return translation;
	}

	function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
	  return e.targetTouches && findInArray(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && findInArray(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}

	function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	}

	// User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.

	// Note we're passing `document` b/c we could be iframed
	function addUserSelectStyles(doc /*: ?Document*/) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}

	function removeUserSelectStyles(doc /*: ?Document*/) {
	  try {
	    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
	    // $FlowIgnore: IE
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      window.getSelection().removeAllRanges(); // remove selection caused by scroll
	    }
	  } catch (e) {
	    // probably IE
	  }
	}

	function styleHacks() /*: Object*/ {
	  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	  // Workaround IE pointer events; see #51
	  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
	  return _extends({
	    touchAction: 'none'
	  }, childStyle);
	}

	function addClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
	      el.className += ' ' + className;
	    }
	  }
	}

	function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
	  }
	}

	/*:: import type Draggable from '../Draggable';*/
	/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
	/*:: import type DraggableCore from '../DraggableCore';*/


	function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y];

	  // Clone new bounds
	  var bounds = draggable.props.bounds;

	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);

	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;

	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode = void 0;
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
	    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	    bounds = {
	      left: -node.offsetLeft + int(boundNodeStyle.paddingLeft) + int(nodeStyle.marginLeft),
	      top: -node.offsetTop + int(boundNodeStyle.paddingTop) + int(nodeStyle.marginTop),
	      right: innerWidth(boundNode) - outerWidth(node) - node.offsetLeft + int(boundNodeStyle.paddingRight) - int(nodeStyle.marginRight),
	      bottom: innerHeight(boundNode) - outerHeight(node) - node.offsetTop + int(boundNodeStyle.paddingBottom) - int(nodeStyle.marginBottom)
	    };
	  }

	  // Keep x and y below right and bottom limits...
	  if (isNum(bounds.right)) x = Math.min(x, bounds.right);
	  if (isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);

	  // But above left and top limits.
	  if (isNum(bounds.left)) x = Math.max(x, bounds.left);
	  if (isNum(bounds.top)) y = Math.max(y, bounds.top);

	  return [x, y];
	}

	function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}

	function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}

	function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	}

	// Get {x, y} positions from event.
	function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
	  var touchObj = typeof touchIdentifier === 'number' ? getTouch(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	  var node = findDOMNode(draggableCore);
	  // User can provide an offsetParent if desired.
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return offsetXYFromParent(touchObj || e, offsetParent);
	}

	// Create an data object exposed by <DraggableCore>'s events
	function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
	  var state = draggable.state;
	  var isStart = !isNum(state.lastX);
	  var node = findDOMNode(draggable);

	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0, deltaY: 0,
	      lastX: x, lastY: y,
	      x: x, y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX, deltaY: y - state.lastY,
	      lastX: state.lastX, lastY: state.lastY,
	      x: x, y: y
	    };
	  }
	}

	// Create an data exposed by <Draggable>'s events
	function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	}

	// A lot faster than stringify/parse
	function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}

	function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
	  var node = ReactDOM.findDOMNode(draggable);
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  }
	  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	  return node;
	}

	/*eslint no-console:0*/
	function log() {
	}

	/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/


	// Simple abstraction for dragging events names.
	/*:: import type {Element as ReactElement} from 'react';*/
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	};

	// Default to mouse events.
	var dragEventFor = eventsFor.mouse;

	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	/*:: export type DraggableBounds = {
	  left: number,
	  right: number,
	  top: number,
	  bottom: number,
	};*/
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
	/*:: export type ControlPosition = {x: number, y: number};*/
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/


	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//

	/*:: export type DraggableCoreProps = {
	  allowAnyClick: boolean,
	  cancel: string,
	  children: ReactElement<any>,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	};*/

	var DraggableCore = function (_React$Component) {
	  inherits(DraggableCore, _React$Component);

	  function DraggableCore() {
	    var _ref;

	    var _temp, _this, _ret;

	    classCallCheck(this, DraggableCore);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN, lastY: NaN,
	      touchIdentifier: null
	    }, _this.handleDragStart = function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e);

	      // Only accept left-clicks.
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

	      // Get nodes. Be sure to grab relative document (could be iframed)
	      var thisNode = ReactDOM.findDOMNode(_this);
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	      var ownerDocument = thisNode.ownerDocument;

	      // Short circuit if handle or cancel prop was provided and selector doesn't match.

	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !matchesSelectorAndParentsTo(e.target, _this.props.handle, thisNode) || _this.props.cancel && matchesSelectorAndParentsTo(e.target, _this.props.cancel, thisNode)) {
	        return;
	      }

	      // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	      var touchIdentifier = getTouchIdentifier(e);
	      _this.setState({ touchIdentifier: touchIdentifier });

	      // Get the current drag point from the event. This is used as the offset.
	      var position = getControlPosition(e, touchIdentifier, _this);
	      if (position == null) return; // not possible but satisfies flow
	      var x = position.x,
	          y = position.y;

	      // Create an event object with all the data parents need to make a decision here.

	      var coreEvent = createCoreData(_this, x, y);

	      // Call event handler. If it returns explicit false, cancel.
	      log('calling', _this.props.onStart);
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	      if (shouldUpdate === false) return;

	      // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	      if (_this.props.enableUserSelectHack) addUserSelectStyles(ownerDocument);

	      // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	      _this.setState({
	        dragging: true,

	        lastX: x,
	        lastY: y
	      });

	      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	      addEvent(ownerDocument, dragEventFor.move, _this.handleDrag);
	      addEvent(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    }, _this.handleDrag = function (e) {

	      // Prevent scrolling on mobile devices, like ipad/iphone.
	      if (e.type === 'touchmove') e.preventDefault();

	      // Get the current drag point from the event. This is used as the offset.
	      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;

	      // Snap to grid if prop has been provided

	      if (Array.isArray(_this.props.grid)) {
	        var _deltaX = x - _this.state.lastX,
	            _deltaY = y - _this.state.lastY;

	        var _snapToGrid = snapToGrid(_this.props.grid, _deltaX, _deltaY);

	        var _snapToGrid2 = slicedToArray(_snapToGrid, 2);

	        _deltaX = _snapToGrid2[0];
	        _deltaY = _snapToGrid2[1];

	        if (!_deltaX && !_deltaY) return; // skip useless drag
	        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
	      }

	      var coreEvent = createCoreData(_this, x, y);

	      // Call event handler. If it returns explicit false, trigger end.
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	      if (shouldUpdate === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
	          // I see why this insanity was deprecated
	          // $FlowIgnore
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	          _this.handleDragStop(event);
	        }
	        return;
	      }

	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    }, _this.handleDragStop = function (e) {
	      if (!_this.state.dragging) return;

	      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;

	      var coreEvent = createCoreData(_this, x, y);

	      var thisNode = ReactDOM.findDOMNode(_this);
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) removeUserSelectStyles(thisNode.ownerDocument);
	      }

	      // Reset the el.
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });

	      // Call event handler
	      _this.props.onStop(e, coreEvent);

	      if (thisNode) {
	        removeEvent(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        removeEvent(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    }, _this.onMouseDown = function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

	      return _this.handleDragStart(e);
	    }, _this.onMouseUp = function (e) {
	      dragEventFor = eventsFor.mouse;

	      return _this.handleDragStop(e);
	    }, _this.onTouchStart = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;

	      return _this.handleDragStart(e);
	    }, _this.onTouchEnd = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;

	      return _this.handleDragStop(e);
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }

	  createClass(DraggableCore, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	      var thisNode = ReactDOM.findDOMNode(this);
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;

	        removeEvent(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        removeEvent(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        removeEvent(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        removeEvent(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        if (this.props.enableUserSelectHack) removeUserSelectStyles(ownerDocument);
	      }
	    }

	    // Same as onMouseDown (start drag), but now consider this a touch device.

	  }, {
	    key: 'render',
	    value: function render() {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return React.cloneElement(React.Children.only(this.props.children), {
	        style: styleHacks(this.props.children.props.style),

	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onTouchStart: this.onTouchStart,
	        onMouseUp: this.onMouseUp,
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	  return DraggableCore;
	}(React.Component);

	DraggableCore.displayName = 'DraggableCore';
	DraggableCore.propTypes = {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: propTypes.bool,

	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: propTypes.bool,

	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: propTypes.bool,

	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },

	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: propTypes.arrayOf(propTypes.number),

	  /**
	   * `scale` specifies the scale of the area you are dragging inside of. It allows
	   * the drag deltas to scale correctly with how far zoomed in/out you are.
	   */
	  scale: propTypes.number,

	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: propTypes.string,

	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: propTypes.string,

	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: propTypes.func,

	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: propTypes.func,

	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: propTypes.func,

	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: propTypes.func,

	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: dontSetMe,
	  style: dontSetMe,
	  transform: dontSetMe
	};
	DraggableCore.defaultProps = {
	  allowAnyClick: false, // by default only accept left click
	  cancel: null,
	  disabled: false,
	  enableUserSelectHack: true,
	  offsetParent: null,
	  handle: null,
	  grid: null,
	  transform: null,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {}
	};

	/*:: import type {DraggableEventHandler} from './utils/types';*/
	/*:: import type {Element as ReactElement} from 'react';*/
	/*:: type DraggableState = {
	  dragging: boolean,
	  dragged: boolean,
	  x: number, y: number,
	  slackX: number, slackY: number,
	  isElementSVG: boolean
	};*/


	//
	// Define <Draggable>
	//

	/*:: export type DraggableProps = {
	  ...$Exact<DraggableCoreProps>,
	  axis: 'both' | 'x' | 'y' | 'none',
	  bounds: DraggableBounds | string | false,
	  defaultClassName: string,
	  defaultClassNameDragging: string,
	  defaultClassNameDragged: string,
	  defaultPosition: ControlPosition,
	  positionOffset: PositionOffsetControlPosition,
	  position: ControlPosition,
	  scale: number
	};*/

	var Draggable = function (_React$Component) {
	  inherits(Draggable, _React$Component);

	  function Draggable(props /*: DraggableProps*/) {
	    classCallCheck(this, Draggable);

	    var _this = possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

	    _this.onDragStart = function (e, coreData) {

	      // Short-circuit if user's callback killed it.
	      var shouldStart = _this.props.onStart(e, createDraggableData(_this, coreData));
	      // Kills start event on core as well, so move handlers are never bound.
	      if (shouldStart === false) return false;

	      _this.setState({ dragging: true, dragged: true });
	    };

	    _this.onDrag = function (e, coreData) {
	      if (!_this.state.dragging) return false;

	      var uiData = createDraggableData(_this, coreData);

	      var newState /*: $Shape<DraggableState>*/ = {
	        x: uiData.x,
	        y: uiData.y
	      };

	      // Keep within bounds.
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var _x = newState.x,
	            _y = newState.y;

	        // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.

	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY;

	        // Get bound position. This will ceil/floor the x and y within the boundaries.

	        var _getBoundPosition = getBoundPosition(_this, newState.x, newState.y),
	            _getBoundPosition2 = slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];

	        newState.x = newStateX;
	        newState.y = newStateY;

	        // Recalculate slack by noting how much was shaved by the boundPosition handler.
	        newState.slackX = _this.state.slackX + (_x - newState.x);
	        newState.slackY = _this.state.slackY + (_y - newState.y);

	        // Update the event we fire to reflect what really happened after bounds took effect.
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      }

	      // Short-circuit if user's callback killed it.
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	      if (shouldUpdate === false) return false;

	      _this.setState(newState);
	    };

	    _this.onDragStop = function (e, coreData) {
	      if (!_this.state.dragging) return false;

	      // Short-circuit if user's callback killed it.
	      var shouldStop = _this.props.onStop(e, createDraggableData(_this, coreData));
	      if (shouldStop === false) return false;

	      var newState /*: $Shape<DraggableState>*/ = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      };

	      // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	      var controlled = Boolean(_this.props.position);
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            _x2 = _this$props$position.x,
	            _y2 = _this$props$position.y;

	        newState.x = _x2;
	        newState.y = _y2;
	      }

	      _this.setState(newState);
	    };

	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,

	      // Whether or not we have been dragged before.
	      dragged: false,

	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,

	      // Used for compensating for out-of-bounds drags
	      slackX: 0, slackY: 0,

	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };

	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	    return _this;
	  }

	  createClass(Draggable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && ReactDOM.findDOMNode(this) instanceof window.SVGElement) {
	        this.setState({ isElementSVG: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps /*: Object*/) {
	      // Set x/y if position has changed
	      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
	        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
	    }
	  }, {
	    key: 'render',
	    value: function render() /*: ReactElement<any>*/ {
	      var _classNames;

	      var style = {},
	          svgTransform = null;

	      // If this is controlled, we don't want to move it - unless it's dragging.
	      var controlled = Boolean(this.props.position);
	      var draggable = !controlled || this.state.dragging;

	      var position = this.props.position || this.props.defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: canDragX(this) && draggable ? this.state.x : position.x,

	        // Set top if vertical drag is enabled
	        y: canDragY(this) && draggable ? this.state.y : position.y
	      };

	      // If this element was SVG, we use the `transform` attribute.
	      if (this.state.isElementSVG) {
	        svgTransform = createSVGTransform(transformOpts, this.props.positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = createCSSTransform(transformOpts, this.props.positionOffset);
	      }

	      var _props = this.props,
	          defaultClassName = _props.defaultClassName,
	          defaultClassNameDragging = _props.defaultClassNameDragging,
	          defaultClassNameDragged = _props.defaultClassNameDragged;


	      var children = React.Children.only(this.props.children);

	      // Mark with class while dragging
	      var className = classnames(children.props.className || '', defaultClassName, (_classNames = {}, defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));

	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return React.createElement(
	        DraggableCore,
	        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
	        React.cloneElement(children, {
	          className: className,
	          style: _extends({}, children.props.style, style),
	          transform: svgTransform
	        })
	      );
	    }
	  }]);
	  return Draggable;
	}(React.Component);

	Draggable.displayName = 'Draggable';
	Draggable.propTypes = _extends({}, DraggableCore.propTypes, {

	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: propTypes.oneOf(['both', 'x', 'y', 'none']),

	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: propTypes.oneOfType([propTypes.shape({
	    left: propTypes.number,
	    right: propTypes.number,
	    top: propTypes.number,
	    bottom: propTypes.number
	  }), propTypes.string, propTypes.oneOf([false])]),

	  defaultClassName: propTypes.string,
	  defaultClassNameDragging: propTypes.string,
	  defaultClassNameDragged: propTypes.string,

	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: propTypes.shape({
	    x: propTypes.number,
	    y: propTypes.number
	  }),
	  positionOffset: propTypes.shape({
	    x: propTypes.oneOfType([propTypes.number, propTypes.string]),
	    y: propTypes.oneOfType([propTypes.number, propTypes.string])
	  }),

	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: propTypes.shape({
	    x: propTypes.number,
	    y: propTypes.number
	  }),

	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: dontSetMe,
	  style: dontSetMe,
	  transform: dontSetMe
	});
	Draggable.defaultProps = _extends({}, DraggableCore.defaultProps, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: { x: 0, y: 0 },
	  position: null,
	  scale: 1
	});

	// Previous versions of this lib exported <Draggable> as the root export. As to not break
	// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	Draggable.default = Draggable;
	Draggable.DraggableCore = DraggableCore;

	return Draggable;

})));
//# sourceMappingURL=react-draggable.js.map


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(440)('createBrowserHistory');
module.exports = __webpack_require__(441).createBrowserHistory;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(442);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(203)),valueEqual=_interopDefault(__webpack_require__(204));__webpack_require__(205);var invariant=_interopDefault(__webpack_require__(206));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(444)
var ieee754 = __webpack_require__(445)
var isArray = __webpack_require__(446)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 445 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 446 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 447 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_parametros__ = __webpack_require__(149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalDelete:state.parametros.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_parametros__["i" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Usuarios__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var columnas=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(__WEBPACK_IMPORTED_MODULE_2__containers_Usuarios__["b" /* tableCols */]);var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({usuarios:[],page:1,showRecords:100,totalRecords:0,orderBy:{field:null,asc:false},modalCreate:{title:'',mode:'',areas:[],show:false,data:null,unchanged:null,btnDisabled:false},modalDelete:{show:false,action:null,message:null},modalFilter:{show:false,filters:[]}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var id=void 0;var data=void 0;var index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_312" /* OBTENER_USUARIOS */]:state=state.set('usuarios',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_74" /* CONMUTAR_SELECCION_USUARIO */]:state=state.setIn(['usuarios',action.payload.index,'selected'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_73" /* CONMUTAR_SELECCION_TODOS_USUARIOS */]:state.get('usuarios').forEach(function(x,n){if(action.payload){if(x.get('visible')){state=state.setIn(['usuarios',n,'selected'],action.payload);}}else{state=state.setIn(['usuarios',n,'selected'],action.payload);}});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_331" /* ORDENAR_USUARIOS */]:state=state.set('orderBy',action.payload.orderBy);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_266" /* MOSTRAR_MODAL_CREAR_USUARIO */]:state=state.setIn(['modalCreate','show'],action.payload.show);state=state.setIn(['modalCreate','title'],action.payload.title);state=state.setIn(['modalCreate','mode'],action.payload.mode);state=state.setIn(['modalCreate','areas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.areas));if(action.payload.mode==='create'){state=state.setIn(['modalCreate','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["X" /* usuario */])(action.payload.permisos,action.payload.grupos)));state=state.setIn(['modalCreate','unchanged'],state.setIn(['modalCreate','data']));}else if(action.payload.mode==='edit'){state=state.setIn(['modalCreate','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.usuario));state=state.setIn(['modalCreate','unchanged'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.usuario));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_205" /* MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS */]:state=state.setIn(['modalCreate','data',action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_79" /* CREAR_ACTUALIZAR_USUARIO */]:id=action.payload.id;index=state.get('usuarios').findIndex(function(x){return x.get('id')===id;});if(index!==-1){state=state.setIn(['usuarios',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));}else{state=state.set('usuarios',state.get('usuarios').push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload)));}state=state.setIn(['modalCreate','show'],false);state=state.setIn(['modalCreate','title'],'');state=state.setIn(['modalCreate','mode'],'');state=state.setIn(['modalCreate','data'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_107" /* DESHABILITAR_BOTON_MODAL_USUARIOS */]:state=state.setIn(['modalCreate','btnDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_254" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_159" /* ELIMINAR_USUARIO */]:index=state.get('usuarios').findIndex(function(x){return x.get('id')===action.payload;});state=state.deleteIn(['usuarios',index]);state=state.setIn(['modalDelete','show'],false);state=state.setIn(['modalDelete','action'],null);state=state.setIn(['modalDelete','message'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_276" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS */]:state=state.setIn(['modalFilter','show'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["w" /* ADICIONAR_CRITERIO_FILTRADO_USUARIOS */]:var firstCol=columnas.first();state=state.updateIn(['modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('value'),operator:'===',value:'',checked:false,comparison:firstCol.get('type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_149" /* ELIMINAR_CRITERIO_FILTRADO_USUARIOS */]:state=state.setIn(['modalFilter','filters'],state.getIn(['modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_54" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS */]:state=state.setIn(['modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_192" /* MODIFICAR_CRITERIO_FILTRADO_USUARIOS */]:if(action.payload.attr==='column'){state=state.setIn(['modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('value')===action.payload.value;}).get('type'));}state=state.setIn(['modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_28" /* APLICAR_CRITERIOS_FILTRADO_USUARIOS */]:state=state.updateIn(['modalFilter','filters'],function(filter){return filter.map(function(x){x=x.set('apply',true);return x;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_40" /* CAMBIAR_MOSTRAR_REGISTROS_USUARIOS */]:state=state.set('showRecords',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_222" /* MODIFICAR_INPUTS_USUARIOS */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;default:return state;}});

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = Paginator;

// Paginator constructor
//
// `per_page` is the number of results per page, `length` is the number of
// pages to display. They default to `25` and `10` respectively.
function Paginator(per_page, length) {
  // You really should be calling this with `new Paginator`, but WHATEVER.
  if (!(this instanceof Paginator)) {
    return new Paginator(per_page, length);
  }

  // Woo, defaults!
  this.per_page = per_page || 25;
  this.length = length || 10;
}

// Build an object with all the necessary information for outputting pagination
// controls.
//
// (new Paginator(paginator.build(100, 2)
Paginator.prototype.build = function(total_results, current_page) {
  // We want the number of pages, rounded up to the nearest page.
  var total_pages = Math.ceil(total_results / this.per_page);

  // Ensure both total_results and current_page are treated as Numbers
  total_results = parseInt(total_results, 10);
  current_page  = parseInt(current_page, 10) || 1;

  // Obviously we can't be on a negative or 0 page.
  if (current_page < 1) { current_page = 1; }
  // If the user has done something like /page/99999 we want to clamp that back
  // down.
  if (current_page > total_pages) { current_page = total_pages; }

  // This is the first page to be displayed as a numbered link.
  var first_page = Math.max(1, current_page - Math.floor(this.length / 2));

  // And here's the last page to be displayed specifically.
  var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));

  // This is triggered if we're at or near one of the extremes; we won't have
  // enough page links. We need to adjust our bounds accordingly.
  if (last_page - first_page + 1 < this.length) {
    if (current_page < (total_pages / 2)) {
      last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
    } else {
      first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
    }
  }

  // This can be triggered if the user wants an odd number of pages.
  if (last_page - first_page + 1 > this.length) {
    // We want to move towards whatever extreme we're closest to at the time.
    if (current_page > (total_pages / 2)) {
      first_page++;
    } else {
      last_page--;
    }
  }

  // First result on the page. This, along with the field below, can be used to
  // do "showing x to y of z results" style things.
  var first_result = this.per_page * (current_page - 1);
  if (first_result < 0) { first_result = 0; }

  // Last result on the page.
  var last_result = (this.per_page * current_page) - 1;
  if (last_result < 0) { last_result = 0; }
  if (last_result > Math.max(total_results - 1, 0)) { last_result = Math.max(total_results - 1, 0); }

  // GIMME THAT OBJECT
  return {
    total_pages: total_pages,
    pages: Math.min(last_page - first_page + 1, total_pages),
    current_page: current_page,
    first_page: first_page,
    last_page: last_page,
    previous_page: current_page - 1,
    next_page: current_page + 1,
    has_previous_page: current_page > 1,
    has_next_page: current_page < total_pages,
    total_results: total_results,
    results: Math.min(last_result - first_result + 1, total_results),
    first_result: first_result,
    last_result: last_result,
  };
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(12));

var _classnames = _interopRequireDefault(__webpack_require__(228));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Page =
/*#__PURE__*/
function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, _getPrototypeOf(Page).apply(this, arguments));
  }

  _createClass(Page, [{
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props = this.props,
          isDisabled = _this$props.isDisabled,
          pageNumber = _this$props.pageNumber;
      e.preventDefault();

      if (isDisabled) {
        return;
      }

      this.props.onClick(pageNumber);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _this$props2 = this.props,
          pageText = _this$props2.pageText,
          pageNumber = _this$props2.pageNumber,
          activeClass = _this$props2.activeClass,
          itemClass = _this$props2.itemClass,
          linkClass = _this$props2.linkClass,
          activeLinkClass = _this$props2.activeLinkClass,
          disabledClass = _this$props2.disabledClass,
          isActive = _this$props2.isActive,
          isDisabled = _this$props2.isDisabled,
          href = _this$props2.href,
          ariaLabel = _this$props2.ariaLabel;
      var css = (0, _classnames["default"])(itemClass, (_cx = {}, _defineProperty(_cx, activeClass, isActive), _defineProperty(_cx, disabledClass, isDisabled), _cx));
      var linkCss = (0, _classnames["default"])(linkClass, _defineProperty({}, activeLinkClass, isActive));
      return _react["default"].createElement("li", {
        className: css,
        onClick: this.handleClick.bind(this)
      }, _react["default"].createElement("a", {
        className: linkCss,
        href: href,
        "aria-label": ariaLabel
      }, pageText));
    }
  }]);

  return Page;
}(_react.Component);

exports["default"] = Page;

_defineProperty(Page, "propTypes", {
  pageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  pageNumber: _propTypes["default"].number.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  isActive: _propTypes["default"].bool.isRequired,
  isDisabled: _propTypes["default"].bool,
  activeClass: _propTypes["default"].string,
  activeLinkClass: _propTypes["default"].string,
  itemClass: _propTypes["default"].string,
  linkClass: _propTypes["default"].string,
  disabledClass: _propTypes["default"].string,
  href: _propTypes["default"].string
});

_defineProperty(Page, "defaultProps", {
  activeClass: "active",
  disabledClass: "disabled",
  itemClass: undefined,
  linkClass: undefined,
  activeLinkCLass: undefined,
  isActive: false,
  isDisabled: false,
  href: "#"
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GruposPermisos__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_usuarios__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreate=function(_Component){_inherits(ModalCreate,_Component);function ModalCreate(props){_classCallCheck(this,ModalCreate);var _this=_possibleConstructorReturn(this,(ModalCreate.__proto__||Object.getPrototypeOf(ModalCreate)).call(this,props));_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreate');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreate .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreate(false,'','');},300);};_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.handleOpenSelectorReportaA=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_USUARIOS',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);};var tabs=[{id:0,caption:'Grupos y permisos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__GruposPermisos__["a" /* default */],null)}];_this.state={tabs:[].concat(tabs),selected:0};return _this;}_createClass(ModalCreate,[{key:'render',value:function render(){var _this2=this;var modalCreate=this.props.modalCreate;var _state=this.state,tabs=_state.tabs,selected=_state.selected;if(!modalCreate.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalCreate',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateUsuarios(modalCreate.get('data'),modalCreate.get('mode'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:modalCreate.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreate.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'80vw',height:'70vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre de usuario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','username']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('username',e.target.value);},disabled:modalCreate.get('mode')==='edit'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','nombres']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('nombres',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apellido'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','apellidos']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('apellidos',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',className:'form-control input-sm',value:modalCreate.getIn(['data','email']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('email',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreate.getIn(['data','area_id']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('area_id',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione \xE1rea'),modalCreate.get('areas')&&modalCreate.get('areas').map(function(area){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:area.get('id'),key:'area'+area.get('id')},area.get('nombre'));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','extension']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('extension',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'S\xFAper usuario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreate.getIn(['data','es_superusuario']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('es_superusuario',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'NO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'SI')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'LDAP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreate.getIn(['data','ldap']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('ldap',e.target.value);},disabled:modalCreate.get('mode')==='create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'NO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'SI')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreate.getIn(['data','esta_activo']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('esta_activo',e.target.value);},disabled:modalCreate.get('mode')==='create'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'INACTIVO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'ACTIVO'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Reporta a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__["a" /* default */],{value:modalCreate.getIn(['data','reporta_a','fullname'])?modalCreate.getIn(['data','reporta_a','fullname']):'',onClick:function onClick(){return _this2.handleOpenSelectorReportaA('modalCreate.data.reporta_a');},onReset:function onReset(){return _this2.props.updateInputsInModalCreate('reporta_a',null);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs green'},tabs.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalCreate:state.usuarios.get('modalCreate')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreate:function displayModalCreate(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_usuarios__["f" /* displayModalCreate */])(show,title,mode));},updateInputsInModalCreate:function updateInputsInModalCreate(attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_usuarios__["q" /* updateInputsInModalCreate */])(attr,value));},createOrUpdateUsuarios:function createOrUpdateUsuarios(data,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_usuarios__["d" /* createOrUpdateUsuarios */])(data,mode));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["q" /* selectFromSelector */])(type,payload));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreate));

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_usuarios__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GruposPermisos=function(_Component){_inherits(GruposPermisos,_Component);function GruposPermisos(){_classCallCheck(this,GruposPermisos);return _possibleConstructorReturn(this,(GruposPermisos.__proto__||Object.getPrototypeOf(GruposPermisos)).apply(this,arguments));}_createClass(GruposPermisos,[{key:'render',value:function render(){var _this2=this;var usuario=this.props.usuario;if(!usuario)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%',overflowX:'hidden',border:'1px solid #ddd'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Grupos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,usuario.get('grupos').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr24['+a.get('id')+']',className:a.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'tr23['+a.get('id')+']',type:'checkbox',checked:a.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.grupos.'+b+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'htmlFor',htmlFor:'tr23['+a.get('id')+']'},a.get('descripcion'))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%',overflowX:'hidden',border:'1px solid #ddd'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Permisos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,usuario.get('permisos').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr23['+a.get('id')+']',className:a.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'tr23['+a.get('id')+']',type:'checkbox',checked:a.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.permisos.'+b+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'htmlFor',htmlFor:'tr23['+a.get('id')+']'},a.get('descripcion'))));})))))));}}]);return GruposPermisos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{usuario:state.usuarios.getIn(['modalCreate','data'])};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_usuarios__["p" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GruposPermisos));

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWBJREFUeNqEUj1LxEAQnd1MVA4lyIEWx6UIKEGUExGsbC3tLfwJ/hT/g7VlCnubqxXBwg/Q4hQP/LhKL5nZuBsvuGfW5MGyuzM7jzdvVuR5DgYnZ+f99ai7Vt5t9K9unu4HLweI3qWYxI6PDosdy0fhcntxO44CcOBzPA7mfEyuHwf7ntQk4jcnywOxIlfxOCNYaLVgb6cXbkTdhJXq2SIlNMC0xIqhHczDbi8OVzpLSUa0WebRfmigLHqj1EcPZnwf7gbDIrYVRyEinurj6jTBHyI7pqVrFQqEbt6TEmZ9v1NRAJNC1xTYxIQh/MmRUlmFQE3qWOW1nqB2TWk1/3tgJV0waVvkFIEeZbHq4ElyKzAmEXOx6gnEVJuWBzmkRJBRPYGZBDsVaOlpSgVJE2yVaAe/0kx/3azBRO0VsbMFZE3CDSZKweZfYIVg+DZ6v7h9GDVOwZPw/PoxKu/fAgwALbDAXf7DdQkAAAAASUVORK5CYII="

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmhJREFUeNpsUztv01AYPfdhOy/XTZ80VV1VoCqlA2zQqUgwMEErWBALv4GJDfEDmOEHsFTqVCTExAiiSI2QEKJKESVFFBWo04TESRzfy2c7LY/kLtf2d8+555zvM9NaI1ora5svby9OnbUEBxgDlIKiWjXQeLy19/X17sEtcPY2rtHS96/Hu0RvXXLz+cUzM87zShsI29DpHCYt4E6Box4IZzTnbDx7V74GjhOSfwgE0H2638K9h08A3iHGVbjTw7g6YmAyw/BgecHNGGJjvfQhIfmfIFDAXJpjuugi7djIFVI4P0plctgJQ0xnFe5eOO02OwEp2VkhSCnC8WOCdqgwnzFx4/IyppwRVN+XYXsecqZA1pB48ekAnw9/4GZx3L04N/GoTwEjX4cNH5vlPfjtAIYp8cWrQutxrC5Mod3VsXVTMFSqtaE+gl9dhaUxE2tXZiF7nYiiatJ3v5s8R/1yOCNLOuwjkELiTbmC9dJHpIaGASsDkoFQGJQwHWMcHWJYOmUj1OjvQotuytt5nHMLEGkCyx6QU384jwkUAd2sxJbS/QShZtg/8rHzzQOzSaFhxQrA6YgQMQHojCUlgnCAAvKFBoXXaHfArSCZDE0gyWJgFIKmvUFKO4MUNIk2a4+hODtDUVuJ/J732AKS6ZtImdTyAQQB3bZN8l9t75IFh0JMUdVKsohsUPqRgnka0tYgggYpCHkKGTsHI5NOMojB4iTICCepvX53AIEfQta1iUCmoTiBmdEri2RgddKFhuJoqb/af/yw/d3zTNM6UkaOfis62aUgddAbnz+rXuPY+Vnzjt9/CzAAbmLjCrfBiRgAAAAASUVORK5CYII="

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnhJREFUeNp0Uk1PE0EYftruVlvAUkhVEPoBcsEoLRJBY01MPHjCs3cvogcT/4qJJN5NvHhoohcOnPw4YEGIkCh+oLGBKm3Z7nZ3dme2vjOhTcjiJJvZzPvOM8/HG2q325Dr3kLp7Y1ibpIxjs4KhQBZfvV6s7K5Vb0bjeof5ZlcGysP1a51mifODybvzE8mzCbrAoTDIThMoGXZiZ4YSiurf+Z1XeuCqJ7Oj+sK3jQcNAmg8xkGQ71mYejcAB49vpmeuzJccl0+dUj6KIAvfHCPg3N+uAv4vg9BOxcCmfEzuP/genpmeqhEMgude10Jwm+DuUIyUdTlqu2byoMfX/dRermBeExHsTiWNi3+lMpzRwDki8zxCIATmzbevfmClukiP5NFhJgwkjeRTeLShdOoVJqnAgwkgCAZ6+UdLC9twjQZ8pdzioFkZBHY3q6B3l4dJEEEPOCeD4cYVH7Xsf15F+FImC775INAJBJSkVoWo0QY9YqgiR4ZZzRaGBkdwK3bFxGLRZUfB3Rm2x4x9CGtsUxH9QYkKICDFuLxKAozGZwdTqBRs2FbLlXbiPdECMCHadj/AaDXZNFqedCIvnRcS4UpRo7+hC5zUmw8Ope9wUFinvpmZ7NKt2RTmB4hKZo6n8qP4Oq1HBkKlVYAQBrUlziB0XQSif4YmQhksgNIJk9iaLhPaV9b/Um+uJSCdzyDbGZQRSkvjo+n4JNxubGUSsCj+ZCpODYjkGMAND2k7exUsfhkCd+29yguB88Wl7FW/o6tT7/gcXqAgGv7hhx1LWBireHVn79YP6ChQ3njb/eFlfWqGqT3H3ZlGIhGI2i2UO/U/wkwAAmoalcxlNA1AAAAAElFTkSuQmCC"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAk5JREFUeNpsU01vElEUPTPzZqBAQaSFQiJYUmlKYhoTF41L3Tbu/Q/+AvsX3Bp/gPsuWLrqyqQ7TUxMtAvF1tYGoXwNw7wv7zwYgtKX3Lw379575p5z77O01ohW+/DVh8zj7aYKhflGdG9ZsGwLNydffgVfr19YHvsEa+Zu/nxndob5StQK+dyzvZzyw/gKlmMj7IygFM+xvNcanp4/t5dAomXHBy2UUBOO2MAl/B9/cPb6PULuoHx0WM0e3GvpUOxD3wZAJWutZqYUYmqpSg5OMgH3YQObL59W0/ullpryR3HegkKEqiWBSGV4R3vQ7sIhScTZFTpHx3A215B5sluVY/WWMg7+ATB/lcLsKpTonHzD+OMFEuTz8ikkt9Kwt9YJZB38cpBdoQAZJdLvCGByfoPB6Xdk90pYy6Xg3c/DaWwArg09DaG5lCsUFN0pckZAojdC8m4auBqaALuSgez7VB1RtDSUWOQvUaBLFUzJBMJ2DwmPgd1Jwm0WoSgJfjDvrTKxtwAIyEkAOQ5hU//Zdg5uowDlUNMnwZLW0sSuUuACYhwQRwFvJxupCjEYUUccOkoaKmdOlZnY1TkgAcXAhxhOwLsDsHoN3u4O5JTDfVCH6I9nfjId3gIgSUATFJk/hVevGtOMwS0XwQ3AzB/FrlKg8Q27I2javVoZrFgwD4qVipAEyMlnaFArzaj/D0DiMXlJAFQyK2r8fnMMRZp4lQ1MaSL5tU/1kqAkMCh2tYI+7+kh70cjPbr4bEZ51jZr8TJnB9PJXpz3V4ABAPOQVJn2Q60GAAAAAElFTkSuQmCC"

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAohJREFUeNpkU9tqE1EUXZmZpE3aTBLbJFPTtFURtSCthr7UCyKKFJ/9An3og6Ag/oXfoUj7og9asCBYKT6UIPHaWtpq7NU2aZK5z5wZ9xxMpMwZDuewz9prr32ZiO/7CNaDx3OLt6fOjBqGg/aKRCIInp8+KzfKH7fudnVF58nE16el+/yU2mBFSWZKpWJKVc0OgUBo02K4NDmU6o75Mx+Wdu9IUXFeiOA/pn1xHeYaugVDdzpbp91qGlAKGTx8dC19/Wpxhjnsxj/RRwk85hGJC9d1O6fneWAuoztDYSSLe9OT6SuXB2ccx73Z9uukwDwfls1g0xZIY/Ad/Gnyt/XVfbyYrSDRE8PExHB6/8B6QuaxIwRBFMt0iIAiMx+LCys8jfGJEUik2WpZOD2SQf9oDtVqQwopCAiY66FS/om3b75CVS2MlU7AJ2WiJBCZjZ2dJuRkDJZFwFAR7UCBja3fNfxY2YEoCtRCj9em3Tpds6FpJseGCBxS0GgYGBzqw62p84gnYnAI2CSbSbPhEpFAaE2zODaUAlWWwDoS5DheGqbWpVE/0CmqCY9qkEyINBceb2uADRNQ8bSWAVVzIFKomCQim+0luS4yKYlsHlRyZo7EsSEC23K5vAsXh/H92zZkuRvxeBS5nEx2yp2KqhxPoV5TYS/8CtdApylM9sZQKKSQzyeRTseRV2QoAzIYY8jme5DN9fI0dQoUIjANGydP9VM7PZw9p/AiBpNYrdbw/t0yTJqRtdU9UrfJCUMpSJIgbWzsYe51BcViHzLHeqCRqhZ1YX1tFwNfZBxS9O3NWkAcHqR606k/n/3coKAoV/Y7vQ/OYCZevlrmv3c0GsFh06u3/f4KMABvSWfDHmbK2gAAAABJRU5ErkJggg=="

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAm1JREFUeNpsU8tu00AUPXZcN0nzTpq2KQ3pAwkIAnWHqCoeexBb+AQ+ABZ8A2s+AIkdm266QUJIFWKBkHg1KpRHi5omJGkbJ3bGHj+4M1EQrTvSyGPPueeec++1EgQBxHp+/9mbyuriRZdxjJaiKBD3W+u1+p9a856max+gDO8ebT+WT20Ezi9NZi/crqadvn2MQBAGfpCOpqNru2937vxPIpY6Onjccx3Twck9MBiSU0ncfHirXFmZX3Md9wqCUwiEVN/zaQfHt0vfbBe5uQyuPVgpl5Zn11ybL4/i/lkICOw5niQRGQShoiqI6Bo43W2ub8n3hRtLZT7gTynk6gkCX9gAOxpAnxhHZDwC1/aI1EViJolu/QhKRMHZ1UX0Gr1USIEn5FPWHy+/wTokkrQOq2vBaHZBN4hmY9Jwfr4An/teiEB45ZZDwDiMhoExT0N+sYDCuUkkplLIlXP4/XEXdo+RUhdhBSSfUwtVTUG8MIHK9QVqI7D/uY6vr2pwmCPrkz+Tk9gwARWQ9WxppbXZhNnpw+ya4A5HZi6L4lIR8WyCcL6sTZiAWjWgAmpxkn5+kqTamK6WkCwmERmLDLvjB0ML9ikWXPLFuozYOap3L8HYN6DHdbS/d5CeTVBndBz87FCBLYkNTyIjBQemnIEsSY5lYrK1+UoWcToLMjEHAyIQ2BCBSx/NVh+ZUhrqmEqBebS3WyhdLg0zt/ugAaIklsSGLHCLa6zDMGhZ2HjyGsnpFPqNHnY2fmHv3R5SMymYbROszSQ2ROAY9qHiofvlxSc5xsKKqqnY3diRE9h4X5d/pzg7lnM4ivsrwADe9Wg/CQJgFAAAAABJRU5ErkJggg=="

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmZJREFUeNp0U+1rUlEY/13v9YV0vq2wttI5CdpL9aEGBZUDv0df668I6n+or0UQ/RuuD0EgVDAZrsKF4AR1a6COKW5qXvXec27PuVeda3bgcF6e8/ye5/d7niMZhgExnK9fbTrm5pbBGMZDkgCyq+VyhTUaT6Eo2ZHJePPWXJXRhez3B1yxmM/QdctXUSCgtV4Py4CvY3cky4e1x5DlLCaGbbzjXDcousG5OQe5HPRSCQPK4PpsEM/XH4WvhS4noeu3JwHGGRiULhsMoKZS4I0GtEIB9mgULJGA0+9DPBpBT7sffvf1W/Lg6OgJufw8C0CRGEXWazUwiiyFQjA8bsjVKjaJzovMD/Q5gxyJhG2cvyeXe2cAuADQNGBmBvLaGuTFRaDfh31lBTWi9pumjbK0B4JQul3vOQpM8JdskOLrdCvDcDjAsjtg5TIkoiKLaokMNR2cnZbqNAMycqG7XbHKR2fMzwO/dsxSwu0BiBJsNsv2LwAJAJCI5ux2gXYbqNetcz5PoORI1cDS0n8AxGW7A+zvEYBKZ2ZlcsEtJLbedMjePBaCTQMghx45ulyWkzxMVUQ2RMQhLfFO16YAqCrixPnm6iqKrRb2W23EfF4cUNSrHg90cr7hDyB33MTnSmUKALVs4uIlROjxg+AsPhGVl3fuIl2tIOB0Ya91gkOi9mxhAal0ekork1ic/kGLBORMxy2K1qS9V1ZQbNThIj2EGh+2tsyOnSai8r1UxMNIBB+LRTTULr4Uds0K1tU/uOLxIrmbNz8XXSrnASSpubG9fbKRyVh1n/zSw29t9oC1b47MfwUYAAUsLiWr4QUJAAAAAElFTkSuQmCC"

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAcxJREFUeNqEUk1rE0EYfmZnkgoJCaGNCehuJTalhJZSUZB66a0HwXsP/Qn+FM+9+hty0LNYCr2I7UVLIW0Fc0hpQpSS7O7MrO9MspuvVV8YMnk/nn2e5x0WRRFMvP/w6WSz5jbi/9NxfP693Wp3DrJCnMW5d28P7a+IE15lufR8o1ZEStwPhkWHsWbrZ+eNEPxsuubEF6m0TBv2Q4liPofXuzveulttSqW2UwH+GjqC0horpSL2njU89+FyMwjlTlxOJMTa9ZQHzDQIjgwdom9zLzfXPc75kbnOAswBJTlC2XrqQRMLxhi442DgB4UFBhgPpm3B5pgBHNUUxQKAHs8pHf3TEuFMetM9IKr/i2mWMwC0SnuSFTG2YKyppwKYVdGO7TFhzBqGIenVeLCUtfURgErucx5ECKREKBU4d3B718PHz6cICGT/1Qs8qpQtGOdyhtGEARWDQFqQJSeDL98u4VbLaKw9IRAJPwjtoJGlVAoDQ800+fRFTTYXcjlcXN2g++s36p5Lzzlve1iEROa8BGH1EbrSAeqrjxEqicHQt8/YSDHMpaNs7wJAp9vvfb287idboAVkRAa5fBYXP9rxO4Mgf0xvPPdHgAEA8OoGd40i1j0AAAAASUVORK5CYII="

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfJJREFUeNqEUs9PE0EU/mZ2WgqpXX+QIDFdalVslh8NlAOQaOKFAwfvHvwT/FM8e/U/MOnBmwcj8WD0ACEGghIkbU0baaEthe3OTJ0ZWV26q37JZt68ee/b9733yGAwgMbL12/fz+azbnAPY2Nrt7Zfqz9JMrYZ+J4/e2pOFjiciRvXlgp5GzHonXk2o6S8V6k/TjBrM/xGA4MLyeOSPZ8jkx7D+uqCU3Amy1yIYizB36AlCSkwfjWDR4uu40yMl/s+XwjeWThQQ4Z6QNSnSkYykcDXasP4lmfvOZTSF9q8TDBEFPbN5bOqCglCCCxK0TvvZyIV4CIxbgpC+4gm/PUmFCIE8iJPyME/e8Lon9j4HvyHYLjKSwRCSEUgf9+15mFbx8QS6CZJMzJ9SlBCwX3fJDLG4PX7ykcwkmQmJtpEhWa7g1dvNlSwjwelebz7tAXLolh0p/Fxe9fErK2WDFGEgKjxfNjegX0lDTc/heNuF99/HGEslcKXwyoazWNDdlCr6+DoJgrBzdI0T9rYO6yg2zszMlaKM3Dv5OBzbuyZuzm1B16U4Nzz2f3cFOx0Gq12F9cztpExncsqYoaHpSIKtx0zJdVIFpHQ6py29muNk1uTN829o/6SHEnh80HFaE6NjmLnWxUJy1LyTltB3k8BBgBeEeQTiWRskAAAAABJRU5ErkJggg=="

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAk1JREFUeNpsUktvUlEQ/u5DoCLl/RAKKKUvWmIxjYntQtcu3LvwJ/hTXLt16coFC2PsojEaMKZtCqFaTdGmjbS0CG3By+vei3OOBSGXSU7uzNyZ78z3zRF6vR6YvXzzPrMUCyf68bB9zO+VfpROn5hkOdfPPX/2lH/lfiLidztX5mN2jLGG0rKLENIE8liWpdzwP7HvqJqujmvudFU4bFY8Wk1FZsOBtKppd8YCDNu77CZevd3gflfTUFcUhP0ePLibiIR9rjSBpgwAfe4dVcV6dhtep4PH5msylGYLrzeybErcT85FYiH/CyPAf74gObC2vMhzsiRhPhpC6eQUM+EA1pJzILEnjRSuJsju7MJqsUCSRei6Dp3yXqcdGlHZ/rLPazQWGCn8+6YW4pAkEW0SjzUzanWlCa/LgcR0lNfovTEi6lcIkzesnM/R8RlN0INGp3h4DHoDsE5YRvQyiKiRSMzikRAOS2WoqoZWu41K7RwzlOOAVDMMMHhIGvFlRxJFrKYW0ep0IYgC3SDh4b1lTJjNfENsrazOAMAw680mPuW+8lFno1P4XDigRhOiwQAyJK7TbsNS/PaA7giAIAhYz2yRgBIfsVA8wIetPG6FAqhdNrC5u0f+TUyHgyMTDDToEt/ftQsEvW4EPG5OZcrvw0mlimarTXkPfpXPcNlQoGtjACgpryQXsPNtH/nvRXqBJpoKHMzGNkNB0Odls7LNyAYKpUq1dt1iuvB7fRDp9kr9D1xOFwkpoksXusmXaZWFn0coV89r/b6/AgwAkUENaQaRxswAAAAASUVORK5CYII="

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfVJREFUeNqMU01PE1EUPe/Na0uptmlASg3MoiZgCA3hQ8PHAjbqwsS9C3+CP8W1W/+BSReyYUPwI4QAVkAgUEgIbVIg1FZb2pl5b3zv2cHBjsaTTOa+e989OffcGeK6LhTevFv+OJoZHPHOfrz/sl86KpWfhxnLe7lXL1/oN/MSZqonOXU/k0AA6lfNhEFIrlAsP2PMyPtr1AscLpyg5pbtIHErhqez4+awmc45nI8FEvwNaiQuBHqTcSxMjJhmX0/Osp1xr878FxWEzwMinxAzEA4xFIpnOjedHTKpYbxW4U2CP4j8uWxmUKsghMCgFI2mFe9QgHZj0Ba4yhFF+KvGJToIRLuPC/efnjD6+26wB1Lq/xgbSCBXKeWJG/OTdky8cWTdT3C9RmWSGk2XCLlWo4xTNbfN5qh7PpXM72GjZeHt0gpq9QbmH4whGb+NpU/reDQ7hcWVVXxvXOHxzCQopQEKXKEbL6o1ZIcy+LC5g62DY2zsHeC0fA4zndIrHOjvg2XbAQRSfsuy9XxC2qzi/H5B6/68W0AsGkW0KyJPBLbDO0fg3JX/CUM81i0bD6WKe6j9qOPJ3EMcF0tSNsFA6g6alqW+VtZBUL78Vtk+Oqne7U9rs5qOQCjSheJFBeFIFOfVujSUYu3rIc4uqxWv76cAAwCwbvRb3SgYxQAAAABJRU5ErkJggg=="

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAn9JREFUeNpsU01rE1EUPe9lkk47yWTStCmtNhFSWxos2EXVhSsRcasuxYV05V8Qf4DgD/AvCK5EV1oFI7iUBqmCNdDvppq2mWSSzEzy3vPOpFFq+uDNfR/3nnvueXeYUgrBWH1/9/NE7k5BKRnuRcfF2qdnmJq9DeF9tQ+2isuMsxXGWHh/a1mEVsPJSI5fSU3OPEj291IIlN49RXz0KqzEQjIeZS/L5Y/3wPGhDxIM/i/A7fZWgVG0t5EaG0ZUa0JGM8gvPrZmLt58QYwv91mfAqCIE0sAqgumBFITGQzpUYhuF0KfRa7waDyXXXolpVrsh/0tgSLDr5I+wUZo1UHCSkAficPzY6juFSmbRPrC/azjq+fkcO00gAqoU7B0ETKkfWbuCTjTYeq5oESAauexcTScX+ZACWFm0YQSLZKhHdr67+/wW0e0dgjYo3sCEXXybYtBDVSHLp2es3IpsILS24c42lkBg6DzRjgRzCDZ/xr0GNRJwwYiWgzt+hYMawleu0V3wbkT+kUirOc7IGJAz68R/Qak1BAlx3hqASPGBJRXpXOv58dkz3eAgQoOm4hyj57NgZm0MHvpBmK6QdUdg/DAg9cRkhicBSDaKJdeo1bdxmR2DtWDDUxl51HZ+QHTysD3XdQO95Gfv06aeGcAdBrY3Chi8lwO3768QWX7J5q1XWyVSxgajiOXLyBG2hzurRKV9lmt7ISNkkjo6HhNyjoK+2gXRsKE57ZIE2ot10Z1fz0Ue4ABVw3NMjnW14rInh8jTYywoTg3EOFpOM4mXNfH9PQUfGlrAwBOs3I8ljbtuMWhRWzIIPrkn+GcYcgIWEowbZ+0qB334/4IMADESjqbnHbH0gAAAABJRU5ErkJggg=="

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAppJREFUeNpsU79PFEEU/mZ39vZu77g7DokcP04BBSUmiEKCSCxs7Ei00JAYO2NlTKyMrX+CJhaGwopSQ0dMtFEsbDRBgiZEQIF4IHcg+2t2Z8eZ5QDlnM1mZ9+8973vfe8NEUJArfSNhzPG0VIfeIiDRSDkw1cWVt3N8rhG6SdSO2Gvn8dfuueqZwuNZqk3Jxg7iNcIfBbgXD6ZC8u5qffzX8eoYeyDxC77uygKhcouovgVUQj1H4YB2ovNuD9+tTTU0zMVBmG/+C8AIYh8F361DL/yE5HnADKYlVdg6MDAmW7cuz5WGuw+PsWDYGAvbL8ECFUt4K7/AHd/I9c7BLaxinD2Ld5Zo7g78RLuRhlBS2cpWbGfStfhfwCEpK0nUjCbWuGsLciSOELPhkq/YgdY3l6HsLfRcLYf+pHNbH0JigEPkLAyMsiEJ7NrqQzM1i7wyhoMZqOhvQs6Z0ovXgdAJACRoulEg5HOwrOroKk0zOY2BDtVpTF0CU6kLkQJXa+BNEoG0lMSsBBKQXWNQktmoGcaYeSaQCIVWOvUYQAiWZFQtk5mSMoSzEILtBrTfEcviC5bwVwQmoh96wA0ic5dB57ngeoaTIPCdb34zDITYNLOOIeVSsW+dQC+7+NSWx6jJ4tY/rWNV7PfcGv0tBoPTM7M4eKJVgx2FTE9u4QPS6x+kHzfw/mOAjarW2hJG3hy8zIceweuY+PRtREMdzbjzcd5WBqPB6xeRGUMGRzHjWvMmxQ7tiOF1JBN6FiTd6Sy9RuFbHpX7MMMqOD088Ii+op5OUAO7jyeRGfBwrF8Cg8mXuDL4neMXzgFwhwZz+hf7a9d5yu3Z6DTPjVQIY9k7erO7Y63Lvc8ErEeyq6JaM6efjai4v4IMABI0DEPqPKkigAAAABJRU5ErkJggg=="

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAndJREFUeNpsU01rE1EUPTPzJk0y+WhMStW2qdVWxUVEQUF0I+4ELQiC7lz4N9z0T+hG9wrdZKUgLqulhrbSag1CKpT0g7RpYjqZmffle5NEKdMHlzfvvXvPPffcO4aUEno9f3Vt4dTp+BXOe+fB0u/NbVpv7h89NU1j1TCM8H7+xY9wJwPHZMbOjRadLAvE/2gToJTiTPx89k+OlVd/LT+0TPIPpO/SzyQk40xCMxBSZ9Z3CoAx5DOjeHT7SbE0XSpzwa8OWB9jINELolQg8AR0EgUKn1PIlIWpkUt4cPNxkTOU12trs8p95RiAXpqaztqou8q6SKQJJmZSqGwsodFsIJk1kcyLYv7IeafcLx4HUNkFF4jFTExMZ0B9DrfD4HUEusYhWs4GPEJg5wly/tBYRIOeDhpEwlS34xcyajdQr3UwOT2MlJOEBRuGNHWp9AQRVXDfQiFV/U5GBSiQ5p6ngBEa5z3fiIhC6g6IMDBwOdoHPkYnHPVyhN0tF7E4QSpr94CEOKELffq+y9Bq+DCJ7rWBoQQBVbPR2O6G4OlsLASJMtCZfQqm0NP5IVWnamdAkUxbyuIYtD7wWegb0YAzAVMkkI6NwPM9xEwHloyDGAmk7AKS9rAS0FKOdugbYeAHPu7OPEM+MY7q3hIKqTFQHmC3XcONc/fxdfMDrk/ew/edzyhvvTmBAddocVRqH3Frahau56qpZDho7+PnTgXffi/gbHYmLEvPSIQBp5JU62sYz13G609zKBXvoOMdYn2zgm7Xg2MVML/4Eu3uPgxhk2gXmNl8v/i2pcXTP8tKdTEcbWLZqDQXwu/l6pfwbEnSGsT9FWAA4mdHv2/9YJ4AAAAASUVORK5CYII="

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoFJREFUeNpsU0tPE2EUPfOg006hD4rQh8WgbCSwkKgbF2owujaCiQsXxpX+D6MmbtXEsHCLmIAbE6NLo8YlGIxREIshIqVl+mQ6j8/zFVCb4UtuZua795577rl3FCEE5Bl79vPd5LHYiOP7cH1AUWi85ytmvlas1bJ9E5ryBntH3BpuP/X9i7ovkluuiE8N9SDepaLpCcRCCqa/VDCaMuIjSWP25Upl6n+QDoCz6Yh7KKzh3sI2LuUimPtRRyaqodj0MDloYiITSTi+mH29Wu0AUf9CsZPJoW5czJl48LmCc5kIKo5Al67B9gUGYxrun+5NnMlFZ+GKiQADj2a7AquseLIvjMv5KMaSBu4sWVir+3i8VIVKYSby0UTdFU8Znu8AYBHQgVOJEN5uOXi4UsdawwU0FSf6TaSoyw6DRvukPkgGWpDKy4F8a3jImCrqFDFn6rhKPR4VGnhvOTAY3WLcjifcQAsqRfhUc/Gq1MKNbBh9nIAMDjEppocxs9HCMktfGTCwP/oOBkUKNk/qF3pDYC6Ktk8RfWzyaaoKrqdDaBDwya8W1m0/CPCR3kFy7CcnmWQRUJqcRJFUKtTnPCeR71LwoeYF92CYyVnCFZpCTrRtCv5to2St8SOrKxiPqEEA4fkYT+mI0rdoeUiH1XZVuQPpsIKqw2QmfifTsnOABiWySlH9uU0Hh2MqjsZV5LtpPSoGeN9rKnhBX7ehoOSLIIPfnGONXGMMWN7xUfVldYDbjM3mrh5HCDgS17DhHgDQcIU+XbBxnDTn1x1UuQcJ9iv7l5Q5e1zLGri92EDJFnoAgHtcfr6wbbVXUqq193+0z97n3UJt1+d51n7aHwEGAAHXJoAuZNlzAAAAAElFTkSuQmCC"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo5JREFUeNpsU0trE1EYPfNMmtdoH2kDNmJbaVFcaBVFpAsREQpFwY0bu3HjQnTj1mVd+ANcuC3qQixmry6E0kWFVIQ+bKy2tbFJm3emyXTujGca+4DkwsedfLnn3POd77uS67rw1vC79ek7fZEzpu3AYUqS9tKQGZPLpa3VXP0uFCmJ/8t9OLC3q/uJbcs5bkIybvdHoMsSbLKENRmvU2WcNnTjRFD7ML1WGSPJHI6sA4KRWMAWVDPxLYex3iCmfpuIh1QsFSyMxQO4GvXHHwOJ6XWSyIck8v6HQsnjAxFc7vTj2VwBg4aG78VdBHQFCk+dbVcxMdwev9gTSEC455sIBOu2KLsoJFzqasP9vjCeDBlYqzn4VXXwarGKZN7Crd5QfLDT/7KpBM84c9fFUFjFp2wdk6smflRsKKqMa7EgfJJ3Ac2OKlit2pEmBTQfngdpnupoU7BUtRGiiTe7fXiRqmK+KuDn6TpvYogmBRJcrOwIJLIWxmM+dOsyLKryQAaJpjJ1/AxrGO3SqdZt7kKZJrzJWBg5piHENuY8vV6e0UOye1TyftvC5l+gZB8SHJTwpSx4q4JeTUKaxhXoR57h7Rn+3iFolJ3xvPhab6HgJG/pJ7jsNP4sUX+jZiCgEsWd/DjH5IrSYpBUAr0yHpzSoXKOP25a6OBhndh0zcX1qIYM2RIbu6i0KiHD5B/GTMHG03kTGpEL7H80wHFOWwhqDZ+SpkBOtCDYJDhZE4gRcKNbYynAqbCMbXpwpVPFbEng0aKJGbYzK1p4wIegLlcEPmdt+DjXbzcsxFlCynRwwVAwW6hjqeg0Zt521SYCWCJvbe0Un29UDx7Hgrs3IEitHXkw3jOv2fl92D8BBgAJeyqBh90ENQAAAABJRU5ErkJggg=="

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmlJREFUeNp0U01vElEUPfMFCEVArdoSqEA0KV246UJdUJM2Lo2JK/9FjXu3utJqTNz4D9worrsQExbFpAFT0TYp0CZ8pIAiyMfMvBnvm2Foa9uX3Lw7c98979x77hNM0wRf7ufPsq7Z2SQYw2QJAkDxQalUZa3WI8hy3gmZr15bu+z8kILBkCeRCJi6bufKMji0NhwiCQR6iitdatTvQ5LyOLLEiWcYukm3m4Zhmbq1BX13FyoxuH7xAlbvpqKRK1fT0PWbRwEmDEyiy1QVg/V1GO02tO1tKLEY2PIy3KEAlmJRDLXb0TeZL+n9g4MHlLJ5HIBuYnSzXq+DlcsQLk/D9Hoh1WrIUjlPcpsYGQzS3LWoaBhvKeXWMQCDA1D9pt8PaXERUjwOjEZQFhZQp9L2yERiqYRCkPt/z58ogTGqHQLE1BLgUmC6XGD5AlipBIFKkbhanKHGYLBDqQ4ZED0OAbfLlo8OIxwGvhVgyTHlA3xkomjH/gegBgDURMv6faDbBZpN+/tHkUApkdTA/PwZAPxntwdUyjYA/+ZMqJHjLgM9iv/6zRt2GgMaIE21aVIjnSm0DGPfmhzyde0UAE2Dj+p7urKCPvkZku9eJILOSMUnkvVhIo7GYIB3xSKYdhoA1erXGVKXpvFxZwdBonnD68PQ7YEwM4O4xwMPxc8RYE87g4FIcz+kvfmnA0YzIJIy77/m0OCqsTkkCTysKPjJG3viLei63Gm3kCO6UWqcMejjxecMPmxsoFKtYop6UNirYL9Wtc5OHqzznIXHq1na7OfMJROcK8a6O7MjW7nfzZdrd7jzT4ABACh3NGsh3GcdAAAAAElFTkSuQmCC"

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo1JREFUeNp0k8tPE1EUxr+ZzvRJO62lUAQaKIQ0FVJFjBBdoIkrDDHuXJi4NnHtX+HCjW408Q/QmHTRaCRRohIJifgiiBICTQu29mHfnc7MHc+MlECKdxZz595zf+c737nD6boOYzxJLC6Nhwej7e/24HkO779s7G6mMjcEwfKZ21+/d+em+RbagaFev28qEpZwzKg3ZckqCPH1nfS8hScIdyhBe6JqTG3PfyTTeLrwFhvbKdy9/xi5QglXL0yGJsKDccZY7LDIAwWHpSferWBh+RN8ni4UylVER8MY6PHj0uSpUK0hxzfTmWsUtnoEwO3rer64jEyxim6/Hy67DXaHExvJX3jw7CX8XjfORUdDlOohhU4fAVjILCPbm9V1yIqK2FgYt+ZmsZcv4lH8Nb5upXD7+hVMjIRQa8qeDg8UTYPU5cTcxSk4nS709XTD53ZhpD+IYMAPj+TBz93fZiz5oHV4AP1fGdlyHZIkIZkrI7GyhnK9CZXy+Aig6p1+HQAY003AcF8AVtGGfLWG9XTO4MLZ5cL0WAixoT4zVmPHADSiMo3hzHA/xgeDWFjbNg8H3A7kKnX0koEcPdTu/ylgRGZgOjNv38zoSXC8BZJDRKOlwGEV0VJVGM0y4joAPO1spXbx6sNHeD1uRIYGUCxVSRlDt1fC8rfvcDnsmJ+dOaLgoAs6AVLZPJJ7WdhEkUyT8GJpBflSBcVKDTvpDBw2GzQqQT1OgaZqUOhtFQUTUKnVTVWNpgy51YLVKph7sqKYkA4A1ScEfT66vm5kC3+ofh6Xz59FQ5bpkvE4QW3M5Apoyorhl9ABIKnFgNdTOh2NkJG6WSf9eRBJtmFwLDJmriUzeaOkYvvcXwEGAIVNH6cDA1DkAAAAAElFTkSuQmCC"

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmtJREFUeNpsUl1PE0EUPbssLYUCXdpaC9gWoSTgAyFigiRGY+KjvuuTr/4A44MP/gx/gMYfwIsan0RjIjGiJIZgSIGFIoXSD0t3Z3dnd70zpITazuZmJzP3nnvumaMEQQCx3jx69SV3a3KWMxetpSgKxP3m242Do43SQy2k/YRydvds67n8a63k+FRSn7l/bdg5tdsAuM3he/5weDC8vLdqPLgIIpba2niux52mg//DqlsYSg3iztO7mczN3DJ3+ByCLgCBH4hOFEF7cDpzPCRyOpaeLGXSc2PL3HbnW3XaRQCPEgWI2MsRVAVqrwbX9bHxbhOKpiJ/bzpDOr2k68V2BtRNzMtqDEqPejY/4zSGjb54BM0mQ8k4xsDoIMauXxnqYOD7PmwScP31d0SS/eAuh1lrolFpIBQNQw2pqJdqsAlIceB1AJCIkkE/FZskXDQVRXw6IYHiE0nBEcaPXSSvJnGwWkQXAE4acAhbxPMJpOdHweoMhc9b2F8zwKizbdlyPLVH7QLg+JKBYzoorxzjz3oRzUoToaEw9KyO8XQW5AE5jrFT6AbAYVVNxCZ0Ka3So+DSTAoDiej5ywTySbls1OEDobhFlMcXxrHw+AbINEjNXgb7y6BndLhk8cRkHHbD7g4gEhiJFxsdhrDqaamBaDKKerGGSKwPI9kR9EZCaNA5ubE7A5s8IFhsrxQkgJhZoa/06xC5xRz2v+3BOjFlbqcGlquxsondT9vY+2pAJdeZR6fI355CgQCN2A4O1w7gkQ7cdLUOAKdhV6uFSv3kd/n8mT68eC8dKWLnY4FsfeZQh7nVVt0/AQYAsf5g+SvepeQAAAAASUVORK5CYII="

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmVJREFUeNp0U0tPE1EU/trplAqlL0laiw40xASByEJIZFGVnSvj1j+gWxNXJq7VrbrwF7h10cSNhMRHojEuACVBKmH6SJQyJeXRxzzv9dyZPiCtN5lMe8853znf953xcc4hztDzZ1+C6fQMHAfd4/MBFG+p6h/n4OAeAoGNToi/eOm+A50LKRaLh6amoty2vVpZdotNXccMEK3LwZxa2bsDSdrAqePv/mLM5tSdMwYBYqyvw9zdhUn/L59P4OGtG8qlZCoH254/DdCdQBCxqZu+ugqnWoW9swN5ehp2NotgIo6bGQWGtaS8+vQ5V9a0u5S+1gfABEilAqdUgm98HDwUQkDT8JXoPPq+BoM5kCYmFT9jryn1+hkAt7heBx8dhbSwACmTAUwTgdlZ/CVKJaLnI1GD8TikZiPSR8Gxib8chH95mZTxgwWHwH7+gFMswqcokIRbjMO2HDCnZ1VvArpjEmnKZc8+cZJJYGsLsMiZ8AgwEqaY6Mb6RQR33JFhGECzCRyfAFXNu9v+RVNRZWIMuDJNuYMAaDycUFGhCOgtuAtFVDA83G5A8TrFDw+F5QMAxAKJJxz2xnW3RPJGbm+rCyjotZetH4DGzaSSeDA3h4Zl4R0JOEZWTpIzF4n/m995bNdqZwB6m0gFft3Ak6vz+KYWwFsGlqIxXItEcDt1ARMEtKdVgZb+fwA0G2C2hXM0ZTZNRcSf0b1pmXi7uYnjI+Lfanm5fRQsK8BIxKcrK7i/uIgP+Tw+FlREqHN5fx/vyU4uHBE6UO4gDWqk/JFaLuMxcXeFk6TuJ90V0HOk1in7J8AAjmgkPfjU+isAAAAASUVORK5CYII="

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAbRJREFUeNqMUk1Lw0AQnf0woK0ttVqp0hwqVCl+UBERT94F7x78Cf4Uz179DT14F8WbYHtRkBYRLNqDtdaPZLObuLs1NGlXcWDJZGbey+x7QUEQgIqT07PL5WKhHL5H46J+22q22vsWpbWwdnR4oJ80LNiz2czGUjENhvj4ctIE4Wrj8XmPUlKL9nCYcOFzE9j1OKSTCdjdrtiLdr7KhVgzEvwW6krC92E6k4Kd9bJt57JV5vFK2KfRQRV+RAMkzxglYI1RaDy2dW1rpWRjQo5VGicYIorWVooFvQVCCAjG8Omw1MgG8AM0uSBUDSnCfk/IGCHwf3DCD/7UhOLBrFkDuep/hDUSSCv1iYo4rIfqGwmUSNJjfYbBcQKhZw0aBMA4B48LwBhBt/cON80HmM9NQ6fXg/Wlku4TwmNWDzaQqzHG+0PSKod5cH5Vh2RiAhYKc8DlV1UPSyuFMGygVlMg1/P6BC6DqXQK8jNZDXAYA1f21V34wMXYFaiyVw0rJyzLgs3VMkxOjGtix/V0XWChZ0cI2i/dzvXdfTd0Qf91BMPrhyNzgKfOmxaWypqaDXHfAgwAtCL8XOfF47gAAAAASUVORK5CYII="

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAehJREFUeNqEUk1v00AUHK/XKf1yZdESVRBXjRSRFqMQVBA5Ic5I3DnwE/gpnLnyG3LgXglx4UDDLZS0RWkDLiRxSusk9u6GXSembmLgWZbX7+2bnZl92mg0goo3b3ffO/ncdvyfjHef6q2Dlvs8Q2ktzr16+SL60jhhZ69bO8X8ClLC7w9XdKJVG8fuM0r1WrJG4gXjgqU1D0MGc2kBTytl+7a9XmWcl1IB/hZKEhccq5aJJ/e3bTu7Wg1CVo7rNLlRhUh4oMnXoDoyhoHGyWmUe+QUbELIa7W8CjAFlMzdzeckCwFN06ATAn8QmDMMMGlMuwWucpoCHNe4jBkAMenjYvRPTyi53JvuwX8AplleAeBcRFrH6rXIxLim9I/pi3QA1RhKaYxdjkN8IwalCMIwWs9ljMkh0wzk+9M7w179C3LZNXxve2h+c3Hu91HeKmD/6zHOLnw83ilB1/V0CeqU3Q81LC/O41b2Btx2N2JVP2riR8eTUxmi0TzBwrKZMsqMoz8MsDh/DWuWhUBKURLKxQIeOMWoptYPnS1c+INZBkwISomOSsmBZS7B+3WOzZvrKGzkMAiGqNy7g+LmRkRfekBnANy2163PZXrSbrQ6vch19Xz8fPDHyL39QzkHBKedXjfu+y3AAGU37INBJto1AAAAAElFTkSuQmCC"

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmBJREFUeNqEUktPE1EU/mY605a+hhZTBNKRDApNrWIRA4nEBUZdmCgLNi4MK5f+FNdu3bFv1J1EXODCR1JJSMTwpqUP6NiCpe10Zjz3hj5Mm3iSybl37jnf+c53jmDbNpi9eb+6Ftcisea909bWNzNb6dwzSXKkhIt/r14+515qBqmDA8HpqKagh53XaopblpIbe+knDpFAhPab2Dw0TKvRK7lmNODzePBgZlK9oUWSpmVNdpIU8T+jaMsyMaD4MDcZVa+NhJMN00w0n6V2nN3yQgdHWZag+LzYPTomIAtT0THVtPGanmb/BbjwLFkvn2IttYGYplKyDzsHh7gdmyAWfh5zVq0Guhg4RAHFUhmfvq3j134aXo8bd+ITnMFOOovU5jbGRoZwNxFn1cxuAIcDW/sZDjA/c4u+BNxOJyxqaenpI3z88gMfPn9Hv98HQZS6RazW6kjExvFi8TGdDSy/W0Emf4LS6R8sv11BmfzSwkPcm74Jo9Ei0GZgmkw8QCOao8OXcaz/5vSZnPdnp3ApqBBLkWJE0Ci7ASzbIhCLLQ1E0iOkBDh9NpUgiUejo8oNuJwyn0YPABtn51UYFFivG3yBGCNZkuDtc/MW+ZQI3OrYpBaARCKufk3B5XIiWyhiL5ODp8+FfFHH+KiKSqWKUL8fC/NznGlPBmz+24dZjKnD0CJDcMoyW0SqXuMtHBFw7rhIAD1ErNUNafxKBNevapwu65NpEQ4FqXIA+RMd6VwBP3cPSERb6gLIFIq61+UqGWaFdcrVt/lmAuWjAi2aiMFwmOYuIJ/N6M28vwIMAMoNDyg4rcU9AAAAAElFTkSuQmCC"

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhRJREFUeNqEUkFPE0EU/mZ2dra7bLNpi2AxQFKalkJrohICiYkXPagXrx78Df4K48GDBzmQePLMhUODNxQ5ciEkJVqDtJGmMWrCATRbd2ecoS5u3aovmezsvu9973vfPiKlhI4XL7c2r5YL81LIELEghLA3u/udxmHnPmfGW/Wuv+LpwwdneRYBx7PeWK0wOYYhcXxyckGV1fdbnbuMsXcklqPRJQxFMKz4RxDCtVO4s3xlRjWoB0FYjlQPEEBieChwKCRGMx5uLtaKs1P5ei8IKlGa/YkXMXYtlTEDlsnw/mMXhBJcqxSK6vlcpa4PEpCooUyIqs5M6hG1o2CUwqA091cFcYLf/sjzcX75EiQIojI9779CTYR4jwTBf+r7GAwh0AxCiL6JMT/04vQ79u8aI2O/7Jzg69o6Go8ewycUahtBpADhHKLnK/eVbkMdtROWIv80NQ2sPhncA9Htwn+9hZG0rY6DzFwJl+7dhs0ZstUy8rduwPS/wd/ehmi3kwq4zTHiWUgXp+EuL8FvNvFl5Rn4xAS86iyI2kY3n0Mv48ByrOQmancdi8I0Kcj3U5iuA29xAelKCUHrEIayzltagG2E4IwkFaQgSC6lYI09iN0d8It5uNV5nG5sgJdKYC0G8WoTOZvBISFNEBxnsuzD3GX4vfDsszzqAu0jkJQDedCGbB6AWg54pYbPo+NGVPdTgAEAqQq70PytIL0AAAAASUVORK5CYII="

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAjlJREFUeNp0kstrU0EUxr/k5qbJzdPYpGkpsUJoA2q1oLjTdiGiIC5cuXHlxv9BEOrStTvBnQvRrSAIsejCrlqpsURq2hCJNQ+TNLm5uc/x3MmzJh34mDNnvvnNzOE4GGOwx8+t9XQkfn0VE0Y5/7Z+kHm+dvOhtd3P9c/xwNZh7nWaMYtNUmX/Fct/vlN7/8J5aRRgyzm8xzpRDjGE2aVH4VTqdnoUYg/XkEhmy+Cx3DhA5tMzdFolvg5Mx3Fx9SmH0JIg79Zo3j4GADMIokJTKtjbfAKXU4Y/2NvSfyH75TFOxa9Cmr0XnlPFl5ReOQ6wNMDsoFX6AElqQlNV1KsOuNwS/AGFjEUIDhmn5+/DMM16/9igBowAzFKIswPJr6MjlxFP3sV04gaP7RzMPe6xvWM1gNUBM2UKYlBau3QghGphg29J3gDlLLilWNdD3gkvIIDRhD9yGe2mCV0V4HFXuCxT5Dlv8Dz3sIkAs03FalDxBMQSt9BRBMhNncuO7dyU28c9tnf8C/Q0ZtR4GImeQSj8APLRH772BWcgiFODffCv/t8H9tO0v3RjV7VqkeeXLlzDfvYjj88uXhl4JwIsrYxmLY/M1gYclIvGE9jZfNPrSCD3/QgLyeWTADV6wW9AryIcCkB0u1Aq/oCPumlufoF72vIheaLDr4wCLIOqrYnULA14PSoqpSJEAUilZrD77Sv3LK+cI0+Be8cAbbmAOrob0agtD491LYfkoqvnyZLsWRkA/gkwABL4S3L78XYyAAAAAElFTkSuQmCC"

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAjxJREFUeNp8U01v00AUnNiOEyepQyhQobRBSlVIoRCBEPTAjQsSEneE+An8FM5cuXLNoQduIAE3qopKNJAIIppA2jrOR93aa6/N8yZuUxyxkrXr3ffmzczbTQRBgHC83nj3ca28dD36nx6fvnzrNNrdp4oibyUmey9fPBezEgWVFuYLdyvlPGaMY4fl1aRS+9pqP5ElAkmcnknRwuO+Nyt5u/ETYfyj9WrpZnmpxn2/Ok1Swn/GvtnH5k4TLue4kNfxoFoprRQv1TzOb8cAIu3+ZD7oD/Hm7XuxzqRUNDtdkuLiTmW5tFxceBXlnXgQTAORSMt2oGezUJJJrK9dFWdEH7Ik4dB29LiESeUEJXd7/dAT3L+1ivlCHr8NEzutXTBvbJPPSdO/AH5wysChwM/1HzCGlmAzOrKxu2eCud6Z2Jke2MwThpUXL6Nn2ZAVFTlNw70bK0iRnGAq9qwHtOmTRpsx1NsHyKRVnNPnoMoK9kc2BjbD4vk5JGV5NkBoEPM4FFnCteJFWOS4ntHEfphQyKaFTWFLw704AJ26ZFx/ZEEi3YyY0O1Dmr4EKTUHA8hUnS6siI0DEHLYog+b28RCRuNXR/iQUpPUEQ+NVht6Lodnjx+GXYgDSFRnq97Ed2pXSlXhUSeGhxYc5sKlNXM5DGLR2TMwfZVPAIi+otGNWy1fEZUKeo4qc4ysI+F8VksLIJfYcD9QYgB/DNPMptWBlsnBIS86xmDMTBo/PWd0LB6VZfdEbJT3V4ABAA5HIzlv9dtdAAAAAElFTkSuQmCC"

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmlJREFUeNpsU8luUlEY/s4dmMpkWxRopGJNNbiwhk1tItbGtXHr0hcwmvgOdWld6Bu4coXumtREE3ZKu8FgOlC1kIoXtC3jPfdc/8PUIpzkBM7wf+f/hsts24YczuerGUc0moBlYTAYA+i8sbdXtAzjITRtq39kr73s/Gr9DTUYPOeamwvYnHdrdR0SnDebuCbswJGqpX+Uf92Hqm7hzFAG/4TgNr1uCwEJ0trcBC8U0Kb1/PQkHt9JxSLnL6TB+Y2zAIMOJBGLXmtsbEAYBsx8HnqCGKVScAX8uHf5EpqmGXv18VO6VDEe0PXsKABN8+AAgiabmYFNNJTDQ2RUFc8+Z9G0OPR4PKYwvKari0MAgiY/OQGCAajhMNR4nDZMaInrKBGl70SPMScck1NQG3X/CAWLE3/dAWV5hRRVIJxOWNksrP19sFgMqqAebUGYHMI6teq0A9oTVAhqu2sfbYYjsL7lCZ3683gA70T3TK7/B4BNoO020GwB9TpwfAz8LgMtWn/NkV8EHgoB81c7nYwCyBZlEVkHcqMTKFnkmehJTOPvEfCnKi0fAyADJKfXC/h83TaZTJjaa5lANLpOFqAXtlEAorAwO9u5syT5UxLfU0e3o1FMu1x4u7ODYq02BKAMAVSrSNLrK1MhLPj8mNF0vFm+C1ZvwKBwXXE4AGn1WAASazESwUW3BzUSMeJ2o1Aq4sPurvQYSRLwlhRR6mSaYyi0WlpAJrFRx3ouh5/lMt5lv8BLwXp0M4lSpYL17e2uK5wP6lj/c2ZPn2RI+YT8fDvqoyegVLyfG5kBKaQQOfvF2pLc+ifAABiQH3PEc1i/AAAAAElFTkSuQmCC"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlZJREFUeNpsU11PE0EUPbM7u/2AtJUWU6qiiSYYo5EmmPDCD9AH46sx8cEnja/+CB989z+Y+MKPgMiDsYQACcbaWBBogYD92t2Zud7ZlQZsbzKZ3bl3zj3n3IwgItjYeDO3MlWme0bjUth8e8/fO2tHzx3XqUEk50uft+Ndnhdmc3SlfNPkVZT8Cy600DoIISvVfKYtlvfX1p66XmoIYsMZdjJQWvEFbbsC/S5g2QhSkKUK7rx6OzvzqLpsovAhaAxA3DUBQn2TUFsl7KwTfm4Z9DoO5LW7uPXi9Wxpfn7ZKF09vyPxX2iWcNRkKGZz0mQWKoNs8AVB6x1yRY2pYnc2LLofuXTxMgAlmlXIfngCxNxEzM+DPv6NQa2BygLgZyX6JT83ngHTN5GAL0WSoUQkSQnXkyBh/k0GegTAaldM20sTKvet+yyhIZApECamL0jUSe3oFChx3TopM4TeEQP2gc6BgGIwb4KGNXRhCkMGxgg2kJeybRiZM45D8W61qEAknSmpHStBhywu0nFVupSCTAcM4ECwqapv+NQ6LS9JGALoMIIoPYDjZiEL1xHtbyO39AQUDaA7R1AH23DSeSA4hv5RG/VAhxomPYP8sw9A4TaC9iHkjUWmrtGvbyC18BLe3GP0m3WW4I5hEBEnPIStXzyuFIxb4EkMEJ79Qa/xHbKxCdM7xeCwzUZOjgEwnuzt7qLz6T3cySmQP43uzjeIiTJM6io6W19B/NLCKMVGCzkCoLR/0lrfOI2fNy/huKC1FTsK/rbGNeMRC8dHpHByfu+vAAMAL/0jvAVZQl0AAAAASUVORK5CYII="

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnhJREFUeNpsU01PE1EUPdOZKWUotKUKFLEWkQ1EASGGxGBi4sIVrt27IixN/Cn+CxfVnQsXJiz8IAoqRBGEaMUUWzofnXkz781436QDkjKTyXuZe96595x3rxJFEeTzaKW6dmdpfIoxjuRRFECGn7/4Utvarj/syWgflU5s891qvGoJePJasfBgeSpnW+yEIJVS4DEBx3FzGT2qfvh0tJxOE4mCU0yy8X3BLdODRQTJZ5oMzYaD0UuDePzkbnnx1mjV9/lMp+izBKEIwQMOzvnJGoYhhBDgFKtMjmBl9XZ54WapSjLnknMnEkQYgflCVhKXLt+/dRMy2d5OHdVnPoxeHUtLV8u2w5/S78UzBJwLMC8gAsosIqy9/ga37WNmvgKVKmEkb7JSwI3pIdRq1kBXBZJAUKkb6wd49fIzbJthdn6cIhE0XUWbyP4cmshmdZAE0eUBD6gCN0DtZwM7Xw+RUlVEJCui7CmyPaS94zC06ZMedREERNA6djBWHsS9+9fRS3p9AraOXbhELMlUQju2G2O7JAQENk0XhpHG3MIVlEZzaDbdOKO8jWy/TraGsMmL4L8KTgnIfcfy4JBWeQNp0j10MQtB4EJOg6qFMI/bEH3pGNtF4LOAjHMxO1dGvW4jXzDi7Iw60TB0jJRyONhv4MdunbDneMA6BMPDA6iMFzExcQH9AxkUiwby+QzevtnF2OU8lBT1i8fOa2UO1/FwdGTHE2STHM/14+vlPOz0RxibKPfn9AHXZHBzYx866ZdTKkuVndhHuqenS1h/v4ffvxqyvbUuAtPizZ0Dp7X1fTs+FA9cMnWd4ZG90NOjomVFzeTcPwEGACDGeYddZX86AAAAAElFTkSuQmCC"

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnxJREFUeNp0U89PE0EU/ra7XWxpSsFYIbVQf9REFBHkYBRIPJh4wrN3DsZ4MPGP8b/wUCIHEw5EY0w04o9ILcREGmwVgaXbbXdnd2bXNxPahGyczebtzrz3ve99740WRRHkWn5cebu4cH6SMY7e0jRAHr9c3WxsVvcemmbys9yT6+uHJ8oaPefypdPDD5Ymh5w26wMkEho8JtDtuEOZFCrvN/4uJZNGH0T59D58X/C27aFNAL3Xthmsww5GCyN4+uzu+OLtQsUPxPQx6ZMAoQjBAw7O+bEVCMMQgqygs+LFs1h+dGd8bna0QmXO9OL6JYgwAvOFZKKoy3V44CgNfv7Yx8oLH+lUEgvzF8Ydhz+n41snAGRG5gUEwClzhHdvttFxfNyYK0EnJozKK5eGcf1qHo1GOxtjwI+pfvm4g/W1qtJgerYE2SXJSIL9+W0jk0mCShAxDXgQKgbNXxZq35vQKCiKQkSUXdc1+gcch1FHGPmKuIgBCdc66qJQHMG9+1NIpUylxxHtuW6gEiTIu+N4yjdWgty0yTmdNjFzcwKjY0MU7MLt+IjoSad16FoIx3b/A0DZ7FYXnsdpAjUMDOjI5zPgfoBsRodhhGhZHfBBU/nGAGRtxWIOg5lT2NtrI5dL0SB5KJzLodloqXaOEatPGztKq5gG3S5DNjuAK5NjKJfPYKI0okBkSdemCiSgS/rkQNLSePtxBj4LSCwfFtE0krqqX7ZVMnu9XlMXy2l7ME0dzA3iANQyY6vWxC61UY41zTyNcYh6/QCNXQvzi5dR39nHVq1BUyuMGAARsF6tbbe4iKD1r7Om5iFBdmW1SsDflLiuB6sX90+AAQDHAW7dW0YnzgAAAABJRU5ErkJggg=="

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnBJREFUeNpsk99r01AUx79psrTrujVtbceabnZs4DYRHSoMh6Dgq77rn+AfoA/+If4Bok+C0CfxVRDBh+I2NqZzrpS1DVvbtU3SJPcm8SSlsJlecsn9dT73nO85V/B9H0H78OLdt/LDlQ1uMYybIAgI9n99OWxoe83nkiz9hDDae330JvxL48O51Xxm/enNtKPbVwAh0Ec6kYpXat9Pnl2GBC02HrjM5Y7h4P8+7FtIFVJ49OrxUnl7ucIdfhv+BIDv+fBcj7p/tXMPrs2RXVTw4OX2UnFTrXCbbY7tpMsA13FDSDAOQ4gJEGUJLs0PPh9CkESsPrmxxEz2lra3rnpAt3G6adgdQhBpmeLkFodNmsjpOPoXBrQTDcmFFNS7i3MRDzzPCw/vva8ikU+COQxm14BBhvJcHLGpGPTOAJxxeLbrRgAkYujBdH4G5oWJWXUW19YL4XqunAMFhnq1BqWYgaY1MAHASQOiU96zKzkU76mwehaOvx6h9uMv7KFN3RopL4oTAI4HRh4wSl399xla+00YbR3yrIzM9SzSqgJJnoKcklGrH08CcJjnBtLLCsSEGGpSWJvHtDKNoFippsJ0ulIsDDUCCATMlBQkNuahEyiZTcLsmFBKaQxaOk53TlHeKkM70AjAooCghBOk9sKtIvqtPqS4FBaRnJSRX8tj2DOh3lFB5Qw2ZNFK5LRo6w4sKt2ggAzywidAMN/9uIPSZglBLDO5FF3mRD3wHE9qVRvoHrUpfn+UEQK0/7ShtwboHJ6jdH8RZxSC57hSVETb7e5/2u0FxqPHJow+8iZ4lYY2QGu3idhIxO7Y7p8AAwALCGZKEPBGCgAAAABJRU5ErkJggg=="

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnxJREFUeNpsU0tPE1EU/ubRdlqmnUBboa0UeUQDiUGCC1+JmrhxoXt/gBvXJi74If4AV0Y3sNKF0YUaICqoIfjgVShEiGF4tDOdO/fOeOaSKtie5GZu7pzz3e/c7ztKGIaI4vn9p+/P3h4e4a6Pv6EoQBDiy7P5rc1P1Xt6XP8M5ejXo6UJ+dWbuemeTGdpvNdiNe9YvQLe4Bi4PmTpRmyq8m71rp74BxKF2twIHvAo+f/l1T2Yp0zceHizfOZa/xRnfBRhG4CQqAYioBWeXDyA8Di6ei1ceXC1XBwrTXHPH2vW6ccBBBMI6BsSUEQzakGL6xB0tvjyBxRNxdCtc2Xf8R9TyaWTDOg2TjfVdw6hqIoE9B2GxkEDWlLH7s4ette2kSp0oDRezrQwCIIA3oGHr0/mKMmE53qo23W4+w5S+Q5ohob9X3tgHgO8ULQACC7gMx9mKQP30EW6mEHpYi8xcJEdzMucjfkKcrTfmqmiFYBxCF/Id+gayKJwoQjHdrA5v4HK7Cq44KjZNWpagaqp7QACks0H9znW365ia24DzoEDozOJbH8eVtGShXHTwNracnsG7q6LzsEuaAlNPm9h7DSSVjLyCMkppDI+GS2StQWA1RlKo0X56n2X+6QHkmkDakxF9WMVqWyK+s/BrthYfvWz1Ug+zUDcjMPMm0h3pxEjFma3CbIuCud7oMc0LL1ZgmElpGJtW3B+15HIGNITrMYIlOH7i0U41NrInREylYbu4R5qQbQBaAh95fVKZCnpQCnb9DrWZyrRERS6NDeUw+yHaXh7rt4C4B8y+9vkwn7kwKNRpDoa9aiFKBYnF+RcREqQ2e1m3R8BBgAy9kz9ysCE6QAAAABJRU5ErkJggg=="

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi5JREFUeNp0UktrU0EU/mbu3FfE1KRRUpWYheALNBURUVy7cy9UkO6KW/+Lbt0IPsFui4gLBbUqFaUuXETUKCYa0jS5yZ2ZO557b5MmTXpgmDPnfOc7jznMGINYPi0de5UvmpORxpjE/kbNqW005DVu8TWw1H758ZfkFgNgJmtyxSPRjJIj0QTW/RDiYGXGb7Dl32/eXrVsd0gSCx9miqC0ooCdp69g5Q/h6OLN0ty5ynIkwzMwUwh2FwMdcbDiCZQXlkqFCpEoPT/wih1YjLInANcD+/Ua9bu3wJlGvrBZCmet2+S6ME5g4oGlZ9A/I70XCDhhDexPNTFmswJBwcnuXkF86VSNZxVu0ukLSGnBcqlnN4HoCQIaIuIv7LUooMOgQ7q75LAAb59B9gCBHSKgqemRr94mMKmD24CfM8nb7THYGQNLpAkUkcb66JyGBFFEWRVL57gFEH5qj8Lxwca2qS3EZaugmzAw24dR/XQgwtsCSBjPIdWbUoE2UJLBnV8Ac/ciWHsK9/glWLnD6K2vgPszsOdOQdfeQ1c/ThKoTgDn9A3KUED/52d45xchZsvorD6Bf/Z60riV3Q9Z/0bbGU1uopYGkfERSQ3VbsMwl0qlqoIARmSoPYXWy0dor79LfBMEEd8jGs/uQ3Yl7PJFNFbuEXiV2riCf88fovXhBbo/vqP3t02/ZYmJFqTkzY160Go9uEMbFK8hR/NrdXtFuUVmnmySVGgO4v4LMAAjRgmO+SJJiQAAAABJRU5ErkJggg=="

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAetJREFUeNqMUj1IHEEU/i7u7Z23e8tGgneGQPw3hZDkkhQiSuwMQREba4uUgpVlCrvEQhurkCoWqcQQ0oTAaYKNqJygGEwgHCSB6Knn7eXcdX/GmdHVPWYFP3gw78173/vmvYkQQsAwNvckq96UnyIEh7/d4t7uUd/8y+85P+bXSX4grkhI6nJYPW7LrXpBK2YxiSoShhu4Buq1NPofDeqdrZ3Z4cl7D4J3UtA5VyVAlmJoru9Af2ZAp1lcCQ3nqgiuKmbY3l/BH+MnHM9GVLP0Ww3KNA33CQoQQnL834Fj74PUGkANEIkCSSsa8gQqgYTIcB0PVsXB318GInRiCVWCkpRFAs+j5gKlA4t29Ggh4d0t04FKt9PQqF4UFgumSEA8ApeaElilWbYRVy/lsns/N1QBkxtENF4jxPxcgcB1CZVOrvMteK5IQDtJJIGh++PcX9iYwWjXK37+vP0WdYk0Ht99jtX8JywWFkQChw4tc+cZcvlF7rMze+ubbxN40fMalRMDP/6twaiUeK7wlZ0TD0a5hLTWxo2d45KKprqHKJslTsy209s2wnMFBTYNZjc/oLt9gPvLOx+hxVJIKS2YW5pCbSyJTGMK775O8VyBwDJd2LTDl/X5i8v3S7NVw9vJb51tITDEUwEGANCx2/rXEEFFAAAAAElFTkSuQmCC"

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAepJREFUeNqMkz1II1EQx/+7Ca6JkqyYiJ8cKEpAQbBQFDm0sVOsFBS9wt5KOTgEG5twxVlZ+XEnKNiIghYKxx5nwEpIIXaiSAgKGmMi0d23u8+3T7OaZJEMLG9mmPnN/w1vBUopLPNNhRWXHOyDg0nx82TiJtZPlPVoNpftc2cTotcHtxx06kdXpSQ/BvzKESZzIDmAz6y+NojOjpDMZiqRPIgNoFyWM8DrKUV7axO+gcp4g7AzmquAdVNqOgL2z2I4id1B0wgeygOyt/rLL5buLwAIDgA9dY+L+DkuDQOCrkMgBsRglcMOqAGwIstMg8AkGsuZMNUMRMkLqE+QGloglvlA7uIOAKvZajR0qJkUj/XHe0BTIclVKKlrfKsj9qA8gA6wqSJzPaXlr7ky//tdLEUfawsBjExUFGVWbT7AxSa42H2LMfODmvd3wKb7RAMLYwM8nts8xJ/pEe7/3PmP2eGv3D+9usb35W0bINoA7RmjXSHsH0f5Z/mUSZ0Ir2JmsBtD80s8/rGyzWsLFTD5yUQCbfUBHl9d38LvkdDTXIuHVBo0k+bbt06qO+yAPGXwe/cA4wO9PN44jKDG70GougIzi2tQ00ms7/3lpwnBBgjZ37Kkd1Shht5XzBIFl/ufFtniT/lFgAEAU//g6kvdGBMAAAAASUVORK5CYII="

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAcJJREFUeNqMkssvA1EUxr+ZjkdbrfFKVD12ErYSRELY2fkH+BMsLcQaSwsrSzZi47EjJEQkEhYkFlhYSVtFpdqOqpk717l3jKZmiC+5mZlzv/s795wzCuccQncz3YeRBj4KHz0/RrOZe2NsZPP20o255zQ3EAxzEAC+6uzTw13G4TFQAakA/CWtIYbY0KBOrx7IvwDQqlHV1o3YxKTOvyAUvfQCfqmA3e4ikyS/zRAKvOot7eoSHEgZIHrCfQAfBqBaKQQDKScQAExd8emBANg+2U2CvNMkkgSqBmrCxFB8mujeoJBWwEqARcssKTAJEGrmaGrjqK1zvNknH4BtyxKl2VUpRxmj5W+x73q9AEaZrR/ND1EJluIpS3i9JQiA+a+hSq8HwJjTsLrRaWitPTCOlhEZn5N75sM1qigmlN+dB3u++Qao5W4TtbEXXIsiszGL4PA00itTsu6XnQWo0TjMTAJqfMDx/ryBJcaVzSNSH4fW0Q+rkIf5rsjRiid7yyN7uoXS3Zn0egE0NiORAN9bQ017D1Lri7CLlP2EDr3Rf7C/itzV2bfXA/igLDaRixfngFhSCooH2xVPCWBlwKcAAwBX1suA6te+hAAAAABJRU5ErkJggg=="

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfZJREFUeNqMUk1rE1EUPS8zmabJdDKB2glEwY9ExJYiBUEQpV25qgtBXfgbpEtXuujKf+AfEKRddOdOGHClbYVCvyKWaijT2mhjphk7Sd7Me76ZONp0EsiBYWbOvfe88+69hHOOAE9f3zTVnDKNHvhlsfqPw/rM0ovyWsRFdXJEpDIyRnSlVz0KSkmvabaJeXSJBEhgAJzTDNybmtUnS5Pmg/lrN07H5NM/f13FoMgpXDSuhiIiK3Qi6LUugX7FAbaPPsJqfIHHKCStqRsXVFPQuZgD9BBxjikSiRq41AAkgCQBzVf0+BWEBX7GBm0xgHHUqk1UbBuEcIydzyCZlOI9YEGuDxwduCCitS3Xh3viCZ4jrcq4PJ6DLHd67tjtuAAXib54dCPVEfQ5XIcik/0/2iDeOYz3ceCxrisMi904y0XiMQFfkB7lg6xFHwFxEqUMV0anUNBLWKm8xd3i4zBWOzmASx0UsiW831mA59Xjm+h7HCOygduXHqJatzA7Poey9QnXjTuoVD/j/sRcmDOWLgqnLC5A2wwST+Pn8T629lahSCo291bwu9XA7vcy3m2+gTaUR14thrk9BXasbdiOjSe3nmPpwys0xSi/HpbDd3bIQC6dx/q3ZbRb/j8BEi3Po5cTJpHI9CBNDEa++GyDBN9/BBgAwfDlCVUQaNAAAAAASUVORK5CYII="

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAdFJREFUeNqMU89r02AYfpJ0iVm7EqhVOxw7dDBEdpiCE1RoEZRddvUgbIex/Rs7eehppyF4LOzQu4MxwYp0HgShIuwwUVSCVtl0s13afl+SzzcpyZYmyF74eN583/s+PO+PSEIIeJZdrtQVI19Cgmk/Ph39bpllXq82g7sgLxVcyKNZpIx8Uj5u5zSjc9Gov8ZihCRC8D+7On4JczevGeTGSEIC4ctKJtB1DTPXi1iCCEkIm1EFlC2Em0iwtWfinXkIzjiO0jljtDC5TtflGIGUQMB+mfja/oPv2Rx9MMjpMdJxOXyXTwkcwIkewfqQ1QtQNB385zcI14FrtQexsSb6SRysZ4Fbf+F6eHwATc9gJGNAm5iCTL5n/LCVRGADNoeaGoHqyaXj5gqQlTODovcwNk5Aj6wXqV8eCo7EDhMonEHpW+dZC7gUG98D3geo7vkb01h9cAvPdt76OGy1xntUd3bjUxAk3+l2sHJ/FgtrT0MUJNfDSm0bjQ/72Hzxxo+NK+h3B7XRNO4UrwymQtMIkdTBU0m+sBOayLsn8Ka78mQDjx/e87HXPkb1+UsfP37+AmZ1fP/suknBb6nefVQXjl06TxMlJfWKNWr+Kv8TYAAkUueexJF47QAAAABJRU5ErkJggg=="

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmhJREFUeNp0U0trU0EYPTP35qYxaW6TlDapNKWGbgo2FkF8rARB6rboXusf0F/hyq2U4krFqugqSBeuAyL4SERBstHa0iR9JKZJ7mvu+M0tqZGkH3x8987jzDnnm2FSSqh4ns0VU1ybFzj674Wa3uWiWbfsFQb+jrGj8Xvbm0HlvYVRxhJprpmTlGmum+OMm5uNPZNbtjk3l82ey8++8oW4Jv/H/wdA456g2kvH99FyHNiuAz2dwflbN8YW8zMK5Go/CMfQkAhpGsyQgRCtlpE4jIULyC9fHzu7MPPEl/5ib6WOE0JJNRiHHg6j86mMjw/2gG4bkbY4PW4Yj2j64skA5FTHdaEMPiAJszt1sK0d4suJmY4k0+IDDGRfqmh0u5gejQc+fG8eYCIahRQCEfgQnIuhEkgtONE+dGxYxEDj1DhiEycZ+1YXdUpHCqTMJIYyEES5aXXQsi2kYlGEia5GtHVKn+amPBeCutPgfLALPuVu+xDVPw2EQyFEjHDghbpYNm1yKVVnYjTOerepn4E6XQmLGSPkPkOXWATMSDcjQEkAaqOu6+i/rccALtFL53LI3r0Nq1ZD4/MXZJaWYFer+PXiJc6s3IEgY3+uPYZHTAcAHM+DTE8gnM1CSyaCulv+GrRy8uYyElcu4XfhLVpkpNtn/DGA5Uu0abFH36WnzzCayWAkmYJvWeCkfb9SwY+NDbSoOx4bYqJF8rZqVRRXV/HhzWtUSmWwmWl0RmN4v76OUqGASrmMOkntSHF8MOs954dT08W248wzYsJDOujRBAaqqikTpRo/qqd0/dv97c3Lat9fAQYA4z8bX9nTsb8AAAAASUVORK5CYII="

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhNJREFUeNqMkltrE0EUx//ZbDaXNrvZzdIkbYOXGgxYQlCK2IIY6EufxGdB8Av44AdR8AP44JOPBR+Ego0PClUKTTXQSmkTYtOkmubSJrQ1e3H2yJSEJNIDs3PmP+f89pyZcdm2DcdWvn7LzkxFHmCIra7nm9ulg8yLZ09yXON55Dgjt1PM2iPs0+aW/frdh8bzV2/SvQBnCLiEqcFxLKSSodlrU9leiGPihWePBkgeEZO6ShC2dCAZNuf6ADb+ldQ5PUPx4BCFcgXfdwq4Ph1Dtd5CZi4Nw7SQiMdCXkl6yVIy/QBWgcU+yx/XsLK2cdHndqlK/lZxH/OpJO7fnsWY3z/YAq+g0TmHpoUH2vB5PXi8RD9Fo10aAmDJTgWyIuOupmK38rsPcOvqJO33XWEvwLJsmKxHRVEwf/MKWl/yUMf8mIloWN8rw+sP0D6PHQmYuzGNgCRiMZVA17IQV4OIaTI8buH/AJMFd02Tkp05PO4jnWvc57EDAINt7u1X8Pb9KgI+Lxbv3cFR8xjx6AQ+b+Txs/qL9KePlih2CMBCq92hg2qzt1AoV7H5YxdhdqhHzRbgcpFeqdUplpvQW4FhmAixZ/sws4BoWCM/qmsE5XqE3dDQCrqGAYWdejqZgK6GUD8+IV9VghBFN1RZJv3sT5diBwC15gncggCPJKF0WCPN8dun55jQdVpz3Ynl9leAAQAJhiGatD9AOgAAAABJRU5ErkJggg=="

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmtJREFUeNpsU9tOE1EUXXPp0CAUWmJbC04xBANNTF+kKhG8fID6aqL/gPEj9E0lIf6Dj30HL03wxQtVIC0QKrWxNG1Dk9Z2Oj1zxn1m0oIZTnIyZ8/ee+211z5Hsm0bYg29fLGpxWIJWBYGS5IA8ncKhT9Wvf4Yqprtu+w3q85X7f9QxseD/pmZMZsxN9fnc5JNw0ACGGv6tPSvyvEDKEoWZ5Y8OHHObKpucw4B0t3agnl4CJPs2YkQVu4s61ORaBqMJc8CDBiIRhhVM9bXYdVqYAcH8M3NgS0tQQsFcfdKHEbvlr6WyaR/V6uPKPy7B4DT7lUq4MUipMlJ2MPDUKtVfKZ2nn/5BoNbkONxXeb8LYXe/A9AJLNWCxgdhZJagDI9DZg9qIkEytRSkdqTSFQtGILSbgc8LViM+tc0yPfukzIyOJ359k9YR0eQdB2KmBbpwXoM3Dod1SkD+scpEapCI5DdpsJhIJcjajQZagcjI+5oLe4VkeQnyiZgdIH2X6BJ7dSqQLfrggjw0AQwP+/GegCIHppNoFAgEMO1RZKo7BQgRi3yN05cnwdA0BQMAgF3C6pnbuNg92M9AFT1diSCh6kb+FGvo2MxnBB9ocZxp4Mns1cde213B81e7xwAcl4jkaa0IUSjUdLJwkL0Ej6VSvArCt7l81iku6GrKnYEU89VJlSJRmR0Dax+fI9suYxSo4HlWIw6M3FBlnD9YhiXabyOsOeIqG7TzDeIYo6EDGp+ZPb2kKKqH8h+mkxiI5/D1/19J3bwYPvPWXq2skkiJVxesqt0XzghpKM8nRVV2Lv2q9eLIvSfAAMAaacnllcFBmYAAAAASUVORK5CYII="

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAkhJREFUeNpsU11rE0EUPTM7ySZpmzT9DNamWAtFfSiCigr+AxF9zKtv/hvf/Aki+FEi6ov4ItWHPGiwiBUKoUqqTUJImmR3M7Mz3t0kNe1m4LIwc+65595zlxljEJzdR5uf5nLmsvZx6gSvtd9W9bjhF7jg5dH9nRc/wq8YXaTSJptb0xklx7IZoKUEz1zJ2DUU69/37vFYrDxegJ9U0lC+AoIIVGg9CL+vIObP48KDQn7x0sWiVnJrnEDg7KGk+i/Ac4iUM/R7BsmrSSxtXMfa3X7el8+Kjf3KfUJ+iRJQw4w0Tc8BRyWGRAZY3rBR/VlC+XED2ayDhZyXl03+hNA3TxNQshlGLAnE44zCIL1goXZwiMNvB1i6zbC0KuAsxNITWwgNMYPeLVJiFEO9ArjHAivrAjNzBr4f4vwIgdGD4YUACsZCE8AtYGWT5jCsGQw5wEYJzP/pj5RwYTA1b07eQmfZ8P0sgdaM2FlYwWkMgMpl6NQAO33GKM0wsQWflkh1uqGVmVWblsiDkQyqxwfag35SqcktaEWTUTHYNx4iGU/C29+BvX4Lpu/C7zYgFjegSY63WySsHyXwpYHU00ieu0bAOuJbBTArBkiXKiaAmTzcvRJUV9E8rOgqBwqlY8ASs/AadbRLb8CzeTjVClqft6FdB17tL7yeCbFRBYoLr6vR/PiSEl5BZJaBD0/R2nkOZqfQ2fsKt+0SEQ+GLSIEUvJm+6jbah2+pS2aon+4g/afd4SYJVuA7vvXdC/IHQtSoTnK+yfAAIEaId1m+vudAAAAAElFTkSuQmCC"

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAqxJREFUeNpsU01ME0EYfbtdKKWGtoItRWgJHApCBE2I0YuoiSaaeDJeOJh41YN3TfTixcRwMfEk8eDJGA+Eg0YTTRRMg02KKFooCBbTlkJLS7f7P+u3K9Xo8iWT3Zn55s173/uGM00TVlwZfzJztD92iKO5ouvQGQPHcQDN380vlDPr65fdLj4Oa41i9sFt+ytgN7o7woGOrqgvvpLBaF8vWj1NUAwGTVNRM3mf5vU/zaU+XySQuTqIFXz9hxmGLkoS7r+YxvVnrzGzlgXPDOzUZPT4m3Dt/KlIuH9oUjXYEHZZ/wOgGQZi4TZcGI5hLb+FO++TSOSKcLtcMA0dI0EPrp4+HtnfG5skiUecDGwQE2MjAwiGWlFVNDz+tIyCokJhPKYSX7Gdz2I01hOJdnY9rJ/7UwPGTEiqjtbmJtw4MYx78S/4Wa3h5UoOYwPdIOp2Xi/t18rlFgcDw6o+ydiWVRwOBnCpL0oOAMmNEhLZIgSeoxwGSWcERon/M9DoBknTIdNQNAMnO4PIVGpIFXcwndlA2OtGc4MAxml27p4AIulWSIa9QVadiYSoJxhqBJivKgh5ad3k9gaw6JdlDaqq7q5wINY4F22HaLHSDZQkBW72O9cBYFEviBIURQH7a7MN0uDisUW12ZZcaGlmdq4DwCqeTo1zNtZuW7hUqGIw7MNqSUS2ImNsKEpSdEwt5lGhfQdAkQBEoub3NNrDJfAIeBuRrcrY5xGQ2RFJAjl00I8PCckJUCB9q1URBnk38XEJEuk41tmGwZAf66s1VOh2keqwoUnYpFxHH4iKIixkN3HzVQKP3iQR/5GDKMuYmE3h+fx3MHqh1sMafztHLuiCg0FAk0uFdLqcpGY5QEXbTC/j7mIaVjc18DxufUtBJ/vcggs+3ijVz/0SYABsJHPUtu/OYwAAAABJRU5ErkJggg=="

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlVJREFUeNpsUktvEmEUPTPzTUFmgJK2UqXQFG3pA6OBLrQxamJcaYwuu3Dp0l9iXLvVtRuDpgt3JIYaTVSaxtRHsJq2xEJBHgXmifebMhECXzKZme+ee+65516h2+2Cn2cb2VwyHl12//vP2/zOQaF4uD7GWN69e/LogfNm7kUsPBFaXYwHMeK0OlpQEJApHJTuykzK98dE98O0bLM/UNgr4v32Dj1fwSQRt9dSsfmZcMa0rIv9ODaqYrPVxuPnL1Cu1aEbJu7fvIZUIo4bqeVYRzcyv/8c3SPYpwECt/dmu4ON3Ed4TymI+hQc1ZqoE+F+uQLDsnHlwkKMscJTgl4eJOi9fxZLePNhGx6ZQRRFqH4VjZaGSv0Y6cQcJLpra0ZguIWegqDiw7lYBBZV6xiGk9DQDLzK5bEyF4Hi9VLMsoYI7J6Es5PjeHjnOl5ubqHaaJGBEkzbxplQAKIgDmBHekDTgI+qKKqKLvNApgmEgyquLs1CoFn2Y4cIeLJpkjoCLkWnUSIF3JxISIUsCjAoxhWNJLBIJs3YeXj/08oYZkOKY65HllE/bkMmY504YUd40HUq2JSSyW6iVPmLiXE/ZMYQCU+hXK3h1toqdNN0sEObyKtqtDQ6kXDwcadDS2TBryp4nX2HxXjsJK6bDnZIAZem6Tp5YMMmicn5OC4lztNWtvB9cg+hQABtWjKL2jH/T3GgBcYDXEE6mcDM6SlaJAGMWkivLBC54ZgniZaDHSI4rNSqn7/t1vgkGJPwZXffSeCjk2iUWz9+nSTQN8e6ef8EGAClUi/qoiOc3wAAAABJRU5ErkJggg=="

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnVJREFUeNpsU8tu00AUPU5sp41NkzRxpfSZqi0VIIQqEEJUZYXECvbwCWxYsuBD+ABUFrDrCnWBQEJdIWigBSr6pqRJ1ebhxrE9M7aZmSrQ4o505fHMnXPPPWdGiaIIYrx89GKpNDdxmXkU3aEoCsT+z8W1Sm21+jCpJctQTvaerj+TX7WbnJ+0cpfuX8mQtn8GgJ4AZtIFY2Hz3foDVRcgyt+cRHcS0IARh+D/8G0PpmVi7smd0dLs+AIjwTVEiANEYYQwCHlEZyJgIQKfoX84g9uPZ0cHZ4YWmE9nuufU0wABCSSImMsWEgqSuoqA/39/swZFTWLy7vQo7dDnfPvWWQa8GuOV3IYLJXmyzDzG2/ChZ3pwbHdQ267BKJoYuj7SF2MQhiF8LuDK/Gf0DKTBKINz1IbTbEMzU1ANDW7LAfEIQKIgBsBFlAx6LYOz6MAcvoDCtAVGGPKlAiIu/F55F33FDA6W93EOAOMaMOl7biKPwRtD8Foetj5sYPfTDtxjl1f3Ubo5jkQieQ4ACSUD2iE4XDpAdbUiW9D7UsiN9WNkZgxajwbd0LGzt3keAJPUc1N5SVeENT0Ao2BKV6QzwlZeRBSKAYhe3aYHcZWn7l1EfjyPypcK9LQGa8qCvW9j9+MvaasQOHaRhGWdhsNLR8hwodYWf6B4tYjDjSOovRqq32rSYq/lytw4A77o1V2ERiAtzY5kkUrrsH+3QF2KY87ArTtQuQ6nAf4x6FCV1D001+vYersBM2vA4y1Rm2D7/Rac/TZIw4d/6MrcGAPf9htN0miJh7Lyuoyvr8rQeP9iVJcrSKgJ+TrFcyYebXTP/RFgAFQobmIOBxbsAAAAAElFTkSuQmCC"

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnpJREFUeNpsUktPE1EU/u68OgylZXi0hZACQU1LEKKCMcat7jTRnQsXxsQtv4E/4M74P1iriUaNCw1FgxpjCJQKKAU60+m8mJnrmSll4XCTc8+959zz3e88GOcc8aq9evChOHl/lvMoubvWX/z4+BwTlbvw7bXdg8b7h6LE1gGW+O88CRMt4XTlR6/rYxce5Xv3jlHH19fPkBu+gWy5mlcFb3Wn/umeKOEMJF5C7xCFbtA9dRXjFoYKGiTRAlPGUV1aKU9O3VwNQ74A8DQAIZxqAuAhBPIMFYpQVAVB4CPSZjEzv1weH5tbDQN+JQ2Abu488mnzIbAAA3o/VK2PwDJo7r5Fy7ZRuvi4PFS6+qIXdVYD8Jg6BUcuOD8BozSLlRWyicgVKkTMQWwUlFF0Ooe5FIPk57BD7G0SiywyjD8bCDyHsOkeeeR3SUxEkROmU6BfQYFJMHfhWXV8efkUrb13VPMTsrcTQSzxZ/+n0GVA6EGbSGdgG9vo15fg2nFgbO8k70SRdd+mahDT81vUxTZRlJBRMsjq89C0EXCvSf7TIBZ136YZUJEiE7LgJ2dN01BZuE0dkIhxE7KcQTK1QUj+cwAEyrPZ+IydzRoyah+mLy2isbWBweESJEnB9q+1RM9Ub9GQOWkABg8HjRr2d9Yh0hTlBlRsfn+D4vg0BvUC9rZqECUJuk7Tzr1zahCYlB6HJAREPwfbbMBzLBzsbUKVI0qBgQkc+SxgWUYaIAqOpKwKXJ6bgGlaaDV/YvHaFNrtDsKTfVSrJeqIg/bRNwjclFIALeP3saybhu8SC4VBHwnhBXXIKocYRXD9QzBi4Xgchmkd9+L+CTAAMqwy+ZzluBgAAAAASUVORK5CYII="

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAixJREFUeNqEUktvElEU/mag5f2yJhXLwxIt0kiqsVEXujP+A925cu1Pce3WtXVtYuJCF7KtTY0NrVQIpRVKeXTkMcO9F8+9ZVooJJ5kcmbmfOe733fO1YbDIWS8+/g1dycVX7W/xyO3vdsuVKqvnE7HZ230783rlyo7bVBicSGyfjsVwozomVbIPe/c+FmsPHfoRKJd1HT7hXHBZjVbA4aA14NnD9bC2VR8gwuxPi5Sx39Cp+M0XUP0ahhP1jLhW7HFD4zze3b93ILtXYyyVKlR8/5hFbnvO9gtlrGSjOF+OpXkYviWyo8mCS4R6bqO4p86vm3v4fC4DrPfw4unj1XN6JvBaQtjChzUXK43sVU4wNFJA43Tv/B73edQwTmfIhAjCVL6UdPAj1IVFSKhCdAcAI9rnjBiAjtBYEu3GEeh1sKJ0YXR68sVIujzIhzwY8DEBHZqiLRKkicQDfvABxaiQTc4Y/C65pCOXwcjcmlvJgHtlwi4epYifiQWgmoLZwPW6HQG07LgcOgKO0UglAKOTt/E+09fwAiUWU7QAE9xUK3jbvomsispZVHMVEDSZdHo9rCZ/4VIMKAu0XGjpU7d2S8hk0pCELHEzrjKnCQOYJoD+Dxu1RyiwUm5LaMDo9NFt2cqDLvY4oQFp/QpfT/MrmI5FkWebt+NpWto0j2QmQkOjZ9hpwhqjXZzM/+7LU+cc7lRrjXh8/lVLRK5ovLWXglOsiOxdt8/AQYAzv8qbmu6vgEAAAAASUVORK5CYII="

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAe5JREFUeNqEU01PE0EYfnZmd5FSvgLYFuwWt9EgHyEaox68eDJevHvwJ/hTPHv1N/QgZ2NC4g3kUAQKFKGhjVKqRrvbnRlnht262FHfy+y8877PPM8z71pCCKh4/ebt+rJfXEz26Vjf2mnsN5rPKKWbVpx7+eK5Xu2kyMtNTd5d8MdhiJ9BOO7atFI9ajy1UyAqSPIRMR6ZmoNehNHMMB7fX/UWvEKFMbYKE8DfQnAhwRmmJkbx6M6S5+WmK2Evup2c9yUk2nnKA0XVcSiGXAe1k5beP1i+4RFCXqnPywB/AKVzK34RjHNYlgVKCH50w7EBBogbTa/AVM5SgBdn0gc2AMDjPsbFPz2xye9asweS6n+NTbG8BCCfUtLjff2WoVnVpAH6z6hMUtJE3EykYfpF4vUiL3QNS7FMeSAQRBHW3r1Hq91B+VoBQRji4+ExFsvz6Hz7jm7Yw5OH92AcJKW9G4SoHhzhy/lXbB98Qmm2oCXN5WawsV2TACEoJXqwTKOsb3BtR2ucmZxANpPB8JUhyPnHWDaDpfJ1eZFALzJJ4MKO5MEtv4TSXB7V/br8iQLMz+almRZWbvoo5q9qRlxwewCgeXbe3qrVO5ZkUD/9jJGRLPaOm6COi92TU1DbxYe9umRD0DrrtJO+XwIMABWp9nS+FgaoAAAAAElFTkSuQmCC"

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAh5JREFUeNp8kctrE1EUxr+ZyXMkoa1NBROaSkpTBE23PhZ25cql2y5duvAPUdGFS1FxIRRBXZlFQ9GVdDENIhGJxkDsw2mneZnM83ruNZlOmNoDhzlzz3d/9zv3Sowx8Ch/qlYK2XM3cEJsbH0+qjV/rd6/u6aN18b7RMFT+9aosP/Ex+0ae/puw7j36PlKEMAzctKJ3aGFamMHjV0d+wcGitkMrpWWp6hVIciEk2MAOwbUWjosx0UiFoWqJpGMx5DNzODq5aIPoa82AWBg/lyKLMH1PMp/a9XvLXLzG1cuFlBaWpiKxaIPSLY6CaC93ggQjyiQZRkeQSzLRovGaPciWLt5faSWEBoh6KBvOhiaNga0+Y9pwaFxvu7rfp8F5pWDt+qNMp2IijHGwddWCvN+33/CoAOP5nVdT9SdoQ1JkggiQ6Yvr7V60+9z7akA2gfH9cRF8hO5F5Ve4lQAF9uuK+qFsylkzsQxrcaQm04hdWkR83Mzfp9rQ3fAFzu9Ph6+WMfjl6/pGBdb2jbKmx8QlRjWy5vkyhUZBPgOeGNHN9AbDLGUz6He2hVj3Ll9C8/evsdgaMK0HV8bcmDTU0UUBYXcedR+NLGnH0I3jvDk1Rsy46FP4C/1BtrdntCGHNiOAzWZgEKQ5Qt5lIqLojbaXSQTcRy2OwT4SZqk0IYAOgkVWUE+lxX/zb0DpFNpkTzmZmfFtzewhHYcfwUYAMZmVaZQlLFHAAAAAElFTkSuQmCC"

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnxJREFUeNp0U89PE0EU/ra725K22ILRGipb22pMG6JcSEQTbUIwnozxpBcvepeEP0KPogcT/wlNT17kIKbEmChFUYKGVtL0R2gLtNCl3Z1Z3+zSAlonmezOe/O+973vvZEsy4JYnqdPMu6RkSQYQ29JEkB+PZcrslrtPhQl23VZc8/tr9I1yMHg0EA8HrBM04lVFAhoY38fSSDQVN3pfKV8G7KcxZHl6v1xblqU3eLc3p2VFZjr6+gQgwsnhzGTuq6Nhs6kYZqXjwL0GFhEl3U60OfnwWs1GGtrUKNRsKkpeIIBpKIRtI1J7cX7hXRhc/MOhXw5DkCZGG2zXAajzFIoBMvng1ypIKOqmP30GW3OIEcimovzlxRy5RgAFwDEAIODkCcmIMdiQLsNdWwMZdJlg8pzEUt1aBhKq3XinxKYqF9yQbqRIqsMy+0Gyy47bKgUWXSLtDENE5wdtuqQATm50F1VnPbRGeEw8HXZbiV8fsDvI9ldju9vADAyihLEbrWAZhOoVp3z6iqBUiB1A4nEfwCEsbkL/M4TgE5n5jDx+oTEzp1d8m9tC8H6MaAB0imzx0NU/WKUYE+loEyawDBo2ui6TGfT6ANAxrvx87gYCGCxXEKVJvCWFsG3eh1vN/J4OD6Od4UC8o0G3TX7TGLHwI9iEQmvF9X6Fh7F4/iYy+GcLOMSlfEgGsP0qdNOmX0BiGKpVkV1bw/1nW2b/gCpf1PTcI+Y7eg6ps+G4bG4PR99SjAVo9HE4q+fKNE0vl5awuSohjeijbRefVjAtUgEQRK7Yhi9OKn7nKWZxxlSPWl3QwgnaIrW8QMhD542vUbx/W49m7sq4v4IMABOqi3Ej7bAEAAAAABJRU5ErkJggg=="

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAnhJREFUeNpsU1trE0EYPbMzSTfdtInFtkkpiaXVWou2FRUEn/so6JugL/oH/Af+B1988if40jcFERQURNBSQdDWlLQN2lsue8neZsZvc7FoOrDszM75znfOmVmmtUYyvry++36yfOeS1qqzDtvH2P76ApPlW3Drb2sHex/uccHWAdbZX30kO2+B3siN3zhTnHuQ66+95i423jzFzOVljBdKOZNHazvVT7e5wF+SZBj9iZJ+3J11mbW2kR8T4LwFli5i4fqTUvnczTUp9RLtDhKgJx0q4dEwWAxrREKICHEsoYYXMXvlcWmquLgmY71yCkG/c0AkARgLMZpnMDMpGNzEYe0dGp6HwvmHpbHC1Wf9MnFCkHQOyYEPzSJwQ2B65Tm5NZG3Fshim6wbMNJn4bpHowMKtIqo2COgR2IcAptwjvcgo6i77igjEmVDqbY8xQJ1VwRULhiBI6+G9Zf3cbTziuzIDkmHSNqECTFgQScEcYuc2NA8TcdYwXD+GkK/TYVN+u72WrIudiAD8o6oAR2RRCmQMjis3CIy1iSpPySCXhFTXeyAgh4BR+JVw8pauLi0Cp4yCX9A90FQhnSBYtnF/k+Q+HYam9itfIZB3QvT8zj8XSW5EhNTs9ivbSLwPUzPLNPJBIMEKnaQYg6aB9+RGR5F5VsNgnNKXMI1NdJGG5WfHzFVLJ7k8c8xUngpVodlDSGbFYj8Y4yMpOG09lHf3yIFPzA3fwHZTAQVtU4JUTeFDrdgDdlI8wAz5Qy2KxswReI7QODZcOr0ZH3q2hIDBI7zq16tuk3FNPxAI4wN+pkoccYoE4YJU5EdUtM4Qst26v26PwIMAKj3P/2YUKgYAAAAAElFTkSuQmCC"

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmRJREFUeNp0UktPE1EU/qYzHWstlrYJNcWUElyUJsaNGh9B0g1Lo0v9Ey78EbrVxBhXuHShm25YGBJRQpAYBDEWpaEPEhksdVpbyjzveO4MfZDCTWbauefc736PIziOA77OPH2yJCcSGdg2uksQAKofFou/7VrtASRpvVNynj13f6XOhjg8HAlMTIQdy/LO+v3uYUPTkAHCTb+cK+0pdyGK6+hbvu4/xiyHbncYAwfR19ZgbG/DoO9LsSgeTd9JXoxfyMG2rvQDdBlwIZauQ5ufh12twioU4E+nYU1NIRCNIDs+Bt28mXzx8VNuZ796j9q/DgAwomwqClilAmF0FE4wCInAlkjO4y+r0JgNX2os6XPYS2q/cQyAcQatFjA0BPH6NYipccAwIGUy2CVJFZInkKlyJAqx3T4/IMGmJkeWIWSz5KgI5pdhb3yDXS5DSCYh8rTID8s0wexeVD0GtMd85KkkefFxUfE47M1NokbJkByEQl6tL+ouAI+MUwbFhnYbaJKc/Sqg0x4H4eDRGDA56fUOABA9/GsCpaIHwr8FOhQ823O5RfW66tUGADhNy3RNRDjcN41HLxdQ8J6jYTsOQLfOJBK4f+s2/uoathoNGKT1MtFeVHZxdWTEZfEq/wMKl3rCJOIzTV6ADs2R5ulYDDNkYjp0DhrF+zCVgkw31+v1UxjQZkNV0SADd2o1MIuc9gmY+/kLxb0/UFoHePd9A1qzeUoKpilx9xcLWzgg+u/zeVfuQqkM9bCN1ysrWKXxdtPgvScwUAm58XZ52W16QyPtifRUzi588GbEi1ztHPsvwAC4uC9qhnsZvwAAAABJRU5ErkJggg=="

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAeJJREFUeNp8UrtOG1EQPfsyXiyzBguIJSyChZBBEFCKpKHLo6egpErNn8CHgH8gkZIiTSIXLhJAWCgkoMgRMSiRBSK29z4y9+I1d/HCrFb3MTPnnjkzlpQSynY+fP70fGF2gQuByCz6lfdd9Uurfvrrjes6762eb3tzQ69uFJwPsqOPC+MBEmxxphi4tlU5OGmsOzaBWLc+O9oIIVhScidkyGZ8vH62nHtSKlaI4cse6TjAfSaFBBcco0EWqyvzubmpyQrj/FXk75cQaSEMeMXU8xykPA/Hjd/6/LRcyjEpt2i7HAe4A2TeLZWKUOJaVLxj27j813EHGKCXaAJExu/4BOdiAED08riQD2riOrexyRoYc3CvsAbLGAAjZga7vgZG23WMCdBvoxKJc36TRBlMiaa2JByjNqqD8qkYc1pjDK7abey+/YhrWlfKswhpiCR96aEU9o5+QE3g2ovVWDm2Sc22bBQm8vrVpbkS9r+doPr1EOWZaQ0yFoxg2PcREosEAI4uvZhJpzFMP+cSXRbq+043RManez+tNWKMI6GN0g0Z04HFR+NoNC/0yx717efZOSbzY3AcR4Op2AGA5p/W31r9e0vNgSrh9OwCrpeCkqvZuqTybnpRqx/r2CjvvwADAJC/7lzAzQmwAAAAAElFTkSuQmCC"

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAApFJREFUeNpsU1tPE0EYPXtpKbX0wqUQKVQMFdIXQBNCQBs06KP+B8ODGh+Mf4b/4IsGE54kxhcMBrkp7YOQgBRvSKG73fvsrt8Otoask0xmd+b7zpxzvm8E3/cRjPkniyulW0NFy2JoDkEAguOlpXJ9p3L8MBqVl4O9YHxae8pXuRlcGO7KPLhfTDVUqwUgigJMy4Whm6lEXHjxYf3XnByRN0QB/2KaH7btMlUxoRJAcyqKhdOaht7+DJ49n+2cvTnwynXcsb+kLwJ4rgfmMDDGWqvneXCZS9ND7mov5h9ND85M9y86Dpto5rUkuJ4Py3YDJpy6QGJPayqB+Njf+43XL220t0cwOZkfrNXsBUqZugDA6CbLdAiAwaek1ZU9LmP8Rh6S78GsGxjOp9FdzKJaVZIhBgGASzK21w/wbrnCk8euX+EMAjaaZuPHdwUdHVFYluuGPGCORwwYjg5rqOwccRk+3Ux0IEvntmsNG4ZmUayL/wAwKHUNfZfTKN0ZRaw9Cof8qJ/pMAyHy5KkAMTksSEJtnMenM7EMVMawbejMzJRh67bXEYiIXEAVTW50SEAhzqwfqrBcXx4VOhYm4RsNgHbsJFOyZTsQ1MN+hcohoUlkFiMT+TQFpMwXOjGpXgE+XwGk1N5pFJtKNCequgYGupCRBbCDOp0KBJc4VoP3dyBONW8uydBgBHUThqQKCk3mEZ/LoUG+RBioJO7VarAwEAntjYPiUUW9Hh4b2R7k9j98hN37xWx8fGAt3eIAdVMLn+uUv+b2KReSCZjZJiB9bV9jIz2ofr1BKvvd7G9dRC80lae0HzOt+cWVnrSKDrMJykifwNBpCgE/UAllEXufmDu8Zlffvvm8XSQ90eAAQA0pF7c08o4PAAAAABJRU5ErkJggg=="

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmxJREFUeNpsU0trFEEQ/mamZ3Y2+0zIC2MmITEkUYgERFQErx5E8KTi1b/h79A/4SW3nCNeYggBYZVEMU/y3N3Z7M7OTD/G6lk2ruw20zRdU/XV91VVG0mSQK/3n1a/jky6d6Xs3G8WXS+Pw5N6LXjLLGuna/78oZKerGsYKtrDE16uJGL1L9gEOOcYd2dL1fNwrbL//aXN7J1efPMmkUqEFAk0A0VZNbFEaQCBscIkXj975y3NLq9xye8PBkAniHOFph+j2eC4rsdoB4LsFubGl/Hq8RtvYWpxTQi52o1jvWiGYaRZL0/auDgOkC/Z8BYL2Pqxidp1FZkhoDxpeaXA/Ujuj/4HoOxKKjiOiek7RUShRNQWaNYFQuMafrYCxiw4ozZKfqbYJ0EvRdl1DQyyTs8XCNTA6UELMwvDyLpZWIZNNlNLlQOK2LMJRJ+5AkuZ1S7CFFzJzk56GnUjQWlYkqCoBWFbonEVYcLLA4dNnB624GQsDBWIgfZJEgxkoChzSFWvn4VpQemDm2VwXQsXJwF1h6c+gxlQ5jgSiEUEt0wdIe7tMES+nEG2aCLiJMOIIWIr9e0DEELAMUrwRuchVAyTKimUwO75Jm6VF3Bv7imOaj+xd7UFKVS/BPJF1b/E4tgTrE49J60O5kceoNqowiuuYKa8ghHXA48U9MT2AQgyRvTThE30bQiaSGa4yLMJNFo+Dq/2cHt4CYlwyFf2S6BHwwrMw/avDbR5C1k7h1YQ4KH3Amf+AcZyEbZPv9CItzQD1l9EbtYOjv74v/d3O9RMPTDrsEwGIWN8q2yk7XNYRs9JrRv3V4ABADSGR6eQ0/NQAAAAAElFTkSuQmCC"

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmlJREFUeNpsU8tqFEEUPVXdPY/ueWZIoiYZiSYKYhJc6EbduHOhgijo3t/wH1z6B0JAhOyMILhxo4kJGk1ASTAxwWF0Mpp5dHc9vFUzYwidaoqmq+8959xzbzGtNcx69PTS26ETmQtS9r4Hy/xv7MW7jV+th5yzVcaYPX/++It9u4NAv+CVR6tBUUTqMJsDcRzjZOZM8W9ZLKx+/XDb4e5/kH5In0lpIYWGUaC0YTZnBCAEKoVR3L36oDo7NbsglZwbqD6iQKOXFMcKUVfBkBAoQhlD5xxMDp/HrSv3q1JgYW3z0x0KXzkCYJaRZljru23aHWTzLiamAyytv0O9UYdf5PArqlppBfMUfu4oALErqZBKcUxMFRCHEp0DgW5Lo4N9NIN1dF0XXsVFOUyPJTzo+WBANDidjp8tgHGG3c0DnJ4uIRf4cOCBaW5KjY8xkZL72xpJ9QcFz5bVqHUJGHZL2YtNmKi06YCyiVFb4s/vEKMTAf1p4edOG6mMi1zR6wEpdUwX+vLDtkCzHoK7ptcM6ayLmGajvtex4PliyoIkFRjmUEASelB2rXQRSfjUCT9PlWpmW21iTGzCAyEkUixPRqXhe2V4zKczbdmybgkpJ0cGOuA6Y2MTCsKoi5HsNK7N3MN+uwYaWbxYfoLLkzdxcew6lrYWaZhm8PHHG3zffp1UwJSHz9vvkU8PodbcQYYYS5lxYkxTkGdVDQdV1Js1qPgYD6JIuIE7gsXVefIhIuM05k7dwMbeMmh87a18ufIMaVYyprrJLgje2Nr+1tzYXANnDnr3zRhHj37Vvy2wpXHtNAd5/wQYAD6WMuT2CwoVAAAAAElFTkSuQmCC"

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAilJREFUeNqMks1PE0EYxh+g3W2t1G0sEqyISynUFJsSOShNwCamiYZED3LgIkcuxoN/iCZePZiYGD2aGD+i0F5KMChxlVaakAK2ykcAt+WzdLu7zkxo3WZL4pu8mXfmeeY3885ug67roPFh5nvc62m9hjoR+5LMp7MrkYf370qVtco+VtCUFpbj+jGR+JbWn76OyQ8ePwsZATQb8R/hanZgINgj9IqeuBFCw1Kt9OMBnNWCs24XwkG/QKYUEiGjVAPQof/rq0783pShET3ULQo8xz0iS5FaANmrHQH2DoqY+DSLSz6RzecWlnD9ymU47LYjd4O5BXqDTG4FM3NpTEkpdJ5rw0AowLRMbhUfp58gTOaD/UHmNQPI6YmvKWRX1zESHUJ/oBs2nmPa+Mgw0ZIM3tZyGoJwygzQNB2jNyJIZX7iB0lpPoM70UGmPX8zCU+rG8NDVxHwdiC5mKsPUFUN/gvtLLf39sFzVqaN3YrC6TjBauqhXhNA1TQoqloV7Da+pjZq1FsXUCamF29j6LvYhf3iISamZ3Fv9DZevouhRzzPfOG+3hpA9U9UyioOlTJ7pFeTCQS6RGzIebyf+oz5pSzWtmSW1EO9phvQ00slBRt/8qR3DoWdXbiczUiTzd52D+tdLmyTB14mx1rMAKVcRpEATjrsuElee/HXGmnFRyBOGD30C/nEDjNgs7CDpsYmnHG3YPegBCvHs9oYfm8nG9dJa5X4K8AAQzQX4KSN3wcAAAAASUVORK5CYII="

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAdxJREFUeNqMUl1rE0EUPbM7m5Y0Zptu21AwWwhYpfSDFh+kvvRd8N0Hf4I/xWdf/Q158F0QoQ+CVsFKaLSQpt/dpmvztTOzzky6cetOpWcZZvbO3MO5514SxzEU3r57/3GpWllM/tP4sL3TarROXuSo/SWJvX71Uu80Cfhlr/T4UdWFAVfdnmsTUtvdP35OUyQKVnJgXDBTcj9icAsTeLax7j/052qM81UjwW1QJXEhMF0qYnN90fdnvdogYmvJPU0/VBApD4hcDrWRcyikfB17srzgW7b9Rh1vEvxDlI4tVytaBSEEtmWh0xsUMwpwnWjqAlcxogiHd1wiQyCu87iI/+sJtf6+NXsgpd7FWCMB50KvkYMGMbLdZgLlfj+K9K4+FnFQ2x7WntIs50AbmiGwLILt+k+EvzvSNIHzdigdJ/AmXQRhiHv5POSwYmG+cqPVo0HqDxj8uTK2vn1Hfa+JmdIkvtZ/4fOPXU3WPDpFeNWVyUKryCiIGMN4zsH98gym3CIcOTwT+XHdXrdQQHAZotE8kBPpSqPNHtBOr48HUmLOcXRJT9dWNMGYJFby91pHOAvaykSaITg+bwefdhrteDRTMSwyrFCgI88E056Hy+4Ah2cXQZL3R4ABALUe7fqXWFN6AAAAAElFTkSuQmCC"

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAm9JREFUeNpsk0tv00AUhc+MY6dOmgeFJg1FoVVpUWlFC0s2IFF1jxBbhKj4BSxYdscPYcEmQmIDq0gsERIViy4TpD7VFzF1Ho5je2a4thOqNhlp5Mz4zudzzp0wpRTC8fPrk0/TC6+fDtYicLH97T1Kc2vQDcs+rH3eUAxVznn0fn1DRM8E+iOdv5ct3XmZG6yVlNj6solUbgVTt0q5FGtX6vXqC6VklTE+KAO/OODHSIQPRQpsXC+kkEz2ELA0ystv84tLzyucsbWByisAGf+QAS2CCDRRLMJMmxC+i8C4jdLCm/zM7OOKFGptcO6/BTpJ0yeQB0Y+mfKQuZZG0jQgeRbW8Xdomobs9LN8scc+UPHNy4Dwq8IljotIIQEm59/RoSyM1CKkXKZNBm7kIVgyM6wgAnSgRK9vqQfHPiMFDHqyFVsLR9Cm0o4YzoAASrSjCelQfRPb1Vc4qn0EY5L2W9GEaBLcxQgFHpGbkMIDJ69e+wjJ8VXqRgKid0r7ftQdxkRs9SqA2kgAm14SSIQh9uhuLGPMnKJs/5KquL1x0N0RCsizigoDaLqBdHoMiyvrlBsHVx1wphD4BCewoqxGKKDwAgtOy8JufYuk+5golGGaGZwc1sIGoDz3AOPZSVLaHgVwydoJDM1H4DbQODughB3YpOD44HfoHgnu4e7So0uAi0stHLJ3Aud8B9bpHu6vPoSu9TtDl6tUuoFiIYOgu0+158MKmOxomtyD3Qi/3MTR7i8K0EDG1GHO5DE3X4DvNahZlJOwEkOATvdPc2//hx3mXJ5lFJaF8K8bStd0YGfnOJbMGex21x6c+yfAAOlIPDJzr7cLAAAAAElFTkSuQmCC"

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_usuarios__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalDelete:state.usuarios.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_usuarios__["k" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_usuarios__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Usuarios__ = __webpack_require__(150);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalFilter=function(_Component){_inherits(ModalFilter,_Component);function ModalFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalFilter.__proto__||Object.getPrototypeOf(ModalFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalFilter');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalFilter .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalFilter(false);},300);},_this.handleApplyFilters=function(e){_this.handleCloseModal();_this.props.applyFilterCriterias();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalFilter,[{key:'render',value:function render(){var _this2=this;var modalFilter=this.props.modalFilter;if(!modalFilter.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalFilter',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Filtro',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalFilter");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus',onClick:function onClick(e){return _this2.props.addModalFilterCriteria();},title:'Aceptar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'trash',onClick:function onClick(e){return _this2.props.removeCheckedModalFilterCriterias();},disabled:modalFilter.get('filters').filter(function(item){return item.get('checked');}).count()===0,title:'Eliminar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',onClick:function onClick(e){return _this2.handleApplyFilters();},title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12',style:{height:'200px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Columna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Operador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Filtro'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalFilter.get('filters').count()>0?modalFilter.get('filters').map(function(item,index){var key='tr2['+index+']';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key,className:''+(item.get('checked')?'info':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.props.toggleCheckedModalFilterCriterias(index,e.target.checked);},checked:item.get('checked')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('column'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'column',e.target.value);}},__WEBPACK_IMPORTED_MODULE_10__containers_Usuarios__["b" /* tableCols */].map(function(x1,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+x1.id+']['+n1+']',value:x1.value},x1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('operator'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'operator',e.target.value);}},__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["H" /* operators */].filter(function(x){return x.comparisons.includes(item.get('comparison'));}).map(function(item1,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+item1.id+']['+n+']',value:item1.value},item1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'value',e.target.value);}})));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',style:{textAlign:'center'}},'No hay filtros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalFilter:state.usuarios.get('modalFilter')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_usuarios__["l" /* showHideModalFilter */])(state));},addModalFilterCriteria:function addModalFilterCriteria(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_usuarios__["a" /* addModalFilterCriteria */])());},removeCheckedModalFilterCriterias:function removeCheckedModalFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_usuarios__["i" /* removeCheckedModalFilterCriterias */])());},toggleCheckedModalFilterCriterias:function toggleCheckedModalFilterCriterias(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_usuarios__["m" /* toggleCheckedModalFilterCriterias */])(index,checked));},updateModalFilterCriteria:function updateModalFilterCriteria(index,attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_usuarios__["r" /* updateModalFilterCriteria */])(index,attr,value));},applyFilterCriterias:function applyFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_usuarios__["b" /* applyFilterCriterias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalFilter));

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({parametros:[],modalDelete:{show:false,action:null,message:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_301" /* OBTENER_PARAMETROS */]:state=state.set('parametros',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_300" /* OBTENER_PARAMETRO */]:index=state.get('parametros').findIndex(function(x){return x.get(['parametro','Id'])===action.payload.id;});if(index!==-1){state=state.setIn(['parametros',index,'data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data[0].data));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_206" /* MODIFICAR_INPUTS_PARAMETROS */]:if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}var path=(''+action.payload.path).split('.');path[path.length-1]='updated';state=state.setIn(path,true);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_8" /* ADICIONAR_NUEVO_DETALLE_PARAMETRO */]:var maxRegistro=state.getIn(['parametros',action.payload.parametroId,'data']).reduce(function(max,item){var itemRegistro=item.get('registro');return itemRegistro>max?itemRegistro:max;},0);var registro=maxRegistro+1;var newItem=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["k" /* detalleparametro */])(state.getIn(['parametros',action.payload.parametroId,'columnas']),registro);state=state.setIn(['parametros',action.payload.parametroId,'data'],state.getIn(['parametros',action.payload.parametroId,'data']).push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(newItem)));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_70" /* CONMUTAR_SELECCION_TODOS_PARAMETROS */]:state.getIn(['parametros',action.payload.parametroIndex,'data']).forEach(function(x,n){state=state.setIn(['parametros',action.payload.parametroIndex,'data',n,'Selected'],action.payload.checked);});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_251" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;default:return state;}});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
// import { tableCols } from '../containers/Solicitudes'
// const columnas = Immutable.fromJS(tableCols)
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({solicitudes:[],page:1,showRecords:100,totalRecords:0,orderBy:{field:'id',asc:false},modalDelete:{show:false,action:null,message:null},// modalFilter: {
// 	show: false,
// 	columnas: [],
// 	filters: []
// },
modalFilter:{show:false,columnas:[],filters:[{apply:true,checked:false,column:'estado',comparison:'string',operator:'!==',value:'0'}]}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var id=void 0;var index=void 0;var columnas=state.getIn(['modalFilter','columnas']);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_304" /* OBTENER_SOLICITUDES */]:state=state.set('solicitudes',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_59" /* CONMUTAR_SELECCION_SOLICITUD */]:state=state.setIn(['solicitudes',action.payload.index,'selected'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_72" /* CONMUTAR_SELECCION_TODOS_SOLICITUDES */]:state.get('solicitudes').forEach(function(x,n){if(action.payload){if(x.get('visible')){state=state.setIn(['solicitudes',n,'selected'],action.payload);}}else{state=state.setIn(['solicitudes',n,'selected'],action.payload);}});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_330" /* ORDENAR_SOLICITUDES */]:state=state.set('orderBy',action.payload.orderBy);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_253" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_158" /* ELIMINAR_SOLICITUD */]:index=state.get('solicitudes').findIndex(function(x){return x.get('id')===action.payload;});state=state.deleteIn(['solicitudes',index]);state=state.setIn(['modalDelete','show'],false);state=state.setIn(['modalDelete','action'],null);state=state.setIn(['modalDelete','message'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_275" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES */]:state=state.setIn(['modalFilter','show'],action.payload.state);state=state.setIn(['modalFilter','columnas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.tableCols));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["v" /* ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES */]:var firstCol=columnas.first();state=state.updateIn(['modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('value'),operator:'===',value:'',checked:false,comparison:firstCol.get('type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_148" /* ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES */]:state=state.setIn(['modalFilter','filters'],state.getIn(['modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_53" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES */]:state=state.setIn(['modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_191" /* MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES */]:if(action.payload.attr==='column'){state=state.setIn(['modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('value')===action.payload.value;}).get('type'));}state=state.setIn(['modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_27" /* APLICAR_CRITERIOS_FILTRADO_SOLICITUDES */]:state=state.updateIn(['modalFilter','filters'],function(filter){return filter.map(function(x){x=x.set('apply',true);return x;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_39" /* CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES */]:state=state.set('showRecords',action.payload);return state;default:return state;}});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({solicitante:null,fecha_requerido:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),responsable_recibo:null,responsable_ingreso:null,proyecto_evento:'',observaciones:'',servicios:[],adjuntos:[],modalAddServicio:{show:false,title:'',mode:null,data:null,btnDisabled:false},modalAddFile:{show:false,title:'',data:null,btnDisabled:false},btnSaveDisabled:false,tipo:1,foros:[],comentario:{guid:null,texto:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var data=void 0,index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_340" /* REINICIAR_SOLICITUD_SERVICIO */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_216" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_246" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO */]:state=state.setIn(['modalAddServicio','title'],action.payload.title);state=state.setIn(['modalAddServicio','show'],action.payload.show);state=state.setIn(['modalAddServicio','mode'],action.payload.mode);data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["R" /* solicitudservicioitem */])());if(action.payload.mode==='edit'){data=state.getIn(['servicios',String(action.payload.index)]);}state=state.setIn(['modalAddServicio','data'],data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_318" /* OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO */]:state=state.set('modalAddServicio',INITIAL_STATE.get('modalAddServicio'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_1" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO */]:var actual=state.getIn(['modalAddServicio','data','cencos']).reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);state=state.updateIn(['modalAddServicio','data','cencos'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["S" /* solicitudservicioitemcenco */])(actual)));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_132" /* ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM */]:state=state.updateIn(['modalAddServicio','data','cencos'],function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_11" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO */]:data=state.getIn(['modalAddServicio','data']);index=state.get('servicios').findIndex(function(x){return x.get('guid')===data.get('guid');});if(index===-1){state=state.set('servicios',state.get('servicios').push(data));}else{state=state.setIn(['servicios',String(index)],data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_242" /* MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO */]:state=state.setIn(['modalAddFile','title'],action.payload.title);state=state.setIn(['modalAddFile','show'],action.payload.show);data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["Q" /* solicitudserviciofile */])());if(action.payload.mode==='edit'){data=state.getIn(['adjuntos',String(action.payload.index)]);}state=state.setIn(['modalAddFile','data'],data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_314" /* OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO */]:state=state.set('modalAddFile',INITIAL_STATE.get('modalAddFile'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["T" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO */]:data=action.payload;index=state.get('adjuntos').findIndex(function(x){return x.get('guid')===data.get('guid');});data=data.set('nombre',''+data.get('nombre'));if(index===-1){state=state.set('adjuntos',state.get('adjuntos').push(data));}else{data=data.set('updated',true);state=state.setIn(['adjuntos',String(index)],data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_125" /* ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO */]:state=state.update('adjuntos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_168" /* ENVIAR_COMENTARIO_SOLICITUD_SERVICIO */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});if(index===-1){var _data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* foro */])(action.payload.usuario,action.payload.comentario));state=state.set('foros',state.get('foros').push(_data));}else{state=state.setIn(['foros',index,'comentario'],action.payload.comentario);}state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_117" /* EDITAR_COMENTARIO_SOLICITUD_SERVICIO */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.setIn(['comentario','guid'],action.payload.guid);state=state.setIn(['comentario','texto'],state.getIn(['foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_138" /* ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.deleteIn(['foros',index]);return state;default:return state;}});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({solicitante:null,fecha_requerido:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),tipo_almacen:'',proyecto_evento:'',observaciones:'',bienes:[],cencos:[],adjuntos:[],btnSaveDisabled:false,foros:[],comentario:{guid:null,texto:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var data=void 0,index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_336" /* REINICIAR_SOLICITUD_BIENES_INVESTIGACION */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_210" /* MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_9" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION */]:var newItem=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["O" /* solicitudbiitem */])());state=state.update('bienes',function(list){return list.push(newItem);});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_223" /* MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION */]:state=state.mergeIn(['bienes',action.index],action.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_152" /* ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION */]:state=state.update('bienes',function(list){return list.filter(function(item){return!item.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["Z" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION */]:var actual=state.get('cencos').reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);state=state.update('cencos',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["S" /* solicitudservicioitemcenco */])(actual)));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_131" /* ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM */]:state=state.update('cencos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["Q" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION */]:data=action.payload;index=state.get('adjuntos').findIndex(function(x){return x.get('guid')===data.get('guid');});data=data.set('nombre',''+data.get('nombre'));if(index===-1){state=state.set('adjuntos',state.get('adjuntos').push(data));}else{data=data.set('updated',true);state=state.setIn(['adjuntos',String(index)],data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_123" /* ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION */]:state=state.update('adjuntos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_67" /* CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION */]:state=state.update('bienes',function(list){return list.map(function(x){return x.set('selected',action.payload);});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_63" /* CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION */]:state=state.update('cencos',function(list){return list.map(function(x){return x.set('selected',action.payload);});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_165" /* ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});if(index===-1){var _data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* foro */])(action.payload.usuario,action.payload.comentario));state=state.set('foros',state.get('foros').push(_data));}else{state=state.setIn(['foros',index,'comentario'],action.payload.comentario);}state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_111" /* EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.setIn(['comentario','guid'],action.payload.guid);state=state.setIn(['comentario','texto'],state.getIn(['foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_135" /* ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.deleteIn(['foros',index]);return state;default:return state;}});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,estado:0,solicitud:{},unchaged:{},aprobadores:[],btnSaveDisabled:true,btnRComprasDisabled:true,btnAproveDisabled:false,modified:[],modalCreateDocumento:{title:'',mode:'',show:false,data:null,btnDisabled:false,plantillas:[],garantias:[],unchanged:null,contratoanual:false,contratosAnuales:[]},modalCreateCompraDirecta:{title:'',show:false,data:null,unchaged:null,servicio_id:0,cot_id:0,servicio_descripcion:'',servicio_cantidad:0},modalAddServicio:{show:false,title:'',mode:null,data:null,btnDisabled:false},addModificacion:false,remove:[],comentario:{id:null,texto:null,btnSendDisabled:false}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var data=void 0,index=void 0,servicio=void 0,indexServicioCompraDirecta=void 0;var _ret=function(){switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["L" /* ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO */]:state=state.set('modified',state.get('modified').filter(function(x){return x.get('entity')+x.get('attribute')+x.get('id')!==action.payload.entity+action.payload.attribute+action.payload.id;}));state=state.update('modified',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));});state=state.set('btnSaveDisabled',state.get('modified').count()===0);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_309" /* OBTENER_SOLICITUD_SERVICIO */]:state=state.set('id',action.payload.solicitud.id);state=state.set('estado',action.payload.solicitud.estado);state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('unchaged',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('modified',INITIAL_STATE.get('modified'));state=state.set('btnSaveDisabled',state.get('modified').count()===0);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_217" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO1 */]:if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(action.payload.path=='solicitud.servicios.0.fecha_cotizaciones'){for(var i=0;i<state.getIn(['solicitud','servicios']).count();i++){state=state.setIn(['solicitud','servicios',i,'fecha_cotizaciones'],action.payload.value);}}if(action.payload.path.split('.').slice(-1)[0]=='responsable_compras'||action.payload.path.split('.').slice(-1)[0]=='solicitante'){state=state.set('btnRComprasDisabled',false);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_administracion'){var cotizado=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var porcentaje=state.getIn(['modalCreateDocumento','data','aiu_administracion']);var valor=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(cotizado,porcentaje);state=state.setIn(['modalCreateDocumento','data','aiu_administracion_value'],valor);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_imprevistos'){var _cotizado=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var _porcentaje=state.getIn(['modalCreateDocumento','data','aiu_imprevistos']);var _valor=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado,_porcentaje);state=state.setIn(['modalCreateDocumento','data','aiu_imprevistos_value'],_valor);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_utilidad'){var _cotizado2=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var _porcentaje2=state.getIn(['modalCreateDocumento','data','aiu_utilidad']);var _valor2=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado2,_porcentaje2);state=state.setIn(['modalCreateDocumento','data','aiu_utilidad_value'],_valor2);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_iva_utilidad'||action.payload.path.split('.').slice(-1)[0]=='aiu_utilidad'){var utilidad=state.getIn(['modalCreateDocumento','data','aiu_utilidad_value']);var _porcentaje3=state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad']);var _valor3=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(utilidad,_porcentaje3);state=state.setIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'],_valor3);}if(action.payload.path.split('.').slice(-1)[0]=='iva'&&action.payload.path.split('.').indexOf("modalCreateDocumento")>=0){//const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
var _cotizado3=state.getIn(['modalCreateDocumento','data','detalles']).reduce(function(acum,detalle){acum+=detalle.get('valor')*detalle.get('cantidad');return acum;},0);var _porcentaje4=state.getIn(['modalCreateDocumento','data','iva']);var _valor4=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado3,_porcentaje4);state=state.setIn(['modalCreateDocumento','data','iva_value'],_valor4);}if(state.getIn(['modalCreateDocumento','data'])){// const aiu_administracion_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'])
// const aiu_imprevistos_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'])
// const aiu_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])
// const aiu_iva_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'])
var iva=state.getIn(['modalCreateDocumento','data','iva_value']);//const cotizado = state.getIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado'])
var _cotizado4=state.getIn(['modalCreateDocumento','data','detalles']).reduce(function(acum,detalle){acum+=detalle.get('valor')*detalle.get('cantidad');return acum;},0);//const aiu_total = aiu_administracion_value + aiu_imprevistos_value + aiu_utilidad_value + aiu_iva_utilidad_value + iva + cotizado
var aiu_total=iva+_cotizado4;// state = state.setIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado_iva'], cotizado + aiu_total)
state=state.setIn(['modalCreateDocumento','data','aiu_total'],aiu_total);if(action.payload.path.split('.').slice(-1)[0]=='tipo'){state=state.setIn(['modalCreateDocumento','data','plantilla_id'],0);}if(action.payload.path.split('.').slice(-1)[0]=='contratoanual'){state=state.setIn(['modalCreateDocumento','data','documento_id'],null);state=state.setIn(['modalCreateDocumento','data','tipo'],0);state=state.setIn(['modalCreateDocumento','data','plantilla_id'],-1);state=state.setIn(['modalCreateDocumento','data','consecutivo'],'');}}if(action.payload.path=='modalCreateCompraDirecta.data.proveedor'){state=state.setIn(['modalCreateCompraDirecta','data','razon_social'],'');}if(action.payload.path=='modalCreateCompraDirecta.data.razon_social'){state=state.setIn(['modalCreateCompraDirecta','data','proveedor'],null);}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_7" /* ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO */]:var nuevaCotizacion=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* cotizacion */])();nuevaCotizacion.fecha_entrega=__WEBPACK_IMPORTED_MODULE_5_moment___default()(state.getIn(['solicitud','fecha_requerido'])).format('YYYY-MM-DD');nuevaCotizacion.servicio=state.getIn(['solicitud','servicios',action.payload.indexServicio]);state=state.updateIn((''+action.payload.path).split('.'),function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(nuevaCotizacion));});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["z" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO */]:state=state.setIn(action.payload.path.split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));if(action.payload.path.split('.').slice(-1)[0]=='proveedore'){var path=action.payload.path.split('.');state=state.setIn([].concat(_toConsumableArray(path.slice(0,path.length-1)),['proveedor_id']),action.payload.value.id);}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_141" /* ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO */]:state=state.updateIn((''+action.payload.path).split('.'),function(list){return list.filter(function(x){return!x.get('selected');});});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_84" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO */]:state=state.set('btnSaveDisabled',action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_81" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO */]:state=state.set('btnAproveDisabled',action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["g" /* ACTUALIZAR_SOLICITUD_SERVICIO */]:var solicitudActualizada=action.payload.solicitud;for(var _index=0;_index<solicitudActualizada.servicios.length;_index++){solicitudActualizada.servicios[_index].cotizaciones_aprobar=solicitudActualizada.servicios[_index].cotizaciones.filter(function(ele){return ele.estado===4;});}var ops=__WEBPACK_IMPORTED_MODULE_2_immutablediff___default()(state.get('solicitud'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(solicitudActualizada));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.get('solicitud'),ops));if(ops.filter(function(x){return x.get('path')==='/estado';}).count()===1){state=state.set('estado',state.getIn(['solicitud','estado']));}for(var _i=0;_i<action.payload.aprobadores.length;_i++){for(var j=0;j<action.payload.aprobadores[_i].aprobaciones.length;j++){action.payload.aprobadores[_i].aprobaciones[j].selected=action.payload.aprobadores[_i].aprobaciones[j].estado===2;}}state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));state=state.set('btnRComprasDisabled',true);state=state.set('btnSaveDisabled',true);state=state.set('unchaged',state.get('solicitud'));state=state.set('addModificacion',false);state=state.set('comentario',INITIAL_STATE.get('comentario'));return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_43" /* CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO */]:var indexServicio=action.payload.indexServicio;var indexCotizacion=action.payload.indexCotizacion;for(var _i2=0;_i2<state.getIn(['solicitud','servicios',indexServicio,'cotizaciones_aprobar']).count();_i2++){state=state.setIn(['solicitud','servicios',indexServicio,'cotizaciones_aprobar',_i2,'recomendado'],false);}state=state.setIn(['solicitud','servicios',indexServicio,'cotizaciones_aprobar',indexCotizacion,'recomendado'],true);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_46" /* CONMUTAR_SELECCION_APROBACION_SERVICIO */]:var servicioid=action.payload.servicioid;var aprobadorid=action.payload.aprobadorid;var aprobacionid=action.payload.aprobacionid;var indexAprobador=state.get('aprobadores').findIndex(function(x){return x.get('id')==aprobadorid;});var indexAprobacion=state.getIn(['aprobadores',indexAprobador,'aprobaciones']).findIndex(function(x){return x.get('id')==aprobacionid;});var aprobaciones=state.getIn(['aprobadores',indexAprobador,'aprobaciones']).filter(function(x){return x.getIn(['cotizacione','servicios',0,'id'])==servicioid;});var _loop=function _loop(_i3){var index=state.getIn(['aprobadores',indexAprobador,'aprobaciones']).findIndex(function(x){return x.get('id')==aprobaciones.getIn([_i3,'id']);});state=state.setIn(['aprobadores',indexAprobador,'aprobaciones',index,'estado'],1);};for(var _i3=0;_i3<aprobaciones.count();_i3++){_loop(_i3);}state=state.setIn(['aprobadores',indexAprobador,'aprobaciones',indexAprobacion,'estado'],3);// 3 es Seleccionado pero no aprobado
return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_260" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO */]:state=state.setIn(['modalCreateDocumento','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalCreateDocumento','title'],action.payload.title);state=state.setIn(['modalCreateDocumento','mode'],action.payload.mode);state=state.setIn(['modalCreateDocumento','plantillas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.plantillas));state=state.setIn(['modalCreateDocumento','garantias'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.garantias));state=state.setIn(['modalCreateDocumento','contratosAnuales'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.contratos));if(action.payload.mode==='create'){var solicitud_id=state.get('id');var documento_id=state.getIn(['solicitud','documentos',action.payload.indexDocumento,'id']);var proveedor_id=state.getIn(['solicitud','documentos',action.payload.indexDocumento,'proveedor','id']);state=state.setIn(['modalCreateDocumento','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["l" /* documento */])(documento_id,solicitud_id,proveedor_id)));}else if(action.payload.mode==='edit'){state=state.setIn(['modalCreateDocumento','data'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));state=state.setIn(['modalCreateDocumento','unchanged'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));var tipo=state.getIn(['modalCreateDocumento','data','tipo']);var creado=state.getIn(['modalCreateDocumento','data','consecutivo'])?true:false;if(!creado){state=state.setIn(['modalCreateDocumento','data','entregas_parciales'],true);}if(!state.getIn(['modalCreateDocumento','data','fecha_inicio']))state=state.setIn(['modalCreateDocumento','data','fecha_inicio'],state.getIn(['solicitud','fecha_inicio'])||__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'));if(!state.getIn(['modalCreateDocumento','data','fecha_entrega']))state=state.setIn(['modalCreateDocumento','data','fecha_entrega'],state.getIn(['solicitud','fecha_requerido']||__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')));if(tipo==5){state=state.setIn(['modalCreateDocumento','contratoanual'],true);}if(tipo==4){state=state.setIn(['modalCreateDocumento','data','anticipo'],0);}var _cotizado5=state.getIn(['modalCreateDocumento','data','detalles']).reduce(function(acum,detalle){acum+=detalle.get('valor')*detalle.get('cantidad');return acum;},0);var _iva=state.getIn(['modalCreateDocumento','data','iva']);state=state.setIn(['modalCreateDocumento','data','iva_value'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado5,_iva)||0);var _aiu_total=state.getIn(['modalCreateDocumento','data','iva_value'])+_cotizado5;state=state.setIn(['modalCreateDocumento','data','aiu_total'],_aiu_total);}}else{state=state.set('modalCreateDocumento',INITIAL_STATE.get('modalCreateDocumento'));}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_257" /* MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO */]:state=state.setIn(['modalCreateCompraDirecta','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalCreateCompraDirecta','title'],action.payload.title);indexServicioCompraDirecta=state.getIn(['solicitud','servicios']).findIndex(function(servicio){return servicio.get('id')===action.payload.servicio_id;});servicio=state.getIn(['solicitud','servicios',indexServicioCompraDirecta]);var FacturaCompraDirectaServicios=servicio.get('factura_compra_directa_servicios');state=state.setIn(['modalCreateCompraDirecta','servicio_id'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.servicio_id));state=state.setIn(['modalCreateCompraDirecta','cot_id'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.cotizacion.get('id')));state=state.setIn(['modalCreateCompraDirecta','servicio_descripcion'],servicio.getIn(['item','descripcion']));state=state.setIn(['modalCreateCompraDirecta','servicio_cantidad'],servicio.get('cantidad'));state=state.setIn(['modalCreateCompraDirecta','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(FacturaCompraDirectaServicios||Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["h" /* compraDirectaItem */])()));state=state.setIn(['modalCreateCompraDirecta','data','razon_social'],action.payload.cotizacion.get('razon_social'));state=state.setIn(['modalCreateCompraDirecta','unchanged'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(FacturaCompraDirectaServicios||{}));}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["F" /* ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO */]:var garantia=state.getIn(['modalCreateDocumento','garantias',String(action.payload)]);state=state.updateIn(['modalCreateDocumento','data','garantias'],function(list){return list.push(garantia);});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_353" /* REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO */]:state=state.setIn(['modalCreateDocumento','data','garantias'],state.getIn(['modalCreateDocumento','data','garantias']).filter(function(x){return x.get('id')!=action.payload;}));return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_101" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO */]:state=state.setIn(['modalCreateDocumento','btnDisabled'],action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_126" /* ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO1 */]:state=state.updateIn(['solicitud','adjuntos'],function(list){return list.filter(function(x){return!x.get('selected');});});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["m" /* ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO */]:var cot=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* cotizacion */])();cot.estado=3;state=state.updateIn((''+action.payload.path).split('.'),function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(cot));});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_364" /* SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO */]:var cotizacion_actual=state.getIn(['solicitud','servicios',action.payload.indexServicio,'cotizaciones']).filter(function(cotizacion){return cotizacion.get('id')==action.payload.cotizacion_id;});if(cotizacion_actual.count()>0){state=state.setIn(['solicitud','servicios',action.payload.indexServicio,'cotizaciones_aprobar',action.payload.indexCotizacionAprobar],cotizacion_actual.get(0));state=state.setIn(['unchaged','servicios',action.payload.indexServicio,'cotizaciones_aprobar',action.payload.indexCotizacionAprobar],cotizacion_actual.get(0));var validacionProveedor=cotizacion_actual.get(0).toJS().proveedore===null?false:true;// if(validacionProveedor == false){
// }
}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_247" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 */]:state=state.setIn(['modalAddServicio','title'],action.payload.title);state=state.setIn(['modalAddServicio','show'],action.payload.show);state=state.setIn(['modalAddServicio','mode'],action.payload.mode);data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["R" /* solicitudservicioitem */])());if(action.payload.mode==='edit'){data=state.getIn(['solicitud','servicios',String(action.payload.index)]);}state=state.setIn(['modalAddServicio','data'],data);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_319" /* OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 */]:state=state.set('modalAddServicio',INITIAL_STATE.get('modalAddServicio'));return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_12" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1 */]:data=state.getIn(['modalAddServicio','data']);var mode=state.getIn(['modalAddServicio','mode']);if(mode=='create'){state=state.setIn(['solicitud','servicios'],state.getIn(['solicitud','servicios']).push(data));}if(mode=='edit'){index=state.getIn(['solicitud','servicios']).findIndex(function(x){return data.get('guid')&&x.get('guid')===data.get('guid')||x.get('id')===data.get('id');});if(index>=0){state=state.setIn(['solicitud','servicios',String(index)],data);}}state=state.set('addModificacion',true);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_2" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1 */]:var actual=state.getIn(['modalAddServicio','data','cencos']).reduce(function(a,b){a+=Number(b.getIn(['pivot','porcentaje']));return a;},0);state=state.updateIn(['modalAddServicio','data','cencos'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({pivot:Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["S" /* solicitudservicioitemcenco */])(actual)}));});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_133" /* ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1 */]:state=state.updateIn(['modalAddServicio','data','cencos'],function(list){return list.filter(function(x){return!x.get('selected');});});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_154" /* ELIMINAR_ITEMS_SOLICITUD_SERVICIO */]:state=state.updateIn(['solicitud','servicios'],function(list){return list.filter(function(item){return!item.get('selected');});});state=state.set('remove',action.payload.remove);state=state.set('addModificacion',true);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_118" /* EDITAR_COMENTARIO_SOLICITUD_SERVICIO1 */]:index=state.getIn(['solicitud','foros']).findIndex(function(c){return c.get('id')===action.payload.id;});state=state.setIn(['comentario','id'],action.payload.id);state=state.setIn(['comentario','texto'],state.getIn(['solicitud','foros',index,'comentario']));return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_88" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1 */]:state=state.setIn(['comentario','btnSendDisabled'],action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_163" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1 */]:state=state.setIn(['solicitud','foros'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.foros));state=state.set('comentario',INITIAL_STATE.get('comentario'));return{v:state};default:return{v:state};}}();if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Plantillas__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var columnas=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(__WEBPACK_IMPORTED_MODULE_2__containers_Plantillas__["b" /* tableCols */]);var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({plantillas:[],page:1,showRecords:100,totalRecords:0,orderBy:{field:null,asc:false},modalCreate:{title:'',mode:'',show:false,data:null,btnDisabled:false},modalDelete:{show:false,action:null,message:null},modalFilter:{show:false,filters:[]}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var id=void 0;var data=void 0;var index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_302" /* OBTENER_PLANTILLAS */]:state=state.set('plantillas',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_58" /* CONMUTAR_SELECCION_PLANTILLA */]:state=state.setIn(['plantillas',action.payload.index,'selected'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_71" /* CONMUTAR_SELECCION_TODOS_PLANTILLAS */]:state.get('plantillas').forEach(function(x,n){if(action.payload){if(x.get('visible')){state=state.setIn(['plantillas',n,'selected'],action.payload);}}else{state=state.setIn(['plantillas',n,'selected'],action.payload);}});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_328" /* ORDENAR_PLANTILLAS */]:state=state.set('orderBy',action.payload.orderBy);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_265" /* MOSTRAR_MODAL_CREAR_PLANTILLA */]:state=state.setIn(['modalCreate','show'],action.payload.show);state=state.setIn(['modalCreate','title'],action.payload.title);state=state.setIn(['modalCreate','mode'],action.payload.mode);if(action.payload.mode==='create'){state=state.setIn(['modalCreate','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["L" /* plantilla */])()));}else if(action.payload.mode==='edit'){index=state.get('plantillas').findIndex(function(x){return x.get('id')===action.payload.id;});state=state.setIn(['modalCreate','data'],state.getIn(['plantillas',index]));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_207" /* MODIFICAR_INPUTS_PLANTILLAS */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_78" /* CREAR_ACTUALIZAR_PLANTILLA */]:id=action.payload.id;index=state.get('plantillas').findIndex(function(x){return x.get('id')===id;});if(index!==-1){state=state.setIn(['plantillas',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));}else{state=state.set('plantillas',state.get('plantillas').push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload)));}state=state.setIn(['modalCreate','show'],false);state=state.setIn(['modalCreate','title'],'');state=state.setIn(['modalCreate','mode'],'');state=state.setIn(['modalCreate','data'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_106" /* DESHABILITAR_BOTON_MODAL_PLANTILLAS */]:state=state.setIn(['modalCreate','btnDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_252" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_156" /* ELIMINAR_PLANTILLA */]:index=state.get('plantillas').findIndex(function(x){return x.get('id')===action.payload;});state=state.deleteIn(['plantillas',index]);state=state.setIn(['modalDelete','show'],false);state=state.setIn(['modalDelete','action'],null);state=state.setIn(['modalDelete','message'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_273" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS */]:state=state.setIn(['modalFilter','show'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["t" /* ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS */]:var firstCol=columnas.first();state=state.updateIn(['modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('Value'),operator:'===',value:'',checked:false,comparison:firstCol.get('Type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_146" /* ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS */]:state=state.setIn(['modalFilter','filters'],state.getIn(['modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_51" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS */]:state=state.setIn(['modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_189" /* MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS */]:if(action.payload.attr==='column'){state=state.setIn(['modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('Value')===action.payload.value;}).get('Type'));}state=state.setIn(['modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_25" /* APLICAR_CRITERIOS_FILTRADO_PLANTILLAS */]:state=state.updateIn(['modalFilter','filters'],function(filter){return filter.map(function(x){x=x.set('apply',true);return x;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_38" /* CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS */]:state=state.set('showRecords',action.payload);return state;default:return state;}});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ckeditor_component__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ckeditor_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_ckeditor_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ace__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_ace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_ace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_mode_java__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brace_mode_java___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_brace_mode_java__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace_theme_github__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace_theme_github___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_brace_theme_github__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_plantillas__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import ReactQuill from 'react-quill'
var ModalCreate=function(_Component){_inherits(ModalCreate,_Component);function ModalCreate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreate.__proto__||Object.getPrototypeOf(ModalCreate)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreate');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreate .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreate(false,'','');},300);},_this.onChange=function(newValue){_this.props.updateInputs('modalCreate.data.texto',newValue);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreate,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreate=_props.modalCreate,enums=_props.enums;if(!modalCreate.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_Modal__["a" /* default */],{id:'modalCreate',show:true,ZIndex:2000,style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdatePlantillas(modalCreate.get('data'),modalCreate.get('mode'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalHeader__["a" /* default */],{title:modalCreate.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreate.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','nombre']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.nombre',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreate.getIn(['data','tipo']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.tipo',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opci\xF3n'),Object.keys(enums.documentos.tipos).map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt21['+a+']',value:a},enums.documentos.tipos[a].NOMBRE);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Plantilla'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_ace___default.a,{width:'100%',mode:'html',theme:'github',value:modalCreate.getIn(['data','texto']),onChange:this.onChange,name:'editor_blaze',editorProps:{$blockScrolling:true}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalCreate:state.plantillas.get('modalCreate'),enums:state.common.get('enums').toJS()};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreate:function displayModalCreate(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["f" /* displayModalCreate */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["p" /* updateInputs */])(path,value));},createOrUpdatePlantillas:function createOrUpdatePlantillas(data,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_plantillas__["d" /* createOrUpdatePlantillas */])(data,mode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreate));

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(40);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loadScript = __webpack_require__(528);

var defaultScriptUrl = 'https://cdn.ckeditor.com/4.6.2/standard/ckeditor.js';

/**
 * @author codeslayer1
 * @description CKEditor component to render a CKEditor textarea with defined configs and all CKEditor events handler
 */

var CKEditor = function (_React$Component) {
  _inherits(CKEditor, _React$Component);

  function CKEditor(props) {
    _classCallCheck(this, CKEditor);

    //Bindings
    var _this = _possibleConstructorReturn(this, (CKEditor.__proto__ || Object.getPrototypeOf(CKEditor)).call(this, props));

    _this.onLoad = _this.onLoad.bind(_this);

    //State initialization
    _this.state = {
      isScriptLoaded: props.isScriptLoaded
    };
    return _this;
  }

  //load ckeditor script as soon as component mounts if not already loaded


  _createClass(CKEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.isScriptLoaded) {
        loadScript(this.props.scriptUrl, this.onLoad);
      } else {
        this.onLoad();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var editor = this.editorInstance;
      if (editor && editor.getData() !== props.content) {
        editor.setData(props.content);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounting = true;
    }
  }, {
    key: 'onLoad',
    value: function onLoad() {
      if (this.unmounting) return;

      this.setState({
        isScriptLoaded: true
      });

      if (!window.CKEDITOR) {
        console.error('CKEditor not found');
        return;
      }

      this.editorInstance = window.CKEDITOR.appendTo(_reactDom2.default.findDOMNode(this), this.props.config, this.props.content);

      //Register listener for custom events if any
      for (var event in this.props.events) {
        var eventHandler = this.props.events[event];

        this.editorInstance.on(event, eventHandler);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { className: this.props.activeClass });
    }
  }]);

  return CKEditor;
}(_react2.default.Component);

CKEditor.defaultProps = {
  content: '',
  config: {},
  isScriptLoaded: false,
  scriptUrl: defaultScriptUrl,
  activeClass: '',
  events: {}
};

CKEditor.propTypes = {
  content: _propTypes2.default.any,
  config: _propTypes2.default.object,
  isScriptLoaded: _propTypes2.default.bool,
  scriptUrl: _propTypes2.default.string,
  activeClass: _propTypes2.default.string,
  events: _propTypes2.default.object
};

exports.default = CKEditor;

/***/ }),
/* 528 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __webpack_require__(12);
var React = __webpack_require__(0);
var isEqual = __webpack_require__(231);
var editorOptions_1 = __webpack_require__(232);
var ace = editorOptions_1.getAceInstance();
var Range = ace.acequire("ace/range").Range;
var ReactAce = /** @class */ (function (_super) {
    __extends(ReactAce, _super);
    function ReactAce(props) {
        var _this = _super.call(this, props) || this;
        editorOptions_1.editorEvents.forEach(function (method) {
            _this[method] = _this[method].bind(_this);
        });
        _this.debounce = editorOptions_1.debounce;
        return _this;
    }
    ReactAce.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, className = _a.className, onBeforeLoad = _a.onBeforeLoad, onValidate = _a.onValidate, mode = _a.mode, focus = _a.focus, theme = _a.theme, fontSize = _a.fontSize, value = _a.value, defaultValue = _a.defaultValue, cursorStart = _a.cursorStart, showGutter = _a.showGutter, wrapEnabled = _a.wrapEnabled, showPrintMargin = _a.showPrintMargin, _b = _a.scrollMargin, scrollMargin = _b === void 0 ? [0, 0, 0, 0] : _b, keyboardHandler = _a.keyboardHandler, onLoad = _a.onLoad, commands = _a.commands, annotations = _a.annotations, markers = _a.markers, placeholder = _a.placeholder;
        this.editor = ace.edit(this.refEditor);
        if (onBeforeLoad) {
            onBeforeLoad(ace);
        }
        var editorProps = Object.keys(this.props.editorProps);
        for (var i = 0; i < editorProps.length; i++) {
            this.editor[editorProps[i]] = this.props.editorProps[editorProps[i]];
        }
        if (this.props.debounceChangePeriod) {
            this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
        }
        this.editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
        this.editor.getSession().setMode("ace/mode/" + mode);
        this.editor.setTheme("ace/theme/" + theme);
        this.editor.setFontSize(fontSize);
        this.editor
            .getSession()
            .setValue(!defaultValue ? value : defaultValue, cursorStart);
        if (this.props.navigateToFileEnd) {
            this.editor.navigateFileEnd();
        }
        this.editor.renderer.setShowGutter(showGutter);
        this.editor.getSession().setUseWrapMode(wrapEnabled);
        this.editor.setShowPrintMargin(showPrintMargin);
        this.editor.on("focus", this.onFocus);
        this.editor.on("blur", this.onBlur);
        this.editor.on("copy", this.onCopy);
        this.editor.on("paste", this.onPaste);
        this.editor.on("change", this.onChange);
        this.editor.on("input", this.onInput);
        if (placeholder) {
            this.updatePlaceholder();
        }
        this.editor
            .getSession()
            .selection.on("changeSelection", this.onSelectionChange);
        this.editor.getSession().selection.on("changeCursor", this.onCursorChange);
        if (onValidate) {
            this.editor.getSession().on("changeAnnotation", function () {
                // tslint:disable-next-line:no-shadowed-variable
                var annotations = _this.editor.getSession().getAnnotations();
                _this.props.onValidate(annotations);
            });
        }
        this.editor.session.on("changeScrollTop", this.onScroll);
        this.editor.getSession().setAnnotations(annotations || []);
        if (markers && markers.length > 0) {
            this.handleMarkers(markers);
        }
        // get a list of possible options to avoid 'misspelled option errors'
        var availableOptions = this.editor.$options;
        editorOptions_1.editorOptions.forEach(function (option) {
            if (availableOptions.hasOwnProperty(option)) {
                _this.editor.setOption(option, _this.props[option]);
            }
            else if (_this.props[option]) {
                console.warn("ReactAce: editor option " + option + " was activated but not found. Did you need to import a related tool or did you possibly mispell the option?");
            }
        });
        this.handleOptions(this.props);
        if (Array.isArray(commands)) {
            commands.forEach(function (command) {
                if (typeof command.exec === "string") {
                    _this.editor.commands.bindKey(command.bindKey, command.exec);
                }
                else {
                    _this.editor.commands.addCommand(command);
                }
            });
        }
        if (keyboardHandler) {
            this.editor.setKeyboardHandler("ace/keyboard/" + keyboardHandler);
        }
        if (className) {
            this.refEditor.className += " " + className;
        }
        if (onLoad) {
            onLoad(this.editor);
        }
        this.editor.resize();
        if (focus) {
            this.editor.focus();
        }
    };
    ReactAce.prototype.componentDidUpdate = function (prevProps) {
        var oldProps = prevProps;
        var nextProps = this.props;
        for (var i = 0; i < editorOptions_1.editorOptions.length; i++) {
            var option = editorOptions_1.editorOptions[i];
            if (nextProps[option] !== oldProps[option]) {
                this.editor.setOption(option, nextProps[option]);
            }
        }
        if (nextProps.className !== oldProps.className) {
            var appliedClasses = this.refEditor.className;
            var appliedClassesArray_1 = appliedClasses.trim().split(" ");
            var oldClassesArray = oldProps.className.trim().split(" ");
            oldClassesArray.forEach(function (oldClass) {
                var index = appliedClassesArray_1.indexOf(oldClass);
                appliedClassesArray_1.splice(index, 1);
            });
            this.refEditor.className =
                " " + nextProps.className + " " + appliedClassesArray_1.join(" ");
        }
        // First process editor value, as it may create a new session (see issue #300)
        if (this.editor && this.editor.getValue() !== nextProps.value) {
            // editor.setValue is a synchronous function call, change event is emitted before setValue return.
            this.silent = true;
            var pos = this.editor.session.selection.toJSON();
            this.editor.setValue(nextProps.value, nextProps.cursorStart);
            this.editor.session.selection.fromJSON(pos);
            this.silent = false;
        }
        if (nextProps.placeholder !== oldProps.placeholder) {
            this.updatePlaceholder();
        }
        if (nextProps.mode !== oldProps.mode) {
            this.editor.getSession().setMode("ace/mode/" + nextProps.mode);
        }
        if (nextProps.theme !== oldProps.theme) {
            this.editor.setTheme("ace/theme/" + nextProps.theme);
        }
        if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
            if (nextProps.keyboardHandler) {
                this.editor.setKeyboardHandler("ace/keyboard/" + nextProps.keyboardHandler);
            }
            else {
                this.editor.setKeyboardHandler(null);
            }
        }
        if (nextProps.fontSize !== oldProps.fontSize) {
            this.editor.setFontSize(nextProps.fontSize);
        }
        if (nextProps.wrapEnabled !== oldProps.wrapEnabled) {
            this.editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
        }
        if (nextProps.showPrintMargin !== oldProps.showPrintMargin) {
            this.editor.setShowPrintMargin(nextProps.showPrintMargin);
        }
        if (nextProps.showGutter !== oldProps.showGutter) {
            this.editor.renderer.setShowGutter(nextProps.showGutter);
        }
        if (!isEqual(nextProps.setOptions, oldProps.setOptions)) {
            this.handleOptions(nextProps);
        }
        if (!isEqual(nextProps.annotations, oldProps.annotations)) {
            this.editor.getSession().setAnnotations(nextProps.annotations || []);
        }
        if (!isEqual(nextProps.markers, oldProps.markers) &&
            Array.isArray(nextProps.markers)) {
            this.handleMarkers(nextProps.markers);
        }
        // this doesn't look like it works at all....
        if (!isEqual(nextProps.scrollMargin, oldProps.scrollMargin)) {
            this.handleScrollMargins(nextProps.scrollMargin);
        }
        if (prevProps.height !== this.props.height ||
            prevProps.width !== this.props.width) {
            this.editor.resize();
        }
        if (this.props.focus && !prevProps.focus) {
            this.editor.focus();
        }
    };
    ReactAce.prototype.handleScrollMargins = function (margins) {
        if (margins === void 0) { margins = [0, 0, 0, 0]; }
        this.editor.renderer.setScrollMargins(margins[0], margins[1], margins[2], margins[3]);
    };
    ReactAce.prototype.componentWillUnmount = function () {
        this.editor.destroy();
        this.editor = null;
    };
    ReactAce.prototype.onChange = function (event) {
        if (this.props.onChange && !this.silent) {
            var value = this.editor.getValue();
            this.props.onChange(value, event);
        }
    };
    ReactAce.prototype.onSelectionChange = function (event) {
        if (this.props.onSelectionChange) {
            var value = this.editor.getSelection();
            this.props.onSelectionChange(value, event);
        }
    };
    ReactAce.prototype.onCursorChange = function (event) {
        if (this.props.onCursorChange) {
            var value = this.editor.getSelection();
            this.props.onCursorChange(value, event);
        }
    };
    ReactAce.prototype.onInput = function (event) {
        if (this.props.onInput) {
            this.props.onInput(event);
        }
        if (this.props.placeholder) {
            this.updatePlaceholder();
        }
    };
    ReactAce.prototype.onFocus = function (event) {
        if (this.props.onFocus) {
            this.props.onFocus(event, this.editor);
        }
    };
    ReactAce.prototype.onBlur = function (event) {
        if (this.props.onBlur) {
            this.props.onBlur(event, this.editor);
        }
    };
    ReactAce.prototype.onCopy = function (text) {
        if (this.props.onCopy) {
            this.props.onCopy(text);
        }
    };
    ReactAce.prototype.onPaste = function (text) {
        if (this.props.onPaste) {
            this.props.onPaste(text);
        }
    };
    ReactAce.prototype.onScroll = function () {
        if (this.props.onScroll) {
            this.props.onScroll(this.editor);
        }
    };
    ReactAce.prototype.handleOptions = function (props) {
        var setOptions = Object.keys(props.setOptions);
        for (var y = 0; y < setOptions.length; y++) {
            this.editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
        }
    };
    ReactAce.prototype.handleMarkers = function (markers) {
        var _this = this;
        // remove foreground markers
        var currentMarkers = this.editor.getSession().getMarkers(true);
        for (var i in currentMarkers) {
            if (currentMarkers.hasOwnProperty(i)) {
                this.editor.getSession().removeMarker(currentMarkers[i].id);
            }
        }
        // remove background markers except active line marker and selected word marker
        currentMarkers = this.editor.getSession().getMarkers(false);
        for (var i in currentMarkers) {
            if (currentMarkers.hasOwnProperty(i) &&
                currentMarkers[i].clazz !== "ace_active-line" &&
                currentMarkers[i].clazz !== "ace_selected-word") {
                this.editor.getSession().removeMarker(currentMarkers[i].id);
            }
        }
        // add new markers
        markers.forEach(function (_a) {
            var startRow = _a.startRow, startCol = _a.startCol, endRow = _a.endRow, endCol = _a.endCol, className = _a.className, type = _a.type, _b = _a.inFront, inFront = _b === void 0 ? false : _b;
            var range = new Range(startRow, startCol, endRow, endCol);
            _this.editor.getSession().addMarker(range, className, type, inFront);
        });
    };
    ReactAce.prototype.updatePlaceholder = function () {
        // Adapted from https://stackoverflow.com/questions/26695708/how-can-i-add-placeholder-text-when-the-editor-is-empty
        var editor = this.editor;
        var placeholder = this.props.placeholder;
        var showPlaceholder = !editor.session.getValue().length;
        var node = editor.renderer.placeholderNode;
        if (!showPlaceholder && node) {
            editor.renderer.scroller.removeChild(editor.renderer.placeholderNode);
            editor.renderer.placeholderNode = null;
        }
        else if (showPlaceholder && !node) {
            node = editor.renderer.placeholderNode = document.createElement("div");
            node.textContent = placeholder || "";
            node.className = "ace_comment ace_placeholder";
            node.style.padding = "0 9px";
            node.style.position = "absolute";
            node.style.zIndex = "3";
            editor.renderer.scroller.appendChild(node);
        }
        else if (showPlaceholder && node) {
            node.textContent = placeholder;
        }
    };
    ReactAce.prototype.updateRef = function (item) {
        this.refEditor = item;
    };
    ReactAce.prototype.render = function () {
        var _a = this.props, name = _a.name, width = _a.width, height = _a.height, style = _a.style;
        var divStyle = __assign({ width: width, height: height }, style);
        return React.createElement("div", { ref: this.updateRef, id: name, style: divStyle });
    };
    ReactAce.propTypes = {
        mode: PropTypes.string,
        focus: PropTypes.bool,
        theme: PropTypes.string,
        name: PropTypes.string,
        className: PropTypes.string,
        height: PropTypes.string,
        width: PropTypes.string,
        fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        showGutter: PropTypes.bool,
        onChange: PropTypes.func,
        onCopy: PropTypes.func,
        onPaste: PropTypes.func,
        onFocus: PropTypes.func,
        onInput: PropTypes.func,
        onBlur: PropTypes.func,
        onScroll: PropTypes.func,
        value: PropTypes.string,
        defaultValue: PropTypes.string,
        onLoad: PropTypes.func,
        onSelectionChange: PropTypes.func,
        onCursorChange: PropTypes.func,
        onBeforeLoad: PropTypes.func,
        onValidate: PropTypes.func,
        minLines: PropTypes.number,
        maxLines: PropTypes.number,
        readOnly: PropTypes.bool,
        highlightActiveLine: PropTypes.bool,
        tabSize: PropTypes.number,
        showPrintMargin: PropTypes.bool,
        cursorStart: PropTypes.number,
        debounceChangePeriod: PropTypes.number,
        editorProps: PropTypes.object,
        setOptions: PropTypes.object,
        style: PropTypes.object,
        scrollMargin: PropTypes.array,
        annotations: PropTypes.array,
        markers: PropTypes.array,
        keyboardHandler: PropTypes.string,
        wrapEnabled: PropTypes.bool,
        enableSnippets: PropTypes.bool,
        enableBasicAutocompletion: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.array
        ]),
        enableLiveAutocompletion: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.array
        ]),
        navigateToFileEnd: PropTypes.bool,
        commands: PropTypes.array,
        placeholder: PropTypes.string
    };
    ReactAce.defaultProps = {
        name: "brace-editor",
        focus: false,
        mode: "",
        theme: "",
        height: "500px",
        width: "500px",
        value: "",
        fontSize: 12,
        enableSnippets: false,
        showGutter: true,
        onChange: null,
        onPaste: null,
        onLoad: null,
        onScroll: null,
        minLines: null,
        maxLines: null,
        readOnly: false,
        highlightActiveLine: true,
        showPrintMargin: true,
        tabSize: 4,
        cursorStart: 1,
        editorProps: {},
        style: {},
        scrollMargin: [0, 0, 0, 0],
        setOptions: {},
        wrapEnabled: false,
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        placeholder: null,
        navigateToFileEnd: true
    };
    return ReactAce;
}(React.Component));
exports.default = ReactAce;
//# sourceMappingURL=ace.js.map

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __webpack_require__(12);
var React = __webpack_require__(0);
var split_1 = __webpack_require__(234);
var DiffMatchPatch = __webpack_require__(533);
var DiffComponent = /** @class */ (function (_super) {
    __extends(DiffComponent, _super);
    function DiffComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.diff = _this.diff.bind(_this);
        return _this;
    }
    DiffComponent.prototype.componentDidUpdate = function () {
        var value = this.props.value;
        if (value !== this.state.value) {
            this.setState({ value: value });
        }
    };
    DiffComponent.prototype.onChange = function (value) {
        this.setState({
            value: value
        });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };
    DiffComponent.prototype.diff = function () {
        var dmp = new DiffMatchPatch();
        var lhString = this.state.value[0];
        var rhString = this.state.value[1];
        if (lhString.length === 0 && rhString.length === 0) {
            return [];
        }
        var diff = dmp.diff_main(lhString, rhString);
        dmp.diff_cleanupSemantic(diff);
        var diffedLines = this.generateDiffedLines(diff);
        var codeEditorSettings = this.setCodeMarkers(diffedLines);
        return codeEditorSettings;
    };
    DiffComponent.prototype.generateDiffedLines = function (diff) {
        var C = {
            DIFF_EQUAL: 0,
            DIFF_DELETE: -1,
            DIFF_INSERT: 1
        };
        var diffedLines = {
            left: [],
            right: []
        };
        var cursor = {
            left: 1,
            right: 1
        };
        diff.forEach(function (chunk) {
            var chunkType = chunk[0];
            var text = chunk[1];
            var lines = text.split("\n").length - 1;
            // diff-match-patch sometimes returns empty strings at random
            if (text.length === 0) {
                return;
            }
            var firstChar = text[0];
            var lastChar = text[text.length - 1];
            var linesToHighlight = 0;
            switch (chunkType) {
                case C.DIFF_EQUAL:
                    cursor.left += lines;
                    cursor.right += lines;
                    break;
                case C.DIFF_DELETE:
                    // If the deletion starts with a newline, push the cursor down to that line
                    if (firstChar === "\n") {
                        cursor.left++;
                        lines--;
                    }
                    linesToHighlight = lines;
                    // If the deletion does not include a newline, highlight the same line on the right
                    if (linesToHighlight === 0) {
                        diffedLines.right.push({
                            startLine: cursor.right,
                            endLine: cursor.right
                        });
                    }
                    // If the last character is a newline, we don't want to highlight that line
                    if (lastChar === "\n") {
                        linesToHighlight -= 1;
                    }
                    diffedLines.left.push({
                        startLine: cursor.left,
                        endLine: cursor.left + linesToHighlight
                    });
                    cursor.left += lines;
                    break;
                case C.DIFF_INSERT:
                    // If the insertion starts with a newline, push the cursor down to that line
                    if (firstChar === "\n") {
                        cursor.right++;
                        lines--;
                    }
                    linesToHighlight = lines;
                    // If the insertion does not include a newline, highlight the same line on the left
                    if (linesToHighlight === 0) {
                        diffedLines.left.push({
                            startLine: cursor.left,
                            endLine: cursor.left
                        });
                    }
                    // If the last character is a newline, we don't want to highlight that line
                    if (lastChar === "\n") {
                        linesToHighlight -= 1;
                    }
                    diffedLines.right.push({
                        startLine: cursor.right,
                        endLine: cursor.right + linesToHighlight
                    });
                    cursor.right += lines;
                    break;
                default:
                    throw new Error("Diff type was not defined.");
            }
        });
        return diffedLines;
    };
    // Receives a collection of line numbers and iterates through them to highlight appropriately
    // Returns an object that tells the render() method how to display the code editors
    DiffComponent.prototype.setCodeMarkers = function (diffedLines) {
        if (diffedLines === void 0) { diffedLines = { left: [], right: [] }; }
        var codeEditorSettings = [];
        var newMarkerSet = {
            left: [],
            right: []
        };
        for (var i = 0; i < diffedLines.left.length; i++) {
            var markerObj = {
                startRow: diffedLines.left[i].startLine - 1,
                endRow: diffedLines.left[i].endLine,
                type: "text",
                className: "codeMarker"
            };
            newMarkerSet.left.push(markerObj);
        }
        for (var i = 0; i < diffedLines.right.length; i++) {
            var markerObj = {
                startRow: diffedLines.right[i].startLine - 1,
                endRow: diffedLines.right[i].endLine,
                type: "text",
                className: "codeMarker"
            };
            newMarkerSet.right.push(markerObj);
        }
        codeEditorSettings[0] = newMarkerSet.left;
        codeEditorSettings[1] = newMarkerSet.right;
        return codeEditorSettings;
    };
    DiffComponent.prototype.render = function () {
        var markers = this.diff();
        return (React.createElement(split_1.default, { name: this.props.name, className: this.props.className, focus: this.props.focus, orientation: this.props.orientation, splits: this.props.splits, mode: this.props.mode, theme: this.props.theme, height: this.props.height, width: this.props.width, fontSize: this.props.fontSize, showGutter: this.props.showGutter, onChange: this.onChange, onPaste: this.props.onPaste, onLoad: this.props.onLoad, onScroll: this.props.onScroll, minLines: this.props.minLines, maxLines: this.props.maxLines, readOnly: this.props.readOnly, highlightActiveLine: this.props.highlightActiveLine, showPrintMargin: this.props.showPrintMargin, tabSize: this.props.tabSize, cursorStart: this.props.cursorStart, editorProps: this.props.editorProps, style: this.props.style, scrollMargin: this.props.scrollMargin, setOptions: this.props.setOptions, wrapEnabled: this.props.wrapEnabled, enableBasicAutocompletion: this.props.enableBasicAutocompletion, enableLiveAutocompletion: this.props.enableLiveAutocompletion, value: this.state.value, markers: markers }));
    };
    DiffComponent.propTypes = {
        cursorStart: PropTypes.number,
        editorProps: PropTypes.object,
        enableBasicAutocompletion: PropTypes.bool,
        enableLiveAutocompletion: PropTypes.bool,
        focus: PropTypes.bool,
        fontSize: PropTypes.number,
        height: PropTypes.string,
        highlightActiveLine: PropTypes.bool,
        maxLines: PropTypes.number,
        minLines: PropTypes.number,
        mode: PropTypes.string,
        name: PropTypes.string,
        className: PropTypes.string,
        onLoad: PropTypes.func,
        onPaste: PropTypes.func,
        onScroll: PropTypes.func,
        onChange: PropTypes.func,
        orientation: PropTypes.string,
        readOnly: PropTypes.bool,
        scrollMargin: PropTypes.array,
        setOptions: PropTypes.object,
        showGutter: PropTypes.bool,
        showPrintMargin: PropTypes.bool,
        splits: PropTypes.number,
        style: PropTypes.object,
        tabSize: PropTypes.number,
        theme: PropTypes.string,
        value: PropTypes.array,
        width: PropTypes.string,
        wrapEnabled: PropTypes.bool
    };
    DiffComponent.defaultProps = {
        cursorStart: 1,
        editorProps: {},
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        focus: false,
        fontSize: 12,
        height: "500px",
        highlightActiveLine: true,
        maxLines: null,
        minLines: null,
        mode: "",
        name: "brace-editor",
        onLoad: null,
        onScroll: null,
        onPaste: null,
        onChange: null,
        orientation: "beside",
        readOnly: false,
        scrollMargin: [0, 0, 0, 0],
        setOptions: {},
        showGutter: true,
        showPrintMargin: true,
        splits: 2,
        style: {},
        tabSize: 4,
        theme: "github",
        value: ["", ""],
        width: "500px",
        wrapEnabled: true
    };
    return DiffComponent;
}(React.Component));
exports.default = DiffComponent;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 531 */
/***/ (function(module, exports) {

ace.define("ace/split",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/editor","ace/virtual_renderer","ace/edit_session"], function(acequire, exports, module) {
"use strict";

var oop = acequire("./lib/oop");
var lang = acequire("./lib/lang");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;

var Editor = acequire("./editor").Editor;
var Renderer = acequire("./virtual_renderer").VirtualRenderer;
var EditSession = acequire("./edit_session").EditSession;


var Split = function(container, theme, splits) {
    this.BELOW = 1;
    this.BESIDE = 0;

    this.$container = container;
    this.$theme = theme;
    this.$splits = 0;
    this.$editorCSS = "";
    this.$editors = [];
    this.$orientation = this.BESIDE;

    this.setSplits(splits || 1);
    this.$cEditor = this.$editors[0];


    this.on("focus", function(editor) {
        this.$cEditor = editor;
    }.bind(this));
};

(function(){

    oop.implement(this, EventEmitter);

    this.$createEditor = function() {
        var el = document.createElement("div");
        el.className = this.$editorCSS;
        el.style.cssText = "position: absolute; top:0px; bottom:0px";
        this.$container.appendChild(el);
        var editor = new Editor(new Renderer(el, this.$theme));

        editor.on("focus", function() {
            this._emit("focus", editor);
        }.bind(this));

        this.$editors.push(editor);
        editor.setFontSize(this.$fontSize);
        return editor;
    };

    this.setSplits = function(splits) {
        var editor;
        if (splits < 1) {
            throw "The number of splits have to be > 0!";
        }

        if (splits == this.$splits) {
            return;
        } else if (splits > this.$splits) {
            while (this.$splits < this.$editors.length && this.$splits < splits) {
                editor = this.$editors[this.$splits];
                this.$container.appendChild(editor.container);
                editor.setFontSize(this.$fontSize);
                this.$splits ++;
            }
            while (this.$splits < splits) {
                this.$createEditor();
                this.$splits ++;
            }
        } else {
            while (this.$splits > splits) {
                editor = this.$editors[this.$splits - 1];
                this.$container.removeChild(editor.container);
                this.$splits --;
            }
        }
        this.resize();
    };
    this.getSplits = function() {
        return this.$splits;
    };
    this.getEditor = function(idx) {
        return this.$editors[idx];
    };
    this.getCurrentEditor = function() {
        return this.$cEditor;
    };
    this.focus = function() {
        this.$cEditor.focus();
    };
    this.blur = function() {
        this.$cEditor.blur();
    };
    this.setTheme = function(theme) {
        this.$editors.forEach(function(editor) {
            editor.setTheme(theme);
        });
    };
    this.setKeyboardHandler = function(keybinding) {
        this.$editors.forEach(function(editor) {
            editor.setKeyboardHandler(keybinding);
        });
    };
    this.forEach = function(callback, scope) {
        this.$editors.forEach(callback, scope);
    };


    this.$fontSize = "";
    this.setFontSize = function(size) {
        this.$fontSize = size;
        this.forEach(function(editor) {
           editor.setFontSize(size);
        });
    };

    this.$cloneSession = function(session) {
        var s = new EditSession(session.getDocument(), session.getMode());

        var undoManager = session.getUndoManager();
        if (undoManager) {
            var undoManagerProxy = new UndoManagerProxy(undoManager, s);
            s.setUndoManager(undoManagerProxy);
        }
        s.$informUndoManager = lang.delayedCall(function() { s.$deltas = []; });
        s.setTabSize(session.getTabSize());
        s.setUseSoftTabs(session.getUseSoftTabs());
        s.setOverwrite(session.getOverwrite());
        s.setBreakpoints(session.getBreakpoints());
        s.setUseWrapMode(session.getUseWrapMode());
        s.setUseWorker(session.getUseWorker());
        s.setWrapLimitRange(session.$wrapLimitRange.min,
                            session.$wrapLimitRange.max);
        s.$foldData = session.$cloneFoldData();

        return s;
    };
    this.setSession = function(session, idx) {
        var editor;
        if (idx == null) {
            editor = this.$cEditor;
        } else {
            editor = this.$editors[idx];
        }
        var isUsed = this.$editors.some(function(editor) {
           return editor.session === session;
        });

        if (isUsed) {
            session = this.$cloneSession(session);
        }
        editor.setSession(session);
        return session;
    };
    this.getOrientation = function() {
        return this.$orientation;
    };
    this.setOrientation = function(orientation) {
        if (this.$orientation == orientation) {
            return;
        }
        this.$orientation = orientation;
        this.resize();
    };
    this.resize = function() {
        var width = this.$container.clientWidth;
        var height = this.$container.clientHeight;
        var editor;

        if (this.$orientation == this.BESIDE) {
            var editorWidth = width / this.$splits;
            for (var i = 0; i < this.$splits; i++) {
                editor = this.$editors[i];
                editor.container.style.width = editorWidth + "px";
                editor.container.style.top = "0px";
                editor.container.style.left = i * editorWidth + "px";
                editor.container.style.height = height + "px";
                editor.resize();
            }
        } else {
            var editorHeight = height / this.$splits;
            for (var i = 0; i < this.$splits; i++) {
                editor = this.$editors[i];
                editor.container.style.width = width + "px";
                editor.container.style.top = i * editorHeight + "px";
                editor.container.style.left = "0px";
                editor.container.style.height = editorHeight + "px";
                editor.resize();
            }
        }
    };

}).call(Split.prototype);

 
function UndoManagerProxy(undoManager, session) {
    this.$u = undoManager;
    this.$doc = session;
}

(function() {
    this.execute = function(options) {
        this.$u.execute(options);
    };

    this.undo = function() {
        var selectionRange = this.$u.undo(true);
        if (selectionRange) {
            this.$doc.selection.setSelectionRange(selectionRange);
        }
    };

    this.redo = function() {
        var selectionRange = this.$u.redo(true);
        if (selectionRange) {
            this.$doc.selection.setSelectionRange(selectionRange);
        }
    };

    this.reset = function() {
        this.$u.reset();
    };

    this.hasUndo = function() {
        return this.$u.hasUndo();
    };

    this.hasRedo = function() {
        return this.$u.hasRedo();
    };
}).call(UndoManagerProxy.prototype);

exports.Split = Split;
});

ace.define("ace/ext/split",["require","exports","module","ace/split"], function(acequire, exports, module) {
"use strict";
module.exports = acequire("../split");

});
                (function() {
                    ace.acequire(["ace/ext/split"], function() {});
                })();
            

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 533 */
/***/ (function(module, exports) {

/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */

/**
 * Class containing the diff, match and patch methods.
 * @constructor
 */
var diff_match_patch = function() {

  // Defaults.
  // Redefine these in your program to override the defaults.

  // Number of seconds to map a diff before giving up (0 for infinity).
  this.Diff_Timeout = 1.0;
  // Cost of an empty edit operation in terms of edit characters.
  this.Diff_EditCost = 4;
  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
  this.Match_Threshold = 0.5;
  // How far to search for a match (0 = exact location, 1000+ = broad match).
  // A match this many characters away from the expected location will add
  // 1.0 to the score (0.0 is a perfect match).
  this.Match_Distance = 1000;
  // When deleting a large block of text (over ~64 characters), how close do
  // the contents have to be to match the expected contents. (0.0 = perfection,
  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
  // end points of a delete need to match.
  this.Patch_DeleteThreshold = 0.5;
  // Chunk size for context length.
  this.Patch_Margin = 4;

  // The number of bits in an int.
  this.Match_MaxBits = 32;
};


//  DIFF FUNCTIONS


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

/**
 * Class representing one diff tuple.
 * ~Attempts to look like a two-element array (which is what this used to be).~
 * Constructor returns an actual two-element array, to allow destructing @JackuB
 * See https://github.com/JackuB/diff-match-patch/issues/14 for details
 * @param {number} op Operation, one of: DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL.
 * @param {string} text Text to be deleted, inserted, or retained.
 * @constructor
 */
diff_match_patch.Diff = function(op, text) {
  return [op, text];
};

/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number=} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */
diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
    opt_deadline) {
  // Set a deadline by which time the diff must be complete.
  if (typeof opt_deadline == 'undefined') {
    if (this.Diff_Timeout <= 0) {
      opt_deadline = Number.MAX_VALUE;
    } else {
      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
  }
  var deadline = opt_deadline;

  // Check for null inputs.
  if (text1 == null || text2 == null) {
    throw new Error('Null input. (diff_main)');
  }

  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [new diff_match_patch.Diff(DIFF_EQUAL, text1)];
    }
    return [];
  }

  if (typeof opt_checklines == 'undefined') {
    opt_checklines = true;
  }
  var checklines = opt_checklines;

  // Trim off common prefix (speedup).
  var commonlength = this.diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = this.diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = this.diff_compute_(text1, text2, checklines, deadline);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, commonprefix));
  }
  if (commonsuffix) {
    diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, commonsuffix));
  }
  this.diff_cleanupMerge(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
    deadline) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [new diff_match_patch.Diff(DIFF_INSERT, text2)];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [new diff_match_patch.Diff(DIFF_DELETE, text1)];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [new diff_match_patch.Diff(DIFF_INSERT, longtext.substring(0, i)),
             new diff_match_patch.Diff(DIFF_EQUAL, shorttext),
             new diff_match_patch.Diff(DIFF_INSERT,
                 longtext.substring(i + shorttext.length))];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [new diff_match_patch.Diff(DIFF_DELETE, text1),
            new diff_match_patch.Diff(DIFF_INSERT, text2)];
  }

  // Check to see if the problem can be split in two.
  var hm = this.diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
    // Merge the results.
    return diffs_a.concat([new diff_match_patch.Diff(DIFF_EQUAL, mid_common)],
                          diffs_b);
  }

  if (checklines && text1.length > 100 && text2.length > 100) {
    return this.diff_lineMode_(text1, text2, deadline);
  }

  return this.diff_bisect_(text1, text2, deadline);
};


/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
  // Scan the text on a line-by-line basis first.
  var a = this.diff_linesToChars_(text1, text2);
  text1 = a.chars1;
  text2 = a.chars2;
  var linearray = a.lineArray;

  var diffs = this.diff_main(text1, text2, false, deadline);

  // Convert the diff back to original text.
  this.diff_charsToLines_(diffs, linearray);
  // Eliminate freak matches (e.g. blank lines)
  this.diff_cleanupSemantic(diffs);

  // Rediff any replacement blocks, this time character-by-character.
  // Add a dummy entry at the end.
  diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, ''));
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete >= 1 && count_insert >= 1) {
          // Delete the offending records and add the merged ones.
          diffs.splice(pointer - count_delete - count_insert,
                       count_delete + count_insert);
          pointer = pointer - count_delete - count_insert;
          var subDiff =
              this.diff_main(text_delete, text_insert, false, deadline);
          for (var j = subDiff.length - 1; j >= 0; j--) {
            diffs.splice(pointer, 0, subDiff[j]);
          }
          pointer = pointer + subDiff.length;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
    pointer++;
  }
  diffs.pop();  // Remove the dummy entry at the end.

  return diffs;
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Bail out if deadline is reached.
    if ((new Date()).getTime() > deadline) {
      break;
    }

    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [new diff_match_patch.Diff(DIFF_DELETE, text1),
          new diff_match_patch.Diff(DIFF_INSERT, text2)];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
    deadline) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = this.diff_main(text1a, text2a, false, deadline);
  var diffsb = this.diff_main(text1b, text2b, false, deadline);

  return diffs.concat(diffsb);
};


/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */
diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4

  // '\x00' is a valid character, but various debuggers don't like it.
  // So we'll insert a junk entry to avoid generating a null character.
  lineArray[0] = '';

  /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */
  function diff_linesToCharsMunge_(text) {
    var chars = '';
    // Walk the text, pulling out a substring for each line.
    // text.split('\n') would would temporarily double our memory footprint.
    // Modifying text would create many large strings to garbage collect.
    var lineStart = 0;
    var lineEnd = -1;
    // Keeping our own length variable is faster than looking it up.
    var lineArrayLength = lineArray.length;
    while (lineEnd < text.length - 1) {
      lineEnd = text.indexOf('\n', lineStart);
      if (lineEnd == -1) {
        lineEnd = text.length - 1;
      }
      var line = text.substring(lineStart, lineEnd + 1);

      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
          (lineHash[line] !== undefined)) {
        chars += String.fromCharCode(lineHash[line]);
      } else {
        if (lineArrayLength == maxLines) {
          // Bail out at 65535 because
          // String.fromCharCode(65536) == String.fromCharCode(0)
          line = text.substring(lineStart);
          lineEnd = text.length;
        }
        chars += String.fromCharCode(lineArrayLength);
        lineHash[line] = lineArrayLength;
        lineArray[lineArrayLength++] = line;
      }
      lineStart = lineEnd + 1;
    }
    return chars;
  }
  // Allocate 2/3rds of the space for text1, the rest for text2.
  var maxLines = 40000;
  var chars1 = diff_linesToCharsMunge_(text1);
  maxLines = 65535;
  var chars2 = diff_linesToCharsMunge_(text2);
  return {chars1: chars1, chars2: chars2, lineArray: lineArray};
};


/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */
diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
  for (var i = 0; i < diffs.length; i++) {
    var chars = diffs[i][1];
    var text = [];
    for (var j = 0; j < chars.length; j++) {
      text[j] = lineArray[chars.charCodeAt(j)];
    }
    diffs[i][1] = text.join('');
  }
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: https://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: https://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */
diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  // Eliminate the null case.
  if (text1_length == 0 || text2_length == 0) {
    return 0;
  }
  // Truncate the longer string.
  if (text1_length > text2_length) {
    text1 = text1.substring(text1_length - text2_length);
  } else if (text1_length < text2_length) {
    text2 = text2.substring(0, text1_length);
  }
  var text_length = Math.min(text1_length, text2_length);
  // Quick check for the worst case.
  if (text1 == text2) {
    return text_length;
  }

  // Start by looking for a single character match
  // and increase length until no match is found.
  // Performance analysis: https://neil.fraser.name/news/2010/11/04/
  var best = 0;
  var length = 1;
  while (true) {
    var pattern = text1.substring(text_length - length);
    var found = text2.indexOf(pattern);
    if (found == -1) {
      return best;
    }
    length += found;
    if (found == 0 || text1.substring(text_length - length) ==
        text2.substring(0, length)) {
      best = length;
      length++;
    }
  }
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */
diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
  if (this.Diff_Timeout <= 0) {
    // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
  }
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }
  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
                                               shorttext.substring(j));
      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
                                               shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastEquality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Number of characters that changed prior to the equality.
  var length_insertions1 = 0;
  var length_deletions1 = 0;
  // Number of characters that changed after the equality.
  var length_insertions2 = 0;
  var length_deletions2 = 0;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      equalities[equalitiesLength++] = pointer;
      length_insertions1 = length_insertions2;
      length_deletions1 = length_deletions2;
      length_insertions2 = 0;
      length_deletions2 = 0;
      lastEquality = diffs[pointer][1];
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_INSERT) {
        length_insertions2 += diffs[pointer][1].length;
      } else {
        length_deletions2 += diffs[pointer][1].length;
      }
      // Eliminate an equality that is smaller or equal to the edits on both
      // sides of it.
      if (lastEquality && (lastEquality.length <=
          Math.max(length_insertions1, length_deletions1)) &&
          (lastEquality.length <= Math.max(length_insertions2,
                                           length_deletions2))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     new diff_match_patch.Diff(DIFF_DELETE, lastEquality));
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        // Throw away the equality we just deleted.
        equalitiesLength--;
        // Throw away the previous equality (it needs to be reevaluated).
        equalitiesLength--;
        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
        length_insertions1 = 0;  // Reset the counters.
        length_deletions1 = 0;
        length_insertions2 = 0;
        length_deletions2 = 0;
        lastEquality = null;
        changes = true;
      }
    }
    pointer++;
  }

  // Normalize the diff.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
  this.diff_cleanupSemanticLossless(diffs);

  // Find any overlaps between deletions and insertions.
  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
  //   -> <del>abc</del>xxx<ins>def</ins>
  // e.g: <del>xxxabc</del><ins>defxxx</ins>
  //   -> <ins>def</ins>xxx<del>abc</del>
  // Only extract an overlap if it is as big as the edit ahead or behind it.
  pointer = 1;
  while (pointer < diffs.length) {
    if (diffs[pointer - 1][0] == DIFF_DELETE &&
        diffs[pointer][0] == DIFF_INSERT) {
      var deletion = diffs[pointer - 1][1];
      var insertion = diffs[pointer][1];
      var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
      var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
      if (overlap_length1 >= overlap_length2) {
        if (overlap_length1 >= deletion.length / 2 ||
            overlap_length1 >= insertion.length / 2) {
          // Overlap found.  Insert an equality and trim the surrounding edits.
          diffs.splice(pointer, 0, new diff_match_patch.Diff(DIFF_EQUAL,
              insertion.substring(0, overlap_length1)));
          diffs[pointer - 1][1] =
              deletion.substring(0, deletion.length - overlap_length1);
          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
          pointer++;
        }
      } else {
        if (overlap_length2 >= deletion.length / 2 ||
            overlap_length2 >= insertion.length / 2) {
          // Reverse overlap found.
          // Insert an equality and swap and trim the surrounding edits.
          diffs.splice(pointer, 0, new diff_match_patch.Diff(DIFF_EQUAL,
              deletion.substring(0, overlap_length2)));
          diffs[pointer - 1][0] = DIFF_INSERT;
          diffs[pointer - 1][1] =
              insertion.substring(0, insertion.length - overlap_length2);
          diffs[pointer + 1][0] = DIFF_DELETE;
          diffs[pointer + 1][1] =
              deletion.substring(overlap_length2);
          pointer++;
        }
      }
      pointer++;
    }
    pointer++;
  }
};


/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
  /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */
  function diff_cleanupSemanticScore_(one, two) {
    if (!one || !two) {
      // Edges are the best.
      return 6;
    }

    // Each port of this function behaves slightly differently due to
    // subtle differences in each language's definition of things like
    // 'whitespace'.  Since this function's purpose is largely cosmetic,
    // the choice has been made to use each language's native features
    // rather than force total conformity.
    var char1 = one.charAt(one.length - 1);
    var char2 = two.charAt(0);
    var nonAlphaNumeric1 = char1.match(diff_match_patch.nonAlphaNumericRegex_);
    var nonAlphaNumeric2 = char2.match(diff_match_patch.nonAlphaNumericRegex_);
    var whitespace1 = nonAlphaNumeric1 &&
        char1.match(diff_match_patch.whitespaceRegex_);
    var whitespace2 = nonAlphaNumeric2 &&
        char2.match(diff_match_patch.whitespaceRegex_);
    var lineBreak1 = whitespace1 &&
        char1.match(diff_match_patch.linebreakRegex_);
    var lineBreak2 = whitespace2 &&
        char2.match(diff_match_patch.linebreakRegex_);
    var blankLine1 = lineBreak1 &&
        one.match(diff_match_patch.blanklineEndRegex_);
    var blankLine2 = lineBreak2 &&
        two.match(diff_match_patch.blanklineStartRegex_);

    if (blankLine1 || blankLine2) {
      // Five points for blank lines.
      return 5;
    } else if (lineBreak1 || lineBreak2) {
      // Four points for line breaks.
      return 4;
    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
      // Three points for end of sentences.
      return 3;
    } else if (whitespace1 || whitespace2) {
      // Two points for whitespace.
      return 2;
    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
      // One point for non-alphanumeric.
      return 1;
    }
    return 0;
  }

  var pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      var equality1 = diffs[pointer - 1][1];
      var edit = diffs[pointer][1];
      var equality2 = diffs[pointer + 1][1];

      // First, shift the edit as far left as possible.
      var commonOffset = this.diff_commonSuffix(equality1, edit);
      if (commonOffset) {
        var commonString = edit.substring(edit.length - commonOffset);
        equality1 = equality1.substring(0, equality1.length - commonOffset);
        edit = commonString + edit.substring(0, edit.length - commonOffset);
        equality2 = commonString + equality2;
      }

      // Second, step character by character right, looking for the best fit.
      var bestEquality1 = equality1;
      var bestEdit = edit;
      var bestEquality2 = equality2;
      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
          diff_cleanupSemanticScore_(edit, equality2);
      while (edit.charAt(0) === equality2.charAt(0)) {
        equality1 += edit.charAt(0);
        edit = edit.substring(1) + equality2.charAt(0);
        equality2 = equality2.substring(1);
        var score = diff_cleanupSemanticScore_(equality1, edit) +
            diff_cleanupSemanticScore_(edit, equality2);
        // The >= encourages trailing rather than leading whitespace on edits.
        if (score >= bestScore) {
          bestScore = score;
          bestEquality1 = equality1;
          bestEdit = edit;
          bestEquality2 = equality2;
        }
      }

      if (diffs[pointer - 1][1] != bestEquality1) {
        // We have an improvement, save it back to the diff.
        if (bestEquality1) {
          diffs[pointer - 1][1] = bestEquality1;
        } else {
          diffs.splice(pointer - 1, 1);
          pointer--;
        }
        diffs[pointer][1] = bestEdit;
        if (bestEquality2) {
          diffs[pointer + 1][1] = bestEquality2;
        } else {
          diffs.splice(pointer + 1, 1);
          pointer--;
        }
      }
    }
    pointer++;
  }
};

// Define some regex patterns for matching boundaries.
diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
diff_match_patch.whitespaceRegex_ = /\s/;
diff_match_patch.linebreakRegex_ = /[\r\n]/;
diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;

/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastEquality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Is there an insertion operation before the last equality.
  var pre_ins = false;
  // Is there a deletion operation before the last equality.
  var pre_del = false;
  // Is there an insertion operation after the last equality.
  var post_ins = false;
  // Is there a deletion operation after the last equality.
  var post_del = false;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      if (diffs[pointer][1].length < this.Diff_EditCost &&
          (post_ins || post_del)) {
        // Candidate found.
        equalities[equalitiesLength++] = pointer;
        pre_ins = post_ins;
        pre_del = post_del;
        lastEquality = diffs[pointer][1];
      } else {
        // Not a candidate, and can never become one.
        equalitiesLength = 0;
        lastEquality = null;
      }
      post_ins = post_del = false;
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_DELETE) {
        post_del = true;
      } else {
        post_ins = true;
      }
      /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */
      if (lastEquality && ((pre_ins && pre_del && post_ins && post_del) ||
                           ((lastEquality.length < this.Diff_EditCost / 2) &&
                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     new diff_match_patch.Diff(DIFF_DELETE, lastEquality));
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        equalitiesLength--;  // Throw away the equality we just deleted;
        lastEquality = null;
        if (pre_ins && pre_del) {
          // No changes made which could affect previous entry, keep going.
          post_ins = post_del = true;
          equalitiesLength = 0;
        } else {
          equalitiesLength--;  // Throw away the previous equality.
          pointer = equalitiesLength > 0 ?
              equalities[equalitiesLength - 1] : -1;
          post_ins = post_del = false;
        }
        changes = true;
      }
    }
    pointer++;
  }

  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
  // Add a dummy entry at the end.
  diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, ''));
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = this.diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, new diff_match_patch.Diff(DIFF_EQUAL,
                    text_insert.substring(0, commonlength)));
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = this.diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          pointer -= count_delete + count_insert;
          diffs.splice(pointer, count_delete + count_insert);
          if (text_delete.length) {
            diffs.splice(pointer, 0,
                new diff_match_patch.Diff(DIFF_DELETE, text_delete));
            pointer++;
          }
          if (text_insert.length) {
            diffs.splice(pointer, 0,
                new diff_match_patch.Diff(DIFF_INSERT, text_insert));
            pointer++;
          }
          pointer++;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */
diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
  var chars1 = 0;
  var chars2 = 0;
  var last_chars1 = 0;
  var last_chars2 = 0;
  var x;
  for (x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
      chars1 += diffs[x][1].length;
    }
    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
      chars2 += diffs[x][1].length;
    }
    if (chars1 > loc) {  // Overshot the location.
      break;
    }
    last_chars1 = chars1;
    last_chars2 = chars2;
  }
  // Was the location was deleted?
  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
    return last_chars2;
  }
  // Add the remaining character length.
  return last_chars2 + (loc - last_chars1);
};


/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */
diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
  var html = [];
  var pattern_amp = /&/g;
  var pattern_lt = /</g;
  var pattern_gt = />/g;
  var pattern_para = /\n/g;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];    // Operation (insert, delete, equal)
    var data = diffs[x][1];  // Text of change.
    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
    switch (op) {
      case DIFF_INSERT:
        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
        break;
      case DIFF_DELETE:
        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
        break;
      case DIFF_EQUAL:
        html[x] = '<span>' + text + '</span>';
        break;
    }
  }
  return html.join('');
};


/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */
diff_match_patch.prototype.diff_text1 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */
diff_match_patch.prototype.diff_text2 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_DELETE) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */
diff_match_patch.prototype.diff_levenshtein = function(diffs) {
  var levenshtein = 0;
  var insertions = 0;
  var deletions = 0;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];
    var data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        // A deletion and an insertion is one substitution.
        levenshtein += Math.max(insertions, deletions);
        insertions = 0;
        deletions = 0;
        break;
    }
  }
  levenshtein += Math.max(insertions, deletions);
  return levenshtein;
};


/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */
diff_match_patch.prototype.diff_toDelta = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    switch (diffs[x][0]) {
      case DIFF_INSERT:
        text[x] = '+' + encodeURI(diffs[x][1]);
        break;
      case DIFF_DELETE:
        text[x] = '-' + diffs[x][1].length;
        break;
      case DIFF_EQUAL:
        text[x] = '=' + diffs[x][1].length;
        break;
    }
  }
  return text.join('\t').replace(/%20/g, ' ');
};


/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
  var diffs = [];
  var diffsLength = 0;  // Keeping our own length var is faster in JS.
  var pointer = 0;  // Cursor in text1
  var tokens = delta.split(/\t/g);
  for (var x = 0; x < tokens.length; x++) {
    // Each token begins with a one character parameter which specifies the
    // operation of this token (delete, insert, equality).
    var param = tokens[x].substring(1);
    switch (tokens[x].charAt(0)) {
      case '+':
        try {
          diffs[diffsLength++] =
              new diff_match_patch.Diff(DIFF_INSERT, decodeURI(param));
        } catch (ex) {
          // Malformed URI sequence.
          throw new Error('Illegal escape in diff_fromDelta: ' + param);
        }
        break;
      case '-':
        // Fall through.
      case '=':
        var n = parseInt(param, 10);
        if (isNaN(n) || n < 0) {
          throw new Error('Invalid number in diff_fromDelta: ' + param);
        }
        var text = text1.substring(pointer, pointer += n);
        if (tokens[x].charAt(0) == '=') {
          diffs[diffsLength++] = new diff_match_patch.Diff(DIFF_EQUAL, text);
        } else {
          diffs[diffsLength++] = new diff_match_patch.Diff(DIFF_DELETE, text);
        }
        break;
      default:
        // Blank tokens are ok (from a trailing \t).
        // Anything else is an error.
        if (tokens[x]) {
          throw new Error('Invalid diff operation in diff_fromDelta: ' +
                          tokens[x]);
        }
    }
  }
  if (pointer != text1.length) {
    throw new Error('Delta length (' + pointer +
        ') does not equal source text length (' + text1.length + ').');
  }
  return diffs;
};


//  MATCH FUNCTIONS


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */
diff_match_patch.prototype.match_main = function(text, pattern, loc) {
  // Check for null inputs.
  if (text == null || pattern == null || loc == null) {
    throw new Error('Null input. (match_main)');
  }

  loc = Math.max(0, Math.min(loc, text.length));
  if (text == pattern) {
    // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
  } else if (!text.length) {
    // Nothing to match.
    return -1;
  } else if (text.substring(loc, loc + pattern.length) == pattern) {
    // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
  } else {
    // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
  }
};


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */
diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
  if (pattern.length > this.Match_MaxBits) {
    throw new Error('Pattern too long for this browser.');
  }

  // Initialise the alphabet.
  var s = this.match_alphabet_(pattern);

  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */
  function match_bitapScore_(e, x) {
    var accuracy = e / pattern.length;
    var proximity = Math.abs(loc - x);
    if (!dmp.Match_Distance) {
      // Dodge divide by zero error.
      return proximity ? 1.0 : accuracy;
    }
    return accuracy + (proximity / dmp.Match_Distance);
  }

  // Highest score beyond which we give up.
  var score_threshold = this.Match_Threshold;
  // Is there a nearby exact match? (speedup)
  var best_loc = text.indexOf(pattern, loc);
  if (best_loc != -1) {
    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    // What about in the other direction? (speedup)
    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
    if (best_loc != -1) {
      score_threshold =
          Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
  }

  // Initialise the bit arrays.
  var matchmask = 1 << (pattern.length - 1);
  best_loc = -1;

  var bin_min, bin_mid;
  var bin_max = pattern.length + text.length;
  var last_rd;
  for (var d = 0; d < pattern.length; d++) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from 'loc' we can stray at this
    // error level.
    bin_min = 0;
    bin_mid = bin_max;
    while (bin_min < bin_mid) {
      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
        bin_min = bin_mid;
      } else {
        bin_max = bin_mid;
      }
      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
    }
    // Use the result from this iteration as the maximum for the next.
    bin_max = bin_mid;
    var start = Math.max(1, loc - bin_mid + 1);
    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;

    var rd = Array(finish + 2);
    rd[finish + 1] = (1 << d) - 1;
    for (var j = finish; j >= start; j--) {
      // The alphabet (s) is a sparse hash, so the following line generates
      // warnings.
      var charMatch = s[text.charAt(j - 1)];
      if (d === 0) {  // First pass: exact match.
        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
      } else {  // Subsequent passes: fuzzy match.
        rd[j] = (((rd[j + 1] << 1) | 1) & charMatch) |
                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
                last_rd[j + 1];
      }
      if (rd[j] & matchmask) {
        var score = match_bitapScore_(d, j - 1);
        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (score <= score_threshold) {
          // Told you so.
          score_threshold = score;
          best_loc = j - 1;
          if (best_loc > loc) {
            // When passing loc, don't exceed our current distance from loc.
            start = Math.max(1, 2 * loc - best_loc);
          } else {
            // Already passed loc, downhill from here on in.
            break;
          }
        }
      }
    }
    // No hope for a (better) match at greater error levels.
    if (match_bitapScore_(d + 1, loc) > score_threshold) {
      break;
    }
    last_rd = rd;
  }
  return best_loc;
};


/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */
diff_match_patch.prototype.match_alphabet_ = function(pattern) {
  var s = {};
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] = 0;
  }
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
  }
  return s;
};


//  PATCH FUNCTIONS


/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */
diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
  if (text.length == 0) {
    return;
  }
  if (patch.start2 === null) {
    throw Error('patch not initialized');
  }
  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
  var padding = 0;

  // Look for the first and last matches of pattern in text.  If two different
  // matches are found, increase the pattern length.
  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
         pattern.length < this.Match_MaxBits - this.Patch_Margin -
         this.Patch_Margin) {
    padding += this.Patch_Margin;
    pattern = text.substring(patch.start2 - padding,
                             patch.start2 + patch.length1 + padding);
  }
  // Add one chunk for good luck.
  padding += this.Patch_Margin;

  // Add the prefix.
  var prefix = text.substring(patch.start2 - padding, patch.start2);
  if (prefix) {
    patch.diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, prefix));
  }
  // Add the suffix.
  var suffix = text.substring(patch.start2 + patch.length1,
                              patch.start2 + patch.length1 + padding);
  if (suffix) {
    patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, suffix));
  }

  // Roll back the start points.
  patch.start1 -= prefix.length;
  patch.start2 -= prefix.length;
  // Extend the lengths.
  patch.length1 += prefix.length + suffix.length;
  patch.length2 += prefix.length + suffix.length;
};


/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
  var text1, diffs;
  if (typeof a == 'string' && typeof opt_b == 'string' &&
      typeof opt_c == 'undefined') {
    // Method 1: text1, text2
    // Compute diffs from text1 and text2.
    text1 = /** @type {string} */(a);
    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
    if (diffs.length > 2) {
      this.diff_cleanupSemantic(diffs);
      this.diff_cleanupEfficiency(diffs);
    }
  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
      typeof opt_c == 'undefined') {
    // Method 2: diffs
    // Compute text1 from diffs.
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
    text1 = this.diff_text1(diffs);
  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
      typeof opt_c == 'undefined') {
    // Method 3: text1, diffs
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
      opt_c && typeof opt_c == 'object') {
    // Method 4: text1, text2, diffs
    // text2 is not used.
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
  } else {
    throw new Error('Unknown call format to patch_make.');
  }

  if (diffs.length === 0) {
    return [];  // Get rid of the null case.
  }
  var patches = [];
  var patch = new diff_match_patch.patch_obj();
  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
  var char_count1 = 0;  // Number of characters into the text1 string.
  var char_count2 = 0;  // Number of characters into the text2 string.
  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
  // text2 (postpatch_text).  We recreate the patches one by one to determine
  // context info.
  var prepatch_text = text1;
  var postpatch_text = text1;
  for (var x = 0; x < diffs.length; x++) {
    var diff_type = diffs[x][0];
    var diff_text = diffs[x][1];

    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
      // A new patch starts here.
      patch.start1 = char_count1;
      patch.start2 = char_count2;
    }

    switch (diff_type) {
      case DIFF_INSERT:
        patch.diffs[patchDiffLength++] = diffs[x];
        patch.length2 += diff_text.length;
        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
                         postpatch_text.substring(char_count2);
        break;
      case DIFF_DELETE:
        patch.length1 += diff_text.length;
        patch.diffs[patchDiffLength++] = diffs[x];
        postpatch_text = postpatch_text.substring(0, char_count2) +
                         postpatch_text.substring(char_count2 +
                             diff_text.length);
        break;
      case DIFF_EQUAL:
        if (diff_text.length <= 2 * this.Patch_Margin &&
            patchDiffLength && diffs.length != x + 1) {
          // Small equality inside a patch.
          patch.diffs[patchDiffLength++] = diffs[x];
          patch.length1 += diff_text.length;
          patch.length2 += diff_text.length;
        } else if (diff_text.length >= 2 * this.Patch_Margin) {
          // Time for a new patch.
          if (patchDiffLength) {
            this.patch_addContext_(patch, prepatch_text);
            patches.push(patch);
            patch = new diff_match_patch.patch_obj();
            patchDiffLength = 0;
            // Unlike Unidiff, our patch lists have a rolling context.
            // https://github.com/google/diff-match-patch/wiki/Unidiff
            // Update prepatch text & pos to reflect the application of the
            // just completed patch.
            prepatch_text = postpatch_text;
            char_count1 = char_count2;
          }
        }
        break;
    }

    // Update the current character count.
    if (diff_type !== DIFF_INSERT) {
      char_count1 += diff_text.length;
    }
    if (diff_type !== DIFF_DELETE) {
      char_count2 += diff_text.length;
    }
  }
  // Pick up the leftover patch if not empty.
  if (patchDiffLength) {
    this.patch_addContext_(patch, prepatch_text);
    patches.push(patch);
  }

  return patches;
};


/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_deepCopy = function(patches) {
  // Making deep copies is hard in JavaScript.
  var patchesCopy = [];
  for (var x = 0; x < patches.length; x++) {
    var patch = patches[x];
    var patchCopy = new diff_match_patch.patch_obj();
    patchCopy.diffs = [];
    for (var y = 0; y < patch.diffs.length; y++) {
      patchCopy.diffs[y] =
          new diff_match_patch.Diff(patch.diffs[y][0], patch.diffs[y][1]);
    }
    patchCopy.start1 = patch.start1;
    patchCopy.start2 = patch.start2;
    patchCopy.length1 = patch.length1;
    patchCopy.length2 = patch.length2;
    patchesCopy[x] = patchCopy;
  }
  return patchesCopy;
};


/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */
diff_match_patch.prototype.patch_apply = function(patches, text) {
  if (patches.length == 0) {
    return [text, []];
  }

  // Deep copy the patches so that no changes are made to originals.
  patches = this.patch_deepCopy(patches);

  var nullPadding = this.patch_addPadding(patches);
  text = nullPadding + text + nullPadding;

  this.patch_splitMax(patches);
  // delta keeps track of the offset between the expected and actual location
  // of the previous patch.  If there are patches expected at positions 10 and
  // 20, but the first patch was found at 12, delta is 2 and the second patch
  // has an effective expected position of 22.
  var delta = 0;
  var results = [];
  for (var x = 0; x < patches.length; x++) {
    var expected_loc = patches[x].start2 + delta;
    var text1 = this.diff_text1(patches[x].diffs);
    var start_loc;
    var end_loc = -1;
    if (text1.length > this.Match_MaxBits) {
      // patch_splitMax will only provide an oversized pattern in the case of
      // a monster delete.
      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
                                  expected_loc);
      if (start_loc != -1) {
        end_loc = this.match_main(text,
            text1.substring(text1.length - this.Match_MaxBits),
            expected_loc + text1.length - this.Match_MaxBits);
        if (end_loc == -1 || start_loc >= end_loc) {
          // Can't find valid trailing context.  Drop this patch.
          start_loc = -1;
        }
      }
    } else {
      start_loc = this.match_main(text, text1, expected_loc);
    }
    if (start_loc == -1) {
      // No match found.  :(
      results[x] = false;
      // Subtract the delta for this failed patch from subsequent patches.
      delta -= patches[x].length2 - patches[x].length1;
    } else {
      // Found a match.  :)
      results[x] = true;
      delta = start_loc - expected_loc;
      var text2;
      if (end_loc == -1) {
        text2 = text.substring(start_loc, start_loc + text1.length);
      } else {
        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
      }
      if (text1 == text2) {
        // Perfect match, just shove the replacement text in.
        text = text.substring(0, start_loc) +
               this.diff_text2(patches[x].diffs) +
               text.substring(start_loc + text1.length);
      } else {
        // Imperfect match.  Run a diff to get a framework of equivalent
        // indices.
        var diffs = this.diff_main(text1, text2, false);
        if (text1.length > this.Match_MaxBits &&
            this.diff_levenshtein(diffs) / text1.length >
            this.Patch_DeleteThreshold) {
          // The end points match, but the content is unacceptably bad.
          results[x] = false;
        } else {
          this.diff_cleanupSemanticLossless(diffs);
          var index1 = 0;
          var index2;
          for (var y = 0; y < patches[x].diffs.length; y++) {
            var mod = patches[x].diffs[y];
            if (mod[0] !== DIFF_EQUAL) {
              index2 = this.diff_xIndex(diffs, index1);
            }
            if (mod[0] === DIFF_INSERT) {  // Insertion
              text = text.substring(0, start_loc + index2) + mod[1] +
                     text.substring(start_loc + index2);
            } else if (mod[0] === DIFF_DELETE) {  // Deletion
              text = text.substring(0, start_loc + index2) +
                     text.substring(start_loc + this.diff_xIndex(diffs,
                         index1 + mod[1].length));
            }
            if (mod[0] !== DIFF_DELETE) {
              index1 += mod[1].length;
            }
          }
        }
      }
    }
  }
  // Strip the padding off.
  text = text.substring(nullPadding.length, text.length - nullPadding.length);
  return [text, results];
};


/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */
diff_match_patch.prototype.patch_addPadding = function(patches) {
  var paddingLength = this.Patch_Margin;
  var nullPadding = '';
  for (var x = 1; x <= paddingLength; x++) {
    nullPadding += String.fromCharCode(x);
  }

  // Bump all the patches forward.
  for (var x = 0; x < patches.length; x++) {
    patches[x].start1 += paddingLength;
    patches[x].start2 += paddingLength;
  }

  // Add some padding on start of first diff.
  var patch = patches[0];
  var diffs = patch.diffs;
  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.unshift(new diff_match_patch.Diff(DIFF_EQUAL, nullPadding));
    patch.start1 -= paddingLength;  // Should be 0.
    patch.start2 -= paddingLength;  // Should be 0.
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[0][1].length) {
    // Grow first equality.
    var extraLength = paddingLength - diffs[0][1].length;
    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
    patch.start1 -= extraLength;
    patch.start2 -= extraLength;
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  // Add some padding on end of last diff.
  patch = patches[patches.length - 1];
  diffs = patch.diffs;
  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, nullPadding));
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
    // Grow last equality.
    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  return nullPadding;
};


/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */
diff_match_patch.prototype.patch_splitMax = function(patches) {
  var patch_size = this.Match_MaxBits;
  for (var x = 0; x < patches.length; x++) {
    if (patches[x].length1 <= patch_size) {
      continue;
    }
    var bigpatch = patches[x];
    // Remove the big old patch.
    patches.splice(x--, 1);
    var start1 = bigpatch.start1;
    var start2 = bigpatch.start2;
    var precontext = '';
    while (bigpatch.diffs.length !== 0) {
      // Create one of several smaller patches.
      var patch = new diff_match_patch.patch_obj();
      var empty = true;
      patch.start1 = start1 - precontext.length;
      patch.start2 = start2 - precontext.length;
      if (precontext !== '') {
        patch.length1 = patch.length2 = precontext.length;
        patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, precontext));
      }
      while (bigpatch.diffs.length !== 0 &&
             patch.length1 < patch_size - this.Patch_Margin) {
        var diff_type = bigpatch.diffs[0][0];
        var diff_text = bigpatch.diffs[0][1];
        if (diff_type === DIFF_INSERT) {
          // Insertions are harmless.
          patch.length2 += diff_text.length;
          start2 += diff_text.length;
          patch.diffs.push(bigpatch.diffs.shift());
          empty = false;
        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
                   patch.diffs[0][0] == DIFF_EQUAL &&
                   diff_text.length > 2 * patch_size) {
          // This is a large deletion.  Let it pass in one chunk.
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          empty = false;
          patch.diffs.push(new diff_match_patch.Diff(diff_type, diff_text));
          bigpatch.diffs.shift();
        } else {
          // Deletion or equality.  Only take as much as we can stomach.
          diff_text = diff_text.substring(0,
              patch_size - patch.length1 - this.Patch_Margin);
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          if (diff_type === DIFF_EQUAL) {
            patch.length2 += diff_text.length;
            start2 += diff_text.length;
          } else {
            empty = false;
          }
          patch.diffs.push(new diff_match_patch.Diff(diff_type, diff_text));
          if (diff_text == bigpatch.diffs[0][1]) {
            bigpatch.diffs.shift();
          } else {
            bigpatch.diffs[0][1] =
                bigpatch.diffs[0][1].substring(diff_text.length);
          }
        }
      }
      // Compute the head context for the next patch.
      precontext = this.diff_text2(patch.diffs);
      precontext =
          precontext.substring(precontext.length - this.Patch_Margin);
      // Append the end context for this patch.
      var postcontext = this.diff_text1(bigpatch.diffs)
                            .substring(0, this.Patch_Margin);
      if (postcontext !== '') {
        patch.length1 += postcontext.length;
        patch.length2 += postcontext.length;
        if (patch.diffs.length !== 0 &&
            patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
          patch.diffs[patch.diffs.length - 1][1] += postcontext;
        } else {
          patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, postcontext));
        }
      }
      if (!empty) {
        patches.splice(++x, 0, patch);
      }
    }
  }
};


/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */
diff_match_patch.prototype.patch_toText = function(patches) {
  var text = [];
  for (var x = 0; x < patches.length; x++) {
    text[x] = patches[x];
  }
  return text.join('');
};


/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.patch_fromText = function(textline) {
  var patches = [];
  if (!textline) {
    return patches;
  }
  var text = textline.split('\n');
  var textPointer = 0;
  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
  while (textPointer < text.length) {
    var m = text[textPointer].match(patchHeader);
    if (!m) {
      throw new Error('Invalid patch string: ' + text[textPointer]);
    }
    var patch = new diff_match_patch.patch_obj();
    patches.push(patch);
    patch.start1 = parseInt(m[1], 10);
    if (m[2] === '') {
      patch.start1--;
      patch.length1 = 1;
    } else if (m[2] == '0') {
      patch.length1 = 0;
    } else {
      patch.start1--;
      patch.length1 = parseInt(m[2], 10);
    }

    patch.start2 = parseInt(m[3], 10);
    if (m[4] === '') {
      patch.start2--;
      patch.length2 = 1;
    } else if (m[4] == '0') {
      patch.length2 = 0;
    } else {
      patch.start2--;
      patch.length2 = parseInt(m[4], 10);
    }
    textPointer++;

    while (textPointer < text.length) {
      var sign = text[textPointer].charAt(0);
      try {
        var line = decodeURI(text[textPointer].substring(1));
      } catch (ex) {
        // Malformed URI sequence.
        throw new Error('Illegal escape in patch_fromText: ' + line);
      }
      if (sign == '-') {
        // Deletion.
        patch.diffs.push(new diff_match_patch.Diff(DIFF_DELETE, line));
      } else if (sign == '+') {
        // Insertion.
        patch.diffs.push(new diff_match_patch.Diff(DIFF_INSERT, line));
      } else if (sign == ' ') {
        // Minor equality.
        patch.diffs.push(new diff_match_patch.Diff(DIFF_EQUAL, line));
      } else if (sign == '@') {
        // Start of next patch.
        break;
      } else if (sign === '') {
        // Blank line?  Whatever.
      } else {
        // WTF?
        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
      }
      textPointer++;
    }
  }
  return patches;
};


/**
 * Class representing one patch operation.
 * @constructor
 */
diff_match_patch.patch_obj = function() {
  /** @type {!Array.<!diff_match_patch.Diff>} */
  this.diffs = [];
  /** @type {?number} */
  this.start1 = null;
  /** @type {?number} */
  this.start2 = null;
  /** @type {number} */
  this.length1 = 0;
  /** @type {number} */
  this.length2 = 0;
};


/**
 * Emulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indices are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */
diff_match_patch.patch_obj.prototype.toString = function() {
  var coords1, coords2;
  if (this.length1 === 0) {
    coords1 = this.start1 + ',0';
  } else if (this.length1 == 1) {
    coords1 = this.start1 + 1;
  } else {
    coords1 = (this.start1 + 1) + ',' + this.length1;
  }
  if (this.length2 === 0) {
    coords2 = this.start2 + ',0';
  } else if (this.length2 == 1) {
    coords2 = this.start2 + 1;
  } else {
    coords2 = (this.start2 + 1) + ',' + this.length2;
  }
  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
  var op;
  // Escape the body of the patch with %xx notation.
  for (var x = 0; x < this.diffs.length; x++) {
    switch (this.diffs[x][0]) {
      case DIFF_INSERT:
        op = '+';
        break;
      case DIFF_DELETE:
        op = '-';
        break;
      case DIFF_EQUAL:
        op = ' ';
        break;
    }
    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
  }
  return text.join('').replace(/%20/g, ' ');
};


// The following export code was added by @ForbesLindesay
module.exports = diff_match_patch;
module.exports['diff_match_patch'] = diff_match_patch;
module.exports['DIFF_DELETE'] = DIFF_DELETE;
module.exports['DIFF_INSERT'] = DIFF_INSERT;
module.exports['DIFF_EQUAL'] = DIFF_EQUAL;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var DocCommentHighlightRules = function() {
    this.$rules = {
        "start" : [ {
            token : "comment.doc.tag",
            regex : "@[\\w\\d_]+" // TODO: fix email addresses
        }, 
        DocCommentHighlightRules.getTagRule(),
        {
            defaultToken : "comment.doc",
            caseInsensitive: true
        }]
    };
};

oop.inherits(DocCommentHighlightRules, TextHighlightRules);

DocCommentHighlightRules.getTagRule = function(start) {
    return {
        token : "comment.doc.tag.storage.type",
        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
    };
};

DocCommentHighlightRules.getStartRule = function(start) {
    return {
        token : "comment.doc", // doc comment
        regex : "\\/\\*(?=\\*)",
        next  : start
    };
};

DocCommentHighlightRules.getEndRule = function (start) {
    return {
        token : "comment.doc", // closing comment
        regex : "\\*\\/",
        next  : start
    };
};


exports.DocCommentHighlightRules = DocCommentHighlightRules;

});

ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
var identifierRe = "[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";

var JavaScriptHighlightRules = function(options) {
    var keywordMapper = this.createKeywordMapper({
        "variable.language":
            "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|"  + // Constructors
            "Namespace|QName|XML|XMLList|"                                             + // E4X
            "ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|"   +
            "Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|"                    +
            "Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|"   + // Errors
            "SyntaxError|TypeError|URIError|"                                          +
            "decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|" + // Non-constructor functions
            "isNaN|parseFloat|parseInt|"                                               +
            "JSON|Math|"                                                               + // Other
            "this|arguments|prototype|window|document"                                 , // Pseudo
        "keyword":
            "const|yield|import|get|set|async|await|" +
            "break|case|catch|continue|default|delete|do|else|finally|for|function|" +
            "if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|" +
            "__parent__|__count__|escape|unescape|with|__proto__|" +
            "class|enum|extends|super|export|implements|private|public|interface|package|protected|static",
        "storage.type":
            "const|let|var|function",
        "constant.language":
            "null|Infinity|NaN|undefined",
        "support.function":
            "alert",
        "constant.language.boolean": "true|false"
    }, "identifier");
    var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";

    var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
        "u[0-9a-fA-F]{4}|" + // unicode
        "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
        "[0-2][0-7]{0,2}|" + // oct
        "3[0-7][0-7]?|" + // oct
        "[4-7][0-7]?|" + //oct
        ".)";

    this.$rules = {
        "no_regex" : [
            DocCommentHighlightRules.getStartRule("doc-start"),
            comments("no_regex"),
            {
                token : "string",
                regex : "'(?=.)",
                next  : "qstring"
            }, {
                token : "string",
                regex : '"(?=.)',
                next  : "qqstring"
            }, {
                token : "constant.numeric", // hexadecimal, octal and binary
                regex : /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
            }, {
                token : "constant.numeric", // decimal integers and floats
                regex : /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
            }, {
                token : [
                    "storage.type", "punctuation.operator", "support.function",
                    "punctuation.operator", "entity.name.function", "text","keyword.operator"
                ],
                regex : "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe +")(\\s*)(=)",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "entity.name.function", "text", "keyword.operator", "text", "storage.type",
                    "text", "paren.lparen"
                ],
                regex : "(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(function)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "entity.name.function", "text", "punctuation.operator",
                    "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : [
                    "text", "text", "storage.type", "text", "paren.lparen"
                ],
                regex : "(:)(\\s*)(function)(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : "keyword",
                regex : "from(?=\\s*('|\"))"
            }, {
                token : "keyword",
                regex : "(?:" + kwBeforeRe + ")\\b",
                next : "start"
            }, {
                token : ["support.constant"],
                regex : /that\b/
            }, {
                token : ["storage.type", "punctuation.operator", "support.function.firebug"],
                regex : /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
            }, {
                token : keywordMapper,
                regex : identifierRe
            }, {
                token : "punctuation.operator",
                regex : /[.](?![.])/,
                next  : "property"
            }, {
                token : "storage.type",
                regex : /=>/
            }, {
                token : "keyword.operator",
                regex : /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                next  : "start"
            }, {
                token : "punctuation.operator",
                regex : /[?:,;.]/,
                next  : "start"
            }, {
                token : "paren.lparen",
                regex : /[\[({]/,
                next  : "start"
            }, {
                token : "paren.rparen",
                regex : /[\])}]/
            }, {
                token: "comment",
                regex: /^#!.*$/
            }
        ],
        property: [{
                token : "text",
                regex : "\\s+"
            }, {
                token : [
                    "storage.type", "punctuation.operator", "entity.name.function", "text",
                    "keyword.operator", "text",
                    "storage.type", "text", "entity.name.function", "text", "paren.lparen"
                ],
                regex : "(" + identifierRe + ")(\\.)(" + identifierRe +")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",
                next: "function_arguments"
            }, {
                token : "punctuation.operator",
                regex : /[.](?![.])/
            }, {
                token : "support.function",
                regex : /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
            }, {
                token : "support.function.dom",
                regex : /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
            }, {
                token :  "support.constant",
                regex : /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
            }, {
                token : "identifier",
                regex : identifierRe
            }, {
                regex: "",
                token: "empty",
                next: "no_regex"
            }
        ],
        "start": [
            DocCommentHighlightRules.getStartRule("doc-start"),
            comments("start"),
            {
                token: "string.regexp",
                regex: "\\/",
                next: "regex"
            }, {
                token : "text",
                regex : "\\s+|^$",
                next : "start"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "regex": [
            {
                token: "regexp.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "string.regexp",
                regex: "/[sxngimy]*",
                next: "no_regex"
            }, {
                token : "invalid",
                regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
            }, {
                token : "constant.language.escape",
                regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
            }, {
                token : "constant.language.delimiter",
                regex: /\|/
            }, {
                token: "constant.language.escape",
                regex: /\[\^?/,
                next: "regex_character_class"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp"
            }
        ],
        "regex_character_class": [
            {
                token: "regexp.charclass.keyword.operator",
                regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
            }, {
                token: "constant.language.escape",
                regex: "]",
                next: "regex"
            }, {
                token: "constant.language.escape",
                regex: "-"
            }, {
                token: "empty",
                regex: "$",
                next: "no_regex"
            }, {
                defaultToken: "string.regexp.charachterclass"
            }
        ],
        "function_arguments": [
            {
                token: "variable.parameter",
                regex: identifierRe
            }, {
                token: "punctuation.operator",
                regex: "[, ]+"
            }, {
                token: "punctuation.operator",
                regex: "$"
            }, {
                token: "empty",
                regex: "",
                next: "no_regex"
            }
        ],
        "qqstring" : [
            {
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "string",
                regex : "\\\\$",
                consumeLineEnd  : true
            }, {
                token : "string",
                regex : '"|$',
                next  : "no_regex"
            }, {
                defaultToken: "string"
            }
        ],
        "qstring" : [
            {
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "string",
                regex : "\\\\$",
                consumeLineEnd  : true
            }, {
                token : "string",
                regex : "'|$",
                next  : "no_regex"
            }, {
                defaultToken: "string"
            }
        ]
    };


    if (!options || !options.noES6) {
        this.$rules.no_regex.unshift({
            regex: "[{}]", onMatch: function(val, state, stack) {
                this.next = val == "{" ? this.nextState : "";
                if (val == "{" && stack.length) {
                    stack.unshift("start", state);
                }
                else if (val == "}" && stack.length) {
                    stack.shift();
                    this.next = stack.shift();
                    if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1)
                        return "paren.quasi.end";
                }
                return val == "{" ? "paren.lparen" : "paren.rparen";
            },
            nextState: "start"
        }, {
            token : "string.quasi.start",
            regex : /`/,
            push  : [{
                token : "constant.language.escape",
                regex : escapedRe
            }, {
                token : "paren.quasi.start",
                regex : /\${/,
                push  : "start"
            }, {
                token : "string.quasi.end",
                regex : /`/,
                next  : "pop"
            }, {
                defaultToken: "string.quasi"
            }]
        });

        if (!options || options.jsx != false)
            JSX.call(this);
    }

    this.embedRules(DocCommentHighlightRules, "doc-",
        [ DocCommentHighlightRules.getEndRule("no_regex") ]);

    this.normalizeRules();
};

oop.inherits(JavaScriptHighlightRules, TextHighlightRules);

function JSX() {
    var tagRegex = identifierRe.replace("\\d", "\\d\\-");
    var jsxTag = {
        onMatch : function(val, state, stack) {
            var offset = val.charAt(1) == "/" ? 2 : 1;
            if (offset == 1) {
                if (state != this.nextState)
                    stack.unshift(this.next, this.nextState, 0);
                else
                    stack.unshift(this.next);
                stack[2]++;
            } else if (offset == 2) {
                if (state == this.nextState) {
                    stack[1]--;
                    if (!stack[1] || stack[1] < 0) {
                        stack.shift();
                        stack.shift();
                    }
                }
            }
            return [{
                type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                value: val.slice(0, offset)
            }, {
                type: "meta.tag.tag-name.xml",
                value: val.substr(offset)
            }];
        },
        regex : "</?" + tagRegex + "",
        next: "jsxAttributes",
        nextState: "jsx"
    };
    this.$rules.start.unshift(jsxTag);
    var jsxJsRule = {
        regex: "{",
        token: "paren.quasi.start",
        push: "start"
    };
    this.$rules.jsx = [
        jsxJsRule,
        jsxTag,
        {include : "reference"},
        {defaultToken: "string"}
    ];
    this.$rules.jsxAttributes = [{
        token : "meta.tag.punctuation.tag-close.xml",
        regex : "/?>",
        onMatch : function(value, currentState, stack) {
            if (currentState == stack[0])
                stack.shift();
            if (value.length == 2) {
                if (stack[0] == this.nextState)
                    stack[1]--;
                if (!stack[1] || stack[1] < 0) {
                    stack.splice(0, 2);
                }
            }
            this.next = stack[0] || "start";
            return [{type: this.token, value: value}];
        },
        nextState: "jsx"
    },
    jsxJsRule,
    comments("jsxAttributes"),
    {
        token : "entity.other.attribute-name.xml",
        regex : tagRegex
    }, {
        token : "keyword.operator.attribute-equals.xml",
        regex : "="
    }, {
        token : "text.tag-whitespace.xml",
        regex : "\\s+"
    }, {
        token : "string.attribute-value.xml",
        regex : "'",
        stateName : "jsx_attr_q",
        push : [
            {token : "string.attribute-value.xml", regex: "'", next: "pop"},
            {include : "reference"},
            {defaultToken : "string.attribute-value.xml"}
        ]
    }, {
        token : "string.attribute-value.xml",
        regex : '"',
        stateName : "jsx_attr_qq",
        push : [
            {token : "string.attribute-value.xml", regex: '"', next: "pop"},
            {include : "reference"},
            {defaultToken : "string.attribute-value.xml"}
        ]
    },
    jsxTag
    ];
    this.$rules.reference = [{
        token : "constant.language.escape.reference.xml",
        regex : "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
    }];
}

function comments(next) {
    return [
        {
            token : "comment", // multi line comment
            regex : /\/\*/,
            next: [
                DocCommentHighlightRules.getTagRule(),
                {token : "comment", regex : "\\*\\/", next : next || "pop"},
                {defaultToken : "comment", caseInsensitive: true}
            ]
        }, {
            token : "comment",
            regex : "\\/\\/",
            next: [
                DocCommentHighlightRules.getTagRule(),
                {token : "comment", regex : "$|^", next : next || "pop"},
                {defaultToken : "comment", caseInsensitive: true}
            ]
        }
    ];
}
exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});

ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;

var MatchingBraceOutdent = function() {};

(function() {

    this.checkOutdent = function(line, input) {
        if (! /^\s+$/.test(line))
            return false;

        return /^\s*\}/.test(input);
    };

    this.autoOutdent = function(doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);

        if (!match) return 0;

        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({row: row, column: column});

        if (!openBracePos || openBracePos.row == row) return 0;

        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column-1), indent);
    };

    this.$getIndent = function(line) {
        return line.match(/^\s*/)[0];
    };

}).call(MatchingBraceOutdent.prototype);

exports.MatchingBraceOutdent = MatchingBraceOutdent;
});

ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var Range = acequire("../../range").Range;
var BaseFoldMode = acequire("./fold_mode").FoldMode;

var FoldMode = exports.FoldMode = function(commentRegex) {
    if (commentRegex) {
        this.foldingStartMarker = new RegExp(
            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
        );
        this.foldingStopMarker = new RegExp(
            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
        );
    }
};
oop.inherits(FoldMode, BaseFoldMode);

(function() {
    
    this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
    this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
    this._getFoldWidgetBase = this.getFoldWidget;
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
    
        if (this.singleLineBlockCommentRe.test(line)) {
            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
                return "";
        }
    
        var fw = this._getFoldWidgetBase(session, foldStyle, row);
    
        if (!fw && this.startRegionRe.test(line))
            return "start"; // lineCommentRegionStart
    
        return fw;
    };

    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        
        if (this.startRegionRe.test(line))
            return this.getCommentRegionBlock(session, line, row);
        
        var match = line.match(this.foldingStartMarker);
        if (match) {
            var i = match.index;

            if (match[1])
                return this.openingBracketBlock(session, match[1], row, i);
                
            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
            
            if (range && !range.isMultiLine()) {
                if (forceMultiline) {
                    range = this.getSectionRange(session, row);
                } else if (foldStyle != "all")
                    range = null;
            }
            
            return range;
        }

        if (foldStyle === "markbegin")
            return;

        var match = line.match(this.foldingStopMarker);
        if (match) {
            var i = match.index + match[0].length;

            if (match[1])
                return this.closingBracketBlock(session, match[1], row, i);

            return session.getCommentFoldRange(row, i, -1);
        }
    };
    
    this.getSectionRange = function(session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();
        while (++row < maxRow) {
            line = session.getLine(row);
            var indent = line.search(/\S/);
            if (indent === -1)
                continue;
            if  (startIndent > indent)
                break;
            var subRange = this.getFoldWidgetRange(session, "all", row);
            
            if (subRange) {
                if (subRange.start.row <= startRow) {
                    break;
                } else if (subRange.isMultiLine()) {
                    row = subRange.end.row;
                } else if (startIndent == indent) {
                    break;
                }
            }
            endRow = row;
        }
        
        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
    };
    this.getCommentRegionBlock = function(session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;
        while (++row < maxRow) {
            line = session.getLine(row);
            var m = re.exec(line);
            if (!m) continue;
            if (m[1]) depth--;
            else depth++;

            if (!depth) break;
        }

        var endRow = row;
        if (endRow > startRow) {
            return new Range(startRow, startColumn, endRow, line.length);
        }
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var JavaScriptHighlightRules = acequire("./javascript_highlight_rules").JavaScriptHighlightRules;
var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
var WorkerClient = acequire("../worker/worker_client").WorkerClient;
var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;

var Mode = function() {
    this.HighlightRules = JavaScriptHighlightRules;
    
    this.$outdent = new MatchingBraceOutdent();
    this.$behaviour = new CstyleBehaviour();
    this.foldingRules = new CStyleFoldMode();
};
oop.inherits(Mode, TextMode);

(function() {

    this.lineCommentStart = "//";
    this.blockComment = {start: "/*", end: "*/"};
    this.$quotes = {'"': '"', "'": "'", "`": "`"};

    this.getNextLineIndent = function(state, line, tab) {
        var indent = this.$getIndent(line);

        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
        var tokens = tokenizedLine.tokens;
        var endState = tokenizedLine.state;

        if (tokens.length && tokens[tokens.length-1].type == "comment") {
            return indent;
        }

        if (state == "start" || state == "no_regex") {
            var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
            if (match) {
                indent += tab;
            }
        } else if (state == "doc-start") {
            if (endState == "start" || endState == "no_regex") {
                return "";
            }
            var match = line.match(/^\s*(\/?)\*/);
            if (match) {
                if (match[1]) {
                    indent += " ";
                }
                indent += "* ";
            }
        }

        return indent;
    };

    this.checkOutdent = function(state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };

    this.autoOutdent = function(state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };

    this.createWorker = function(session) {
        var worker = new WorkerClient(["ace"], __webpack_require__(535), "JavaScriptWorker");
        worker.attachToDocument(session.getDocument());

        worker.on("annotate", function(results) {
            session.setAnnotations(results.data);
        });

        worker.on("terminate", function() {
            session.clearAnnotations();
        });

        return worker;
    };

    this.$id = "ace/mode/javascript";
}).call(Mode.prototype);

exports.Mode = Mode;
});

ace.define("ace/mode/java_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var JavaHighlightRules = function() {
    var keywords = (
    "abstract|continue|for|new|switch|" +
    "assert|default|goto|package|synchronized|" +
    "boolean|do|if|private|this|" +
    "break|double|implements|protected|throw|" +
    "byte|else|import|public|throws|" +
    "case|enum|instanceof|return|transient|" +
    "catch|extends|int|short|try|" +
    "char|final|interface|static|void|" +
    "class|finally|long|strictfp|volatile|" +
    "const|float|native|super|while"
    );

    var buildinConstants = ("null|Infinity|NaN|undefined");


    var langClasses = (
        "AbstractMethodError|AssertionError|ClassCircularityError|"+
        "ClassFormatError|Deprecated|EnumConstantNotPresentException|"+
        "ExceptionInInitializerError|IllegalAccessError|"+
        "IllegalThreadStateException|InstantiationError|InternalError|"+
        "NegativeArraySizeException|NoSuchFieldError|Override|Process|"+
        "ProcessBuilder|SecurityManager|StringIndexOutOfBoundsException|"+
        "SuppressWarnings|TypeNotPresentException|UnknownError|"+
        "UnsatisfiedLinkError|UnsupportedClassVersionError|VerifyError|"+
        "InstantiationException|IndexOutOfBoundsException|"+
        "ArrayIndexOutOfBoundsException|CloneNotSupportedException|"+
        "NoSuchFieldException|IllegalArgumentException|NumberFormatException|"+
        "SecurityException|Void|InheritableThreadLocal|IllegalStateException|"+
        "InterruptedException|NoSuchMethodException|IllegalAccessException|"+
        "UnsupportedOperationException|Enum|StrictMath|Package|Compiler|"+
        "Readable|Runtime|StringBuilder|Math|IncompatibleClassChangeError|"+
        "NoSuchMethodError|ThreadLocal|RuntimePermission|ArithmeticException|"+
        "NullPointerException|Long|Integer|Short|Byte|Double|Number|Float|"+
        "Character|Boolean|StackTraceElement|Appendable|StringBuffer|"+
        "Iterable|ThreadGroup|Runnable|Thread|IllegalMonitorStateException|"+
        "StackOverflowError|OutOfMemoryError|VirtualMachineError|"+
        "ArrayStoreException|ClassCastException|LinkageError|"+
        "NoClassDefFoundError|ClassNotFoundException|RuntimeException|"+
        "Exception|ThreadDeath|Error|Throwable|System|ClassLoader|"+
        "Cloneable|Class|CharSequence|Comparable|String|Object"
    );

    var keywordMapper = this.createKeywordMapper({
        "variable.language": "this",
        "keyword": keywords,
        "constant.language": buildinConstants,
        "support.function": langClasses
    }, "identifier");

    this.$rules = {
        "start" : [
            {
                token : "comment",
                regex : "\\/\\/.*$"
            },
            DocCommentHighlightRules.getStartRule("doc-start"),
            {
                token : "comment", // multi line comment
                regex : "\\/\\*",
                next : "comment"
            }, {
                token : "string", // single line
                regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
            }, {
                token : "string", // single line
                regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
            }, {
                token : "constant.numeric", // hex
                regex : /0(?:[xX][0-9a-fA-F][0-9a-fA-F_]*|[bB][01][01_]*)[LlSsDdFfYy]?\b/
            }, {
                token : "constant.numeric", // float
                regex : /[+-]?\d[\d_]*(?:(?:\.[\d_]*)?(?:[eE][+-]?[\d_]+)?)?[LlSsDdFfYy]?\b/
            }, {
                token : "constant.language.boolean",
                regex : "(?:true|false)\\b"
            }, {
                token : keywordMapper,
                regex : "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
            }, {
                token : "keyword.operator",
                regex : "!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?\\:|\\*=|%=|\\+=|\\-=|&=|\\^=|\\b(?:in|instanceof|new|delete|typeof|void)"
            }, {
                token : "lparen",
                regex : "[[({]"
            }, {
                token : "rparen",
                regex : "[\\])}]"
            }, {
                token : "text",
                regex : "\\s+"
            }
        ],
        "comment" : [
            {
                token : "comment", // closing comment
                regex : "\\*\\/",
                next : "start"
            }, {
                defaultToken : "comment"
            }
        ]
    };

    this.embedRules(DocCommentHighlightRules, "doc-",
        [ DocCommentHighlightRules.getEndRule("start") ]);
};

oop.inherits(JavaHighlightRules, TextHighlightRules);

exports.JavaHighlightRules = JavaHighlightRules;
});

ace.define("ace/mode/java",["require","exports","module","ace/lib/oop","ace/mode/javascript","ace/mode/java_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var JavaScriptMode = acequire("./javascript").Mode;
var JavaHighlightRules = acequire("./java_highlight_rules").JavaHighlightRules;

var Mode = function() {
    JavaScriptMode.call(this);
    this.HighlightRules = JavaHighlightRules;
};
oop.inherits(Mode, JavaScriptMode);

(function() {
    
    this.createWorker = function(session) {
        return null;
    };

    this.$id = "ace/mode/java";
}).call(Mode.prototype);

exports.Mode = Mode;
});


/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports.id = 'ace/mode/javascript_worker';
module.exports.src = "\"no use strict\";!function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}}(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}if(\"[object Object]\"!==Object.prototype.toString.call(obj))return obj;copy={};for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/javascript/jshint\",[\"require\",\"exports\",\"module\"],function(acequire,exports,module){module.exports=function outer(modules,cache,entry){function newRequire(name,jumped){if(!cache[name]){if(!modules[name]){var currentRequire=\"function\"==typeof acequire&&acequire;if(!jumped&&currentRequire)return currentRequire(name,!0);if(previousRequire)return previousRequire(name,!0);var err=Error(\"Cannot find module '\"+name+\"'\");throw err.code=\"MODULE_NOT_FOUND\",err}var m=cache[name]={exports:{}};modules[name][0].call(m.exports,function(x){var id=modules[name][1][x];return newRequire(id?id:x)},m,m.exports,outer,modules,cache,entry)}return cache[name].exports}for(var previousRequire=\"function\"==typeof acequire&&acequire,i=0;entry.length>i;i++)newRequire(entry[i]);return newRequire(entry[0])}({\"/node_modules/browserify/node_modules/events/events.js\":[function(_dereq_,module){function EventEmitter(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function isFunction(arg){return\"function\"==typeof arg}function isNumber(arg){return\"number\"==typeof arg}function isObject(arg){return\"object\"==typeof arg&&null!==arg}function isUndefined(arg){return void 0===arg}module.exports=EventEmitter,EventEmitter.EventEmitter=EventEmitter,EventEmitter.prototype._events=void 0,EventEmitter.prototype._maxListeners=void 0,EventEmitter.defaultMaxListeners=10,EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||0>n||isNaN(n))throw TypeError(\"n must be a positive number\");return this._maxListeners=n,this},EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(this._events||(this._events={}),\"error\"===type&&(!this._events.error||isObject(this._events.error)&&!this._events.error.length)){if(er=arguments[1],er instanceof Error)throw er;throw TypeError('Uncaught, unspecified \"error\" event.')}if(handler=this._events[type],isUndefined(handler))return!1;if(isFunction(handler))switch(arguments.length){case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;default:for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];handler.apply(this,args)}else if(isObject(handler)){for(len=arguments.length,args=Array(len-1),i=1;len>i;i++)args[i-1]=arguments[i];for(listeners=handler.slice(),len=listeners.length,i=0;len>i;i++)listeners[i].apply(this,args)}return!0},EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(this._events||(this._events={}),this._events.newListener&&this.emit(\"newListener\",type,isFunction(listener.listener)?listener.listener:listener),this._events[type]?isObject(this._events[type])?this._events[type].push(listener):this._events[type]=[this._events[type],listener]:this._events[type]=listener,isObject(this._events[type])&&!this._events[type].warned){var m;m=isUndefined(this._maxListeners)?EventEmitter.defaultMaxListeners:this._maxListeners,m&&m>0&&this._events[type].length>m&&(this._events[type].warned=!0,console.error(\"(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.\",this._events[type].length),\"function\"==typeof console.trace&&console.trace())}return this},EventEmitter.prototype.on=EventEmitter.prototype.addListener,EventEmitter.prototype.once=function(type,listener){function g(){this.removeListener(type,g),fired||(fired=!0,listener.apply(this,arguments))}if(!isFunction(listener))throw TypeError(\"listener must be a function\");var fired=!1;return g.listener=listener,this.on(type,g),this},EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError(\"listener must be a function\");if(!this._events||!this._events[type])return this;if(list=this._events[type],length=list.length,position=-1,list===listener||isFunction(list.listener)&&list.listener===listener)delete this._events[type],this._events.removeListener&&this.emit(\"removeListener\",type,listener);else if(isObject(list)){for(i=length;i-->0;)if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break}if(0>position)return this;1===list.length?(list.length=0,delete this._events[type]):list.splice(position,1),this._events.removeListener&&this.emit(\"removeListener\",type,listener)}return this},EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[type]&&delete this._events[type],this;if(0===arguments.length){for(key in this._events)\"removeListener\"!==key&&this.removeAllListeners(key);return this.removeAllListeners(\"removeListener\"),this._events={},this\n}if(listeners=this._events[type],isFunction(listeners))this.removeListener(type,listeners);else for(;listeners.length;)this.removeListener(type,listeners[listeners.length-1]);return delete this._events[type],this},EventEmitter.prototype.listeners=function(type){var ret;return ret=this._events&&this._events[type]?isFunction(this._events[type])?[this._events[type]]:this._events[type].slice():[]},EventEmitter.listenerCount=function(emitter,type){var ret;return ret=emitter._events&&emitter._events[type]?isFunction(emitter._events[type])?1:emitter._events[type].length:0}},{}],\"/node_modules/jshint/data/ascii-identifier-data.js\":[function(_dereq_,module){for(var identifierStartTable=[],i=0;128>i;i++)identifierStartTable[i]=36===i||i>=65&&90>=i||95===i||i>=97&&122>=i;for(var identifierPartTable=[],i=0;128>i;i++)identifierPartTable[i]=identifierStartTable[i]||i>=48&&57>=i;module.exports={asciiIdentifierStartTable:identifierStartTable,asciiIdentifierPartTable:identifierPartTable}},{}],\"/node_modules/jshint/lodash.js\":[function(_dereq_,module,exports){(function(global){(function(){function baseFindIndex(array,predicate,fromRight){for(var length=array.length,index=fromRight?length:-1;fromRight?index--:length>++index;)if(predicate(array[index],index,array))return index;return-1}function baseIndexOf(array,value,fromIndex){if(value!==value)return indexOfNaN(array,fromIndex);for(var index=fromIndex-1,length=array.length;length>++index;)if(array[index]===value)return index;return-1}function baseIsFunction(value){return\"function\"==typeof value||!1}function baseToString(value){return\"string\"==typeof value?value:null==value?\"\":value+\"\"}function indexOfNaN(array,fromIndex,fromRight){for(var length=array.length,index=fromIndex+(fromRight?0:-1);fromRight?index--:length>++index;){var other=array[index];if(other!==other)return index}return-1}function isObjectLike(value){return!!value&&\"object\"==typeof value}function lodash(){}function arrayCopy(source,array){var index=-1,length=source.length;for(array||(array=Array(length));length>++index;)array[index]=source[index];return array}function arrayEach(array,iteratee){for(var index=-1,length=array.length;length>++index&&iteratee(array[index],index,array)!==!1;);return array}function arrayFilter(array,predicate){for(var index=-1,length=array.length,resIndex=-1,result=[];length>++index;){var value=array[index];predicate(value,index,array)&&(result[++resIndex]=value)}return result}function arrayMap(array,iteratee){for(var index=-1,length=array.length,result=Array(length);length>++index;)result[index]=iteratee(array[index],index,array);return result}function arrayMax(array){for(var index=-1,length=array.length,result=NEGATIVE_INFINITY;length>++index;){var value=array[index];value>result&&(result=value)}return result}function arraySome(array,predicate){for(var index=-1,length=array.length;length>++index;)if(predicate(array[index],index,array))return!0;return!1}function assignWith(object,source,customizer){var props=keys(source);push.apply(props,getSymbols(source));for(var index=-1,length=props.length;length>++index;){var key=props[index],value=object[key],result=customizer(value,source[key],key,object,source);(result===result?result===value:value!==value)&&(value!==undefined||key in object)||(object[key]=result)}return object}function baseCopy(source,props,object){object||(object={});for(var index=-1,length=props.length;length>++index;){var key=props[index];object[key]=source[key]}return object}function baseCallback(func,thisArg,argCount){var type=typeof func;return\"function\"==type?thisArg===undefined?func:bindCallback(func,thisArg,argCount):null==func?identity:\"object\"==type?baseMatches(func):thisArg===undefined?property(func):baseMatchesProperty(func,thisArg)}function baseClone(value,isDeep,customizer,key,object,stackA,stackB){var result;if(customizer&&(result=object?customizer(value,key,object):customizer(value)),result!==undefined)return result;if(!isObject(value))return value;var isArr=isArray(value);if(isArr){if(result=initCloneArray(value),!isDeep)return arrayCopy(value,result)}else{var tag=objToString.call(value),isFunc=tag==funcTag;if(tag!=objectTag&&tag!=argsTag&&(!isFunc||object))return cloneableTags[tag]?initCloneByTag(value,tag,isDeep):object?value:{};if(result=initCloneObject(isFunc?{}:value),!isDeep)return baseAssign(result,value)}stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==value)return stackB[length];return stackA.push(value),stackB.push(result),(isArr?arrayEach:baseForOwn)(value,function(subValue,key){result[key]=baseClone(subValue,isDeep,customizer,key,value,stackA,stackB)}),result}function baseFilter(collection,predicate){var result=[];return baseEach(collection,function(value,index,collection){predicate(value,index,collection)&&result.push(value)}),result}function baseForIn(object,iteratee){return baseFor(object,iteratee,keysIn)}function baseForOwn(object,iteratee){return baseFor(object,iteratee,keys)}function baseGet(object,path,pathKey){if(null!=object){pathKey!==undefined&&pathKey in toObject(object)&&(path=[pathKey]);for(var index=-1,length=path.length;null!=object&&length>++index;)var result=object=object[path[index]];return result}}function baseIsEqual(value,other,customizer,isLoose,stackA,stackB){if(value===other)return 0!==value||1/value==1/other;var valType=typeof value,othType=typeof other;return\"function\"!=valType&&\"object\"!=valType&&\"function\"!=othType&&\"object\"!=othType||null==value||null==other?value!==value&&other!==other:baseIsEqualDeep(value,other,baseIsEqual,customizer,isLoose,stackA,stackB)}function baseIsEqualDeep(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=arrayTag,othTag=arrayTag;objIsArr||(objTag=objToString.call(object),objTag==argsTag?objTag=objectTag:objTag!=objectTag&&(objIsArr=isTypedArray(object))),othIsArr||(othTag=objToString.call(other),othTag==argsTag?othTag=objectTag:othTag!=objectTag&&(othIsArr=isTypedArray(other)));var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&!objIsArr&&!objIsObj)return equalByTag(object,other,objTag);if(!isLoose){var valWrapped=objIsObj&&hasOwnProperty.call(object,\"__wrapped__\"),othWrapped=othIsObj&&hasOwnProperty.call(other,\"__wrapped__\");if(valWrapped||othWrapped)return equalFunc(valWrapped?object.value():object,othWrapped?other.value():other,customizer,isLoose,stackA,stackB)}if(!isSameTag)return!1;stackA||(stackA=[]),stackB||(stackB=[]);for(var length=stackA.length;length--;)if(stackA[length]==object)return stackB[length]==other;stackA.push(object),stackB.push(other);var result=(objIsArr?equalArrays:equalObjects)(object,other,equalFunc,customizer,isLoose,stackA,stackB);return stackA.pop(),stackB.pop(),result}function baseIsMatch(object,props,values,strictCompareFlags,customizer){for(var index=-1,length=props.length,noCustomizer=!customizer;length>++index;)if(noCustomizer&&strictCompareFlags[index]?values[index]!==object[props[index]]:!(props[index]in object))return!1;for(index=-1;length>++index;){var key=props[index],objValue=object[key],srcValue=values[index];if(noCustomizer&&strictCompareFlags[index])var result=objValue!==undefined||key in object;else result=customizer?customizer(objValue,srcValue,key):undefined,result===undefined&&(result=baseIsEqual(srcValue,objValue,customizer,!0));if(!result)return!1}return!0}function baseMatches(source){var props=keys(source),length=props.length;if(!length)return constant(!0);if(1==length){var key=props[0],value=source[key];if(isStrictComparable(value))return function(object){return null==object?!1:object[key]===value&&(value!==undefined||key in toObject(object))}}for(var values=Array(length),strictCompareFlags=Array(length);length--;)value=source[props[length]],values[length]=value,strictCompareFlags[length]=isStrictComparable(value);return function(object){return null!=object&&baseIsMatch(toObject(object),props,values,strictCompareFlags)}}function baseMatchesProperty(path,value){var isArr=isArray(path),isCommon=isKey(path)&&isStrictComparable(value),pathKey=path+\"\";return path=toPath(path),function(object){if(null==object)return!1;var key=pathKey;if(object=toObject(object),!(!isArr&&isCommon||key in object)){if(object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),null==object)return!1;key=last(path),object=toObject(object)}return object[key]===value?value!==undefined||key in object:baseIsEqual(value,object[key],null,!0)}}function baseMerge(object,source,customizer,stackA,stackB){if(!isObject(object))return object;var isSrcArr=isLength(source.length)&&(isArray(source)||isTypedArray(source));if(!isSrcArr){var props=keys(source);push.apply(props,getSymbols(source))}return arrayEach(props||source,function(srcValue,key){if(props&&(key=srcValue,srcValue=source[key]),isObjectLike(srcValue))stackA||(stackA=[]),stackB||(stackB=[]),baseMergeDeep(object,source,key,baseMerge,customizer,stackA,stackB);else{var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue),!isSrcArr&&result===undefined||!isCommon&&(result===result?result===value:value!==value)||(object[key]=result)}}),object}function baseMergeDeep(object,source,key,mergeFunc,customizer,stackA,stackB){for(var length=stackA.length,srcValue=source[key];length--;)if(stackA[length]==srcValue)return object[key]=stackB[length],undefined;var value=object[key],result=customizer?customizer(value,srcValue,key,object,source):undefined,isCommon=result===undefined;isCommon&&(result=srcValue,isLength(srcValue.length)&&(isArray(srcValue)||isTypedArray(srcValue))?result=isArray(value)?value:getLength(value)?arrayCopy(value):[]:isPlainObject(srcValue)||isArguments(srcValue)?result=isArguments(value)?toPlainObject(value):isPlainObject(value)?value:{}:isCommon=!1),stackA.push(srcValue),stackB.push(result),isCommon?object[key]=mergeFunc(result,srcValue,customizer,stackA,stackB):(result===result?result!==value:value===value)&&(object[key]=result)}function baseProperty(key){return function(object){return null==object?undefined:object[key]}}function basePropertyDeep(path){var pathKey=path+\"\";return path=toPath(path),function(object){return baseGet(object,path,pathKey)}}function baseSlice(array,start,end){var index=-1,length=array.length;start=null==start?0:+start||0,0>start&&(start=-start>length?0:length+start),end=end===undefined||end>length?length:+end||0,0>end&&(end+=length),length=start>end?0:end-start>>>0,start>>>=0;for(var result=Array(length);length>++index;)result[index]=array[index+start];return result}function baseSome(collection,predicate){var result;return baseEach(collection,function(value,index,collection){return result=predicate(value,index,collection),!result}),!!result}function baseValues(object,props){for(var index=-1,length=props.length,result=Array(length);length>++index;)result[index]=object[props[index]];return result}function binaryIndex(array,value,retHighest){var low=0,high=array?array.length:low;if(\"number\"==typeof value&&value===value&&HALF_MAX_ARRAY_LENGTH>=high){for(;high>low;){var mid=low+high>>>1,computed=array[mid];(retHighest?value>=computed:value>computed)?low=mid+1:high=mid}return high}return binaryIndexBy(array,value,identity,retHighest)}function binaryIndexBy(array,value,iteratee,retHighest){value=iteratee(value);for(var low=0,high=array?array.length:0,valIsNaN=value!==value,valIsUndef=value===undefined;high>low;){var mid=floor((low+high)/2),computed=iteratee(array[mid]),isReflexive=computed===computed;if(valIsNaN)var setLow=isReflexive||retHighest;else setLow=valIsUndef?isReflexive&&(retHighest||computed!==undefined):retHighest?value>=computed:value>computed;setLow?low=mid+1:high=mid}return nativeMin(high,MAX_ARRAY_INDEX)}function bindCallback(func,thisArg,argCount){if(\"function\"!=typeof func)return identity;if(thisArg===undefined)return func;switch(argCount){case 1:return function(value){return func.call(thisArg,value)};case 3:return function(value,index,collection){return func.call(thisArg,value,index,collection)};case 4:return function(accumulator,value,index,collection){return func.call(thisArg,accumulator,value,index,collection)};case 5:return function(value,other,key,object,source){return func.call(thisArg,value,other,key,object,source)}}return function(){return func.apply(thisArg,arguments)}}function bufferClone(buffer){return bufferSlice.call(buffer,0)}function createAssigner(assigner){return restParam(function(object,sources){var index=-1,length=null==object?0:sources.length,customizer=length>2&&sources[length-2],guard=length>2&&sources[2],thisArg=length>1&&sources[length-1];for(\"function\"==typeof customizer?(customizer=bindCallback(customizer,thisArg,5),length-=2):(customizer=\"function\"==typeof thisArg?thisArg:null,length-=customizer?1:0),guard&&isIterateeCall(sources[0],sources[1],guard)&&(customizer=3>length?null:customizer,length=1);length>++index;){var source=sources[index];source&&assigner(object,source,customizer)}return object})}function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){var length=collection?getLength(collection):0;if(!isLength(length))return eachFunc(collection,iteratee);for(var index=fromRight?length:-1,iterable=toObject(collection);(fromRight?index--:length>++index)&&iteratee(iterable[index],index,iterable)!==!1;);return collection}}function createBaseFor(fromRight){return function(object,iteratee,keysFunc){for(var iterable=toObject(object),props=keysFunc(object),length=props.length,index=fromRight?length:-1;fromRight?index--:length>++index;){var key=props[index];if(iteratee(iterable[key],key,iterable)===!1)break}return object}}function createFindIndex(fromRight){return function(array,predicate,thisArg){return array&&array.length?(predicate=getCallback(predicate,thisArg,3),baseFindIndex(array,predicate,fromRight)):-1}}function createForEach(arrayFunc,eachFunc){return function(collection,iteratee,thisArg){return\"function\"==typeof iteratee&&thisArg===undefined&&isArray(collection)?arrayFunc(collection,iteratee):eachFunc(collection,bindCallback(iteratee,thisArg,3))}}function equalArrays(array,other,equalFunc,customizer,isLoose,stackA,stackB){var index=-1,arrLength=array.length,othLength=other.length,result=!0;if(arrLength!=othLength&&!(isLoose&&othLength>arrLength))return!1;for(;result&&arrLength>++index;){var arrValue=array[index],othValue=other[index];if(result=undefined,customizer&&(result=isLoose?customizer(othValue,arrValue,index):customizer(arrValue,othValue,index)),result===undefined)if(isLoose)for(var othIndex=othLength;othIndex--&&(othValue=other[othIndex],!(result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB))););else result=arrValue&&arrValue===othValue||equalFunc(arrValue,othValue,customizer,isLoose,stackA,stackB)}return!!result}function equalByTag(object,other,tag){switch(tag){case boolTag:case dateTag:return+object==+other;case errorTag:return object.name==other.name&&object.message==other.message;case numberTag:return object!=+object?other!=+other:0==object?1/object==1/other:object==+other;case regexpTag:case stringTag:return object==other+\"\"}return!1}function equalObjects(object,other,equalFunc,customizer,isLoose,stackA,stackB){var objProps=keys(object),objLength=objProps.length,othProps=keys(other),othLength=othProps.length;if(objLength!=othLength&&!isLoose)return!1;for(var skipCtor=isLoose,index=-1;objLength>++index;){var key=objProps[index],result=isLoose?key in other:hasOwnProperty.call(other,key);if(result){var objValue=object[key],othValue=other[key];result=undefined,customizer&&(result=isLoose?customizer(othValue,objValue,key):customizer(objValue,othValue,key)),result===undefined&&(result=objValue&&objValue===othValue||equalFunc(objValue,othValue,customizer,isLoose,stackA,stackB))}if(!result)return!1;skipCtor||(skipCtor=\"constructor\"==key)}if(!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;if(objCtor!=othCtor&&\"constructor\"in object&&\"constructor\"in other&&!(\"function\"==typeof objCtor&&objCtor instanceof objCtor&&\"function\"==typeof othCtor&&othCtor instanceof othCtor))return!1}return!0}function getCallback(func,thisArg,argCount){var result=lodash.callback||callback;return result=result===callback?baseCallback:result,argCount?result(func,thisArg,argCount):result}function getIndexOf(collection,target,fromIndex){var result=lodash.indexOf||indexOf;return result=result===indexOf?baseIndexOf:result,collection?result(collection,target,fromIndex):result}function initCloneArray(array){var length=array.length,result=new array.constructor(length);return length&&\"string\"==typeof array[0]&&hasOwnProperty.call(array,\"index\")&&(result.index=array.index,result.input=array.input),result}function initCloneObject(object){var Ctor=object.constructor;return\"function\"==typeof Ctor&&Ctor instanceof Ctor||(Ctor=Object),new Ctor}function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return bufferClone(object);case boolTag:case dateTag:return new Ctor(+object);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:var buffer=object.buffer;return new Ctor(isDeep?bufferClone(buffer):buffer,object.byteOffset,object.length);case numberTag:case stringTag:return new Ctor(object);case regexpTag:var result=new Ctor(object.source,reFlags.exec(object));result.lastIndex=object.lastIndex}return result}function isIndex(value,length){return value=+value,length=null==length?MAX_SAFE_INTEGER:length,value>-1&&0==value%1&&length>value}function isIterateeCall(value,index,object){if(!isObject(object))return!1;var type=typeof index;if(\"number\"==type)var length=getLength(object),prereq=isLength(length)&&isIndex(index,length);else prereq=\"string\"==type&&index in object;if(prereq){var other=object[index];return value===value?value===other:other!==other}return!1}function isKey(value,object){var type=typeof value;if(\"string\"==type&&reIsPlainProp.test(value)||\"number\"==type)return!0;if(isArray(value))return!1;var result=!reIsDeepProp.test(value);return result||null!=object&&value in toObject(object)}function isLength(value){return\"number\"==typeof value&&value>-1&&0==value%1&&MAX_SAFE_INTEGER>=value}function isStrictComparable(value){return value===value&&(0===value?1/value>0:!isObject(value))}function shimIsPlainObject(value){var Ctor;if(lodash.support,!isObjectLike(value)||objToString.call(value)!=objectTag||!hasOwnProperty.call(value,\"constructor\")&&(Ctor=value.constructor,\"function\"==typeof Ctor&&!(Ctor instanceof Ctor)))return!1;var result;return baseForIn(value,function(subValue,key){result=key}),result===undefined||hasOwnProperty.call(value,result)}function shimKeys(object){for(var props=keysIn(object),propsLength=props.length,length=propsLength&&object.length,support=lodash.support,allowIndexes=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object)),index=-1,result=[];propsLength>++index;){var key=props[index];(allowIndexes&&isIndex(key,length)||hasOwnProperty.call(object,key))&&result.push(key)}return result}function toObject(value){return isObject(value)?value:Object(value)}function toPath(value){if(isArray(value))return value;var result=[];return baseToString(value).replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,\"$1\"):number||match)}),result}function indexOf(array,value,fromIndex){var length=array?array.length:0;if(!length)return-1;if(\"number\"==typeof fromIndex)fromIndex=0>fromIndex?nativeMax(length+fromIndex,0):fromIndex;else if(fromIndex){var index=binaryIndex(array,value),other=array[index];return(value===value?value===other:other!==other)?index:-1}return baseIndexOf(array,value,fromIndex||0)}function last(array){var length=array?array.length:0;return length?array[length-1]:undefined}function slice(array,start,end){var length=array?array.length:0;return length?(end&&\"number\"!=typeof end&&isIterateeCall(array,start,end)&&(start=0,end=length),baseSlice(array,start,end)):[]}function unzip(array){for(var index=-1,length=(array&&array.length&&arrayMax(arrayMap(array,getLength)))>>>0,result=Array(length);length>++index;)result[index]=arrayMap(array,baseProperty(index));return result}function includes(collection,target,fromIndex,guard){var length=collection?getLength(collection):0;return isLength(length)||(collection=values(collection),length=collection.length),length?(fromIndex=\"number\"!=typeof fromIndex||guard&&isIterateeCall(target,fromIndex,guard)?0:0>fromIndex?nativeMax(length+fromIndex,0):fromIndex||0,\"string\"==typeof collection||!isArray(collection)&&isString(collection)?length>fromIndex&&collection.indexOf(target,fromIndex)>-1:getIndexOf(collection,target,fromIndex)>-1):!1}function reject(collection,predicate,thisArg){var func=isArray(collection)?arrayFilter:baseFilter;return predicate=getCallback(predicate,thisArg,3),func(collection,function(value,index,collection){return!predicate(value,index,collection)})}function some(collection,predicate,thisArg){var func=isArray(collection)?arraySome:baseSome;return thisArg&&isIterateeCall(collection,predicate,thisArg)&&(predicate=null),(\"function\"!=typeof predicate||thisArg!==undefined)&&(predicate=getCallback(predicate,thisArg,3)),func(collection,predicate)}function restParam(func,start){if(\"function\"!=typeof func)throw new TypeError(FUNC_ERROR_TEXT);return start=nativeMax(start===undefined?func.length-1:+start||0,0),function(){for(var args=arguments,index=-1,length=nativeMax(args.length-start,0),rest=Array(length);length>++index;)rest[index]=args[start+index];switch(start){case 0:return func.call(this,rest);case 1:return func.call(this,args[0],rest);case 2:return func.call(this,args[0],args[1],rest)}var otherArgs=Array(start+1);for(index=-1;start>++index;)otherArgs[index]=args[index];return otherArgs[start]=rest,func.apply(this,otherArgs)}}function clone(value,isDeep,customizer,thisArg){return isDeep&&\"boolean\"!=typeof isDeep&&isIterateeCall(value,isDeep,customizer)?isDeep=!1:\"function\"==typeof isDeep&&(thisArg=customizer,customizer=isDeep,isDeep=!1),customizer=\"function\"==typeof customizer&&bindCallback(customizer,thisArg,1),baseClone(value,isDeep,customizer)}function isArguments(value){var length=isObjectLike(value)?value.length:undefined;return isLength(length)&&objToString.call(value)==argsTag}function isEmpty(value){if(null==value)return!0;var length=getLength(value);return isLength(length)&&(isArray(value)||isString(value)||isArguments(value)||isObjectLike(value)&&isFunction(value.splice))?!length:!keys(value).length}function isObject(value){var type=typeof value;return\"function\"==type||!!value&&\"object\"==type}function isNative(value){return null==value?!1:objToString.call(value)==funcTag?reIsNative.test(fnToString.call(value)):isObjectLike(value)&&reIsHostCtor.test(value)}function isNumber(value){return\"number\"==typeof value||isObjectLike(value)&&objToString.call(value)==numberTag}function isString(value){return\"string\"==typeof value||isObjectLike(value)&&objToString.call(value)==stringTag}function isTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[objToString.call(value)]}function toPlainObject(value){return baseCopy(value,keysIn(value))}function has(object,path){if(null==object)return!1;var result=hasOwnProperty.call(object,path);return result||isKey(path)||(path=toPath(path),object=1==path.length?object:baseGet(object,baseSlice(path,0,-1)),path=last(path),result=null!=object&&hasOwnProperty.call(object,path)),result}function keysIn(object){if(null==object)return[];isObject(object)||(object=Object(object));var length=object.length;length=length&&isLength(length)&&(isArray(object)||support.nonEnumArgs&&isArguments(object))&&length||0;for(var Ctor=object.constructor,index=-1,isProto=\"function\"==typeof Ctor&&Ctor.prototype===object,result=Array(length),skipIndexes=length>0;length>++index;)result[index]=index+\"\";for(var key in object)skipIndexes&&isIndex(key,length)||\"constructor\"==key&&(isProto||!hasOwnProperty.call(object,key))||result.push(key);return result}function values(object){return baseValues(object,keys(object))}function escapeRegExp(string){return string=baseToString(string),string&&reHasRegExpChars.test(string)?string.replace(reRegExpChars,\"\\\\$&\"):string}function callback(func,thisArg,guard){return guard&&isIterateeCall(func,thisArg,guard)&&(thisArg=null),baseCallback(func,thisArg)}function constant(value){return function(){return value}}function identity(value){return value}function property(path){return isKey(path)?baseProperty(path):basePropertyDeep(path)}var undefined,VERSION=\"3.7.0\",FUNC_ERROR_TEXT=\"Expected a function\",argsTag=\"[object Arguments]\",arrayTag=\"[object Array]\",boolTag=\"[object Boolean]\",dateTag=\"[object Date]\",errorTag=\"[object Error]\",funcTag=\"[object Function]\",mapTag=\"[object Map]\",numberTag=\"[object Number]\",objectTag=\"[object Object]\",regexpTag=\"[object RegExp]\",setTag=\"[object Set]\",stringTag=\"[object String]\",weakMapTag=\"[object WeakMap]\",arrayBufferTag=\"[object ArrayBuffer]\",float32Tag=\"[object Float32Array]\",float64Tag=\"[object Float64Array]\",int8Tag=\"[object Int8Array]\",int16Tag=\"[object Int16Array]\",int32Tag=\"[object Int32Array]\",uint8Tag=\"[object Uint8Array]\",uint8ClampedTag=\"[object Uint8ClampedArray]\",uint16Tag=\"[object Uint16Array]\",uint32Tag=\"[object Uint32Array]\",reIsDeepProp=/\\.|\\[(?:[^[\\]]+|([\"'])(?:(?!\\1)[^\\n\\\\]|\\\\.)*?)\\1\\]/,reIsPlainProp=/^\\w*$/,rePropName=/[^.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|([\"'])((?:(?!\\2)[^\\n\\\\]|\\\\.)*?)\\2)\\]/g,reRegExpChars=/[.*+?^${}()|[\\]\\/\\\\]/g,reHasRegExpChars=RegExp(reRegExpChars.source),reEscapeChar=/\\\\(\\\\)?/g,reFlags=/\\w*$/,reIsHostCtor=/^\\[object .+?Constructor\\]$/,typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=!0,typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=!1;var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[stringTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=!0,cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[mapTag]=cloneableTags[setTag]=cloneableTags[weakMapTag]=!1;var objectTypes={\"function\":!0,object:!0},freeExports=objectTypes[typeof exports]&&exports&&!exports.nodeType&&exports,freeModule=objectTypes[typeof module]&&module&&!module.nodeType&&module,freeGlobal=freeExports&&freeModule&&\"object\"==typeof global&&global&&global.Object&&global,freeSelf=objectTypes[typeof self]&&self&&self.Object&&self,freeWindow=objectTypes[typeof window]&&window&&window.Object&&window,moduleExports=freeModule&&freeModule.exports===freeExports&&freeExports,root=freeGlobal||freeWindow!==(this&&this.window)&&freeWindow||freeSelf||this,arrayProto=Array.prototype,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp(\"^\"+escapeRegExp(objToString).replace(/toString|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,\"$1.*?\")+\"$\"),ArrayBuffer=isNative(ArrayBuffer=root.ArrayBuffer)&&ArrayBuffer,bufferSlice=isNative(bufferSlice=ArrayBuffer&&new ArrayBuffer(0).slice)&&bufferSlice,floor=Math.floor,getOwnPropertySymbols=isNative(getOwnPropertySymbols=Object.getOwnPropertySymbols)&&getOwnPropertySymbols,getPrototypeOf=isNative(getPrototypeOf=Object.getPrototypeOf)&&getPrototypeOf,push=arrayProto.push,preventExtensions=isNative(Object.preventExtensions=Object.preventExtensions)&&preventExtensions,propertyIsEnumerable=objectProto.propertyIsEnumerable,Uint8Array=isNative(Uint8Array=root.Uint8Array)&&Uint8Array,Float64Array=function(){try{var func=isNative(func=root.Float64Array)&&func,result=new func(new ArrayBuffer(10),0,1)&&func}catch(e){}return result}(),nativeAssign=function(){var object={1:0},func=preventExtensions&&isNative(func=Object.assign)&&func;try{func(preventExtensions(object),\"xo\")}catch(e){}return!object[1]&&func}(),nativeIsArray=isNative(nativeIsArray=Array.isArray)&&nativeIsArray,nativeKeys=isNative(nativeKeys=Object.keys)&&nativeKeys,nativeMax=Math.max,nativeMin=Math.min,NEGATIVE_INFINITY=Number.NEGATIVE_INFINITY,MAX_ARRAY_LENGTH=Math.pow(2,32)-1,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1,FLOAT64_BYTES_PER_ELEMENT=Float64Array?Float64Array.BYTES_PER_ELEMENT:0,MAX_SAFE_INTEGER=Math.pow(2,53)-1,support=lodash.support={};(function(x){var Ctor=function(){this.x=x},props=[];Ctor.prototype={valueOf:x,y:x};for(var key in new Ctor)props.push(key);support.funcDecomp=/\\bthis\\b/.test(function(){return this}),support.funcNames=\"string\"==typeof Function.name;try{support.nonEnumArgs=!propertyIsEnumerable.call(arguments,1)}catch(e){support.nonEnumArgs=!0}})(1,0);var baseAssign=nativeAssign||function(object,source){return null==source?object:baseCopy(source,getSymbols(source),baseCopy(source,keys(source),object))},baseEach=createBaseEach(baseForOwn),baseFor=createBaseFor();bufferSlice||(bufferClone=ArrayBuffer&&Uint8Array?function(buffer){var byteLength=buffer.byteLength,floatLength=Float64Array?floor(byteLength/FLOAT64_BYTES_PER_ELEMENT):0,offset=floatLength*FLOAT64_BYTES_PER_ELEMENT,result=new ArrayBuffer(byteLength);if(floatLength){var view=new Float64Array(result,0,floatLength);view.set(new Float64Array(buffer,0,floatLength))}return byteLength!=offset&&(view=new Uint8Array(result,offset),view.set(new Uint8Array(buffer,offset))),result}:constant(null));var getLength=baseProperty(\"length\"),getSymbols=getOwnPropertySymbols?function(object){return getOwnPropertySymbols(toObject(object))}:constant([]),findLastIndex=createFindIndex(!0),zip=restParam(unzip),forEach=createForEach(arrayEach,baseEach),isArray=nativeIsArray||function(value){return isObjectLike(value)&&isLength(value.length)&&objToString.call(value)==arrayTag},isFunction=baseIsFunction(/x/)||Uint8Array&&!baseIsFunction(Uint8Array)?function(value){return objToString.call(value)==funcTag}:baseIsFunction,isPlainObject=getPrototypeOf?function(value){if(!value||objToString.call(value)!=objectTag)return!1;var valueOf=value.valueOf,objProto=isNative(valueOf)&&(objProto=getPrototypeOf(valueOf))&&getPrototypeOf(objProto);return objProto?value==objProto||getPrototypeOf(value)==objProto:shimIsPlainObject(value)}:shimIsPlainObject,assign=createAssigner(function(object,source,customizer){return customizer?assignWith(object,source,customizer):baseAssign(object,source)}),keys=nativeKeys?function(object){if(object)var Ctor=object.constructor,length=object.length;return\"function\"==typeof Ctor&&Ctor.prototype===object||\"function\"!=typeof object&&isLength(length)?shimKeys(object):isObject(object)?nativeKeys(object):[]}:shimKeys,merge=createAssigner(baseMerge);lodash.assign=assign,lodash.callback=callback,lodash.constant=constant,lodash.forEach=forEach,lodash.keys=keys,lodash.keysIn=keysIn,lodash.merge=merge,lodash.property=property,lodash.reject=reject,lodash.restParam=restParam,lodash.slice=slice,lodash.toPlainObject=toPlainObject,lodash.unzip=unzip,lodash.values=values,lodash.zip=zip,lodash.each=forEach,lodash.extend=assign,lodash.iteratee=callback,lodash.clone=clone,lodash.escapeRegExp=escapeRegExp,lodash.findLastIndex=findLastIndex,lodash.has=has,lodash.identity=identity,lodash.includes=includes,lodash.indexOf=indexOf,lodash.isArguments=isArguments,lodash.isArray=isArray,lodash.isEmpty=isEmpty,lodash.isFunction=isFunction,lodash.isNative=isNative,lodash.isNumber=isNumber,lodash.isObject=isObject,lodash.isPlainObject=isPlainObject,lodash.isString=isString,lodash.isTypedArray=isTypedArray,lodash.last=last,lodash.some=some,lodash.any=some,lodash.contains=includes,lodash.include=includes,lodash.VERSION=VERSION,freeExports&&freeModule?moduleExports?(freeModule.exports=lodash)._=lodash:freeExports._=lodash:root._=lodash\n}).call(this)}).call(this,\"undefined\"!=typeof global?global:\"undefined\"!=typeof self?self:\"undefined\"!=typeof window?window:{})},{}],\"/node_modules/jshint/src/jshint.js\":[function(_dereq_,module,exports){var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),vars=_dereq_(\"./vars.js\"),messages=_dereq_(\"./messages.js\"),Lexer=_dereq_(\"./lex.js\").Lexer,reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,style=_dereq_(\"./style.js\"),options=_dereq_(\"./options.js\"),scopeManager=_dereq_(\"./scope-manager.js\"),JSHINT=function(){\"use strict\";function checkOption(name,t){return name=name.trim(),/^[+-]W\\d{3}$/g.test(name)?!0:-1!==options.validNames.indexOf(name)||\"jslint\"===t.type||_.has(options.removed,name)?!0:(error(\"E001\",t,name),!1)}function isString(obj){return\"[object String]\"===Object.prototype.toString.call(obj)}function isIdentifier(tkn,value){return tkn?tkn.identifier&&tkn.value===value?!0:!1:!1}function isReserved(token){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(token.isProperty)return!1}return!0}function supplant(str,data){return str.replace(/\\{([^{}]*)\\}/g,function(a,b){var r=data[b];return\"string\"==typeof r||\"number\"==typeof r?r:a})}function combine(dest,src){Object.keys(src).forEach(function(name){_.has(JSHINT.blacklist,name)||(dest[name]=src[name])})}function processenforceall(){if(state.option.enforceall){for(var enforceopt in options.bool.enforcing)void 0!==state.option[enforceopt]||options.noenforceall[enforceopt]||(state.option[enforceopt]=!0);for(var relaxopt in options.bool.relaxing)void 0===state.option[relaxopt]&&(state.option[relaxopt]=!1)}}function assume(){processenforceall(),state.option.esversion||state.option.moz||(state.option.esversion=state.option.es3?3:state.option.esnext?6:5),state.inES5()&&combine(predefined,vars.ecmaIdentifiers[5]),state.inES6()&&combine(predefined,vars.ecmaIdentifiers[6]),state.option.module&&(state.option.strict===!0&&(state.option.strict=\"global\"),state.inES6()||warning(\"W134\",state.tokens.next,\"module\",6)),state.option.couch&&combine(predefined,vars.couch),state.option.qunit&&combine(predefined,vars.qunit),state.option.rhino&&combine(predefined,vars.rhino),state.option.shelljs&&(combine(predefined,vars.shelljs),combine(predefined,vars.node)),state.option.typed&&combine(predefined,vars.typed),state.option.phantom&&(combine(predefined,vars.phantom),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.prototypejs&&combine(predefined,vars.prototypejs),state.option.node&&(combine(predefined,vars.node),combine(predefined,vars.typed),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.devel&&combine(predefined,vars.devel),state.option.dojo&&combine(predefined,vars.dojo),state.option.browser&&(combine(predefined,vars.browser),combine(predefined,vars.typed)),state.option.browserify&&(combine(predefined,vars.browser),combine(predefined,vars.typed),combine(predefined,vars.browserify),state.option.strict===!0&&(state.option.strict=\"global\")),state.option.nonstandard&&combine(predefined,vars.nonstandard),state.option.jasmine&&combine(predefined,vars.jasmine),state.option.jquery&&combine(predefined,vars.jquery),state.option.mootools&&combine(predefined,vars.mootools),state.option.worker&&combine(predefined,vars.worker),state.option.wsh&&combine(predefined,vars.wsh),state.option.globalstrict&&state.option.strict!==!1&&(state.option.strict=\"global\"),state.option.yui&&combine(predefined,vars.yui),state.option.mocha&&combine(predefined,vars.mocha)}function quit(code,line,chr){var percentage=Math.floor(100*(line/state.lines.length)),message=messages.errors[code].desc;throw{name:\"JSHintError\",line:line,character:chr,message:message+\" (\"+percentage+\"% scanned).\",raw:message,code:code}}function removeIgnoredMessages(){var ignored=state.ignoredLines;_.isEmpty(ignored)||(JSHINT.errors=_.reject(JSHINT.errors,function(err){return ignored[err.line]}))}function warning(code,t,a,b,c,d){var ch,l,w,msg;if(/^W\\d{3}$/.test(code)){if(state.ignored[code])return;msg=messages.warnings[code]}else/E\\d{3}/.test(code)?msg=messages.errors[code]:/I\\d{3}/.test(code)&&(msg=messages.info[code]);return t=t||state.tokens.next||{},\"(end)\"===t.id&&(t=state.tokens.curr),l=t.line||0,ch=t.from||0,w={id:\"(error)\",raw:msg.desc,code:msg.code,evidence:state.lines[l-1]||\"\",line:l,character:ch,scope:JSHINT.scope,a:a,b:b,c:c,d:d},w.reason=supplant(msg.desc,w),JSHINT.errors.push(w),removeIgnoredMessages(),JSHINT.errors.length>=state.option.maxerr&&quit(\"E043\",l,ch),w}function warningAt(m,l,ch,a,b,c,d){return warning(m,{line:l,from:ch},a,b,c,d)}function error(m,t,a,b,c,d){warning(m,t,a,b,c,d)}function errorAt(m,l,ch,a,b,c,d){return error(m,{line:l,from:ch},a,b,c,d)}function addInternalSrc(elem,src){var i;return i={id:\"(internal)\",elem:elem,value:src},JSHINT.internals.push(i),i}function doOption(){var nt=state.tokens.next,body=nt.body.match(/(-\\s+)?[^\\s,:]+(?:\\s*:\\s*(-\\s+)?[^\\s,]+)?/g)||[],predef={};if(\"globals\"===nt.type){body.forEach(function(g,idx){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(\"-\"===key||!key.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}\"-\"===key.charAt(0)?(key=key.slice(1),val=!1,JSHINT.blacklist[key]=key,delete predefined[key]):predef[key]=\"true\"===val}),combine(predefined,predef);for(var key in predef)_.has(predef,key)&&(declared[key]=nt)}\"exported\"===nt.type&&body.forEach(function(e,idx){if(!e.length){if(idx>0&&idx===body.length-1)return;return error(\"E002\",nt),void 0}state.funct[\"(scope)\"].addExported(e)}),\"members\"===nt.type&&(membersOnly=membersOnly||{},body.forEach(function(m){var ch1=m.charAt(0),ch2=m.charAt(m.length-1);ch1!==ch2||'\"'!==ch1&&\"'\"!==ch1||(m=m.substr(1,m.length-2).replace('\\\\\"','\"')),membersOnly[m]=!1}));var numvals=[\"maxstatements\",\"maxparams\",\"maxdepth\",\"maxcomplexity\",\"maxerr\",\"maxlen\",\"indent\"];(\"jshint\"===nt.type||\"jslint\"===nt.type)&&(body.forEach(function(g){g=g.split(\":\");var key=(g[0]||\"\").trim(),val=(g[1]||\"\").trim();if(checkOption(key,nt))if(numvals.indexOf(key)>=0)if(\"false\"!==val){if(val=+val,\"number\"!=typeof val||!isFinite(val)||0>=val||Math.floor(val)!==val)return error(\"E032\",nt,g[1].trim()),void 0;state.option[key]=val}else state.option[key]=\"indent\"===key?4:!1;else{if(\"validthis\"===key)return state.funct[\"(global)\"]?void error(\"E009\"):\"true\"!==val&&\"false\"!==val?void error(\"E002\",nt):(state.option.validthis=\"true\"===val,void 0);if(\"quotmark\"!==key)if(\"shadow\"!==key)if(\"unused\"!==key)if(\"latedef\"!==key)if(\"ignore\"!==key)if(\"strict\"!==key){\"module\"===key&&(hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"module\"));var esversions={es3:3,es5:5,esnext:6};if(!_.has(esversions,key)){if(\"esversion\"===key){switch(val){case\"5\":state.inES5(!0)&&warning(\"I003\");case\"3\":case\"6\":state.option.moz=!1,state.option.esversion=+val;break;case\"2015\":state.option.moz=!1,state.option.esversion=6;break;default:error(\"E002\",nt)}return hasParsedCode(state.funct)||error(\"E055\",state.tokens.next,\"esversion\"),void 0}var match=/^([+-])(W\\d{3})$/g.exec(key);if(match)return state.ignored[match[2]]=\"-\"===match[1],void 0;var tn;return\"true\"===val||\"false\"===val?(\"jslint\"===nt.type?(tn=options.renamed[key]||key,state.option[tn]=\"true\"===val,void 0!==options.inverted[tn]&&(state.option[tn]=!state.option[tn])):state.option[key]=\"true\"===val,\"newcap\"===key&&(state.option[\"(explicitNewcap)\"]=!0),void 0):(error(\"E002\",nt),void 0)}switch(val){case\"true\":state.option.moz=!1,state.option.esversion=esversions[key];break;case\"false\":state.option.moz||(state.option.esversion=5);break;default:error(\"E002\",nt)}}else switch(val){case\"true\":state.option.strict=!0;break;case\"false\":state.option.strict=!1;break;case\"func\":case\"global\":case\"implied\":state.option.strict=val;break;default:error(\"E002\",nt)}else switch(val){case\"line\":state.ignoredLines[nt.line]=!0,removeIgnoredMessages();break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.latedef=!0;break;case\"false\":state.option.latedef=!1;break;case\"nofunc\":state.option.latedef=\"nofunc\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.unused=!0;break;case\"false\":state.option.unused=!1;break;case\"vars\":case\"strict\":state.option.unused=val;break;default:error(\"E002\",nt)}else switch(val){case\"true\":state.option.shadow=!0;break;case\"outer\":state.option.shadow=\"outer\";break;case\"false\":case\"inner\":state.option.shadow=\"inner\";break;default:error(\"E002\",nt)}else switch(val){case\"true\":case\"false\":state.option.quotmark=\"true\"===val;break;case\"double\":case\"single\":state.option.quotmark=val;break;default:error(\"E002\",nt)}}}),assume())}function peek(p){var t,i=p||0,j=lookahead.length;if(j>i)return lookahead[i];for(;i>=j;)t=lookahead[j],t||(t=lookahead[j]=lex.token()),j+=1;return t||\"(end)\"!==state.tokens.next.id?t:state.tokens.next}function peekIgnoreEOL(){var t,i=0;do t=peek(i++);while(\"(endline)\"===t.id);return t}function advance(id,t){switch(state.tokens.curr.id){case\"(number)\":\".\"===state.tokens.next.id&&warning(\"W005\",state.tokens.curr);break;case\"-\":(\"-\"===state.tokens.next.id||\"--\"===state.tokens.next.id)&&warning(\"W006\");break;case\"+\":(\"+\"===state.tokens.next.id||\"++\"===state.tokens.next.id)&&warning(\"W007\")}for(id&&state.tokens.next.id!==id&&(t?\"(end)\"===state.tokens.next.id?error(\"E019\",t,t.id):error(\"E020\",state.tokens.next,id,t.id,t.line,state.tokens.next.value):(\"(identifier)\"!==state.tokens.next.type||state.tokens.next.value!==id)&&warning(\"W116\",state.tokens.next,id,state.tokens.next.value)),state.tokens.prev=state.tokens.curr,state.tokens.curr=state.tokens.next;;){if(state.tokens.next=lookahead.shift()||lex.token(),state.tokens.next||quit(\"E041\",state.tokens.curr.line),\"(end)\"===state.tokens.next.id||\"(error)\"===state.tokens.next.id)return;if(state.tokens.next.check&&state.tokens.next.check(),state.tokens.next.isSpecial)\"falls through\"===state.tokens.next.type?state.tokens.curr.caseFallsThrough=!0:doOption();else if(\"(endline)\"!==state.tokens.next.id)break}}function isInfix(token){return token.infix||!token.identifier&&!token.template&&!!token.led}function isEndOfExpr(){var curr=state.tokens.curr,next=state.tokens.next;return\";\"===next.id||\"}\"===next.id||\":\"===next.id?!0:isInfix(next)===isInfix(curr)||\"yield\"===curr.id&&state.inMoz()?curr.line!==startLine(next):!1}function isBeginOfExpr(prev){return!prev.left&&\"unary\"!==prev.arity}function expression(rbp,initial){var left,isArray=!1,isObject=!1,isLetExpr=!1;state.nameStack.push(),initial||\"let\"!==state.tokens.next.value||\"(\"!==peek(0).value||(state.inMoz()||warning(\"W118\",state.tokens.next,\"let expressions\"),isLetExpr=!0,state.funct[\"(scope)\"].stack(),advance(\"let\"),advance(\"(\"),state.tokens.prev.fud(),advance(\")\")),\"(end)\"===state.tokens.next.id&&error(\"E006\",state.tokens.curr);var isDangerous=state.option.asi&&state.tokens.prev.line!==startLine(state.tokens.curr)&&_.contains([\"]\",\")\"],state.tokens.prev.id)&&_.contains([\"[\",\"(\"],state.tokens.curr.id);if(isDangerous&&warning(\"W014\",state.tokens.curr,state.tokens.curr.id),advance(),initial&&(state.funct[\"(verb)\"]=state.tokens.curr.value,state.tokens.curr.beginsStmt=!0),initial===!0&&state.tokens.curr.fud)left=state.tokens.curr.fud();else for(state.tokens.curr.nud?left=state.tokens.curr.nud():error(\"E030\",state.tokens.curr,state.tokens.curr.id);(state.tokens.next.lbp>rbp||\"(template)\"===state.tokens.next.type)&&!isEndOfExpr();)isArray=\"Array\"===state.tokens.curr.value,isObject=\"Object\"===state.tokens.curr.value,left&&(left.value||left.first&&left.first.value)&&(\"new\"!==left.value||left.first&&left.first.value&&\".\"===left.first.value)&&(isArray=!1,left.value!==state.tokens.curr.value&&(isObject=!1)),advance(),isArray&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W009\",state.tokens.curr),isObject&&\"(\"===state.tokens.curr.id&&\")\"===state.tokens.next.id&&warning(\"W010\",state.tokens.curr),left&&state.tokens.curr.led?left=state.tokens.curr.led(left):error(\"E033\",state.tokens.curr,state.tokens.curr.id);return isLetExpr&&state.funct[\"(scope)\"].unstack(),state.nameStack.pop(),left}function startLine(token){return token.startLine||token.line}function nobreaknonadjacent(left,right){left=left||state.tokens.curr,right=right||state.tokens.next,state.option.laxbreak||left.line===startLine(right)||warning(\"W014\",right,right.value)}function nolinebreak(t){t=t||state.tokens.curr,t.line!==startLine(state.tokens.next)&&warning(\"E022\",t,t.value)}function nobreakcomma(left,right){left.line!==startLine(right)&&(state.option.laxcomma||(comma.first&&(warning(\"I001\"),comma.first=!1),warning(\"W014\",left,right.value)))}function comma(opts){if(opts=opts||{},opts.peek?nobreakcomma(state.tokens.prev,state.tokens.curr):(nobreakcomma(state.tokens.curr,state.tokens.next),advance(\",\")),state.tokens.next.identifier&&(!opts.property||!state.inES5()))switch(state.tokens.next.value){case\"break\":case\"case\":case\"catch\":case\"continue\":case\"default\":case\"do\":case\"else\":case\"finally\":case\"for\":case\"if\":case\"in\":case\"instanceof\":case\"return\":case\"switch\":case\"throw\":case\"try\":case\"var\":case\"let\":case\"while\":case\"with\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}if(\"(punctuator)\"===state.tokens.next.type)switch(state.tokens.next.value){case\"}\":case\"]\":case\",\":if(opts.allowTrailing)return!0;case\")\":return error(\"E024\",state.tokens.next,state.tokens.next.value),!1}return!0}function symbol(s,p){var x=state.syntax[s];return x&&\"object\"==typeof x||(state.syntax[s]=x={id:s,lbp:p,value:s}),x}function delim(s){var x=symbol(s,0);return x.delim=!0,x}function stmt(s,f){var x=delim(s);return x.identifier=x.reserved=!0,x.fud=f,x}function blockstmt(s,f){var x=stmt(s,f);return x.block=!0,x}function reserveName(x){var c=x.id.charAt(0);return(c>=\"a\"&&\"z\">=c||c>=\"A\"&&\"Z\">=c)&&(x.identifier=x.reserved=!0),x}function prefix(s,f){var x=symbol(s,150);return reserveName(x),x.nud=\"function\"==typeof f?f:function(){return this.arity=\"unary\",this.right=expression(150),(\"++\"===this.id||\"--\"===this.id)&&(state.option.plusplus?warning(\"W016\",this,this.id):!this.right||this.right.identifier&&!isReserved(this.right)||\".\"===this.right.id||\"[\"===this.right.id||warning(\"W017\",this),this.right&&this.right.isMetaProperty?error(\"E031\",this):this.right&&this.right.identifier&&state.funct[\"(scope)\"].block.modify(this.right.value,this)),this},x}function type(s,f){var x=delim(s);return x.type=s,x.nud=f,x}function reserve(name,func){var x=type(name,func);return x.identifier=!0,x.reserved=!0,x}function FutureReservedWord(name,meta){var x=type(name,meta&&meta.nud||function(){return this});return meta=meta||{},meta.isFutureReservedWord=!0,x.value=name,x.identifier=!0,x.reserved=!0,x.meta=meta,x}function reservevar(s,v){return reserve(s,function(){return\"function\"==typeof v&&v(this),this})}function infix(s,f,p,w){var x=symbol(s,p);return reserveName(x),x.infix=!0,x.led=function(left){return w||nobreaknonadjacent(state.tokens.prev,state.tokens.curr),\"in\"!==s&&\"instanceof\"!==s||\"!\"!==left.id||warning(\"W018\",left,\"!\"),\"function\"==typeof f?f(left,this):(this.left=left,this.right=expression(p),this)},x}function application(s){var x=symbol(s,42);return x.led=function(left){return nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left,this.right=doFunction({type:\"arrow\",loneArg:left}),this},x}function relation(s,f){var x=symbol(s,100);return x.led=function(left){nobreaknonadjacent(state.tokens.prev,state.tokens.curr),this.left=left;var right=this.right=expression(100);return isIdentifier(left,\"NaN\")||isIdentifier(right,\"NaN\")?warning(\"W019\",this):f&&f.apply(this,[left,right]),left&&right||quit(\"E041\",state.tokens.curr.line),\"!\"===left.id&&warning(\"W018\",left,\"!\"),\"!\"===right.id&&warning(\"W018\",right,\"!\"),this},x}function isPoorRelation(node){return node&&(\"(number)\"===node.type&&0===+node.value||\"(string)\"===node.type&&\"\"===node.value||\"null\"===node.type&&!state.option.eqnull||\"true\"===node.type||\"false\"===node.type||\"undefined\"===node.type)}function isTypoTypeof(left,right,state){var values;return state.option.notypeof?!1:left&&right?(values=state.inES6()?typeofValues.es6:typeofValues.es3,\"(identifier)\"===right.type&&\"typeof\"===right.value&&\"(string)\"===left.type?!_.contains(values,left.value):!1):!1}function isGlobalEval(left,state){var isGlobal=!1;return\"this\"===left.type&&null===state.funct[\"(context)\"]?isGlobal=!0:\"(identifier)\"===left.type&&(state.option.node&&\"global\"===left.value?isGlobal=!0:!state.option.browser||\"window\"!==left.value&&\"document\"!==left.value||(isGlobal=!0)),isGlobal}function findNativePrototype(left){function walkPrototype(obj){return\"object\"==typeof obj?\"prototype\"===obj.right?obj:walkPrototype(obj.left):void 0}function walkNative(obj){for(;!obj.identifier&&\"object\"==typeof obj.left;)obj=obj.left;return obj.identifier&&natives.indexOf(obj.value)>=0?obj.value:void 0}var natives=[\"Array\",\"ArrayBuffer\",\"Boolean\",\"Collator\",\"DataView\",\"Date\",\"DateTimeFormat\",\"Error\",\"EvalError\",\"Float32Array\",\"Float64Array\",\"Function\",\"Infinity\",\"Intl\",\"Int16Array\",\"Int32Array\",\"Int8Array\",\"Iterator\",\"Number\",\"NumberFormat\",\"Object\",\"RangeError\",\"ReferenceError\",\"RegExp\",\"StopIteration\",\"String\",\"SyntaxError\",\"TypeError\",\"Uint16Array\",\"Uint32Array\",\"Uint8Array\",\"Uint8ClampedArray\",\"URIError\"],prototype=walkPrototype(left);return prototype?walkNative(prototype):void 0}function checkLeftSideAssign(left,assignToken,options){var allowDestructuring=options&&options.allowDestructuring;if(assignToken=assignToken||left,state.option.freeze){var nativeObject=findNativePrototype(left);nativeObject&&warning(\"W121\",left,nativeObject)}return left.identifier&&!left.isMetaProperty&&state.funct[\"(scope)\"].block.reassign(left.value,left),\".\"===left.id?((!left.left||\"arguments\"===left.left.value&&!state.isStrict())&&warning(\"E031\",assignToken),state.nameStack.set(state.tokens.prev),!0):\"{\"===left.id||\"[\"===left.id?(allowDestructuring&&state.tokens.curr.left.destructAssign?state.tokens.curr.left.destructAssign.forEach(function(t){t.id&&state.funct[\"(scope)\"].block.modify(t.id,t.token)}):\"{\"!==left.id&&left.left?\"arguments\"!==left.left.value||state.isStrict()||warning(\"E031\",assignToken):warning(\"E031\",assignToken),\"[\"===left.id&&state.nameStack.set(left.right),!0):left.isMetaProperty?(error(\"E031\",assignToken),!0):left.identifier&&!isReserved(left)?(\"exception\"===state.funct[\"(scope)\"].labeltype(left.value)&&warning(\"W022\",left),state.nameStack.set(left),!0):(left===state.syntax[\"function\"]&&warning(\"W023\",state.tokens.curr),!1)}function assignop(s,f,p){var x=infix(s,\"function\"==typeof f?f:function(left,that){return that.left=left,left&&checkLeftSideAssign(left,that,{allowDestructuring:!0})?(that.right=expression(10),that):(error(\"E031\",that),void 0)},p);return x.exps=!0,x.assign=!0,x}function bitwise(s,f,p){var x=symbol(s,p);return reserveName(x),x.led=\"function\"==typeof f?f:function(left){return state.option.bitwise&&warning(\"W016\",this,this.id),this.left=left,this.right=expression(p),this},x}function bitwiseassignop(s){return assignop(s,function(left,that){return state.option.bitwise&&warning(\"W016\",that,that.id),left&&checkLeftSideAssign(left,that)?(that.right=expression(10),that):(error(\"E031\",that),void 0)},20)}function suffix(s){var x=symbol(s,150);return x.led=function(left){return state.option.plusplus?warning(\"W016\",this,this.id):left.identifier&&!isReserved(left)||\".\"===left.id||\"[\"===left.id||warning(\"W017\",this),left.isMetaProperty?error(\"E031\",this):left&&left.identifier&&state.funct[\"(scope)\"].block.modify(left.value,left),this.left=left,this},x}function optionalidentifier(fnparam,prop,preserve){if(state.tokens.next.identifier){preserve||advance();var curr=state.tokens.curr,val=state.tokens.curr.value;return isReserved(curr)?prop&&state.inES5()?val:fnparam&&\"undefined\"===val?val:(warning(\"W024\",state.tokens.curr,state.tokens.curr.id),val):val}}function identifier(fnparam,prop){var i=optionalidentifier(fnparam,prop,!1);if(i)return i;if(\"...\"===state.tokens.next.value){if(state.inES6(!0)||warning(\"W119\",state.tokens.next,\"spread/rest operator\",\"6\"),advance(),checkPunctuator(state.tokens.next,\"...\"))for(warning(\"E024\",state.tokens.next,\"...\");checkPunctuator(state.tokens.next,\"...\");)advance();return state.tokens.next.identifier?identifier(fnparam,prop):(warning(\"E024\",state.tokens.curr,\"...\"),void 0)}error(\"E030\",state.tokens.next,state.tokens.next.value),\";\"!==state.tokens.next.id&&advance()}function reachable(controlToken){var t,i=0;if(\";\"===state.tokens.next.id&&!controlToken.inBracelessBlock)for(;;){do t=peek(i),i+=1;while(\"(end)\"!==t.id&&\"(comment)\"===t.id);if(t.reach)return;if(\"(endline)\"!==t.id){if(\"function\"===t.id){state.option.latedef===!0&&warning(\"W026\",t);break}warning(\"W027\",t,t.value,controlToken.value);break}}}function parseFinalSemicolon(){if(\";\"!==state.tokens.next.id){if(state.tokens.next.isUnclosed)return advance();var sameLine=startLine(state.tokens.next)===state.tokens.curr.line&&\"(end)\"!==state.tokens.next.id,blockEnd=checkPunctuator(state.tokens.next,\"}\");sameLine&&!blockEnd?errorAt(\"E058\",state.tokens.curr.line,state.tokens.curr.character):state.option.asi||(blockEnd&&!state.option.lastsemic||!sameLine)&&warningAt(\"W033\",state.tokens.curr.line,state.tokens.curr.character)}else advance(\";\")}function statement(){var r,i=indent,t=state.tokens.next,hasOwnScope=!1;if(\";\"===t.id)return advance(\";\"),void 0;var res=isReserved(t);if(res&&t.meta&&t.meta.isFutureReservedWord&&\":\"===peek().id&&(warning(\"W024\",t,t.id),res=!1),t.identifier&&!res&&\":\"===peek().id&&(advance(),advance(\":\"),hasOwnScope=!0,state.funct[\"(scope)\"].stack(),state.funct[\"(scope)\"].block.addBreakLabel(t.value,{token:state.tokens.curr}),state.tokens.next.labelled||\"{\"===state.tokens.next.value||warning(\"W028\",state.tokens.next,t.value,state.tokens.next.value),state.tokens.next.label=t.value,t=state.tokens.next),\"{\"===t.id){var iscase=\"case\"===state.funct[\"(verb)\"]&&\":\"===state.tokens.curr.value;return block(!0,!0,!1,!1,iscase),void 0}return r=expression(0,!0),!r||r.identifier&&\"function\"===r.value||\"(punctuator)\"===r.type&&r.left&&r.left.identifier&&\"function\"===r.left.value||state.isStrict()||\"global\"!==state.option.strict||warning(\"E007\"),t.block||(state.option.expr||r&&r.exps?state.option.nonew&&r&&r.left&&\"(\"===r.id&&\"new\"===r.left.id&&warning(\"W031\",t):warning(\"W030\",state.tokens.curr),parseFinalSemicolon()),indent=i,hasOwnScope&&state.funct[\"(scope)\"].unstack(),r}function statements(){for(var p,a=[];!state.tokens.next.reach&&\"(end)\"!==state.tokens.next.id;)\";\"===state.tokens.next.id?(p=peek(),(!p||\"(\"!==p.id&&\"[\"!==p.id)&&warning(\"W032\"),advance(\";\")):a.push(statement());return a}function directives(){for(var i,p,pn;\"(string)\"===state.tokens.next.id;){if(p=peek(0),\"(endline)\"===p.id){i=1;do pn=peek(i++);while(\"(endline)\"===pn.id);if(\";\"===pn.id)p=pn;else{if(\"[\"===pn.value||\".\"===pn.value)break;state.option.asi&&\"(\"!==pn.value||warning(\"W033\",state.tokens.next)}}else{if(\".\"===p.id||\"[\"===p.id)break;\";\"!==p.id&&warning(\"W033\",p)}advance();var directive=state.tokens.curr.value;(state.directive[directive]||\"use strict\"===directive&&\"implied\"===state.option.strict)&&warning(\"W034\",state.tokens.curr,directive),state.directive[directive]=!0,\";\"===p.id&&advance(\";\")}state.isStrict()&&(state.option[\"(explicitNewcap)\"]||(state.option.newcap=!0),state.option.undef=!0)}function block(ordinary,stmt,isfunc,isfatarrow,iscase){var a,m,t,line,d,b=inblock,old_indent=indent;inblock=ordinary,t=state.tokens.next;var metrics=state.funct[\"(metrics)\"];if(metrics.nestedBlockDepth+=1,metrics.verifyMaxNestedBlockDepthPerFunction(),\"{\"===state.tokens.next.id){if(advance(\"{\"),state.funct[\"(scope)\"].stack(),line=state.tokens.curr.line,\"}\"!==state.tokens.next.id){for(indent+=state.option.indent;!ordinary&&state.tokens.next.from>indent;)indent+=state.option.indent;if(isfunc){m={};for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);directives(),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\"))}a=statements(),metrics.statementCount+=a.length,indent-=state.option.indent}advance(\"}\",t),isfunc&&(state.funct[\"(scope)\"].validateParams(),m&&(state.directive=m)),state.funct[\"(scope)\"].unstack(),indent=old_indent}else if(ordinary)state.funct[\"(noblockscopedvar)\"]=\"for\"!==state.tokens.next.id,state.funct[\"(scope)\"].stack(),(!stmt||state.option.curly)&&warning(\"W116\",state.tokens.next,\"{\",state.tokens.next.value),state.tokens.next.inBracelessBlock=!0,indent+=state.option.indent,a=[statement()],indent-=state.option.indent,state.funct[\"(scope)\"].unstack(),delete state.funct[\"(noblockscopedvar)\"];else if(isfunc){if(state.funct[\"(scope)\"].stack(),m={},!stmt||isfatarrow||state.inMoz()||error(\"W118\",state.tokens.curr,\"function closure expressions\"),!stmt)for(d in state.directive)_.has(state.directive,d)&&(m[d]=state.directive[d]);expression(10),state.option.strict&&state.funct[\"(context)\"][\"(global)\"]&&(m[\"use strict\"]||state.isStrict()||warning(\"E007\")),state.funct[\"(scope)\"].unstack()}else error(\"E021\",state.tokens.next,\"{\",state.tokens.next.value);switch(state.funct[\"(verb)\"]){case\"break\":case\"continue\":case\"return\":case\"throw\":if(iscase)break;default:state.funct[\"(verb)\"]=null}return inblock=b,!ordinary||!state.option.noempty||a&&0!==a.length||warning(\"W035\",state.tokens.prev),metrics.nestedBlockDepth-=1,a}function countMember(m){membersOnly&&\"boolean\"!=typeof membersOnly[m]&&warning(\"W036\",state.tokens.curr,m),\"number\"==typeof member[m]?member[m]+=1:member[m]=1}function comprehensiveArrayExpression(){var res={};res.exps=!0,state.funct[\"(comparray)\"].stack();var reversed=!1;return\"for\"!==state.tokens.next.value&&(reversed=!0,state.inMoz()||warning(\"W116\",state.tokens.next,\"for\",state.tokens.next.value),state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"for\"),\"each\"===state.tokens.next.value&&(advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"define\"),res.left=expression(130),_.contains([\"in\",\"of\"],state.tokens.next.value)?advance():error(\"E045\",state.tokens.curr),state.funct[\"(comparray)\"].setState(\"generate\"),expression(10),advance(\")\"),\"if\"===state.tokens.next.value&&(advance(\"if\"),advance(\"(\"),state.funct[\"(comparray)\"].setState(\"filter\"),res.filter=expression(10),advance(\")\")),reversed||(state.funct[\"(comparray)\"].setState(\"use\"),res.right=expression(10)),advance(\"]\"),state.funct[\"(comparray)\"].unstack(),res}function isMethod(){return state.funct[\"(statement)\"]&&\"class\"===state.funct[\"(statement)\"].type||state.funct[\"(context)\"]&&\"class\"===state.funct[\"(context)\"][\"(verb)\"]}function isPropertyName(token){return token.identifier||\"(string)\"===token.id||\"(number)\"===token.id}function propertyName(preserveOrToken){var id,preserve=!0;return\"object\"==typeof preserveOrToken?id=preserveOrToken:(preserve=preserveOrToken,id=optionalidentifier(!1,!0,preserve)),id?\"object\"==typeof id&&(\"(string)\"===id.id||\"(identifier)\"===id.id?id=id.value:\"(number)\"===id.id&&(id=\"\"+id.value)):\"(string)\"===state.tokens.next.id?(id=state.tokens.next.value,preserve||advance()):\"(number)\"===state.tokens.next.id&&(id=\"\"+state.tokens.next.value,preserve||advance()),\"hasOwnProperty\"===id&&warning(\"W001\"),id}function functionparams(options){function addParam(addParamArgs){state.funct[\"(scope)\"].addParam.apply(state.funct[\"(scope)\"],addParamArgs)}var next,ident,t,paramsIds=[],tokens=[],pastDefault=!1,pastRest=!1,arity=0,loneArg=options&&options.loneArg;if(loneArg&&loneArg.identifier===!0)return state.funct[\"(scope)\"].addParam(loneArg.value,loneArg),{arity:1,params:[loneArg.value]};if(next=state.tokens.next,options&&options.parsedOpening||advance(\"(\"),\")\"===state.tokens.next.id)return advance(\")\"),void 0;for(;;){arity++;var currentParams=[];if(_.contains([\"{\",\"[\"],state.tokens.next.id)){tokens=destructuringPattern();for(t in tokens)t=tokens[t],t.id&&(paramsIds.push(t.id),currentParams.push([t.id,t.token]))}else if(checkPunctuator(state.tokens.next,\"...\")&&(pastRest=!0),ident=identifier(!0))paramsIds.push(ident),currentParams.push([ident,state.tokens.curr]);else for(;!checkPunctuators(state.tokens.next,[\",\",\")\"]);)advance();if(pastDefault&&\"=\"!==state.tokens.next.id&&error(\"W138\",state.tokens.current),\"=\"===state.tokens.next.id&&(state.inES6()||warning(\"W119\",state.tokens.next,\"default parameters\",\"6\"),advance(\"=\"),pastDefault=!0,expression(10)),currentParams.forEach(addParam),\",\"!==state.tokens.next.id)return advance(\")\",next),{arity:arity,params:paramsIds};pastRest&&warning(\"W131\",state.tokens.next),comma()}}function functor(name,token,overwrites){var funct={\"(name)\":name,\"(breakage)\":0,\"(loopage)\":0,\"(tokens)\":{},\"(properties)\":{},\"(catch)\":!1,\"(global)\":!1,\"(line)\":null,\"(character)\":null,\"(metrics)\":null,\"(statement)\":null,\"(context)\":null,\"(scope)\":null,\"(comparray)\":null,\"(generator)\":null,\"(arrow)\":null,\"(params)\":null};return token&&_.extend(funct,{\"(line)\":token.line,\"(character)\":token.character,\"(metrics)\":createMetrics(token)}),_.extend(funct,overwrites),funct[\"(context)\"]&&(funct[\"(scope)\"]=funct[\"(context)\"][\"(scope)\"],funct[\"(comparray)\"]=funct[\"(context)\"][\"(comparray)\"]),funct}function isFunctor(token){return\"(scope)\"in token}function hasParsedCode(funct){return funct[\"(global)\"]&&!funct[\"(verb)\"]}function doTemplateLiteral(left){function end(){if(state.tokens.curr.template&&state.tokens.curr.tail&&state.tokens.curr.context===ctx)return!0;var complete=state.tokens.next.template&&state.tokens.next.tail&&state.tokens.next.context===ctx;return complete&&advance(),complete||state.tokens.next.isUnclosed}var ctx=this.context,noSubst=this.noSubst,depth=this.depth;if(!noSubst)for(;!end();)!state.tokens.next.template||state.tokens.next.depth>depth?expression(0):advance();return{id:\"(template)\",type:\"(template)\",tag:left}}function doFunction(options){var f,token,name,statement,classExprBinding,isGenerator,isArrow,ignoreLoopFunc,oldOption=state.option,oldIgnored=state.ignored;options&&(name=options.name,statement=options.statement,classExprBinding=options.classExprBinding,isGenerator=\"generator\"===options.type,isArrow=\"arrow\"===options.type,ignoreLoopFunc=options.ignoreLoopFunc),state.option=Object.create(state.option),state.ignored=Object.create(state.ignored),state.funct=functor(name||state.nameStack.infer(),state.tokens.next,{\"(statement)\":statement,\"(context)\":state.funct,\"(arrow)\":isArrow,\"(generator)\":isGenerator}),f=state.funct,token=state.tokens.curr,token.funct=state.funct,functions.push(state.funct),state.funct[\"(scope)\"].stack(\"functionouter\");var internallyAccessibleName=name||classExprBinding;internallyAccessibleName&&state.funct[\"(scope)\"].block.add(internallyAccessibleName,classExprBinding?\"class\":\"function\",state.tokens.curr,!1),state.funct[\"(scope)\"].stack(\"functionparams\");var paramsInfo=functionparams(options);return paramsInfo?(state.funct[\"(params)\"]=paramsInfo.params,state.funct[\"(metrics)\"].arity=paramsInfo.arity,state.funct[\"(metrics)\"].verifyMaxParametersPerFunction()):state.funct[\"(metrics)\"].arity=0,isArrow&&(state.inES6(!0)||warning(\"W119\",state.tokens.curr,\"arrow function syntax (=>)\",\"6\"),options.loneArg||advance(\"=>\")),block(!1,!0,!0,isArrow),!state.option.noyield&&isGenerator&&\"yielded\"!==state.funct[\"(generator)\"]&&warning(\"W124\",state.tokens.curr),state.funct[\"(metrics)\"].verifyMaxStatementsPerFunction(),state.funct[\"(metrics)\"].verifyMaxComplexityPerFunction(),state.funct[\"(unusedOption)\"]=state.option.unused,state.option=oldOption,state.ignored=oldIgnored,state.funct[\"(last)\"]=state.tokens.curr.line,state.funct[\"(lastcharacter)\"]=state.tokens.curr.character,state.funct[\"(scope)\"].unstack(),state.funct[\"(scope)\"].unstack(),state.funct=state.funct[\"(context)\"],ignoreLoopFunc||state.option.loopfunc||!state.funct[\"(loopage)\"]||f[\"(isCapturing)\"]&&warning(\"W083\",token),f}function createMetrics(functionStartToken){return{statementCount:0,nestedBlockDepth:-1,ComplexityCount:1,arity:0,verifyMaxStatementsPerFunction:function(){state.option.maxstatements&&this.statementCount>state.option.maxstatements&&warning(\"W071\",functionStartToken,this.statementCount)\n},verifyMaxParametersPerFunction:function(){_.isNumber(state.option.maxparams)&&this.arity>state.option.maxparams&&warning(\"W072\",functionStartToken,this.arity)},verifyMaxNestedBlockDepthPerFunction:function(){state.option.maxdepth&&this.nestedBlockDepth>0&&this.nestedBlockDepth===state.option.maxdepth+1&&warning(\"W073\",null,this.nestedBlockDepth)},verifyMaxComplexityPerFunction:function(){var max=state.option.maxcomplexity,cc=this.ComplexityCount;max&&cc>max&&warning(\"W074\",functionStartToken,cc)}}}function increaseComplexityCount(){state.funct[\"(metrics)\"].ComplexityCount+=1}function checkCondAssignment(expr){var id,paren;switch(expr&&(id=expr.id,paren=expr.paren,\",\"===id&&(expr=expr.exprs[expr.exprs.length-1])&&(id=expr.id,paren=paren||expr.paren)),id){case\"=\":case\"+=\":case\"-=\":case\"*=\":case\"%=\":case\"&=\":case\"|=\":case\"^=\":case\"/=\":paren||state.option.boss||warning(\"W084\")}}function checkProperties(props){if(state.inES5())for(var name in props)props[name]&&props[name].setterToken&&!props[name].getterToken&&warning(\"W078\",props[name].setterToken)}function metaProperty(name,c){if(checkPunctuator(state.tokens.next,\".\")){var left=state.tokens.curr.id;advance(\".\");var id=identifier();return state.tokens.curr.isMetaProperty=!0,name!==id?error(\"E057\",state.tokens.prev,left,id):c(),state.tokens.curr}}function destructuringPattern(options){var isAssignment=options&&options.assignment;return state.inES6()||warning(\"W104\",state.tokens.curr,isAssignment?\"destructuring assignment\":\"destructuring binding\",\"6\"),destructuringPatternRecursive(options)}function destructuringPatternRecursive(options){var ids,identifiers=[],openingParsed=options&&options.openingParsed,isAssignment=options&&options.assignment,recursiveOptions=isAssignment?{assignment:isAssignment}:null,firstToken=openingParsed?state.tokens.curr:state.tokens.next,nextInnerDE=function(){var ident;if(checkPunctuators(state.tokens.next,[\"[\",\"{\"])){ids=destructuringPatternRecursive(recursiveOptions);for(var id in ids)id=ids[id],identifiers.push({id:id.id,token:id.token})}else if(checkPunctuator(state.tokens.next,\",\"))identifiers.push({id:null,token:state.tokens.curr});else{if(!checkPunctuator(state.tokens.next,\"(\")){var is_rest=checkPunctuator(state.tokens.next,\"...\");if(isAssignment){var identifierToken=is_rest?peek(0):state.tokens.next;identifierToken.identifier||warning(\"E030\",identifierToken,identifierToken.value);var assignTarget=expression(155);assignTarget&&(checkLeftSideAssign(assignTarget),assignTarget.identifier&&(ident=assignTarget.value))}else ident=identifier();return ident&&identifiers.push({id:ident,token:state.tokens.curr}),is_rest}advance(\"(\"),nextInnerDE(),advance(\")\")}return!1},assignmentProperty=function(){var id;checkPunctuator(state.tokens.next,\"[\")?(advance(\"[\"),expression(10),advance(\"]\"),advance(\":\"),nextInnerDE()):\"(string)\"===state.tokens.next.id||\"(number)\"===state.tokens.next.id?(advance(),advance(\":\"),nextInnerDE()):(id=identifier(),checkPunctuator(state.tokens.next,\":\")?(advance(\":\"),nextInnerDE()):id&&(isAssignment&&checkLeftSideAssign(state.tokens.curr),identifiers.push({id:id,token:state.tokens.curr})))};if(checkPunctuator(firstToken,\"[\")){openingParsed||advance(\"[\"),checkPunctuator(state.tokens.next,\"]\")&&warning(\"W137\",state.tokens.curr);for(var element_after_rest=!1;!checkPunctuator(state.tokens.next,\"]\");)nextInnerDE()&&!element_after_rest&&checkPunctuator(state.tokens.next,\",\")&&(warning(\"W130\",state.tokens.next),element_after_rest=!0),checkPunctuator(state.tokens.next,\"=\")&&(checkPunctuator(state.tokens.prev,\"...\")?advance(\"]\"):advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"]\")||advance(\",\");advance(\"]\")}else if(checkPunctuator(firstToken,\"{\")){for(openingParsed||advance(\"{\"),checkPunctuator(state.tokens.next,\"}\")&&warning(\"W137\",state.tokens.curr);!checkPunctuator(state.tokens.next,\"}\")&&(assignmentProperty(),checkPunctuator(state.tokens.next,\"=\")&&(advance(\"=\"),\"undefined\"===state.tokens.next.id&&warning(\"W080\",state.tokens.prev,state.tokens.prev.value),expression(10)),checkPunctuator(state.tokens.next,\"}\")||(advance(\",\"),!checkPunctuator(state.tokens.next,\"}\"))););advance(\"}\")}return identifiers}function destructuringPatternMatch(tokens,value){var first=value.first;first&&_.zip(tokens,Array.isArray(first)?first:[first]).forEach(function(val){var token=val[0],value=val[1];token&&value?token.first=value:token&&token.first&&!value&&warning(\"W080\",token.first,token.first.value)})}function blockVariableStatement(type,statement,context){var tokens,lone,value,letblock,prefix=context&&context.prefix,inexport=context&&context.inexport,isLet=\"let\"===type,isConst=\"const\"===type;for(state.inES6()||warning(\"W104\",state.tokens.curr,type,\"6\"),isLet&&\"(\"===state.tokens.next.value?(state.inMoz()||warning(\"W118\",state.tokens.next,\"let block\"),advance(\"(\"),state.funct[\"(scope)\"].stack(),letblock=!0):state.funct[\"(noblockscopedvar)\"]&&error(\"E048\",state.tokens.curr,isConst?\"Const\":\"Let\"),statement.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),!prefix&&isConst&&\"=\"!==state.tokens.next.id&&warning(\"E012\",state.tokens.curr,state.tokens.curr.value);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],state.funct[\"(scope)\"].block.isGlobal()&&predefined[t.id]===!1&&warning(\"W079\",t.token,t.id),t.id&&!state.funct[\"(noblockscopedvar)\"]&&(state.funct[\"(scope)\"].addlabel(t.id,{type:type,token:t.token}),names.push(t.token),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.token.value,t.token)));if(\"=\"===state.tokens.next.id&&(advance(\"=\"),prefix||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),!prefix&&\"=\"===peek(0).id&&state.tokens.next.identifier&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),statement.first=statement.first.concat(names),\",\"!==state.tokens.next.id)break;comma()}return letblock&&(advance(\")\"),block(!0,!0),statement.block=!0,state.funct[\"(scope)\"].unstack()),statement}function classdef(isStatement){return state.inES6()||warning(\"W104\",state.tokens.curr,\"class\",\"6\"),isStatement?(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"class\",token:state.tokens.curr})):state.tokens.next.identifier&&\"extends\"!==state.tokens.next.value?(this.name=identifier(),this.namedExpr=!0):this.name=state.nameStack.infer(),classtail(this),this}function classtail(c){var wasInClassBody=state.inClassBody;\"extends\"===state.tokens.next.value&&(advance(\"extends\"),c.heritage=expression(10)),state.inClassBody=!0,advance(\"{\"),c.body=classbody(c),advance(\"}\"),state.inClassBody=wasInClassBody}function classbody(c){for(var name,isStatic,isGenerator,getset,computed,props=Object.create(null),staticProps=Object.create(null),i=0;\"}\"!==state.tokens.next.id;++i)if(name=state.tokens.next,isStatic=!1,isGenerator=!1,getset=null,\";\"!==name.id){if(\"*\"===name.id&&(isGenerator=!0,advance(\"*\"),name=state.tokens.next),\"[\"===name.id)name=computedPropertyName(),computed=!0;else{if(!isPropertyName(name)){warning(\"W052\",state.tokens.next,state.tokens.next.value||state.tokens.next.type),advance();continue}advance(),computed=!1,name.identifier&&\"static\"===name.value&&(checkPunctuator(state.tokens.next,\"*\")&&(isGenerator=!0,advance(\"*\")),(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,isStatic=!0,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())),!name.identifier||\"get\"!==name.value&&\"set\"!==name.value||(isPropertyName(state.tokens.next)||\"[\"===state.tokens.next.id)&&(computed=\"[\"===state.tokens.next.id,getset=name,name=state.tokens.next,\"[\"===state.tokens.next.id?name=computedPropertyName():advance())}if(!checkPunctuator(state.tokens.next,\"(\")){for(error(\"E054\",state.tokens.next,state.tokens.next.value);\"}\"!==state.tokens.next.id&&!checkPunctuator(state.tokens.next,\"(\");)advance();\"(\"!==state.tokens.next.value&&doFunction({statement:c})}if(computed||(getset?saveAccessor(getset.value,isStatic?staticProps:props,name.value,name,!0,isStatic):(\"constructor\"===name.value?state.nameStack.set(c):state.nameStack.set(name),saveProperty(isStatic?staticProps:props,name.value,name,!0,isStatic))),getset&&\"constructor\"===name.value){var propDesc=\"get\"===getset.value?\"class getter method\":\"class setter method\";error(\"E049\",name,propDesc,\"constructor\")}else\"prototype\"===name.value&&error(\"E049\",name,\"class method\",\"prototype\");propertyName(name),doFunction({statement:c,type:isGenerator?\"generator\":null,classExprBinding:c.namedExpr?c.name:null})}else warning(\"W032\"),advance(\";\");checkProperties(props)}function saveProperty(props,name,tkn,isClass,isStatic){var msg=[\"key\",\"class method\",\"static class method\"];msg=msg[(isClass||!1)+(isStatic||!1)],tkn.identifier&&(name=tkn.value),props[name]&&\"__proto__\"!==name?warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name].basic=!0,props[name].basictkn=tkn}function saveAccessor(accessorType,props,name,tkn,isClass,isStatic){var flagName=\"get\"===accessorType?\"getterToken\":\"setterToken\",msg=\"\";isClass?(isStatic&&(msg+=\"static \"),msg+=accessorType+\"ter method\"):msg=\"key\",state.tokens.curr.accessorType=accessorType,state.nameStack.set(tkn),props[name]?(props[name].basic||props[name][flagName])&&\"__proto__\"!==name&&warning(\"W075\",state.tokens.next,msg,name):props[name]=Object.create(null),props[name][flagName]=tkn}function computedPropertyName(){advance(\"[\"),state.inES6()||warning(\"W119\",state.tokens.curr,\"computed property names\",\"6\");var value=expression(10);return advance(\"]\"),value}function checkPunctuators(token,values){return\"(punctuator)\"===token.type?_.contains(values,token.value):!1}function checkPunctuator(token,value){return\"(punctuator)\"===token.type&&token.value===value}function destructuringAssignOrJsonValue(){var block=lookupBlockType();block.notJson?(!state.inES6()&&block.isDestAssign&&warning(\"W104\",state.tokens.curr,\"destructuring assignment\",\"6\"),statements()):(state.option.laxbreak=!0,state.jsonMode=!0,jsonValue())}function jsonValue(){function jsonObject(){var o={},t=state.tokens.next;if(advance(\"{\"),\"}\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E026\",state.tokens.next,t.line);else{if(\"}\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id?error(\"E028\",state.tokens.next):\"(string)\"!==state.tokens.next.id&&warning(\"W095\",state.tokens.next,state.tokens.next.value)}if(o[state.tokens.next.value]===!0?warning(\"W075\",state.tokens.next,\"key\",state.tokens.next.value):\"__proto__\"===state.tokens.next.value&&!state.option.proto||\"__iterator__\"===state.tokens.next.value&&!state.option.iterator?warning(\"W096\",state.tokens.next,state.tokens.next.value):o[state.tokens.next.value]=!0,advance(),advance(\":\"),jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"}\")}function jsonArray(){var t=state.tokens.next;if(advance(\"[\"),\"]\"!==state.tokens.next.id)for(;;){if(\"(end)\"===state.tokens.next.id)error(\"E027\",state.tokens.next,t.line);else{if(\"]\"===state.tokens.next.id){warning(\"W094\",state.tokens.curr);break}\",\"===state.tokens.next.id&&error(\"E028\",state.tokens.next)}if(jsonValue(),\",\"!==state.tokens.next.id)break;advance(\",\")}advance(\"]\")}switch(state.tokens.next.id){case\"{\":jsonObject();break;case\"[\":jsonArray();break;case\"true\":case\"false\":case\"null\":case\"(number)\":case\"(string)\":advance();break;case\"-\":advance(\"-\"),advance(\"(number)\");break;default:error(\"E003\",state.tokens.next)}}var api,declared,functions,inblock,indent,lookahead,lex,member,membersOnly,predefined,stack,urls,bang={\"<\":!0,\"<=\":!0,\"==\":!0,\"===\":!0,\"!==\":!0,\"!=\":!0,\">\":!0,\">=\":!0,\"+\":!0,\"-\":!0,\"*\":!0,\"/\":!0,\"%\":!0},functionicity=[\"closure\",\"exception\",\"global\",\"label\",\"outer\",\"unused\",\"var\"],extraModules=[],emitter=new events.EventEmitter,typeofValues={};typeofValues.legacy=[\"xml\",\"unknown\"],typeofValues.es3=[\"undefined\",\"boolean\",\"number\",\"string\",\"function\",\"object\"],typeofValues.es3=typeofValues.es3.concat(typeofValues.legacy),typeofValues.es6=typeofValues.es3.concat(\"symbol\"),type(\"(number)\",function(){return this}),type(\"(string)\",function(){return this}),state.syntax[\"(identifier)\"]={type:\"(identifier)\",lbp:0,identifier:!0,nud:function(){var v=this.value;return\"=>\"===state.tokens.next.id?this:(state.funct[\"(comparray)\"].check(v)||state.funct[\"(scope)\"].block.use(v,state.tokens.curr),this)},led:function(){error(\"E033\",state.tokens.next,state.tokens.next.value)}};var baseTemplateSyntax={lbp:0,identifier:!1,template:!0};state.syntax[\"(template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template middle)\"]=_.extend({type:\"(template middle)\",middle:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(template tail)\"]=_.extend({type:\"(template tail)\",tail:!0,noSubst:!1},baseTemplateSyntax),state.syntax[\"(no subst template)\"]=_.extend({type:\"(template)\",nud:doTemplateLiteral,led:doTemplateLiteral,noSubst:!0,tail:!0},baseTemplateSyntax),type(\"(regexp)\",function(){return this}),delim(\"(endline)\"),delim(\"(begin)\"),delim(\"(end)\").reach=!0,delim(\"(error)\").reach=!0,delim(\"}\").reach=!0,delim(\")\"),delim(\"]\"),delim('\"').reach=!0,delim(\"'\").reach=!0,delim(\";\"),delim(\":\").reach=!0,delim(\"#\"),reserve(\"else\"),reserve(\"case\").reach=!0,reserve(\"catch\"),reserve(\"default\").reach=!0,reserve(\"finally\"),reservevar(\"arguments\",function(x){state.isStrict()&&state.funct[\"(global)\"]&&warning(\"E008\",x)}),reservevar(\"eval\"),reservevar(\"false\"),reservevar(\"Infinity\"),reservevar(\"null\"),reservevar(\"this\",function(x){state.isStrict()&&!isMethod()&&!state.option.validthis&&(state.funct[\"(statement)\"]&&state.funct[\"(name)\"].charAt(0)>\"Z\"||state.funct[\"(global)\"])&&warning(\"W040\",x)}),reservevar(\"true\"),reservevar(\"undefined\"),assignop(\"=\",\"assign\",20),assignop(\"+=\",\"assignadd\",20),assignop(\"-=\",\"assignsub\",20),assignop(\"*=\",\"assignmult\",20),assignop(\"/=\",\"assigndiv\",20).nud=function(){error(\"E014\")},assignop(\"%=\",\"assignmod\",20),bitwiseassignop(\"&=\"),bitwiseassignop(\"|=\"),bitwiseassignop(\"^=\"),bitwiseassignop(\"<<=\"),bitwiseassignop(\">>=\"),bitwiseassignop(\">>>=\"),infix(\",\",function(left,that){var expr;if(that.exprs=[left],state.option.nocomma&&warning(\"W127\"),!comma({peek:!0}))return that;for(;;){if(!(expr=expression(10)))break;if(that.exprs.push(expr),\",\"!==state.tokens.next.value||!comma())break}return that},10,!0),infix(\"?\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(10),advance(\":\"),that[\"else\"]=expression(10),that},30);var orPrecendence=40;infix(\"||\",function(left,that){return increaseComplexityCount(),that.left=left,that.right=expression(orPrecendence),that},orPrecendence),infix(\"&&\",\"and\",50),bitwise(\"|\",\"bitor\",70),bitwise(\"^\",\"bitxor\",80),bitwise(\"&\",\"bitand\",90),relation(\"==\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));switch(!0){case!eqnull&&state.option.eqeqeq:this.from=this.character,warning(\"W116\",this,\"===\",\"==\");break;case isPoorRelation(left):warning(\"W041\",this,\"===\",left.value);break;case isPoorRelation(right):warning(\"W041\",this,\"===\",right.value);break;case isTypoTypeof(right,left,state):warning(\"W122\",this,right.value);break;case isTypoTypeof(left,right,state):warning(\"W122\",this,left.value)}return this}),relation(\"===\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!=\",function(left,right){var eqnull=state.option.eqnull&&(\"null\"===(left&&left.value)||\"null\"===(right&&right.value));return!eqnull&&state.option.eqeqeq?(this.from=this.character,warning(\"W116\",this,\"!==\",\"!=\")):isPoorRelation(left)?warning(\"W041\",this,\"!==\",left.value):isPoorRelation(right)?warning(\"W041\",this,\"!==\",right.value):isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"!==\",function(left,right){return isTypoTypeof(right,left,state)?warning(\"W122\",this,right.value):isTypoTypeof(left,right,state)&&warning(\"W122\",this,left.value),this}),relation(\"<\"),relation(\">\"),relation(\"<=\"),relation(\">=\"),bitwise(\"<<\",\"shiftleft\",120),bitwise(\">>\",\"shiftright\",120),bitwise(\">>>\",\"shiftrightunsigned\",120),infix(\"in\",\"in\",120),infix(\"instanceof\",\"instanceof\",120),infix(\"+\",function(left,that){var right;return that.left=left,that.right=right=expression(130),left&&right&&\"(string)\"===left.id&&\"(string)\"===right.id?(left.value+=right.value,left.character=right.character,!state.option.scripturl&&reg.javascriptURL.test(left.value)&&warning(\"W050\",left),left):that},130),prefix(\"+\",\"num\"),prefix(\"+++\",function(){return warning(\"W007\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"+++\",function(left){return warning(\"W007\"),this.left=left,this.right=expression(130),this},130),infix(\"-\",\"sub\",130),prefix(\"-\",\"neg\"),prefix(\"---\",function(){return warning(\"W006\"),this.arity=\"unary\",this.right=expression(150),this}),infix(\"---\",function(left){return warning(\"W006\"),this.left=left,this.right=expression(130),this},130),infix(\"*\",\"mult\",140),infix(\"/\",\"div\",140),infix(\"%\",\"mod\",140),suffix(\"++\"),prefix(\"++\",\"preinc\"),state.syntax[\"++\"].exps=!0,suffix(\"--\"),prefix(\"--\",\"predec\"),state.syntax[\"--\"].exps=!0,prefix(\"delete\",function(){var p=expression(10);return p?(\".\"!==p.id&&\"[\"!==p.id&&warning(\"W051\"),this.first=p,p.identifier&&!state.isStrict()&&(p.forgiveUndef=!0),this):this}).exps=!0,prefix(\"~\",function(){return state.option.bitwise&&warning(\"W016\",this,\"~\"),this.arity=\"unary\",this.right=expression(150),this}),prefix(\"...\",function(){return state.inES6(!0)||warning(\"W119\",this,\"spread/rest operator\",\"6\"),state.tokens.next.identifier||\"(string)\"===state.tokens.next.type||checkPunctuators(state.tokens.next,[\"[\",\"(\"])||error(\"E030\",state.tokens.next,state.tokens.next.value),expression(150),this}),prefix(\"!\",function(){return this.arity=\"unary\",this.right=expression(150),this.right||quit(\"E041\",this.line||0),bang[this.right.id]===!0&&warning(\"W018\",this,\"!\"),this}),prefix(\"typeof\",function(){var p=expression(150);return this.first=this.right=p,p||quit(\"E041\",this.line||0,this.character||0),p.identifier&&(p.forgiveUndef=!0),this}),prefix(\"new\",function(){var mp=metaProperty(\"target\",function(){state.inES6(!0)||warning(\"W119\",state.tokens.prev,\"new.target\",\"6\");for(var inFunction,c=state.funct;c&&(inFunction=!c[\"(global)\"],c[\"(arrow)\"]);)c=c[\"(context)\"];inFunction||warning(\"W136\",state.tokens.prev,\"new.target\")});if(mp)return mp;var i,c=expression(155);if(c&&\"function\"!==c.id)if(c.identifier)switch(c[\"new\"]=!0,c.value){case\"Number\":case\"String\":case\"Boolean\":case\"Math\":case\"JSON\":warning(\"W053\",state.tokens.prev,c.value);break;case\"Symbol\":state.inES6()&&warning(\"W053\",state.tokens.prev,c.value);break;case\"Function\":state.option.evil||warning(\"W054\");break;case\"Date\":case\"RegExp\":case\"this\":break;default:\"function\"!==c.id&&(i=c.value.substr(0,1),state.option.newcap&&(\"A\">i||i>\"Z\")&&!state.funct[\"(scope)\"].isPredefined(c.value)&&warning(\"W055\",state.tokens.curr))}else\".\"!==c.id&&\"[\"!==c.id&&\"(\"!==c.id&&warning(\"W056\",state.tokens.curr);else state.option.supernew||warning(\"W057\",this);return\"(\"===state.tokens.next.id||state.option.supernew||warning(\"W058\",state.tokens.curr,state.tokens.curr.value),this.first=this.right=c,this}),state.syntax[\"new\"].exps=!0,prefix(\"void\").exps=!0,infix(\".\",function(left,that){var m=identifier(!1,!0);return\"string\"==typeof m&&countMember(m),that.left=left,that.right=m,m&&\"hasOwnProperty\"===m&&\"=\"===state.tokens.next.value&&warning(\"W001\"),!left||\"arguments\"!==left.value||\"callee\"!==m&&\"caller\"!==m?state.option.evil||!left||\"document\"!==left.value||\"write\"!==m&&\"writeln\"!==m||warning(\"W060\",left):state.option.noarg?warning(\"W059\",left,m):state.isStrict()&&error(\"E008\"),state.option.evil||\"eval\"!==m&&\"execScript\"!==m||isGlobalEval(left,state)&&warning(\"W061\"),that},160,!0),infix(\"(\",function(left,that){state.option.immed&&left&&!left.immed&&\"function\"===left.id&&warning(\"W062\");var n=0,p=[];if(left&&\"(identifier)\"===left.type&&left.value.match(/^[A-Z]([A-Z0-9_$]*[a-z][A-Za-z0-9_$]*)?$/)&&-1===\"Array Number String Boolean Date Object Error Symbol\".indexOf(left.value)&&(\"Math\"===left.value?warning(\"W063\",left):state.option.newcap&&warning(\"W064\",left)),\")\"!==state.tokens.next.id)for(;p[p.length]=expression(10),n+=1,\",\"===state.tokens.next.id;)comma();return advance(\")\"),\"object\"==typeof left&&(state.inES5()||\"parseInt\"!==left.value||1!==n||warning(\"W065\",state.tokens.curr),state.option.evil||(\"eval\"===left.value||\"Function\"===left.value||\"execScript\"===left.value?(warning(\"W061\",left),p[0]&&\"(string)\"===[0].id&&addInternalSrc(left,p[0].value)):!p[0]||\"(string)\"!==p[0].id||\"setTimeout\"!==left.value&&\"setInterval\"!==left.value?!p[0]||\"(string)\"!==p[0].id||\".\"!==left.value||\"window\"!==left.left.value||\"setTimeout\"!==left.right&&\"setInterval\"!==left.right||(warning(\"W066\",left),addInternalSrc(left,p[0].value)):(warning(\"W066\",left),addInternalSrc(left,p[0].value))),left.identifier||\".\"===left.id||\"[\"===left.id||\"=>\"===left.id||\"(\"===left.id||\"&&\"===left.id||\"||\"===left.id||\"?\"===left.id||state.inES6()&&left[\"(name)\"]||warning(\"W067\",that)),that.left=left,that},155,!0).exps=!0,prefix(\"(\",function(){var pn1,ret,triggerFnExpr,first,last,pn=state.tokens.next,i=-1,parens=1,opening=state.tokens.curr,preceeding=state.tokens.prev,isNecessary=!state.option.singleGroups;do\"(\"===pn.value?parens+=1:\")\"===pn.value&&(parens-=1),i+=1,pn1=pn,pn=peek(i);while((0!==parens||\")\"!==pn1.value)&&\";\"!==pn.value&&\"(end)\"!==pn.type);if(\"function\"===state.tokens.next.id&&(triggerFnExpr=state.tokens.next.immed=!0),\"=>\"===pn.value)return doFunction({type:\"arrow\",parsedOpening:!0});var exprs=[];if(\")\"!==state.tokens.next.id)for(;exprs.push(expression(10)),\",\"===state.tokens.next.id;)state.option.nocomma&&warning(\"W127\"),comma();return advance(\")\",this),state.option.immed&&exprs[0]&&\"function\"===exprs[0].id&&\"(\"!==state.tokens.next.id&&\".\"!==state.tokens.next.id&&\"[\"!==state.tokens.next.id&&warning(\"W068\",this),exprs.length?(exprs.length>1?(ret=Object.create(state.syntax[\",\"]),ret.exprs=exprs,first=exprs[0],last=exprs[exprs.length-1],isNecessary||(isNecessary=preceeding.assign||preceeding.delim)):(ret=first=last=exprs[0],isNecessary||(isNecessary=opening.beginsStmt&&(\"{\"===ret.id||triggerFnExpr||isFunctor(ret))||triggerFnExpr&&(!isEndOfExpr()||\"}\"!==state.tokens.prev.id)||isFunctor(ret)&&!isEndOfExpr()||\"{\"===ret.id&&\"=>\"===preceeding.id||\"(number)\"===ret.type&&checkPunctuator(pn,\".\")&&/^\\d+$/.test(ret.value))),ret&&(!isNecessary&&(first.left||first.right||ret.exprs)&&(isNecessary=!isBeginOfExpr(preceeding)&&first.lbp<=preceeding.lbp||!isEndOfExpr()&&last.lbp<state.tokens.next.lbp),isNecessary||warning(\"W126\",opening),ret.paren=!0),ret):void 0}),application(\"=>\"),infix(\"[\",function(left,that){var s,e=expression(10);return e&&\"(string)\"===e.type&&(state.option.evil||\"eval\"!==e.value&&\"execScript\"!==e.value||isGlobalEval(left,state)&&warning(\"W061\"),countMember(e.value),!state.option.sub&&reg.identifier.test(e.value)&&(s=state.syntax[e.value],s&&isReserved(s)||warning(\"W069\",state.tokens.prev,e.value))),advance(\"]\",that),e&&\"hasOwnProperty\"===e.value&&\"=\"===state.tokens.next.value&&warning(\"W001\"),that.left=left,that.right=e,that},160,!0),prefix(\"[\",function(){var blocktype=lookupBlockType();if(blocktype.isCompArray)return state.option.esnext||state.inMoz()||warning(\"W118\",state.tokens.curr,\"array comprehension\"),comprehensiveArrayExpression();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;var b=state.tokens.curr.line!==startLine(state.tokens.next);for(this.first=[],b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));\"(end)\"!==state.tokens.next.id;){for(;\",\"===state.tokens.next.id;){if(!state.option.elision){if(state.inES5()){warning(\"W128\");do advance(\",\");while(\",\"===state.tokens.next.id);continue}warning(\"W070\")}advance(\",\")}if(\"]\"===state.tokens.next.id)break;if(this.first.push(expression(10)),\",\"!==state.tokens.next.id)break;if(comma({allowTrailing:!0}),\"]\"===state.tokens.next.id&&!state.inES5()){warning(\"W070\",state.tokens.curr);break}}return b&&(indent-=state.option.indent),advance(\"]\",this),this}),function(x){x.nud=function(){var b,f,i,p,t,nextVal,isGeneratorMethod=!1,props=Object.create(null);b=state.tokens.curr.line!==startLine(state.tokens.next),b&&(indent+=state.option.indent,state.tokens.next.from===indent+state.option.indent&&(indent+=state.option.indent));var blocktype=lookupBlockType();if(blocktype.isDestAssign)return this.destructAssign=destructuringPattern({openingParsed:!0,assignment:!0}),this;for(;\"}\"!==state.tokens.next.id;){if(nextVal=state.tokens.next.value,!state.tokens.next.identifier||\",\"!==peekIgnoreEOL().id&&\"}\"!==peekIgnoreEOL().id)if(\":\"===peek().id||\"get\"!==nextVal&&\"set\"!==nextVal){if(\"*\"===state.tokens.next.value&&\"(punctuator)\"===state.tokens.next.type?(state.inES6()||warning(\"W104\",state.tokens.next,\"generator functions\",\"6\"),advance(\"*\"),isGeneratorMethod=!0):isGeneratorMethod=!1,\"[\"===state.tokens.next.id)i=computedPropertyName(),state.nameStack.set(i);else if(state.nameStack.set(state.tokens.next),i=propertyName(),saveProperty(props,i,state.tokens.next),\"string\"!=typeof i)break;\"(\"===state.tokens.next.value?(state.inES6()||warning(\"W104\",state.tokens.curr,\"concise methods\",\"6\"),doFunction({type:isGeneratorMethod?\"generator\":null})):(advance(\":\"),expression(10))}else advance(nextVal),state.inES5()||error(\"E034\"),i=propertyName(),i||state.inES6()||error(\"E035\"),i&&saveAccessor(nextVal,props,i,state.tokens.curr),t=state.tokens.next,f=doFunction(),p=f[\"(params)\"],\"get\"===nextVal&&i&&p?warning(\"W076\",t,p[0],i):\"set\"!==nextVal||!i||p&&1===p.length||warning(\"W077\",t,i);else state.inES6()||warning(\"W104\",state.tokens.next,\"object short notation\",\"6\"),i=propertyName(!0),saveProperty(props,i,state.tokens.next),expression(10);if(countMember(i),\",\"!==state.tokens.next.id)break;comma({allowTrailing:!0,property:!0}),\",\"===state.tokens.next.id?warning(\"W070\",state.tokens.curr):\"}\"!==state.tokens.next.id||state.inES5()||warning(\"W070\",state.tokens.curr)}return b&&(indent-=state.option.indent),advance(\"}\",this),checkProperties(props),this},x.fud=function(){error(\"E036\",state.tokens.curr)}}(delim(\"{\"));var conststatement=stmt(\"const\",function(context){return blockVariableStatement(\"const\",this,context)});conststatement.exps=!0;var letstatement=stmt(\"let\",function(context){return blockVariableStatement(\"let\",this,context)});letstatement.exps=!0;var varstatement=stmt(\"var\",function(context){var tokens,lone,value,prefix=context&&context.prefix,inexport=context&&context.inexport,implied=context&&context.implied,report=!(context&&context.ignore);for(this.first=[];;){var names=[];_.contains([\"{\",\"[\"],state.tokens.next.value)?(tokens=destructuringPattern(),lone=!1):(tokens=[{id:identifier(),token:state.tokens.curr}],lone=!0),prefix&&implied||!report||!state.option.varstmt||warning(\"W132\",this),this.first=this.first.concat(names);for(var t in tokens)tokens.hasOwnProperty(t)&&(t=tokens[t],!implied&&state.funct[\"(global)\"]&&(predefined[t.id]===!1?warning(\"W079\",t.token,t.id):state.option.futurehostile===!1&&(!state.inES5()&&vars.ecmaIdentifiers[5][t.id]===!1||!state.inES6()&&vars.ecmaIdentifiers[6][t.id]===!1)&&warning(\"W129\",t.token,t.id)),t.id&&(\"for\"===implied?(state.funct[\"(scope)\"].has(t.id)||report&&warning(\"W088\",t.token,t.id),state.funct[\"(scope)\"].block.use(t.id,t.token)):(state.funct[\"(scope)\"].addlabel(t.id,{type:\"var\",token:t.token}),lone&&inexport&&state.funct[\"(scope)\"].setExported(t.id,t.token)),names.push(t.token)));if(\"=\"===state.tokens.next.id&&(state.nameStack.set(state.tokens.curr),advance(\"=\"),prefix||!report||state.funct[\"(loopage)\"]||\"undefined\"!==state.tokens.next.id||warning(\"W080\",state.tokens.prev,state.tokens.prev.value),\"=\"===peek(0).id&&state.tokens.next.identifier&&(!prefix&&report&&!state.funct[\"(params)\"]||-1===state.funct[\"(params)\"].indexOf(state.tokens.next.value))&&warning(\"W120\",state.tokens.next,state.tokens.next.value),value=expression(prefix?120:10),lone?tokens[0].first=value:destructuringPatternMatch(names,value)),\",\"!==state.tokens.next.id)break;comma()}return this});varstatement.exps=!0,blockstmt(\"class\",function(){return classdef.call(this,!0)}),blockstmt(\"function\",function(context){var inexport=context&&context.inexport,generator=!1;\"*\"===state.tokens.next.value&&(advance(\"*\"),state.inES6({strict:!0})?generator=!0:warning(\"W119\",state.tokens.curr,\"function*\",\"6\")),inblock&&warning(\"W082\",state.tokens.curr);var i=optionalidentifier();return state.funct[\"(scope)\"].addlabel(i,{type:\"function\",token:state.tokens.curr}),void 0===i?warning(\"W025\"):inexport&&state.funct[\"(scope)\"].setExported(i,state.tokens.prev),doFunction({name:i,statement:this,type:generator?\"generator\":null,ignoreLoopFunc:inblock}),\"(\"===state.tokens.next.id&&state.tokens.next.line===state.tokens.curr.line&&error(\"E039\"),this}),prefix(\"function\",function(){var generator=!1;\"*\"===state.tokens.next.value&&(state.inES6()||warning(\"W119\",state.tokens.curr,\"function*\",\"6\"),advance(\"*\"),generator=!0);var i=optionalidentifier();return doFunction({name:i,type:generator?\"generator\":null}),this}),blockstmt(\"if\",function(){var t=state.tokens.next;increaseComplexityCount(),state.condition=!0,advance(\"(\");var expr=expression(0);checkCondAssignment(expr);var forinifcheck=null;state.option.forin&&state.forinifcheckneeded&&(state.forinifcheckneeded=!1,forinifcheck=state.forinifchecks[state.forinifchecks.length-1],forinifcheck.type=\"(punctuator)\"===expr.type&&\"!\"===expr.value?\"(negative)\":\"(positive)\"),advance(\")\",t),state.condition=!1;var s=block(!0,!0);return forinifcheck&&\"(negative)\"===forinifcheck.type&&s&&s[0]&&\"(identifier)\"===s[0].type&&\"continue\"===s[0].value&&(forinifcheck.type=\"(negative-with-continue)\"),\"else\"===state.tokens.next.id&&(advance(\"else\"),\"if\"===state.tokens.next.id||\"switch\"===state.tokens.next.id?statement():block(!0,!0)),this}),blockstmt(\"try\",function(){function doCatch(){if(advance(\"catch\"),advance(\"(\"),state.funct[\"(scope)\"].stack(\"catchparams\"),checkPunctuators(state.tokens.next,[\"[\",\"{\"])){var tokens=destructuringPattern();_.each(tokens,function(token){token.id&&state.funct[\"(scope)\"].addParam(token.id,token,\"exception\")})}else\"(identifier)\"!==state.tokens.next.type?warning(\"E030\",state.tokens.next,state.tokens.next.value):state.funct[\"(scope)\"].addParam(identifier(),state.tokens.curr,\"exception\");\"if\"===state.tokens.next.value&&(state.inMoz()||warning(\"W118\",state.tokens.curr,\"catch filter\"),advance(\"if\"),expression(0)),advance(\")\"),block(!1),state.funct[\"(scope)\"].unstack()}var b;for(block(!0);\"catch\"===state.tokens.next.id;)increaseComplexityCount(),b&&!state.inMoz()&&warning(\"W118\",state.tokens.next,\"multiple catch blocks\"),doCatch(),b=!0;return\"finally\"===state.tokens.next.id?(advance(\"finally\"),block(!0),void 0):(b||error(\"E021\",state.tokens.next,\"catch\",state.tokens.next.value),this)}),blockstmt(\"while\",function(){var t=state.tokens.next;return state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this}).labelled=!0,blockstmt(\"with\",function(){var t=state.tokens.next;return state.isStrict()?error(\"E010\",state.tokens.curr):state.option.withstmt||warning(\"W085\",state.tokens.curr),advance(\"(\"),expression(0),advance(\")\",t),block(!0,!0),this}),blockstmt(\"switch\",function(){var t=state.tokens.next,g=!1,noindent=!1;\nfor(state.funct[\"(breakage)\"]+=1,advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),t=state.tokens.next,advance(\"{\"),state.tokens.next.from===indent&&(noindent=!0),noindent||(indent+=state.option.indent),this.cases=[];;)switch(state.tokens.next.id){case\"case\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"case\":case\"continue\":case\"return\":case\"switch\":case\"throw\":break;default:state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"case\")}advance(\"case\"),this.cases.push(expression(0)),increaseComplexityCount(),g=!0,advance(\":\"),state.funct[\"(verb)\"]=\"case\";break;case\"default\":switch(state.funct[\"(verb)\"]){case\"yield\":case\"break\":case\"continue\":case\"return\":case\"throw\":break;default:this.cases.length&&(state.tokens.curr.caseFallsThrough||warning(\"W086\",state.tokens.curr,\"default\"))}advance(\"default\"),g=!0,advance(\":\");break;case\"}\":return noindent||(indent-=state.option.indent),advance(\"}\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(verb)\"]=void 0,void 0;case\"(end)\":return error(\"E023\",state.tokens.next,\"}\"),void 0;default:if(indent+=state.option.indent,g)switch(state.tokens.curr.id){case\",\":return error(\"E040\"),void 0;case\":\":g=!1,statements();break;default:return error(\"E025\",state.tokens.curr),void 0}else{if(\":\"!==state.tokens.curr.id)return error(\"E021\",state.tokens.next,\"case\",state.tokens.next.value),void 0;advance(\":\"),error(\"E024\",state.tokens.curr,\":\"),statements()}indent-=state.option.indent}return this}).labelled=!0,stmt(\"debugger\",function(){return state.option.debug||warning(\"W087\",this),this}).exps=!0,function(){var x=stmt(\"do\",function(){state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,increaseComplexityCount(),this.first=block(!0,!0),advance(\"while\");var t=state.tokens.next;return advance(\"(\"),checkCondAssignment(expression(0)),advance(\")\",t),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1,this});x.labelled=!0,x.exps=!0}(),blockstmt(\"for\",function(){var s,t=state.tokens.next,letscope=!1,foreachtok=null;\"each\"===t.value&&(foreachtok=t,advance(\"each\"),state.inMoz()||warning(\"W118\",state.tokens.curr,\"for each\")),increaseComplexityCount(),advance(\"(\");var nextop,comma,initializer,i=0,inof=[\"in\",\"of\"],level=0;checkPunctuators(state.tokens.next,[\"{\",\"[\"])&&++level;do{if(nextop=peek(i),++i,checkPunctuators(nextop,[\"{\",\"[\"])?++level:checkPunctuators(nextop,[\"}\",\"]\"])&&--level,0>level)break;0===level&&(!comma&&checkPunctuator(nextop,\",\")?comma=nextop:!initializer&&checkPunctuator(nextop,\"=\")&&(initializer=nextop))}while(level>0||!_.contains(inof,nextop.value)&&\";\"!==nextop.value&&\"(end)\"!==nextop.type);if(_.contains(inof,nextop.value)){state.inES6()||\"of\"!==nextop.value||warning(\"W104\",nextop,\"for of\",\"6\");var ok=!(initializer||comma);if(initializer&&error(\"W133\",comma,nextop.value,\"initializer is forbidden\"),comma&&error(\"W133\",comma,nextop.value,\"more than one ForBinding\"),\"var\"===state.tokens.next.id?(advance(\"var\"),state.tokens.curr.fud({prefix:!0})):\"let\"===state.tokens.next.id||\"const\"===state.tokens.next.id?(advance(state.tokens.next.id),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud({prefix:!0})):Object.create(varstatement).fud({prefix:!0,implied:\"for\",ignore:!ok}),advance(nextop.value),expression(20),advance(\")\",t),\"in\"===nextop.value&&state.option.forin&&(state.forinifcheckneeded=!0,void 0===state.forinifchecks&&(state.forinifchecks=[]),state.forinifchecks.push({type:\"(none)\"})),state.funct[\"(breakage)\"]+=1,state.funct[\"(loopage)\"]+=1,s=block(!0,!0),\"in\"===nextop.value&&state.option.forin){if(state.forinifchecks&&state.forinifchecks.length>0){var check=state.forinifchecks.pop();(s&&s.length>0&&(\"object\"!=typeof s[0]||\"if\"!==s[0].value)||\"(positive)\"===check.type&&s.length>1||\"(negative)\"===check.type)&&warning(\"W089\",this)}state.forinifcheckneeded=!1}state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}else{if(foreachtok&&error(\"E045\",foreachtok),\";\"!==state.tokens.next.id)if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud();else if(\"let\"===state.tokens.next.id)advance(\"let\"),letscope=!0,state.funct[\"(scope)\"].stack(),state.tokens.curr.fud();else for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();if(nolinebreak(state.tokens.curr),advance(\";\"),state.funct[\"(loopage)\"]+=1,\";\"!==state.tokens.next.id&&checkCondAssignment(expression(0)),nolinebreak(state.tokens.curr),advance(\";\"),\";\"===state.tokens.next.id&&error(\"E021\",state.tokens.next,\")\",\";\"),\")\"!==state.tokens.next.id)for(;expression(0,\"for\"),\",\"===state.tokens.next.id;)comma();advance(\")\",t),state.funct[\"(breakage)\"]+=1,block(!0,!0),state.funct[\"(breakage)\"]-=1,state.funct[\"(loopage)\"]-=1}return letscope&&state.funct[\"(scope)\"].unstack(),this}).labelled=!0,stmt(\"break\",function(){var v=state.tokens.next.value;return state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line!==startLine(state.tokens.next)?0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value):(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"continue\",function(){var v=state.tokens.next.value;return 0===state.funct[\"(breakage)\"]&&warning(\"W052\",state.tokens.next,this.value),state.funct[\"(loopage)\"]||warning(\"W052\",state.tokens.next,this.value),state.option.asi||nolinebreak(this),\";\"===state.tokens.next.id||state.tokens.next.reach||state.tokens.curr.line===startLine(state.tokens.next)&&(state.funct[\"(scope)\"].funct.hasBreakLabel(v)||warning(\"W090\",state.tokens.next,v),this.first=state.tokens.next,advance()),reachable(this),this}).exps=!0,stmt(\"return\",function(){return this.line===startLine(state.tokens.next)?\";\"===state.tokens.next.id||state.tokens.next.reach||(this.first=expression(0),!this.first||\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)):\"(punctuator)\"===state.tokens.next.type&&[\"[\",\"{\",\"+\",\"-\"].indexOf(state.tokens.next.value)>-1&&nolinebreak(this),reachable(this),this}).exps=!0,function(x){x.exps=!0,x.lbp=25}(prefix(\"yield\",function(){var prev=state.tokens.prev;state.inES6(!0)&&!state.funct[\"(generator)\"]?\"(catch)\"===state.funct[\"(name)\"]&&state.funct[\"(context)\"][\"(generator)\"]||error(\"E046\",state.tokens.curr,\"yield\"):state.inES6()||warning(\"W104\",state.tokens.curr,\"yield\",\"6\"),state.funct[\"(generator)\"]=\"yielded\";var delegatingYield=!1;return\"*\"===state.tokens.next.value&&(delegatingYield=!0,advance(\"*\")),this.line!==startLine(state.tokens.next)&&state.inMoz()?state.option.asi||nolinebreak(this):((delegatingYield||\";\"!==state.tokens.next.id&&!state.option.asi&&!state.tokens.next.reach&&state.tokens.next.nud)&&(nobreaknonadjacent(state.tokens.curr,state.tokens.next),this.first=expression(10),\"(punctuator)\"!==this.first.type||\"=\"!==this.first.value||this.first.paren||state.option.boss||warningAt(\"W093\",this.first.line,this.first.character)),state.inMoz()&&\")\"!==state.tokens.next.id&&(prev.lbp>30||!prev.assign&&!isEndOfExpr()||\"yield\"===prev.id)&&error(\"E050\",this)),this})),stmt(\"throw\",function(){return nolinebreak(this),this.first=expression(20),reachable(this),this}).exps=!0,stmt(\"import\",function(){if(state.inES6()||warning(\"W119\",state.tokens.curr,\"import\",\"6\"),\"(string)\"===state.tokens.next.type)return advance(\"(string)\"),this;if(state.tokens.next.identifier){if(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value)return advance(\"from\"),advance(\"(string)\"),this;advance(\",\")}if(\"*\"===state.tokens.next.id)advance(\"*\"),advance(\"as\"),state.tokens.next.identifier&&(this.name=identifier(),state.funct[\"(scope)\"].addlabel(this.name,{type:\"const\",token:state.tokens.curr}));else for(advance(\"{\");;){if(\"}\"===state.tokens.next.value){advance(\"}\");break}var importName;if(\"default\"===state.tokens.next.type?(importName=\"default\",advance(\"default\")):importName=identifier(),\"as\"===state.tokens.next.value&&(advance(\"as\"),importName=identifier()),state.funct[\"(scope)\"].addlabel(importName,{type:\"const\",token:state.tokens.curr}),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return advance(\"from\"),advance(\"(string)\"),this}).exps=!0,stmt(\"export\",function(){var token,identifier,ok=!0;if(state.inES6()||(warning(\"W119\",state.tokens.curr,\"export\",\"6\"),ok=!1),state.funct[\"(scope)\"].block.isGlobal()||(error(\"E053\",state.tokens.curr),ok=!1),\"*\"===state.tokens.next.value)return advance(\"*\"),advance(\"from\"),advance(\"(string)\"),this;if(\"default\"===state.tokens.next.type){state.nameStack.set(state.tokens.next),advance(\"default\");var exportType=state.tokens.next.id;return(\"function\"===exportType||\"class\"===exportType)&&(this.block=!0),token=peek(),expression(10),identifier=token.value,this.block&&(state.funct[\"(scope)\"].addlabel(identifier,{type:exportType,token:token}),state.funct[\"(scope)\"].setExported(identifier,token)),this}if(\"{\"===state.tokens.next.value){advance(\"{\");for(var exportedTokens=[];;){if(state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance(),exportedTokens.push(state.tokens.curr),\"as\"===state.tokens.next.value&&(advance(\"as\"),state.tokens.next.identifier||error(\"E030\",state.tokens.next,state.tokens.next.value),advance()),\",\"!==state.tokens.next.value){if(\"}\"===state.tokens.next.value){advance(\"}\");break}error(\"E024\",state.tokens.next,state.tokens.next.value);break}advance(\",\")}return\"from\"===state.tokens.next.value?(advance(\"from\"),advance(\"(string)\")):ok&&exportedTokens.forEach(function(token){state.funct[\"(scope)\"].setExported(token.value,token)}),this}if(\"var\"===state.tokens.next.id)advance(\"var\"),state.tokens.curr.fud({inexport:!0});else if(\"let\"===state.tokens.next.id)advance(\"let\"),state.tokens.curr.fud({inexport:!0});else if(\"const\"===state.tokens.next.id)advance(\"const\"),state.tokens.curr.fud({inexport:!0});else if(\"function\"===state.tokens.next.id)this.block=!0,advance(\"function\"),state.syntax[\"function\"].fud({inexport:!0});else if(\"class\"===state.tokens.next.id){this.block=!0,advance(\"class\");var classNameToken=state.tokens.next;state.syntax[\"class\"].fud(),state.funct[\"(scope)\"].setExported(classNameToken.value,classNameToken)}else error(\"E024\",state.tokens.next,state.tokens.next.value);return this}).exps=!0,FutureReservedWord(\"abstract\"),FutureReservedWord(\"boolean\"),FutureReservedWord(\"byte\"),FutureReservedWord(\"char\"),FutureReservedWord(\"class\",{es5:!0,nud:classdef}),FutureReservedWord(\"double\"),FutureReservedWord(\"enum\",{es5:!0}),FutureReservedWord(\"export\",{es5:!0}),FutureReservedWord(\"extends\",{es5:!0}),FutureReservedWord(\"final\"),FutureReservedWord(\"float\"),FutureReservedWord(\"goto\"),FutureReservedWord(\"implements\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"import\",{es5:!0}),FutureReservedWord(\"int\"),FutureReservedWord(\"interface\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"long\"),FutureReservedWord(\"native\"),FutureReservedWord(\"package\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"private\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"protected\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"public\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"short\"),FutureReservedWord(\"static\",{es5:!0,strictOnly:!0}),FutureReservedWord(\"super\",{es5:!0}),FutureReservedWord(\"synchronized\"),FutureReservedWord(\"transient\"),FutureReservedWord(\"volatile\");var lookupBlockType=function(){var pn,pn1,prev,i=-1,bracketStack=0,ret={};checkPunctuators(state.tokens.curr,[\"[\",\"{\"])&&(bracketStack+=1);do{if(prev=-1===i?state.tokens.curr:pn,pn=-1===i?state.tokens.next:peek(i),pn1=peek(i+1),i+=1,checkPunctuators(pn,[\"[\",\"{\"])?bracketStack+=1:checkPunctuators(pn,[\"]\",\"}\"])&&(bracketStack-=1),1===bracketStack&&pn.identifier&&\"for\"===pn.value&&!checkPunctuator(prev,\".\")){ret.isCompArray=!0,ret.notJson=!0;break}if(0===bracketStack&&checkPunctuators(pn,[\"}\",\"]\"])){if(\"=\"===pn1.value){ret.isDestAssign=!0,ret.notJson=!0;break}if(\".\"===pn1.value){ret.notJson=!0;break}}checkPunctuator(pn,\";\")&&(ret.isBlock=!0,ret.notJson=!0)}while(bracketStack>0&&\"(end)\"!==pn.id);return ret},arrayComprehension=function(){function declare(v){var l=_current.variables.filter(function(elt){return elt.value===v?(elt.undef=!1,v):void 0}).length;return 0!==l}function use(v){var l=_current.variables.filter(function(elt){return elt.value!==v||elt.undef?void 0:(elt.unused===!0&&(elt.unused=!1),v)}).length;return 0===l}var _current,CompArray=function(){this.mode=\"use\",this.variables=[]},_carrays=[];return{stack:function(){_current=new CompArray,_carrays.push(_current)},unstack:function(){_current.variables.filter(function(v){v.unused&&warning(\"W098\",v.token,v.raw_text||v.value),v.undef&&state.funct[\"(scope)\"].block.use(v.value,v.token)}),_carrays.splice(-1,1),_current=_carrays[_carrays.length-1]},setState:function(s){_.contains([\"use\",\"define\",\"generate\",\"filter\"],s)&&(_current.mode=s)},check:function(v){return _current?_current&&\"use\"===_current.mode?(use(v)&&_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!0,unused:!1}),!0):_current&&\"define\"===_current.mode?(declare(v)||_current.variables.push({funct:state.funct,token:state.tokens.curr,value:v,undef:!1,unused:!0}),!0):_current&&\"generate\"===_current.mode?(state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):_current&&\"filter\"===_current.mode?(use(v)&&state.funct[\"(scope)\"].block.use(v,state.tokens.curr),!0):!1:void 0}}},escapeRegex=function(str){return str.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")},itself=function(s,o,g){function each(obj,cb){obj&&(Array.isArray(obj)||\"object\"!=typeof obj||(obj=Object.keys(obj)),obj.forEach(cb))}var i,k,x,reIgnoreStr,reIgnore,optionKeys,newOptionObj={},newIgnoredObj={};o=_.clone(o),state.reset(),o&&o.scope?JSHINT.scope=o.scope:(JSHINT.errors=[],JSHINT.undefs=[],JSHINT.internals=[],JSHINT.blacklist={},JSHINT.scope=\"(main)\"),predefined=Object.create(null),combine(predefined,vars.ecmaIdentifiers[3]),combine(predefined,vars.reservedVars),combine(predefined,g||{}),declared=Object.create(null);var exported=Object.create(null);if(o)for(each(o.predef||null,function(item){var slice,prop;\"-\"===item[0]?(slice=item.slice(1),JSHINT.blacklist[slice]=slice,delete predefined[slice]):(prop=Object.getOwnPropertyDescriptor(o.predef,item),predefined[item]=prop?prop.value:!1)}),each(o.exported||null,function(item){exported[item]=!0}),delete o.predef,delete o.exported,optionKeys=Object.keys(o),x=0;optionKeys.length>x;x++)if(/^-W\\d{3}$/g.test(optionKeys[x]))newIgnoredObj[optionKeys[x].slice(1)]=!0;else{var optionKey=optionKeys[x];newOptionObj[optionKey]=o[optionKey],(\"esversion\"===optionKey&&5===o[optionKey]||\"es5\"===optionKey&&o[optionKey])&&warning(\"I003\"),\"newcap\"===optionKeys[x]&&o[optionKey]===!1&&(newOptionObj[\"(explicitNewcap)\"]=!0)}state.option=newOptionObj,state.ignored=newIgnoredObj,state.option.indent=state.option.indent||4,state.option.maxerr=state.option.maxerr||50,indent=1;var scopeManagerInst=scopeManager(state,predefined,exported,declared);if(scopeManagerInst.on(\"warning\",function(ev){warning.apply(null,[ev.code,ev.token].concat(ev.data))}),scopeManagerInst.on(\"error\",function(ev){error.apply(null,[ev.code,ev.token].concat(ev.data))}),state.funct=functor(\"(global)\",null,{\"(global)\":!0,\"(scope)\":scopeManagerInst,\"(comparray)\":arrayComprehension(),\"(metrics)\":createMetrics(state.tokens.next)}),functions=[state.funct],urls=[],stack=null,member={},membersOnly=null,inblock=!1,lookahead=[],!isString(s)&&!Array.isArray(s))return errorAt(\"E004\",0),!1;api={get isJSON(){return state.jsonMode},getOption:function(name){return state.option[name]||null},getCache:function(name){return state.cache[name]},setCache:function(name,value){state.cache[name]=value},warn:function(code,data){warningAt.apply(null,[code,data.line,data.char].concat(data.data))},on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)}.bind(this))}},emitter.removeAllListeners(),(extraModules||[]).forEach(function(func){func(api)}),state.tokens.prev=state.tokens.curr=state.tokens.next=state.syntax[\"(begin)\"],o&&o.ignoreDelimiters&&(Array.isArray(o.ignoreDelimiters)||(o.ignoreDelimiters=[o.ignoreDelimiters]),o.ignoreDelimiters.forEach(function(delimiterPair){delimiterPair.start&&delimiterPair.end&&(reIgnoreStr=escapeRegex(delimiterPair.start)+\"[\\\\s\\\\S]*?\"+escapeRegex(delimiterPair.end),reIgnore=RegExp(reIgnoreStr,\"ig\"),s=s.replace(reIgnore,function(match){return match.replace(/./g,\" \")}))})),lex=new Lexer(s),lex.on(\"warning\",function(ev){warningAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"error\",function(ev){errorAt.apply(null,[ev.code,ev.line,ev.character].concat(ev.data))}),lex.on(\"fatal\",function(ev){quit(\"E041\",ev.line,ev.from)}),lex.on(\"Identifier\",function(ev){emitter.emit(\"Identifier\",ev)}),lex.on(\"String\",function(ev){emitter.emit(\"String\",ev)}),lex.on(\"Number\",function(ev){emitter.emit(\"Number\",ev)}),lex.start();for(var name in o)_.has(o,name)&&checkOption(name,state.tokens.curr);assume(),combine(predefined,g||{}),comma.first=!0;try{switch(advance(),state.tokens.next.id){case\"{\":case\"[\":destructuringAssignOrJsonValue();break;default:directives(),state.directive[\"use strict\"]&&\"global\"!==state.option.strict&&warning(\"W097\",state.tokens.prev),statements()}\"(end)\"!==state.tokens.next.id&&quit(\"E041\",state.tokens.curr.line),state.funct[\"(scope)\"].unstack()}catch(err){if(!err||\"JSHintError\"!==err.name)throw err;var nt=state.tokens.next||{};JSHINT.errors.push({scope:\"(main)\",raw:err.raw,code:err.code,reason:err.message,line:err.line||nt.line,character:err.character||nt.from},null)}if(\"(main)\"===JSHINT.scope)for(o=o||{},i=0;JSHINT.internals.length>i;i+=1)k=JSHINT.internals[i],o.scope=k.elem,itself(k.value,o,g);return 0===JSHINT.errors.length};return itself.addModule=function(func){extraModules.push(func)},itself.addModule(style.register),itself.data=function(){var fu,f,i,j,n,globals,data={functions:[],options:state.option};itself.errors.length&&(data.errors=itself.errors),state.jsonMode&&(data.json=!0);var impliedGlobals=state.funct[\"(scope)\"].getImpliedGlobals();for(impliedGlobals.length>0&&(data.implieds=impliedGlobals),urls.length>0&&(data.urls=urls),globals=state.funct[\"(scope)\"].getUsedOrDefinedGlobals(),globals.length>0&&(data.globals=globals),i=1;functions.length>i;i+=1){for(f=functions[i],fu={},j=0;functionicity.length>j;j+=1)fu[functionicity[j]]=[];for(j=0;functionicity.length>j;j+=1)0===fu[functionicity[j]].length&&delete fu[functionicity[j]];fu.name=f[\"(name)\"],fu.param=f[\"(params)\"],fu.line=f[\"(line)\"],fu.character=f[\"(character)\"],fu.last=f[\"(last)\"],fu.lastcharacter=f[\"(lastcharacter)\"],fu.metrics={complexity:f[\"(metrics)\"].ComplexityCount,parameters:f[\"(metrics)\"].arity,statements:f[\"(metrics)\"].statementCount},data.functions.push(fu)}var unuseds=state.funct[\"(scope)\"].getUnuseds();unuseds.length>0&&(data.unused=unuseds);for(n in member)if(\"number\"==typeof member[n]){data.member=member;break}return data},itself.jshint=itself,itself}();\"object\"==typeof exports&&exports&&(exports.JSHINT=JSHINT)},{\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./lex.js\":\"/node_modules/jshint/src/lex.js\",\"./messages.js\":\"/node_modules/jshint/src/messages.js\",\"./options.js\":\"/node_modules/jshint/src/options.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./scope-manager.js\":\"/node_modules/jshint/src/scope-manager.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",\"./style.js\":\"/node_modules/jshint/src/style.js\",\"./vars.js\":\"/node_modules/jshint/src/vars.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/lex.js\":[function(_dereq_,module,exports){\"use strict\";function asyncTrigger(){var _checks=[];return{push:function(fn){_checks.push(fn)},check:function(){for(var check=0;_checks.length>check;++check)_checks[check]();_checks.splice(0,_checks.length)}}}function Lexer(source){var lines=source;\"string\"==typeof lines&&(lines=lines.replace(/\\r\\n/g,\"\\n\").replace(/\\r/g,\"\\n\").split(\"\\n\")),lines[0]&&\"#!\"===lines[0].substr(0,2)&&(-1!==lines[0].indexOf(\"node\")&&(state.option.node=!0),lines[0]=\"\"),this.emitter=new events.EventEmitter,this.source=source,this.setLines(lines),this.prereg=!0,this.line=0,this.char=1,this.from=1,this.input=\"\",this.inComment=!1,this.context=[],this.templateStarts=[];for(var i=0;state.option.indent>i;i+=1)state.tab+=\" \";this.ignoreLinterErrors=!1}var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),reg=_dereq_(\"./reg.js\"),state=_dereq_(\"./state.js\").state,unicodeData=_dereq_(\"../data/ascii-identifier-data.js\"),asciiIdentifierStartTable=unicodeData.asciiIdentifierStartTable,asciiIdentifierPartTable=unicodeData.asciiIdentifierPartTable,Token={Identifier:1,Punctuator:2,NumericLiteral:3,StringLiteral:4,Comment:5,Keyword:6,NullLiteral:7,BooleanLiteral:8,RegExp:9,TemplateHead:10,TemplateMiddle:11,TemplateTail:12,NoSubstTemplate:13},Context={Block:1,Template:2};Lexer.prototype={_lines:[],inContext:function(ctxType){return this.context.length>0&&this.context[this.context.length-1].type===ctxType},pushContext:function(ctxType){this.context.push({type:ctxType})},popContext:function(){return this.context.pop()},isContext:function(context){return this.context.length>0&&this.context[this.context.length-1]===context},currentContext:function(){return this.context.length>0&&this.context[this.context.length-1]},getLines:function(){return this._lines=state.lines,this._lines},setLines:function(val){this._lines=val,state.lines=this._lines},peek:function(i){return this.input.charAt(i||0)},skip:function(i){i=i||1,this.char+=i,this.input=this.input.slice(i)},on:function(names,listener){names.split(\" \").forEach(function(name){this.emitter.on(name,listener)}.bind(this))},trigger:function(){this.emitter.emit.apply(this.emitter,Array.prototype.slice.call(arguments))},triggerAsync:function(type,args,checks,fn){checks.push(function(){fn()&&this.trigger(type,args)}.bind(this))},scanPunctuator:function(){var ch2,ch3,ch4,ch1=this.peek();switch(ch1){case\".\":if(/^[0-9]$/.test(this.peek(1)))return null;if(\".\"===this.peek(1)&&\".\"===this.peek(2))return{type:Token.Punctuator,value:\"...\"};case\"(\":case\")\":case\";\":case\",\":case\"[\":case\"]\":case\":\":case\"~\":case\"?\":return{type:Token.Punctuator,value:ch1};case\"{\":return this.pushContext(Context.Block),{type:Token.Punctuator,value:ch1};case\"}\":return this.inContext(Context.Block)&&this.popContext(),{type:Token.Punctuator,value:ch1};case\"#\":return{type:Token.Punctuator,value:ch1};case\"\":return null}return ch2=this.peek(1),ch3=this.peek(2),ch4=this.peek(3),\">\"===ch1&&\">\"===ch2&&\">\"===ch3&&\"=\"===ch4?{type:Token.Punctuator,value:\">>>=\"}:\"=\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"===\"}:\"!\"===ch1&&\"=\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"!==\"}:\">\"===ch1&&\">\"===ch2&&\">\"===ch3?{type:Token.Punctuator,value:\">>>\"}:\"<\"===ch1&&\"<\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\"<<=\"}:\">\"===ch1&&\">\"===ch2&&\"=\"===ch3?{type:Token.Punctuator,value:\">>=\"}:\"=\"===ch1&&\">\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:ch1===ch2&&\"+-<>&|\".indexOf(ch1)>=0?{type:Token.Punctuator,value:ch1+ch2}:\"<>=!+-*%&|^\".indexOf(ch1)>=0?\"=\"===ch2?{type:Token.Punctuator,value:ch1+ch2}:{type:Token.Punctuator,value:ch1}:\"/\"===ch1?\"=\"===ch2?{type:Token.Punctuator,value:\"/=\"}:{type:Token.Punctuator,value:\"/\"}:null},scanComments:function(){function commentToken(label,body,opt){var special=[\"jshint\",\"jslint\",\"members\",\"member\",\"globals\",\"global\",\"exported\"],isSpecial=!1,value=label+body,commentType=\"plain\";return opt=opt||{},opt.isMultiline&&(value+=\"*/\"),body=body.replace(/\\n/g,\" \"),\"/*\"===label&&reg.fallsThrough.test(body)&&(isSpecial=!0,commentType=\"falls through\"),special.forEach(function(str){if(!isSpecial&&(\"//\"!==label||\"jshint\"===str)&&(\" \"===body.charAt(str.length)&&body.substr(0,str.length)===str&&(isSpecial=!0,label+=str,body=body.substr(str.length)),isSpecial||\" \"!==body.charAt(0)||\" \"!==body.charAt(str.length+1)||body.substr(1,str.length)!==str||(isSpecial=!0,label=label+\" \"+str,body=body.substr(str.length+1)),isSpecial))switch(str){case\"member\":commentType=\"members\";break;case\"global\":commentType=\"globals\";break;default:var options=body.split(\":\").map(function(v){return v.replace(/^\\s+/,\"\").replace(/\\s+$/,\"\")});if(2===options.length)switch(options[0]){case\"ignore\":switch(options[1]){case\"start\":self.ignoringLinterErrors=!0,isSpecial=!1;break;case\"end\":self.ignoringLinterErrors=!1,isSpecial=!1}}commentType=str}}),{type:Token.Comment,commentType:commentType,value:value,body:body,isSpecial:isSpecial,isMultiline:opt.isMultiline||!1,isMalformed:opt.isMalformed||!1}}var ch1=this.peek(),ch2=this.peek(1),rest=this.input.substr(2),startLine=this.line,startChar=this.char,self=this;if(\"*\"===ch1&&\"/\"===ch2)return this.trigger(\"error\",{code:\"E018\",line:startLine,character:startChar}),this.skip(2),null;if(\"/\"!==ch1||\"*\"!==ch2&&\"/\"!==ch2)return null;if(\"/\"===ch2)return this.skip(this.input.length),commentToken(\"//\",rest);var body=\"\";if(\"*\"===ch2){for(this.inComment=!0,this.skip(2);\"*\"!==this.peek()||\"/\"!==this.peek(1);)if(\"\"===this.peek()){if(body+=\"\\n\",!this.nextLine())return this.trigger(\"error\",{code:\"E017\",line:startLine,character:startChar}),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0,isMalformed:!0})}else body+=this.peek(),this.skip();return this.skip(2),this.inComment=!1,commentToken(\"/*\",body,{isMultiline:!0})}},scanKeyword:function(){var result=/^[a-zA-Z_$][a-zA-Z0-9_$]*/.exec(this.input),keywords=[\"if\",\"in\",\"do\",\"var\",\"for\",\"new\",\"try\",\"let\",\"this\",\"else\",\"case\",\"void\",\"with\",\"enum\",\"while\",\"break\",\"catch\",\"throw\",\"const\",\"yield\",\"class\",\"super\",\"return\",\"typeof\",\"delete\",\"switch\",\"export\",\"import\",\"default\",\"finally\",\"extends\",\"function\",\"continue\",\"debugger\",\"instanceof\"];return result&&keywords.indexOf(result[0])>=0?{type:Token.Keyword,value:result[0]}:null},scanIdentifier:function(){function isNonAsciiIdentifierStart(code){return code>256}function isNonAsciiIdentifierPart(code){return code>256}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function removeEscapeSequences(id){return id.replace(/\\\\u([0-9a-fA-F]{4})/g,function(m0,codepoint){return String.fromCharCode(parseInt(codepoint,16))})}var type,char,id=\"\",index=0,readUnicodeEscapeSequence=function(){if(index+=1,\"u\"!==this.peek(index))return null;var code,ch1=this.peek(index+1),ch2=this.peek(index+2),ch3=this.peek(index+3),ch4=this.peek(index+4);return isHexDigit(ch1)&&isHexDigit(ch2)&&isHexDigit(ch3)&&isHexDigit(ch4)?(code=parseInt(ch1+ch2+ch3+ch4,16),asciiIdentifierPartTable[code]||isNonAsciiIdentifierPart(code)?(index+=5,\"\\\\u\"+ch1+ch2+ch3+ch4):null):null}.bind(this),getIdentifierStart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierStartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierStart(code)?(index+=1,chr):null}.bind(this),getIdentifierPart=function(){var chr=this.peek(index),code=chr.charCodeAt(0);return 92===code?readUnicodeEscapeSequence():128>code?asciiIdentifierPartTable[code]?(index+=1,chr):null:isNonAsciiIdentifierPart(code)?(index+=1,chr):null}.bind(this);if(char=getIdentifierStart(),null===char)return null;for(id=char;char=getIdentifierPart(),null!==char;)id+=char;switch(id){case\"true\":case\"false\":type=Token.BooleanLiteral;break;case\"null\":type=Token.NullLiteral;break;default:type=Token.Identifier}return{type:type,value:removeEscapeSequences(id),text:id,tokenLength:id.length}},scanNumericLiteral:function(){function isDecimalDigit(str){return/^[0-9]$/.test(str)}function isOctalDigit(str){return/^[0-7]$/.test(str)}function isBinaryDigit(str){return/^[01]$/.test(str)}function isHexDigit(str){return/^[0-9a-fA-F]$/.test(str)}function isIdentifierStart(ch){return\"$\"===ch||\"_\"===ch||\"\\\\\"===ch||ch>=\"a\"&&\"z\">=ch||ch>=\"A\"&&\"Z\">=ch}var bad,index=0,value=\"\",length=this.input.length,char=this.peek(index),isAllowedDigit=isDecimalDigit,base=10,isLegacy=!1;if(\".\"!==char&&!isDecimalDigit(char))return null;if(\".\"!==char){for(value=this.peek(index),index+=1,char=this.peek(index),\"0\"===value&&((\"x\"===char||\"X\"===char)&&(isAllowedDigit=isHexDigit,base=16,index+=1,value+=char),(\"o\"===char||\"O\"===char)&&(isAllowedDigit=isOctalDigit,base=8,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Octal integer literal\",\"6\"]}),index+=1,value+=char),(\"b\"===char||\"B\"===char)&&(isAllowedDigit=isBinaryDigit,base=2,state.inES6(!0)||this.trigger(\"warning\",{code:\"W119\",line:this.line,character:this.char,data:[\"Binary integer literal\",\"6\"]}),index+=1,value+=char),isOctalDigit(char)&&(isAllowedDigit=isOctalDigit,base=8,isLegacy=!0,bad=!1,index+=1,value+=char),!isOctalDigit(char)&&isDecimalDigit(char)&&(index+=1,value+=char));length>index;){if(char=this.peek(index),isLegacy&&isDecimalDigit(char))bad=!0;else if(!isAllowedDigit(char))break;value+=char,index+=1}if(isAllowedDigit!==isDecimalDigit)return!isLegacy&&2>=value.length?{type:Token.NumericLiteral,value:value,isMalformed:!0}:length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isLegacy:isLegacy,isMalformed:!1}}if(\".\"===char)for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1;if(\"e\"===char||\"E\"===char){if(value+=char,index+=1,char=this.peek(index),(\"+\"===char||\"-\"===char)&&(value+=this.peek(index),index+=1),char=this.peek(index),!isDecimalDigit(char))return null;for(value+=char,index+=1;length>index&&(char=this.peek(index),isDecimalDigit(char));)value+=char,index+=1}return length>index&&(char=this.peek(index),isIdentifierStart(char))?null:{type:Token.NumericLiteral,value:value,base:base,isMalformed:!isFinite(value)}},scanEscapeSequence:function(checks){var allowNewLine=!1,jump=1;this.skip();var char=this.peek();switch(char){case\"'\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\'\"]},checks,function(){return state.jsonMode});break;case\"b\":char=\"\\\\b\";break;case\"f\":char=\"\\\\f\";break;case\"n\":char=\"\\\\n\";break;case\"r\":char=\"\\\\r\";break;case\"t\":char=\"\\\\t\";break;case\"0\":char=\"\\\\0\";var n=parseInt(this.peek(1),10);this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return n>=0&&7>=n&&state.isStrict()});break;case\"u\":var hexCode=this.input.substr(1,4),code=parseInt(hexCode,16);isNaN(code)&&this.trigger(\"warning\",{code:\"W052\",line:this.line,character:this.char,data:[\"u\"+hexCode]}),char=String.fromCharCode(code),jump=5;break;case\"v\":this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\v\"]},checks,function(){return state.jsonMode}),char=\"\u000b\";break;case\"x\":var x=parseInt(this.input.substr(1,2),16);this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"\\\\x-\"]},checks,function(){return state.jsonMode}),char=String.fromCharCode(x),jump=3;break;case\"\\\\\":char=\"\\\\\\\\\";break;case'\"':char='\\\\\"';break;case\"/\":break;case\"\":allowNewLine=!0,char=\"\"}return{\"char\":char,jump:jump,allowNewLine:allowNewLine}},scanTemplateLiteral:function(checks){var tokenType,ch,value=\"\",startLine=this.line,startChar=this.char,depth=this.templateStarts.length;if(!state.inES6(!0))return null;if(\"`\"===this.peek())tokenType=Token.TemplateHead,this.templateStarts.push({line:this.line,\"char\":this.char}),depth=this.templateStarts.length,this.skip(1),this.pushContext(Context.Template);else{if(!this.inContext(Context.Template)||\"}\"!==this.peek())return null;tokenType=Token.TemplateMiddle}for(;\"`\"!==this.peek();){for(;\"\"===(ch=this.peek());)if(value+=\"\\n\",!this.nextLine()){var startPos=this.templateStarts.pop();return this.trigger(\"error\",{code:\"E052\",line:startPos.line,character:startPos.char}),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,depth:depth,context:this.popContext()}}if(\"$\"===ch&&\"{\"===this.peek(1))return value+=\"${\",this.skip(2),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.currentContext()};\nif(\"\\\\\"===ch){var escape=this.scanEscapeSequence(checks);value+=escape.char,this.skip(escape.jump)}else\"`\"!==ch&&(value+=ch,this.skip(1))}return tokenType=tokenType===Token.TemplateHead?Token.NoSubstTemplate:Token.TemplateTail,this.skip(1),this.templateStarts.pop(),{type:tokenType,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,depth:depth,context:this.popContext()}},scanStringLiteral:function(checks){var quote=this.peek();if('\"'!==quote&&\"'\"!==quote)return null;this.triggerAsync(\"warning\",{code:\"W108\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&'\"'!==quote});var value=\"\",startLine=this.line,startChar=this.char,allowNewLine=!1;for(this.skip();this.peek()!==quote;)if(\"\"===this.peek()){if(allowNewLine?(allowNewLine=!1,this.triggerAsync(\"warning\",{code:\"W043\",line:this.line,character:this.char},checks,function(){return!state.option.multistr}),this.triggerAsync(\"warning\",{code:\"W042\",line:this.line,character:this.char},checks,function(){return state.jsonMode&&state.option.multistr})):this.trigger(\"warning\",{code:\"W112\",line:this.line,character:this.char}),!this.nextLine())return this.trigger(\"error\",{code:\"E029\",line:startLine,character:startChar}),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!0,quote:quote}}else{allowNewLine=!1;var char=this.peek(),jump=1;if(\" \">char&&this.trigger(\"warning\",{code:\"W113\",line:this.line,character:this.char,data:[\"<non-printable>\"]}),\"\\\\\"===char){var parsed=this.scanEscapeSequence(checks);char=parsed.char,jump=parsed.jump,allowNewLine=parsed.allowNewLine}value+=char,this.skip(jump)}return this.skip(),{type:Token.StringLiteral,value:value,startLine:startLine,startChar:startChar,isUnclosed:!1,quote:quote}},scanRegExp:function(){var terminated,index=0,length=this.input.length,char=this.peek(),value=char,body=\"\",flags=[],malformed=!1,isCharSet=!1,scanUnexpectedChars=function(){\" \">char&&(malformed=!0,this.trigger(\"warning\",{code:\"W048\",line:this.line,character:this.char})),\"<\"===char&&(malformed=!0,this.trigger(\"warning\",{code:\"W049\",line:this.line,character:this.char,data:[char]}))}.bind(this);if(!this.prereg||\"/\"!==char)return null;for(index+=1,terminated=!1;length>index;)if(char=this.peek(index),value+=char,body+=char,isCharSet)\"]\"===char&&(\"\\\\\"!==this.peek(index-1)||\"\\\\\"===this.peek(index-2))&&(isCharSet=!1),\"\\\\\"===char&&(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars()),index+=1;else{if(\"\\\\\"===char){if(index+=1,char=this.peek(index),body+=char,value+=char,scanUnexpectedChars(),\"/\"===char){index+=1;continue}if(\"[\"===char){index+=1;continue}}if(\"[\"!==char){if(\"/\"===char){body=body.substr(0,body.length-1),terminated=!0,index+=1;break}index+=1}else isCharSet=!0,index+=1}if(!terminated)return this.trigger(\"error\",{code:\"E015\",line:this.line,character:this.from}),void this.trigger(\"fatal\",{line:this.line,from:this.from});for(;length>index&&(char=this.peek(index),/[gim]/.test(char));)flags.push(char),value+=char,index+=1;try{RegExp(body,flags.join(\"\"))}catch(err){malformed=!0,this.trigger(\"error\",{code:\"E016\",line:this.line,character:this.char,data:[err.message]})}return{type:Token.RegExp,value:value,flags:flags,isMalformed:malformed}},scanNonBreakingSpaces:function(){return state.option.nonbsp?this.input.search(/(\\u00A0)/):-1},scanUnsafeChars:function(){return this.input.search(reg.unsafeChars)},next:function(checks){this.from=this.char;var start;if(/\\s/.test(this.peek()))for(start=this.char;/\\s/.test(this.peek());)this.from+=1,this.skip();var match=this.scanComments()||this.scanStringLiteral(checks)||this.scanTemplateLiteral(checks);return match?match:(match=this.scanRegExp()||this.scanPunctuator()||this.scanKeyword()||this.scanIdentifier()||this.scanNumericLiteral(),match?(this.skip(match.tokenLength||match.value.length),match):null)},nextLine:function(){var char;if(this.line>=this.getLines().length)return!1;this.input=this.getLines()[this.line],this.line+=1,this.char=1,this.from=1;var inputTrimmed=this.input.trim(),startsWith=function(){return _.some(arguments,function(prefix){return 0===inputTrimmed.indexOf(prefix)})},endsWith=function(){return _.some(arguments,function(suffix){return-1!==inputTrimmed.indexOf(suffix,inputTrimmed.length-suffix.length)})};if(this.ignoringLinterErrors===!0&&(startsWith(\"/*\",\"//\")||this.inComment&&endsWith(\"*/\")||(this.input=\"\")),char=this.scanNonBreakingSpaces(),char>=0&&this.trigger(\"warning\",{code:\"W125\",line:this.line,character:char+1}),this.input=this.input.replace(/\\t/g,state.tab),char=this.scanUnsafeChars(),char>=0&&this.trigger(\"warning\",{code:\"W100\",line:this.line,character:char}),!this.ignoringLinterErrors&&state.option.maxlen&&state.option.maxlen<this.input.length){var inComment=this.inComment||startsWith.call(inputTrimmed,\"//\")||startsWith.call(inputTrimmed,\"/*\"),shouldTriggerError=!inComment||!reg.maxlenException.test(inputTrimmed);shouldTriggerError&&this.trigger(\"warning\",{code:\"W101\",line:this.line,character:this.input.length})}return!0},start:function(){this.nextLine()},token:function(){function isReserved(token,isProperty){if(!token.reserved)return!1;var meta=token.meta;if(meta&&meta.isFutureReservedWord&&state.inES5()){if(!meta.es5)return!1;if(meta.strictOnly&&!state.option.strict&&!state.isStrict())return!1;if(isProperty)return!1}return!0}for(var token,checks=asyncTrigger(),create=function(type,value,isProperty,token){var obj;if(\"(endline)\"!==type&&\"(end)\"!==type&&(this.prereg=!1),\"(punctuator)\"===type){switch(value){case\".\":case\")\":case\"~\":case\"#\":case\"]\":case\"++\":case\"--\":this.prereg=!1;break;default:this.prereg=!0}obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"])}return\"(identifier)\"===type&&((\"return\"===value||\"case\"===value||\"typeof\"===value)&&(this.prereg=!0),_.has(state.syntax,value)&&(obj=Object.create(state.syntax[value]||state.syntax[\"(error)\"]),isReserved(obj,isProperty&&\"(identifier)\"===type)||(obj=null))),obj||(obj=Object.create(state.syntax[type])),obj.identifier=\"(identifier)\"===type,obj.type=obj.type||type,obj.value=value,obj.line=this.line,obj.character=this.char,obj.from=this.from,obj.identifier&&token&&(obj.raw_text=token.text||token.value),token&&token.startLine&&token.startLine!==this.line&&(obj.startLine=token.startLine),token&&token.context&&(obj.context=token.context),token&&token.depth&&(obj.depth=token.depth),token&&token.isUnclosed&&(obj.isUnclosed=token.isUnclosed),isProperty&&obj.identifier&&(obj.isProperty=isProperty),obj.check=checks.check,obj}.bind(this);;){if(!this.input.length)return this.nextLine()?create(\"(endline)\",\"\"):this.exhausted?null:(this.exhausted=!0,create(\"(end)\",\"\"));if(token=this.next(checks))switch(token.type){case Token.StringLiteral:return this.triggerAsync(\"String\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value,quote:token.quote},checks,function(){return!0}),create(\"(string)\",token.value,null,token);case Token.TemplateHead:return this.trigger(\"TemplateHead\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template)\",token.value,null,token);case Token.TemplateMiddle:return this.trigger(\"TemplateMiddle\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template middle)\",token.value,null,token);case Token.TemplateTail:return this.trigger(\"TemplateTail\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(template tail)\",token.value,null,token);case Token.NoSubstTemplate:return this.trigger(\"NoSubstTemplate\",{line:this.line,\"char\":this.char,from:this.from,startLine:token.startLine,startChar:token.startChar,value:token.value}),create(\"(no subst template)\",token.value,null,token);case Token.Identifier:this.triggerAsync(\"Identifier\",{line:this.line,\"char\":this.char,from:this.form,name:token.value,raw_name:token.text,isProperty:\".\"===state.tokens.curr.id},checks,function(){return!0});case Token.Keyword:case Token.NullLiteral:case Token.BooleanLiteral:return create(\"(identifier)\",token.value,\".\"===state.tokens.curr.id,token);case Token.NumericLiteral:return token.isMalformed&&this.trigger(\"warning\",{code:\"W045\",line:this.line,character:this.char,data:[token.value]}),this.triggerAsync(\"warning\",{code:\"W114\",line:this.line,character:this.char,data:[\"0x-\"]},checks,function(){return 16===token.base&&state.jsonMode}),this.triggerAsync(\"warning\",{code:\"W115\",line:this.line,character:this.char},checks,function(){return state.isStrict()&&8===token.base&&token.isLegacy}),this.trigger(\"Number\",{line:this.line,\"char\":this.char,from:this.from,value:token.value,base:token.base,isMalformed:token.malformed}),create(\"(number)\",token.value);case Token.RegExp:return create(\"(regexp)\",token.value);case Token.Comment:if(state.tokens.curr.comment=!0,token.isSpecial)return{id:\"(comment)\",value:token.value,body:token.body,type:token.commentType,isSpecial:token.isSpecial,line:this.line,character:this.char,from:this.from};break;case\"\":break;default:return create(\"(punctuator)\",token.value)}else this.input.length&&(this.trigger(\"error\",{code:\"E024\",line:this.line,character:this.char,data:[this.peek()]}),this.input=\"\")}}},exports.Lexer=Lexer,exports.Context=Context},{\"../data/ascii-identifier-data.js\":\"/node_modules/jshint/data/ascii-identifier-data.js\",\"../lodash\":\"/node_modules/jshint/lodash.js\",\"./reg.js\":\"/node_modules/jshint/src/reg.js\",\"./state.js\":\"/node_modules/jshint/src/state.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/messages.js\":[function(_dereq_,module,exports){\"use strict\";var _=_dereq_(\"../lodash\"),errors={E001:\"Bad option: '{a}'.\",E002:\"Bad option value.\",E003:\"Expected a JSON value.\",E004:\"Input is neither a string nor an array of strings.\",E005:\"Input is empty.\",E006:\"Unexpected early end of program.\",E007:'Missing \"use strict\" statement.',E008:\"Strict violation.\",E009:\"Option 'validthis' can't be used in a global scope.\",E010:\"'with' is not allowed in strict mode.\",E011:\"'{a}' has already been declared.\",E012:\"const '{a}' is initialized to 'undefined'.\",E013:\"Attempting to override '{a}' which is a constant.\",E014:\"A regular expression literal can be confused with '/='.\",E015:\"Unclosed regular expression.\",E016:\"Invalid regular expression.\",E017:\"Unclosed comment.\",E018:\"Unbegun comment.\",E019:\"Unmatched '{a}'.\",E020:\"Expected '{a}' to match '{b}' from line {c} and instead saw '{d}'.\",E021:\"Expected '{a}' and instead saw '{b}'.\",E022:\"Line breaking error '{a}'.\",E023:\"Missing '{a}'.\",E024:\"Unexpected '{a}'.\",E025:\"Missing ':' on a case clause.\",E026:\"Missing '}' to match '{' from line {a}.\",E027:\"Missing ']' to match '[' from line {a}.\",E028:\"Illegal comma.\",E029:\"Unclosed string.\",E030:\"Expected an identifier and instead saw '{a}'.\",E031:\"Bad assignment.\",E032:\"Expected a small integer or 'false' and instead saw '{a}'.\",E033:\"Expected an operator and instead saw '{a}'.\",E034:\"get/set are ES5 features.\",E035:\"Missing property name.\",E036:\"Expected to see a statement and instead saw a block.\",E037:null,E038:null,E039:\"Function declarations are not invocable. Wrap the whole function invocation in parens.\",E040:\"Each value should have its own case label.\",E041:\"Unrecoverable syntax error.\",E042:\"Stopping.\",E043:\"Too many errors.\",E044:null,E045:\"Invalid for each loop.\",E046:\"A yield statement shall be within a generator function (with syntax: `function*`)\",E047:null,E048:\"{a} declaration not directly within block.\",E049:\"A {a} cannot be named '{b}'.\",E050:\"Mozilla acequires the yield expression to be parenthesized here.\",E051:null,E052:\"Unclosed template literal.\",E053:\"Export declaration must be in global scope.\",E054:\"Class properties must be methods. Expected '(' but instead saw '{a}'.\",E055:\"The '{a}' option cannot be set after any executable code.\",E056:\"'{a}' was used before it was declared, which is illegal for '{b}' variables.\",E057:\"Invalid meta property: '{a}.{b}'.\",E058:\"Missing semicolon.\"},warnings={W001:\"'hasOwnProperty' is a really bad name.\",W002:\"Value of '{a}' may be overwritten in IE 8 and earlier.\",W003:\"'{a}' was used before it was defined.\",W004:\"'{a}' is already defined.\",W005:\"A dot following a number can be confused with a decimal point.\",W006:\"Confusing minuses.\",W007:\"Confusing plusses.\",W008:\"A leading decimal point can be confused with a dot: '{a}'.\",W009:\"The array literal notation [] is preferable.\",W010:\"The object literal notation {} is preferable.\",W011:null,W012:null,W013:null,W014:\"Bad line breaking before '{a}'.\",W015:null,W016:\"Unexpected use of '{a}'.\",W017:\"Bad operand.\",W018:\"Confusing use of '{a}'.\",W019:\"Use the isNaN function to compare with NaN.\",W020:\"Read only.\",W021:\"Reassignment of '{a}', which is is a {b}. Use 'var' or 'let' to declare bindings that may change.\",W022:\"Do not assign to the exception parameter.\",W023:\"Expected an identifier in an assignment and instead saw a function invocation.\",W024:\"Expected an identifier and instead saw '{a}' (a reserved word).\",W025:\"Missing name in function declaration.\",W026:\"Inner functions should be listed at the top of the outer function.\",W027:\"Unreachable '{a}' after '{b}'.\",W028:\"Label '{a}' on {b} statement.\",W030:\"Expected an assignment or function call and instead saw an expression.\",W031:\"Do not use 'new' for side effects.\",W032:\"Unnecessary semicolon.\",W033:\"Missing semicolon.\",W034:'Unnecessary directive \"{a}\".',W035:\"Empty block.\",W036:\"Unexpected /*member '{a}'.\",W037:\"'{a}' is a statement label.\",W038:\"'{a}' used out of scope.\",W039:\"'{a}' is not allowed.\",W040:\"Possible strict violation.\",W041:\"Use '{a}' to compare with '{b}'.\",W042:\"Avoid EOL escaping.\",W043:\"Bad escaping of EOL. Use option multistr if needed.\",W044:\"Bad or unnecessary escaping.\",W045:\"Bad number '{a}'.\",W046:\"Don't use extra leading zeros '{a}'.\",W047:\"A trailing decimal point can be confused with a dot: '{a}'.\",W048:\"Unexpected control character in regular expression.\",W049:\"Unexpected escaped character '{a}' in regular expression.\",W050:\"JavaScript URL.\",W051:\"Variables should not be deleted.\",W052:\"Unexpected '{a}'.\",W053:\"Do not use {a} as a constructor.\",W054:\"The Function constructor is a form of eval.\",W055:\"A constructor name should start with an uppercase letter.\",W056:\"Bad constructor.\",W057:\"Weird construction. Is 'new' necessary?\",W058:\"Missing '()' invoking a constructor.\",W059:\"Avoid arguments.{a}.\",W060:\"document.write can be a form of eval.\",W061:\"eval can be harmful.\",W062:\"Wrap an immediate function invocation in parens to assist the reader in understanding that the expression is the result of a function, and not the function itself.\",W063:\"Math is not a function.\",W064:\"Missing 'new' prefix when invoking a constructor.\",W065:\"Missing radix parameter.\",W066:\"Implied eval. Consider passing a function instead of a string.\",W067:\"Bad invocation.\",W068:\"Wrapping non-IIFE function literals in parens is unnecessary.\",W069:\"['{a}'] is better written in dot notation.\",W070:\"Extra comma. (it breaks older versions of IE)\",W071:\"This function has too many statements. ({a})\",W072:\"This function has too many parameters. ({a})\",W073:\"Blocks are nested too deeply. ({a})\",W074:\"This function's cyclomatic complexity is too high. ({a})\",W075:\"Duplicate {a} '{b}'.\",W076:\"Unexpected parameter '{a}' in get {b} function.\",W077:\"Expected a single parameter in set {a} function.\",W078:\"Setter is defined without getter.\",W079:\"Redefinition of '{a}'.\",W080:\"It's not necessary to initialize '{a}' to 'undefined'.\",W081:null,W082:\"Function declarations should not be placed in blocks. Use a function expression or move the statement to the top of the outer function.\",W083:\"Don't make functions within a loop.\",W084:\"Assignment in conditional expression\",W085:\"Don't use 'with'.\",W086:\"Expected a 'break' statement before '{a}'.\",W087:\"Forgotten 'debugger' statement?\",W088:\"Creating global 'for' variable. Should be 'for (var {a} ...'.\",W089:\"The body of a for in should be wrapped in an if statement to filter unwanted properties from the prototype.\",W090:\"'{a}' is not a statement label.\",W091:null,W093:\"Did you mean to return a conditional instead of an assignment?\",W094:\"Unexpected comma.\",W095:\"Expected a string and instead saw {a}.\",W096:\"The '{a}' key may produce unexpected results.\",W097:'Use the function form of \"use strict\".',W098:\"'{a}' is defined but never used.\",W099:null,W100:\"This character may get silently deleted by one or more browsers.\",W101:\"Line is too long.\",W102:null,W103:\"The '{a}' property is deprecated.\",W104:\"'{a}' is available in ES{b} (use 'esversion: {b}') or Mozilla JS extensions (use moz).\",W105:\"Unexpected {a} in '{b}'.\",W106:\"Identifier '{a}' is not in camel case.\",W107:\"Script URL.\",W108:\"Strings must use doublequote.\",W109:\"Strings must use singlequote.\",W110:\"Mixed double and single quotes.\",W112:\"Unclosed string.\",W113:\"Control character in string: {a}.\",W114:\"Avoid {a}.\",W115:\"Octal literals are not allowed in strict mode.\",W116:\"Expected '{a}' and instead saw '{b}'.\",W117:\"'{a}' is not defined.\",W118:\"'{a}' is only available in Mozilla JavaScript extensions (use moz option).\",W119:\"'{a}' is only available in ES{b} (use 'esversion: {b}').\",W120:\"You might be leaking a variable ({a}) here.\",W121:\"Extending prototype of native object: '{a}'.\",W122:\"Invalid typeof value '{a}'\",W123:\"'{a}' is already defined in outer scope.\",W124:\"A generator function shall contain a yield statement.\",W125:\"This line contains non-breaking spaces: http://jshint.com/doc/options/#nonbsp\",W126:\"Unnecessary grouping operator.\",W127:\"Unexpected use of a comma operator.\",W128:\"Empty array elements acequire elision=true.\",W129:\"'{a}' is defined in a future version of JavaScript. Use a different variable name to avoid migration issues.\",W130:\"Invalid element after rest element.\",W131:\"Invalid parameter after rest parameter.\",W132:\"`var` declarations are forbidden. Use `let` or `const` instead.\",W133:\"Invalid for-{a} loop left-hand-side: {b}.\",W134:\"The '{a}' option is only available when linting ECMAScript {b} code.\",W135:\"{a} may not be supported by non-browser environments.\",W136:\"'{a}' must be in function scope.\",W137:\"Empty destructuring.\",W138:\"Regular parameters should not come after default parameters.\"},info={I001:\"Comma warnings can be turned off with 'laxcomma'.\",I002:null,I003:\"ES5 option is now set per default\"};exports.errors={},exports.warnings={},exports.info={},_.each(errors,function(desc,code){exports.errors[code]={code:code,desc:desc}}),_.each(warnings,function(desc,code){exports.warnings[code]={code:code,desc:desc}}),_.each(info,function(desc,code){exports.info[code]={code:code,desc:desc}})},{\"../lodash\":\"/node_modules/jshint/lodash.js\"}],\"/node_modules/jshint/src/name-stack.js\":[function(_dereq_,module){\"use strict\";function NameStack(){this._stack=[]}Object.defineProperty(NameStack.prototype,\"length\",{get:function(){return this._stack.length}}),NameStack.prototype.push=function(){this._stack.push(null)},NameStack.prototype.pop=function(){this._stack.pop()},NameStack.prototype.set=function(token){this._stack[this.length-1]=token},NameStack.prototype.infer=function(){var type,nameToken=this._stack[this.length-1],prefix=\"\";return nameToken&&\"class\"!==nameToken.type||(nameToken=this._stack[this.length-2]),nameToken?(type=nameToken.type,\"(string)\"!==type&&\"(number)\"!==type&&\"(identifier)\"!==type&&\"default\"!==type?\"(expression)\":(nameToken.accessorType&&(prefix=nameToken.accessorType+\" \"),prefix+nameToken.value)):\"(empty)\"},module.exports=NameStack},{}],\"/node_modules/jshint/src/options.js\":[function(_dereq_,module,exports){\"use strict\";exports.bool={enforcing:{bitwise:!0,freeze:!0,camelcase:!0,curly:!0,eqeqeq:!0,futurehostile:!0,notypeof:!0,es3:!0,es5:!0,forin:!0,funcscope:!0,immed:!0,iterator:!0,newcap:!0,noarg:!0,nocomma:!0,noempty:!0,nonbsp:!0,nonew:!0,undef:!0,singleGroups:!1,varstmt:!1,enforceall:!1},relaxing:{asi:!0,multistr:!0,debug:!0,boss:!0,evil:!0,globalstrict:!0,plusplus:!0,proto:!0,scripturl:!0,sub:!0,supernew:!0,laxbreak:!0,laxcomma:!0,validthis:!0,withstmt:!0,moz:!0,noyield:!0,eqnull:!0,lastsemic:!0,loopfunc:!0,expr:!0,esnext:!0,elision:!0},environments:{mootools:!0,couch:!0,jasmine:!0,jquery:!0,node:!0,qunit:!0,rhino:!0,shelljs:!0,prototypejs:!0,yui:!0,mocha:!0,module:!0,wsh:!0,worker:!0,nonstandard:!0,browser:!0,browserify:!0,devel:!0,dojo:!0,typed:!0,phantom:!0},obsolete:{onecase:!0,regexp:!0,regexdash:!0}},exports.val={maxlen:!1,indent:!1,maxerr:!1,predef:!1,globals:!1,quotmark:!1,scope:!1,maxstatements:!1,maxdepth:!1,maxparams:!1,maxcomplexity:!1,shadow:!1,strict:!0,unused:!0,latedef:!1,ignore:!1,ignoreDelimiters:!1,esversion:5},exports.inverted={bitwise:!0,forin:!0,newcap:!0,plusplus:!0,regexp:!0,undef:!0,eqeqeq:!0,strict:!0},exports.validNames=Object.keys(exports.val).concat(Object.keys(exports.bool.relaxing)).concat(Object.keys(exports.bool.enforcing)).concat(Object.keys(exports.bool.obsolete)).concat(Object.keys(exports.bool.environments)),exports.renamed={eqeq:\"eqeqeq\",windows:\"wsh\",sloppy:\"strict\"},exports.removed={nomen:!0,onevar:!0,passfail:!0,white:!0,gcl:!0,smarttabs:!0,trailing:!0},exports.noenforceall={varstmt:!0,strict:!0}},{}],\"/node_modules/jshint/src/reg.js\":[function(_dereq_,module,exports){\"use strict\";exports.unsafeString=/@cc|<\\/?|script|\\]\\s*\\]|<\\s*!|&lt/i,exports.unsafeChars=/[\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEsc=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/,exports.needEscGlobal=/[\\u0000-\\u001f&<\"\\/\\\\\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g,exports.starSlash=/\\*\\//,exports.identifier=/^([a-zA-Z_$][a-zA-Z0-9_$]*)$/,exports.javascriptURL=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i,exports.fallsThrough=/^\\s*falls?\\sthrough\\s*$/,exports.maxlenException=/^(?:(?:\\/\\/|\\/\\*|\\*) ?)?[^ ]+$/},{}],\"/node_modules/jshint/src/scope-manager.js\":[function(_dereq_,module){\"use strict\";var _=_dereq_(\"../lodash\"),events=_dereq_(\"events\"),marker={},scopeManager=function(state,predefined,exported,declared){function _newScope(type){_current={\"(labels)\":Object.create(null),\"(usages)\":Object.create(null),\"(breakLabels)\":Object.create(null),\"(parent)\":_current,\"(type)\":type,\"(params)\":\"functionparams\"===type||\"catchparams\"===type?[]:null},_scopeStack.push(_current)}function warning(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function error(code,token){emitter.emit(\"warning\",{code:code,token:token,data:_.slice(arguments,2)})}function _setupUsages(labelName){_current[\"(usages)\"][labelName]||(_current[\"(usages)\"][labelName]={\"(modified)\":[],\"(reassigned)\":[],\"(tokens)\":[]})}function _checkForUnused(){if(\"functionparams\"===_current[\"(type)\"])return _checkParams(),void 0;var curentLabels=_current[\"(labels)\"];for(var labelName in curentLabels)curentLabels[labelName]&&\"exception\"!==curentLabels[labelName][\"(type)\"]&&curentLabels[labelName][\"(unused)\"]&&_warnUnused(labelName,curentLabels[labelName][\"(token)\"],\"var\")}function _checkParams(){var params=_current[\"(params)\"];if(params)for(var unused_opt,param=params.pop();param;){var label=_current[\"(labels)\"][param];if(unused_opt=_getUnusedOption(state.funct[\"(unusedOption)\"]),\"undefined\"===param)return;if(label[\"(unused)\"])_warnUnused(param,label[\"(token)\"],\"param\",state.funct[\"(unusedOption)\"]);else if(\"last-param\"===unused_opt)return;param=params.pop()}}function _getLabel(labelName){for(var i=_scopeStack.length-1;i>=0;--i){var scopeLabels=_scopeStack[i][\"(labels)\"];if(scopeLabels[labelName])return scopeLabels}}function usedSoFarInCurrentFunction(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(usages)\"][labelName])return current[\"(usages)\"][labelName];if(current===_currentFunctBody)break}return!1}function _checkOuterShadow(labelName,token){if(\"outer\"===state.option.shadow)for(var isGlobal=\"global\"===_currentFunctBody[\"(type)\"],isNewFunction=\"functionparams\"===_current[\"(type)\"],outsideCurrentFunction=!isGlobal,i=0;_scopeStack.length>i;i++){var stackItem=_scopeStack[i];isNewFunction||_scopeStack[i+1]!==_currentFunctBody||(outsideCurrentFunction=!1),outsideCurrentFunction&&stackItem[\"(labels)\"][labelName]&&warning(\"W123\",token,labelName),stackItem[\"(breakLabels)\"][labelName]&&warning(\"W123\",token,labelName)}}function _latedefWarning(type,labelName,token){state.option.latedef&&(state.option.latedef===!0&&\"function\"===type||\"function\"!==type)&&warning(\"W003\",token,labelName)}var _current,_scopeStack=[];_newScope(\"global\"),_current[\"(predefined)\"]=predefined;var _currentFunctBody=_current,usedPredefinedAndGlobals=Object.create(null),impliedGlobals=Object.create(null),unuseds=[],emitter=new events.EventEmitter,_getUnusedOption=function(unused_opt){return void 0===unused_opt&&(unused_opt=state.option.unused),unused_opt===!0&&(unused_opt=\"last-param\"),unused_opt},_warnUnused=function(name,tkn,type,unused_opt){var line=tkn.line,chr=tkn.from,raw_name=tkn.raw_text||name;unused_opt=_getUnusedOption(unused_opt);var warnable_types={vars:[\"var\"],\"last-param\":[\"var\",\"param\"],strict:[\"var\",\"param\",\"last-param\"]};unused_opt&&warnable_types[unused_opt]&&-1!==warnable_types[unused_opt].indexOf(type)&&warning(\"W098\",{line:line,from:chr},raw_name),(unused_opt||\"var\"===type)&&unuseds.push({name:name,line:line,character:chr})},scopeManagerInst={on:function(names,listener){names.split(\" \").forEach(function(name){emitter.on(name,listener)})},isPredefined:function(labelName){return!this.has(labelName)&&_.has(_scopeStack[0][\"(predefined)\"],labelName)},stack:function(type){var previousScope=_current;_newScope(type),type||\"functionparams\"!==previousScope[\"(type)\"]||(_current[\"(isFuncBody)\"]=!0,_current[\"(context)\"]=_currentFunctBody,_currentFunctBody=_current)},unstack:function(){var i,j,subScope=_scopeStack.length>1?_scopeStack[_scopeStack.length-2]:null,isUnstackingFunctionBody=_current===_currentFunctBody,isUnstackingFunctionParams=\"functionparams\"===_current[\"(type)\"],isUnstackingFunctionOuter=\"functionouter\"===_current[\"(type)\"],currentUsages=_current[\"(usages)\"],currentLabels=_current[\"(labels)\"],usedLabelNameList=Object.keys(currentUsages);for(currentUsages.__proto__&&-1===usedLabelNameList.indexOf(\"__proto__\")&&usedLabelNameList.push(\"__proto__\"),i=0;usedLabelNameList.length>i;i++){var usedLabelName=usedLabelNameList[i],usage=currentUsages[usedLabelName],usedLabel=currentLabels[usedLabelName];if(usedLabel){var usedLabelType=usedLabel[\"(type)\"];if(usedLabel[\"(useOutsideOfScope)\"]&&!state.option.funcscope){var usedTokens=usage[\"(tokens)\"];if(usedTokens)for(j=0;usedTokens.length>j;j++)usedLabel[\"(function)\"]===usedTokens[j][\"(function)\"]&&error(\"W038\",usedTokens[j],usedLabelName)}if(_current[\"(labels)\"][usedLabelName][\"(unused)\"]=!1,\"const\"===usedLabelType&&usage[\"(modified)\"])for(j=0;usage[\"(modified)\"].length>j;j++)error(\"E013\",usage[\"(modified)\"][j],usedLabelName);if((\"function\"===usedLabelType||\"class\"===usedLabelType)&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)error(\"W021\",usage[\"(reassigned)\"][j],usedLabelName,usedLabelType)}else if(isUnstackingFunctionOuter&&(state.funct[\"(isCapturing)\"]=!0),subScope)if(subScope[\"(usages)\"][usedLabelName]){var subScopeUsage=subScope[\"(usages)\"][usedLabelName];subScopeUsage[\"(modified)\"]=subScopeUsage[\"(modified)\"].concat(usage[\"(modified)\"]),subScopeUsage[\"(tokens)\"]=subScopeUsage[\"(tokens)\"].concat(usage[\"(tokens)\"]),subScopeUsage[\"(reassigned)\"]=subScopeUsage[\"(reassigned)\"].concat(usage[\"(reassigned)\"]),subScopeUsage[\"(onlyUsedSubFunction)\"]=!1}else subScope[\"(usages)\"][usedLabelName]=usage,isUnstackingFunctionBody&&(subScope[\"(usages)\"][usedLabelName][\"(onlyUsedSubFunction)\"]=!0);else if(\"boolean\"==typeof _current[\"(predefined)\"][usedLabelName]){if(delete declared[usedLabelName],usedPredefinedAndGlobals[usedLabelName]=marker,_current[\"(predefined)\"][usedLabelName]===!1&&usage[\"(reassigned)\"])for(j=0;usage[\"(reassigned)\"].length>j;j++)warning(\"W020\",usage[\"(reassigned)\"][j])}else if(usage[\"(tokens)\"])for(j=0;usage[\"(tokens)\"].length>j;j++){var undefinedToken=usage[\"(tokens)\"][j];undefinedToken.forgiveUndef||(state.option.undef&&!undefinedToken.ignoreUndef&&warning(\"W117\",undefinedToken,usedLabelName),impliedGlobals[usedLabelName]?impliedGlobals[usedLabelName].line.push(undefinedToken.line):impliedGlobals[usedLabelName]={name:usedLabelName,line:[undefinedToken.line]})}}if(subScope||Object.keys(declared).forEach(function(labelNotUsed){_warnUnused(labelNotUsed,declared[labelNotUsed],\"var\")}),subScope&&!isUnstackingFunctionBody&&!isUnstackingFunctionParams&&!isUnstackingFunctionOuter){var labelNames=Object.keys(currentLabels);for(i=0;labelNames.length>i;i++){var defLabelName=labelNames[i];currentLabels[defLabelName][\"(blockscoped)\"]||\"exception\"===currentLabels[defLabelName][\"(type)\"]||this.funct.has(defLabelName,{excludeCurrent:!0})||(subScope[\"(labels)\"][defLabelName]=currentLabels[defLabelName],\"global\"!==_currentFunctBody[\"(type)\"]&&(subScope[\"(labels)\"][defLabelName][\"(useOutsideOfScope)\"]=!0),delete currentLabels[defLabelName])}}_checkForUnused(),_scopeStack.pop(),isUnstackingFunctionBody&&(_currentFunctBody=_scopeStack[_.findLastIndex(_scopeStack,function(scope){return scope[\"(isFuncBody)\"]||\"global\"===scope[\"(type)\"]})]),_current=subScope},addParam:function(labelName,token,type){if(type=type||\"param\",\"exception\"===type){var previouslyDefinedLabelType=this.funct.labeltype(labelName);previouslyDefinedLabelType&&\"exception\"!==previouslyDefinedLabelType&&(state.option.node||warning(\"W002\",state.tokens.next,labelName))}if(_.has(_current[\"(labels)\"],labelName)?_current[\"(labels)\"][labelName].duplicated=!0:(_checkOuterShadow(labelName,token,type),_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":token,\"(unused)\":!0},_current[\"(params)\"].push(labelName)),_.has(_current[\"(usages)\"],labelName)){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}},validateParams:function(){if(\"global\"!==_currentFunctBody[\"(type)\"]){var isStrict=state.isStrict(),currentFunctParamScope=_currentFunctBody[\"(parent)\"];currentFunctParamScope[\"(params)\"]&&currentFunctParamScope[\"(params)\"].forEach(function(labelName){var label=currentFunctParamScope[\"(labels)\"][labelName];label&&label.duplicated&&(isStrict?warning(\"E011\",label[\"(token)\"],labelName):state.option.shadow!==!0&&warning(\"W004\",label[\"(token)\"],labelName))})}},getUsedOrDefinedGlobals:function(){var list=Object.keys(usedPredefinedAndGlobals);return usedPredefinedAndGlobals.__proto__===marker&&-1===list.indexOf(\"__proto__\")&&list.push(\"__proto__\"),list},getImpliedGlobals:function(){var values=_.values(impliedGlobals),hasProto=!1;return impliedGlobals.__proto__&&(hasProto=values.some(function(value){return\"__proto__\"===value.name}),hasProto||values.push(impliedGlobals.__proto__)),values},getUnuseds:function(){return unuseds},has:function(labelName){return Boolean(_getLabel(labelName))},labeltype:function(labelName){var scopeLabels=_getLabel(labelName);return scopeLabels?scopeLabels[labelName][\"(type)\"]:null},addExported:function(labelName){var globalLabels=_scopeStack[0][\"(labels)\"];if(_.has(declared,labelName))delete declared[labelName];else if(_.has(globalLabels,labelName))globalLabels[labelName][\"(unused)\"]=!1;else{for(var i=1;_scopeStack.length>i;i++){var scope=_scopeStack[i];if(scope[\"(type)\"])break;if(_.has(scope[\"(labels)\"],labelName)&&!scope[\"(labels)\"][labelName][\"(blockscoped)\"])return scope[\"(labels)\"][labelName][\"(unused)\"]=!1,void 0}exported[labelName]=!0}},setExported:function(labelName,token){this.block.use(labelName,token)\n},addlabel:function(labelName,opts){var type=opts.type,token=opts.token,isblockscoped=\"let\"===type||\"const\"===type||\"class\"===type,isexported=\"global\"===(isblockscoped?_current:_currentFunctBody)[\"(type)\"]&&_.has(exported,labelName);if(_checkOuterShadow(labelName,token,type),isblockscoped){var declaredInCurrentScope=_current[\"(labels)\"][labelName];if(declaredInCurrentScope||_current!==_currentFunctBody||\"global\"===_current[\"(type)\"]||(declaredInCurrentScope=!!_currentFunctBody[\"(parent)\"][\"(labels)\"][labelName]),!declaredInCurrentScope&&_current[\"(usages)\"][labelName]){var usage=_current[\"(usages)\"][labelName];usage[\"(onlyUsedSubFunction)\"]?_latedefWarning(type,labelName,token):warning(\"E056\",token,labelName,type)}declaredInCurrentScope?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&scopeManagerInst.funct.has(labelName)&&warning(\"W004\",token,labelName),scopeManagerInst.block.add(labelName,type,token,!isexported)}else{var declaredInCurrentFunctionScope=scopeManagerInst.funct.has(labelName);!declaredInCurrentFunctionScope&&usedSoFarInCurrentFunction(labelName)&&_latedefWarning(type,labelName,token),scopeManagerInst.funct.has(labelName,{onlyBlockscoped:!0})?warning(\"E011\",token,labelName):state.option.shadow!==!0&&declaredInCurrentFunctionScope&&\"__proto__\"!==labelName&&\"global\"!==_currentFunctBody[\"(type)\"]&&warning(\"W004\",token,labelName),scopeManagerInst.funct.add(labelName,type,token,!isexported),\"global\"===_currentFunctBody[\"(type)\"]&&(usedPredefinedAndGlobals[labelName]=marker)}},funct:{labeltype:function(labelName,options){for(var onlyBlockscoped=options&&options.onlyBlockscoped,excludeParams=options&&options.excludeParams,currentScopeIndex=_scopeStack.length-(options&&options.excludeCurrent?2:1),i=currentScopeIndex;i>=0;i--){var current=_scopeStack[i];if(current[\"(labels)\"][labelName]&&(!onlyBlockscoped||current[\"(labels)\"][labelName][\"(blockscoped)\"]))return current[\"(labels)\"][labelName][\"(type)\"];var scopeCheck=excludeParams?_scopeStack[i-1]:current;if(scopeCheck&&\"functionparams\"===scopeCheck[\"(type)\"])return null}return null},hasBreakLabel:function(labelName){for(var i=_scopeStack.length-1;i>=0;i--){var current=_scopeStack[i];if(current[\"(breakLabels)\"][labelName])return!0;if(\"functionparams\"===current[\"(type)\"])return!1}return!1},has:function(labelName,options){return Boolean(this.labeltype(labelName,options))},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!1,\"(function)\":_currentFunctBody,\"(unused)\":unused}}},block:{isGlobal:function(){return\"global\"===_current[\"(type)\"]},use:function(labelName,token){var paramScope=_currentFunctBody[\"(parent)\"];paramScope&&paramScope[\"(labels)\"][labelName]&&\"param\"===paramScope[\"(labels)\"][labelName][\"(type)\"]&&(scopeManagerInst.funct.has(labelName,{excludeParams:!0,onlyBlockscoped:!0})||(paramScope[\"(labels)\"][labelName][\"(unused)\"]=!1)),token&&(state.ignored.W117||state.option.undef===!1)&&(token.ignoreUndef=!0),_setupUsages(labelName),token&&(token[\"(function)\"]=_currentFunctBody,_current[\"(usages)\"][labelName][\"(tokens)\"].push(token))},reassign:function(labelName,token){this.modify(labelName,token),_current[\"(usages)\"][labelName][\"(reassigned)\"].push(token)},modify:function(labelName,token){_setupUsages(labelName),_current[\"(usages)\"][labelName][\"(modified)\"].push(token)},add:function(labelName,type,tok,unused){_current[\"(labels)\"][labelName]={\"(type)\":type,\"(token)\":tok,\"(blockscoped)\":!0,\"(unused)\":unused}},addBreakLabel:function(labelName,opts){var token=opts.token;scopeManagerInst.funct.hasBreakLabel(labelName)?warning(\"E011\",token,labelName):\"outer\"===state.option.shadow&&(scopeManagerInst.funct.has(labelName)?warning(\"W004\",token,labelName):_checkOuterShadow(labelName,token)),_current[\"(breakLabels)\"][labelName]=token}}};return scopeManagerInst};module.exports=scopeManager},{\"../lodash\":\"/node_modules/jshint/lodash.js\",events:\"/node_modules/browserify/node_modules/events/events.js\"}],\"/node_modules/jshint/src/state.js\":[function(_dereq_,module,exports){\"use strict\";var NameStack=_dereq_(\"./name-stack.js\"),state={syntax:{},isStrict:function(){return this.directive[\"use strict\"]||this.inClassBody||this.option.module||\"implied\"===this.option.strict},inMoz:function(){return this.option.moz},inES6:function(){return this.option.moz||this.option.esversion>=6},inES5:function(strict){return strict?!(this.option.esversion&&5!==this.option.esversion||this.option.moz):!this.option.esversion||this.option.esversion>=5||this.option.moz},reset:function(){this.tokens={prev:null,next:null,curr:null},this.option={},this.funct=null,this.ignored={},this.directive={},this.jsonMode=!1,this.jsonWarnings=[],this.lines=[],this.tab=\"\",this.cache={},this.ignoredLines={},this.forinifcheckneeded=!1,this.nameStack=new NameStack,this.inClassBody=!1}};exports.state=state},{\"./name-stack.js\":\"/node_modules/jshint/src/name-stack.js\"}],\"/node_modules/jshint/src/style.js\":[function(_dereq_,module,exports){\"use strict\";exports.register=function(linter){linter.on(\"Identifier\",function(data){linter.getOption(\"proto\")||\"__proto__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name,\"6\"]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"iterator\")||\"__iterator__\"===data.name&&linter.warn(\"W103\",{line:data.line,\"char\":data.char,data:[data.name]})}),linter.on(\"Identifier\",function(data){linter.getOption(\"camelcase\")&&data.name.replace(/^_+|_+$/g,\"\").indexOf(\"_\")>-1&&!data.name.match(/^[A-Z0-9_]*$/)&&linter.warn(\"W106\",{line:data.line,\"char\":data.from,data:[data.name]})}),linter.on(\"String\",function(data){var code,quotmark=linter.getOption(\"quotmark\");quotmark&&(\"single\"===quotmark&&\"'\"!==data.quote&&(code=\"W109\"),\"double\"===quotmark&&'\"'!==data.quote&&(code=\"W108\"),quotmark===!0&&(linter.getCache(\"quotmark\")||linter.setCache(\"quotmark\",data.quote),linter.getCache(\"quotmark\")!==data.quote&&(code=\"W110\")),code&&linter.warn(code,{line:data.line,\"char\":data.char}))}),linter.on(\"Number\",function(data){\".\"===data.value.charAt(0)&&linter.warn(\"W008\",{line:data.line,\"char\":data.char,data:[data.value]}),\".\"===data.value.substr(data.value.length-1)&&linter.warn(\"W047\",{line:data.line,\"char\":data.char,data:[data.value]}),/^00+/.test(data.value)&&linter.warn(\"W046\",{line:data.line,\"char\":data.char,data:[data.value]})}),linter.on(\"String\",function(data){var re=/^(?:javascript|jscript|ecmascript|vbscript|livescript)\\s*:/i;linter.getOption(\"scripturl\")||re.test(data.value)&&linter.warn(\"W107\",{line:data.line,\"char\":data.char})})}},{}],\"/node_modules/jshint/src/vars.js\":[function(_dereq_,module,exports){\"use strict\";exports.reservedVars={arguments:!1,NaN:!1},exports.ecmaIdentifiers={3:{Array:!1,Boolean:!1,Date:!1,decodeURI:!1,decodeURIComponent:!1,encodeURI:!1,encodeURIComponent:!1,Error:!1,eval:!1,EvalError:!1,Function:!1,hasOwnProperty:!1,isFinite:!1,isNaN:!1,Math:!1,Number:!1,Object:!1,parseInt:!1,parseFloat:!1,RangeError:!1,ReferenceError:!1,RegExp:!1,String:!1,SyntaxError:!1,TypeError:!1,URIError:!1},5:{JSON:!1},6:{Map:!1,Promise:!1,Proxy:!1,Reflect:!1,Set:!1,Symbol:!1,WeakMap:!1,WeakSet:!1}},exports.browser={Audio:!1,Blob:!1,addEventListener:!1,applicationCache:!1,atob:!1,blur:!1,btoa:!1,cancelAnimationFrame:!1,CanvasGradient:!1,CanvasPattern:!1,CanvasRenderingContext2D:!1,CSS:!1,clearInterval:!1,clearTimeout:!1,close:!1,closed:!1,Comment:!1,CustomEvent:!1,DOMParser:!1,defaultStatus:!1,Document:!1,document:!1,DocumentFragment:!1,Element:!1,ElementTimeControl:!1,Event:!1,event:!1,fetch:!1,FileReader:!1,FormData:!1,focus:!1,frames:!1,getComputedStyle:!1,HTMLElement:!1,HTMLAnchorElement:!1,HTMLBaseElement:!1,HTMLBlockquoteElement:!1,HTMLBodyElement:!1,HTMLBRElement:!1,HTMLButtonElement:!1,HTMLCanvasElement:!1,HTMLCollection:!1,HTMLDirectoryElement:!1,HTMLDivElement:!1,HTMLDListElement:!1,HTMLFieldSetElement:!1,HTMLFontElement:!1,HTMLFormElement:!1,HTMLFrameElement:!1,HTMLFrameSetElement:!1,HTMLHeadElement:!1,HTMLHeadingElement:!1,HTMLHRElement:!1,HTMLHtmlElement:!1,HTMLIFrameElement:!1,HTMLImageElement:!1,HTMLInputElement:!1,HTMLIsIndexElement:!1,HTMLLabelElement:!1,HTMLLayerElement:!1,HTMLLegendElement:!1,HTMLLIElement:!1,HTMLLinkElement:!1,HTMLMapElement:!1,HTMLMenuElement:!1,HTMLMetaElement:!1,HTMLModElement:!1,HTMLObjectElement:!1,HTMLOListElement:!1,HTMLOptGroupElement:!1,HTMLOptionElement:!1,HTMLParagraphElement:!1,HTMLParamElement:!1,HTMLPreElement:!1,HTMLQuoteElement:!1,HTMLScriptElement:!1,HTMLSelectElement:!1,HTMLStyleElement:!1,HTMLTableCaptionElement:!1,HTMLTableCellElement:!1,HTMLTableColElement:!1,HTMLTableElement:!1,HTMLTableRowElement:!1,HTMLTableSectionElement:!1,HTMLTemplateElement:!1,HTMLTextAreaElement:!1,HTMLTitleElement:!1,HTMLUListElement:!1,HTMLVideoElement:!1,history:!1,Image:!1,Intl:!1,length:!1,localStorage:!1,location:!1,matchMedia:!1,MessageChannel:!1,MessageEvent:!1,MessagePort:!1,MouseEvent:!1,moveBy:!1,moveTo:!1,MutationObserver:!1,name:!1,Node:!1,NodeFilter:!1,NodeList:!1,Notification:!1,navigator:!1,onbeforeunload:!0,onblur:!0,onerror:!0,onfocus:!0,onload:!0,onresize:!0,onunload:!0,open:!1,openDatabase:!1,opener:!1,Option:!1,parent:!1,performance:!1,print:!1,Range:!1,requestAnimationFrame:!1,removeEventListener:!1,resizeBy:!1,resizeTo:!1,screen:!1,scroll:!1,scrollBy:!1,scrollTo:!1,sessionStorage:!1,setInterval:!1,setTimeout:!1,SharedWorker:!1,status:!1,SVGAElement:!1,SVGAltGlyphDefElement:!1,SVGAltGlyphElement:!1,SVGAltGlyphItemElement:!1,SVGAngle:!1,SVGAnimateColorElement:!1,SVGAnimateElement:!1,SVGAnimateMotionElement:!1,SVGAnimateTransformElement:!1,SVGAnimatedAngle:!1,SVGAnimatedBoolean:!1,SVGAnimatedEnumeration:!1,SVGAnimatedInteger:!1,SVGAnimatedLength:!1,SVGAnimatedLengthList:!1,SVGAnimatedNumber:!1,SVGAnimatedNumberList:!1,SVGAnimatedPathData:!1,SVGAnimatedPoints:!1,SVGAnimatedPreserveAspectRatio:!1,SVGAnimatedRect:!1,SVGAnimatedString:!1,SVGAnimatedTransformList:!1,SVGAnimationElement:!1,SVGCSSRule:!1,SVGCircleElement:!1,SVGClipPathElement:!1,SVGColor:!1,SVGColorProfileElement:!1,SVGColorProfileRule:!1,SVGComponentTransferFunctionElement:!1,SVGCursorElement:!1,SVGDefsElement:!1,SVGDescElement:!1,SVGDocument:!1,SVGElement:!1,SVGElementInstance:!1,SVGElementInstanceList:!1,SVGEllipseElement:!1,SVGExternalResourcesRequired:!1,SVGFEBlendElement:!1,SVGFEColorMatrixElement:!1,SVGFEComponentTransferElement:!1,SVGFECompositeElement:!1,SVGFEConvolveMatrixElement:!1,SVGFEDiffuseLightingElement:!1,SVGFEDisplacementMapElement:!1,SVGFEDistantLightElement:!1,SVGFEFloodElement:!1,SVGFEFuncAElement:!1,SVGFEFuncBElement:!1,SVGFEFuncGElement:!1,SVGFEFuncRElement:!1,SVGFEGaussianBlurElement:!1,SVGFEImageElement:!1,SVGFEMergeElement:!1,SVGFEMergeNodeElement:!1,SVGFEMorphologyElement:!1,SVGFEOffsetElement:!1,SVGFEPointLightElement:!1,SVGFESpecularLightingElement:!1,SVGFESpotLightElement:!1,SVGFETileElement:!1,SVGFETurbulenceElement:!1,SVGFilterElement:!1,SVGFilterPrimitiveStandardAttributes:!1,SVGFitToViewBox:!1,SVGFontElement:!1,SVGFontFaceElement:!1,SVGFontFaceFormatElement:!1,SVGFontFaceNameElement:!1,SVGFontFaceSrcElement:!1,SVGFontFaceUriElement:!1,SVGForeignObjectElement:!1,SVGGElement:!1,SVGGlyphElement:!1,SVGGlyphRefElement:!1,SVGGradientElement:!1,SVGHKernElement:!1,SVGICCColor:!1,SVGImageElement:!1,SVGLangSpace:!1,SVGLength:!1,SVGLengthList:!1,SVGLineElement:!1,SVGLinearGradientElement:!1,SVGLocatable:!1,SVGMPathElement:!1,SVGMarkerElement:!1,SVGMaskElement:!1,SVGMatrix:!1,SVGMetadataElement:!1,SVGMissingGlyphElement:!1,SVGNumber:!1,SVGNumberList:!1,SVGPaint:!1,SVGPathElement:!1,SVGPathSeg:!1,SVGPathSegArcAbs:!1,SVGPathSegArcRel:!1,SVGPathSegClosePath:!1,SVGPathSegCurvetoCubicAbs:!1,SVGPathSegCurvetoCubicRel:!1,SVGPathSegCurvetoCubicSmoothAbs:!1,SVGPathSegCurvetoCubicSmoothRel:!1,SVGPathSegCurvetoQuadraticAbs:!1,SVGPathSegCurvetoQuadraticRel:!1,SVGPathSegCurvetoQuadraticSmoothAbs:!1,SVGPathSegCurvetoQuadraticSmoothRel:!1,SVGPathSegLinetoAbs:!1,SVGPathSegLinetoHorizontalAbs:!1,SVGPathSegLinetoHorizontalRel:!1,SVGPathSegLinetoRel:!1,SVGPathSegLinetoVerticalAbs:!1,SVGPathSegLinetoVerticalRel:!1,SVGPathSegList:!1,SVGPathSegMovetoAbs:!1,SVGPathSegMovetoRel:!1,SVGPatternElement:!1,SVGPoint:!1,SVGPointList:!1,SVGPolygonElement:!1,SVGPolylineElement:!1,SVGPreserveAspectRatio:!1,SVGRadialGradientElement:!1,SVGRect:!1,SVGRectElement:!1,SVGRenderingIntent:!1,SVGSVGElement:!1,SVGScriptElement:!1,SVGSetElement:!1,SVGStopElement:!1,SVGStringList:!1,SVGStylable:!1,SVGStyleElement:!1,SVGSwitchElement:!1,SVGSymbolElement:!1,SVGTRefElement:!1,SVGTSpanElement:!1,SVGTests:!1,SVGTextContentElement:!1,SVGTextElement:!1,SVGTextPathElement:!1,SVGTextPositioningElement:!1,SVGTitleElement:!1,SVGTransform:!1,SVGTransformList:!1,SVGTransformable:!1,SVGURIReference:!1,SVGUnitTypes:!1,SVGUseElement:!1,SVGVKernElement:!1,SVGViewElement:!1,SVGViewSpec:!1,SVGZoomAndPan:!1,Text:!1,TextDecoder:!1,TextEncoder:!1,TimeEvent:!1,top:!1,URL:!1,WebGLActiveInfo:!1,WebGLBuffer:!1,WebGLContextEvent:!1,WebGLFramebuffer:!1,WebGLProgram:!1,WebGLRenderbuffer:!1,WebGLRenderingContext:!1,WebGLShader:!1,WebGLShaderPrecisionFormat:!1,WebGLTexture:!1,WebGLUniformLocation:!1,WebSocket:!1,window:!1,Window:!1,Worker:!1,XDomainRequest:!1,XMLHttpRequest:!1,XMLSerializer:!1,XPathEvaluator:!1,XPathException:!1,XPathExpression:!1,XPathNamespace:!1,XPathNSResolver:!1,XPathResult:!1},exports.devel={alert:!1,confirm:!1,console:!1,Debug:!1,opera:!1,prompt:!1},exports.worker={importScripts:!0,postMessage:!0,self:!0,FileReaderSync:!0},exports.nonstandard={escape:!1,unescape:!1},exports.couch={require:!1,respond:!1,getRow:!1,emit:!1,send:!1,start:!1,sum:!1,log:!1,exports:!1,module:!1,provides:!1},exports.node={__filename:!1,__dirname:!1,GLOBAL:!1,global:!1,module:!1,acequire:!1,Buffer:!0,console:!0,exports:!0,process:!0,setTimeout:!0,clearTimeout:!0,setInterval:!0,clearInterval:!0,setImmediate:!0,clearImmediate:!0},exports.browserify={__filename:!1,__dirname:!1,global:!1,module:!1,acequire:!1,Buffer:!0,exports:!0,process:!0},exports.phantom={phantom:!0,acequire:!0,WebPage:!0,console:!0,exports:!0},exports.qunit={asyncTest:!1,deepEqual:!1,equal:!1,expect:!1,module:!1,notDeepEqual:!1,notEqual:!1,notPropEqual:!1,notStrictEqual:!1,ok:!1,propEqual:!1,QUnit:!1,raises:!1,start:!1,stop:!1,strictEqual:!1,test:!1,\"throws\":!1},exports.rhino={defineClass:!1,deserialize:!1,gc:!1,help:!1,importClass:!1,importPackage:!1,java:!1,load:!1,loadClass:!1,Packages:!1,print:!1,quit:!1,readFile:!1,readUrl:!1,runCommand:!1,seal:!1,serialize:!1,spawn:!1,sync:!1,toint32:!1,version:!1},exports.shelljs={target:!1,echo:!1,exit:!1,cd:!1,pwd:!1,ls:!1,find:!1,cp:!1,rm:!1,mv:!1,mkdir:!1,test:!1,cat:!1,sed:!1,grep:!1,which:!1,dirs:!1,pushd:!1,popd:!1,env:!1,exec:!1,chmod:!1,config:!1,error:!1,tempdir:!1},exports.typed={ArrayBuffer:!1,ArrayBufferView:!1,DataView:!1,Float32Array:!1,Float64Array:!1,Int16Array:!1,Int32Array:!1,Int8Array:!1,Uint16Array:!1,Uint32Array:!1,Uint8Array:!1,Uint8ClampedArray:!1},exports.wsh={ActiveXObject:!0,Enumerator:!0,GetObject:!0,ScriptEngine:!0,ScriptEngineBuildVersion:!0,ScriptEngineMajorVersion:!0,ScriptEngineMinorVersion:!0,VBArray:!0,WSH:!0,WScript:!0,XDomainRequest:!0},exports.dojo={dojo:!1,dijit:!1,dojox:!1,define:!1,require:!1},exports.jquery={$:!1,jQuery:!1},exports.mootools={$:!1,$$:!1,Asset:!1,Browser:!1,Chain:!1,Class:!1,Color:!1,Cookie:!1,Core:!1,Document:!1,DomReady:!1,DOMEvent:!1,DOMReady:!1,Drag:!1,Element:!1,Elements:!1,Event:!1,Events:!1,Fx:!1,Group:!1,Hash:!1,HtmlTable:!1,IFrame:!1,IframeShim:!1,InputValidator:!1,instanceOf:!1,Keyboard:!1,Locale:!1,Mask:!1,MooTools:!1,Native:!1,Options:!1,OverText:!1,Request:!1,Scroller:!1,Slick:!1,Slider:!1,Sortables:!1,Spinner:!1,Swiff:!1,Tips:!1,Type:!1,typeOf:!1,URI:!1,Window:!1},exports.prototypejs={$:!1,$$:!1,$A:!1,$F:!1,$H:!1,$R:!1,$break:!1,$continue:!1,$w:!1,Abstract:!1,Ajax:!1,Class:!1,Enumerable:!1,Element:!1,Event:!1,Field:!1,Form:!1,Hash:!1,Insertion:!1,ObjectRange:!1,PeriodicalExecuter:!1,Position:!1,Prototype:!1,Selector:!1,Template:!1,Toggle:!1,Try:!1,Autocompleter:!1,Builder:!1,Control:!1,Draggable:!1,Draggables:!1,Droppables:!1,Effect:!1,Sortable:!1,SortableObserver:!1,Sound:!1,Scriptaculous:!1},exports.yui={YUI:!1,Y:!1,YUI_config:!1},exports.mocha={mocha:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,context:!1,xcontext:!1,before:!1,after:!1,beforeEach:!1,afterEach:!1,suite:!1,test:!1,setup:!1,teardown:!1,suiteSetup:!1,suiteTeardown:!1},exports.jasmine={jasmine:!1,describe:!1,xdescribe:!1,it:!1,xit:!1,beforeEach:!1,afterEach:!1,setFixtures:!1,loadFixtures:!1,spyOn:!1,expect:!1,runs:!1,waitsFor:!1,waits:!1,beforeAll:!1,afterAll:!1,fail:!1,fdescribe:!1,fit:!1,pending:!1}},{}]},{},[\"/node_modules/jshint/src/jshint.js\"])}),ace.define(\"ace/mode/javascript_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/worker/mirror\",\"ace/mode/javascript/jshint\"],function(acequire,exports,module){\"use strict\";function startRegex(arr){return RegExp(\"^(\"+arr.join(\"|\")+\")\")}var oop=acequire(\"../lib/oop\"),Mirror=acequire(\"../worker/mirror\").Mirror,lint=acequire(\"./javascript/jshint\").JSHINT,disabledWarningsRe=startRegex([\"Bad for in variable '(.+)'.\",'Missing \"use strict\"']),errorsRe=startRegex([\"Unexpected\",\"Expected \",\"Confusing (plus|minus)\",\"\\\\{a\\\\} unterminated regular expression\",\"Unclosed \",\"Unmatched \",\"Unbegun comment\",\"Bad invocation\",\"Missing space after\",\"Missing operator at\"]),infoRe=startRegex([\"Expected an assignment\",\"Bad escapement of EOL\",\"Unexpected comma\",\"Unexpected space\",\"Missing radix parameter.\",\"A leading decimal point can\",\"\\\\['{a}'\\\\] is better written in dot notation.\",\"'{a}' used out of scope\"]),JavaScriptWorker=exports.JavaScriptWorker=function(sender){Mirror.call(this,sender),this.setTimeout(500),this.setOptions()};oop.inherits(JavaScriptWorker,Mirror),function(){this.setOptions=function(options){this.options=options||{esnext:!0,moz:!0,devel:!0,browser:!0,node:!0,laxcomma:!0,laxbreak:!0,lastsemic:!0,onevar:!1,passfail:!1,maxerr:100,expr:!0,multistr:!0,globalstrict:!0},this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.changeOptions=function(newOptions){oop.mixin(this.options,newOptions),this.doc.getValue()&&this.deferredUpdate.schedule(100)},this.isValidJS=function(str){try{eval(\"throw 0;\"+str)}catch(e){if(0===e)return!0}return!1},this.onUpdate=function(){var value=this.doc.getValue();if(value=value.replace(/^#!.*\\n/,\"\\n\"),!value)return this.sender.emit(\"annotate\",[]);var errors=[],maxErrorLevel=this.isValidJS(value)?\"warning\":\"error\";lint(value,this.options,this.options.globals);for(var results=lint.errors,errorAdded=!1,i=0;results.length>i;i++){var error=results[i];if(error){var raw=error.raw,type=\"warning\";if(\"Missing semicolon.\"==raw){var str=error.evidence.substr(error.character);str=str.charAt(str.search(/\\S/)),\"error\"==maxErrorLevel&&str&&/[\\w\\d{(['\"]/.test(str)?(error.reason='Missing \";\" before statement',type=\"error\"):type=\"info\"}else{if(disabledWarningsRe.test(raw))continue;infoRe.test(raw)?type=\"info\":errorsRe.test(raw)?(errorAdded=!0,type=maxErrorLevel):\"'{a}' is not defined.\"==raw?type=\"warning\":\"'{a}' is defined but never used.\"==raw&&(type=\"info\")}errors.push({row:error.line-1,column:error.character-1,text:error.reason,type:type,raw:raw})}}this.sender.emit(\"annotate\",errors)}}.call(JavaScriptWorker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_plantillas__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalDelete:state.plantillas.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_plantillas__["k" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_plantillas__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Plantillas__ = __webpack_require__(151);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalFilter=function(_Component){_inherits(ModalFilter,_Component);function ModalFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalFilter.__proto__||Object.getPrototypeOf(ModalFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalFilter');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalFilter .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalFilter(false);},300);},_this.handleApplyFilters=function(e){_this.handleCloseModal();_this.props.applyFilterCriterias();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalFilter,[{key:'render',value:function render(){var _this2=this;var modalFilter=this.props.modalFilter;if(!modalFilter.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalFilter',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Filtro',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalFilter");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus',onClick:function onClick(e){return _this2.props.addModalFilterCriteria();},title:'Aceptar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'trash',onClick:function onClick(e){return _this2.props.removeCheckedModalFilterCriterias();},disabled:modalFilter.get('filters').filter(function(item){return item.get('checked');}).count()===0,title:'Eliminar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',onClick:function onClick(e){return _this2.handleApplyFilters();},title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12',style:{height:'200px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Columna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Operador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Filtro'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalFilter.get('filters').count()>0?modalFilter.get('filters').map(function(item,index){var key='tr2['+index+']';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key,className:''+(item.get('checked')?'info':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.props.toggleCheckedModalFilterCriterias(index,e.target.checked);},checked:item.get('checked')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('column'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'column',e.target.value);}},__WEBPACK_IMPORTED_MODULE_10__containers_Plantillas__["b" /* tableCols */].map(function(x1,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+x1.Id+']['+n1+']',value:x1.Value},x1.Caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('operator'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'operator',e.target.value);}},__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["H" /* operators */].filter(function(x){return x.comparisons.includes(item.get('comparison'));}).map(function(item1,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+item1.id+']['+n+']',value:item1.value},item1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'value',e.target.value);}})));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',style:{textAlign:'center'}},'No hay filtros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalFilter:state.plantillas.get('modalFilter')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_plantillas__["l" /* showHideModalFilter */])(state));},addModalFilterCriteria:function addModalFilterCriteria(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_plantillas__["a" /* addModalFilterCriteria */])());},removeCheckedModalFilterCriterias:function removeCheckedModalFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_plantillas__["i" /* removeCheckedModalFilterCriterias */])());},toggleCheckedModalFilterCriterias:function toggleCheckedModalFilterCriterias(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_plantillas__["m" /* toggleCheckedModalFilterCriterias */])(index,checked));},updateModalFilterCriteria:function updateModalFilterCriteria(index,attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_plantillas__["q" /* updateModalFilterCriteria */])(index,attr,value));},applyFilterCriterias:function applyFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_plantillas__["b" /* applyFilterCriterias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalFilter));

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Garantias__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var columnas=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(__WEBPACK_IMPORTED_MODULE_2__containers_Garantias__["b" /* tableCols */]);var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({garantias:[],page:1,showRecords:100,totalRecords:0,orderBy:{field:null,asc:false},modalCreate:{title:'',mode:'',show:false,data:null,btnDisabled:false},modalDelete:{show:false,action:null,message:null},modalFilter:{show:false,filters:[]}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var id=void 0;var data=void 0;var index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_294" /* OBTENER_GARANTIAS */]:state=state.set('garantias',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_56" /* CONMUTAR_SELECCION_GARANTIA */]:state=state.setIn(['garantias',action.payload.index,'selected'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_65" /* CONMUTAR_SELECCION_TODOS_GARANTIAS */]:state.get('garantias').forEach(function(x,n){if(action.payload){if(x.get('Visible')){state=state.setIn(['garantias',n,'selected'],action.payload);}}else{state=state.setIn(['garantias',n,'selected'],action.payload);}});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_326" /* ORDENAR_GARANTIAS */]:state=state.set('orderBy',action.payload.orderBy);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_263" /* MOSTRAR_MODAL_CREAR_GARANTIA */]:state=state.setIn(['modalCreate','show'],action.payload.show);state=state.setIn(['modalCreate','title'],action.payload.title);state=state.setIn(['modalCreate','mode'],action.payload.mode);if(action.payload.mode==='create'){state=state.setIn(['modalCreate','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["s" /* garantia */])()));}else if(action.payload.mode==='edit'){index=state.get('garantias').findIndex(function(x){return x.get('id')===action.payload.id;});state=state.setIn(['modalCreate','data'],state.getIn(['garantias',index]));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_200" /* MODIFICAR_INPUTS_GARANTIAS */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_76" /* CREAR_ACTUALIZAR_GARANTIA */]:id=action.payload.id;index=state.get('garantias').findIndex(function(x){return x.get('id')===id;});if(index!==-1){state=state.setIn(['garantias',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));}else{state=state.set('garantias',state.get('garantias').push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload)));}state=state.setIn(['modalCreate','show'],false);state=state.setIn(['modalCreate','title'],'');state=state.setIn(['modalCreate','mode'],'');state=state.setIn(['modalCreate','data'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_104" /* DESHABILITAR_BOTON_MODAL_GARANTIAS */]:state=state.setIn(['modalCreate','btnDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_249" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_150" /* ELIMINAR_GARANTIA */]:index=state.get('garantias').findIndex(function(x){return x.get('id')===action.payload;});state=state.deleteIn(['garantias',index]);state=state.setIn(['modalDelete','show'],false);state=state.setIn(['modalDelete','action'],null);state=state.setIn(['modalDelete','message'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_271" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS */]:state=state.setIn(['modalFilter','show'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["r" /* ADICIONAR_CRITERIO_FILTRADO_GARANTIAS */]:var firstCol=columnas.first();state=state.updateIn(['modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('Value'),operator:'===',value:'',checked:false,comparison:firstCol.get('Type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_144" /* ELIMINAR_CRITERIO_FILTRADO_GARANTIAS */]:state=state.setIn(['modalFilter','filters'],state.getIn(['modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_49" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS */]:state=state.setIn(['modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_185" /* MODIFICAR_CRITERIO_FILTRADO_GARANTIAS */]:if(action.payload.attr==='column'){state=state.setIn(['modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('Value')===action.payload.value;}).get('Type'));}state=state.setIn(['modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_23" /* APLICAR_CRITERIOS_FILTRADO_GARANTIAS */]:state=state.updateIn(['modalFilter','filters'],function(filter){return filter.map(function(x){x=x.set('apply',true);return x;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_37" /* CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS */]:state=state.set('showRecords',action.payload);return state;default:return state;}});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ckeditor_component__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ckeditor_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_ckeditor_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_garantias__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import ReactQuill from 'react-quill'
var ModalCreate=function(_Component){_inherits(ModalCreate,_Component);function ModalCreate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreate.__proto__||Object.getPrototypeOf(ModalCreate)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreate');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreate .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreate(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreate,[{key:'render',value:function render(){var _this2=this;var modalCreate=this.props.modalCreate;if(!modalCreate.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Modal__["a" /* default */],{id:'modalCreate',show:true,ZIndex:2000,style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateGarantias(modalCreate.get('data'),modalCreate.get('mode'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__["a" /* default */],{title:modalCreate.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreate.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','nombre']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreate.data.nombre',e.target.value);},disabled:modalCreate.get('mode')==='edit'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Garantia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_ckeditor_component___default.a,{activeClass:'p10',content:modalCreate.getIn(['data','texto']),events:{"change":function change(e){return _this2.props.updateInputs('modalCreate.data.texto',e.editor.getData());}}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalCreate:state.garantias.get('modalCreate')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreate:function displayModalCreate(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_garantias__["f" /* displayModalCreate */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_garantias__["p" /* updateInputs */])(path,value));},createOrUpdateGarantias:function createOrUpdateGarantias(data,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_garantias__["d" /* createOrUpdateGarantias */])(data,mode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreate));

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_garantias__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalDelete:state.garantias.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_garantias__["k" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_garantias__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_Garantias__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalFilter=function(_Component){_inherits(ModalFilter,_Component);function ModalFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalFilter.__proto__||Object.getPrototypeOf(ModalFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalFilter');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalFilter .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalFilter(false);},300);},_this.handleApplyFilters=function(e){_this.handleCloseModal();_this.props.applyFilterCriterias();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalFilter,[{key:'render',value:function render(){var _this2=this;var modalFilter=this.props.modalFilter;if(!modalFilter.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalFilter',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Filtro',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalFilter");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus',onClick:function onClick(e){return _this2.props.addModalFilterCriteria();},title:'Aceptar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'trash',onClick:function onClick(e){return _this2.props.removeCheckedModalFilterCriterias();},disabled:modalFilter.get('filters').filter(function(item){return item.get('checked');}).count()===0,title:'Eliminar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',onClick:function onClick(e){return _this2.handleApplyFilters();},title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12',style:{height:'200px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Columna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Operador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Filtro'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalFilter.get('filters').count()>0?modalFilter.get('filters').map(function(item,index){var key='tr2['+index+']';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key,className:''+(item.get('checked')?'info':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.props.toggleCheckedModalFilterCriterias(index,e.target.checked);},checked:item.get('checked')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('column'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'column',e.target.value);}},__WEBPACK_IMPORTED_MODULE_10__containers_Garantias__["b" /* tableCols */].map(function(x1,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+x1.Id+']['+n1+']',value:x1.Value},x1.Caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('operator'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'operator',e.target.value);}},__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["H" /* operators */].filter(function(x){return x.comparisons.includes(item.get('comparison'));}).map(function(item1,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+item1.id+']['+n+']',value:item1.value},item1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'value',e.target.value);}})));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',style:{textAlign:'center'}},'No hay filtros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalFilter:state.garantias.get('modalFilter')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_garantias__["l" /* showHideModalFilter */])(state));},addModalFilterCriteria:function addModalFilterCriteria(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_garantias__["a" /* addModalFilterCriteria */])());},removeCheckedModalFilterCriterias:function removeCheckedModalFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_garantias__["i" /* removeCheckedModalFilterCriterias */])());},toggleCheckedModalFilterCriterias:function toggleCheckedModalFilterCriterias(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_garantias__["m" /* toggleCheckedModalFilterCriterias */])(index,checked));},updateModalFilterCriteria:function updateModalFilterCriteria(index,attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_garantias__["q" /* updateModalFilterCriteria */])(index,attr,value));},applyFilterCriterias:function applyFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_garantias__["b" /* applyFilterCriterias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalFilter));

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({solicitante:null,fecha_requerido:null,ordenador_gasto:null,proveedor:null,responsable_recibo:[],responsable_ingreso:[],proyecto_evento:'',observaciones:'',servicios:[],cencos:[],anticipo:0,adjuntos:[],modalAddServicio:{show:false,title:'',mode:null,data:null,btnDisabled:false},modalAddFile:{show:false,title:'',data:null,btnDisabled:false},btnSaveDisabled:false,tipo:3,moneda:'COP',foros:[],comentario:{guid:null,texto:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var data=void 0,index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_341" /* REINICIAR_SOLICITUD_SERVICIO_OT */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_218" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_244" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT */]:state=state.setIn(['modalAddServicio','title'],action.payload.title);state=state.setIn(['modalAddServicio','show'],action.payload.show);state=state.setIn(['modalAddServicio','mode'],action.payload.mode);data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["R" /* solicitudservicioitem */])());if(action.payload.mode==='edit'){data=state.getIn(['servicios',String(action.payload.index)]);}state=state.setIn(['modalAddServicio','data'],data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_316" /* OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT */]:state=state.set('modalAddServicio',INITIAL_STATE.get('modalAddServicio'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_3" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT */]:var actual=state.get('cencos').reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);state=state.update('cencos',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["S" /* solicitudservicioitemcenco */])(actual)));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_134" /* ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM */]:state=state.update('cencos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_13" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT */]:data=state.getIn(['modalAddServicio','data']);index=state.get('servicios').findIndex(function(x){return x.get('guid')===data.get('guid');});if(index===-1){state=state.set('servicios',state.get('servicios').push(data));}else{state=state.setIn(['servicios',String(index)],data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_243" /* MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT */]:state=state.setIn(['modalAddFile','title'],action.payload.title);state=state.setIn(['modalAddFile','show'],action.payload.show);data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["Q" /* solicitudserviciofile */])());if(action.payload.mode==='edit'){data=state.getIn(['adjuntos',String(action.payload.index)]);}state=state.setIn(['modalAddFile','data'],data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_315" /* OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT */]:state=state.set('modalAddFile',INITIAL_STATE.get('modalAddFile'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["U" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT */]:data=action.payload;index=state.get('adjuntos').findIndex(function(x){return x.get('guid')===data.get('guid');});data=data.set('nombre',''+data.get('nombre'));if(index===-1){state=state.set('adjuntos',state.get('adjuntos').push(data));}else{data=data.set('updated',true);state=state.setIn(['adjuntos',String(index)],data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_127" /* ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT */]:state=state.update('adjuntos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_333" /* RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO_OT */]:state=state.set('adjuntos',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["A" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT */]:state=state.setIn(action.payload.path.split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_15" /* ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT */]:data={guid:Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["B" /* guid */])(),selected:false};state=state.update(action.payload,function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(data));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_157" /* ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT */]:state=state.update(action.payload.path,function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_155" /* ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT */]:state=state.update('servicios',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_95" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT */]:state=state.set('btnSaveDisabled',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_167" /* ENVIAR_COMENTARIO_SOLICITUD_OT */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});if(index===-1){var _data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* foro */])(action.payload.usuario,action.payload.comentario));state=state.set('foros',state.get('foros').push(_data));}else{state=state.setIn(['foros',index,'comentario'],action.payload.comentario);}state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_115" /* EDITAR_COMENTARIO_SOLICITUD_OT */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.setIn(['comentario','guid'],action.payload.guid);state=state.setIn(['comentario','texto'],state.getIn(['foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_137" /* ELIMINAR_COMENTARIO_SOLICITUD_OT */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.deleteIn(['foros',index]);return state;default:return state;}});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var thisYear=new Date().getFullYear();var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({proyecto_evento:null,observaciones:null,fecha_inicio:__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date(thisYear,0,1)).format('YYYY-MM-DD'),fecha_entrega:__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date(thisYear,11,31)).format('YYYY-MM-DD'),proveedor:Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["M" /* proveedor */])(),btnSaveDisabled:false,tipo_proveedor:1,tipo:2});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var data=void 0,index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_337" /* REINICIAR_SOLICITUD_CONTRATOANUAL */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_212" /* MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(action.payload.path=='tipo_proveedor'){if(action.payload.value==2){state=state.set('proveedor',Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["M" /* proveedor */])());}}if(action.payload.path=='fecha_inicio'){var year=__WEBPACK_IMPORTED_MODULE_2_moment___default()(action.payload.value).year();state=state.set('fecha_entrega',__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date(year,11,31)).format('YYYY-MM-DD'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_92" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL */]:state=state.set('btnSaveDisabled',action.payload);return state;default:return state;}});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,estado:0,solicitud:{},btnSaveDisabled:true,btnRComprasDisabled:true,btnAproveDisabled:false,modified:[],modalCreateDocumento:{title:'',mode:'',show:false,data:null,btnDisabled:false,plantillas:[],garantias:[],unchanged:null,contratoanual:false,contratosAnuales:[]},modalAddServicio:{show:false,title:'',mode:null,data:null,btnDisabled:false},aprobadores:[],addModificacion:false,comentario:{id:null,texto:null,btnSendDisabled:false}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var i=void 0,p=void 0,data=void 0,index=void 0,cotizado=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_342" /* REINICIAR_SOLICITUD_SERVICIO_OT1 */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["M" /* ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT */]:state=state.set('modified',state.get('modified').filter(function(x){return x.get('entity')+x.get('attribute')+x.get('id')!==action.payload.entity+action.payload.attribute+action.payload.id;}));state=state.update('modified',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));});state=state.set('btnSaveDisabled',state.get('modified').count()===0);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_310" /* OBTENER_SOLICITUD_SERVICIO_OT */]:state=state.set('id',action.payload.solicitud.id);state=state.set('estado',action.payload.solicitud.estado);state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('unchaged',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));if(action.payload.reset!==false){state=state.set('modified',INITIAL_STATE.get('modified'));}state=state.set('btnSaveDisabled',state.get('modified').count()===0);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["h" /* ACTUALIZAR_SOLICITUD_SERVICIO_OT */]:var ops=__WEBPACK_IMPORTED_MODULE_2_immutablediff___default()(state.get('solicitud'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.get('solicitud'),ops));if(ops.filter(function(x){return x.get('path')==='/estado';}).count()===1){state=state.set('estado',state.getIn(['solicitud','estado']));}state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));state=state.set('btnRComprasDisabled',true);state=state.set('addModificacion',false);state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_261" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT */]:state=state.setIn(['modalCreateDocumento','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalCreateDocumento','title'],action.payload.title);state=state.setIn(['modalCreateDocumento','mode'],action.payload.mode);state=state.setIn(['modalCreateDocumento','plantillas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.plantillas));state=state.setIn(['modalCreateDocumento','garantias'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.garantias));state=state.setIn(['modalCreateDocumento','contratosAnuales'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.contratos));if(action.payload.mode==='create'){var solicitud_id=state.get('id');var documento_id=state.getIn(['solicitud','documentos',action.payload.indexDocumento,'id']);var proveedor_id=state.getIn(['solicitud','documentos',action.payload.indexDocumento,'proveedor','id']);state=state.setIn(['modalCreateDocumento','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["l" /* documento */])(documento_id,solicitud_id,proveedor_id)));}else if(action.payload.mode==='edit'){state=state.setIn(['modalCreateDocumento','data'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));state=state.setIn(['modalCreateDocumento','unchanged'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));var tipo=state.getIn(['modalCreateDocumento','data','tipo']);// console.log('consecutivo', state.getIn(['modalCreateDocumento', 'data']));
// console.log('consecutivo', state.getIn(['modalCreateDocumento', 'unchanged']));
var creado=state.getIn(['modalCreateDocumento','data','consecutivo'])?true:false;if(!creado){state=state.setIn(['modalCreateDocumento','data','entregas_parciales'],true);}var _cotizado=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var aiu_adm=state.getIn(['modalCreateDocumento','data','aiu_administracion']);state=state.setIn(['modalCreateDocumento','data','aiu_administracion_value'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado,aiu_adm)||0);var aiu_imp=state.getIn(['modalCreateDocumento','data','aiu_imprevistos']);state=state.setIn(['modalCreateDocumento','data','aiu_imprevistos_value'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado,aiu_imp)||0);var aiu_uti=state.getIn(['modalCreateDocumento','data','aiu_utilidad']);state=state.setIn(['modalCreateDocumento','data','aiu_utilidad_value'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado,aiu_uti)||0);var aiu_iva_uti=state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad']);state=state.setIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(state.getIn(['modalCreateDocumento','data','aiu_utilidad_value']),aiu_iva_uti)||0);var iva=state.getIn(['modalCreateDocumento','data','iva']);state=state.setIn(['modalCreateDocumento','data','iva_value'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado,iva)||0);var aiu_total=state.getIn(['modalCreateDocumento','data','aiu_administracion_value'])+state.getIn(['modalCreateDocumento','data','aiu_imprevistos_value'])+state.getIn(['modalCreateDocumento','data','aiu_utilidad_value'])+state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'])+state.getIn(['modalCreateDocumento','data','iva_value'])+_cotizado;state=state.setIn(['modalCreateDocumento','data','aiu_total'],aiu_total);if(!state.getIn(['modalCreateDocumento','data','fecha_inicio']))state=state.setIn(['modalCreateDocumento','data','fecha_inicio'],state.getIn(['solicitud','created_at']));if(!state.getIn(['modalCreateDocumento','data','fecha_entrega']))state=state.setIn(['modalCreateDocumento','data','fecha_entrega'],state.getIn(['solicitud','fecha_requerido']));// if (tipo == 4) {
//     const documento_original = state.getIn(['solicitud', 'documento_origen'])
//     state = state.setIn(['modalCreateDocumento', 'data', 'fecha_entrega'], documento_original.get('fecha_entrega'))
//     state = state.setIn(['modalCreateDocumento', 'data', 'fecha_inicio'], documento_original.get('fecha_inicio'))
// }
if(tipo==5){state=state.setIn(['modalCreateDocumento','contratoanual'],true);}if(tipo==4){state=state.setIn(['modalCreateDocumento','data','anticipo'],0);}}}else{state=state.set('modalCreateDocumento',INITIAL_STATE.get('modalCreateDocumento'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_219" /* MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1 */]:if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(action.payload.path=='modalCreateDocumento.contratoanual'){state=state.setIn(['modalCreateDocumento','data','tipo'],0);state=state.setIn(['modalCreateDocumento','data','plantilla_id'],0);if(action.payload.value==false){state=state.setIn(['modalCreateDocumento','data','documento_id'],null);}}if(action.payload.path.split('.').slice(-1)[0]=='responsable_compras'||action.payload.path.split('.').slice(-1)[0]=='solicitante'){state=state.set('btnRComprasDisabled',false);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_administracion'){var _cotizado2=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var porcentaje=state.getIn(['modalCreateDocumento','data','aiu_administracion']);var valor=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado2,porcentaje);state=state.setIn(['modalCreateDocumento','data','aiu_administracion_value'],valor);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_imprevistos'){var _cotizado3=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var _porcentaje=state.getIn(['modalCreateDocumento','data','aiu_imprevistos']);var _valor=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado3,_porcentaje);state=state.setIn(['modalCreateDocumento','data','aiu_imprevistos_value'],_valor);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_utilidad'){var _cotizado4=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var _porcentaje2=state.getIn(['modalCreateDocumento','data','aiu_utilidad']);var _valor2=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado4,_porcentaje2);state=state.setIn(['modalCreateDocumento','data','aiu_utilidad_value'],_valor2);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_iva_utilidad'||action.payload.path.split('.').slice(-1)[0]=='aiu_utilidad'){var utilidad=state.getIn(['modalCreateDocumento','data','aiu_utilidad_value']);var _porcentaje3=state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad']);var _valor3=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(utilidad,_porcentaje3);state=state.setIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'],_valor3);}if(action.payload.path.split('.').slice(-1)[0]=='iva'){var _cotizado5=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var _porcentaje4=state.getIn(['modalCreateDocumento','data','iva']);var _valor4=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["v" /* getPorcentaje */])(_cotizado5,_porcentaje4);state=state.setIn(['modalCreateDocumento','data','iva_value'],_valor4);}if(state.getIn(['modalCreateDocumento','data'])){var aiu_administracion_value=state.getIn(['modalCreateDocumento','data','aiu_administracion_value']);var aiu_imprevistos_value=state.getIn(['modalCreateDocumento','data','aiu_imprevistos_value']);var aiu_utilidad_value=state.getIn(['modalCreateDocumento','data','aiu_utilidad_value']);var aiu_iva_utilidad_value=state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad_value']);var _iva=state.getIn(['modalCreateDocumento','data','iva_value']);var _cotizado6=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);var _aiu_total=aiu_administracion_value+aiu_imprevistos_value+aiu_utilidad_value+aiu_iva_utilidad_value+_iva+_cotizado6;state=state.setIn(['modalCreateDocumento','data','aiu_total'],_aiu_total);// state = state.setIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado_iva'], cotizado + aiu_total)
if(action.payload.path.split('.').slice(-1)[0]=='tipo'){state=state.setIn(['modalCreateDocumento','data','plantilla_id'],0);}if(action.payload.path.split('.').slice(-1)[0]=='contratoanual'){state=state.setIn(['modalCreateDocumento','data','documento_id'],null);state=state.setIn(['modalCreateDocumento','data','tipo'],0);state=state.setIn(['modalCreateDocumento','data','plantilla_id'],-1);state=state.setIn(['modalCreateDocumento','data','consecutivo'],'');}}// if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
//     let newPath = action.payload.path.split('.')
//     newPath = newPath.splice(0, newPath.length-1)
//     if (newPath[newPath.length-1] == 'pivot') {
//         state = state.setIn([...newPath, 'selected'], true)
//     }
// }
return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_344" /* REINICIAR_VALORES_AIU */]:cotizado=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);state=state.setIn(['modalCreateDocumento','data','aiu_administracion'],0);state=state.setIn(['modalCreateDocumento','data','aiu_administracion_value'],0);state=state.setIn(['modalCreateDocumento','data','aiu_imprevistos'],0);state=state.setIn(['modalCreateDocumento','data','aiu_imprevistos_value'],0);state=state.setIn(['modalCreateDocumento','data','aiu_utilidad'],0);state=state.setIn(['modalCreateDocumento','data','aiu_utilidad_value'],0);state=state.setIn(['modalCreateDocumento','data','aiu_iva_utilidad'],0);state=state.setIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'],0);state=state.setIn(['modalCreateDocumento','data','aiu_total'],cotizado);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_345" /* REINICIAR_VALORES_IVA */]:cotizado=state.getIn(['modalCreateDocumento','data','cotizacion','cotizado']);state=state.setIn(['modalCreateDocumento','data','iva'],0);state=state.setIn(['modalCreateDocumento','data','aiu_total'],cotizado);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["G" /* ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT */]:var garantia=state.getIn(['modalCreateDocumento','garantias',String(action.payload)]);state=state.updateIn(['modalCreateDocumento','data','garantias'],function(list){return list.push(garantia);});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_354" /* REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT */]:state=state.setIn(['modalCreateDocumento','data','garantias'],state.getIn(['modalCreateDocumento','data','garantias']).filter(function(x){return x.get('id')!==action.payload;}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["V" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT1 */]:data=action.payload;index=state.getIn(['solicitud','adjuntos']).findIndex(function(x){return x.get('guid')===data.get('guid');});data=data.set('nombre',''+data.get('nombre'));if(index===-1){state=state.setIn(['solicitud','adjuntos'],state.getIn(['solicitud','adjuntos']).push(data));}else{state=state.setIn(['solicitud','adjuntos',String(index)],data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_128" /* ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1 */]:state=state.updateIn(['solicitud','adjuntos'],function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_102" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT */]:state=state.setIn(['modalCreateDocumento','btnDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_82" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT */]:state=state.set('btnAproveDisabled',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_245" /* MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 */]:state=state.setIn(['modalAddServicio','title'],action.payload.title);state=state.setIn(['modalAddServicio','show'],action.payload.show);state=state.setIn(['modalAddServicio','mode'],action.payload.mode);data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["R" /* solicitudservicioitem */])());if(action.payload.mode==='edit'){data=state.getIn(['solicitud','servicios',String(action.payload.index)]);}state=state.setIn(['modalAddServicio','data'],data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_317" /* OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 */]:state=state.set('modalAddServicio',INITIAL_STATE.get('modalAddServicio'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_14" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1 */]:data=state.getIn(['modalAddServicio','data']);var mode=state.getIn(['modalAddServicio','mode']);if(mode=='create'){state=state.setIn(['solicitud','servicios'],state.getIn(['solicitud','servicios']).push(data));}if(mode=='edit'){index=state.getIn(['solicitud','servicios']).findIndex(function(x){return data.get('guid')&&x.get('guid')===data.get('guid')||x.get('id')===data.get('id');});if(index>=0){state=state.setIn(['solicitud','servicios',String(index)],data);}}state=state.set('addModificacion',true);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_367" /* SELECCIONAR_MONEDA_SOLICITUD_OT1 */]:var idx=0;if(state.getIn(['solicitud','cotizaciones'])){for(idx=0;idx<state.getIn(['solicitud','cotizaciones']).count();idx++){state=state.setIn(['solicitud','cotizaciones',idx,'moneda'],action.payload.moneda);}}state=state.set('addModificacion',true);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_116" /* EDITAR_COMENTARIO_SOLICITUD_OT1 */]:index=state.getIn(['solicitud','foros']).findIndex(function(c){return c.get('id')===action.payload.id;});state=state.setIn(['comentario','id'],action.payload.id);state=state.setIn(['comentario','texto'],state.getIn(['solicitud','foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_87" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1 */]:state=state.setIn(['comentario','btnSendDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_162" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1 */]:state=state.setIn(['solicitud','foros'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.foros));state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;default:return state;}});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,estado:0,solicitud:{},btnSaveDisabled:true,btnRComprasDisabled:true,modified:[],modalCreateDocumento:{title:'',show:false,data:null,btnDisabled:false,unchanged:null,plantillas:[]},modalAddFirmas:{show:false,data:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_338" /* REINICIAR_SOLICITUD_CONTRATOANUAL1 */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["J" /* ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL */]:state=state.set('modified',state.get('modified').filter(function(x){return x.get('entity')+x.get('attribute')+x.get('id')!==action.payload.entity+action.payload.attribute+action.payload.id;}));state=state.update('modified',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));});state=state.set('btnSaveDisabled',state.get('modified').count()===0);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_306" /* OBTENER_SOLICITUD_CONTRATOANUAL */]:state=state.set('id',action.payload.solicitud.id);state=state.set('estado',action.payload.solicitud.estado);state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));if(action.payload.reset!==false){state=state.set('modified',INITIAL_STATE.get('modified'));}state=state.set('btnSaveDisabled',state.get('modified').count()===0);return state;// case types.ACTUALIZAR_SOLICITUD_CONTRATOANUAL:
//     const ops = diff(state.get('solicitud'), Immutable.fromJS(action.payload))
//     state = state.set('solicitud', patch(state.get('solicitud'), ops))
//     if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
//         state = state.set('estado', state.getIn(['solicitud', 'estado']))
//     }
//     state = state.set('btnRComprasDisabled', true)
//     return state
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["e" /* ACTUALIZAR_SOLICITUD_CONTRATOANUAL */]:var ops=__WEBPACK_IMPORTED_MODULE_2_immutablediff___default()(state.get('solicitud'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.get('solicitud'),ops));if(ops.filter(function(x){return x.get('path')==='/estado';}).count()===1){state=state.set('estado',state.getIn(['solicitud','estado']));}state=state.set('btnRComprasDisabled',true);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_259" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL */]:state=state.setIn(['modalCreateDocumento','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalCreateDocumento','title'],action.payload.title);state=state.setIn(['modalCreateDocumento','plantillas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.plantillas));state=state.setIn(['modalCreateDocumento','data'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));state=state.setIn(['modalCreateDocumento','unchanged'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));}else{state=state.set('modalCreateDocumento',INITIAL_STATE.get('modalCreateDocumento'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_213" /* MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1 */]:if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(action.payload.path.split('.').slice(-1)[0]=='responsable_compras'){state=state.set('btnRComprasDisabled',false);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_239" /* MOSTRAR_MODAL_ADICION_FIRMAS */]:if(action.payload.show){//const documentos = state.getIn(['solicitud', 'documentos']).filter(x => x.get('tipo') == 5 && x.get('documento_id') == null && x.get('estado') > 0 && x.get('estado') < 11)
//const documentos = action.payload.documentos.filter(x => x.get('tipo') == 5 && x.get('documento_id') == null && x.get('estado') > 0 && x.get('estado') < 11)
var documentos=action.payload.solicitud.get('documentos').filter(function(x){return x.get('tipo')==5&&x.get('documento_id')==null&&x.get('estado')>0&&x.get('estado')<11;});var documento_id=documentos.count()>0?documentos.first().get('id'):null;state=state.setIn(['modalAddFirmas','show'],true);state=state.setIn(['modalAddFirmas','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["d" /* adjunto */])()));state=state.setIn(['modalAddFirmas','data','documento_id'],documento_id);state=state.setIn(['modalAddFirmas','data','clasificacion'],'CONTRATO FIRMADO');state=state.setIn(['modalAddFirmas','data','observaciones'],'Contrato firmado y aceptado por el proveedor');state=state.setIn(['modalAddFirmas','data','editable'],0);}else{state=state.set('modalAddFirmas',INITIAL_STATE.get('modalAddFirmas'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_90" /* DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO */]:return state.setIn(['modalCreateDocumento','btnDisabled'],action.payload);default:return state;}});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
// import { tableCols } from '../containers/ExternosAprobaciones'
// const columnas = Immutable.fromJS(tableCols)
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({aprobaciones:[],page:1,showRecords:100,totalRecords:0,orderBy:{field:null,asc:false},modalFilter:{show:false,columnas:[],filters:[]},modalSummary:{show:false,data:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var columnas=state.getIn(['modalFilter','columnas']);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_292" /* OBTENER_EXTERNOS_APROBACIONES */]:state=state.set('aprobaciones',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_324" /* ORDENAR_EXTERNOS_APROBACIONES */]:state=state.set('orderBy',action.payload.orderBy);return state;// case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES:
//     state = state.setIn(['modalFilter', 'show'], action.payload)
//     return state
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_269" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES */]:state=state.setIn(['modalFilter','show'],action.payload.state);state=state.setIn(['modalFilter','columnas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.tableCols));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["p" /* ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */]:var firstCol=columnas.first();state=state.updateIn(['modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('value'),operator:'===',value:'',checked:false,comparison:firstCol.get('type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_142" /* ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */]:state=state.setIn(['modalFilter','filters'],state.getIn(['modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_47" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */]:state=state.setIn(['modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_183" /* MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES */]:if(action.payload.attr==='column'){state=state.setIn(['modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('value')===action.payload.value;}).get('type'));}state=state.setIn(['modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_21" /* APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES */]:state=state.updateIn(['modalFilter','filters'],function(filter){return filter.map(function(x){x=x.set('apply',true);return x;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_35" /* CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES */]:state=state.set('showRecords',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_280" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES */]:if(action.payload.show){state=state.setIn(['modalSummary','show'],true);state=state.setIn(['modalSummary','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));}else{state=state.set('modalSummary',INITIAL_STATE.get('modalSummary'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_198" /* MODIFICAR_INPUTS_EXTERNOS_APROBACIONES */]:if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;default:return state;}});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,documento:null,modalSummary:{show:false,data:{},unchanged:{},url:'',type:'',editar:false},modalCreateVerificacion:{show:false,data:null,unchanged:null,url:'',type:''},modalCreateEntrega:{show:false,data:null,unchanged:null,criterios:{},url:'',type:''},modalAddAdicional:{show:false,guardando:false,data:null,unchanged:null,detalles:[],url:'',type:''}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_197" /* MODIFICAR_INPUTS_DOCUMENTOS */]:if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_279" /* MOSTRAR_MODAL_RESUMEN_DOCUMENTO */]:if(action.payload.show){state=state.setIn(['modalSummary','show'],true);state=state.setIn(['modalSummary','url'],action.payload.url);state=state.setIn(['modalSummary','type'],action.payload.type);}else{state=state.set('modalSummary',INITIAL_STATE.get('modalSummary'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_262" /* MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO */]:if(action.payload.show){var entregas=state.getIn(['modalSummary','data','entregas']);var index=entregas.findIndex(function(e){return e.get('id')==action.payload.id;});state=state.setIn(['modalCreateEntrega','show'],true);state=state.setIn(['modalCreateEntrega','data'],state.getIn(['modalSummary','data','entregas',String(index)]));state=state.setIn(['modalCreateEntrega','criterios'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.criterios));state=state.setIn(['modalCreateEntrega','unchanged'],state.getIn(['modalSummary','data','entregas',String(index)]));state=state.setIn(['modalCreateEntrega','url'],state.getIn(['modalSummary','url']));state=state.setIn(['modalCreateEntrega','type'],state.getIn(['modalSummary','type']));}else{state=state.set('modalCreateEntrega',INITIAL_STATE.get('modalCreateEntrega'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_230" /* MOSTRAR_MODAL_ADICIONAR_ADICIONAL */]:if(action.payload.show){var documento_id=state.getIn(['documento','id'])?state.getIn(['documento','id']):null;state=state.setIn(['modalAddAdicional','show'],true);state=state.setIn(['modalAddAdicional','url'],action.payload.url);state=state.setIn(['modalAddAdicional','type'],action.payload.type);state=state.setIn(['modalAddAdicional','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["c" /* adicion */])(documento_id)));state=state.setIn(['modalAddAdicional','data','fecha_entrega'],state.getIn(['modalSummary','data','fecha_entrega']));state=state.setIn(['modalAddAdicional','detalles'],state.getIn(['modalSummary','data','detalles']));}else{state=state.set('modalAddAdicional',INITIAL_STATE.get('modalAddAdicional'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["Y" /* ADICIONAR_NUEVO_CENCO_ADICIONAL */]:var actual=state.getIn(['modalAddAdicional','data','cencos']).reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);state=state.updateIn(['modalAddAdicional','data','cencos'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["S" /* solicitudservicioitemcenco */])(actual)));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_130" /* ELIMINAR_CENCOS_ADICIONAL */]:state=state.updateIn(['modalAddAdicional','data','cencos'],function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["c" /* ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO */]:var ops=__WEBPACK_IMPORTED_MODULE_2_immutablediff___default()(state.getIn(['modalSummary','data']),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));state=state.setIn(['modalSummary','data'],__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.getIn(['modalSummary','data']),ops));state=state.setIn(['modalSummary','unchanged'],__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.getIn(['modalSummary','data']),ops));var solicitud=state.getIn(['modalSummary','data','solicitude']);var solicitud_id=solicitud.get('id');var type=__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["m" /* enums */].solicitudes.tipos[solicitud.get('tipo')].type;var url='solicitudes/'+__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["m" /* enums */].solicitudes.tipos[solicitud.get('tipo')].url+'/'+solicitud_id;state=state.setIn(['modalSummary','type'],type);state=state.setIn(['modalSummary','url'],url);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_122" /* ELIMINAR_ARCHIVOS_DOCUMENTO */]:state=state.updateIn(['modalSummary','data','adjuntos'],function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_267" /* MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO */]:if(action.payload.show){state=state.setIn(['modalCreateVerificacion','show'],true);state=state.setIn(['modalCreateVerificacion','data'],state.getIn(['modalSummary','data','verificaciones_sst',String(action.payload.index)]));state=state.setIn(['modalCreateVerificacion','unchanged'],state.getIn(['modalSummary','data','verificaciones_sst',String(action.payload.index)]));state=state.setIn(['modalCreateVerificacion','url'],state.getIn(['modalSummary','url']));state=state.setIn(['modalCreateVerificacion','type'],state.getIn(['modalSummary','type']));}else{state=state.set('modalCreateVerificacion',INITIAL_STATE.get('modalCreateVerificacion'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_97" /* DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION */]:state=state.setIn(['modalAddAdicional','guardando'],action.payload);return state;default:return state;}});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fs__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fs__);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({fecha_solicitud:__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),motivo_viaje:null,tipo_viaje:1,asistencia_viajero:false,tipo_trayecto:1,cant_pasajeros:1,tiquete_comprado:null,adjuntos:[],observaciones:'',trayectos:[Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["U" /* trayecto */])()],pasajeros:[Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["K" /* pasajero */])()],btnSaveDisabled:false,cencos:[],tipo:4,foros:[],comentario:{guid:null,texto:null},flagAdjunto:false});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var index=void 0,trayectos=void 0,pasajeros=void 0,adjuntos=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_343" /* REINICIAR_SOLICITUD_TIQUETESAEREO */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_220" /* MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO */]:if(Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(state.get('cant_pasajeros')>state.get('pasajeros').count()){for(var i=state.get('pasajeros').count();i<state.get('cant_pasajeros');i++){state=state.setIn(['pasajeros',i],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["K" /* pasajero */])()));}}if(state.get('cant_pasajeros')<state.get('pasajeros').count()){pasajeros=state.get('pasajeros').toJS().splice(0,state.get('cant_pasajeros'));state=state.set('pasajeros',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(pasajeros));}if(action.payload.path=='tipo_viaje'){if(action.payload.value==1){state=state.setIn(['pasajeros',0,'cedula'],null).setIn(['pasajeros',0,'pasaporte'],null).setIn(['pasajeros',0,'pais_expedicion'],null).setIn(['pasajeros',0,'fecha_caducidad_pasaporte'],null).setIn(['pasajeros',0,'pasaporte_adjunto'],null);}if(action.payload.value==2){state=state.setIn(['pasajeros',0,'cedula'],null).setIn(['pasajeros',0,'pasaporte'],null).setIn(['pasajeros',0,'nacionalidad'],null).setIn(['pasajeros',0,'pais_expedicion'],null).setIn(['pasajeros',0,'fecha_caducidad_pasaporte'],null).setIn(['pasajeros',0,'pasaporte_adjunto'],null);}}if(action.payload.path=='tipo_trayecto'&&action.payload.value!=3){trayectos=state.get('trayectos').toJS().splice(0,1);state=state.set('trayectos',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(trayectos));}if(action.payload.path=='tipo_trayecto'&&action.payload.value!=1){state.get('pasajeros').map(function(p,i){state=state.setIn(['pasajeros',i,'asistencia','fecha_regreso'],null);});}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_17" /* ADICIONAR_TRAYECTO */]:index=state.get('trayectos').count();state=state.setIn(['trayectos',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["U" /* trayecto */])()));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_356" /* REMOVER_TRAYECTOS */]:state=state.update('trayectos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_96" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO */]:state=state.set('btnSaveDisabled',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_16" /* ADICIONAR_PASAPORTE */]:state=state.setIn(['pasajeros',action.payload.index,'pasaporte_adjunto'],action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["B" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO */]:state=state.setIn(action.payload.path.split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_4" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO */]:var actual=state.get('cencos').reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);state=state.update('cencos',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["P" /* solicitudcenco */])(actual)));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_348" /* REMOVER_CENCOS_TIQUETESAEREOS */]:state=state.update('cencos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_169" /* ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});if(index===-1){var data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["r" /* foro */])(action.payload.usuario,action.payload.comentario));state=state.set('foros',state.get('foros').push(data));}else{state=state.setIn(['foros',index,'comentario'],action.payload.comentario);}state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_119" /* EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.setIn(['comentario','guid'],action.payload.guid);state=state.setIn(['comentario','texto'],state.getIn(['foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_139" /* ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.deleteIn(['foros',index]);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["X" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1 */]:index=action.payload;adjuntos=state.get('adjuntos').findIndex(function(x){return x.get('guid')===index.get('guid');});index=index.set('nombre',''+index.get('nombre'));if(adjuntos===-1){state=state.set('adjuntos',state.get('adjuntos').push(index));}else{index=index.set('updated',true);state=state.setIn(['adjuntos',String(adjuntos)],index);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_129" /* ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO */]:state=state.update('adjuntos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;default:return state;}});

/***/ }),
/* 549 */
/***/ (function(module, exports) {



/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,estado:0,solicitud:{},aprobadores:{},unchaged:{},btnSaveDisabled:true,btnRComprasDisabled:true,modified:[],modalAddCotizacion:{title:'',mode:'',show:false,data:null,btnDisabled:false},modalAddTiquete:{title:'',show:false,index:null,data:null,btnDisabled:false},modalSelectVersion:{title:'',show:false,index:null,data:null,btnDisabled:false},modalAddAsistencia:{title:'',show:false,index:null,data:null,btnDisabled:false},addModificacion:false,comentario:{id:null,texto:null,btnSendDisabled:false},flagAdjunto:false,adjuntos:[]});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var index=void 0,adjuntos=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["N" /* ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO */]:state=state.set('modified',state.get('modified').filter(function(x){return x.get('entity')+x.get('attribute')+x.get('id')!==action.payload.entity+action.payload.attribute+action.payload.id;}));state=state.update('modified',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));});state=state.set('btnSaveDisabled',state.get('modified').count()===0);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_311" /* OBTENER_SOLICITUD_TIQUETESAEREO */]:action.payload.solicitud.cotizaciones=action.payload.solicitud.cotizaciones.filter(function(cot){return cot.viaje.filter(function(v){return v.activo;}).length>0;});action.payload.aprobadores=action.payload.aprobadores.filter(function(a1){a1.aprobaciones=a1.aprobaciones.filter(function(a2){return action.payload.solicitud.cotizaciones.findIndex(function(cot){return a2.cotizacione.id==cot.id;})>=0;});return a1.aprobaciones.length>0;});state=state.set('id',action.payload.solicitud.id);state=state.set('estado',action.payload.solicitud.estado);state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('unchaged',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));if(action.payload.reset!==false){state=state.set('modified',INITIAL_STATE.get('modified'));}state=state.set('btnSaveDisabled',state.get('modified').count()===0);state.getIn(['solicitud','cotizaciones']).map(function(c,i){c.get('aprobaciones').map(function(a,j){state=state.setIn(['solicitud','cotizaciones',i,'aprobaciones',j,'selected'],false);});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_233" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO */]:state=state.setIn(['modalAddCotizacion','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalAddCotizacion','title'],action.payload.title);state=state.setIn(['modalAddCotizacion','mode'],action.payload.mode);if(action.payload.mode==='create'){state=state.setIn(['modalAddCotizacion','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* cotizacion */])()));}else if(action.payload.mode==='edit'){state=state.setIn(['modalAddCotizacion','data'],state.getIn(['solicitud','cotizaciones',action.payload.index]));}}else{state=state.set('modalAddCotizacion',INITIAL_STATE.get('modalAddCotizacion'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_237" /* MOSTRAR_MODAL_ADICIONAR_TIQUETE */]:state=state.setIn(['modalAddTiquete','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalAddTiquete','title'],action.payload.title);state=state.setIn(['modalAddTiquete','index'],action.payload.index);state=state.setIn(['modalAddTiquete','data'],state.getIn(['solicitud','viaje','pasajeros',action.payload.index]));}else{state=state.set('modalAddTiquete',INITIAL_STATE.get('modalAddTiquete'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_283" /* MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO */]:state=state.setIn(['modalSelectVersion','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalSelectVersion','title'],action.payload.title);state=state.setIn(['modalSelectVersion','index'],action.payload.index);state=state.setIn(['modalSelectVersion','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));}else{state=state.set('modalSelectVersion',INITIAL_STATE.get('modalSelectVersion'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_231" /* MOSTRAR_MODAL_ADICIONAR_ASISTENCIA */]:state=state.setIn(['modalAddAsistencia','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalAddAsistencia','title'],action.payload.title);state=state.setIn(['modalAddAsistencia','index'],action.payload.index);state=state.setIn(['modalAddAsistencia','data'],state.getIn(['solicitud','viaje','pasajeros',action.payload.index]));}else{state=state.set('modalAddAsistencia',INITIAL_STATE.get('modalAddAsistencia'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_221" /* MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1 */]:if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(action.payload.path.split('.').slice(-1)[0]=='responsable_compras'||action.payload.path.split('.').slice(-1)[0]=='solicitante'){state=state.set('btnRComprasDisabled',false);}if(state.getIn(['solicitud','viaje','cant_pasajeros'])>state.getIn(['solicitud','viaje','pasajeros']).count()){for(var i=state.getIn(['solicitud','viaje','pasajeros']).count();i<state.getIn(['solicitud','viaje','cant_pasajeros']);i++){var p=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["K" /* pasajero */])();if(!state.getIn(['solicitud','viaje','asistencia_viajero'])){p.asistencia=null;}state=state.setIn(['solicitud','viaje','pasajeros',i],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(p));}}if(state.getIn(['solicitud','viaje','cant_pasajeros'])<state.getIn(['solicitud','viaje','pasajeros']).count()&&state.getIn(['solicitud','viaje','cant_pasajeros'])!=0){var pasajeros=state.getIn(['solicitud','viaje','pasajeros']).toJS().splice(0,state.getIn(['solicitud','viaje','cant_pasajeros']));state=state.setIn(['solicitud','viaje','pasajeros'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(pasajeros));}if(action.payload.path.split('.').slice(-1)[0]=='tipo_viaje'){for(var _i=0;_i<state.getIn(['solicitud','viaje','cant_pasajeros']);_i++){state=state.setIn(['solicitud','viaje','pasajeros',_i,'guid'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["B" /* guid */])());}}if(action.payload.path.split('.').slice(-1)[0]=='tipo_trayecto'&&action.payload.value!=3){var trayectos=state.getIn(['solicitud','viaje','trayectos']).toJS().splice(0,1);state=state.setIn(['solicitud','viaje','trayectos'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(trayectos));}if(action.payload.path.split('.').slice(-1)[0]=='tipo_trayecto'&&action.payload.value!=1){state.getIn(['solicitud','viaje','pasajeros']).map(function(p,i){if(state.getIn(['solicitud','viaje','pasajeros',i,'asistencia'])!=null)state=state.setIn(['solicitud','viaje','pasajeros',i,'asistencia','fecha_regreso'],null);});}if(action.payload.path.split('.').slice(-1)[0]=='asistencia_viajero'){state.getIn(['solicitud','viaje','pasajeros']).map(function(p,i){if(!state.getIn(['solicitud','viaje','pasajeros',i,'asistencia'])&&action.payload.value)state=state.setIn(['solicitud','viaje','pasajeros',i,'asistencia'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["f" /* asistencia */])()));else if(!action.payload.value)state=state.setIn(['solicitud','viaje','pasajeros',i,'asistencia'],null);});}// if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
//     let newPath = action.payload.path.split('.')
//     newPath = newPath.splice(0, newPath.length-1)
//     if (newPath[newPath.length-1] == 'pivot') {
//         state = state.setIn([...newPath, 'selected'], true)
//     }
// }
return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["W" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO */]:state=state.setIn((''+action.payload.path).split('.'),action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["X" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1 */]:index=action.payload;adjuntos=state.get('adjuntos').findIndex(function(x){return x.get('guid')===index.get('guid');});index=index.set('nombre',''+index.get('nombre'));if(adjuntos===-1){state=state.set('adjuntos',state.get('adjuntos').push(index));}else{index=index.set('updated',true);state=state.setIn(['adjuntos',String(adjuntos)],index);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["o" /* ADICIONAR_COTIZACION_TIQUETESAEREO */]:index=state.getIn(['solicitud','cotizaciones']).findIndex(function(x){return x.get('guid')==action.payload.data.get('guid');});if(index==-1){index=state.getIn(['solicitud','cotizaciones']).count();}state=state.setIn(['solicitud','cotizaciones',index],action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_228" /* MODIFICAR_TIQUETE */]:state=state.setIn(['solicitud','viaje','pasajeros',action.payload.index],action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_182" /* MODIFICAR_ASISTENCIA */]:state=state.setIn(['solicitud','viaje','pasajeros',action.payload.index],action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_109" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO */]:state=state.set('btnSaveDisabled',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["i" /* ACTUALIZAR_SOLICITUD_TIQUETESAEREO */]:action.payload.solicitud.cotizaciones=action.payload.solicitud.cotizaciones.filter(function(cot){return cot.viaje.filter(function(v){return v.activo;}).length>0;});action.payload.aprobadores=action.payload.aprobadores.filter(function(a1){a1.aprobaciones=a1.aprobaciones.filter(function(a2){return action.payload.solicitud.cotizaciones.findIndex(function(cot){return a2.cotizacione.id==cot.id;})>=0;});return a1.aprobaciones.length>0;});var ops=__WEBPACK_IMPORTED_MODULE_2_immutablediff___default()(state.get('solicitud'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.get('solicitud'),ops));if(ops.filter(function(x){return x.get('path')==='/estado';}).count()===1){state=state.set('estado',state.getIn(['solicitud','estado']));}state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));state=state.set('btnRComprasDisabled',true);state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_362" /* SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO */]:state=state.updateIn(['aprobadores',action.payload.indexAprobador,'aprobaciones'],function(list){return list.map(function(x){return x.set('estado',1);});});state=state.setIn(['aprobadores',action.payload.indexAprobador,'aprobaciones',action.payload.indexAprobacion,'estado'],2);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_351" /* REMOVER_COTIZACION_TIQUETESAEREO */]:state=state.updateIn(['solicitud','cotizaciones'],function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_110" /* EDITAR_ARCHIVO_PASAPORTE */]:var data=action.payload.data.get('id')?action.payload.data.set('id',null):action.payload.data;data=data.get('guid')?data.set('guid',Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["B" /* guid */])()):data;state=state.setIn(['solicitud','viaje','pasajeros',action.payload.index,'adjunto'],data);state=state.setIn(['solicitud','viaje','pasajeros',action.payload.index,'adjunto_id'],null);state=state.setIn(['solicitud','viaje','pasajeros',action.payload.index,'guid'],Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["B" /* guid */])());return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["C" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1 */]:state=state.setIn(action.payload.path.split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_18" /* ADICIONAR_TRAYECTO1 */]:index=state.getIn(['solicitud','viaje','trayectos']).count();state=state.setIn(['solicitud','viaje','trayectos',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["U" /* trayecto */])()));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_357" /* REMOVER_TRAYECTOS1 */]:state=state.updateIn(['solicitud','viaje','trayectos'],function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_5" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1 */]:var actual=state.getIn(['solicitud','viaje','cencos']).reduce(function(a,b){a+=Number(b.getIn(['pivot','porcentaje']));return a;},0);state=state.updateIn(['solicitud','viaje','cencos'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({pivot:Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["P" /* solicitudcenco */])(actual)}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_349" /* REMOVER_CENCOS_TIQUETESAEREOS1 */]:return state.updateIn(['solicitud','viaje','cencos'],function(list){return list.filter(function(x){return!x.get('selected');});});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_120" /* EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1 */]:index=state.getIn(['solicitud','foros']).findIndex(function(c){return c.get('id')===action.payload.id;});state=state.setIn(['comentario','id'],action.payload.id);state=state.setIn(['comentario','texto'],state.getIn(['solicitud','foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_89" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1 */]:state=state.setIn(['comentario','btnSendDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_164" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1 */]:state=state.setIn(['solicitud','foros'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.foros));state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;default:return state;}});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,estado:0,solicitud:{},btnSaveDisabled:true,modified:[]});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_358" /* RESETEAR_REDUCER_SOLICITUD_OTROSI */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_308" /* OBTENER_SOLICITUD_OTROSI */]:state=state.set('id',action.payload.solicitud.id);state=state.set('estado',action.payload.solicitud.estado);state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));if(action.payload.reset!==false){state=state.set('modified',INITIAL_STATE.get('modified'));}state=state.set('btnSaveDisabled',state.get('modified').count()===0);return state;default:return state;}});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_exact_math__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(2);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,estado:0,solicitud:{},tipo_almacen:"",unchaged:{},aprobadores:[],btnSaveDisabled:true,btnRComprasDisabled:true,btnAproveDisabled:false,modified:[],modalCreateDocumento:{title:'',mode:'',show:false,data:null,btnDisabled:false,plantillas:[],garantias:[],unchanged:null,contratoanual:false,contratosAnuales:[]},modalCreateCompraDirecta:{title:'',show:false,data:null,unchaged:null,bien_id:0,cot_id:0,bien_descripcion:'',bien_cantidad:0},addModificacion:false,remove:[],moneda:'COP',comentario:{id:null,texto:null,btnSendDisabled:false}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var path=void 0,nuevaCotizacion=void 0,indexBien=void 0,bien=void 0,newItem=void 0;var _ret=function(){switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["I" /* ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION */]:state=state.set('modified',state.get('modified').filter(function(x){return x.get('entity')+x.get('attribute')+x.get('id')!==action.payload.entity+action.payload.attribute+action.payload.id;}));state=state.update('modified',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));});state=state.set('btnSaveDisabled',state.get('modified').count()===0);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_305" /* OBTENER_SOLICITUD_BIENES_INVESTIGACION */]:state=state.set('id',action.payload.solicitud.id);state=state.set('estado',action.payload.solicitud.estado);state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('unchaged',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('tipo_almacen',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.tipo_almacen));state=state.set('modified',INITIAL_STATE.get('modified'));state=state.set('btnSaveDisabled',state.get('modified').count()===0);if(state.getIn(['solicitud','cotizaciones']).count()>0){state=state.set('moneda',state.getIn(['solicitud','cotizaciones',0,'moneda']));}else{state=state.set('moneda',INITIAL_STATE.get('moneda'));}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_366" /* SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1 */]:state=state.set('moneda',action.payload.moneda);state.getIn(['solicitud','bienes']).map(function(b,ib){b.get('cotizaciones').map(function(c,ic){var cotizacion=c.set('moneda',action.payload.moneda);state=state.setIn(['solicitud','bienes',ib,'cotizaciones',ic],cotizacion);});});state=state.set('btnSaveDisabled',false);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_211" /* MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1 */]:path=(''+action.payload.path).split('.');if(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn(path,action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn(path,action.payload.value);}else{state=state.setIn(path,__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(action.payload.path==='solicitud.bienes.0.fecha_cotizaciones'){for(var i=0;i<state.getIn(['solicitud','bienes']).count();i++){state=state.setIn(['solicitud','bienes',i,'fecha_cotizaciones'],action.payload.value);}}// if (action.payload.path.match(/solicitud.bienes.\d.compra_directa/)) {
//     state = state.setIn(path.slice(0,3).concat(['cotizaciones']), Immutable.fromJS([]))
// }
if(path[path.length-1]==='item'){state=state.set('btnSaveDisabled',false);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_administracion'){var _cotizado=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var porcentaje=state.getIn(['modalCreateDocumento','data','aiu_administracion']);var valor=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(_cotizado,porcentaje);state=state.setIn(['modalCreateDocumento','data','aiu_administracion_value'],valor);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_imprevistos'){var _cotizado2=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var _porcentaje=state.getIn(['modalCreateDocumento','data','aiu_imprevistos']);var _valor=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(_cotizado2,_porcentaje);state=state.setIn(['modalCreateDocumento','data','aiu_imprevistos_value'],_valor);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_utilidad'){var _cotizado3=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var _porcentaje2=state.getIn(['modalCreateDocumento','data','aiu_utilidad']);var _valor2=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(_cotizado3,_porcentaje2);state=state.setIn(['modalCreateDocumento','data','aiu_utilidad_value'],_valor2);}if(action.payload.path.split('.').slice(-1)[0]=='aiu_iva_utilidad'||action.payload.path.split('.').slice(-1)[0]=='aiu_utilidad'){var utilidad=state.getIn(['modalCreateDocumento','data','aiu_utilidad_value']);var _porcentaje3=state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad']);var _valor3=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(utilidad,_porcentaje3);state=state.setIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'],_valor3);}if(action.payload.path.split('.').slice(-1)[0]=='iva'&&action.payload.path.split('.').indexOf("modalCreateDocumento")>=0){var _cotizado4=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var _porcentaje4=state.getIn(['modalCreateDocumento','data','iva']);var _valor4=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(_cotizado4,_porcentaje4);state=state.setIn(['modalCreateDocumento','data','iva_value'],_valor4);}if(action.payload.path.split('.').slice(-1)[0]=='iva_value'&&action.payload.path.split('.').indexOf("modalCreateDocumento")>=0){var _cotizado5=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var total_iva=state.getIn(['modalCreateDocumento','data','iva_value'])||0;var _valor5=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["w" /* getPorcentajeFromTotal */])(_cotizado5,total_iva);state=state.setIn(['modalCreateDocumento','data','iva'],_valor5);}if(state.getIn(['modalCreateDocumento','data'])){var aiu_administracion_value=state.getIn(['modalCreateDocumento','data','aiu_administracion_value']);var aiu_imprevistos_value=state.getIn(['modalCreateDocumento','data','aiu_imprevistos_value']);var aiu_utilidad_value=state.getIn(['modalCreateDocumento','data','aiu_utilidad_value']);var aiu_iva_utilidad_value=state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad_value']);var iva=state.getIn(['modalCreateDocumento','data','iva_value'])||0;var _cotizado6=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var _aiu_total=aiu_administracion_value+'+'+aiu_imprevistos_value+'+'+aiu_utilidad_value+'+'+aiu_iva_utilidad_value+'+'+iva+'+'+_cotizado6;state=state.setIn(['modalCreateDocumento','data','aiu_total'],__WEBPACK_IMPORTED_MODULE_5_exact_math___default.a.formula(_aiu_total));// state = state.setIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado_iva'], cotizado + aiu_total)
if(action.payload.path.split('.').slice(-1)[0]=='tipo'){state=state.setIn(['modalCreateDocumento','data','plantilla_id'],0);}if(action.payload.path.split('.').slice(-1)[0]=='contratoanual'){state=state.setIn(['modalCreateDocumento','data','documento_id'],null);state=state.setIn(['modalCreateDocumento','data','tipo'],0);state=state.setIn(['modalCreateDocumento','data','plantilla_id'],-1);state=state.setIn(['modalCreateDocumento','data','consecutivo'],'');}}if(action.payload.path.split('.').slice(-1)[0]=='responsable_compras'||action.payload.path.split('.').slice(-1)[0]=='solicitante'){state=state.set('btnRComprasDisabled',false);}// if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
//     let newPath = action.payload.path.split('.')
//     newPath = newPath.splice(0, newPath.length-1)
//     if (newPath[newPath.length-1] == 'pivot') {
//         state = state.setIn([...newPath, 'selected'], true)
//     }
// }
if(action.payload.path.split('.').slice(-1)[0]=='tipo_almacen'){if(action.payload.value==='Laboratorio'){state=state.setIn(['solicitud','tipo'],6);}else{state=state.setIn(['solicitud','tipo'],7);}}if(action.payload.path=='modalCreateCompraDirecta.data.proveedor'){state=state.setIn(['modalCreateCompraDirecta','data','razon_social'],'');}if(action.payload.path=='modalCreateCompraDirecta.data.razon_social'){state=state.setIn(['modalCreateCompraDirecta','data','proveedor'],null);}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_369" /* SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION */]:path=(''+action.payload.path).split('.');for(var _i=0;_i<state.getIn(path).count();_i++){state=state.setIn(path.concat([_i,'selected']),action.payload.value);}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["H" /* ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION */]:newItem=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["A" /* grupoItem */])());state=state.updateIn(['solicitud','grupo_cotizaciones'],function(list){return list.concat([newItem]);});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_6" /* ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION */]:nuevaCotizacion=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["i" /* cotizacion */])();var fecha_entrega=__WEBPACK_IMPORTED_MODULE_4_moment___default()(state.getIn(['solicitud','fecha_requerido'])).format('YYYY-MM-DD');nuevaCotizacion.fecha_entrega=fecha_entrega;nuevaCotizacion.servicio=state.getIn(['solicitud','bienes',action.payload.indexServicio]);state=state.updateIn((''+action.payload.path).split('.'),function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(nuevaCotizacion));});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["l" /* ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION */]:nuevaCotizacion=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["i" /* cotizacion */])();nuevaCotizacion.estado=3;state=state.updateIn((''+action.payload.path).split('.'),function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(nuevaCotizacion));});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["x" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION */]:path=action.payload.path.split('.');var bienes=state.getIn(path);bienes.map(function(b,i){var index=b.get('cotizaciones').findIndex(function(x){return x.get('proveedor_id')==action.payload.value.id;});if(b.get('selected')&&b.get('cantidad_solicitada')>0&&index==-1){var nuevacotizacion1=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["i" /* cotizacion */])();var nuevacotizacion2=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["i" /* cotizacion */])();nuevacotizacion1.proveedor_id=action.payload.value.id;nuevacotizacion1.proveedore=action.payload.value;nuevacotizacion2.proveedor_id=action.payload.value.id;nuevacotizacion2.proveedore=action.payload.value;state=state.updateIn(['solicitud','bienes',i,'cotizaciones'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(nuevacotizacion1));});state=state.updateIn(['solicitud','bienes',i,'cotizaciones'],function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(nuevacotizacion2));});}state=state.setIn(['solicitud','bienes',i,'selected'],false);});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_352" /* REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION */]:var index=state.getIn(['solicitud','bienes']).findIndex(function(x){return x.get('id')==action.payload.bien_id;});if(index!=-1){var _cotizaciones=state.getIn(['solicitud','bienes',index,'cotizaciones']).filter(function(cotizacion){return cotizacion.get('proveedor_id')!=action.payload.proveedor_id;});state=state.setIn(['solicitud','bienes',index,'cotizaciones'],_cotizaciones);}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_363" /* SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION */]:var cotizacion_actual=state.getIn(['solicitud','bienes',action.payload.bien_idx,'cotizaciones']).filter(function(cotizacion){return cotizacion.get('id')==action.payload.cotizacion_id;});if(cotizacion_actual.count()>0){state=state.setIn(['solicitud','bienes',action.payload.bien_idx,'cotizaciones_aprobar',action.payload.cotizacion_aprobar_idx],cotizacion_actual.get(0));state=state.setIn(['unchaged','bienes',action.payload.bien_idx,'cotizaciones_aprobar',action.payload.cotizacion_aprobar_idx],cotizacion_actual.get(0));}return{v:state};// case types.ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION:
// 	state = state.updateIn(`${action.payload.path}`.split('.'), list => list.filter(x => !x.get('selected')))
//     return state
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_83" /* DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */]:state=state.set('btnSaveDisabled',action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_80" /* DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION */]:state=state.set('btnAproveDisabled',action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["d" /* ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION */]:var solicitudActualizada=action.payload.solicitud;for(var _index=0;_index<solicitudActualizada.bienes.length;_index++){solicitudActualizada.bienes[_index].cotizaciones_aprobar=solicitudActualizada.bienes[_index].cotizaciones.filter(function(ele){return ele.estado===4;});}var ops=__WEBPACK_IMPORTED_MODULE_2_immutablediff___default()(state.get('solicitud'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(solicitudActualizada));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.get('solicitud'),ops));if(ops.filter(function(x){return x.get('path')==='/estado';}).count()===1){state=state.set('estado',state.getIn(['solicitud','estado']));}for(var _i2=0;_i2<action.payload.aprobadores.length;_i2++){for(var j=0;j<action.payload.aprobadores[_i2].aprobaciones.length;j++){action.payload.aprobadores[_i2].aprobaciones[j].selected=action.payload.aprobadores[_i2].aprobaciones[j].estado===2;}}state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));state=state.set('btnRComprasDisabled',true);state=state.set('unchaged',state.get('solicitud'));state=state.set('addModificacion',false);state=state.set('comentario',INITIAL_STATE.get('comentario'));return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_42" /* CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION */]:var bien_id=action.payload.bien_id;var proveedor_id=action.payload.proveedor_id;var bien_idx=state.getIn(['solicitud','bienes']).findIndex(function(b){return b.get('id')==bien_id;});var cotizaciones=state.getIn(['solicitud','bienes',bien_idx,'cotizaciones']);cotizaciones.map(function(cotizacion,cotizacion_idx){if(cotizacion.get('proveedor_id')==proveedor_id){var recomendado=!state.getIn(['solicitud','bienes',bien_idx,'cotizaciones',cotizacion_idx,'recomendado']);state=state.setIn(['solicitud','bienes',bien_idx,'cotizaciones',cotizacion_idx,'recomendado'],recomendado);}else{state=state.setIn(['solicitud','bienes',bien_idx,'cotizaciones',cotizacion_idx,'recomendado'],false);}});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_45" /* CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION */]:var indexAprobador=state.get('aprobadores').findIndex(function(x){return x.get('id')==action.payload.aprobador_id;});var indexAprobacion=state.getIn(['aprobadores',indexAprobador,'aprobaciones']).findIndex(function(x){return x.get('id')==action.payload.aprobacion_id;});var aprobaciones=state.getIn(['aprobadores',indexAprobador,'aprobaciones']).filter(function(x){return x.getIn(['cotizacione','bienes',0,'id'])==action.payload.bien_id;});var _loop=function _loop(_i3){var index=state.getIn(['aprobadores',indexAprobador,'aprobaciones']).findIndex(function(x){return x.get('id')==aprobaciones.getIn([_i3,'id']);});state=state.setIn(['aprobadores',indexAprobador,'aprobaciones',index,'estado'],1);};for(var _i3=0;_i3<aprobaciones.count();_i3++){_loop(_i3);}state=state.setIn(['aprobadores',indexAprobador,'aprobaciones',indexAprobacion,'estado'],3);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_62" /* CONMUTAR_SELECCION_TODOS_BIENES */]:state.getIn(['solicitud','bienes']).forEach(function(x,n){state=state.setIn(['solicitud','bienes',n,'selected'],action.payload);});return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_33" /* CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION */]:var cotizado=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var iva_value=getTotalConIva(state.getIn(['modalCreateDocumento','data']))-getTotalSinIva(state.getIn(['modalCreateDocumento','data']));state=state.setIn(['modalCreateDocumento','data','iva_value'],iva_value);state=state.setIn(['modalCreateDocumento','data','iva'],Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["w" /* getPorcentajeFromTotal */])(cotizado,iva_value)||0);var formula=state.getIn(['modalCreateDocumento','data','aiu_administracion_value'])+'\n                + '+state.getIn(['modalCreateDocumento','data','aiu_imprevistos_value'])+'\n                + '+state.getIn(['modalCreateDocumento','data','aiu_utilidad_value'])+'\n                + '+state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'])+'\n                + '+state.getIn(['modalCreateDocumento','data','iva_value'])+'\n                + '+cotizado;var aiu_total=__WEBPACK_IMPORTED_MODULE_5_exact_math___default.a.formula(formula);state=state.setIn(['modalCreateDocumento','data','aiu_total'],aiu_total);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_258" /* MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION */]:state=state.setIn(['modalCreateDocumento','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalCreateDocumento','title'],action.payload.title);state=state.setIn(['modalCreateDocumento','mode'],action.payload.mode);state=state.setIn(['modalCreateDocumento','plantillas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.plantillas));state=state.setIn(['modalCreateDocumento','garantias'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.garantias));state=state.setIn(['modalCreateDocumento','contratosAnuales'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.contratos));if(action.payload.mode==='create'){var solicitud_id=state.get('id');var documento_id=state.getIn(['solicitud','documentos',action.payload.indexDocumento,'id']);var _proveedor_id=state.getIn(['solicitud','documentos',action.payload.indexDocumento,'proveedor','id']);state=state.setIn(['modalCreateDocumento','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["l" /* documento */])(documento_id,solicitud_id,_proveedor_id)));}else if(action.payload.mode==='edit'){state=state.setIn(['modalCreateDocumento','data'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));state=state.setIn(['modalCreateDocumento','unchanged'],state.getIn(['solicitud','documentos',action.payload.indexDocumento]));var tipo=state.getIn(['modalCreateDocumento','data','tipo']);var creado=state.getIn(['modalCreateDocumento','data','consecutivo'])?true:false;if(!creado){state=state.setIn(['modalCreateDocumento','data','entregas_parciales'],true);}if(!state.getIn(['modalCreateDocumento','data','fecha_inicio']))state=state.setIn(['modalCreateDocumento','data','fecha_inicio'],state.getIn(['solicitud','created_at']));if(!state.getIn(['modalCreateDocumento','data','fecha_entrega']))state=state.setIn(['modalCreateDocumento','data','fecha_entrega'],state.getIn(['solicitud','fecha_requerido']));var _cotizado7=getTotalSinIva(state.getIn(['modalCreateDocumento','data']));var aiu_adm=state.getIn(['modalCreateDocumento','data','aiu_administracion']);state=state.setIn(['modalCreateDocumento','data','aiu_administracion_value'],Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(_cotizado7,aiu_adm)||0);var aiu_imp=state.getIn(['modalCreateDocumento','data','aiu_imprevistos']);state=state.setIn(['modalCreateDocumento','data','aiu_imprevistos_value'],Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(_cotizado7,aiu_imp)||0);var aiu_uti=state.getIn(['modalCreateDocumento','data','aiu_utilidad']);state=state.setIn(['modalCreateDocumento','data','aiu_utilidad_value'],Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(_cotizado7,aiu_uti)||0);var aiu_iva_uti=state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad']);state=state.setIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'],Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(state.getIn(['modalCreateDocumento','data','aiu_utilidad_value']),aiu_iva_uti)||0);var _formula=(state.getIn(['modalCreateDocumento','data','aiu_administracion_value'])||0)+'\n                        + '+(state.getIn(['modalCreateDocumento','data','aiu_imprevistos_value'])||0)+'\n                        + '+(state.getIn(['modalCreateDocumento','data','aiu_utilidad_value'])||0)+'\n                        + '+(state.getIn(['modalCreateDocumento','data','aiu_iva_utilidad_value'])||0)+'\n                        + '+(state.getIn(['modalCreateDocumento','data','iva_value'])||0)+'\n                        + '+_cotizado7;var _aiu_total2=__WEBPACK_IMPORTED_MODULE_5_exact_math___default.a.formula(_formula);state=state.setIn(['modalCreateDocumento','data','aiu_total'],_aiu_total2);state=state.setIn(['modalCreateDocumento','data','almacen'],state.get('tipo_almacen'));if(tipo==5){state=state.setIn(['modalCreateDocumento','contratoanual'],true);}if(tipo==4){state=state.setIn(['modalCreateDocumento','data','anticipo'],0);}}}else{state=state.set('modalCreateDocumento',INITIAL_STATE.get('modalCreateDocumento'));}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_256" /* MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION */]:state=state.setIn(['modalCreateCompraDirecta','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalCreateCompraDirecta','title'],action.payload.title);indexBien=state.getIn(['solicitud','bienes']).findIndex(function(bien){return bien.get('id')===action.payload.bien_id;});bien=state.getIn(['solicitud','bienes',indexBien]);var facturaCompraDirecta=bien.get('factura_compra_directa');state=state.setIn(['modalCreateCompraDirecta','bien_id'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.bien_id));state=state.setIn(['modalCreateCompraDirecta','cot_id'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.cotizacion.get('id')));state=state.setIn(['modalCreateCompraDirecta','bien_descripcion'],bien.get('descripcion'));state=state.setIn(['modalCreateCompraDirecta','bien_cantidad'],bien.get('cantidad_solicitada'));state=state.setIn(['modalCreateCompraDirecta','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(facturaCompraDirecta||Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["h" /* compraDirectaItem */])()));state=state.setIn(['modalCreateCompraDirecta','data','razon_social'],action.payload.cotizacion.get('proveedor_nombre_cp'));state=state.setIn(['modalCreateCompraDirecta','unchanged'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(facturaCompraDirecta||{}));}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["E" /* ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION */]:if(action.payload.checked){var garantia=state.getIn(['modalCreateDocumento','garantias',String(action.payload.index)]);state=state.updateIn(['modalCreateDocumento','data','garantias'],function(list){return list.push(garantia);});}else{state=state.updateIn(['modalCreateDocumento','data','garantias'],function(list){return list.filter(function(g){return g.get('id')!==action.payload.id;});});}return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_100" /* DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION */]:state=state.setIn(['modalCreateDocumento','btnDisabled'],action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_10" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1 */]:newItem=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["O" /* solicitudbiitem */])());state=state.updateIn(['solicitud','bienes'],function(list){return list.push(newItem);});console.log(state.getIn(['solicitud']).toJS());return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_153" /* ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1 */]:console.log(state.getIn(['solicitud']).toJS());state=state.updateIn(['solicitud','bienes'],function(list){return list.filter(function(item){return!item.get('selected');});});state=state.set('remove',action.payload.remove);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_112" /* EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1 */]:var indexcomentario=state.getIn(['solicitud','foros']).findIndex(function(c){return c.get('id')===action.payload.id;});state=state.setIn(['comentario','id'],action.payload.id);state=state.setIn(['comentario','texto'],state.getIn(['solicitud','foros',indexcomentario,'comentario']));return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_85" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1 */]:state=state.setIn(['comentario','btnSendDisabled'],action.payload);return{v:state};case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_160" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1 */]:state=state.setIn(['solicitud','foros'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.foros));state=state.set('comentario',INITIAL_STATE.get('comentario'));return{v:state};default:return{v:state};}}();if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;});var getTotalSinIva=function getTotalSinIva(data){return data.get('detalles').reduce(function(acum,detalle){acum+=detalle.get('valor')*detalle.get('cantidad');return acum;},0)||0;};var getTotalConIva=function getTotalConIva(data){return data.get('detalles').reduce(function(acum,detalle){acum+=detalle.get('valor_con_iva')*detalle.get('cantidad');return acum;},0)||0;};

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Grupos__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var columnas=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(__WEBPACK_IMPORTED_MODULE_2__containers_Grupos__["b" /* tableCols */]);var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({grupos:[],permisos:[],permisosGrupo:[],page:1,selected:null,showRecords:100,totalRecords:0,orderBy:{field:null,asc:false},modalCreate:{title:'',mode:'',show:false,data:null,unchanged:null,btnDisabled:false},modalDelete:{show:false,action:null,message:null},modalFilter:{show:false,filters:[]}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var id=void 0;var data=void 0;var index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_296" /* OBTENER_GRUPOS */]:state=state.set('grupos',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);state=state.set('permisos',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.permisos));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_327" /* ORDENAR_GRUPOS */]:state=state.set('orderBy',action.payload.orderBy);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_264" /* MOSTRAR_MODAL_CREAR_GRUPO */]:state=state.setIn(['modalCreate','show'],action.payload.show);state=state.setIn(['modalCreate','title'],action.payload.title);state=state.setIn(['modalCreate','mode'],action.payload.mode);if(action.payload.mode==='create'){state=state.setIn(['modalCreate','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["z" /* grupo */])()));state=state.setIn(['modalCreate','unchanged'],state.setIn(['modalCreate','data']));}else if(action.payload.mode==='edit'){data=state.getIn(['grupos',String(action.payload.index)]);state=state.setIn(['modalCreate','data'],data);state=state.setIn(['modalCreate','unchanged'],data);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_204" /* MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS */]:state=state.setIn(['modalCreate','data',action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_77" /* CREAR_ACTUALIZAR_GRUPO */]:id=action.payload.id;index=state.get('grupos').findIndex(function(x){return x.get('id')===id;});if(index!==-1){state=state.setIn(['grupos',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));}else{state=state.set('grupos',state.get('grupos').push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload)));}state=state.setIn(['modalCreate','show'],false);state=state.setIn(['modalCreate','title'],'');state=state.setIn(['modalCreate','mode'],'');state=state.setIn(['modalCreate','data'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_105" /* DESHABILITAR_BOTON_MODAL_GRUPOS */]:state=state.setIn(['modalCreate','btnDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_250" /* MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO */]:state=state.setIn(['modalDelete','show'],action.payload.open);state=state.setIn(['modalDelete','action'],action.payload.action);state=state.setIn(['modalDelete','message'],action.payload.message);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_151" /* ELIMINAR_GRUPO */]:index=state.get('grupos').findIndex(function(x){return x.get('id')===action.payload;});state=state.deleteIn(['grupos',index]);state=state.setIn(['modalDelete','show'],false);state=state.setIn(['modalDelete','action'],null);state=state.setIn(['modalDelete','message'],null);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_272" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS */]:state=state.setIn(['modalFilter','show'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["s" /* ADICIONAR_CRITERIO_FILTRADO_GRUPOS */]:var firstCol=columnas.first();state=state.updateIn(['modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('value'),operator:'===',value:'',checked:false,comparison:firstCol.get('type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_145" /* ELIMINAR_CRITERIO_FILTRADO_GRUPOS */]:state=state.setIn(['modalFilter','filters'],state.getIn(['modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_50" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS */]:state=state.setIn(['modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_186" /* MODIFICAR_CRITERIO_FILTRADO_GRUPOS */]:if(action.payload.attr==='column'){state=state.setIn(['modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('value')===action.payload.value;}).get('type'));}state=state.setIn(['modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_24" /* APLICAR_CRITERIOS_FILTRADO_GRUPOS */]:state=state.updateIn(['modalFilter','filters'],function(filter){return filter.map(function(x){x=x.set('apply',true);return x;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_201" /* MODIFICAR_INPUTS_GRUPOS */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_365" /* SELECCIONAR_ITEM_GRUPOS */]:state=state.set('selected',action.payload);var permisos=state.get('permisos');var permisosGrupo=state.getIn(['grupos',String(action.payload),'permisos']);permisos=permisos.map(function(x){if(permisosGrupo.filter(function(k){return k.get('id')===x.get('id');}).count()!==0){x=x.set('selected',true);}return x;});state=state.set('permisosGrupo',permisos);return state;default:return state;}});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_grupos__ = __webpack_require__(114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PermisosGrupo=function(_Component){_inherits(PermisosGrupo,_Component);function PermisosGrupo(){_classCallCheck(this,PermisosGrupo);return _possibleConstructorReturn(this,(PermisosGrupo.__proto__||Object.getPrototypeOf(PermisosGrupo)).apply(this,arguments));}_createClass(PermisosGrupo,[{key:'render',value:function render(){var _this2=this;var _props=this.props,selected=_props.selected,grupo=_props.grupo,permisos=_props.permisos;if(selected===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{fontSize:'1.5em',color:'rgb(187,187,187)',fontStyle:'italic',fontWeight:'100'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'info-circle'}),' Seleccione un grupo para visualizar/modificar sus permisos'));}var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{key:'ba2[0]',name:'floppy-o',onClick:function onClick(e){return _this2.props.storePermisosGrupo();},title:'Guardar'})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_Box__["a" /* default */],{title:'Permisos del grupo',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-grupo-permisos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAll(e.target.checked);},checked:permisos.filter(function(x){return x.get('selected');}).count()===permisos.count()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Permiso'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,permisos.count()>0?permisos.map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr2['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.updateInputs('permisosGrupo.'+n+'.selected',e.target.checked);},checked:x.get('selected')||false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('nombre')));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:2},'No existen registros')))))));}}]);return PermisosGrupo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{selected:state.grupos.get('selected'),grupo:state.grupos.getIn(['grupos',String(state.grupos.get('selected'))]),permisos:state.grupos.get('permisosGrupo')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_grupos__["l" /* updateInputs */])(path,value,false));},toggleSelectAll:function toggleSelectAll(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_grupos__["k" /* toggleSelectAll */])(checked));},storePermisosGrupo:function storePermisosGrupo(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_grupos__["j" /* storePermisosGrupo */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PermisosGrupo));

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_grupos__ = __webpack_require__(114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreate=function(_Component){_inherits(ModalCreate,_Component);function ModalCreate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreate.__proto__||Object.getPrototypeOf(ModalCreate)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreate');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreate .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreate(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreate,[{key:'render',value:function render(){var _this2=this;var modalCreate=this.props.modalCreate;if(!modalCreate.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalCreate',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateGrupos(modalCreate.get('data'),modalCreate.get('mode'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:modalCreate.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreate.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreate.getIn(['data','nombre']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('nombre',e.target.value);},disabled:modalCreate.get('mode')==='edit'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:3,className:'form-control input-sm',value:modalCreate.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputsInModalCreate('descripcion',e.target.value);}})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalCreate:state.grupos.get('modalCreate')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreate:function displayModalCreate(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_grupos__["c" /* displayModalCreate */])(show,title,mode));},updateInputsInModalCreate:function updateInputsInModalCreate(attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_grupos__["m" /* updateInputsInModalCreate */])(attr,value));},createOrUpdateGrupos:function createOrUpdateGrupos(data,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_grupos__["a" /* createOrUpdateGrupos */])(data,mode));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreate));

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_grupos__ = __webpack_require__(114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalDelete:state.grupos.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_grupos__["h" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({documentos:[],busqueda:'',tipo:0});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_31" /* BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS */]:state=state.set('documentos',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_32" /* BUSQUEDADOCUMENTO_REINICIAR_ESTADO */]:state=INITIAL_STATE;return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_30" /* BUSQUEDADOCUMENTO_MODIFICAR_INPUTS */]:if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;default:return state;}});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({numberRegisters:100,total:0,purchasing_manager:null,storage_manage:null,cenco:null,total_storage:'',storage:'',request_type:false,reportToGet:'provider_evaluation',initial_date:'',final_date:'',provider_evaluation:{orderBy:{field:null,asc:false},data:[],accumulate:[],state_eval:'',provider:null,initial_date:'',final_date:'',modalFilter:{show:false,columns:[],filters:[]},//Paginacion
page:1,showRecords:100,totalRecords:0},contracted_amount_providers:{orderBy:{field:null,asc:false},data:[],modalFilter:{show:false,columns:[],filters:[]},provider:null,initial_date:'',final_date:'',//Paginacion
page:1,showRecords:100,totalRecords:0},contracted_amount_cencos:{orderBy:{field:null,asc:false},data:[],modalFilter:{show:false,columns:[],filters:[]},initial_date:'',final_date:'',//Paginacion
page:1,showRecords:100,totalRecords:0},compliance_purchasing_manager:{orderBy:{field:null,asc:false},data:[],modalFilter:{show:false,columns:[],filters:[]},initial_date:'',final_date:'',//Paginacion
page:1,showRecords:100,totalRecords:0},radicados:{orderBy:{field:null,asc:false},data:[],modalFilter:{show:false,columns:[],filters:[]},initial_date:'',final_date:'',//Paginacion
page:1,showRecords:100,totalRecords:0},manage_purchasing_manager:{orderBy:{field:null,asc:false},data:[],modalFilter:{show:false,columns:[],filters:[]},accumulate:[],initial_date:'',final_date:'',show_request_type:false,//Paginacion
page:1,showRecords:100,totalRecords:0},document_reporter:{initial_date:'',final_date:''}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var reportToGet=state.get('reportToGet');var columnas=state.getIn([reportToGet,'modalFilter','columns']);switch(action.type){// case types.MODIFICAR_NUMERO_REGISTROS_MOSTRAR:
//     return state.setIn(['numberRegisters'], action.number);
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_224" /* MODIFICAR_NUMERO_REGISTROS_MOSTRAR */]:state=state.setIn([action.reportToGet,'showRecords'],Number(action.number));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_208" /* MODIFICAR_INPUTS_REPORTES */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_329" /* ORDENAR_REPORTES */]:state=state.setIn([action.payload.reportToGet,'orderBy'],action.payload.orderBy);state=state.set('reportToGet',action.payload.reportToGet);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_291" /* OBTENER_EVALUACION_PROVEEDOR */]:state=state.setIn(['provider_evaluation','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.setIn(['provider_evaluation','page'],action.payload.page);state=state.setIn(['provider_evaluation','totalRecords'],action.payload.totalRecords);state=state.setIn(['provider_evaluation','accumulate'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.accumulate));state=state.setIn(['provider_evaluation','range_eval'],action.payload.range_eval);if(action.payload.accumulate['puntaje_total']>=action.payload.range_eval["aprobo"]){state=state.setIn(['provider_evaluation','state_eval'],"Aprobado");}else if(action.payload.accumulate['puntaje_total']<=action.payload.range_eval["no_aprobo"]){state=state.setIn(['provider_evaluation','state_eval'],"No aprobado");}else{state=state.setIn(['provider_evaluation','state_eval'],"Aprobado con seguimiento");}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_274" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES */]:state=state.setIn([action.payload.reportToGet,'modalFilter','show'],action.payload.state);state=state.setIn([action.payload.reportToGet,'modalFilter','columns'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.tableCols));state=state.setIn(['reportToGet'],action.payload.reportToGet);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["u" /* ADICIONAR_CRITERIO_FILTRADO_REPORTES */]:var firstCol=state.getIn([reportToGet,'modalFilter','columns']).first();var value=false;if(firstCol.get('enums')){value=firstCol.getIn(['enums',0,'value']);}state=state.updateIn([reportToGet,'modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('value'),operator:'===',value:value==false?'':value,checked:false,comparison:firstCol.get('type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_190" /* MODIFICAR_CRITERIO_FILTRADO_REPORTES */]:if(action.payload.attr==='column'){state=state.setIn([reportToGet,'modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('value')===action.payload.value;}).get('type'));var enumsColumn=columnas.find(function(x){return x.get('value')===action.payload.value;}).get('enums');if(enumsColumn){state=state.setIn([reportToGet,'modalFilter','filters',action.payload.index,'value'],enumsColumn.getIn([0,'value']));}}state=state.setIn([reportToGet,'modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_52" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES */]:state=state.setIn([reportToGet,'modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_147" /* ELIMINAR_CRITERIO_FILTRADO_REPORTES */]:state=state.setIn([reportToGet,'modalFilter','filters'],state.getIn([reportToGet,'modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_26" /* APLICAR_CRITERIOS_FILTRADO_REPORTES */]:state=state.updateIn([reportToGet,'modalFilter','filters'],function(filter){return filter.map(function(filterColumn){filterColumn=filterColumn.set('apply',true);return filterColumn;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_299" /* OBTENER_MONTO_CONTRATADO_PROVEEDOR */]:state=state.setIn(['contracted_amount_providers','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.setIn(['contracted_amount_providers','page'],action.payload.page);state=state.setIn(['contracted_amount_providers','totalRecords'],action.payload.totalRecords);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_298" /* OBTENER_MONTO_CONTRATADO_CENCO */]:state=state.setIn(['contracted_amount_cencos','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.setIn(['contracted_amount_cencos','page'],action.payload.page);state=state.setIn(['contracted_amount_cencos','totalRecords'],action.payload.totalRecords);return state;// case types.OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS:
//     if (isPrimitive(action.data)) {
//         state = state.setIn(['compliance_purchasing_manager', 'data'], action.data);
//     } else {
//         state = state.setIn(['compliance_purchasing_manager', 'data'], Immutable.fromJS(action.data)); 
//     }
//     state = state.setIn(['total'], action.total);
//     return state;
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_289" /* OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS */]:state=state.setIn(['compliance_purchasing_manager','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.setIn(['compliance_purchasing_manager','page'],action.payload.page);state=state.setIn(['compliance_purchasing_manager','totalRecords'],action.payload.totalRecords);return state;// case types.OBTENER_GESTION_RESPONSABLE_COMPRAS:
//     if (isPrimitive(action.data)) {
//         state = state.setIn(['manage_purchasing_manager', 'data'], action.data);
//     } else {
//         state = state.setIn(['manage_purchasing_manager', 'data'], Immutable.fromJS(action.data)); 
//     }
//     state = state.setIn(['total'], action.total);
//     state = state.setIn(['manage_purchasing_manager', 'show_request_type'], !state.get('request_type'))
//     return state;
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_295" /* OBTENER_GESTION_RESPONSABLE_COMPRAS */]:state=state.setIn(['manage_purchasing_manager','show_request_type'],!state.get('request_type'));state=state.setIn(['manage_purchasing_manager','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.setIn(['manage_purchasing_manager','page'],action.payload.page);state=state.setIn(['manage_purchasing_manager','totalRecords'],action.payload.totalRecords);state=state.setIn(['manage_purchasing_manager','accumulate'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.accumulate));return state;// case types.OBTENER_RADICADOS:
//     if(isPrimitive(action.data)) {
//         state = state.setIn(['radicados', 'data'], action.data)
//         state = state.setIn(['total_storage'], action.total)
//     } else {
//         state = state.setIn(['radicados', 'data'], Immutable.fromJS(action.data));
//         state = state.setIn(['total_storage'], Immutable.fromJS(action.total));
//     }
//     state = state.setIn(['total'], action.total);
//     return state;
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_303" /* OBTENER_RADICADOS */]:state=state.setIn(['radicados','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.data));state=state.setIn(['radicados','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.setIn(['radicados','page'],action.payload.page);state=state.setIn(['radicados','totalRecords'],action.payload.totalRecords);return state;default:return state;}});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({cotizaciones:[],page:1,showRecords:100,totalRecords:0,orderBy:{field:null,asc:false},modalFilter:{show:false,columnas:[],filters:[]},modalSummary:{show:false,data:null},modalSummaryCotizaciones:{show:false,data:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var columnas=state.getIn(['modalFilter','columnas']);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_293" /* OBTENER_EXTERNOS_COTIZACIONES */]:state=state.set('cotizaciones',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_325" /* ORDENAR_EXTERNOS_COTIZACIONES */]:state=state.set('orderBy',action.payload.orderBy);return state;// case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES:
//     state = state.setIn(['modalFilter', 'show'], action.payload)
//     return state
case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_270" /* MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES */]:state=state.setIn(['modalFilter','show'],action.payload.state);state=state.setIn(['modalFilter','columnas'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.tableCols));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["q" /* ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */]:var firstCol=columnas.first();state=state.updateIn(['modalFilter','filters'],function(filter){return filter.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({column:firstCol.get('value'),operator:'===',value:'',checked:false,comparison:firstCol.get('type'),apply:false}));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_143" /* ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */]:state=state.setIn(['modalFilter','filters'],state.getIn(['modalFilter','filters']).filter(function(item){return!item.get('checked');}));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_48" /* CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */]:state=state.setIn(['modalFilter','filters',action.payload.index,'checked'],action.payload.checked);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_184" /* MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES */]:if(action.payload.attr==='column'){state=state.setIn(['modalFilter','filters',action.payload.index,'comparison'],columnas.find(function(x){return x.get('value')===action.payload.value;}).get('type'));}state=state.setIn(['modalFilter','filters',action.payload.index,action.payload.attr],action.payload.value);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_22" /* APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES */]:state=state.updateIn(['modalFilter','filters'],function(filter){return filter.map(function(x){x=x.set('apply',true);return x;});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_36" /* CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES */]:state=state.set('showRecords',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_281" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES */]:if(action.payload.show){state=state.setIn(['modalSummary','show'],true);state=state.setIn(['modalSummary','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));}else{state=state.set('modalSummary',INITIAL_STATE.get('modalSummary'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_282" /* MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD */]:if(action.payload.show){state=state.setIn(['modalSummaryCotizaciones','show'],true);state=state.setIn(['modalSummaryCotizaciones','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));var cotizaciones=state.getIn(['modalSummaryCotizaciones','data','solicitud','cotizaciones']);if(cotizaciones){cotizaciones.map(function(c,i){state=state.setIn(['modalSummaryCotizaciones','data','solicitud','cotizaciones',i,'no_cotizar'],true);});try{cotizaciones=state.getIn(['modalSummaryCotizaciones','data','solicitud','cotizaciones']).sortBy(function(c){return c.getIn(["bienes",0,'id']);});state=state.setIn(['modalSummaryCotizaciones','data','solicitud','cotizaciones'],cotizaciones);}catch(e){console.warn("No hay bienes para ordernar");}}}else{state=state.set('modalSummaryCotizaciones',INITIAL_STATE.get('modalSummaryCotizaciones'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_199" /* MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES */]:if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["P" /* ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES */]:if(state.getIn(['modalSummary','show'])){state=state.setIn((''+action.payload.path).split('.'),action.payload.data);}if(state.getIn(['modalSummaryCotizaciones','show'])){state=state.setIn('modalSummaryCotizaciones.data.solicitud.cotizaciones.0.adjunto'.split('.'),action.payload.data);}return state;default:return state;}});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({fecha_solicitud:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),motivo_hospedaje:null,cant_huespedes:1,observaciones:'',alojamientos:[Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["e" /* alojamiento */])()],huespedes:[Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["C" /* huesped */])()],adjuntos:[],btnSaveDisabled:false,cencos:[],tipo:8,foros:[],comentario:{guid:null,texto:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var index=void 0,huespedes=void 0,adjuntos=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_339" /* REINICIAR_SOLICITUD_HOTELES */]:return INITIAL_STATE;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_214" /* MODIFICAR_INPUTS_SOLICITUD_HOTELES */]:if(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(state.get('cant_huespedes')>state.get('huespedes').count()){for(var i=state.get('huespedes').count();i<state.get('cant_huespedes');i++){state=state.setIn(['huespedes',i],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["C" /* huesped */])()));}}if(state.get('cant_huespedes')<state.get('huespedes').count()){huespedes=state.get('huespedes').toJS().splice(0,state.get('cant_huespedes'));state=state.set('huespedes',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(huespedes));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["k" /* ADICIONAR_ALOJAMIENTO */]:index=state.get('alojamientos').count();state=state.setIn(['alojamientos',index],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["e" /* alojamiento */])()));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_346" /* REMOVER_ALOJAMIENTOS */]:state=state.update('alojamientos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_93" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES */]:state=state.set('btnSaveDisabled',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["y" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES */]:state=state.setIn(action.payload.path.split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_0" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES */]:var actual=state.get('cencos').reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);state=state.update('cencos',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["P" /* solicitudcenco */])(actual)));});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_347" /* REMOVER_CENCOS_HOTELES */]:state=state.update('cencos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_166" /* ENVIAR_COMENTARIO_SOLICITUD_HOTELES */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});if(index===-1){var data=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["r" /* foro */])(action.payload.usuario,action.payload.comentario));state=state.set('foros',state.get('foros').push(data));}else{state=state.setIn(['foros',index,'comentario'],action.payload.comentario);}state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_113" /* EDITAR_COMENTARIO_SOLICITUD_HOTELES */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.setIn(['comentario','guid'],action.payload.guid);state=state.setIn(['comentario','texto'],state.getIn(['foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_136" /* ELIMINAR_COMENTARIO_SOLICITUD_HOTELES */]:index=state.get('foros').findIndex(function(c){return c.get('guid')===action.payload.guid;});state=state.deleteIn(['foros',index]);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["S" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1 */]:index=action.payload;adjuntos=state.get('adjuntos').findIndex(function(x){return x.get('guid')===index.get('guid');});index=index.set('nombre',''+index.get('nombre'));if(adjuntos===-1){state=state.set('adjuntos',state.get('adjuntos').push(index));}else{index=index.set('updated',true);state=state.setIn(['adjuntos',String(adjuntos)],index);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_124" /* ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES */]:state=state.update('adjuntos',function(list){return list.filter(function(x){return!x.get('selected');});});return state;default:return state;}});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({maestras:[],modalAddMaestra:{show:false,data:{nombre:'',file:null,icono:'',clasificacion:'',guid:''},btnDisabled:false},modalDelete:{show:false,action:null,message:null},modalProgress:{show:false}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_297" /* OBTENER_MAESTRAS */]:return state.set('maestras',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_235" /* MOSTRAR_MODAL_ADICIONAR_MAESTRA */]:return state.setIn(['modalAddMaestra','show'],action.payload);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_57" /* CONMUTAR_SELECCION_MAESTRAS */]:return state.setIn(['maestras',action.payload.index,'checked'],action.payload.checked);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_60" /* CONMUTAR_SELECCION_TODAS_MAESTRAS */]:state.get('maestras').forEach(function(x,n){state=state.setIn(['maestras',n,'checked'],action.payload.checked);});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_202" /* MODIFICAR_INPUTS_MAESTRA */]:if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_278" /* MOSTRAR_MODAL_PROGRESS */]:return state.setIn(['modalProgress','show'],action.payload);default:return state;}});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutablediff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutablediff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutablepatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutablepatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({id:null,estado:0,solicitud:{},aprobadores:{},unchaged:{},btnSaveDisabled:true,btnRComprasDisabled:true,modified:[],modalAddCotizacion:{title:'',mode:'',show:false,data:null,btnDisabled:false},modalAddReservacion:{title:'',show:false,index:null,data:null,btnDisabled:false},addModificacion:false,comentario:{id:null,texto:null,btnSendDisabled:false}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];var index=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["K" /* ADICIONAR_MODIFICACION_SOLICITUD_HOTELES */]:state=state.set('modified',state.get('modified').filter(function(x){return x.get('entity')+x.get('attribute')+x.get('id')!==action.payload.entity+action.payload.attribute+action.payload.id;}));state=state.update('modified',function(list){return list.push(__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload));});state=state.set('btnSaveDisabled',state.get('modified').count()===0);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_307" /* OBTENER_SOLICITUD_HOTELES */]:state=state.set('id',action.payload.solicitud.id);state=state.set('estado',action.payload.solicitud.estado);state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('unchaged',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));if(action.payload.reset!==false){state=state.set('modified',INITIAL_STATE.get('modified'));}state=state.set('btnSaveDisabled',state.get('modified').count()===0);state.getIn(['solicitud','cotizaciones']).map(function(c,i){c.get('aprobaciones').map(function(a,j){state=state.setIn(['solicitud','cotizaciones',i,'aprobaciones',j,'selected'],false);});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_232" /* MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES */]:state=state.setIn(['modalAddCotizacion','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalAddCotizacion','title'],action.payload.title);state=state.setIn(['modalAddCotizacion','mode'],action.payload.mode);if(action.payload.mode==='create'){state=state.setIn(['modalAddCotizacion','data'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["i" /* cotizacion */])()));}else if(action.payload.mode==='edit'){state=state.setIn(['modalAddCotizacion','data'],state.getIn(['solicitud','cotizaciones',action.payload.index]));}}else{state=state.set('modalAddCotizacion',INITIAL_STATE.get('modalAddCotizacion'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_236" /* MOSTRAR_MODAL_ADICIONAR_RESERVACION */]:state=state.setIn(['modalAddReservacion','show'],action.payload.show);if(action.payload.show){state=state.setIn(['modalAddReservacion','title'],action.payload.title);state=state.setIn(['modalAddReservacion','index'],action.payload.index);state=state.setIn(['modalAddReservacion','data'],state.getIn(['solicitud','hotel','huespedes',action.payload.index]));}else{state=state.set('modalAddReservacion',INITIAL_STATE.get('modalAddReservacion'));}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_215" /* MODIFICAR_INPUTS_SOLICITUD_HOTELES1 */]:if(Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}if(action.payload.path.split('.').slice(-1)[0]=='responsable_compras'||action.payload.path.split('.').slice(-1)[0]=='solicitante'){state=state.set('btnRComprasDisabled',false);}// if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
//     let newPath = action.payload.path.split('.')
//     newPath = newPath.splice(0, newPath.length-1)
//     if (newPath[newPath.length-1] == 'pivot') {
//         state = state.setIn([...newPath, 'selected'], true)
//     }
// }
return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["R" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES */]:state=state.setIn((''+action.payload.path).split('.'),action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["n" /* ADICIONAR_COTIZACION_HOTELES */]:index=state.getIn(['solicitud','cotizaciones']).findIndex(function(x){return x.get('guid')==action.payload.data.get('guid');});if(index==-1){index=state.getIn(['solicitud','cotizaciones']).count();}state=state.setIn(['solicitud','cotizaciones',index],action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_227" /* MODIFICAR_RESERVACION */]:state=state.setIn(['solicitud','hotel','huespedes',action.payload.index],action.payload.data);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_108" /* DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES */]:state=state.set('btnSaveDisabled',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["f" /* ACTUALIZAR_SOLICITUD_HOTELES */]:var ops=__WEBPACK_IMPORTED_MODULE_2_immutablediff___default()(state.get('solicitud'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.solicitud));state=state.set('solicitud',__WEBPACK_IMPORTED_MODULE_3_immutablepatch___default()(state.get('solicitud'),ops));if(ops.filter(function(x){return x.get('path')==='/estado';}).count()===1){state=state.set('estado',state.getIn(['solicitud','estado']));}state=state.set('aprobadores',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.aprobadores));state=state.set('btnRComprasDisabled',true);state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_361" /* SELECCIONAR_APROBACION_SOLICITUD_HOTELES */]:state=state.updateIn(['aprobadores',action.payload.indexAprobador,'aprobaciones'],function(list){return list.map(function(x){return x.set('estado',1);});});state=state.setIn(['aprobadores',action.payload.indexAprobador,'aprobaciones',action.payload.indexAprobacion,'estado'],2);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_350" /* REMOVER_COTIZACION_HOTELES */]:state=state.updateIn(['solicitud','cotizaciones'],function(list){return list.filter(function(x){return!x.get('selected');});});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_114" /* EDITAR_COMENTARIO_SOLICITUD_HOTELES1 */]:index=state.getIn(['solicitud','foros']).findIndex(function(c){return c.get('id')===action.payload.id;});state=state.setIn(['comentario','id'],action.payload.id);state=state.setIn(['comentario','texto'],state.getIn(['solicitud','foros',index,'comentario']));return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_86" /* DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1 */]:state=state.setIn(['comentario','btnSendDisabled'],action.payload);return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_161" /* ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1 */]:state=state.setIn(['solicitud','foros'],__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.foros));state=state.set('comentario',INITIAL_STATE.get('comentario'));return state;default:return state;}});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({passwordactual:'',passwordnuevo:'',verificacion:''});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */]:state=state.set(action.payload.path,action.payload.value);return state;default:return state;}});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({delegados:[],page:1,showRecords:50,totalRecords:5,orderBy:{field:null,asc:false},modalAddDelegado:{show:false,title:"",action:"create",data:{responsable_cenco:'',cenco:'',tipo_solicitud:[],delegado:'',guid:''},btnDisabled:false},modalDelete:{show:false,action:null,message:null}});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_290" /* OBTENER_DELEGADOS */]:state=state.set('page',action.payload.page);state=state.set('totalRecords',action.payload.totalRecords);action.payload.data=action.payload.data.map(function(ele){ele.tipo_solicitud=ele.tipo_solicitud.split(",");return ele;});return state.set('delegados',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.data));case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_234" /* MOSTRAR_MODAL_ADICIONAR_DELEGADOS */]:state=state.setIn(['modalAddDelegado','show'],action.payload.show);state=state.setIn(['modalAddDelegado','title'],action.payload.title);if(action.payload.id){var data=state.get('delegados').filter(function(x){return x.get('id')===action.payload.id;}).get(0);state=state.setIn(['modalAddDelegado','data'],data);}return state.setIn(['modalAddDelegado','action'],action.payload.action);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_55" /* CONMUTAR_SELECCION_DELEGADOS */]:return state.setIn(['delegados',action.payload.index,'checked'],action.payload.checked);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_64" /* CONMUTAR_SELECCION_TODOS_DELEGADOS */]:state.get('delegados').forEach(function(x,n){state=state.setIn(['delegados',n,'checked'],action.payload.checked);});return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_196" /* MODIFICAR_INPUTS_DELEGADOS */]:if(Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["G" /* isPrimitive */])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_323" /* ORDENAR_DELEGADOS */]:return state.set('orderBy',action.payload.orderBy);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_34" /* CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS */]:return state.set('showRecords',action.payload);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_359" /* RESET_MODAL_ADD_DELEGADO */]:return state.setIn(["modalAddDelegado","data"],INITIAL_STATE.getIn(["modalAddDelegado","data"]));case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_368" /* SELECCIONAR_TIPO_SOLICITUD */]:if(action.payload.check){return state.updateIn(["modalAddDelegado","data","tipo_solicitud"],function(l){return l.push(action.payload.tipo_solicitud);});}else{return state.updateIn(["modalAddDelegado","data","tipo_solicitud"],function(l){return l.filter(function(ele){return ele!==action.payload.tipo_solicitud;});});}default:return state;}});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objectify_array__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objectify_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_objectify_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_util__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({columns:[],ids:[],data:[],records:0,page:1,take:200,query:'',connection:'mysql'});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_19" /* ADMINDB_POBLAR_RESULTADOS */]:var data=action.payload.data.data;var ids=[];var page=action.payload.page;var take=state.get('take');var skip=take*(page-1);data=data.map(function(x,n){x.id3n71f13r=skip+n+1;ids.push(x.id3n71f13r);return x;});state=state.set('ids',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(ids));data=__WEBPACK_IMPORTED_MODULE_2_objectify_array___default()(data,{by:'id3n71f13r'});state=state.set('data',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(data));state=state.set('records',action.payload.data.records);state=state.set('page',action.payload.page);if(action.payload.data.data.length>0){var columns=Object.keys(action.payload.data.data[0]);columns.pop();columns=columns.map(function(x,n){var w=action.payload.data.data.reduce(function(a,b){a=String(b[x]).length>a?String(b[x]).length:a;return a;},0);w=x.length>w?x.length:w;return{ID:n+1,CAPTION:x,VALUE:x,TYPE:'VARCHAR2',FORMAT:'',WIDTH:w*6+12,FIXED:false};});columns=[{ID:0,CAPTION:'No',VALUE:'id3n71f13r',TYPE:'VARCHAR2',FORMAT:'',WIDTH:40,FIXED:true}].concat(_toConsumableArray(columns));state=state.set('columns',columns);}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_193" /* MODIFICAR_INPUTS_ADMINDB */]:if(Object(__WEBPACK_IMPORTED_MODULE_3_util__["isPrimitive"])(action.payload.value)){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{if(action.payload.immutable===false){state=state.setIn((''+action.payload.path).split('.'),action.payload.value);}else{state=state.setIn((''+action.payload.path).split('.'),__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(action.payload.value));}}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["_20" /* ADMINDB_RESETEAR_TABLA */]:state=state.set('ids',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS([]));state=state.set('data',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS({}));state=state.set('records',0);state=state.set('columns',__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS([]));return state;default:return state;}});

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function objectifyArray (array, options) {
  if (!Array.isArray(array)) return array

  if (!options) {
    options = {by: ['id']}
  }

  if (!options.by) {
    options.by = ['id']
  } else if (typeof options.by === 'string') {
    options.by = [options.by]
  }

  var by = options.by
  var recursive = !!(options && options.recursive)

  var result = {}

  array.forEach(function (element) {
    var identifier
    if (Array.isArray(by)) {
      for (var i = 0; i < by.length; i++) {
        if (element.hasOwnProperty(by[i])) {
          identifier = element[by[i]]
          break
        }
      }
    } else {
      identifier = by(element)
    }

    if (!identifier) return

    result[identifier] = element

    if (recursive && typeof element === 'object') {
      result[identifier] = {}
      Object.keys(element).forEach(function (e) {
        result[identifier][e] = objectifyArray(element[e], options)
      })
    }
  })

  return result
}


/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(570);
exports.encode = exports.stringify = __webpack_require__(571);


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleOption__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleButton=function(_Component){_inherits(ModuleButton,_Component);function ModuleButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModuleButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModuleButton.__proto__||Object.getPrototypeOf(ModuleButton)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnClick=function(e,hasChildren){e.preventDefault();var ink=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.ink);var li=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this.li);ink.classList.remove("animate");if(!ink.offsetHeight&&!ink.offsetWidth){var d=Math.max(li.offsetWidth,li.offsetHeight);ink.style.height=d+'px';ink.style.width=d+'px';}var rect=li.getBoundingClientRect();var x=e.pageX-rect.left-ink.offsetWidth/2;var y=e.pageY-rect.top-ink.offsetHeight/2;ink.style.top=y+'px';ink.style.left=x+'px';ink.classList.add("animate");if(hasChildren){var isExpanded=_this.props.expanded===_this.props.id;var id=void 0;if(isExpanded){id=null;}else{id=_this.props.id;}_this.props.expandCollapseModule(id);}else{var url=_this.props.url;__WEBPACK_IMPORTED_MODULE_3__utils_history__["a" /* default */].push(window.FOLDER+url);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModuleButton,[{key:'render',value:function render(){var _this2=this;var _props=this.props,caption=_props.caption,options=_props.options,id=_props.id,expandible=_props.expandible,url=_props.url;var isExpanded=this.props.expanded===id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:function ref(li){return _this2.li=li;},className:''+(expandible?'treeview':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ink',ref:function ref(ink){return _this2.ink=ink;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+(!expandible&&options.count()===1?options.first().get('url'):''),onClick:function onClick(e){return _this2.handleOnClick(e,expandible);}},caption,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{marginTop:'4px'},className:expandible?'fa fa-angle-'+(isExpanded?'down':'right')+' pull-right':''})),expandible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'treeview-menu '+(isExpanded?'slideExpand':'slideCollapse')},options.map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleOption__["a" /* default */],{key:'li['+id+']['+x.get('id')+']',caption:x.get('nombre'),url:x.get('url')});})));}}]);return ModuleButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{expanded:state.common.get('expanded')};}function mapDispatchToProps(dispatch){return{expandCollapseModule:function expandCollapseModule(moduloId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["i" /* expandCollapseModule */])(moduloId));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModuleButton));

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_history__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleOption=function(_Component){_inherits(ModuleOption,_Component);function ModuleOption(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModuleOption);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModuleOption.__proto__||Object.getPrototypeOf(ModuleOption)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnClick=function(e){e.preventDefault();var ink=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.ink);var li=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this.li);ink.classList.remove("animate");if(!ink.offsetHeight&&!ink.offsetWidth){var d=Math.max(li.offsetWidth,li.offsetHeight);ink.style.height=d+'px';ink.style.width=d+'px';}var rect=li.getBoundingClientRect();var x=e.pageX-rect.left-ink.offsetWidth/2;var y=e.pageY-rect.top-ink.offsetHeight/2;ink.style.top=y+'px';ink.style.left=x+'px';ink.classList.add("animate");__WEBPACK_IMPORTED_MODULE_2__utils_history__["a" /* default */].push(window.FOLDER+_this.props.url);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModuleOption,[{key:'render',value:function render(){var _this2=this;var caption=this.props.caption;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:function ref(li){return _this2.li=li;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ink',ref:function ref(ink){return _this2.ink=ink;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.handleOnClick(e);}},caption));}}]);return ModuleOption;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ModuleOption);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-icesi.d80994e3.png";

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = {"name":"comprasicesifront","version":"9.0.0","homepage":".","private":true,"dependencies":{"axios":"^0.17.1","core-js":"^2.5.1","css-tooltip":"^0.3.4","exact-math":"^2.1.0","glamor":"^2.20.40","history":"^4.7.2","immutable":"^3.8.2","immutablediff":"^0.4.4","immutablepatch":"^0.4.2","ip":"^1.1.5","moment":"^2.19.2","numeral":"^2.0.6","objectify-array":"^2.1.0","prop-types":"^15.6.0","react":"^16.2.0","react-ace":"^7.0.1","react-ckeditor-component":"^1.0.7","react-dom":"^16.2.0","react-draggable":"^3.0.5","react-dropzone":"^4.2.9","react-file-download":"^0.3.5","react-fontawesome":"^1.6.1","react-idle-timer":"^2.0.0","react-js-pagination":"^3.0.2","react-redux":"^5.0.6","react-router":"^4.2.0","react-router-dom":"^4.2.2","react-scripts":"1.1.1","react-select":"^2.0.0","react-timeago":"^4.1.9","react-toastify":"^2.2.0","react-virtualized":"^9.21.1","redux":"^3.7.2","redux-thunk":"^2.2.0","universal-cookie":"^2.1.0"},"scripts":{"start":"react-scripts start","build":"react-scripts build","build:production":"NODE_ENV=production react-scripts build","test":"react-scripts test --env=jsdom","eject":"react-scripts eject","publish":"NODE_ENV=production react-scripts build && rm -rf ../public/static/* && cp -R build/static/* ../public/static"}}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_universal_cookie__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_universal_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_universal_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_MsgBox__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_auth__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_signin_css__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_signin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_signin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_css_tooltip_dist_css_tooltip_css__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_css_tooltip_dist_css_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_css_tooltip_dist_css_tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_bg_1_jpg__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_bg_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_bg_1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_logo_png__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var cookies=new __WEBPACK_IMPORTED_MODULE_3_universal_cookie___default.a();var inputSm={height:'30px',padding:'5px 10px',fontSize:'12px',lineHeight:'1.5'};var SignIn=function(_Component){_inherits(SignIn,_Component);function SignIn(){_classCallCheck(this,SignIn);return _possibleConstructorReturn(this,(SignIn.__proto__||Object.getPrototypeOf(SignIn)).apply(this,arguments));}_createClass(SignIn,[{key:'componentWillMount',value:function componentWillMount(){this.props.clearMessage();var token=cookies.get('token');if(token){this.props.history.push(window.FOLDER+'/');}}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.clearMessage();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,username=_props.username,password=_props.password,processing=_props.processing;if(this.props.message){var message=this.props.message;switch(message.get('type')){case'danger':__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].error(message.get('message'));break;case'warning':__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warn(message.get('message'));break;case'success':__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].success(message.get('message'));break;default:__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].info(message.get('message'));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'signin-container',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_10__img_bg_1_jpg___default.a+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-box animated fadeIn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-6 text-center',style:{paddingTop:'45px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-12 icesi',style:{borderRight:'1px solid #fff',alignSelf:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__img_logo_png___default.a,style:{verticalAlign:'middle'},alt:'logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center',style:{fontSize:'24px',fontWeight:300,margin:'30px 0'}},'Inicio de sesi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){e.preventDefault();_this2.props.signIn({username:_this2.props.username,password:_this2.props.password});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-10 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-addon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:username,onChange:function onChange(e){return _this2.props.changeInputs('username',e.target.value);},placeholder:'Nombre de usuario',style:inputSm})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-10 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-addon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lock'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',className:'form-control input-sm',value:password,onChange:function onChange(e){return _this2.props.changeInputs('password',e.target.value);},placeholder:'Contrase\xF1a',style:inputSm})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-10 col-md-offset-1 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'rememberme',value:'1',style:{color:'#fff'}}),'Recordarme'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{cursor:'pointer'},className:'pulse tooltip-multiline tooltip-bottom','data-tooltip':'Para recuperar contrase\xF1as: usuarios de la universidad, cont\xE1ctese con el departamento de SYRI; usuarios externos, comun\xEDquese con el departamento de compras.'},'\xBFOlvid\xF3 su contrase\xF1a?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-10 col-md-offset-1 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default btn-sm',style:{padding:'5px 30px'},disabled:processing},processing?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'circle-o-notch',spin:true}),' Iniciando sesi\xF3n ...'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Inciar sesi\xF3n')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_MsgBox__["a" /* default */],null));}}]);return SignIn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{username:state.auth.get('username'),password:state.auth.get('password'),processing:state.auth.get('processing'),message:state.common.get('message')};}function mapDispatchToProps(dispatch){return{changeInputs:function changeInputs(attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_auth__["a" /* changeInputs */])(attr,value));},signIn:function signIn(credentials){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_auth__["c" /* signIn */])(credentials));},clearMessage:function clearMessage(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_common__["c" /* clearMessage */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SignIn));

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg-1.7335cf3b.jpg";

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANgAAADWCAYAAACzKkydAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAFBhaW50Lk5FVCA1LjEuNBLfpoMAAAC2ZVhJZklJKgAIAAAABQAaAQUAAQAAAEoAAAAbAQUAAQAAAFIAAAAoAQMAAQAAAAMAAAAxAQIAEAAAAFoAAABphwQAAQAAAGoAAAAAAAAAo5MAAOgDAACjkwAA6AMAAFBhaW50Lk5FVCA1LjEuNAADAACQBwAEAAAAMDIzMAGgAwABAAAAAQAAAAWgBAABAAAAlAAAAAAAAAACAAEAAgAEAAAAUjk4AAIABwAEAAAAMDEwMAAAAADGeaJxF/RJFQAAICZJREFUeF7t3Qncf2895/HfNKFQY5swlhmym8IoFGmRNjEllQpJRYrKlmxjLUoRWmZGZShEm1TWJCllmZiSJcuQLNlmEIa2eT/P/T1353vu871/9/L93vf9/3u/Ho/P43y/Z7vOcl3X53N9rs91nUullFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSinlTPhXq+UVjjvc4a9d+w0j7xV5q5X800pe8fSnv9NvZ1nKuXLhC1gK0jWy+MjI+0aelILz+tV6Bep/RT7Y/xmPzn5fuPq9z+qYS+M5Stk1V1ktLxQpCFeLfGLkv+fvyyM/G3lC5IMiU96wWs5502o55x6RX895H7j3t5TdcuEKWDL/v87iGZGfitw78h8iI7ddLU/Kp0Y+IHK94V8pO+bCFbCYb2/M4rV7/w7wSavlsUnB/fdZaLPh+1fLUnbKuRewZPxbRf7N6u/I01bLOdfLvh+y+n1cPiGiPfeayEusKGXXnFsBS0F5t8hT8vPHI183rHwLL4r80d7PNd4mcsu9n8fm9qvl86Il/+/q9wEU9sg9Im+9WlXKiTmXApbMS5v8YuTOw4pLlx6Ydbdb/WYm/k0WHBtL/OfV8s2r5WXJuf9dFh+79+/Sj66Wm/jqyBMjz81x7zCsKeWEnHkBS6b9/Cw4MN57WPEWHptt03XPXC3nXD/7XTuFkAeRQ2SJ+X3dPPKOkT+NvNCKJXLeT87iS/f+Ddry/+39LOVknIcGe9vIUrrvHvmvez8HmIl/tvdzDcd/yt7PS38S+d3IL0e0q14W0caam4Cftlq+IAXzr1a/10jhes8sHrf379JfRD47+7aAlVNx5gUsmfaRWTx1798Bbp2M/hV+ZL+/zGJqJv595Oci3xT5eSvCHSIfnH0/KnLDiA7p9498i43I+a6WBecGfmS1XELheo+9n5e+IOf6/dXvUk7MuURyJNNfK4uXRt5nWLEO0+8TksFfmP3ulN9fH3l85KlZ9+os18g+N8riGyIqC4Xy3tnvr7O0jQn5tvn/d/n9H/P71fn9t7ZNybYvy+Lhe/8uPTb73G/1u5RTsXMNlsx72wjzb59k4D/P4vMiS46Kq0aemGO47p8e+fDsT+u9d9Y9LaJwTtG/dZPIx0e0od4uMvIxkVfmmCdnSTu9zsop2cb5QSviVyMP2vt5NiT9q0TWKjr/5+uWyD5vF3n/o+y7DZLOu0Q87wNk/TUjom+0dY9FjnnX1bFvv1p1pWGnBSwPTMfwsyM/l980zT4pND+dxZixp9A+3xn5x+zzxojgXXhxTMKPG/69BR3TI/adFloFTjDw3SL/LXL1yD65Jq74x0Qs/yFC+zFFN5JjrhsZTclTkfNo9/1SZL8DPes4V34i8jXDisN5cORVkZP2DR6X/xH5pVzjNff+rvGBEc6rDx/+HQ8VpGOXLJorNDsrYHkJajqmHbSLfibrhvbVBObftJ31MxEa6zsj/7y3ah/7cXrccfh3GZKWwN5p5MePTQvPKpMwR78y8seRr8r2/5nlRnKM0C0F4vH5vcmDeRy0D7Ubp1rZOxHK9X7Dv8PRh/iQCMfOsck9HKr5FrYrYEzppUpodAgduftkwliJnuTYC81OTIvVi6G5lkKb1M6fl8w8tKeyr8L34shTsu7++f+J+f2h+f0o26dkm/4p/WXvm+2DpzDr7pLFD/gdmICcHq/J+uvnt7628R5vkfW0pmOYoT8Z+cfI3SO04OuyfTF4OPu/Uxa0Kk04ctfs/4Or3yci5712FrygPJbfu1pHy3Kw/HjWfU7+C1Cm/QUwM3l/JfLl2fbabGMW3zXCrNW98DZZ/+VZOs9HZPG1ka/Pul/N/3vl9z0jvLAK5jdl/euynlUgxtOzu0FEvKbnw1H0oRHvSbv02dn3M/Pb81UpSeMWWdCiKqvfiWgzaz+/INveJb8FENBOvxX5P5HfzrZHZOlY7+3+EYWK1/Y2kY/I9l/P8krDrjSYF7EpbvBWkZfmAQ+RFXmgXswNsvSwcd/It2f7UsSGECqm4pq5uQGu/LFw/WFEYRv5L5GbRVwjrXX1pL+pcMkgHDLTwiXzPWfv586hzRQy5qSKSIUwOmSYhp8b8R45bx6U61Uo4Hnq0H9V1hk98NgIC8GoBIXNf9j/syP2fX6EdvruiHRVKp7LrSPwLBRoz4WprpJSuF4QUaBdxziS4Yciro3n13pp3jjiWOdQKUqLRUCL76SyP292VcCYc5s6isHp8Yw86G+LXCWZ+/f2Vg/IGGo0jo53Hda8hV+IaKOpdTcxmhlqxJGfThqD9zDnVOuK1hgxHEZ6a2Q/jgbtoOdFaFkoqLfJub4i8nd7q07FmKmmppEM6v80w/1B0rtVhGNIeBlNBpmfacYcZr5pR941183Ro++P5pGJjY2jFcc+wN+M3CX7cSo4B+11s+z7oIh9tAOdw5IJ+oAIjKMbTUEVoXC2j88xtKeCj9fnvP8pSxXY3bPtfhFacRr/6XwvyfqbRxR+WncbJveFYycFLA/tj1YP1cM7tLM2+62N3XJsFp8TEd407Xi2jVnIvLlNXuLY0GbOjDCv3pBtGtpq1JEhPCrrFVjOjqlm+9ycd017ZT8RJQoW9//44lUYH5N9pb8txnSnFYl2mXsbC7Br/edc03jNKph5W+WquS5dFAqf8DPRMgrIE3KcPkAeWe2cD4swAzlGOHekLw8oYNPuC+YbDaQQ6XOk9TBN999GdHso1BiX9hk9ib+xWkIa4z0wuVkuI7ZdKdmVBhvIw/+OLLQTaIk5z872L179XiPrmV9s9dslg4y15wjXvZc7Dj2h/bRfmDUGaMqYavjxZXKMMFMgU43jy2QEbcH9aJGkJdCXc8axMiO00x6Y/T51uu+W4JwwKvtLk+7NIkZt86wqHKPzx7VM35MCP94bpr/dv+t/WOS5ud5XRTwPbSAV2ZdEmLosgRdmm8pPBeX80zRUULo2PAPtXtpO2805xvSYkx+b9XeMqBBGM9L5XhFx7q/MtmtFnE8/5FiZKrR3yvobR8R7siqulOy0gCEvURiTviaaY0SI0z3zcGmih0aGofwzvirCPn9UtnNYjLD3mSP6rJz/FyKcBDTRfSNq0idF2PXaSk/Mur/NOb4ov6em5UOzXhtiINtlAG0U56cltBmkcZPsp6LYOjkvDUJL8JhKW2XxBZFHR8aoEw6YaVeETDr+V0nsa9+cTztTrKX3qrCNOCctRmOrJLS/Rpf49Hyeg2M5Q7Q7/3fEs358zu25KlzjvtpnHFY/HFFRMLtdD5NfP6f70s5mkajg3i0yeguZ3rSbZ82Jog2oQE415JWCae13KvJivEBm2a/kAS+q/OyjcftdERrhSfnP7OIVlCnulXVTs8H+GvEy+R9ErpftJ2r3rK5NG2Ccv8MLZ/8PmTPbZahvi4xm5zOy7Q5Z/9ZZzrsLtk7SYVJ9VIQ591tJc9+Tlm368a6RdYO5Nf2f3++c3/6/Mv/HuUqY1kxOE//sF76sd28qOtrxZdk2hIJlvfYwj59zDBom61R43iWNqgBoL70565nOb5/f47XQppwdrp/Wcv2/m+3D+892XQ3OIy3r3pBtQ3s725jzrBsaT5vQ9fEyshiuNGyzgKmFvifiAeo0fFaEdlkrFNlPJ+2fZ73GsBeiEa0Rrg1AA62NNl6d11wcX5ttYw14bHIeGVHNLZNpS/GuaQvQTp8RmfLNEf1iR6pRcx4F97XZfwjRKmVkmwWMuTB3rTNJmD401YuTAfWFHCDHMt2YNDK8ttSXZN8TaavDSDocCB+Qc788v9We0hSBMKK2/vxs/7G9v5vJ8bQrT6XuAN0GX5TjDvTdlX/ZbKWAJbNpWHNkjCbWElzh35JMyBQ7QM7B+SDD62hmgjAZdzK0P2npj+FEmN6/Ng8NaszYAXKMtsl1ImOhYvpwY4/8Yo4d3eelDGzLyaHP47DCBZ6/xbFYSObUzqIBNYBph3nM4TbhDGDGQuP6i5P+7eeFK4VqiF3MUqSDDmlRFA+NKEjTwiUa42ezX6cZKGtsS4NpJ3EvHxYEy9Ok4Hx0RINcw3nRgZDzcQ9r8B7ah3YakobOY/1sX5N0uK0Hsl670DXygCnwHDOcJGOBHNEwZ0rqY/vlnONK1Tgv22GbbTBRAToxzZmhX2OMfhj5vmTCu2c/rl/moKmtnxvhDDnXDJprUoBoTKafa5/OxajvjIv/lREVgxhL18wTd2Knyy7J/fAkcuqwGngEVWRc56/JNS+awKclaUpLOBd3PO3OQaTNLZBa4MFWvbFJT0XIq8kLOg5zEbViyr8/TnobraWzZGsFbEpuXqekvisZVgckL9sQ0Jptn57fgkKZlTI2FLqxsL00+51Zz36uR1yfzleZcgnXZdiLduaf5tq2VqiSNne69JmWMqSlaQ30gx2LnEvgsCgO8ZWe9xhNMYWXU6eze/rhpMO0PTFJUyEWkiVN7VPu/nmzQ/8ZZ5c+rx9MmuNo9GOT9ORXbWBeX5W5dzbvQ9U1IapFO57j7ZlHuc+ce/BUR0bPsXehs55n/MTspIBNyYWrzRS238nF7k8omvWGaAgeZYpxbOjTgf4pnsczIdehA1xQ6pTR/KOt9OstDc84NUmblhe2NGXog1v9viw5hxpcJ68OYX1cR8U96RL5xqR3rOEuSdO7EkWvM/64M28Z0aALRADCkUma181C5/YQMHwM3KfOcIEFGwtazu+8KoEp351j5nnjWOy8gB2F1QtT2IbRxbmpM+tPStpmnPLSeUHHNtWZmH9Jm9bRqaz7YMSwHbGAlyXHc75oR55mAKjIDnOQCEG7LElT1L2ulNMMjmQuGnJzpG6NpMlsN4/L5Rxph2EqQGlOI4r2SRq6WuYzjp16+ohTF7BcGBUtg2zqlJWGHvwL6QTI9av1aRKRD9OQpJ2TtE9cwHKsUCTtw8NQe6somOzTNJa4f9IVZbORpDmETUWmAdZTBGOzUmRmJpaKk4bdtP83JE1m2UaSpn5KTih9pEtIy33Khwrg1Lu7hMACfZZr+TXpXNgCxgFgwN8mj58bfk4u9FSqdpfkHrQbXOem58G5wbanKTZllpE/y70eyfuZdE9UwHKcjG54yhKcR6Lq9fPpOHctnAAqEW0l7bTRHJ8j+Hkaw7hP0jQ6YknLeS4+1iE42LR52j80lGeqYAu30ob1/rXZ5twnaS5qFSRd5t18FLuC7BjWhntUwBRo5qr2p3a/9j+Hyxz3cOekuVaZJp0LW8BEvYvSPowfyIXeLft+Vn5zbIxR1VNk3OdnPzFtZ0quS62sHbhkFsr82ioGaYqLlGH2Y/wmeJZi84zbmr+oRZLusQtYjjHWypyRa/OLBBYCbfCYHD8OHTlAjufpM1WDIUFzOAZMgSfD7pNjfJFG8O/cccKsVkAuGxCQc3CA0JCcXFNE7EiT82WNHKNSMNpgeq+8kp+U/a3fSI7l1TRcSt4ctZqIojvl2APvL/vvpIBto6N5/qKX+JvcgBqGSaOhyks2F/Y4z+J5oGbl8vVC52Lb++VB02JqZPfLRTwXWsK207QTDiXPUAFm4syfOZe0gv2tkY2FC9nOVS+4WcaZmknGv90229YK14pvjcwLl0JlkOaRom2y319GVBy06xTPbjoAdooA6Pm9clYcWriQff4iYkSGNqNCaRyfaR6WKsedsY0CdhRz6Jq5saFhG/EwzekwFxpCzXweaDcI5eJNm4vM++pkbja+Qsa0oOmWxLZddjHo3phHuMgwMs6RtOZI9hf4LMhaITN+7JZZp7tkjdy3DMrcmqIvjZl1kr4maTLrphi5MI0JHdE1MufQiYnm5BpNs8Clf5f83lngwia2YSKatFNNscmJwfz5kdyceSUuJLkHteRhjWMvRgXBpJv3u8wxvP9QLTKSdI9lImZ/FRBP6xRa60RzOeZ83v91c/xGjZB9ltpAG9tqRyHnnE70OmK6Appyn+wnX82n9lOwXdNWSVoXtg0mc16u/+X1uVDengtHrl/BomEPzMuxa5L2kQtY9hU+JhZy6mThUFBAdhWdwQPo+qYePH1J10maJ9YGq/vW1p6afz+Rc46jogeynw5lg2enDLNXZd9f2/u7HZLWxSxg2yA3xzunP0oQ7YNzU2dWGJO2/jeeJYMwNYI5WtjsO2eV0Y5awEwGNB9Z/b3ZVxzoTkia+tl0tk+R4Zl587bRUWGSao/re5yahQZlqiz224BJX1+bgjivwFkI2nI0mT7LU1eOSevCOjkuSy7+6pFpJrLOVNj3jHC18l5xO98nItD2LBHqo4YWUfJ9kVfkmswBeC/XmP8XBVMgzOGY2CVLs/R6TrSYiuEkIqZz9MZO0XWwFhWSzK1NqFN7DmcTL6hQKB+1f37kYZHbR64duZwZf2bsrIDlJhWqm0TMK++hDh/Yy/97R8yFoVBxj+sj4R2zTufpZT1EW0YQrKEyI7xlam4v9jdzrcMLzvIGkfOc2nne4KcJ9HntkqX75S3lclcgTiPzQqACVnDmcICJndyEkLubRrRD9cfpOnhZ3pVp/+4ckda5sdUClpu5RuTmEW53BUVnp5mjvCj9TNBXI/SFx432Es/2IamtuJkfF9n0AfSdkPRMzWbCGy9JV8G0P2Z44bkfz8ksvqN2U0lMI+53StJSAXFnT+FUWhwhvkV21uWwgGd8oMmS9+M+dXIbh7fUhTDHO/M+OdWYkd7ZQyObIkF2ylbaYLl4o3tpH+2oTRlPRLVedoGsHAsatQfaOqvMpLFr+876LJIOjaBwPyzp7LvWs961mdXWsBuRDyIQvPy5fa6DVB+QEQA/mXNMJ089EknrSG2w7MexYYYtz3lEO+TDsu+pIuIPI+mK/xs/Xjgiwy8FCpwG75zL//q5n40Om1yPSXQUHNaQ6PfjKAjP6W45v+d4gJz7QrfBZEiZ9bBaXYY2avjJkSdElgoXrxWHg4b1OJX21kk6GtkcBvrkjETez7i5rn+KmD+EyeFDFPpRlqYCoFFoYp3no2aba5mtkGtQ0cy9dpwMu66V9fvN0Uktc/NqbktoHN0Ph1oveQ5mrOK6976M0DDBqjkxmYWX024Kp+9uq+TPjG1pMA1WN7nJXe/mNWxpi8U53XMOWktkOMeCTlvD+Mf507dK0hL6M87VB9enH2YxvexPg/B4mVefZlOhzL1ohl98dM6xFkR6GDnvcbyIKh6m0pTPyr5zN/bWSJpLYXC0wPixjQvB6v3IN8akmZBW5/iSUwjiYrX718g5Lq4Gy0VwsU4/rgAmFMeFSS+ZMjeKHChcubG3irCvDRXxkLTd7Dtk9mzblpZ1LvPNXy3nNgaLt3KcBlvF8Jhse0pEDNsa2d9oAPMGPjJiNiq1Lg1r3NpoXvoC55EL1wlQgc0Z27W7gnNqjvu/UKzez+9HnhURLSTEStid+Mk5t8g7PjMttrXMGzQo2ec8PsxFfRocF4JPF9snuVFf9uBqHr8bJkL647L/dDCeCUpNwXxYpMVlyfG8Ta5x8AomDfOqGx0r7dEUEmn+kuzL9NtIjjN49Lsi2pwKm/bn1qMLZiyNBDYz8mnGgl0OHdtzM/GWSXMnpvC2yHt5U4SDTSFj4k/RPKDpzoRtFjBmgzkHBYxqY01d3/vk5dw3wg0OUepqRA1cpofI7KnDQTS0SWdMTjpt4J8EHkKxfJ+R86oABpKe6bWZFKPLm9nmKyZjBXAoOV7NyfvJibNLWAhzhwYXtC+bnJjc440iPKhL0GDziAnt7OmnnE5E0tTtcZKvYR6ZvBMVvuDyOfPPEO+MrRWw3MzfRwTHLpKH+Y4RHbmcAo/Oby5gcWY+InDDHLtm12c7E84Mu3hEtg/qPutvGjF5DofIItl21cgHRXxUYaytBLSOESKPzHoN64Gcm3YQEMoVby71+2Q78+vXsvSJpVNpz23g+WYxfKRvho8WjhXWschxTCXfXHtefosPXCNp8hYujTv7uuw/7yg+MjlWxcX76kP3rIZDyT46kE9aGJeCr88s6HebGmwjeTgakFzaPswHHkXzHTwt4ouIa/NSZH8miGBSjX/HTYczqLG99P3A0Ox/v8gjIpwQYDYJjLXPMP4oaWjbjV9zUbh9BnbfuZDt+pTUzOx365mSGs8GlPrG9JmZFYfACTSPRPcOn5zrO1Z7LPtzBoiEUJs7x8Ozjid0PihSpTjv0DZZz1Oz77HN0xzDI6vtq63rPWv3+uDiYuhV1jPzdBeoBFggx+WAQyMcGDWwK3ZewPJQTI7CGTAfjuDzNUzAJUR/mOSExvFhcl5F5zKLEE0Dmm/Et5N5uwZTJ/sz10SK4NY5Tj+L9T7FM2oBGpJzZZ9sf3PEHBXaZtPICfu+KOfZNy3Pg1yb4N6lyHmDWJ+T6/vqyKHto2z3iSYVlncyDwWjCde6WpImDXBAuwUDP38+51rKwAdwXZExL8wLsfCrAx7o7K87gGXj/TGHfyjrnhUZP111KNmPqT8fSa8r4MyihXYW7Jubk0EfF1mLkJ7AGfKAvMA1B0iOM+p5LAT3zHaFYiDbxuhqBU9EN3POeuajQvCQrBu0XdbRVgoqM8eI2WEcUdaLdzPHw+hJ+rRsOzAUPvsZoiEiZW6vazeav+LUE/MkjSO76afkOEM9ljI9eHTV+Cog7WDmEO3ApOOU0dE/rTymfGHSds8HSJrfmMXUkpjCvc3Jw9rQvylNeYuloP+J04j2WQq98i59P3utA3jhPU3hrZUWr7R3T6v7eAiFoW+Q40k+Wsp735G0DlTsSe+KE+ybix2HmC/d4DijEGfI72Xf/UKe3+IAOR0gUny/cK1Q00FH8FC4DoEZQvO5RxppIMeZz4HGcx14cNI98Byyn0zKnBk+nD6BGekb05scAzsn10aLbZrwRkHiqtZFwkEhGt1SN4hKZ1Ph8k4WCxeyzZTmi98VCBxVjuX95RiR5hjcS2O5nqXCRSN/Ss69FF3BQbHkOYU8Q4uxQFQkNJKp9lgt+lu1pZfynspnzWrZNbsyEdUo8/n+4CHcNA90f7Bdfvvu1HUihqloB4molznWvGPZzu5Xy2D8ON1Gci5pmYQFn5zj9wtytnHdiolUY6nRfYVRQZuOtbIfW9302UZbTydJMZXAfODjmZJr07+ofSgjboLmokWmGnIOk8n4qvkAyANkH2a4oSpLjgPIT0w5JqD22WHmKu3k+85zrTGQ9SJqmHg00Ubn2QrmpXRpr00OKZqVtSK4+8zYSQHLTTARaImpGcUxwVu4Pw88kqlFVauNvzm/jcd6UfbRf6Z2m2Lcloaxl3vUYRqCiTF+wnSKDEULyQiiOngs55+rdS/aZcwjToTxA4Fq5VHTngbPf5759dMciVyXrgdalol73LhNXkn9jj5sSFsfiexLUzHH9SmOVsBx0CRQOdw451IJHkr20STQRUODntQ5wWMpeIF228RSWTj1sJddaTAPhgZjvyoo2lL3iDDP5pjhaNRMgjh9uVFhmjPORmRq7aM+aO08bTAPai1oNeewnq2uBmXS4iFJe3SirJH9dVyaD0MG85mjbQQiazdo08ng2jA0s8J+ZHIdL4+4N95PlYTOYe2aeVQJDWxgovvVuS66Rr/j5bTDAXLMb0S0E4UjeX8qTX2ZS0HAgpJVTJwV2mHiOwUfHPn5ZV8T5ujS8b44VbTtFRYWz6Y0jYrgCVaQbxe5XJ6hycf3QBTKeXTSsdmZk2MkGfZaublFtZxt7GRtgym0ntpm9AIOZF+mo+BOL2dtPohs48Dg1fL9sTEqxHreJ4VMRfLwbDug+bKPGnL6hUvp0rRjn9kVityPd8rbSjMzmWhI2kpF56MIOzGRki4TXrrGijHZaDcViOj4P0m6h5myx2b1bqUpntR9SlOh9d6kafaswft8nuy8gG0iD0hHMUfI3FV8xzwYnZ8D2U/BGUySrF8c/5R9TNCv0fuo7KN22yfbfJT7TVly+YrA/n7/h40h6zlW1MC2j3xP9lmaN7CUY3GeBczo09ErOCK+b22YSvZjkjE1mSC8TTQYrXQkcrw5K2g+BVXB+sAcvxbGlX2YfrxRU5ubSbtp9txSjsTO2mCHkQzNXTwvXNoO3Ln7ZD/mzRihwEvEpFzTeNnnAZEXR4z1sZyP3eKW1j7hIeRAmH9Hmo0v6kMjeorogosQvVGuwJx5AUumNXUzt/cUbQQRG3M7nUk3OiDAvp4PedGRyTzU12U5n4GWh23q7TKe6wBJW6ziVDPq6JzPyVfKsTjzApaMzGtl2Pd09OqXZf3SPHfzGWV9dnbewTz3Rs29SvOI8BumkM9DdUY4UsaR1tplJlwp5cSci4mYQqK/izucV4/zYs0xgRQC5ty8N95xxyLn5q6ezu0nbs/wlANkX4Xf2C5BwoKQlwYclnJkzqWAIZlXv4To903eOk6J6XgsZuRJ5wFk+k0jMYYp5JbIdf1oxPQBZzakoVx5ObcChmTiN0Y29Y/Mo7SZh2LJToLh9tMh9wYZ6rMpZaecawHbRDI/d/ncyziGPR0bBTmLqXNEx+Sxxk+VchIuZAELHBWm59LhLAKBuSYA+DSMZqJh92Pkdyk75UIWsJXp+MyIMVmCdI1q3TSx5zw4dhhcuYDYNW5/MXjGPa2FYpWyC84tkmNbxJzkjdS5rCNZe863yI4dwFpKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUA1y69P8BYhkC7Gyfm/8AAAAASUVORK5CYII="

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_auth__ = __webpack_require__(78);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(ComposedComponent){var checkAuthorization=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var Authorization=function(_Component){_inherits(Authorization,_Component);function Authorization(){_classCallCheck(this,Authorization);return _possibleConstructorReturn(this,(Authorization.__proto__||Object.getPrototypeOf(Authorization)).apply(this,arguments));}_createClass(Authorization,[{key:'componentWillMount',value:function componentWillMount(){var url=this.props.match.path;if(!this.props.user){this.context.router.history.push(window.FOLDER+'/signin');this.props.signOut();}else{if(checkAuthorization){if(url!==window.FOLDER+'/cambiar-contrasena'){if(!this.props.user.get('modulos').filter(function(x){return x.get('modulos').filter(function(y){return window.FOLDER+y.get('url')===url;}).count()>0||window.FOLDER+x.get('url')===url;}).count()){this.context.router.history.push(window.FOLDER+'/unauthorized');}}}}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){var url=this.props.match.path;if(!nextProps.user){this.context.router.history.push(window.FOLDER+'/signin');this.props.signOut();}else{if(checkAuthorization){if(url!==window.FOLDER+'/cambiar-contrasena'){if(!nextProps.user.get('modulos').filter(function(x){return x.get('modulos').filter(function(y){return window.FOLDER+y.get('url')===url;}).count()>0||window.FOLDER+x.get('url')===url;}).count()){this.context.router.history.push(window.FOLDER+'/unauthorized');}}}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComposedComponent,this.props);}}]);return Authorization;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Authorization.contextTypes={router:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};function mapStateToProps(state){return{user:state.common.get('user')};}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{signOut:function signOut(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_auth__["e" /* signOut */])());}};};return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Authorization);});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'E-Compras'));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{};}function mapDispatchToProps(dispatch){return{};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App));

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Parametros1_ModalDelete__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_parametros1__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_immutable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var value=x.get(c.get('value'))||Object(__WEBPACK_IMPORTED_MODULE_13_immutable__["Map"])({});return value;}var Parametros1=function(_Component){_inherits(Parametros1,_Component);function Parametros1(){_classCallCheck(this,Parametros1);return _possibleConstructorReturn(this,(Parametros1.__proto__||Object.getPrototypeOf(Parametros1)).apply(this,arguments));}_createClass(Parametros1,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParametros();}},{key:'render',value:function render(){var _this2=this;var parametros=this.props.parametros;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0]',name:'floppy-o',onClick:function onClick(e){return _this2.props.createOrUpdateParametros();},title:'Guardar'})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Parametros',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},parametros.map(function(x,j){var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{size:14,contrast:true,key:'ba['+j+'][0]',name:'plus-circle',onClick:function onClick(e){return _this2.props.addNewParameterDetail(j);},title:'Nueva',style:{marginTop:'-4px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{size:14,contrast:true,key:'ba['+j+'][1]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los Parametros seleccionados?',function(){return _this2.props.deleteParametros(j);});},title:'Eliminar',style:{marginTop:'-4px'},disabled:x.get('data').filter(function(d){return d.get('selected');}).count()===0,danger:true})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:x.getIn(['parametro','nombre'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxSection__["a" /* default */],{title:x.getIn(['parametro','nombre']),actions:boxActions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(j,e.target.checked);},checked:x.get('data').filter(function(x){return x.get('selected');}).count()>0&&x.get('data').filter(function(x){return x.get('selected');}).count()>=x.get('data').count()})),x.get('columnas').map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th['+x.getIn(['parametro','Nombre'])+']['+p.get('id')+']'},p.get('caption'));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,x.get('data').count()>0?x.get('data').map(function(p,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.getIn(['parametro','nombre'])+']['+p.get('registro')+']',className:p.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'bottom'},onChange:function onChange(e){return _this2.props.updateInputs('parametros.'+j+'.data.'+n+'.selected',e.target.checked);},checked:p.get('selected')})),x.get('columnas').map(function(c){var foundVal=findValues(c,p);var value=foundVal.get('valor');var id=foundVal.get('id');if(c.get('Type')){switch(c.get('type')){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.get('format'));break;case'bool':value=value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format(c.get('format'));break;default:}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+foundVal.get('guid')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:value,onChange:function onChange(e){return _this2.props.updateInputs('parametros.'+j+'.data.'+n+'.'+c.get('value')+'.valor',e.target.value);}}));}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:x.get('columnas').count()+1},'No existen registros'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Parametros1_ModalDelete__["a" /* default */],null));}}]);return Parametros1;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{parametros:state.parametros1.get('parametros')};}function mapDispatchToProps(dispatch){return{getParametros:function getParametros(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_parametros1__["d" /* getParametros */])());},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_parametros1__["g" /* updateInputs */])(path,value));},addNewParameterDetail:function addNewParameterDetail(parametroId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_parametros1__["a" /* addNewParameterDetail */])(parametroId));},createOrUpdateParametros:function createOrUpdateParametros(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_parametros1__["b" /* createOrUpdateParametros */])());},toggleSelectAllItems:function toggleSelectAllItems(parametroIndex,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_parametros1__["f" /* toggleSelectAllItems */])(parametroIndex,checked));},deleteParametros:function deleteParametros(parametroIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_parametros1__["c" /* deleteParametros */])(parametroIndex));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_parametros1__["e" /* showHideModalDelete */])(open,message,action));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Parametros1));

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_parametros1__ = __webpack_require__(238);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalDelete:state.parametros1.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_parametros1__["e" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Error404=function(_Component){_inherits(Error404,_Component);function Error404(){_classCallCheck(this,Error404);return _possibleConstructorReturn(this,(Error404.__proto__||Object.getPrototypeOf(Error404)).apply(this,arguments));}_createClass(Error404,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error 404');}}]);return Error404;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{};}function mapDispatchToProps(dispatch){return{};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Error404));

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Error401=function(_Component){_inherits(Error401,_Component);function Error401(){_classCallCheck(this,Error401);return _possibleConstructorReturn(this,(Error401.__proto__||Object.getPrototypeOf(Error401)).apply(this,arguments));}_createClass(Error401,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error 401');}}]);return Error401;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{};}function mapDispatchToProps(dispatch){return{};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Error401));

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CreacionSolicitudServicio_ModalAddServicio__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__ = __webpack_require__(240);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreacionSolicitudServicio=function(_Component){_inherits(CreacionSolicitudServicio,_Component);function CreacionSolicitudServicio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreacionSolicitudServicio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreacionSolicitudServicio.__proto__||Object.getPrototypeOf(CreacionSolicitudServicio)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(list){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreacionSolicitudServicio,[{key:'render',value:function render(){var _this2=this;var _props=this.props,creacionsolicitudservicio=_props.creacionsolicitudservicio,enums=_props.enums;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.createSolicitudServicio();},title:'Guardar',disabled:creacionsolicitudservicio.get('btnSaveDisabled')})];var actionsSectionDetallesServicios=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalAddServicio(true,'Agregar Item','create');},title:'Adicionar servicio'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeSolicitudServicioItems();},title:'Eliminar servicio',danger:true,disabled:creacionsolicitudservicio.get('servicios').filter(function(x){return x.get('selected');}).count()===0})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Solicitud de servicios > Creaci\xF3n de solicitud'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('fullname')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('email')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('extension')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.getIn(['area','nombre'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacionsolicitudservicio.get('tipo')].responsable.fullname||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:enums.solicitudes.tipos[creacionsolicitudservicio.get('tipo')].responsable.email||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacionsolicitudservicio.get('tipo')].responsable.extension||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY/MM/DD'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del servicio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacionsolicitudservicio.get('proyecto_evento'),className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proyecto_evento',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',value:creacionsolicitudservicio.get('fecha_requerido')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('fecha_requerido',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable gesti\xF3n recibo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shared_SelectorInput__["a" /* default */],{value:creacionsolicitudservicio.getIn(['responsable_recibo','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('responsable_recibo');},onReset:function onReset(){return _this2.props.updateInputs('responsable_recibo',null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacionsolicitudservicio.getIn(['responsable_recibo','area'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacionsolicitudservicio.getIn(['responsable_recibo','extension'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable gesti\xF3n ingreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shared_SelectorInput__["a" /* default */],{value:creacionsolicitudservicio.getIn(['responsable_ingreso','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('responsable_ingreso');},onReset:function onReset(){return _this2.props.updateInputs('responsable_ingreso',null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Area'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacionsolicitudservicio.getIn(['responsable_ingreso','area'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacionsolicitudservicio.getIn(['responsable_ingreso','extension'])||'',className:'form-control input-sm',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Detalles servicios',actions:actionsSectionDetallesServicios},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllSolicitudServicioItems(e.target.checked);},checked:creacionsolicitudservicio.get('servicios').filter(function(x){return x.get('selected');}).count()>0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Descripci\xF3n del servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'35%'}},'Centro de costo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudservicio.get('servicios').count()>0?creacionsolicitudservicio.get('servicios').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:x.get('id')?x.get('id'):x.get('guid'),className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('servicios.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'LinkToEdit',style:{textAlign:'right'},onClick:function onClick(){return _this2.props.displayModalAddServicio(true,'Modificación de items','edit',n);}},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('cantidad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('cencos').map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:c.get('id')?c.get('id'):c.get('guid'),className:'label-cenco-dist',title:c.getIn(['cenco','descripcion'])},c.getIn(['cenco','codigo']),' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_3_numeral___default()(c.get('porcentaje')/100).format('0%')));})));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5,style:{textAlign:'center'}},'Para crear los servicios haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'plus-circle'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:creacionsolicitudservicio.get('observaciones'),onChange:function onChange(e){return _this2.props.updateInputs('observaciones',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_AttachedFilesBox__["a" /* default */],{files:creacionsolicitudservicio.get('adjuntos'),removeFiles:this.props.removeSolicitudServicioFiles,updateInputs:this.props.updateInputs,obj:creacionsolicitudservicio,check:'solicitud'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_CreacionSolicitudServicio_ModalAddServicio__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addSolicitudServicioFile();}}));}}]);return CreacionSolicitudServicio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.common.get('user'),creacionsolicitudservicio:state.creacionsolicitudservicio,enums:state.common.get('enums').toJS(),responsable:state.common.getIn(['parametros','SOLICITUDES'])?state.common.getIn(['parametros','SOLICITUDES']).filter(function(x){return x.get('TIPO_SOLICITUD')==state.creacionsolicitudservicio.get('tipo');}).first():null};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["o" /* updateInputs */])(path,value));},showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["q" /* selectFromSelector */])(type,payload));},displayModalAddServicio:function displayModalAddServicio(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["f" /* displayModalAddServicio */])(show,title,mode,index));},removeSolicitudServicioItems:function removeSolicitudServicioItems(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["l" /* removeSolicitudServicioItems */])());},toggleSelectAllSolicitudServicioItems:function toggleSelectAllSolicitudServicioItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["n" /* toggleSelectAllSolicitudServicioItems */])(checked));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["e" /* displayModalAddFile */])(show,title,mode,index));},toggleSelectAllSolicitudServicioFiles:function toggleSelectAllSolicitudServicioFiles(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["m" /* toggleSelectAllSolicitudServicioFiles */])(checked));},uploadFile:function uploadFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["p" /* uploadFile */])(file));},addSolicitudServicioFile:function addSolicitudServicioFile(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["b" /* addSolicitudServicioFile */])());},createSolicitudServicio:function createSolicitudServicio(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["d" /* createSolicitudServicio */])());},removeSolicitudServicioFiles:function removeSolicitudServicioFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["k" /* removeSolicitudServicioFiles */])());},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["i" /* enviarComentario */])());},eliminarComentario:function eliminarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["h" /* eliminarComentario */])(guid));},editarComentario:function editarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudservicio__["g" /* editarComentario */])(guid));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CreacionSolicitudServicio));

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CreacionSolicitudServicioOT_ModalAddServicio__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__ = __webpack_require__(154);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreacionSolicitudServicioOT=function(_Component){_inherits(CreacionSolicitudServicioOT,_Component);function CreacionSolicitudServicioOT(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreacionSolicitudServicioOT);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreacionSolicitudServicioOT.__proto__||Object.getPrototypeOf(CreacionSolicitudServicioOT)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/cencos',fn);},_this.handleOpenSelectorAddCenco=function(list){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){var index=_this.props.creacionsolicitudservicioot.get('cencos').findIndex(function(c){return c.getIn(['cenco','id'])==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT',payload);}};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.creacionsolicitudservicioot.getIn(['ordenador_gasto','id']),comparison:'string'};_this.props.showModalSelector('Listado de centros de costo',columns,'/cencos',fn,customFilter);},_this.handleOpenSelectorAddResponsable=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addResponsable(payload);});};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);},_this.handleOpenSelectorProveedor=function(path){var columns=[{id:1,caption:'Identificacion',value:'identificacion',width:'30%'},{id:2,caption:'Nombre',value:'nombre',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT',payload);};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores',fn);},_this.handleOpenSelectorMoneda=function(moneda){_this.props.updateInputs('moneda',moneda);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreacionSolicitudServicioOT,[{key:'componentWillMount',value:function componentWillMount(){this.props.initReducer();this.props.getParameterByName('DIVISAS');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,creacionsolicitudservicioot=_props.creacionsolicitudservicioot,enums=_props.enums,divisas=_props.divisas;var moneda=creacionsolicitudservicioot.get('moneda');var divisa=Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.createSolicitudServicio();},title:'Guardar',disabled:creacionsolicitudservicioot.get('btnSaveDisabled')})];var actionsSectionDetallesServicios=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.displayModalAddServicio(true,'Agregar Item','create');},title:'Adicionar servicio'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeSolicitudServicioItems();},title:'Eliminar servicio',danger:true,disabled:creacionsolicitudservicioot.get('servicios').filter(function(x){return x.get('selected');}).count()===0})];var actionsDistribucionCencos=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[4][0]',size:14,name:'plus-circle',onClick:function onClick(e){return _this2.props.addCencoSolicitudServicio();},title:'Nueva'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[4][1]',size:14,name:'trash',onClick:function onClick(e){return _this2.props.removeCencosSolicitudServicio();},title:'Eliminar',disabled:creacionsolicitudservicioot.get('cencos').filter(function(x){return x.get('selected');}).count()===0,danger:true})];var actionsAdicionarResponsable=function actionsAdicionarResponsable(path){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba['+path+'][0]',size:14,name:'plus-circle',onClick:function onClick(){return _this2.props.addUsuarioResponsable(path);},title:'Adicionar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba['+path+'][1]',size:14,name:'trash',onClick:function onClick(){return _this2.props.removeSolicitudServicioResponsable(path);},title:'Eliminar',disabled:creacionsolicitudservicioot.get(path).filter(function(x){return x.get('selected');}).count()===0})];};var totalSevicios_sin_iva=creacionsolicitudservicioot.get('servicios').map(function(x){return Number(x.get('cotizado'));}).reduce(function(a,b){b+=a;return b;},0);var totalSevicios=creacionsolicitudservicioot.get('servicios').map(function(x){return Number(x.get('cotizado_iva'));}).reduce(function(a,b){b+=a;return b;},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Solicitud de servicios - Oficina t\xE9cnica > Creaci\xF3n de solicitud'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('fullname')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('email')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('extension')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.getIn(['area','nombre'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacionsolicitudservicioot.get('tipo')].responsable.fullname||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:enums.solicitudes.tipos[creacionsolicitudservicioot.get('tipo')].responsable.email||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacionsolicitudservicioot.get('tipo')].responsable.extension||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY/MM/DD'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del servicio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacionsolicitudservicioot.get('proyecto_evento'),className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proyecto_evento',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:creacionsolicitudservicioot.getIn(['proveedor','nombre'])||'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('proveedor');},onReset:function onReset(){return _this2.props.updateInputs('proveedor',null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',value:creacionsolicitudservicioot.get('fecha_requerido')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('fecha_requerido',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Responsables del ingreso del proveedor',actions:actionsAdicionarResponsable('responsable_ingreso'),onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudservicioot.get('responsable_ingreso').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr3['+a.get('id')+']',className:a.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},value:a.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('responsable_ingreso.'+b+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:a.get('fullname')?a.get('fullname'):'',onClick:function onClick(){return _this2.handleOpenSelectorAddResponsable('responsable_ingreso.'+b);},onReset:function onReset(){return _this2.props.updateInputs('responsable_ingreso.'+b,{selected:a.get('selected'),guid:a.get('guid')});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.get('area')||'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'14%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.get('extension')||'',disabled:true})));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Responsables del recibo del servicio',actions:actionsAdicionarResponsable('responsable_recibo'),onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudservicioot.get('responsable_recibo').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr3['+a.get('id')+']',className:a.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},value:a.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('responsable_recibo.'+b+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:a.get('fullname')?a.get('fullname'):'',onClick:function onClick(){return _this2.handleOpenSelectorAddResponsable('responsable_recibo.'+b);},onReset:function onReset(){return _this2.props.updateInputs('responsable_recibo.'+b,{selected:a.get('selected'),guid:a.get('guid')});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'43%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.get('area')||'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'14%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:a.get('extension')||'',disabled:true})));})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Detalles servicios',actions:actionsSectionDetallesServicios},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-tipo-moneda'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{maxWidth:'86%',padding:'0 10px'}},'Tipo de moneda:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{alignItems:'flex-end'},className:'btn-group',role:'group','aria-label':'Basic outlined example'},divisas&&divisas.map(function(d,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:'d['+i+']',style:{borderRadius:'5px'},onClick:function onClick(){return _this2.handleOpenSelectorMoneda(d.get('CODIGO'));},type:'button',className:moneda==d.get('CODIGO')?'btn btn-primary':'btn btn-outline-primary'},d.get('CODIGO'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllSolicitudServicioItems(e.target.checked);},checked:creacionsolicitudservicioot.get('servicios').filter(function(x){return x.get('selected');}).count()>0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'55%'}},'Descripci\xF3n del servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Valor del servicio sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Valor total del servicio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudservicioot.get('servicios').count()>0?creacionsolicitudservicioot.get('servicios').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:x.get('id')?x.get('id'):x.get('guid'),className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('servicios.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'LinkToEdit',style:{textAlign:'right'},onClick:function onClick(e){return _this2.props.displayModalAddServicio(true,'Modificación de items','edit',n);}},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["q" /* formatcoin */])(x.get('cotizado'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["q" /* formatcoin */])(x.get('cotizado_iva'),divisa.simbolo)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5,style:{textAlign:'center'}},'Para crear los servicios haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'plus-circle'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Recursos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Ordenador del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:creacionsolicitudservicioot.getIn(['ordenador_gasto','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('ordenador_gasto');},onReset:function onReset(){return _this2.props.updateInputs('ordenador_gasto',null);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Anticipo aprobado, %'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:creacionsolicitudservicioot.get('anticipo'),onChange:function onChange(e){return _this2.props.updateInputs('anticipo',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor del anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["q" /* formatcoin */])(Number(creacionsolicitudservicioot.get('anticipo'))/100*totalSevicios_sin_iva,divisa.simbolo),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Distribuci\xF3n en centros de costo',actions:actionsDistribucionCencos,onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudservicioot.get('cencos').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('guid')+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.getIn('selected'),onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:x.getIn(['cenco','descripcion'])?x.getIn(['cenco','descripcion']):'',onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('cencos.'+n+'.cenco');},onReset:function onReset(){return _this2.props.updateInputs('cencos.'+n+'.cenco',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.get('porcentaje'),onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.porcentaje',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_numeral___default()(Number(x.get('porcentaje'))/100*totalSevicios).format('$0,0.00'),disabled:true})));})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:creacionsolicitudservicioot.get('observaciones'),onChange:function onChange(e){return _this2.props.updateInputs('observaciones',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__["a" /* default */],{files:creacionsolicitudservicioot.get('adjuntos'),removeFiles:this.props.removeSolicitudServicioFiles,updateInputs:this.props.updateInputs,obj:creacionsolicitudservicioot,check:'solicitud'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_CreacionSolicitudServicioOT_ModalAddServicio__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addSolicitudServicioFile();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return CreacionSolicitudServicioOT;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.common.get('user'),creacionsolicitudservicioot:state.creacionsolicitudservicioot,enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["s" /* updateInputs */])(path,value));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["q" /* selectFromSelector */])(type,payload));},displayModalAddServicio:function displayModalAddServicio(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["h" /* displayModalAddServicio */])(show,title,mode,index));},removeSolicitudServicioItems:function removeSolicitudServicioItems(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["o" /* removeSolicitudServicioItems */])());},toggleSelectAllSolicitudServicioItems:function toggleSelectAllSolicitudServicioItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["r" /* toggleSelectAllSolicitudServicioItems */])(checked));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["g" /* displayModalAddFile */])(show,title,mode,index));},toggleSelectAllSolicitudServicioFiles:function toggleSelectAllSolicitudServicioFiles(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["q" /* toggleSelectAllSolicitudServicioFiles */])(checked));},uploadFile:function uploadFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["t" /* uploadFile */])(file));},createSolicitudServicio:function createSolicitudServicio(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["f" /* createSolicitudServicio */])());},removeSolicitudServicioResponsable:function removeSolicitudServicioResponsable(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["p" /* removeSolicitudServicioResponsable */])(path));},addResponsable:function addResponsable(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["b" /* addResponsable */])(path));},addCencoSolicitudServicio:function addCencoSolicitudServicio(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["a" /* addCencoSolicitudServicio */])());},removeCencosSolicitudServicio:function removeCencosSolicitudServicio(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["m" /* removeCencosSolicitudServicio */])());},addUsuarioResponsable:function addUsuarioResponsable(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["e" /* addUsuarioResponsable */])(path));},removeSolicitudServicioFiles:function removeSolicitudServicioFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["n" /* removeSolicitudServicioFiles */])());},initReducer:function initReducer(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["l" /* initReducer */])());},addSolicitudServicioFile:function addSolicitudServicioFile(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["c" /* addSolicitudServicioFile */])(data));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["l" /* getParameterByName */])(nombre));},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["k" /* enviarComentario */])());},eliminarComentario:function eliminarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["j" /* eliminarComentario */])(guid));},editarComentario:function editarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_creacionsolicitudservicioot__["i" /* editarComentario */])(guid));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CreacionSolicitudServicioOT));

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_creacionsolicitudservicioot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddServicio=function(_Component){_inherits(ModalAddServicio,_Component);function ModalAddServicio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddServicio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddServicio.__proto__||Object.getPrototypeOf(ModalAddServicio)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddServicio');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddServicio .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddServicio(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddServicio,[{key:'render',value:function render(){var _this2=this;var modalAddServicio=this.props.modalAddServicio;if(!modalAddServicio.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Modal__["a" /* default */],{id:'modalAddServicio',show:true,zindex:2000,width:600},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__["a" /* default */],{title:modalAddServicio.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddServicio.get('btnDisabled'),title:'Aceptar',onClick:function onClick(){return _this2.props.addSolicitudServicioItem();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'Descripcion',className:'form-control input-sm',value:modalAddServicio.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.descripcion',e.target.value);},rows:3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor del servicio sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddServicio.getIn(['data','cotizado']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cotizado',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor total del servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddServicio.getIn(['data','cotizado_iva']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cotizado_iva',e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddServicio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalAddServicio:state.creacionsolicitudservicioot.get('modalAddServicio')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddServicio:function displayModalAddServicio(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_creacionsolicitudservicioot__["h" /* displayModalAddServicio */])(show,title));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_creacionsolicitudservicioot__["s" /* updateInputs */])(path,value));},addSolicitudServicioItem:function addSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_creacionsolicitudservicioot__["d" /* addSolicitudServicioItem */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddServicio));

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CreacionSolicitudServicio_ModalAddServicio__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__ = __webpack_require__(596);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreacionSolicitudBI=function(_Component){_inherits(CreacionSolicitudBI,_Component);function CreacionSolicitudBI(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreacionSolicitudBI);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreacionSolicitudBI.__proto__||Object.getPrototypeOf(CreacionSolicitudBI)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(list){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);},_this.handleOpenSelectorAddCenco=function(list,index){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){var index=_this.props.creacionsolicitudBI.get('cencos').findIndex(function(c){return c.getIn(['cenco','id'])==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION',payload);}};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.creacionsolicitudBI.getIn(['cencos',index,'responsable','id']),comparison:'number'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreacionSolicitudBI,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('UNIDADES');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,creacionsolicitudBI=_props.creacionsolicitudBI,enums=_props.enums,unidades=_props.unidades;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.createSolicitudBienes();},title:'Guardar',disabled:creacionsolicitudBI.get('btnSaveDisabled')})];var actionsSectionDetallesBienes=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.addSolicitudBienesItem();},title:'Adicionar bien'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeSolicitudBienesItem();},title:'Eliminar bien',danger:true,disabled:!creacionsolicitudBI.get('bienes').filter(function(x){return x.get('selected');}).count()})];var actionsSectionDistribucionCencos=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[2][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.addCencoSolicitudBienesItem();},title:'Nuevo cenco'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_BoxButton__["a" /* default */],{key:'ba[2][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeCencosSolicitudBienesItem();},title:'Eliminar',disabled:!creacionsolicitudBI.get('cencos').filter(function(x){return x.get('selected');}).count()})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Solicitud de Bienes e Investigaci\xF3n > Creaci\xF3n de solicitud'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('fullname')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('email')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('extension')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.getIn(['area','nombre'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[7].responsable.fullname||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:enums.solicitudes.tipos[7].responsable.email||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[7].responsable.extension||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY/MM/DD'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del bien solicitado'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacionsolicitudBI.get('proyecto_evento'),className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proyecto_evento',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:creacionsolicitudBI.get('tipo_almacen'),onChange:function onChange(e){return _this2.props.updateInputs('tipo_almacen',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Seleccione el almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'laboratorio'},'Laboratorio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'materiales'},'Materiales')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',value:creacionsolicitudBI.get('fecha_requerido')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('fecha_requerido',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Detalle Bienes',actions:actionsSectionDetallesBienes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllSolicitudBienesItems(e.target.checked);},checked:creacionsolicitudBI.get('bienes').filter(function(x){return x.get('selected');}).count()===creacionsolicitudBI.get('bienes').count()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'65%'}},'Descripci\xF3n bienes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Unidad / Presentaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudBI.get('bienes').count()>0?creacionsolicitudBI.get('bienes').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:x.get('id')?x.get('id'):x.get('guid'),className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected'),onChange:function onChange(e){return _this2.props.editSolicitudBienesItem(n,{selected:e.target.checked});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:x.get('descripcion')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.editSolicitudBienesItem(n,{descripcion:e.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',value:x.get('cantidad_requerida')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.editSolicitudBienesItem(n,{cantidad_requerida:e.target.value});},min:'1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:x.get('unidad')||'',onChange:function onChange(e){return _this2.props.editSolicitudBienesItem(n,{unidad:e.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Seleccione unidad'),unidades&&unidades.map(function(unidad,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:idx,value:unidad.get('UNIDAD')},unidad.get('UNIDAD'));}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:5,style:{textAlign:'center'}},'Para crear los bienes haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'plus-circle'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n de centros de costo',actions:actionsSectionDistribucionCencos},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllSolicitudBienesCencos(e.target.checked);},checked:creacionsolicitudBI.get('cencos').filter(function(x){return x.get('selected');}).count()===creacionsolicitudBI.get('cencos').count()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'45%'}},'Responsable Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'45%'}},'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Porcentaje(%)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudBI.get('cencos').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('guid')+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.getIn('selected'),onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:x.getIn(['responsable','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('cencos.'+n+'.responsable');},onReset:function onReset(){return _this2.props.updateInputs('cencos.'+n+'.responsable',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'30%'}},x.get('responsable')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_SelectorInput__["a" /* default */],{value:x.get('cenco')?x.getIn(['cenco','codigo']):'',onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('cencos.'+n+'.cenco',n);},onReset:function onReset(){return _this2.props.updateInputs('cencos.'+n+'.cenco',null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',placeholder:'Seleccione un responsable del cenco',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.get('porcentaje'),onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.porcentaje',e.target.value);},disabled:x.get('responsable')==null})));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:creacionsolicitudBI.get('observaciones'),onChange:function onChange(e){return _this2.props.updateInputs('observaciones',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__["a" /* default */],{files:creacionsolicitudBI.get('adjuntos'),removeFiles:this.props.removeSolicitudServicioBIFiles,updateInputs:this.props.updateInputs,obj:creacionsolicitudBI,check:'solicitud'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxSection__["a" /* default */],{title:'Recomendaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-sorted',style:{backgroundColor:'#eee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'SI EL EQUIPO REQUIERE ACCESORIOS (KIT DE HERRAMIENTAS O PARTES) ADICIONALES PARA SU FUNCIONAMIENTO, DEBE RELACIONARLO EN EL SIGUIENTE CUADRO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'EN LA DESCRIPCI\xD3N DE LOS BIENES, FAVOR INDICAR MARCA, MODELO, CARACTER\xCDSTICAS Y ESPECIFICACIONES.'))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_CreacionSolicitudServicio_ModalAddServicio__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addSolicitudServicioBIFile();}}));}}]);return CreacionSolicitudBI;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.common.get('user'),creacionsolicitudBI:state.creacionsolicitudBI,enums:state.common.get('enums').toJS(),responsable:state.common.getIn(['parametros','SOLICITUDES'])?state.common.getIn(['parametros','SOLICITUDES']).filter(function(x){return x.get('TIPO_SOLICITUD')==state.creacionsolicitudBI.get('tipo');}).first():null,unidades:state.common.getIn(['parametros','UNIDADES'])};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["n" /* updateInputs */])(path,value));},showModalSelector:function showModalSelector(title,fields,url,action,filters){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action,filters));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},addSolicitudBienesItem:function addSolicitudBienesItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["b" /* addSolicitudBienesItem */])());},editSolicitudBienesItem:function editSolicitudBienesItem(index,data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["e" /* editSolicitudBienesItem */])(index,data));},removeSolicitudBienesItem:function removeSolicitudBienesItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["j" /* removeSolicitudBienesItem */])());},addCencoSolicitudBienesItem:function addCencoSolicitudBienesItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["a" /* addCencoSolicitudBienesItem */])());},removeCencosSolicitudBienesItem:function removeCencosSolicitudBienesItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["i" /* removeCencosSolicitudBienesItem */])());},toggleSelectAllSolicitudBienesItems:function toggleSelectAllSolicitudBienesItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["m" /* toggleSelectAllSolicitudBienesItems */])(checked));},toggleSelectAllSolicitudBienesCencos:function toggleSelectAllSolicitudBienesCencos(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["l" /* toggleSelectAllSolicitudBienesCencos */])(checked));},createSolicitudBienes:function createSolicitudBienes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["d" /* createSolicitudBienes */])());},addSolicitudServicioBIFile:function addSolicitudServicioBIFile(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["c" /* addSolicitudServicioBIFile */])());},removeSolicitudServicioBIFiles:function removeSolicitudServicioBIFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["k" /* removeSolicitudServicioBIFiles */])());},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["h" /* enviarComentario */])());},eliminarComentario:function eliminarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["g" /* eliminarComentario */])(guid));},editarComentario:function editarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_creacionSolicitudbi__["f" /* editarComentario */])(guid));},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["l" /* getParameterByName */])(param));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CreacionSolicitudBI));

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initReducer */
/* harmony export (immutable) */ __webpack_exports__["n"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["b"] = addSolicitudBienesItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = editSolicitudBienesItem;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCencoSolicitudBienesItem;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeCencosSolicitudBienesItem;
/* harmony export (immutable) */ __webpack_exports__["j"] = removeSolicitudBienesItem;
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleSelectAllSolicitudBienesItems;
/* harmony export (immutable) */ __webpack_exports__["l"] = toggleSelectAllSolicitudBienesCencos;
/* harmony export (immutable) */ __webpack_exports__["c"] = addSolicitudServicioBIFile;
/* harmony export (immutable) */ __webpack_exports__["k"] = removeSolicitudServicioBIFiles;
/* harmony export (immutable) */ __webpack_exports__["d"] = createSolicitudBienes;
/* harmony export (immutable) */ __webpack_exports__["h"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["f"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["g"] = eliminarComentario;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(3);
function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_336" /* REINICIAR_SOLICITUD_BIENES_INVESTIGACION */]});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_210" /* MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION */],payload:{path:path,value:value}});};}function addSolicitudBienesItem(){return{type:__WEBPACK_IMPORTED_MODULE_4__types__["_9" /* ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION */]};}function editSolicitudBienesItem(index,data){return{type:__WEBPACK_IMPORTED_MODULE_4__types__["_223" /* MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION */],index:index,data:data};}function addCencoSolicitudBienesItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["Z" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION */]});};}function removeCencosSolicitudBienesItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_131" /* ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM */]});};}function removeSolicitudBienesItem(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_152" /* ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION */]});};}function toggleSelectAllSolicitudBienesItems(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_67" /* CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION */],payload:checked});};}function toggleSelectAllSolicitudBienesCencos(checked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_63" /* CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION */],payload:checked});};}function addSolicitudServicioBIFile(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["Q" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION */],payload:data});};fn1(dispatch);};}function removeSolicitudServicioBIFiles(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_123" /* ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION */]});};}function createSolicitudBienes(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_91" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_91" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION */],payload:false});};var fn2=function fn2(d){return d(initReducer());};fn0(dispatch);var data=getState().creacionsolicitudBI;var errors=validarSolicitud(data);var files=data.get('adjuntos');if(errors.length){return errors.forEach(function(element){__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warning(element,{bodyClassName:'toastify-content toastify-warning'});});}else{axios.post(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/bienes-investigacion',data).then(function(res){var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_5__utils_history__["a" /* default */].push(window.FOLDER+'/');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('La solicitud ha sido guardada exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn1,fn2,fn3,fn4]));}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});}};}function enviarComentario(){return function(dispatch,getState){var guid=getState().creacionsolicitudBI.getIn(['comentario','guid']);var comentario=getState().creacionsolicitudBI.getIn(['comentario','texto']);var usuario=getState().common.get('user');var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_165" /* ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION */],payload:{comentario:comentario,guid:guid,usuario:usuario}});};fn1(dispatch);};}function editarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_111" /* EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION */],payload:{guid:guid}});};fn1(dispatch);};}function eliminarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_135" /* ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION */],payload:{guid:guid}});};fn1(dispatch);};}function validarSolicitud(data){var errors=[];//Foreach bien, validar que la descripcion no sea repetida
var descripciones={};data.get('bienes').forEach(function(item,index){var desc=item.get('descripcion').trim().toLowerCase();if(descripciones[desc]){errors.push('Item '+(index+1)+': La descripci\xF3n "'+item.get('descripcion')+'" est\xE1 repetida en el \xEDtem '+descripciones[desc]);}else{descripciones[desc]=index+1;}});data.get("bienes").forEach(function(item,index){if(!item.get("unidad")){errors.push('Item '+(index+1)+': La unidad en "'+item.get("descripcion")+'" es requerida');}});// validar si hay un bien con cantidad cero
var index=data.get('bienes').findIndex(function(item){return Number(item.get('cantidad_requerida'))===0;});if(index>=0){errors.push('Item '+(index+1)+': '+data.getIn(['bienes',index,'descripcion'])+' debe ser mayor a cero');}// validar si porcentaje de distribucion de cencos es igual a 100
var porcentaje=data.get('cencos').reduce(function(a,b){a+=Number(b.get('porcentaje'));return a;},0);if(porcentaje!==100){errors.push('El porcentaje total de distribuci\xF3n de los cencos es diferente de 100');}if(data.get('fecha_requerido')&&__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract('days',1).isAfter(data.get('fecha_requerido'))){errors.push('La fecha de entrega no debe ser inferior a la de hoy');}if(data.get('cencos').filter(function(x){return x.get('cenco')===null;}).count()>0){errors.push('La creación de bienes requiere que todos los centros de costos estén definidos');}if(data.get('cencos').filter(function(x){return x.get('porcentaje')<1;}).count()>0)errors.push('El porcentaje en los cencos debe ser mayor a 0');if(data.get('adjuntos').count()>0){var size=data.get('adjuntos').reduce(function(a,b){a+=b.get('file').size;return a;},0);if(size>__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["W" /* uploadMaxSize */].value)errors.push('La capacidad m\xE1xima para subir archivos es de de '+__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["W" /* uploadMaxSize */].unidad);if(data.get('adjuntos').filter(function(x){return!x.get('clasificacion');}).count()>0)errors.push('Todos los archivos deben tener una clasificación');}return errors;}

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Solicitudes_ModalFilter__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Solicitudes_ModalDelete__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// export const tableCols = [
//     { id: 1, caption: 'Id', value: 'id', type: 'number', format: '', width: '5%', LinkToEdit: true },
//     { id: 2, caption: 'Asignada a', value: 'responsable_compras', type: 'string', format: '', width: '15%' },
//     { id: 3, caption: 'Tipo', value: 'tipo', type: 'string', format: '', width: '15%' },
//     { id: 4, caption: 'Area', value: 'area', type: 'string', format: '', width: '10%' },
//     { id: 5, caption: 'Proyecto/Evento/Actividad', value: 'proyecto_evento', type: 'string', format: '', width: '30%' },
//     { id: 6, caption: 'Fecha creación', value: 'fecha_creacion', type: 'datetime', format: 'YYYY-MM-DD HH:mm:ss', width: '10%' },
//     { id: 7, caption: 'Estado', value: 'estado', type: 'string', format: '', width: '10%' },
// ]
function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.solicitudes.estados[value];}else if(c.value==='tipo'){value=enums.solicitudes.tipos[value].caption;}return value;}var Solicitudes=function(_Component){_inherits(Solicitudes,_Component);function Solicitudes(){_classCallCheck(this,Solicitudes);return _possibleConstructorReturn(this,(Solicitudes.__proto__||Object.getPrototypeOf(Solicitudes)).apply(this,arguments));}_createClass(Solicitudes,[{key:'componentWillMount',value:function componentWillMount(){this.props.getSolicitudes(1);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,solicitudes=_props.solicitudes,orderBy=_props.orderBy,page=_props.page,totalRecords=_props.totalRecords,showRecords=_props.showRecords,enums=_props.enums;var tableCols=[{id:1,caption:'Id',value:'id',type:'string',format:'',width:'5%',LinkToEdit:true},{id:2,caption:'Asignada a',value:'responsable_compras',type:'string',format:'',width:'15%'},{id:3,caption:'Tipo',value:'tipo',type:'string',format:'',width:'15%',enums:Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["o" /* extractKeyValue */])(enums.solicitudes.tipos,'caption')},{id:4,caption:'Area',value:'area',type:'string',format:'',width:'10%'},{id:5,caption:'Proyecto/Evento/Actividad',value:'proyecto_evento',type:'string',format:'',width:'35%'},{id:6,caption:'Fecha creación',value:'fecha_creacion',type:'datetime',format:'YYYY-MM-DD HH:mm:ss',width:'10%'},{id:7,caption:'Estado',value:'estado',type:'string',format:'',width:'10%',enums:Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["o" /* extractKeyValue */])(enums.solicitudes.estados)}];var boxActions=[// <BoxButton key="ba[0][0]" name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea anular las solicitudes seleccionadas?`, () => this.props.deleteSolicitudes()) } disabled={ solicitudes.filter(x => x.get('selected')).count() === 0 } danger title="Anular solicitud" />,
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.getSolicitudes(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-right'})});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Listado de solicitudes',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeRecordsToShow(records);},pagination:pagination}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(e.target.checked);},checked:solicitudes.filter(function(x){return x.get('selected');}).count()>0&&solicitudes.filter(function(x){return x.get('selected')&&x.get('visible');}).count()>=solicitudes.filter(function(x){return x.get('visible');}).count()})),tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudes.filter(function(x){return x.get('visible');}).count()>0?solicitudes.filter(function(x){return x.get('visible');}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectItem(x.get('id'),e.target.checked);},checked:x.get('selected')})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format);alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_12__utils_history__["a" /* default */].push(window.FOLDER+('/solicitudes/'+enums.solicitudes.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Solicitudes_ModalFilter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Solicitudes_ModalDelete__["a" /* default */],null));}}]);return Solicitudes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitudes:state.solicitudes.get('solicitudes'),orderBy:state.solicitudes.get('orderBy'),totalRecords:state.solicitudes.get('totalRecords'),showRecords:state.solicitudes.get('showRecords'),page:state.solicitudes.get('page'),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{getSolicitudes:function getSolicitudes(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["f" /* getSolicitudes */])(page));},toggleSelectItem:function toggleSelectItem(id,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["m" /* toggleSelectItem */])(id,checked));},toggleSelectAllItems:function toggleSelectAllItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["l" /* toggleSelectAllItems */])(checked));},filterSolicitudes:function filterSolicitudes(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["e" /* filterSolicitudes */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["h" /* setOrderBy */])(field));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["i" /* showHideModalDelete */])(open,message,action));},deleteSolicitudes:function deleteSolicitudes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["d" /* deleteSolicitudes */])());},changeRecordsToShow:function changeRecordsToShow(records){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["c" /* changeRecordsToShow */])(records));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudes__["j" /* showHideModalFilter */])(state,tableCols));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Solicitudes));

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudes__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { tableCols } from '../../containers/Solicitudes'
var ModalFilter=function(_Component){_inherits(ModalFilter,_Component);function ModalFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalFilter.__proto__||Object.getPrototypeOf(ModalFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalFilter');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalFilter .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalFilter(false);},300);},_this.handleApplyFilters=function(e){_this.handleCloseModal();_this.props.applyFilterCriterias();},_this.showTypeInput=function(index,item){var _this$props=_this.props,modalFilter=_this$props.modalFilter,updateModalFilterCriteria=_this$props.updateModalFilterCriteria;var tableCols=modalFilter.get('columnas');var value=modalFilter.getIn(['filters',index,'column']);var col=tableCols.filter(function(c){return c.get('value')==value;}).first();if(col.get('enums')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}},col.get('enums').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+index+']['+n+']',value:x.get('value')},x.get('text'));}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalFilter,[{key:'render',value:function render(){var _this2=this;var modalFilter=this.props.modalFilter;if(!modalFilter.get('show')){return null;}var tableCols=modalFilter.get('columnas');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalFilter',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Filtro',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalFilter");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus',onClick:function onClick(e){return _this2.props.addModalFilterCriteria();},title:'Aceptar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'trash',onClick:function onClick(e){return _this2.props.removeCheckedModalFilterCriterias();},disabled:modalFilter.get('filters').filter(function(item){return item.get('checked');}).count()===0,title:'Eliminar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',onClick:function onClick(e){return _this2.handleApplyFilters();},title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12',style:{height:'200px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Columna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Operador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Filtro'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalFilter.get('filters').count()>0?modalFilter.get('filters').map(function(item,index){var key='tr2['+index+']';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key,className:''+(item.get('checked')?'info':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.props.toggleCheckedModalFilterCriterias(index,e.target.checked);},checked:item.get('checked')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('column'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'column',e.target.value);}},tableCols.map(function(x1,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+x1.get('id')+']['+n1+']',value:x1.get('value')},x1.get('caption'));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('operator'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'operator',e.target.value);}},__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["H" /* operators */].filter(function(x){return x.comparisons.includes(item.get('comparison'));}).map(function(item1,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+item1.id+']['+n+']',value:item1.value},item1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.showTypeInput(index,item)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',style:{textAlign:'center'}},'No hay filtros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalFilter:state.solicitudes.get('modalFilter')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudes__["j" /* showHideModalFilter */])(state));},addModalFilterCriteria:function addModalFilterCriteria(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudes__["a" /* addModalFilterCriteria */])());},removeCheckedModalFilterCriterias:function removeCheckedModalFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudes__["g" /* removeCheckedModalFilterCriterias */])());},toggleCheckedModalFilterCriterias:function toggleCheckedModalFilterCriterias(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudes__["k" /* toggleCheckedModalFilterCriterias */])(index,checked));},updateModalFilterCriteria:function updateModalFilterCriteria(index,attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudes__["n" /* updateModalFilterCriteria */])(index,attr,value));},applyFilterCriterias:function applyFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudes__["b" /* applyFilterCriterias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalFilter));

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_solicitudes__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDelete=function(_Component){_inherits(ModalDelete,_Component);function ModalDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDelete.__proto__||Object.getPrototypeOf(ModalDelete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalDelete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalDelete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalDelete(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDelete,[{key:'render',value:function render(){var _this2=this;var modalDelete=this.props.modalDelete;if(!modalDelete.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalDelete',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalDelete.get('message')||'Esta seguro que desea eliminar este registro?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal(e);}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:modalDelete.get('action')},'Ok')));}}]);return ModalDelete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalDelete:state.solicitudes.get('modalDelete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalDelete:function showHideModalDelete(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_solicitudes__["i" /* showHideModalDelete */])(open));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalDelete));

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SolicitudServicio_General__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SolicitudServicio_Proveedores__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SolicitudServicio_Cotizaciones__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicio_Aprobaciones__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SolicitudServicio_Documentos__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SolicitudServicio_Cancelacion__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SolicitudServicio_CompraDirecta__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { getSolicitud, updateSolicitudServicio } from '../actions/solicitudservicio'
var SolicitudServicio=function(_Component){_inherits(SolicitudServicio,_Component);function SolicitudServicio(props){_classCallCheck(this,SolicitudServicio);var _this=_possibleConstructorReturn(this,(SolicitudServicio.__proto__||Object.getPrototypeOf(SolicitudServicio)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar la solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerCancelacion();});};_this.state={tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_SolicitudServicio_General__["a" /* default */],null),estado:1},{id:1,caption:'Proveedores',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_SolicitudServicio_Proveedores__["a" /* default */],null),estado:1},{id:2,caption:'Cotizaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SolicitudServicio_Cotizaciones__["a" /* default */],null),estado:2},{id:3,caption:'Aprobaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicio_Aprobaciones__["a" /* default */],null),estado:3},{id:4,caption:'Documentos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SolicitudServicio_Documentos__["a" /* default */],null),estado:4},{id:5,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SolicitudServicio_Cancelacion__["a" /* default */],null),estado:0},{id:6,caption:'Compra directa',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SolicitudServicio_CompraDirecta__["a" /* default */],null),estado:4}],selected:0};return _this;}_createClass(SolicitudServicio,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){this.props.getSolicitud(this.props.match.params.id);var params=new URLSearchParams(this.props.location.search);if(params.has("aprobacion")){this.setState({selected:3});}this.props.getParameterByName('DIVISAS');}else{__WEBPACK_IMPORTED_MODULE_12__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes');}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,btnSaveDisabled=_props.btnSaveDisabled,estado=_props.estado,btnRComprasDisabled=_props.btnRComprasDisabled,solicitud=_props.solicitud,aprobadores=_props.aprobadores;var readOnly=!Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);var documentos_proceso=solicitud.get('documentos')?solicitud.get('documentos').filter(function(d){return d.get('estado')==4||d.get('estado')>6;}).count():0;var facturas_directas=solicitud.get('servicios')?solicitud.get('servicios').filter(function(b){return b.get('factura_compra_directa_servicios')&&b.get('compra_directa');}).count():0;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.updateSolicitudServicio();},title:'Actualizar solicitud',disabled:btnSaveDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'user',onClick:function onClick(){return _this2.props.canmbiarResponsable(solicitud,'ACTUALIZAR_SOLICITUD_SERVICIO');},title:'Cambiar responsable',disabled:btnRComprasDisabled||selected!==0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'ban',onClick:function onClick(){return _this2.cancel();},title:'Aprobar cancelaci\xF3n solicitud',disabled:readOnly||selected!==5||estado==0})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){if(solicitud.get('documentos')&&x.id===4&&solicitud.get('documentos').count()===0)return null;if(x.id===3&&aprobadores.count()===0)return null;if(estado==1){return x.id==0||x.id==1||x.id==5;}else if((documentos_proceso>0||facturas_directas>0)&&x.id===5){return null;}else if(estado>=2){return x.estado<=estado;}else if(estado==0){return x.id==0||x.id==5;}}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li01['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component)))));}}]);return SolicitudServicio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{btnSaveDisabled:state.solicitudservicio.get('btnSaveDisabled'),btnRComprasDisabled:state.solicitudservicio.get('btnRComprasDisabled'),estado:state.solicitudservicio.get('estado'),solicitud:state.solicitudservicio.get('solicitud'),aprobadores:state.solicitudservicio.get('aprobadores')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["r" /* getSolicitud */])(id));},updateSolicitudServicio:function updateSolicitudServicio(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["D" /* updateSolicitudServicio */])());},canmbiarResponsable:function canmbiarResponsable(solicitud,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["b" /* canmbiarResponsable */])(solicitud,type));},registerCancelacion:function registerCancelacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["v" /* registerCancelacion */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["l" /* getParameterByName */])(nombre));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SolicitudServicio));

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _defaultFormatter = __webpack_require__(602);

var _defaultFormatter2 = _interopRequireDefault(_defaultFormatter);

var _dateParser = __webpack_require__(603);

var _dateParser2 = _interopRequireDefault(_dateParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = React.Component;


// Just some simple constants for readability
var MINUTE = 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var WEEK = DAY * 7;
var MONTH = DAY * 30;
var YEAR = DAY * 365;

var TimeAgo = function (_Component) {
  _inherits(TimeAgo, _Component);

  function TimeAgo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeAgo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeAgo.__proto__ || Object.getPrototypeOf(TimeAgo)).call.apply(_ref, [this].concat(args))), _this), _this.isStillMounted = false, _this.tick = function (refresh) {
      if (!_this.isStillMounted || !_this.props.live) {
        return;
      }

      var then = (0, _dateParser2.default)(_this.props.date).valueOf();
      if (!then) {
        console.warn('[react-timeago] Invalid Date provided');
        return;
      }

      var now = _this.props.now();
      var seconds = Math.round(Math.abs(now - then) / 1000);

      var unboundPeriod = seconds < MINUTE ? 1000 : seconds < HOUR ? 1000 * MINUTE : seconds < DAY ? 1000 * HOUR : 0;
      var period = Math.min(Math.max(unboundPeriod, _this.props.minPeriod * 1000), _this.props.maxPeriod * 1000);

      if (period) {
        if (_this.timeoutId) {
          clearTimeout(_this.timeoutId);
        }
        _this.timeoutId = setTimeout(_this.tick, period);
      }

      if (!refresh) {
        _this.forceUpdate();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeAgo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isStillMounted = true;
      if (this.props.live) {
        this.tick(true);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (this.props.live !== lastProps.live || this.props.date !== lastProps.date) {
        if (!this.props.live && this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.tick();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isStillMounted = false;
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = undefined;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _props = this.props,
          date = _props.date,
          formatter = _props.formatter,
          Komponent = _props.component,
          live = _props.live,
          minPeriod = _props.minPeriod,
          maxPeriod = _props.maxPeriod,
          title = _props.title,
          now = _props.now,
          passDownProps = _objectWithoutProperties(_props, ['date', 'formatter', 'component', 'live', 'minPeriod', 'maxPeriod', 'title', 'now']);
      /* eslint-enable no-unused-vars */


      var then = (0, _dateParser2.default)(date).valueOf();
      if (!then) {
        return null;
      }
      var timeNow = now();
      var seconds = Math.round(Math.abs(timeNow - then) / 1000);
      var suffix = then < timeNow ? 'ago' : 'from now';

      var _ref2 = seconds < MINUTE ? [Math.round(seconds), 'second'] : seconds < HOUR ? [Math.round(seconds / MINUTE), 'minute'] : seconds < DAY ? [Math.round(seconds / HOUR), 'hour'] : seconds < WEEK ? [Math.round(seconds / DAY), 'day'] : seconds < MONTH ? [Math.round(seconds / WEEK), 'week'] : seconds < YEAR ? [Math.round(seconds / MONTH), 'month'] : [Math.round(seconds / YEAR), 'year'],
          _ref3 = _slicedToArray(_ref2, 2),
          value = _ref3[0],
          unit = _ref3[1];

      var passDownTitle = typeof title === 'undefined' ? typeof date === 'string' ? date : (0, _dateParser2.default)(date).toISOString().substr(0, 16).replace('T', ' ') : title;

      var spreadProps = Komponent === 'time' ? Object.assign({}, passDownProps, {
        dateTime: (0, _dateParser2.default)(date).toISOString()
      }) : passDownProps;

      var nextFormatter = _defaultFormatter2.default.bind(null, value, unit, suffix);

      return React.createElement(
        Komponent,
        _extends({}, spreadProps, { title: passDownTitle }),
        formatter(value, unit, suffix, then, nextFormatter, now)
      );
    }
  }]);

  return TimeAgo;
}(Component);

TimeAgo.displayName = 'TimeAgo';
TimeAgo.defaultProps = {
  live: true,
  component: 'time',
  minPeriod: 0,
  maxPeriod: Infinity,
  formatter: _defaultFormatter2.default,
  now: function now() {
    return Date.now();
  }
};
exports.default = TimeAgo;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFormatter;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function defaultFormatter(value, unit, suffix) {
  if (value !== 1) {
    unit += 's';
  }
  return value + ' ' + unit + ' ' + suffix;
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dateParser;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function dateParser(date) {
  var parsed = new Date(date);
  if (!Number.isNaN(parsed.valueOf())) {
    return parsed;
  }

  var parts = String(date).match(/\d+/g);
  if (parts == null || parts.length <= 2) {
    return parsed;
  } else {
    var _parts$map = parts.map(function (x) {
      return parseInt(x);
    }),
        _parts$map2 = _toArray(_parts$map),
        firstP = _parts$map2[0],
        secondP = _parts$map2[1],
        restPs = _parts$map2.slice(2);

    var correctedParts = [firstP, secondP - 1].concat(_toConsumableArray(restPs));
    var isoDate = new Date(Date.UTC.apply(Date, _toConsumableArray(correctedParts)));
    return isoDate;
  }
}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Spanish
var strings = {
  prefixAgo: 'hace',
  prefixFromNow: 'dentro de',
  suffixAgo: '',
  suffixFromNow: '',
  seconds: 'menos de un minuto',
  minute: 'un minuto',
  minutes: 'unos %d minutos',
  hour: 'una hora',
  hours: '%d horas',
  day: 'un día',
  days: '%d días',
  month: 'un mes',
  months: '%d meses',
  year: 'un año',
  years: '%d años'
};
exports.default = strings;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildFormatter;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// If the numbers array is present, format numbers with it,
// otherwise just cast the number to a string and return it
var normalizeNumber = function normalizeNumber(numbers, value) {
  return numbers && numbers.length === 10 ? String(value).split('').map(function (digit) {
    return digit.match(/^[0-9]$/) ? numbers[parseInt(digit)] : digit;
  }).join('') : String(value);
};

// Take a string or a function that takes number of days and returns a string
// and provide a uniform API to create string parts


var normalizeFn = function normalizeFn(value, distanceMillis, numbers) {
  return function (stringOrFn) {
    return typeof stringOrFn === 'function' ? stringOrFn(value, distanceMillis).replace(/%d/g, normalizeNumber(numbers, value)) : stringOrFn.replace(/%d/g, normalizeNumber(numbers, value));
  };
};

function buildFormatter(strings) {
  return function formatter(value, unit, suffix, epochMiliseconds, _nextFormmater, now) {
    var current = now();
    // convert weeks to days if strings don't handle weeks
    if (unit === 'week' && !strings.week && !strings.weeks) {
      var _days = Math.round(Math.abs(epochMiliseconds - current) / (1000 * 60 * 60 * 24));
      value = _days;
      unit = 'day';
    }

    // create a normalize function for given value
    var normalize = normalizeFn(value, current - epochMiliseconds, strings.numbers != null ? strings.numbers : undefined);

    // The eventual return value stored in an array so that the wordSeparator can be used
    var dateString = [];

    // handle prefixes
    if (suffix === 'ago' && strings.prefixAgo) {
      dateString.push(normalize(strings.prefixAgo));
    }
    if (suffix === 'from now' && strings.prefixFromNow) {
      dateString.push(normalize(strings.prefixFromNow));
    }

    // Handle Main number and unit
    var isPlural = value > 1;
    if (isPlural) {
      var stringFn = strings[unit + 's'] || strings[unit] || '%d ' + unit;
      dateString.push(normalize(stringFn));
    } else {
      var _stringFn = strings[unit] || strings[unit + 's'] || '%d ' + unit;
      dateString.push(normalize(_stringFn));
    }

    // Handle Suffixes
    if (suffix === 'ago' && strings.suffixAgo) {
      dateString.push(normalize(strings.suffixAgo));
    }
    if (suffix === 'from now' && strings.suffixFromNow) {
      dateString.push(normalize(strings.suffixFromNow));
    }

    // join the array into a string and return it
    var wordSeparator = typeof strings.wordSeparator === 'string' ? strings.wordSeparator : ' ';
    return dateString.join(wordSeparator);
  };
}

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddServicio=function(_Component){_inherits(ModalAddServicio,_Component);function ModalAddServicio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddServicio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddServicio.__proto__||Object.getPrototypeOf(ModalAddServicio)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddServicio');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddServicio .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddServicio(false);},300);},_this.handleOpenSelector=function(path,index){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1',payload);_this.props.updateInputs('modalAddServicio.data.cencos.'+index+'.id',null);_this.props.updateInputs('modalAddServicio.data.cencos.'+index+'.codigo',null);_this.props.updateInputs('modalAddServicio.data.cencos.'+index+'.descripcion',null);_this.props.updateInputs('modalAddServicio.data.cencos.'+index+'.responsable_id',a.id);_this.props.updateInputs('modalAddServicio.data.cencos.'+index+'.pivot.cenco_id',null);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/cencos',fn);},_this.handleOpenSelectorAddCenco=function(list,cenco_idx){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var cenco=_this.props.modalAddServicio.getIn(['data','cencos',cenco_idx]).toJS();var payload={};var fn=function fn(a){var index=_this.props.modalAddServicio.getIn(['data','cencos']).findIndex(function(c){return c.getIn(['cenco','id'])==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_2_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{cenco.id=a.id;cenco.codigo=a.codigo;cenco.descripcion=a.descripcion;payload.path=list;payload.value=cenco;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1',payload);_this.props.updateInputs('modalAddServicio.data.cencos.'+cenco_idx+'.pivot.cenco_id',a.id);}};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.modalAddServicio.getIn(['data','cencos',cenco_idx,'usuario','id']),comparison:'string'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddServicio,[{key:'render',value:function render(){var _this2=this;var modalAddServicio=this.props.modalAddServicio;if(!modalAddServicio.get('show')){return null;}var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',size:14,name:'plus-circle',onClick:function onClick(e){return _this2.props.addCencoSolicitudServicioItem();},title:'Nueva'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',size:14,name:'trash',onClick:function onClick(e){return _this2.props.removeCencosSolicitudServicioItem();},title:'Eliminar',disabled:modalAddServicio.getIn(['data','cencos']).filter(function(x){return x.get('selected');}).count()===0,danger:true})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalAddServicio',show:true,zindex:2000,width:800},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:modalAddServicio.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddServicio.get('btnDisabled'),title:'Aceptar',onClick:function onClick(){return _this2.props.addSolicitudServicioItem();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'Descripcion',className:'form-control input-sm',value:modalAddServicio.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.descripcion',e.target.value);},rows:3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddServicio.getIn(['data','cantidad']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cantidad',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_Box__["a" /* default */],{title:'Centros de costo',actions:boxActions,onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalAddServicio.getIn(['data','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('guid')+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.getIn('selected'),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Shared_SelectorInput__["a" /* default */],{value:x.getIn(['usuario','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('modalAddServicio.data.cencos.'+n+'.usuario',n);},onReset:function onReset(){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n+'.usuario',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'30%'}},x.get('usuario')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Shared_SelectorInput__["a" /* default */],{value:x.get('descripcion')||'',onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('modalAddServicio.data.cencos.'+n,n);},onReset:function onReset(){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n,null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',placeholder:'Seleccione un responsable del cenco',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.getIn(['pivot','porcentaje']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.cencos.'+n+'.pivot.porcentaje',e.target.value);},disabled:x.get('usuario')==null})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddServicio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddServicio:state.solicitudservicio.get('modalAddServicio')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddServicio:function displayModalAddServicio(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["l" /* displayModalAddServicio */])(show));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["q" /* selectFromSelector */])(type,payload));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["C" /* updateInputs */])(path,value));},addSolicitudServicioItem:function addSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["h" /* addSolicitudServicioItem */])());},addCencoSolicitudServicioItem:function addCencoSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["a" /* addCencoSolicitudServicioItem */])());},removeCencosSolicitudServicioItem:function removeCencosSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["w" /* removeCencosSolicitudServicioItem */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddServicio));

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Proveedores=function(_Component){_inherits(Proveedores,_Component);function Proveedores(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Proveedores);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Proveedores.__proto__||Object.getPrototypeOf(Proveedores)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(list){var columns=[{id:1,caption:'Nit',value:'identificacion',width:'30%'},{id:2,caption:'Razon Social',value:'nombre',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addProveedorCotizacion(payload);});};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Proveedores,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicio=_props.solicitudservicio,estado=_props.estado;var yesterday=__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract('days',1);//const yesterday = moment().add('days', 2)
var fueraLimiteCotizaciones=__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicio.getIn(['servicios',0,'fecha_cotizaciones'])).isAfter(yesterday);if(!id)return null;var servicio_id=solicitudservicio.getIn(['servicios',0,'id'])?solicitudservicio.getIn(['servicios',0,'id']):0;var readOnly=!Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',this.props.solicitudservicio);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Informacion b\xE1sica para las cotizaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha l\xEDmite cotizaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:solicitudservicio.getIn(['servicios',0,'fecha_cotizaciones'])!=='-0001-11-30 00:00:00'?__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudservicio.getIn(['servicios',0,'fecha_cotizaciones'])).format('YYYY-MM-DD'):'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.0.fecha_cotizaciones',e.target.value,solicitudservicio.getIn(['servicios',0,'id']));}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),solicitudservicio.get('servicios').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{key:x.get('id'),title:'Servicio No '+(n+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'Descripcion',className:'form-control input-sm',value:x.get('descripcion'),rows:3,disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:x.get('cantidad'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{lineHeight:'19px'}},'Proveedores con solicitud de cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'pa['+n+'][0]',size:14,name:'plus-circle',onClick:function onClick(){return _this2.props.addCotizacion('solicitud.servicios.'+n+'.cotizaciones',n);},title:'Adicionar',disabled:!fueraLimiteCotizaciones||x.get('estado')==0||x.get('estado')>=2||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'pa['+n+'][1]',size:14,name:'trash',onClick:function onClick(){return _this2.props.removeProveedorCotizacion('solicitud.servicios.'+n+'.cotizaciones');},title:'Eliminar',disabled:solicitudservicio.getIn(('solicitud.servicios.'+n+'.cotizaciones').split('.').splice(1)).filter(function(x){return x.get('selected');}).count()===0||x.get('estado')==0||x.get('estado')>=2||!fueraLimiteCotizaciones||readOnly})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Descargar cotizaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,//.filter(c => c.get('proveedor_id')!== null)                                                                               
x.get('cotizaciones').map(function(a,b){var fileid=a.get('adjunto_id')?a.getIn(['adjunto','id']):null;var filename=a.get('adjunto_id')?a.getIn(['adjunto','nombre']):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr3['+a.get('guid')+']',className:a.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},value:a.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.cotizaciones.'+b+'.selected',e.target.checked);},disabled:x.get('estado')==0||x.get('estado')>=2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,solicitudservicio.getIn(['servicios',n,'cotizaciones',b,'estado'])==1&&!a.getIn(['adjunto','id'])&&fueraLimiteCotizaciones?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_SelectorInput__["a" /* default */],{value:a.getIn(['proveedore','nombre'])?a.getIn(['proveedore','nombre']):'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('solicitud.servicios.'+n+'.cotizaciones.'+b+'.proveedore');},onReset:function onReset(){return null;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:a.getIn(['proveedore','nombre'])?a.getIn(['proveedore','nombre']):'',disabled:true})),a.get('adjunto_id')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:a.get('adjunto')?function(){return _this2.props.downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+a.getIn(['adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'not-allowed'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},fileid?''+a.getIn(['adjunto','nombre']):'Archivo sin adjuntar')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{marginLeft:'4px'},type:'checkbox',disabled:readOnly||x.get('cantidad')==0,checked:x.get('compra_directa'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.compra_directa',e.target.checked,x.get('id'));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{paddingLeft:'5px'}},' Compra Directa '))))))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Proveedores;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudservicio.get('id'),estado:state.solicitudservicio.get('estado'),solicitudservicio:state.solicitudservicio.get('solicitud')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudservicio__["C" /* updateInputs */])(path,value,id));},addCotizacion:function addCotizacion(path,indexServicio){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudservicio__["b" /* addCotizacion */])(path,indexServicio));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["q" /* selectFromSelector */])(type,payload));},addProveedorCotizacion:function addProveedorCotizacion(payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudservicio__["g" /* addProveedorCotizacion */])(payload));},removeProveedorCotizacion:function removeProveedorCotizacion(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudservicio__["y" /* removeProveedorCotizacion */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["h" /* downloadFile */])(id,filename));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Proveedores));

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_util__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cotizaciones=function(_Component){_inherits(Cotizaciones,_Component);function Cotizaciones(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Cotizaciones);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Cotizaciones.__proto__||Object.getPrototypeOf(Cotizaciones)).call.apply(_ref,[this].concat(args))),_this),_this.getTotal=function(valor,iva,cantidad){var total=valor*cantidad;return iva?total+iva*total/100:total;},_this.handleOpenSelectorMoneda=function(moneda,n){var cotizaciones=_this.props.solicitudservicio.getIn(['servicios',n,'cotizaciones']);cotizaciones.map(function(c,i){_this.props.updateInputs('solicitud.servicios.'+n+'.cotizaciones.'+i+'.moneda',moneda);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Cotizaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('FORMAS_PAGO');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,solicitudservicio=_props.solicitudservicio,formaspago=_props.formaspago,divisas=_props.divisas;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Comparativo de cotizaciones'},solicitudservicio.get('servicios').map(function(x,n){var cotizacionesDisponibles=x.get('cotizaciones').filter(function(c){return c.get('estado')>=3&&c.get('proveedor_id')!==null;});var cotizacionesCompraDirecta=x.get('cotizaciones').filter(function(c){return c.get('estado')>=3&&c.get('proveedor_id')==null;});var readOnly=x.get('estado')==0||x.get('estado')>=2||!Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',_this2.props.solicitudservicio);var moneda=x.get('cotizaciones')&&x.get('cotizaciones').count()>0?x.get('cotizaciones').first().get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["t" /* getDivisa */])(divisas,moneda);return[n>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep1['+n+']',className:'separator'}):null,n>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep2'+n+']',className:'separator'}):null,n>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep3'+n+']',className:'separator'}):null,n>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep4['+n+']',className:'separator'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{key:'bs['+n+']',title:'Servicio No '+(n+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-solicitudes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{maxWidth:'86%',padding:'0 10px'}},'Tipo de moneda:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{alignItems:'flex-end'},className:'btn-group',role:'group','aria-label':'Basic outlined example'},divisas&&divisas.map(function(d,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:'d['+i+']',style:{borderRadius:'5px'},onClick:function onClick(){return _this2.handleOpenSelectorMoneda(d.get('CODIGO'),n);},type:'button',className:divisa.moneda==d.get('CODIGO')?'btn btn-primary':'btn btn-outline-primary'},d.get('CODIGO'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped',id:'comparativo-cotizaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},x.get('descripcion')||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('cantidad')||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'pa['+n+'][0]',size:14,name:'plus-circle',title:'Adicionar',disabled:x.get('cotizaciones_aprobar').count()==x.get('cotizaciones').count()||x.get('cotizaciones_aprobar').count()>=3||!cotizacionesDisponibles.count()&&x.get('compra_directa')==0||x.get('estado')==0||x.get('estado')>=2||x.get('cotizaciones_aprobar').count()==cotizacionesDisponibles.count()&&x.get('compra_directa')==0||readOnly// disabled={(x.get('cotizaciones_aprobar').count() >= 3 || (!cotizacionesDisponibles.count() && x.get('compra_directa') == 0)) || x.get('estado') == 0 || x.get('estado') >= 2 || (x.get('cotizaciones_aprobar').count() == cotizacionesDisponibles.count()) || readOnly }
,onClick:function onClick(){return _this2.props.addCotizacionAprobar('solicitud.servicios.'+n+'.cotizaciones_aprobar');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'},title:"Recomendación"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fa fa-star',style:{"color":"goldenrod","fontSize":"20px"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Valor Unit. antes de IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'% IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Valor total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Distribuc\xF3n de cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'7%'}},'Cotizaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,x.get('cotizaciones_aprobar').map(function(a,b){var fileid=a.get('adjunto_id')?a.getIn(['adjunto','id']):null;var filename=a.get('adjunto_id')?a.getIn(['adjunto','nombre']):null;if(a.get('estado')<3)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'rc['+n+']['+b+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:a.get('recomendado')||false,disabled:readOnly,onChange:function onChange(e){return _this2.props.recomendarCotizacion(n,b);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:a.get('id')||'',disabled:readOnly,onChange:function onChange(e){return _this2.props.seleccionarCotizacionAprobar(e.target.value,n,b);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Seleccione proveedor'),cotizacionesDisponibles.map(function(cotizacion){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:cotizacion.get('guid'),value:cotizacion.get('id')},cotizacion.getIn(['proveedore','nombre'])?cotizacion.getIn(['proveedore','nombre']):'');}),cotizacionesCompraDirecta.map(function(cotizacion){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:cotizacion.get('guid'),value:cotizacion.get('id')},'COMPRA DIRECTA');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:a.get('cotizado')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.cotizaciones_aprobar.'+b+'.cotizado',e.target.value,b+1);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:a.get('iva'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.cotizaciones_aprobar.'+b+'.iva',e.target.value,b+1);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right',verticalAlign:'middle'}},''+Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["q" /* formatcoin */])(_this2.getTotal(a.get('cotizado'),a.get('iva'),x.get('cantidad')),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped',id:'dist-cenco',style:{fontSize:'12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,x.get('cencos').map(function(c,i){var total=_this2.getTotal(a.get('cotizado'),a.get('iva'),x.get('cantidad'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'cenco['+n+']['+b+']['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,c.get('codigo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},c.getIn(['pivot','porcentaje'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["q" /* formatcoin */])(c.getIn(['pivot','porcentaje'])/100*total,divisa.simbolo)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',disabled:readOnly,value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(a.get('fecha_entrega')).format('YYYY-MM-DD'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.cotizaciones_aprobar.'+b+'.fecha_entrega',e.target.value,b+1);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:a.get('forma_pago')||'0',disabled:readOnly||a.get('proveedore')==null,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.servicios.'+n+'.cotizaciones_aprobar.'+b+'.forma_pago',e.target.value,b+1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0',disabled:true},'Seleccione'),formaspago&&formaspago.map(function(opt,iopt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt['+n+']['+b+']['+iopt+']',value:opt.get('NOMBRE')},' ',opt.get('NOMBRE'),' ');}))),a.get('adjunto_id')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer',textAlign:'center',verticalAlign:'middle'},onClick:a.get('adjunto')?function(){return _this2.props.downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'not-allowed',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sin archivo')));}))))))];}));}}]);return Cotizaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitudservicio:state.solicitudservicio.get('solicitud'),formaspago:state.common.getIn(['parametros','FORMAS_PAGO']),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__["C" /* updateInputs */])(path,value,id));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["h" /* downloadFile */])(id,filename));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["l" /* getParameterByName */])(nombre));},recomendarCotizacion:function recomendarCotizacion(indexServicio,indexCotizacionAprobar){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__["t" /* recomendarCotizacion */])(indexServicio,indexCotizacionAprobar));},addCotizacionAprobar:function addCotizacionAprobar(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__["c" /* addCotizacionAprobar */])(path));},seleccionarCotizacionAprobar:function seleccionarCotizacionAprobar(cotizacion_id,indexServicio,indexCotizacionAprobar){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__["B" /* seleccionarCotizacionAprobar */])(cotizacion_id,indexServicio,indexCotizacionAprobar));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cotizaciones));

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(610);


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(611);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 611 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreateDocumento=function(_Component){_inherits(ModalCreateDocumento,_Component);function ModalCreateDocumento(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreateDocumento);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreateDocumento.__proto__||Object.getPrototypeOf(ModalCreateDocumento)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreateDocumento');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateDocumento .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreateDocumento(false,'','');},300);},_this.getTotalSinIva=function(){return _this.props.modalCreateDocumento.getIn(['data','detalles']).reduce(function(acum,detalle){acum+=detalle.get('valor')*detalle.get('cantidad');return acum;},0);},_this.getTotalConIva=function(){return _this.props.modalCreateDocumento.getIn(['data','detalles']).reduce(function(acum,detalle){acum+=detalle.get('valor_con_iva')*detalle.get('cantidad');return acum;},0);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreateDocumento,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('ALMACEN');this.props.getParameterByName('TIPO_FORMAS_PAGO');this.props.getParameterByName('TOLERANCIA');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreateDocumento=_props.modalCreateDocumento,enums=_props.enums,documento_origen=_props.documento_origen,almacenes=_props.almacenes,tipo_formas_pago=_props.tipo_formas_pago,divisas=_props.divisas;if(!modalCreateDocumento.get('show')){return null;}var moneda=modalCreateDocumento.getIn(['data','cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var tipoDocumento=modalCreateDocumento.getIn(['data','tipo'])?modalCreateDocumento.getIn(['data','tipo']):0;var contratoanual=modalCreateDocumento.get('contratoanual');var allowedTypes=[];var readOnly=documento_origen!=null;if(contratoanual){allowedTypes.push(1);}else{allowedTypes.push(1,2);if(tipoDocumento==4)allowedTypes.push(4);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Modal__["a" /* default */],{id:'modalCreateDocumento',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateDocumento();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__["a" /* default */],{title:modalCreateDocumento.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'eye',onClick:function onClick(e){e.preventDefault();_this2.props.previewDocumento(modalCreateDocumento.getIn(['data','id']));},disabled:modalCreateDocumento.get('btnDisabled'),title:'Visualizar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreateDocumento.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-document',style:{width:tipoDocumento===4?'70vw':'80vw',height:tipoDocumento===4?'55vh':'80vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{width:'35%',color:'#333',fontWeight:'bold'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].NOMBRE:'PENDIENTE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'No. documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,(modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].PREFIJO:'PENDIENTE')+(modalCreateDocumento.getIn(['data','consecutivo'])||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','proveedore','nombre']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Valor sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(this.getTotalSinIva(),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Valor total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(this.getTotalConIva(),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:modalCreateDocumento.getIn(['data','detalles']).count()},'Servicios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','detalles']).first().get('descripcion'))),modalCreateDocumento.getIn(['data','detalles']).map(function(a,b){if(b===0)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr0['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('descripcion')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},tipoDocumento==1||tipoDocumento==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha registro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')||'',disabled:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha inicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalCreateDocumento.getIn(['data','fecha_inicio'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_inicio',e.target.value);},disabled:tipoDocumento==4})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalCreateDocumento.getIn(['data','fecha_entrega'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_entrega',e.target.value);},disabled:tipoDocumento==4}))),modalCreateDocumento.getIn(['data','tipo'])!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{marginTop:'-10px'},type:'checkbox',value:modalCreateDocumento.get('contratoanual'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.contratoanual',e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'5px'}},'Contrato anual')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','documento_id'])||0,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.documento_id',Number(e.target.value));},disabled:modalCreateDocumento.get('contratoanual')==false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione un n\xFAmero de contrato'),modalCreateDocumento.get('contratosAnuales').map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt3['+a.get('id')+']',value:a.get('id')},a.get('consecutivo'));}))))),tipoDocumento!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione el tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:tipoDocumento,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.tipo',e.target.value);},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opcion'),Object.keys(enums.documentos.tipos).map(function(a){if(allowedTypes.indexOf(Number(a))!=-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a+']',value:a},enums.documentos.tipos[a].NOMBRE);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione la plantilla del documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','plantilla_id'])||-1,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.plantilla_id',e.target.value);},disabled:Number(modalCreateDocumento.getIn(['data','tipo']))===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:-1,disabled:true},'Seleccione una opci\xF3n'),modalCreateDocumento.get('plantillas').filter(function(a){return a.get('tipo')===Number(modalCreateDocumento.getIn(['data','tipo']));}).map(function(a){if(a.get('nombre')!=="ORDEN DE SERVICIO - CONTRATO ANUAL"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a.get('id')+']',value:a.get('id')},a.get('nombre'));}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'% Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','anticipo']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(this.getTotalSinIva()*modalCreateDocumento.getIn(['data','anticipo'])/100,divisa.simbolo),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalCreateDocumento.getIn(['data','pago_anticipo'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.pago_anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','anticipo'])==0||modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','forma_pago_anticipo'])||0,onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.forma_pago_anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','anticipo'])==0||modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una forma de pago'),tipo_formas_pago&&tipo_formas_pago.map(function(formaPago,iformaPago){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+iformaPago+']',value:formaPago.get('NOMBRE')},formaPago.get('NOMBRE'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'D\xEDas pagos del saldo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','dias_pagos_saldo'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.dias_pagos_saldo',e.target.value);}})))))),tipoDocumento!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione las garantias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},modalCreateDocumento.get('garantias').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'div1['+a.get('id')+']',className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','garantias']).filter(function(x){return x.get('id')===a.get('id');}).count()===1,onChange:function onChange(e){return _this2.props.addGarantia(e.target.checked,b,a.get('id'));},disabled:readOnly}),a.get('nombre'))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'IVA (%)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','iva']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.iva',e.target.value);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','iva_value']),divisa.simbolo),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'65%',textAlign:'right'},colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','aiu_total']),divisa.simbolo)))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opciones adicionales'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','entregas_parciales']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.entregas_parciales',e.target.checked);},disabled:readOnly}),'Entregas parciales'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','validacion_soma']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.validacion_soma',e.target.checked);},disabled:readOnly}),'Validaci\xF3n por SOMA'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opciones del documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','almacen'])||0,onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.almacen',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione un almacen'),almacenes&&almacenes.map(function(almacen,ialmacen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+ialmacen+']',value:almacen.get('ALMACEN')},almacen.get('ALMACEN'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','numero_cotizacion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.numero_cotizacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalCreateDocumento.getIn(['data','fecha_cotizacion'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_cotizacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Clausula %'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','clausula'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.clausula',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Alcance y entregables de la Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalCreateDocumento.getIn(['data','alcance_entregables'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.alcance_entregables',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Garant\xEDas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalCreateDocumento.getIn(['data','garantia_documento'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.garantia_documento',e.target.value);}}))),modalCreateDocumento.getIn(['data','aprobacion','observaciones'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones del proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,defaultValue:modalCreateDocumento.getIn(['data','aprobacion','observaciones'])||'',disabled:true}))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreateDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalCreateDocumento:state.solicitudservicio.get('modalCreateDocumento'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudservicio.getIn(['solicitud','documento_origen']),almacenes:state.common.getIn(['parametros','ALMACEN']),tipo_formas_pago:state.common.getIn(['parametros','TIPO_FORMAS_PAGO']),divisas:state.common.getIn(['parametros','DIVISAS'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["n" /* displayModalCreateDocumento */])(show,title,mode));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["C" /* updateInputs */])(path,value,immutable));},addGarantia:function addGarantia(checked,index,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["f" /* addGarantia */])(checked,index,id));},createOrUpdateDocumento:function createOrUpdateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["k" /* createOrUpdateDocumento */])());},previewDocumento:function previewDocumento(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["s" /* previewDocumento */])(id));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["l" /* getParameterByName */])(nombre));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreateDocumento));

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Documentos_General__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Documentos_Aprobacion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Documentos_DocumentosAsociados__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Documentos_Entregas__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Documentos_Adiciones__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Documentos_Facturas__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Documentos_Cancelacion__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSummary=function(_Component){_inherits(ModalSummary,_Component);function ModalSummary(props){_classCallCheck(this,ModalSummary);var _this=_possibleConstructorReturn(this,(ModalSummary.__proto__||Object.getPrototypeOf(ModalSummary)).call(this,props));_this.handleCloseModal=function(){var modal=document.getElementById('modalSummary');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSummary .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');_this.setState({maximised:false,selected:0});setTimeout(function(){return _this.props.showHideModalSummary(false);},300);};_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar este documento?',function(){_this.props.showModalConfirmarAccion(false);_this.props.cancelDocumento();});};var tabs=[{id:0,caption:'Documento',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Documentos_General__["a" /* default */],{disabledAttach:true,reducer:'solicitudservicio'}),estado:0},{id:1,caption:'Aprobación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Documentos_Aprobacion__["a" /* default */],null),estado:0},{id:2,caption:'Documentos asociados',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Documentos_DocumentosAsociados__["a" /* default */],null),estado:1},{id:3,caption:'Ajustes',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Documentos_Adiciones__["a" /* default */],null),estado:0},{id:4,caption:'Entregas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Documentos_Entregas__["a" /* default */],null),estado:0},{id:5,caption:'Facturas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Documentos_Facturas__["a" /* default */],null),estado:6},{id:6,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Documentos_Cancelacion__["a" /* default */],null),estado:0}];if(props.modalSummary.getIn(['data','estado'])===6&&!props.modalSummary.get('documentos'))delete tabs[2];if(props.modalSummary.getIn(['data','estado'])===6&&!props.modalSummary.get('adiciones'))delete tabs[3];if(props.tipo_solicitud===5){delete tabs[2];delete tabs[3];delete tabs[4];delete tabs[5];delete tabs[6];}_this.state={tabs:[].concat(tabs),selected:0,maximised:false};return _this;}_createClass(ModalSummary,[{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected,maximised=_state.maximised;var _props=this.props,modalSummary=_props.modalSummary,user=_props.user,enums=_props.enums,documento_origen=_props.documento_origen;if(!modalSummary.get('show')){return null;}var documento=modalSummary.get('data');var readOnly=documento_origen!=null;var editar=modalSummary.get('editar');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalSummary',show:true,ZIndex:2000,draggable:!maximised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:maximised?'bold':'normal'}},'Documento: '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].NOMBRE+' '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].PREFIJO+modalSummary.getIn(['data','consecutivo'])),onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSummary");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:maximised?'compress':'arrows-alt',title:maximised?'Minimizar':"Maximizar",onClick:function onClick(e){return _this2.setState({maximised:!maximised});}}),this.state.selected===0&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',documento.get('solicitude'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Actualizar documento',onClick:function onClick(){return _this2.props.updateDocumento();},disabled:!editar}),this.state.selected===3&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["E" /* isAllowedToViewComponent */])('responsables_recibo',documento,user.get('id'))&&documento.get('estado')!==11&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus-circle',title:'Crear adici\xF3n',onClick:function onClick(e){return _this2.props.showHideModalAddAdicional(true,documento.get('id'),modalSummary.get('url'),modalSummary.get('type'));},disabled:readOnly}),this.state.selected===6&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'ban',title:'Cancelar orden/contrato',onClick:function onClick(e){return _this2.cancel();},disabled:documento.get('estado')==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.maximised?'modal-100-100':'modal-80-70'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs green'},tabs.filter(function(x){return x.estado<=documento.get('estado');}).map(function(x){// const entregado = documento.get('entregas').count() > 0 ? documento.get('entregas').filter(e => e.get('recibido') == 1).count() > 0 : false                                                    
// if (entregado && x.id == 6) return null
if(documento.get('estado')==11&&x.id==6)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSummary:state.documentos.get('modalSummary'),user:state.common.get('user'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudservicio.getIn(['solicitud','documento_origen']),tipo_solicitud:state.solicitudservicio.getIn(['solicitud','tipo'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalSummary:function showHideModalSummary(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["k" /* showHideModalSummary */])(state));},showHideModalAddFactura:function showHideModalAddFactura(show,documento,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["r" /* showHideModalAddFactura */])(show,documento,url,type));},showHideModalAddAdicional:function showHideModalAddAdicional(show,documento,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["i" /* showHideModalAddAdicional */])(show,documento,url,type));},cancelDocumento:function cancelDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["c" /* cancelDocumento */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},updateDocumento:function updateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["m" /* updateDocumento */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSummary));

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RowDocumentosAsociados; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
var RowDocumentosAsociados=function RowDocumentosAsociados(_ref){var origen=_ref.origen,documento=_ref.documento,indice=_ref.indice,enums=_ref.enums,downloadFile=_ref.downloadFile,divisa=_ref.divisa;var valor=0;var fecha_inicio=null;var fecha_entrega=null;var adjunto=null;if(documento.get('tipo')==6){var totalSevicios=origen.get('detalles').reduce(function(a,b){if(!b.get('adicion_id'))a+=b.get('valor')*b.get('cantidad');return a;},0);//valor = Math.round((totalSevicios * (origen.get('anticipo'))) / 100)
valor=totalSevicios*origen.get('anticipo')/100;fecha_entrega=__WEBPACK_IMPORTED_MODULE_1_moment___default()(origen.get('pago_anticipo')).format('YYYY-MM-DD');}else{valor=documento.get('detalles').reduce(function(a1,b1){a1+=b1.get('valor_con_iva');return a1;},0);fecha_inicio=documento.get('fecha_inicio')?__WEBPACK_IMPORTED_MODULE_1_moment___default()(documento.get('fecha_inicio')).format('YYYY-MM-DD'):null;fecha_entrega=documento.get('fecha_entrega')?__WEBPACK_IMPORTED_MODULE_1_moment___default()(documento.get('fecha_entrega')).format('YYYY-MM-DD'):null;}if(documento.get('adjuntos').count()>0){adjunto=documento.getIn(['adjuntos',-1]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,documento.get('consecutivo')?enums.documentos.tipos[documento.get('tipo')].PREFIJO+documento.get('consecutivo'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,documento.getIn(['proveedore','nombre'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["q" /* formatcoin */])(valor,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.tipos[documento.get('tipo')]?enums.documentos.tipos[documento.get('tipo')].NOMBRE:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.estados[documento.get('estado')]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},fecha_inicio),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},fecha_entrega),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,documento.get('detalles').map(function(c,d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr5['+documento.get('id')+']['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:c.get('adicion_id')!==null?'adicional':''},c.get('descripcion')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},adjunto&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{key:'font1['+adjunto.get('id')+']',name:'download',onClick:function onClick(e){return downloadFile(adjunto.get('id'),adjunto.get('nombre'));}}))),documento.get('tipo')===4&&documento.get('documentos').count()>0?documento.get('documentos').map(function(sub,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowDocumentosAsociados,{origen:documento,documento:sub,indice:indice+idx,key:'tr4['+sub.get('id')+']',downloadFile:downloadFile,enums:enums});}):null);};

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var filesTypes=__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* acceptedFiles */].map(function(x){return x.type;}).join();var ModalAddVerificacionSOMA=function(_Component){_inherits(ModalAddVerificacionSOMA,_Component);function ModalAddVerificacionSOMA(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddVerificacionSOMA);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddVerificacionSOMA.__proto__||Object.getPrototypeOf(ModalAddVerificacionSOMA)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('modalAddVerificacionSOMA');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddVerificacionSOMA .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalAddVerificacionSOMA(false);},300);},_this.handleOnDrop=function(files){if(files.length>1){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('Solo es permitido procesar un archivo a la vez',{bodyClassName:'toastify-content toastify-warning'});return;}_this.props.uploadVerificacionSSTFile(files[0]);},_this.handleOnRejected=function(files){files.forEach(function(x){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('El archivo '+x.name+' no es del tipo esperado. '+x.type,{bodyClassName:'toastify-content toastify-warning'});});},_this.setIcon=function(icon){if(icon){var imageSrc=__webpack_require__(80)("./"+icon);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageSrc});}return null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddVerificacionSOMA,[{key:'render',value:function render(){var _this2=this;var modalAddVerificacionSOMA=this.props.modalAddVerificacionSOMA;if(!modalAddVerificacionSOMA.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Modal__["a" /* default */],{id:'modalAddVerificacionSOMA',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__["a" /* default */],{title:'Verificaci\xF3n Salud Ocupacional y Medio Ambiente SOMA',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalAddVerificacionSOMA");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Guardar',onClick:function onClick(e){return _this2.props.storeVerificacionSST();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_dropzone__["a" /* default */],{accept:filesTypes,onDropAccepted:this.handleOnDrop,onDropRejected:this.handleOnRejected,className:'dropzone1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Arrastre los soportes a esta secci\xF3n')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre del archivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'div-input-sm'},modalAddVerificacionSOMA.getIn(['data','file'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'1px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.setIcon(modalAddVerificacionSOMA.getIn(['data','icono']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'4px',verticalAlign:'bottom'}},modalAddVerificacionSOMA.getIn(['data','file']).name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px',verticalAlign:'bottom',color:'#ccc'}},'(',__WEBPACK_IMPORTED_MODULE_3_numeral___default()(modalAddVerificacionSOMA.getIn(['data','file']).size).format('0.0 b'),')')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control input-sm',rows:4,value:modalAddVerificacionSOMA.getIn(['data','observaciones'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddVerificacionSOMA.data.observaciones',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Evaluaci\xF3n del servicio recibido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'70%'}},'Criterio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Calificaci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Calificaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalAddVerificacionSOMA.getIn(['data','aceptado'])||-1,onChange:function onChange(e){return _this2.props.updateInputs('modalAddVerificacionSOMA.data.aceptado',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:-1,disabled:true},'Seleccione una opci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'Aceptado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'No aceptado')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddVerificacionSOMA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddVerificacionSOMA:state.common.get('modalAddVerificacionSOMA')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalAddVerificacionSOMA:function showHideModalAddVerificacionSOMA(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["s" /* showHideModalAddVerificacionSOMA */])(show));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["C" /* updateInputs */])(path,value,immutable));},uploadVerificacionSSTFile:function uploadVerificacionSSTFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["G" /* uploadVerificacionSSTFile */])(file));},storeVerificacionSST:function storeVerificacionSST(last){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["B" /* storeVerificacionSST */])(last));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddVerificacionSOMA));

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*
 * window-size
 * https://github.com/jonschlinkert/window-size
 *
 * Copyright (c) 2014 Jon Schlinkert
 * Licensed under the MIT license.
 */

const tty = __webpack_require__(617)

module.exports = (function() {
  var width;
  var height;

  if(tty.isatty(1) && tty.isatty(2)) {
    if(process.stdout.getWindowSize) {
      width = process.stdout.getWindowSize(1)[0];
      height = process.stdout.getWindowSize(1)[1];
    } else if (tty.getWindowSize) {
      width = tty.getWindowSize()[1];
      height = tty.getWindowSize()[0];
    } else if (process.stdout.columns && process.stdout.rows) {
      height = process.stdout.columns;
      width = process.stdout.rows;
    }
  } else {
    new Error('Error: could not get window size with tty or process.stdout');
  }
  return {
    height: height,
    width: width
  }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147)))

/***/ }),
/* 617 */
/***/ (function(module, exports) {

exports.isatty = function () { return false; };

function ReadStream() {
  throw new Error('tty.ReadStream is not implemented');
}
exports.ReadStream = ReadStream;

function WriteStream() {
  throw new Error('tty.ReadStream is not implemented');
}
exports.WriteStream = WriteStream;


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttachedAdicionalsBox=function(_Component){_inherits(AttachedAdicionalsBox,_Component);function AttachedAdicionalsBox(){_classCallCheck(this,AttachedAdicionalsBox);return _possibleConstructorReturn(this,(AttachedAdicionalsBox.__proto__||Object.getPrototypeOf(AttachedAdicionalsBox)).apply(this,arguments));}_createClass(AttachedAdicionalsBox,[{key:'render',value:function render(){var _props=this.props,adiciones=_props.adiciones,divisa=_props.divisa;if(adiciones.count()===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center',color:'#bbb'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'exclamation-circle'}),' No han sido agregadas adiciones a este documento'));}return adiciones.map(function(a,b){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'bs19['+b+']'},b>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Ajuste #'+(b+1)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{colSpan:4},'Descripci\xF3n'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{colSpan:4},a.getIn(['detalles','0','descripcion'])))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Valor sin IVA'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Valor Total'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{colSpan:2},'Fecha Entrega'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["q" /* formatcoin */])(a.getIn(['detalles','0','cantidad'])*a.getIn(['detalles','0','valor']),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["q" /* formatcoin */])(a.getIn(['detalles','0','cantidad'])*a.getIn(['detalles','0','valor_con_iva']),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'},colSpan:2},__WEBPACK_IMPORTED_MODULE_4_moment___default()(a.get('fecha')).format('YYYY-MM-DD')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{colSpan:4},'Distribuci\xF3n en cencos')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'C\xF3digo'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Valor'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,a.getIn(['detalles','0','cencos']).map(function(c,d){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:'tr20['+c.get('id')+']'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,c.get('codigo')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,c.get('descripcion')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(Number(c.getIn(['pivot','porcentaje']))/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["q" /* formatcoin */])(Number(c.getIn(['pivot','porcentaje']))/100*(a.getIn(['detalles','0','cantidad'])*a.getIn(['detalles','0','valor_con_iva'])),divisa.simbolo)));})))));});}}]);return AttachedAdicionalsBox;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AttachedAdicionalsBox));

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttachedInvoicesBox=function(_Component){_inherits(AttachedInvoicesBox,_Component);function AttachedInvoicesBox(){_classCallCheck(this,AttachedInvoicesBox);return _possibleConstructorReturn(this,(AttachedInvoicesBox.__proto__||Object.getPrototypeOf(AttachedInvoicesBox)).apply(this,arguments));}_createClass(AttachedInvoicesBox,[{key:'render',value:function render(){var _this2=this;var _props=this.props,facturas=_props.facturas,documento=_props.documento,url=_props.url,type=_props.type,saldo=_props.saldo,user=_props.user,por_recibir=_props.por_recibir,divisa=_props.divisa;var totalFactura={valor_sin_iva:facturas.reduce(function(acc,current){return acc+current.get('valor_sin_iva');},0),valor_total:facturas.reduce(function(acc,current){return acc+current.get('valor_con_iva');},0),anticipo_descontado:facturas.reduce(function(acc,current){return acc+current.get('amortizacion');},0),valor_a_pagar:facturas.reduce(function(acc,current){return acc+current.get('valor_a_pagar');},0)};var buttons=[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxButton__["a" /* default */],{key:'ba[2][0]',size:14,contrast:true,name:'plus-circle',onClick:function onClick(e){return _this2.props.showHideModalAddFactura(true,documento,url,type,saldo);},title:'Adicionar factura',disabled:documento.get('estado')==11||por_recibir}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxButton__["a" /* default */],{key:'ba[2][1]',size:14,contrast:true,name:'trash',onClick:function onClick(e){return _this2.props.removeFactura();},title:'Eliminar factura',disabled:facturas&&facturas.filter(function(x){return x.get('selected');}).count()===0,danger:true})];// if (!isAllowedToViewComponent('responsables_ingreso', documento, user.get('id')) || documento.get('estado') === 11) buttons = []
if(!Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_almacen',documento,user.get('id')))buttons=[];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Facturas',actions:buttons},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{width:'20px'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%'}},'N\xFAmero'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%'}},'Fecha de la factura'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'15%'}},'Fecha de radicaci\xF3n'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'15%'}},'C\xF3digo de radicaci\xF3n'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%'}},'Valor sin IVA'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%'}},'Valor total'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%'}},'Ant. Descontado'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'5%'}},'Ant %'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'10%'}},'Valor pagado'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:{width:'5%'}},'Archivo'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,facturas&&facturas.count()>0?facturas.map(function(x,n){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:'tr[24]['+n+']['+x.get('guid')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.facturas.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,x.get('numero_factura')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_moment___default()(x.get('fecha_factura')).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_moment___default()(x.get('fecha_radicacion')).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,x.getIn(['radicado','codigo'])),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(x.get('valor_sin_iva'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(x.get('valor_con_iva'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(x.get('amortizacion'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(x.get('porcentaje_amortizacion')/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(x.get('valor_a_pagar'),divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'center'}},x.get('adjunto')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'download',onClick:function onClick(e){return _this2.props.downloadFile(x.getIn(['adjunto','id']),x.getIn(['adjunto','nombre']));}}))));}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{colSpan:11,style:{textAlign:'center'}},'Para adicionar facturas haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'plus-circle'})))),facturas&&facturas.count()>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{colSpan:5,style:{textAlign:'right',fontWeight:'bold'}},'Totales'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(totalFactura.valor_sin_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(totalFactura.valor_total,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(totalFactura.anticipo_descontado,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["q" /* formatcoin */])(totalFactura.valor_a_pagar,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null)))));}}]);return AttachedInvoicesBox;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{url:state.documentos.getIn(['modalSummary','url']),type:state.documentos.getIn(['modalSummary','type']),documento:state.documentos.getIn(['modalSummary','data']),facturas:state.documentos.getIn(['modalSummary','data','facturas']),user:state.common.get('user')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalAddFactura:function showHideModalAddFactura(show,documento,url,type,saldo){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_common__["r" /* showHideModalAddFactura */])(show,documento,url,type,saldo));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_common__["h" /* downloadFile */])(id,filename));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_documentos__["n" /* updateInputs */])(path,value));},removeFactura:function removeFactura(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_documentos__["g" /* removeFactura */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AttachedInvoicesBox));

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RowControlFacturacion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
var RowControlFacturacion=function RowControlFacturacion(_ref){var origen=_ref.origen,documento=_ref.documento,enums=_ref.enums,totalDetalles=_ref.totalDetalles,divisa=_ref.divisa;var detalleTotales=totalDetalles(documento);var detallesOrigen=totalDetalles(origen);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.tipos[documento.get('tipo')].PREFIJO+documento.get('consecutivo')),documento.get('tipo')==6?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_1_numeral___default()(origen.get('anticipo')/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},' ',Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["q" /* formatcoin */])(origen.get('anticipo')/100*detallesOrigen.sin_iva_sin_adiciones,divisa.simbolo))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["q" /* formatcoin */])(detalleTotales.sin_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["q" /* formatcoin */])(detalleTotales.con_iva,divisa.simbolo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},'0%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["q" /* formatcoin */])(0,divisa.simbolo)))),documento.get('tipo')===4&&documento.get('documentos').count()>0?documento.get('documentos').map(function(sub,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowControlFacturacion,{origen:documento,documento:sub,key:'tr12['+idx+']',enums:enums,totalDetalles:totalDetalles,divisa:divisa});}):null);};

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_otrosi__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreate=function(_Component){_inherits(ModalCreate,_Component);function ModalCreate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreate.__proto__||Object.getPrototypeOf(ModalCreate)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreateOtrosi');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateOtrosi .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalCreateOtrosi(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreate,[{key:'render',value:function render(){var _this2=this;var modalCreateOtrosi=this.props.modalCreateOtrosi;if(!modalCreateOtrosi.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalCreateOtrosi',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Confirmaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'400px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{color:'#000',fontWeight:'300'}},modalCreateOtrosi.get('message'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalFooter__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.props.createOtrosi();}},'OTROSI'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default',type:'button',onClick:function onClick(e){return _this2.handleCloseModal();}},'Cancelar')));}}]);return ModalCreate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalCreateOtrosi:state.common.get('modalCreateOtrosi')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalCreateOtrosi:function showHideModalCreateOtrosi(open){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_common__["t" /* showHideModalCreateOtrosi */])(open));},createOtrosi:function createOtrosi(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_otrosi__["a" /* createOtrosi */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreate));

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalCreateCompraDirecta__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompraDirectaServicio=function(_React$Component){_inherits(CompraDirectaServicio,_React$Component);function CompraDirectaServicio(){_classCallCheck(this,CompraDirectaServicio);return _possibleConstructorReturn(this,(CompraDirectaServicio.__proto__||Object.getPrototypeOf(CompraDirectaServicio)).apply(this,arguments));}_createClass(CompraDirectaServicio,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudservicio=_props.solicitudservicio,divisas=_props.divisas,displayModalCompraDirecta=_props.displayModalCompraDirecta;//console.log("# entrada datos desde despues de aprobaciones",solicitudservicio.toJS())
var medios_pago={tarjeta_debito:'Tarjeta Débito',tarjeta_credito:'Tarjeta Crédito',caja_menor:'Caja Menor'};if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Producto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre razon social'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'NIT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No. Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Adjuntar factura'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudservicio.get('cotizaciones').filter(function(c){return c.get('proveedore')==null&&c.getIn(['aprobaciones','0','estado'])==2;}).map(function(cot){var moneda=cot.get('moneda');var divisa=Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["t" /* getDivisa */])(divisas,moneda);return cot.get('servicios').filter(function(servicios){return servicios.get('compra_directa');}).map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',disabled:!!a.getIn(['factura_compra_directa_servicios','id'])||!Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',_this2.props.solicitudservicio),onClick:function onClick(){return displayModalCompraDirecta(true,'Registrar Compra Directa',a.get('id'),cot);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.getIn(['cantidad'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['factura_compra_directa_servicios','razon_social'])||cot.get('proveedor_nombre_cp')||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['factura_compra_directa_servicios','nit'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.getIn(['factura_compra_directa_servicios','no_factura'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.getIn(['factura_compra_directa_servicios','fecha_compra'])).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,medios_pago[a.getIn(['factura_compra_directa_servicios','medio_pago'])]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(a.getIn(['factura_compra_directa_servicios','valor_compra']),divisa.simbolo)),a.getIn(['factura_compra_directa_servicios','adjunto_id'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:function onClick(){return _this2.props.downloadFile(a.getIn(['factura_compra_directa_servicios','adjunto','id']),a.getIn(['factura_compra_directa_servicios','adjunto','nombre']));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+a.getIn(['factura_compra_directa_servicios','adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,a.getIn(['factura_compra_directa_servicios','adjunto'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+a.getIn(['factura_compra_directa_servicios','adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'not-allowed'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},'Archivo sin adjuntar'))));});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalCreateCompraDirecta__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return CompraDirectaServicio;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{id:state.solicitudservicio.get('id'),solicitudservicio:state.solicitudservicio.get('solicitud'),enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{displayModalCompraDirecta:function displayModalCompraDirecta(show,title,servicio_id,cotizacion){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudservicio__["m" /* displayModalCompraDirecta */])(show,title,servicio_id,cotizacion));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["h" /* downloadFile */])(id,filename));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CompraDirectaServicio));

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreateCompraDirecta=function(_Component){_inherits(ModalCreateCompraDirecta,_Component);function ModalCreateCompraDirecta(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreateCompraDirecta);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreateCompraDirecta.__proto__||Object.getPrototypeOf(ModalCreateCompraDirecta)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(path){var columns=[{id:2,caption:'Nombre',value:'nombre',width:'100%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1',payload);};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores_externos',fn);},_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreateCompraDirecta');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateCompraDirecta .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCompraDirecta(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreateCompraDirecta,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreateCompraDirecta=_props.modalCreateCompraDirecta,updateInputs=_props.updateInputs;if(!modalCreateCompraDirecta.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalCreateCompraDirecta',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateCompraDirecta();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:modalCreateCompraDirecta.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreateCompraDirecta.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'70vw',height:'60vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Producto comprado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',defaultValue:modalCreateCompraDirecta.get('servicio_descripcion'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',defaultValue:modalCreateCompraDirecta.get('servicio_cantidad'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccionar proveedor existente'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__["a" /* default */],{value:modalCreateCompraDirecta.getIn(['data','proveedor','nombre'])||'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('modalCreateCompraDirecta.data.proveedor');},onReset:function onReset(){return _this2.props.updateInputs('modalCreateCompraDirecta.data.proveedor',null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Proveedor nuevo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','razon_social']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.razon_social',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'No. Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','no_factura']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.no_factura',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Fecha Compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','fecha_compra']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.fecha_compra',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Forma de Pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:modalCreateCompraDirecta.getIn(['data','medio_pago']),className:'form-control input-sm',onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.medio_pago',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Seleccione forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'tarjeta_debito'},'Tarjeta d\xE9bito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'tarjeta_credito'},'Tarjeta cr\xE9dito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'caja_menor'},'Caja menor')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Valor compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','valor_compra']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.valor_compra',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Adjuntar factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',modalCreateCompraDirecta.getIn(['data','adjunto','file'])?modalCreateCompraDirecta.getIn(['data','adjunto','file']).name:' Seleccione un archivo...')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFileCompraDirecta('modalCreateCompraDirecta.data.adjunto');}}));}}]);return ModalCreateCompraDirecta;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalCreateCompraDirecta:state.solicitudservicio.get('modalCreateCompraDirecta'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudservicio.getIn(['solicitud','documento_origen'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["q" /* selectFromSelector */])(type,payload));},displayModalCompraDirecta:function displayModalCompraDirecta(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["m" /* displayModalCompraDirecta */])(show,title,mode));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFileCompraDirecta:function addFileCompraDirecta(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["e" /* addFileCompraDirecta */])(path));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["C" /* updateInputs */])(path,value,immutable));},createOrUpdateCompraDirecta:function createOrUpdateCompraDirecta(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudservicio__["j" /* createOrUpdateCompraDirecta */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreateCompraDirecta));

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SolicitudServicioOT_General__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SolicitudServicioOT_Aprobaciones__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SolicitudServicioOT_Documentos__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicioOT_Cancelacion__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudservicioot__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { showModalConfirmarAccion } from '../actions/common'
var SolicitudServicioOT=function(_Component){_inherits(SolicitudServicioOT,_Component);function SolicitudServicioOT(props){_classCallCheck(this,SolicitudServicioOT);var _this=_possibleConstructorReturn(this,(SolicitudServicioOT.__proto__||Object.getPrototypeOf(SolicitudServicioOT)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar la solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerCancelacion();});};_this.state={tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_SolicitudServicioOT_General__["a" /* default */],null),estado:1},{id:1,caption:'Aprobaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_SolicitudServicioOT_Aprobaciones__["a" /* default */],null),estado:1},{id:2,caption:'Documentos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SolicitudServicioOT_Documentos__["a" /* default */],null),estado:4},{id:3,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SolicitudServicioOT_Cancelacion__["a" /* default */],null),estado:0}],selected:0};return _this;}_createClass(SolicitudServicioOT,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){var params=new URLSearchParams(this.props.location.search);if(params.has("aprobacion")){this.setState({selected:1});}this.props.getSolicitud(this.props.match.params.id);this.props.getParameterByName('DIVISAS');}else{__WEBPACK_IMPORTED_MODULE_9__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes');}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,estado=_props.estado,btnRComprasDisabled=_props.btnRComprasDisabled,solicitud=_props.solicitud,btnSaveDisabled=_props.btnSaveDisabled;var readOnly=!Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);var documentos_proceso=solicitud.get('documentos')?solicitud.get('documentos').filter(function(d){return d.get('estado')==4||d.get('estado')>6;}).count():0;var documentos_cancelados=solicitud.get('documentos')?solicitud.get('documentos').filter(function(d){return d.get('estado')==0;}).count():0;var boxActions=void 0;boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.updateSolicitud();},title:'Actualizar solicitud',disabled:btnSaveDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'user',onClick:function onClick(){return _this2.props.canmbiarResponsable(solicitud,'ACTUALIZAR_SOLICITUD_SERVICIO_OT');},title:'Cambiar responsable',disabled:btnRComprasDisabled||selected!==0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'ban',onClick:function onClick(){return _this2.cancel();},title:'Aprobar cancelaci\xF3n solicitud',disabled:readOnly||selected!==3||estado==0})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){if(solicitud.get('documentos')&&x.id===2&&solicitud.get('documentos').count()===0)return null;if(estado==1){return x.id==0||x.id==1||x.id==3;}else if(documentos_proceso>0&&x.id===3){return null;}else if(estado>=2){return x.estado<=estado;}else if(estado==0){if(documentos_cancelados>0)return x.id<3;else return x.id==0||x.id==3;}}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li01['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component))))));}}]);return SolicitudServicioOT;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{btnSaveDisabled:state.solicitudservicioot.get('btnSaveDisabled'),btnRComprasDisabled:state.solicitudservicioot.get('btnRComprasDisabled'),estado:state.solicitudservicioot.get('estado'),solicitud:state.solicitudservicioot.get('solicitud')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudservicioot__["k" /* getSolicitud */])(id));},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},canmbiarResponsable:function canmbiarResponsable(solicitud,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["b" /* canmbiarResponsable */])(solicitud,type));},registerCancelacion:function registerCancelacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudservicioot__["n" /* registerCancelacion */])());},updateSolicitud:function updateSolicitud(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudservicioot__["v" /* updateSolicitud */])());},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["l" /* getParameterByName */])(nombre));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SolicitudServicioOT));

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_solicitudservicioot__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddServicio=function(_Component){_inherits(ModalAddServicio,_Component);function ModalAddServicio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddServicio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddServicio.__proto__||Object.getPrototypeOf(ModalAddServicio)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddServicio');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddServicio .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddServicio(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddServicio,[{key:'render',value:function render(){var _this2=this;var modalAddServicio=this.props.modalAddServicio;if(!modalAddServicio.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Modal__["a" /* default */],{id:'modalAddServicio',show:true,zindex:2000,width:600},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__["a" /* default */],{title:modalAddServicio.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddServicio.get('btnDisabled'),title:'Aceptar',onClick:function onClick(){return _this2.props.addSolicitudServicioItem();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'Descripcion',className:'form-control input-sm',value:modalAddServicio.getIn(['data','descripcion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.descripcion',e.target.value);},rows:3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor del servicio sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddServicio.getIn(['data','valor'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.valor',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor total del servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddServicio.getIn(['data','valor_con_iva'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddServicio.data.valor_con_iva',e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddServicio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddServicio:state.solicitudservicioot.get('modalAddServicio')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddServicio:function displayModalAddServicio(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_solicitudservicioot__["f" /* displayModalAddServicio */])(show));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_solicitudservicioot__["u" /* updateInputs */])(path,value));},addSolicitudServicioItem:function addSolicitudServicioItem(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_solicitudservicioot__["c" /* addSolicitudServicioItem */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddServicio));

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreateDocumento=function(_Component){_inherits(ModalCreateDocumento,_Component);function ModalCreateDocumento(props){_classCallCheck(this,ModalCreateDocumento);var _this=_possibleConstructorReturn(this,(ModalCreateDocumento.__proto__||Object.getPrototypeOf(ModalCreateDocumento)).call(this,props));_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreateDocumento');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateDocumento .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreateDocumento(false,'','');},300);};_this.estaCotizado=function(){return _this.props.modalCreateDocumento.getIn(['data','cotizacion','cotizado'])!=0;};_this.state={isAIU:true};return _this;}_createClass(ModalCreateDocumento,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('ALMACEN');this.props.getParameterByName('TIPO_FORMAS_PAGO');this.props.getParameterByName('TOLERANCIA');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.modalCreateDocumento.getIn(['data','iva'])>0){this.setState({isAIU:false});}}},{key:'setIsAIU',value:function setIsAIU(value){this.setState({isAIU:value});if(value){this.props.resetIVA();}else{this.props.resetAIU();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreateDocumento=_props.modalCreateDocumento,enums=_props.enums,documento_origen=_props.documento_origen,almacenes=_props.almacenes,tipo_formas_pago=_props.tipo_formas_pago,divisas=_props.divisas;if(!modalCreateDocumento.get('show')){return null;}var moneda=modalCreateDocumento.getIn(['data','cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var tipoDocumento=modalCreateDocumento.getIn(['data','tipo'])?modalCreateDocumento.getIn(['data','tipo']):0;var contratoanual=modalCreateDocumento.get('contratoanual');var allowedTypes=[];var readOnly=documento_origen!=null;if(contratoanual){allowedTypes.push(1);}else{allowedTypes.push(1,2);if(tipoDocumento==4)allowedTypes.push(4);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Modal__["a" /* default */],{id:'modalCreateDocumento',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateDocumento();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__["a" /* default */],{title:modalCreateDocumento.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'eye',onClick:function onClick(e){e.preventDefault();_this2.props.previewDocumento(modalCreateDocumento.getIn(['data','id']));},disabled:modalCreateDocumento.get('btnDisabled'),title:'Visualizar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreateDocumento.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-document',style:{width:tipoDocumento===4?'70vw':'80vw',height:tipoDocumento===4?'55vh':'80vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{width:'35%',color:'#333',fontWeight:'bold'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].NOMBRE:'PENDIENTE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'No. documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,(modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].PREFIJO:'PENDIENTE')+(modalCreateDocumento.getIn(['data','consecutivo'])||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','proveedore','nombre']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Valor sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','cotizacion','cotizado']),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Valor total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','cotizacion','cotizado_iva']),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:modalCreateDocumento.getIn(['data','detalles']).count()},'Servicios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','detalles']).first().get('descripcion'))),modalCreateDocumento.getIn(['data','detalles']).map(function(a,b){if(b===0)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr0['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('descripcion')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},tipoDocumento==1||tipoDocumento==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha registro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')||'',disabled:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha inicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_inicio'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_inicio',e.target.value);},disabled:tipoDocumento==4})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_entrega'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_entrega',e.target.value);},disabled:tipoDocumento==4}))),modalCreateDocumento.getIn(['data','tipo'])!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{marginTop:'-10px'},type:'checkbox',value:modalCreateDocumento.get('contratoanual'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.contratoanual',e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'5px'}},'Contrato anual')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','documento_id'])||0,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.documento_id',Number(e.target.value));},disabled:modalCreateDocumento.get('contratoanual')==false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione un n\xFAmero de contrato'),modalCreateDocumento.get('contratosAnuales').map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt3['+a.get('id')+']',value:a.get('id')},a.get('consecutivo'));}))))),tipoDocumento!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione el tipo de documentos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:tipoDocumento,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.tipo',e.target.value);},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opcion'),Object.keys(enums.documentos.tipos).map(function(a){if(allowedTypes.indexOf(Number(a))!=-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a+']',value:a},enums.documentos.tipos[a].NOMBRE);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione la plantilla del documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','plantilla_id'])||-1,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.plantilla_id',e.target.value);},disabled:Number(modalCreateDocumento.getIn(['data','tipo']))===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:-1,disabled:true},'Seleccione una opci\xF3n'),modalCreateDocumento.get('plantillas').filter(function(a){return a.get('tipo')===Number(modalCreateDocumento.getIn(['data','tipo']));}).map(function(a){if(a.get('nombre')!=="ORDEN DE SERVICIO - CONTRATO ANUAL"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a.get('id')+']',value:a.get('id')},a.get('nombre'));}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'% Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:this.estaCotizado()?modalCreateDocumento.getIn(['data','anticipo']):'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:this.estaCotizado()?Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','cotizacion','cotizado'])*modalCreateDocumento.getIn(['data','anticipo'])/100,divisa.simbolo):'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:this.estaCotizado()?__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','pago_anticipo'])).format('YYYY-MM-DD'):'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.pago_anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','anticipo'])==0||modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','forma_pago_anticipo'])||0,onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.forma_pago_anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','anticipo'])==0||modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una forma de pago'),tipo_formas_pago&&tipo_formas_pago.map(function(formaPago,iformaPago){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+iformaPago+']',value:formaPago.get('NOMBRE')},formaPago.get('NOMBRE'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'D\xEDas pagos del saldo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','dias_pagos_saldo'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.dias_pagos_saldo',e.target.value);}})))))),tipoDocumento!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione las garantias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},modalCreateDocumento.get('garantias').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'div1['+a.get('id')+']',className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','garantias']).filter(function(x){return x.get('id')===a.get('id');}).count()===1,onChange:function onChange(e){return _this2.props.addGarantia(e.target.checked,b,a.get('id'));},disabled:readOnly}),a.get('nombre'))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setIsAIU(e.target.value);},checked:this.state.isAIU}),'AIU')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.setIsAIU(!e.target.value);},checked:!this.state.isAIU}),'IVA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.isAIU?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'Administracion (%)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','aiu_administracion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.aiu_administracion',e.target.value);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','aiu_administracion_value']),divisa.simbolo),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'Imprevistos (%)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','aiu_imprevistos'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.aiu_imprevistos',e.target.value);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','aiu_imprevistos_value']),divisa.simbolo),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'Utilidad (%)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','aiu_utilidad'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.aiu_utilidad',e.target.value);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','aiu_utilidad_value']),divisa.simbolo),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'IVA sobre utilidad (%)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','aiu_iva_utilidad'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.aiu_iva_utilidad',e.target.value);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','aiu_iva_utilidad_value']),divisa.simbolo),disabled:true})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'IVA (%)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','iva'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.iva',e.target.value);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','iva_value']),divisa.simbolo),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'65%',textAlign:'right'},colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','aiu_total']),divisa.simbolo)))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opciones adicionales'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','entregas_parciales']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.entregas_parciales',e.target.checked);},disabled:readOnly}),'Entregas parciales'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','validacion_soma']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.validacion_soma',e.target.checked);},disabled:readOnly}),'Validaci\xF3n por SOMA'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opciones del documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','almacen'])||0,onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.almacen',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione un almacen'),almacenes&&almacenes.map(function(almacen,ialmacen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+ialmacen+']',value:almacen.get('ALMACEN')},almacen.get('ALMACEN'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','numero_cotizacion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.numero_cotizacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_cotizacion'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_cotizacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Clausula %'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','clausula'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.clausula',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Alcance y entregables de la Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalCreateDocumento.getIn(['data','alcance_entregables'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.alcance_entregables',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Garant\xEDas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalCreateDocumento.getIn(['data','garantia_documento'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.garantia_documento',e.target.value);}}))),modalCreateDocumento.getIn(['data','aprobacion','observaciones'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones del proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,defaultValue:modalCreateDocumento.getIn(['data','aprobacion','observaciones'])||'',disabled:true}))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreateDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalCreateDocumento:state.solicitudservicioot.get('modalCreateDocumento'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudservicioot.getIn(['solicitud','documento_origen']),almacenes:state.common.getIn(['parametros','ALMACEN']),tipo_formas_pago:state.common.getIn(['parametros','TIPO_FORMAS_PAGO']),divisas:state.common.getIn(['parametros','DIVISAS'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["g" /* displayModalCreateDocumento */])(show,title,mode));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["u" /* updateInputs */])(path,value,immutable));},addGarantia:function addGarantia(checked,index,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["b" /* addGarantia */])(checked,index,id));},createOrUpdateDocumento:function createOrUpdateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["e" /* createOrUpdateDocumento */])());},previewDocumento:function previewDocumento(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["l" /* previewDocumento */])(id));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["l" /* getParameterByName */])(nombre));},resetAIU:function resetAIU(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["q" /* resetAIU */])());},resetIVA:function resetIVA(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudservicioot__["r" /* resetIVA */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreateDocumento));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Documentos_General__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Documentos_Aprobacion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Documentos_DocumentosAsociados__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Documentos_Entregas__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Documentos_Adiciones__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Documentos_Facturas__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Documentos_Cancelacion__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSummary=function(_Component){_inherits(ModalSummary,_Component);function ModalSummary(props){_classCallCheck(this,ModalSummary);var _this=_possibleConstructorReturn(this,(ModalSummary.__proto__||Object.getPrototypeOf(ModalSummary)).call(this,props));_this.handleCloseModal=function(){var modal=document.getElementById('modalSummary');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSummary .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');_this.setState({maximised:false,selected:0});setTimeout(function(){return _this.props.showHideModalSummary(false);},300);};_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar este documento?',function(){_this.props.showModalConfirmarAccion(false);_this.props.cancelDocumento();});};var tabs=[{id:0,caption:'Documento',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Documentos_General__["a" /* default */],{disabledAttach:true,reducer:'solicitudservicioot'}),estado:0},{id:1,caption:'Aprobación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Documentos_Aprobacion__["a" /* default */],null),estado:0},{id:2,caption:'Documentos asociados',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Documentos_DocumentosAsociados__["a" /* default */],null),estado:1},{id:3,caption:'Ajustes',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Documentos_Adiciones__["a" /* default */],null),estado:0},{id:4,caption:'Entregas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Documentos_Entregas__["a" /* default */],null),estado:0},{id:5,caption:'Facturas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Documentos_Facturas__["a" /* default */],null),estado:6},{id:6,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Documentos_Cancelacion__["a" /* default */],null),estado:0}];if(props.modalSummary.getIn(['data','estado'])===6&&!props.modalSummary.get('documentos'))delete tabs[2];if(props.modalSummary.getIn(['data','estado'])===6&&!props.modalSummary.get('adiciones'))delete tabs[3];if(props.tipo_solicitud===5){delete tabs[2];delete tabs[3];delete tabs[4];delete tabs[5];delete tabs[6];}_this.state={tabs:[].concat(tabs),selected:0,maximised:false};return _this;}_createClass(ModalSummary,[{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected,maximised=_state.maximised;var _props=this.props,modalSummary=_props.modalSummary,user=_props.user,enums=_props.enums,documento_origen=_props.documento_origen;if(!modalSummary.get('show')){return null;}var documento=modalSummary.get('data');var readOnly=documento_origen!=null;var editar=modalSummary.get('editar');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalSummary',show:true,ZIndex:2000,draggable:!maximised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:maximised?'bold':'normal'}},'Documento: '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].NOMBRE+' '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].PREFIJO+modalSummary.getIn(['data','consecutivo'])),onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSummary");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:maximised?'compress':'arrows-alt',title:maximised?'Minimizar':"Maximizar",onClick:function onClick(e){return _this2.setState({maximised:!maximised});}}),this.state.selected===0&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',documento.get('solicitude'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Actualizar documento',onClick:function onClick(){return _this2.props.updateDocumento();},disabled:!editar}),this.state.selected===3&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["E" /* isAllowedToViewComponent */])('responsables_recibo',documento,user.get('id'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus-circle',title:'Crear adici\xF3n',onClick:function onClick(e){return _this2.props.showHideModalAddAdicional(true,documento.get('id'),modalSummary.get('url'),modalSummary.get('type'));},disabled:readOnly}),this.state.selected===6&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'ban',title:'Cancelar orden/contrato',onClick:function onClick(e){return _this2.cancel();},disabled:documento.get('estado')==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.maximised?'modal-100-100':'modal-80-70'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs green'},tabs.filter(function(x){return x.estado<=documento.get('estado');}).map(function(x){//const entregado = documento.get('entregas').count() > 0 ? documento.get('entregas').filter(e => e.get('recibido') == 1).count() > 0 : false
//if (entregado && x.id == 6) return null
if(documento.get('estado')==11&&x.id==6)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSummary:state.documentos.get('modalSummary'),user:state.common.get('user'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudservicioot.getIn(['solicitud','documento_origen']),tipo_solicitud:state.solicitudservicioot.getIn(['solicitud','tipo'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalSummary:function showHideModalSummary(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["k" /* showHideModalSummary */])(state));},showHideModalAddFactura:function showHideModalAddFactura(show,documento,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["r" /* showHideModalAddFactura */])(show,documento,url,type));},showHideModalAddAdicional:function showHideModalAddAdicional(show,documento,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["i" /* showHideModalAddAdicional */])(show,documento,url,type));},cancelDocumento:function cancelDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["c" /* cancelDocumento */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},updateDocumento:function updateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["m" /* updateDocumento */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSummary));

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SolicitudBI_General__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SolicitudBI_Proveedores__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SolicitudBI_Cotizaciones__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SolicitudBI_Aprobaciones__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SolicitudBI_Documentos__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SolicitudBI_CompraDirecta__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SolicitudBI_Cancelacion__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { showModalConfirmarAccion } from '../actions/common'
var SolicitudBI=function(_Component){_inherits(SolicitudBI,_Component);function SolicitudBI(props){_classCallCheck(this,SolicitudBI);var _this=_possibleConstructorReturn(this,(SolicitudBI.__proto__||Object.getPrototypeOf(SolicitudBI)).call(this,props));_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar la solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerCancelacion();});};_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.state={tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_SolicitudBI_General__["a" /* default */],null),estado:1},{id:1,caption:'Proveedores',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_SolicitudBI_Proveedores__["a" /* default */],null),estado:8},{id:2,caption:'Cotizaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SolicitudBI_Cotizaciones__["a" /* default */],null),estado:2},{id:3,caption:'Aprobaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SolicitudBI_Aprobaciones__["a" /* default */],null),estado:3},{id:4,caption:'Documentos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SolicitudBI_Documentos__["a" /* default */],null),estado:4},{id:5,caption:'Compra directa',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SolicitudBI_CompraDirecta__["a" /* default */],null),estado:4},{id:6,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SolicitudBI_Cancelacion__["a" /* default */],null),estado:0}],selected:0};return _this;}_createClass(SolicitudBI,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){this.props.getSolicitud(this.props.match.params.id);var params=new URLSearchParams(this.props.location.search);if(params.has("aprobacion")){this.setState({selected:3});}this.props.getParameterByName('DIVISAS');}else{__WEBPACK_IMPORTED_MODULE_13__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes');}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,estado=_props.estado,btnSaveDisabled=_props.btnSaveDisabled,aprobadores=_props.aprobadores,btnRComprasDisabled=_props.btnRComprasDisabled,solicitud=_props.solicitud,p_almacen=_props.p_almacen,tipo_almacen=_props.tipo_almacen,user=_props.user;var responsable_almacen=null;if(p_almacen&&p_almacen.count()>0){responsable_almacen=p_almacen.filter(function(a){return a.get('ALMACEN')===tipo_almacen;}).getIn(['0','USUARIO']);}var esResponsableAlmacen=responsable_almacen==user.get('username')||user.get('es_superusuario');var esResponsableCompras=solicitud.getIn(['responsable_compras','id'])==user.get('id');var readOnly=!Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);var documentos_proceso=solicitud.get('documentos')?solicitud.get('documentos').filter(function(d){return d.get('estado')==4||d.get('estado')>6;}).count():0;var facturas_directas=solicitud.get('bienes')?solicitud.get('bienes').filter(function(b){return b.get('factura_compra_directa')&&b.get('compra_directa');}).count():0;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.updateSolicitudBI();},title:'Actualizar solicitud',disabled:btnSaveDisabled&&solicitud.get('estado')!=1||solicitud.get('estado')==1&&!esResponsableAlmacen&&!esResponsableCompras}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'user',onClick:function onClick(){return _this2.props.canmbiarResponsable(solicitud,'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION');},title:'Cambiar responsable',disabled:btnRComprasDisabled||selected!==0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][5]',name:'ban',onClick:function onClick(){return _this2.cancel();},title:'Aprobar cancelaci\xF3n solicitud',disabled:readOnly||selected!==6||estado==0})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){if(solicitud.get('documentos')&&x.id===4&&solicitud.get('documentos').count()===0)return null;if(x.id===3&&aprobadores.count()===0)return null;if(estado<=1){var rechazos=aprobadores.filter(function(x){return x.get('aprobaciones').filter(function(y){return y.get('estado')==0;}).count()>0;}).count()>0;if(rechazos){return x.estado<=3;}return x.estado<=1;}else if(estado===8){return x.estado===1||x.estado===8||x.estado===0;}else if((documentos_proceso>0||facturas_directas>0)&&x.id===6){return null;}else if(estado>=2){return x.estado<=estado||x.estado===8;}}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li01['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(selected==2||selected==3?'table-section-scrollable':'nav-main-section-scrollable')},tabs[selected].component)))));}}]);return SolicitudBI;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{btnSaveDisabled:state.solicitudBI.get('btnSaveDisabled'),estado:state.solicitudBI.get('estado'),aprobadores:state.solicitudBI.get('aprobadores'),btnRComprasDisabled:state.solicitudBI.get('btnRComprasDisabled'),solicitud:state.solicitudBI.get('solicitud'),p_almacen:state.common.getIn(['parametros','ALMACEN']),tipo_almacen:state.solicitudBI.get('tipo_almacen'),user:state.common.get('user')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["r" /* getSolicitud */])(id));},updateSolicitudBI:function updateSolicitudBI(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["G" /* updateSolicitudBI */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},canmbiarResponsable:function canmbiarResponsable(solicitud,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["b" /* canmbiarResponsable */])(solicitud,type));},registerCancelacion:function registerCancelacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["u" /* registerCancelacion */])());},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_common__["l" /* getParameterByName */])(nombre));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SolicitudBI));

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Proveedores=function(_Component){_inherits(Proveedores,_Component);function Proveedores(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Proveedores);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Proveedores.__proto__||Object.getPrototypeOf(Proveedores)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(list){var columns=[{id:1,caption:'Nit',value:'identificacion',width:'30%'},{id:2,caption:'Razon Social',value:'nombre',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addProveedorCotizacion(payload);});};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores',fn);},_this.getProveedoresUnicos=function(bien){var proveedores=[];var cotizaciones=bien.get('cotizaciones');cotizaciones.valueSeq().forEach(function(cotizacion){var proveedor_id=cotizacion.get('proveedor_id');var index=proveedores.findIndex(function(proveedor){return proveedor.get('id')==proveedor_id;});if(proveedor_id&&index==-1){var proveedor=cotizacion.get('proveedore').set('bien_id',bien.get('id'));if(!cotizacion.get('id')){proveedor=proveedor.set('isNew',true);}else{proveedor=proveedor.set('isNew',false);}proveedores.push(proveedor);}});return proveedores;},_this.handleOpenSelectorMoneda=function(moneda){_this.props.seleccionarMoneda(moneda);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Proveedores,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudBI=_props.solicitudBI,estado=_props.estado,divisas=_props.divisas,moneda=_props.moneda;if(!id)return null;var es_responsable_compras=Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitudBI);var readOnly=estado!=2&&estado!=3&&estado!=8||!es_responsable_compras;var buttons=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',size:14,contrast:true,name:'plus-circle',title:'Adicionar proveedor',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('solicitud.bienes');},disabled:readOnly})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Informacion b\xE1sica para las cotizaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha l\xEDmite cotizaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',disabled:estado>2&&estado<8,value:solicitudBI.getIn(['bienes',0,'fecha_cotizaciones'])!=='-0001-11-30 00:00:00'?__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudBI.getIn(['bienes',0,'fecha_cotizaciones'])).format('YYYY-MM-DD'):'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.0.fecha_cotizaciones',e.target.value,solicitudBI.getIn(['bienes',0,'id']));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-10 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label',style:{marginRight:'10px'}},'Tipo de moneda:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{alignItems:'flex-end'},className:'btn-group',role:'group','aria-label':'Basic outlined example'},divisas&&divisas.map(function(d,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:'d['+i+']',style:{borderRadius:'5px'},type:'button',onClick:estado==1||estado==8?function(){return _this2.handleOpenSelectorMoneda(d.get('CODIGO'));}:null,className:moneda==d.get('CODIGO')?'btn btn-primary':'btn btn-outline-primary'},d.get('CODIGO'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Listado de bienes',actions:buttons},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'20px',style:{textAlign:'center',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:solicitudBI.get('bienes').filter(function(x){return x.get('selected');}).count()==solicitudBI.get('bienes').count(),onChange:function onChange(e){return _this2.props.toggleSelectAllProveedores(e.target.checked);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Descripci\xF3n inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Observaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'\xBFCompra directa?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proveedores'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudBI.get('bienes').map(function(x,n){var proveedores=_this2.getProveedoresUnicos(x);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr[24]['+n+']['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+n+'.selected',e.target.checked);},disabled:readOnly||x.get('cantidad_solicitada')==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',disabled:estado>=2&&estado<8||x.get('cantidad_solicitada')==0,value:x.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+n+'.observaciones',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},x.get('cantidad_solicitada')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},x.get('unidad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',disabled:readOnly||x.get('cantidad_solicitada')==0,checked:x.get('compra_directa'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+n+'.compra_directa',e.target.checked,x.get('id'));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,proveedores.map(function(p){if(p.get('isNew')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'p['+x.get('id')+']['+p.get('id')+']',className:'label-proveedor-new',title:p.get('identificacion'),style:{cursor:'pointer'},onClick:function onClick(){return _this2.props.removeProveedorCotizacion(p);}},'x | '+p.get('nombre'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'p['+x.get('id')+']['+p.get('id')+']',className:'label-cenco-dist',title:p.get('identificacion')},p.get('nombre'));}})));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Proveedores;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudBI.get('id'),estado:state.solicitudBI.get('estado'),solicitudBI:state.solicitudBI.get('solicitud'),divisas:state.common.getIn(['parametros','DIVISAS']),moneda:state.solicitudBI.get('moneda')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["F" /* updateInputs */])(path,value,id));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},toggleAllCotizacion:function toggleAllCotizacion(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["D" /* toggleAllCotizacion */])(path,value));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_common__["q" /* selectFromSelector */])(type,payload));},addCotizacion:function addCotizacion(path,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["a" /* addCotizacion */])(path,index));},addProveedorCotizacion:function addProveedorCotizacion(payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["g" /* addProveedorCotizacion */])(payload));},removeProveedorCotizacion:function removeProveedorCotizacion(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["y" /* removeProveedorCotizacion */])(path));},addGroupOrders:function addGroupOrders(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["f" /* addGroupOrders */])());},removeGroupOrders:function removeGroupOrders(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["x" /* removeGroupOrders */])());},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_common__["h" /* downloadFile */])(id,filename));},toggleSelectAllProveedores:function toggleSelectAllProveedores(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["E" /* toggleSelectAllProveedores */])(checked));},seleccionarMoneda:function seleccionarMoneda(moneda){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["C" /* seleccionarMoneda */])(moneda));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Proveedores));

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_solicitudbi__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cotizaciones=function(_Component){_inherits(Cotizaciones,_Component);function Cotizaciones(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Cotizaciones);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Cotizaciones.__proto__||Object.getPrototypeOf(Cotizaciones)).call.apply(_ref,[this].concat(args))),_this),_this.getTotal=function(valor,iva,cantidad){if(!valor)return 0;if(!cantidad)return 0;var total=valor*cantidad;return iva?total+iva*total/100:total;},_this.getProveedores=function(){var cotizaciones=_this.props.solicitudBI.get('cotizaciones');var proveedores=[];cotizaciones.map(function(c){var index=-1;proveedores.forEach(function(p,i){if(c.get('proveedor_id')==p.get('id'))index=i;});if(c.get('proveedor_id')&&index==-1){proveedores.push(c.get('proveedore'));}});return proveedores.sort(function(a,b){return a.get('id')-b.get('id');});},_this.getTipoCompra=function(bien){var tiene_proveedor=bien.get('cotizaciones').filter(function(c){return c.get('proveedor_id')!=null;}).count()>0;if(bien.get('compra_directa')&&!tiene_proveedor)return 1;if(!bien.get('compra_directa')&&tiene_proveedor)return 2;if(bien.get('compra_directa')&&tiene_proveedor)return 3;return 1;},_this.changeValueCotizacion=function(cotizacion_id,attr,value){var bienes=_this.props.solicitudBI.get('bienes');var cotizacion=_this.props.solicitudBI.get('cotizaciones').filter(function(c){return c.get('id')==cotizacion_id;}).first();var bien_id=cotizacion.getIn(['bienes',0,'id']);var bien_idx=bienes.findIndex(function(x){return x.get('id')==bien_id;});if(bien_idx>=0){if(attr=='recomendado'){bienes.getIn([bien_idx,'cotizaciones']).valueSeq().forEach(function(cot){var idx=bienes.getIn([bien_idx,'cotizaciones']).findIndex(function(x){return x.get('id')==cot.get('id');});_this.props.updateInputs('solicitud.bienes.'+bien_idx+'.cotizaciones.'+idx+'.recomendado',false);});}var cotizacion_idx=bienes.getIn([bien_idx,'cotizaciones']).findIndex(function(x){return x.get('id')==cotizacion_id;});if(cotizacion_idx>=0){_this.props.updateInputs('solicitud.bienes.'+bien_idx+'.cotizaciones.'+cotizacion_idx+'.'+attr,value,cotizacion_id);}}},_this.getTotalSeleccionado=function(proveedor_id){var total=0;_this.props.solicitudBI.get('bienes').valueSeq().forEach(function(b){var cantidad=b.get('cantidad_solicitada');b.get('cotizaciones').valueSeq().forEach(function(c){if(c.get('recomendado')&&c.get('proveedor_id')==proveedor_id){total+=cantidad*Number(c.get('cotizado_iva'));}});});var cotizaciones_proveedor=_this.props.solicitudBI.get('cotizaciones').filter(function(b){return b.get('proveedor_id')==proveedor_id;});var moneda=cotizaciones_proveedor?cotizaciones_proveedor.first().get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["t" /* getDivisa */])(_this.props.divisas,moneda);return Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["q" /* formatcoin */])(total,divisa.simbolo);},_this.getTotalCotizacion=function(){var total=_this.props.solicitudBI.get('bienes').reduce(function(acum,bien){acum+=bien.get('cotizaciones').filter(function(c){return c.get('recomendado');}).reduce(function(acum2,cotizacion){var cotizado=Number(cotizacion.get('cotizado'));var iva=Number(cotizacion.get('iva'));var cotizado_iva=cotizado+Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["v" /* getPorcentaje */])(cotizado,iva);var cantidad=Number(bien.get('cantidad_solicitada'));acum2+=cotizado_iva*cantidad;return acum2;},0);return acum;},0);return total;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Cotizaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,solicitudBI=_props.solicitudBI,divisas=_props.divisas;var moneda=solicitudBI.get('cotizaciones')?solicitudBI.get('cotizaciones').first().get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var proveedores=this.getProveedores();var es_responsable_compras=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitudBI);var readOnly=solicitudBI.get('estado')==0||solicitudBI.get('estado')>3||solicitudBI.get('estado')==8||!es_responsable_compras;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{overflow:'auto',whiteSpace:'nowrap',paddingBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped',id:'comparativo-cotizaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4,style:{borderTop:'1px solid #FFF',borderLeft:'1px solid #FFF'}}),proveedores.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'phead['+i+']'},p.get('nombre'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'COMPRA DIRECTA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Descripci\xF3n inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'230px'}},'Observaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'U.M.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cantidad'),proveedores.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'pcol['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudBI.get('bienes').map(function(bien,bienIndex){var cantidad=bien.get('cantidad_solicitada');var tipo_compra=_this2.getTipoCompra(bien);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'itm['+bienIndex+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',style:{width:'100%'},value:bien.get('descripcion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+bienIndex+'.descripcion',e.target.value,bien.get('id'));},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control input-sm',width:'100%',rows:5,value:bien.get('observaciones')||'',disabled:readOnly,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.bienes.'+bienIndex+'.observaciones',e.target.value,bien.get('id'));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,bien.get('unidad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,cantidad),proveedores.map(function(p){var cotizaciones_proveedor=bien.get('cotizaciones').filter(function(cotizaciones){return cotizaciones.getIn(['pivot','bienes_detalle_id'])==bien.get('id')&&cotizaciones.get('proveedor_id')==p.get('id');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'tdprov['+p.get('id')+']['+bien.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Marca'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. Unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. con IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'T. Entrega'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,cotizaciones_proveedor.map(function(cp,cpi){var moneda=cp.get('moneda')?cp.get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var valor=cp.get('cotizado');var iva=cp.get('iva');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'cp['+bien.get('id')+']['+cp.get('id')+']['+cp.get('proveedor_id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:cp.get('recomendado'),onChange:function onChange(e){return _this2.changeValueCotizacion(cp.get('id'),'recomendado',e.target.checked);},disabled:cp.get('estado')==0||cp.get('estado')==2||readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:cp.get('marca')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cp.get('id'),'marca',e.target.value);},style:{width:'150px'},disabled:cp.get('estado')==0||cp.get('estado')==2||readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:valor||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cp.get('id'),'cotizado',e.target.value);},style:{width:'150px'},disabled:cp.get('estado')==0||cp.get('estado')==2||readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:iva||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cp.get('id'),'iva',e.target.value);},style:{width:'100px'},disabled:cp.get('estado')==0||cp.get('estado')==2||readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["q" /* formatcoin */])(_this2.getTotal(valor,iva,cantidad),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',value:cp.get('tiempo_entrega')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cp.get('id'),'tiempo_entrega',e.target.value);},className:'form-control input-sm',style:{width:'100px'},disabled:cp.get('estado')==0||cp.get('estado')==2||readOnly})));}))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,tipo_compra==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Marca'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. Unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. con IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'T. Entrega'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,bien.get('cotizaciones').map(function(cotizacion,cotizacionIndex){var moneda=cotizacion.get('moneda')?cotizacion.get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var valor=cotizacion.get('cotizado')?cotizacion.get('cotizado'):0;var iva=cotizacion.get('iva')?cotizacion.get('iva'):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+bienIndex+']['+cotizacionIndex+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:cotizacion.get('recomendado'),onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'recomendado',e.target.checked);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:cotizacion.get('proveedor_nombre_cp')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'proveedor_nombre_cp',e.target.value);},style:{width:'200px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:cotizacion.get('marca')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'marca',e.target.value);},style:{width:'150px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:cotizacion.get('cotizado')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'cotizado',e.target.value);},style:{width:'150px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:cotizacion.get('iva'),onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'iva',e.target.value);},style:{width:'100px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["q" /* formatcoin */])(_this2.getTotal(valor,iva,cantidad),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',value:cotizacion.get('tiempo_entrega')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'tiempo_entrega',e.target.value);},className:'form-control input-sm',style:{width:'100px'},disabled:readOnly})));}))),tipo_compra==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Marca'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. Unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. con IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'T. Entrega'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,bien.get('cotizaciones').filter(function(c){return!c.get('proveedor_id');}).map(function(cotizacion,cotizacionIndex){var moneda=cotizacion.get('moneda')?cotizacion.get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var valor=cotizacion.get('cotizado')?cotizacion.get('cotizado'):0;var iva=cotizacion.get('iva')?cotizacion.get('iva'):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+bienIndex+']['+cotizacionIndex+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:cotizacion.get('recomendado'),onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'recomendado',e.target.checked);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:cotizacion.get('proveedor_nombre_cp')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'proveedor_nombre_cp',e.target.value);},style:{width:'200px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:cotizacion.get('marca')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'marca',e.target.value);},style:{width:'150px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:cotizacion.get('cotizado')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'cotizado',e.target.value);},style:{width:'150px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:cotizacion.get('iva'),onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'iva',e.target.value);},style:{width:'100px'},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["q" /* formatcoin */])(_this2.getTotal(valor,iva,cantidad),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',value:cotizacion.get('tiempo_entrega')||'',onChange:function onChange(e){return _this2.changeValueCotizacion(cotizacion.get('id'),'tiempo_entrega',e.target.value);},className:'form-control input-sm',style:{width:'100px'},disabled:readOnly})));})))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{backgroundColor:'#eee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:4,style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Total Seleccionado por Proveedor')),proveedores.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'fcol['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this2.getTotalSeleccionado(p.get('id')))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Total presupuesto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 text-center',style:{fontSize:'18px',fontWeight:'bold'}},Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["q" /* formatcoin */])(this.getTotalCotizacion(),divisa.simbolo)))))));}}]);return Cotizaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitudBI:state.solicitudBI.get('solicitud'),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_solicitudbi__["F" /* updateInputs */])(path,value,id));},addCotizacionAprobar:function addCotizacionAprobar(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_solicitudbi__["b" /* addCotizacionAprobar */])(path));},seleccionarCotizacionAprobar:function seleccionarCotizacionAprobar(cotizacion_id,bien_idx,cotizacion_aprobar_idx){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_solicitudbi__["B" /* seleccionarCotizacionAprobar */])(cotizacion_id,bien_idx,cotizacion_aprobar_idx));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["h" /* downloadFile */])(id,filename));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["l" /* getParameterByName */])(nombre));},recomendarCotizacion:function recomendarCotizacion(bien_id,proveedor_id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_solicitudbi__["t" /* recomendarCotizacion */])(bien_id,proveedor_id));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cotizaciones));

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_solicitudbi__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreateDocumento=function(_Component){_inherits(ModalCreateDocumento,_Component);function ModalCreateDocumento(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreateDocumento);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreateDocumento.__proto__||Object.getPrototypeOf(ModalCreateDocumento)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreateDocumento');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateDocumento .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreateDocumento(false,'','');},300);},_this.getTotalSinIva=function(){return _this.props.modalCreateDocumento.getIn(['data','detalles']).reduce(function(acum,detalle){acum+=detalle.get('valor')*detalle.get('cantidad');return acum;},0);},_this.getTotalConIva=function(){return _this.props.modalCreateDocumento.getIn(['data','detalles']).reduce(function(acum,detalle){acum+=detalle.get('valor_con_iva')*detalle.get('cantidad');return acum;},0);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreateDocumento,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('ALMACEN');this.props.getParameterByName('TIPO_FORMAS_PAGO');this.props.getParameterByName('TOLERANCIA');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreateDocumento=_props.modalCreateDocumento,enums=_props.enums,documento_origen=_props.documento_origen,almacenes=_props.almacenes,tipo_formas_pago=_props.tipo_formas_pago,divisas=_props.divisas;if(!modalCreateDocumento.get('show')){return null;}var moneda=modalCreateDocumento.getIn(['data','cotizacion','moneda']);var divisa=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var tipoDocumento=modalCreateDocumento.getIn(['data','tipo'])?modalCreateDocumento.getIn(['data','tipo']):0;var contratoanual=modalCreateDocumento.get('contratoanual');var allowedTypes=[];var readOnly=documento_origen!=null;if(contratoanual){allowedTypes.push(1);}else{allowedTypes.push(2,3);if(tipoDocumento==4)allowedTypes.push(4);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_Modal__["a" /* default */],{id:'modalCreateDocumento',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateDocumento();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__["a" /* default */],{title:modalCreateDocumento.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{name:'eye',onClick:function onClick(e){e.preventDefault();_this2.props.previewDocumento(modalCreateDocumento.getIn(['data','id']));},disabled:modalCreateDocumento.get('btnDisabled'),title:'Visualizar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreateDocumento.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'create-document',style:{width:tipoDocumento===4?'70vw':'80vw',height:tipoDocumento===4?'55vh':'80vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{width:'35%',color:'#333',fontWeight:'bold'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].NOMBRE:'PENDIENTE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'No. documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,(modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].PREFIJO:'PENDIENTE')+(modalCreateDocumento.getIn(['data','consecutivo'])||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','proveedore','nombre']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Valor sin IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["q" /* formatcoin */])(this.getTotalSinIva(),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Valor total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["q" /* formatcoin */])(this.getTotalConIva(),divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:modalCreateDocumento.getIn(['data','detalles']).count()},'Bienes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','detalles']).first().get('descripcion'))),modalCreateDocumento.getIn(['data','detalles']).map(function(a,b){if(b===0)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr0['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('descripcion')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},tipoDocumento==1||tipoDocumento==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha registro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')||'',disabled:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha inicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_inicio'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_inicio',e.target.value);},disabled:tipoDocumento==4})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_entrega'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_entrega',e.target.value);},disabled:tipoDocumento==4}))),modalCreateDocumento.getIn(['data','tipo'])!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{marginTop:'-10px'},type:'checkbox',value:modalCreateDocumento.get('contratoanual'),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.contratoanual',e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'5px'}},'Contrato anual')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','documento_id'])||0,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.documento_id',Number(e.target.value));},disabled:modalCreateDocumento.get('contratoanual')==false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione un n\xFAmero de contrato'),modalCreateDocumento.get('contratosAnuales').map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt3['+a.get('id')+']',value:a.get('id')},a.get('consecutivo'));}))))),tipoDocumento!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione el tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:tipoDocumento,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.tipo',e.target.value);_this2.props.updateInputs('modalCreateDocumento.data.plantilla_id',"");},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opcion'),Object.keys(enums.documentos.tipos).map(function(a){if(allowedTypes.indexOf(Number(a))!=-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a+']',value:a},enums.documentos.tipos[a].NOMBRE);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione la plantilla del documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','plantilla_id'])||-1,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.plantilla_id',e.target.value);},disabled:Number(modalCreateDocumento.getIn(['data','tipo']))===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:-1,disabled:true},'Seleccione una opci\xF3n'),modalCreateDocumento.get('plantillas').filter(function(a){return a.get('tipo')===Number(modalCreateDocumento.getIn(['data','tipo']));}).map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a.get('id')+']',value:a.get('id')},a.get('nombre'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'% Anticipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','anticipo']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["q" /* formatcoin */])(this.getTotalSinIva()*modalCreateDocumento.getIn(['data','anticipo'])/100,divisa.simbolo),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','pago_anticipo'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.pago_anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','anticipo'])==0||modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{padding:"1px 2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','forma_pago_anticipo'])||0,onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.forma_pago_anticipo',e.target.value);},disabled:modalCreateDocumento.getIn(['data','anticipo'])==0||modalCreateDocumento.getIn(['data','cotizacion','cotizado'])==0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una forma de pago'),tipo_formas_pago&&tipo_formas_pago.map(function(formaPago,iformaPago){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+iformaPago+']',value:formaPago.get('NOMBRE')},formaPago.get('NOMBRE'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:"1px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'D\xEDas pagos del saldo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','dias_pagos_saldo'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.dias_pagos_saldo',e.target.value);}})))))),tipoDocumento!=4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione las garantias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},modalCreateDocumento.get('garantias').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'div1['+a.get('id')+']',className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','garantias']).filter(function(x){return x.get('id')===a.get('id');}).count()===1,onChange:function onChange(e){return _this2.props.addGarantia(e.target.checked,b,a.get('id'));},disabled:readOnly}),a.get('nombre'))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},'Valor total del IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'0%',display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','iva']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.iva',e.target.value);},disabled:readOnly})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',style:{display:'inline-block',width:'Calc(100% - 30px)'},value:modalCreateDocumento.getIn(['data','iva_value']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.iva_value',e.target.value);},disabled:readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{name:'retweet',onClick:function onClick(e){e.preventDefault();_this2.props.calculateIva();},disabled:readOnly,title:'Calcular IVA',size:'12'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'35%'}},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'65%',textAlign:'right'},colSpan:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["q" /* formatcoin */])(modalCreateDocumento.getIn(['data','aiu_total']),divisa.simbolo)))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opciones adicionales'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalCreateDocumento.getIn(['data','entregas_parciales']),onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.entregas_parciales',e.target.checked);},disabled:readOnly}),'Entregas parciales'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opciones del documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 10px',border:'1px solid #eee',borderRadius:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','almacen'])||0,onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.almacen',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione un almacen'),almacenes&&almacenes.map(function(almacen,ialmacen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+ialmacen+']',value:almacen.get('ALMACEN')},almacen.get('ALMACEN'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','numero_cotizacion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.numero_cotizacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_cotizacion'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_cotizacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Clausula %'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','clausula'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.clausula',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Alcance y entregables de la Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalCreateDocumento.getIn(['data','alcance_entregables'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.alcance_entregables',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Garant\xEDas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalCreateDocumento.getIn(['data','garantia_documento'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.garantia_documento',e.target.value);}}))),modalCreateDocumento.getIn(['data','aprobacion','observaciones'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones del proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,defaultValue:modalCreateDocumento.getIn(['data','aprobacion','observaciones'])||'',disabled:true}))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreateDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalCreateDocumento:state.solicitudBI.get('modalCreateDocumento'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudBI.getIn(['solicitud','documento_origen']),almacenes:state.common.getIn(['parametros','ALMACEN']),tipo_formas_pago:state.common.getIn(['parametros','TIPO_FORMAS_PAGO']),divisas:state.common.getIn(['parametros','DIVISAS'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudbi__["n" /* displayModalCreateDocumento */])(show,title,mode));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudbi__["F" /* updateInputs */])(path,value,immutable));},addGarantia:function addGarantia(checked,index,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudbi__["e" /* addGarantia */])(checked,index,id));},createOrUpdateDocumento:function createOrUpdateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudbi__["l" /* createOrUpdateDocumento */])());},previewDocumento:function previewDocumento(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudbi__["s" /* previewDocumento */])(id));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["l" /* getParameterByName */])(nombre));},calculateIva:function calculateIva(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudbi__["i" /* calculateIva */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreateDocumento));

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Documentos_General__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Documentos_Aprobacion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Documentos_DocumentosAsociados__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Documentos_Entregas__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Documentos_Adiciones__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Documentos_Facturas__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Documentos_Cancelacion__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSummary=function(_Component){_inherits(ModalSummary,_Component);function ModalSummary(props){_classCallCheck(this,ModalSummary);var _this=_possibleConstructorReturn(this,(ModalSummary.__proto__||Object.getPrototypeOf(ModalSummary)).call(this,props));_this.handleCloseModal=function(){var modal=document.getElementById('modalSummary');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSummary .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');_this.setState({maximised:false,selected:0});setTimeout(function(){return _this.props.showHideModalSummary(false);},300);};_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar este documento?',function(){_this.props.showModalConfirmarAccion(false);_this.props.cancelDocumento();});};var tabs=[{id:0,caption:'Documento',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Documentos_General__["a" /* default */],{disabledAttach:true,reducer:'solicitudBI'}),estado:0},{id:1,caption:'Aprobación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Documentos_Aprobacion__["a" /* default */],null),estado:0},{id:2,caption:'Documentos asociados',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Documentos_DocumentosAsociados__["a" /* default */],null),estado:1},{id:3,caption:'Ajustes',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Documentos_Adiciones__["a" /* default */],null),estado:0},{id:4,caption:'Entregas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Documentos_Entregas__["a" /* default */],null),estado:0},{id:5,caption:'Facturas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Documentos_Facturas__["a" /* default */],null),estado:6},{id:6,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Documentos_Cancelacion__["a" /* default */],null),estado:0}];if(props.modalSummary.getIn(['data','estado'])===6&&!props.modalSummary.get('documentos'))delete tabs[2];if(props.modalSummary.getIn(['data','estado'])===6&&!props.modalSummary.get('adiciones'))delete tabs[3];if(props.tipo_solicitud===5){delete tabs[2];delete tabs[3];delete tabs[4];delete tabs[5];delete tabs[6];}_this.state={tabs:[].concat(tabs),selected:0,maximised:false};return _this;}_createClass(ModalSummary,[{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected,maximised=_state.maximised;var _props=this.props,modalSummary=_props.modalSummary,user=_props.user,enums=_props.enums,documento_origen=_props.documento_origen;if(!modalSummary.get('show')){return null;}var documento=modalSummary.get('data');var readOnly=documento_origen!=null;var editar=modalSummary.get('editar');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalSummary',show:true,ZIndex:2000,draggable:!maximised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:maximised?'bold':'normal'}},'Documento: '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].NOMBRE+' '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].PREFIJO+modalSummary.getIn(['data','consecutivo'])),onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSummary");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:maximised?'compress':'arrows-alt',title:maximised?'Minimizar':"Maximizar",onClick:function onClick(e){return _this2.setState({maximised:!maximised});}}),this.state.selected===0&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',documento.get('solicitude'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Actualizar documento',onClick:function onClick(){return _this2.props.updateDocumento();},disabled:!editar}),this.state.selected===3&&Object(__WEBPACK_IMPORTED_MODULE_17__utils_helpers__["E" /* isAllowedToViewComponent */])('responsables_recibo',documento,user.get('id'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus-circle',title:'Crear adici\xF3n',onClick:function onClick(e){return _this2.props.showHideModalAddAdicional(true,documento.get('id'),modalSummary.get('url'),modalSummary.get('type'));},disabled:readOnly}),this.state.selected===6&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'ban',title:'Cancelar orden/contrato',onClick:function onClick(e){return _this2.cancel();},disabled:documento.get('estado')==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.maximised?'modal-100-100':'modal-80-70'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs green'},tabs.filter(function(x){return x.estado<=documento.get('estado');}).map(function(x){// const entregado = documento.get('entregas').count() > 0 ? documento.get('entregas').filter(e => e.get('recibido') == 1).count() > 0 : false                                                    
// if (entregado && x.id == 6) return null
if(documento.get('estado')==11&&x.id==6)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSummary:state.documentos.get('modalSummary'),user:state.common.get('user'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudBI.getIn(['solicitud','documento_origen']),tipo_solicitud:state.solicitudBI.getIn(['solicitud','tipo'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalSummary:function showHideModalSummary(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["k" /* showHideModalSummary */])(state));},showHideModalAddFactura:function showHideModalAddFactura(show,documento,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["r" /* showHideModalAddFactura */])(show,documento,url,type));},showHideModalAddAdicional:function showHideModalAddAdicional(show,documento,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["i" /* showHideModalAddAdicional */])(show,documento,url,type));},cancelDocumento:function cancelDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["c" /* cancelDocumento */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},updateDocumento:function updateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_documentos__["m" /* updateDocumento */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSummary));

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalCreateCompraDirecta__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompraDirecta=function(_React$Component){_inherits(CompraDirecta,_React$Component);function CompraDirecta(){_classCallCheck(this,CompraDirecta);return _possibleConstructorReturn(this,(CompraDirecta.__proto__||Object.getPrototypeOf(CompraDirecta)).apply(this,arguments));}_createClass(CompraDirecta,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudBI=_props.solicitudBI,divisas=_props.divisas,displayModalCompraDirecta=_props.displayModalCompraDirecta;var medios_pago={tarjeta_debito:'Tarjeta Débito',tarjeta_credito:'Tarjeta Crédito',caja_menor:'Caja Menor'};if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Producto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Nombre razon social'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'NIT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No. Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Adjuntar factura'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudBI.get('cotizaciones').filter(function(c){return c.get('recomendado')&&!c.get('proveedor_id');}).map(function(cot){var moneda=cot.get('moneda');var divisa=Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["t" /* getDivisa */])(divisas,moneda);return cot.get('bienes').filter(function(bien){return bien.get('compra_directa');}).map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',disabled:!!a.getIn(['factura_compra_directa','id'])||!Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',_this2.props.solicitudBI),onClick:function onClick(){return displayModalCompraDirecta(true,'Registrar Compra Directa',a.get('id'),cot);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.getIn(['cantidad_solicitada'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['factura_compra_directa','razon_social'])||cot.get('proveedor_nombre_cp')||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['factura_compra_directa','nit'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.getIn(['factura_compra_directa','no_factura'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.getIn(['factura_compra_directa','fecha_compra'])).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,medios_pago[a.getIn(['factura_compra_directa','medio_pago'])]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["q" /* formatcoin */])(a.getIn(['factura_compra_directa','valor_compra']),divisa.simbolo)),a.getIn(['factura_compra_directa','adjunto_id'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:function onClick(){return _this2.props.downloadFile(a.getIn(['factura_compra_directa','adjunto','id']),a.getIn(['factura_compra_directa','adjunto','nombre']));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+a.getIn(['factura_compra_directa','adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,a.getIn(['factura_compra_directa','adjunto'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+a.getIn(['factura_compra_directa','adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'not-allowed'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},'Archivo sin adjuntar'))));});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalCreateCompraDirecta__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return CompraDirecta;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state,ownProps){return{id:state.solicitudBI.get('id'),solicitudBI:state.solicitudBI.get('solicitud'),enums:state.common.get('enums').toJS(),divisas:state.common.getIn(['parametros','DIVISAS'])};}function mapDispatchToProps(dispatch){return{displayModalCompraDirecta:function displayModalCompraDirecta(show,title,bien_id,cotizacion){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["m" /* displayModalCompraDirecta */])(show,title,bien_id,cotizacion));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["h" /* downloadFile */])(id,filename));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CompraDirecta));

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreateCompraDirecta=function(_Component){_inherits(ModalCreateCompraDirecta,_Component);function ModalCreateCompraDirecta(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreateCompraDirecta);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreateCompraDirecta.__proto__||Object.getPrototypeOf(ModalCreateCompraDirecta)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(path){var columns=[{id:2,caption:'Nombre',value:'nombre',width:'100%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1',payload);};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores_externos',fn);},_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreateCompraDirecta');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateCompraDirecta .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCompraDirecta(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreateCompraDirecta,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreateCompraDirecta=_props.modalCreateCompraDirecta,updateInputs=_props.updateInputs;if(!modalCreateCompraDirecta.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalCreateCompraDirecta',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.createOrUpdateCompraDirecta();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:modalCreateCompraDirecta.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreateCompraDirecta.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'70vw',height:'60vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Producto comprado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',defaultValue:modalCreateCompraDirecta.get('bien_descripcion'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',defaultValue:modalCreateCompraDirecta.get('bien_cantidad'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccionar proveedor existente'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__["a" /* default */],{value:modalCreateCompraDirecta.getIn(['data','proveedor','nombre'])||'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('modalCreateCompraDirecta.data.proveedor');},onReset:function onReset(){return _this2.props.updateInputs('modalCreateCompraDirecta.data.proveedor',null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Proveedor nuevo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','razon_social']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.razon_social',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'No. Factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','no_factura']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.no_factura',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Fecha Compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','fecha_compra']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.fecha_compra',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Forma de Pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:modalCreateCompraDirecta.getIn(['data','medio_pago']),className:'form-control input-sm',onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.medio_pago',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Seleccione forma de pago'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'tarjeta_debito'},'Tarjeta d\xE9bito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'tarjeta_credito'},'Tarjeta cr\xE9dito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'caja_menor'},'Caja menor')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'',className:'control-label'},'Valor compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalCreateCompraDirecta.getIn(['data','valor_compra']),onChange:function onChange(e){return updateInputs('modalCreateCompraDirecta.data.valor_compra',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Adjuntar factura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',modalCreateCompraDirecta.getIn(['data','adjunto','file'])?modalCreateCompraDirecta.getIn(['data','adjunto','file']).name:' Seleccione un archivo...')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFileCompraDirecta('modalCreateCompraDirecta.data.adjunto');}}));}}]);return ModalCreateCompraDirecta;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalCreateCompraDirecta:state.solicitudBI.get('modalCreateCompraDirecta'),enums:state.common.get('enums').toJS(),documento_origen:state.solicitudBI.getIn(['solicitud','documento_origen'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["q" /* selectFromSelector */])(type,payload));},displayModalCompraDirecta:function displayModalCompraDirecta(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["m" /* displayModalCompraDirecta */])(show,title,mode));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFileCompraDirecta:function addFileCompraDirecta(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["d" /* addFileCompraDirecta */])(path));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["F" /* updateInputs */])(path,value,immutable));},createOrUpdateCompraDirecta:function createOrUpdateCompraDirecta(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudbi__["k" /* createOrUpdateCompraDirecta */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreateCompraDirecta));

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_creacioncontratoanual__ = __webpack_require__(636);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreacionContratoAnual=function(_Component){_inherits(CreacionContratoAnual,_Component);function CreacionContratoAnual(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreacionContratoAnual);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreacionContratoAnual.__proto__||Object.getPrototypeOf(CreacionContratoAnual)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(list){var columns=[{id:1,caption:'Nit',value:'identificacion',width:'30%'},{id:2,caption:'Razon Social',value:'nombre',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL',payload);};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreacionContratoAnual,[{key:'render',value:function render(){var _this2=this;var _props=this.props,creacioncontratoanual=_props.creacioncontratoanual,enums=_props.enums;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.createContratoAnual();},title:'Guardar',disabled:creacioncontratoanual.get('btnSaveDisabled')})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Layout_Box__["a" /* default */],{title:'Solicitud de contrato anual > Creaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('fullname')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('email')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('extension')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.getIn(['area','nombre'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacioncontratoanual.get('tipo')].responsable.fullname||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:enums.solicitudes.tipos[creacioncontratoanual.get('tipo')].responsable.email||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacioncontratoanual.get('tipo')].responsable.extension||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY/MM/DD'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxSection__["a" /* default */],{title:'Datos del contrato'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de servicio a desarrollar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.get('proyecto_evento')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proyecto_evento',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Inicio del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:creacioncontratoanual.get('fecha_inicio')||'',onChange:function onChange(e){return _this2.props.updateInputs('fecha_inicio',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Terminaci\xF3n del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',value:creacioncontratoanual.get('fecha_entrega')||'',className:'form-control input-sm',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxSection__["a" /* default */],{title:'Datos del proveedor/contratista'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre de raz\xF3n social'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Shared_SelectorInput__["a" /* default */],{value:creacioncontratoanual.get('proveedor')?creacioncontratoanual.getIn(['proveedor','nombre']):'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('proveedor');},onReset:function onReset(){return _this2.props.updateInputs('proveedor',null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','identificacion'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.identificacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre del representante legal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','representante'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.representante',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'C.C. del representante legal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','cc_representante'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.cc_representante',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Persona de contacto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','contacto'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.contacto',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cargo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','cargo'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.cargo',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo electr\xF3nico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','correo'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.correo',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular/Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','telefono'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.telefono',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Direcci\xF3n para env\xEDo de notificaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:creacioncontratoanual.getIn(['proveedor','direccion'])||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('proveedor.direccion',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:creacioncontratoanual.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('observaciones',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shared_AttachedFilesBox__["a" /* default */],{files:creacioncontratoanual.get('adjuntos'),updateInputs:this.props.updateInputs,obj:creacioncontratoanual,check:'solicitud',disabledAttach:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return CreacionContratoAnual;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.common.get('user'),creacioncontratoanual:state.creacioncontratoanual,enums:state.common.get('enums').toJS(),responsable:state.common.getIn(['parametros','SOLICITUDES'])?state.common.getIn(['parametros','SOLICITUDES']).filter(function(x){return x.get('TIPO_SOLICITUD')==state.creacionsolicitudhoteles.get('tipo');}).first():null};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_creacioncontratoanual__["b" /* updateInputs */])(path,value));},createContratoAnual:function createContratoAnual(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_creacioncontratoanual__["a" /* createContratoAnual */])());},showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["q" /* selectFromSelector */])(type,payload));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CreacionContratoAnual));

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initReducer */
/* harmony export (immutable) */ __webpack_exports__["b"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["a"] = createContratoAnual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(3);
function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_337" /* REINICIAR_SOLICITUD_CONTRATOANUAL */]});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__types__["_212" /* MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL */],payload:{path:path,value:value}});};}function createContratoAnual(){var axios=Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_92" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_4__types__["_92" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL */],payload:false});};var fn2=function fn2(d){return d(initReducer());};fn0(dispatch);var data=getState().creacioncontratoanual.toJS();axios.post(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* API_URL */]+'/solicitudes/contratos-anuales',data).then(function(res){var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_5__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success('La solicitud ha sido guardada exitosamente',{bodyClassName:'toastify-content toastify-success'});};fn1(dispatch);fn3();fn4();fn2(dispatch);}).catch(function(err){console.log(err);Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});};}

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContratoAnual_General__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContratoAnual_Documentos__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContratoAnual_Cancelacion__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContratoAnual_ModalAddFirmas__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_contratoanual__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContratoAnual=function(_Component){_inherits(ContratoAnual,_Component);function ContratoAnual(props){_classCallCheck(this,ContratoAnual);var _this=_possibleConstructorReturn(this,(ContratoAnual.__proto__||Object.getPrototypeOf(ContratoAnual)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea rechazar esta solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.cancelSolicitud();});};_this.state={tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ContratoAnual_General__["a" /* default */],null),estado:0},{id:1,caption:'Documentos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ContratoAnual_Documentos__["a" /* default */],null),estado:1},{id:2,caption:'Rechazar',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ContratoAnual_Cancelacion__["a" /* default */],null),estado:0}],selected:0};return _this;}_createClass(ContratoAnual,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){this.props.getSolicitud(this.props.match.params.id);}else{__WEBPACK_IMPORTED_MODULE_10__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes');}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,estado=_props.estado,btnRComprasDisabled=_props.btnRComprasDisabled,solicitud=_props.solicitud;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'floppy-o',onClick:function onClick(){return _this2.cancel();},title:'Rechazar solicitud',disabled:estado>4||estado===0||selected!==2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'user',onClick:function onClick(){return _this2.props.canmbiarResponsable(solicitud,'ACTUALIZAR_SOLICITUD_CONTRATOANUAL');},title:'Cambiar responsable',disabled:btnRComprasDisabled||selected!==0})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){return x.estado<=estado;}).map(function(x){//if ((estado == 0) && (x.id == 1)) return null
//if ((estado == 7) && (x.id == 2)) return null
if(estado>4&&x.id==2)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li01['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ContratoAnual_ModalAddFirmas__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return ContratoAnual;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{estado:state.contratoanual.get('estado'),btnRComprasDisabled:state.contratoanual.get('btnRComprasDisabled'),solicitud:state.contratoanual.get('solicitud')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_contratoanual__["e" /* getSolicitud */])(id));},cancelSolicitud:function cancelSolicitud(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_contratoanual__["a" /* cancelSolicitud */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},canmbiarResponsable:function canmbiarResponsable(solicitud,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["b" /* canmbiarResponsable */])(solicitud,type));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ContratoAnual));

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_contratoanual__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var General=function(_Component){_inherits(General,_Component);function General(){var _ref;var _temp,_this,_ret;_classCallCheck(this,General);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=General.__proto__||Object.getPrototypeOf(General)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/auxiliares',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(General,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,contratoanual=_props.contratoanual;if(!id)return null;var documento=contratoanual.getIn(['documentos',0]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:contratoanual.getIn(['solicitante','fullname'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:contratoanual.getIn(['solicitante','email'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:contratoanual.getIn(['solicitante','extension'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:contratoanual.getIn(['solicitante','area','nombre'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',contratoanual.get('responsable_compras'))&&contratoanual.get('estado')!=0&&contratoanual.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_SelectorInput__["a" /* default */],{value:contratoanual.getIn(['responsable_compras','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.responsable_compras');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.responsable_compras',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:contratoanual.getIn(['responsable_compras','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:contratoanual.getIn(['responsable_compras','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:contratoanual.getIn(['responsable_compras','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(contratoanual.get('created_at')).format('DD/MM/YYYY')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:contratoanual.get('id')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Datos del contrato'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de servicio a desarrollar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:contratoanual.get('proyecto_evento')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Inicio del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_inicio')).format('DD/MM/YYYY')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Terminaci\xF3n del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(documento.get('fecha_entrega')).format('DD/MM/YYYY')||'',className:'form-control input-sm',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Datos del proveedor/contratista'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre de raz\xF3n social'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','nombre'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','identificacion'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre del representante legal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','representante'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'C.C. del representante legal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','cc_representante'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Persona de contacto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','contacto'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cargo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','cargo'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo electr\xF3nico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','correo'])||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular/Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','telefono'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Direcci\xF3n para env\xEDo de notificaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:documento.getIn(['proveedore','direccion'])||'',className:'form-control input-sm',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:contratoanual.get('observaciones')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_AttachedFilesBox__["a" /* default */],{files:contratoanual.get('adjuntos'),root:'solicitud',removeFiles:this.props.removeFiles,updateInputs:this.props.updateInputs,obj:contratoanual,check:'solicitud',disabledAttach:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return General;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.contratoanual.get('id'),contratoanual:state.contratoanual.get('solicitud')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_contratoanual__["e" /* getSolicitud */])(id));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["q" /* selectFromSelector */])(type,payload));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(General));

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContratoAnual_ModalCreateDocumento__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContratoAnual_ModalSummaryDocumento__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_contratoanual__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_documentos__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Documentos=function(_Component){_inherits(Documentos,_Component);function Documentos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Documentos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Documentos.__proto__||Object.getPrototypeOf(Documentos)).call.apply(_ref,[this].concat(args))),_this),_this.buttonOption=function(documento,index){if(documento.getIn(['aprobacion','estado'])===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'binoculars',onClick:function onClick(){return _this.props.showHideModalSummary(true,documento.get('id'),'solicitudes/contratos-anuales/'+_this.props.id,'ACTUALIZAR_SOLICITUD_CONTRATOANUAL');}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',onClick:function onClick(){return _this.props.displayModalCreateDocumento(true,'Documento',index);},disabled:!Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',_this.props.contratoanual)||documento.get('estado')===0||documento.get('estado')===2});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Documentos,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,contratoanual=_props.contratoanual,enums=_props.enums;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Tipo documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Estado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Inicio del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Terminaci\xF3n del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo de servicio a desarrollar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,contratoanual.get('documentos').map(function(a,b){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr4['+a.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},_this2.buttonOption(a,b)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.get('consecutivo')?enums.documentos.tipos[a.get('tipo')].PREFIJO+a.get('consecutivo'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,a.getIn(['proveedore','nombre'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.tipos[a.get('tipo')]?enums.documentos.tipos[a.get('tipo')].NOMBRE:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,enums.documentos.estados[a.get('estado')]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_inicio')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_inicio')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},a.get('fecha_entrega')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.get('fecha_entrega')).format('YYYY-MM-DD'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,contratoanual.get('proyecto_evento')));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ContratoAnual_ModalCreateDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ContratoAnual_ModalSummaryDocumento__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Documentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.contratoanual.get('id'),contratoanual:state.contratoanual.get('solicitud'),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode,indexDocumento){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_contratoanual__["d" /* displayModalCreateDocumento */])(show,title,mode,indexDocumento));},showHideModalSummary:function showHideModalSummary(show,id,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_documentos__["k" /* showHideModalSummary */])(show,id,url,type));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Documentos));

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_contratoanual__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCreateDocumento=function(_Component){_inherits(ModalCreateDocumento,_Component);function ModalCreateDocumento(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCreateDocumento);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCreateDocumento.__proto__||Object.getPrototypeOf(ModalCreateDocumento)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalCreateDocumento');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalCreateDocumento .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalCreateDocumento(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCreateDocumento,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalCreateDocumento=_props.modalCreateDocumento,enums=_props.enums,docs_vigentes=_props.docs_vigentes;var readOnly=docs_vigentes.count()>0;if(!modalCreateDocumento.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Modal__["a" /* default */],{id:'modalCreateDocumento',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__["a" /* default */],{title:modalCreateDocumento.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'eye',onClick:function onClick(e){e.preventDefault();_this2.props.previewDocumento(modalCreateDocumento.getIn(['data','id']));},disabled:modalCreateDocumento.get('btnDisabled'),title:' Visualizar el documento antes de enviar a aprobaci\xF3n del proveedor'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'floppy-o',disabled:modalCreateDocumento.get('btnDisabled'),title:'Guardar y enviar al proveedor',onClick:function onClick(e){e.preventDefault();_this2.props.createOrUpdateDocumento();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'80vw',height:'70vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('colgroup',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{width:'35%',color:'#333',fontWeight:'bold'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('col',{style:{}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].NOMBRE:'PENDIENTE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'N\xFAmero documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,(modalCreateDocumento.getIn(['data','tipo'])?enums.documentos.tipos[modalCreateDocumento.getIn(['data','tipo'])].PREFIJO:'PENDIENTE')+(modalCreateDocumento.getIn(['data','consecutivo'])||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalCreateDocumento.getIn(['data','proveedore','nombre'])))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione el tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','tipo'])||0,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.tipo',e.target.value);},disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opcion'),Object.keys(enums.documentos.tipos).map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a+']',value:a},enums.documentos.tipos[a].NOMBRE);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Inicio del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_inicio'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalCreateDocumento.data.fecha_inicio',e.target.value);},disabled:readOnly}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Terminaci\xF3n del contrato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_3_moment___default()(modalCreateDocumento.getIn(['data','fecha_entrega'])).format('YYYY-MM-DD')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione la plantilla del documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalCreateDocumento.getIn(['data','plantilla_id'])||0,onChange:function onChange(e){_this2.props.updateInputs('modalCreateDocumento.data.plantilla_id',e.target.value);},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opcion'),modalCreateDocumento.get('plantillas').filter(function(a){return a.get('tipo')===Number(modalCreateDocumento.getIn(['data','tipo']));}).map(function(a){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+a.get('id')+']',value:a.get('id')},a.get('nombre'));}))))),modalCreateDocumento.getIn(['data','aprobacion','observaciones'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones del proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,defaultValue:modalCreateDocumento.getIn(['data','aprobacion','observaciones'])||'',disabled:true})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalCreateDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,onwProps){return{modalCreateDocumento:state.contratoanual.get('modalCreateDocumento'),enums:state.common.get('enums').toJS(),docs_vigentes:state.contratoanual.getIn(['solicitud','documentos']).filter(function(x){return x.get('estado')==12;})};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalCreateDocumento:function displayModalCreateDocumento(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_contratoanual__["d" /* displayModalCreateDocumento */])(show,title,mode));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_contratoanual__["i" /* updateInputs */])(path,value,immutable));},createOrUpdateDocumento:function createOrUpdateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_contratoanual__["c" /* createOrUpdateDocumento */])());},previewDocumento:function previewDocumento(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_contratoanual__["f" /* previewDocumento */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalCreateDocumento));

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Documentos_Contrato__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Documentos_Cancelacion__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import DocumentosFirmados from '../Documentos/DocumentosFirmados'
var ModalSummary=function(_Component){_inherits(ModalSummary,_Component);function ModalSummary(props){_classCallCheck(this,ModalSummary);var _this=_possibleConstructorReturn(this,(ModalSummary.__proto__||Object.getPrototypeOf(ModalSummary)).call(this,props));_this.handleCloseModal=function(){var modal=document.getElementById('modalSummary');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSummary .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');_this.setState({maximised:false,selected:0});setTimeout(function(){return _this.props.showHideModalSummary(false);},300);};_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar este documento?',function(){_this.props.showModalConfirmarAccion(false);_this.props.cancelDocumento();});};_this.renew=function(result){if(result==1)_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea renovar este contrato?',function(){_this.props.showModalConfirmarAccion(false);_this.props.renewContrato(1);});else _this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea no renovar este contrato?',function(){_this.props.showModalConfirmarAccion(false);_this.props.renewContrato(0);});};var tabs=[{id:0,caption:'Documento',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Documentos_Contrato__["a" /* default */],null),estado:0},{id:1,caption:'Cierre',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Documentos_Cancelacion__["a" /* default */],null),estado:0}];_this.state={tabs:[].concat(tabs),selected:0,maximised:false};return _this;}_createClass(ModalSummary,[{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected,maximised=_state.maximised;var _props=this.props,modalSummary=_props.modalSummary,enums=_props.enums,solicitud=_props.solicitud;if(!modalSummary.get('show')){return null;}var documento=modalSummary.get('data');var id=documento.get('id');var docs_en_espera=solicitud.get('documentos').filter(function(x){return x.get('id')!=id&&x.get('tipo')==5&&x.get('estado')==13;});var docs_en_proceso=solicitud.get('documentos').filter(function(x){return x.get('id')!=id&&x.get('tipo')==5&&x.get('estado')>0&&x.get('estado')<11;});var enableBtn=true;enableBtn=enableBtn&&__WEBPACK_IMPORTED_MODULE_2_moment___default()().isAfter(new Date().getFullYear()+'-11-30');//enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-02-03`) 
enableBtn=enableBtn&&docs_en_espera.count()==0;enableBtn=enableBtn&&documento.get('estado')==12;enableBtn=enableBtn&&docs_en_proceso.count()==0;var esResponsableCompras=Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalSummary',show:true,ZIndex:2000,draggable:!maximised},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:maximised?'bold':'normal'}},'Documento: '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].NOMBRE+' '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].PREFIJO+modalSummary.getIn(['data','consecutivo'])),onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSummary");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:maximised?'compress':'arrows-alt',title:maximised?'Minimizar':"Maximizar",onClick:function onClick(e){return _this2.setState({maximised:!maximised});}}),this.state.selected===0&&enableBtn&&esResponsableCompras&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'history',title:'Renovar contrato',onClick:function onClick(e){return _this2.renew(1);},disabled:documento.get('estado')==14}),this.state.selected===0&&esResponsableCompras&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'cloud-upload',title:'Cerrar solicitud',onClick:function onClick(e){return _this2.props.showHideModalAddFirmas(true,solicitud);},disabled:documento.get('estado')!=3}),this.state.selected===1&&enableBtn&&esResponsableCompras&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'hand-stop-o',title:'No renovar contrato',onClick:function onClick(e){return _this2.renew(0);},disabled:documento.get('estado')==14}),this.state.selected===1&&esResponsableCompras&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'ban',title:'Cancelar contrato',onClick:function onClick(e){return _this2.cancel();},disabled:documento.get('estado')==0||documento.get('estado')==14})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.maximised?'modal-100-100':'modal-80-70'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs green'},tabs.filter(function(x){return x.estado<=documento.get('estado');}).map(function(x){if((documento.get('estado')>=3&&documento.get('estado')<12||docs_en_espera.count()>0)&&x.id==1)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSummary:state.documentos.get('modalSummary'),user:state.common.get('user'),enums:state.common.get('enums').toJS(),//documentos_solicitud: state.contratoanual.getIn(['solicitud', 'documentos'])
solicitud:state.contratoanual.get('solicitud')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{closeDocumento:function closeDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__["b" /* closeDocumento */])());},showHideModalSummary:function showHideModalSummary(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_documentos__["k" /* showHideModalSummary */])(state));},showHideModalAddFirmas:function showHideModalAddFirmas(show,solicitud){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__["h" /* showHideModalAddFirmas */])(show,solicitud));},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},cancelDocumento:function cancelDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_documentos__["c" /* cancelDocumento */])());},renewContrato:function renewContrato(result){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_contratoanual__["g" /* renewContrato */])(result));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSummary));

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_contratoanual__ = __webpack_require__(64);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancelacion=function(_Component){_inherits(Cancelacion,_Component);function Cancelacion(){_classCallCheck(this,Cancelacion);return _possibleConstructorReturn(this,(Cancelacion.__proto__||Object.getPrototypeOf(Cancelacion)).apply(this,arguments));}_createClass(Cancelacion,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,contratoanual=_props.contratoanual;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de rechazo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(contratoanual.get('fecha_cancelacion')).format('YYYY-MM-DD')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de rechazo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:contratoanual.get('motivo_cancelacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.motivo_cancelacion',e.target.value);},disabled:contratoanual.get('estado')===0}))))));}}]);return Cancelacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.contratoanual.get('id'),contratoanual:state.contratoanual.get('solicitud')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_contratoanual__["i" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cancelacion));

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ExternosAprobaciones_ModalFilter__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ExternosAprobaciones_ModalSummary__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalDelete__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_externosaprobaciones__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_history__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// export const tableCols = [
//     { id: 1, caption: 'No.', value: 'consecutivo', type: 'string', format: '', width: '6%' },
//     { id: 2, caption: 'Tipo', value: 'tipo', type: 'string', format: '', width: '16%' },
//     { id: 3, caption: 'Estado', value: 'estado', type: 'string', format: '', width: '8%' },
//     { id: 4, caption: 'Fecha inicio', value: 'fecha_inicio', type: 'datetime', format: 'YYYY-MM-DD', width: '15%' },
//     { id: 5, caption: 'Fecha entrega', value: 'fecha_entrega', type: 'datetime', format: 'YYYY-MM-DD', width: '15%' },
//     { id: 6, caption: 'Solicitante', value: 'solicitante', type: 'string', format: '', width: '20%' },
//     { id: 7, caption: 'Responsable compras', value: 'responsable_compras', type: 'string', format: '', width: '20%' },
// ]
function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_12__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.documentos.estados[value];}else if(c.value==='tipo'){value=enums.documentos.tipos[value].NOMBRE;}else if(c.value==='consecutivo'){value=enums.documentos.tipos[x.get('tipo')].PREFIJO+value;}return value;}var ExternosAprobaciones=function(_Component){_inherits(ExternosAprobaciones,_Component);function ExternosAprobaciones(){_classCallCheck(this,ExternosAprobaciones);return _possibleConstructorReturn(this,(ExternosAprobaciones.__proto__||Object.getPrototypeOf(ExternosAprobaciones)).apply(this,arguments));}_createClass(ExternosAprobaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getAprobaciones(1);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,aprobaciones=_props.aprobaciones,orderBy=_props.orderBy,page=_props.page,totalRecords=_props.totalRecords,showRecords=_props.showRecords,dropdownNuevaSolicitud=_props.dropdownNuevaSolicitud,vista=_props.vista,enums=_props.enums,enumdocumentos=_props.enumdocumentos;var tableCols=[{id:1,caption:'No.',value:'consecutivo',type:'string',format:'',width:'6%'},{id:2,caption:'Tipo',value:'tipo',type:'string',format:'',width:'16%',enums:Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["o" /* extractKeyValue */])(enumdocumentos.get('tipos'),'NOMBRE')},{id:3,caption:'Estado',value:'estado',type:'string',format:'',width:'8%',enums:Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["o" /* extractKeyValue */])(enumdocumentos.get('estados'))},{id:4,caption:'Fecha inicio',value:'fecha_inicio',type:'datetime',format:'YYYY-MM-DD',width:'15%'},{id:5,caption:'Fecha entrega',value:'fecha_entrega',type:'datetime',format:'YYYY-MM-DD',width:'15%'},{id:6,caption:'Solicitante',value:'solicitante',type:'string',format:'',width:'20%'},{id:7,caption:'Responsable compras',value:'responsable_compras',type:'string',format:'',width:'20%'}];var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.getAprobaciones(__WEBPACK_IMPORTED_MODULE_15__utils_history__["a" /* default */].location.pathname,pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-right'})});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Listado de documentos por aprobar',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-aprobaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23px'}}),tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,aprobaciones.filter(function(x){return x.get('visible');}).count()>0?aprobaciones.filter(function(x){return x.get('visible');}).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{size:12,name:'binoculars',onClick:function onClick(){return _this2.props.showHideModalSummary(true,x.get('id'));}})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format);alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_15__utils_history__["a" /* default */].push(window.FOLDER+('/aprobaciones/'+enums.aprobaciones.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ExternosAprobaciones_ModalFilter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ExternosAprobaciones_ModalSummary__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalDelete__["a" /* default */],null));}}]);return ExternosAprobaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{aprobaciones:state.externosaprobaciones.get('aprobaciones'),orderBy:state.externosaprobaciones.get('orderBy'),totalRecords:state.externosaprobaciones.get('totalRecords'),showRecords:state.externosaprobaciones.get('showRecords'),page:state.externosaprobaciones.get('page'),enums:state.common.get('enums').toJS(),enumdocumentos:state.common.getIn(['enums','documentos'])};}function mapDispatchToProps(dispatch){return{getAprobaciones:function getAprobaciones(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_externosaprobaciones__["e" /* getAprobaciones */])(page));},filterAprobaciones:function filterAprobaciones(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_externosaprobaciones__["d" /* filterAprobaciones */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_externosaprobaciones__["h" /* setOrderBy */])(field));},changeRecordsToShow:function changeRecordsToShow(records){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_externosaprobaciones__["c" /* changeRecordsToShow */])(records));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_externosaprobaciones__["i" /* showHideModalFilter */])(state,tableCols));},showHideModalSummary:function showHideModalSummary(show,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_externosaprobaciones__["j" /* showHideModalSummary */])(show,index));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ExternosAprobaciones));

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { tableCols } from '../../containers/ExternosAprobaciones'
var ModalFilter=function(_Component){_inherits(ModalFilter,_Component);function ModalFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalFilter.__proto__||Object.getPrototypeOf(ModalFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalFilter');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalFilter .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalFilter(false);},300);},_this.handleApplyFilters=function(e){_this.handleCloseModal();_this.props.applyFilterCriterias();},_this.showTypeInput=function(index,item){var _this$props=_this.props,modalFilter=_this$props.modalFilter,updateModalFilterCriteria=_this$props.updateModalFilterCriteria;var tableCols=modalFilter.get('columnas');var value=modalFilter.getIn(['filters',index,'column']);var col=tableCols.filter(function(c){return c.get('value')==value;}).first();if(col.get('enums')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}},col.get('enums').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+index+']['+n+']',value:x.get('value')},x.get('text'));}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalFilter,[{key:'render',value:function render(){var _this2=this;var modalFilter=this.props.modalFilter;if(!modalFilter.get('show')){return null;}var tableCols=modalFilter.get('columnas');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalFilter',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Filtro',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalFilter");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus',onClick:function onClick(e){return _this2.props.addModalFilterCriteria();},title:'Aceptar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'trash',onClick:function onClick(e){return _this2.props.removeCheckedModalFilterCriterias();},disabled:modalFilter.get('filters').filter(function(item){return item.get('checked');}).count()===0,title:'Eliminar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',onClick:function onClick(e){return _this2.handleApplyFilters();},title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12',style:{height:'200px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Columna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Operador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Filtro'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalFilter.get('filters').count()>0?modalFilter.get('filters').map(function(item,index){var key='tr2['+index+']';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key,className:''+(item.get('checked')?'info':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.props.toggleCheckedModalFilterCriterias(index,e.target.checked);},checked:item.get('checked')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('column'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'column',e.target.value);}},tableCols.map(function(x1,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+x1.get('id')+']['+n1+']',value:x1.get('value')},x1.get('caption'));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('operator'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'operator',e.target.value);}},__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["H" /* operators */].filter(function(x){return x.comparisons.includes(item.get('comparison'));}).map(function(item1,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+item1.id+']['+n+']',value:item1.value},item1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.showTypeInput(index,item)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',style:{textAlign:'center'}},'No hay filtros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalFilter:state.externosaprobaciones.get('modalFilter')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["i" /* showHideModalFilter */])(state));},addModalFilterCriteria:function addModalFilterCriteria(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["a" /* addModalFilterCriteria */])());},removeCheckedModalFilterCriterias:function removeCheckedModalFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["g" /* removeCheckedModalFilterCriterias */])());},toggleCheckedModalFilterCriterias:function toggleCheckedModalFilterCriterias(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["k" /* toggleCheckedModalFilterCriterias */])(index,checked));},updateModalFilterCriteria:function updateModalFilterCriteria(index,attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["m" /* updateModalFilterCriteria */])(index,attr,value));},applyFilterCriterias:function applyFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["b" /* applyFilterCriterias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalFilter));

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSummary=function(_Component){_inherits(ModalSummary,_Component);function ModalSummary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalSummary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalSummary.__proto__||Object.getPrototypeOf(ModalSummary)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('modalSummary');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSummary .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalSummary(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalSummary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalSummary=_props.modalSummary,enums=_props.enums;if(!modalSummary.get('show')){return null;}var adjunto=modalSummary.getIn(['data','adjuntos']).filter(function(a){return a.get('documento_id')!=null;}).last();var fileid=adjunto?adjunto.get('id'):null;var filename=adjunto?adjunto.get('nombre'):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalSummary',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Resumen del documento '+enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].NOMBRE+' '+modalSummary.getIn(['data','consecutivo']),onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSummary");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',title:'Aprobar',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Al hacer click en el bot\xF3n Ok, estar\xE1 aprobando las condiciones del documento.',function(){_this2.props.showHideModalDelete(false);_this2.handleCloseModal();_this2.props.registerApprovalResult(modalSummary.getIn(['data','id']),2);});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'ban',title:'Rechazar',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Al hacer click en el bot\xF3n Ok, estar\xE1 rechazando el documento para ser corregido.',function(){_this2.props.showHideModalDelete(false);_this2.handleCloseModal();_this2.props.registerApprovalResult(modalSummary.getIn(['data','id']),1);});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'800px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:enums.documentos.tipos[modalSummary.getIn(['data','tipo'])].NOMBRE,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'N\xFAmero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','consecutivo']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descargar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:adjunto?function(){return _this2.props.downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' ',adjunto?filename:'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','solicitude','solicitante','fullname']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','solicitude','responsable_compras','fullname']),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalSummary.getIn(['data','observaciones']),onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.observaciones',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSummary:state.externosaprobaciones.get('modalSummary'),enums:state.common.get('enums').toJS()};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalSummary:function showHideModalSummary(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["j" /* showHideModalSummary */])(state));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["u" /* showHideModalDelete */])(open,message,action));},registerApprovalResult:function registerApprovalResult(id,result){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["f" /* registerApprovalResult */])(id,result));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["h" /* downloadFile */])(id,filename));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externosaprobaciones__["l" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSummary));

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorAirport__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__ = __webpack_require__(256);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreacionTiquetesAereo=function(_Component){_inherits(CreacionTiquetesAereo,_Component);function CreacionTiquetesAereo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreacionTiquetesAereo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreacionTiquetesAereo.__proto__||Object.getPrototypeOf(CreacionTiquetesAereo)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/cencos',fn);},_this.handleOpenSelectorAddCenco=function(list,index){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){var index=_this.props.creaciontiqueteaereo.get('cencos').findIndex(function(c){return c.getIn(['cenco','id'])==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO',payload);}};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.creaciontiqueteaereo.getIn(['cencos',index,'responsable','id']),comparison:'string'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_this.handleOpenSelectorAddPasajero=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addPasajero(payload);});};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);},_this.handleOpenSelectorUbicacionOrigen=function(path){var columns=[{id:1,caption:'Código',value:'code',width:'30%'},{id:2,caption:'Nombre',value:'name',width:'35%'},{id:3,caption:'País',value:'country_name',width:'35%'}];var payload={};var fn=function fn(a,query){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addOrigen(payload,query);});};_this.props.showModalSelectorUrlAirports('Listado de aeropuertos',columns,'/aeropuertos',fn);},_this.handleOpenSelectorUbicacionDestino=function(path){var columns=[{id:1,caption:'Código',value:'code',width:'30%'},{id:2,caption:'Nombre',value:'name',width:'35%'},{id:3,caption:'País',value:'country_name',width:'35%'}];var payload={};var fn=function fn(a,query){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addDestino(payload,query);});};_this.props.showModalSelectorUrlAirports('Listado de aeropuertos',columns,'/aeropuertos',fn);},_this.handleAeropuerto=function(index,tipo,value){if(tipo==='origen'){_this.props.updateInputs('trayectos.'+index+'.origen',value);_this.props.updateInputs('trayectos.'+index+'.aeropuerto_origen',value);}if(tipo==='destino'){_this.props.updateInputs('trayectos.'+index+'.destino',value);_this.props.updateInputs('trayectos.'+index+'.aeropuerto_destino',value);}},_this.onResetAeropuerto=function(tipo,index){if(tipo=='origen'){_this.props.updateInputs('trayectos.'+index+'.origen',null);_this.props.updateInputs('trayectos.'+index+'.aeropuerto_origen',null);}if(tipo=='destino'){_this.props.updateInputs('trayectos.'+index+'.destino',null);_this.props.updateInputs('trayectos.'+index+'.aeropuerto_destino',null);}},_this.getTotalDias=function(index){var creaciontiqueteaereo=_this.props.creaciontiqueteaereo;var fecha_salida=creaciontiqueteaereo.getIn(['pasajeros',index,'asistencia','fecha_salida']);var fecha_regreso=creaciontiqueteaereo.getIn(['pasajeros',index,'asistencia','fecha_regreso']);if(!fecha_salida||!fecha_regreso)return 0;return Math.abs(__WEBPACK_IMPORTED_MODULE_2_moment___default()(fecha_regreso).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(fecha_salida),'days'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreacionTiquetesAereo,[{key:'render',value:function render(){var _this2=this;var _props=this.props,creaciontiqueteaereo=_props.creaciontiqueteaereo,enums=_props.enums;var tipo_viaje=creaciontiqueteaereo.get('tipo_viaje');var asistencia_vajero=creaciontiqueteaereo.get('asistencia_viajero');var tipo_trayecto=creaciontiqueteaereo.get('tipo_trayecto');var tipos_identificacion=enums.tipos_identificacion;var flagAdjunto=creaciontiqueteaereo.get('flagAdjunto');// let openModal = "";
var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.createTiqueteAereo();},title:'Guardar'})];var accionesTrayectos=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',title:'Adicionar trayecto',onClick:function onClick(){return _this2.props.addTrayecto();},disabled:creaciontiqueteaereo.get('tipo_trayecto')!=3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',title:'Eliminar trayecto',onClick:function onClick(){return _this2.props.removeTrayectos();},danger:true,disabled:creaciontiqueteaereo.get('tipo_trayecto')!=3})];var actionsDistribucionCencos=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[2][0]',size:14,contrast:true,name:'plus-circle',title:'Nuevo',onClick:function onClick(){return _this2.props.addCencoSolicitud();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[2][1]',size:14,contrast:true,name:'trash',title:'Eliminar',onClick:function onClick(){return _this2.props.removeCenco();},danger:true})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Solicitud de tiquete a\xE9reo > Creaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('fullname')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('email')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('extension')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.getIn(['area','nombre'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creaciontiqueteaereo.get('tipo')].responsable.fullname||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:enums.solicitudes.tipos[creaciontiqueteaereo.get('tipo')].responsable.email||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creaciontiqueteaereo.get('tipo')].responsable.extension||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY/MM/DD'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del viaje'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo del viaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:creaciontiqueteaereo.get('motivo_viaje')||'',onChange:function onChange(e){return _this2.props.updateInputs('motivo_viaje',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de viaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:creaciontiqueteaereo.get('tipo_viaje')||'',onChange:function onChange(e){return _this2.props.updateInputs('tipo_viaje',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Nacional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Internacional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de trayectoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:creaciontiqueteaereo.get('tipo_trayecto')||'',onChange:function onChange(e){return _this2.props.updateInputs('tipo_trayecto',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Ida y vuelta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Solo ida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Multiples ciudades')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad de pasajeros'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'number',min:'1',value:creaciontiqueteaereo.get('cant_pasajeros')||'',onChange:function onChange(e){return _this2.props.updateInputs('cant_pasajeros',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'22px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'assist',value:asistencia_vajero,onChange:function onChange(e){return _this2.props.updateInputs('asistencia_viajero',e.target.checked);},disabled:creaciontiqueteaereo.get('tipo_viaje')==1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{margin:'0 0 0 7px'},className:'control-label',htmlFor:'assist'},'Asistencia al viajero'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Trayectos',actions:accionesTrayectos},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Origen'),creaciontiqueteaereo.get('tipo_trayecto')==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'13%'}},'Fecha'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Hora')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'13%'}},'Fecha ida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Hora ida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Destino'),creaciontiqueteaereo.get('tipo_trayecto')==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'13%'}},'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Hora regreso')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creaciontiqueteaereo.get('trayectos').map(function(t,i){// let origen = t.get('origen') && t.get('aeropuerto_origen') ? `${t.get('origen')}-${t.get('aeropuerto_origen')}` : ''
// let destino = t.get('destino') && t.get('aeropuerto_destino') ? `${t.get('destino')}-${t.get('aeropuerto_destino')}` : ''
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:t.get('guid'),className:t.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},value:t.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('trayectos.'+i+'.selected',e.target.value);},disabled:i==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:t.get('origen')?t.get('origen')+' '+t.get('aeropuerto_origen'):'',onClick:function onClick(){return _this2.handleOpenSelectorUbicacionOrigen('trayectos.'+i);},onReset:function onReset(){return _this2.onResetAeropuerto('origen',i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_ida')||'',onChange:function onChange(e){return _this2.props.updateInputs('trayectos.'+i+'.fecha_ida',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'time',value:t.get('hora_ida')||'',onChange:function onChange(e){return _this2.props.updateInputs('trayectos.'+i+'.hora_ida',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:t.get('destino')?t.get('destino')+' '+t.get('aeropuerto_destino'):'',onClick:function onClick(){return _this2.handleOpenSelectorUbicacionDestino('trayectos.'+i);},onReset:function onReset(){return _this2.onResetAeropuerto('destino',i);}})),creaciontiqueteaereo.get('tipo_trayecto')==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_regreso')||'',onChange:function onChange(e){return _this2.props.updateInputs('trayectos.'+i+'.fecha_regreso',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'time',value:t.get('hora_regreso')||'',onChange:function onChange(e){return _this2.props.updateInputs('trayectos.'+i+'.hora_regreso',e.target.value);}}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n de centros de costos',actions:actionsDistribucionCencos},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ordenador del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Centro de costo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creaciontiqueteaereo.get('cencos').count()>0?creaciontiqueteaereo.get('cencos').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+(x.get('id')?x.get('id'):x.get('guid'))+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:x.getIn(['responsable','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('cencos.'+n+'.responsable');},onReset:function onReset(){return _this2.props.updateInputs('cencos.'+n+'.responsable',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('responsable')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:x.get('cenco')?x.getIn(['cenco','codigo']):'',onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('cencos.'+n+'.cenco',n);},onReset:function onReset(){return _this2.props.updateInputs('cencos.'+n+'.cenco',null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',placeholder:'Seleccione un responsable del cenco',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.get('porcentaje')?x.get('porcentaje'):0,onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.porcentaje',e.target.value);},disabled:x.get('responsable')==null})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6,style:{textAlign:'center'}},'Para agregar un centro de costo haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{name:'plus-circle'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:creaciontiqueteaereo.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('observaciones',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__["a" /* default */],{files:creaciontiqueteaereo.get('adjuntos'),removeFiles:this.props.removeSolicitudTiqutesAereos,updateInputs:this.props.updateInputs,obj:creaciontiqueteaereo,check:'solicitud'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Pasajeros'},creaciontiqueteaereo.get('pasajeros').map(function(p,i){var mode=p.get('pasaporte_adjunto')?'edit':'create';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'Fragment['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Pasajero #'+(i+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Información del pasajero',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo pasajero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_pasajero'),onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.tipo_pasajero',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Empleado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Invitado')))),p.get('tipo_pasajero')==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre completo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:p.get('fullname')?p.get('fullname'):'',onClick:function onClick(){return _this2.handleOpenSelectorAddPasajero('pasajeros.'+i);},onReset:function onReset(){return _this2.props.updateInputs('pasajeros.'+i,{selected:p.get('selected'),guid:p.get('guid')});}})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nombres')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.nombres',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('apellidos')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.apellidos',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_documento')||1,onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.tipo_documento',e.target.value);}},Object.keys(tipos_identificacion).map(function(key,ikey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt['+i+']['+ikey+']',value:key},tipos_identificacion[key]);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. de Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('cedula')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.cedula',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('celular')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.celular',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha nacimiento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:p.get('fecha_nacimiento')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.fecha_nacimiento',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),p.get('tipo_pasajero')==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('email')||'',disabled:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('correo')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.correo',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nacionalidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nacionalidad')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.nacionalidad',e.target.value);},disabled:tipo_viaje==1})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Pasaporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('pasaporte')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.pasaporte',e.target.value);},disabled:tipo_viaje==1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pa\xEDs expedici\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('pais_expedicion')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.pais_expedicion',e.target.value);},disabled:tipo_viaje==1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha caducidad pasaporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:p.get('fecha_caducidad_pasaporte')||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.fecha_caducidad_pasaporte',e.target.value);},onBlur:function onBlur(e){return _this2.props.validateCaducidadPasaporte(e.target.value);},disabled:tipo_viaje==1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Adjuntar pasaporte pasajero ',i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file '+(tipo_viaje==2?'label-upload-file-enabled':'label-upload-file-disabled'),onClick:tipo_viaje==2?function(){_this2.props.displayModalAddFile(true,'Adjuntar pasaporte',mode,p.get('pasaporte_adjunto'),i);_this2.props.updateInputs('flagAdjunto',true);}:function(){return null;},disabled:tipo_viaje==1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',p.get('pasaporte_adjunto')?p.getIn(['pasaporte_adjunto','nombre']):' Seleccione un archivo...'))))),asistencia_vajero&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Información asistencia de viaje',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pa\xEDs destino'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','pais_destino'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.pais_destino',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:p.getIn(['asistencia','fecha_salida'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.fecha_salida',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:p.getIn(['asistencia','fecha_regreso'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.fecha_regreso',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total d\xEDas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:_this2.getTotalDias(i)||0,disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'En caso de emergencia avisar a:',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres y apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','avisar_a'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.avisar_a',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Direcci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','direccion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.direccion',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','ciudad'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.ciudad',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','celular'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.celular',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','telefono'])||'',onChange:function onChange(e){return _this2.props.updateInputs('pasajeros.'+i+'.asistencia.telefono',e.target.value);},disabled:asistencia_vajero==false}))))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalAddFile__["a" /* default */],{action:function action(){return flagAdjunto?_this2.props.addFile():_this2.props.addFileAdjunto();}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorAirport__["a" /* default */],null));}}]);return CreacionTiquetesAereo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.common.get('user'),creaciontiqueteaereo:state.creaciontiqueteaereo,enums:state.common.get('enums').toJS(),responsable:state.common.getIn(['parametros','SOLICITUDES'])?state.common.getIn(['parametros','SOLICITUDES']).filter(function(x){return x.get('TIPO_SOLICITUD')==state.creaciontiqueteaereo.get('tipo');}).first():null};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["o" /* updateInputs */])(path,value));},addTrayecto:function addTrayecto(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["g" /* addTrayecto */])());},removeTrayectos:function removeTrayectos(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["n" /* removeTrayectos */])());},createTiqueteAereo:function createTiqueteAereo(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["h" /* createTiqueteAereo */])());},displayModalAddFile:function displayModalAddFile(show,title,mode,file,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["g" /* displayModalAddFile */])(show,title,mode,file,index));},updateInputsModalAddFile:function updateInputsModalAddFile(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["C" /* updateInputs */])(path,value));},selectFile:function selectFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["p" /* selectFile */])(file));},addFile:function addFile(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["c" /* addFile */])());},addPasajero:function addPasajero(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["f" /* addPasajero */])(path));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["q" /* selectFromSelector */])(type,payload));},showModalSelectorUrlAirports:function showModalSelectorUrlAirports(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["z" /* showModalSelectorUrlAirports */])(title,fields,url,action,customFilter));},addOrigen:function addOrigen(path,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["e" /* addOrigen */])(path,query));},addDestino:function addDestino(path,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["b" /* addDestino */])(path,query));},addCencoSolicitud:function addCencoSolicitud(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["a" /* addCencoSolicitud */])());},removeCenco:function removeCenco(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["l" /* removeCenco */])());},validateCaducidadPasaporte:function validateCaducidadPasaporte(fecha){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["p" /* validateCaducidadPasaporte */])(fecha));},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["k" /* enviarComentario */])());},eliminarComentario:function eliminarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["j" /* eliminarComentario */])(guid));},editarComentario:function editarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["i" /* editarComentario */])(guid));},addFileAdjunto:function addFileAdjunto(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["d" /* addFileAdjunto */])());},removeSolicitudTiqutesAereos:function removeSolicitudTiqutesAereos(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creaciontiqueteaereo__["m" /* removeSolicitudTiqutesAereos */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CreacionTiquetesAereo));

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TiquetesAereos_General__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TiquetesAereos_Cotizacion__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TiquetesAereos_Aprobaciones__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TiquetesAereos_Tiquetes__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TiquetesAereos_Asistencia__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TiquetesAereos_Cierre__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TiquetesAereos_Cancelacion__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TiquetesAereo=function(_Component){_inherits(TiquetesAereo,_Component);function TiquetesAereo(props){_classCallCheck(this,TiquetesAereo);var _this=_possibleConstructorReturn(this,(TiquetesAereo.__proto__||Object.getPrototypeOf(TiquetesAereo)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar la solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerCancelacion();});};_this.state={tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_TiquetesAereos_General__["a" /* default */],null),estado:1},{id:1,caption:'Cotización',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_TiquetesAereos_Cotizacion__["a" /* default */],null),estado:2},{id:2,caption:'Aprobación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_TiquetesAereos_Aprobaciones__["a" /* default */],{selectedTab:_this.selectTab.bind(_this)}),estado:3},{id:3,caption:'Tiquetes',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TiquetesAereos_Tiquetes__["a" /* default */],null),estado:4},{id:4,caption:'Asistencia',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_TiquetesAereos_Asistencia__["a" /* default */],null),estado:4},{id:5,caption:'Cierre',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_TiquetesAereos_Cierre__["a" /* default */],null),estado:6},{id:6,caption:'Cancelacion',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_TiquetesAereos_Cancelacion__["a" /* default */],null),estado:0}],selected:0};return _this;}_createClass(TiquetesAereo,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){this.props.getSolicitud(this.props.match.params.id);var params=new URLSearchParams(this.props.location.search);if(params.has("aprobacion")){this.setState({selected:2});}}else{__WEBPACK_IMPORTED_MODULE_13__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/nuevas');}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,estado=_props.estado,asistencia=_props.asistencia,pasajeros_actualizados=_props.pasajeros_actualizados,solicitud=_props.solicitud,btnRComprasDisabled=_props.btnRComprasDisabled;var descargar_asistencia=pasajeros_actualizados?pasajeros_actualizados.filter(function(a){return a.getIn(['asistencia','fecha_compra'])==null;}).count()==0:false;var boxActions=void 0;var readOnly=!Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);var onlySolicitante=Object(__WEBPACK_IMPORTED_MODULE_14__utils_helpers__["E" /* isAllowedToViewComponent */])('solicitante',solicitud);boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'pencil',onClick:function onClick(){return _this2.props.updateTravel();},title:'Editar informaci\xF3n viaje',disabled:estado>3||estado==0||selected!==0||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'history',onClick:function onClick(){return _this2.props.displayModalSelectVersion(true,"Listado de versiones");},title:'Seleccionar versi\xF3n',disabled:estado>3||estado==0||selected!==0||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'floppy-o',onClick:function onClick(){return _this2.props.updateTiquetesAereo();},title:'Enviar a aprobaci\xF3n',disabled:estado!==2||selected!==1||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'user',onClick:function onClick(){return _this2.props.canmbiarResponsable(solicitud,'ACTUALIZAR_SOLICITUD_TIQUETESAEREO');},title:'Cambiar responsable',disabled:btnRComprasDisabled||selected!==0||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][4]',name:'ticket',onClick:function onClick(){return _this2.props.registerTiquetes();},title:'Registrar tiquetes',disabled:estado!==4||selected!==3||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][5]',name:'plane',onClick:function onClick(){return _this2.props.registerAsistencias();},title:'Registrar asistencia al viajero',disabled:estado<4||estado>6||selected!==4||descargar_asistencia||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][6]',name:'cloud-download',onClick:function onClick(){return _this2.props.descargarAsistencia();},title:'Descargar asistencia al viajero',disabled:!descargar_asistencia||selected!==4||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][7]',name:'check',onClick:function onClick(){return _this2.props.registerTiquetesExpirados();},title:'Actualizar informaci\xF3n',disabled:estado!==6||selected!==5||!onlySolicitante}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][8]',name:'ban',onClick:function onClick(){return _this2.cancel();},title:'Aprobar cancelaci\xF3n solicitud',disabled:readOnly||selected!==6||estado==0})];if(!descargar_asistencia){boxActions.splice(6,1);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){return x.estado<=estado||estado==0;}).map(function(x){if(estado==0&&x.estado==4)return null;if(estado==0&&x.estado==5)return null;if(estado==0&&x.estado==6)return null;if(!asistencia&&x.id==4)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li01['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component)))));}}]);return TiquetesAereo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{btnSaveDisabled:state.tiquetesaereo.get('btnSaveDisabled'),estado:state.tiquetesaereo.get('estado'),asistencia:state.tiquetesaereo.getIn(['solicitud','viaje','asistencia_viajero']),pasajeros_actualizados:state.tiquetesaereo.getIn(['unchaged','viaje','pasajeros']),btnRComprasDisabled:state.tiquetesaereo.get('btnRComprasDisabled'),solicitud:state.tiquetesaereo.get('solicitud')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["v" /* getSolicitud */])(id));},updateTiquetesAereo:function updateTiquetesAereo(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["H" /* updateTiquetesAereo */])());},updateTravel:function updateTravel(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["I" /* updateTravel */])());},registerTiquetes:function registerTiquetes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["z" /* registerTiquetes */])());},registerAsistencias:function registerAsistencias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["x" /* registerAsistencias */])());},registerTiquetesExpirados:function registerTiquetesExpirados(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["A" /* registerTiquetesExpirados */])());},descargarAsistencia:function descargarAsistencia(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["k" /* descargarAsistencia */])());},canmbiarResponsable:function canmbiarResponsable(solicitud,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["b" /* canmbiarResponsable */])(solicitud,type));},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},displayModalSelectVersion:function displayModalSelectVersion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["o" /* displayModalSelectVersion */])(show,message,action));},registerCancelacion:function registerCancelacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_tiquetesaereo__["y" /* registerCancelacion */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TiquetesAereo));

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PasajeroEdicion__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PasajeroLectura__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_ModalSelectorAirport__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_Comentarios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_creaciontiqueteaereo__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalSelectVersion__ = __webpack_require__(651);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var General=function(_Component){_inherits(General,_Component);function General(){var _ref;var _temp,_this,_ret;_classCallCheck(this,General);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=General.__proto__||Object.getPrototypeOf(General)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/auxiliares',fn);},_this.handleOpenSelectorAddPasajero=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addPasajero(payload);});};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);},_this.handleOpenSelectorResponsableCenco=function(path,index){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1',payload);_this.props.updateInputs('solicitud.viaje.cencos.'+index+'.id',null);_this.props.updateInputs('solicitud.viaje.cencos.'+index+'.codigo',null);_this.props.updateInputs('solicitud.viaje.cencos.'+index+'.descripcion',null);_this.props.updateInputs('solicitud.viaje.cencos.'+index+'.responsable_id',a.id);_this.props.updateInputs('solicitud.viaje.cencos.'+index+'.pivot.cenco_id',null);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/cencos',fn);},_this.handleOpenSelectorAddCenco=function(list,index){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var cenco=_this.props.tiquetesaereo.getIn(['viaje','cencos',index]).toJS();var payload={};var fn=function fn(a){var index=_this.props.tiquetesaereo.getIn(['viaje','cencos']).findIndex(function(c){return c.get('id')==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_4_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{cenco.id=a.id,cenco.codigo=a.codigo,cenco.descripcion=a.descripcion;payload.path=list;payload.value=cenco;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1',payload);_this.props.updateInputs('solicitud.viaje.cencos.'+index+'.pivot.cenco_id',a.id);}};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.tiquetesaereo.getIn(['viaje','cencos',index,'usuario','id']),comparison:'string'};console.log(customFilter);_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_this.handleOpenSelectorUbicacionOrigen=function(path){var columns=[{id:1,caption:'Código',value:'code',width:'30%'},{id:2,caption:'Nombre',value:'name',width:'35%'},{id:3,caption:'País',value:'country_name',width:'35%'}];var payload={};var fn=function fn(a,query){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addOrigen(payload,query);});};_this.props.showModalSelectorUrlAirports('Listado de aeropuertos',columns,'/aeropuertos',fn);},_this.handleOpenSelectorUbicacionDestino=function(path){var columns=[{id:1,caption:'Código',value:'code',width:'30%'},{id:2,caption:'Nombre',value:'name',width:'35%'},{id:3,caption:'País',value:'country_name',width:'35%'}];var payload={};var fn=function fn(a,query){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addDestino(payload,query);});};_this.props.showModalSelectorUrlAirports('Listado de aeropuertos',columns,'/aeropuertos',fn);},_this.handleAeropuerto=function(index,tipo,value){if(tipo==='origen'){_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.origen',value);_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.aeropuerto_origen',value);}if(tipo==='destino'){_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.destino',value);_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.aeropuerto_destino',value);}},_this.onResetAeropuerto=function(tipo,index){if(tipo=='origen'){_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.origen',null);_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.aeropuerto_origen',null);}if(tipo=='destino'){_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.destino',null);_this.props.updateInputs('solicitud.viaje.trayectos.'+index+'.aeropuerto_destino',null);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(General,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,tiquetesaereo=_props.tiquetesaereo,aprobadores=_props.aprobadores,user=_props.user,comentario=_props.comentario,enums=_props.enums,flagAdjunto=_props.flagAdjunto,adjuntos=_props.adjuntos;var tipos_identificacion=enums.tipos_identificacion;if(!id)return null;var can_edit=Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["E" /* isAllowedToViewComponent */])("solicitante",tiquetesaereo)||Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["E" /* isAllowedToViewComponent */])("aprobador_primer_nivel",aprobadores);var accionesTrayectos=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',title:'Adicionar trayecto',onClick:function onClick(){return _this2.props.addTrayecto();},disabled:tiquetesaereo.getIn(['viaje','tipo_trayecto'])!=3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',title:'Eliminar trayecto',onClick:function onClick(){return _this2.props.removeTrayectos();},danger:true,disabled:tiquetesaereo.getIn(['viaje','tipo_trayecto'])!=3})];var actionsDistribucionCencos=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Layout_BoxButton__["a" /* default */],{key:'ba[2][0]',size:14,contrast:true,name:'plus-circle',title:'Nuevo',onClick:function onClick(){return _this2.props.addCencoSolicitud();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Layout_BoxButton__["a" /* default */],{key:'ba[2][1]',size:14,contrast:true,name:'trash',title:'Eliminar',onClick:function onClick(){return _this2.props.removeCenco();},danger:true})];var asistencia_vajero=tiquetesaereo.getIn(['viaje','asistencia_viajero']);var disabled_comment=tiquetesaereo.get('estado')===0||tiquetesaereo.get('estado')===7;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',tiquetesaereo.get('solicitante'))&&tiquetesaereo.get('estado')!=0&&tiquetesaereo.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:tiquetesaereo.getIn(['solicitante','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.solicitante');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.solicitante',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:tiquetesaereo.getIn(['solicitante','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:tiquetesaereo.getIn(['solicitante','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:tiquetesaereo.getIn(['solicitante','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:tiquetesaereo.getIn(['solicitante','area','nombre'])||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',tiquetesaereo.get('responsable_compras'))&&tiquetesaereo.get('estado')!=0&&tiquetesaereo.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:tiquetesaereo.getIn(['responsable_compras','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.responsable_compras');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.responsable_compras',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:tiquetesaereo.getIn(['responsable_compras','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:tiquetesaereo.getIn(['responsable_compras','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:tiquetesaereo.getIn(['responsable_compras','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(tiquetesaereo.getIn(['created_at'])).format('DD/MM/YYYY')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:tiquetesaereo.get('id')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n del viaje'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo del viaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:tiquetesaereo.get('proyecto_evento')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.proyecto_evento',e.target.value);},disabled:!can_edit||tiquetesaereo.get('estado')>3||tiquetesaereo.get('estado')==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de viaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:tiquetesaereo.getIn(['viaje','tipo_viaje'])||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.tipo_viaje',e.target.value);},disabled:!can_edit||tiquetesaereo.get('estado')>3||tiquetesaereo.get('estado')==0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Nacional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Internacional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de trayectoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:tiquetesaereo.getIn(['viaje','tipo_trayecto'])||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.tipo_trayecto',e.target.value);},disabled:!can_edit||tiquetesaereo.get('estado')>3||tiquetesaereo.get('estado')==0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Ida y vuelta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Solo ida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Multiples ciudades')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad de pasajeros'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'number',min:'1',value:tiquetesaereo.getIn(['viaje','cant_pasajeros'])||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.cant_pasajeros',e.target.value);},disabled:!can_edit||tiquetesaereo.get('estado')>3||tiquetesaereo.get('estado')==0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'22px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'assist',checked:asistencia_vajero,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.asistencia_viajero',e.target.checked);},disabled:tiquetesaereo.getIn(['viaje','tipo_viaje'])==1||!can_edit||tiquetesaereo.get('estado')>3||tiquetesaereo.get('estado')==0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{margin:'0 0 0 7px'},className:'control-label',htmlFor:'assist'},'Asistencia al viajero'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),can_edit&&tiquetesaereo.get('estado')<4&&tiquetesaereo.get('estado')!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Trayectos',actions:accionesTrayectos},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Origen'),tiquetesaereo.getIn(['viaje','tipo_trayecto'])==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'13%'}},'Fecha'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Hora')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'13%'}},'Fecha ida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Hora ida')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Destino'),tiquetesaereo.getIn(['viaje','tipo_trayecto'])==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'13%'}},'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Hora regreso')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['viaje','trayectos']).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'t['+t.get('guid')+i+']',className:t.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},value:t.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.trayectos.'+i+'.selected',e.target.value);},disabled:i==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:t.get('origen')?t.get('origen')+' '+t.get('aeropuerto_origen'):'',onClick:function onClick(){return _this2.handleOpenSelectorUbicacionOrigen('solicitud.viaje.trayectos.'+i);},onReset:function onReset(){return _this2.onResetAeropuerto('origen',i);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_ida')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_ida')).format('YYYY-MM-DD'):'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.trayectos.'+i+'.fecha_ida',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'time',value:t.get('hora_ida')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.trayectos.'+i+'.hora_ida',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:t.get('destino')?t.get('destino')+' '+t.get('aeropuerto_destino'):'',onClick:function onClick(){return _this2.handleOpenSelectorUbicacionDestino('solicitud.viaje.trayectos.'+i);},onReset:function onReset(){return _this2.onResetAeropuerto('destino',i);}})),tiquetesaereo.getIn(['viaje','tipo_trayecto'])==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_regreso')?__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_regreso')).format('YYYY-MM-DD'):'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.trayectos.'+i+'.fecha_regreso',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'time',value:t.get('hora_regreso')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.trayectos.'+i+'.hora_regreso',e.target.value);}}))));})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Origen'),tiquetesaereo.getIn(['viaje','tipo_trayecto'])==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Fecha viaje'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Fecha ida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Destino'),tiquetesaereo.getIn(['viaje','tipo_trayecto'])==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Fecha regreso'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['viaje','trayectos']).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr[0]['+i+']',className:t.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('origen')+'-'+t.get('aeropuerto_origen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_ida')).format('DD/MM/YYYY hh:mm A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('destino')+'-'+t.get('aeropuerto_destino')),tiquetesaereo.getIn(['viaje','tipo_trayecto'])==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_regreso')).format('DD/MM/YYYY hh:mm A')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),can_edit&&tiquetesaereo.get('estado')<3&&tiquetesaereo.get('estado')!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n de centros de costos',actions:actionsDistribucionCencos},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ordenador del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Centro de costo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['viaje','cencos']).count()>0?tiquetesaereo.getIn(['viaje','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+(x.get('id')?x.get('id'):x.get('guid'))+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:x.getIn(['usuario','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelectorResponsableCenco('solicitud.viaje.cencos.'+n+'.usuario',n);},onReset:function onReset(){return _this2.props.updateInputs('solicitud.viaje.cencos.'+n+'.usuario',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('usuario')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:x.get('codigo'),onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('solicitud.viaje.cencos.'+n,n);},onReset:function onReset(){return _this2.props.updateInputs('solicitud.viaje.cencos.'+n,null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',placeholder:'Seleccione un responsable del cenco',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.getIn(['pivot','porcentaje'])?x.getIn(['pivot','porcentaje']):0,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.cencos.'+n+'.pivot.porcentaje',e.target.value);},disabled:x.get('usuario')==null})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6,style:{textAlign:'center'}},'Para agregar un centro de costo haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_fontawesome___default.a,{name:'plus-circle'})))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n de centros de costos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ordenador del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Centro de costo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['viaje','cencos']).count()>0?tiquetesaereo.getIn(['viaje','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+(x.getIn(['pivot','id'])?x.getIn(['pivot','id']):x.getIn(['pivot','guid']))+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:x.getIn(['usuario','fullname']||''),disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:x.get('codigo')||'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.getIn(['pivot','porcentaje'])?x.getIn(['pivot','porcentaje']):0,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},'No hay distribuci\xF3n de centro de costos para esta solicitud')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:tiquetesaereo.getIn(['observaciones'])||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.observaciones',e.target.value);},disabled:!can_edit||tiquetesaereo.get('estado')>3||tiquetesaereo.get('estado')==0}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Shared_Comentarios__["a" /* default */],{foros:tiquetesaereo.get('foros'),comentario:this.props.comentario,updateInputs:this.props.updateInputs,disabled_comment:disabled_comment,enviarComentario:this.props.enviarComentario,editarComentario:this.props.editarComentario,eliminarComentario:this.props.eliminarComentario}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shared_AttachedFilesBox__["a" /* default */],{files:tiquetesaereo.get('adjuntos').filter(function(adjunto){return!adjunto.get('documento_id');}),root:'solicitud',removeFiles:this.props.removeSolicitudTiqutesAereos,updateInputs:this.props.updateInputs,obj:tiquetesaereo,check:'solicitud',disabledAttach:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Pasajeros'},tiquetesaereo.getIn(['viaje','pasajeros']).map(function(p,i){if(can_edit&&tiquetesaereo.get('estado')<4&&tiquetesaereo.get('estado')!=0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PasajeroEdicion__["a" /* PasajeroEdicion */],{key:'Fragment['+i+']',p:p,i:i,updateInputs:_this2.props.updateInputs,handleOpenSelectorAddPasajero:_this2.handleOpenSelectorAddPasajero,displayModalAddFile:_this2.props.displayModalAddFile,validateCaducidadPasaporte:_this2.props.validateCaducidadPasaporte,asistencia_vajero:asistencia_vajero,tipo_viaje:tiquetesaereo.getIn(['viaje','tipo_viaje']),tipos_identificacion:tipos_identificacion});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PasajeroLectura__["a" /* PasajeroLectura */],{key:'Fragment['+i+']',p:p,i:i,downloadFile:_this2.props.downloadFile,asistencia_vajero:asistencia_vajero});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalAddFile__["a" /* default */],{action:function action(){return flagAdjunto?_this2.props.editPassportFile():_this2.props.addFileAdjunto();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_ModalSelectorAirport__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ModalSelectVersion__["a" /* default */],null));}}]);return General;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.tiquetesaereo.get('id'),tiquetesaereo:state.tiquetesaereo.get('solicitud'),aprobadores:state.tiquetesaereo.get('aprobadores'),user:state.common.get('user'),comentario:state.tiquetesaereo.get('comentario'),enums:state.common.get('enums').toJS(),flagAdjunto:state.tiquetesaereo.get('flagAdjunto'),adjuntos:state.tiquetesaereo.get('adjuntos')};}function mapDispatchToProps(dispatch){return{addOrigen:function addOrigen(path,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["g" /* addOrigen */])(path,query));},addDestino:function addDestino(path,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["c" /* addDestino */])(path,query));},addCencoSolicitud:function addCencoSolicitud(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["b" /* addCencoSolicitud */])());},removeCenco:function removeCenco(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["B" /* removeCenco */])());},addTrayecto:function addTrayecto(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["i" /* addTrayecto */])());},addPasajero:function addPasajero(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["h" /* addPasajero */])(path));},editPassportFile:function editPassportFile(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["r" /* editPassportFile */])());},displayModalAddFile:function displayModalAddFile(show,title,mode,file,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["g" /* displayModalAddFile */])(show,title,mode,file,index));},removeTrayectos:function removeTrayectos(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["E" /* removeTrayectos */])());},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["h" /* downloadFile */])(id,filename));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));},showModalSelector:function showModalSelector(title,fields,url,action){var filter=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["y" /* showModalSelector */])(title,fields,url,action,filter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["q" /* selectFromSelector */])(type,payload));},validateCaducidadPasaporte:function validateCaducidadPasaporte(value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_creaciontiqueteaereo__["p" /* validateCaducidadPasaporte */])(value));},showModalSelectorUrlAirports:function showModalSelectorUrlAirports(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_common__["z" /* showModalSelectorUrlAirports */])(title,fields,url,action,customFilter));},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["u" /* enviarComentario */])());},editarComentario:function editarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["s" /* editarComentario */])(id));},eliminarComentario:function eliminarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["t" /* eliminarComentario */])(id));},removeSolicitudTiqutesAereos:function removeSolicitudTiqutesAereos(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["D" /* removeSolicitudTiqutesAereos */])());},addFileAdjunto:function addFileAdjunto(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_tiquetesaereo__["e" /* addFileAdjunto */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(General));

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasajeroEdicion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_SelectorInput__ = __webpack_require__(22);
var PasajeroEdicion=function PasajeroEdicion(props){var p=props.p,i=props.i,updateInputs=props.updateInputs,handleOpenSelectorAddPasajero=props.handleOpenSelectorAddPasajero,displayModalAddFile=props.displayModalAddFile,validateCaducidadPasaporte=props.validateCaducidadPasaporte,asistencia_vajero=props.asistencia_vajero,tipo_viaje=props.tipo_viaje,tipos_identificacion=props.tipos_identificacion;var mode=p.get('pasaporte_adjunto')?'edit':'create';var fecha_salida=__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.getIn(['asistencia','fecha_salida']));var fecha_regreso=__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.getIn(['asistencia','fecha_regreso']));var totalDias=Math.abs(fecha_regreso.diff(fecha_salida,'days'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Pasajero #'+(i+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Información del pasajero',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo pasajero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_pasajero'),onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.tipo_pasajero',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Empleado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Invitado')))),p.get('tipo_pasajero')==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre completo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_SelectorInput__["a" /* default */],{value:p.get('fullname')?p.get('fullname'):(p.get('nombres')||"")+' '+(p.get('apellidos')||""),onClick:function onClick(){return handleOpenSelectorAddPasajero('solicitud.viaje.pasajeros.'+i);},onReset:function onReset(){return updateInputs('solicitud.viaje.pasajeros.'+i,{selected:p.get('selected'),guid:p.get('guid')});}})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nombres')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.nombres',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('apellidos')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.apellidos',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_documento')||1,onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.tipo_documento',e.target.value);}},Object.keys(tipos_identificacion).map(function(key,ikey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt['+i+']['+ikey+']',value:key},tipos_identificacion[key]);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. de Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('cedula')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.cedula',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('celular')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.celular',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha nacimiento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.get('fecha_nacimiento')).format('YYYY-MM-DD')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.fecha_nacimiento',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),p.get('tipo_pasajero')==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('correo')||'',disabled:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('correo')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.correo',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nacionalidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nacionalidad')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.nacionalidad',e.target.value);},disabled:tipo_viaje==1})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Pasaporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('pasaporte')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.pasaporte',e.target.value);},disabled:tipo_viaje==1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pa\xEDs expedici\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('pais_expedicion')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.pais_expedicion',e.target.value);},disabled:tipo_viaje==1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha caducidad pasaporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.get('fecha_caducidad_pasaporte')).format('YYYY-MM-DD')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.fecha_caducidad_pasaporte',e.target.value);},onBlur:function onBlur(e){return validateCaducidadPasaporte(e.target.value);},disabled:tipo_viaje==1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Adjuntar pasaporte pasajero ',i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file '+(tipo_viaje==2?'label-upload-file-enabled':'label-upload-file-disabled'),onClick:tipo_viaje==2?function(){displayModalAddFile(true,'Adjuntar pasaporte',mode,p.get('adjunto'),i);updateInputs('flagAdjunto',true);}:function(){return null;},disabled:tipo_viaje==1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',p.get('adjunto')?p.getIn(['adjunto','nombre']):' Seleccione un archivo...'))))),asistencia_vajero&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Información asistencia de viaje',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pa\xEDs destino'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','pais_destino'])||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.pais_destino',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.getIn(['asistencia','fecha_salida'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.fecha_salida',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.getIn(['asistencia','fecha_regreso'])).format('YYYY-MM-DD')||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.fecha_regreso',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total d\xEDas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:totalDias||0,disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'En caso de emergencia avisar a:',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres y apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','avisar_a'])||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.avisar_a',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Direcci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','direccion'])||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.direccion',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','ciudad'])||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.ciudad',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','celular'])||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.celular',e.target.value);},disabled:asistencia_vajero==false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','telefono'])||'',onChange:function onChange(e){return updateInputs('solicitud.viaje.pasajeros.'+i+'.asistencia.telefono',e.target.value);},disabled:asistencia_vajero==false}))))))));};

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasajeroLectura; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
var PasajeroLectura=function PasajeroLectura(props){var p=props.p,i=props.i,downloadFile=props.downloadFile,asistencia_vajero=props.asistencia_vajero;var fileid=p.getIn(['adjunto','id'])?p.getIn(['adjunto','id']):null;var filename=p.getIn(['adjunto','nombre'])?p.getIn(['adjunto','nombre']):null;var fecha_salida=__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.getIn(['asistencia','fecha_salida']));var fecha_regreso=__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.getIn(['asistencia','fecha_regreso']));var totalDias=Math.abs(fecha_regreso.diff(fecha_salida,'days'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Pasajero #'+(i+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Información del pasajero',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo pasajero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_pasajero')||'',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Empleado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Invitado')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nombres')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('apellidos')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'C\xE9dula'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('cedula')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('celular')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('correo')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha nacimiento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.get('fecha_nacimiento')).format('DD/MM/YYYY')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nacionalidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nacionalidad')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Pasaporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('pasaporte')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pa\xEDs expedici\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('pais_expedicion')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha caducidad pasaporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.get('fecha_caducidad_pasaporte')).format('DD/MM/YYYY')!='Invalid date'?__WEBPACK_IMPORTED_MODULE_1_moment___default()(p.get('fecha_caducidad_pasaporte')).format('DD/MM/YYYY'):'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Descargar pasaporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file '+(p.get('pasaporte_adjunto')?'label-upload-file-enabled':'label-upload-file-disabled'),onClick:p.get('pasaporte_adjunto')?function(){return downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' ',p.get('pasaporte_adjunto')?filename:''))))),asistencia_vajero&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Información asistencia de viaje',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pa\xEDs destino'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','pais_destino'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:fecha_salida.format('YYYY-MM-DD')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:fecha_regreso.format('YYYY-MM-DD')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total d\xEDas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:totalDias||0,disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'En caso de emergencia avisar a:',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres y apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','avisar_a'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Direcci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','direccion'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','ciudad'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','celular'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.getIn(['asistencia','telefono'])||'',disabled:true}))))))));};

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_tiquetesaereo__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSelectVersion=function(_Component){_inherits(ModalSelectVersion,_Component);function ModalSelectVersion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalSelectVersion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalSelectVersion.__proto__||Object.getPrototypeOf(ModalSelectVersion)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalSelectVersion');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSelectVersion .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalSelectVersion(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalSelectVersion,[{key:'render',value:function render(){var _this2=this;var modalSelectVersion=this.props.modalSelectVersion;if(!modalSelectVersion.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_Modal__["a" /* default */],{id:'modalSelectVersion',show:true,ZIndex:2000,width:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.addOrEditCotizacion();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalHeader__["a" /* default */],{title:modalSelectVersion.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Versi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha solitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{"width":"12%"}},'Tipo de viaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{"width":"11%"}},'Tipo de trayectoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{"width":"9%"}},'Cantidad de pasajeros'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{"width":"6%"}},'Asistencia al viajero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Origen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Destino'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha llegada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{"width":"10%"}},'Centro de costo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{"width":"10%"}},'Autor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalSelectVersion.get('data')&&modalSelectVersion.get('data').map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+row.get('id')+']',className:row.get('activo')?'success':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{"textAlign":"right"}},!row.get('activo')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'LinkToEdit',onClick:function onClick(){return _this2.props.activateVersion(row.get('id'));}},modalSelectVersion.get('data').count()-index):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,modalSelectVersion.get('data').count()-index)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(row.get('created_at')).format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('tipo_viaje')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:row.get('tipo_viaje')||'',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Nacional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Internacional'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('tipo_trayecto')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:row.get('tipo_trayecto')||'',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Ida y vuelta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Solo ida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Multiples ciudades'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{"textAlign":"right"}},row.get('cant_pasajeros')||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{"textAlign":"center"}},row.get('asistencia_viajero')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'check-square'}):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('trayectos').count()&&row.getIn(['trayectos',0,'origen'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('trayectos').count()&&__WEBPACK_IMPORTED_MODULE_3_moment___default()(row.getIn(['trayectos',0,'fecha_ida'])).format('YYYY-MM-DD HH:mm:ss')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('trayectos').count()&&row.getIn(['trayectos',0,'destino'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('trayectos').count()&&__WEBPACK_IMPORTED_MODULE_3_moment___default()(row.getIn(['trayectos',0,'fecha_destino'])).format('YYYY-MM-DD HH:mm:ss')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('cencos').count()&&row.getIn(['cencos',0,'descripcion'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,row.get('usuario')&&row.getIn(['usuario','nombres'])+' '+row.getIn(['usuario','apellidos'])));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalSelectVersion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSelectVersion:state.tiquetesaereo.get('modalSelectVersion')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalSelectVersion:function displayModalSelectVersion(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_tiquetesaereo__["o" /* displayModalSelectVersion */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));},activateVersion:function activateVersion(viaje_id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_tiquetesaereo__["a" /* activateVersion */])(viaje_id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSelectVersion));

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ModalAddCotizacion__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cotizacion=function(_Component){_inherits(Cotizacion,_Component);function Cotizacion(){_classCallCheck(this,Cotizacion);return _possibleConstructorReturn(this,(Cotizacion.__proto__||Object.getPrototypeOf(Cotizacion)).apply(this,arguments));}_createClass(Cotizacion,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,tiquetesaereo=_props.tiquetesaereo;var estado=tiquetesaereo.get('estado');if(!id)return null;var accionesCotizaciones=[];if(Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',tiquetesaereo.get('solicitud'))){accionesCotizaciones=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',title:'Adicionar cotizaci\xF3n',onClick:function onClick(){return _this2.props.displayModalAddCotizacion(true,'Adicionar cotización','create');},disabled:tiquetesaereo.get('estado')!=2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',title:'Eliminar cotizaci\xF3n',onClick:function onClick(){return _this2.props.removeCotizacion();},danger:true,disabled:tiquetesaereo.get('estado')!=2})];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Comparativo de tiquetes',actions:accionesCotizaciones},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Aerol\xEDnea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha de Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pantallazo cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo de adjunto'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['solicitud','cotizaciones']).count()>0?tiquetesaereo.getIn(['solicitud','cotizaciones']).map(function(x,n){var fileid=x.get('adjunto_id')?x.getIn(['adjunto','id']):null;var filename=x.get('adjunto_id')?x.getIn(['adjunto','nombre']):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+n+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.cotizaciones.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:(estado==2?'LinkToEdit':'')+' text-right',onClick:estado==2?function(){return _this2.props.displayModalAddCotizacion(true,'Editar cotización','edit',n);}:null},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_2_numeral___default()(x.get('cotizado')).format('$0,0.00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_3_moment___default()(x.getIn(['adjunto','created_at'])).format('DD/MM/YYYY')),x.get('adjunto_id')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:x.get('adjunto')?function(){return _this2.props.downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+x.getIn(['adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('adjunto')?''+x.getIn(['adjunto','nombre']):'Archivo sin adjuntar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('adjunto')?''+x.getIn(['adjunto','observaciones']):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('adjunto')?''+x.getIn(['adjunto','clasificacion']):''));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6,style:{textAlign:'center'}},'Para agregar una cotizaci\xF3n haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'plus-circle'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ModalAddCotizacion__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('modalAddCotizacion.data.adjunto');}}));}}]);return Cotizacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.tiquetesaereo.get('id'),tiquetesaereo:state.tiquetesaereo};}function mapDispatchToProps(dispatch){return{displayModalAddCotizacion:function displayModalAddCotizacion(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["m" /* displayModalAddCotizacion */])(show,title,mode,index));},removeCotizacion:function removeCotizacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["C" /* removeCotizacion */])());},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},updateInputsModalAddFile:function updateInputsModalAddFile(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["C" /* updateInputs */])(path,value));},selectFile:function selectFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["p" /* selectFile */])(file));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["d" /* addFile */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["h" /* downloadFile */])(id,filename));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cotizacion));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddCotizacion=function(_Component){_inherits(ModalAddCotizacion,_Component);function ModalAddCotizacion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddCotizacion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddCotizacion.__proto__||Object.getPrototypeOf(ModalAddCotizacion)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddCotizacion');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddCotizacion .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddCotizacion(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddCotizacion,[{key:'render',value:function render(){var _this2=this;var modalAddCotizacion=this.props.modalAddCotizacion;if(!modalAddCotizacion.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalAddCotizacion',show:true,ZIndex:2000,width:700},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.addOrEditCotizacion();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:modalAddCotizacion.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddCotizacion.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Aerol\xEDnea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalAddCotizacion.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddCotizacion.data.descripcion',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor cotizado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddCotizacion.getIn(['data','cotizado']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddCotizacion.data.cotizado',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pantallazo cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',modalAddCotizacion.getIn(['data','adjunto','file'])?modalAddCotizacion.getIn(['data','adjunto','file']).name:' Seleccione un archivo...')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalAddCotizacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddCotizacion:state.tiquetesaereo.get('modalAddCotizacion')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddCotizacion:function displayModalAddCotizacion(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__["m" /* displayModalAddCotizacion */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));},addOrEditCotizacion:function addOrEditCotizacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__["f" /* addOrEditCotizacion */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddCotizacion));

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_tiquetesaereo__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Aprobaciones=function(_Component){_inherits(Aprobaciones,_Component);_createClass(Aprobaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('APROBADORES_ADICIONALES');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.setState({aprobadores:this.props.aprobadores});}}]);function Aprobaciones(props){_classCallCheck(this,Aprobaciones);var _this=_possibleConstructorReturn(this,(Aprobaciones.__proto__||Object.getPrototypeOf(Aprobaciones)).call(this,props));_this.rubros=false;_this.aprobador_id=null;_this.approve=function(aprobador_id,cencos){//this.rubros = true
_this.aprobador_id=aprobador_id;var aprobaciones=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones');_this.props.showModalConfirmarAccion(true,'Al hacer click en Ok, estar\xE1 aprobando el cargue de '+__WEBPACK_IMPORTED_MODULE_4_numeral___default()(_this.getTotal(_this.aprobador_id)).format('$0,0.00')+' '+(cencos.length>1?'entre los ':'al')+' centro'+(cencos.length>1?'s':'')+' de costo '+Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["V" /* uniqueArray */])(cencos).join(', '),function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(aprobaciones,2);});};_this.reject=function(aprobador_id){_this.rubros=false;var aprobaciones=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones');_this.props.showModalConfirmarAccion(true,'\xBFEsta seguro que desea rechazar esta solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(aprobaciones,0);});};_this.getTotal=function(aprobador_id){var aprobacion=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones').filter(function(a){return a.get('estado')==2;});return aprobacion.count()>0?aprobacion.first().getIn(['cotizacione','cotizado']):0;};_this.getSolicitudPendiente=function(aprobaciones){return _this.props.tiquetesaereo.get('estado')===3&&aprobaciones.filter(function(x){return x.get('estado')===1;}).count()>0;};_this.getSolicitudRechazada=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')===0;}).count()==aprobaciones.count();};_this.getSolicitudAprobadas=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')===2;}).count()>0;};_this.getSolicitudAprobadasEnRevision=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')===3;}).count()>0;};_this.getEstadoAprobacion=function(index){if(index<_this.props.aprobadores.count()){var aprobaciones=_this.props.aprobadores.getIn([index,'aprobaciones']);var validado=_this.props.tiquetesaereo.get('estado')>3||_this.props.tiquetesaereo.get('estado')===0;if(aprobaciones.count()>0){if(_this.getSolicitudPendiente(aprobaciones))return 1;if(validado&&_this.getSolicitudRechazada(aprobaciones))return 0;if(validado&&_this.getSolicitudAprobadas(aprobaciones))return 2;if(_this.getSolicitudAprobadasEnRevision(aprobaciones))return 3;return 1;}}return 1;};_this.getTipoAprobacion=function(index){if(index<_this.props.aprobadores.count()){var aprobaciones=_this.props.aprobadores.getIn([index,'aprobaciones']);return aprobaciones.count()>0?aprobaciones.first().get('tipo'):1;}return 1;};_this.handleOpenSelectorAprobador=function(){var fields=[{id:1,caption:'Nombre',value:'fullname',width:'40%'},{id:2,caption:'Cargo',value:'cargo',width:'40%'},{id:3,caption:'Miembro',value:'esmiembrocomite',width:'20%'}];_this.props.showModalSelector('Seleccione aprobador adicional',fields,'/usuarios/aprobadores-adicionales',function(aprobador){_this.setState({aprobadorAdicional:aprobador});});};_this.handleEnviarSolicitudAdicional=function(){var _this$state=_this.state,aprobadorAdicional=_this$state.aprobadorAdicional,motivoAprobacionAdicional=_this$state.motivoAprobacionAdicional;if(!aprobadorAdicional||!motivoAprobacionAdicional.trim())return;_this.props.crearAprobacionAdicional(aprobadorAdicional,motivoAprobacionAdicional);_this.setState({solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''});};_this.info_aprobador_adicional=function(aprobador){var aprobadores_adicionales=_this.props.aprobadores_adicionales;if(!aprobador)return null;if(!aprobadores_adicionales)return null;var aprobadorInfo=aprobadores_adicionales.find(function(a){return a.get('USUARIO')===aprobador.get('username');});if(!aprobadorInfo)return null;return{cargo:aprobadorInfo.get('CARGO')||'Sin cargo',esmiembrocomite:aprobadorInfo.get('MIEMBRO_COMITE')==='SI'};};_this.state={aprobador_id:null,aprobadores:_this.props.aprobadores,solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''};return _this;}_createClass(Aprobaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,tiquetesaereo=_props.tiquetesaereo,enums=_props.enums,aprobadores=_props.aprobadores,selectedTab=_props.selectedTab;if(!id)return null;var adjunto=[];tiquetesaereo.get('cotizaciones').map(function(x){var adjuntoId=x.get('adjunto_id');var fileid=x.get('adjunto_id')?x.getIn(['adjunto','id']):null;var filename=x.get('adjunto_id')?x.getIn(['adjunto','nombre']):null;if(adjuntoId){adjunto.push({fileid:fileid,filename:filename});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,tiquetesaereo.get('estado')===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxSection__["a" /* default */],{title:'Aprobaci\xF3n adicional'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:this.state.solicitarAprobacionAdicional,onChange:function onChange(e){return _this2.setState({solicitarAprobacionAdicional:e.target.checked});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'7px'}},'Solicitar aprobaci\xF3n adicional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},this.state.solicitarAprobacionAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione aprobador adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:this.state.aprobadorAdicional?this.state.aprobadorAdicional.fullname:'',onClick:this.handleOpenSelectorAprobador,onReset:function onReset(){return _this2.setState({aprobadorAdicional:null});}})))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cargo del aprobador:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control input-sm',style:{background:'#f9f9f9',paddingTop:'5px'}},this.state.aprobadorAdicional.cargo||'Sin cargo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{display:'flex',alignItems:'center',marginTop:25}},this.state.aprobadorAdicional.esmiembrocomite==='SI'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{fontSize:13}},'Integrantes del Comit\xE9 de Rector\xEDa')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo de la solicitud adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:3,className:'form-control input-sm',value:this.state.motivoAprobacionAdicional,onChange:function onChange(e){return _this2.setState({motivoAprobacionAdicional:e.target.value});}}))))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{textAlign:'right',paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',disabled:!this.state.motivoAprobacionAdicional.trim()||!this.state.aprobadorAdicional,onClick:this.handleEnviarSolicitudAdicional},'Enviar solicitud adicional')))),aprobadores.count()>0&&aprobadores.map(function(a,b){var cencos=[];var estado=_this2.getEstadoAprobacion(b);var tipo_aprobacion=_this2.getTipoAprobacion(b);var nombre_su_original=a.get('aprobaciones').filter(function(x){return x.get('estado')===0||x.get('estado')===2;}).count()>0?a.get('aprobaciones').filter(function(x){return x.get('estado')===0||x.get('estado')===2;}).first().getIn(['aprobador_su','fullname']):null;var info_aprobador_adicional=_this2.info_aprobador_adicional(a);return[b>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep1['+b+']',className:'separator'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxSection__["a" /* default */],{key:'bs1['+a.get('id')+']',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,tipo_aprobacion===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#fff',fontWeight:600}},'Solicitud de aprobaci\xF3n adicional a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,a.get('fullname'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Solicitud de aprobaci\xF3n a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,a.get('fullname')))))},info_aprobador_adicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:500}},'Cargo: ',info_aprobador_adicional.cargo||'Sin cargo'),info_aprobador_adicional.esmiembrocomite?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{marginLeft:10}},'Integrantes del Comit\xE9 de Rector\xEDa'):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Solicitud de aprobaci\xF3n: ',enums.aprobaciones.estados[estado],estado===1?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' \u2022 ',a.getIn(['aprobaciones','0','fecha'])?__WEBPACK_IMPORTED_MODULE_3_moment___default()(a.getIn(['aprobaciones','0','fecha'])).format('YYYY-MM-DD HH:mm'):null)))),nombre_su_original&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Esta solicitud fue ',''+(estado===2?'aprobada':'rechazada'),' por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,nombre_su_original)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Solicitada por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,tiquetesaereo.getIn(['solicitante','fullname']))),' \u2022 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+tiquetesaereo.getIn(['solicitante','email'])},tiquetesaereo.getIn(['solicitante','email']))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep2['+b+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Detalle:'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep3['+b+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'Seleccionar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Aerol\xEDnea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Pantallazo cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'40%'}},'Distribuci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,a.get('aprobaciones').map(function(c,d){var responsable_id=a.get('id');var adjuntoId=c.getIn(['cotizacione','adjunto_id']);var data=adjunto.find(function(x){return x.fileid===adjuntoId;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+a.get('id')+']['+c.get('id')+']['+d+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle',padding:'15px'}},estado===0||estado===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,c.get('estado')==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default.a,{name:'check',style:{color:'green',fontSize:'30px'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,c.get('estado')==2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default.a,{name:'check',style:{color:'green',fontSize:'30px'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{width:'45px',height:'35px'},onClick:function onClick(){return _this2.props.seleccionarAprobacion(b,d);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,c.getIn(['cotizacione','descripcion'])),adjuntoId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:adjuntoId?function(){return _this2.props.downloadFile(data.fileid,data.filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},data.filename)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,adjuntoId?data.filename:'Archivo sin adjuntar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(c.getIn(['cotizacione','cotizado'])).format('$0,0.00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Rubro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,c.getIn(['cotizacione','viaje','0','cencos']).map(function(e,f){if(e.get('responsable_id')!=responsable_id&&e.getIn(['pivot','aprobador_id'])!=responsable_id)return null;var indexCenco=cencos.findIndex(function(x){return x==e.get('codigo');});if(indexCenco==-1)cencos.push(e.get('codigo'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr2['+a.get('id')+']['+c.get('id')+']['+e.get('id')+']['+f+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+e.get('descripcion')},e.get('codigo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+e.getIn(['pivot','rubro','descripcion'])},e.getIn(['pivot','rubro','nombre']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(e.getIn(['pivot','porcentaje'])/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(e.getIn(['pivot','porcentaje'])/100*c.getIn(['cotizacione','cotizado'])).format('$0,0.00')));})))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:6,className:'form-control input-sm',value:a.getIn(['aprobaciones',0,'observaciones'])||'',onChange:function onChange(e){return _this2.props.updateInputs('aprobadores.'+b+'.aprobaciones.0.observaciones',e.target.value);},disabled:!Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobaciones',a)||estado!==1&&estado!==3||tiquetesaereo.get('estado')==0||tipo_aprobacion===3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'well'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Recuerde que puede modificar la solicitud en cualquier momento, previo a la aprobaci\xF3n desde la pesta\xF1a solicitud, haciendo click sobre el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default.a,{name:'pencil'}),'\xA0tambi\xE9n puede volver a una versi\xF3n anterior haciendo clic sobre el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_fontawesome___default.a,{name:'history'}),'\xA0seleccionando la versi\xF3n correspondiente. Para hacer modificaciones puede hacer click al bot\xF3n de ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Cambiar'),'.')),Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobaciones',a)&&estado!==2&&tiquetesaereo.get('estado')>0&&tiquetesaereo.get('estado')<4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right',padding:'10px 0'}},tipo_aprobacion!==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default btn-sm btn-squared',onClick:function onClick(e){return selectedTab(e,0);}},'Cambiar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm btn-squared',onClick:function onClick(e){return _this2.approve(a.get('id'),cencos);}},'Aprobar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default btn-sm btn-squared',onClick:function onClick(e){return _this2.reject(a.get('id'));}},'Rechazar'))))))];}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalConfirmarAccion__["a" /* default */],null,this.rubros&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_Box__["a" /* default */],{title:'Selecci\xF3n de rubros',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.tiquetesaereo.getIn(['viaje','cencos']).filter(function(c){return c.get('responsable_id')==_this2.aprobador_id;}).map(function(x,n){if(x.get('rubros').count()>0){var index=_this2.props.tiquetesaereo.getIn(['viaje','cencos']).findIndex(function(f){return f.get('id')===x.get('id');});if(index<0)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:x.get('descripcion')?x.get('descripcion'):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:Number(x.getIn(['pivot','rubro_id']))||0,onChange:function onChange(e){_this2.props.updateInputs('solicitud.viaje.cencos.'+index+'.pivot.rubro_id',Number(e.target.value));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opci\xF3n'),x.get('rubros').map(function(r,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'optr['+j+']',value:r.get('id')},r.get('nombre'));}))));}})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Aprobaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.tiquetesaereo.get('id'),tiquetesaereo:state.tiquetesaereo.get('solicitud'),aprobadores:state.tiquetesaereo.get('aprobadores'),enums:state.common.get('enums').toJS(),user:state.common.get('user'),aprobadores_adicionales:state.common.getIn(['parametros','APROBADORES_ADICIONALES'])};}function mapDispatchToProps(dispatch){return{showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},registerApprovalResult:function registerApprovalResult(aprobador_id,result){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_tiquetesaereo__["w" /* registerApprovalResult */])(aprobador_id,result));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));},seleccionarAprobacion:function seleccionarAprobacion(cotizacion_id,aprobador_id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_tiquetesaereo__["F" /* seleccionarAprobacion */])(cotizacion_id,aprobador_id));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["h" /* downloadFile */])(id,filename));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["q" /* selectFromSelector */])(type,payload));},crearAprobacionAdicional:function crearAprobacionAdicional(aprobador,motivo){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_tiquetesaereo__["j" /* crearAprobacionAdicional */])(aprobador,motivo));},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["l" /* getParameterByName */])(param));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Aprobaciones));

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(656);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(657);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(257);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(658);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(659);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(660);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(661);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(258);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(157);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(662);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(663);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(664);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(665);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(666);
/* unused harmony reexport withRouter */





























/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(157);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(157);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(202);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(257);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(207);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(208);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(210);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(211);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(143);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(109);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(212);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAddTiquete__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tiquetes=function(_Component){_inherits(Tiquetes,_Component);function Tiquetes(){_classCallCheck(this,Tiquetes);return _possibleConstructorReturn(this,(Tiquetes.__proto__||Object.getPrototypeOf(Tiquetes)).apply(this,arguments));}_createClass(Tiquetes,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,tiquetesaereo=_props.tiquetesaereo;if(!id)return null;var tipo_trayecto=tiquetesaereo.getIn(['viaje','tipo_trayecto']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Registro de tiquetes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-tiquetes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'6%',textAlign:'center'}},'No.Pasaj.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No. Tiquete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'8%'}},'Valor tiquete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Aerol\xEDnea/Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'40%'}},'Trayectos'),tiquetesaereo.get('estado')==4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Adjuntar tiquete'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Descargar tiquete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['viaje','pasajeros']).count()>0&&tiquetesaereo.getIn(['viaje','pasajeros']).map(function(x,n){var fileid=x.getIn(['tiquete','adjunto'])?x.getIn(['tiquete','adjunto','id']):null;var filename=x.getIn(['tiquete','adjunto','nombre'])?x.getIn(['tiquete','adjunto','nombre']):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+n+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',onClick:function onClick(){return _this2.props.displayModalAddTiquete(true,'Agregar tiquete',n);},disabled:tiquetesaereo.get('estado')!=4||!Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',tiquetesaereo)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['tiquete','numero_tiquete'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(x.getIn(['tiquete','valor_pagado'])).format('$0,0.00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['tiquete','fecha_compra'])?__WEBPACK_IMPORTED_MODULE_2_moment___default()(x.getIn(['tiquete','fecha_compra'])).format('DD/MM/YYYY'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['tiquete','aerolinea'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Or\xEDgen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Destino'),tipo_trayecto==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha regreso'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,x.getIn(['tiquete','itinerarios']).map(function(t,ti){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'ite['+n+']['+ti+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('origen')+'-'+t.get('aeropuerto_origen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_salida')).format('DD/MM/YYYY hh:mm A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('destino')+'-'+t.get('aeropuerto_destino')),tipo_trayecto==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_llegada')).format('DD/MM/YYYY hh:mm A')));})))),tiquetesaereo.get('estado')==4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['tiquete','adjunto'])?''+x.getIn(['tiquete','adjunto','nombre']):'Archivo sin adjuntar'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:x.getIn(['tiquete','adjunto'])?function(){return _this2.props.downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+x.getIn(['tiquete','adjunto','nombre']))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalAddTiquete__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('modalAddTiquete.data.tiquete.adjunto');}}));}}]);return Tiquetes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.tiquetesaereo.get('id'),tiquetesaereo:state.tiquetesaereo.get('solicitud')};}function mapDispatchToProps(dispatch){return{displayModalAddTiquete:function displayModalAddTiquete(show,title,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__["n" /* displayModalAddTiquete */])(show,title,index));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__["d" /* addFile */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["h" /* downloadFile */])(id,filename));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Tiquetes));

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddTiquete=function(_Component){_inherits(ModalAddTiquete,_Component);function ModalAddTiquete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddTiquete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddTiquete.__proto__||Object.getPrototypeOf(ModalAddTiquete)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddTiquete');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddTiquete .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddTiquete(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddTiquete,[{key:'render',value:function render(){var _this2=this;var modalAddTiquete=this.props.modalAddTiquete;if(!modalAddTiquete.get('show')){return null;}var tipo_trayecto=modalAddTiquete.getIn(['data','viaje','tipo_trayecto']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalAddTiquete',show:true,ZIndex:2000,width:820},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.editPasajero(modalAddTiquete.get('index'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:modalAddTiquete.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddTiquete.get('btnDisabled'),title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Aerol\xEDnea/Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddTiquete.getIn(['data','tiquete','aerolinea'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.aerolinea',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',colSpan:tipo_trayecto==1?6:4},'Trayectos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Or\xEDgen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hora salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Destino'),tipo_trayecto==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Hora regreso')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalAddTiquete.getIn(['data','tiquete','itinerarios']).map(function(t,ti){var fecha_salida=t.get('fecha_salida').split(' ')[0];var hora_salida=t.get('fecha_salida').split(' ')[1];var fecha_llegada=t.get('fecha_llegada')?t.get('fecha_llegada').split(' ')[0]:__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).format('DD/MM/YYY');var hora_llegada=t.get('fecha_llegada')?t.get('fecha_llegada').split(' ')[1]:__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).format('hh:mm A');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'itep['+ti+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('origen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:fecha_salida||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.itinerarios.'+ti+'.fecha_salida',e.target.value+' '+hora_salida);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'time',value:hora_salida||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.itinerarios.'+ti+'.fecha_salida',fecha_salida+' '+e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('destino')),tipo_trayecto==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:fecha_llegada||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.itinerarios.'+ti+'.fecha_llegada',e.target.value+' '+hora_llegada);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'time',value:hora_llegada||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.itinerarios.'+ti+'.fecha_llegada',fecha_llegada+' '+e.target.value);}}))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'N\xFAmero tiquete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddTiquete.getIn(['data','tiquete','numero_tiquete'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.numero_tiquete',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tiquete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',modalAddTiquete.getIn(['data','tiquete','adjunto'])?modalAddTiquete.getIn(['data','tiquete','adjunto','file']).name:' Seleccione un archivo...')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:modalAddTiquete.getIn(['data','tiquete','fecha_compra'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.fecha_compra',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddTiquete.getIn(['data','tiquete','valor_pagado'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddTiquete.data.tiquete.valor_pagado',e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalAddTiquete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddTiquete:state.tiquetesaereo.get('modalAddTiquete')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddTiquete:function displayModalAddTiquete(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["n" /* displayModalAddTiquete */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));},editPasajero:function editPasajero(index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["q" /* editPasajero */])(index));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddTiquete));

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAddAsistencia__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Asistencia=function(_Component){_inherits(Asistencia,_Component);function Asistencia(){_classCallCheck(this,Asistencia);return _possibleConstructorReturn(this,(Asistencia.__proto__||Object.getPrototypeOf(Asistencia)).apply(this,arguments));}_createClass(Asistencia,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,tiquetesaereo=_props.tiquetesaereo;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Registro de asistencias compradas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-tiquetes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'No. Pasaj.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'No. Voucher'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'12%'}},'Valor asistencia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Fecha compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'16%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Destino'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'12%'}},tiquetesaereo.get('estado')==4?'Adjuntar voucher':'Descargar voucher'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['viaje','pasajeros']).count()>0&&tiquetesaereo.getIn(['viaje','pasajeros']).map(function(x,n){var fileid=x.getIn(['asistencia','adjunto','id'])?x.getIn(['asistencia','adjunto','id']):null;var filename=x.getIn(['asistencia','adjunto','nombre'])?x.getIn(['asistencia','adjunto','nombre']):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+n+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',onClick:function onClick(){return _this2.props.displayModalAddAsistencia(true,'Agregar asistencia al viajero',n);},disabled:tiquetesaereo.get('estado')<4||tiquetesaereo.get('estado')>6})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['asistencia','numero_voucher'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['asistencia','valor'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['asistencia','fecha_compra'])?__WEBPACK_IMPORTED_MODULE_2_moment___default()(x.getIn(['asistencia','fecha_compra'])).format('DD/MM/YYYY'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['asistencia','proveedor'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['asistencia','pais_destino'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(x.getIn(['asistencia','fecha_salida'])).format('DD/MM/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(x.getIn(['asistencia','fecha_regreso'])).format('DD/MM/YYYY')),x.getIn(['asistencia','adjunto','id'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:function onClick(){return _this2.props.downloadFile(fileid,filename);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+x.getIn(['asistencia','adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['asistencia','adjunto','file'])?x.getIn(['asistencia','adjunto','file']).name:'Archivo sin adjuntar'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalAddAsistencia__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('modalAddAsistencia.data.asistencia.adjunto');}}));}}]);return Asistencia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.tiquetesaereo.get('id'),tiquetesaereo:state.tiquetesaereo.get('solicitud')};}function mapDispatchToProps(dispatch){return{displayModalAddAsistencia:function displayModalAddAsistencia(show,title,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__["l" /* displayModalAddAsistencia */])(show,title,index));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_tiquetesaereo__["d" /* addFile */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["h" /* downloadFile */])(id,filename));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Asistencia));

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddAsistencia=function(_Component){_inherits(ModalAddAsistencia,_Component);function ModalAddAsistencia(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddAsistencia);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddAsistencia.__proto__||Object.getPrototypeOf(ModalAddAsistencia)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddAsistencia');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddAsistencia .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddAsistencia(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddAsistencia,[{key:'render',value:function render(){var _this2=this;var modalAddAsistencia=this.props.modalAddAsistencia;if(!modalAddAsistencia.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalAddAsistencia',show:true,ZIndex:2000,width:820},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.editAsistencia(modalAddAsistencia.get('index'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:modalAddAsistencia.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddAsistencia.get('btnDisabled'),title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddAsistencia.getIn(['data','asistencia','proveedor'])||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pa\xEDs destino'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha regreso'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,modalAddAsistencia.getIn(['data','asistencia','pais_destino'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalAddAsistencia.getIn(['data','asistencia','fecha_salida'])).format('DD/MM/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalAddAsistencia.getIn(['data','asistencia','fecha_regreso'])).format('DD/MM/YYYY'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'N\xFAmero voucher'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddAsistencia.getIn(['data','asistencia','numero_voucher'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddAsistencia.data.asistencia.numero_voucher',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Voucher'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),modalAddAsistencia.getIn(['data','asistencia','adjunto','id'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,modalAddAsistencia.getIn(['data','asistencia','adjunto'])?modalAddAsistencia.getIn(['data','asistencia','adjunto','nombre']):' Seleccione un archivo...'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,modalAddAsistencia.getIn(['data','asistencia','adjunto'])?modalAddAsistencia.getIn(['data','asistencia','adjunto','file']).name:' Seleccione un archivo...'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:modalAddAsistencia.getIn(['data','asistencia','fecha_compra'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddAsistencia.data.asistencia.fecha_compra',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddAsistencia.getIn(['data','asistencia','valor'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddAsistencia.data.asistencia.valor',e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalAddAsistencia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddAsistencia:state.tiquetesaereo.get('modalAddAsistencia')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddAsistencia:function displayModalAddAsistencia(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["l" /* displayModalAddAsistencia */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));},editAsistencia:function editAsistencia(index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_tiquetesaereo__["p" /* editAsistencia */])(index));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddAsistencia));

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_tiquetesaereo__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tiquetes=function(_Component){_inherits(Tiquetes,_Component);function Tiquetes(){_classCallCheck(this,Tiquetes);return _possibleConstructorReturn(this,(Tiquetes.__proto__||Object.getPrototypeOf(Tiquetes)).apply(this,arguments));}_createClass(Tiquetes,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,tiquetesaereo=_props.tiquetesaereo;var estado=tiquetesaereo.get('estado');if(!id)return null;var tipo_trayecto=tiquetesaereo.getIn(['viaje','tipo_trayecto']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Cierre de tiquetes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25px',textAlign:'center'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pasajero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'No. Tiquete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Aerol\xEDnea/Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'70%'}},'Trayectos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tiquetesaereo.getIn(['viaje','pasajeros']).count()>0&&tiquetesaereo.getIn(['viaje','pasajeros']).map(function(x,n){var pasajero=x.get('nombres')+' '+x.get('apellidos');//const hoy = new Date(2019, 5, 15)
var hoy=new Date();var expirados=x.getIn(['tiquete','itinerarios']).filter(function(i){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(i.get('fecha_salida'))<__WEBPACK_IMPORTED_MODULE_2_moment___default()(hoy);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+n+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,pasajero),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['tiquete','numero_tiquete'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['tiquete','aerolinea'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Or\xEDgen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Destino'),tipo_trayecto==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha regreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'\xBFSe cumpli\xF3 el viaje?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observaciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,expirados.map(function(t,ti){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'ite['+n+']['+ti+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('origen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_salida')).format('DD/MM/YYYY hh:mm A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('destino')),tipo_trayecto==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_llegada')).format('DD/MM/YYYY hh:mm A')),estado<7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:t.get('cumplido')==null?"-1":t.get('cumplido'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.pasajeros.'+n+'.tiquete.itinerarios.'+ti+'.cumplido',e.target.value);},disabled:estado!=6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'-1',disabled:true},'Seleccione una opci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'No cumpli\xF3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Si cumpli\xF3'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,''+(t.get('cumplido')==1?'Si cumplió':'No cumplió')),estado<7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:2,cols:20,className:'form-control input-sm',value:t.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.viaje.pasajeros.'+n+'.tiquete.itinerarios.'+ti+'.observaciones',e.target.value);},disabled:estado!=6})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{height:'50px'}},t.get('observaciones')));})))));})))));}}]);return Tiquetes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.tiquetesaereo.get('id'),tiquetesaereo:state.tiquetesaereo.get('solicitud')};}function mapDispatchToProps(dispatch){return{displayModalAddTiquete:function displayModalAddTiquete(show,title,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_tiquetesaereo__["n" /* displayModalAddTiquete */])(show,title,index));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_tiquetesaereo__["d" /* addFile */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["h" /* downloadFile */])(id,filename));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Tiquetes));

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_tiquetesaereo__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancelacion=function(_Component){_inherits(Cancelacion,_Component);function Cancelacion(){_classCallCheck(this,Cancelacion);return _possibleConstructorReturn(this,(Cancelacion.__proto__||Object.getPrototypeOf(Cancelacion)).apply(this,arguments));}_createClass(Cancelacion,[{key:'render',value:function render(){var _this2=this;var solicitud=this.props.solicitud;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de cancelaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitud.get('fecha_cancelacion')).format('YYYY-MM-DD')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de cancelaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitud.get('motivo_cancelacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.motivo_cancelacion',e.target.value);},disabled:solicitud.get('estado')==0}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Cancelacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitud:state.tiquetesaereo.get('solicitud')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_tiquetesaereo__["G" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cancelacion));

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_otrosi__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_solicitudservicioot__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SolicitudServicioOT_General__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SolicitudServicioOT_Aprobaciones__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SolicitudServicioOT_Documentos__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SolicitudServicioOT_Cancelacion__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SolicitudServicio_General__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SolicitudServicio_Aprobaciones__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SolicitudServicio_Documentos__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SolicitudServicio_Cancelacion__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SolicitudBI_General__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SolicitudBI_Aprobaciones__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_SolicitudBI_Documentos__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_SolicitudBI_Cancelacion__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//actions
//----
var Otrosi=function(_Component){_inherits(Otrosi,_Component);function Otrosi(props){_classCallCheck(this,Otrosi);var _this=_possibleConstructorReturn(this,(Otrosi.__proto__||Object.getPrototypeOf(Otrosi)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar la solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.state.cancelarOtrosi();});};_this.state={tabs:[{component:null}],selected:0,load:true};return _this;}_createClass(Otrosi,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){this.props.getSolicitudOS(this.props.match.params.id);this.props.getParameterByName('DIVISAS');}else{__WEBPACK_IMPORTED_MODULE_4__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){switch(nextProps.tipo_solicitud){case 1:if(this.props.match.params.id){this.props.getSolicitudServicio(this.props.match.params.id);}else{__WEBPACK_IMPORTED_MODULE_4__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');}this.setState({tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_SolicitudServicio_General__["a" /* default */],null),estado:0},{id:1,caption:'Aprobaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_SolicitudServicio_Aprobaciones__["a" /* default */],null),estado:0},{id:2,caption:'Documentos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_SolicitudServicio_Documentos__["a" /* default */],null),estado:4},{id:3,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_SolicitudServicio_Cancelacion__["a" /* default */],null),estado:4}],selected:this.state.selected,load:true,cancelarOtrosi:this.props.cancelarServicio});break;case 3:if(this.props.match.params.id){this.props.getSolicitudServicioOT(this.props.match.params.id);}else{__WEBPACK_IMPORTED_MODULE_4__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');}this.setState({tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_SolicitudServicioOT_General__["a" /* default */],null),estado:0},{id:1,caption:'Aprobaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_SolicitudServicioOT_Aprobaciones__["a" /* default */],null),estado:0},{id:2,caption:'Documentos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_SolicitudServicioOT_Documentos__["a" /* default */],null),estado:4},{id:3,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SolicitudServicioOT_Cancelacion__["a" /* default */],null),estado:4}],selected:this.state.selected,load:true,cancelarOtrosi:this.props.cancelarServicioOT});break;case 6:case 7:if(this.props.match.params.id){this.props.getSolicitudBienes(this.props.match.params.id);}else{__WEBPACK_IMPORTED_MODULE_4__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');}this.setState({tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_SolicitudBI_General__["a" /* default */],null),estado:0},{id:1,caption:'Aprobaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_SolicitudBI_Aprobaciones__["a" /* default */],null),estado:2},{id:2,caption:'Documentos',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_SolicitudBI_Documentos__["a" /* default */],null),estado:2},{id:3,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SolicitudBI_Cancelacion__["a" /* default */],null),estado:4}],selected:this.state.selected,load:true,cancelarOtrosi:this.props.cancelarBienes});break;}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,estado=_props.estado,solicitud=_props.solicitud,user=_props.user;//const esResponsableCompras = solicitud.getIn(['responsable_compras', 'id']) == user.get('id') || user.get('es_superusuario')
var readOnly=!Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',title:'Guardar',onClick:function onClick(){return _this2.props.updateSolicitudBI();},disabled:this.props.tipo_solicitud!=6&&this.props.tipo_solicitud!=7||estado>1||estado==0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'ban',onClick:function onClick(){return _this2.cancel();},title:'Aprobar cancelaci\xF3n solicitud',disabled:readOnly||selected!==3||estado==0})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){if(solicitud.get('documentos')&&x.id===2&&solicitud.get('documentos').count()===0)return null;if(estado==7&&x.id==3)return null;if(estado==0){return x.id==0||x.id==3;}return true;}).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li01['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},this.state.load&&tabs[selected].component)))));}}]);return Otrosi;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{estado:state.otrosi.get('estado'),solicitud:state.otrosi.get('solicitud'),tipo_solicitud:state.otrosi.getIn(['solicitud','documento_origen','solicitude','tipo'])};}function mapDispatchToProps(dispatch){return{getSolicitudOS:function getSolicitudOS(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_otrosi__["b" /* getSolicitud */])(id));},getSolicitudServicioOT:function getSolicitudServicioOT(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_solicitudservicioot__["k" /* getSolicitud */])(id));},getSolicitudServicio:function getSolicitudServicio(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__["r" /* getSolicitud */])(id));},getSolicitudBienes:function getSolicitudBienes(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["r" /* getSolicitud */])(id));},updateSolicitudBI:function updateSolicitudBI(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["G" /* updateSolicitudBI */])());},cancelarServicio:function cancelarServicio(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_solicitudservicio__["v" /* registerCancelacion */])());},cancelarServicioOT:function cancelarServicioOT(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_solicitudservicioot__["n" /* registerCancelacion */])());},cancelarBienes:function cancelarBienes(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudbi__["u" /* registerCancelacion */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_common__["l" /* getParameterByName */])(nombre));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Otrosi));

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_busquedadocumento__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_store__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ENTER_KEY=13;var BusquedaDocumentos=function(_Component){_inherits(BusquedaDocumentos,_Component);function BusquedaDocumentos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BusquedaDocumentos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BusquedaDocumentos.__proto__||Object.getPrototypeOf(BusquedaDocumentos)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnKeyDown=function(key){if(key===ENTER_KEY){_this.props.buscarDocumento();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BusquedaDocumentos,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.reiniciarEstado();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,tipo=_props.tipo,busqueda=_props.busqueda,documentos=_props.documentos,enums=_props.enums;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Layout_BoxButton__["a" /* default */],{key:'ba[11][0]',name:'search',onClick:function onClick(e){return _this2.props.buscarDocumento();},title:'Buscar documento'})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Layout_Box__["a" /* default */],{title:'B\xFAsqueda de documentos',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',height:'100%',justifyContent:'space-between',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:tipo||'',onChange:function onChange(e){return _this2.props.updateInputs('tipo',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'Todos'),enums.getIn(['documentos','tipos']).valueSeq().map(function(x){if(x.get('CODIGO')==4)return null;if(x.get('CODIGO')==6)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[3]['+x.get('CODIGO')+']',value:x.get('CODIGO')},x.get('NOMBRE'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Consecutivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:busqueda||'',onChange:function onChange(e){return _this2.props.updateInputs('busqueda',e.target.value);},onKeyDown:function onKeyDown(e){return _this2.handleOnKeyDown(e.keyCode);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderTop:'1px solid #ddd'}},documentos.map(function(x,n){if(x.get('tipo')==4)return null;var docName=enums.getIn(['documentos','tipos',String(x.get('tipo')),'NOMBRE']);var prefix=enums.getIn(['documentos','tipos',String(x.get('tipo')),'PREFIJO']);var estado=enums.getIn(['documentos','estados',String(x.get('estado'))]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:x.get('id'),className:'documento-search-result',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_6__utils_history__["a" /* default */].push(window.FOLDER+('/documentos/'+x.get('id')));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{fontSize:'1.2em'}},docName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-primary'},prefix,x.get('consecutivo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'No. Solicitud:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'100'}},x.getIn(['solicitude','id']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Estado:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'100'}},' ',estado,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Actividad/Evento:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'100'}},x.getIn(['solicitude','proyecto_evento']))));})))))))));}}]);return BusquedaDocumentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{documentos:state.busquedadocumento.get('documentos'),tipo:state.busquedadocumento.get('tipo'),busqueda:state.busquedadocumento.get('busqueda'),enums:state.common.get('enums')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_busquedadocumento__["c" /* updateInputs */])(path,value));},buscarDocumento:function buscarDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_busquedadocumento__["a" /* buscarDocumento */])());},reiniciarEstado:function reiniciarEstado(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_busquedadocumento__["b" /* reiniciarEstado */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(BusquedaDocumentos));

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buscarDocumento;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["b"] = reiniciarEstado;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(3);
function buscarDocumento(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var tipo=getState().busquedadocumento.get('tipo');var busqueda=getState().busquedadocumento.get('busqueda');axios.get(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* API_URL */]+'/documentos/busqueda',{params:{busqueda:busqueda,tipo:tipo}}).then(function(res){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_2__types__["_31" /* BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS */],payload:{data:res.data}});};fn1(dispatch);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* displayMessages */])(dispatch,err);});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_30" /* BUSQUEDADOCUMENTO_MODIFICAR_INPUTS */],payload:{path:path,value:value}});};}function reiniciarEstado(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["_32" /* BUSQUEDADOCUMENTO_REINICIAR_ESTADO */]});};}

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Documento___ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Contrato___ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TipoDocumento=function(_Component){_inherits(TipoDocumento,_Component);function TipoDocumento(){_classCallCheck(this,TipoDocumento);return _possibleConstructorReturn(this,(TipoDocumento.__proto__||Object.getPrototypeOf(TipoDocumento)).apply(this,arguments));}_createClass(TipoDocumento,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){this.props.getDocumento(this.props.match.params.id);}this.props.getParameterByName('ALMACEN');}},{key:'render',value:function render(){var documento=this.props.documento;switch(documento.get('tipo')){case 5:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Contrato___["a" /* default */],{documento:documento});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Documento___["a" /* default */],{documento:documento});}}}]);return TipoDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{documento:state.documentos.getIn(['modalSummary','data'])};}function mapDispatchToProps(dispatch){return{getDocumento:function getDocumento(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_documentos__["e" /* getDocumento */])(id));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["l" /* getParameterByName */])(nombre));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TipoDocumento));

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Documentos_General__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Documentos_Aprobacion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Documentos_DocumentosAsociados__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Documentos_Entregas__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Documentos_Adiciones__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Documentos_Facturas__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Documentos_Cancelacion__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Documentos_ModalCreateEntrega__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Documentos_ModalAddFactura__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Documentos_ModalLastFactura__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Documentos_ModalAddAdicional__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Documento=function(_Component){_inherits(Documento,_Component);function Documento(props){_classCallCheck(this,Documento);var _this=_possibleConstructorReturn(this,(Documento.__proto__||Object.getPrototypeOf(Documento)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar este documento?',function(){_this.props.showModalConfirmarAccion(false);_this.props.cancelDocumento();});};_this.state={tabs:[{id:0,caption:'Documento',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Documentos_General__["a" /* default */],null),estado:0},{id:1,caption:'Aprobación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Documentos_Aprobacion__["a" /* default */],null),estado:0},{id:2,caption:'Documentos asociados',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Documentos_DocumentosAsociados__["a" /* default */],null),estado:1},{id:3,caption:'Ajustes',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Documentos_Adiciones__["a" /* default */],null),estado:0},{id:4,caption:'Entregas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Documentos_Entregas__["a" /* default */],null),estado:0},{id:5,caption:'Facturas',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Documentos_Facturas__["a" /* default */],null),estado:6},{id:6,caption:'Cancelación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Documentos_Cancelacion__["a" /* default */],null),estado:0}],selected:0};return _this;}_createClass(Documento,[{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,documento=_props.documento,user=_props.user,modalSummary=_props.modalSummary;if(!documento)return null;if(!documento.get('solicitude'))return null;var editar=modalSummary.get('editar');var boxActions=[];//if (selected === 2) boxActions = [ <BoxButton name="plus-circle" title="Asociar documento" onClick={ e => alert('hola') } />]
if(selected===6)boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{name:'ban',title:'Cancelar documento',onClick:function onClick(){return _this2.cancel();},disabled:documento.get('estado')==0})];if(Object(__WEBPACK_IMPORTED_MODULE_18__utils_helpers__["E" /* isAllowedToViewComponent */])('responsables_recibo',documento,user.get('id'))&&documento.get('estado')!==11){if(selected===3)boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{key:'boxbtn[0]',name:'plus-circle',title:'Crear adici\xF3n',onClick:function onClick(e){return _this2.props.showHideModalAddAdicional(true,documento.get('id'),'','');}})];}if(Object(__WEBPACK_IMPORTED_MODULE_18__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',documento.get('solicitude'))){if(selected===0)boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Layout_BoxButton__["a" /* default */],{key:'boxbtn[1]',name:'floppy-o',title:'Actualizar documento',onClick:function onClick(){return _this2.props.updateDocumento();},disabled:!editar})];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){return x.estado<=documento.get('estado');}).map(function(x){if(documento.get('estado')==11&&x.id==6)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Documentos_ModalCreateEntrega__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Documentos_ModalAddFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Documentos_ModalLastFactura__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Documentos_ModalAddAdicional__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Documento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{modalSummary:state.documentos.get('modalSummary'),user:state.common.get('user')};}function mapDispatchToProps(dispatch){return{showHideModalAddAdicional:function showHideModalAddAdicional(show,documento,url,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_documentos__["i" /* showHideModalAddAdicional */])(show,documento,url,type));},cancelDocumento:function cancelDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_documentos__["c" /* cancelDocumento */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},updateDocumento:function updateDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__actions_documentos__["m" /* updateDocumento */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Documento));

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Documentos_Contrato__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Documentos_Cancelacion__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContratoAnual_ModalAddFirmas__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_documentos__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_contratoanual__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Contrato=function(_Component){_inherits(Contrato,_Component);function Contrato(props){_classCallCheck(this,Contrato);var _this=_possibleConstructorReturn(this,(Contrato.__proto__||Object.getPrototypeOf(Contrato)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar este documento?',function(){_this.props.showModalConfirmarAccion(false);_this.props.cancelDocumento();});};_this.renew=function(result){if(result==1)_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea renovar este contrato?',function(){_this.props.showModalConfirmarAccion(false);_this.props.renewContrato(1);});else _this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea no renovar este contrato?',function(){_this.props.showModalConfirmarAccion(false);_this.props.renewContrato(0);});};_this.state={tabs:[{id:0,caption:'Documento',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Documentos_Contrato__["a" /* default */],null),estado:0},{id:1,caption:'Cierre',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Documentos_Cancelacion__["a" /* default */],null),estado:0}],selected:0};return _this;}_createClass(Contrato,[{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var documento=this.props.documento;if(!documento)return null;if(!documento.get('solicitude'))return null;var solicitud=documento.get('solicitude');var documentos_solicitud=solicitud.get('documentos');var id=documento.get('id');var docs_en_espera=documentos_solicitud.filter(function(x){return x.get('id')!=id&&x.get('tipo')==5&&x.get('estado')==13;});var docs_en_proceso=documentos_solicitud.filter(function(x){return x.get('id')!=id&&x.get('tipo')==5&&x.get('estado')>0&&x.get('estado')<11;});var enableBtn=true;// enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-11-30`) 
enableBtn=enableBtn&&__WEBPACK_IMPORTED_MODULE_2_moment___default()().isAfter(new Date().getFullYear()+'-02-03');enableBtn=enableBtn&&docs_en_espera.count()==0;enableBtn=enableBtn&&documento.get('estado')==12;enableBtn=enableBtn&&docs_en_proceso.count()==0;var boxActions=[];if(this.state.selected===0&&enableBtn){boxActions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'btn1',name:'history',title:'Renovar contrato',onClick:function onClick(e){return _this2.renew(1);}}));}if(this.state.selected===0){boxActions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'btn2',name:'cloud-upload',title:'Cerrar solicitud',onClick:function onClick(e){return _this2.props.showHideModalAddFirmas(true,solicitud);},disabled:documento.get('estado')!=3}));}if(this.state.selected===1&&enableBtn){boxActions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'btn4',id:'btn4',name:'hand-stop-o',title:'No renovar contrato',onClick:function onClick(e){return _this2.renew(0);},disabled:documento.get('estado')==14}));}if(this.state.selected===1){boxActions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'btn3',name:'ban',title:'Cancelar orden/contrato',onClick:function onClick(e){return _this2.cancel();},disabled:documento.get('estado')==0||documento.get('estado')==14}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){return x.estado<=documento.get('estado');}).map(function(x){if(documento.get('estado')>=3&&documento.get('estado')<12&&x.id==1)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContratoAnual_ModalAddFirmas__["a" /* default */],null));}}]);return Contrato;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{};}function mapDispatchToProps(dispatch){return{showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},cancelDocumento:function cancelDocumento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_documentos__["c" /* cancelDocumento */])());},renewContrato:function renewContrato(result){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_contratoanual__["g" /* renewContrato */])(result));},showHideModalAddFirmas:function showHideModalAddFirmas(show,documentos){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_contratoanual__["h" /* showHideModalAddFirmas */])(show,documentos));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Contrato));

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Reportes_EvaluacionProveedor__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reportes_MontoContratadoProveedor__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Reportes_MontoContratadoCenco__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Reportes_CumplimientoResponsableCompras__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Reportes_Radicados__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Reportes_GestionResponsableCompras__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Reportes_ReporteTiquetes__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Reportes_ReporteHoteles__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reportes_ReporteDocumentos__ = __webpack_require__(688);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportesContainer=function(_React$Component){_inherits(ReportesContainer,_React$Component);function ReportesContainer(props){_classCallCheck(this,ReportesContainer);var _this=_possibleConstructorReturn(this,(ReportesContainer.__proto__||Object.getPrototypeOf(ReportesContainer)).call(this,props));var tabs=[{id:0,caption:"Documentos",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Reportes_ReporteDocumentos__["a" /* default */],null)},{id:1,caption:"Tiquetes",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Reportes_ReporteTiquetes__["a" /* default */],null)},{id:2,caption:"Hoteles",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Reportes_ReporteHoteles__["a" /* default */],null)},{id:3,caption:"Evaluación proveedor",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Reportes_EvaluacionProveedor__["a" /* default */],null)},{id:4,caption:"Monto contratado proveedor",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Reportes_MontoContratadoProveedor__["a" /* default */],null)},{id:5,caption:"Monto contratado cenco",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Reportes_MontoContratadoCenco__["a" /* default */],null)},{id:6,caption:"Cumplimiento responsable compras",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Reportes_CumplimientoResponsableCompras__["a" /* default */],null)},{id:7,caption:"Gestión responsable compras",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Reportes_GestionResponsableCompras__["a" /* default */],null)},{id:8,caption:"Radicados",component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Reportes_Radicados__["a" /* default */],null)}];_this.state={tabs:tabs,selected:0};return _this;}_createClass(ReportesContainer,[{key:'selectTab',value:function selectTab(tabId){this.setState({selected:tabId});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tab-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-tabs'},tabs.map(function(tab){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li02['+tab.id+']',className:selected===tab.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(tab.id);}},tab.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component)))));}}]);return ReportesContainer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReportesContainer);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.solicitudes.estados[value];}else if(c.value==='tipo'){value=enums.solicitudes.tipos[value].caption;}return value;}var EvaluacionProveedor=function(_React$Component){_inherits(EvaluacionProveedor,_React$Component);function EvaluacionProveedor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EvaluacionProveedor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EvaluacionProveedor.__proto__||Object.getPrototypeOf(EvaluacionProveedor)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(list){var columns=[{id:1,caption:'Nit',value:'identificacion',width:'30%'},{id:2,caption:'Razon Social',value:'nombre',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',payload);};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EvaluacionProveedor,[{key:'handleChangeProvider',value:function handleChangeProvider(value){return this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',{path:'provider',value:value});}},{key:'newPageOfResults',value:function newPageOfResults(pg){this.props.search(pg);}},{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_evaluacion_proveedores';var params={proveedor_id:this.props.reportes.getIn(['provider_evaluation','provider','id']),proveedor_nombre:this.props.reportes.getIn(['provider_evaluation','provider','nombre']),fecha_inicio:this.props.reportes.getIn(['provider_evaluation','initial_date']),fecha_fin:this.props.reportes.getIn(['provider_evaluation','final_date']),filters:this.props.reportes.getIn(['provider_evaluation','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS(),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,reportes=_props.reportes,enums=_props.enums,accumulate=_props.accumulate,orderBy=_props.orderBy,showRecords=_props.showRecords,totalRecords=_props.totalRecords,page=_props.page;var tableCols=[{id:1,caption:'Tipo Solicitud',value:'Tipo_Solicitud',type:'number',format:'',width:'8%',enums:Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["o" /* extractKeyValue */])(enums.solicitudes.tipos,'caption')},{id:2,caption:'No. Solicitud',value:'Numero_Solicitud',type:'number',format:'',width:'6.5%'},{id:3,caption:'Fecha Solicitud',value:'Fecha_Solicitud',type:'datetime',format:'YYYY-MM-DD',width:'7.3%'},{id:4,caption:'No. Orden/Contrato',value:'Orden_Contrato',type:'string',format:'',width:'7.7%'},{id:5,caption:'Fecha Orden/Contrato',value:'Fecha_Documento',type:'datetime',format:'YYYY-MM-DD',width:'7.7%'},{id:6,caption:'Valor Orden/Contrato',value:'Valor',type:'number',format:'$ 0,0[.]00',width:'8%'},{id:7,caption:'Descripción',value:'Descripcion',type:'string',format:'',width:'7.7%'},{id:8,caption:'Fecha Entrega Oficial',value:'Fecha_oficial',type:'datetime',format:'YYYY-MM-DD',width:'8.6%'},{id:9,caption:'Fecha Entrega Real',value:'Fecha_real',type:'datetime',format:'YYYY-MM-DD',width:'8%'},{id:10,caption:'CAL',value:'Calidad',type:'number',format:'',width:'3%'},{id:11,caption:'CUM',value:'Cumplimiento',type:'number',format:'',width:'3.5%'},{id:12,caption:'SER',value:'Gestion_servicio',type:'number',format:'',width:'3%'},{id:13,caption:'Observaciones Evaluación',value:'observaciones',type:'string',format:'',width:'8%'}];var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'search',title:'Buscar',onClick:function onClick(e){return _this2.newPageOfResults(1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'file-pdf-o',onClick:function onClick(e){return _this2.downloadFile('pdf');},title:'Descargar PDF'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:this.props.showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.newPageOfResults(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-right'})});var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:reportes.getIn(['provider_evaluation','provider'])?reportes.getIn(['provider_evaluation','provider','nombre']):'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('provider_evaluation.provider');},onReset:function onReset(){return _this2.handleChangeProvider(null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['provider_evaluation','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("provider_evaluation.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['provider_evaluation','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("provider_evaluation.final_date",e.target.value);}}))),accumulate.size?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accumulate-report'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nota:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,accumulate.get('puntaje_total'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Estado:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,reportes.getIn(["provider_evaluation","state_eval"])))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accumulate-report'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Calidad:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,accumulate.get('calidad'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cumplimiento:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,accumulate.get('cumplimiento'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Gesti\xF3n del servicio:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,accumulate.get('gestion_servicio')))))))):null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Reporte evaluaci\xF3n de proveedor',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,pagination:pagination,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeNumberRecordsToShow(records);},formRequest:formRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content table-responsive',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted',id:'table-evaluacion-proveedor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,tableCols.map(function(x){var style={width:''+x.width,verticalAlign:"middle"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},title:x.caption,className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reportes.getIn(['provider_evaluation','data']).size>0?reportes.getIn(['provider_evaluation','data']).map(function(x){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('Id')+']',className:x.get('selected')?'info':''},tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.id===1){value=enums.solicitudes.tipos[value].caption;}else if(c.type){switch(c.type){case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format):'';alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=value!=null?__WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format(c.format):'';alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_9__utils_history__["a" /* default */].push(window.FOLDER+('/solicitudes/'+enums.solicitudes.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalFilter__["a" /* default */],null));}}]);return EvaluacionProveedor;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes,orderBy:reportes.getIn(['provider_evaluation','orderBy']),accumulate:reportes.getIn(['provider_evaluation','accumulate']),enums:state.common.get('enums').toJS(),showRecords:reportes.getIn(['provider_evaluation','showRecords']),totalRecords:reportes.getIn(['provider_evaluation','totalRecords']),page:reportes.getIn(['provider_evaluation','page'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'provider_evaluation'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["l" /* setOrderBy */])(field,'provider_evaluation'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'provider_evaluation'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["f" /* getEvaluacionProveedor */])(page));},downloadFile:function downloadFile(url,params,tipo){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["d" /* downloadFile */])(url,params,'Evaluaci\xF3n Proveedores.'+tipo));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(EvaluacionProveedor));

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.solicitudes.estados[value];}else if(c.value==='tipo'){value=enums.solicitudes.tipos[value].caption;}return value;}var MontoContratadoProveedor=function(_React$Component){_inherits(MontoContratadoProveedor,_React$Component);function MontoContratadoProveedor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MontoContratadoProveedor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MontoContratadoProveedor.__proto__||Object.getPrototypeOf(MontoContratadoProveedor)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(list){var columns=[{id:1,caption:'Nit',value:'identificacion',width:'30%'},{id:2,caption:'Razon Social',value:'nombre',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',payload);};_this.props.showModalSelector('Listado de proveedores',columns,'/proveedores',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MontoContratadoProveedor,[{key:'handleChangeProvider',value:function handleChangeProvider(value){return this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',{path:'provider',value:value});}},{key:'newPageOfResults',value:function newPageOfResults(page){this.props.search(page);}},{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_monto_contratado_proveedor';var params={proveedor_id:this.props.reportes.getIn(['contracted_amount_providers','provider','id']),proveedor_nombre:this.props.reportes.getIn(['contracted_amount_providers','provider','nombre']),fecha_inicio:this.props.reportes.getIn(['contracted_amount_providers','initial_date']),fecha_fin:this.props.reportes.getIn(['contracted_amount_providers','final_date']),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,reportes=_props.reportes,enums=_props.enums,orderBy=_props.orderBy,showRecords=_props.showRecords,totalRecords=_props.totalRecords,page=_props.page;var tableCols=[{id:1,caption:'Proveedor',value:'proveedor',type:'string',format:'',width:'25%'},{id:2,caption:'Valor Comprado',value:'cantidad_comprada',type:'number',format:'$ 0,0[.]00',width:'25%'},{id:3,caption:'Valor ejecutado',value:'valor_ejecutado',type:'number',format:'$ 0,0[.]00',width:'25%'},{id:4,caption:'Valor comprometido',value:'valor_comprometido',type:'number',format:'$ 0,0[.]00',width:'25%'}];var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'search',title:'Buscar',onClick:function onClick(e){return _this2.newPageOfResults(1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'file-pdf-o',onClick:function onClick(e){return _this2.downloadFile('pdf');},title:'Descargar PDF'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.newPageOfResults(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-right'})});var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:reportes.getIn(['contracted_amount_providers','provider'])?reportes.getIn(['contracted_amount_providers','provider','nombre']):'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('contracted_amount_providers.provider');},onReset:function onReset(){return _this2.handleChangeProvider(null);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['contracted_amount_providers','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("contracted_amount_providers.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['contracted_amount_providers','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("contracted_amount_providers.final_date",e.target.value);}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Reporte monto contratado por proveedor',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,pagination:pagination,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeNumberRecordsToShow(records);},formRequest:formRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',height:'100%',justifyContent:'space-between',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-evaluacion-proveedor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reportes.getIn(['contracted_amount_providers','data']).size>0?reportes.getIn(['contracted_amount_providers','data']).map(function(x,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('proveedor_id')+index+']',className:x.get('selected')?'info':''},tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format):'';alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_9__utils_history__["a" /* default */].push(window.FOLDER+('/solicitudes/'+enums.solicitudes.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length},'No existen registros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalFilter__["a" /* default */],null));}}]);return MontoContratadoProveedor;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes,orderBy:reportes.getIn(['contracted_amount_providers','orderBy']),enums:state.common.get('enums').toJS(),showRecords:reportes.getIn(['contracted_amount_providers','showRecords']),totalRecords:reportes.getIn(['contracted_amount_providers','totalRecords']),page:reportes.getIn(['contracted_amount_providers','page'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'contracted_amount_providers'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["l" /* setOrderBy */])(field,'contracted_amount_providers'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'contracted_amount_providers'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["i" /* getMontoContratadoProveedor */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["d" /* downloadFile */])(url,params,'Monto contratado de proveedores.'+type));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MontoContratadoProveedor));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.solicitudes.estados[value];}else if(c.value==='tipo'){value=enums.solicitudes.tipos[value].caption;}return value;}var MontoContratadoCenco=function(_React$Component){_inherits(MontoContratadoCenco,_React$Component);function MontoContratadoCenco(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MontoContratadoCenco);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MontoContratadoCenco.__proto__||Object.getPrototypeOf(MontoContratadoCenco)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorUsuarios=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/cencos',fn);},_this.handleOpenSelectorCenco=function(list){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripción',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',payload);};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.reportes.getIn(['responsable','id']),comparison:'string'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MontoContratadoCenco,[{key:'handleClearCenco',value:function handleClearCenco(){this.props.updateInputs('cenco',null);this.props.updateInputs('responsable',null);}},{key:'newPageOfResults',value:function newPageOfResults(page){this.props.search(page);}},{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_monto_contratado_cenco';var params={cenco_id:this.props.reportes.getIn(['cenco','id']),cenco_nombre:this.props.reportes.getIn(['cenco','descripcion']),responsable_id:this.props.reportes.getIn(['responsable','id']),responsable_nombre:this.props.reportes.getIn(['responsable','fullname']),fecha_inicio:this.props.reportes.getIn(['contracted_amount_cencos','initial_date']),fecha_fin:this.props.reportes.getIn(['contracted_amount_cencos','final_date']),filters:this.props.reportes.getIn(['contracted_amount_cencos','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS(),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,reportes=_props.reportes,enums=_props.enums,showRecords=_props.showRecords,totalRecords=_props.totalRecords,page=_props.page;var tableCols=[{id:1,caption:'Cenco',value:'cenco',type:'string',format:'',width:'25%'},{id:2,caption:'Valor Comprado',value:'cantidad_comprada',type:'number',format:'$ 0,0[.]00',width:'25%'},{id:3,caption:'Valor ejecutado',value:'valor_ejecutado',type:'number',format:'$ 0,0[.]00',width:'25%'},{id:4,caption:'Valor comprometido',value:'valor_comprometido',type:'number',format:'$ 0,0[.]00',width:'25%'}];var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'search',title:'Buscar',onClick:function onClick(e){return _this2.newPageOfResults(1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'file-pdf-o',onClick:function onClick(e){return _this2.downloadFile('pdf');},title:'Descargar PDF'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.newPageOfResults(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-right'})});var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Due\xF1o de cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:reportes.get('responsable')?reportes.getIn(['responsable','fullname']):'',onClick:function onClick(){return _this2.handleOpenSelectorUsuarios('responsable');},onReset:function onReset(){return _this2.handleClearCenco();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cenco'),reportes.get('responsable')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:reportes.get('cenco')?reportes.getIn(['cenco','descripcion']):'',onClick:function onClick(){return _this2.handleOpenSelectorCenco('cenco');},onReset:function onReset(){return _this2.props.updateInputs('cenco',null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',placeholder:'Seleccione un responsable del cenco',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-3 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['contracted_amount_cencos','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("contracted_amount_cencos.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['contracted_amount_cencos','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("contracted_amount_cencos.final_date",e.target.value);}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Reporte monto contratado por cenco',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,pagination:pagination,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeNumberRecordsToShow(records);},formRequest:formRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',height:'100%',justifyContent:'space-between',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-evaluacion-proveedor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reportes.getIn(['contracted_amount_cencos','data']).size>0?reportes.getIn(['contracted_amount_cencos','data']).map(function(x,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('proveedor_id')+index+']',className:x.get('selected')?'info':''},tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format):'';alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_9__utils_history__["a" /* default */].push(window.FOLDER+('/solicitudes/'+enums.solicitudes.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length},'No existen registros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalFilter__["a" /* default */],null));}}]);return MontoContratadoCenco;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes,enums:state.common.get('enums').toJS(),showRecords:reportes.getIn(['contracted_amount_cencos','showRecords']),totalRecords:reportes.getIn(['contracted_amount_cencos','totalRecords']),page:reportes.getIn(['contracted_amount_cencos','page'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'contracted_amount_cencos'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'contracted_amount_cencos'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["h" /* getMontoContratadoCenco */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["d" /* downloadFile */])(url,params,'Monto contratado por cenco.'+type));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MontoContratadoCenco));

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(!value){return value;}if(c.value==='tipo_solicitud'){value=enums.solicitudes.tipos[value].caption;}else if(c.value==='evento'){value=enums.etapas[value];}return value;}var CumplimientoResponsableCompras=function(_React$Component){_inherits(CumplimientoResponsableCompras,_React$Component);function CumplimientoResponsableCompras(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CumplimientoResponsableCompras);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CumplimientoResponsableCompras.__proto__||Object.getPrototypeOf(CumplimientoResponsableCompras)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorProveedor=function(list){var columns=[{id:1,caption:'Id',value:'username',width:'30%'},{id:2,caption:'Nombres',value:'nombres',width:'35%'},{id:3,caption:'Apellidos',value:'apellidos',width:'35%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',payload);};_this.props.showModalSelector('Listado de responsables de compras',columns,'/solicitudes/get_responsable_compras',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CumplimientoResponsableCompras,[{key:'newPageOfResults',value:function newPageOfResults(pg){this.props.search(pg);}},{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_cumplimiento_responsable_compras';var responsable_nombre=null;if(this.props.reportes.getIn(['purchasing_manager','username'])){responsable_nombre=this.props.reportes.getIn(['purchasing_manager','nombres'])+" "+this.props.reportes.getIn(['purchasing_manager','apellidos']);}var filters=this.props.reportes.getIn(['compliance_purchasing_manager','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS();var indexEtapa=filters.findIndex(function(f){return f.column==='evento';});if(indexEtapa>=0){var evento=filters[indexEtapa];var etapas=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.getIn(['enums','etapas']).filter(function(e){return e==evento.value;});if(etapas.count()){var value=etapas.keySeq().toArray().join('|');var operator=evento.operator==="!=="?"NOT REGEXP":"REGEXP";filters=[].concat(_toConsumableArray(filters.slice(0,indexEtapa)),[{"column":"evento","operator":operator,"value":value,"comparison":"string"}],_toConsumableArray(filters.slice(indexEtapa+1)));}}var params={responsable_id:this.props.reportes.getIn(['purchasing_manager','username']),responsable_nombre:responsable_nombre,filters:filters,type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,reportes=_props.reportes,enums=_props.enums,orderBy=_props.orderBy,showRecords=_props.showRecords,totalRecords=_props.totalRecords,page=_props.page;var tableCols=[{id:1,caption:'Responsable Compras',value:'responsable',type:'string',format:'',width:'20%'},{id:2,caption:'Tipo Solicitud',value:'tipo_solicitud',type:'string',width:'17%',enums:Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["o" /* extractKeyValue */])(enums.solicitudes.tipos,'caption')},{id:3,caption:'No. Solicitud',value:'numero_solicitud',type:'number',width:'10%'},{id:4,caption:'Orden/Contrato',value:'numero_documento',type:'string',width:'11%'},{id:5,caption:'OTROSÍ',value:'otrosi',type:'string',width:'10%'},{id:6,caption:'Etapa',value:'evento',type:'string',width:'20%',enums:Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["o" /* extractKeyValue */])(enums.etapasFilter)},{id:7,caption:'Horas',value:'horas',type:'number',format:'0,0[.]00',width:'10%'}];var filters_cols=[{id:1,caption:'Responsable Compras',value:'responsable',type:'string',format:'',width:'20%'},{id:2,caption:'Tipo Solicitud',value:'tipo_solicitud',type:'string',width:'17%',enums:Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["o" /* extractKeyValue */])(enums.solicitudes.tipos,'caption')},{id:3,caption:'No. Solicitud',value:'numero_solicitud',type:'number',width:'10%'},{id:4,caption:'Orden/Contrato',value:'numero_documento',type:'string',width:'11%'},{id:5,caption:'OTROSÍ',value:'otrosi',type:'string',width:'10%'},{id:6,caption:'Etapa',value:'evento',type:'string',width:'20%',enums:Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["o" /* extractKeyValue */])(enums.etapasFilter)}];var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'search',title:'Buscar',onClick:function onClick(e){return _this2.newPageOfResults(1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,filters_cols);},title:'Filtro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'file-pdf-o',onClick:function onClick(e){return _this2.downloadFile('pdf');},title:'Descargar PDF'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.newPageOfResults(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-right'})});var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable Compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:reportes.get('purchasing_manager')?reportes.getIn(['purchasing_manager','nombres'])+" "+reportes.getIn(['purchasing_manager','apellidos']):'',onClick:function onClick(){return _this2.handleOpenSelectorProveedor('purchasing_manager');},onReset:function onReset(){return _this2.props.updateInputs('purchasing_manager',null);}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Reporte cumplimiento del responsable de compras',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,pagination:pagination,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeNumberRecordsToShow(records);},formRequest:formRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',height:'100%',justifyContent:'space-between',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-cumplimiento-responsable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reportes.getIn(['compliance_purchasing_manager','data']).size>0?reportes.getIn(['compliance_purchasing_manager','data']).map(function(x,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('responsable')+index+']',className:x.get('selected')?'info':''},tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format):'';alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('responsable')+']['+c.id+']',style:style},value);}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length},'No existen registros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalFilter__["a" /* default */],null));}}]);return CumplimientoResponsableCompras;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes,orderBy:reportes.getIn(['compliance_purchasing_manager','orderBy']),enums:state.common.get('enums').toJS(),showRecords:reportes.getIn(['compliance_purchasing_manager','showRecords']),totalRecords:reportes.getIn(['compliance_purchasing_manager','totalRecords']),page:reportes.getIn(['compliance_purchasing_manager','page'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'compliance_purchasing_manager'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["l" /* setOrderBy */])(field,'compliance_purchasing_manager'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'compliance_purchasing_manager'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["e" /* getCumplimientoResponsableCompras */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["d" /* downloadFile */])(url,params,'Cumplimiento responsable compras.'+type));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CumplimientoResponsableCompras));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_immutable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_immutable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.solicitudes.estados[value];}else if(c.value==='tipo'){value=enums.solicitudes.tipos[value].caption;}return value;}var Radicados=function(_React$Component){_inherits(Radicados,_React$Component);function Radicados(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Radicados);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Radicados.__proto__||Object.getPrototypeOf(Radicados)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorResponsableCompras=function(list){var columns=[{id:1,caption:'Username',value:'USUARIO',width:'30%'},{id:2,caption:'Nombres',value:'NOMBRES',width:'45%'},{id:3,caption:'Almacén',value:'ALMACEN',width:'25%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',payload);};_this.props.showModalSelector('Listado de responsable del almacén',columns,'/solicitudes/bienes-investigacion/responsables-almacen',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Radicados,[{key:'componentWillMount',// constructor(props) {
//     super(props);
//     this.state = {
//         page: 1
//     };
// }
value:function componentWillMount(){this.props.getParameterByName('ALMACEN');}},{key:'newPageOfResults',value:function newPageOfResults(pg){this.props.search(pg);}},{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_radicados';var params={// usuario_id: this.props.reportes.getIn(['storage_manage', 'USUARIO']),
// usuario_nombre: this.props.reportes.getIn(['storage_manage', 'NOMBRES']),
fecha_inicio:this.props.reportes.getIn(['radicados','initial_date']),fecha_fin:this.props.reportes.getIn(['radicados','final_date']),almacen:this.props.reportes.get('storage'),filters:this.props.reportes.getIn(['radicados','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS(),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,reportes=_props.reportes,enums=_props.enums,orderBy=_props.orderBy,showRecords=_props.showRecords,totalRecords=_props.totalRecords,almacenes=_props.almacenes,page=_props.page;var tableCols=[{id:1,caption:'Almacén',value:'almacen',type:'string',format:'',width:'6%',enums:Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["o" /* extractKeyValue */])(almacenes,'ALMACEN','ALMACEN')},{id:2,caption:'Responsable de compras',value:'responsable_compras',type:'string',format:'',width:'13%'},{id:3,caption:'Usuario almacén',value:'usuario',type:'string',format:'',width:'13%'},{id:4,caption:'No. Solicitud',value:'solicitud_id',type:'string',format:'',width:'7.5%'},{id:5,caption:'No. Orden/Contrato',value:'orden_contrato',type:'string',format:'',width:'10.5%'},{id:6,caption:'Radicado',value:'n_radicado',type:'string',format:'',width:'6%'},{id:7,caption:'Valor factura',value:'valor_factura',type:'number',format:'$ 0,0[.]00',width:'8%'},{id:8,caption:'Nombre proveedor',value:'nombre_proveedor',type:'string',format:'',width:'12%'},{id:9,caption:'NIT proveedor',value:'nit_proveedor',type:'number',width:'8%'},{id:10,caption:'Descripción del servicio',value:'concepto',type:'string',width:'13%'}];var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'search',title:'Buscar',onClick:function onClick(e){return _this2.newPageOfResults(1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'file-pdf-o',onClick:function onClick(e){return _this2.downloadFile('pdf');},title:'Descargar PDF'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.newPageOfResults(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-right'})});var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Almac\xE9n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:reportes.get('storage')||0,onChange:function onChange(e){return _this2.props.updateInputs('storage',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:""},'Ninguno'),almacenes&&almacenes.map(function(almacen,ialmacen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt[0]['+ialmacen+']',value:almacen.get('ALMACEN')},almacen.get('ALMACEN'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['radicados','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("radicados.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['radicados','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("radicados.final_date",e.target.value);}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Reporte de radicados',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,pagination:pagination,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeNumberRecordsToShow(records);},formRequest:formRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',height:'100%',justifyContent:'space-between',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-evaluacion-proveedor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reportes.getIn(['radicados','data']).size>0?reportes.getIn(['radicados','data']).map(function(x,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('proveedor_id')+index+']',className:x.get('selected')?'info':''},tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format):'';alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.id===10&&value){value=value.split(',').map(function(v,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:'serv['+(i+1)+']',style:{margin:'0'}},v);});}if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_9__utils_history__["a" /* default */].push(window.FOLDER+('/solicitudes/'+enums.solicitudes.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length},'No existen registros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalFilter__["a" /* default */],null));}}]);return Radicados;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes,orderBy:reportes.getIn(['radicados','orderBy']),enums:state.common.get('enums').toJS(),almacenes:state.common.getIn(['parametros','ALMACEN']),showRecords:reportes.getIn(['radicados','showRecords']),totalRecords:reportes.getIn(['radicados','totalRecords']),page:reportes.getIn(['radicados','page'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'radicados'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["l" /* setOrderBy */])(field,'radicados'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'radicados'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["j" /* getReporteRadicados */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["d" /* downloadFile */])(url,params,'Radicados.'+type));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["l" /* getParameterByName */])(nombre));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Radicados));

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.solicitudes.estados[value];}else if(c.value==='tipo'){value=enums.solicitudes.tipos[value].caption;}return value;}var GestionResponsableCompras=function(_React$Component){_inherits(GestionResponsableCompras,_React$Component);function GestionResponsableCompras(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GestionResponsableCompras);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GestionResponsableCompras.__proto__||Object.getPrototypeOf(GestionResponsableCompras)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelectorResponsableCompras=function(list){var columns=[{id:1,caption:'Username',value:'USUARIO',width:'30%'},{id:2,caption:'Nombres',value:'NOMBRES',width:'45%'},{id:3,caption:'Almacén',value:'ALMACEN',width:'25%'}];var payload={};var fn=function fn(a){payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES',payload);};_this.props.showModalSelector('Listado de proveedores',columns,'/solicitudes/bienes-investigacion/responsables-almacen',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GestionResponsableCompras,[{key:'newPageOfResults',value:function newPageOfResults(pg){this.props.search(pg);}},{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_gestion_responsable_compras';var params={fecha_inicio:this.props.reportes.getIn(['manage_purchasing_manager','initial_date']),fecha_fin:this.props.reportes.getIn(['manage_purchasing_manager','final_date']),tipo_solicitud:this.props.reportes.get('request_type'),filters:this.props.reportes.getIn(['manage_purchasing_manager','modalFilter','filters']).filter(function(column){return column.get('apply');}).toJS(),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,reportes=_props.reportes,enums=_props.enums,orderBy=_props.orderBy,showRecords=_props.showRecords,totalRecords=_props.totalRecords,page=_props.page;var tableCols=[{id:1,caption:'Responsable compras',value:'responsable',type:'string',format:'',width:'25%'},{id:2,caption:'Tipo solicitud',value:'tipo',type:'string',format:'',width:'8%',enums:Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["o" /* extractKeyValue */])(enums.solicitudes.tipos,'caption')},{id:3,caption:'Total Solicitudes',value:'total_solicitudes',type:'number',format:'0,0',width:'8%'},{id:4,caption:'Gestionadas',value:'gestionados',type:'number',format:'0,0',width:'10%'},{id:5,caption:'Sin gestionar',value:'no_gestionados',type:'number',format:'0,0',width:'10%'},{id:6,caption:'Total Documentos',value:'total_documentos',type:'number',format:'0,0',width:'20%'},{id:7,caption:'Ordenes',value:'ordenes',type:'number',format:'0,0',width:'20%'},{id:8,caption:'Contratos',value:'contratos',type:'number',format:'0,0',width:'20%'},{id:9,caption:'Compras directas',value:'facturas',type:'number',format:'0,0',width:'40%'}];var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][0]',name:'search',title:'Buscar',onClick:function onClick(e){return _this2.newPageOfResults(1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'file-pdf-o',onClick:function onClick(e){return _this2.downloadFile('pdf');},title:'Descargar PDF'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.newPageOfResults(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_fontawesome___default.a,{name:'angle-double-right'})});var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['manage_purchasing_manager','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("manage_purchasing_manager.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['manage_purchasing_manager','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("manage_purchasing_manager.final_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-sm-6 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'request_type',name:'request_type',checked:reportes.get('request_type'),onChange:function onChange(e){return _this2.props.updateInputs('request_type',e.target.checked);},style:{width:'20px',height:'20px',marginRight:'5px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'request_type',className:'control-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:'left',marginTop:'10px'}},'Tipo solicitud')))))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_Box__["a" /* default */],{title:'Reporte de Gesti\xF3n de Responsable de Compras',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,pagination:pagination,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeNumberRecordsToShow(records);},formRequest:formRequest}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',height:'100%',justifyContent:'space-between',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap text-center',id:'table-evaluacion-proveedor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'30%',colSpan:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'30%',colSpan:'3',className:'text-center'},'Solicitudes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'40%',colSpan:'4',className:'text-center'},'Documentos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:'text-center '+(orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''),title:x.caption},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reportes.getIn(['manage_purchasing_manager','data']).size>0?reportes.getIn(['manage_purchasing_manager','data']).map(function(x,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('proveedor_id')+index+']',className:x.get('selected')?'info':''},tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(reportes.getIn(['manage_purchasing_manager','show_request_type'])&&c.value==='tipo'){value="";}if(c.type){switch(c.type){case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format):'';alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_4_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_9__utils_history__["a" /* default */].push(window.FOLDER+('/solicitudes/'+enums.solicitudes.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length},'No existen registros'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,reportes.getIn(['manage_purchasing_manager','accumulate']).size>0&&reportes.getIn(['manage_purchasing_manager','accumulate']).map(function(x,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'acc['+index+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'},colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Totales:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(x.get('total_solicitudes',0)).format('0,0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(x.get('total_gestionados',0)).format('0,0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(x.get('total_no_gestionados',0)).format('0,0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(x.get('total_documentos',0)).format('0,0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(x.get('total_ordenes',0)).format('0,0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(x.get('total_contratos',0)).format('0,0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_4_numeral___default()(x.get('total_facturas',0)).format('0,0')));}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalFilter__["a" /* default */],null));}}]);return GestionResponsableCompras;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes,orderBy:reportes.getIn(['manage_purchasing_manager','orderBy']),enums:state.common.get('enums').toJS(),showRecords:reportes.getIn(['manage_purchasing_manager','showRecords']),totalRecords:reportes.getIn(['manage_purchasing_manager','totalRecords']),page:reportes.getIn(['manage_purchasing_manager','page'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'manage_purchasing_manager'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["l" /* setOrderBy */])(field,'manage_purchasing_manager'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'manage_purchasing_manager'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["g" /* getGestionResponsableCompras */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["d" /* downloadFile */])(url,params,'GestionResponsableCompras.'+type));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GestionResponsableCompras));

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReporteTiquetes=function(_React$Component){_inherits(ReporteTiquetes,_React$Component);function ReporteTiquetes(){_classCallCheck(this,ReporteTiquetes);return _possibleConstructorReturn(this,(ReporteTiquetes.__proto__||Object.getPrototypeOf(ReporteTiquetes)).apply(this,arguments));}_createClass(ReporteTiquetes,[{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_reporte_documentos_tiquetes';var params={fecha_inicio:this.props.reportes.getIn(['document_reporter_tickets','initial_date']),fecha_fin:this.props.reportes.getIn(['document_reporter_tickets','final_date']),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var reportes=this.props.reportes;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'})];var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['document_reporter_tickets','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("document_reporter_tickets.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['document_reporter_tickets','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("document_reporter_tickets.final_date",e.target.value);}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Reporte de tiquetes',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,formRequest:formRequest}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ModalFilter__["a" /* default */],null));}}]);return ReporteTiquetes;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'document_reporter_tickets'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["l" /* setOrderBy */])(field,'document_reporter_tickets'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'document_reporter_tickets'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["j" /* getReporteRadicados */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["d" /* downloadFile */])(url,params,'document_reporter_tickets.'+type));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["l" /* getParameterByName */])(nombre));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ReporteTiquetes));

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReporteHoteles=function(_React$Component){_inherits(ReporteHoteles,_React$Component);function ReporteHoteles(){_classCallCheck(this,ReporteHoteles);return _possibleConstructorReturn(this,(ReporteHoteles.__proto__||Object.getPrototypeOf(ReporteHoteles)).apply(this,arguments));}_createClass(ReporteHoteles,[{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_reporte_documentos_hoteles';var params={fecha_inicio:this.props.reportes.getIn(['document_reporter_hotels','initial_date']),fecha_fin:this.props.reportes.getIn(['document_reporter_hotels','final_date']),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var reportes=this.props.reportes;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'})];var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['document_reporter_hotels','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("document_reporter_hotels.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['document_reporter_hotels','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("document_reporter_hotels.final_date",e.target.value);}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Reporte de hoteles',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,formRequest:formRequest}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ModalFilter__["a" /* default */],null));}}]);return ReporteHoteles;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'document_reporter_hotels'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["l" /* setOrderBy */])(field,'document_reporter_hotels'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'document_reporter_hotels'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["j" /* getReporteRadicados */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["d" /* downloadFile */])(url,params,'document_reporter_hotels.'+type));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["l" /* getParameterByName */])(nombre));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ReporteHoteles));

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_reportes__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReporteDocumentos=function(_React$Component){_inherits(ReporteDocumentos,_React$Component);function ReporteDocumentos(){_classCallCheck(this,ReporteDocumentos);return _possibleConstructorReturn(this,(ReporteDocumentos.__proto__||Object.getPrototypeOf(ReporteDocumentos)).apply(this,arguments));}_createClass(ReporteDocumentos,[{key:'downloadFile',value:function downloadFile(type_report){var url='/reportes/download_reporte_documentos';var params={// usuario_id: this.props.reportes.getIn(['storage_manage', 'USUARIO']),
// usuario_nombre: this.props.reportes.getIn(['storage_manage', 'NOMBRES']),
fecha_inicio:this.props.reportes.getIn(['document_reporter','initial_date']),fecha_fin:this.props.reportes.getIn(['document_reporter','final_date']),type_report:type_report};return this.props.downloadFile(url,params,type_report);}},{key:'render',value:function render(){var _this2=this;var reportes=this.props.reportes;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'file-excel-o',onClick:function onClick(e){return _this2.downloadFile('xlsx');},title:'Descargar excel'})];var formRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'initial_date',className:'control-label'},'Fecha Inicial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'initial_date',value:reportes.getIn(['document_reporter','initial_date']),onChange:function onChange(e){return _this2.props.updateInputs("document_reporter.initial_date",e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 col-sm-4 col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'final_date',className:'control-label'},'Fecha Final'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'final_date',value:reportes.getIn(['document_reporter','final_date']),onChange:function onChange(e){return _this2.props.updateInputs("document_reporter.final_date",e.target.value);}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-sm-12 col-xs-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Layout_Box__["a" /* default */],{title:'Reporte de documentos',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_ButtonStrip__["a" /* default */],{actions:boxActions,formRequest:formRequest}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalSelectorFromList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ModalFilter__["a" /* default */],null));}}]);return ReporteDocumentos;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){var reportes=state.reportes;return{reportes:reportes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
showModalSelector:function showModalSelector(title,fields,url,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["y" /* showModalSelector */])(title,fields,url,action));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["m" /* showHideModalFilter */])(state,tableCols,'document_reporter'));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["l" /* setOrderBy */])(field,'document_reporter'));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["q" /* selectFromSelector */])(type,payload));},changeNumberRecordsToShow:function changeNumberRecordsToShow(number){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["c" /* changeNumberRegisterToShow */])(number,'document_reporter'));},search:function search(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["j" /* getReporteRadicados */])(page));},downloadFile:function downloadFile(url,params,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["d" /* downloadFile */])(url,params,'document_reporter.'+type));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_common__["l" /* getParameterByName */])(nombre));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_reportes__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ReporteDocumentos));

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ExternosCotizaciones_ModalFilter__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ExternosCotizaciones_ModalSummary__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ExternosCotizaciones_ModalSummaryCotizaciones__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalDelete__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function findValues(c,x){var enums=__WEBPACK_IMPORTED_MODULE_13__utils_store__["a" /* default */].getState().common.get('enums').toJS();var value=x.getIn(c.value.split('.'));if(c.value==='estado'){value=enums.cotizaciones.estados[value];}return value;}var ExternosCotizaciones=function(_Component){_inherits(ExternosCotizaciones,_Component);function ExternosCotizaciones(){_classCallCheck(this,ExternosCotizaciones);return _possibleConstructorReturn(this,(ExternosCotizaciones.__proto__||Object.getPrototypeOf(ExternosCotizaciones)).apply(this,arguments));}_createClass(ExternosCotizaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getCotizaciones(1);this.props.getParameterByName('DIVISAS');}},{key:'render',value:function render(){var _this2=this;var tableCols=[{id:1,caption:'Solicitud',value:'solicitud_id',type:'number',format:'',width:'10%'},{id:2,caption:'Proyecto/Evento/Actividad',value:'proyecto_evento',type:'string',format:'',width:'20%'},{id:3,caption:'Fecha límite cotización',value:'fecha_cotizaciones',type:'datetime',format:'YYYY-MM-DD',width:'20%'},{id:4,caption:'Responsable compras',value:'responsable_compras',type:'string',format:'',width:'15%'},{id:5,caption:'Servicio',value:'descripcion',type:'string',format:'',width:'25%'},{id:6,caption:'Fecha entrega',value:'fecha_requerido',type:'datetime',format:'YYYY-MM-DD',width:'10%'}];var _props=this.props,cotizaciones=_props.cotizaciones,orderBy=_props.orderBy,page=_props.page,totalRecords=_props.totalRecords,showRecords=_props.showRecords,enums=_props.enums;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'filter',onClick:function onClick(e){return _this2.props.showHideModalFilter(true,tableCols);},title:'Filtro'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.getCotizaciones(__WEBPACK_IMPORTED_MODULE_16__utils_history__["a" /* default */].location.pathname,pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'angle-double-right'})});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_Box__["a" /* default */],{title:'Listado de cotizaciones pendientes',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-cotizaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23px'}}),tableCols.map(function(x){var style={width:''+x.width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.id+']',style:style,onClick:function onClick(e){return _this2.props.setOrderBy(x);},className:orderBy.get('field')===x.value?orderBy.get('asc')?'asc':'desc':''},x.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,cotizaciones.filter(function(x){return x.get('visible');}).count()>0?cotizaciones.filter(function(x){return x.get('visible');}).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('solicitud_id')+'-'+n+']',className:x.get('selected')?'info':''},x.get('id')!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{size:12,name:'binoculars',onClick:function onClick(){return _this2.props.showHideModalSummary(true,x.get('id'));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{size:12,name:'binoculars',onClick:function onClick(){return _this2.props.showHideModalSummaryCotizaciones(true,x.get('solicitud_id'));}})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.type){switch(c.type){case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.format):null;alignment='right';break;case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.format);alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_16__utils_history__["a" /* default */].push(window.FOLDER+('/cotizaciones/'+enums.cotizaciones.tipos[x.get('tipo')].url+'/'+x.get('id')));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.id+']',style:style},value);}}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:tableCols.length+1},'No existen registros'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ExternosCotizaciones_ModalFilter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ExternosCotizaciones_ModalSummary__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ExternosCotizaciones_ModalSummaryCotizaciones__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('modalSummary.data.adjunto');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_ModalDelete__["a" /* default */],null));}}]);return ExternosCotizaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{cotizaciones:state.externoscotizaciones.get('cotizaciones'),orderBy:state.externoscotizaciones.get('orderBy'),totalRecords:state.externoscotizaciones.get('totalRecords'),showRecords:state.externoscotizaciones.get('showRecords'),page:state.externoscotizaciones.get('page'),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{getCotizaciones:function getCotizaciones(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["f" /* getCotizaciones */])(page));},filterCotizaciones:function filterCotizaciones(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["e" /* filterCotizaciones */])(term));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["j" /* setOrderBy */])(field));},changeRecordsToShow:function changeRecordsToShow(records){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["d" /* changeRecordsToShow */])(records));},showHideModalFilter:function showHideModalFilter(state,tableCols){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["k" /* showHideModalFilter */])(state,tableCols));},showHideModalSummary:function showHideModalSummary(show,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["l" /* showHideModalSummary */])(show,index));},showHideModalSummaryCotizaciones:function showHideModalSummaryCotizaciones(show,solicitud_id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["m" /* showHideModalSummaryCotizaciones */])(show,solicitud_id));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_externoscotizaciones__["a" /* addFile */])(path));},getParameterByName:function getParameterByName(nombre){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__actions_common__["l" /* getParameterByName */])(nombre));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ExternosCotizaciones));

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_externoscotizaciones__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { tableCols } from '../../containers/ExternosAprobaciones'
var ModalFilter=function(_Component){_inherits(ModalFilter,_Component);function ModalFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalFilter.__proto__||Object.getPrototypeOf(ModalFilter)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalFilter');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalFilter .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalFilter(false);},300);},_this.handleApplyFilters=function(e){_this.handleCloseModal();_this.props.applyFilterCriterias();},_this.showTypeInput=function(index,item){var _this$props=_this.props,modalFilter=_this$props.modalFilter,updateModalFilterCriteria=_this$props.updateModalFilterCriteria;var tableCols=modalFilter.get('columnas');var value=modalFilter.getIn(['filters',index,'column']);var col=tableCols.filter(function(c){return c.get('value')==value;}).first();if(col.get('enums')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}},col.get('enums').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+index+']['+n+']',value:x.get('value')},x.get('text'));}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:item.get('value'),onChange:function onChange(e){return updateModalFilterCriteria(index,'value',e.target.value);}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalFilter,[{key:'render',value:function render(){var _this2=this;var modalFilter=this.props.modalFilter;if(!modalFilter.get('show')){return null;}var tableCols=modalFilter.get('columnas');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalFilter',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:'Filtro',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalFilter");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'plus',onClick:function onClick(e){return _this2.props.addModalFilterCriteria();},title:'Aceptar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'trash',onClick:function onClick(e){return _this2.props.removeCheckedModalFilterCriterias();},disabled:modalFilter.get('filters').filter(function(item){return item.get('checked');}).count()===0,title:'Eliminar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',onClick:function onClick(e){return _this2.handleApplyFilters();},title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12',style:{height:'200px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Columna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Operador'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Filtro'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalFilter.get('filters').count()>0?modalFilter.get('filters').map(function(item,index){var key='tr2['+index+']';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key,className:''+(item.get('checked')?'info':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(e){return _this2.props.toggleCheckedModalFilterCriterias(index,e.target.checked);},checked:item.get('checked')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('column'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'column',e.target.value);}},tableCols.map(function(x1,n1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt1['+x1.get('id')+']['+n1+']',value:x1.get('value')},x1.get('caption'));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:item.get('operator'),onChange:function onChange(e){return _this2.props.updateModalFilterCriteria(index,'operator',e.target.value);}},__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["H" /* operators */].filter(function(x){return x.comparisons.includes(item.get('comparison'));}).map(function(item1,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt2['+item1.id+']['+n+']',value:item1.value},item1.caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.showTypeInput(index,item)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',style:{textAlign:'center'}},'No hay filtros')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalFilter:state.externoscotizaciones.get('modalFilter')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalFilter:function showHideModalFilter(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externoscotizaciones__["k" /* showHideModalFilter */])(state));},addModalFilterCriteria:function addModalFilterCriteria(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externoscotizaciones__["b" /* addModalFilterCriteria */])());},removeCheckedModalFilterCriterias:function removeCheckedModalFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externoscotizaciones__["i" /* removeCheckedModalFilterCriterias */])());},toggleCheckedModalFilterCriterias:function toggleCheckedModalFilterCriterias(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externoscotizaciones__["n" /* toggleCheckedModalFilterCriterias */])(index,checked));},updateModalFilterCriteria:function updateModalFilterCriteria(index,attr,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externoscotizaciones__["p" /* updateModalFilterCriteria */])(index,attr,value));},applyFilterCriterias:function applyFilterCriterias(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_externoscotizaciones__["c" /* applyFilterCriterias */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalFilter));

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_externoscotizaciones__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSummary=function(_Component){_inherits(ModalSummary,_Component);function ModalSummary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalSummary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalSummary.__proto__||Object.getPrototypeOf(ModalSummary)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('modalSummary');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSummary .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalSummary(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalSummary,[{key:'render',value:function render(){var _this2=this;var modalSummary=this.props.modalSummary;if(!modalSummary.get('show')){return null;}var tipo_solicitud=modalSummary.getIn(['data','solicitud','tipo']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalSummary',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:'Subir cotizaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSummary");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'check',title:'Enviar cotizaci\xF3n',onClick:function onClick(){return _this2.props.registerCotizacion(modalSummary.getIn(['data','id']),3);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'800px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','solicitud','responsable_compras','fullname']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','solicitud','responsable_compras','email']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','solicitud','responsable_compras','extension']),disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','solicitud','proyecto_evento']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalSummary.getIn(['data','solicitud','id']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalSummary.getIn(['data','solicitud','created_at'])).format('DD/MM/YYYY'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(modalSummary.getIn(['data','fecha_entrega'])).format('YYYY-MM-DD'),onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.fecha_entrega',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},tipo_solicitud===6||tipo_solicitud===7?"Descripción del bien":"Descripción del servicio"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:2,value:tipo_solicitud===6||tipo_solicitud===7?modalSummary.getIn(['data','bienes',0,'item','descripcion']):modalSummary.getIn(['data','servicios',0,'descripcion']),disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:tipo_solicitud===6||tipo_solicitud===7?modalSummary.getIn(['data','bienes',0,'cantidad_solicitada'])+' '+modalSummary.getIn(['data','bienes',0,'unidad'])+' ':modalSummary.getIn(['data','servicios',0,'cantidad']),disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Subir cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',modalSummary.getIn(['data','adjunto','file'])?modalSummary.getIn(['data','adjunto','file']).name:' Seleccione un archivo...')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-info'},'Incluir toda la informaci\xF3n necesaria en la cotizaci\xF3n o de lo contrario enviar la informaci\xF3n adicional al correo del Responsable de compras')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:modalSummary.getIn(['data','observaciones'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalSummary.data.observaciones',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSummary:state.externoscotizaciones.get('modalSummary'),enums:state.common.get('enums').toJS()};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalSummary:function showHideModalSummary(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_externoscotizaciones__["l" /* showHideModalSummary */])(state));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["u" /* showHideModalDelete */])(open,message,action));},registerCotizacion:function registerCotizacion(id,result){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_externoscotizaciones__["g" /* registerCotizacion */])(id,result));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_externoscotizaciones__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSummary));

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_externoscotizaciones__ = __webpack_require__(125);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSummaryCotizaciones=function(_Component){_inherits(ModalSummaryCotizaciones,_Component);function ModalSummaryCotizaciones(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalSummaryCotizaciones);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalSummaryCotizaciones.__proto__||Object.getPrototypeOf(ModalSummaryCotizaciones)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('modalSummaryCotizaciones');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalSummaryCotizaciones .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalSummaryCotizaciones(false);},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalSummaryCotizaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalSummaryCotizaciones=_props.modalSummaryCotizaciones,divisas=_props.divisas;if(!modalSummaryCotizaciones.get('show')){return null;}var solicitud=modalSummaryCotizaciones.getIn(['data','solicitud']);var solicitud_id=solicitud.get('id');var cotizaciones=solicitud.get('cotizaciones');var moneda=cotizaciones?cotizaciones.first().get('moneda'):'COP';var divisa=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["t" /* getDivisa */])(divisas,moneda);var cont_items=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_Modal__["a" /* default */],{id:'modalSummaryCotizaciones',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalHeader__["a" /* default */],{title:'Subir cotizaci\xF3n',onClose:function onClose(e){return _this2.handleCloseModal(e,"modalSummaryCotizaciones");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Layout_BoxButton__["a" /* default */],{name:'check',title:'Enviar cotizaci\xF3n',onClick:function onClick(){return _this2.props.registerSolicitudCotizaciones(solicitud_id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'Calc(100vw - 32px)',height:'Calc(100vh - 117px)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:solicitud.getIn(['responsable_compras','fullname']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:solicitud.getIn(['responsable_compras','email']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:solicitud.getIn(['responsable_compras','extension']),disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proyecto/Evento/Actividad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:solicitud.getIn(['proyecto_evento']),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:solicitud_id,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitud.getIn(['created_at'])).format('DD/MM/YYYY'),disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-info'},'Usted podr\xE1 cotizar por cada \xEDtem hasta dos opciones si lo desea, indicando la marca y el precio por cada uno, as\xED como el tiempo de entrega')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Archivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',solicitud.getIn(['cotizaciones',0,'adjunto','file'])?solicitud.getIn(['cotizaciones',0,'adjunto','file']).name:' Adjuntar cotización')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-tipo-moneda'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{maxWidth:'86%',padding:'0 10px'}},'Tipo de moneda:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{alignItems:'flex-end'},className:'btn-group',role:'group','aria-label':'Basic outlined example'},divisas&&divisas.map(function(d,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:'d['+i+']',style:{borderRadius:'5px'},type:'button',className:moneda==d.get('CODIGO')?'btn btn-primary':'btn btn-outline-primary'},d.get('CODIGO'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_Box__["a" /* default */],{title:'Cotizaciones',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:"Calc(100vh - 365px)",overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped',id:'comparativo-marcas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Descripci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Unidad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cant.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Marca'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. Unitario'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Vlr. con IVA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'D\xEDas h\xE1biles de entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No cotizar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,cotizaciones.filter(function(c){return c.get('proveedor_id');}).map(function(cotizacion,idx){var cantidad=Number(cotizacion.getIn(['bienes',0,'cantidad_solicitada']));var cotizado_iva=Number(cotizacion.get('cotizado_iva'));var valor_total=cantidad*cotizado_iva;var isnew=true;if(idx>0){var idant=cotizaciones.getIn([idx-1,'bienes',0,'id']);var idact=cotizacion.getIn(['bienes',0,'id']);if(idant===idact)isnew=false;}if(isnew)cont_items++;var tipo=cont_items%2;var style={backgroundColor:tipo===1?'#efefef':'#ffffff'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'cot['+cotizacion.get('id')+']['+cotizacion.get('proveedor_id')+']'},isnew&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:2,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px'}},cotizacion.getIn(['bienes',0,'descripcion']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:2,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px'}},cotizacion.getIn(['bienes',0,'observaciones']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:2,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'50px'}},cotizacion.getIn(['bienes',0,'unidad']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:2,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'50px'}},cotizacion.getIn(['bienes',0,'cantidad_solicitada'])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:cotizacion.get('marca')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalSummaryCotizaciones.data.solicitud.cotizaciones.'+idx+'.marca',e.target.value);},style:{width:'100px'},maxLength:500})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:cotizacion.get('cotizado')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalSummaryCotizaciones.data.solicitud.cotizaciones.'+idx+'.cotizado',e.target.value);},style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:cotizacion.get('iva')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalSummaryCotizaciones.data.solicitud.cotizaciones.'+idx+'.iva',e.target.value);},style:{width:'50px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'150px',textAlign:'right'}},valor_total?Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["q" /* formatcoin */])(valor_total,divisa.simbolo):Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["q" /* formatcoin */])(0,divisa.simbolo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:cotizacion.get('tiempo_entrega')||'',onChange:function onChange(e){return _this2.props.updateInputs('modalSummaryCotizaciones.data.solicitud.cotizaciones.'+idx+'.tiempo_entrega',e.target.value);},style:{width:'100px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:cotizacion.get('no_cotizar')||false,onChange:function onChange(e){return _this2.props.updateInputs('modalSummaryCotizaciones.data.solicitud.cotizaciones.'+idx+'.no_cotizar',e.target.checked);},disabled:true})));}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalSummaryCotizaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalSummaryCotizaciones:state.externoscotizaciones.get('modalSummaryCotizaciones'),divisas:state.common.getIn(['parametros','DIVISAS'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalSummaryCotizaciones:function showHideModalSummaryCotizaciones(state){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_externoscotizaciones__["m" /* showHideModalSummaryCotizaciones */])(state));},registerSolicitudCotizaciones:function registerSolicitudCotizaciones(solicitud_id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_externoscotizaciones__["h" /* registerSolicitudCotizaciones */])(solicitud_id));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_externoscotizaciones__["o" /* updateInputs */])(path,value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalSummaryCotizaciones));

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_creacionsolicitudservicioot__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__ = __webpack_require__(694);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreacionSolicitudHoteles=function(_Component){_inherits(CreacionSolicitudHoteles,_Component);function CreacionSolicitudHoteles(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreacionSolicitudHoteles);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreacionSolicitudHoteles.__proto__||Object.getPrototypeOf(CreacionSolicitudHoteles)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_HOTELES',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/cencos',fn);},_this.handleOpenSelectorAddCenco=function(list,index){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){var index=_this.props.creacionsolicitudhoteles.get('cencos').findIndex(function(c){return c.getIn(['cenco','id'])==a.id;});if(index>=0){__WEBPACK_IMPORTED_MODULE_3_react_toastify__["toast"].warn('El cenco '+a.codigo+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{payload.path=list;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_HOTELES',payload);}};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.creacionsolicitudhoteles.getIn(['cencos',index,'responsable','id']),comparison:'string'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_this.handleOpenSelectorAddHuesped=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addHuesped(payload);});};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreacionSolicitudHoteles,[{key:'render',value:function render(){var _this2=this;var _props=this.props,creacionsolicitudhoteles=_props.creacionsolicitudhoteles,enums=_props.enums;var tipos_identificacion=enums.tipos_identificacion;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.createSolicitudHoteles();},title:'Guardar'})];// const accionesAlojamientos = [
//     <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" title="Adicionar alojamiento" onClick={ () => this.props.addAlojamiento() }  disabled/>,
//     <BoxButton key="ba[1][1]" size={14} contrast name="trash" title="Eliminar alojamiento" onClick={ () => this.props.removeAlojamientos() } danger disabled />,
// ]
var actionsDistribucionCencos=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[2][0]',size:14,contrast:true,name:'plus-circle',title:'Nuevo',onClick:function onClick(){return _this2.props.addCencoSolicitud();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[2][1]',size:14,contrast:true,name:'trash',title:'Eliminar',onClick:function onClick(){return _this2.props.removeCenco();},danger:true})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Solicitud de hoteles > Creaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Solicitante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('fullname')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('email')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.get('extension')||'',className:'form-control input-sm',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.user.getIn(['area','nombre'])||'',className:'form-control input-sm',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacionsolicitudhoteles.get('tipo')].responsable.fullname||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:enums.solicitudes.tipos[creacionsolicitudhoteles.get('tipo')].responsable.email||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:enums.solicitudes.tipos[creacionsolicitudhoteles.get('tipo')].responsable.extension||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY/MM/DD'),disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n hospedaje'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo del hospedaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:creacionsolicitudhoteles.get('motivo_hospedaje')||'',onChange:function onChange(e){return _this2.props.updateInputs('motivo_hospedaje',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad hu\xE9spedes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'number',min:'1',max:'9',value:creacionsolicitudhoteles.get('cant_huespedes')||'',onChange:function onChange(e){return _this2.props.updateInputs('cant_huespedes',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Detalles de alojamiento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-alojamientos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Fecha ingreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Fecha salida'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudhoteles.get('alojamientos').map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:t.get('guid'),className:t.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},value:t.get('selected'),onChange:function onChange(e){return _this2.props.updateInputs('alojamientos.'+i+'.selected',e.target.value);},disabled:i==0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:t.get('ciudad')||'',onChange:function onChange(e){return _this2.props.updateInputs('alojamientos.'+i+'.ciudad',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_ingreso')||'',onChange:function onChange(e){return _this2.props.updateInputs('alojamientos.'+i+'.fecha_ingreso',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_salida')||'',onChange:function onChange(e){return _this2.props.updateInputs('alojamientos.'+i+'.fecha_salida',e.target.value);}})));}))),creacionsolicitudhoteles.get('alojamientos').map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table nowrap',key:t.get('id')+'-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'182px'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Consumo a la habitaci\xF3n '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:'form-control input-sm',value:t.get('consumo_habitacion'),onChange:function onChange(e){return _this2.props.updateInputs('alojamientos.'+i+'.consumo_habitacion',e.target.checked);}}),'  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Monto de consumo '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',style:{marginLeft:'5px',width:'100px'},value:t.get('monto_consumo')||'',onChange:function onChange(e){return _this2.props.updateInputs('alojamientos.'+i+'.monto_consumo',e.target.value);},disabled:!t.get('consumo_habitacion')}),' ')))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n de centros de costos',actions:actionsDistribucionCencos},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ordenador del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Centro de costo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,creacionsolicitudhoteles.get('cencos').count()>0?creacionsolicitudhoteles.get('cencos').map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+(x.get('id')?x.get('id'):x.get('guid'))+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{marginTop:'6px'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:x.getIn(['responsable','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('cencos.'+n+'.responsable');},onReset:function onReset(){return _this2.props.updateInputs('cencos.'+n+'.responsable',null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('responsable')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:x.get('cenco')?x.getIn(['cenco','codigo']):'',onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('cencos.'+n+'.cenco',n);},onReset:function onReset(){return _this2.props.updateInputs('cencos.'+n+'.cenco',null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',placeholder:'Seleccione un responsable del cenco',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.get('porcentaje')?x.get('porcentaje'):0,onChange:function onChange(e){return _this2.props.updateInputs('cencos.'+n+'.porcentaje',e.target.value);},disabled:x.get('responsable')==null})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6,style:{textAlign:'center'}},'Para agregar un centro de costo haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'plus-circle'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:creacionsolicitudhoteles.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('observaciones',e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Shared_AttachedFilesBox__["a" /* default */],{files:creacionsolicitudhoteles.get('adjuntos'),removeFiles:this.props.removeSolicitudHotelesFiles,updateInputs:this.props.updateInputs,obj:creacionsolicitudhoteles,check:'solicitud'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxSection__["a" /* default */],{title:'Hu\xE9spedes'},creacionsolicitudhoteles.get('huespedes').map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'Fragment['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Hu\xE9sped #'+(i+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Información del huésped',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo hu\xE9sped'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_huesped'),onChange:function onChange(e){return _this2.props.updateInputs('huespedes.'+i+'.tipo_huesped',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Empleado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Invitado')))),p.get('tipo_huesped')==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre completo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Shared_SelectorInput__["a" /* default */],{value:p.get('fullname')?p.get('fullname'):'',onClick:function onClick(){return _this2.handleOpenSelectorAddHuesped('huespedes.'+i);},onReset:function onReset(){return _this2.props.updateInputs('huespedes.'+i,{selected:p.get('selected'),guid:p.get('guid')});}})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nombres')||'',onChange:function onChange(e){return _this2.props.updateInputs('huespedes.'+i+'.nombres',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('apellidos')||'',onChange:function onChange(e){return _this2.props.updateInputs('huespedes.'+i+'.apellidos',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_documento')||1,onChange:function onChange(e){return _this2.props.updateInputs('huespedes.'+i+'.tipo_documento',e.target.value);}},Object.keys(tipos_identificacion).map(function(key,ikey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt['+i+']['+ikey+']',value:key},tipos_identificacion[key]);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. de Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('numero_documento')||'',onChange:function onChange(e){return _this2.props.updateInputs('huespedes.'+i+'.numero_documento',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('celular')||'',onChange:function onChange(e){return _this2.props.updateInputs('huespedes.'+i+'.celular',e.target.value);}})))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile();}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return CreacionSolicitudHoteles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.common.get('user'),creacionsolicitudhoteles:state.creacionsolicitudhoteles,enums:state.common.get('enums').toJS(),responsable:state.common.getIn(['parametros','SOLICITUDES'])?state.common.getIn(['parametros','SOLICITUDES']).filter(function(x){return x.get('TIPO_SOLICITUD')==state.creacionsolicitudhoteles.get('tipo');}).first():null};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["l" /* updateInputs */])(path,value));},addAlojamiento:function addAlojamiento(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["a" /* addAlojamiento */])());},removeAlojamientos:function removeAlojamientos(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["i" /* removeAlojamientos */])());},createSolicitudHoteles:function createSolicitudHoteles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["e" /* createSolicitudHoteles */])());},addHuesped:function addHuesped(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["d" /* addHuesped */])(path));},removeSolicitudServicioFiles:function removeSolicitudServicioFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_creacionsolicitudservicioot__["n" /* removeSolicitudServicioFiles */])());},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["q" /* selectFromSelector */])(type,payload));},addCencoSolicitud:function addCencoSolicitud(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["b" /* addCencoSolicitud */])());},removeCenco:function removeCenco(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["j" /* removeCenco */])());},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["h" /* enviarComentario */])());},eliminarComentario:function eliminarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["g" /* eliminarComentario */])(guid));},editarComentario:function editarComentario(guid){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["f" /* editarComentario */])(guid));},addFile:function addFile(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["c" /* addFile */])());},removeSolicitudHotelesFiles:function removeSolicitudHotelesFiles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__actions_creacionsolicitudhoteles__["k" /* removeSolicitudHotelesFiles */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CreacionSolicitudHoteles));

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initReducer */
/* harmony export (immutable) */ __webpack_exports__["l"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["a"] = addAlojamiento;
/* harmony export (immutable) */ __webpack_exports__["i"] = removeAlojamientos;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSolicitudHoteles;
/* harmony export (immutable) */ __webpack_exports__["d"] = addHuesped;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCencoSolicitud;
/* harmony export (immutable) */ __webpack_exports__["j"] = removeCenco;
/* harmony export (immutable) */ __webpack_exports__["h"] = enviarComentario;
/* harmony export (immutable) */ __webpack_exports__["f"] = editarComentario;
/* harmony export (immutable) */ __webpack_exports__["g"] = eliminarComentario;
/* harmony export (immutable) */ __webpack_exports__["c"] = addFile;
/* harmony export (immutable) */ __webpack_exports__["k"] = removeSolicitudHotelesFiles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(3);
function initReducer(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_339" /* REINICIAR_SOLICITUD_HOTELES */]});};}function updateInputs(path,value){if(path==='motivo_hospedaje'||path==='observaciones'||path.includes('huespedes')||path.includes('ciudad')){var regex=/[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;value=value.replace(regex,"").toUpperCase();}return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_214" /* MODIFICAR_INPUTS_SOLICITUD_HOTELES */],payload:{path:path,value:value}});};}function addAlojamiento(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["k" /* ADICIONAR_ALOJAMIENTO */]});};}function removeAlojamientos(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_346" /* REMOVER_ALOJAMIENTOS */]});};}function createSolicitudHoteles(){var axios=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var fn0=function fn0(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_93" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES */],payload:true});};var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_93" /* DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES */],payload:false});};var fn2=function fn2(d){return d(initReducer());};fn0(dispatch);var data=getState().creacionsolicitudhoteles;var files=data.get('adjuntos');axios.post(__WEBPACK_IMPORTED_MODULE_4____["b" /* API_URL */]+'/solicitudes/hoteles',data).then(function(res){var fn3=function fn3(){return __WEBPACK_IMPORTED_MODULE_5__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');};var fn4=function fn4(){return __WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].success('La solicitud ha sido guardada exitosamente',{bodyClassName:'toastify-content toastify-success'});};dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__common__["F" /* uploadFiles */])('/files/'+res.data.solicitud.id,files,[fn1,fn2,fn3,fn4]));fn1(dispatch);fn2(dispatch);fn3();fn4();}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_6__common__["f" /* displayMessages */])(dispatch,err);fn1(dispatch);});};}function addHuesped(payload){return function(dispatch,getState){var path=payload.path.split('.')[0];var huespedes=getState().creacionsolicitudhoteles.get(path);if(huespedes.filter(function(x){return x.get('id')===payload.value.id;}).count()!==0){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warn('La persona '+payload.value.fullname+' ya se encuentra en el listado',{bodyClassName:'toastify-content toastify-warning'});}else{var huesped=getState().creacionsolicitudhoteles.getIn(payload.path.split('.')).toJS();huesped=Object.assign({},huesped,payload.value);huesped.correo=huesped.email;huesped.cedula=huesped.username;payload.value=huesped;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["y" /* ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES */],payload:payload});}};}function addCencoSolicitud(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_0" /* ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES */]});};}function removeCenco(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_347" /* REMOVER_CENCOS_HOTELES */]});};}function enviarComentario(){return function(dispatch,getState){var guid=getState().creacionsolicitudhoteles.getIn(['comentario','guid']);var comentario=getState().creacionsolicitudhoteles.getIn(['comentario','texto']);var usuario=getState().common.get('user');var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_166" /* ENVIAR_COMENTARIO_SOLICITUD_HOTELES */],payload:{comentario:comentario,guid:guid,usuario:usuario}});};fn1(dispatch);};}function editarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_113" /* EDITAR_COMENTARIO_SOLICITUD_HOTELES */],payload:{guid:guid}});};fn1(dispatch);};}function eliminarComentario(guid){return function(dispatch){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_136" /* ELIMINAR_COMENTARIO_SOLICITUD_HOTELES */],payload:{guid:guid}});};fn1(dispatch);};}function addFile(){return function(dispatch,getState){var data=getState().common.getIn(['modalAddFile','data']);var errors=[];if(!data.get('file'))errors.push('No adicionó ningun archivo');if(!data.get('clasificacion'))errors.push('No se seleccionó ninguna clasificación');if(errors.length>0){errors.forEach(function(x){__WEBPACK_IMPORTED_MODULE_1_react_toastify__["toast"].warning(x,{bodyClassName:'toastify-content toastify-warning'});});}else{var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["S" /* ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1 */],payload:data});};var fn2=function fn2(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_313" /* OCULTAR_MODAL_AGREGAR_ARCHIVO */]});};fn1(dispatch);fn2(dispatch);}};}function removeSolicitudHotelesFiles(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_124" /* ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES */]});};}

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SolicitudHoteles_General__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SolicitudHoteles_Cotizacion__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SolicitudHoteles_Aprobaciones__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SolicitudHoteles_Reservaciones__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SolicitudHoteles_Cierre__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SolicitudHoteles_Cancelacion__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_solicitudhoteles__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SolicitudHoteles=function(_Component){_inherits(SolicitudHoteles,_Component);function SolicitudHoteles(props){_classCallCheck(this,SolicitudHoteles);var _this=_possibleConstructorReturn(this,(SolicitudHoteles.__proto__||Object.getPrototypeOf(SolicitudHoteles)).call(this,props));_this.selectTab=function(e,tab){e.preventDefault();_this.setState({selected:tab});};_this.cancel=function(){_this.props.showModalConfirmarAccion(true,'\xBFEst\xE1 seguro que desea cancelar la solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerCancelacion();});};_this.getSolicitudRechazada=function(){var contador=0;if(_this.props.solicitud.get('cotizaciones')){if(_this.props.solicitud.get('cotizaciones').count()==0)return false;_this.props.solicitud.get('cotizaciones').map(function(cotizacion){if(cotizacion.get('aprobaciones')){var aprobaciones=cotizacion.get('aprobaciones').count();var rechazadas=cotizacion.get('aprobaciones').filter(function(x){return x.get('estado')==0;}).count();if(aprobaciones==rechazadas)contador++;}});return contador==_this.props.solicitud.get('cotizaciones').count();}return false;};_this.getSolicitudAprobadas=function(){var contador=0;if(_this.props.solicitud.get('cotizaciones')){contador=_this.props.solicitud.get('cotizaciones').reduce(function(cont,cotizacion){if(cotizacion.get('aprobaciones')){var aprobados=cotizacion.get('aprobaciones').filter(function(aprobacion){return aprobacion.get('estado')==2;}).count();if(aprobados>0){cont++;}}return cont;},0);}return contador>0;};_this.getEstadoAprobacion=function(){if(_this.getSolicitudRechazada())return 0;if(_this.getSolicitudAprobadas())return 2;return 1;};_this.getPagoRealizado=function(){var contador=0;if(_this.props.solicitud.get('hotel')){contador=_this.props.solicitud.getIn(['hotel','reservaciones']).reduce(function(cont,reservacion){if(reservacion.get('valor_pagado')>0){cont++;}return cont;},0);}return contador>0;};_this.state={tabs:[{id:0,caption:'Solicitud',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_SolicitudHoteles_General__["a" /* default */],null),estado:1},{id:1,caption:'Cotización',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_SolicitudHoteles_Cotizacion__["a" /* default */],null),estado:2},{id:2,caption:'Aprobación',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SolicitudHoteles_Aprobaciones__["a" /* default */],null),estado:3},{id:3,caption:'Reservaciones',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SolicitudHoteles_Reservaciones__["a" /* default */],null),estado:4},{id:4,caption:'Cierre',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SolicitudHoteles_Cierre__["a" /* default */],null),estado:6},{id:5,caption:'Cancelacion',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SolicitudHoteles_Cancelacion__["a" /* default */],null),estado:0}],selected:0};return _this;}_createClass(SolicitudHoteles,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.id){this.props.getSolicitud(this.props.match.params.id);var params=new URLSearchParams(this.props.location.search);if(params.has("aprobacion")){this.setState({selected:2});}}else{__WEBPACK_IMPORTED_MODULE_12__utils_history__["a" /* default */].push(window.FOLDER+'/solicitudes/abiertas');}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,tabs=_state.tabs,selected=_state.selected;var _props=this.props,estado=_props.estado,solicitud=_props.solicitud,btnRComprasDisabled=_props.btnRComprasDisabled,user=_props.user,btnSaveDisabled=_props.btnSaveDisabled;//const esResponsableCompras = solicitud.getIn(['responsable_compras', 'id']) == user.get('id')
var readOnly=!Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitud);var onlySolicitante=Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["E" /* isAllowedToViewComponent */])('solicitante',solicitud);var boxActions=void 0;boxActions=[estado===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.updateSolicitudHoteles();},title:'Actualizar solicitud',disabled:estado!==1||selected!==0}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.updateSolicitudHoteles();},title:'Actualizar solicitud',disabled:estado!==2||selected!==1||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][2]',name:'user',onClick:function onClick(){return _this2.props.canmbiarResponsable(solicitud,'ACTUALIZAR_SOLICITUD_HOTELES');},title:'Cambiar responsable',disabled:btnRComprasDisabled||selected!==0||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][3]',name:'ticket',onClick:function onClick(){return _this2.props.registerReservaciones();},title:'Registrar reservaci\xF3n',disabled:estado!==4||selected!==3||readOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][4]',name:'check',onClick:function onClick(){return _this2.props.registerReservacionesExpirados();},title:'Actualizar reservaciones',disabled:estado!==6||selected!==4||!onlySolicitante}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][5]',name:'ban',onClick:function onClick(){return _this2.cancel();},title:'Aprobar cancelaci\xF3n solicitud',disabled:selected!==5||estado==0})// !esResponsableCompras ? <BoxButton key="ba[0][5]" name="ban" onClick={ () => this.cancel() } title="Aprobar cancelación solicitud" disabled={ selected !== 5 || estado == 0 } />:null,
// esResponsableCompras ? <BoxButton key="ba[0][5]" name="ban" onClick={ () => this.props.solicitarCancelación() } title="Solicitar cancelación solicitud" disabled={ selected !== 5 || estado == 0 } />: null,
];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-tabs-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-tabs-tabs'},tabs.filter(function(x){return x.estado<=estado||estado==0;}).map(function(x){if(estado==0){if(_this2.getEstadoAprobacion()==1&&x.id==2)return null;if(!_this2.getPagoRealizado()&&x.id==3)return null;if(!_this2.getPagoRealizado()&&x.id==4)return null;}if(estado==1&&x.id==5)return null;if(estado==7&&x.id==5)return null;if(_this2.getEstadoAprobacion()==0&&x.id==5)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li01['+x.id+']',className:selected===x.id?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.selectTab(e,x.id);}},x.caption));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-main-section-scrollable'},tabs[selected].component)))));}}]);return SolicitudHoteles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{btnSaveDisabled:state.solicitudhoteles.get('btnSaveDisabled'),btnRComprasDisabled:state.solicitudhoteles.get('btnRComprasDisabled'),estado:state.solicitudhoteles.get('estado'),solicitud:state.solicitudhoteles.get('solicitud'),user:state.common.get('user')};}function mapDispatchToProps(dispatch){return{getSolicitud:function getSolicitud(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudhoteles__["k" /* getSolicitud */])(id));},updateSolicitudHoteles:function updateSolicitudHoteles(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudhoteles__["t" /* updateSolicitudHoteles */])());},registerReservaciones:function registerReservaciones(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudhoteles__["n" /* registerReservaciones */])());},registerReservacionesExpirados:function registerReservacionesExpirados(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudhoteles__["o" /* registerReservacionesExpirados */])());},canmbiarResponsable:function canmbiarResponsable(solicitud,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["b" /* canmbiarResponsable */])(solicitud,type));},registerCancelacion:function registerCancelacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudhoteles__["m" /* registerCancelacion */])());},solicitarCancelación:function solicitarCancelaciN(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_solicitudhoteles__["r" /* solicitarCancelación */])());},showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SolicitudHoteles));

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_Comentarios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_AttachedFilesBox__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var General=function(_Component){_inherits(General,_Component);function General(){var _ref;var _temp,_this,_ret;_classCallCheck(this,General);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=General.__proto__||Object.getPrototypeOf(General)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenSelector=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_HOTELES1',payload);};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/auxiliares',fn);},_this.getSolicitudRechazada=function(){var contador=0;if(_this.props.solicitudhoteles.get('cotizaciones')){contador=_this.props.solicitudhoteles.get('cotizaciones').reduce(function(cont,cotizacion){if(cotizacion.get('aprobaciones')){var aprobaciones=cotizacion.get('aprobaciones').count();var rechazados=cotizacion.get('aprobaciones').filter(function(aprobacion){return aprobacion.get('estado')==0;}).count();if(aprobaciones==rechazados){cont++;}}return cont;},0);}return contador>0;},_this.handleOpenSelectorAddHuesped=function(path){var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector(function(){return _this.props.addHuesped(payload);});};_this.props.showModalSelector('Listado de usuarios',columns,'/usuarios/ldap',fn);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(General,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudhoteles=_props.solicitudhoteles,enums=_props.enums,user=_props.user,comentario=_props.comentario;var tipos_identificacion=enums.tipos_identificacion;var esSuperusuario=user.get('es_superusuario');if(!id)return null;var solicitudRechazada=this.getSolicitudRechazada();var disabled_comment=solicitudhoteles.get('estado')===0||solicitudhoteles.get('estado')===7;var readOnly=solicitudhoteles.get('estado')!==1||!esSuperusuario;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n b\xE1sica'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudhoteles.get('solicitante'))&&!solicitudRechazada&&solicitudhoteles.get('estado')!=0&&solicitudhoteles.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_SelectorInput__["a" /* default */],{value:solicitudhoteles.getIn(['solicitante','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.solicitante');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.solicitante',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudhoteles.getIn(['solicitante','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudhoteles.getIn(['solicitante','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudhoteles.getIn(['solicitante','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'\xC1rea'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudhoteles.getIn(['solicitante','area','nombre'])||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["E" /* isAllowedToViewComponent */])('administrador',solicitudhoteles.get('responsable_compras'))&&!solicitudRechazada&&solicitudhoteles.get('estado')!=0&&solicitudhoteles.get('estado')!=7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_SelectorInput__["a" /* default */],{value:solicitudhoteles.getIn(['responsable_compras','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('solicitud.responsable_compras');},onReset:function onReset(){return _this2.props.updateInputs('solicitud.responsable_compras',null);}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de compras'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudhoteles.getIn(['responsable_compras','fullname'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Correo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudhoteles.getIn(['responsable_compras','email'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Extensi\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudhoteles.getIn(['responsable_compras','extension'])||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitudhoteles.getIn(['created_at'])).format('DD/MM/YYYY')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. Solicitud'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:solicitudhoteles.get('id')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Informaci\xF3n hospedaje'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo del hospedaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:solicitudhoteles.get('proyecto_evento')||'',disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cantidad hu\xE9spedes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'number',min:'1',max:'9',value:solicitudhoteles.getIn(['hotel','cant_huespedes'])||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Detalles de alojamiento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-alojamientos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Fecha ingreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Fecha salida'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudhoteles.getIn(['hotel','alojamientos']).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:t.get('id'),className:t.get('selected')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,t.get('ciudad')||''):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:t.get('ciudad'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.alojamientos.'+i+'.ciudad',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_ingreso')).format('DD/MM/YYYY')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_ingreso')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.alojamientos.'+i+'.fecha_ingreso',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_salida')).format('DD/MM/YYYY')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_salida')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.alojamientos.'+i+'.fecha_salida',e.target.value);}})));}))),solicitudhoteles.getIn(['hotel','alojamientos']).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table nowrap',key:t.get('id')+'-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'182px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Consumo a la habitaci\xF3n '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:'form-control input-sm',checked:t.get('consumo_habitacion'),value:t.get('consumo_habitacion'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.alojamientos.'+i+'.consumo_habitacion',e.target.checked);},disabled:readOnly}),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Monto de consumo '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',style:{marginLeft:'5px',width:'100px'},value:Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["q" /* formatcoin */])(t.get('monto_consumo')||'',"$"),disabled:readOnly}),' '):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Monto de consumo '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',style:{marginLeft:'5px',width:'100px'},value:t.get('monto_consumo')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.alojamientos.'+i+'.monto_consumo',e.target.value);},disabled:!t.get('consumo_habitacion')}),' ')))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Distribuci\xF3n de centros de costos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ordenador del gasto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Centro de costo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudhoteles.getIn(['hotel','cencos']).count()>0?solicitudhoteles.getIn(['hotel','cencos']).map(function(x,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+(x.getIn(['pivot','id'])?x.getIn(['pivot','id']):x.getIn(['pivot','guid']))+']',className:x.get('selected')?'info-dark':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:x.getIn(['usuario','fullname']||''),disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:x.get('codigo')||'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',placeholder:'Porcentaje',value:x.getIn(['pivot','porcentaje'])?x.getIn(['pivot','porcentaje']):0,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},'%'));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},'No hay distribuci\xF3n de centro de costos para esta solicitud')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Observaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitudhoteles.get('observaciones')||'',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_Comentarios__["a" /* default */],{foros:solicitudhoteles.get('foros'),comentario:this.props.comentario,updateInputs:this.props.updateInputs,disabled_comment:disabled_comment,enviarComentario:this.props.enviarComentario,editarComentario:this.props.editarComentario,eliminarComentario:this.props.eliminarComentario}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_AttachedFilesBox__["a" /* default */],{files:solicitudhoteles.get('adjuntos').filter(function(adjunto){return!adjunto.get('documento_id');}),root:'solicitud',removeFiles:this.props.removeFiles,updateInputs:this.props.updateInputs,obj:solicitudhoteles,check:'solicitud',disabledAttach:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxSection__["a" /* default */],{title:'Hu\xE9spedes'},solicitudhoteles.getIn(['hotel','huespedes']).map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'Fragment['+i+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_Box__["a" /* default */],{title:'Hu\xE9sped #'+(i+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_Box__["a" /* default */],{title:'Información del huésped',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo hu\xE9sped'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_huesped'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.tipo_huesped',e.target.value);},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Empleado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Invitado')))),p.get('tipo_huesped')==1?readOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nombres')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.nombres',e.target.value);},disabled:readOnly}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('apellidos')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.apellidos',e.target.value);},disabled:readOnly})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre completo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_SelectorInput__["a" /* default */],{value:p.get('nombres')?p.get('nombres'):'',onClick:function onClick(){return _this2.handleOpenSelectorAddHuesped('solicitud.hotel.huespedes.'+i);},onReset:function onReset(){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i,{selected:p.get('selected'),guid:p.get('guid')});},disabled:readOnly})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombres'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('nombres')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.nombres',e.target.value);},disabled:readOnly}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apellidos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('apellidos')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.apellidos',e.target.value);},disabled:readOnly})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tipo de documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:p.get('tipo_documento')||1,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.tipo_documento',e.target.value);},disabled:readOnly},Object.keys(tipos_identificacion).map(function(key,ikey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'opt['+i+']['+ikey+']',value:key},tipos_identificacion[key]);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'No. de Documento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('numero_documento')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.numero_documento',e.target.value);},disabled:readOnly}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'text',value:p.get('celular')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+i+'.celular',e.target.value);},disabled:readOnly})))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return General;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudhoteles.get('id'),solicitudhoteles:state.solicitudhoteles.get('solicitud'),enums:state.common.get('enums').toJS(),user:state.common.get('user'),comentario:state.solicitudhoteles.get('comentario')};}function mapDispatchToProps(dispatch){return{showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["q" /* selectFromSelector */])(type,payload));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["s" /* updateInputs */])(path,value));},enviarComentario:function enviarComentario(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["j" /* enviarComentario */])());},editarComentario:function editarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["h" /* editarComentario */])(id));},eliminarComentario:function eliminarComentario(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["i" /* eliminarComentario */])(id));},addHuesped:function addHuesped(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["b" /* addHuesped */])(path));},addFile:function addFile(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["a" /* addFile */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(General));

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ModalAddCotizacion__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cotizacion=function(_Component){_inherits(Cotizacion,_Component);function Cotizacion(){_classCallCheck(this,Cotizacion);return _possibleConstructorReturn(this,(Cotizacion.__proto__||Object.getPrototypeOf(Cotizacion)).apply(this,arguments));}_createClass(Cotizacion,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudhoteles=_props.solicitudhoteles;var estado=solicitudhoteles.get('estado');if(!id)return null;var accionesCotizaciones=[];if(Object(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitudhoteles.get('solicitud'))){accionesCotizaciones=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'ba[1][0]',size:14,contrast:true,name:'plus-circle',title:'Adicionar cotizaci\xF3n',onClick:function onClick(){return _this2.props.displayModalAddCotizacion(true,'Adicionar cotización','create');},disabled:solicitudhoteles.get('estado')!=2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxButton__["a" /* default */],{key:'ba[1][1]',size:14,contrast:true,name:'trash',title:'Eliminar cotizaci\xF3n',onClick:function onClick(){return _this2.props.removeCotizacion();},danger:true,disabled:solicitudhoteles.get('estado')!=2})];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Comparativo de reservaciones',actions:accionesCotizaciones},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{width:'5%'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proveedor hospedaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha de Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pantallazo cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo de adjunto'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudhoteles.getIn(['solicitud','cotizaciones']).count()>0?solicitudhoteles.getIn(['solicitud','cotizaciones']).map(function(x,n){var fileid=x.get('adjunto_id')?x.getIn(['adjunto','id']):null;var filename=x.get('adjunto_id')?x.getIn(['adjunto','nombre']):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+n+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},checked:x.get('selected')||false,onChange:function onChange(e){return _this2.props.updateInputs('solicitud.cotizaciones.'+n+'.selected',e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:(estado==2?'LinkToEdit':'')+' text-right',onClick:estado==2?function(){return _this2.props.displayModalAddCotizacion(true,'Editar cotización','edit',n);}:null},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('descripcion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_2_numeral___default()(x.get('cotizado')).format('$0,0.00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_3_moment___default()(x.getIn(['adjunto','created_at'])).format('DD/MM/YYYY')),x.get('adjunto_id')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:x.get('adjunto')?function(){return _this2.props.downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+x.getIn(['adjunto','nombre']))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('adjunto')?''+x.getIn(['adjunto','nombre']):'Archivo sin adjuntar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('adjunto')?''+x.getIn(['adjunto','observaciones']):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.get('adjunto')?''+x.getIn(['adjunto','clasificacion']):''));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:6,style:{textAlign:'center'}},'Para agregar una cotizaci\xF3n haga click en el bot\xF3n ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#888'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'plus-circle'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ModalAddCotizacion__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('modalAddCotizacion.data.adjunto');}}));}}]);return Cotizacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudhoteles.get('id'),solicitudhoteles:state.solicitudhoteles};}function mapDispatchToProps(dispatch){return{displayModalAddCotizacion:function displayModalAddCotizacion(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__["e" /* displayModalAddCotizacion */])(show,title,mode,index));},removeCotizacion:function removeCotizacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__["p" /* removeCotizacion */])());},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},updateInputsModalAddFile:function updateInputsModalAddFile(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["C" /* updateInputs */])(path,value));},selectFile:function selectFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["p" /* selectFile */])(file));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__["a" /* addFile */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_common__["h" /* downloadFile */])(id,filename));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__["s" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cotizacion));

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudhoteles__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddCotizacion=function(_Component){_inherits(ModalAddCotizacion,_Component);function ModalAddCotizacion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddCotizacion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddCotizacion.__proto__||Object.getPrototypeOf(ModalAddCotizacion)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddCotizacion');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddCotizacion .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddCotizacion(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddCotizacion,[{key:'render',value:function render(){var _this2=this;var modalAddCotizacion=this.props.modalAddCotizacion;if(!modalAddCotizacion.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'modalAddCotizacion',show:true,ZIndex:2000,width:700},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.addOrEditCotizacion();},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_ModalHeader__["a" /* default */],{title:modalAddCotizacion.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddCotizacion.get('btnDisabled'),title:'Guardar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor de hospedaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:modalAddCotizacion.getIn(['data','descripcion']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddCotizacion.data.descripcion',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor cotizado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control input-sm',value:modalAddCotizacion.getIn(['data','cotizado']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddCotizacion.data.cotizado',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pantallazo cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',modalAddCotizacion.getIn(['data','adjunto','file'])?modalAddCotizacion.getIn(['data','adjunto','file']).name:' Seleccione un archivo...')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalAddCotizacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddCotizacion:state.solicitudhoteles.get('modalAddCotizacion')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddCotizacion:function displayModalAddCotizacion(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudhoteles__["e" /* displayModalAddCotizacion */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudhoteles__["s" /* updateInputs */])(path,value));},addOrEditCotizacion:function addOrEditCotizacion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudhoteles__["c" /* addOrEditCotizacion */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddCotizacion));

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Aprobaciones=function(_Component){_inherits(Aprobaciones,_Component);_createClass(Aprobaciones,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('APROBADORES_ADICIONALES');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.setState({aprobadores:this.props.aprobadores});}}]);function Aprobaciones(props){_classCallCheck(this,Aprobaciones);var _this=_possibleConstructorReturn(this,(Aprobaciones.__proto__||Object.getPrototypeOf(Aprobaciones)).call(this,props));_this.rubros=false;_this.aprobador_id=null;_this.approve=function(aprobador_id,cencos){//this.rubros = true
_this.aprobador_id=aprobador_id;var aprobaciones=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones');_this.props.showModalConfirmarAccion(true,'Al hacer click en Ok, estar\xE1 aprobando el cargue de '+__WEBPACK_IMPORTED_MODULE_3_numeral___default()(_this.getTotal(_this.aprobador_id)).format('$0,0.00')+' '+(cencos.length>1?'entre los ':'al')+' centro'+(cencos.length>1?'s':'')+' de costo '+Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["V" /* uniqueArray */])(cencos).join(', '),function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(aprobaciones,2);});};_this.reject=function(aprobador_id){_this.rubros=false;var aprobaciones=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones');_this.props.showModalConfirmarAccion(true,'\xBFEsta seguro que desea rechazar esta solicitud?',function(){_this.props.showModalConfirmarAccion(false);_this.props.registerApprovalResult(aprobaciones,0);});};_this.getTotal=function(aprobador_id){var aprobacion=_this.props.aprobadores.filter(function(u){return u.get('id')==aprobador_id;}).first().get('aprobaciones').filter(function(a){return a.get('estado')==2;});return aprobacion.count()>0?aprobacion.first().getIn(['cotizacione','cotizado']):0;};_this.getSolicitudRechazada=function(){var contador=0;if(_this.props.solicitudhoteles.get('cotizaciones')){if(_this.props.solicitudhoteles.get('cotizaciones').count()==0)return false;_this.props.solicitudhoteles.get('cotizaciones').map(function(cotizacion){if(cotizacion.get('aprobaciones')){var aprobaciones=cotizacion.get('aprobaciones').count();var rechazadas=cotizacion.get('aprobaciones').filter(function(x){return x.get('estado')==0;}).count();if(aprobaciones==rechazadas)contador++;}});return contador==_this.props.solicitudhoteles.get('cotizaciones').count();}return false;};_this.getSolicitudAprobadas=function(){var contador=0;if(_this.props.solicitudhoteles.get('cotizaciones')){contador=_this.props.solicitudhoteles.get('cotizaciones').reduce(function(cont,cotizacion){if(cotizacion.get('aprobaciones')){var aprobados=cotizacion.get('aprobaciones').filter(function(aprobacion){return aprobacion.get('estado')==2;}).count();if(aprobados>0){cont++;}}return cont;},0);}return contador>0;};_this.getSolicitudPendiente=function(aprobaciones){return _this.props.solicitudhoteles.get('estado')===3&&aprobaciones.filter(function(x){return x.get('estado')===1;}).count()>0;};_this.getSolicitudRechazada=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')===0;}).count()==aprobaciones.count();};_this.getSolicitudAprobadas=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')===2;}).count()>0;};_this.getSolicitudAprobadasEnRevision=function(aprobaciones){return aprobaciones.filter(function(x){return x.get('estado')===3;}).count()>0;};_this.getEstadoAprobacion=function(index){if(index<_this.props.aprobadores.count()){var aprobaciones=_this.props.aprobadores.getIn([index,'aprobaciones']);var validado=_this.props.solicitudhoteles.get('estado')>3||_this.props.solicitudhoteles.get('estado')===0;if(aprobaciones.count()>0){if(_this.getSolicitudPendiente(aprobaciones))return 1;if(validado&&_this.getSolicitudRechazada(aprobaciones))return 0;if(validado&&_this.getSolicitudAprobadas(aprobaciones))return 2;if(_this.getSolicitudAprobadasEnRevision(aprobaciones))return 3;return 1;}}return 1;};_this.getTipoAprobacion=function(index){if(index<_this.props.aprobadores.count()){var aprobaciones=_this.props.aprobadores.getIn([index,'aprobaciones']);return aprobaciones.count()>0?aprobaciones.first().get('tipo'):1;}return 1;};_this.handleOpenSelectorAprobador=function(){var fields=[{id:1,caption:'Nombre',value:'fullname',width:'40%'},{id:2,caption:'Cargo',value:'cargo',width:'40%'},{id:3,caption:'Miembro',value:'esmiembrocomite',width:'20%'}];_this.props.showModalSelector('Seleccione aprobador adicional',fields,'/usuarios/aprobadores-adicionales',function(aprobador){_this.setState({aprobadorAdicional:aprobador});});};_this.handleEnviarSolicitudAdicional=function(){var _this$state=_this.state,aprobadorAdicional=_this$state.aprobadorAdicional,motivoAprobacionAdicional=_this$state.motivoAprobacionAdicional;if(!aprobadorAdicional||!motivoAprobacionAdicional.trim())return;_this.props.crearAprobacionAdicional(aprobadorAdicional,motivoAprobacionAdicional);_this.setState({solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''});};_this.info_aprobador_adicional=function(aprobador){var aprobadores_adicionales=_this.props.aprobadores_adicionales;if(!aprobador)return null;if(!aprobadores_adicionales)return null;var aprobadorInfo=aprobadores_adicionales.find(function(a){return a.get('USUARIO')===aprobador.get('username');});if(!aprobadorInfo)return null;return{cargo:aprobadorInfo.get('CARGO')||'Sin cargo',esmiembrocomite:aprobadorInfo.get('MIEMBRO_COMITE')==='SI'};};_this.state={aprobador_id:null,aprobadores:_this.props.aprobadores,solicitarAprobacionAdicional:false,aprobadorAdicional:null,motivoAprobacionAdicional:''};return _this;}_createClass(Aprobaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudhoteles=_props.solicitudhoteles,enums=_props.enums,aprobadores=_props.aprobadores;if(!id)return null;var adjunto=[];solicitudhoteles.get('cotizaciones').map(function(x){var adjuntoId=x.get('adjunto_id');var fileid=x.get('adjunto_id')?x.getIn(['adjunto','id']):null;var filename=x.get('adjunto_id')?x.getIn(['adjunto','nombre']):null;if(adjuntoId){adjunto.push({fileid:fileid,filename:filename});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,solicitudhoteles.get('estado')===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{title:'Aprobaci\xF3n adicional'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:this.state.solicitarAprobacionAdicional,onChange:function onChange(e){return _this2.setState({solicitarAprobacionAdicional:e.target.checked});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'7px'}},'Solicitar aprobaci\xF3n adicional')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3'},this.state.solicitarAprobacionAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Seleccione aprobador adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_SelectorInput__["a" /* default */],{value:this.state.aprobadorAdicional?this.state.aprobadorAdicional.fullname:'',onClick:this.handleOpenSelectorAprobador,onReset:function onReset(){return _this2.setState({aprobadorAdicional:null});}})))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cargo del aprobador:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control input-sm',style:{background:'#f9f9f9',paddingTop:'5px'}},this.state.aprobadorAdicional.cargo||'Sin cargo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3',style:{display:'flex',alignItems:'center',marginTop:25}},this.state.aprobadorAdicional.esmiembrocomite==='SI'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{fontSize:13}},'Integrantes del Comit\xE9 de Rector\xEDa')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Motivo de la solicitud adicional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:3,className:'form-control input-sm',value:this.state.motivoAprobacionAdicional,onChange:function onChange(e){return _this2.setState({motivoAprobacionAdicional:e.target.value});}}))))),this.state.solicitarAprobacionAdicional&&this.state.aprobadorAdicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{textAlign:'right',paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',disabled:!this.state.motivoAprobacionAdicional.trim()||!this.state.aprobadorAdicional,onClick:this.handleEnviarSolicitudAdicional},'Enviar solicitud adicional')))),aprobadores.count()>0&&aprobadores.map(function(a,b){var estado=_this2.getEstadoAprobacion(b);var tipo_aprobacion=_this2.getTipoAprobacion(b);var nombre_su_original=a.get('aprobaciones').filter(function(x){return x.get('estado')===0||x.get('estado')===2;}).count()>0?a.get('aprobaciones').filter(function(x){return x.get('estado')===0||x.get('estado')===2;}).first().getIn(['aprobador_su','fullname']):null;var cencos=[];var info_aprobador_adicional=_this2.info_aprobador_adicional(a);return[b>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep1['+b+']',className:'separator'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Layout_BoxSection__["a" /* default */],{key:'bs1['+a.get('id')+']',title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,tipo_aprobacion===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#fff',fontWeight:600}},'Solicitud de aprobaci\xF3n adicional a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,a.get('fullname'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Solicitud de aprobaci\xF3n a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,a.get('fullname')))))},info_aprobador_adicional&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:500}},'Cargo: ',info_aprobador_adicional.cargo||'Sin cargo'),info_aprobador_adicional.esmiembrocomite?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label label-success',style:{marginLeft:10}},'Integrantes del Comit\xE9 de Rector\xEDa'):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Solicitud de aprobaci\xF3n: ',enums.aprobaciones.estados[estado],estado===1?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' \u2022 ',a.getIn(['aprobaciones','0','fecha'])?__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.getIn(['aprobaciones','0','fecha'])).format('YYYY-MM-DD HH:mm'):null)))),nombre_su_original&&(estado===0||estado===2)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Esta solicitud fue ',''+(estado===2?'aprobada':'rechazada'),' por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,nombre_su_original)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Solicitada por ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,solicitudhoteles.getIn(['solicitante','fullname']))),' \u2022 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+solicitudhoteles.getIn(['solicitante','email'])},solicitudhoteles.getIn(['solicitante','email']))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep2['+b+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Detalle:'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'sep3['+b+']',className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%',textAlign:'center'}},'Seleccionar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Proveedor de alojamiento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'50%'}},'Pantallazo cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Cotizaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'40%'}},'Distribuci\xF3n'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,a.get('aprobaciones').map(function(c,d){var responsable_id=a.get('id');var adjuntoId=c.getIn(['cotizacione','adjunto_id']);var data=adjunto.find(function(x){return x.fileid===adjuntoId;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+a.get('id')+']['+c.get('id')+']['+d+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle',padding:'15px'}},estado===0||estado===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,c.get('estado')===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green',fontSize:'30px'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,c.get('estado')===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_fontawesome___default.a,{name:'check',style:{color:'green',fontSize:'30px'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{width:'45px',height:'35px'},onClick:function onClick(){return _this2.props.seleccionarAprobacion(b,d);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,c.getIn(['cotizacione','descripcion'])),adjuntoId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:adjuntoId?function(){return _this2.props.downloadFile(data.fileid,data.filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},data.filename)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,adjuntoId?data.filename:'Archivo sin adjuntar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(c.getIn(['cotizacione','cotizado'])).format('$0,0.00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cenco'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Rubro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Porcentaje'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Valor'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,c.getIn(['cotizacione','hotel','0','cencos']).map(function(e,f){if(e.get('responsable_id')!=responsable_id&&e.getIn(['pivot','aprobador_id'])!=responsable_id)return null;var indexCenco=cencos.findIndex(function(x){return x==e.get('codigo');});if(indexCenco==-1)cencos.push(e.get('codigo'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr2['+a.get('id')+']['+c.get('id')+']['+e.get('id')+']['+f+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+e.get('descripcion')},e.get('codigo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:''+e.getIn(['pivot','rubro','descripcion'])},e.getIn(['pivot','rubro','nombre']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(e.getIn(['pivot','porcentaje'])/100).format('0.0%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(e.getIn(['pivot','porcentaje'])/100*c.getIn(['cotizacione','cotizado'])).format('$0,0.00')));})))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Observaciones'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:6,className:'form-control input-sm',value:a.getIn(['aprobaciones',0,'observaciones'])||'',onChange:function onChange(e){return _this2.props.updateInputs('aprobadores.'+b+'.aprobaciones.0.observaciones',e.target.value);},disabled:!Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobaciones',a)||estado!==1&&estado!==3||solicitudhoteles.get('estado')==0||tipo_aprobacion===3})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('aprobaciones',a)&&estado!==2&&solicitudhoteles.get('estado')>0&&solicitudhoteles.get('estado')<4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right',padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm btn-squared',onClick:function onClick(e){return _this2.approve(a.get('id'),cencos);}},'Aprobar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-default btn-sm btn-squared',onClick:function onClick(e){return _this2.reject(a.get('id'));}},'Rechazar'))))))];}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalConfirmarAccion__["a" /* default */],null,this.rubros&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_Box__["a" /* default */],{title:'Selecci\xF3n de rubros',onModal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{height:'81px',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.solicitudhoteles.getIn(['hotel','cencos']).filter(function(c){return c.get('responsable_id')==_this2.aprobador_id;}).map(function(x,n){if(x.get('rubros').count()>0){var index=_this2.props.solicitudhoteles.getIn(['hotel','cencos']).findIndex(function(f){return f.get('id')===x.get('id');});if(index<0)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+x.get('id')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20px',verticalAlign:'middle'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,n+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'55%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control input-sm',value:x.get('descripcion')?x.get('descripcion'):'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'45%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:Number(x.getIn(['pivot','rubro_id']))||0,onChange:function onChange(e){_this2.props.updateInputs('solicitud.hotel.cencos.'+index+'.pivot.rubro_id',Number(e.target.value));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0,disabled:true},'Seleccione una opci\xF3n'),x.get('rubros').map(function(r,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'optr['+j+']',value:r.get('id')},r.get('nombre'));}))));}})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Aprobaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudhoteles.get('id'),solicitudhoteles:state.solicitudhoteles.get('solicitud'),aprobadores:state.solicitudhoteles.get('aprobadores'),enums:state.common.get('enums').toJS(),user:state.common.get('user'),aprobadores_adicionales:state.common.getIn(['parametros','APROBADORES_ADICIONALES'])};}function mapDispatchToProps(dispatch){return{showModalConfirmarAccion:function showModalConfirmarAccion(show,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["x" /* showModalConfirmarAccion */])(show,message,action));},registerApprovalResult:function registerApprovalResult(aprobador_id,result){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["l" /* registerApprovalResult */])(aprobador_id,result));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["s" /* updateInputs */])(path,value));},seleccionarAprobacion:function seleccionarAprobacion(cotizacion_id,aprobador_id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["q" /* seleccionarAprobacion */])(cotizacion_id,aprobador_id));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["h" /* downloadFile */])(id,filename));},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["q" /* selectFromSelector */])(type,payload));},crearAprobacionAdicional:function crearAprobacionAdicional(aprobador,motivo){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_solicitudhoteles__["d" /* crearAprobacionAdicional */])(aprobador,motivo));},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__actions_common__["l" /* getParameterByName */])(param));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Aprobaciones));

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAddReservacion__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_solicitudhoteles__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Reservaciones=function(_Component){_inherits(Reservaciones,_Component);function Reservaciones(){_classCallCheck(this,Reservaciones);return _possibleConstructorReturn(this,(Reservaciones.__proto__||Object.getPrototypeOf(Reservaciones)).apply(this,arguments));}_createClass(Reservaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudhoteles=_props.solicitudhoteles;if(!id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_BoxSection__["a" /* default */],{title:'Registro de reservaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-reservaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'6%',textAlign:'center'}},'No.Huesp.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No. Reservaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'8%'}},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Proveedor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'40%'}},'Alojamiento'),solicitudhoteles.get('estado')==4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Adjuntar reservaci\xF3n'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Descargar reservaci\xF3nn'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudhoteles.getIn(['hotel','huespedes']).count()>0&&solicitudhoteles.getIn(['hotel','huespedes']).map(function(x,n){var fileid=x.getIn(['reservacion','adjunto'])?x.getIn(['reservacion','adjunto','id']):null;var filename=x.getIn(['reservacion','adjunto','nombre'])?x.getIn(['reservacion','adjunto','nombre']):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+n+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Layout_BoxButton__["a" /* default */],{size:12,name:'pencil',onClick:function onClick(){return _this2.props.displayModalAddReservacion(true,'Agregar reservación',n);},disabled:solicitudhoteles.get('estado')!=4||!Object(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["E" /* isAllowedToViewComponent */])('responsable_compras',solicitudhoteles)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['reservacion','numero_reservacion'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_3_numeral___default()(x.getIn(['reservacion','valor_pagado'])).format('$0,0.00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['reservacion','fecha_compra'])?__WEBPACK_IMPORTED_MODULE_2_moment___default()(x.getIn(['reservacion','fecha_compra'])).format('DD/MM/YYYY'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['reservacion','proveedor_alojamiento'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha ingreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,x.getIn(['reservacion','rutas']).map(function(t,ti){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'ite['+n+']['+ti+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('ciudad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_ingreso')).format('DD/MM/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_salida')).format('DD/MM/YYYY')));})))),solicitudhoteles.get('estado')==4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['reservacion','adjunto'])?''+x.getIn(['reservacion','adjunto','nombre']):'Archivo sin adjuntar'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{cursor:'pointer'},onClick:x.getIn(['reservacion','adjunto'])?function(){return _this2.props.downloadFile(fileid,filename);}:function(){return null;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px'}},''+x.getIn(['reservacion','adjunto','nombre']))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalAddReservacion__["a" /* default */],{displayModalAddFile:this.props.displayModalAddFile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalAddFile__["a" /* default */],{action:function action(){return _this2.props.addFile('modalAddReservacion.data.reservacion.adjunto');}}));}}]);return Reservaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudhoteles.get('id'),solicitudhoteles:state.solicitudhoteles.get('solicitud')};}function mapDispatchToProps(dispatch){return{displayModalAddReservacion:function displayModalAddReservacion(show,title,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudhoteles__["f" /* displayModalAddReservacion */])(show,title,index));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_solicitudhoteles__["a" /* addFile */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_common__["h" /* downloadFile */])(id,filename));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Reservaciones));

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddReservacion=function(_Component){_inherits(ModalAddReservacion,_Component);function ModalAddReservacion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddReservacion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddReservacion.__proto__||Object.getPrototypeOf(ModalAddReservacion)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(e){var modal=document.getElementById('modalAddReservacion');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#modalAddReservacion .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.displayModalAddReservacion(false,'','');},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddReservacion,[{key:'render',value:function render(){var _this2=this;var modalAddReservacion=this.props.modalAddReservacion;if(!modalAddReservacion.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Shared_Modal__["a" /* default */],{id:'modalAddReservacion',show:true,ZIndex:2000,width:820},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form',onSubmit:function onSubmit(e){e.preventDefault();_this2.props.editHuesped(modalAddReservacion.get('index'));},noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalHeader__["a" /* default */],{title:modalAddReservacion.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Layout_BoxButton__["a" /* default */],{name:'check',disabled:modalAddReservacion.get('btnDisabled'),title:'Aceptar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Proveedor de alojamiento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddReservacion.getIn(['data','reservacion','proveedor_alojamiento'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddReservacion.data.reservacion.proveedor_alojamiento',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-trayectos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',colSpan:3},'Alojamiento')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha ingreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modalAddReservacion.getIn(['data','reservacion','rutas']).map(function(t,ti){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'itep['+ti+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('ciudad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_ingreso')?t.get('fecha_ingreso'):'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddReservacion.data.reservacion.rutas.'+ti+'.fecha_ingreso',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:t.get('fecha_salida')?t.get('fecha_salida'):'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddReservacion.data.reservacion.rutas.'+ti+'.fecha_salida',e.target.value);}})));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'separator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'N\xFAmero reservacion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddReservacion.getIn(['data','reservacion','numero_reservacion'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddReservacion.data.reservacion.numero_reservacion',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Reservacion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-control input-sm label-upload-file label-upload-file-enabled',onClick:function onClick(){return _this2.props.displayModalAddFile(true,'Adjuntar archivo','create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' ',modalAddReservacion.getIn(['data','reservacion','adjunto'])?modalAddReservacion.getIn(['data','reservacion','adjunto','file']).name:' Seleccione un archivo...')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Fecha de compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',type:'date',value:modalAddReservacion.getIn(['data','reservacion','fecha_compra'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddReservacion.data.reservacion.fecha_compra',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Valor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control input-sm',value:modalAddReservacion.getIn(['data','reservacion','valor_pagado'])||'',onChange:function onChange(e){return _this2.props.updateInputs('modalAddReservacion.data.reservacion.valor_pagado',e.target.value);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalFooter__["a" /* default */],null)));}}]);return ModalAddReservacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddReservacion:state.solicitudhoteles.get('modalAddReservacion')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{displayModalAddReservacion:function displayModalAddReservacion(show,title,mode){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__["f" /* displayModalAddReservacion */])(show,title,mode));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__["s" /* updateInputs */])(path,value));},editHuesped:function editHuesped(index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_solicitudhoteles__["g" /* editHuesped */])(index));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddReservacion));

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_solicitudhoteles__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Reservaciones=function(_Component){_inherits(Reservaciones,_Component);function Reservaciones(){_classCallCheck(this,Reservaciones);return _possibleConstructorReturn(this,(Reservaciones.__proto__||Object.getPrototypeOf(Reservaciones)).apply(this,arguments));}_createClass(Reservaciones,[{key:'render',value:function render(){var _this2=this;var _props=this.props,id=_props.id,solicitudhoteles=_props.solicitudhoteles;var estado=solicitudhoteles.get('estado');if(!id)return null;var tipo_alojamiento=solicitudhoteles.getIn(['hotel','tipo_alojamiento']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Cierre de reservaciones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-alojamientos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25px',textAlign:'center'}},'No.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pasajero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'No. Reservacion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Proveedor de alojamiento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'70%'}},'Trayectos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,solicitudhoteles.getIn(['hotel','huespedes']).count()>0&&solicitudhoteles.getIn(['hotel','huespedes']).map(function(x,n){var huesped=x.get('nombres')+' '+x.get('apellidos');//const hoy = new Date(2020, 11, 15)
var hoy=new Date();var expirados=x.getIn(['reservacion','rutas']).filter(function(i){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(i.get('fecha_salida'))<__WEBPACK_IMPORTED_MODULE_2_moment___default()(hoy);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr['+n+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},n+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,huesped),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['reservacion','numero_reservacion'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,x.getIn(['reservacion','proveedor_alojamiento'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-alojamientos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha ingreso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Fecha salida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'\xBFSe cumpli\xF3 con la estad\xEDa?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observaciones'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,expirados.map(function(t,ti){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'ite['+n+']['+ti+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,t.get('ciudad')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_ingreso')).format('DD/MM/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(t.get('fecha_salida')).format('DD/MM/YYYY')),estado<7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:t.get('cumplido')==null?"-1":t.get('cumplido'),onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+n+'.reservacion.rutas.'+ti+'.cumplido',e.target.value);},disabled:estado!=6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'-1',disabled:true},'Seleccione una opci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'No cumpli\xF3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Si cumpli\xF3'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,''+(t.get('cumplido')==1?'Si cumplió':'No cumplió')),estado<7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:2,cols:20,className:'form-control input-sm',value:t.get('observaciones')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.hotel.huespedes.'+n+'.reservacion.rutas.'+ti+'.observaciones',e.target.value);},disabled:estado!=6})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{height:'50px'}},t.get('observaciones')));})))));})))));}}]);return Reservaciones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{id:state.solicitudhoteles.get('id'),solicitudhoteles:state.solicitudhoteles.get('solicitud')};}function mapDispatchToProps(dispatch){return{displayModalAddReservacion:function displayModalAddReservacion(show,title,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_solicitudhoteles__["f" /* displayModalAddReservacion */])(show,title,index));},displayModalAddFile:function displayModalAddFile(show,title,mode,index){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["g" /* displayModalAddFile */])(show,title,mode,index));},addFile:function addFile(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_solicitudhoteles__["a" /* addFile */])(path));},downloadFile:function downloadFile(id,filename){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_common__["h" /* downloadFile */])(id,filename));},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_solicitudhoteles__["s" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Reservaciones));

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_solicitudhoteles__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancelacion=function(_Component){_inherits(Cancelacion,_Component);function Cancelacion(){_classCallCheck(this,Cancelacion);return _possibleConstructorReturn(this,(Cancelacion.__proto__||Object.getPrototypeOf(Cancelacion)).apply(this,arguments));}_createClass(Cancelacion,[{key:'render',value:function render(){var _this2=this;var solicitud=this.props.solicitud;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'fecha_rechazo',className:'control-label'},'Fecha de cancelaci\xF3n'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',className:'form-control input-sm',name:'fecha_rechazo',id:'fecha_rechazo',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(solicitud.get('fecha_cancelacion')).format('YYYY-MM-DD')||'',disabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layout_BoxSection__["a" /* default */],{title:'Motivo de cancelaci\xF3n'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'text',className:'form-control input-sm',rows:4,value:solicitud.get('motivo_cancelacion')||'',onChange:function onChange(e){return _this2.props.updateInputs('solicitud.motivo_cancelacion',e.target.value);},disabled:solicitud.get('estado')==0}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Shared_ModalConfirmarAccion__["a" /* default */],null));}}]);return Cancelacion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{solicitud:state.solicitudhoteles.get('solicitud')};}function mapDispatchToProps(dispatch){return{updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_solicitudhoteles__["s" /* updateInputs */])(path,value));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Cancelacion));

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_auth__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_cambiarcontrasena__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_glamor__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_glamor__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CambiarContrasena=function(_Component){_inherits(CambiarContrasena,_Component);function CambiarContrasena(){_classCallCheck(this,CambiarContrasena);return _possibleConstructorReturn(this,(CambiarContrasena.__proto__||Object.getPrototypeOf(CambiarContrasena)).apply(this,arguments));}_createClass(CambiarContrasena,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.user){__WEBPACK_IMPORTED_MODULE_2__utils_history__["a" /* default */].push(window.FOLDER+'/signin');this.props.signOut();return;}if(!!this.props.user.get('ldap')){__WEBPACK_IMPORTED_MODULE_2__utils_history__["a" /* default */].push(window.FOLDER+'/');}}},{key:'render',value:function render(){var _this2=this;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Layout_BoxButton__["a" /* default */],{key:'ba[0][1]',name:'floppy-o',onClick:function onClick(){return _this2.props.actualizarContrasena();},title:'Guardar'})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Layout_Box__["a" /* default */],{title:'Cambiar contrase\xF1a',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Contrase\xF1a actual'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',value:this.props.form.get('passwordactual')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('passwordactual',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nueva contrase\xF1a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',value:this.props.form.get('passwordnuevo')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('passwordnuevo',e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Verificacion nueva contrase\xF1a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',value:this.props.form.get('verificacion')||'',className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('verificacion',e.target.value);}})))))))));}}]);return CambiarContrasena;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{user:state.common.get('user'),form:state.cambiarcontrasena};}function mapDispatchToProps(dispatch){return{signOut:function signOut(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_auth__["e" /* signOut */])());},updateInputs:function updateInputs(path,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_cambiarcontrasena__["b" /* updateInputs */])(path,value));},actualizarContrasena:function actualizarContrasena(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_cambiarcontrasena__["a" /* actualizarContrasena */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CambiarContrasena));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = updateInputs;
/* harmony export (immutable) */ __webpack_exports__["a"] = actualizarContrasena;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_history__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(3);
function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */],payload:{path:path,value:value}});};}function actualizarContrasena(){var axios=Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){var currentpwd=getState().cambiarcontrasena.get('passwordactual');var newpwd=getState().cambiarcontrasena.get('passwordnuevo');var newpwdverification=getState().cambiarcontrasena.get('verificacion');axios.post(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/account/cambiar-contrasena',{currentpwd:currentpwd,newpwd:newpwd,newpwd_confirmation:newpwdverification}).then(function(res){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */],payload:{path:'passwordactual',value:''}});dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */],payload:{path:'passwordnuevo',value:''}});dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */],payload:{path:'verificacion',value:''}});Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,{success:'La contrasena ha sido actualizada exitosamente'});}).catch(function(err){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */],payload:{path:'passwordactual',value:''}});dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */],payload:{path:'passwordnuevo',value:''}});dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["_194" /* MODIFICAR_INPUTS_CAMBIO_CONTRASENA */],payload:{path:'verificacion',value:''}});Object(__WEBPACK_IMPORTED_MODULE_5__common__["f" /* displayMessages */])(dispatch,err);});};}

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Maestra_ModalAddMaestra__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Maestra_ModalProgress__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalDelete__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_maestra__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tableCols=[{Id:1,Caption:"Nombre Maestra",Value:"nombre",Type:"string",Width:"10"},{Id:2,Caption:"Fecha de actualización",Value:"updated_at",Type:"datetime",Width:"10",Format:'YYYY-MM-DD'}];function findValues(c,x){var value=x.getIn(c.Value.split('.'));return value;}var Maestra=function(_React$Component){_inherits(Maestra,_React$Component);function Maestra(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Maestra);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Maestra.__proto__||Object.getPrototypeOf(Maestra)).call.apply(_ref,[this].concat(args))),_this),_this.handleAction=function(row){console.log();switch(row.get('nombre')){case"Proveedores":_this.props.getProveedores();break;case"Usuarios":_this.props.synchroUsers();break;default:break;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Maestra,[{key:'componentWillMount',value:function componentWillMount(){this.props.getMaestras();this.props.getParameterByName('MAESTRAS');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,maestras=_props.maestras,enums=_props.enums;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[0]',name:'plus-circle',onClick:function onClick(e){return _this2.props.showHideModalAddMaestra(true,'Creación de Maestras','create');},title:'Nueva Maestra'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_BoxButton__["a" /* default */],{key:'ba[1]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los Maestras seleccionadas?',function(){return _this2.props.deleteMaestras();});},disabled:maestras.filter(function(x){return x.get('checked');}).count()===0,danger:true,title:'Eliminar maestra'})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Layout_Box__["a" /* default */],{title:'Maestras',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-maestras'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(e.target.checked);},checked:maestras.filter(function(x){return x.get('checked');}).count()>0&&maestras.filter(function(x){return x.get('checked');}).count()||false})),tableCols.map(function(x){var style={width:''+x.Width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.Id+']',style:style},x.Caption);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'100px',style:{textAlign:'center'}},'Sincronizar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'items'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle',padding:'7px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.getItems();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_fontawesome___default.a,{name:'check'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'cencos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle',padding:'7px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.getCencos();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_fontawesome___default.a,{name:'check'})))),maestras.map(function(x,c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('checked')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectItem(c,e.target.checked);},checked:x.get('checked')||false})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.Type){switch(c.Type){case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.Format);alignment='right';break;case'html':value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'10vh',overflowX:'hidden'},dangerouslySetInnerHTML:{__html:value}});break;case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.Format):'';alignment='right';break;default:}}var style={textAlign:alignment};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return _this2.props.showHideModalAddMaestra(true,'Modificación de maestras','edit',x.get('id'));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',style:style},value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center',verticalAlign:'middle',padding:'7px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.handleAction(x);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_fontawesome___default.a,{name:'check'}))));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Maestra_ModalAddMaestra__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalDelete__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Maestra_ModalProgress__["a" /* default */],null));}}]);return Maestra;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{maestras:state.maestras.get('maestras'),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{getMaestras:function getMaestras(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["e" /* getMaestras */])(page));},toggleSelectItem:function toggleSelectItem(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["k" /* toggleSelectItem */])(index,checked));},toggleSelectAllItems:function toggleSelectAllItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["j" /* toggleSelectAllItems */])(checked));},showHideModalAddMaestra:function showHideModalAddMaestra(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["h" /* showHideModalAddMaestra */])(show));},showHideModalDelete:function showHideModalDelete(open,message,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["u" /* showHideModalDelete */])(open,message,action));},deleteMaestras:function deleteMaestras(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["b" /* deleteMaestras */])());},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_common__["l" /* getParameterByName */])(param));},getProveedores:function getProveedores(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["f" /* getProveedores */])());},synchroUsers:function synchroUsers(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["i" /* synchroUsers */])());},getItems:function getItems(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["d" /* getItems */])());},getCencos:function getCencos(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["c" /* getCencos */])());}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Maestra));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_maestra__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var filesTypes=__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["a" /* acceptedFiles */].map(function(x){return x.type;}).join();var ModalAddMaestra=function(_Component){_inherits(ModalAddMaestra,_Component);function ModalAddMaestra(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddMaestra);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddMaestra.__proto__||Object.getPrototypeOf(ModalAddMaestra)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('ModalAddMaestra');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#ModalAddMaestra .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalAddMaestra(false);},300);},_this.handleOnDrop=function(files){if(files.length>1){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('Solo es permitido procesar un archivo a la vez',{bodyClassName:'toastify-content toastify-warning'});return;}_this.props.selectFile(files[0]);},_this.handleOnRejected=function(files){files.forEach(function(x){__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn('El archivo '+x.name+' no es del tipo esperado. '+x.type,{bodyClassName:'toastify-content toastify-warning'});});},_this.handleSave=function(e){_this.props.AddMaestra();_this.handleCloseModal(e,"ModalAddMaestra");},_this.setIcon=function(icon){if(icon){var imageSrc=__webpack_require__(80)("./"+icon);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageSrc});}return null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddMaestra,[{key:'render',value:function render(){var _this2=this;var _props=this.props,modalAddMaestra=_props.modalAddMaestra,parametros=_props.parametros;if(!modalAddMaestra.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Modal__["a" /* default */],{id:'ModalAddMaestra',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__["a" /* default */],{title:'Agregar nueva maestra',onClose:function onClose(e){return _this2.handleCloseModal(e,"ModalAddMaestra");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Guardar',onClick:function onClick(e){return _this2.handleSave(e);},disabled:modalAddMaestra.getIn(['data','file'])&&modalAddMaestra.getIn(['data','file']).size!=0?false:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_dropzone__["a" /* default */],{accept:filesTypes,onDropAccepted:this.handleOnDrop,onDropRejected:this.handleOnRejected,className:'dropzone1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Arrastre el archivo')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'div-input-sm'},modalAddMaestra.getIn(['data','file'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'1px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.setIcon(modalAddMaestra.getIn(['data','icono']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'4px',verticalAlign:'bottom'}},modalAddMaestra.getIn(['data','file']).name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'3px',verticalAlign:'bottom',color:'#ccc'}},'(',__WEBPACK_IMPORTED_MODULE_3_numeral___default()(modalAddMaestra.getIn(['data','file']).size).format('0.0 b'),')')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',value:modalAddMaestra.getIn(['data','clasificacion']),onChange:function onChange(e){return _this2.props.updateInputs('modalAddMaestra.data.clasificacion',e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Seleccione el tipo de maestra'),parametros&&parametros.map(function(ele){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:ele.get("NOMBRE")},ele.get("NOMBRE"));}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddMaestra;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddMaestra:state.maestras.get('modalAddMaestra'),parametros:state.common.getIn(['parametros','MAESTRAS'])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showHideModalAddMaestra:function showHideModalAddMaestra(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["h" /* showHideModalAddMaestra */])(show));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["l" /* updateInputs */])(path,value,immutable));},selectFile:function selectFile(file){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["g" /* selectFile */])(file));},AddMaestra:function AddMaestra(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_maestra__["a" /* AddMaestra */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddMaestra));

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalProgress=function(_Component){_inherits(ModalProgress,_Component);function ModalProgress(){_classCallCheck(this,ModalProgress);return _possibleConstructorReturn(this,(ModalProgress.__proto__||Object.getPrototypeOf(ModalProgress)).apply(this,arguments));}_createClass(ModalProgress,[{key:'render',value:function render(){var modalProgress=this.props.modalProgress;if(!modalProgress.get('show')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_Modal__["a" /* default */],{id:'ModalProgress',show:true,ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',width:'200px',padding:'10px',color:'green',fontWeight:'bold'}},'Sincronizando...'));}}]);return ModalProgress;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalProgress:state.maestras.get('modalProgress')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalProgress));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Delegados_ModalAddDelegados__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalDelete__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_delegados__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tableCols=[{Id:0,Caption:"ID",Value:"id",Type:"number",Width:"4",LinkToEdit:true},{Id:1,Caption:"Responsable del cenco",Value:"responsable_cenco.fullname",Type:"string",Width:"20"},{Id:2,Caption:"Cenco",Value:"cenco.descripcion",Type:"string",Width:"24"},{Id:3,Caption:"Tipo de solicitud",Value:"tipo_solicitud",Type:"string",Width:"32"},{Id:4,Caption:"Nombre del delegado",Value:"delegado.fullname",Type:"string",Width:"20"}];function findValues(c,x){var value=x.getIn(c.Value.split('.'));if(c.Value==="tipo_solicitud"){var solicitudes=__WEBPACK_IMPORTED_MODULE_10__utils_store__["a" /* default */].getState().common.getIn(['parametros','SOLICITUDES']).filter(function(x){return value.indexOf(x.get('TIPO_SOLICITUD'))>=0;}).map(function(x){return x.get('SOLICITUD');});value=solicitudes.join(', ');}return value;}var Delegados=function(_React$Component){_inherits(Delegados,_React$Component);function Delegados(){_classCallCheck(this,Delegados);return _possibleConstructorReturn(this,(Delegados.__proto__||Object.getPrototypeOf(Delegados)).apply(this,arguments));}_createClass(Delegados,[{key:'componentWillMount',value:function componentWillMount(){this.props.getParameterByName('SOLICITUDES');this.props.getDelegados();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,delegados=_props.delegados,orderBy=_props.orderBy,page=_props.page,totalRecords=_props.totalRecords,showRecords=_props.showRecords;var boxActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[0]',name:'plus-circle',onClick:function onClick(e){return _this2.props.showHideModalAddDelegados(true,'Creación de Delegados','create');},title:'Nuevo Delegado'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Layout_BoxButton__["a" /* default */],{key:'ba[1]',name:'trash',onClick:function onClick(e){return _this2.props.showHideModalDelete(true,'Esta seguro que desea eliminar los delegados seleccionados?',function(){return _this2.props.deleteDelegados();});},disabled:delegados.filter(function(x){return x.get('checked');}).count()===0,danger:true,title:'Eliminar maestra'})];var pagination=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{activePage:page,itemsCountPerPage:showRecords,totalItemsCount:totalRecords,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.getDelegados(pg);},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-double-right'})});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Layout_Box__["a" /* default */],{title:'Asignaci\xF3n de delegados',stretch:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Layout_ButtonStrip__["a" /* default */],{actions:boxActions,totalRecords:totalRecords,showRecords:showRecords,changeRecordsToShow:function changeRecordsToShow(records){return _this2.props.changeRecordsToShow(records);},pagination:pagination}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-content',style:{flex:1,height:0,overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-delegados'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'20px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectAllItems(e.target.checked);},checked:delegados.filter(function(x){return x.get('checked');}).count()===delegados.count()||false})),tableCols.map(function(x){var style={width:x.Width+'%'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:'th1['+x.Id+']',style:style},x.Caption);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,delegados.map(function(x,c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tr1['+x.get('id')+']',className:x.get('checked')?'info':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',style:{verticalAlign:'middle'},onChange:function onChange(e){return _this2.props.toggleSelectItem(c,e.target.checked);},checked:x.get('checked')||false})),tableCols.map(function(c){var alignment='left';var value=findValues(c,x);if(c.Type){switch(c.Type){case'bool':if(typeof value==='string')value=parseInt(value,10);value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'1.1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(value?'check-':'')+'square'}));break;case'number':value=__WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(c.Format);alignment='right';break;case'html':value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'10vh',overflowX:'hidden'},dangerouslySetInnerHTML:{__html:value}});break;case'datetime':value=value?__WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(c.Format):'';alignment='right';break;default:}}var style={textAlign:alignment,Width:c.Width+"%"};if(c.LinkToEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',className:'LinkToEdit',style:style,onClick:function onClick(e){return _this2.props.showHideModalAddDelegados(true,'Modificación de delegados','edit',x.get('id'));}},value);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'td1['+x.get('id')+']['+c.Id+']',style:style},value);}}));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Delegados_ModalAddDelegados__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shared_ModalDelete__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Shared_ModalSelectorFromList__["a" /* default */],null));}}]);return Delegados;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{delegados:state.delegados.get('delegados'),orderBy:state.delegados.get('orderBy'),totalRecords:state.delegados.get('totalRecords'),showRecords:state.delegados.get('showRecords'),page:state.delegados.get('page'),enums:state.common.get('enums').toJS()};}function mapDispatchToProps(dispatch){return{getDelegados:function getDelegados(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["e" /* getDelegados */])(page));},toggleSelectItem:function toggleSelectItem(index,checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["i" /* toggleSelectItem */])(index,checked));},toggleSelectAllItems:function toggleSelectAllItems(checked){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["h" /* toggleSelectAllItems */])(checked));},showHideModalAddDelegados:function showHideModalAddDelegados(show,title,action,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["g" /* showHideModalAddDelegados */])(show,title,action,id));},showHideModalDelete:function showHideModalDelete(open,message,action,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["u" /* showHideModalDelete */])(open,message,action,id));},deleteDelegados:function deleteDelegados(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["d" /* deleteDelegados */])());},getParameterByName:function getParameterByName(param){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["l" /* getParameterByName */])(param));},changeRecordsToShow:function changeRecordsToShow(records){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["c" /* changeRecordsToShow */])(records));},setOrderBy:function setOrderBy(field){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["f" /* setOrderBy */])(field));}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Delegados));

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dropzone__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_delegados__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_common__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddDelegado=function(_Component){_inherits(ModalAddDelegado,_Component);function ModalAddDelegado(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalAddDelegado);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalAddDelegado.__proto__||Object.getPrototypeOf(ModalAddDelegado)).call.apply(_ref,[this].concat(args))),_this),_this.handleCloseModal=function(){var modal=document.getElementById('ModalAddDelegado');modal.classList.remove('fadeIn');modal.classList.add('fadeOut');var modalDialog=document.querySelector('#ModalAddDelegado .modal-dialog');modalDialog.classList.remove('zoomIn');modalDialog.classList.add('zoomOut');setTimeout(function(){return _this.props.showHideModalAddDelegados(false);},300);},_this.handleSave=function(e){_this.props.AddDelegado();_this.handleCloseModal(e,"ModalAddDelegado");},_this.handleOpenSelector=function(path){var url=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'/usuarios/cencos';var columns=[{id:1,caption:'Identificacion',value:'username',width:'30%'},{id:2,caption:'Nombre',value:'fullname',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_DELEGADOS',payload);};_this.props.showModalSelector('Listado de usuarios',columns,url,fn);},_this.handleOpenSelectorAddCenco=function(path){var columns=[{id:1,caption:'Codigo',value:'codigo',width:'30%'},{id:2,caption:'Descripcion',value:'descripcion',width:'70%'}];var payload={};var fn=function fn(a){payload.path=path;payload.value=a;_this.props.selectFromSelector('MODIFICAR_INPUTS_DELEGADOS',payload);};var customFilter={column:'T0.responsable_id',operator:'===',value:_this.props.modalAddDelegado.getIn(['data','responsable_cenco','id']),comparison:'string'};_this.props.showModalSelector('Listado de CENCOS',columns,'/cencos',fn,customFilter);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalAddDelegado,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.props.user.get('es_superusuario')){this.props.updateInputs('modalAddDelegado.data.responsable_cenco',this.props.user,false);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,modalAddDelegado=_props.modalAddDelegado,parametros=_props.parametros,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Shared_Modal__["a" /* default */],{id:'ModalAddDelegado',show:modalAddDelegado.get('show'),ZIndex:2000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Shared_ModalHeader__["a" /* default */],{title:modalAddDelegado.get('title'),onClose:function onClose(e){return _this2.handleCloseModal(e,"ModalAddDelegado");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Shared_ModalButtonStrip__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Layout_BoxButton__["a" /* default */],{name:'floppy-o',title:'Guardar',onClick:function onClick(e){return _this2.handleSave(e);},disabled:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Shared_ModalBody__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'600px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Responsable de cenco'),user.get('es_superusuario')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:modalAddDelegado.getIn(['data','responsable_cenco','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('modalAddDelegado.data.responsable_cenco');},onReset:function onReset(){return _this2.props.updateInputs('modalAddDelegado.data.responsable_cenco',null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',disabled:true,className:'form-control input-sm',value:modalAddDelegado.getIn(['data','responsable_cenco','fullname'])||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Cenco'),modalAddDelegado.getIn(['data','responsable_cenco'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:modalAddDelegado.getIn(['data','cenco','descripcion'])||'',onClick:function onClick(){return _this2.handleOpenSelectorAddCenco('modalAddDelegado.data.cenco');},onReset:function onReset(){return _this2.props.updateInputs('modalAddDelegado.data.cenco',null);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',disabled:true,className:'form-control input-sm',value:modalAddDelegado.getIn(['data','cenco','descripcion'])||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-condensed table-bordered table-striped table-sorted nowrap',id:'table-delegados'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tipo de Solicitud'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,parametros&&parametros.map(function(ele){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'tipo['+ele.get('TIPO_SOLICITUD')+']'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:modalAddDelegado.getIn(['data','tipo_solicitud']).indexOf(ele.get("TIPO_SOLICITUD"))>=0,onChange:function onChange(e){return _this2.props.SelectTipoSolicitud(ele.get("TIPO_SOLICITUD"),e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ele.get("SOLICITUD")));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Usuario a delegar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shared_SelectorInput__["a" /* default */],{value:modalAddDelegado.getIn(['data','delegado','fullname'])||'',onClick:function onClick(){return _this2.handleOpenSelector('modalAddDelegado.data.delegado','/usuarios/ldap');},onReset:function onReset(){return _this2.props.updateInputs('modalAddDelegado.data.delegado',null);}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Shared_ModalFooter__["a" /* default */],null));}}]);return ModalAddDelegado;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{modalAddDelegado:state.delegados.get('modalAddDelegado'),parametros:state.common.getIn(['parametros','SOLICITUDES']),user:state.common.get('user')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{SelectTipoSolicitud:function SelectTipoSolicitud(tipo_solicitud,check){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["b" /* SelectTipoSolicitud */])(tipo_solicitud,check));},showHideModalAddDelegados:function showHideModalAddDelegados(show){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["g" /* showHideModalAddDelegados */])(show));},updateInputs:function updateInputs(path,value,immutable){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["j" /* updateInputs */])(path,value,immutable));},AddDelegado:function AddDelegado(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__actions_delegados__["a" /* AddDelegado */])());},showModalSelector:function showModalSelector(title,fields,url,action,customFilter){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["y" /* showModalSelector */])(title,fields,url,action,customFilter));},selectFromSelector:function selectFromSelector(type,payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_common__["q" /* selectFromSelector */])(type,payload));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAddDelegado));

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_virtualized__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_virtualized_styles_css__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_virtualized_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_virtualized_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ace__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_ace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_brace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_brace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_brace_mode_mysql__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_brace_mode_mysql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_brace_mode_mysql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_brace_mode_sql__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_brace_mode_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_brace_mode_sql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_brace_theme_github__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_brace_theme_github___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_brace_theme_github__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_brace_ext_language_tools__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_brace_ext_language_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_brace_ext_language_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_js_pagination__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_fontawesome__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_admindb__ = __webpack_require__(819);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Acciones
// Templates de queries útiles para soporte
var QUERY_TEMPLATES={'':'-- Seleccione un template','usuario_por_email':'-- Buscar usuario por email\nSELECT * FROM usuarios WHERE email LIKE \'%@icesi.edu.co%\' LIMIT 50','solicitudes_recientes':'-- Solicitudes creadas en los últimos 7 días\nSELECT id, proyecto_evento, estado, solicitante_id, created_at \nFROM solicitudes \nWHERE created_at >= DATE_SUB(NOW(), INTERVAL 7 DAY) \nORDER BY created_at DESC \nLIMIT 100','documentos_por_estado':'-- Documentos por estado específico\nSELECT d.id, d.estado, d.solicitud_id, s.proyecto_evento \nFROM documentos d \nJOIN solicitudes s ON d.solicitud_id = s.id \nWHERE d.estado = 11 \nLIMIT 50','facturas_por_documento':'-- Facturas de un documento específico\nSELECT f.*, d.solicitud_id \nFROM facturas f \nJOIN documentos d ON f.documento_id = d.id \nWHERE d.id = 12345','verificar_totales':'-- Verificar totales documento vs facturas\nSELECT \n    d.id as documento_id,\n    SUM(dd.valor_con_iva * dd.cantidad) as total_detalles,\n    (SELECT SUM(f.valor_a_pagar) FROM facturas f WHERE f.documento_id = d.id) as total_facturas,\n    ABS(SUM(dd.valor_con_iva * dd.cantidad) - COALESCE((SELECT SUM(f.valor_a_pagar) FROM facturas f WHERE f.documento_id = d.id), 0)) as diferencia\nFROM documentos d\nLEFT JOIN documento_detalle dd ON d.id = dd.documento_id\nWHERE d.id = 12345\nGROUP BY d.id','solicitud_completa':'-- Ver solicitud con documentos y facturas\nSELECT \n    s.id as solicitud_id,\n    s.proyecto_evento,\n    d.id as documento_id,\n    d.estado as doc_estado,\n    COUNT(f.id) as num_facturas\nFROM solicitudes s\nLEFT JOIN documentos d ON s.id = d.solicitud_id\nLEFT JOIN facturas f ON d.id = f.documento_id\nWHERE s.id = 12345\nGROUP BY s.id, s.proyecto_evento, d.id, d.estado'};function findValues(c,x){var value=x.getIn(c.VALUE.split('.'));return value;}var AdminDB=function(_React$Component){_inherits(AdminDB,_React$Component);function AdminDB(props){_classCallCheck(this,AdminDB);var _this=_possibleConstructorReturn(this,(AdminDB.__proto__||Object.getPrototypeOf(AdminDB)).call(this,props));_this.handleMouseDown=function(e){_this.setState({isResizing:true});e.preventDefault();};_this.handleMouseMove=function(e){if(!_this.state.isResizing)return;// Obtener la posición del editor
var editorElement=document.querySelector('.ace_editor');if(!editorElement)return;var editorTop=editorElement.getBoundingClientRect().top;var newHeight=e.clientY-editorTop;// Limites: min 100px, max 600px
if(newHeight>=100&&newHeight<=600){_this.setState({editorHeight:newHeight});}};_this.handleMouseUp=function(){if(_this.state.isResizing){_this.setState({isResizing:false});}};_this.saveToHistory=function(query,connection,records,executionTime){var history=_this.loadHistory();var newEntry={query:query,connection:connection,records:records,executionTime:executionTime,timestamp:new Date().toISOString()};// Mantener solo las últimas 20
var updatedHistory=[newEntry].concat(_toConsumableArray(history)).slice(0,20);localStorage.setItem('admindb_history',JSON.stringify(updatedHistory));_this.setState({queryHistory:updatedHistory});};_this.loadHistory=function(){try{var stored=localStorage.getItem('admindb_history');return stored?JSON.parse(stored):[];}catch(e){return[];}};_this.clearHistory=function(){localStorage.removeItem('admindb_history');_this.setState({queryHistory:[]});};_this.loadQueryFromHistory=function(query){_this.props.updateInputs('query',query);_this.setState({showHistory:false});};_this.loadTemplate=function(e){var template=e.target.value;if(template&&QUERY_TEMPLATES[template]){_this.props.updateInputs('query',QUERY_TEMPLATES[template]);}};_this.exportToCSV=function(){var _this$props=_this.props,data=_this$props.data,columns=_this$props.columns,ids=_this$props.ids;if(ids.count()===0){alert('No hay datos para exportar');return;}// Headers
var csv=columns.map(function(c){return'"'+c.CAPTION+'"';}).join(',')+'\n';// Rows
ids.forEach(function(id){var row=data.get(String(id));var values=columns.map(function(c){var value=findValues(c,row);// Escapar comillas y envolver en comillas
value=value?String(value).replace(/"/g,'""'):'';return'"'+value+'"';});csv+=values.join(',')+'\n';});// Descargar
var blob=new Blob([csv],{type:'text/csv;charset=utf-8;'});var link=document.createElement('a');var url=URL.createObjectURL(blob);link.setAttribute('href',url);link.setAttribute('download','query_results_'+Date.now()+'.csv');link.style.visibility='hidden';document.body.appendChild(link);link.click();document.body.removeChild(link);};_this.copyToClipboard=function(){var _this$props2=_this.props,data=_this$props2.data,columns=_this$props2.columns,ids=_this$props2.ids;if(ids.count()===0){alert('No hay datos para copiar');return;}// Formato TSV (Tab-Separated Values) para mejor compatibilidad con Excel
var text=columns.map(function(c){return c.CAPTION;}).join('\t')+'\n';ids.forEach(function(id){var row=data.get(String(id));var values=columns.map(function(c){var value=findValues(c,row);return value||'';});text+=values.join('\t')+'\n';});// Copiar al clipboard
navigator.clipboard.writeText(text).then(function(){alert('Datos copiados al portapapeles');}).catch(function(err){console.error('Error al copiar:',err);});};_this.cellRenderer=function(_ref){var columnIndex=_ref.columnIndex,key=_ref.key,rowIndex=_ref.rowIndex,style=_ref.style;if(rowIndex===0){var col=_this.props.columns[columnIndex];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'rvtableheader',style:Object.assign({},style,{textAlign:'center'})},col.CAPTION);}else{var ri=rowIndex-1;if(!Object(__WEBPACK_IMPORTED_MODULE_4_util__["isNumber"])(ri))return null;var id=_this.props.ids.get(ri);var c=_this.props.columns[columnIndex];var a=_this.props.data.get(String(id));var alignment='left';var value=findValues(c,a);var fixed=c.FIXED;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'rvtablecell'+(fixed?' fixed':''),style:Object.assign({},style,{textAlign:alignment})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,value));}};_this.getColumnWidth=function(_ref2){var index=_ref2.index;var c=_this.props.columns[index];return c.WIDTH||150;};_this.onClick=function(e){var callback=function callback(result){if(_this.multiGridRef.current){_this.multiGridRef.current.forceUpdateGrids();}// Guardar en historial si fue exitoso
if(result&&result.executionTime){_this.setState({executionTime:result.executionTime});_this.saveToHistory(_this.props.query,_this.props.connection,result.records||0,result.executionTime);}};_this.props.executeQuery(1,_this.state.readOnly,callback);};_this.state={readOnly:true,executionTime:0,queryHistory:_this.loadHistory(),showHistory:false,editorHeight:150,// Altura inicial del editor
isResizing:false};_this.multiGridRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(AdminDB,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousemove',this.handleMouseMove);document.addEventListener('mouseup',this.handleMouseUp);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousemove',this.handleMouseMove);document.removeEventListener('mouseup',this.handleMouseUp);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.records!=prevProps.records){if(this.multiGridRef.current){this.multiGridRef.current.forceUpdateGrids();}}}// Guardar en localStorage
},{key:'render',value:function render(){var _this2=this;var _props=this.props,columns=_props.columns,ids=_props.ids;var rowCount=ids.count()+1;var columnCount=columns.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'admindb-container',style:{display:'flex',flexDirection:'column',height:'calc(100vh - 100px)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:'10px',flexShrink:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{marginRight:'10px'}},'Templates de Soporte:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',onChange:this.loadTemplate,style:{display:'inline-block',width:'auto'}},Object.keys(QUERY_TEMPLATES).map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:key},key===''?'-- Seleccione un template':key.replace(/_/g,' '));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6',style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default btn-sm',onClick:function onClick(){return _this2.setState({showHistory:!_this2.state.showHistory});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'history'}),' Historial (',this.state.queryHistory.length,')'))),this.state.showHistory&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:'10px',flexShrink:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #ddd',padding:'10px',maxHeight:'200px',overflowY:'auto',backgroundColor:'#f9f9f9'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Historial de Queries'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default btn-xs pull-right',onClick:this.clearHistory},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'trash'}),' Limpiar')),this.state.queryHistory.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{color:'#999'}},'No hay queries en el historial'):this.state.queryHistory.map(function(entry,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:idx,style:{borderBottom:'1px solid #eee',padding:'5px 0',cursor:'pointer'},onClick:function onClick(){return _this2.loadQueryFromHistory(entry.query);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'11px',color:'#666'}},new Date(entry.timestamp).toLocaleString(),' |',entry.connection.toUpperCase(),' |',entry.records,' registros |',entry.executionTime,'ms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'12px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},entry.query.substring(0,100),'...'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{flexShrink:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_ace___default.a,{width:'100%',height:this.state.editorHeight+'px',mode:'sql',theme:'github',showPrintMargin:false,value:this.props.query,onChange:function onChange(v){return _this2.props.updateInputs('query',v);},name:'sql_editor',editorProps:{$blockScrolling:Infinity},fontSize:14,highlightActiveLine:true,wrapEnabled:false,setOptions:{enableBasicAutocompletion:true,enableLiveAutocompletion:false,enableSnippets:false,showLineNumbers:true,tabSize:4,useWorker:false}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{flexShrink:0,height:'8px',backgroundColor:this.state.isResizing?'#007bff':'#e0e0e0',cursor:'ns-resize',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',display:'flex',alignItems:'center',justifyContent:'center',transition:this.state.isResizing?'none':'background-color 0.2s',userSelect:'none'},onMouseDown:this.handleMouseDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'40px',height:'3px',backgroundColor:this.state.isResizing?'#fff':'#999',borderRadius:'2px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{flexShrink:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2',style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control input-sm',onChange:function onChange(e){return _this2.props.updateInputs('connection',e.target.value);},value:this.props.connection},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'mysql'},'MYSQL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'oracle'},'ORACLE'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4',style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{fontWeight:'normal',marginBottom:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:this.state.readOnly,onChange:function onChange(e){return _this2.setState({readOnly:e.target.checked});},style:{marginRight:'5px'}}),'Solo Lectura (READ-ONLY)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6',style:{padding:'10px',textAlign:'right'}},this.state.executionTime>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'15px',color:'#666'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'clock-o'}),' ',this.state.executionTime,'ms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-sm btn-default',onClick:this.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'play'}),' Ejecutar'))),this.props.records>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginTop:'10px',marginBottom:'10px',flexShrink:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default btn-sm',onClick:this.exportToCSV,style:{marginRight:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'download'}),' Exportar CSV'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-default btn-sm',onClick:this.copyToClipboard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'clipboard'}),' Copiar'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{flex:1,minHeight:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'datawrapper',style:{height:'100%'}},this.props.records>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_virtualized__["a" /* AutoSizer */],null,function(_ref3){var width=_ref3.width,height=_ref3.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_virtualized__["b" /* MultiGrid */],{ref:_this2.multiGridRef,cellRenderer:_this2.cellRenderer,columnWidth:_this2.getColumnWidth,columnCount:columnCount,fixedColumnCount:columns.filter(function(x){return x.FIXED;}).length,fixedRowCount:1,height:height,rowHeight:20,rowCount:rowCount,width:width,hideTopRightGridScrollbar:true,hideBottomLeftGridScrollbar:true});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{flexShrink:0,marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_js_pagination___default.a,{activePage:this.props.page,itemsCountPerPage:this.props.take,totalItemsCount:this.props.records,pageRangeDisplayed:10,onChange:function onChange(pg){return _this2.props.executeQuery(pg,_this2.state.readOnly,function(){if(_this2.multiGridRef.current){_this2.multiGridRef.current.forceUpdateGrids();}});},firstPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-double-left'}),prevPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-left'}),nextPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-right'}),lastPageText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_fontawesome___default.a,{name:'angle-double-right'})}))));}}]);return AdminDB;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state,ownProps){return{ids:state.admindb.get('ids'),records:state.admindb.get('records'),data:state.admindb.get('data'),columns:state.admindb.get('columns'),query:state.admindb.get('query'),connection:state.admindb.get('connection'),take:state.admindb.get('take'),page:state.admindb.get('page')};};var mapDispatchToProps={executeQuery:__WEBPACK_IMPORTED_MODULE_13__actions_admindb__["a" /* executeQuery */],updateInputs:__WEBPACK_IMPORTED_MODULE_13__actions_admindb__["b" /* updateInputs */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AdminDB));

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(713);
/* unused harmony reexport ArrowKeyStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(288);
/* unused harmony reexport CellMeasurer */
/* unused harmony reexport CellMeasurerCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(771);
/* unused harmony reexport Collection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(778);
/* unused harmony reexport ColumnSizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid__ = __webpack_require__(39);
/* unused harmony reexport accessibilityOverscanIndicesGetter */
/* unused harmony reexport defaultCellRangeRenderer */
/* unused harmony reexport defaultOverscanIndicesGetter */
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__ = __webpack_require__(780);
/* unused harmony reexport InfiniteLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(787);
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Masonry__ = __webpack_require__(791);
/* unused harmony reexport createMasonryCellPositioner */
/* unused harmony reexport Masonry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__MultiGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(807);
/* unused harmony reexport ScrollSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(809);
/* unused harmony reexport createTableMultiSort */
/* unused harmony reexport defaultTableCellDataGetter */
/* unused harmony reexport defaultTableCellRenderer */
/* unused harmony reexport defaultTableHeaderRenderer */
/* unused harmony reexport defaultTableHeaderRowRenderer */
/* unused harmony reexport defaultTableRowRenderer */
/* unused harmony reexport Table */
/* unused harmony reexport Column */
/* unused harmony reexport SortDirection */
/* unused harmony reexport SortIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WindowScroller__ = __webpack_require__(812);
/* unused harmony reexport WindowScroller */














/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(261);
/* unused harmony reexport default */
/* unused harmony reexport ArrowKeyStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(285);
/* unused harmony reexport bpfrpt_proptype_ScrollIndices */








/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(715);
module.exports = __webpack_require__(29).Object.getPrototypeOf;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(83);
var $getPrototypeOf = __webpack_require__(262);

__webpack_require__(161)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(717);
var $Object = __webpack_require__(29).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(47);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(58), 'Object', { defineProperty: __webpack_require__(57).f });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(719), __esModule: true };

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(101);
__webpack_require__(129);
module.exports = __webpack_require__(168).f('iterator');


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(164);
var defined = __webpack_require__(158);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(165);
var descriptor = __webpack_require__(100);
var setToStringTag = __webpack_require__(128);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(71)(IteratorPrototype, __webpack_require__(38)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(57);
var anObject = __webpack_require__(51);
var getKeys = __webpack_require__(102);

module.exports = __webpack_require__(58) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(72);
var toLength = __webpack_require__(166);
var toAbsoluteIndex = __webpack_require__(724);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(164);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(726);
var step = __webpack_require__(727);
var Iterators = __webpack_require__(86);
var toIObject = __webpack_require__(72);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(266)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(729), __esModule: true };

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(730);
__webpack_require__(272);
__webpack_require__(735);
__webpack_require__(736);
module.exports = __webpack_require__(29).Symbol;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(37);
var has = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(58);
var $export = __webpack_require__(47);
var redefine = __webpack_require__(267);
var META = __webpack_require__(731).KEY;
var $fails = __webpack_require__(85);
var shared = __webpack_require__(160);
var setToStringTag = __webpack_require__(128);
var uid = __webpack_require__(126);
var wks = __webpack_require__(38);
var wksExt = __webpack_require__(168);
var wksDefine = __webpack_require__(169);
var enumKeys = __webpack_require__(732);
var isArray = __webpack_require__(733);
var anObject = __webpack_require__(51);
var isObject = __webpack_require__(65);
var toObject = __webpack_require__(83);
var toIObject = __webpack_require__(72);
var toPrimitive = __webpack_require__(163);
var createDesc = __webpack_require__(100);
var _create = __webpack_require__(165);
var gOPNExt = __webpack_require__(734);
var $GOPD = __webpack_require__(171);
var $GOPS = __webpack_require__(170);
var $DP = __webpack_require__(57);
var $keys = __webpack_require__(102);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(271).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(130).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(99)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(71)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(126)('meta');
var isObject = __webpack_require__(65);
var has = __webpack_require__(70);
var setDesc = __webpack_require__(57).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(85)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(102);
var gOPS = __webpack_require__(170);
var pIE = __webpack_require__(130);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(103);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(72);
var gOPN = __webpack_require__(271).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(169)('asyncIterator');


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(169)('observable');


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(738), __esModule: true };

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(739);
module.exports = __webpack_require__(29).Object.setPrototypeOf;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(47);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(740).set });


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(65);
var anObject = __webpack_require__(51);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(84)(Function.call, __webpack_require__(171).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(742), __esModule: true };

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(743);
var $Object = __webpack_require__(29).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(47);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(165) });


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(745);
module.exports = __webpack_require__(29).Object.assign;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(47);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(746) });


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(58);
var getKeys = __webpack_require__(102);
var gOPS = __webpack_require__(170);
var pIE = __webpack_require__(130);
var toObject = __webpack_require__(83);
var IObject = __webpack_require__(269);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(85)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;


function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(23);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Used in deferred mode to track which cells have been queued for measurement.

  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeAndPositionData = {};
    this._lastMeasuredIndex = -1;
    this._lastBatchedIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (_currentOffset === offset) {
          return middle;
        } else if (_currentOffset < offset) {
          low = middle + 1;
        } else if (_currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);




/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(751);
module.exports = __webpack_require__(29).Object.keys;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(83);
var $keys = __webpack_require__(102);

__webpack_require__(161)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(23);




/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}



/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(755), __esModule: true };

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(272);
__webpack_require__(101);
__webpack_require__(129);
__webpack_require__(756);
__webpack_require__(764);
__webpack_require__(765);
module.exports = __webpack_require__(29).Promise;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(99);
var global = __webpack_require__(37);
var ctx = __webpack_require__(84);
var classof = __webpack_require__(176);
var $export = __webpack_require__(47);
var isObject = __webpack_require__(65);
var aFunction = __webpack_require__(127);
var anInstance = __webpack_require__(757);
var forOf = __webpack_require__(758);
var speciesConstructor = __webpack_require__(280);
var task = __webpack_require__(281).set;
var microtask = __webpack_require__(760)();
var newPromiseCapabilityModule = __webpack_require__(178);
var perform = __webpack_require__(282);
var userAgent = __webpack_require__(761);
var promiseResolve = __webpack_require__(283);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(38)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(762)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(128)($Promise, PROMISE);
__webpack_require__(763)(PROMISE);
Wrapper = __webpack_require__(29)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(284)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(84);
var call = __webpack_require__(278);
var isArrayIter = __webpack_require__(279);
var anObject = __webpack_require__(51);
var toLength = __webpack_require__(166);
var getIterFn = __webpack_require__(177);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(37);
var macrotask = __webpack_require__(281).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(103)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(37);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(71);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(37);
var core = __webpack_require__(29);
var dP = __webpack_require__(57);
var DESCRIPTORS = __webpack_require__(58);
var SPECIES = __webpack_require__(38)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(47);
var core = __webpack_require__(29);
var global = __webpack_require__(37);
var speciesConstructor = __webpack_require__(280);
var promiseResolve = __webpack_require__(283);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(47);
var newPromiseCapability = __webpack_require__(178);
var perform = __webpack_require__(282);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(23);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}



/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(286);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);








/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return typeof children === 'function' ? children({ measure: this._measure }) : children;
    }
  }, {
    key: '_getCellMeasurements',
    value: function _getCellMeasurements() {
      var cache = this.props.cache;


      var node = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this);

      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height;

        // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }
        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth);

        // Reset after measuring to avoid breaking styles; see #660
        if (styleWidth) {
          node.style.width = styleWidth;
        }
        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return { height: height, width: width };
      } else {
        return { height: 0, width: 0 };
      }
    }
  }, {
    key: '_maybeMeasureCell',
    value: function _maybeMeasureCell() {
      var _props = this.props,
          cache = _props.cache,
          _props$columnIndex = _props.columnIndex,
          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
          parent = _props.parent,
          _props$rowIndex = _props.rowIndex,
          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;


      if (!cache.has(rowIndex, columnIndex)) {
        var _getCellMeasurements2 = this._getCellMeasurements(),
            height = _getCellMeasurements2.height,
            width = _getCellMeasurements2.width;

        cache.set(rowIndex, columnIndex, width, height);

        // If size has changed, let Grid know to re-render.
        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

// Used for DEV mode warning check


CellMeasurer.__internalCellMeasurerFlag = false;
CellMeasurer.propTypes =  true ? null : {
  cache: function cache() {
    return (typeof bpfrpt_proptype_CellMeasureCache === 'function' ? bpfrpt_proptype_CellMeasureCache.isRequired ? bpfrpt_proptype_CellMeasureCache.isRequired : bpfrpt_proptype_CellMeasureCache : PropTypes.shape(bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
  },
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  columnIndex: PropTypes.number,
  index: PropTypes.number,
  parent: PropTypes.shape({
    invalidateCellSizeAfterRender: PropTypes.func,
    recomputeGridSize: PropTypes.func
  }).isRequired,
  rowIndex: PropTypes.number
};
/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
if (false) {
  CellMeasurer.__internalCellMeasurerFlag = true;
}



/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_HEIGHT */
/* unused harmony export DEFAULT_WIDTH */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(289);




var DEFAULT_HEIGHT = 30;

var DEFAULT_WIDTH = 100;

// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache = function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCache);

    this._cellHeightCache = {};
    this._cellWidthCache = {};
    this._columnWidthCache = {};
    this._rowHeightCache = {};
    this._columnCount = 0;
    this._rowCount = 0;

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
    };

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;


    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;

    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCache, [{
    key: 'clear',
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache.hasOwnProperty(key);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }
      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      }

      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: '_updateCachedColumnAndRowSizes',
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;
        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }
        var columnKey = this._keyMapper(0, columnIndex);
        this._columnWidthCache[columnKey] = columnWidth;
      }
      if (!this._hasFixedHeight) {
        var rowHeight = 0;
        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }
        var rowKey = this._keyMapper(rowIndex, 0);
        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (CellMeasurerCache);


function defaultKeyMapper(rowIndex, columnIndex) {
  return rowIndex + '-' + columnIndex;
}


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(772);
/* unused harmony reexport Collection */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionView__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types__ = __webpack_require__(88);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _React$PureComponent);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'forceUpdate',
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }

    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props,
          cellCount = _props.cellCount,
          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
          sectionSize = _props.sectionSize;


      var data = Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _props2 = this.props,
          cellGroupRenderer = _props2.cellGroupRenderer,
          cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: '_setCollectionViewRef',
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
Collection.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};


function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_scrollbarSize__ = __webpack_require__(277);













// @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()
    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };
    _this._calculateSizeAndPositionDataOnNextUpdate = false;
    _this._onSectionRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);

    _this._invokeOnSectionRenderedHelper = function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;


      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._updateScrollPositionForScrollToCell = function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;

      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    };

    _this._scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_11_dom_helpers_scrollbarSize__["a" /* default */])();
    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          cellLayoutManager = _props.cellLayoutManager,
          scrollLeft = _props.scrollLeft,
          scrollToCell = _props.scrollToCell,
          scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_11_dom_helpers_scrollbarSize__["a" /* default */])();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width;

      // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          height = _props2.height,
          scrollToAlignment = _props2.scrollToAlignment,
          scrollToCell = _props2.scrollToCell,
          width = _props2.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          autoHeight = _props3.autoHeight,
          cellCount = _props3.cellCount,
          cellLayoutManager = _props3.cellLayoutManager,
          className = _props3.className,
          height = _props3.height,
          horizontalOverscanSize = _props3.horizontalOverscanSize,
          id = _props3.id,
          noContentRenderer = _props3.noContentRenderer,
          style = _props3.style,
          verticalOverscanSize = _props3.verticalOverscanSize,
          width = _props3.width;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;

      // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;

        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width;

      // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0 },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            } },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;


        isScrollingChange(false);

        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref2) {
      var _this3 = this;

      var scrollLeft = _ref2.scrollLeft,
          scrollTop = _ref2.scrollTop,
          totalHeight = _ref2.totalHeight,
          totalWidth = _ref2.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref3) {
          var scrollLeft = _ref3.scrollLeft,
              scrollTop = _ref3.scrollTop;
          var _props4 = _this3.props,
              height = _props4.height,
              onScroll = _props4.onScroll,
              width = _props4.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref4) {
      var scrollLeft = _ref4.scrollLeft,
          scrollTop = _ref4.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
};
CollectionView.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(CollectionView);

/* harmony default export */ __webpack_exports__["a"] = (CollectionView);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(775);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(88);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */



var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);



/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(88);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);



/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === undefined ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(779);
/* unused harmony reexport ColumnSizer */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a" /* default */]);


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          columnMaxWidth = _props.columnMaxWidth,
          columnMinWidth = _props.columnMinWidth,
          columnCount = _props.columnCount,
          width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnMaxWidth = _props2.columnMaxWidth,
          columnMinWidth = _props2.columnMinWidth,
          columnCount = _props2.columnCount,
          width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
ColumnSizer.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(781);
/* unused harmony reexport InfiniteLoader */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a" /* default */]);


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__ = __webpack_require__(174);










/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'resetLoadMoreRowsCache',
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;

      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: '_doStuff',
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
          _this3 = this;

      var _props = this.props,
          isRowLoaded = _props.isRowLoaded,
          minimumBatchSize = _props.minimumBatchSize,
          rowCount = _props.rowCount,
          threshold = _props.threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
            stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
InfiniteLoader.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
      startIndex = _ref4.startIndex,
      stopIndex = _ref4.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
      minimumBatchSize = _ref5.minimumBatchSize,
      rowCount = _ref5.rowCount,
      startIndex = _ref5.startIndex,
      stopIndex = _ref5.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(783);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(784), __esModule: true };

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(101);
__webpack_require__(785);
module.exports = __webpack_require__(29).Array.from;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(84);
var $export = __webpack_require__(47);
var toObject = __webpack_require__(83);
var call = __webpack_require__(278);
var isArrayIter = __webpack_require__(279);
var toLength = __webpack_require__(166);
var createProperty = __webpack_require__(786);
var getIterFn = __webpack_require__(177);

$export($export.S + $export.F * !__webpack_require__(284)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(57);
var createDesc = __webpack_require__(100);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(290);
/* unused harmony reexport default */
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(131);
/* unused harmony reexport bpfrpt_proptype_RowRendererParams */








/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(789), __esModule: true };

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(790);
var $Object = __webpack_require__(29).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(72);
var $getOwnPropertyDescriptor = __webpack_require__(171).f;

__webpack_require__(161)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Masonry__ = __webpack_require__(179);
/* unused harmony reexport createCellPositioner */
/* unused harmony reexport Masonry */



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Masonry__["a" /* default */]);


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Masonry__ = __webpack_require__(179);


function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;

  var columnHeights = void 0;

  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;
    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;

    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;

    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];
    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;

    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;

  return cellPositioner;
}



/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(264);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__ = __webpack_require__(802);





// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache = function () {
  function PositionCache() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PositionCache);

    this._columnSizeMap = {};
    this._intervalTree = Object(__WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__["a" /* default */])();
    this._leftMap = {};
  }
  // Tracks the height of each column


  // Store tops and bottoms of each cell for fast intersection lookup.


  // Maps cell index to x coordinates for quick lookup.


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PositionCache, [{
    key: 'estimateTotalHeight',
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }

    // Render all cells visible within the viewport range defined.

  }, {
    key: 'range',
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: 'setPosition',
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);
      this._leftMap[index] = left;

      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];
      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: 'count',
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: 'shortestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: 'tallestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (PositionCache);

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(796);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(799);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(797), __esModule: true };

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129);
__webpack_require__(101);
module.exports = __webpack_require__(798);


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(176);
var ITERATOR = __webpack_require__(38)('iterator');
var Iterators = __webpack_require__(86);
module.exports = __webpack_require__(29).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(800), __esModule: true };

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129);
__webpack_require__(101);
module.exports = __webpack_require__(801);


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(51);
var get = __webpack_require__(177);
module.exports = __webpack_require__(29).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__ = __webpack_require__(803);
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/



var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin);
    var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.left.remove(interval);
    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.right.remove(interval);
    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS;
    }
    for (var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);

  var mid = pts[pts.length >> 1];

  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }

  //Split center intervals
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);

  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}

//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);
    if (r === EMPTY) {
      this.root = null;
    }
    return r !== NOT_FOUND;
  }
  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});

Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});

function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }
  return new IntervalTree(createIntervalTree(intervals));
}

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(805);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a" /* default */]);


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(39);













var SCROLLBAR_SIZE_BUFFER = 20;

/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _initialiseProps.call(_this);

    var deferredMeasurementCache = props.deferredMeasurementCache,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount;


    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'forceUpdateGrids',
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }

    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$columnIndex = _ref2.columnIndex,
          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
          _ref2$rowIndex = _ref2.rowIndex,
          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;

      var _props = this.props,
          fixedColumnCount = _props.fixedColumnCount,
          fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          scrollLeft = _props2.scrollLeft,
          scrollTop = _props2.scrollTop;


      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          onScroll = _props3.onScroll,
          onSectionRendered = _props3.onSectionRendered,
          onScrollbarPresenceChange = _props3.onScrollbarPresenceChange,
          scrollLeftProp = _props3.scrollLeft,
          scrollToColumn = _props3.scrollToColumn,
          scrollTopProp = _props3.scrollTop,
          scrollToRow = _props3.scrollToRow,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      this._prepareForRender();

      // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }

      // scrollTop and scrollLeft props are explicitly filtered out and ignored

      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _props4 = this.props,
          columnWidth = _props4.columnWidth,
          enableFixedColumnScroll = _props4.enableFixedColumnScroll,
          enableFixedRowScroll = _props4.enableFixedRowScroll,
          height = _props4.height,
          fixedColumnCount = _props4.fixedColumnCount,
          fixedRowCount = _props4.fixedRowCount,
          rowHeight = _props4.rowHeight,
          style = _props4.style,
          styleBottomLeftGrid = _props4.styleBottomLeftGrid,
          styleBottomRightGrid = _props4.styleBottomRightGrid,
          styleTopLeftGrid = _props4.styleTopLeftGrid,
          styleTopRightGrid = _props4.styleTopRightGrid,
          width = _props4.width;


      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          overflow: 'visible', // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible', // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: '_prepareForRender',
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;


      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'BottomLeftGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._bottomLeftGridStyle, {
              height: height,
              width: width,
              overflowY: 'hidden'
            }) },
          bottomLeftGrid
        );
      }
      return bottomLeftGrid;
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _state2 = this.state,
          showHorizontalScrollbar = _state2.showHorizontalScrollbar,
          scrollbarSize = _state2.scrollbarSize;


      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'TopRightGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
              height: height,
              width: width,
              overflowX: 'hidden'
            }) },
          topRightGrid
        );
      }
      return topRightGrid;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

MultiGrid.defaultProps = {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = {
    scrollLeft: 0,
    scrollTop: 0,
    scrollbarSize: 0,
    showHorizontalScrollbar: false,
    showVerticalScrollbar: false
  };
  this._deferredInvalidateColumnIndex = null;
  this._deferredInvalidateRowIndex = null;

  this._bottomLeftGridRef = function (ref) {
    _this2._bottomLeftGrid = ref;
  };

  this._bottomRightGridRef = function (ref) {
    _this2._bottomRightGrid = ref;
  };

  this._cellRendererBottomLeftGrid = function (_ref3) {
    var rowIndex = _ref3.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['rowIndex']);

    var _props5 = _this2.props,
        cellRenderer = _props5.cellRenderer,
        fixedRowCount = _props5.fixedRowCount,
        rowCount = _props5.rowCount;


    if (rowIndex === rowCount - fixedRowCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          height: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        parent: _this2,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  };

  this._cellRendererBottomRightGrid = function (_ref4) {
    var columnIndex = _ref4.columnIndex,
        rowIndex = _ref4.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex', 'rowIndex']);

    var _props6 = _this2.props,
        cellRenderer = _props6.cellRenderer,
        fixedColumnCount = _props6.fixedColumnCount,
        fixedRowCount = _props6.fixedRowCount;


    return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
      columnIndex: columnIndex + fixedColumnCount,
      parent: _this2,
      rowIndex: rowIndex + fixedRowCount
    }));
  };

  this._cellRendererTopRightGrid = function (_ref5) {
    var columnIndex = _ref5.columnIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['columnIndex']);

    var _props7 = _this2.props,
        cellRenderer = _props7.cellRenderer,
        columnCount = _props7.columnCount,
        fixedColumnCount = _props7.fixedColumnCount;


    if (columnIndex === columnCount - fixedColumnCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          width: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _this2
      }));
    }
  };

  this._columnWidthRightGrid = function (_ref6) {
    var index = _ref6.index;
    var _props8 = _this2.props,
        columnCount = _props8.columnCount,
        fixedColumnCount = _props8.fixedColumnCount,
        columnWidth = _props8.columnWidth;
    var _state3 = _this2.state,
        scrollbarSize = _state3.scrollbarSize,
        showHorizontalScrollbar = _state3.showHorizontalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
      return scrollbarSize;
    }

    return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
  };

  this._onScroll = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft,
        scrollTop = scrollInfo.scrollTop;

    _this2.setState({
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    });
    var onScroll = _this2.props.onScroll;
    if (onScroll) {
      onScroll(scrollInfo);
    }
  };

  this._onScrollbarPresenceChange = function (_ref7) {
    var horizontal = _ref7.horizontal,
        size = _ref7.size,
        vertical = _ref7.vertical;
    var _state4 = _this2.state,
        showHorizontalScrollbar = _state4.showHorizontalScrollbar,
        showVerticalScrollbar = _state4.showVerticalScrollbar;


    if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
      _this2.setState({
        scrollbarSize: size,
        showHorizontalScrollbar: horizontal,
        showVerticalScrollbar: vertical
      });

      var onScrollbarPresenceChange = _this2.props.onScrollbarPresenceChange;

      if (typeof onScrollbarPresenceChange === 'function') {
        onScrollbarPresenceChange({
          horizontal: horizontal,
          size: size,
          vertical: vertical
        });
      }
    }
  };

  this._onScrollLeft = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft;

    _this2._onScroll({
      scrollLeft: scrollLeft,
      scrollTop: _this2.state.scrollTop
    });
  };

  this._onScrollTop = function (scrollInfo) {
    var scrollTop = scrollInfo.scrollTop;

    _this2._onScroll({
      scrollTop: scrollTop,
      scrollLeft: _this2.state.scrollLeft
    });
  };

  this._rowHeightBottomGrid = function (_ref8) {
    var index = _ref8.index;
    var _props9 = _this2.props,
        fixedRowCount = _props9.fixedRowCount,
        rowCount = _props9.rowCount,
        rowHeight = _props9.rowHeight;
    var _state5 = _this2.state,
        scrollbarSize = _state5.scrollbarSize,
        showVerticalScrollbar = _state5.showVerticalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
      return scrollbarSize;
    }

    return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
  };

  this._topLeftGridRef = function (ref) {
    _this2._topLeftGrid = ref;
  };

  this._topRightGridRef = function (ref) {
    _this2._topRightGrid = ref;
  };
};

MultiGrid.propTypes =  false ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(MultiGrid);

/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(288);




/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator = function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCacheDecorator);

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    };

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;


    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCacheDecorator, [{
    key: 'clear',
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCacheDecorator);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(808);
/* unused harmony reexport ScrollSync */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          clientHeight = _state.clientHeight,
          clientWidth = _state.clientWidth,
          scrollHeight = _state.scrollHeight,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop,
          scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;

      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMultiSort__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Column__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortDirection__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortIndicator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(811);
/* unused harmony reexport createMultiSort */
/* unused harmony reexport defaultCellDataGetter */
/* unused harmony reexport defaultCellRenderer */
/* unused harmony reexport defaultHeaderRowRenderer */
/* unused harmony reexport defaultHeaderRenderer */
/* unused harmony reexport defaultRowRenderer */
/* unused harmony reexport Column */
/* unused harmony reexport SortDirection */
/* unused harmony reexport SortIndicator */
/* unused harmony reexport Table */











/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */]);


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error('Required parameter "sortCallback" not specified');
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};

  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);
      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      // Clear sortBy array of all non-selected keys
      sortBy.length = 0;
      sortBy.push(dataKey);

      // Clear sortDirection object of all non-selected keys
      var sortDirectionKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sortDirection);
      sortDirectionKeys.forEach(function (key) {
        if (key !== dataKey) delete sortDirection[key];
      });

      // If key is already selected, reverse sort direction.
      // Else, set sort direction to default direction.
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    }

    // Notify application code
    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SortDirection__ = __webpack_require__(132);




















/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _React$PureComponent);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _Grid$getOffsetForCel.scrollTop;

        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'getScrollbarWidth',
    value: function getScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(this.Grid);
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }

      return 0;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeader = _props.disableHeader,
          gridClassName = _props.gridClassName,
          gridStyle = _props.gridStyle,
          headerHeight = _props.headerHeight,
          headerRowRenderer = _props.headerRowRenderer,
          height = _props.height,
          id = _props.id,
          noRowsRenderer = _props.noRowsRenderer,
          rowClassName = _props.rowClassName,
          rowStyle = _props.rowStyle,
          scrollToIndex = _props.scrollToIndex,
          style = _props.style,
          width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          overflow: 'hidden'
        }, flexStyles);
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': this.props['aria-label'],
          'aria-labelledby': this.props['aria-labelledby'],
          'aria-colcount': __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).length,
          'aria-rowcount': this.props.rowCount,
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ReactVirtualized__Table', className),
          id: id,
          role: 'grid',
          style: style },
        !disableHeader && headerRowRenderer({
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ReactVirtualized__Table__headerRow', rowClass),
          columns: this._getHeaderColumns(),
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            height: headerHeight,
            overflow: 'hidden',
            paddingRight: scrollbarWidth,
            width: width
          }, rowStyleObject)
        }),
        __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          'aria-readonly': null,
          autoContainerWidth: true,
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: this._setRef,
          role: 'rowgroup',
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({ columnData: columnData, dataKey: dataKey, event: event });
      };

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-colindex': columnIndex + 1,
          'aria-describedby': id,
          className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ReactVirtualized__Table__rowColumn', className),
          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
          onClick: onClick,
          role: 'gridcell',
          style: style,
          title: title },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _props2 = this.props,
          headerClassName = _props2.headerClassName,
          headerStyle = _props2.headerStyle,
          onHeaderClick = _props2.onHeaderClick,
          sort = _props2.sort,
          sortBy = _props2.sortBy,
          sortDirection = _props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;

      var sortEnabled = !disableSort && sort;

      var classNames = Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headerStyle, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var headerOnClick = void 0,
          headerOnKeyDown = void 0,
          headerTabIndex = void 0,
          headerAriaSort = void 0,
          headerAriaLabel = void 0;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey;

        // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC ? 'ascending' : 'descending';
      }

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': headerAriaLabel,
          'aria-sort': headerAriaSort,
          className: classNames,
          id: id,
          key: 'Header-Col' + index,
          onClick: headerOnClick,
          onKeyDown: headerOnKeyDown,
          role: 'columnheader',
          style: style,
          tabIndex: headerTabIndex },
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _props3 = this.props,
          children = _props3.children,
          onRowClick = _props3.onRowClick,
          onRowDoubleClick = _props3.onRowDoubleClick,
          onRowRightClick = _props3.onRowRightClick,
          onRowMouseOver = _props3.onRowMouseOver,
          onRowMouseOut = _props3.onRowMouseOut,
          rowClassName = _props3.rowClassName,
          rowGetter = _props3.rowGetter,
          rowRenderer = _props3.rowRenderer,
          rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getHeaderColumns',
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _props4 = this.props,
          children = _props4.children,
          disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();

      this.setState({ scrollbarWidth: scrollbarWidth });
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  headerRowRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
Table.propTypes =  false ? {
  /** This is just set on the grid top element. */
  'aria-label': PropTypes.string,

  /** This is just set on the grid top element. */
  'aria-labelledby': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
   * Optional callback when a column is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onColumnClick: PropTypes.func,

  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : {};


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(298);
/* unused harmony reexport WindowScroller */
/* unused harmony reexport IS_SCROLLING_TIMEOUT */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a" /* default */]);


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowScroller_js__ = __webpack_require__(298);



var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });

  disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollOffset;


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */

var isWindow = function isWindow(element) {
  return element === window;
};

// TODO Move this into WindowScroller and import from there


var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;

    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}

/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */
function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}

/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var DocCommentHighlightRules = function() {
    this.$rules = {
        "start" : [ {
            token : "comment.doc.tag",
            regex : "@[\\w\\d_]+" // TODO: fix email addresses
        }, 
        DocCommentHighlightRules.getTagRule(),
        {
            defaultToken : "comment.doc",
            caseInsensitive: true
        }]
    };
};

oop.inherits(DocCommentHighlightRules, TextHighlightRules);

DocCommentHighlightRules.getTagRule = function(start) {
    return {
        token : "comment.doc.tag.storage.type",
        regex : "\\b(?:TODO|FIXME|XXX|HACK)\\b"
    };
};

DocCommentHighlightRules.getStartRule = function(start) {
    return {
        token : "comment.doc", // doc comment
        regex : "\\/\\*(?=\\*)",
        next  : start
    };
};

DocCommentHighlightRules.getEndRule = function (start) {
    return {
        token : "comment.doc", // closing comment
        regex : "\\*\\/",
        next  : start
    };
};


exports.DocCommentHighlightRules = DocCommentHighlightRules;

});

ace.define("ace/mode/mysql_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"], function(acequire, exports, module) {

var oop = acequire("../lib/oop");
var lang = acequire("../lib/lang");
var DocCommentHighlightRules = acequire("./doc_comment_highlight_rules").DocCommentHighlightRules;
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var MysqlHighlightRules = function() {

    var mySqlKeywords = /*sql*/ "alter|and|as|asc|between|count|create|delete|desc|distinct|drop|from|having|in|insert|into|is|join|like|not|on|or|order|select|set|table|union|update|values|where" + "|accessible|action|add|after|algorithm|all|analyze|asensitive|at|authors|auto_increment|autocommit|avg|avg_row_length|before|binary|binlog|both|btree|cache|call|cascade|cascaded|case|catalog_name|chain|change|changed|character|check|checkpoint|checksum|class_origin|client_statistics|close|coalesce|code|collate|collation|collations|column|columns|comment|commit|committed|completion|concurrent|condition|connection|consistent|constraint|contains|continue|contributors|convert|cross|current_date|current_time|current_timestamp|current_user|cursor|data|database|databases|day_hour|day_microsecond|day_minute|day_second|deallocate|dec|declare|default|delay_key_write|delayed|delimiter|des_key_file|describe|deterministic|dev_pop|dev_samp|deviance|directory|disable|discard|distinctrow|div|dual|dumpfile|each|elseif|enable|enclosed|end|ends|engine|engines|enum|errors|escape|escaped|even|event|events|every|execute|exists|exit|explain|extended|fast|fetch|field|fields|first|flush|for|force|foreign|found_rows|full|fulltext|function|general|global|grant|grants|group|groupby_concat|handler|hash|help|high_priority|hosts|hour_microsecond|hour_minute|hour_second|if|ignore|ignore_server_ids|import|index|index_statistics|infile|inner|innodb|inout|insensitive|insert_method|install|interval|invoker|isolation|iterate|key|keys|kill|language|last|leading|leave|left|level|limit|linear|lines|list|load|local|localtime|localtimestamp|lock|logs|low_priority|master|master_heartbeat_period|master_ssl_verify_server_cert|masters|match|max|max_rows|maxvalue|message_text|middleint|migrate|min|min_rows|minute_microsecond|minute_second|mod|mode|modifies|modify|mutex|mysql_errno|natural|next|no|no_write_to_binlog|offline|offset|one|online|open|optimize|option|optionally|out|outer|outfile|pack_keys|parser|partition|partitions|password|phase|plugin|plugins|prepare|preserve|prev|primary|privileges|procedure|processlist|profile|profiles|purge|query|quick|range|read|read_write|reads|real|rebuild|recover|references|regexp|relaylog|release|remove|rename|reorganize|repair|repeatable|replace|acequire|resignal|restrict|resume|return|returns|revoke|right|rlike|rollback|rollup|row|row_format|rtree|savepoint|schedule|schema|schema_name|schemas|second_microsecond|security|sensitive|separator|serializable|server|session|share|show|signal|slave|slow|smallint|snapshot|soname|spatial|specific|sql|sql_big_result|sql_buffer_result|sql_cache|sql_calc_found_rows|sql_no_cache|sql_small_result|sqlexception|sqlstate|sqlwarning|ssl|start|starting|starts|status|std|stddev|stddev_pop|stddev_samp|storage|straight_join|subclass_origin|sum|suspend|table_name|table_statistics|tables|tablespace|temporary|terminated|to|trailing|transaction|trigger|triggers|truncate|uncommitted|undo|uninstall|unique|unlock|upgrade|usage|use|use_frm|user|user_resources|user_statistics|using|utc_date|utc_time|utc_timestamp|value|variables|varying|view|views|warnings|when|while|with|work|write|xa|xor|year_month|zerofill|begin|do|then|else|loop|repeat";
    var builtins = "by|bool|boolean|bit|blob|decimal|double|enum|float|long|longblob|longtext|medium|mediumblob|mediumint|mediumtext|time|timestamp|tinyblob|tinyint|tinytext|text|bigint|int|int1|int2|int3|int4|int8|integer|float|float4|float8|double|char|varbinary|varchar|varcharacter|precision|date|datetime|year|unsigned|signed|numeric|ucase|lcase|mid|len|round|rank|now|format|coalesce|ifnull|isnull|nvl";
    var variable = "charset|clear|connect|edit|ego|exit|go|help|nopager|notee|nowarning|pager|print|prompt|quit|rehash|source|status|system|tee";

    var keywordMapper = this.createKeywordMapper({
        "support.function": builtins,
        "keyword": mySqlKeywords,
        "constant": "false|true|null|unknown|date|time|timestamp|ODBCdotTable|zerolessFloat",
        "variable.language": variable
    }, "identifier", true);

    
    function string(rule) {
        var start = rule.start;
        var escapeSeq = rule.escape;
        return {
            token: "string.start",
            regex: start,
            next: [
                {token: "constant.language.escape", regex: escapeSeq},
                {token: "string.end", next: "start", regex: start},
                {defaultToken: "string"}
            ]
        };
    }

    this.$rules = {
        "start" : [ {
            token : "comment", regex : "(?:-- |#).*$"
        },  
        string({start: '"', escape: /\\[0'"bnrtZ\\%_]?/}),
        string({start: "'", escape: /\\[0'"bnrtZ\\%_]?/}),
        DocCommentHighlightRules.getStartRule("doc-start"),
        {
            token : "comment", // multi line comment
            regex : /\/\*/,
            next : "comment"
        }, {
            token : "constant.numeric", // hex
            regex : /0[xX][0-9a-fA-F]+|[xX]'[0-9a-fA-F]+'|0[bB][01]+|[bB]'[01]+'/
        }, {
            token : "constant.numeric", // float
            regex : "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
        }, {
            token : keywordMapper,
            regex : "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, {
            token : "constant.class",
            regex : "@@?[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, {
            token : "constant.buildin",
            regex : "`[^`]*`"
        }, {
            token : "keyword.operator",
            regex : "\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|="
        }, {
            token : "paren.lparen",
            regex : "[\\(]"
        }, {
            token : "paren.rparen",
            regex : "[\\)]"
        }, {
            token : "text",
            regex : "\\s+"
        } ],
        "comment" : [
            {token : "comment", regex : "\\*\\/", next : "start"},
            {defaultToken : "comment"}
        ]
    };

    this.embedRules(DocCommentHighlightRules, "doc-", [ DocCommentHighlightRules.getEndRule("start") ]);
    this.normalizeRules();
};

oop.inherits(MysqlHighlightRules, TextHighlightRules);

exports.MysqlHighlightRules = MysqlHighlightRules;
});

ace.define("ace/mode/mysql",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/mysql_highlight_rules"], function(acequire, exports, module) {

var oop = acequire("../lib/oop");
var TextMode = acequire("../mode/text").Mode;
var MysqlHighlightRules = acequire("./mysql_highlight_rules").MysqlHighlightRules;

var Mode = function() {
    this.HighlightRules = MysqlHighlightRules;
    this.$behaviour = this.$defaultBehaviour;
};
oop.inherits(Mode, TextMode);

(function() {       
    this.lineCommentStart = ["--", "#"]; // todo space
    this.blockComment = {start: "/*", end: "*/"};

    this.$id = "ace/mode/mysql";
}).call(Mode.prototype);

exports.Mode = Mode;
});


/***/ }),
/* 817 */
/***/ (function(module, exports) {

ace.define("ace/mode/sql_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var SqlHighlightRules = function() {

    var keywords = (
        "select|insert|update|delete|from|where|and|or|group|by|order|limit|offset|having|as|case|" +
        "when|else|end|type|left|right|join|on|outer|desc|asc|union|create|table|primary|key|if|" +
        "foreign|not|references|default|null|inner|cross|natural|database|drop|grant"
    );

    var builtinConstants = (
        "true|false"
    );

    var builtinFunctions = (
        "avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|" + 
        "coalesce|ifnull|isnull|nvl"
    );

    var dataTypes = (
        "int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|" +
        "money|real|number|integer"
    );

    var keywordMapper = this.createKeywordMapper({
        "support.function": builtinFunctions,
        "keyword": keywords,
        "constant.language": builtinConstants,
        "storage.type": dataTypes
    }, "identifier", true);

    this.$rules = {
        "start" : [ {
            token : "comment",
            regex : "--.*$"
        },  {
            token : "comment",
            start : "/\\*",
            end : "\\*/"
        }, {
            token : "string",           // " string
            regex : '".*?"'
        }, {
            token : "string",           // ' string
            regex : "'.*?'"
        }, {
            token : "string",           // ` string (apache drill)
            regex : "`.*?`"
        }, {
            token : "constant.numeric", // float
            regex : "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
        }, {
            token : keywordMapper,
            regex : "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, {
            token : "keyword.operator",
            regex : "\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|="
        }, {
            token : "paren.lparen",
            regex : "[\\(]"
        }, {
            token : "paren.rparen",
            regex : "[\\)]"
        }, {
            token : "text",
            regex : "\\s+"
        } ]
    };
    this.normalizeRules();
};

oop.inherits(SqlHighlightRules, TextHighlightRules);

exports.SqlHighlightRules = SqlHighlightRules;
});

ace.define("ace/mode/sql",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/sql_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var SqlHighlightRules = acequire("./sql_highlight_rules").SqlHighlightRules;

var Mode = function() {
    this.HighlightRules = SqlHighlightRules;
    this.$behaviour = this.$defaultBehaviour;
};
oop.inherits(Mode, TextMode);

(function() {

    this.lineCommentStart = "--";

    this.$id = "ace/mode/sql";
}).call(Mode.prototype);

exports.Mode = Mode;

});


/***/ }),
/* 818 */
/***/ (function(module, exports) {

ace.define("ace/snippets",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/lang","ace/range","ace/anchor","ace/keyboard/hash_handler","ace/tokenizer","ace/lib/dom","ace/editor"], function(acequire, exports, module) {
"use strict";
var oop = acequire("./lib/oop");
var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
var lang = acequire("./lib/lang");
var Range = acequire("./range").Range;
var Anchor = acequire("./anchor").Anchor;
var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var Tokenizer = acequire("./tokenizer").Tokenizer;
var comparePoints = Range.comparePoints;

var SnippetManager = function() {
    this.snippetMap = {};
    this.snippetNameMap = {};
};

(function() {
    oop.implement(this, EventEmitter);
    
    this.getTokenizer = function() {
        function TabstopToken(str, _, stack) {
            str = str.substr(1);
            if (/^\d+$/.test(str) && !stack.inFormatString)
                return [{tabstopId: parseInt(str, 10)}];
            return [{text: str}];
        }
        function escape(ch) {
            return "(?:[^\\\\" + ch + "]|\\\\.)";
        }
        SnippetManager.$tokenizer = new Tokenizer({
            start: [
                {regex: /:/, onMatch: function(val, state, stack) {
                    if (stack.length && stack[0].expectIf) {
                        stack[0].expectIf = false;
                        stack[0].elseBranch = stack[0];
                        return [stack[0]];
                    }
                    return ":";
                }},
                {regex: /\\./, onMatch: function(val, state, stack) {
                    var ch = val[1];
                    if (ch == "}" && stack.length) {
                        val = ch;
                    }else if ("`$\\".indexOf(ch) != -1) {
                        val = ch;
                    } else if (stack.inFormatString) {
                        if (ch == "n")
                            val = "\n";
                        else if (ch == "t")
                            val = "\n";
                        else if ("ulULE".indexOf(ch) != -1) {
                            val = {changeCase: ch, local: ch > "a"};
                        }
                    }

                    return [val];
                }},
                {regex: /}/, onMatch: function(val, state, stack) {
                    return [stack.length ? stack.shift() : val];
                }},
                {regex: /\$(?:\d+|\w+)/, onMatch: TabstopToken},
                {regex: /\$\{[\dA-Z_a-z]+/, onMatch: function(str, state, stack) {
                    var t = TabstopToken(str.substr(1), state, stack);
                    stack.unshift(t[0]);
                    return t;
                }, next: "snippetVar"},
                {regex: /\n/, token: "newline", merge: false}
            ],
            snippetVar: [
                {regex: "\\|" + escape("\\|") + "*\\|", onMatch: function(val, state, stack) {
                    stack[0].choices = val.slice(1, -1).split(",");
                }, next: "start"},
                {regex: "/(" + escape("/") + "+)/(?:(" + escape("/") + "*)/)(\\w*):?",
                 onMatch: function(val, state, stack) {
                    var ts = stack[0];
                    ts.fmtString = val;

                    val = this.splitRegex.exec(val);
                    ts.guard = val[1];
                    ts.fmt = val[2];
                    ts.flag = val[3];
                    return "";
                }, next: "start"},
                {regex: "`" + escape("`") + "*`", onMatch: function(val, state, stack) {
                    stack[0].code = val.splice(1, -1);
                    return "";
                }, next: "start"},
                {regex: "\\?", onMatch: function(val, state, stack) {
                    if (stack[0])
                        stack[0].expectIf = true;
                }, next: "start"},
                {regex: "([^:}\\\\]|\\\\.)*:?", token: "", next: "start"}
            ],
            formatString: [
                {regex: "/(" + escape("/") + "+)/", token: "regex"},
                {regex: "", onMatch: function(val, state, stack) {
                    stack.inFormatString = true;
                }, next: "start"}
            ]
        });
        SnippetManager.prototype.getTokenizer = function() {
            return SnippetManager.$tokenizer;
        };
        return SnippetManager.$tokenizer;
    };

    this.tokenizeTmSnippet = function(str, startState) {
        return this.getTokenizer().getLineTokens(str, startState).tokens.map(function(x) {
            return x.value || x;
        });
    };

    this.$getDefaultValue = function(editor, name) {
        if (/^[A-Z]\d+$/.test(name)) {
            var i = name.substr(1);
            return (this.variables[name[0] + "__"] || {})[i];
        }
        if (/^\d+$/.test(name)) {
            return (this.variables.__ || {})[name];
        }
        name = name.replace(/^TM_/, "");

        if (!editor)
            return;
        var s = editor.session;
        switch(name) {
            case "CURRENT_WORD":
                var r = s.getWordRange();
            case "SELECTION":
            case "SELECTED_TEXT":
                return s.getTextRange(r);
            case "CURRENT_LINE":
                return s.getLine(editor.getCursorPosition().row);
            case "PREV_LINE": // not possible in textmate
                return s.getLine(editor.getCursorPosition().row - 1);
            case "LINE_INDEX":
                return editor.getCursorPosition().column;
            case "LINE_NUMBER":
                return editor.getCursorPosition().row + 1;
            case "SOFT_TABS":
                return s.getUseSoftTabs() ? "YES" : "NO";
            case "TAB_SIZE":
                return s.getTabSize();
            case "FILENAME":
            case "FILEPATH":
                return "";
            case "FULLNAME":
                return "Ace";
        }
    };
    this.variables = {};
    this.getVariableValue = function(editor, varName) {
        if (this.variables.hasOwnProperty(varName))
            return this.variables[varName](editor, varName) || "";
        return this.$getDefaultValue(editor, varName) || "";
    };
    this.tmStrFormat = function(str, ch, editor) {
        var flag = ch.flag || "";
        var re = ch.guard;
        re = new RegExp(re, flag.replace(/[^gi]/, ""));
        var fmtTokens = this.tokenizeTmSnippet(ch.fmt, "formatString");
        var _self = this;
        var formatted = str.replace(re, function() {
            _self.variables.__ = arguments;
            var fmtParts = _self.resolveVariables(fmtTokens, editor);
            var gChangeCase = "E";
            for (var i  = 0; i < fmtParts.length; i++) {
                var ch = fmtParts[i];
                if (typeof ch == "object") {
                    fmtParts[i] = "";
                    if (ch.changeCase && ch.local) {
                        var next = fmtParts[i + 1];
                        if (next && typeof next == "string") {
                            if (ch.changeCase == "u")
                                fmtParts[i] = next[0].toUpperCase();
                            else
                                fmtParts[i] = next[0].toLowerCase();
                            fmtParts[i + 1] = next.substr(1);
                        }
                    } else if (ch.changeCase) {
                        gChangeCase = ch.changeCase;
                    }
                } else if (gChangeCase == "U") {
                    fmtParts[i] = ch.toUpperCase();
                } else if (gChangeCase == "L") {
                    fmtParts[i] = ch.toLowerCase();
                }
            }
            return fmtParts.join("");
        });
        this.variables.__ = null;
        return formatted;
    };

    this.resolveVariables = function(snippet, editor) {
        var result = [];
        for (var i = 0; i < snippet.length; i++) {
            var ch = snippet[i];
            if (typeof ch == "string") {
                result.push(ch);
            } else if (typeof ch != "object") {
                continue;
            } else if (ch.skip) {
                gotoNext(ch);
            } else if (ch.processed < i) {
                continue;
            } else if (ch.text) {
                var value = this.getVariableValue(editor, ch.text);
                if (value && ch.fmtString)
                    value = this.tmStrFormat(value, ch);
                ch.processed = i;
                if (ch.expectIf == null) {
                    if (value) {
                        result.push(value);
                        gotoNext(ch);
                    }
                } else {
                    if (value) {
                        ch.skip = ch.elseBranch;
                    } else
                        gotoNext(ch);
                }
            } else if (ch.tabstopId != null) {
                result.push(ch);
            } else if (ch.changeCase != null) {
                result.push(ch);
            }
        }
        function gotoNext(ch) {
            var i1 = snippet.indexOf(ch, i + 1);
            if (i1 != -1)
                i = i1;
        }
        return result;
    };

    this.insertSnippetForSelection = function(editor, snippetText) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var tabString = editor.session.getTabString();
        var indentString = line.match(/^\s*/)[0];
        
        if (cursor.column < indentString.length)
            indentString = indentString.slice(0, cursor.column);

        snippetText = snippetText.replace(/\r/g, "");
        var tokens = this.tokenizeTmSnippet(snippetText);
        tokens = this.resolveVariables(tokens, editor);
        tokens = tokens.map(function(x) {
            if (x == "\n")
                return x + indentString;
            if (typeof x == "string")
                return x.replace(/\t/g, tabString);
            return x;
        });
        var tabstops = [];
        tokens.forEach(function(p, i) {
            if (typeof p != "object")
                return;
            var id = p.tabstopId;
            var ts = tabstops[id];
            if (!ts) {
                ts = tabstops[id] = [];
                ts.index = id;
                ts.value = "";
            }
            if (ts.indexOf(p) !== -1)
                return;
            ts.push(p);
            var i1 = tokens.indexOf(p, i + 1);
            if (i1 === -1)
                return;

            var value = tokens.slice(i + 1, i1);
            var isNested = value.some(function(t) {return typeof t === "object";});
            if (isNested && !ts.value) {
                ts.value = value;
            } else if (value.length && (!ts.value || typeof ts.value !== "string")) {
                ts.value = value.join("");
            }
        });
        tabstops.forEach(function(ts) {ts.length = 0;});
        var expanding = {};
        function copyValue(val) {
            var copy = [];
            for (var i = 0; i < val.length; i++) {
                var p = val[i];
                if (typeof p == "object") {
                    if (expanding[p.tabstopId])
                        continue;
                    var j = val.lastIndexOf(p, i - 1);
                    p = copy[j] || {tabstopId: p.tabstopId};
                }
                copy[i] = p;
            }
            return copy;
        }
        for (var i = 0; i < tokens.length; i++) {
            var p = tokens[i];
            if (typeof p != "object")
                continue;
            var id = p.tabstopId;
            var i1 = tokens.indexOf(p, i + 1);
            if (expanding[id]) {
                if (expanding[id] === p)
                    expanding[id] = null;
                continue;
            }
            
            var ts = tabstops[id];
            var arg = typeof ts.value == "string" ? [ts.value] : copyValue(ts.value);
            arg.unshift(i + 1, Math.max(0, i1 - i));
            arg.push(p);
            expanding[id] = p;
            tokens.splice.apply(tokens, arg);

            if (ts.indexOf(p) === -1)
                ts.push(p);
        }
        var row = 0, column = 0;
        var text = "";
        tokens.forEach(function(t) {
            if (typeof t === "string") {
                var lines = t.split("\n");
                if (lines.length > 1){
                    column = lines[lines.length - 1].length;
                    row += lines.length - 1;
                } else
                    column += t.length;
                text += t;
            } else {
                if (!t.start)
                    t.start = {row: row, column: column};
                else
                    t.end = {row: row, column: column};
            }
        });
        var range = editor.getSelectionRange();
        var end = editor.session.replace(range, text);

        var tabstopManager = new TabstopManager(editor);
        var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
        tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
    };
    
    this.insertSnippet = function(editor, snippetText) {
        var self = this;
        if (editor.inVirtualSelectionMode)
            return self.insertSnippetForSelection(editor, snippetText);
        
        editor.forEachSelection(function() {
            self.insertSnippetForSelection(editor, snippetText);
        }, null, {keepOrder: true});
        
        if (editor.tabstopManager)
            editor.tabstopManager.tabNext();
    };

    this.$getScope = function(editor) {
        var scope = editor.session.$mode.$id || "";
        scope = scope.split("/").pop();
        if (scope === "html" || scope === "php") {
            if (scope === "php" && !editor.session.$mode.inlinePhp) 
                scope = "html";
            var c = editor.getCursorPosition();
            var state = editor.session.getState(c.row);
            if (typeof state === "object") {
                state = state[0];
            }
            if (state.substring) {
                if (state.substring(0, 3) == "js-")
                    scope = "javascript";
                else if (state.substring(0, 4) == "css-")
                    scope = "css";
                else if (state.substring(0, 4) == "php-")
                    scope = "php";
            }
        }
        
        return scope;
    };

    this.getActiveScopes = function(editor) {
        var scope = this.$getScope(editor);
        var scopes = [scope];
        var snippetMap = this.snippetMap;
        if (snippetMap[scope] && snippetMap[scope].includeScopes) {
            scopes.push.apply(scopes, snippetMap[scope].includeScopes);
        }
        scopes.push("_");
        return scopes;
    };

    this.expandWithTab = function(editor, options) {
        var self = this;
        var result = editor.forEachSelection(function() {
            return self.expandSnippetForSelection(editor, options);
        }, null, {keepOrder: true});
        if (result && editor.tabstopManager)
            editor.tabstopManager.tabNext();
        return result;
    };
    
    this.expandSnippetForSelection = function(editor, options) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var before = line.substring(0, cursor.column);
        var after = line.substr(cursor.column);

        var snippetMap = this.snippetMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = this.findMatchingSnippet(snippets, before, after);
            return !!snippet;
        }, this);
        if (!snippet)
            return false;
        if (options && options.dryRun)
            return true;
        editor.session.doc.removeInLine(cursor.row,
            cursor.column - snippet.replaceBefore.length,
            cursor.column + snippet.replaceAfter.length
        );

        this.variables.M__ = snippet.matchBefore;
        this.variables.T__ = snippet.matchAfter;
        this.insertSnippetForSelection(editor, snippet.content);

        this.variables.M__ = this.variables.T__ = null;
        return true;
    };

    this.findMatchingSnippet = function(snippetList, before, after) {
        for (var i = snippetList.length; i--;) {
            var s = snippetList[i];
            if (s.startRe && !s.startRe.test(before))
                continue;
            if (s.endRe && !s.endRe.test(after))
                continue;
            if (!s.startRe && !s.endRe)
                continue;

            s.matchBefore = s.startRe ? s.startRe.exec(before) : [""];
            s.matchAfter = s.endRe ? s.endRe.exec(after) : [""];
            s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
            s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
            return s;
        }
    };

    this.snippetMap = {};
    this.snippetNameMap = {};
    this.register = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;
        var self = this;
        
        if (!snippets) 
            snippets = [];
        
        function wrapRegexp(src) {
            if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src))
                src = "(?:" + src + ")";

            return src || "";
        }
        function guardedRegexp(re, guard, opening) {
            re = wrapRegexp(re);
            guard = wrapRegexp(guard);
            if (opening) {
                re = guard + re;
                if (re && re[re.length - 1] != "$")
                    re = re + "$";
            } else {
                re = re + guard;
                if (re && re[0] != "^")
                    re = "^" + re;
            }
            return new RegExp(re);
        }

        function addSnippet(s) {
            if (!s.scope)
                s.scope = scope || "_";
            scope = s.scope;
            if (!snippetMap[scope]) {
                snippetMap[scope] = [];
                snippetNameMap[scope] = {};
            }

            var map = snippetNameMap[scope];
            if (s.name) {
                var old = map[s.name];
                if (old)
                    self.unregister(old);
                map[s.name] = s;
            }
            snippetMap[scope].push(s);

            if (s.tabTrigger && !s.trigger) {
                if (!s.guard && /^\w/.test(s.tabTrigger))
                    s.guard = "\\b";
                s.trigger = lang.escapeRegExp(s.tabTrigger);
            }
            
            if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard)
                return;
            
            s.startRe = guardedRegexp(s.trigger, s.guard, true);
            s.triggerRe = new RegExp(s.trigger, "", true);

            s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
            s.endTriggerRe = new RegExp(s.endTrigger, "", true);
        }

        if (snippets && snippets.content)
            addSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(addSnippet);
        
        this._signal("registerSnippets", {scope: scope});
    };
    this.unregister = function(snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;

        function removeSnippet(s) {
            var nameMap = snippetNameMap[s.scope||scope];
            if (nameMap && nameMap[s.name]) {
                delete nameMap[s.name];
                var map = snippetMap[s.scope||scope];
                var i = map && map.indexOf(s);
                if (i >= 0)
                    map.splice(i, 1);
            }
        }
        if (snippets.content)
            removeSnippet(snippets);
        else if (Array.isArray(snippets))
            snippets.forEach(removeSnippet);
    };
    this.parseSnippetFile = function(str) {
        str = str.replace(/\r/g, "");
        var list = [], snippet = {};
        var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
        var m;
        while (m = re.exec(str)) {
            if (m[1]) {
                try {
                    snippet = JSON.parse(m[1]);
                    list.push(snippet);
                } catch (e) {}
            } if (m[4]) {
                snippet.content = m[4].replace(/^\t/gm, "");
                list.push(snippet);
                snippet = {};
            } else {
                var key = m[2], val = m[3];
                if (key == "regex") {
                    var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
                    snippet.guard = guardRe.exec(val)[1];
                    snippet.trigger = guardRe.exec(val)[1];
                    snippet.endTrigger = guardRe.exec(val)[1];
                    snippet.endGuard = guardRe.exec(val)[1];
                } else if (key == "snippet") {
                    snippet.tabTrigger = val.match(/^\S*/)[0];
                    if (!snippet.name)
                        snippet.name = val;
                } else {
                    snippet[key] = val;
                }
            }
        }
        return list;
    };
    this.getSnippetByName = function(name, editor) {
        var snippetMap = this.snippetNameMap;
        var snippet;
        this.getActiveScopes(editor).some(function(scope) {
            var snippets = snippetMap[scope];
            if (snippets)
                snippet = snippets[name];
            return !!snippet;
        }, this);
        return snippet;
    };

}).call(SnippetManager.prototype);


var TabstopManager = function(editor) {
    if (editor.tabstopManager)
        return editor.tabstopManager;
    editor.tabstopManager = this;
    this.$onChange = this.onChange.bind(this);
    this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
    this.$onChangeSession = this.onChangeSession.bind(this);
    this.$onAfterExec = this.onAfterExec.bind(this);
    this.attach(editor);
};
(function() {
    this.attach = function(editor) {
        this.index = 0;
        this.ranges = [];
        this.tabstops = [];
        this.$openTabstops = null;
        this.selectedTabstop = null;

        this.editor = editor;
        this.editor.on("change", this.$onChange);
        this.editor.on("changeSelection", this.$onChangeSelection);
        this.editor.on("changeSession", this.$onChangeSession);
        this.editor.commands.on("afterExec", this.$onAfterExec);
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.detach = function() {
        this.tabstops.forEach(this.removeTabstopMarkers, this);
        this.ranges = null;
        this.tabstops = null;
        this.selectedTabstop = null;
        this.editor.removeListener("change", this.$onChange);
        this.editor.removeListener("changeSelection", this.$onChangeSelection);
        this.editor.removeListener("changeSession", this.$onChangeSession);
        this.editor.commands.removeListener("afterExec", this.$onAfterExec);
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.tabstopManager = null;
        this.editor = null;
    };

    this.onChange = function(delta) {
        var changeRange = delta;
        var isRemove = delta.action[0] == "r";
        var start = delta.start;
        var end = delta.end;
        var startRow = start.row;
        var endRow = end.row;
        var lineDif = endRow - startRow;
        var colDiff = end.column - start.column;

        if (isRemove) {
            lineDif = -lineDif;
            colDiff = -colDiff;
        }
        if (!this.$inChange && isRemove) {
            var ts = this.selectedTabstop;
            var changedOutside = ts && !ts.some(function(r) {
                return comparePoints(r.start, start) <= 0 && comparePoints(r.end, end) >= 0;
            });
            if (changedOutside)
                return this.detach();
        }
        var ranges = this.ranges;
        for (var i = 0; i < ranges.length; i++) {
            var r = ranges[i];
            if (r.end.row < start.row)
                continue;

            if (isRemove && comparePoints(start, r.start) < 0 && comparePoints(end, r.end) > 0) {
                this.removeRange(r);
                i--;
                continue;
            }

            if (r.start.row == startRow && r.start.column > start.column)
                r.start.column += colDiff;
            if (r.end.row == startRow && r.end.column >= start.column)
                r.end.column += colDiff;
            if (r.start.row >= startRow)
                r.start.row += lineDif;
            if (r.end.row >= startRow)
                r.end.row += lineDif;

            if (comparePoints(r.start, r.end) > 0)
                this.removeRange(r);
        }
        if (!ranges.length)
            this.detach();
    };
    this.updateLinkedFields = function() {
        var ts = this.selectedTabstop;
        if (!ts || !ts.hasLinkedRanges)
            return;
        this.$inChange = true;
        var session = this.editor.session;
        var text = session.getTextRange(ts.firstNonLinked);
        for (var i = ts.length; i--;) {
            var range = ts[i];
            if (!range.linked)
                continue;
            var fmt = exports.snippetManager.tmStrFormat(text, range.original);
            session.replace(range, fmt);
        }
        this.$inChange = false;
    };
    this.onAfterExec = function(e) {
        if (e.command && !e.command.readOnly)
            this.updateLinkedFields();
    };
    this.onChangeSelection = function() {
        if (!this.editor)
            return;
        var lead = this.editor.selection.lead;
        var anchor = this.editor.selection.anchor;
        var isEmpty = this.editor.selection.isEmpty();
        for (var i = this.ranges.length; i--;) {
            if (this.ranges[i].linked)
                continue;
            var containsLead = this.ranges[i].contains(lead.row, lead.column);
            var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
            if (containsLead && containsAnchor)
                return;
        }
        this.detach();
    };
    this.onChangeSession = function() {
        this.detach();
    };
    this.tabNext = function(dir) {
        var max = this.tabstops.length;
        var index = this.index + (dir || 1);
        index = Math.min(Math.max(index, 1), max);
        if (index == max)
            index = 0;
        this.selectTabstop(index);
        if (index === 0)
            this.detach();
    };
    this.selectTabstop = function(index) {
        this.$openTabstops = null;
        var ts = this.tabstops[this.index];
        if (ts)
            this.addTabstopMarkers(ts);
        this.index = index;
        ts = this.tabstops[this.index];
        if (!ts || !ts.length)
            return;
        
        this.selectedTabstop = ts;
        if (!this.editor.inVirtualSelectionMode) {        
            var sel = this.editor.multiSelect;
            sel.toSingleRange(ts.firstNonLinked.clone());
            for (var i = ts.length; i--;) {
                if (ts.hasLinkedRanges && ts[i].linked)
                    continue;
                sel.addRange(ts[i].clone(), true);
            }
            if (sel.ranges[0])
                sel.addRange(sel.ranges[0].clone());
        } else {
            this.editor.selection.setRange(ts.firstNonLinked);
        }
        
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
    };
    this.addTabstops = function(tabstops, start, end) {
        if (!this.$openTabstops)
            this.$openTabstops = [];
        if (!tabstops[0]) {
            var p = Range.fromPoints(end, end);
            moveRelative(p.start, start);
            moveRelative(p.end, start);
            tabstops[0] = [p];
            tabstops[0].index = 0;
        }

        var i = this.index;
        var arg = [i + 1, 0];
        var ranges = this.ranges;
        tabstops.forEach(function(ts, index) {
            var dest = this.$openTabstops[index] || ts;
                
            for (var i = ts.length; i--;) {
                var p = ts[i];
                var range = Range.fromPoints(p.start, p.end || p.start);
                movePoint(range.start, start);
                movePoint(range.end, start);
                range.original = p;
                range.tabstop = dest;
                ranges.push(range);
                if (dest != ts)
                    dest.unshift(range);
                else
                    dest[i] = range;
                if (p.fmtString) {
                    range.linked = true;
                    dest.hasLinkedRanges = true;
                } else if (!dest.firstNonLinked)
                    dest.firstNonLinked = range;
            }
            if (!dest.firstNonLinked)
                dest.hasLinkedRanges = false;
            if (dest === ts) {
                arg.push(dest);
                this.$openTabstops[index] = dest;
            }
            this.addTabstopMarkers(dest);
        }, this);
        
        if (arg.length > 2) {
            if (this.tabstops.length)
                arg.push(arg.splice(2, 1)[0]);
            this.tabstops.splice.apply(this.tabstops, arg);
        }
    };

    this.addTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            if  (!range.markerId)
                range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
        });
    };
    this.removeTabstopMarkers = function(ts) {
        var session = this.editor.session;
        ts.forEach(function(range) {
            session.removeMarker(range.markerId);
            range.markerId = null;
        });
    };
    this.removeRange = function(range) {
        var i = range.tabstop.indexOf(range);
        range.tabstop.splice(i, 1);
        i = this.ranges.indexOf(range);
        this.ranges.splice(i, 1);
        this.editor.session.removeMarker(range.markerId);
        if (!range.tabstop.length) {
            i = this.tabstops.indexOf(range.tabstop);
            if (i != -1)
                this.tabstops.splice(i, 1);
            if (!this.tabstops.length)
                this.detach();
        }
    };

    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys({
        "Tab": function(ed) {
            if (exports.snippetManager && exports.snippetManager.expandWithTab(ed)) {
                return;
            }

            ed.tabstopManager.tabNext(1);
        },
        "Shift-Tab": function(ed) {
            ed.tabstopManager.tabNext(-1);
        },
        "Esc": function(ed) {
            ed.tabstopManager.detach();
        },
        "Return": function(ed) {
            return false;
        }
    });
}).call(TabstopManager.prototype);



var changeTracker = {};
changeTracker.onChange = Anchor.prototype.onChange;
changeTracker.setPosition = function(row, column) {
    this.pos.row = row;
    this.pos.column = column;
};
changeTracker.update = function(pos, delta, $insertRight) {
    this.$insertRight = $insertRight;
    this.pos = pos; 
    this.onChange(delta);
};

var movePoint = function(point, diff) {
    if (point.row == 0)
        point.column += diff.column;
    point.row += diff.row;
};

var moveRelative = function(point, start) {
    if (point.row == start.row)
        point.column -= start.column;
    point.row -= start.row;
};


acequire("./lib/dom").importCssString("\
.ace_snippet-marker {\
    -moz-box-sizing: border-box;\
    box-sizing: border-box;\
    background: rgba(194, 193, 208, 0.09);\
    border: 1px dotted rgba(211, 208, 235, 0.62);\
    position: absolute;\
}");

exports.snippetManager = new SnippetManager();


var Editor = acequire("./editor").Editor;
(function() {
    this.insertSnippet = function(content, options) {
        return exports.snippetManager.insertSnippet(this, content, options);
    };
    this.expandSnippet = function(options) {
        return exports.snippetManager.expandWithTab(this, options);
    };
}).call(Editor.prototype);

});

ace.define("ace/autocomplete/popup",["require","exports","module","ace/virtual_renderer","ace/editor","ace/range","ace/lib/event","ace/lib/lang","ace/lib/dom"], function(acequire, exports, module) {
"use strict";

var Renderer = acequire("../virtual_renderer").VirtualRenderer;
var Editor = acequire("../editor").Editor;
var Range = acequire("../range").Range;
var event = acequire("../lib/event");
var lang = acequire("../lib/lang");
var dom = acequire("../lib/dom");

var $singleLineEditor = function(el) {
    var renderer = new Renderer(el);

    renderer.$maxLines = 4;

    var editor = new Editor(renderer);

    editor.setHighlightActiveLine(false);
    editor.setShowPrintMargin(false);
    editor.renderer.setShowGutter(false);
    editor.renderer.setHighlightGutterLine(false);

    editor.$mouseHandler.$focusWaitTimout = 0;
    editor.$highlightTagPending = true;

    return editor;
};

var AcePopup = function(parentNode) {
    var el = dom.createElement("div");
    var popup = new $singleLineEditor(el);

    if (parentNode)
        parentNode.appendChild(el);
    el.style.display = "none";
    popup.renderer.content.style.cursor = "default";
    popup.renderer.setStyle("ace_autocomplete");

    popup.setOption("displayIndentGuides", false);
    popup.setOption("dragDelay", 150);

    var noop = function(){};

    popup.focus = noop;
    popup.$isFocused = true;

    popup.renderer.$cursorLayer.restartTimer = noop;
    popup.renderer.$cursorLayer.element.style.opacity = 0;

    popup.renderer.$maxLines = 8;
    popup.renderer.$keepTextAreaAtCursor = false;

    popup.setHighlightActiveLine(false);
    popup.session.highlight("");
    popup.session.$searchHighlight.clazz = "ace_highlight-marker";

    popup.on("mousedown", function(e) {
        var pos = e.getDocumentPosition();
        popup.selection.moveToPosition(pos);
        selectionMarker.start.row = selectionMarker.end.row = pos.row;
        e.stop();
    });

    var lastMouseEvent;
    var hoverMarker = new Range(-1,0,-1,Infinity);
    var selectionMarker = new Range(-1,0,-1,Infinity);
    selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");
    popup.setSelectOnHover = function(val) {
        if (!val) {
            hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
        } else if (hoverMarker.id) {
            popup.session.removeMarker(hoverMarker.id);
            hoverMarker.id = null;
        }
    };
    popup.setSelectOnHover(false);
    popup.on("mousemove", function(e) {
        if (!lastMouseEvent) {
            lastMouseEvent = e;
            return;
        }
        if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) {
            return;
        }
        lastMouseEvent = e;
        lastMouseEvent.scrollTop = popup.renderer.scrollTop;
        var row = lastMouseEvent.getDocumentPosition().row;
        if (hoverMarker.start.row != row) {
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row);
        }
    });
    popup.renderer.on("beforeRender", function() {
        if (lastMouseEvent && hoverMarker.start.row != -1) {
            lastMouseEvent.$pos = null;
            var row = lastMouseEvent.getDocumentPosition().row;
            if (!hoverMarker.id)
                popup.setRow(row);
            setHoverMarker(row, true);
        }
    });
    popup.renderer.on("afterRender", function() {
        var row = popup.getRow();
        var t = popup.renderer.$textLayer;
        var selected = t.element.childNodes[row - t.config.firstRow];
        if (selected == t.selectedNode)
            return;
        if (t.selectedNode)
            dom.removeCssClass(t.selectedNode, "ace_selected");
        t.selectedNode = selected;
        if (selected)
            dom.addCssClass(selected, "ace_selected");
    });
    var hideHoverMarker = function() { setHoverMarker(-1); };
    var setHoverMarker = function(row, suppressRedraw) {
        if (row !== hoverMarker.start.row) {
            hoverMarker.start.row = hoverMarker.end.row = row;
            if (!suppressRedraw)
                popup.session._emit("changeBackMarker");
            popup._emit("changeHoverMarker");
        }
    };
    popup.getHoveredRow = function() {
        return hoverMarker.start.row;
    };

    event.addListener(popup.container, "mouseout", hideHoverMarker);
    popup.on("hide", hideHoverMarker);
    popup.on("changeSelection", hideHoverMarker);

    popup.session.doc.getLength = function() {
        return popup.data.length;
    };
    popup.session.doc.getLine = function(i) {
        var data = popup.data[i];
        if (typeof data == "string")
            return data;
        return (data && data.value) || "";
    };

    var bgTokenizer = popup.session.bgTokenizer;
    bgTokenizer.$tokenizeRow = function(row) {
        var data = popup.data[row];
        var tokens = [];
        if (!data)
            return tokens;
        if (typeof data == "string")
            data = {value: data};
        if (!data.caption)
            data.caption = data.value || data.name;

        var last = -1;
        var flag, c;
        for (var i = 0; i < data.caption.length; i++) {
            c = data.caption[i];
            flag = data.matchMask & (1 << i) ? 1 : 0;
            if (last !== flag) {
                tokens.push({type: data.className || "" + ( flag ? "completion-highlight" : ""), value: c});
                last = flag;
            } else {
                tokens[tokens.length - 1].value += c;
            }
        }

        if (data.meta) {
            var maxW = popup.renderer.$size.scrollerWidth / popup.renderer.layerConfig.characterWidth;
            var metaData = data.meta;
            if (metaData.length + data.caption.length > maxW - 2) {
                metaData = metaData.substr(0, maxW - data.caption.length - 3) + "\u2026";
            }
            tokens.push({type: "rightAlignedText", value: metaData});
        }
        return tokens;
    };
    bgTokenizer.$updateOnChange = noop;
    bgTokenizer.start = noop;

    popup.session.$computeWidth = function() {
        return this.screenWidth = 0;
    };

    popup.$blockScrolling = Infinity;
    popup.isOpen = false;
    popup.isTopdown = false;
    popup.autoSelect = true;

    popup.data = [];
    popup.setData = function(list) {
        popup.setValue(lang.stringRepeat("\n", list.length), -1);
        popup.data = list || [];
        popup.setRow(0);
    };
    popup.getData = function(row) {
        return popup.data[row];
    };

    popup.getRow = function() {
        return selectionMarker.start.row;
    };
    popup.setRow = function(line) {
        line = Math.max(this.autoSelect ? 0 : -1, Math.min(this.data.length, line));
        if (selectionMarker.start.row != line) {
            popup.selection.clearSelection();
            selectionMarker.start.row = selectionMarker.end.row = line || 0;
            popup.session._emit("changeBackMarker");
            popup.moveCursorTo(line || 0, 0);
            if (popup.isOpen)
                popup._signal("select");
        }
    };

    popup.on("changeSelection", function() {
        if (popup.isOpen)
            popup.setRow(popup.selection.lead.row);
        popup.renderer.scrollCursorIntoView();
    });

    popup.hide = function() {
        this.container.style.display = "none";
        this._signal("hide");
        popup.isOpen = false;
    };
    popup.show = function(pos, lineHeight, topdownOnly) {
        var el = this.container;
        var screenHeight = window.innerHeight;
        var screenWidth = window.innerWidth;
        var renderer = this.renderer;
        var maxH = renderer.$maxLines * lineHeight * 1.4;
        var top = pos.top + this.$borderSize;
        var allowTopdown = top > screenHeight / 2 && !topdownOnly;
        if (allowTopdown && top + lineHeight + maxH > screenHeight) {
            renderer.$maxPixelHeight = top - 2 * this.$borderSize;
            el.style.top = "";
            el.style.bottom = screenHeight - top + "px";
            popup.isTopdown = false;
        } else {
            top += lineHeight;
            renderer.$maxPixelHeight = screenHeight - top - 0.2 * lineHeight;
            el.style.top = top + "px";
            el.style.bottom = "";
            popup.isTopdown = true;
        }

        el.style.display = "";
        this.renderer.$textLayer.checkForSizeChanges();

        var left = pos.left;
        if (left + el.offsetWidth > screenWidth)
            left = screenWidth - el.offsetWidth;

        el.style.left = left + "px";

        this._signal("show");
        lastMouseEvent = null;
        popup.isOpen = true;
    };

    popup.getTextLeftOffset = function() {
        return this.$borderSize + this.renderer.$padding + this.$imageSize;
    };

    popup.$imageSize = 0;
    popup.$borderSize = 1;

    return popup;
};

dom.importCssString("\
.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\
    background-color: #CAD6FA;\
    z-index: 1;\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    border: 1px solid #abbffe;\
    margin-top: -1px;\
    background: rgba(233,233,253,0.4);\
}\
.ace_editor.ace_autocomplete .ace_line-hover {\
    position: absolute;\
    z-index: 2;\
}\
.ace_editor.ace_autocomplete .ace_scroller {\
   background: none;\
   border: none;\
   box-shadow: none;\
}\
.ace_rightAlignedText {\
    color: gray;\
    display: inline-block;\
    position: absolute;\
    right: 4px;\
    text-align: right;\
    z-index: -1;\
}\
.ace_editor.ace_autocomplete .ace_completion-highlight{\
    color: #000;\
    text-shadow: 0 0 0.01em;\
}\
.ace_editor.ace_autocomplete {\
    width: 280px;\
    z-index: 200000;\
    background: #fbfbfb;\
    color: #444;\
    border: 1px lightgray solid;\
    position: fixed;\
    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
    line-height: 1.4;\
}");

exports.AcePopup = AcePopup;

});

ace.define("ace/autocomplete/util",["require","exports","module"], function(acequire, exports, module) {
"use strict";

exports.parForEach = function(array, fn, callback) {
    var completed = 0;
    var arLength = array.length;
    if (arLength === 0)
        callback();
    for (var i = 0; i < arLength; i++) {
        fn(array[i], function(result, err) {
            completed++;
            if (completed === arLength)
                callback(result, err);
        });
    }
};

var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;

exports.retrievePrecedingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos-1; i >= 0; i--) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf.reverse().join("");
};

exports.retrieveFollowingIdentifier = function(text, pos, regex) {
    regex = regex || ID_REGEX;
    var buf = [];
    for (var i = pos; i < text.length; i++) {
        if (regex.test(text[i]))
            buf.push(text[i]);
        else
            break;
    }
    return buf;
};

exports.getCompletionPrefix = function (editor) {
    var pos = editor.getCursorPosition();
    var line = editor.session.getLine(pos.row);
    var prefix;
    editor.completers.forEach(function(completer) {
        if (completer.identifierRegexps) {
            completer.identifierRegexps.forEach(function(identifierRegex) {
                if (!prefix && identifierRegex)
                    prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
            }.bind(this));
        }
    }.bind(this));
    return prefix || this.retrievePrecedingIdentifier(line, pos.column);
};

});

ace.define("ace/autocomplete",["require","exports","module","ace/keyboard/hash_handler","ace/autocomplete/popup","ace/autocomplete/util","ace/lib/event","ace/lib/lang","ace/lib/dom","ace/snippets"], function(acequire, exports, module) {
"use strict";

var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
var AcePopup = acequire("./autocomplete/popup").AcePopup;
var util = acequire("./autocomplete/util");
var event = acequire("./lib/event");
var lang = acequire("./lib/lang");
var dom = acequire("./lib/dom");
var snippetManager = acequire("./snippets").snippetManager;

var Autocomplete = function() {
    this.autoInsert = false;
    this.autoSelect = true;
    this.exactMatch = false;
    this.gatherCompletionsId = 0;
    this.keyboardHandler = new HashHandler();
    this.keyboardHandler.bindKeys(this.commands);

    this.blurListener = this.blurListener.bind(this);
    this.changeListener = this.changeListener.bind(this);
    this.mousedownListener = this.mousedownListener.bind(this);
    this.mousewheelListener = this.mousewheelListener.bind(this);

    this.changeTimer = lang.delayedCall(function() {
        this.updateCompletions(true);
    }.bind(this));

    this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
};

(function() {

    this.$init = function() {
        this.popup = new AcePopup(document.body || document.documentElement);
        this.popup.on("click", function(e) {
            this.insertMatch();
            e.stop();
        }.bind(this));
        this.popup.focus = this.editor.focus.bind(this.editor);
        this.popup.on("show", this.tooltipTimer.bind(null, null));
        this.popup.on("select", this.tooltipTimer.bind(null, null));
        this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
        return this.popup;
    };

    this.getPopup = function() {
        return this.popup || this.$init();
    };

    this.openPopup = function(editor, prefix, keepPopupPosition) {
        if (!this.popup)
            this.$init();

	this.popup.autoSelect = this.autoSelect;

        this.popup.setData(this.completions.filtered);

        editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        
        var renderer = editor.renderer;
        this.popup.setRow(this.autoSelect ? 0 : -1);
        if (!keepPopupPosition) {
            this.popup.setTheme(editor.getTheme());
            this.popup.setFontSize(editor.getFontSize());

            var lineHeight = renderer.layerConfig.lineHeight;

            var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
            pos.left -= this.popup.getTextLeftOffset();

            var rect = editor.container.getBoundingClientRect();
            pos.top += rect.top - renderer.layerConfig.offset;
            pos.left += rect.left - editor.renderer.scrollLeft;
            pos.left += renderer.gutterWidth;

            this.popup.show(pos, lineHeight);
        } else if (keepPopupPosition && !prefix) {
            this.detach();
        }
    };

    this.detach = function() {
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.off("changeSelection", this.changeListener);
        this.editor.off("blur", this.blurListener);
        this.editor.off("mousedown", this.mousedownListener);
        this.editor.off("mousewheel", this.mousewheelListener);
        this.changeTimer.cancel();
        this.hideDocTooltip();

        this.gatherCompletionsId += 1;
        if (this.popup && this.popup.isOpen)
            this.popup.hide();

        if (this.base)
            this.base.detach();
        this.activated = false;
        this.completions = this.base = null;
    };

    this.changeListener = function(e) {
        var cursor = this.editor.selection.lead;
        if (cursor.row != this.base.row || cursor.column < this.base.column) {
            this.detach();
        }
        if (this.activated)
            this.changeTimer.schedule();
        else
            this.detach();
    };

    this.blurListener = function(e) {
        var el = document.activeElement;
        var text = this.editor.textInput.getElement();
        var fromTooltip = e.relatedTarget && this.tooltipNode && this.tooltipNode.contains(e.relatedTarget);
        var container = this.popup && this.popup.container;
        if (el != text && el.parentNode != container && !fromTooltip
            && el != this.tooltipNode && e.relatedTarget != text
        ) {
            this.detach();
        }
    };

    this.mousedownListener = function(e) {
        this.detach();
    };

    this.mousewheelListener = function(e) {
        this.detach();
    };

    this.goTo = function(where) {
        var row = this.popup.getRow();
        var max = this.popup.session.getLength() - 1;

        switch(where) {
            case "up": row = row <= 0 ? max : row - 1; break;
            case "down": row = row >= max ? -1 : row + 1; break;
            case "start": row = 0; break;
            case "end": row = max; break;
        }

        this.popup.setRow(row);
    };

    this.insertMatch = function(data, options) {
        if (!data)
            data = this.popup.getData(this.popup.getRow());
        if (!data)
            return false;

        if (data.completer && data.completer.insertMatch) {
            data.completer.insertMatch(this.editor, data);
        } else {
            if (this.completions.filterText) {
                var ranges = this.editor.selection.getAllRanges();
                for (var i = 0, range; range = ranges[i]; i++) {
                    range.start.column -= this.completions.filterText.length;
                    this.editor.session.remove(range);
                }
            }
            if (data.snippet)
                snippetManager.insertSnippet(this.editor, data.snippet);
            else
                this.editor.execCommand("insertstring", data.value || data);
        }
        this.detach();
    };


    this.commands = {
        "Up": function(editor) { editor.completer.goTo("up"); },
        "Down": function(editor) { editor.completer.goTo("down"); },
        "Ctrl-Up|Ctrl-Home": function(editor) { editor.completer.goTo("start"); },
        "Ctrl-Down|Ctrl-End": function(editor) { editor.completer.goTo("end"); },

        "Esc": function(editor) { editor.completer.detach(); },
        "Return": function(editor) { return editor.completer.insertMatch(); },
        "Shift-Return": function(editor) { editor.completer.insertMatch(null, {deleteSuffix: true}); },
        "Tab": function(editor) {
            var result = editor.completer.insertMatch();
            if (!result && !editor.tabstopManager)
                editor.completer.goTo("down");
            else
                return result;
        },

        "PageUp": function(editor) { editor.completer.popup.gotoPageUp(); },
        "PageDown": function(editor) { editor.completer.popup.gotoPageDown(); }
    };

    this.gatherCompletions = function(editor, callback) {
        var session = editor.getSession();
        var pos = editor.getCursorPosition();

        var prefix = util.getCompletionPrefix(editor);

        this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
        this.base.$insertRight = true;

        var matches = [];
        var total = editor.completers.length;
        editor.completers.forEach(function(completer, i) {
            completer.getCompletions(editor, session, pos, prefix, function(err, results) {
                if (!err && results)
                    matches = matches.concat(results);
                callback(null, {
                    prefix: util.getCompletionPrefix(editor),
                    matches: matches,
                    finished: (--total === 0)
                });
            });
        });
        return true;
    };

    this.showPopup = function(editor) {
        if (this.editor)
            this.detach();

        this.activated = true;

        this.editor = editor;
        if (editor.completer != this) {
            if (editor.completer)
                editor.completer.detach();
            editor.completer = this;
        }

        editor.on("changeSelection", this.changeListener);
        editor.on("blur", this.blurListener);
        editor.on("mousedown", this.mousedownListener);
        editor.on("mousewheel", this.mousewheelListener);

        this.updateCompletions();
    };

    this.updateCompletions = function(keepPopupPosition) {
        if (keepPopupPosition && this.base && this.completions) {
            var pos = this.editor.getCursorPosition();
            var prefix = this.editor.session.getTextRange({start: this.base, end: pos});
            if (prefix == this.completions.filterText)
                return;
            this.completions.setFilter(prefix);
            if (!this.completions.filtered.length)
                return this.detach();
            if (this.completions.filtered.length == 1
            && this.completions.filtered[0].value == prefix
            && !this.completions.filtered[0].snippet)
                return this.detach();
            this.openPopup(this.editor, prefix, keepPopupPosition);
            return;
        }
        var _id = this.gatherCompletionsId;
        this.gatherCompletions(this.editor, function(err, results) {
            var detachIfFinished = function() {
                if (!results.finished) return;
                return this.detach();
            }.bind(this);

            var prefix = results.prefix;
            var matches = results && results.matches;

            if (!matches || !matches.length)
                return detachIfFinished();
            if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId)
                return;

            this.completions = new FilteredList(matches);

            if (this.exactMatch)
                this.completions.exactMatch = true;

            this.completions.setFilter(prefix);
            var filtered = this.completions.filtered;
            if (!filtered.length)
                return detachIfFinished();
            if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet)
                return detachIfFinished();
            if (this.autoInsert && filtered.length == 1 && results.finished)
                return this.insertMatch(filtered[0]);

            this.openPopup(this.editor, prefix, keepPopupPosition);
        }.bind(this));
    };

    this.cancelContextMenu = function() {
        this.editor.$mouseHandler.cancelContextMenu();
    };

    this.updateDocTooltip = function() {
        var popup = this.popup;
        var all = popup.data;
        var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
        var doc = null;
        if (!selected || !this.editor || !this.popup.isOpen)
            return this.hideDocTooltip();
        this.editor.completers.some(function(completer) {
            if (completer.getDocTooltip)
                doc = completer.getDocTooltip(selected);
            return doc;
        });
        if (!doc)
            doc = selected;

        if (typeof doc == "string")
            doc = {docText: doc};
        if (!doc || !(doc.docHTML || doc.docText))
            return this.hideDocTooltip();
        this.showDocTooltip(doc);
    };

    this.showDocTooltip = function(item) {
        if (!this.tooltipNode) {
            this.tooltipNode = dom.createElement("div");
            this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
            this.tooltipNode.style.margin = 0;
            this.tooltipNode.style.pointerEvents = "auto";
            this.tooltipNode.tabIndex = -1;
            this.tooltipNode.onblur = this.blurListener.bind(this);
            this.tooltipNode.onclick = this.onTooltipClick.bind(this);
        }

        var tooltipNode = this.tooltipNode;
        if (item.docHTML) {
            tooltipNode.innerHTML = item.docHTML;
        } else if (item.docText) {
            tooltipNode.textContent = item.docText;
        }

        if (!tooltipNode.parentNode)
            document.body.appendChild(tooltipNode);
        var popup = this.popup;
        var rect = popup.container.getBoundingClientRect();
        tooltipNode.style.top = popup.container.style.top;
        tooltipNode.style.bottom = popup.container.style.bottom;

        if (window.innerWidth - rect.right < 320) {
            tooltipNode.style.right = window.innerWidth - rect.left + "px";
            tooltipNode.style.left = "";
        } else {
            tooltipNode.style.left = (rect.right + 1) + "px";
            tooltipNode.style.right = "";
        }
        tooltipNode.style.display = "block";
    };

    this.hideDocTooltip = function() {
        this.tooltipTimer.cancel();
        if (!this.tooltipNode) return;
        var el = this.tooltipNode;
        if (!this.editor.isFocused() && document.activeElement == el)
            this.editor.focus();
        this.tooltipNode = null;
        if (el.parentNode)
            el.parentNode.removeChild(el);
    };

    this.onTooltipClick = function(e) {
        var a = e.target;
        while (a && a != this.tooltipNode) {
            if (a.nodeName == "A" && a.href) {
                a.rel = "noreferrer";
                a.target = "_blank";
                break;
            }
            a = a.parentNode;
        }
    };

}).call(Autocomplete.prototype);

Autocomplete.startCommand = {
    name: "startAutocomplete",
    exec: function(editor) {
        if (!editor.completer)
            editor.completer = new Autocomplete();
        editor.completer.autoInsert = false;
        editor.completer.autoSelect = true;
        editor.completer.showPopup(editor);
        editor.completer.cancelContextMenu();
    },
    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
};

var FilteredList = function(array, filterText) {
    this.all = array;
    this.filtered = array;
    this.filterText = filterText || "";
    this.exactMatch = false;
};
(function(){
    this.setFilter = function(str) {
        if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0)
            var matches = this.filtered;
        else
            var matches = this.all;

        this.filterText = str;
        matches = this.filterCompletions(matches, this.filterText);
        matches = matches.sort(function(a, b) {
            return b.exactMatch - a.exactMatch || b.score - a.score;
        });
        var prev = null;
        matches = matches.filter(function(item){
            var caption = item.snippet || item.caption || item.value;
            if (caption === prev) return false;
            prev = caption;
            return true;
        });

        this.filtered = matches;
    };
    this.filterCompletions = function(items, needle) {
        var results = [];
        var upper = needle.toUpperCase();
        var lower = needle.toLowerCase();
        loop: for (var i = 0, item; item = items[i]; i++) {
            var caption = item.value || item.caption || item.snippet;
            if (!caption) continue;
            var lastIndex = -1;
            var matchMask = 0;
            var penalty = 0;
            var index, distance;

            if (this.exactMatch) {
                if (needle !== caption.substr(0, needle.length))
                    continue loop;
            }else{
                for (var j = 0; j < needle.length; j++) {
                    var i1 = caption.indexOf(lower[j], lastIndex + 1);
                    var i2 = caption.indexOf(upper[j], lastIndex + 1);
                    index = (i1 >= 0) ? ((i2 < 0 || i1 < i2) ? i1 : i2) : i2;
                    if (index < 0)
                        continue loop;
                    distance = index - lastIndex - 1;
                    if (distance > 0) {
                        if (lastIndex === -1)
                            penalty += 10;
                        penalty += distance;
                    }
                    matchMask = matchMask | (1 << index);
                    lastIndex = index;
                }
            }
            item.matchMask = matchMask;
            item.exactMatch = penalty ? 0 : 1;
            item.score = (item.score || 0) - penalty;
            results.push(item);
        }
        return results;
    };
}).call(FilteredList.prototype);

exports.Autocomplete = Autocomplete;
exports.FilteredList = FilteredList;

});

ace.define("ace/autocomplete/text_completer",["require","exports","module","ace/range"], function(acequire, exports, module) {
    var Range = acequire("../range").Range;
    
    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;

    function getWordIndex(doc, pos) {
        var textBefore = doc.getTextRange(Range.fromPoints({row: 0, column:0}, pos));
        return textBefore.split(splitRegex).length - 1;
    }
    function wordDistance(doc, pos) {
        var prefixPos = getWordIndex(doc, pos);
        var words = doc.getValue().split(splitRegex);
        var wordScores = Object.create(null);
        
        var currentWord = words[prefixPos];

        words.forEach(function(word, idx) {
            if (!word || word === currentWord) return;

            var distance = Math.abs(prefixPos - idx);
            var score = words.length - distance;
            if (wordScores[word]) {
                wordScores[word] = Math.max(score, wordScores[word]);
            } else {
                wordScores[word] = score;
            }
        });
        return wordScores;
    }

    exports.getCompletions = function(editor, session, pos, prefix, callback) {
        var wordScore = wordDistance(session, pos, prefix);
        var wordList = Object.keys(wordScore);
        callback(null, wordList.map(function(word) {
            return {
                caption: word,
                value: word,
                score: wordScore[word],
                meta: "local"
            };
        }));
    };
});

ace.define("ace/ext/language_tools",["require","exports","module","ace/snippets","ace/autocomplete","ace/config","ace/lib/lang","ace/autocomplete/util","ace/autocomplete/text_completer","ace/editor","ace/config"], function(acequire, exports, module) {
"use strict";

var snippetManager = acequire("../snippets").snippetManager;
var Autocomplete = acequire("../autocomplete").Autocomplete;
var config = acequire("../config");
var lang = acequire("../lib/lang");
var util = acequire("../autocomplete/util");

var textCompleter = acequire("../autocomplete/text_completer");
var keyWordCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        if (session.$mode.completer) {
            return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
        }
        var state = editor.session.getState(pos.row);
        var completions = session.$mode.getCompletions(state, session, pos, prefix);
        callback(null, completions);
    }
};

var snippetCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
        var snippetMap = snippetManager.snippetMap;
        var completions = [];
        snippetManager.getActiveScopes(editor).forEach(function(scope) {
            var snippets = snippetMap[scope] || [];
            for (var i = snippets.length; i--;) {
                var s = snippets[i];
                var caption = s.name || s.tabTrigger;
                if (!caption)
                    continue;
                completions.push({
                    caption: caption,
                    snippet: s.content,
                    meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
                    type: "snippet"
                });
            }
        }, this);
        callback(null, completions);
    },
    getDocTooltip: function(item) {
        if (item.type == "snippet" && !item.docHTML) {
            item.docHTML = [
                "<b>", lang.escapeHTML(item.caption), "</b>", "<hr></hr>",
                lang.escapeHTML(item.snippet)
            ].join("");
        }
    }
};

var completers = [snippetCompleter, textCompleter, keyWordCompleter];
exports.setCompleters = function(val) {
    completers.length = 0;
    if (val) completers.push.apply(completers, val);
};
exports.addCompleter = function(completer) {
    completers.push(completer);
};
exports.textCompleter = textCompleter;
exports.keyWordCompleter = keyWordCompleter;
exports.snippetCompleter = snippetCompleter;

var expandSnippet = {
    name: "expandSnippet",
    exec: function(editor) {
        return snippetManager.expandWithTab(editor);
    },
    bindKey: "Tab"
};

var onChangeMode = function(e, editor) {
    loadSnippetsForMode(editor.session.$mode);
};

var loadSnippetsForMode = function(mode) {
    var id = mode.$id;
    if (!snippetManager.files)
        snippetManager.files = {};
    loadSnippetFile(id);
    if (mode.modes)
        mode.modes.forEach(loadSnippetsForMode);
};

var loadSnippetFile = function(id) {
    if (!id || snippetManager.files[id])
        return;
    var snippetFilePath = id.replace("mode", "snippets");
    snippetManager.files[id] = {};
    config.loadModule(snippetFilePath, function(m) {
        if (m) {
            snippetManager.files[id] = m;
            if (!m.snippets && m.snippetText)
                m.snippets = snippetManager.parseSnippetFile(m.snippetText);
            snippetManager.register(m.snippets || [], m.scope);
            if (m.includeScopes) {
                snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
                m.includeScopes.forEach(function(x) {
                    loadSnippetFile("ace/mode/" + x);
                });
            }
        }
    });
};

var doLiveAutocomplete = function(e) {
    var editor = e.editor;
    var hasCompleter = editor.completer && editor.completer.activated;
    if (e.command.name === "backspace") {
        if (hasCompleter && !util.getCompletionPrefix(editor))
            editor.completer.detach();
    }
    else if (e.command.name === "insertstring") {
        var prefix = util.getCompletionPrefix(editor);
        if (prefix && !hasCompleter) {
            if (!editor.completer) {
                editor.completer = new Autocomplete();
            }
            editor.completer.autoInsert = false;
            editor.completer.showPopup(editor);
        }
    }
};

var Editor = acequire("../editor").Editor;
acequire("../config").defineOptions(Editor.prototype, "editor", {
    enableBasicAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.addCommand(Autocomplete.startCommand);
            } else {
                this.commands.removeCommand(Autocomplete.startCommand);
            }
        },
        value: false
    },
    enableLiveAutocompletion: {
        set: function(val) {
            if (val) {
                if (!this.completers)
                    this.completers = Array.isArray(val)? val: completers;
                this.commands.on('afterExec', doLiveAutocomplete);
            } else {
                this.commands.removeListener('afterExec', doLiveAutocomplete);
            }
        },
        value: false
    },
    enableSnippets: {
        set: function(val) {
            if (val) {
                this.commands.addCommand(expandSnippet);
                this.on("changeMode", onChangeMode);
                onChangeMode(null, this);
            } else {
                this.commands.removeCommand(expandSnippet);
                this.off("changeMode", onChangeMode);
            }
        },
        value: false
    }
});
});
                (function() {
                    ace.acequire(["ace/ext/language_tools"], function() {});
                })();
            

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = executeQuery;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateInputs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_util__);
function executeQuery(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var readOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var next=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var axios=Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* createAxiosInstance */])();return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_20" /* ADMINDB_RESETEAR_TABLA */]});var take=getState().admindb.get('take');var query=getState().admindb.get('query');var connection=getState().admindb.get('connection');axios.post(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* API_URL */]+'/admin/db',{query:query,connection:connection,page:page,take:take,readOnly:readOnly}).then(function(res){var fn1=function fn1(d){return d({type:__WEBPACK_IMPORTED_MODULE_0__types__["_19" /* ADMINDB_POBLAR_RESULTADOS */],payload:{data:res.data,page:page}});};fn1(dispatch);// Pass execution results to callback
var result={executionTime:res.data.executionTime,records:res.data.records,queryExecuted:res.data.queryExecuted};if(Object(__WEBPACK_IMPORTED_MODULE_4_util__["isFunction"])(next))next(result);}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* displayMessages */])(dispatch,err);if(Object(__WEBPACK_IMPORTED_MODULE_4_util__["isFunction"])(next))next(null);});};}function updateInputs(path,value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["_193" /* MODIFICAR_INPUTS_ADMINDB */],payload:{path:path,value:value}});};}

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_includes__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_number_is_nan__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_from__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_set__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_fn_set__);


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(822);
module.exports = __webpack_require__(54).Array.find;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(53);
var $find = __webpack_require__(304)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(137)(KEY);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(180)('native-function-to-string', Function.toString);


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(825);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(60);
var isArray = __webpack_require__(826);
var SPECIES = __webpack_require__(44)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(181);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(828);
module.exports = __webpack_require__(54).Array.includes;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(53);
var $includes = __webpack_require__(306)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(137)('includes');


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(184);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(831);
module.exports = __webpack_require__(54).Number.isNaN;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(53);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(833);
module.exports = __webpack_require__(54).Array.findIndex;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(53);
var $find = __webpack_require__(304)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(137)(KEY);


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(307);
__webpack_require__(841);
module.exports = __webpack_require__(54).Array.from;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(184);
var defined = __webpack_require__(183);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(308);
var descriptor = __webpack_require__(134);
var setToStringTag = __webpack_require__(187);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(89)(IteratorPrototype, __webpack_require__(44)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(73);
var anObject = __webpack_require__(90);
var getKeys = __webpack_require__(309);

module.exports = __webpack_require__(74) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(92);
var toIObject = __webpack_require__(138);
var arrayIndexOf = __webpack_require__(306)(false);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(59).document;
module.exports = document && document.documentElement;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(92);
var toObject = __webpack_require__(182);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(75);
var $export = __webpack_require__(53);
var toObject = __webpack_require__(182);
var call = __webpack_require__(311);
var isArrayIter = __webpack_require__(312);
var toLength = __webpack_require__(136);
var createProperty = __webpack_require__(842);
var getIterFn = __webpack_require__(313);

$export($export.S + $export.F * !__webpack_require__(314)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(73);
var createDesc = __webpack_require__(134);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(844);
__webpack_require__(307);
__webpack_require__(845);
__webpack_require__(847);
__webpack_require__(855);
__webpack_require__(858);
__webpack_require__(860);
module.exports = __webpack_require__(54).Set;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(188);
var test = {};
test[__webpack_require__(44)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(91)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(846);
var getKeys = __webpack_require__(309);
var redefine = __webpack_require__(91);
var global = __webpack_require__(59);
var hide = __webpack_require__(89);
var Iterators = __webpack_require__(106);
var wks = __webpack_require__(44);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(137);
var step = __webpack_require__(315);
var Iterators = __webpack_require__(106);
var toIObject = __webpack_require__(138);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(185)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(848);
var validate = __webpack_require__(319);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(850)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(73).f;
var create = __webpack_require__(308);
var redefineAll = __webpack_require__(316);
var ctx = __webpack_require__(75);
var anInstance = __webpack_require__(317);
var forOf = __webpack_require__(139);
var $iterDefine = __webpack_require__(185);
var step = __webpack_require__(315);
var setSpecies = __webpack_require__(849);
var DESCRIPTORS = __webpack_require__(74);
var fastKey = __webpack_require__(318).fastKey;
var validate = __webpack_require__(319);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(59);
var dP = __webpack_require__(73);
var DESCRIPTORS = __webpack_require__(74);
var SPECIES = __webpack_require__(44)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(59);
var $export = __webpack_require__(53);
var redefine = __webpack_require__(91);
var redefineAll = __webpack_require__(316);
var meta = __webpack_require__(318);
var forOf = __webpack_require__(139);
var anInstance = __webpack_require__(317);
var isObject = __webpack_require__(60);
var fails = __webpack_require__(133);
var $iterDetect = __webpack_require__(314);
var setToStringTag = __webpack_require__(187);
var inheritIfRequired = __webpack_require__(851);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(60);
var setPrototypeOf = __webpack_require__(852).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(60);
var anObject = __webpack_require__(90);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(75)(Function.call, __webpack_require__(853).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(854);
var createDesc = __webpack_require__(134);
var toIObject = __webpack_require__(138);
var toPrimitive = __webpack_require__(301);
var has = __webpack_require__(92);
var IE8_DOM_DEFINE = __webpack_require__(299);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(74) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 854 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(53);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(856)('Set') });


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(188);
var from = __webpack_require__(857);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(139);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(859)('Set');


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(53);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(861)('Set');


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(53);
var aFunction = __webpack_require__(303);
var ctx = __webpack_require__(75);
var forOf = __webpack_require__(139);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.ade914dd.js